
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree126"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree126"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $e34d72d50b6899c0$exports = {};
$parcel$extendImportMap({
    "3CDMC": "btn.b1aa09dc.mp3",
    "lU8aV": "btnrelease.19db364c.mp3",
    "r7kyJ": "crateopen.d9d71160.mp3",
    "8AMeq": "wintercrateopen.772d4dfb.mp3",
    "5Ad3H": "robocrateopen.bd853b30.mp3",
    "dNH0R": "unboxed.f0fee4ce.mp3",
    "02eJc": "unusualunboxed.291c861e.mp3",
    "atjRc": "bulkWorker.49745e56.js"
});

function $923c9e0e4e96ee85$var$Crate(op) {
    /* Options:
    id - Determines crate name and icon, which are pulled from cratenames.js.
    series - Crate series number
    schema - Crate schema number
    loot - Stores crate contents
    effects - Stores unusual effects available in this crate
    note - Crate note (like the "Items obtained from this case may have Strange and/or Unusual quality." text). Text is pulled from text.js
    autoChance - If the crate has only graded items from Commando to Elite grade, set this to true to automatically determine chance to get an item based on value:
        0 or undefined - Use chances set for each item.
        1 - Set item chances based on their grade, so the chance of unboxing an item with specific grade equals to:
            Mercenary - 80%
            Commando - 16%
            Assassin - 3.2%
            Elite - 0.8%
        2 - Give each item an equal chance to be unboxed.
    unusualtype - Determines if unusuals can be unboxed from this crate, and in what way.
        0 or undefined - Unusuals can't be unboxed from this crate.
        1 - Pick a random item from the universal unusual pool.
        2 - Pick a random item from the crate with quality 10. Items with higher grades have smaller chances to be picked.
        3 - Same as 2, but each item has an equal chance of being picked.
    bonus - Determines if bonus items can be unboxed from this crate.
    exclusiveBonus - Determines case exclusive bonus items
        loot - List of case exclusive bonus items
        chance - Chance of getting a case exclusive bonus item instead of a global bonus item. 1 = 0.01%, 10000 = 100%
    */ this.id = op.id;
    this.series = op.series;
    this.schema = op.schema;
    this.loot = null;
    if (typeof op.effects === "undefined") this.effects = [];
    else this.effects = op.effects;
    if (typeof op.unusual === "undefined") this.unusual = 0;
    else this.unusual = op.unusual;
    if (typeof op.note === "undefined") this.note = 0;
    else this.note = op.note;
    if (typeof op.autoChance === "undefined") this.autoChance = 0;
    else this.autoChance = op.autoChance;
    if (typeof op.bonus === "undefined") this.bonus = false;
    else this.bonus = true;
    if (typeof op.exclusiveBonus === "undefined") this.exclusiveBonus = false;
    else this.exclusiveBonus = op.exclusiveBonus;
    if (typeof op.oneExclusiveBonus === "undefined") this.oneExclusiveBonus = false;
    else this.oneExclusiveBonus = op.oneExclusiveBonus;
    if (typeof op.creepyBonus === "undefined") this.creepyBonus = false;
    else this.creepyBonus = op.creepyBonus;
}
function $923c9e0e4e96ee85$var$Item(op) {
    /* Options:
        id - Determines item name and icon, which are pulled from itemnames.js
        chance - Chance of getting that item. 1 = 0.01%, 10000 = 100%. Can be left blank if crate autoChance is set to true.
        quality - Determines item quality and/or behavior:
            0 - Unusual
            1 - Unique
            2 - Strange
            3 - Haunted
            4 - 90% chance to be Unique, 10% chance to be Strange
            5 - Decorated - 10% Battle Scarred, 20% Well Worn, 40% Field Tested, 20% Minimal Wear, 10% Factory New
            6 - Decorated - Same as 5, but also has 10% chance to be Strange and 1% chance to be Unusual
            7 - 99% to be Unique, 1% to be Unusual
            8 - 90% chance to be Unique, 10% to be Strange Haunted
            9 - Unique, but can be replaced: 10% to be Strange or 1% to be Unusual.
            10 - Same as 4, but it also has a 1% chance to be Unusual. Can be both Strange and Unusual
            11 - Killstreak Kit. 65% to be normal, 25% to be Specialized, 10% to be Professional.
            12 - Strangifier
        grade - Item grade.
    */ this.id = op.id;
    if (typeof op.chance === "undefined" && typeof this.chance === "undefined") this.chance = 0;
    else this.chance = op.chance;
    this.quality = op.quality;
    if (typeof op.grade === 'undefined') this.grade = 0;
    else this.grade = op.grade;
}
const $923c9e0e4e96ee85$export$43cbf05ac7bc87ec = [
    5,
    6,
    13,
    14,
    21,
    22,
    23,
    28,
    29,
    30,
    34,
    35,
    36,
    43,
    44,
    45,
    47,
    48,
    49,
    51,
    52,
    55,
    56,
    57,
    58,
    63,
    64,
    65,
    71,
    72,
    73,
    111,
    117,
    118,
    122,
    123,
    130,
    131,
    133,
    134,
    135,
    136,
    137,
    140,
    142,
    143,
    147,
    148,
    152,
    153,
    157,
    160,
    166,
    167,
    172,
    177,
    182,
    183,
    187,
    188,
    197,
    198,
    204,
    210,
    211,
    225,
    230,
    235,
    240,
    245,
    246,
    250,
    265,
    266,
    275,
    281,
    289,
    290,
    292,
    294,
    301,
    303,
    305,
    308,
    316,
    317,
    327,
    341,
    342,
    358,
    359,
    362,
    366,
    370,
    375,
    376,
    383,
    387,
    388,
    389,
    390,
    392,
    393,
    394,
    395,
    397,
    399,
    400,
    401,
    402,
    405,
    407,
    408,
    409,
    411,
    413,
    414,
    415,
    417,
    418,
    420,
    422,
    423,
    425,
    427,
    430,
    431,
    432,
    433,
    435,
    436,
    438,
    439,
    440,
    441,
    454,
    455,
    457,
    459,
    460,
    464,
    465,
    467,
    471,
    472,
    475,
    479,
    480,
    481,
    483,
    487,
    488,
    490,
    492,
    496,
    501,
    503,
    504,
    506,
    510,
    512,
    516,
    524,
    525,
    526,
    537,
    538,
    541,
    547,
    549,
    552,
    553,
    666,
    685,
    689,
    691,
    692,
    693,
    694,
    696,
    704,
    705,
    710,
    712,
    715,
    718,
    720,
    725,
    727,
    732,
    733,
    739,
    746,
    749,
    754,
    755,
    756,
    777,
    779,
    784,
    785,
    786,
    791,
    792,
    793,
    794,
    798,
    804,
    812,
    815,
    818,
    902,
    905,
    906,
    907,
    908,
    909,
    913,
    964,
    1355,
    1357,
    1358,
    1360,
    1361,
    1362,
    1363,
    1364,
    1365,
    1366,
    1367,
    1368,
    1369,
    1371,
    1372,
    1373,
    1374,
    1375,
    1376,
    1377,
    1378,
    1379,
    1380,
    1381,
    1382,
    1383,
    1384,
    1385,
    1386,
    1387,
    1388,
    1389,
    1390,
    1391,
    1392,
    1393,
    1394,
    1395,
    1397,
    1399,
    1400,
    1401,
    1403,
    1404,
    1405,
    1406,
    1407,
    1408,
    1410,
    1411,
    1412,
    1413,
    1414,
    1415,
    1416,
    1417,
    1418,
    1419,
    1421
];
const $923c9e0e4e96ee85$export$40df5ace82dd8ebd = [
    46,
    50,
    53,
    54,
    191,
    260,
    291,
    343,
    434,
    470,
    482,
    707,
    1356,
    1396,
    1398,
    1402,
    1409,
    1420
];
const $923c9e0e4e96ee85$export$828ca659e1638c64 = [
    62,
    70,
    124,
    158,
    178,
    194,
    1354,
    1359,
    1370
];
const $923c9e0e4e96ee85$export$97338bf46fad8d5d = [
    916,
    917,
    918
];
const $923c9e0e4e96ee85$export$c19bf1bf46c6afa8 = [
    929,
    932,
    933,
    936,
    939,
    941,
    942,
    943,
    945,
    949,
    953
];
const $923c9e0e4e96ee85$export$e281edce0be87230 = [
    893
];
// Unusual effect containers
const $923c9e0e4e96ee85$var$gen1FX = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14
];
const $923c9e0e4e96ee85$var$gen2FX = [
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35
];
const $923c9e0e4e96ee85$var$gen3FX = [
    55,
    56,
    57,
    58,
    59,
    60,
    61
];
const $923c9e0e4e96ee85$export$d4f00319c000ebd9 = $923c9e0e4e96ee85$var$gen1FX.concat($923c9e0e4e96ee85$var$gen2FX, $923c9e0e4e96ee85$var$gen3FX);
const $923c9e0e4e96ee85$export$fcfd2f8245a0c72b = [
    36,
    37,
    38,
    39
];
const $923c9e0e4e96ee85$export$efdb3cea0ec18a0e = $923c9e0e4e96ee85$export$fcfd2f8245a0c72b.concat([
    40,
    41,
    42,
    43,
    44
]);
const $923c9e0e4e96ee85$export$daa7f6f4c59cb124 = [
    62,
    63,
    64,
    65,
    66,
    67,
    68,
    69
];
const $923c9e0e4e96ee85$export$7ed6475de6021fb1 = [
    70,
    71,
    72,
    73,
    74,
    75
];
const $923c9e0e4e96ee85$export$a7e398160505ca4b = $923c9e0e4e96ee85$export$efdb3cea0ec18a0e.concat($923c9e0e4e96ee85$export$daa7f6f4c59cb124, $923c9e0e4e96ee85$export$7ed6475de6021fb1);
const $923c9e0e4e96ee85$export$6ee9b6d42e1b16dd = [
    89,
    90,
    91,
    92,
    93,
    94,
    95
];
const $923c9e0e4e96ee85$export$a1fdcf29c390e2ff = [
    96,
    97,
    98,
    99
];
const $923c9e0e4e96ee85$export$479ea04ee3735415 = $923c9e0e4e96ee85$export$efdb3cea0ec18a0e.concat($923c9e0e4e96ee85$export$daa7f6f4c59cb124, $923c9e0e4e96ee85$export$7ed6475de6021fb1, $923c9e0e4e96ee85$export$6ee9b6d42e1b16dd, $923c9e0e4e96ee85$export$a1fdcf29c390e2ff);
const $923c9e0e4e96ee85$export$d7cc75ae001f49bb = [
    100,
    101,
    102,
    103,
    104,
    105,
    106,
    107,
    108,
    109,
    110
];
const $923c9e0e4e96ee85$export$87cb2b63d48546e5 = [
    111,
    112,
    113,
    114,
    115,
    116,
    117,
    118,
    119,
    120,
    121,
    122
];
const $923c9e0e4e96ee85$export$dbe6de95c084ac0b = [
    143,
    144,
    145,
    146,
    147,
    148,
    149,
    150
];
const $923c9e0e4e96ee85$export$38414dd56dd1142f = [
    174,
    175,
    176,
    177,
    178,
    179,
    180,
    181,
    182,
    183,
    184,
    185,
    186,
    187,
    188
];
const $923c9e0e4e96ee85$export$4af39f2718c7dd8c = [
    233,
    234,
    235,
    236,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    244
];
const $923c9e0e4e96ee85$export$6341f1ffae36f6e1 = [
    264,
    265,
    266,
    267,
    268,
    269,
    270,
    271,
    272,
    273,
    274,
    275,
    276
];
const $923c9e0e4e96ee85$export$67f97e3ea05d86cd = [
    307,
    308,
    309,
    310,
    311,
    312,
    313,
    314,
    315,
    316,
    317,
    318
];
const $923c9e0e4e96ee85$export$bf8344a3e5db3ea9 = [
    334,
    335,
    336,
    337,
    338,
    339,
    340
];
const $923c9e0e4e96ee85$export$531bb3e137492ac6 = [
    359,
    360,
    361,
    362,
    363,
    364,
    365,
    366,
    367,
    368,
    369
];
const $923c9e0e4e96ee85$var$tauntFX = [
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23
];
const $923c9e0e4e96ee85$var$oldWeaponFX = [
    24,
    25,
    26,
    27
];
const $923c9e0e4e96ee85$var$weaponFX = [
    24,
    25,
    26
];
const $923c9e0e4e96ee85$var$roboFX = [
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54
];
const $923c9e0e4e96ee85$var$eotlFX = [
    76,
    77,
    78,
    79
];
const $923c9e0e4e96ee85$var$invasionFX = $923c9e0e4e96ee85$export$d4f00319c000ebd9.concat([
    80,
    81,
    82,
    83,
    84,
    85,
    86,
    87,
    88
]);
const $923c9e0e4e96ee85$export$c317c9865986caea = [
    123,
    124,
    125,
    126,
    127,
    128,
    129,
    130,
    131,
    132,
    133
];
const $923c9e0e4e96ee85$export$678a0e6ea5e17d = [
    151,
    152,
    153,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162
];
const $923c9e0e4e96ee85$export$a5ca802835f1e521 = [
    189,
    190,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
    202,
    203,
    204
];
const $923c9e0e4e96ee85$export$5d2fb103389bf3ce = [
    245,
    246,
    247,
    248,
    249,
    250,
    251
];
const $923c9e0e4e96ee85$export$8f8d26fc356f0f89 = [
    277,
    278,
    279,
    280,
    281,
    282,
    283,
    284,
    285,
    286,
    287,
    288
];
const $923c9e0e4e96ee85$export$488be7bbcbddddcb = [
    319,
    320,
    321,
    322,
    323,
    324,
    325,
    326
];
const $923c9e0e4e96ee85$export$fee703f8270b19bf = [
    341,
    342,
    343,
    344,
    345,
    346,
    347,
    348,
    349,
    350,
    351
];
const $923c9e0e4e96ee85$var$summer20FX = $923c9e0e4e96ee85$export$d4f00319c000ebd9.concat([
    134,
    135,
    136,
    137,
    138,
    139,
    140,
    141,
    142
]);
const $923c9e0e4e96ee85$var$summer21FX = $923c9e0e4e96ee85$export$d4f00319c000ebd9.concat([
    163,
    164,
    165,
    166,
    167,
    168,
    169,
    170,
    171,
    172,
    173
]);
const $923c9e0e4e96ee85$var$summer22FX = $923c9e0e4e96ee85$export$d4f00319c000ebd9.concat([
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    221,
    222,
    223,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    231,
    232
]);
const $923c9e0e4e96ee85$export$77cd6f67ebed231f = [
    252,
    253,
    254,
    255,
    256,
    257,
    258,
    259,
    260,
    261,
    262,
    263
];
const $923c9e0e4e96ee85$export$6418d71abfdb50e1 = [
    289,
    290,
    291,
    292,
    293,
    294,
    295,
    296,
    297,
    298,
    299,
    300,
    301,
    302,
    303,
    304,
    305,
    306
];
const $923c9e0e4e96ee85$export$78afa2b74c302149 = [
    327,
    328,
    329,
    330,
    331,
    332,
    333
];
const $923c9e0e4e96ee85$export$5fd569f55a6c2fd0 = [
    352,
    353,
    354,
    355,
    356,
    357,
    358
];
const $923c9e0e4e96ee85$export$10dc550ff6f20217 = [
    24,
    7,
    74,
    762,
    763,
    "paint",
    "strangepart",
    15,
    767,
    768,
    769
];
const $923c9e0e4e96ee85$export$46565d5461ea95ac = [
    75,
    76,
    77,
    78,
    79,
    80,
    81,
    82,
    83,
    84,
    85,
    86,
    87,
    88,
    89,
    149,
    920,
    973,
    974,
    1033,
    1611,
    1612,
    1613,
    1614,
    1615,
    1616,
    1617,
    1618,
    1619,
    1620,
    1621,
    1622,
    1623,
    1624,
    1625,
    1626,
    1627,
    1628,
    1629,
    1630,
    1631,
    1632,
    1633,
    1634,
    1635,
    1636,
    1637,
    1638,
    1639,
    1640,
    1641,
    1642,
    1643,
    1644,
    1645,
    1646,
    1699,
    1700,
    1701,
    1702,
    1703,
    1704,
    1705,
    1706,
    1763,
    1764,
    1765,
    1766,
    1767,
    1788,
    1789,
    1790,
    1854,
    1855,
    1856,
    1857,
    1858,
    1882,
    1883,
    1884,
    1920,
    1921,
    1922,
    1923,
    1924,
    1925,
    1955,
    1956,
    1957,
    1958,
    1982,
    1983,
    1984,
    2008,
    2009,
    2010,
    2011,
    2034,
    2035,
    2036,
    2037,
    2073,
    2074,
    2075,
    2099,
    2100,
    2101,
    2102,
    2130,
    2131,
    2132,
    2156,
    2157,
    2158,
    2193,
    2194,
    2195,
    2196,
    2220,
    2221,
    2222,
    2223,
    2224
];
const $923c9e0e4e96ee85$export$823717ebc7f69446 = [
    8,
    9,
    16,
    17,
    37,
    66,
    105,
    106,
    107,
    108,
    109,
    110,
    112,
    113,
    114,
    119,
    125,
    126,
    127,
    248,
    249,
    771,
    820,
    821,
    822,
    823,
    824,
    825,
    826
];
const $923c9e0e4e96ee85$export$d74038d209dbd599 = [
    256,
    257,
    258,
    262,
    263,
    264,
    269,
    270,
    272,
    273,
    274,
    278,
    279,
    280,
    298,
    299,
    300,
    313,
    314,
    315,
    367,
    368,
    369,
    373,
    374,
    380,
    381,
    382,
    446,
    447,
    453,
    529,
    530,
    658,
    659,
    660,
    663,
    664,
    665,
    669,
    670,
    671,
    760,
    761,
    833,
    834,
    961,
    962,
    963
];
const $923c9e0e4e96ee85$export$dd394babd3967010 = [
    {
        id: 1652,
        quality: 12
    },
    {
        id: 1653,
        quality: 12
    },
    {
        id: 1654,
        quality: 12
    },
    {
        id: 1655,
        quality: 12
    },
    {
        id: 1656,
        quality: 12
    },
    {
        id: 1657,
        quality: 12
    },
    {
        id: 1658,
        quality: 12
    },
    {
        id: 1659,
        quality: 12
    },
    {
        id: 1660,
        quality: 12
    },
    {
        id: 1661,
        quality: 12
    },
    {
        id: 1662,
        quality: 12
    },
    {
        id: 1663,
        quality: 12
    },
    {
        id: 1664,
        quality: 12
    },
    {
        id: 1652,
        quality: 11
    },
    {
        id: 1653,
        quality: 11
    }
];
const $923c9e0e4e96ee85$export$5a1370e0815c8951 = [
    772,
    773,
    774,
    775,
    318,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    221,
    345,
    346,
    347,
    348,
    349,
    350,
    351,
    352,
    353,
    673,
    674,
    675,
    676,
    677,
    678,
    679,
    680,
    681,
    922,
    923,
    924,
    925,
    926,
    927,
    928,
    929,
    930,
    931,
    932,
    933,
    934,
    935,
    936,
    937,
    938,
    939,
    940,
    941,
    942,
    943,
    944,
    945,
    946,
    947,
    948,
    949,
    950,
    951,
    952,
    953,
    954,
    955,
    956,
    957,
    889,
    890,
    891,
    892,
    893,
    894,
    895,
    896,
    897
];
let $923c9e0e4e96ee85$export$ba9ca3d1b9c67713 = {};
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw11 = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31
];
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw12 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw11.concat([
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw13 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw12.concat([
    49,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    64,
    65,
    66,
    67,
    68,
    69,
    70,
    71
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw14 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw13.concat([
    73,
    74,
    75,
    76,
    77,
    78,
    79,
    80,
    83,
    84,
    85,
    86
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw16 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw14.concat([
    96,
    97,
    98,
    99,
    100,
    101,
    104,
    105,
    106,
    107,
    110,
    111,
    112,
    113,
    114,
    115,
    116,
    117,
    118,
    119,
    120,
    121,
    122
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw17 = [
    104,
    105,
    106,
    107,
    110,
    111,
    123,
    124,
    125,
    126,
    127
];
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw18 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw17.concat([
    132,
    134
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw19 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw18.concat([
    135,
    137,
    138
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.xmas19 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw19.concat([
    139
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw20 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.xmas19.concat([
    140,
    142
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.xmas20 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw20.concat([
    143
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw21 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.xmas20.concat([
    145,
    147
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.xmas21 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw21.concat([
    148
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw22 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.xmas21.concat([
    150,
    151
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.xmas22 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw22.concat([
    152
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.summer23 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.xmas22.concat([
    154
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw23 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.summer23.concat([
    155
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.xmas23 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw23.concat([
    157
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.summer24 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.xmas23.concat([
    158
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw24 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.summer24.concat([
    159
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.xmas24 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw24.concat([
    160
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.summer25 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.xmas24.concat([
    162
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw25 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.summer25.concat([
    163
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.xmas25 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw25.concat([
    164
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.summer26 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.xmas25.concat([
    165
]);
$923c9e0e4e96ee85$export$ba9ca3d1b9c67713.hw26 = $923c9e0e4e96ee85$export$ba9ca3d1b9c67713.summer26.concat([
    166
]);
let $923c9e0e4e96ee85$export$afbe48a4a4275937 = [
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 1,
        schema: 5022,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        unusual: 1,
        autoChance: 2
    }),
    /*  [0] */ new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 2,
        schema: 5041,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 3,
        schema: 5022,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 4,
        schema: 5041,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 5,
        schema: 5045,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 2,
        series: 6,
        schema: 5048,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        unusual: 1
    }),
    /* [5] */ new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 7,
        schema: 5022,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 8,
        schema: 5041,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 9,
        schema: 5045,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 10,
        schema: 5045,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 11,
        schema: 5041,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        unusual: 1
    }),
    /*  [10] */ new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 12,
        schema: 5022,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 13,
        schema: 5022,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 14,
        schema: 5041,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 15,
        schema: 5045,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 16,
        schema: 5045,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        unusual: 1
    }),
    /* [15] */ new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 17,
        schema: 5041,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 18,
        schema: 5022,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 19,
        schema: 5022,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 20,
        schema: 5041,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 21,
        schema: 5045,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        note: 1,
        unusual: 1
    }),
    /*  [20] */ new $923c9e0e4e96ee85$var$Crate({
        id: 5,
        series: 22,
        schema: 5066,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 23,
        schema: 5022,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 24,
        schema: 5041,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 25,
        schema: 5045,
        effects: $923c9e0e4e96ee85$var$gen1FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 26,
        schema: 5022,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    /* [25] */ new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 27,
        schema: 5041,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 28,
        schema: 5045,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 29,
        schema: 5045,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 6,
        series: 30,
        schema: 5068,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 31,
        schema: 5022,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    /*  [30] */ new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 32,
        schema: 5041,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 33,
        schema: 5045,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 34,
        schema: 5022,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 7,
        series: 35,
        schema: 5070,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 2,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 8,
        series: 36,
        schema: 5071,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        unusual: 1
    }),
    /* [35] */ new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 37,
        schema: 5041,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 38,
        schema: 5045,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 39,
        schema: 5022,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 6,
        series: 40,
        schema: 5068,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 41,
        schema: 5045,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    /*  [40] */ new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 42,
        schema: 5041,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 43,
        schema: 5022,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 44,
        schema: 5041,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 45,
        schema: 5045,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 9,
        series: 46,
        schema: 5078,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    /* [45] */ new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 47,
        schema: 5022,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 10,
        series: 48,
        schema: 5080,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 49,
        schema: 5041,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 6,
        series: 50,
        schema: 5068,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 11,
        series: 51,
        schema: 5627,
        effects: $923c9e0e4e96ee85$export$efdb3cea0ec18a0e,
        note: 3,
        unusual: 1,
        autoChance: 2
    }),
    /*  [50] */ new $923c9e0e4e96ee85$var$Crate({
        id: 12,
        series: 52,
        schema: 5629,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 2,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 13,
        series: 53,
        schema: 5630,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 54,
        schema: 5022,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 55,
        schema: 5045,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 56,
        schema: 5041,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    /* [55] */ new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 57,
        schema: 5022,
        effects: $923c9e0e4e96ee85$var$gen2FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 14,
        series: 58,
        schema: 5635,
        effects: $923c9e0e4e96ee85$var$roboFX,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 59,
        schema: 5045,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 15,
        series: 60,
        schema: 5660,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        note: 1,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 16,
        series: 61,
        schema: 5640,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        unusual: 1,
        autoChance: 2
    }),
    /*  [60] */ new $923c9e0e4e96ee85$var$Crate({
        id: 17,
        series: 62,
        schema: 5642,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 18,
        series: 63,
        schema: 5644,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 19,
        series: 64,
        schema: 5646,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 20,
        series: 65,
        schema: 5648,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 21,
        series: 66,
        schema: 5650,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        unusual: 1,
        autoChance: 2
    }),
    /* [65] */ new $923c9e0e4e96ee85$var$Crate({
        id: 22,
        series: 67,
        schema: 5652,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 23,
        series: 68,
        schema: 5654,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 24,
        series: 69,
        schema: 5656,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 71,
        schema: 5041,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 25,
        series: 72,
        schema: 5708,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        unusual: 1,
        autoChance: 2
    }),
    /*  [70] */ new $923c9e0e4e96ee85$var$Crate({
        id: 26,
        series: 73,
        schema: 5709,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 27,
        series: 74,
        schema: 5712,
        effects: $923c9e0e4e96ee85$export$daa7f6f4c59cb124,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 75,
        schema: 5022,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 76,
        schema: 5041,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 1,
        series: 77,
        schema: 5045,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        note: 1,
        unusual: 1
    }),
    /* [75] */ new $923c9e0e4e96ee85$var$Crate({
        id: 28,
        series: 78,
        schema: 5714,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        note: 2,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 29,
        series: 79,
        schema: 5715,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 30,
        series: 81,
        schema: 5719,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 31,
        series: 82,
        schema: 5734,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 31,
        series: 83,
        schema: 5735,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        note: 142,
        unusual: 1,
        autoChance: 2
    }),
    /*  [80] */ new $923c9e0e4e96ee85$var$Crate({
        id: 3,
        series: 0,
        schema: 5739,
        effects: $923c9e0e4e96ee85$var$tauntFX,
        note: 7,
        unusual: 3,
        autoChance: 2
    }),
    /*  Mann Co. Audition Reel */ new $923c9e0e4e96ee85$var$Crate({
        id: 32,
        series: 0,
        schema: 5741,
        note: 2,
        autoChance: 2
    }),
    /*  Bread Box */ new $923c9e0e4e96ee85$var$Crate({
        id: 33,
        series: 0,
        schema: 5737,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        unusual: 1,
        autoChance: 2
    }),
    /*  Mann Co. Stockpile Crate */ new $923c9e0e4e96ee85$var$Crate({
        id: 31,
        series: 84,
        schema: 5742,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        note: 142,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 31,
        series: 85,
        schema: 5752,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        unusual: 1
    }),
    /* [85] */ new $923c9e0e4e96ee85$var$Crate({
        id: 43,
        series: 86,
        schema: 5761,
        effects: $923c9e0e4e96ee85$var$gen3FX,
        note: 4,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 34,
        series: 0,
        schema: 5763,
        effects: $923c9e0e4e96ee85$export$a7e398160505ca4b,
        note: 8,
        unusual: 1,
        autoChance: 2,
        creepyBonus: true
    }),
    /*  Unlocked Creepy Scout Crate */ new $923c9e0e4e96ee85$var$Crate({
        id: 35,
        series: 0,
        schema: 5769,
        effects: $923c9e0e4e96ee85$export$a7e398160505ca4b,
        note: 8,
        unusual: 1,
        autoChance: 2,
        creepyBonus: true
    }),
    /*  Unlocked Creepy Soldier Crate */ new $923c9e0e4e96ee85$var$Crate({
        id: 36,
        series: 0,
        schema: 5764,
        effects: $923c9e0e4e96ee85$export$a7e398160505ca4b,
        note: 8,
        unusual: 1,
        autoChance: 2,
        creepyBonus: true
    }),
    /*  Unlocked Creepy Pyro Crate */ new $923c9e0e4e96ee85$var$Crate({
        id: 37,
        series: 0,
        schema: 5771,
        effects: $923c9e0e4e96ee85$export$a7e398160505ca4b,
        note: 8,
        unusual: 1,
        autoChance: 2,
        creepyBonus: true
    }),
    /*  Unlocked Creepy Demo Crate [90] */ new $923c9e0e4e96ee85$var$Crate({
        id: 38,
        series: 0,
        schema: 5765,
        effects: $923c9e0e4e96ee85$export$a7e398160505ca4b,
        note: 8,
        unusual: 1,
        autoChance: 2,
        creepyBonus: true
    }),
    /*  Unlocked Creepy Heavy Crate */ new $923c9e0e4e96ee85$var$Crate({
        id: 39,
        series: 0,
        schema: 5766,
        effects: $923c9e0e4e96ee85$export$a7e398160505ca4b,
        note: 8,
        unusual: 1,
        autoChance: 2,
        creepyBonus: true
    }),
    /*  Unlocked Creepy Engineer Crate */ new $923c9e0e4e96ee85$var$Crate({
        id: 40,
        series: 0,
        schema: 5770,
        effects: $923c9e0e4e96ee85$export$a7e398160505ca4b,
        note: 8,
        unusual: 1,
        autoChance: 2,
        creepyBonus: true
    }),
    /*  Unlocked Creepy Medic Crate */ new $923c9e0e4e96ee85$var$Crate({
        id: 41,
        series: 0,
        schema: 5768,
        effects: $923c9e0e4e96ee85$export$a7e398160505ca4b,
        note: 8,
        unusual: 1,
        autoChance: 2,
        creepyBonus: true
    }),
    /*  Unlocked Creepy Sniper Crate */ new $923c9e0e4e96ee85$var$Crate({
        id: 42,
        series: 0,
        schema: 5767,
        effects: $923c9e0e4e96ee85$export$a7e398160505ca4b,
        note: 8,
        unusual: 1,
        autoChance: 2,
        creepyBonus: true
    }),
    /*  Unlocked Creepy Spy Crate [95] */ new $923c9e0e4e96ee85$var$Crate({
        id: 44,
        series: 87,
        schema: 5774,
        effects: $923c9e0e4e96ee85$var$eotlFX,
        note: 2,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 45,
        series: 88,
        schema: 5789,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 2,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 46,
        series: 89,
        schema: 5790,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 4,
        unusual: 1,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 31,
        series: 90,
        schema: 5781,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 6,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 31,
        series: 91,
        schema: 5802,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 142,
        unusual: 1,
        autoChance: 2
    }),
    /*  [100] */ new $923c9e0e4e96ee85$var$Crate({
        id: 31,
        series: 92,
        schema: 5803,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 4,
        series: 93,
        schema: 5806,
        effects: $923c9e0e4e96ee85$var$oldWeaponFX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    /*  Concealed Killer Weapons Case */ new $923c9e0e4e96ee85$var$Crate({
        id: 47,
        series: 94,
        schema: 5807,
        effects: $923c9e0e4e96ee85$var$oldWeaponFX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 48,
        series: 95,
        schema: 5817,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 49,
        series: 96,
        schema: 5822,
        effects: $923c9e0e4e96ee85$var$invasionFX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    /* [105] */ new $923c9e0e4e96ee85$var$Crate({
        id: 50,
        series: 97,
        schema: 5823,
        effects: $923c9e0e4e96ee85$var$invasionFX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 51,
        series: 98,
        schema: 5828,
        effects: $923c9e0e4e96ee85$export$6ee9b6d42e1b16dd,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 52,
        series: 99,
        schema: 5831,
        effects: $923c9e0e4e96ee85$var$weaponFX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 53,
        series: 100,
        schema: 5832,
        effects: $923c9e0e4e96ee85$var$weaponFX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 54,
        series: 101,
        schema: 5842,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    /*  [110] */ new $923c9e0e4e96ee85$var$Crate({
        id: 55,
        series: 102,
        schema: 5849,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 31,
        series: 103,
        schema: 5859,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 1,
        unusual: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 56,
        series: 104,
        schema: 5861,
        effects: $923c9e0e4e96ee85$export$a1fdcf29c390e2ff.concat($923c9e0e4e96ee85$export$d4f00319c000ebd9),
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true,
        exclusiveBonus: {
            loot: [
                827,
                828,
                829
            ],
            chance: 5000
        }
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 57,
        series: 105,
        schema: 5865,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true,
        exclusiveBonus: {
            loot: [
                972
            ],
            chance: 4000
        },
        oneExclusiveBonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 58,
        series: 106,
        schema: 5867,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    /* [115] */ new $923c9e0e4e96ee85$var$Crate({
        id: 59,
        series: 107,
        schema: 5871,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 60,
        series: 108,
        schema: 5875,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 61,
        series: 109,
        schema: 5883,
        effects: $923c9e0e4e96ee85$var$weaponFX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 62,
        series: 110,
        schema: 5885,
        effects: $923c9e0e4e96ee85$var$weaponFX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 63,
        series: 111,
        schema: 18000,
        autoChance: 1
    }),
    /*  [120] */ new $923c9e0e4e96ee85$var$Crate({
        id: 64,
        series: 114,
        schema: 18004,
        autoChance: 1
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 65,
        series: 117,
        schema: 5888,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true,
        exclusiveBonus: {
            loot: [
                972
            ],
            chance: 4000
        },
        oneExclusiveBonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 66,
        series: 118,
        schema: 5890,
        effects: $923c9e0e4e96ee85$var$weaponFX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 67,
        series: 119,
        schema: 5893,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 68,
        series: 120,
        schema: 5894,
        effects: $923c9e0e4e96ee85$export$d7cc75ae001f49bb.concat($923c9e0e4e96ee85$export$d4f00319c000ebd9),
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true,
        exclusiveBonus: {
            loot: [
                832,
                835,
                836,
                837
            ],
            chance: 5000
        }
    }),
    /* [125] */ new $923c9e0e4e96ee85$var$Crate({
        id: 69,
        series: 121,
        schema: 5897,
        effects: $923c9e0e4e96ee85$var$weaponFX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 70,
        series: 122,
        schema: 5902,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true,
        exclusiveBonus: {
            loot: [
                972
            ],
            chance: 4000
        },
        oneExclusiveBonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 71,
        series: 123,
        schema: 5904,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 72,
        series: 0,
        schema: 5850,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 3,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 73,
        series: 0,
        schema: 5852,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 3,
        autoChance: 2
    }),
    /*  [130] */ new $923c9e0e4e96ee85$var$Crate({
        id: 74,
        series: 0,
        schema: 5856,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 3,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 75,
        series: 0,
        schema: 5853,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 3,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 76,
        series: 0,
        schema: 5855,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 3,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 77,
        series: 0,
        schema: 5858,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 3,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 78,
        series: 0,
        schema: 5854,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 3,
        autoChance: 2
    }),
    /* [135] */ new $923c9e0e4e96ee85$var$Crate({
        id: 79,
        series: 0,
        schema: 5851,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 3,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 80,
        series: 0,
        schema: 5857,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 3,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 81,
        series: 0,
        schema: 5860,
        effects: $923c9e0e4e96ee85$export$d4f00319c000ebd9,
        note: 5,
        unusual: 3,
        autoChance: 2
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 82,
        series: 124,
        schema: 5905,
        effects: $923c9e0e4e96ee85$export$87cb2b63d48546e5.concat($923c9e0e4e96ee85$export$d4f00319c000ebd9),
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true,
        exclusiveBonus: {
            loot: [
                1647,
                1648,
                1649,
                1650,
                1651
            ],
            chance: 5000
        }
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 83,
        series: 125,
        schema: 5909,
        effects: $923c9e0e4e96ee85$export$c317c9865986caea.concat($923c9e0e4e96ee85$export$d4f00319c000ebd9),
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true,
        exclusiveBonus: {
            loot: [
                972
            ],
            chance: 4000
        },
        oneExclusiveBonus: true
    }),
    /*  [140] */ new $923c9e0e4e96ee85$var$Crate({
        id: 84,
        series: 126,
        schema: 5912,
        effects: $923c9e0e4e96ee85$var$weaponFX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 85,
        series: 127,
        schema: 5914,
        effects: $923c9e0e4e96ee85$var$summer20FX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 86,
        series: 128,
        schema: 5915,
        effects: $923c9e0e4e96ee85$export$dbe6de95c084ac0b.concat($923c9e0e4e96ee85$export$d4f00319c000ebd9),
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true,
        exclusiveBonus: {
            loot: [
                966,
                967,
                968,
                969,
                970,
                971
            ],
            chance: 5000
        }
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 87,
        series: 129,
        schema: 5918,
        effects: $923c9e0e4e96ee85$var$weaponFX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 88,
        series: 130,
        schema: 5922,
        effects: $923c9e0e4e96ee85$export$678a0e6ea5e17d.concat($923c9e0e4e96ee85$export$d4f00319c000ebd9),
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true,
        exclusiveBonus: {
            loot: [
                972
            ],
            chance: 4000
        },
        oneExclusiveBonus: true
    }),
    /* [145] */ new $923c9e0e4e96ee85$var$Crate({
        id: 89,
        series: 131,
        schema: 5925,
        effects: $923c9e0e4e96ee85$var$weaponFX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 90,
        series: 132,
        schema: 5927,
        effects: $923c9e0e4e96ee85$var$summer21FX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 91,
        series: 133,
        schema: 5928,
        effects: $923c9e0e4e96ee85$export$38414dd56dd1142f.concat($923c9e0e4e96ee85$export$d4f00319c000ebd9),
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true,
        exclusiveBonus: {
            loot: [
                1745,
                1746,
                1747,
                1748,
                1749
            ],
            chance: 5000
        }
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 92,
        series: 134,
        schema: 5931,
        effects: $923c9e0e4e96ee85$var$weaponFX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 93,
        series: 135,
        schema: 5935,
        effects: $923c9e0e4e96ee85$export$a5ca802835f1e521.concat($923c9e0e4e96ee85$export$d4f00319c000ebd9),
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true,
        exclusiveBonus: {
            loot: [
                972
            ],
            chance: 4000
        },
        oneExclusiveBonus: true
    }),
    /* [150] */ new $923c9e0e4e96ee85$var$Crate({
        id: 94,
        series: 136,
        schema: 5938,
        effects: $923c9e0e4e96ee85$var$summer22FX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 95,
        series: 137,
        schema: 5939,
        effects: $923c9e0e4e96ee85$export$4af39f2718c7dd8c.concat($923c9e0e4e96ee85$export$d4f00319c000ebd9),
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true,
        exclusiveBonus: {
            loot: [
                1838,
                1839,
                1840,
                1841,
                1842
            ],
            chance: 5000
        }
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 96,
        series: 138,
        schema: 5942,
        effects: $923c9e0e4e96ee85$var$weaponFX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 97,
        series: 139,
        schema: 5947,
        effects: $923c9e0e4e96ee85$export$5d2fb103389bf3ce.concat($923c9e0e4e96ee85$export$d4f00319c000ebd9),
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true,
        exclusiveBonus: {
            loot: [
                972
            ],
            chance: 4000
        },
        oneExclusiveBonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 98,
        series: 140,
        schema: 5949,
        effects: $923c9e0e4e96ee85$export$77cd6f67ebed231f.concat($923c9e0e4e96ee85$export$d4f00319c000ebd9),
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    /* [155] */ new $923c9e0e4e96ee85$var$Crate({
        id: 99,
        series: 141,
        schema: 5951,
        effects: $923c9e0e4e96ee85$var$weaponFX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 100,
        series: 142,
        schema: 5952,
        effects: $923c9e0e4e96ee85$export$6341f1ffae36f6e1.concat($923c9e0e4e96ee85$export$d4f00319c000ebd9),
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true,
        exclusiveBonus: {
            loot: [
                1951,
                1952,
                1953,
                1954
            ],
            chance: 5000
        }
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 101,
        series: 143,
        schema: 5957,
        effects: $923c9e0e4e96ee85$export$8f8d26fc356f0f89,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true,
        exclusiveBonus: {
            loot: [
                972
            ],
            chance: 4000
        },
        oneExclusiveBonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 102,
        series: 144,
        schema: 5959,
        effects: $923c9e0e4e96ee85$export$6418d71abfdb50e1.concat($923c9e0e4e96ee85$export$d4f00319c000ebd9),
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 103,
        series: 145,
        schema: 5960,
        effects: $923c9e0e4e96ee85$export$67f97e3ea05d86cd.concat($923c9e0e4e96ee85$export$d4f00319c000ebd9),
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    /* [160] */ new $923c9e0e4e96ee85$var$Crate({
        id: 104,
        series: 146,
        schema: 5963,
        effects: $923c9e0e4e96ee85$var$weaponFX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 105,
        series: 147,
        schema: 5968,
        effects: $923c9e0e4e96ee85$export$488be7bbcbddddcb.concat($923c9e0e4e96ee85$export$d4f00319c000ebd9),
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true,
        exclusiveBonus: {
            loot: [
                972
            ],
            chance: 4000
        },
        oneExclusiveBonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 106,
        series: 148,
        schema: 5970,
        effects: $923c9e0e4e96ee85$export$78afa2b74c302149.concat($923c9e0e4e96ee85$export$d4f00319c000ebd9),
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 107,
        series: 149,
        schema: 5971,
        effects: $923c9e0e4e96ee85$export$bf8344a3e5db3ea9.concat($923c9e0e4e96ee85$export$d4f00319c000ebd9),
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true,
        exclusiveBonus: {
            loot: [
                2126,
                2127,
                2128,
                2129
            ],
            chance: 5000
        }
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 108,
        series: 150,
        schema: 5976,
        effects: $923c9e0e4e96ee85$export$fee703f8270b19bf.concat($923c9e0e4e96ee85$export$d4f00319c000ebd9),
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true,
        exclusiveBonus: {
            loot: [
                972
            ],
            chance: 4000
        },
        oneExclusiveBonus: true
    }),
    /* [165] */ new $923c9e0e4e96ee85$var$Crate({
        id: 109,
        series: 151,
        schema: 5978,
        effects: $923c9e0e4e96ee85$export$5fd569f55a6c2fd0.concat($923c9e0e4e96ee85$export$d4f00319c000ebd9),
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 110,
        series: 152,
        schema: 5980,
        effects: $923c9e0e4e96ee85$var$weaponFX,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    }),
    new $923c9e0e4e96ee85$var$Crate({
        id: 111,
        series: 153,
        schema: 5981,
        effects: $923c9e0e4e96ee85$export$531bb3e137492ac6,
        note: 5,
        unusual: 2,
        autoChance: 1,
        bonus: true
    })
];
let $923c9e0e4e96ee85$export$43b46fa232650b2f = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    64,
    65,
    66,
    67,
    68,
    69,
    70,
    71,
    72,
    73,
    74,
    75,
    76,
    77,
    78,
    79,
    80,
    81,
    82,
    83,
    84,
    85,
    86,
    87,
    88,
    89,
    90,
    91,
    92,
    93,
    94,
    95,
    96,
    97,
    98,
    99,
    100,
    101,
    102,
    103,
    104,
    105,
    106,
    107,
    108,
    109,
    110,
    111,
    129,
    130,
    131,
    132,
    133,
    134,
    135,
    136,
    137,
    138,
    112,
    113,
    114,
    115,
    116,
    117,
    118,
    119,
    120,
    121,
    122,
    123,
    124,
    125,
    126,
    127,
    128,
    139,
    140,
    141,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
    150,
    151,
    152,
    153,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
    166,
    167,
    168
];
// Define loot for each crate
$923c9e0e4e96ee85$export$afbe48a4a4275937[0].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 3,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 4,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 5,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 6,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 7,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 8,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 9,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[1].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 10,
        chance: 1350,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 11,
        chance: 1350,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 12,
        chance: 1350,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 13,
        chance: 900,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 14,
        chance: 900,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 15,
        chance: 1350,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 16,
        chance: 1350,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 17,
        chance: 1350,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[2].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 18,
        chance: 1650,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 19,
        chance: 1650,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 20,
        chance: 1650,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 21,
        chance: 825,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 22,
        chance: 825,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 23,
        chance: 825,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 24,
        chance: 1650,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 9,
        chance: 825,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[3].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 25,
        chance: 1650,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 26,
        chance: 1650,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 27,
        chance: 1650,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 28,
        chance: 825,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 29,
        chance: 825,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 30,
        chance: 825,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 8,
        chance: 1650,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 15,
        chance: 825,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[4].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 7,
        chance: 1350,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 31,
        chance: 1800,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 32,
        chance: 1800,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 33,
        chance: 1800,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 34,
        chance: 450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 35,
        chance: 450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 36,
        chance: 450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 30,
        chance: 450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 37,
        chance: 1350,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[5].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 38,
        chance: 1340,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 39,
        chance: 1340,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 40,
        chance: 1340,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 41,
        chance: 1340,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 42,
        chance: 1340,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 43,
        chance: 200,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 44,
        chance: 200,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 45,
        chance: 200,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 46,
        chance: 200,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 47,
        chance: 200,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 48,
        chance: 200,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 49,
        chance: 200,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 50,
        chance: 200,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 51,
        chance: 200,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 52,
        chance: 200,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 53,
        chance: 200,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 54,
        chance: 200,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 55,
        chance: 200,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 56,
        chance: 200,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 57,
        chance: 200,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 58,
        chance: 200,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[6].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 59,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 60,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 18,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 62,
        chance: 350,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 63,
        chance: 350,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 64,
        chance: 350,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 65,
        chance: 350,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 24,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 66,
        chance: 1700,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[7].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 67,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 68,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 69,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 70,
        chance: 350,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 71,
        chance: 350,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 72,
        chance: 350,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 73,
        chance: 350,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 15,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 74,
        chance: 1700,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[8].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 105,
        chance: 1600,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 106,
        chance: 1600,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 107,
        chance: 1600,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 108,
        chance: 1600,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 109,
        chance: 1600,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 110,
        chance: 1600,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 111,
        chance: 300,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[9].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 112,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 113,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 114,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 115,
        chance: 1450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 116,
        chance: 1450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 117,
        chance: 634,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 118,
        chance: 633,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 62,
        chance: 633,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[10].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 37,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 16,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 119,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 120,
        chance: 1450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 121,
        chance: 1450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 122,
        chance: 634,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 123,
        chance: 633,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 124,
        chance: 633,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[11].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 125,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 126,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 127,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 128,
        chance: 1450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 129,
        chance: 1450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 130,
        chance: 634,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 131,
        chance: 633,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 49,
        chance: 633,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[12].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 8,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 105,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 106,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 132,
        chance: 1450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 18,
        chance: 1450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 133,
        chance: 634,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 134,
        chance: 633,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 135,
        chance: 633,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[13].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 9,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 107,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 108,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 12,
        chance: 1450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 27,
        chance: 1450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 73,
        chance: 634,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 136,
        chance: 633,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 44,
        chance: 633,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[14].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 66,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 109,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 110,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 10,
        chance: 1450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 25,
        chance: 1450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 111,
        chance: 634,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 46,
        chance: 633,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 137,
        chance: 633,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[15].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 112,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 37,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 125,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 11,
        chance: 1450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 138,
        chance: 1450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 65,
        chance: 634,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 57,
        chance: 633,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 28,
        chance: 633,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[16].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 113,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 16,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 126,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 139,
        chance: 1450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 31,
        chance: 1450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 140,
        chance: 634,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 51,
        chance: 633,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 53,
        chance: 633,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[17].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 114,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 119,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 127,
        chance: 1700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 141,
        chance: 1450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2,
        chance: 1450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 142,
        chance: 634,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 47,
        chance: 633,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 143,
        chance: 633,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[18].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 59,
        chance: 2100,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 144,
        chance: 2100,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 145,
        chance: 2100,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 146,
        chance: 2100,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 147,
        chance: 500,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 148,
        chance: 500,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 149,
        chance: 500,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[19].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 150,
        chance: 2225,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 26,
        chance: 2225,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 151,
        chance: 2225,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 60,
        chance: 2225,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 152,
        chance: 500,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 153,
        chance: 500,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[20].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 154,
        chance: 2225,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 151,
        chance: 2225,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 155,
        chance: 2225,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 156,
        chance: 2225,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 157,
        chance: 500,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 158,
        chance: 500,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[21].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 159,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 160,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 161,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 162,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 163,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 164,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 165,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 166,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 167,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[22].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 168,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 169,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 170,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 171,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 172,
        chance: 450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 65,
        chance: 450,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[23].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 173,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 174,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 175,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 176,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 177,
        chance: 450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 178,
        chance: 450,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[24].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 179,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 180,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 31,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 181,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 182,
        chance: 450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 183,
        chance: 450,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[25].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 184,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 120,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 185,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 186,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 187,
        chance: 450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 188,
        chance: 450,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[26].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 189,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 132,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 18,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 190,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 56,
        chance: 450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 191,
        chance: 450,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[27].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 151,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 192,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 38,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 193,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 35,
        chance: 450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 194,
        chance: 450,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[28].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 195,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 10,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 196,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 146,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 197,
        chance: 450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 198,
        chance: 450,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[29].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 115,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 199,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 200,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 201,
        quality: 2
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[30].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 138,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 202,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 203,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 139,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 204,
        chance: 450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 58,
        chance: 450,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[31].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 128,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 205,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 12,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 3,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 53,
        chance: 450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 48,
        chance: 450,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[32].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 206,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 207,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 121,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 27,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 52,
        chance: 450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 58,
        chance: 450,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[33].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 208,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 209,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 33,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 4,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 210,
        chance: 450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 211,
        chance: 450,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[34].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 212,
        chance: 1089,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 213,
        chance: 99,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 214,
        chance: 1089,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 215,
        chance: 1089,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 216,
        chance: 1089,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 217,
        chance: 1089,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 218,
        chance: 1089,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 219,
        chance: 1089,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 220,
        chance: 1089,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 221,
        chance: 1089,
        quality: 4
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[35].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 222,
        chance: 1742,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 223,
        chance: 1742,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 224,
        chance: 1741,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 225,
        chance: 425,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 226,
        chance: 425,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 227,
        chance: 425,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 228,
        chance: 425,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 229,
        chance: 425,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 230,
        chance: 425,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 231,
        chance: 425,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 232,
        chance: 425,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 233,
        chance: 425,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 234,
        chance: 425,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 235,
        chance: 425,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[36].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 236,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 237,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 238,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 239,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 240,
        chance: 450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 177,
        chance: 450,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[37].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 241,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 242,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 243,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 244,
        chance: 2250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 245,
        chance: 450,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 246,
        chance: 450,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[38].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 116,
        chance: 2357,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 247,
        chance: 2357,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 175,
        chance: 2357,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 248,
        chance: 943,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 249,
        chance: 943,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 250,
        chance: 472,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 34,
        chance: 471,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[39].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 223,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 69,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 251,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 252,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 253,
        quality: 2
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[40].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 254,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 60,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 255,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 256,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 257,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 258,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 259,
        chance: 495,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 260,
        chance: 495,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[41].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 261,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 41,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 169,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 262,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 263,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 264,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 265,
        chance: 495,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 266,
        chance: 495,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[42].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 267,
        chance: 2200,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 268,
        chance: 2200,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 11,
        chance: 2200,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 269,
        chance: 1100,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 270,
        chance: 1100,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 122,
        chance: 550,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 49,
        chance: 550,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[43].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 150,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 271,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 3,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 272,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 273,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 274,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 275,
        chance: 495,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 23,
        chance: 495,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[44].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 145,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 276,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 277,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 278,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 279,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 280,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 281,
        chance: 495,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 64,
        chance: 495,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[45].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 282,
        chance: 1250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 283,
        chance: 1250,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 284,
        chance: 600,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 285,
        chance: 600,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 286,
        chance: 600,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 287,
        chance: 600,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 288,
        chance: 600,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 289,
        chance: 600,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 290,
        chance: 600,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 291,
        chance: 600,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 292,
        chance: 600,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 293,
        chance: 600,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 294,
        chance: 600,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 295,
        chance: 400,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 296,
        chance: 400,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[46].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 67,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 179,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 297,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 298,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 299,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 300,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 301,
        chance: 495,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 134,
        chance: 495,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[47].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 302,
        chance: 1050,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 303,
        chance: 1050,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 304,
        chance: 1050,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 305,
        chance: 1050,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 306,
        chance: 1050,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 307,
        chance: 1050,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 308,
        chance: 1050,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 309,
        chance: 1050,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 310,
        chance: 1050,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 311,
        chance: 450,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[48].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 20,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 312,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 170,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 313,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 314,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 315,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 316,
        chance: 495,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 317,
        chance: 495,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[49].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 318,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 319,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 320,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 321,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 322,
        quality: 2
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[50].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 323,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 324,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 325,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 326,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 327,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 328,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 329,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 330,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 331,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 332,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 333,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 334,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 335,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 336,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 337,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 338,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 339,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 340,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 341,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 342,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 343,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 344,
        quality: 3
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[51].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 345,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 346,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 347,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 348,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 349,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 350,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 351,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 352,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 353,
        quality: 4
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[52].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 354,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 355,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 356,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 357,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 358,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 359,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 360,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 361,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 362,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 363,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 364,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 365,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 366,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[53].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 222,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 224,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 189,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 367,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 368,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 369,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 370,
        chance: 495,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 371,
        chance: 495,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[54].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 372,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 26,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 186,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 373,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 374,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 257,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 375,
        chance: 495,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 376,
        chance: 495,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[55].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 377,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 378,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 379,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 380,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 381,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 382,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 211,
        chance: 495,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 383,
        chance: 495,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[56].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 40,
        chance: 2200,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 384,
        chance: 2200,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 190,
        chance: 2200,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 385,
        chance: 1100,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 167,
        chance: 1100,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 44,
        chance: 1100,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[57].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 386,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 387,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 388,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 389,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 390,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 391,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 392,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 393,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 394,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 395,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 396,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 397,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 398,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 399,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 400,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 401,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 402,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 403,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 404,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 405,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 406,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 407,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 408,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 409,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 410,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 411,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 412,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 413,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 414,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 415,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 416,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 417,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 418,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 419,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 420,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 421,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 422,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 423,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 424,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 425,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 426,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 427,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 428,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 429,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 430,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 431,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 432,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 433,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 434,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 435,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 436,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 437,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 438,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 439,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 440,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 441,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 442,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[58].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 443,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 444,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 445,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 446,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 258,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 447,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 308,
        chance: 495,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 448,
        chance: 495,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[59].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 449,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 450,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 451,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1573,
        quality: 12
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 453,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[60].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 454,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 455,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 456,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 457,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 458,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 459,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 460,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 461,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 462,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 463,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[61].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 464,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 465,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 466,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 467,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 468,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 469,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 470,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 471,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[62].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 472,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 473,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 474,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 475,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 476,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 477,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 478,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 479,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[63].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 480,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 481,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 482,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 483,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 484,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 485,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 486,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 487,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[64].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 488,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 489,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 490,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 491,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 492,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 493,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 494,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 495,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[65].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 496,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 497,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 498,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 499,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 500,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 501,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 502,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 503,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[66].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 504,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 505,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 506,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 507,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 508,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 509,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 510,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 511,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[67].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 512,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 513,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 514,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 515,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 516,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 517,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 518,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 519,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[68].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 520,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 521,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 522,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 523,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 524,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 525,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 526,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 527,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[69].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 25,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 528,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 68,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 256,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 529,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 530,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 519,
        chance: 495,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 303,
        chance: 495,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[70].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 531,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 532,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 533,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 534,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 535,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 536,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 537,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 538,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 539,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 540,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 541,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 542,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[71].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 543,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 544,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 545,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 546,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 547,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 548,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 549,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 550,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 551,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 552,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 553,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 554,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[72].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 555,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 556,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 557,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 558,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 559,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 560,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 561,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 562,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 563,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 564,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 565,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 566,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 567,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 568,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 569,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 570,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 571,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 572,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 573,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 574,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 575,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 576,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 577,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 578,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 579,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 580,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 581,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 582,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 583,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 584,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 585,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 586,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 587,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 588,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 589,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 590,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 591,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 592,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 593,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 594,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 595,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 596,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 597,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 598,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 599,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 600,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 601,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 602,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 603,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 604,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 605,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 606,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 607,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 608,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 609,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 610,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 611,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 612,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 613,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 614,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 615,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 616,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 617,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 618,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 619,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 620,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 621,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 622,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 623,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 624,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 625,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 626,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 627,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 628,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 629,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 630,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 631,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 632,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 633,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 634,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 635,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 636,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 637,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 638,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 639,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 640,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 641,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 642,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 643,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 644,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 645,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 646,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 647,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 648,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 649,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 650,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 651,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 652,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 653,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 654,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 655,
        quality: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 656,
        quality: 3
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[73].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 19,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 657,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 132,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 658,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 659,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 660,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 43,
        chance: 495,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 284,
        chance: 495,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[74].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 661,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 176,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 662,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 663,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 664,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 665,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 666,
        chance: 495,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 359,
        chance: 495,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[75].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 667,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 144,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 668,
        chance: 1980,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 669,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 670,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 671,
        chance: 990,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 672,
        chance: 495,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 50,
        chance: 495,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[76].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 673,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 674,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 675,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 676,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 677,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 678,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 679,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 680,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 681,
        quality: 4
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[77].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 682,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 683,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 684,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 685,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 686,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 687,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 688,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 689,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 690,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 691,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 692,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 693,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 694,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 695,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 696,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 697,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 698,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 699,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 701,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 702,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 703,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 704,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 705,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 706,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 707,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 708,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 709,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 710,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 711,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 712,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 713,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[78].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 714,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 715,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 716,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 717,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 718,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 719,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 720,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 721,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 722,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 723,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 724,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 725,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 726,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 727,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 728,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 729,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 730,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 731,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 732,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 733,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 734,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 735,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 736,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 737,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 738,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 739,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 740,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 741,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 742,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 743,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 744,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 745,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 746,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 747,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 748,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 749,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 750,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 751,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 752,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 753,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 754,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 755,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 756,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[79].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 757,
        chance: 2000,
        quality: 12
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 758,
        chance: 2000,
        quality: 12
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 759,
        chance: 2000,
        quality: 12
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 760,
        chance: 1000,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 761,
        chance: 1000,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 264,
        chance: 1000,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 177,
        chance: 500,
        quality: 12
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 130,
        chance: 500,
        quality: 12
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[80].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 150,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 170,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 189,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 151,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 205,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 154,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 224,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 195,
        quality: 11
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[81].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 75,
        quality: 7
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 76,
        quality: 7
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 77,
        quality: 7
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 78,
        quality: 7
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 79,
        quality: 7
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 80,
        quality: 7
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 81,
        quality: 7
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 82,
        quality: 7
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 83,
        quality: 7
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 84,
        quality: 7
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 85,
        quality: 7
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 86,
        quality: 7
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 87,
        quality: 7
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 88,
        quality: 7
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 89,
        quality: 7
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[82].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 772,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 773,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 774,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 775,
        quality: 4
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[83].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 776,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 777,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 778,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 779,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 780,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 781,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 782,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 783,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 784,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 785,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 786,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 787,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 788,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 789,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 790,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 791,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 792,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 793,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 794,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 795,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 796,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 797,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 798,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 799,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 800,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 801,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 802,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 803,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 804,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 805,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 806,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 807,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 808,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 809,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 810,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 811,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 812,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 813,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 814,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 815,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 816,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 817,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 818,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 819,
        quality: 1
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[84].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 145,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 155,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 60,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 69,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 181,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1128,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 199,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 173,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 192,
        quality: 11
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[85].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1572,
        chance: 1500,
        quality: 12
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 830,
        chance: 1500,
        quality: 12
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 831,
        chance: 1500,
        quality: 12
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1571,
        chance: 1500,
        quality: 12
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 833,
        chance: 1000,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 834,
        chance: 1000,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 262,
        chance: 1000,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1404,
        chance: 334,
        quality: 12
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1466,
        chance: 333,
        quality: 12
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 251,
        chance: 333,
        quality: 12
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[86].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 889,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 890,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 891,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 892,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 893,
        quality: 9
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 894,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 895,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 896,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 897,
        quality: 4
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[87].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 838,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 839,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 840,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 841,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 842,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 843,
        quality: 8
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[88].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 844,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 845,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 846,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 847,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 848,
        quality: 8
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[89].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 849,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 850,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 851,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 852,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 853,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 854,
        quality: 8
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[90].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 855,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 856,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 857,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 858,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 859,
        quality: 8
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[91].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 860,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 861,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 862,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 863,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 864,
        quality: 8
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[92].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 865,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 866,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 867,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 868,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 869,
        quality: 8
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[93].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 870,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 871,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 872,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 873,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 874,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 875,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 876,
        quality: 8
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[94].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 877,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 878,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 879,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 880,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 881,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 882,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 883,
        quality: 8
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[95].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 884,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 885,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 886,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 887,
        quality: 8
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 888,
        quality: 8
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[96].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 898,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 899,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 900,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 901,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 902,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 903,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 904,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 905,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 906,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 907,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 908,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 909,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 910,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 911,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 912,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 913,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 914,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 915,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 916,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 917,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 918,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 919,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 920,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 921,
        quality: 4
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[97].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 922,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 923,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 924,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 925,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 926,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 927,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 928,
        quality: 4
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[98].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 929,
        quality: 9
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 930,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 931,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 932,
        quality: 9
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 933,
        quality: 9
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 934,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 935,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 936,
        quality: 9
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 937,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 938,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 939,
        quality: 9
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 940,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 941,
        quality: 9
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 942,
        quality: 9
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 943,
        quality: 9
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 944,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 945,
        quality: 9
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 946,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 947,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 948,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 949,
        quality: 9
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 950,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 951,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 952,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 953,
        quality: 9
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 954,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 955,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 956,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 957,
        quality: 4
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[99].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 958,
        chance: 1213,
        quality: 12
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 959,
        chance: 1213,
        quality: 12
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 960,
        chance: 1213,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 961,
        chance: 1213,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 962,
        chance: 1212,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 963,
        chance: 1212,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 964,
        chance: 1212,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 198,
        chance: 1212,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 965,
        chance: 100,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 115,
        chance: 100,
        quality: 2
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[100].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 180,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 193,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 176,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 201,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 372,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 444,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 450,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1571,
        quality: 11
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1572,
        quality: 11
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[101].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 39,
        chance: 1607,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 975,
        chance: 1607,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 976,
        chance: 1607,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 977,
        chance: 1607,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 978,
        chance: 1607,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 42,
        chance: 333,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 141,
        chance: 333,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 979,
        chance: 333,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 980,
        chance: 333,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 981,
        chance: 333,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 982,
        chance: 100,
        quality: 12
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 199,
        chance: 100,
        quality: 2
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[102].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 104,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 103,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 102,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 101,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 100,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 99,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 98,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 97,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 96,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 95,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 94,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 93,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 92,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 91,
        quality: 6,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 90,
        quality: 6,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[103].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 983,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 984,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 985,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 986,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 987,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 988,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 989,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 990,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 991,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 992,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 993,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 994,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 995,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 996,
        quality: 6,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 997,
        quality: 6,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[104].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 998,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 999,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1000,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1001,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1002,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1003,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1004,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1005,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1006,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1007,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1008,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1009,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1010,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1011,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1012,
        quality: 10,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1013,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[105].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1014,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1015,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1016,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1017,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1018,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1019,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1020,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1021,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1022,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1023,
        quality: 10,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1024,
        quality: 4,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[106].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1025,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1026,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1027,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1028,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1029,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1030,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1031,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1032,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1033,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1034,
        quality: 4,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[107].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1053,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1035,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1036,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1037,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1038,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1039,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1040,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1041,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1042,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1043,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1044,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1045,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1046,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1047,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1048,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1049,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1050,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1051,
        quality: 4,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1052,
        quality: 4,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[108].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1054,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1055,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1056,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1057,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1058,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1059,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1060,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1061,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1062,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1063,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1064,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1065,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1066,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1067,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1068,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1069,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1070,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1071,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1072,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1073,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1074,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1075,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1076,
        quality: 6,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1077,
        quality: 6,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1078,
        quality: 6,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[109].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1079,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1080,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1081,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1082,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1083,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1084,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1085,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1086,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1087,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1088,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1089,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1090,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1091,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1092,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1093,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1094,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1095,
        quality: 6,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1096,
        quality: 6,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[110].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1097,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1098,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1099,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1100,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1101,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1102,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1103,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1104,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1105,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1106,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1107,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1108,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1109,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1110,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1111,
        quality: 10,
        grade: 5
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[111].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1112,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1113,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1114,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1115,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1116,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1117,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1118,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1119,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1120,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1121,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1122,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1123,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1124,
        quality: 4,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1125,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[112].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 258,
        chance: 700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 373,
        chance: 700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 272,
        chance: 700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 670,
        chance: 700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 665,
        chance: 700,
        quality: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1126,
        chance: 100,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 156,
        chance: 700,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 31,
        chance: 700,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 139,
        chance: 700,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 208,
        chance: 700,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 173,
        chance: 700,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1127,
        chance: 700,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1128,
        chance: 700,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1129,
        chance: 700,
        quality: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1130,
        chance: 700,
        quality: 2
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[113].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1131,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1132,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1133,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1134,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1135,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1136,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1137,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1138,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1139,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1140,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1141,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1142,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1143,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1144,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1145,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1146,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1147,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1148,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1149,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1150,
        quality: 10,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1151,
        quality: 4,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[114].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1152,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1153,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1154,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1155,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1156,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1157,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1158,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1159,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1160,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1161,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1162,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1163,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1164,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1165,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1166,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1167,
        quality: 10,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1168,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[115].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1169,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1170,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1171,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1172,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1173,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1174,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1175,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1176,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1177,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1178,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1179,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1180,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1181,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1182,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1183,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1184,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1185,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1186,
        quality: 10,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1187,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[116].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1188,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1189,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1190,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1191,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1192,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1193,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1194,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1195,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1196,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1197,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1198,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1199,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1200,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1201,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1202,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1203,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1204,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1205,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1206,
        quality: 10,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1207,
        quality: 4,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[117].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1208,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1209,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1210,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1211,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1212,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1213,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1214,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1215,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1216,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1217,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1218,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1219,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1220,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1221,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1222,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1223,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1224,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1225,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1226,
        quality: 10,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1227,
        quality: 4,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[118].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1228,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1229,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1230,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1231,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1232,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1233,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1234,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1235,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1236,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1237,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1238,
        quality: 6,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[119].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1239,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1240,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1241,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1242,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1243,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1244,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1245,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1246,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1247,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1248,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1249,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1250,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1251,
        quality: 6,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[120].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1252,
        quality: 5,
        grade: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1253,
        quality: 5,
        grade: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1254,
        quality: 5,
        grade: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1255,
        quality: 5,
        grade: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1256,
        quality: 5,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1257,
        quality: 5,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1258,
        quality: 5,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1259,
        quality: 5,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1260,
        quality: 5,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1261,
        quality: 5,
        grade: 4
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[121].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1262,
        quality: 5,
        grade: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1263,
        quality: 5,
        grade: 1
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1264,
        quality: 5,
        grade: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1265,
        quality: 5,
        grade: 2
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1266,
        quality: 5,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1267,
        quality: 5,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1268,
        quality: 5,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1269,
        quality: 5,
        grade: 4
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[122].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1270,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1271,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1272,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1273,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1274,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1275,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1276,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1277,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1278,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1279,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1280,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1281,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1282,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1283,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1284,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1285,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1286,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1287,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1288,
        quality: 10,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1289,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[123].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1290,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1291,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1292,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1293,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1294,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1295,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1296,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1297,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1298,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1299,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1300,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1301,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1302,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1303,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1304,
        quality: 6,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[124].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1305,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1306,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1307,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1308,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1309,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1310,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1311,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1312,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1313,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1314,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1315,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1316,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1317,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1318,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1319,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1320,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1321,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1322,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1323,
        quality: 4,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[125].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1324,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1325,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1326,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1327,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1328,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1329,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1330,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1331,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1332,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1333,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1334,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1335,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1336,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1337,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1338,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1339,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1340,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1341,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1342,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1343,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[126].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1344,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1345,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1346,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1347,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1348,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1349,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1350,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1351,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1352,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1353,
        quality: 6,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[127].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1422,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1423,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1424,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1425,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1426,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1427,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1428,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1429,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1430,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1431,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1432,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1433,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1434,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1435,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1436,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1437,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1438,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1439,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[128].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1440,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1441,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1442,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1443,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1444,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1445,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1446,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1447,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1448,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1449,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1450,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1451,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1452,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1453,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1454,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1455,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1456,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1457,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1458,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1459,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1460,
        quality: 10,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1461,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[129].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 776,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 301,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1462,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 225,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 517,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 386,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1355,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 387,
        quality: 10
    }),
    //Row2
    new $923c9e0e4e96ee85$var$Item({
        id: 226,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1463,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 900,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 521,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 698,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 508,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 486,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 361,
        quality: 4
    }),
    //Row3
    new $923c9e0e4e96ee85$var$Item({
        id: 288,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 448,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 289,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 532,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 777,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 666,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 506,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 499,
        quality: 4
    }),
    //Row4
    new $923c9e0e4e96ee85$var$Item({
        id: 1358,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 703,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 778,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 779,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 780,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 710,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 704,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 781,
        quality: 4
    }),
    //Row5
    new $923c9e0e4e96ee85$var$Item({
        id: 331,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1464,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 912,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 714,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 307,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 21,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 389,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 172,
        quality: 10
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[130].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 709,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 519,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 287,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 480,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 782,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 459,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 921,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 918,
        quality: 4
    }),
    //Row2
    new $923c9e0e4e96ee85$var$Item({
        id: 509,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 514,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 913,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1368,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 520,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 390,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 715,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 292,
        quality: 10
    }),
    //Row3
    new $923c9e0e4e96ee85$var$Item({
        id: 485,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1369,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 716,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 229,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 518,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1367,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 783,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 713,
        quality: 4
    }),
    //Row4
    new $923c9e0e4e96ee85$var$Item({
        id: 914,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 488,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 908,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 476,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 692,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 358,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 391,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1465,
        quality: 4
    }),
    //Row5
    new $923c9e0e4e96ee85$var$Item({
        id: 784,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1360,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 392,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 137,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 393,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 475,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 308,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 525,
        quality: 10
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[131].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 550,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1466,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 469,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1376,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 682,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 394,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 549,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1371,
        quality: 10
    }),
    //Row2
    new $923c9e0e4e96ee85$var$Item({
        id: 510,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1467,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 343,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 785,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1468,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 489,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 395,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 786,
        quality: 10
    }),
    //Row3
    new $923c9e0e4e96ee85$var$Item({
        id: 396,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 397,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 245,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 787,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 788,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 398,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 230,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 496,
        quality: 10
    }),
    //Row4
    new $923c9e0e4e96ee85$var$Item({
        id: 370,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 296,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 231,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1469,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1377,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 789,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 463,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 399,
        quality: 10
    }),
    //Row5
    new $923c9e0e4e96ee85$var$Item({
        id: 904,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 5,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 483,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 400,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1470,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 401,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 310,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 402,
        quality: 10
    }),
    //Row6
    new $923c9e0e4e96ee85$var$Item({
        id: 183,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 403,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 404,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 790,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 791,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 718,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 527,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 699,
        quality: 4
    }),
    //Row7
    new $923c9e0e4e96ee85$var$Item({
        id: 705,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 686,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 546,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 898,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1379,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 354,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 342,
        quality: 10
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[132].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1471,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1472,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 792,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 309,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 285,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 512,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 405,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 406,
        quality: 4
    }),
    //Row2
    new $923c9e0e4e96ee85$var$Item({
        id: 907,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 407,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1386,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 719,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 357,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 408,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 461,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 915,
        quality: 4
    }),
    //Row3
    new $923c9e0e4e96ee85$var$Item({
        id: 901,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 409,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 793,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 498,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 477,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 487,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 118,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 410,
        quality: 4
    }),
    //Row4
    new $923c9e0e4e96ee85$var$Item({
        id: 711,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 548,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 721,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1473,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 537,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 48,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 411,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 794,
        quality: 10
    }),
    //Row5
    new $923c9e0e4e96ee85$var$Item({
        id: 722,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1380,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 412,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 795,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 796,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1474,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 464,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 413,
        quality: 10
    }),
    //Row6
    new $923c9e0e4e96ee85$var$Item({
        id: 724,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 492,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 712,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 281,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 341,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 507,
        quality: 4
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[133].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 284,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 516,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 491,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 474,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 725,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 414,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 726,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 727,
        quality: 10
    }),
    //Row2
    new $923c9e0e4e96ee85$var$Item({
        id: 905,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 522,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 728,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 415,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1391,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 729,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 363,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 468,
        quality: 4
    }),
    //Row3
    new $923c9e0e4e96ee85$var$Item({
        id: 917,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 481,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 730,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1475,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 697,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 693,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 131,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1392,
        quality: 10
    }),
    //Row4
    new $923c9e0e4e96ee85$var$Item({
        id: 265,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 731,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 505,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 732,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 232,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 916,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 303,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 416,
        quality: 4
    }),
    //Row5
    new $923c9e0e4e96ee85$var$Item({
        id: 1476,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 197,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 733,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 501,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 417,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 462,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 734,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 735,
        quality: 4
    }),
    //Row6
    new $923c9e0e4e96ee85$var$Item({
        id: 797,
        quality: 4
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[134].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 736,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 366,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1394,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 672,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 798,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 418,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 708,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 473,
        quality: 4
    }),
    //Row2
    new $923c9e0e4e96ee85$var$Item({
        id: 799,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 737,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 800,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1393,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 700,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 513,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 533,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 293,
        quality: 4
    }),
    //Row3
    new $923c9e0e4e96ee85$var$Item({
        id: 899,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 801,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 802,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 803,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 467,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 804,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1396,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 420,
        quality: 10
    }),
    //Row4
    new $923c9e0e4e96ee85$var$Item({
        id: 304,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 458,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 143,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 35,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 738,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 903,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 233,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 421,
        quality: 4
    }),
    //Row5
    new $923c9e0e4e96ee85$var$Item({
        id: 1477,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1478,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 964,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 422,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 423,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 805,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 523,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 739,
        quality: 10
    }),
    //Row6
    new $923c9e0e4e96ee85$var$Item({
        id: 740,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1397,
        quality: 10
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[135].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 545,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 690,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1479,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 524,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 424,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 806,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 741,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1480,
        quality: 4
    }),
    //Row2
    new $923c9e0e4e96ee85$var$Item({
        id: 515,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 478,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 465,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 482,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 504,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 497,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 526,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 490,
        quality: 10
    }),
    //Row3
    new $923c9e0e4e96ee85$var$Item({
        id: 356,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 360,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 742,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 743,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 744,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 290,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 425,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 745,
        quality: 4
    }),
    //Row4
    new $923c9e0e4e96ee85$var$Item({
        id: 746,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 696,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 426,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 306,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 551,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 807,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1481,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 689,
        quality: 10
    }),
    //Row5
    new $923c9e0e4e96ee85$var$Item({
        id: 188,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 427,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 428,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 701,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 553,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 748,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 429,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 371,
        quality: 4
    }),
    //Row6
    new $923c9e0e4e96ee85$var$Item({
        id: 316,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1482,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 749,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 430,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 123,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 431,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 542,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 808,
        quality: 4
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[136].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 750,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 500,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 538,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 536,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 493,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 359,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 259,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 706,
        quality: 4
    }),
    //Row2
    new $923c9e0e4e96ee85$var$Item({
        id: 511,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 695,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1407,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 702,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 751,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 302,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 432,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 539,
        quality: 4
    }),
    //Row3
    new $923c9e0e4e96ee85$var$Item({
        id: 294,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1402,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 234,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 134,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1483,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 809,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 135,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 433,
        quality: 10
    }),
    //Row4
    new $923c9e0e4e96ee85$var$Item({
        id: 323,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 688,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 434,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1406,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 810,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 472,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1405,
        quality: 10
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[137].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 495,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 811,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 812,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 136,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 753,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 435,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 479,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 466,
        quality: 4
    }),
    //Row2
    new $923c9e0e4e96ee85$var$Item({
        id: 436,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 286,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1484,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 375,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 355,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 540,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 503,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 305,
        quality: 10
    }),
    //Row3
    new $923c9e0e4e96ee85$var$Item({
        id: 541,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1413,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 437,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 754,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 460,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 484,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 813,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 326,
        quality: 4
    }),
    //Row4
    new $923c9e0e4e96ee85$var$Item({
        id: 814,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1485,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1486,
        quality: 4
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[138].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 227,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1420,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 295,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 442,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 543,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 329,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 388,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 906,
        quality: 10
    }),
    //Row2
    new $923c9e0e4e96ee85$var$Item({
        id: 456,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 454,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 235,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 816,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1487,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1488,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 902,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 552,
        quality: 10
    }),
    //Row3
    new $923c9e0e4e96ee85$var$Item({
        id: 327,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 544,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 717,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 720,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 687,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 755,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 684,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1489,
        quality: 4
    }),
    //Row4
    new $923c9e0e4e96ee85$var$Item({
        id: 419,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 328,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 340,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 817,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 471,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1490,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 911,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 554,
        quality: 4
    }),
    //Row5
    new $923c9e0e4e96ee85$var$Item({
        id: 438,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 494,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 275,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 291,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 547,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1418,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1419,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1491,
        quality: 4
    }),
    //Row6
    new $923c9e0e4e96ee85$var$Item({
        id: 1417,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 691,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 756,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 502,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1492,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 815,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 365,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 439,
        quality: 10
    }),
    //Row7
    new $923c9e0e4e96ee85$var$Item({
        id: 383,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 747,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 364,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 685,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1414,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 440,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 228,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1493,
        quality: 4
    }),
    //Row8
    new $923c9e0e4e96ee85$var$Item({
        id: 707,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 457,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1494,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 325,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 250,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 910,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 723,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 535,
        quality: 4
    }),
    //Row9
    new $923c9e0e4e96ee85$var$Item({
        id: 332,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 683,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1495,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 818,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 752,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 362,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1415,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 441,
        quality: 10
    }),
    //Row10
    new $923c9e0e4e96ee85$var$Item({
        id: 694,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1496,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1497,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 531,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 470,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 819,
        quality: 10
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 534,
        quality: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 455,
        quality: 10
    }),
    //Row11
    new $923c9e0e4e96ee85$var$Item({
        id: 909,
        quality: 10
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[139].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1499,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1500,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1501,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1502,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1503,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1504,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1505,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1506,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1507,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1508,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1509,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1510,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1511,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1512,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1513,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1514,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1515,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1516,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1517,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1518,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1519,
        quality: 4,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1520,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[140].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1521,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1522,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1523,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1524,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1525,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1526,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1527,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1528,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1529,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1530,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1531,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1532,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1533,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1534,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1535,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1536,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1537,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1538,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[141].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1539,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1540,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1541,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1542,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1543,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1544,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1545,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1546,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1547,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1548,
        quality: 6,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[142].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1549,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1550,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1551,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1552,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1553,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1554,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1555,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1556,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1557,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1558,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1559,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1560,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1561,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1562,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1563,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1564,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1565,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1566,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1567,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1568,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1569,
        quality: 10,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1570,
        quality: 4,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[143].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1574,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1575,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1576,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1577,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1578,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1579,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1580,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1581,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1582,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1583,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1584,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1585,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1586,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1587,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1588,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1589,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1590,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1591,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1592,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1593,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1594,
        quality: 4,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1595,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[144].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1596,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1597,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1598,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1599,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1600,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1601,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1602,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1603,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1604,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1605,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1606,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1607,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1608,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1609,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1610,
        quality: 6,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[145].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1666,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1667,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1668,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1669,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1670,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1671,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1672,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1673,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1674,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1675,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1676,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1677,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1678,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1679,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1680,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1681,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1682,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1683,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1684,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1685,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[146].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1686,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1687,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1688,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1689,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1690,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1691,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1692,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1693,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1694,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1695,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1696,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1697,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1698,
        quality: 6,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[147].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1707,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1708,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1709,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1710,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1711,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1712,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1713,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1714,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1715,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1716,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1717,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1718,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1719,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1720,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1721,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1722,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1723,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1724,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[148].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1725,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1726,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1727,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1728,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1729,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1730,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1731,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1732,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1733,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1734,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1735,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1736,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1737,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1738,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1739,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1740,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1741,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1742,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1743,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1744,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[149].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1750,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1751,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1752,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1753,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1754,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1755,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1756,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1757,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1758,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1759,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1760,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1761,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1762,
        quality: 6,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[150].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1768,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1769,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1770,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1771,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1772,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1773,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1774,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1775,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1776,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1777,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1778,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1779,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1780,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1781,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1782,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1783,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1784,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1785,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1786,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1787,
        quality: 4,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[151].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1791,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1792,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1793,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1794,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1795,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1796,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1797,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1798,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1799,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1800,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1801,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1802,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1803,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1804,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1805,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1806,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1807,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1808,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1809,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1810,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1811,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1812,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1813,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1814,
        quality: 4,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1815,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[152].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1816,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1817,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1818,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1819,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1820,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1821,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1822,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1823,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1824,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1825,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1826,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1827,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1828,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1829,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1830,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1831,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1832,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1833,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1834,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1835,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1836,
        quality: 10,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1837,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[153].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1843,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1844,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1845,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1846,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1847,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1848,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1849,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1850,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1851,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1852,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1853,
        quality: 6,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[154].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1859,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1860,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1861,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1862,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1863,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1864,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1865,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1866,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1867,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1868,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1869,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1870,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1871,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1872,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1873,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1874,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1875,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1876,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1877,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1878,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1879,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1880,
        quality: 10,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1881,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[155].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1885,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1886,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1887,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1888,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1889,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1890,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1891,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1892,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1893,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1894,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1895,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1896,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1897,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1898,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1899,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1900,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1901,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1902,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1903,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1904,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1905,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1906,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1907,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1908,
        quality: 10,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1909,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[156].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1910,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1911,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1912,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1913,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1914,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1915,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1916,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1917,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1918,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1919,
        quality: 6,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[157].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1926,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1927,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1928,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1929,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1930,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1931,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1932,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1933,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1934,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1935,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1936,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1937,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1938,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1939,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1940,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1941,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1942,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1943,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1944,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1945,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1946,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1947,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1948,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1949,
        quality: 10,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1950,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[158].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1959,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1960,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1961,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1962,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1963,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1964,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1965,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1966,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1967,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1968,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1969,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1970,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1971,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1972,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1973,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1974,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1975,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1976,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1977,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1978,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1979,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1980,
        quality: 10,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1981,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[159].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 1985,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1986,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1987,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1988,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1989,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1990,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1991,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1992,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1993,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1994,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1995,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1996,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1997,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1998,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 1999,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2000,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2001,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2002,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2003,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2004,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2005,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2006,
        quality: 4,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2007,
        quality: 4,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[160].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 2027,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2012,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2031,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2013,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2017,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2028,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2024,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2018,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2032,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2033,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2019,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2026,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2022,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2029,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2025,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2020,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2014,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2030,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2021,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2016,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2015,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[161].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 2044,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2045,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2048,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2047,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2046,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2049,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2041,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2042,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2043,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2040,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2039,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2038,
        quality: 6,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[162].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 2050,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2051,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2052,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2053,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2054,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2055,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2056,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2057,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2058,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2059,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2060,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2061,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2062,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2063,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2064,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2065,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2066,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2067,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2068,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2069,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2070,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2071,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2072,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[163].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 2076,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2077,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2078,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2079,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2080,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2081,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2082,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2083,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2084,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2085,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2086,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2087,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2088,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2089,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2090,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2091,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2092,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2093,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2094,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2095,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2096,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2097,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2098,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[164].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 2103,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2104,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2105,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2106,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2107,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2108,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2109,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2110,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2111,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2112,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2113,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2114,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2115,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2116,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2117,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2118,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2119,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2120,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2121,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2122,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2123,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2124,
        quality: 4,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2125,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[165].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 2133,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2134,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2135,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2136,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2137,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2138,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2139,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2140,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2141,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2142,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2143,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2144,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2145,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2146,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2147,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2148,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2149,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2150,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2151,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2152,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2153,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2154,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2155,
        quality: 10,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[166].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 2159,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2160,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2161,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2162,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2163,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2164,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2165,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2166,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2167,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2168,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2169,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2170,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2171,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2172,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2173,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2174,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2175,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2176,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2177,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2178,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2179,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2180,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2181,
        quality: 10,
        grade: 6
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2182,
        quality: 4,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[167].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 2183,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2184,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2185,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2186,
        quality: 6,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2187,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2188,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2189,
        quality: 6,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2190,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2191,
        quality: 6,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2192,
        quality: 6,
        grade: 6
    })
];
$923c9e0e4e96ee85$export$afbe48a4a4275937[168].loot = [
    new $923c9e0e4e96ee85$var$Item({
        id: 2197,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2198,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2199,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2200,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2201,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2202,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2203,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2204,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2205,
        quality: 10,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2206,
        quality: 4,
        grade: 3
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2207,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2208,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2209,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2210,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2211,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2212,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2213,
        quality: 4,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2214,
        quality: 10,
        grade: 4
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2215,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2216,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2217,
        quality: 4,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2218,
        quality: 10,
        grade: 5
    }),
    new $923c9e0e4e96ee85$var$Item({
        id: 2219,
        quality: 10,
        grade: 6
    })
];


let $393df7a6c81f1387$export$b808efe4d9fd6ed7 = {
    1: {
        img: "vita_saw",
        eng: "The Vita-Saw",
        rus: "\u0412\u0438\u0442\u0430-\u043F\u0438\u043B\u0430",
        pol: "Vita-pi\u0142a",
        sch: "\u7EF4\u5854\u952F",
        fre: "La Vita-Scie",
        bra: "A Vitasserra",
        schema: 173,
        hun: "Az \xc9letbe-V\xe1g\xf3",
        swe: "Vita-s\xe5gen"
    },
    2: {
        img: "gunslinger",
        eng: "The Gunslinger",
        rus: "\u041E\u0440\u0443\u0436\u0435\u0439\u043D\u0438\u043A",
        pol: "Jednor\u0119ki bandyta",
        sch: "\u67AA\u70AE\u5DE5\u4E4B\u81C2",
        fre: "Le Flingueur",
        bra: "O Pistoleiro",
        schema: 142,
        hun: "A Fegyverforgat\xf3",
        swe: "Revolvermannen"
    },
    3: {
        img: "equalizer",
        eng: "The Equalizer",
        rus: "\u0423\u0440\u0430\u0432\u043D\u0438\u0442\u0435\u043B\u044C",
        pol: "Wyr\xf3wnywacz",
        sch: "\u5341\u5B57\u9550",
        fre: "L'Equalizer",
        bra: "O Compensador",
        schema: 128,
        hun: "Az Egyenl\xedt\u0151",
        swe: "Utj\xe4mnaren"
    },
    4: {
        img: "scottish_resistance",
        eng: "The Scottish Resistance",
        rus: "\u0428\u043E\u0442\u043B\u0430\u043D\u0434\u0441\u043A\u043E\u0435 \u0441\u043E\u043F\u0440\u043E\u0442\u0438\u0432\u043B\u0435\u043D\u0438\u0435",
        pol: "Szkocki op\xf3r",
        sch: "\u82CF\u683C\u5170\u9632\u5FA1\u8005",
        fre: "La Scottish Resistance",
        bra: "A Resist\xeancia Escocesa",
        schema: 130,
        hun: "A Sk\xf3t Ellen\xe1ll\xe1s",
        swe: "Skotska motst\xe5ndet"
    },
    5: {
        img: "old_guadalajara",
        eng: "Old Guadalajara",
        rus: "\u0421\u0442\u0430\u0440\u0430\u044F \u0413\u0432\u0430\u0434\u0430\u043B\u0430\u0445\u0430\u0440\u0430",
        pol: "Stara Guadalajara",
        sch: "\u53E4\u8001\u7684\u74DC\u8FBE\u62C9\u54C8\u62C9\u8349\u5E3D",
        fre: "Guadalajara d'antan",
        bra: "Velha Guadalajara",
        schema: 247,
        hun: "R\xe9gi Guadalajara",
        swe: "Gammal Guadalajara"
    },
    6: {
        img: "nappers_respite",
        eng: "Napper's Respite",
        rus: "\u041E\u0442\u0434\u044B\u0445 \u0434\u043B\u044F \u043C\u043E\u0437\u0433\u043E\u0432",
        pol: "Szlafmyca \u015Bpiocha",
        sch: "\u5C0F\u5077\u7684\u5598\u606F",
        fre: "Neurones au repos",
        bra: "Gorro do Dorminhoco",
        schema: 248,
        hun: "A Szund\xedt\xf3 Sz\xfcnideje",
        swe: "Slumrarens Andrum"
    },
    7: {
        img: "name_tag",
        eng: "Name Tag",
        rus: "\u0418\u043C\u0435\u043D\u043D\u043E\u0439 \u044F\u0440\u043B\u044B\u043A",
        pol: "Etykieta z nazw\u0105",
        sch: "\u540D\u79F0\u6807\u7B7E",
        fre: "\xc9tiquette",
        bra: "Etiqueta de Nome",
        schema: 5020,
        hun: "N\xe9vc\xe9dula",
        swe: "Namnlapp"
    },
    8: {
        img: "an_extraordinary_abundance_of_tinge",
        eng: "An Extraordinary Abundance of Tinge",
        rus: "\u041E\u0433\u0440\u043E\u043C\u043D\u043E\u0435 \u0438\u0437\u043E\u0431\u0438\u043B\u0438\u0435 \u043E\u0442\u0442\u0435\u043D\u043A\u043E\u0432",
        pol: "Nadzwyczajna obfito\u015B\u0107 zabarwienia",
        sch: "\u72EC\u7279\u6EE1\u6876\u767D",
        fre: "Une Touche d'Abondance Extraordinaire",
        bra: "Uma Extraordin\xe1ria Abund\xe2ncia de Matiz",
        schema: 5039,
        hun: "K\xfcl\xf6n\xf6sen B\u0151s\xe9ges Sz\xednezet",
        swe: "Ett enast\xe5ende \xf6verfl\xf6d av skiftningar"
    },
    9: {
        img: "a_distinctive_lack_of_hue",
        eng: "A Distinctive Lack of Hue",
        rus: "\u041E\u0441\u0442\u0440\u0430\u044F \u043D\u0435\u0445\u0432\u0430\u0442\u043A\u0430 \u0446\u0432\u0435\u0442\u0430",
        pol: "Charakterystyczny brak odcienia",
        sch: "\u7279\u522B\u65E0\u8272\u9ED1",
        fre: "Un Manque de Cama\xefeux",
        bra: "Uma Distinta Falta de Colora\xe7\xe3o",
        schema: 5040,
        hun: "A Sz\xednezet Felt\u0171n\u0151 Hi\xe1nya",
        swe: "En utpr\xe4glad brist p\xe5 nyans"
    },
    10: {
        img: "black_box",
        eng: "The Black Box",
        rus: "\u0427\u0451\u0440\u043D\u044B\u0439 \u044F\u0449\u0438\u043A",
        pol: "Czarna skrzynka",
        sch: "\u9ED1\u5323\u5B50",
        fre: "La Bo\xeete Noire",
        bra: "A Caixa Preta",
        schema: 228,
        hun: "Fekete Doboz",
        swe: "Svarta l\xe5dan"
    },
    11: {
        img: "shortstop",
        eng: "The Shortstop",
        rus: "\u041F\u0440\u0435\u0440\u044B\u0432\u0430\u0442\u0435\u043B\u044C",
        pol: "Wstrzymywacz",
        sch: "\u6E38\u51FB\u624B",
        fre: "L'Arr\xeat-court",
        bra: "A Interbases",
        schema: 220,
        hun: "A Meg\xe1ll\xedt\xf3",
        ger: "Der Shortstop",
        swe: "Shortstop"
    },
    12: {
        img: "letranger",
        eng: "L'Etranger",
        rus: "\u041D\u0435\u0437\u043D\u0430\u043A\u043E\u043C\u0435\u0446",
        pol: "L'\xc9tranger",
        sch: "\u964C\u751F\u4EBA",
        fre: "L'\xc9tranger",
        bra: "L'\xc9tranger",
        schema: 224,
        hun: "L'\xc9tranger",
        swe: "Fr\xe4mlingen"
    },
    13: {
        img: "sober_stuntman",
        eng: "Sober Stuntman",
        rus: "\u0422\u0440\u0435\u0437\u0432\u044B\u0439 \u043A\u0430\u0441\u043A\u0430\u0434\u0435\u0440",
        pol: "Trze\u017Awy kaskader",
        sch: "\u51B7\u9759\u7684\u7279\u6280\u6F14\u5458",
        fre: "Cascadeur sobre",
        bra: "Dubl\xea S\xf3brio",
        schema: 255,
        hun: "J\xf3zan Kaszkad\u0151r",
        ger: "N\xfcchterner Stuntman"
    },
    14: {
        img: "chieftains_challenge",
        eng: "Chieftain's Challenge",
        rus: "\u0418\u0441\u043F\u044B\u0442\u0430\u043D\u0438\u0435 \u0432\u043E\u0436\u0434\u044F",
        pol: "Zew wodza",
        sch: "\u5370\u7B2C\u5B89\u914B\u957F\u5E3D",
        fre: "D\xe9fi du chef",
        bra: "Cacife do Cacique",
        schema: 250,
        hun: "A T\xf6rzsf\u0151 Er\u0151pr\xf3b\xe1ja",
        swe: "H\xf6vdingens H\xf6nsfj\xe4derhatt"
    },
    15: {
        img: "dueling_minigame",
        eng: "Dueling Mini-Game",
        rus: '\u041C\u0438\u043D\u0438-\u0438\u0433\u0440\u0430 "\u0414\u0443\u044D\u043B\u044C"',
        pol: "Minigra - pojedynek",
        sch: "\u8FF7\u4F60\u6E38\u620F:\u51B3\u6597!",
        fre: "Mini-jeu de duel",
        bra: "Minigame de Duelo",
        schema: 241,
        hun: "P\xe1rbaj minij\xe1t\xe9k",
        swe: "Duelleringsminispel"
    },
    16: {
        img: "a_deep_commitment_to_purple",
        eng: "A Deep Commitment to Purple",
        rus: "\u0424\u0438\u043E\u043B\u0435\u0442\u043E\u0432\u0430\u044F \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u044C",
        pol: "G\u0142\u0119boko zaanga\u017Cowana purpura",
        sch: "\u575A\u5B9A\u8A93\u7EA6\u7D2B",
        fre: "Une Pourpre Imposante",
        bra: "Um Profundo Compromisso com Roxo",
        schema: 5031,
        hun: "M\xe9ly Elk\xf6telezetts\xe9g a Lila Ir\xe1nt",
        swe: "Ett djupt engagemang f\xf6r lila"
    },
    17: {
        img: "australium_gold",
        eng: "Australium Gold",
        rus: "\u0417\u043E\u043B\u043E\u0442\u043E\u0439 \u0430\u0432\u0441\u0442\u0440\u0430\u043B\u0438\u0439",
        pol: "Z\u0142ocisto\u015B\u0107 australium",
        sch: "\u6FB3\u5143\u7D20\u91D1\u8272",
        fre: "Or Australium",
        bra: "Ouro Austr\xe1lio",
        schema: 5037,
        hun: "Ausztr\xe1lium Arany",
        swe: "Australiumguld"
    },
    18: {
        img: "bushwacka",
        eng: "The Bushwacka",
        rus: "\u041A\u0443\u0441\u0442\u043E\u043B\u043E\u043C",
        pol: "Bandyta z buszu",
        sch: "\u704C\u6728\u4E1B",
        fre: "Le Bushwacka",
        bra: "O Fac\xe3o do Desbravador",
        schema: 232,
        hun: "A Boz\xf3tver\u0151",
        ger: "Der Buschwacka",
        swe: "Bushwacka"
    },
    19: {
        img: "critacola",
        eng: "Crit-a-Cola",
        rus: "\u041A\u0440\u0438\u0442\u043E\u043A\u043E\u043B\u0430",
        pol: "Kryt-o-Cola",
        sch: "\u7206\u51FB\u53EF\u4E50",
        fre: "Crit-a-Cola",
        bra: "Criti-Cola",
        schema: 163,
        hun: "Krit-a-K\xf3la",
        ger: "Krit-a-Cola"
    },
    20: {
        img: "homewrecker",
        eng: "The Homewrecker",
        rus: "\u041A\u0440\u0443\u0448\u0438\u0442\u0435\u043B\u044C",
        pol: "Burzyciel",
        sch: "\u62C6\u8FC1\u8005",
        fre: "Le Briseur de M\xe9nages",
        bra: "A Quebra-Casas",
        schema: 153,
        hun: "A Laklerendez\u0151",
        swe: "Hemrivaren"
    },
    21: {
        img: "troublemakers_tossle_cap",
        eng: "Troublemaker's Tossle Cap",
        rus: "\u0428\u0430\u043F\u043A\u0430 \u0431\u0435\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u044C\u0449\u0438\u043A\u0430",
        pol: "Czapka rozrabiaki",
        sch: "\u9EBB\u70E6\u5236\u9020\u8005\u7684\u9632\u5BD2\u5E3D",
        fre: "Bonnet de Fauteur de troubles",
        bra: "Touca do Trombadinha",
        schema: 150,
        hun: "K\xf6t\xf6tt K\xf6teked\u0151",
        swe: "Br\xe5kstakens M\xf6ssa"
    },
    22: {
        img: "bombing_run",
        eng: "Bombing Run",
        rus: "\u0417\u0430\u0445\u043E\u0434 \u043D\u0430 \u0446\u0435\u043B\u044C",
        pol: "Rajd bombowy",
        sch: "\u8F70\u70B8\u822A\u8DEF",
        fre: "Frappe a\xe9rienne",
        bra: "Bombardeiro",
        schema: 249,
        hun: "Bombat\xe1mad\xe1s",
        swe: "Bomb-Rush"
    },
    23: {
        img: "stout_shako",
        eng: "Stout Shako",
        rus: "\u041F\u0440\u043E\u0447\u043D\u044B\u0439 \u043A\u0438\u0432\u0435\u0440",
        pol: "Opas\u0142e czako",
        sch: "\u65AF\u6258\u7279\u519B\u5E3D",
        fre: "Fier shako",
        bra: "Shako Robusto",
        schema: 251,
        hun: "Csod\xe1s Cs\xe1k\xf3",
        swe: "Kraftig Kask"
    },
    24: {
        img: "description_tag",
        eng: "Description Tag",
        rus: "\u042F\u0440\u043B\u044B\u043A \u0434\u043B\u044F \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u044F",
        pol: "Etykieta z opisem",
        sch: "\u63CF\u8FF0\u6807\u7B7E",
        fre: "\xc9tiquette de Description",
        bra: "Etiqueta de Descri\xe7\xe3o",
        schema: 5044,
        hun: "Le\xedr\xe1s-c\xe9dula",
        swe: "Beskrivningslapp"
    },
    25: {
        img: "battalions_backup",
        eng: "The Battalion's Backup",
        rus: "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430 \u0431\u0430\u0442\u0430\u043B\u044C\u043E\u043D\u0430",
        pol: "Wsparcie batalionu",
        sch: "\u519B\u961F\u7684\u652F\u63F4",
        fre: "Le Soutien du Bataillon",
        bra: "O Refor\xe7o do Batalh\xe3o",
        schema: 226,
        hun: "Az Ezred Er\u0151s\xedt\xe9se",
        swe: "Bataljonens f\xf6rst\xe4rkning"
    },
    26: {
        img: "pain_train",
        eng: "The Pain Train",
        rus: "\u041A\u043E\u0441\u0442\u044B\u043B\u044C",
        pol: "Pa\u0142ka sokisty",
        sch: "\u9489\u68CD",
        fre: "Le Pain Train",
        bra: "\xc9 Pau, \xc9 Prego",
        schema: 154,
        hun: "A Sz\xfar\xf3 F\xe1jdalom",
        swe: "Pl\xe5gt\xe5get"
    },
    27: {
        img: "your_eternal_reward",
        eng: "Your Eternal Reward",
        rus: "\u0412\u0435\u0447\u043D\u044B\u0439 \u043F\u043E\u043A\u043E\u0439",
        pol: "Ostateczna nagroda",
        sch: "\u6C38\u751F\u7684\u56DE\u62A5",
        fre: "Ton \xc9ternelle R\xe9compense",
        bra: "Sua Eterna Recompensa",
        schema: 225,
        hun: "\xd6r\xf6kk\xe9 Tart\xf3 Jutalmad",
        swe: "Evighetsbel\xf6ningen"
    },
    28: {
        img: "whoopee_cap",
        eng: "Whoopee Cap",
        rus: "\u041C\u043E\u043B\u043E\u0434\u0451\u0436\u043D\u0430\u044F \u043A\u043E\u0440\u043E\u043D\u0430",
        pol: "Pierdziuszka",
        sch: "\u72C2\u6B22\u4E4B\u51A0",
        fre: "Toque de Fanfaron",
        bra: "Chap\xe9u Whoopee",
        schema: 174,
        hun: "Az Ihaj-csuhaj",
        swe: "Whoopee-M\xf6ssa"
    },
    29: {
        img: "heavy_duty_rag",
        eng: "The Heavy Duty Rag",
        rus: "\u0422\u0440\u044F\u043F\u043A\u0430 \u0440\u0430\u0431\u043E\u0447\u0435\u0433\u043E",
        pol: "Bandana Grubego",
        sch: "\u7ED3\u5B9E\u7684\u5934\u5DFE",
        fre: "Bandeau des lourdes obligations",
        bra: "Bandana do Encrenqueiro",
        schema: 185,
        hun: "Strapab\xedr\xf3 Fejkend\u0151",
        swe: "Tunga T\xe5liga Trasan"
    },
    30: {
        img: "handymans_handle",
        eng: "Handyman's Handle",
        rus: "\u0420\u044B\u0447\u0430\u0433 \u0443\u043C\u0435\u043B\u044C\u0446\u0430",
        pol: "Przepychaczka babci klozetowej",
        sch: "\u80FD\u5DE5\u5DE7\u5320\u7684\u628A\u624B",
        fre: "Poign\xe9e multifonction",
        bra: "Desentupidor do Ajudante",
        schema: 253,
        hun: "Ezermester Nyele",
        swe: "Hantverkarens Handtag"
    },
    31: {
        img: "powerjack",
        eng: "The Powerjack",
        rus: "\u0420\u0430\u0437\u044A\u0435\u0434\u0438\u043D\u0438\u0442\u0435\u043B\u044C",
        pol: "Lewarek",
        sch: "\u5F3A\u529B\u5343\u65A4\u9876",
        fre: "Le Powerjack",
        bra: "A Liga\xe7\xe3o Direta",
        schema: 214,
        hun: "Az \xc9leter\u0151-Emel\u0151",
        swe: "Eldomkraften"
    },
    32: {
        img: "gunboats",
        eng: "The Gunboats",
        rus: "\u0428\u0442\u0443\u0440\u043C\u0431\u043E\u0442\u0438\u043D\u043A\u0438",
        pol: "Kanonierki",
        sch: "\u70AE\u8247",
        fre: "Les Bottes de s\xfbret\xe9",
        bra: "As Canhoneiras",
        schema: 133,
        hun: "Az Ac\xe9lbet\xe9tes",
        swe: "Kanonb\xe5tarna"
    },
    33: {
        img: "southern_hospitality",
        eng: "The Southern Hospitality",
        rus: "\u042E\u0436\u043D\u043E\u0435 \u0433\u043E\u0441\u0442\u0435\u043F\u0440\u0438\u0438\u043C\u0441\u0442\u0432\u043E",
        pol: "Po\u0142udniowa go\u015Bcinno\u015B\u0107",
        sch: "\u5357\u90E8\u7684\u6B3E\u5F85",
        fre: "L'Hospitalit\xe9 Sudiste",
        bra: "A Hospitalidade do Sul",
        schema: 155,
        hun: "A D\xe9lvid\xe9ki Vend\xe9gszeretet",
        swe: "S\xf6derns g\xe4stfrihet"
    },
    34: {
        img: "blokes_bucket_hat",
        eng: "Bloke's Bucket Hat",
        rus: "\u0428\u043B\u044F\u043F\u0430 \u0440\u044B\u0431\u043E\u043B\u043E\u0432\u0430",
        pol: "Ziomalska czapka w\u0119dkarska",
        sch: "\u6E14\u592B\u7684\u6C34\u6876\u5E3D",
        fre: "Bob de Mec",
        bra: "Chap\xe9u de Pesca",
        schema: 181,
        hun: "Hapek Horg\xe1szholmija",
        swe: "Filurens Fiskarhatt"
    },
    35: {
        img: "safensound",
        eng: "Safe'n'Sound",
        rus: "\u0428\u0443\u043C\u043E\u043F\u043E\u0433\u043B\u043E\u0449\u0430\u044E\u0449\u0438\u0435 \u043D\u0430\u0443\u0448\u043D\u0438\u043A\u0438",
        pol: "Safe'n'Sound",
        sch: "\u5B89\u5168\u8033\u5957",
        fre: "Son et Sauf",
        bra: "Som e Salvo",
        schema: 178,
        hun: "Ipari F\xfclv\xe9d\u0151",
        swe: "H\xf6rselskydd"
    },
    36: {
        img: "ze_goggles",
        eng: "Ze Goggles",
        rus: "\u041F\u0443\u0447\u0435\u0433\u043B\u0430\u0437\u044B",
        pol: "G\xf3gle",
        sch: "\u62A4\u76EE\u955C",
        fre: "Les B\xe9zicles",
        bra: "As \xd3kulos",
        schema: 177,
        hun: "A Szellemz\u0151",
        swe: "Das Bildf\xf6rst\xe4rkare"
    },
    37: {
        img: "colorno216190216",
        eng: "Color No. 216-190-216",
        rus: "\u0426\u0432\u0435\u0442 #216-190-216",
        pol: "Kolor nr 216-190-216",
        sch: "\u989C\u8272\u7F16\u53F7 216-190-216",
        fre: "Couleur N\xb0 216-190-216",
        bra: "Cor 216-190-216",
        schema: 5030,
        hun: "216-190-216. Sz\xe1m\xfa Sz\xedn",
        swe: "F\xe4rg nr. 216-190-216"
    },
    38: {
        img: "jag",
        eng: "The Jag",
        rus: "\u041E\u0441\u0442\u0440\u043E\u0437\u0443\u0431",
        pol: "Kie\u0142",
        sch: "\u5C16\u9F7F\u6273\u624B",
        fre: "Le Crochet",
        bra: "A Dentadura",
        schema: 329,
        hun: "A S\xfcrget\u0151",
        swe: "Jacken"
    },
    39: {
        img: "candy_cane",
        eng: "The Candy Cane",
        rus: "\u041A\u0430\u0440\u0430\u043C\u0435\u043B\u044C\u043D\u0430\u044F \u0442\u0440\u043E\u0441\u0442\u044C",
        pol: "Laska cukrowa",
        sch: "\u7CD6\u679C\u624B\u6756",
        fre: "Sucre d'orge",
        bra: "Bengala Doce",
        schema: 317,
        hun: "cukorkap\xe1lca",
        swe: "Polkagris"
    },
    40: {
        img: "fists_of_steel",
        eng: "The Fists of Steel",
        rus: "\u0421\u0442\u0430\u043B\u044C\u043D\u044B\u0435 \u043A\u0443\u043B\u0430\u043A\u0438",
        pol: "Pi\u0119\u015Bci ze stali",
        sch: "\u94A2\u94C1\u624B\u5957",
        fre: "Les Poings d'Acier",
        bra: "Os Punhos de Ferro",
        schema: 331,
        hun: "A Vas\xf6kl\xf6k",
        swe: "St\xe5ln\xe4varna"
    },
    41: {
        img: "back_scratcher",
        eng: "The Back Scratcher",
        rus: "\u0421\u043F\u0438\u043D\u043E\u0447\u0451\u0441",
        pol: "Drapaczka",
        sch: "\u4E0D\u6C42\u4EBA",
        fre: "Le Gratte-dos",
        bra: "O Co\xe7ador de Costas",
        schema: 326,
        hun: "A H\xe1tvakar\xf3",
        swe: "Ryggkliaren"
    },
    42: {
        img: "claidheamh_mor",
        eng: "The Claidheamh M\xf2r",
        rus: "\u041A\u043B\u0435\u0439\u043C\u043E\u0440",
        pol: "Claidheamh M\xf2r",
        sch: "\u6469\u5C14\u5DE8\u5251",
        fre: "La Claidheamh M\xf2r",
        bra: "A Claidheamh M\xf2r",
        schema: 327,
        hun: "A Claidheamh M\xf2r",
        ger: "Das Claidheamh M\xf2r",
        swe: "Claidheamh M\xf2r"
    },
    43: {
        img: "defiant_spartan",
        eng: "Defiant Spartan",
        rus: "\u041D\u0435\u043F\u043E\u043A\u043E\u0440\u043D\u044B\u0439 \u0441\u043F\u0430\u0440\u0442\u0430\u043D\u0435\u0446",
        pol: "Krn\u0105brny Spartanin",
        sch: "\u65AF\u5DF4\u8FBE\u6218\u58EB\u5934\u76D4",
        fre: "Spartiate Provocateur",
        bra: "Espartano Desafiador",
        schema: 340,
        hun: "Dacos Sp\xe1rtai",
        swe: "Trotsig Spartan"
    },
    44: {
        img: "detective_noir",
        eng: "D\xe9tective Noir",
        rus: "\u041C\u0440\u0430\u0447\u043D\u044B\u0439 \u0434\u0435\u0442\u0435\u043A\u0442\u0438\u0432",
        pol: "Detektyw noir",
        sch: "\u6DF1\u8272\u4FA6\u63A2\u5E3D",
        fre: "D\xe9tective Noir",
        bra: "D\xe9tective Noir",
        schema: 319,
        swe: "Detektiv Noir"
    },
    45: {
        img: "a_rather_festive_tree",
        eng: "A Rather Festive Tree",
        rus: "\u0414\u043E\u0432\u043E\u043B\u044C\u043D\u043E \u043F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u043E\u0435 \u0434\u0435\u0440\u0435\u0432\u0446\u0435",
        pol: "Dosy\u0107 \u015Bwi\u0105teczna choinka",
        sch: "\u7CBE\u7F8E\u7684\u5723\u8BDE\u6811",
        fre: "Un Sapin Assez Festif",
        bra: "Uma \xc1rvore Um Tanto Festiva",
        schema: 341,
        hun: "Egy El\xe9gg\xe9 \xdcnnep\xe9lyes Fa",
        swe: "En Ganska Festlig Gran"
    },
    46: {
        img: "exquisite_rack",
        eng: "Exquisite Rack",
        rus: "\u0418\u0437\u044F\u0449\u043D\u0430\u044F \u0432\u0435\u0448\u0430\u043B\u043A\u0430",
        pol: "Poka\u017Ane poro\u017Ce",
        sch: "\u7CBE\u7F8E\u7684\u9E7F\u89D2",
        fre: "Support Exquis",
        bra: "Galhada Requintada",
        schema: 339,
        hun: "Kit\u0171n\u0151 Tr\xf3fea",
        swe: "Snygga Ben"
    },
    47: {
        img: "buckaroos_hat",
        eng: "Buckaroo's Hat",
        rus: "\u041A\u043E\u0432\u0431\u043E\u0439\u0441\u043A\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "Kowbojski kapelusz",
        sch: "\u897F\u73ED\u7259\u725B\u4ED4\u5E3D",
        fre: "Chapeau de Buckaroo",
        bra: "Chap\xe9u do Pe\xe3o",
        schema: 322,
        hun: "Tehen\xe9szfi\xfa T\xf6kfed\u0151je",
        swe: "Buckaroons Hatt"
    },
    48: {
        img: "prince_tavishs_crown",
        eng: "Prince Tavish's Crown",
        rus: "\u041A\u043E\u0440\u043E\u043D\u0430 \u043F\u0440\u0438\u043D\u0446\u0430 \u0422\u0430\u0432\u0438\u0448\u0430",
        pol: "Korona ksi\u0119cia Tavisha",
        sch: "\u5854\u7EF4\u4EC0\u738B\u5B50\u7684\u7687\u51A0",
        fre: "Couronne du Prince Tavish",
        bra: "Coroa do Pr\xedncipe Tavish",
        schema: 342,
        hun: "Tavish Herceg Koron\xe1ja",
        swe: "Prins Tavish Krona"
    },
    49: {
        img: "coupe_disaster",
        eng: "Coupe D'isaster",
        rus: "\u041F\u0440\u0438\u0447\u0451\u0441\u043A\u0430 \u0431\u0443\u043D\u0442\u0430\u0440\u044F",
        pol: "Cauchemarny toup\xe9ecik",
        sch: "\u4FEE\u526A\u8FC7\u7684\u5047\u53D1",
        fre: "Coupe D'\xc9sastre",
        bra: "Coupe D'isastre",
        schema: 330,
        hun: "L'ecs\xfaszott M\u0171haj",
        swe: "Katastrofal Tup\xe9"
    },
    50: {
        img: "blighted_beak",
        eng: "Blighted Beak",
        rus: "\u041F\u0440\u043E\u043A\u0430\u0436\u0451\u043D\u043D\u044B\u0439 \u043A\u043B\u044E\u0432",
        pol: "Morowa maska",
        sch: "\u75AB\u533B\u7684\u9E1F\u5634\u9762\u5177",
        fre: "Bec Bubonique",
        bra: "Bico Infectado",
        schema: 315,
        hun: "Par\xe1d\xe9s Pestisdoktor",
        swe: "F\xf6rd\xe4rvad N\xe4bb"
    },
    51: {
        img: "madame_dixie",
        eng: "Madame Dixie",
        rus: "\u0414\u0430\u043C\u0441\u043A\u0438\u0439 \u043A\u043E\u0442\u0435\u043B\u043E\u043A",
        pol: "Pani Dixie",
        sch: "\u8FEA\u514B\u897F\u592B\u4EBA\u7684\u82B1\u793C\u5E3D",
        fre: "Madame Dixie",
        bra: "Madame Dixie",
        schema: 321,
        swe: "Madam Dixie"
    },
    52: {
        img: "german_gonzila",
        eng: "German Gonzila",
        rus: "\u041D\u0435\u043C\u0435\u0446\u043A\u0430\u044F \u0433\u043E\u043D\u0437\u0438\u043B\u043B\u0430",
        pol: "Niemiecka gonzila",
        sch: "\u63D0\u6D1B\u5C14\u5706\u5E3D",
        fre: "Gonzila Allemand",
        bra: "Gonzila Alem\xe3o",
        schema: 323,
        hun: "Germ\xe1n Gonzila",
        swe: "Tysk Tyrolerhatt"
    },
    53: {
        img: "pyromancers_mask",
        eng: "Pyromancer's Mask",
        rus: "\u041C\u0430\u0441\u043A\u0430 \u043F\u0438\u0440\u043E\u043C\u0430\u043D\u0442\u0430",
        pol: "Maska piromanty",
        sch: "\u706B\u7130\u672F\u58EB\u7684\u9762\u5177",
        fre: "Masque de Pyromancien",
        bra: "M\xe1scara do Piromante",
        schema: 316,
        hun: "A Pirom\xe1ni\xe1s \xc1larca",
        swe: "Eldsj\xe4lens Mask"
    },
    54: {
        img: "le_party_phantom",
        eng: "Le Party Phantom",
        rus: "\u041F\u0440\u0438\u0437\u0440\u0430\u043A \u0432\u0435\u0447\u0435\u0440\u0438\u043D\u043A\u0438",
        pol: "Upi\xf3r na przyj\u0119ciu",
        sch: "\u821E\u4F1A\u9B45\u5F71",
        fre: "Le Fant\xf4me de la F\xeate",
        bra: "Le Fantasma da Festa",
        schema: 337,
        hun: "Az \xc1larcosb\xe1l Fantomja",
        swe: "Le Partyfantomen"
    },
    55: {
        img: "industrial_festivizer",
        eng: "Industrial Festivizer",
        rus: "\u0417\u0430\u0432\u043E\u0434\u0441\u043A\u043E\u0439 \u0437\u0430\u0432\u043E\u0434\u0438\u043B\u0430",
        pol: "Przemys\u0142owe \u015Bwiecide\u0142ka",
        sch: "\u5723\u8BDE\u5F69\u706F",
        fre: "Festivit\xe9s Industrielles",
        bra: "Festivizante Industrial",
        schema: 338,
        hun: "Ipari \xdcnnepies\xedt\u0151",
        swe: "Industriell Festlighet"
    },
    56: {
        img: "larrikin_robin",
        eng: "Larrikin Robin",
        rus: "\u0411\u0443\u0439\u043D\u044B\u0439 \u0420\u043E\u0431\u0438\u043D",
        pol: "Robin z Sherbrooke",
        sch: "\u7EFF\u6797\u597D\u6C49\u4E4B\u5E3D",
        fre: "Robin Brigand",
        bra: "N\xe3o Robin o meu Chap\xe9u",
        schema: 314,
        hun: "A Bajkever\u0151 Robin",
        swe: "G\xe4ckande Robin"
    },
    57: {
        img: "flipped_trillby",
        eng: "Flipped Trilby",
        rus: "\u041F\u0435\u0440\u0435\u0432\u0451\u0440\u043D\u0443\u0442\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "Odwr\xf3cony trilby",
        sch: "\u7FFB\u8F6C\u7684\u5706\u6BE1\u5E3D",
        fre: "Chapeau de Feutre Retourn\xe9",
        bra: "Trilby Invertido",
        schema: 324,
        hun: "Ford\xedtott Filckalap",
        swe: "Vikt Trilby"
    },
    58: {
        img: "magnificent_mongolian",
        eng: "Magnificent Mongolian",
        rus: "\u0412\u0435\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u043C\u043E\u043D\u0433\u043E\u043B",
        pol: "Mocarny Mongo\u0142",
        sch: "\u5B8F\u4F1F\u7684\u8499\u53E4\u5E3D",
        fre: "Magnifique Mongol",
        bra: "Mongol Magn\xedfico",
        schema: 313,
        hun: "M\xe9retes Mongol",
        swe: "Magnifik Mongol"
    },
    59: {
        img: "chargin_targe",
        eng: "The Chargin' Targe",
        rus: "\u0428\u0442\u0443\u0440\u043C\u043E\u0432\u043E\u0439 \u0449\u0438\u0442",
        pol: "Tarcza szar\u017Cy",
        sch: "\u51B2\u950B\u76FE",
        fre: "Le Bouclier b\xe9lier",
        bra: "A Tarja de Investida",
        schema: 131,
        hun: "A Rohamoz\xf3 Paizs",
        swe: "Anfallssk\xf6lden"
    },
    60: {
        img: "direct_hit",
        eng: "The Direct Hit",
        rus: "\u041F\u0440\u044F\u043C\u043E\u0435 \u043F\u043E\u043F\u0430\u0434\u0430\u043D\u0438\u0435",
        pol: "Celny strza\u0142",
        sch: "\u7CBE\u786E\u6253\u51FB\u8005",
        fre: "Le Direct Hit",
        bra: "O Tiro Certo",
        schema: 127,
        hun: "A Telibe Tal\xe1lat",
        swe: "Direkta tr\xe4ffen"
    },
    61: {
        img: "DUMMY",
        eng: "DUMMY"
    },
    62: {
        img: "demomans_fro",
        eng: "Demoman's Fro",
        rus: "\u0410\u0444\u0440\u043E",
        pol: "Afro Demomana",
        sch: "\u7206\u7834\u624B\u7684\u57C3\u5F17\u7F57\u53D1\u578B",
        fre: "Coupe afro du Demoman",
        bra: "Afro do Demoman",
        schema: 47,
        hun: "Kirobban-a-fr\xf3",
        swe: "Demomans Afro"
    },
    63: {
        img: "drs_dapper_topper",
        eng: "Dr's Dapper Topper",
        rus: "\u0427\u0443\u0434\u043D\u043E\u0439 \u0446\u0438\u043B\u0438\u043D\u0434\u0440",
        pol: "Pasiasty kapelusz Prota",
        sch: "\u535A\u58EB\u5999\u5999\u5E3D",
        fre: "Haut-de-forme du docteur",
        bra: "Cartola Listrada do Dr.",
        schema: 252,
        hun: "A Doktor Sraffos Sipk\xe1ja",
        swe: "Doktorns H\xf6ga Hatt"
    },
    64: {
        img: "rimmed_raincatcher",
        eng: "Rimmed Raincatcher",
        rus: "\u041F\u0438\u0440\u0430\u0442\u0441\u043A\u0430\u044F \u0442\u0440\u0435\u0443\u0433\u043E\u043B\u043A\u0430",
        pol: "Piracki pier\xf3g",
        sch: "\u51F8\u7F18\u906E\u96E8\u5E3D",
        fre: "Lampion bord\xe9",
        bra: "Tric\xf3rnio Cata-Chuva",
        schema: 216,
        hun: "Karim\xe1s Kal\xf3zkalap",
        swe: "Kaptenens Keps"
    },
    65: {
        img: "milkman",
        eng: "The Milkman",
        rus: "\u041C\u043E\u043B\u043E\u0447\u043D\u0438\u043A",
        pol: "Mleczarz",
        sch: "\u725B\u5976\u5546",
        fre: "Le Laitier",
        bra: "O Leiteiro",
        schema: 219,
        hun: "A Tejesember",
        swe: "Mj\xf6lkbudet"
    },
    66: {
        img: "team_spirit",
        eng: "Team Spirit",
        rus: "\u041A\u043E\u043C\u0430\u043D\u0434\u043D\u044B\u0439 \u0434\u0443\u0445",
        pol: "Duch dru\u017Cyny",
        sch: "\u56E2\u961F\u7CBE\u795E",
        fre: "Esprit d'\xc9quipe",
        bra: "Esp\xedrito de Equipe",
        schema: 5046,
        hun: "Csapatszellem",
        swe: "Laganda"
    },
    67: {
        img: "force_a_nature",
        eng: "The Force-A-Nature",
        rus: "\u041D\u0435\u0443\u043C\u043E\u043B\u0438\u043C\u0430\u044F \u0441\u0438\u043B\u0430",
        pol: "Si\u0142a natury",
        sch: "\u81EA\u7136\u4E4B\u529B",
        fre: "La Force-de-la-Nature",
        bra: "A For\xe7a da Natureza",
        schema: 45,
        hun: "Az Els\xf6pr\xf6get\u0151",
        swe: "Naturkraft"
    },
    68: {
        img: "bonk_atomic_punch",
        eng: "Bonk! Atomic Punch",
        rus: "\u0411\u043E\u043D\u043A! \u0410\u0442\u043E\u043C\u043D\u044B\u0439 \u0437\u0430\u043B\u043F",
        pol: "Bonk! Atomowy kop",
        sch: "\u539F\u5B50\u80FD\u996E\u6599",
        fre: "Bonk! Atomic Punch",
        bra: "Bonk! Pancada At\xf4mica",
        schema: 46,
        hun: "Poff! Atompuncs",
        ger: "Bonk! Atomenergie-Drink"
    },
    69: {
        img: "huntsman",
        eng: "The Huntsman",
        rus: "\u041E\u0445\u043E\u0442\u043D\u0438\u043A",
        pol: "\u0141owca",
        sch: "\u730E\u4EBA\u77ED\u5F13",
        fre: "Le Huntsman",
        bra: "O Ca\xe7ador",
        schema: 56,
        hun: "A Levad\xe1sz",
        swe: "J\xe4garen"
    },
    70: {
        img: "trophy_belt",
        eng: "Trophy Belt",
        rus: "\u041B\u0435\u043D\u0442\u0430 \u0441 \u0442\u0440\u043E\u0444\u0435\u044F\u043C\u0438",
        pol: "Pas zdobyczy",
        sch: "\u6218\u5229\u54C1\u5E3D\u5E26",
        fre: "Ceinture troph\xe9e",
        bra: "Trof\xe9us do Ca\xe7ador",
        schema: 53,
        hun: "Fogas D\xedszszalag",
        swe: "Trof\xe9b\xe4lte"
    },
    71: {
        img: "horrific_headsplitter",
        eng: "Horrific Headsplitter",
        rus: "\u0423\u0436\u0430\u0441\u0430\u044E\u0449\u0438\u0439 \u0442\u043E\u043F\u043E\u0440 \u043C\u044F\u0441\u043D\u0438\u043A\u0430",
        pol: "Makabryczny roz\u0142upywacz",
        sch: "\u53EF\u6015\u7684\u5288\u5934\u8005",
        fre: "\xc9pouvantable Hachoir",
        bra: "Abre-Cr\xe2nios Horripilante",
        schema: 291,
        hun: "Hallatlan Hasogat\xe1s",
        swe: "Skr\xe4mmande Skallfraktur"
    },
    72: {
        img: "cadavers_cranium",
        eng: "Cadaver's Cranium",
        rus: "\u0427\u0435\u0440\u0435\u043F \u043C\u0435\u0440\u0442\u0432\u0435\u0446\u0430",
        pol: "Czerep Frankensteina",
        sch: "\u6B7B\u5C38\u7684\u5934\u76D6\u9AA8",
        fre: "Boite cr\xe2nienne d'un cadavre",
        bra: "Cr\xe2nio do Cad\xe1ver",
        schema: 290,
        hun: "Hulla Homloka",
        swe: "Kadavrets Kranium"
    },
    73: {
        img: "familiar_fez",
        eng: "Familiar Fez",
        rus: "\u0417\u043D\u0430\u043A\u043E\u043C\u0430\u044F \u0444\u0435\u0441\u043A\u0430",
        pol: "Znajomy fez",
        sch: "\u773C\u719F\u7684\u975E\u65AF\u5E3D",
        fre: "Fez et gestes",
        bra: "Fez Familiar",
        schema: 223,
        hun: "Felt\u0171n\u0151 Fez",
        swe: "V\xe4lbekant Fez"
    },
    74: {
        img: "gift_wrap",
        eng: "Gift Wrap",
        rus: "\u041F\u043E\u0434\u0430\u0440\u043E\u0447\u043D\u0430\u044F \u0443\u043F\u0430\u043A\u043E\u0432\u043A\u0430",
        pol: "Zestaw do pakowania",
        sch: "\u793C\u7269\u5305\u88C5",
        fre: "Papier Cadeau",
        bra: "Embrulho para Presente",
        schema: 5042,
        hun: "Csomagol\xf3pap\xedr",
        rom: "Ambalaj de Cadou",
        swe: "Presentpapper"
    },
    75: {
        img: "i_see_you",
        eng: "Taunt: I See You",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u042F \u0442\u0435\u0431\u044F \u0432\u0438\u0436\u0443",
        schema: 1116,
        pol: "Drwina: Widz\u0119 ci\u0119",
        sch: "\u5632\u8BBD\uFF1A\u770B\u89C1\u4F60\u4E86",
        fre: "Raillerie : Je te vois",
        bra: "Provoca\xe7\xe3o: T\xf4 de Olho",
        hun: "Besz\xf3l\xe1s: L\xe1tlak",
        swe: "H\xe5n: Jag ser dig"
    },
    76: {
        img: "buy_a_life",
        eng: "Taunt: Buy A Life",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0417\u0430\u0439\u043C\u0438\u0441\u044C \u0434\u0435\u043B\u043E\u043C",
        schema: 1108,
        pol: "Drwina: Kup sobie \u017Cycie",
        sch: "\u5632\u8BBD\uFF1A\u5F3A\u8005\u7684\u65BD\u820D",
        fre: "Raillerie : Ach\xe8te-toi une vie",
        bra: "Provoca\xe7\xe3o: Compre uma Vida",
        hun: "Besz\xf3l\xe1s: Vegy\xe9l \xe9letet",
        swe: "H\xe5n: K\xf6p ett liv"
    },
    77: {
        img: "results_are_in",
        eng: "Taunt: Results Are In",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0414\u0438\u0430\u0433\u043D\u043E\u0437 \u043D\u0430\u043B\u0438\u0446\u043E",
        schema: 1109,
        pol: "Drwina: Mam twoje wyniki",
        sch: "\u5632\u8BBD\uFF1A\u68C0\u67E5\u62A5\u544A",
        fre: "Raillerie : Rien d'anormal",
        bra: "Provoca\xe7\xe3o: Resultado do Exame",
        hun: "Besz\xf3l\xe1s: Meg\xe9rkeztek a leletek",
        swe: "H\xe5n: Resultaten \xe4r h\xe4r"
    },
    78: {
        img: "party_trick",
        eng: "Taunt: Party Trick",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0424\u043E\u043A\u0443\u0441 \u0434\u043B\u044F \u0432\u0435\u0447\u0435\u0440\u0438\u043D\u043A\u0438",
        schema: 1112,
        pol: "Drwina: Sztuczka imprezowa",
        sch: "\u5632\u8BBD\uFF1A\u6D3E\u5BF9\u793C\u7269",
        fre: "Raillerie : Le petit tour",
        bra: "Provoca\xe7\xe3o: Truque de Festa",
        hun: "Besz\xf3l\xe1s: Bulitr\xfckk",
        swe: "H\xe5n: Partytrick"
    },
    79: {
        img: "fresh_brewed_victory",
        eng: "Taunt: Fresh Brewed Victory",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0421\u0432\u0435\u0436\u0435\u0441\u0432\u0430\u0440\u0435\u043D\u043D\u0430\u044F \u043F\u043E\u0431\u0435\u0434\u0430",
        schema: 1113,
        pol: "Drwina: \u015Awie\u017Co zaparzone zwyci\u0119stwo",
        sch: "\u5632\u8BBD\uFF1A\u5148\u5E72\u4E3A\u656C",
        fre: "Raillerie : Victoire encore chaude",
        bra: "Provoca\xe7\xe3o: Vit\xf3ria Rec\xe9m-Coada",
        hun: "Besz\xf3l\xe1s: Frissen f\u0151z\xf6tt diadal",
        swe: "H\xe5n: Nybryggd seger"
    },
    80: {
        img: "spent_well_spirits",
        eng: "Taunt: Spent Well Spirits",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0430\u044F \u0440\u0430\u0437\u0440\u044F\u0434\u043A\u0430",
        schema: 1114,
        pol: "Drwina: Po\u0142ykacz ognia",
        sch: "\u5632\u8BBD\uFF1A\u70C8\u9152\u4E0A\u5934",
        fre: "Raillerie : Cocktail explosif",
        bra: "Provoca\xe7\xe3o: Destilado de Dinamite",
        hun: "Besz\xf3l\xe1s: J\xf3l haszn\xe1lt szesz",
        swe: "H\xe5n: V\xe4lspenderad sprit"
    },
    81: {
        img: "rancho_relaxo",
        eng: "Taunt: Rancho Relaxo",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0420\u0430\u043D\u0447\u043E \u0420\u0435\u043B\u0430\u043A\u0441\u043E",
        schema: 1115,
        pol: "Drwina: Relaks na ranczo",
        sch: "\u5632\u8BBD\uFF1A\u60A0\u95F2\u5EA6\u5047",
        fre: "Raillerie : Rancho Relaxo",
        bra: "Provoca\xe7\xe3o: Descanso no Rancho",
        hun: "Besz\xf3l\xe1s: Rancho Relaxo",
        swe: "H\xe5n: Rancho Relaxo"
    },
    82: {
        img: "battin_a_thousand",
        eng: "Taunt: Battin' a Thousand",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041E\u0434\u0438\u043D \u043F\u0440\u043E\u0442\u0438\u0432 \u0442\u044B\u0441\u044F\u0447\u0438",
        schema: 1117,
        pol: "Drwina: Perfekcyjny pa\u0142karz",
        sch: "\u5632\u8BBD\uFF1A\u4EE5\u4E00\u654C\u5343",
        fre: "Raillerie : J'dois en \xeatre \xe0 mille",
        bra: "Provoca\xe7\xe3o: Mestre do Taco",
        hun: "Besz\xf3l\xe1s: T\xf6k\xe9letes j\xe1t\xe9k",
        swe: "H\xe5n: Slagmanslyckan"
    },
    83: {
        img: "oblooterated",
        eng: "Taunt: Oblooterated",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0422\u0440\u0430\u0442\u0430 \u0441\u043E\u043A\u0440\u043E\u0432\u0438\u0449",
        schema: 1120,
        pol: "Drwina: Upojony",
        sch: "\u5632\u8BBD\uFF1A\u6709\u9152\u4E0D\u7ED9\u559D",
        fre: "Raillerie : Oblooterated",
        bra: "Provoca\xe7\xe3o: Obebitera\xe7\xe3o",
        hun: "Besz\xf3l\xe1s: Fen\xe9kig",
        swe: "H\xe5n: Mak-\xf6l-erad"
    },
    84: {
        img: "deep_fried_desire",
        eng: "Taunt: Deep Fried Desire",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0425\u043E\u0440\u043E\u0448\u043E \u043F\u0440\u043E\u0436\u0430\u0440\u0435\u043D\u043D\u0430\u044F \u0441\u0442\u0440\u0430\u0441\u0442\u044C",
        schema: 1119,
        pol: "Drwina: G\u0142\u0119boko sma\u017Cone po\u017C\u0105danie",
        sch: "\u5632\u8BBD\uFF1A\u6709\u8089\u4E0D\u7ED9\u5403",
        fre: "Raillerie : Le d\xe9sir consomm\xe9",
        bra: "Provoca\xe7\xe3o: Galante Frito",
        hun: "Besz\xf3l\xe1s: R\xe1ntott v\xe1gy",
        swe: "H\xe5n: Friterad f\xf6rf\xf6relse"
    },
    85: {
        img: "square_dance",
        eng: "Taunt: Square Dance",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041A\u0430\u0434\u0440\u0438\u043B\u044C",
        schema: 1106,
        pol: "Drwina: Oberek",
        sch: "\u5632\u8BBD\uFF1A\u65B9\u5757\u821E",
        fre: "Raillerie : Square Dance",
        bra: "Provoca\xe7\xe3o: Quadrilha",
        hun: "Besz\xf3l\xe1s: K\xf6rt\xe1nc",
        swe: "H\xe5n: Squaredans"
    },
    86: {
        img: "flippin_awesome",
        eng: "Taunt: Flippin' Awesome",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041A\u0440\u0443\u0442\u043E\u0439 \u043A\u0443\u0432\u044B\u0440\u043E\u043A",
        schema: 1107,
        pol: "Drwina: Wypasiony fiko\u0142ek",
        sch: "\u5632\u8BBD\uFF1A\u725B\u903C\u95EA\u95EA\u7684\u7FFB\u8DDF\u5934",
        fre: "Raillerie : Absolument renversant",
        bra: "Provoca\xe7\xe3o: Mortal Radical",
        hun: "Besz\xf3l\xe1s: Durv\xe1n feldob",
        swe: "H\xe5n: H\xe4ftig Bak\xe5tvolt"
    },
    87: {
        img: "rock_paper_scissors",
        eng: "Taunt: Rock, Paper, Scissors",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041A\u0430\u043C\u0435\u043D\u044C, \u043D\u043E\u0436\u043D\u0438\u0446\u044B, \u0431\u0443\u043C\u0430\u0433\u0430",
        schema: 1110,
        pol: "Drwina: Kamie\u0144, papier, no\u017Cyce",
        sch: "\u5632\u8BBD\uFF1A\u77F3\u5934\u526A\u5200\u5E03",
        fre: "Raillerie : Pierre, Papier, Ciseaux",
        bra: "Provoca\xe7\xe3o: Pedra, Papel e Tesoura",
        hun: "Besz\xf3l\xe1s: K\u0151, pap\xedr, oll\xf3",
        swe: "H\xe5n: Sten, sax, p\xe5se"
    },
    88: {
        img: "conga",
        eng: "Taunt: Conga",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041A\u043E\u043D\u0433\u0430",
        schema: 1118,
        pol: "Drwina: Konga",
        sch: "\u5632\u8BBD\uFF1A\u5EB7\u8304\u821E",
        fre: "Raillerie : Conga",
        bra: "Provoca\xe7\xe3o: Conga",
        hun: "Besz\xf3l\xe1s: Konga",
        swe: "H\xe5n: Conga"
    },
    89: {
        img: "skullcracker",
        eng: "Taunt: Skullcracker",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0413\u043E\u043B\u043E\u0432\u043E\u043B\u043E\u043C\u043A\u0430",
        schema: 1111,
        pol: "Drwina: Kruszenie czaszek",
        sch: "\u5632\u8BBD\uFF1A\u7838\u70C2\u72D7\u5934",
        fre: "Raillerie : Briseur de Cr\xe2nes",
        bra: "Provoca\xe7\xe3o: Quebra-Cuca",
        hun: "Besz\xf3l\xe1s: Fejt\xf6r\u0151",
        swe: "H\xe5n: Skallkn\xe4ckare"
    },
    90: {
        img: "red_rock_roscoe",
        eng: "Red Rock Roscoe | Pistol",
        rus: "Red Rock Roscoe | \u041F\u0438\u0441\u0442\u043E\u043B\u0435\u0442",
        pol: "Z Red Rock | Pistolet",
        sch: "\u7EA2\u77F3 \u624B\u67AA",
        bra: "Red Rock Roscoe Pistola",
        fre: "Pistolet Roscoe rouge rouille",
        schema: 15013,
        schema2: 0,
        hun: "Red Rock Roscoe pisztoly"
    },
    91: {
        img: "sand_cannon",
        eng: "Sand Cannon | Rocket Launcher",
        rus: "Sand Cannon | \u0420\u0430\u043A\u0435\u0442\u043E\u043C\u0451\u0442",
        pol: "Dzia\u0142o piaskowe | Wyrzutnia rakiet",
        sch: "\u6C99\u6F20\u5DE8\u70AE \u706B\u7BAD\u53D1\u5C04\u5668",
        bra: "Canh\xe3o de Areia Lan\xe7a-Foguetes",
        fre: "Lance-Roquettes Canon sabl\xe9",
        schema: 15014,
        schema2: 1,
        hun: "Sand Cannon rak\xe9tavet\u0151"
    },
    92: {
        img: "sudden_flurry",
        eng: "Sudden Flurry | Stickybomb Launcher",
        rus: "Sudden Flurry | \u041B\u0438\u043F\u0443\u0447\u043A\u043E\u043C\u0451\u0442",
        pol: "Nag\u0142y podmuch | Wyrzutnia bomb samoprzylepnych",
        sch: "\u77AC\u95F4\u7206\u53D1 \u9ECF\u6027\u70B8\u5F39\u53D1\u5C04\u5668",
        bra: "Enxurrada Inesperada Lan\xe7a-stickybombs",
        fre: "Lanceur de Bombes collantes Rafale surprise",
        schema: 15009,
        schema2: 8,
        hun: "Sudden Flurry tapad\xf3bomba-vet\u0151"
    },
    93: {
        img: "psychedelic_slugger",
        eng: "Psychedelic Slugger | Revolver",
        rus: "Psychedelic Slugger | \u0420\u0435\u0432\u043E\u043B\u044C\u0432\u0435\u0440",
        pol: "Psychodeliczny wycisk | Rewolwer",
        sch: "\u5E7B\u5F69 \u5DE6\u8F6E\u624B\u67AA",
        bra: "Batedor Psicod\xe9lico Rev\xf3lver",
        fre: "Revolver psych\xe9d\xe9lique",
        schema: 15011,
        schema2: 3,
        hun: "Psychedelic Slugger revolver"
    },
    94: {
        img: "purple_range",
        eng: "Purple Range | Sniper Rifle",
        rus: "Purple Range | \u0421\u043D\u0430\u0439\u043F\u0435\u0440\u0441\u043A\u0430\u044F \u0432\u0438\u043D\u0442\u043E\u0432\u043A\u0430",
        pol: "Zakres fioletu | Karabin snajperski",
        sch: "\u7D2B\u5149\u5341\u5C04 \u72D9\u51FB\u6B65\u67AA",
        bra: "Pontaria P\xfarpura Rifle de Sniper",
        fre: "Fusil de chasse violet",
        schema: 15007,
        schema2: 7,
        hun: "Purple Range mesterl\xf6v\xe9sz puska"
    },
    95: {
        img: "night_terror",
        eng: "Night Terror | Scattergun",
        rus: "Night Terror | \u041E\u0431\u0440\u0435\u0437",
        pol: "Nocny terror | Dubelt\xf3wka",
        sch: "\u591C\u4E4B\u6050\u60E7 \u730E\u67AA",
        bra: "Terror da Meia-noite Espingarda",
        fre: "Fusil \xe0 dispersion Terreur nocturne",
        schema: 15002,
        schema2: 11,
        hun: "Night Terror repeszpuska"
    },
    96: {
        img: "carpet_bomber",
        eng: "Carpet Bomber | Stickybomb Launcher",
        rus: "Carpet Bomber | \u041B\u0438\u043F\u0443\u0447\u043A\u043E\u043C\u0451\u0442",
        pol: "Nalot dywanowy | Wyrzutnia bomb samoprzylepnych",
        sch: "\u5730\u6BEF\u5F0F\u8F70\u70B8 \u9ECF\u6027\u70B8\u5F39\u53D1\u5C04\u5668",
        bra: "Arrasa Quarteir\xe3o Lan\xe7a-stickybombs",
        fre: "Lanceur de Bombes collantes Bombardier tapiss\xe9",
        schema: 15012,
        schema2: 4,
        hun: "Carpet Bomber tapad\xf3bomba-vet\u0151"
    },
    97: {
        img: "woodland_warrior",
        eng: "Woodland Warrior | Rocket Launcher",
        rus: "Woodland Warrior | \u0420\u0430\u043A\u0435\u0442\u043E\u043C\u0451\u0442",
        pol: "Le\u015Bny wojownik | Wyrzutnia rakiet",
        sch: "\u6797\u5730\u6218\u58EB \u706B\u7BAD\u53D1\u5C04\u5668",
        bra: "Matador do Matagal Lan\xe7a-foguetes",
        fre: "Lance-Roquettes Guerrier des bois",
        schema: 15006,
        schema2: 6,
        hun: "Woodland Warrior rak\xe9tavet\u0151"
    },
    98: {
        img: "wrapped_reviver",
        eng: "Wrapped Reviver | Medi Gun",
        rus: "Wrapped Reviver | \u041B\u0435\u0447\u0435\u0431\u043D\u0430\u044F \u043F\u0443\u0448\u043A\u0430",
        pol: "Spakowany o\u017Cywiciel | Medigun",
        sch: "\u8FF7\u5F69\u6551\u63F4\u8005 \u533B\u7597\u67AA",
        bra: "Revivedor Embrulhado Arma M\xe9dica",
        fre: "Medigun Ressuscitateur emball\xe9",
        schema: 15010,
        schema2: 2,
        hun: "Wrapped Reviver gy\xf3gypuska"
    },
    99: {
        img: "forest_fire",
        eng: "Forest Fire | Flame Thrower",
        rus: "Forest Fire | \u041E\u0433\u043D\u0435\u043C\u0451\u0442",
        pol: "Le\u015Bny ogie\u0144 | Miotacz ognia",
        sch: "\u68EE\u6797\u4E4B\u706B \u706B\u7130\u55B7\u5C04\u5668",
        bra: "Fogo na Floresta Lan\xe7a-chamas",
        fre: "Lance-flammes Feu de for\xeat",
        schema: 15005,
        schema2: 9,
        hun: "Forest Fire l\xe1ngsz\xf3r\xf3"
    },
    100: {
        img: "night_owl",
        eng: "Night Owl | Sniper Rifle",
        rus: "Night Owl | \u0421\u043D\u0430\u0439\u043F\u0435\u0440\u0441\u043A\u0430\u044F \u0432\u0438\u043D\u0442\u043E\u0432\u043A\u0430",
        pol: "Nocna sowa | Karabin snajperski",
        sch: "\u591C\u67AD \u72D9\u51FB\u6B65\u67AA",
        bra: "Coruja da Noite Rifle de Sniper",
        fre: "Fusil de sniper Oiseau de nuit",
        schema: 15000,
        schema2: 14,
        hun: "Night Owl mesterl\xf6v\xe9sz puska"
    },
    101: {
        img: "woodsy_widowmaker",
        eng: "Woodsy Widowmaker | SMG",
        rus: "Woodsy Widowmaker | \u041F\u0438\u0441\u0442\u043E\u043B\u0435\u0442-\u043F\u0443\u043B\u0435\u043C\u0451\u0442",
        pol: "Lesisty owdawiacz | PM",
        sch: "\u7EDD\u540E\u4E4B\u6728 SMG",
        bra: "Viuvadora Verdejante Submetralhadora",
        fre: "Mitraillette Endeuilleur bois\xe9",
        schema: 15001,
        schema2: 13,
        hun: "Woodsy Widowmaker g\xe9ppisztoly"
    },
    102: {
        img: "backwoods_boomstick",
        eng: "Backwoods Boomstick | Shotgun",
        rus: "Backwoods Boomstick | \u0414\u0440\u043E\u0431\u043E\u0432\u0438\u043A",
        pol: "Grzmi\u0105cy kij z puszczy | Strzelba",
        sch: "\u8352\u91CE\u795E\u5175 \u9730\u5F39\u67AA",
        bra: "Sert\xe3o Escopeta",
        fre: "Fusil \xe0 pompe Fusil de derri\xe8re les fagots",
        schema: 15003,
        schema2: 12,
        hun: "Backwoods Boomstick s\xf6r\xe9tes puska"
    },
    103: {
        img: "king_of_the_jungle",
        eng: "King of the Jungle | Minigun",
        rus: "King of the Jungle | \u041F\u0443\u043B\u0435\u043C\u0451\u0442",
        pol: "Kr\xf3l d\u017Cungli | Minigun",
        sch: "\u4E1B\u6797\u4E4B\u738B \u533B\u7597\u67AA",
        bra: "Rei da Selva Metralhadora Girat\xf3ria",
        fre: "Minigun Roi de la jungle",
        schema: 15004,
        schema2: 10,
        hun: "King of the Jungle g\xe9p\xe1gy\xfa"
    },
    104: {
        img: "masked_mender",
        eng: "Masked Mender | Medi Gun",
        rus: "Masked Mender | \u041B\u0435\u0447\u0435\u0431\u043D\u0430\u044F \u043F\u0443\u0448\u043A\u0430",
        pol: "Zakamufliowany uzdrowiciel | Medigun",
        sch: "\u8499\u9762\u8005 \u533B\u7597\u67AA",
        bra: "Medicamento Mascarado Arma M\xe9dica",
        fre: "Medigun R\xe9parateur masqu\xe9",
        schema: 15008,
        schema2: 5,
        hun: "Masked Mender gy\xf3gypuska"
    },
    105: {
        img: "pink_as_hell",
        eng: "Pink as Hell",
        rus: "\u041D\u0435\u0440\u0435\u0430\u043B\u044C\u043D\u043E \u0440\u043E\u0437\u043E\u0432\u044B\u0439",
        pol: "R\xf3\u017Cowy jak diabli",
        sch: "\u6781\u81F4\u95EA\u4EAE\u7C89",
        fre: "Un Rose d'Enfer",
        bra: "Rosa pra Caramba",
        schema: 5051,
        hun: "Pokoli R\xf3zsasz\xedn",
        swe: "Rosa som in i helvete"
    },
    106: {
        img: "a_color_similar_to_slate",
        eng: "A Color Similar to Slate",
        rus: "\u041A\u0430\u043A\u043E\u0439-\u0442\u043E \u0441\u0438\u043D\u0435\u0432\u0430\u0442\u043E-\u0441\u0435\u0440\u044B\u0439",
        pol: "Kolor podobny do \u0142upkowego",
        sch: "\u6DF1\u6C89\u77F3\u677F\u9752",
        fre: "Une Couleur Similaire \xe0 l'Ardoise",
        bra: "Uma Cor Similar \xe0 Ard\xf3sia",
        schema: 5052,
        hun: "Pal\xe1hoz Hasonl\xf3 Sz\xedn",
        swe: "En f\xe4rg som liknar griffeltavla"
    },
    107: {
        img: "drably_olive",
        eng: "Drably Olive",
        rus: "\u0422\u0443\u0441\u043A\u043B\u043E-\u043E\u043B\u0438\u0432\u043A\u043E\u0432\u044B\u0439",
        pol: "Ponura oliwka",
        sch: "\u5E73\u6DE1\u6A44\u6984\u7EFF",
        fre: "Vert Olive",
        bra: "Oliva Mon\xf3tono",
        schema: 5053,
        hun: "Z\xf6ldesen Barna",
        swe: "Smutsgul olivf\xe4rg"
    },
    108: {
        img: "the_bitter_taste_of_defeat_and_lime",
        eng: "The Bitter Taste of Defeat and Lime",
        rus: "\u0413\u043E\u0440\u044C\u043A\u0438\u0439 \u0432\u043A\u0443\u0441 \u043F\u043E\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0438 \u043B\u0430\u0439\u043C\u0430",
        pol: "Gorzki smak pora\u017Cki i limonki",
        sch: "\u82E6\u6DA9\u9752\u67E0\u7EFF",
        fre: "Le Go\xfbt Amer de la D\xe9faite et du Citron Vert",
        bra: "O Amargo Sabor de Derrota e Lim\xe3o",
        schema: 5054,
        hun: "A Veres\xe9g \xe9s Lime Keser\u0171 \xcdze",
        swe: "Den bittra smaken av f\xf6rlust och lime"
    },
    109: {
        img: "the_color_of_a_gentlemanns_business_pants",
        eng: "The Color of a Gentlemann's Business Pants",
        rus: "\u0426\u0432\u0435\u0442 \u0431\u0440\u044E\u043A \u0414\u0436\u0435\u043D\u0442\u043B\u044C\u043C\u0430\u043D\u043D\u0430",
        pol: "Kolor biznesowych spodni d\u017Centelmena",
        sch: "\u5546\u52A1\u7C73\u9EC4\u8272",
        fre: "La Couleur du Pantalon d'Affaires d'un Gentlemann",
        bra: "A Cor das Cal\xe7as de Neg\xf3cios de um Cavalheiro",
        schema: 5055,
        hun: "Egy \xdariember T\xe1rgyal\xf3nadr\xe1gj\xe1nak Sz\xedne",
        swe: "F\xe4rgen p\xe5 en gentlemanns aff\xe4rsbyxor"
    },
    110: {
        img: "dark_salmon_injustice",
        eng: "Dark Salmon Injustice",
        rus: "\u0422\u0451\u043C\u043D\u0430\u044F \u043B\u043E\u0441\u043E\u0441\u0435\u0432\u0430\u044F \u043D\u0435\u0441\u043F\u0440\u0430\u0432\u0435\u0434\u043B\u0438\u0432\u043E\u0441\u0442\u044C",
        pol: "Niesprawiedliwo\u015B\u0107 ciemnego \u0142ososia",
        sch: "\u4E0D\u516C\u6DF1\u6A59\u7EA2",
        fre: "Injustice Saumon Fonc\xe9",
        bra: "Injusti\xe7a Salm\xe3o Escuro",
        schema: 5056,
        hun: "S\xf6t\xe9t Lazac Igazs\xe1gtalans\xe1g",
        swe: "Laxf\xe4rgad or\xe4ttvisa"
    },
    111: {
        img: "grenadiers_softcap",
        eng: "Grenadier's Softcap",
        rus: "\u041A\u0435\u043F\u043A\u0430 \u0433\u0440\u0435\u043D\u0430\u0434\u0435\u0440\u0430",
        pol: "Patrol\xf3wka grenadiera",
        sch: "\u6295\u5F39\u5175\u7684\u8F6F\u5E3D",
        fre: "Casquette de grenadier",
        bra: "Quepe do Granadeiro",
        schema: 227,
        hun: "Gr\xe1n\xe1tos Terepsapk\xe1ja",
        swe: "Grenadj\xe4rens Keps"
    },
    112: {
        img: "indubitably_green",
        eng: "Indubitably Green",
        rus: "\u0418\u0441\u0442\u0438\u043D\u043D\u043E \u0437\u0435\u043B\u0451\u043D\u044B\u0439",
        pol: "Niezaprzeczalnie zielony",
        sch: "\u7EDD\u5BF9\u7ECF\u5178\u7EFF",
        fre: "Indubitablement Vert",
        bra: "Indiscutivelmente Verde",
        schema: 5027,
        hun: "K\xe9ts\xe9gtelen\xfcl Z\xf6ld",
        swe: "Otvivelaktigt gr\xf6n"
    },
    113: {
        img: "zepheniahs_greed",
        eng: "Zepheniah's Greed",
        rus: "\u0416\u0430\u0434\u043D\u043E\u0441\u0442\u044C \u0417\u0435\u0444\u0435\u043D\u0430\u0439\u0438",
        pol: "Zach\u0142anno\u015B\u0107 Zefeniasza",
        sch: "\u6CFD\u8001\u8D2A\u6B32\u7EFF",
        fre: "L'Avarice de Zepheniah",
        bra: "Gan\xe2ncia do Zepheniah",
        schema: 5028,
        hun: "Zepheniah Kapzsis\xe1ga",
        swe: "Zepheniahs girighet"
    },
    114: {
        img: "noble_hatters_violet",
        eng: "Noble Hatter's Violet",
        rus: "\u0411\u043B\u0430\u0433\u043E\u0440\u043E\u0434\u043D\u044B\u0439 \u0444\u0438\u043E\u043B\u0435\u0442\u043E\u0432\u044B\u0439",
        pol: "Fiolet zacnego kapelusznika",
        sch: "\u8D35\u65CF\u5E3D\u5546\u7D2B",
        fre: "Violet de l'Aristocrate Chapeaut\xe9",
        bra: "Violeta do Nobre Chapeleiro",
        schema: 5029,
        hun: "Nemes Kalaposok Iboly\xe1ja",
        swe: "Nobla hattmakarens violett"
    },
    115: {
        img: "ullapool_caber",
        eng: "The Ullapool Caber",
        rus: "\u0410\u043B\u043B\u0430\u043F\u0443\u043B\u044C\u0441\u043A\u043E\u0435 \u0431\u0440\u0435\u0432\u043D\u043E",
        pol: "Ullapoolski pal",
        sch: "\u6728\u67C4\u624B\u69B4\u5F39",
        fre: "Le Caber d'Ullapool",
        bra: "A Tora de Ullapool",
        schema: 307,
        hun: "A Kot-Nyeles Gr\xe1n\xe1t",
        swe: "Ullapool-Caber"
    },
    116: {
        img: "lochnload",
        eng: "The Loch-n-Load",
        rus: "\u041F\u043E\u0434\u043A\u0438\u0434\u044B\u0448",
        pol: "Loch-n-Load",
        sch: "\u53CC\u7BA1\u69B4\u5F39\u53D1\u5C04\u5668",
        fre: "Le Loch-n-Load",
        bra: "A Bomba do Lago Ness",
        schema: 308,
        hun: "A Loch-Nesze-Sz\xf6rny",
        ger: "Der Lochnesser",
        swe: "Loch-n-Load"
    },
    117: {
        img: "scotch_bonnet",
        eng: "Scotch Bonnet",
        rus: "\u0428\u043E\u0442\u043B\u0430\u043D\u0434\u0441\u043A\u0438\u0439 \u0447\u0435\u043F\u0435\u0446",
        pol: "Szkocki kask",
        sch: "\u7834\u635F\u7684\u9632\u66B4\u5934\u76D4",
        fre: "Casque \xc9cossais",
        bra: "Capacete Escoc\xeas",
        schema: 306,
        hun: "Sk\xf3t Sisak",
        swe: "Skotsk H\xe4tta"
    },
    118: {
        img: "glengarry_bonnet",
        eng: "Glengarry Bonnet",
        rus: "\u0413\u043B\u0435\u043D\u0433\u0430\u0440\u0440\u0438",
        pol: "Fura\u017Cerka z Glengarry",
        sch: "\u82CF\u683C\u5170\u8F6F\u5E3D",
        fre: "Bonnet Glengarry",
        bra: "Boina Glengarry",
        schema: 100,
        hun: "Glengarry Sapka",
        swe: "Glengarry-H\xe4tta"
    },
    119: {
        img: "mann_co_orange",
        eng: "Mann Co. Orange",
        rus: "\u041E\u0440\u0430\u043D\u0436\u0435\u0432\u044B\u0439 \u0432 \u0441\u0442\u0438\u043B\u0435 \u041C\u0430\u043D\u043D \u041A\u043E",
        pol: "Pomara\u0144cz firmy Mann Co.",
        sch: "\u66FC\u6069\u4F01\u4E1A\u6A59",
        fre: "Orange Mann Co.",
        bra: "Laranja Mann Co.",
        schema: 5032,
        hun: "Mann Co. Narancs",
        swe: "Mann Co.-orange"
    },
    120: {
        img: "crusaders_crossbow",
        eng: "Crusader's Crossbow",
        rus: "\u0410\u0440\u0431\u0430\u043B\u0435\u0442 \u043A\u0440\u0435\u0441\u0442\u043E\u043D\u043E\u0441\u0446\u0430",
        pol: "Kusza krzy\u017Cowca",
        sch: "\u5341\u5B57\u519B\u4E4B\u5F29",
        fre: "L'Arbal\xe8te du Crois\xe9",
        bra: "A Besta do Cruzado",
        schema: 305,
        hun: "A Szamarit\xe1nus Sz\xe1mszer\xedja",
        swe: "Korsriddarens armborst"
    },
    121: {
        img: "amputator",
        eng: "The Amputator",
        rus: "\u0410\u043C\u043F\u0443\u0442\u0430\u0442\u043E\u0440",
        pol: "Amputator",
        sch: "\u5668\u5B98\u5207\u5272\u5668",
        fre: "L'Amputateur",
        bra: "A Amputadora",
        schema: 304,
        hun: "Az Amput\xe1l\xf3",
        swe: "Amputeraren"
    },
    122: {
        img: "berliners_bucket_helm",
        eng: "Berliner's Bucket Helm",
        rus: "\u0411\u043E\u0435\u0432\u043E\u0439 \u0448\u043B\u0435\u043C \u0431\u0435\u0440\u043B\u0438\u043D\u0446\u0430",
        pol: "He\u0142m garnczkowy Berli\u0144czyka",
        sch: "\u67CF\u6797\u7684\u6876\u5F0F\u5934\u76D4",
        fre: "Seau Berlinois",
        bra: "Elmo do Berlinense",
        schema: 303,
        hun: "Berlini B\xe1dogsisak",
        swe: "Tyskens Tunnhj\xe4lm"
    },
    123: {
        img: "vintage_tyrolean",
        eng: "Vintage Tyrolean",
        rus: "\u0421\u0442\u0430\u0440\u0430\u044F \u0442\u0438\u0440\u043E\u043B\u044C\u0441\u043A\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "Klasyczny kapelusz tyrolski",
        sch: "\u4F20\u7EDF\u63D0\u6D1B\u5E3D",
        fre: "Chapeau tyrolien",
        bra: "Tirol\xeas Cl\xe1ssico",
        schema: 101,
        hun: "\xd6reg Tiroli",
        swe: "Gammal Tyrolerhatt"
    },
    124: {
        img: "prussian_pickelhaube",
        eng: "Prussian Pickelhaube",
        rus: "\u041F\u0440\u0443\u0441\u0441\u043A\u0438\u0439 \u043F\u0438\u043A\u0435\u043B\u044C\u0445\u0435\u043B\u044C\u043C",
        pol: "Pruska pikielhauba",
        sch: "\u666E\u9C81\u58EB\u5C16\u9876\u76D4",
        fre: "Casque \xe0 pointe prussien",
        bra: "Pickelhaube Prussiano",
        schema: 50,
        hun: "Porosz D\xedszsisak",
        swe: "Preussisk Pickelhuva"
    },
    125: {
        img: "muskelmannbraun",
        eng: "Muskelmannbraun",
        rus: "\u041C\u0443\u0441\u043A\u0443\u043B\u0438\u0441\u0442\u043E-\u043A\u043E\u0440\u0438\u0447\u043D\u0435\u0432\u044B\u0439",
        pol: "Muskularny br\u0105z",
        sch: "\u731B\u7537\u808C\u8089\u8272",
        fre: "Marronmuskelmann",
        bra: "Muskelmannbraun",
        schema: 5033,
        hun: "Izomember-barna"
    },
    126: {
        img: "peculiarly_drab_tincture",
        eng: "Peculiarly Drab Tincture",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u043E\u0442\u0442\u0435\u043D\u043E\u043A \u0441\u0435\u0440\u043E\u0433\u043E",
        pol: "Osobliwie szarawe zabarwienie",
        sch: "\u6C89\u95F7\u4E4F\u5473\u8D6D",
        fre: "Teinture Mate Particuli\xe8re",
        bra: "Tintura Peculiarmente Amarronzada",
        schema: 5034,
        hun: "K\xfcl\xf6n\xf6sen Egyhang\xfa Sz\xednezet",
        swe: "Underligt blekgul f\xe4rg"
    },
    127: {
        img: "radigan_conagher_brown",
        eng: "Radigan Conagher Brown",
        rus: "\u041A\u043E\u0440\u0438\u0447\u043D\u0435\u0432\u044B\u0439 \u043E\u0442 \u0420\u0430\u0434\u0438\u0433\u0430\u043D\u0430 \u041A\u043E\u043D\u0430\u0433\u0435\u0440\u0430",
        pol: "Br\u0105z Radigana Conaghera",
        sch: "\u8001\u5320\u5496\u5561\u8272",
        fre: "Brun Radigan Conagher",
        bra: "Marrom Radigan Conagher",
        schema: 5035,
        hun: "Radigan Conagher Barna",
        swe: "Radigan Conagher-brun"
    },
    128: {
        img: "brass_beast",
        eng: "The Brass Beast",
        rus: "\u041B\u0430\u0442\u0443\u043D\u043D\u044B\u0439 \u043C\u043E\u043D\u0441\u0442\u0440",
        pol: "Mosi\u0119\u017Cna bestia",
        sch: "\u9EC4\u94DC\u731B\u517D",
        fre: "La B\xeate de Bronze",
        bra: "A Fera de Bronze",
        schema: 312,
        hun: "A Bronz Bestia",
        swe: "M\xe4ssingsmonstret"
    },
    129: {
        img: "buffalo_steak_sandvich",
        eng: "The Buffalo Steak Sandvich",
        rus: "\u0411\u0443\u0442\u0435\u0440\u0431\u0440\u043E\u0434 \u0438\u0437 \u043C\u044F\u0441\u0430 \u0431\u0443\u0439\u0432\u043E\u043B\u0430",
        pol: "Stek z bizona",
        sch: "\u6C34\u725B\u6392\u4E09\u660E\u6CBB",
        fre: "Le Sandvich au Steak de Bison",
        bra: "O Sandviche de Bife de B\xfafalo",
        schema: 311,
        hun: "A Bivaly B\xe9lsz\xedn Szendvics",
        swe: "Buffelbiffsm\xf6rgos"
    },
    130: {
        img: "big_chief",
        eng: "The Big Chief",
        rus: "\u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u043E\u0436\u0434\u044C",
        pol: "Wielki w\xf3dz",
        sch: "\u5927\u914B\u957F",
        fre: "Le Grand Chef",
        bra: "O Grande Cacique",
        schema: 309,
        schema2: 5725,
        hun: "A Nagyf\u0151n\xf6k",
        swe: "Den Stora H\xf6vdingen"
    },
    131: {
        img: "officers_ushanka",
        eng: "Officer's Ushanka",
        rus: "\u041E\u0444\u0438\u0446\u0435\u0440\u0441\u043A\u0430\u044F \u0443\u0448\u0430\u043D\u043A\u0430",
        pol: "Uszanka oficera",
        sch: "\u5B98\u5458\u7684\u7EA2\u519B\u5E3D",
        fre: "Ouchanka d'officier",
        bra: "Ushanka do Oficial",
        schema: 96,
        hun: "Tiszti Usanka",
        swe: "Officerens usjanka"
    },
    132: {
        img: "sydney_sleeper",
        eng: "The Sydney Sleeper",
        rus: "\u0421\u0438\u0434\u043D\u0435\u0439\u0441\u043A\u0438\u0439 \u0441\u043E\u043D\u044F",
        pol: "Sydnejski usypiacz",
        sch: "\u6089\u5C3C\u6C89\u7761\u8005",
        fre: "La Sarbacane de Sydney",
        bra: "O Anestesiador de Sydney",
        schema: 230,
        hun: "A Sydney-i Pisi-Puska",
        swe: "Sydney-s\xf6varen"
    },
    133: {
        img: "ol_snaggletooth",
        eng: "Ol' Snaggletooth",
        rus: "\u0421\u0442\u0430\u0440\u044B\u0439 \u043A\u0440\u0438\u0432\u043E\u0437\u0443\u0431",
        pol: "G\u0142owa Forfitera",
        sch: "\u8001\u9CC4\u9C7C\u9F85\u7259",
        fre: "Sacr\xe9 dentier",
        bra: "Velho Dente-Torto",
        schema: 229,
        hun: "V\xe9n Csorbafog",
        swe: "Gamle Gadden"
    },
    134: {
        img: "professionals_panama",
        eng: "Professional's Panama",
        rus: "\u041F\u0430\u043D\u0430\u043C\u0430 \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u0430",
        pol: "Panama profesjonalisty",
        sch: "\u4E13\u4E1A\u4EBA\u58EB\u7684\u5DF4\u62FF\u9A6C\u8349\u5E3D",
        fre: "Panama du professionnel",
        bra: "Panam\xe1 do Profissional",
        schema: 109,
        hun: "Profik Panam\xe1ja",
        swe: "Proffsets Str\xe5hatt"
    },
    135: {
        img: "shooters_sola_topi",
        eng: "Shooter's Sola Topi",
        rus: "\u0422\u0440\u043E\u043F\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0448\u043B\u0435\u043C \u0441\u0442\u0440\u0435\u043B\u043A\u0430",
        pol: "Kolonialny he\u0142m strzelca",
        sch: "\u5C04\u624B\u7684\u6728\u9AD3\u906E\u9633\u5E3D",
        fre: "Tireur Colonial",
        bra: "Chap\xe9u de Saf\xe1ri",
        schema: 158,
        hun: "Szafari-kalap",
        swe: "Skjutarens Tropikhj\xe4lm"
    },
    136: {
        img: "backbiters_billycock",
        eng: "Backbiter's Billycock",
        rus: "\u041A\u043E\u0442\u0435\u043B\u043E\u043A \u0441\u043F\u043B\u0435\u0442\u043D\u0438\u043A\u0430",
        pol: "Melonik oszczercy",
        sch: "\u80CC\u540E\u8BFD\u8C24\u8005\u7684\u5C0F\u793C\u5E3D",
        fre: "Chapeau melon",
        bra: "Chap\xe9u-Coco do Caluniador",
        schema: 108,
        hun: "H\xe1tbasz\xfar\xf3k Kem\xe9nykalapja",
        swe: "Baktalarens Kubb"
    },
    137: {
        img: "tyrants_helm",
        eng: "Tyrant's Helm",
        rus: "\u0428\u043B\u0435\u043C \u0432\u0438\u043A\u0438\u043D\u0433\u0430",
        pol: "He\u0142m tyrana",
        sch: "\u66B4\u541B\u5934\u76D4",
        fre: "Casque de viking",
        bra: "Elmo do Tirano",
        schema: 99,
        hun: "Zsarnok-sisak",
        swe: "Tyrannens Hj\xe4lm"
    },
    138: {
        img: "mad_milk",
        eng: "Mad Milk",
        rus: "\u0417\u043B\u043E\u043C\u043E\u043B\u043E\u043A\u043E",
        pol: "W\u015Bciek\u0142e mleko",
        sch: "\u75AF\u72C2\u7684\u725B\u5976",
        fre: "Lait frelat\xe9",
        bra: "Leite Louco",
        schema: 222,
        hun: "Kerge Tej",
        swe: "Manisk mj\xf6lk"
    },
    139: {
        img: "degreaser",
        eng: "The Degreaser",
        rus: "\u0427\u0438\u0441\u0442\u0438\u043B\u044C\u0449\u0438\u043A",
        pol: "Odt\u0142uszczacz",
        sch: "\u8131\u6CB9\u5242",
        fre: "Le D\xe9graisseur",
        bra: "O Desengraxante",
        schema: 215,
        hun: "A Zs\xedrold\xf3",
        swe: "Avfettaren"
    },
    140: {
        img: "attendant",
        eng: "The Attendant",
        rus: "\u0417\u0430\u043F\u0440\u0430\u0432\u0449\u0438\u043A",
        pol: "Pomocnik",
        sch: "\u670D\u52A1\u5458\u4E4B\u5E3D",
        fre: "Le Pr\xe9pos\xe9",
        bra: "Frentista",
        schema: 213,
        hun: "A Benzinkutas",
        swe: "Personalm\xf6ssan"
    },
    141: {
        img: "wrangler",
        eng: "The Wrangler",
        rus: "\u041F\u043E\u0432\u043E\u0434\u044B\u0440\u044C",
        pol: "Poskramiacz",
        sch: "\u9065\u63A7\u624B\u67C4",
        fre: "Le Dompteur",
        bra: "O Pe\xe3o",
        schema: 140,
        hun: "Az Idom\xedt\xf3",
        swe: "Gr\xe4lmakaren"
    },
    142: {
        img: "hotrod",
        eng: "Hotrod",
        rus: "\u0421\u0432\u0430\u0440\u043E\u0447\u043D\u0430\u044F \u043C\u0430\u0441\u043A\u0430",
        pol: "Hotrod",
        sch: "\u70ED\u6D6A",
        fre: "Hotrod",
        bra: "Hotrod",
        schema: 148,
        hun: "\xcdvad\xf3",
        swe: "Svetsarmask"
    },
    143: {
        img: "professors_peculiarity",
        eng: "Professor's Peculiarity",
        rus: "\u0421\u0432\u043E\u0435\u043E\u0431\u0440\u0430\u0437\u0438\u0435 \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u043E\u0440\u0430",
        pol: "Profesorska osobliwo\u015B\u0107",
        sch: "\u6559\u6388\u7684\u84EC\u4E71\u767D\u53D1",
        fre: "Particularit\xe9 Professorale",
        bra: "Peculiaridade do Professor",
        schema: 384,
        hun: "A Professzor P\xe1ratlans\xe1ga",
        swe: "Professorns Pr\xe4gel"
    },
    144: {
        img: "grenade_launcher",
        eng: "Grenade Launcher",
        rus: "\u0413\u0440\u0430\u043D\u0430\u0442\u043E\u043C\u0451\u0442",
        pol: "Granatnik",
        sch: "\u69B4\u5F39\u53D1\u5C04\u5668",
        fre: "Lance-grenades",
        bra: "Lan\xe7a-Granadas",
        schema: 206,
        hun: "gr\xe1n\xe1tvet\u0151",
        swe: "Granatkastare"
    },
    145: {
        img: "stickybomb_launcher",
        eng: "Stickybomb Launcher",
        rus: "\u041B\u0438\u043F\u0443\u0447\u043A\u043E\u043C\u0451\u0442",
        pol: "Wyrzutnia bomb samoprzylepnych",
        sch: "\u9ECF\u6027\u70B8\u5F39\u53D1\u5C04\u5668",
        fre: "Lanceur de bombes collantes",
        bra: "Lan\xe7a-Stickybombs",
        schema: 207,
        hun: "tapad\xf3bomba-vet\u0151",
        swe: "Klisterbombskastare"
    },
    146: {
        img: "eyelander",
        eng: "The Eyelander",
        rus: "\u041E\u0434\u043D\u043E\u0433\u043B\u0430\u0437\u044B\u0439 \u0433\u043E\u0440\u0435\u0446",
        pol: "Wyszczerbiec",
        sch: "\u82CF\u683C\u5170\u957F\u5251",
        fre: "L'Eyelander",
        bra: "A Eyelander",
        schema: 132,
        hun: "Az Egyetlen",
        swe: "\xd6gl\xe4ndaren"
    },
    147: {
        img: "hustlers_hallmark",
        eng: "Hustler's Hallmark",
        rus: "\u0428\u043B\u044F\u043F\u0430 \u0441\u0443\u0442\u0435\u043D\u0451\u0440\u0430",
        pol: "Wizyt\xf3wka sutenera",
        sch: "\u76AE\u6761\u5BA2\u7684\u6807\u5FD7\u5E3D",
        fre: "Marque du D\xe9brouillard",
        bra: "Chap\xe9u do Malandro",
        schema: 146,
        hun: "Cinkel\u0151 C\xe9g\xe9re",
        swe: "Fuskarens Fj\xe4derhatt"
    },
    148: {
        img: "tipplers_tricorne",
        eng: "Tippler's Tricorne",
        rus: "\u0422\u0440\u0435\u0443\u0433\u043E\u043B\u043A\u0430 \u043F\u044C\u044F\u043D\u0438\u0446\u044B",
        pol: "Trikorn pijaka",
        sch: "\u9189\u6C49\u7684\u4E09\u89D2\u5E3D",
        fre: "Tricorne de l'ivrogne",
        bra: "Tric\xf3rnio do B\xeabado",
        schema: 179,
        hun: "Tint\xe1s T\xf6kf\xf6d\u0151",
        swe: "Sm\xe5suparens Sj\xf6r\xf6varhatt"
    },
    149: {
        img: "schadenfreude",
        eng: "Taunt: The Schadenfreude",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0417\u043B\u043E\u0440\u0430\u0434\u0441\u0442\u0432\u043E",
        schema: 463,
        pol: "Drwina: Schadenfreude",
        sch: "\u5632\u8BBD\uFF1A\u5E78\u707E\u4E50\u7978",
        fre: "Raillerie : Le Plaisir Sadique",
        bra: "Provoca\xe7\xe3o: A Schadenfreude",
        hun: "Besz\xf3l\xe1s: A k\xe1r\xf6r\xf6m",
        swe: "H\xe5n: Skadegl\xe4djen"
    },
    150: {
        img: "rocket_launcher",
        eng: "Rocket Launcher",
        rus: "\u0420\u0430\u043A\u0435\u0442\u043E\u043C\u0451\u0442",
        pol: "Wyrzutnia rakiet",
        sch: "\u706B\u7BAD\u53D1\u5C04\u5668",
        fre: "Lance-roquettes",
        bra: "Lan\xe7a-Foguetes",
        schema: 205,
        hun: "rak\xe9tavet\u0151",
        swe: "Raketgev\xe4r"
    },
    151: {
        img: "shotgun",
        eng: "Shotgun",
        rus: "\u0414\u0440\u043E\u0431\u043E\u0432\u0438\u043A",
        pol: "Strzelba",
        sch: "\u9730\u5F39\u67AA",
        fre: "Fusil \xe0 pompe",
        bra: "Escopeta",
        schema: 199,
        hun: "s\xf6r\xe9tes puska",
        swe: "Hagelgev\xe4r"
    },
    152: {
        img: "killers_kabuto",
        eng: "Killer's Kabuto",
        rus: "\u041A\u0430\u0431\u0443\u0442\u043E \u0443\u0431\u0438\u0439\u0446\u044B",
        pol: "Kabuto zab\xf3jcy",
        sch: "\u6740\u624B\u7684\u6B66\u58EB\u4E4B\u80C4",
        fre: "Kabuto de tueur",
        bra: "Kabuto do Assassino",
        schema: 152,
        hun: "Gyilkos Kabuto",
        swe: "M\xf6rdarens Kabuto"
    },
    153: {
        img: "sergeants_drill_hat",
        eng: "Sergeant's Drill Hat",
        rus: "\u041A\u043E\u043C\u043F\u0430\u043D\u0435\u0439\u0441\u043A\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "Kapelusz instruktora musztry",
        sch: "\u58EB\u5B98\u7684\u64CD\u7EC3\u5E3D",
        fre: "Chapeau d'Entra\xeenement du Sergent",
        bra: "Chapel\xe3o do Sargento",
        schema: 183,
        hun: "\u0150rmesteri Kik\xe9pz\u0151kalap",
        swe: "Sergeantens \xd6vningshatt"
    },
    154: {
        img: "gloves_of_running_urgently",
        eng: "Gloves of Running Urgently",
        rus: "\u0413\u043E\u0440\u044F\u0449\u0438\u0435 \u0440\u0443\u043A\u0430\u0432\u0438\u0446\u044B \u0443\u0441\u043A\u043E\u0440\u0435\u043D\u0438\u044F",
        pol: "Gor\u0105ce r\u0119kawice uciekiniera",
        sch: "\u7D27\u6025\u9003\u8DD1\u624B\u5957",
        fre: "Gants de Retraite Urgente",
        bra: "As Geradoras de Rapidez Urgente",
        schema: 1184,
        hun: "A F\xfcrge Sprintel\xe9s Bokszkeszty\u0171i",
        swe: "Gorbatjovs rushande uppercut"
    },
    155: {
        img: "minigun",
        eng: "Minigun",
        rus: "\u041F\u0443\u043B\u0435\u043C\u0451\u0442",
        pol: "Minigun",
        sch: "\u8F6C\u8F6E\u673A\u67AA",
        fre: "Minigun",
        bra: "Metralhadora Girat\xf3ria",
        schema: 202,
        hun: "g\xe9p\xe1gy\xfa"
    },
    156: {
        img: "natascha",
        eng: "Natascha",
        rus: "\u041D\u0430\u0442\u0430\u0448\u0430",
        pol: "Natasza",
        sch: "\u5A1C\u5854\u838E\u8F6C\u8F6E\u673A\u67AA",
        fre: "Natascha",
        bra: "Natascha",
        schema: 41,
        hun: "Natasa"
    },
    157: {
        img: "hound_dog",
        eng: "The Hound Dog",
        rus: "\u041F\u0440\u0438\u0447\u0435\u0441\u043A\u0430 \u042D\u043B\u0432\u0438\u0441\u0430",
        pol: "Hound Dog",
        sch: "\u730E\u72AC",
        fre: "Hound Dog",
        bra: "C\xe3o de Ca\xe7a",
        schema: 145,
        hun: "A Nagykutya",
        swe: "Hound Dog"
    },
    158: {
        img: "football_helmet",
        eng: "Football Helmet",
        rus: "\u0424\u0443\u0442\u0431\u043E\u043B\u044C\u043D\u044B\u0439 \u0448\u043B\u0435\u043C",
        pol: "Kask futbolowy",
        sch: "\u6A44\u6984\u7403\u5934\u76D4",
        fre: "Casque de football",
        bra: "Capacete de Futebol Americano",
        schema: 49,
        hun: "Amerikaifoci-sisak",
        swe: "Amerikansk Fotbollshj\xe4lm"
    },
    159: {
        img: "big_steel_jaw_of_summer_fun",
        eng: "Big Steel Jaw of Summer Fun",
        rus: "\u0411\u043E\u043B\u044C\u0448\u0430\u044F \u0441\u0442\u0430\u043B\u044C\u043D\u0430\u044F \u0447\u0435\u043B\u044E\u0441\u0442\u044C \u0434\u043B\u044F \u043B\u0435\u0442\u043D\u0435\u0433\u043E \u0432\u0435\u0441\u0435\u043B\u044C\u044F",
        pol: "Wielka stalowa szcz\u0119ka letniej radochy",
        sch: "\u590F\u65E5\u72C2\u6B22\u5927\u94A2\u989A",
        fre: "M\xe2choire en Acier d'Amusement Estivale",
        bra: "Grande Mand\xedbula de A\xe7o de Divers\xe3o de Ver\xe3o",
        schema: 485,
        hun: "A Ny\xe1ri M\xf3ka Nagy Ac\xe9l \xc1llkapcsa",
        swe: "Stora sommarskoj-st\xe5lk\xe4ken"
    },
    160: {
        img: "coppers_hard_top",
        eng: "Copper's Hard Top",
        rus: "\u0428\u043B\u0435\u043C \u0448\u0435\u0440\u0438\u0444\u0430",
        pol: "Zadaszenie gliniarza",
        sch: "\u8B66\u7528\u673A\u8F66\u5934\u76D4",
        fre: "Casque de Policier",
        bra: "Capacete do Tira",
        schema: 478,
        hun: "Zserny\xe1k Kem\xe9nyfedele",
        swe: "Konstapelns knoppskydd"
    },
    161: {
        img: "nessies_nine_iron",
        eng: "Nessie's Nine Iron",
        rus: "\u0416\u0435\u043B\u0435\u0437\u043D\u0430\u044F \u0434\u0435\u0432\u044F\u0442\u043A\u0430 \u041D\u0435\u0441\u0441\u0438",
        pol: "\u017Belazna Nessie",
        sch: "\u5C3C\u65AF\u7684\u4E5D\u53F7\u94C1\u6746",
        fre: "Fer N\xb09 de Nessie",
        bra: "Ferro Nove do Nessie",
        schema: 482,
        hun: "Nessie Kilences Vasa",
        swe: "Nessies J\xe4rnnia"
    },
    162: {
        img: "postal_pummeler",
        eng: "Postal Pummeler",
        rus: "\u041F\u043E\u0447\u0442\u043E\u0432\u044B\u0439 \u0434\u0435\u0431\u043E\u0448\u0438\u0440",
        pol: "Pocztowy pogromca",
        sch: "\u660E\u4FE1\u7247\u6253\u624B",
        fre: "Le Poutreur Postal",
        bra: "A Pancada Postal",
        schema: 457,
        hun: "A Postai P\xfcf\xf6l\u0151",
        swe: "Postpucklaren"
    },
    163: {
        img: "prairie_heel_biters",
        eng: "Prairie Heel Biters",
        rus: "\u0428\u043F\u043E\u0440\u044B \u0434\u0438\u043A\u043E\u0433\u043E \u0437\u0430\u043F\u0430\u0434\u0430",
        pol: "Preriowe podgryzacze pi\u0119t",
        sch: "\u8349\u539F\u9489\u523A\u9A6C\u9774",
        fre: "\xc9perons des Plaines",
        bra: "Esporas da Pradaria",
        schema: 484,
        hun: "Bokorugr\xf3 Sarkanty\xfa",
        swe: "Pr\xe4riens h\xe4lbitare"
    },
    164: {
        img: "rogues_col_roule",
        eng: "Rogue's Col Roule",
        rus: "\u0412\u043E\u0434\u043E\u043B\u0430\u0437\u043A\u0430 \u043C\u043E\u0448\u0435\u043D\u043D\u0438\u043A\u0430",
        pol: "Gryz\u0105cy golf gangstera",
        sch: "\u76D7\u8D3C\u7684\u9AD8\u9886\u6BDB\u8863",
        fre: "Col Roul\xe9 du Voleur",
        bra: "Cou Roule do Malandro",
        schema: 483,
        hun: "Gazfick\xf3 Garb\xf3ja",
        swe: "Bedragarens Col Roule"
    },
    165: {
        img: "security_shades",
        eng: "Security Shades",
        rus: "\u041F\u043E\u043B\u0438\u0446\u0435\u0439\u0441\u043A\u0438\u0435 \u043E\u0447\u043A\u0438",
        pol: "Przyciemniane patrol\xf3wki",
        sch: "\u4FDD\u5B89\u58A8\u955C",
        fre: "Lunettes S\xe9curitaires",
        bra: "\xd3culos do Seguran\xe7a",
        schema: 479,
        hun: "S\xf6t\xe9t\xedtett Szemtakar\xf3",
        swe: "Snutens solskydd"
    },
    166: {
        img: "stately_steel_toe",
        eng: "Stately Steel Toe",
        rus: "\u0421\u0430\u043F\u043E\u0433 \u0441\u0442\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0432\u0435\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0430",
        pol: "Dostojne obuwie ochronne",
        sch: "\u9AD8\u8D35\u7684\u94C1\u76AE\u978B",
        fre: "Noble Chaussure de S\xe9curit\xe9",
        bra: "Pontap\xe9 Imponente",
        schema: 481,
        hun: "Alighanem Ac\xe9lorr\xfa",
        swe: "St\xe5tlig st\xe5lh\xe4tta"
    },
    167: {
        img: "tam_o_shanter",
        eng: "Tam O' Shanter",
        rus: "\u0422\u044D\u043C-\u043E-\u0448\u0435\u043D\u0442\u0435\u0440",
        pol: "Tam O' Shanter",
        sch: "\u82CF\u683C\u5170\u5F0F\u4FBF\u5E3D",
        fre: "B\xe9ret \xc9cossais",
        bra: "Tam O' Shanter",
        schema: 480
    },
    168: {
        img: "sandman",
        eng: "The Sandman",
        rus: "\u0414\u0440\u0451\u043C\u0430",
        pol: "Piaskun",
        sch: "\u7761\u9B54",
        fre: "Le marchand de sable",
        bra: "O Jo\xe3o Pestana",
        schema: 44,
        hun: "A Test\xe1pol\xf3",
        swe: "John Blund"
    },
    169: {
        img: "pistol",
        eng: "Pistol",
        rus: "\u041F\u0438\u0441\u0442\u043E\u043B\u0435\u0442",
        pol: "Pistolet",
        sch: "\u624B\u67AA",
        fre: "Pistolet",
        bra: "Pistola",
        schema: 23,
        hun: "pisztoly",
        ger: "Pistole"
    },
    170: {
        img: "scattergun",
        eng: "Scattergun",
        rus: "\u041E\u0431\u0440\u0435\u0437",
        pol: "Dubelt\xf3wka",
        sch: "\u730E\u67AA",
        fre: "Fusil \xe0 dispersion",
        bra: "Espingarda",
        schema: 200,
        hun: "repeszpuska",
        swe: "Hagelb\xf6ssa"
    },
    171: {
        img: "boston_basher",
        eng: "The Boston Basher",
        rus: "\u0411\u043E\u0441\u0442\u043E\u043D\u0441\u043A\u0438\u0439 \u0440\u0430\u0437\u0434\u043E\u043B\u0431\u0430\u0439",
        pol: "Bosto\u0144ski t\u0142uczek",
        sch: "\u6CE2\u58EB\u987F\u72FC\u7259\u68D2",
        fre: "Le Bastonneur Bostonien",
        bra: "O Batedor de Boston",
        schema: 325,
        hun: "A Bostoni Bever\u0151",
        swe: "Bostonbankaren"
    },
    172: {
        img: "ye_olde_baker_boy",
        eng: "Ye Olde Baker Boy",
        rus: "\u041A\u0435\u043F\u043A\u0430 \u0433\u0430\u0437\u0435\u0442\u0447\u0438\u043A\u0430",
        pol: "Czapka gazeciarza",
        sch: "\u8001\u5F0F\u62A5\u7AE5\u5E3D",
        fre: "Casquette de gavroche",
        bra: "Padeirinho, \xf4 p\xe1!",
        schema: 107,
        hun: "Rikkancs-sapka",
        swe: "\xc4ppelknyckarkeps"
    },
    173: {
        img: "ambassador",
        eng: "The Ambassador",
        rus: "\u0410\u043C\u0431\u0430\u0441\u0441\u0430\u0434\u043E\u0440",
        pol: "Ambasador",
        sch: "\u5927\u4F7F\u624B\u67AA",
        fre: "L'Ambassadeur",
        bra: "O Embaixador",
        schema: 61,
        hun: "A Nagyk\xf6vet",
        swe: "Ambassad\xf6ren"
    },
    174: {
        img: "connivers_kunai",
        eng: "Conniver's Kunai",
        rus: "\u041A\u0443\u043D\u0430\u0439 \u0437\u0430\u0433\u043E\u0432\u043E\u0440\u0449\u0438\u043A\u0430",
        pol: "Kunai kr\u0119tacza",
        sch: "\u5BC6\u8C0B\u8005\u7684\u82E6\u65E0",
        fre: "Kuna\xef du Conspirateur",
        bra: "Kunai do Conspirador",
        schema: 356,
        hun: "K\xe9tsz\xedn\u0171 Kunai",
        swe: "Konspirat\xf6rens Kunai"
    },
    175: {
        img: "knife",
        eng: "Knife",
        rus: "\u041D\u043E\u0436",
        pol: "N\xf3\u017C",
        sch: "\u5200\u5B50",
        fre: "Couteau",
        bra: "Faca",
        schema: 194,
        hun: "k\xe9s",
        swe: "Kniv"
    },
    176: {
        img: "revolver",
        eng: "Revolver",
        rus: "\u0420\u0435\u0432\u043E\u043B\u044C\u0432\u0435\u0440",
        pol: "Rewolwer",
        sch: "\u5DE6\u8F6E\u624B\u67AA",
        fre: "Revolver",
        bra: "Rev\xf3lver",
        schema: 24
    },
    177: {
        img: "private_eye",
        eng: "Private Eye",
        rus: "\u0427\u0430\u0441\u0442\u043D\u044B\u0439 \u0441\u044B\u0449\u0438\u043A",
        pol: "Bystrooki detektyw",
        sch: "\u79C1\u5BB6\u4FA6\u63A2\u5E3D",
        fre: "D\xe9tective Priv\xe9",
        bra: "Detetive Particular",
        schema: 388,
        schema2: 5724,
        hun: "Priv\xe1t Kop\xf3",
        swe: "Privatdetektiven"
    },
    178: {
        img: "fancy_fedora",
        eng: "Fancy Fedora",
        rus: "\u0424\u0435\u0442\u0440\u043E\u0432\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "Gustowna fedora",
        sch: "\u82B1\u54E8\u8F6F\u5462\u5E3D",
        fre: "Fedora \xe9l\xe9gant",
        bra: "Fedora Fabuloso",
        schema: 55,
        hun: "P\xf6pec Puhakalap",
        swe: "Fl\xe5dig fedora"
    },
    179: {
        img: "flame_thrower",
        eng: "Flame Thrower",
        rus: "\u041E\u0433\u043D\u0435\u043C\u0451\u0442",
        pol: "Miotacz ognia",
        sch: "\u706B\u7130\u55B7\u5C04\u5668",
        fre: "Lance-flammes",
        bra: "Lan\xe7a-Chamas",
        schema: 208,
        hun: "l\xe1ngsz\xf3r\xf3",
        swe: "Eldkastare"
    },
    180: {
        img: "flare_gun",
        eng: "The Flare Gun",
        rus: "\u0420\u0430\u043A\u0435\u0442\u043D\u0438\u0446\u0430",
        pol: "Pistolet sygna\u0142owy",
        sch: "\u4FE1\u53F7\u67AA",
        fre: "Pistolet de d\xe9tresse",
        bra: "Arma Sinalizadora",
        schema: 39,
        hun: "jelz\u0151pisztoly",
        swe: "Signalpistol"
    },
    181: {
        img: "backburner",
        eng: "The Backburner",
        rus: "\u0414\u043E\u0436\u0438\u0433\u0430\u0442\u0435\u043B\u044C",
        pol: "Dupalacz",
        sch: "\u5077\u88AD\u70C8\u7130\u55B7\u5C04\u5668",
        fre: "Le br\xfbleur arri\xe8re",
        bra: "O Queima-Costas",
        schema: 40,
        hun: "A Be\xe9get\u0151",
        swe: "Ryggbr\xe4nnaren"
    },
    182: {
        img: "prancers_pride",
        eng: "Prancer's Pride",
        rus: "\u0413\u043E\u0440\u0434\u043E\u0441\u0442\u044C \u0441\u0442\u0430\u0438",
        pol: "Duma renifera",
        sch: "\u9A6F\u9E7F\u6B22\u817E\u7684\u89D2",
        fre: "Fiert\xe9 de Prancer",
        bra: "Orgulho da Rena",
        schema: 318,
        hun: "Pomp\xe1s B\xfcszkes\xe9ge",
        swe: "Prancers Prydnad"
    },
    183: {
        img: "respectless_rubber_glove",
        eng: "Respectless Rubber Glove",
        rus: "\u041D\u0430\u0433\u043B\u0430\u044F \u0440\u0435\u0437\u0438\u043D\u043E\u0432\u0430\u044F \u043F\u0435\u0440\u0447\u0430\u0442\u043A\u0430",
        pol: "Niepowa\u017Cna gumowa r\u0119kawica",
        sch: "\u908B\u9062\u7684\u6A61\u80F6\u624B\u5957",
        fre: "Gant en caoutchouc ridicule",
        bra: "Luva de Borracha Pat\xe9tica",
        schema: 102,
        hun: "G\xfanyos Gumikeszty\u0171",
        swe: "Respektl\xf6s Gummihandske"
    },
    184: {
        img: "syringe_gun",
        eng: "Syringe Gun",
        rus: "\u0428\u043F\u0440\u0438\u0446\u0435\u043C\u0451\u0442",
        pol: "Pistolet strzykawkowy",
        sch: "\u6CE8\u5C04\u67AA",
        fre: "Pistolet \xe0 seringues",
        bra: "Arma de Seringas",
        schema: 204,
        hun: "olt\xf3pisztoly",
        swe: "Sprutgev\xe4r"
    },
    185: {
        img: "bonesaw",
        eng: "Bonesaw",
        rus: "\u041C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0430\u044F \u043F\u0438\u043B\u0430",
        pol: "Pi\u0142a do ko\u015Bci",
        sch: "\u9AA8\u952F",
        fre: "Scie \xe0 amputation",
        bra: "Serra de Ossos",
        schema: 198,
        hun: "csontf\u0171r\xe9sz",
        swe: "Bens\xe5g"
    },
    186: {
        img: "medi_gun",
        eng: "Medi Gun",
        rus: "\u041B\u0435\u0447\u0435\u0431\u043D\u0430\u044F \u043F\u0443\u0448\u043A\u0430",
        pol: "Medigun",
        sch: "\u533B\u7597\u67AA",
        fre: "Medigun",
        bra: "Arma M\xe9dica",
        schema: 211,
        hun: "gy\xf3gypuska",
        swe: "H\xe4lsovapen"
    },
    187: {
        img: "gentlemans_gatsby",
        eng: "Gentleman's Gatsby",
        rus: "\u0414\u0436\u0435\u043D\u0442\u043B\u044C\u043C\u0435\u043D\u0441\u043A\u0430\u044F \u043A\u0435\u043F\u043A\u0430",
        pol: "Kaszkiet d\u017Centelmena",
        sch: "\u7EC5\u58EB\u7684\u76D6\u8328\u6BD4\u5E3D",
        fre: "Gatsby du Gentleman",
        bra: "Boina do Cavalheiro",
        schema: 184,
        hun: "\xdari Gatsby",
        swe: "Gentlemannens Golfhatt"
    },
    188: {
        img: "otolaryngologists_mirror",
        eng: "Otolaryngologist's Mirror",
        rus: "\u0417\u0435\u0440\u043A\u0430\u043B\u043E \u043E\u0442\u043E\u043B\u0430\u0440\u0438\u043D\u0433\u043E\u043B\u043E\u0433\u0430",
        pol: "Lustro otolaryngologa",
        sch: "\u8033\u9F3B\u5589\u79D1\u533B\u5E08\u7684\u8BCA\u7597\u955C",
        fre: "Miroir d'oto-rhino-laryngologiste",
        bra: "Espelho do Otorrinolaringologista",
        schema: 104,
        hun: "Otolaringol\xf3gus-t\xfck\xf6r",
        swe: "Otorhinolaryngologikerns Spegel"
    },
    189: {
        img: "sniper_rifle",
        eng: "Sniper Rifle",
        rus: "\u0421\u043D\u0430\u0439\u043F\u0435\u0440\u0441\u043A\u0430\u044F \u0432\u0438\u043D\u0442\u043E\u0432\u043A\u0430",
        pol: "Karabin snajperski",
        sch: "\u72D9\u51FB\u6B65\u67AA",
        fre: "Fusil de sniper",
        bra: "Rifle de Precis\xe3o",
        schema: 201,
        hun: "mesterl\xf6v\xe9sz puska",
        swe: "Krypskyttegev\xe4r"
    },
    190: {
        img: "jarate",
        eng: "Jarate",
        rus: "\u0411\u0430\u043D\u043A\u0430\u0442\u0435",
        pol: "Sikwondo",
        sch: "\u74F6\u624B\u9053",
        fre: "Jarat\xe9",
        bra: "Jarrat\xea",
        schema: 58,
        hun: "Vizelharc"
    },
    191: {
        img: "villains_veil",
        eng: "Villain's Veil",
        rus: "\u0412\u0443\u0430\u043B\u044C \u0437\u043B\u043E\u0434\u0435\u044F",
        pol: "Chusta \u0142otrzyka",
        sch: "\u6076\u68CD\u7684\u9762\u7F69",
        fre: "Voile du Vaurien",
        bra: "V\xe9u do Vil\xe3o",
        schema: 393,
        hun: "Gazfick\xf3 Kend\u0151je",
        swe: "Skurkens Sl\xf6ja"
    },
    192: {
        img: "frontier_justice",
        eng: "Frontier Justice",
        rus: "\u0421\u0430\u043C\u043E\u0441\u0443\u0434",
        pol: "Samos\u0105d",
        sch: "\u8FB9\u5883\u5BA1\u5224",
        fre: "Que justice soit faite",
        bra: "Justi\xe7a com a Pr\xf3pria Sentinela",
        schema: 141,
        hun: "Automatiz\xe1lt bossz\xfa",
        swe: "V\xe4sternr\xe4ttvisa"
    },
    193: {
        img: "wrench",
        eng: "Wrench",
        rus: "\u0413\u0430\u0435\u0447\u043D\u044B\u0439 \u043A\u043B\u044E\u0447",
        pol: "Klucz",
        sch: "\u6273\u624B",
        fre: "Cl\xe9",
        bra: "Chave Inglesa",
        schema: 197,
        hun: "franciakulcs",
        swe: "Skiftnyckel"
    },
    194: {
        img: "mining_light",
        eng: "Mining Light",
        rus: "\u0428\u0430\u0445\u0442\u0451\u0440\u0441\u043A\u0438\u0439 \u0444\u043E\u043D\u0430\u0440\u044C",
        pol: "Lampa g\xf3rnicza",
        sch: "\u77FF\u706F",
        fre: "Lampe de mineur",
        bra: "Luz de Minera\xe7\xe3o",
        schema: 48,
        hun: "B\xe1ny\xe1szl\xe1mpa",
        swe: "Gruvlampa"
    },
    195: {
        img: "axtinguisher",
        eng: "The Axtinguisher",
        rus: "\u041E\u0433\u043D\u0435\u0442\u043E\u043F\u043E\u0440",
        pol: "Poskramiacz p\u0142omieni",
        sch: "\u706B\u7130\u6218\u65A7",
        fre: "L'Hachtincteur",
        bra: "O Queimachado",
        schema: 38,
        hun: "A Fejhasogat\xf3",
        swe: "Brandslaktaren"
    },
    196: {
        img: "razorback",
        eng: "The Razorback",
        rus: "\u0411\u0440\u043E\u043D\u0435\u043F\u0430\u043D\u0446\u0438\u0440\u044C",
        pol: "Antyklinga",
        sch: "\u7535\u51FB\u80CC\u810A\u76FE",
        fre: "Le Razorback",
        bra: "O Escudo Antinavalha",
        schema: 57,
        hun: "A Visszav\xe1g\xf3",
        ger: "Der Stammesschild",
        swe: "Razorback"
    },
    197: {
        img: "tough_guys_toque",
        eng: "Tough Guy's Toque",
        rus: "\u0428\u0430\u043F\u043A\u0430 \u043A\u0440\u0443\u0442\u043E\u0433\u043E \u043F\u0430\u0440\u043D\u044F",
        pol: "Pomponik twardziela",
        sch: "\u786C\u6C49\u7684\u65E0\u8FB9\u5E3D",
        fre: "Tuque de gros dur",
        bra: "Touca do Valent\xe3o",
        schema: 97,
        hun: "A Kem\xe9nyfi\xfa Sapija",
        swe: "Tuffingens toppluva"
    },
    198: {
        img: "frenchmans_beret",
        eng: "Frenchman's Beret",
        rus: "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0438\u0439 \u0431\u0435\u0440\u0435\u0442",
        pol: "Beret Francuza",
        sch: "\u6CD5\u5F0F\u8D1D\u96F7\u5E3D",
        fre: "B\xe9ret du Fran\xe7ais",
        bra: "Boina do Franc\xeas",
        schema: 180,
        hun: "Francia Sv\xe1jcisapka",
        swe: "Fransmannens Basker"
    },
    199: {
        img: "kritzkrieg",
        eng: "The Kritzkrieg",
        rus: "\u041A\u0440\u0438\u0446\u043A\u0440\u0438\u0433",
        pol: "Kritzkrieg",
        sch: "\u95EA\u7535\u6218\u533B\u7597\u67AA",
        fre: "Le Kritzkrieg",
        bra: "A Kritzkrieg",
        schema: 35,
        hun: "A Kritzkrieg",
        ger: "Die Kritzkrieg",
        swe: "Kritzkrieg"
    },
    200: {
        img: "holy_mackerel",
        eng: "The Holy Mackerel",
        rus: "\u041F\u043E\u0434\u0434\u0430\u0439 \u043B\u0435\u0449\u0430",
        pol: "\u015Awi\u0119ta makrela",
        sch: "\u5C1A\u65B9\u5B9D\u9CAD",
        fre: "Le maquereau sacr\xe9",
        bra: "O Santo Carapau",
        schema: 221,
        hun: "A Magass\xe1gos Makr\xe9la",
        swe: "Fina fisken"
    },
    201: {
        img: "machina",
        eng: "The Machina",
        rus: "\u041C\u0430\u0445\u0438\u043D\u0430",
        pol: "Machina",
        sch: "\u9B3C\u68B0\u795E\u72D9",
        fre: "La Machina",
        bra: "A Machina",
        schema: 526,
        hun: "A Machina",
        ger: "Die Machina",
        swe: "Machina"
    },
    202: {
        img: "half_zatoichi",
        eng: "The Half-Zatoichi",
        rus: "\u041F\u043E\u043B\u0443\u0434\u0437\u0430\u0442\u043E\u0438\u0442\u0438",
        pol: "Prawie Zatoichi",
        sch: "\u5EA7\u5934\u5E02\u4E4B\u5200",
        fre: "Demi-Zatoichi",
        bra: "Quase-Zatoichi",
        schema: 357,
        hun: "F\xe9l-Zatoichi",
        swe: "Halv-Zatoichi"
    },
    203: {
        img: "fists",
        eng: "Fists",
        rus: "\u041A\u0443\u043B\u0430\u043A\u0438",
        pol: "Pi\u0119\u015Bci",
        sch: "\u62F3\u5934",
        fre: "Poings",
        bra: "Punhos",
        schema: 195,
        hun: "\xf6kl\xf6k",
        swe: "Knytn\xe4var"
    },
    204: {
        img: "grimm_hatte",
        eng: "Grimm Hatte",
        rus: "\u041C\u0440\u0430\u0447\u043D\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "S\u0119pny k\u0142obuk",
        sch: "\u9ED1\u6B7B\u75C5\u533B\u5E3D",
        fre: "Sinistre Haine",
        bra: "Schapel dos Grimm",
        schema: 383,
        hun: "Zord Sapoka",
        swe: "Grymm Hatt"
    },
    205: {
        img: "ubersaw",
        eng: "The Ubersaw",
        rus: "\u0423\u0431\u0435\u0440-\u043F\u0438\u043B\u0430",
        pol: "\xdcberpi\u0142a",
        sch: "\u8FC7\u8F7D\u5145\u80FD\u952F",
        fre: "L'\xdcberscie",
        bra: "A \xdcberserra",
        schema: 37,
        hun: "Az Agyonf\u0171r\xe9sz",
        swe: "\xdcbers\xe5gen"
    },
    206: {
        img: "soda_popper",
        eng: "The Soda Popper",
        rus: "\u0413\u0430\u0437\u0438\u0440\u043E\u0432\u0449\u0438\u043A",
        pol: "Buzownik",
        sch: "\u82CF\u6253\u70AE\u624B",
        fre: "Le Rafra\xeechisseur",
        bra: "A Refrispingarda",
        schema: 448,
        hun: "Az \xdcd\xedt\u0151 \xdcr\xedt\u0151",
        swe: "L\xe4skpopparen"
    },
    207: {
        img: "family_business",
        eng: "The Family Business",
        rus: "\u0421\u0435\u043C\u0435\u0439\u043D\u043E\u0435 \u0434\u0435\u043B\u043E",
        pol: "Rodzinny interes",
        sch: "\u5BB6\u65CF\u8FD0\u8425\u67AA",
        fre: "L'Entreprise Familiale",
        bra: "Os Neg\xf3cios de Fam\xedlia",
        schema: 425,
        hun: "A Csal\xe1di V\xe1llalkoz\xe1s",
        swe: "Familjens Ensak"
    },
    208: {
        img: "reserve_shooter",
        eng: "The Reserve Shooter",
        rus: "\u041E\u0444\u0438\u0446\u0435\u0440 \u0437\u0430\u043F\u0430\u0441\u0430",
        pol: "Rezerwista",
        sch: "\u9884\u5907\u5F79\u5C04\u624B",
        fre: "Le Tireur R\xe9serviste",
        bra: "O Atirador Reserva",
        schema: 415,
        hun: "A Tartal\xe9kos S\xf6r\xe9tes",
        swe: "Reservskjutaren"
    },
    209: {
        img: "atomizer",
        eng: "The Atomizer",
        rus: "\u0420\u0430\u0441\u0449\u0435\u043F\u0438\u0442\u0435\u043B\u044C",
        pol: "Atomizer",
        sch: "\u539F\u5B50\u80FD\u7403\u68D2",
        fre: "L'Atomiseur",
        bra: "O Atomizador",
        schema: 450,
        hun: "Az Atomiz\xe1l\xf3",
        swe: "Atomiseraren"
    },
    210: {
        img: "hard_counter",
        eng: "Hard Counter",
        rus: "\u0416\u0451\u0441\u0442\u043A\u0438\u0439 \u043E\u0442\u0440\u0430\u0436\u0430\u0442\u0435\u043B\u044C",
        pol: "Parasolka ochronna",
        sch: "\u575A\u56FA\u7684\u96E8\u4F1E\u5E3D\u5B50",
        fre: "Grands moyens",
        bra: "Para-chuva",
        schema: 254,
        hun: "Er\u0151s Ellen\xe9rv",
        swe: "H\xe5rd Kontring"
    },
    211: {
        img: "western_wear",
        eng: "Western Wear",
        rus: "\u0417\u0430\u043F\u0430\u0434\u043D\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "Zachodni styl",
        sch: "\u897F\u90E8\u5706\u9876\u793C\u5E3D",
        fre: "Usure de l'Ouest",
        bra: "Veste do Oeste",
        schema: 379,
        hun: "Vadnyugati Viselet",
        swe: "Sheriffens Stolthet"
    },
    212: {
        img: "festive_scattergun",
        eng: "Festive Scattergun",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u043E\u0431\u0440\u0435\u0437",
        pol: "\u015Awi\u0105teczna dubelt\xf3wka",
        sch: "\u8282\u65E5\u730E\u67AA",
        fre: "Fusil \xe0 dispersion festif",
        bra: "Espingarda Festiva",
        schema: 669,
        hun: "\xdcnnepi Repeszpuska",
        swe: "Festlig hagelb\xf6ssa"
    },
    213: {
        img: "festive_bat",
        eng: "Festive Bat",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u0430\u044F \u0431\u0438\u0442\u0430",
        pol: "\u015Awi\u0105teczny kij",
        sch: "\u8282\u65E5\u7403\u68D2",
        fre: "Batte festive",
        bra: "Taco Festivo",
        schema: 660,
        hun: "\xdcnnepi \xdct\u0151",
        swe: "Festligt slagtr\xe4"
    },
    214: {
        img: "festive_rocket_launcher",
        eng: "Festive Rocket Launcher",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u0440\u0430\u043A\u0435\u0442\u043E\u043C\u0451\u0442",
        pol: "\u015Awi\u0105teczna wyrzutnia rakiet",
        sch: "\u8282\u65E5\u706B\u7BAD\u53D1\u5C04\u5668",
        fre: "Lance-roquettes festif",
        bra: "Lan\xe7a-Foguetes Festivo",
        schema: 658,
        hun: "\xdcnnepi Rak\xe9tavet\u0151",
        swe: "Festligt raketgev\xe4r"
    },
    215: {
        img: "festive_flame_thrower",
        eng: "Festive Flame Thrower",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u043E\u0433\u043D\u0435\u043C\u0451\u0442",
        pol: "\u015Awi\u0105teczny miotacz ognia",
        sch: "\u8282\u65E5\u706B\u7130\u55B7\u5C04\u5668",
        fre: "Lance-flammes festif",
        bra: "Lan\xe7a-Chamas Festivo",
        schema: 659,
        hun: "\xdcnnepi L\xe1ngsz\xf3r\xf3",
        swe: "Festlig eldkastare"
    },
    216: {
        img: "festive_stickybomb_launcher",
        eng: "Festive Stickybomb Launcher",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u043B\u0438\u043F\u0443\u0447\u043A\u043E\u043C\u0451\u0442",
        pol: "\u015Awi\u0105teczna wyrzutnia bomb samoprzylepnych",
        sch: "\u8282\u65E5\u9ECF\u6027\u70B8\u5F39\u53D1\u5C04\u5668",
        fre: "Lanceur de bombes collantes festif",
        bra: "Lan\xe7a-Stickybombs Festivo",
        schema: 661,
        hun: "\xdcnnepi Tapad\xf3bomba-vet\u0151",
        swe: "Festlig klisterbombskastare"
    },
    217: {
        img: "festive_minigun",
        eng: "Festive Minigun",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u043F\u0443\u043B\u0435\u043C\u0451\u0442",
        pol: "\u015Awi\u0105teczny minigun",
        sch: "\u8282\u65E5\u8F6C\u8F6E\u673A\u67AA",
        fre: "Minigun festif",
        bra: "Metralhadora Girat\xf3ria Festiva",
        schema: 654,
        hun: "\xdcnnepi G\xe9p\xe1gy\xfa",
        swe: "Festlig minigun"
    },
    218: {
        img: "festive_wrench",
        eng: "Festive Wrench",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u0433\u0430\u0435\u0447\u043D\u044B\u0439 \u043A\u043B\u044E\u0447",
        pol: "\u015Awi\u0105teczny klucz",
        sch: "\u8282\u65E5\u6273\u624B",
        fre: "Cl\xe9 \xe0 molette festive",
        bra: "Chave Inglesa Festiva",
        schema: 662,
        hun: "\xdcnnepi Franciakulcs",
        swe: "Festlig skiftnyckel"
    },
    219: {
        img: "festive_medi_gun",
        eng: "Festive Medi Gun",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u0430\u044F \u043B\u0435\u0447\u0435\u0431\u043D\u0430\u044F \u043F\u0443\u0448\u043A\u0430",
        pol: "\u015Awi\u0105teczny medigun",
        sch: "\u8282\u65E5\u533B\u7597\u67AA",
        fre: "Medigun festif",
        bra: "Arma M\xe9dica Festiva",
        schema: 663,
        hun: "\xdcnnepi Gy\xf3gypuska",
        swe: "Festligt h\xe4lsovapen"
    },
    220: {
        img: "festive_sniper_rifle",
        eng: "Festive Sniper Rifle",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u0430\u044F \u0441\u043D\u0430\u0439\u043F\u0435\u0440\u0441\u043A\u0430\u044F \u0432\u0438\u043D\u0442\u043E\u0432\u043A\u0430",
        pol: "\u015Awi\u0105teczny karabin snajperski",
        sch: "\u8282\u65E5\u72D9\u51FB\u6B65\u67AA",
        fre: "Fusil de sniper festif",
        bra: "Rifle de Precis\xe3o Festivo",
        schema: 664,
        hun: "\xdcnnepi Mesterl\xf6v\xe9sz Puska",
        swe: "Festligt krypskyttegev\xe4r"
    },
    221: {
        img: "festive_knife",
        eng: "Festive Knife",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u043D\u043E\u0436",
        pol: "\u015Awi\u0105teczny n\xf3\u017C",
        sch: "\u8282\u65E5\u5200\u5B50",
        fre: "Couteau festif",
        bra: "Faca Festiva",
        schema: 665,
        hun: "\xdcnnepi K\xe9s",
        swe: "Festlig kniv"
    },
    222: {
        img: "wrap_assassin",
        eng: "The Wrap Assassin",
        rus: "\u041E\u0431\u0451\u0440\u0442\u043E\u0447\u043D\u044B\u0439 \u0443\u0431\u0438\u0439\u0446\u0430",
        pol: "Pakuj\u0105cy zab\xf3jca",
        sch: "\u5305\u88C5\u7EB8\u6740\u624B",
        fre: "L'assassin emball\xe9",
        bra: "O Assassino do Embrulho",
        schema: 648,
        hun: "A Csomagol\xf3s Gyilkos",
        swe: "Omslagsm\xf6rdaren"
    },
    223: {
        img: "holiday_punch",
        eng: "The Holiday Punch",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u0443\u0434\u0430\u0440",
        pol: "\u015Awi\u0105teczny wigor",
        sch: "\u6B22\u4E50\u62F3\u5957",
        fre: "Le Punch des Vacances",
        bra: "O Soco Festivo",
        schema: 656,
        hun: "Az \xdcnnepi Fel\xfct\xe9s",
        swe: "Julklappen"
    },
    224: {
        img: "spy_cicle",
        eng: "The Spy-cicle",
        rus: "\u0421\u043E\u0441\u0443\u043B\u044C\u043A\u0430",
        pol: "Zamro\u017Cony agent",
        sch: "\u795E\u5947\u7684\u51B0\u9525",
        fre: "La Spy-lactite",
        bra: "A Spy-lactite",
        schema: 649,
        hun: "A K\xe9m-csap",
        swe: "Smygtappen"
    },
    225: {
        img: "big_elfin_deal",
        eng: "Big Elfin Deal",
        rus: "\u0422\u043E\u0436\u0435 \u043C\u043D\u0435, \u044D\u043B\u044C\u0444",
        pol: "Wyelfiona mycka",
        sch: "\u6B22\u4E50\u5C0F\u7CBE\u7075\u7684\u5E3D\u5B50",
        fre: "Une Affaire elftraordinaire",
        bra: "Baita Duen-de Uma Barganha",
        schema: 652,
        hun: "A Mocskossz\xe1j\xfa Man\xf3",
        swe: "Tomteloftet"
    },
    226: {
        img: "bootie_time",
        eng: "Bootie Time",
        rus: "\u042D\u043B\u044C\u0444\u0438\u0439\u0441\u043A\u0438\u0435 \u0431\u043E\u0442\u0438\u043D\u043E\u0447\u043A\u0438",
        pol: "Seksowne trzewiczki",
        sch: "\u6B22\u4E50\u5C0F\u7CBE\u7075\u7684\u978B\u5B50",
        fre: "Le Temps des Bottines",
        bra: "As Botinhas da Hora",
        schema: 653,
        hun: "A Csilingel\u0151 Csizma",
        swe: "St\xf6veldags"
    },
    227: {
        img: "all_father",
        eng: "All-Father",
        rus: "\u0412\u0441\u0435\u043E\u0442\u0435\u0446",
        pol: "Wszechojciec",
        sch: "\u4F17\u795E\u4E4B\u7236\u7684\u80E1\u5B50",
        fre: "Le P\xe8re de Tout",
        bra: "Pai de Todos",
        schema: 647,
        hun: "A Mindenek Atyja",
        swe: "Allfadern"
    },
    228: {
        img: "ornament_armament",
        eng: "Ornament Armament",
        rus: "\u0414\u0435\u043A\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435 \u0432\u043E\u043E\u0440\u0443\u0436\u0435\u043D\u0438\u0435",
        pol: "Ozdobny or\u0119\u017C",
        sch: "\u519B\u7528\u88C5\u9970\u70B8\u5F39",
        fre: "L'Armement Ornemental",
        bra: "O Armamento de Ornamento",
        schema: 641,
        hun: "Az El\u0151lg\xf6mb\xf6l\u0151s",
        swe: "Dekoreringsbev\xe4pningen"
    },
    229: {
        img: "kringle_collection",
        eng: "Kringle Collection",
        rus: "\u0422\u0443\u043B\u0443\u043F \u043E\u0442 \u041A\u0440\u0438\u043D\u0433\u043B\u0430",
        pol: "Kolekcja Kringle'a",
        sch: "\u5723\u8BDE\u8001\u4EBA\u7684\u73CD\u85CF\u5916\u5957",
        fre: "La Collection de Kringle",
        bra: "A Cole\xe7\xe3o do Noel",
        schema: 650,
        hun: "A T\xe9la-P\xf3tl\xf3",
        swe: "Tomtekollektionen"
    },
    230: {
        img: "head_warmer",
        eng: "Head Warmer",
        rus: "\u0413\u043E\u043B\u043E\u0432\u043E\u0433\u0440\u0435\u0439\u043A\u0430",
        pol: "Ocieplacz g\u0142owy",
        sch: "\u51AC\u5B63\u96EA\u7ED2\u5E3D",
        fre: "La T\xeate Brul\xe9e",
        bra: "O Aquecedor de Cabe\xe7a",
        schema: 644,
        hun: "A Fejmelenget\u0151",
        swe: "Huvudv\xe4rmaren"
    },
    231: {
        img: "jingle_belt",
        eng: "Jingle Belt",
        rus: "\u0411\u0443\u0431\u0435\u043D\u0446\u043E\u0432\u044B\u0439 \u043F\u043E\u044F\u0441",
        pol: "Ob\u0142\u0119dnie dzwoni\u0105cy pas",
        sch: "\u96EA\u6A47\u54CD\u94C3",
        fre: "La ceinture de clochettes",
        bra: "Toca o Cinto Pequenino",
        schema: 651,
        hun: "A L\xe1ngcseng\u0151",
        swe: "Bj\xe4llerb\xe4ltet"
    },
    232: {
        img: "sandvich_safe",
        eng: "Sandvich Safe",
        rus: "\u0421\u0435\u0439\u0444 \u0434\u043B\u044F \u0431\u0443\u0442\u0435\u0440\u0431\u0440\u043E\u0434\u0430",
        pol: "Kanapkowy sejf",
        sch: "\u5348\u9910\u76D2",
        fre: "Le Coffre \xe0 Sandvich",
        bra: "O Cofre de Sandviches",
        schema: 643,
        hun: "A Szendvics-sz\xe9f",
        swe: "Sm\xf6rgossk\xe5pet"
    },
    233: {
        img: "stocking_stuffer",
        eng: "Stocking Stuffer",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u043D\u043E\u0441\u043E\u043A",
        pol: "Wypchana skarpeta",
        sch: "\u9C9C\u7EA2\u7684\u5723\u8BDE\u889C\u5B50",
        fre: "La Chaussette de No\xebl",
        bra: "A Meia de Natal",
        schema: 670,
        hun: "A Cuccos Zokni",
        swe: "Julsockan"
    },
    234: {
        img: "outback_intellectual",
        eng: "Outback Intellectual",
        rus: "\u0418\u043D\u0442\u0435\u043B\u043B\u0438\u0433\u0435\u043D\u0442 \u0438\u0437 \u043F\u0443\u0441\u0442\u044B\u043D\u0438",
        pol: "Intelektualista z pustkowi",
        sch: "\u8352\u539F\u6587\u5B66\u5BB6",
        fre: "L'intellectuel de l'arri\xe8re-pays",
        bra: "O Intelectual do Interior",
        schema: 645,
        hun: "A Vadon \xc9rtelmis\xe9ge",
        swe: "Australiska Akademikern"
    },
    235: {
        img: "brown_bomber",
        eng: "Brown Bomber",
        rus: "\u041A\u043E\u0440\u0438\u0447\u043D\u0435\u0432\u044B\u0439 \u0431\u043E\u043C\u0431\u0438\u0441\u0442",
        pol: "Br\u0105zowy bombowiec",
        sch: "\u68D5\u8272\u96EA\u5730\u5E3D",
        fre: "La Bombe Brune",
        bra: "O Bombardeiro Marrom",
        schema: 671,
        hun: "A Barna Bomb\xe1z\xf3",
        swe: "Den Bruna Bombaren"
    },
    236: {
        img: "bazaar_bargain",
        eng: "The Bazaar Bargain",
        rus: "\u0411\u0430\u0437\u0430\u0440\u043D\u0430\u044F \u0431\u0435\u0437\u0434\u0435\u043B\u0443\u0448\u043A\u0430",
        pol: "Dalekosi\u0119\u017Cny d\u017Cezail",
        sch: "\u5E02\u573A\u8FD8\u4EF7\u8005",
        fre: "La P\xe9toire du bazar",
        bra: "A Barganha do Bazar",
        schema: 402,
        hun: "A Baz\xe1ri Bizsu",
        swe: "Basarfyndet"
    },
    237: {
        img: "big_earner",
        eng: "The Big Earner",
        rus: "\u0413\u043B\u0430\u0432\u043D\u044B\u0439 \u0434\u0435\u043B\u0435\u0446",
        pol: "Gruba ryba",
        sch: "\u66B4\u5229\u6740\u624B",
        fre: "Le Grand Gagnant",
        bra: "O Grande Ganhador",
        schema: 461,
        hun: "A Nagy Hal",
        swe: "Den Stora L\xf6ntagaren"
    },
    238: {
        img: "blutsauger",
        eng: "The Blutsauger",
        rus: "\u041A\u0440\u043E\u0432\u043E\u043F\u0438\u0439\u0446\u0430",
        pol: "Blutsauger",
        sch: "\u5438\u8840\u9B3C\u9488\u7B52\u67AA",
        fre: "Le Blutsauger",
        bra: "A Blutsauger",
        schema: 36,
        hun: "A Blutsauger",
        ger: "Der Blutsauger",
        swe: "Blutsauger"
    },
    239: {
        img: "liberty_launcher",
        eng: "The Liberty Launcher",
        rus: "\u041E\u0441\u0432\u043E\u0431\u043E\u0434\u0438\u0442\u0435\u043B\u044C",
        pol: "Wyrzutnia wolno\u015Bci",
        sch: "\u81EA\u7531\u63A8\u8FDB\u70AE",
        fre: "Le Lib\xe9rateur",
        bra: "O Lan\xe7ador da Liberdade",
        schema: 414,
        hun: "A Szabads\xe1gvet\u0151",
        swe: "Frihetsgev\xe4ret"
    },
    240: {
        img: "cosa_nostra_cap",
        eng: "Cosa Nostra Cap",
        rus: "\u0428\u043B\u044F\u043F\u0430 \u043C\u0430\u0444\u0438\u043E\u0437\u0438",
        pol: "Kapelusz Cosa Nostry",
        sch: "\u6211\u4EEC\u7684\u4E8B\u4E1A\u4E4B\u5E3D",
        fre: "Chapeau de la Cosa Nostra",
        bra: "Chap\xe9u da Cosa Nostra",
        schema: 459,
        hun: "Cosa Nostra Kalap",
        swe: "Cosa Nostra-hatt"
    },
    241: {
        img: "dead_ringer",
        eng: "The Dead Ringer",
        rus: "\u0417\u0432\u043E\u043D \u0441\u043C\u0435\u0440\u0442\u0438",
        pol: "Dzwon zmar\u0142ego",
        sch: "\u6B7B\u4EA1\u4E4B\u94C3",
        fre: "La Dead Ringer",
        bra: "A C\xf3pia Mortal",
        schema: 59,
        hun: "A Hal\xe1li Ketyeg\u0151",
        swe: "D\xf6dsringaren"
    },
    242: {
        img: "submachine_gun",
        eng: "SMG",
        rus: "\u041F\u0438\u0441\u0442\u043E\u043B\u0435\u0442-\u043F\u0443\u043B\u0435\u043C\u0451\u0442",
        pol: "PM",
        sch: "SMG",
        fre: "Mitraillette",
        bra: "Submetralhadora",
        schema: 16,
        hun: "g\xe9ppisztoly",
        swe: "Kpist"
    },
    243: {
        img: "quick_fix",
        eng: "The Quick-Fix",
        rus: "\u0411\u044B\u0441\u0442\u0440\u043E\u043F\u0440\u0430\u0432",
        pol: "Quick-Fix",
        sch: "\u5FEB\u901F\u533B\u7597\u67AA",
        fre: "Le Secou'rapide",
        bra: "A Quebra-Galho",
        schema: 411,
        hun: "A Gyorsbeavatkoz\xe1s",
        swe: "Snabbfixaren"
    },
    244: {
        img: "killing_gloves_of_boxing",
        eng: "The Killing Gloves of Boxing",
        rus: "\u041A\u0443\u043B\u0430\u043A\u0438 \u0433\u0440\u043E\u0437\u043D\u043E\u0433\u043E \u0431\u043E\u043A\u0441\u0451\u0440\u0430",
        pol: "Krytyczne grzmoty bokserskie",
        sch: "\u6740\u622E\u62F3\u51FB\u624B\u5957",
        fre: "Les Kamarades Gants de Boxe",
        bra: "Os Kr\xedticos Garantidos no Boxe",
        schema: 43,
        hun: "A Kimondottan Gal\xe1d Bokszkeszty\u0171k",
        swe: "Kalinins Grymma Boxningshandskar"
    },
    245: {
        img: "flamboyant_flamenco",
        eng: "The Flamboyant Flamenco",
        rus: "\u042F\u0440\u043A\u043E\u0435 \u0444\u043B\u0430\u043C\u0435\u043D\u043A\u043E",
        pol: "Fatalne flamenco",
        sch: "\u534E\u4E3D\u7684\u5F17\u62C9\u95E8\u6208\u5E3D",
        fre: "Le Flamenco Flamboyant",
        bra: "O Flamenco Extravagante",
        schema: 627,
        hun: "A Felv\xe1g\xf3s Flamenco",
        swe: "Den Flambojanta Flamencon"
    },
    246: {
        img: "reggaelator",
        eng: "Reggaelator",
        rus: "\u0420\u044D\u0433\u0433\u0438\u043B\u044F\u0442\u043E\u0440",
        pol: "Reggaelator",
        sch: "\u96F7\u9B3C\u53D1\u578B",
        fre: "Reggaelateur",
        bra: "Reggaeador",
        schema: 390,
        hun: "Reggael\xe1l\xf3"
    },
    247: {
        img: "overdose",
        eng: "The Overdose",
        rus: "\u041F\u0435\u0440\u0435\u0434\u043E\u0437",
        pol: "Ko\u0144ska dawka",
        sch: "\u8FC7\u8F7D\u6CE8\u5C04\u67AA",
        fre: "L'Overdose",
        bra: "A Overdose",
        schema: 412,
        hun: "A T\xfaladagol\xf3",
        swe: "\xd6verdoseringen"
    },
    248: {
        img: "a_manns_mint",
        eng: "A Mann's Mint",
        rus: "\u0417\u0435\u043B\u0435\u043D\u044C \u041C\u0430\u043D\u043D\u0430",
        pol: "Mi\u0119ta Manna",
        sch: "\u66FC\u6C0F\u8584\u8377\u7EFF",
        fre: "Une menthe Mann",
        bra: "Menta de Macho",
        schema: 5076,
        hun: "Mann Ment\xe1ja",
        swe: "En Manns Mint"
    },
    249: {
        img: "after_eight",
        eng: "After Eight",
        rus: "\u041F\u043E\u043B\u0443\u043D\u043E\u0447\u043D\u044B\u0439 \u0448\u043E\u043A\u043E\u043B\u0430\u0434",
        pol: "Po \xf3smej",
        sch: "\u665A\u516B\u70B9\u591C\u8272",
        fre: "After Eight",
        bra: "Depois das Oito",
        schema: 5077,
        swe: "Efter \xe5tta"
    },
    250: {
        img: "salty_dog",
        eng: "The Salty Dog",
        rus: "\u041C\u043E\u0440\u0441\u043A\u043E\u0439 \u0432\u043E\u043B\u043A",
        pol: "Wilk morski",
        sch: "\u6C34\u624B\u8001\u5175\u7684\u5E3D\u5B50",
        fre: "Le Loup de Mer",
        bra: "O Lobo do Mar",
        schema: 611,
        hun: "A V\xe9n Tenger\xe9sz",
        swe: "Erfarna Seglaren"
    },
    251: {
        img: "widowmaker",
        eng: "The Widowmaker",
        rus: "\u041E\u0432\u0434\u043E\u0432\u0438\u0442\u0435\u043B\u044C",
        pol: "Likwidator",
        sch: "\u5BE1\u5987\u5236\u9020\u8005",
        fre: "Le Faiseur de Veuves",
        bra: "A Viuvadora",
        schema: 527,
        schema2: 5757,
        hun: "A Widowmaker",
        swe: "\xc4nkmakaren"
    },
    252: {
        img: "mantreads",
        eng: "The Mantreads",
        rus: "\u041B\u044E\u0434\u043E\u0434\u0430\u0432\u044B",
        pol: "Mia\u017Cd\u017Cyciele",
        sch: "\u8E0F\u6B65\u9774",
        fre: "Les Bottes de Combat",
        bra: "Os Coturnos de Macho",
        schema: 444,
        hun: "Az Arctapos\xf3",
        swe: "Manst\xf6vlarna"
    },
    253: {
        img: "sapper",
        eng: "Sapper",
        rus: "\u0416\u0443\u0447\u043E\u043A",
        pol: "Saper",
        sch: "\u7535\u5B50\u5DE5\u5175",
        fre: "Saboteur",
        bra: "Sabotador",
        schema: 736,
        hun: "Mentes\xedt\u0151"
    },
    254: {
        img: "bat",
        eng: "Bat",
        rus: "\u0411\u0438\u0442\u0430",
        pol: "Kij",
        sch: "\u7403\u68D2",
        fre: "Batte",
        bra: "Taco",
        schema: 190,
        hun: "\xfct\u0151",
        swe: "Slagtr\xe4"
    },
    255: {
        img: "diamondback",
        eng: "The Diamondback",
        rus: "\u0410\u043B\u043C\u0430\u0437\u043D\u044B\u0439 \u0437\u043C\u0435\u0439",
        pol: "Grzechotnik",
        sch: "\u83F1\u80CC\u54CD\u5C3E\u86C7",
        fre: "Le Diamondback",
        bra: "O Diamante Bruto",
        schema: 525,
        hun: "A Diamondback",
        ger: "Der Diamondback",
        swe: "Diamondback"
    },
    256: {
        img: "strange_part_gib_kills",
        eng: "Strange Part: Gib Kills",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0440\u0430\u0437\u043E\u0440\u0432\u0430\u043D\u043D\u044B\u0435 \u0432\u0440\u0430\u0433\u0438",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Rozcz\u0142onkowani wrogowie",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u70B8\u788E\u654C\u4EBA\u6570",
        fre: "Pi\xe8ce \xe9trange : Mises en pi\xe8ce",
        bra: "Pe\xe7a Estranha: Explos\xf5es Fatais",
        schema: 6013,
        hun: "Fura Alkatr\xe9sz: Cafatokra robbant\xe1sok",
        swe: "M\xe4rklig del: Fiender spr\xe4ngda i sm\xe5bitar"
    },
    257: {
        img: "strange_part_airborne_enemies_killed",
        eng: "Strange Part: Airborne Enemies Killed",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0439\u0441\u0442\u0432\u0430 \u0432 \u0432\u043E\u0437\u0434\u0443\u0445\u0435",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Wrogowie zabici w powietrzu",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u7A7A\u4E2D\u654C\u4EBA\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Ennemis dans les airs tu\xe9s",
        bra: "Pe\xe7a Estranha: V\xedtimas no Ar",
        schema: 6012,
        hun: "Fura Alkatr\xe9sz: Meg\xf6lt rep\xfcl\u0151 ellenfelek",
        swe: "M\xe4rklig del: Luftburna fiender d\xf6dade"
    },
    258: {
        img: "strange_part_heavies_killed",
        eng: "Strange Part: Heavies Killed",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0442\u044B\u0435 \u043F\u0443\u043B\u0435\u043C\u0451\u0442\u0447\u0438\u043A\u0438",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zabici Grubi",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u673A\u67AA\u624B\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Heavies tu\xe9s",
        bra: "Pe\xe7a Estranha: Heavies Mortos",
        schema: 6000,
        hun: "Fura Alkatr\xe9sz: Meg\xf6lt G\xe9p\xe1gy\xfasok",
        swe: "M\xe4rklig del: Heavies d\xf6dade"
    },
    259: {
        img: "crocodile_smile",
        eng: "The Crocodile Smile",
        rus: "\u041A\u0440\u043E\u043A\u043E\u0434\u0438\u043B\u044C\u044F \u0443\u043B\u044B\u0431\u043A\u0430",
        pol: "Krokodyli u\u015Bmiech",
        sch: "\u9CC4\u9C7C\u7259\u9879\u94FE",
        fre: "Le Sourire du Crocodile",
        bra: "As L\xe1grimas de Crocodilo",
        schema: 618,
        hun: "A Krokodilmosoly",
        swe: "Krokodilsmilet"
    },
    260: {
        img: "large_luchadore",
        eng: "Large Luchadore",
        rus: "\u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043B\u0443\u0447\u0430\u0434\u043E\u0440",
        pol: "Ogromny luchador",
        sch: "\u6454\u89D2\u624B\u9762\u5177",
        fre: "Masque de Luchador",
        bra: "Grande Luchador",
        schema: 380,
        hun: "A Nagy Luchador",
        swe: "Stor skr\xe5puk"
    },
    261: {
        img: "bottle",
        eng: "Bottle",
        rus: "\u0411\u0443\u0442\u044B\u043B\u043A\u0430",
        pol: "Butelka",
        sch: "\u74F6\u5B50",
        fre: "Bouteille",
        bra: "Garrafa",
        schema: 191,
        hun: "palack",
        swe: "Flaska"
    },
    262: {
        img: "strange_part_buildings_destroyed",
        eng: "Strange Part: Buildings Destroyed",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u043D\u0438\u0447\u0442\u043E\u0436\u0435\u043D\u043D\u044B\u0435 \u043F\u043E\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zniszczone konstrukcje",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u5EFA\u7B51\u6467\u6BC1\u6570",
        fre: "Pi\xe8ce \xe9trange : B\xe2timents d\xe9truits",
        bra: "Pe\xe7a Estranha: Constru\xe7\xf5es Destru\xeddas",
        schema: 6009,
        hun: "Fura Alkatr\xe9sz: Lerombolt \xe9p\xedtm\xe9nyek",
        swe: "M\xe4rklig del: Byggnader f\xf6rst\xf6rda"
    },
    263: {
        img: "strange_part_projectiles_reflected",
        eng: "Strange Part: Projectiles Reflected",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u043E\u0442\u0440\u0430\u0436\u0451\u043D\u043D\u044B\u0435 \u0441\u043D\u0430\u0440\u044F\u0434\u044B",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Odbite pociski",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u53CD\u5F39\u6570",
        fre: "Pi\xe8ce \xe9trange : Projectiles renvoy\xe9s",
        bra: "Pe\xe7a Estranha: Proj\xe9teis Refletidos",
        schema: 6010,
        hun: "Fura Alkatr\xe9sz: Visszaf\xfajt l\xf6ved\xe9kek",
        swe: "M\xe4rklig del: Projektiler reflekterade"
    },
    264: {
        img: "strange_part_headshot_kills",
        eng: "Strange Part: Headshot Kills",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0439\u0441\u0442\u0432\u0430 \u0432 \u0433\u043E\u043B\u043E\u0432\u0443",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zabici strza\u0142ami w g\u0142ow\u0119",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u7206\u5934\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Frags par tir en pleine t\xeate",
        bra: "Pe\xe7a Estranha: Tiros Fatais na Cabe\xe7a",
        schema: 6011,
        hun: "Fura Alkatr\xe9sz: Fejl\xf6v\xe9ses \xf6l\xe9sek",
        swe: "M\xe4rklig del: D\xf6dliga huvudskott"
    },
    265: {
        img: "outdoorsman",
        eng: "The Outdoorsman",
        rus: "\u0414\u0440\u043E\u0432\u043E\u0441\u0435\u043A",
        pol: "Odludek",
        sch: "\u6237\u5916\u731B\u7537",
        fre: "L'homme d'ext\xe9rieur",
        bra: "O Lenhador",
        schema: 603,
        hun: "Az Erd\u0151ker\xfcl\u0151",
        swe: "Friluftsm\xe4nniskan"
    },
    266: {
        img: "ol_geezer",
        eng: "Ol' Geezer",
        rus: "\u0421\u0442\u0430\u0440\u0438\u043A\u0430\u0448\u043A\u0430",
        pol: "Ol' Geezer",
        sch: "\u8001\u5F0F\u725B\u4ED4\u5E3D",
        fre: "Vieu' Schnock",
        bra: "Ol' Geezer",
        schema: 399,
        hun: "V\xe9n Szivar",
        swe: "Gamle Gubbe"
    },
    267: {
        img: "tribalmans_shiv",
        eng: "The Tribalman's Shiv",
        rus: "\u0417\u0430\u0442\u043E\u0447\u043A\u0430 \u0434\u0438\u043A\u0430\u0440\u044F",
        pol: "Plemienne ostrze",
        sch: "\u90E8\u843D\u780D\u5200",
        fre: "Le Couteau Aborig\xe8ne",
        bra: "O Estoque Tribal",
        schema: 171,
        hun: "A T\xf6rzsi B\xf6k\u0151",
        swe: "Stamherrens handgjorda kniv"
    },
    268: {
        img: "detonator",
        eng: "Detonator",
        rus: "\u0414\u0435\u0442\u043E\u043D\u0430\u0442\u043E\u0440",
        pol: "Detonator",
        sch: "\u8D77\u7206\u8005",
        fre: "Le D\xe9tonateur",
        bra: "A Detonadora",
        schema: 351,
        hun: "A Deton\xe1tor",
        swe: "Detonatorn"
    },
    269: {
        img: "strange_part_allies_extinguished",
        eng: "Strange Part: Teammates Extinguished",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u043F\u043E\u0442\u0443\u0448\u0435\u043D\u043D\u044B\u0435 \u0441\u043E\u044E\u0437\u043D\u0438\u043A\u0438",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Ugaszeni sojusznicy",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u961F\u53CB\u706D\u706B\u6570",
        fre: "Pi\xe8ce \xe9trange : co\xe9quipiers en feu \xe9teints",
        bra: "Pe\xe7a Estranha: Aliados em Chamas Extinguidos",
        schema: 6020,
        hun: "Fura Alkatr\xe9sz: Eloltott csapatt\xe1rsak",
        swe: "M\xe4rklig del: Lagkamrater sl\xe4ckta"
    },
    270: {
        img: "strange_part_posthumous_kills",
        eng: "Strange Part: Posthumous Kills",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u043F\u043E\u0441\u043C\u0435\u0440\u0442\u043D\u044B\u0435 \u0443\u0431\u0438\u0439\u0441\u0442\u0432\u0430",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zab\xf3jstwa zza grobu",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u6B7B\u540E\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Victimes posthumes",
        bra: "Pe\xe7a Estranha: V\xedtimas P\xf3stumas",
        schema: 6019,
        hun: "Fura Alkatr\xe9sz: Posztumusz \xf6l\xe9sek",
        swe: "M\xe4rklig del: D\xf6dade efter du d\xf6tt"
    },
    271: {
        img: "market_gardener",
        eng: "The Market Gardener",
        rus: "\u0417\u0435\u043C\u043B\u0435\u043A\u043E\u043F",
        pol: "Ogrodnik z Arnhem",
        sch: "\u5E02\u573A\u82B1\u56ED\u94C1\u9539",
        fre: "Le Jardinier",
        bra: "O P\xe1-raquedista",
        schema: 416,
        hun: "A Gerillakert\xe9sz",
        swe: "Tr\xe4dg\xe5rdsm\xe4staren"
    },
    272: {
        img: "strange_part_critical_kills",
        eng: "Strange Part: Critical Kills",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0439\u0441\u0442\u0432\u0430 \u043A\u0440\u0438\u0442\u0430\u043C\u0438",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zab\xf3jstwa krytyczne",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u7206\u51FB\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Victimes par coup critique",
        bra: "Pe\xe7a Estranha: Cr\xedticos Fatais",
        schema: 6021,
        hun: "Fura Alkatr\xe9sz: Kritikus \xf6l\xe9sek",
        swe: "M\xe4rklig del: D\xf6dade med kritiska tr\xe4ffar"
    },
    273: {
        img: "strange_part_demomen_killed",
        eng: "Strange Part: Demomen Killed",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0442\u044B\u0435 \u043F\u043E\u0434\u0440\u044B\u0432\u043D\u0438\u043A\u0438",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zabici Demomani",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u7206\u7834\u624B\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Demomen tu\xe9s",
        bra: "Pe\xe7a Estranha: Demomen Mortos",
        schema: 6001,
        hun: "Fura Alkatr\xe9sz: Meg\xf6lt Robbant\xf3sok",
        swe: "M\xe4rklig del: Demomen d\xf6dade"
    },
    274: {
        img: "strange_part_revenge_kills",
        eng: "Strange Part: Revenge Kills",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0439\u0441\u0442\u0432\u0430 \u0441 \u043C\u0435\u0441\u0442\u044C\u044E",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zab\xf3jstwa odwetowe",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u590D\u4EC7\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Victimes par vengeance",
        bra: "Pe\xe7a Estranha: Vingan\xe7as",
        schema: 6018,
        hun: "Fura Alkatr\xe9sz: Bossz\xfa \xf6l\xe9sek",
        swe: "M\xe4rklig del: H\xe4mndmord"
    },
    275: {
        img: "hat_with_no_name",
        eng: "The Hat With No Name",
        rus: "\u0428\u043B\u044F\u043F\u0430 \u0431\u0435\u0437 \u0438\u043C\u0435\u043D\u0438",
        pol: "Kapelusz bez imienia",
        sch: "\u65E0\u540D\u4E4B\u5E3D",
        fre: "Le Chapeau Sans Nom",
        bra: "O Chap\xe9u Sem Nome",
        schema: 631,
        hun: "A N\xe9vtelen Kalap",
        swe: "Namnl\xf6sa hatten"
    },
    276: {
        img: "scotsmans_skullcutter",
        eng: "The Scotsman's Skullcutter",
        rus: "\u0428\u043E\u0442\u043B\u0430\u043D\u0434\u0441\u043A\u0438\u0439 \u0433\u043E\u043B\u043E\u0432\u043E\u0440\u0435\u0437",
        pol: "Czerepo\u0142amacz Szkota",
        sch: "\u82CF\u683C\u5170\u788E\u9885\u65A7",
        fre: "La Guillotine \xc9cossaise",
        bra: "O Corta-Cr\xe2nios Escoc\xeas",
        schema: 172,
        hun: "A Sk\xf3t Fejt\xf6r\u0151",
        swe: "Skottens skallsk\xe4rare"
    },
    277: {
        img: "persian_persuader",
        eng: "The Persian Persuader",
        rus: "\u041F\u0435\u0440\u0441\u0438\u0434\u0441\u043A\u0438\u0439 \u0437\u0430\u043A\u043B\u0438\u043D\u0430\u0442\u0435\u043B\u044C",
        pol: "Perska perswazja",
        sch: "\u6CE2\u65AF\u5F2F\u5200",
        fre: "La persuasion persane",
        bra: "O Persuasor Persa",
        schema: 404,
        hun: "A Perzsa Penge",
        swe: "\xd6sterl\xe4ndska \xf6vertalaren"
    },
    278: {
        img: "strange_part_soldiers_killed",
        eng: "Strange Part: Soldiers Killed",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0442\u044B\u0435 \u0441\u043E\u043B\u0434\u0430\u0442\u044B",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zabici \u017Bo\u0142nierze",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u58EB\u5175\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Soldiers tu\xe9s",
        bra: "Pe\xe7a Estranha: Soldiers Mortos",
        schema: 6002,
        hun: "Fura Alkatr\xe9sz: Meg\xf6lt Katon\xe1k",
        swe: "M\xe4rklig del: Soldiers d\xf6dade"
    },
    279: {
        img: "strange_part_domination_kills",
        eng: "Strange Part: Domination Kills",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0439\u0441\u0442\u0432\u0430 \u0441 \u043F\u0440\u0435\u0432\u043E\u0441\u0445\u043E\u0434\u0441\u0442\u0432\u043E\u043C",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zab\xf3jstwa dominacyjne",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u63A7\u5236\u6570",
        fre: "Pi\xe8ce \xe9trange : Victimes domin\xe9es",
        bra: "Pe\xe7a Estranha: Domina\xe7\xf5es",
        schema: 6016,
        hun: "Fura Alkatr\xe9sz: Al\xe1z\xf3 \xf6l\xe9sek",
        swe: "M\xe4rklig del: Domineringsmord"
    },
    280: {
        img: "strange_part_kills_while_explosive_jumping",
        eng: "Strange Part: Kills While Explosive Jumping",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0439\u0441\u0442\u0432\u0430 \u0432 \u043F\u0440\u044B\u0436\u043A\u0435 \u043D\u0430 \u0432\u0437\u0440\u044B\u0432\u0447\u0430\u0442\u043A\u0435",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zab\xf3jstwa podczas skoku na eksplozji",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u7206\u70B8\u8D77\u8DF3\u7A7A\u4E2D\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Victimes lors de sauts propuls\xe9s",
        bra: "Pe\xe7a Estranha: Saltos Explosivos Fatais",
        schema: 6022,
        hun: "Fura Alkatr\xe9sz: \xd6l\xe9sek robban\xf3-ugr\xe1s k\xf6zben",
        swe: "M\xe4rklig del: D\xf6dade under explosionshopp"
    },
    281: {
        img: "tavish_degroot_experience",
        eng: "The Tavish DeGroot Experience",
        rus: "\u041E\u043F\u044B\u0442 \u0422\u0430\u0432\u0438\u0448\u0430 \u0414\u0435\u0413\u0440\u0443\u0442\u0430",
        pol: "Tavish DeGroot Experience",
        sch: "\u5854\u7EF4\u4EC0\u5FB7\u683C\u7F57\u7279\u7684\u5BBD\u8FB9\u5E3D",
        fre: "L'exp\xe9rience Tavish DeGroot",
        bra: "A Experi\xeancia do Tavish DeGroot",
        schema: 604,
        hun: "A Tavish DeGroot-\xe9rz\xe9s",
        swe: "Tavish DeGroot-Upplevelsen"
    },
    282: {
        img: "lollichop",
        eng: "Lollichop",
        rus: "\u041A\u043B\u0435\u0434\u0435\u043D\u0435\u0446",
        pol: "Lizasiek",
        sch: "\u950B\u5229\u7684\u6CE2\u677F\u7CD6",
        fre: "La Sussache",
        bra: "O Pyrolito",
        schema: 739,
        hun: "A Szel\u0151ke",
        swe: "Slickepinan"
    },
    283: {
        img: "rainblower",
        eng: "Rainblower",
        rus: "\u0420\u0430\u0434\u0443\u0436\u0438\u0433\u0430\u0442\u0435\u043B\u044C",
        pol: "T\u0119czomiot",
        sch: "\u5F69\u8679\u55B7\u706F",
        fre: "Le Chasse-nuages",
        bra: "O Lan\xe7arco-\xedris",
        schema: 741,
        hun: "A Sziv\xe1rm\xe1ny",
        swe: "Regnbl\xe5saren"
    },
    284: {
        img: "apparatchiks_apparel",
        eng: "The Apparatchik's Apparel",
        rus: "\u041E\u0434\u0435\u0436\u0434\u0430 \u0430\u043F\u043F\u0430\u0440\u0430\u0442\u0447\u0438\u043A\u0430",
        pol: "Koszula komucha",
        sch: "\u515A\u50DA\u7684\u670D\u9970",
        fre: "Les V\xeatements d'Apparatchik",
        bra: "A Vestimenta do Vereador",
        schema: 777,
        hun: "Az Appar\xe1tcsik \xc1lma",
        swe: "Byr\xe5kratens Bomullsskjorta"
    },
    285: {
        img: "bird_man_of_aberdeen",
        eng: "Bird-Man of Aberdeen",
        rus: "\u041F\u0442\u0438\u0446\u0435\u043B\u043E\u0432 \u0438\u0437 \u0410\u0431\u0435\u0440\u0434\u0438\u043D\u0430",
        pol: "Ptasznik z Aberdeen",
        sch: "\u963F\u4F2F\u4E01\u7684\u9E1F\u4EBA",
        fre: "L'Homme-Oiseau d'Aberdeen",
        bra: "O Homem de Aberdeen",
        schema: 776,
        hun: "Az Aberdeeni Mad\xe1rember",
        swe: "F\xe5gelk\xe4nnaren fr\xe5n Aberdeen"
    },
    286: {
        img: "business_casual",
        eng: "Business Casual",
        rus: "\u0414\u0435\u043B\u043E\u0432\u043E\u0439 \u0441\u0442\u0438\u043B\u044F\u0433\u0430",
        pol: "Lu\u017Any biznes",
        sch: "\u5546\u52A1\u4F11\u95F2\u88C5",
        fre: "Le Businessman D\xe9tendu",
        bra: "O Traje Casual",
        schema: 782,
        hun: "A Laza \xdczlet",
        swe: "Vardagliga Kontoristen"
    },
    287: {
        img: "captains_cocktails",
        eng: "Captain's Cocktails",
        rus: "\u041A\u0430\u043F\u0438\u0442\u0430\u043D\u0441\u043A\u0438\u0435 \u043A\u043E\u043A\u0442\u0435\u0439\u043B\u0438",
        pol: "Koktajle kapitana",
        sch: "\u4E10\u5E2E\u5934\u5934\u7684\u7F50\u5934\u76D2",
        fre: "Les Cocktails du Capitaine",
        bra: "Os Coquet\xe9is do Capit\xe3o",
        schema: 731,
        hun: "A Kapit\xe1ny Kokt\xe9ljai",
        swe: "Kaptenens Konserver"
    },
    288: {
        img: "dillingers_duffel",
        eng: "Dillinger's Duffel",
        rus: "\u0412\u0435\u0449\u043C\u0435\u0448\u043E\u043A \u0414\u0438\u043B\u043B\u0438\u043D\u0434\u0436\u0435\u0440\u0430",
        pol: "Dorobek Dillingera",
        sch: "\u72C4\u6797\u6770\u7684\u7C97\u82B1\u5462\u5E03\u888B",
        fre: "Sac de Dillinger",
        bra: "A Mala do Marginal",
        schema: 781,
        hun: "Dillinger Utaz\xf3t\xe1sk\xe1ja",
        swe: "V\xe5garens V\xe4ska"
    },
    289: {
        img: "fed_fightin_fedora",
        eng: "Fed-Fightin' Fedora",
        rus: "\u0424\u0435\u0442\u0440\u043E\u0432\u0430\u044F \u0448\u043B\u044F\u043F\u0430 \u0444\u0435\u0434\u0435\u0440\u0430\u043B\u043E\u0431\u043E\u0440\u0446\u0430",
        pol: "Antyfederalna fedora",
        sch: "\u8054\u90A6\u63A2\u5458\u6253\u8D25\u8005",
        fre: "Le Fedora du Combat des F\xe9d\xe9raux",
        bra: "O Fedora Furado",
        schema: 780,
        hun: "A Kop\xf3kap\xf3 Kalap",
        swe: "Federal-fajtande Fedora"
    },
    290: {
        img: "gentlemans_ushanka",
        eng: "Gentleman's Ushanka",
        rus: "\u0414\u0436\u0435\u043D\u0442\u043B\u044C\u043C\u0435\u043D\u0441\u043A\u0430\u044F \u0443\u0448\u0430\u043D\u043A\u0430",
        pol: "Uszanka d\u017Centelmena",
        sch: "\u7EC5\u58EB\u7684\u7EA2\u519B\u5E3D",
        fre: "L'Ushanka du Gentilhomme",
        bra: "A Ushanka do Cavalheiro",
        schema: 778,
        hun: "Az \xdariember Usank\xe1ja",
        swe: "Gentlemannens Usjanka"
    },
    291: {
        img: "hazmat_headcase",
        eng: "HazMat Headcase",
        rus: "\u0413\u043E\u043B\u043E\u0432\u043D\u043E\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442 \u0445\u0438\u043C\u0437\u0430\u0449\u0438\u0442\u044B",
        pol: "Gor\u0105ca g\u0142owa",
        sch: "\u5371\u7206\u54C1\u5904\u7406\u9762\u7F69",
        fre: "Le casque Hazmat",
        bra: "O Capacete Contra Coisas Corrosivas",
        schema: 783,
        hun: "A Vegyv\xe9delmis Veszedelem",
        swe: "Skyddsdr\xe4ktshj\xe4lmen"
    },
    292: {
        img: "helmet_without_a_home",
        eng: "Helmet Without a Home",
        rus: "\u0428\u043B\u0435\u043C \u0431\u0435\u0437 \u043A\u0440\u044B\u0448\u0438 \u043D\u0430\u0434 \u0433\u043E\u043B\u043E\u0432\u043E\u0439",
        pol: "Kask kloszarda",
        sch: "\u65E0\u5BB6\u53EF\u76D4",
        fre: "Le Casque Sans Foyer",
        bra: "O Capacete Sem Lar",
        schema: 732,
        hun: "A Hajl\xe9ktalan Homloktakar\xf3",
        swe: "Heml\xf6sa hj\xe4lmen"
    },
    293: {
        img: "idea_tube",
        eng: "Idea Tube",
        rus: "\u0422\u0443\u0431\u0443\u0441 \u0441 \u0438\u0434\u0435\u044F\u043C\u0438",
        pol: "Pomys\u0142owy tubus",
        sch: "\u601D\u60F3\u7BA1",
        fre: "Le Tube \xe0 id\xe9es",
        bra: "O Porta-Ideias",
        schema: 784,
        hun: "Az \xd6tletcs\u0151",
        swe: "Id\xe9r\xf6ret"
    },
    294: {
        img: "liquidators_lid",
        eng: "Liquidator's Lid",
        rus: "\u0428\u0430\u043F\u043E\u0447\u043A\u0430 \u041B\u0438\u043A\u0432\u0438\u0434\u0430\u0442\u043E\u0440\u0430",
        pol: "Leon likwidator",
        sch: "\u6E05\u7B97\u4EBA\u7684\u5E3D\u5B50",
        fre: "Le Galurin du Liquidateur",
        bra: "O Exterminador Estiloso",
        schema: 779,
        hun: "A Felsz\xe1mol\xf3 Fejreval\xf3ja",
        swe: "Likviderarens Luva"
    },
    295: {
        img: "balloonicorn",
        eng: "Balloonicorn",
        rus: "\u041D\u0430\u0434\u0443\u0432\u043D\u043E\u0440\u043E\u0433",
        pol: "Balonoro\u017Cec",
        sch: "\u6C14\u7403\u72EC\u89D2\u517D",
        fre: "La Ballicorne",
        bra: "O Bal\xe3onic\xf3rnio",
        schema: 738,
        hun: "A Lufikornis",
        swe: "Ballongh\xf6rningen"
    },
    296: {
        img: "infernal_orchestrina",
        eng: "Infernal Orchestrina",
        rus: "\u0410\u0434\u0441\u043A\u0430\u044F \u041E\u0440\u043A\u0435\u0441\u0442\u0440\u0438\u043D\u0430",
        pol: "Piekielna pozytywka",
        sch: "\u70BC\u72F1\u7BA1\u5F26\u4E50",
        fre: "Orgue de Barbarie",
        bra: "Orquestrina Infernal",
        schema: 745,
        hun: "Pokoli Zeneg\xe9p",
        swe: "Infernalisk Pianola"
    },
    297: {
        img: "tomislav",
        eng: "Tomislav",
        rus: "\u0422\u043E\u043C\u0438\u0441\u043B\u0430\u0432",
        pol: "Tomis\u0142aw",
        sch: "\u6C64\u59C6\u65AF\u62C9\u592B",
        fre: "Tomislav",
        bra: "Tomislav",
        schema: 424,
        hun: "Tomiszlav"
    },
    298: {
        img: "strange_part_scouts_killed",
        eng: "Strange Part: Scouts Killed",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0442\u044B\u0435 \u0440\u0430\u0437\u0432\u0435\u0434\u0447\u0438\u043A\u0438",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zabici Skauci",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u4FA6\u5BDF\u5175\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Scouts tu\xe9s",
        bra: "Pe\xe7a Estranha: Scouts Mortos",
        schema: 6003,
        hun: "Fura Alkatr\xe9sz: Meg\xf6lt Felder\xedt\u0151k",
        swe: "M\xe4rklig del: Scouts d\xf6dade"
    },
    299: {
        img: "strange_part_sappers_destroyed",
        eng: "Strange Part: Sappers Destroyed",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u043D\u0438\u0447\u0442\u043E\u0436\u0435\u043D\u043D\u044B\u0435 \u0436\u0443\u0447\u043A\u0438",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zniszczone sapery",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u7535\u5B50\u5DE5\u5175\u6467\u6BC1\u6570",
        fre: "Pi\xe8ce \xe9trange : Saboteurs d\xe9truits",
        bra: "Pe\xe7a Estranha: Sabotadores Removidos",
        schema: 6025,
        hun: "Fura Alkatr\xe9sz: Elpuszt\xedtott mentes\xedt\u0151k",
        swe: "M\xe4rklig del: Sappers borttagna"
    },
    300: {
        img: "strange_part_cloaked_spies_killed",
        eng: "Strange Part: Cloaked Spies Killed",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0442\u044B\u0435 \u043D\u0435\u0432\u0438\u0434\u0438\u043C\u044B\u0435 \u0448\u043F\u0438\u043E\u043D\u044B",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zabici niewidzialni Szpiedzy",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u9690\u5F62\u95F4\u8C0D\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Spies invisibles tu\xe9s",
        bra: "Pe\xe7a Estranha: Spies Camuflados Mortos",
        schema: 6024,
        hun: "Fura Alkatr\xe9sz: Meg\xf6lt \xe1lc\xe1zott K\xe9mek",
        swe: "M\xe4rklig del: Dolda Spies d\xf6dade"
    },
    301: {
        img: "backwards_ballcap",
        eng: "The Backwards Ballcap",
        rus: "\u041F\u0435\u0440\u0435\u0432\u0435\u0440\u043D\u0443\u0442\u0430\u044F \u0431\u0435\u0439\u0441\u0431\u043E\u043B\u043A\u0430",
        pol: "Bejsbol\xf3wka buntownika",
        sch: "\u53CD\u6234\u7684\u68D2\u7403\u5E3D",
        fre: "La casquette \xe0 l'envers",
        bra: "O Bon\xe9 pra Tr\xe1s",
        schema: 617,
        hun: "A L\xe1zad\xf3 Labdaj\xe1t\xe9kos",
        swe: "Bak\xe5tv\xe4nda Bollkepsen"
    },
    302: {
        img: "koala_compact",
        eng: "Koala Compact",
        rus: "\u041A\u0430\u0440\u043C\u0430\u043D\u043D\u044B\u0439 \u043A\u043E\u0430\u043B\u0430",
        pol: "Kompaktowy koala",
        sch: "\u53E3\u888B\u8003\u62C9",
        fre: "Le Koala Compact",
        bra: "O Coala Compacto",
        schema: 824,
        hun: "A Koalatart\xf3",
        swe: "Den Kompakta Koalan"
    },
    303: {
        img: "soviet_gentleman",
        eng: "The Soviet Gentleman",
        rus: "\u0421\u043E\u0432\u0435\u0442\u0441\u043A\u0438\u0439 \u0434\u0436\u0435\u043D\u0442\u043B\u044C\u043C\u0435\u043D",
        pol: "Radziecki d\u017Centelmen",
        sch: "\u82CF\u7EF4\u57C3\u7EC5\u58EB",
        fre: "Le Gentleman Sovi\xe9tique",
        bra: "O Cavalheiro Sovi\xe9tico",
        schema: 821,
        hun: "A Szovjet \xdariember",
        swe: "Den Sovjetiska Gentlemannen"
    },
    304: {
        img: "pocket_purrer",
        eng: "Pocket Purrer",
        rus: "\u041A\u0430\u0440\u043C\u0430\u043D\u043D\u044B\u0439 \u043C\u0443\u0440\u043B\u044B\u043A\u0430",
        pol: "Kieszonkowy kiciu\u015B",
        sch: "\u53E3\u888B\u732B\u732B",
        fre: "Le Ronronneur de Poche",
        bra: "O Felino Fofinho",
        schema: 823,
        hun: "A Zsebdorombol\xf3",
        swe: "Fickspinnaren"
    },
    305: {
        img: "hat_of_cards",
        eng: "Hat of Cards",
        rus: "\u0428\u043B\u044F\u043F\u0430 \u043A\u0430\u0440\u0442",
        pol: "Czapka z kart",
        sch: "\u7EB8\u724C\u9A97\u672F\u5E08",
        fre: "Chapeau de Cartes",
        bra: "Chap\xe9u de Cartas",
        schema: 825,
        hun: "A K\xe1rty\xe1sz",
        swe: "Korthatt"
    },
    306: {
        img: "medi_mask",
        eng: "Medi-Mask",
        rus: "\u041C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0438\u0439 \u0440\u0435\u0441\u043F\u0438\u0440\u0430\u0442\u043E\u0440",
        pol: "Med-maska",
        sch: "\u9632\u6BD2\u9762\u5177",
        fre: "Medi-Masque",
        bra: "Medi-m\xe1scara",
        schema: 826,
        hun: "Gy\xf3gymaszk",
        swe: "Sjukskyddet"
    },
    307: {
        img: "track_terrorizer",
        eng: "Track Terrorizer",
        rus: "\u0413\u0440\u043E\u0437\u0430 \u0431\u0435\u0433\u043E\u0432\u043E\u0439 \u0434\u043E\u0440\u043E\u0436\u043A\u0438",
        pol: "Bezecnik z bie\u017Cni",
        sch: "\u8DDF\u8E2A\u72C2",
        fre: "La Terreur des Pistes",
        bra: "O Terror das Pistas",
        schema: 827,
        hun: "A P\xe1lya \xd6rd\xf6ge",
        swe: "L\xf6parpl\xe5gan"
    },
    308: {
        img: "war_pig",
        eng: "The War Pig",
        rus: "\u0411\u043E\u0435\u0432\u043E\u0439 \u043A\u0430\u0431\u0430\u043D",
        pol: "\u015Awinia wojny",
        sch: "\u6218\u573A\u8C6A\u732A",
        fre: "Le Porc de Guerre",
        bra: "O Porco de Guerra",
        schema: 829,
        hun: "A Harc\xe1tlan",
        swe: "Krigsgrisen"
    },
    309: {
        img: "bearded_bombardier",
        eng: "Bearded Bombardier",
        rus: "\u0411\u043E\u0440\u043E\u0434\u0430\u0442\u044B\u0439 \u0431\u043E\u043C\u0431\u0430\u0440\u0434\u0438\u0440",
        pol: "Brodaty bombardier",
        sch: "\u70B8\u5F39\u5175\u7684\u82B1\u767D\u80E1\u987B",
        fre: "Le Bombardier Barbu",
        bra: "O Bombardeiro Barbudo",
        schema: 830,
        hun: "A Szak\xe1llas T\xfcz\xe9r",
        swe: "Den Sk\xe4ggiga Spr\xe4ngaren"
    },
    310: {
        img: "pyrotechnic_tote",
        eng: "Pyrotechnic Tote",
        rus: "\u0420\u0430\u043D\u0435\u0446 \u0441 \u043F\u0438\u0440\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u043E\u0439",
        pol: "Torba pirotechnika",
        sch: "\u70DF\u706B\u80CC\u5305",
        fre: "Le Fourre-tout Pyrotechnique",
        bra: "A Sacola Pirot\xe9cnica",
        schema: 856,
        hun: "A Pirotechnikus Taty\xf3ja",
        swe: "Den Pyrotekniska V\xe4skan"
    },
    311: {
        img: "robro_3000",
        eng: "RoBro 3000",
        rus: "\u0420\u043E\u0411\u0440\u043E 3000",
        pol: "RoBro 3000",
        sch: "\u673A\u5668\u4F19\u4F34 3000",
        fre: "Le RoBro 3000",
        bra: "O RoBr\xf3der 3000",
        schema: 733,
        hun: "A RoboTes\xf3 3000",
        ger: "Der RoBro 3000"
    },
    312: {
        img: "shovel",
        eng: "Shovel",
        rus: "\u041B\u043E\u043F\u0430\u0442\u0430",
        pol: "Saperka",
        sch: "\u94C1\u9539",
        fre: "Pelle",
        bra: "P\xe1",
        schema: 196,
        hun: "\xe1s\xf3",
        swe: "Skyffel"
    },
    313: {
        img: "strange_part_engineers_killed",
        eng: "Strange Part: Engineers Killed",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0442\u044B\u0435 \u0438\u043D\u0436\u0435\u043D\u0435\u0440\u044B",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zabici In\u017Cynierowie",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u5DE5\u7A0B\u5E08\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Engineers tu\xe9s",
        bra: "Pe\xe7a Estranha: Engineers Mortos",
        schema: 6004,
        hun: "Fura Alkatr\xe9sz: Meg\xf6lt M\xe9rn\xf6k\xf6k",
        swe: "M\xe4rklig Del: Engineers d\xf6dade"
    },
    314: {
        img: "strange_part_robots_destroyed",
        eng: "Strange Part: Robots Destroyed",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u043D\u0438\u0447\u0442\u043E\u0436\u0435\u043D\u043D\u044B\u0435 \u0440\u043E\u0431\u043E\u0442\u044B",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zniszczone roboty",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u673A\u5668\u4EBA\u6467\u6BC1\u6570",
        fre: "Pi\xe8ce \xe9trange : Robots d\xe9truits",
        bra: "Pe\xe7a Estranha: Rob\xf4s Destru\xeddos",
        schema: 6026,
        hun: "Fura Alkatr\xe9sz: Elpuszt\xedtott robotok",
        swe: "M\xe4rklig del: Robotar f\xf6rst\xf6rda"
    },
    315: {
        img: "strange_part_low_health_kills",
        eng: "Strange Part: Low-Health Kills",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0439\u0441\u0442\u0432\u0430 \u043D\u0430 \u0433\u0440\u0430\u043D\u0438 \u0441\u043C\u0435\u0440\u0442\u0438",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zab\xf3jstwa z niskim stanem zdrowia",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u6B8B\u8840\u72B6\u6001\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Nombre de victimes en ayant une sant\xe9 faible",
        bra: "Pe\xe7a Estranha: V\xedtimas enquanto com Pouca Vida",
        schema: 6032,
        hun: "Fura Alkatr\xe9sz: \xd6l\xe9sek alacsony \xe9leter\u0151n\xe9l",
        swe: "M\xe4rklig del: D\xf6dade vid l\xe5g h\xe4lsa"
    },
    316: {
        img: "surgeons_stahlhelm",
        eng: "The Surgeon's Stahlhelm",
        rus: "\u0428\u0442\u0430\u043B\u044C\u0445\u0435\u043B\u044C\u043C \u0432\u0440\u0430\u0447\u0430",
        pol: "Stalowy he\u0142m chirurga",
        sch: "\u5916\u79D1\u533B\u751F\u7684\u94A2\u76D4",
        fre: "Le Stahlhelm de Chirurgien",
        bra: "Stahlhelm do Cirurgi\xe3o",
        schema: 616,
        hun: "A Seb\xe9szi Sisak",
        swe: "Kirurgens Krigshj\xe4lm"
    },
    317: {
        img: "furious_fukaamigasa",
        eng: "Furious Fukaamigasa",
        rus: "\u0421\u0432\u0438\u0440\u0435\u043F\u044B\u0439 \u0444\u0443\u043A\u0430\u0430\u043C\u0438\u0433\u0430\u0441\u0430",
        pol: "Fukaamigasa furiata",
        sch: "\u6124\u6012\u8005\u7684\u6597\u7B20",
        fre: "Furieux Fukaamigasa",
        bra: "Fukaamigasa Furioso",
        schema: 395,
        hun: "D\xfch\xf6s Fukaamigasa",
        swe: "F\xf6rbannad Fukaamigasa"
    },
    318: {
        img: "strange_bacon_grease",
        eng: "Strange Bacon Grease",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0432\u0438\u043D\u043E\u0439 \u0436\u0438\u0440",
        pol: "Kuriozalna s\u0142onina",
        sch: "\u5947\u5F02\u732A\u6CB9",
        fre: "Graisse de bacon \xe9trange",
        bra: "Banha Estranha",
        schema: 5633,
        hun: "Fura Szalonnazs\xedr",
        swe: "M\xe4rkligt baconfett"
    },
    319: {
        img: "construction_pda",
        eng: "Construction PDA",
        rus: "\u041A\u041F\u041A \u043F\u043E\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
        pol: "PDA budowy",
        sch: "\u5EFA\u9020\u5DE5\u5177",
        fre: "PDA de Construction",
        bra: "PDA de Constru\xe7\xe3o",
        schema: 737,
        hun: "\xc9p\xedt\u0151 PDA",
        swe: "Bygg-PDA"
    },
    320: {
        img: "original",
        eng: "The Original",
        rus: "\u041E\u0440\u0438\u0433\u0438\u043D\u0430\u043B\u044C\u043D\u0430\u044F \u043E\u043A\u0440\u0430\u0441\u043A\u0430",
        pol: "Oryginalna",
        sch: "\u539F\u7248",
        fre: "Originel",
        bra: "Original",
        schema: 513,
        hun: "Eredeti",
        swe: "Original"
    },
    321: {
        img: "invis_watch",
        eng: "Invis Watch",
        rus: "\u0427\u0430\u0441\u044B \u043D\u0435\u0432\u0438\u0434\u0438\u043C\u043E\u0441\u0442\u0438",
        pol: "Zegarek niewidzialno\u015Bci",
        sch: "\u9690\u5F62\u624B\u8868",
        fre: "Montre d'invisibilit\xe9",
        bra: "Rel\xf3gio de Invisibilidade",
        schema: 212,
        hun: "\xe1tl\xe1tsz-\xf3ra",
        swe: "Osynlighetsklocka"
    },
    322: {
        img: "splendid_screen",
        eng: "The Splendid Screen",
        rus: "\u0420\u043E\u0441\u043A\u043E\u0448\u043D\u043E\u0435 \u043F\u0440\u0438\u043A\u0440\u044B\u0442\u0438\u0435",
        pol: "Prze\u015Bwietny puklerz",
        sch: "\u8F89\u714C\u62A4\u76FE",
        fre: "Le Mirage \xc9blouissant",
        bra: "O Escudo Espl\xeandido",
        schema: 406,
        hun: "A Pomp\xe1s Pajzs",
        swe: "Det str\xe5lande skyddet"
    },
    323: {
        img: "sir_hootsalot",
        eng: "Sir Hootsalot",
        rus: "\u0421\u044D\u0440 \u0421\u043E\u0432\u043E\u043B\u043E\u0442",
        pol: "Kapitan Sowa",
        sch: "\u591C\u884C\u8005\u7235\u58EB",
        fre: "Sire Hululalot",
        bra: "Sr. Coruj\xe3o",
        schema: 917,
        hun: "Sir Huhogi"
    },
    324: {
        img: "master_mind",
        eng: "Master Mind",
        rus: "\u0413\u0438\u0433\u0430\u043D\u0442 \u043C\u044B\u0441\u043B\u0438",
        pol: "Umys\u0142 majstra",
        sch: "\u8D85\u7EA7\u5927\u8111",
        fre: "L'esprit du ma\xeetre",
        bra: "A Mente Mestra",
        schema: 918,
        hun: "Az Agymester",
        swe: "Geniet"
    },
    325: {
        img: "rump_o_lantern",
        eng: "Rump-o'-Lantern",
        rus: "\u0410\u0444\u0435\u0434\u0440\u043E\u0444\u043E\u043D\u0430\u0440\u044C",
        pol: "Halloweenowe wsparcie duchowe",
        sch: "\u906E\u81C0\u5357\u74DC\u706F",
        fre: "La Lantern-o-croupion",
        bra: "O Lampi\xe3o Traseiro",
        schema: 869,
        hun: "A T\xf6k Als\xf3",
        swe: "Rumplyktan"
    },
    326: {
        img: "scarecrow",
        eng: "Scarecrow",
        rus: "\u041F\u0443\u0433\u0430\u043B\u043E",
        pol: "Strach na wr\xf3ble",
        sch: "\u7A3B\u8349\u4EBA",
        fre: "L'\xc9pouvantail",
        bra: "O Espantalho",
        schema: 919,
        hun: "A Mad\xe1rijeszt\u0151",
        swe: "F\xe5gelskr\xe4mman"
    },
    327: {
        img: "crones_dome",
        eng: "Crone's Dome",
        rus: "\u0412\u0435\u0434\u044C\u043C\u0438\u043D\u0441\u043A\u0438\u0439 \u043A\u043E\u043B\u043F\u0430\u043A",
        pol: "Kapelusz wied\u017Amy",
        sch: "\u5DEB\u5A46\u7684\u5C16\u5E3D",
        fre: "Le Chapeau de sorci\xe8re",
        bra: "O Chap\xe9u do Mausol\xe9u",
        schema: 920,
        hun: "A Banya B\xfar\xe1ja",
        swe: "K\xe4rringens Hatt"
    },
    328: {
        img: "executioner",
        eng: "Executioner",
        rus: "\u041F\u0430\u043B\u0430\u0447",
        pol: "Spojrzenie kata",
        sch: "\u8499\u9762\u523D\u5B50\u624B",
        fre: "Le Bourreau",
        bra: "O Carrasco",
        schema: 921,
        hun: "A H\xf3h\xe9r",
        swe: "Avr\xe4ttaren"
    },
    329: {
        img: "bonedolier",
        eng: "Bonedolier",
        rus: "\u041A\u043E\u0441\u0442\u043E\u043D\u0442\u0430\u0448",
        pol: "Wybuchowa czacha",
        sch: "\u9AA8\u5F39\u5E26",
        fre: "L'Osseli\xe8re",
        bra: "A Cranioleira",
        schema: 922,
        hun: "A Robban\xf3fej",
        swe: "Benbandet"
    },
    330: {
        img: "plutonidome",
        eng: "Plutonidome",
        rus: "\u041F\u043B\u0443\u0442\u043E\u043D\u0438\u0435\u0432\u044B\u0439 \u043A\u043E\u0442\u0435\u043B\u043E\u043A",
        pol: "P\u0142ynny potencja\u0142",
        sch: "\u8BE1\u5F02\u8111\u888B",
        fre: "Le Plutoniheaume",
        bra: "O Plutonidomo",
        schema: 923,
        hun: "A Plut\xf3nib\xfara",
        swe: "Plutonidomen"
    },
    331: {
        img: "spooky_shoes",
        eng: "Spooky Shoes",
        rus: "\u0416\u0443\u0442\u043A\u0430\u044F \u043E\u0431\u0443\u0432\u043A\u0430",
        pol: "Trupie trampki",
        sch: "\u9AB7\u9AC5\u957F\u9774",
        fre: "Les sinistres chaussures",
        bra: "As Meias Macabras",
        schema: 924,
        hun: "A R\xe9miszt\u0151 Cip\u0151k",
        swe: "Sp\xf6kliga Skorna"
    },
    332: {
        img: "spooky_sleeves",
        eng: "Spooky Sleeves",
        rus: "\u0416\u0443\u0442\u043A\u0438\u0435 \u0440\u0443\u043A\u0430\u0432\u0430",
        pol: "Trupie r\u0119kawy",
        sch: "\u9AB7\u9AC5\u957F\u8896\u886B",
        fre: "Les sinistres manchettes",
        bra: "As Mangas Macabras",
        schema: 925,
        hun: "A R\xe9miszt\u0151 Ruhaujjak",
        swe: "Sp\xf6kliga \xc4rmarna"
    },
    333: {
        img: "zipperface",
        eng: "Zipperface",
        rus: "\u041C\u043E\u043B\u043D\u0438\u0435\u043B\u0438\u043A\u0438\u0439",
        pol: "Twarz na zamek b\u0142yskawiczny",
        sch: "\u53BB\u9AA8\u62C9\u94FE",
        fre: "Le Cr\xe2neur",
        bra: "O Cara de Z\xedper",
        schema: 926,
        hun: "A Cipz\xe1rarc",
        swe: "Dragkedjeansiktet"
    },
    334: {
        img: "boo_balloon",
        eng: "Boo Balloon",
        rus: "\u0416\u0443\u0442\u043A\u0438\u0439 \u0448\u0430\u0440\u0438\u043A",
        pol: "Z\u0142owieszczy balonik",
        sch: "\u5E7D\u7075\u6C14\u7403",
        fre: "Le ballon de boo-druche",
        bra: "O Abobal\xe3o",
        schema: 927,
        hun: "A Juj-lufi",
        swe: "Bu-Ballongen"
    },
    335: {
        img: "unknown_monkeynaut",
        eng: "Unknown Monkeynaut",
        rus: "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u044B\u0439 \u043E\u0431\u0435\u0437\u044C\u044F\u043D\u0430\u0432\u0442",
        pol: "Nieznany ma\u0142ponauta",
        sch: "\u65E0\u540D\u7684\u5B87\u822A\u7334",
        fre: "Le singenaute inconnu",
        bra: "O Macaconauta Desconhecido",
        schema: 929,
        hun: "Az Ismeretlen Majomnauta",
        swe: "Den Ok\xe4nda Apanauten"
    },
    336: {
        img: "grand_duchess_tutu",
        eng: "Grand Duchess Tutu",
        rus: "\u041F\u0430\u0447\u043A\u0430 \u0432\u0435\u043B\u0438\u043A\u043E\u0439 \u043A\u043D\u044F\u0436\u043D\u044B",
        pol: "Tutu wielkiej ksi\u0119\u017Cnej",
        sch: "\u5927\u516C\u592B\u4EBA\u7684\u82AD\u857E\u821E\u77ED\u88D9",
        fre: "Le tutu de la Grande Duchesse",
        bra: "O Tutu da Gr\xe3-Duquesa",
        schema: 930,
        hun: "A Nagyhercegn\u0151i T\xfct\xfc",
        swe: "Storhertiginnans Balettkjol"
    },
    337: {
        img: "grand_duchess_fairy_wings",
        eng: "Grand Duchess Fairy Wings",
        rus: "\u0412\u043E\u043B\u0448\u0435\u0431\u043D\u044B\u0435 \u043A\u0440\u044B\u043B\u044B\u0448\u043A\u0438 \u0432\u0435\u043B\u0438\u043A\u043E\u0439 \u043A\u043D\u044F\u0436\u043D\u044B",
        pol: "Ba\u015Bniowe skrzyd\u0142a wielkiej ksi\u0119\u017Cnej",
        sch: "\u5927\u516C\u592B\u4EBA\u7684\u5C0F\u4ED9\u5973\u7FC5\u8180",
        fre: "Les ailes f\xe9eriques de la Grande Duchesse",
        bra: "As Asas de Fada da Gr\xe3-Duquesa",
        schema: 931,
        hun: "A Nagyhercegn\u0151i T\xfcnd\xe9rsz\xe1rnyak",
        swe: "Storhertiginnans Fevingar"
    },
    338: {
        img: "grand_duchess_tiara",
        eng: "Grand Duchess Tiara",
        rus: "\u041A\u043E\u0440\u043E\u043D\u0430 \u0432\u0435\u043B\u0438\u043A\u043E\u0439 \u043A\u043D\u044F\u0436\u043D\u044B",
        pol: "Diadem wielkiej ksi\u0119\u017Cnej",
        sch: "\u5927\u516C\u592B\u4EBA\u7684\u5B9D\u51A0",
        fre: "Le diad\xe8me de la Grande Duchesse",
        bra: "A Tiara da Gr\xe3-Duquesa",
        schema: 932,
        hun: "A Nagyhercegn\u0151i Diad\xe9m",
        swe: "Storhertiginnans Tiara"
    },
    339: {
        img: "dead_little_buddy",
        eng: "Dead Little Buddy",
        rus: "\u041C\u0435\u0440\u0442\u0432\u044B\u0439 \u0434\u0440\u0443\u0436\u043E\u043A",
        pol: "Ma\u0142y martwy kumpel",
        sch: "\u73A9\u4F34\u5C0F\u5E7D\u7075",
        fre: "Le petit pote mort",
        bra: "O Fantasminha Camarada",
        schema: 934,
        hun: "A Kis Halott Haver",
        swe: "D\xf6d Liten Kompis"
    },
    340: {
        img: "exorcizor",
        eng: "Exorcizor",
        rus: "\u0424\u0438\u0437\u0437\u043E\u0440\u0446\u0438\u0441\u0442",
        pol: "Koloratka egzorcysty",
        sch: "\u9A71\u9B54\u4EBA",
        fre: "L'Exorciseur",
        bra: "O Exorcista",
        schema: 936,
        hun: "Az \xd6rd\xf6gi\u0171z\u0151",
        swe: "Exercisten"
    },
    341: {
        img: "voodoo_juju_slight_return",
        eng: "Voodoo JuJu (Slight Return)",
        rus: "\u0410\u043C\u0443\u043B\u0435\u0442 \u0432\u0443\u0434\u0443 (\u0432\u0435\u0440\u0441\u0438\u044F 2.0)",
        pol: "Juju voodoo (skromny powr\xf3t)",
        sch: "\u5DEB\u6BD2\u7B26\u5492\uFF08\u5FAE\u5C0F\u7684\u56DE\u62A5\uFF09",
        fre: "Le JuJu vaudou (petit retour)",
        bra: "O Vudu Juju (O Retorno)",
        schema: 935,
        hun: "A Vudu JuJu (Kis visszat\xe9r\xe9s)",
        rom: "The Voodoo JuJu (\xcentoarcere aproximativ\u0103)",
        swe: "Voodoo JuJu (Igen)"
    },
    342: {
        img: "wraith_wrap",
        eng: "Wraith Wrap",
        rus: "\u041F\u0440\u0438\u0437\u0440\u0430\u0447\u043D\u044B\u0439 \u043F\u043E\u043A\u0440\u043E\u0432",
        pol: "Kaptur krematora",
        sch: "\u5E7D\u7075\u515C\u5E3D",
        fre: "Le Ch\xe2le Spectral",
        bra: "O Capuz do Espectro",
        schema: 937,
        hun: "A Lid\xe9rccsuklya",
        swe: "V\xe5lnadsluvan"
    },
    343: {
        img: "coffin_kit",
        eng: "Coffin Kit",
        rus: "\u041F\u043E\u0445\u043E\u0440\u043E\u043D\u043D\u044B\u0435 \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u043D\u043E\u0441\u0442\u0438",
        pol: "Zestaw trumniarza",
        sch: "\u6C42\u6B7B\u80CC\u5305",
        fre: "Le Cercueil \xe0 dos",
        bra: "O Z\xe9 do Caix\xe3o",
        schema: 938,
        hun: "A Kopors\xf3 K\xe9szlet",
        swe: "Kistkitet"
    },
    344: {
        img: "bat_outta_hell",
        eng: "Bat Outta Hell",
        rus: "\u0414\u0443\u0431\u0438\u043D\u0430 \u0438\u0437 \u0430\u0434\u0430",
        pol: "Piekielna pa\u0142ka",
        sch: "\u6050\u6016\u9AB8\u9AA8",
        fre: "La Batte des Enfers",
        bra: "O Tacom Dem\xf4nio",
        schema: 939,
        hun: "A Pokoli \xdct\u0151",
        ger: "Der Schl\xe4ger aus der H\xf6lle"
    },
    345: {
        img: "festive_holy_mackerel",
        eng: "The Festive Holy Mackerel",
        rus: "\u041F\u043E\u0434\u0434\u0430\u0439 \u043F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u043E\u0433\u043E \u043B\u0435\u0449\u0430",
        pol: "\u015Awi\u0105teczna \u015Awi\u0119ta makrela",
        sch: "\u8282\u65E5\u5C1A\u65B9\u5B9D\u9CAD",
        fre: "Maquereau Sacr\xe9 festif",
        bra: "O Santo Carapau Festivo",
        schema: 999,
        hun: "\xdcnnepi Magass\xe1gos Makr\xe9la",
        swe: "Festliga fina fisken"
    },
    346: {
        img: "festive_axtinguisher",
        eng: "The Festive Axtinguisher",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u041E\u0433\u043D\u0435\u0442\u043E\u043F\u043E\u0440",
        pol: "\u015Awi\u0105teczny Poskramiacz p\u0142omieni",
        sch: "\u8282\u65E5\u706B\u7130\u6218\u65A7",
        fre: "Hachtincteur festif",
        bra: "O Queimachado Festivo",
        schema: 1000,
        hun: "\xdcnnepi Fejhasogat\xf3",
        swe: "Festliga brandslaktaren"
    },
    347: {
        img: "festive_buff_banner",
        eng: "The Festive Buff Banner",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u043E\u0435 \u0412\u0434\u043E\u0445\u043D\u043E\u0432\u043B\u044F\u044E\u0449\u0435\u0435 \u0437\u043D\u0430\u043C\u044F",
        pol: "\u015Awi\u0105teczny Sztandar chwa\u0142y",
        sch: "\u8282\u65E5\u6218\u65D7",
        fre: "Drapeau Buff festif",
        bra: "O Estandarte de Encorajamento Festivo",
        schema: 1001,
        hun: "\xdcnnepi L\xe1z\xedt\xf3 Lobog\xf3",
        swe: "Festliga buffbaneret"
    },
    348: {
        img: "festive_sandvich",
        eng: "The Festive Sandvich",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u0431\u0443\u0442\u0435\u0440\u0431\u0440\u043E\u0434",
        pol: "\u015Awi\u0105teczna kanapka",
        sch: "\u8282\u65E5\u4E09\u660E\u6CBB",
        fre: "Sandvich festif",
        bra: "O Sandviche Festivo",
        schema: 1002,
        hun: "\xdcnnepi Szendvics",
        swe: "Festliga sm\xf6rgosen"
    },
    349: {
        img: "festive_ubersaw",
        eng: "The Festive Ubersaw",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u0430\u044F \u0423\u0431\u0435\u0440-\u043F\u0438\u043B\u0430",
        pol: "\u015Awi\u0105teczna \xdcberpi\u0142a",
        sch: "\u8282\u65E5\u8FC7\u8F7D\u5145\u80FD\u952F",
        fre: "\xdcberscie festive",
        bra: "A \xdcberserra Festiva",
        schema: 1003,
        hun: "\xdcnnepi Agyonf\u0171r\xe9sz",
        swe: "Festliga \xfcbers\xe5gen"
    },
    350: {
        img: "festive_frontier_justice",
        eng: "The Festive Frontier Justice",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u0421\u0430\u043C\u043E\u0441\u0443\u0434",
        pol: "\u015Awi\u0105teczny Samos\u0105d",
        sch: "\u8282\u65E5\u8FB9\u5883\u88C1\u51B3\u8005",
        fre: "Justice Frontali\xe8re festive",
        bra: "A Justi\xe7a Vingadora Festiva",
        schema: 1004,
        hun: "\xdcnnepi \xd6nb\xedr\xe1skod\xf3",
        swe: "Festlig v\xe4sternr\xe4ttvisa"
    },
    351: {
        img: "festive_huntsman",
        eng: "The Festive Huntsman",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u041E\u0445\u043E\u0442\u043D\u0438\u043A",
        pol: "\u015Awi\u0105teczny \u0141owca",
        sch: "\u8282\u65E5\u730E\u4EBA\u77ED\u5F13",
        fre: "Huntsman festif",
        bra: "O Ca\xe7ador Festivo",
        schema: 1005,
        hun: "\xdcnnepi Levad\xe1sz",
        swe: "Festliga j\xe4garen"
    },
    352: {
        img: "festive_ambassador",
        eng: "The Festive Ambassador",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u0410\u043C\u0431\u0430\u0441\u0441\u0430\u0434\u043E\u0440",
        pol: "\u015Awi\u0105teczny Ambasador",
        sch: "\u8282\u65E5\u5927\u4F7F\u624B\u67AA",
        fre: "Ambassadeur festif",
        bra: "O Embaixador Festivo",
        schema: 1006,
        hun: "\xdcnnepi Nagyk\xf6vet",
        swe: "Festliga ambassad\xf6ren"
    },
    353: {
        img: "festive_grenade_launcher",
        eng: "Festive Grenade Launcher",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u0433\u0440\u0430\u043D\u0430\u0442\u043E\u043C\u0451\u0442",
        pol: "\u015Awi\u0105teczny granatnik",
        sch: "\u8282\u65E5\u69B4\u5F39\u53D1\u5C04\u5668",
        fre: "Lance-grenades festif",
        bra: "Lan\xe7a-Granadas Festivo",
        schema: 1007,
        hun: "\xdcnnepi Gr\xe1n\xe1tvet\u0151",
        swe: "Festliga granatkastaren"
    },
    354: {
        img: "winter_wonderland_wrap",
        eng: "Winter Wonderland Wrap",
        rus: "\u0428\u0430\u0440\u0444 \u0437\u0438\u043C\u043D\u0438\u0445 \u0447\u0443\u0434\u0435\u0441",
        pol: "Szal \u015Bnie\u017Cnego szale\u0144stwa",
        sch: "\u5947\u5E7B\u51AC\u65E5\u9762\u7F69",
        fre: "L'\xe9charpe du r\xeave hivernal",
        bra: "O Esquiador Esquentado",
        schema: 976,
        hun: "A T\xe9li T\xfcnd\xe9rorsz\xe1gi Takar\xf3",
        swe: "Vitt vinterland-sjal"
    },
    355: {
        img: "cut_throat_concierge",
        eng: "Cut Throat Concierge",
        rus: "\u041A\u043E\u043D\u0441\u044C\u0435\u0440\u0436-\u0443\u0431\u0438\u0439\u0446\u0430",
        pol: "Szumowina Szwajcar",
        sch: "\u5272\u5589\u770B\u95E8\u4EBA",
        fre: "Le groom assassin",
        bra: "O Porteiro Degolador",
        schema: 977,
        hun: "A Hal\xe1li Hotelport\xe1s",
        swe: "Den strupsk\xe4rande portvakten"
    },
    356: {
        img: "der_wintermantel",
        eng: "Der Wintermantel",
        rus: "\u0414\u0435\u0440 \u0412\u0438\u043D\u0442\u0435\u0440\u043C\u0430\u043D\u0442\u0435\u043B\u044C",
        pol: "Der Wintermantel",
        sch: "\u51AC\u5B63\u5927\u8863",
        fre: "Der Wintermantel",
        bra: "Der Wintermantel",
        schema: 978
    },
    357: {
        img: "cool_breeze",
        eng: "Cool Breeze",
        rus: "\u041E\u0441\u0432\u0435\u0436\u0430\u044E\u0449\u0438\u0439 \u0441\u043A\u0432\u043E\u0437\u043D\u044F\u043A",
        pol: "Zimny zefirek",
        sch: "\u51B7\u98CE",
        fre: "La bise",
        bra: "A Brisa Fresca",
        schema: 979,
        hun: "A H\u0171s\xedt\u0151 Szell\u0151",
        swe: "Den Svala Brisen"
    },
    358: {
        img: "soldiers_slope_scopers",
        eng: "Soldier's Slope Scopers",
        rus: "\u0421\u043E\u043B\u0434\u0430\u0442\u0441\u043A\u0438\u0435 \u043B\u044B\u0436\u043D\u044B\u0435 \u043E\u0447\u043A\u0438",
        pol: "G\xf3rskie gogle gwardzisty",
        sch: "\u58EB\u5175\u7684\u6ED1\u96EA\u98CE\u955C",
        fre: "Lunettes de ski du Soldier",
        bra: "O Esquiador Estiloso",
        schema: 980,
        hun: "A Katona Lejt\u0151k\xe9mlel\u0151je",
        swe: "Soldatens skidglas\xf6gon"
    },
    359: {
        img: "cold_killer",
        eng: "The Cold Killer",
        rus: "\u0425\u043B\u0430\u0434\u043D\u043E\u043A\u0440\u043E\u0432\u043D\u044B\u0439 \u0443\u0431\u0438\u0439\u0446\u0430",
        pol: "Zimnokrwisty zab\xf3jca",
        sch: "\u51B7\u9762\u6B7B\u795E",
        fre: "Le tueur de sang froid",
        bra: "O Sangue-Frio",
        schema: 981,
        hun: "A Hidegre-tev\u0151",
        swe: "Den Kallblodiga M\xf6rdaren"
    },
    360: {
        img: "docs_holiday",
        eng: "Doc's Holiday",
        rus: "\u0414\u043E\u043A\u0442\u043E\u0440 \u043D\u0430 \u043E\u0442\u0434\u044B\u0445\u0435",
        pol: "Urlop zdrowotny",
        sch: "\u533B\u751F\u7684\u5047\u65E5",
        fre: "Doc Holiday",
        bra: "F\xe9rias do Doutor",
        schema: 982,
        hun: "Szabadnapos Doktor",
        swe: "L\xe4karens semester"
    },
    361: {
        img: "digit_divulger",
        eng: "Digit Divulger",
        rus: "\u0421\u043A\u0430\u0443\u0442\u0441\u043A\u0438\u0435 \u043F\u0430\u043B\u044C\u0447\u0438\u043A\u0438",
        pol: "Palczaste pokazywacze",
        sch: "\u65E0\u6307\u624B\u5957",
        fre: "Mitaines r\xe9v\xe9latrices",
        bra: "O Divulgador de Digitais",
        schema: 983,
        hun: "Az Ujjmutat\xf3",
        swe: "Fingerr\xe4knar-vantar"
    },
    362: {
        img: "tough_stuff_muffs",
        eng: "Tough Stuff Muffs",
        rus: "\u0421\u0443\u0440\u043E\u0432\u044B\u0435 \u043D\u0430\u0443\u0448\u043D\u0438\u0447\u043A\u0438",
        pol: "Najtwardsze nauszniki",
        sch: "\u4E25\u4E25\u5B9E\u5B9E\u62A4\u8033\u5E3D",
        fre: "Cache-oreilles de dur",
        bra: "Ouvidos Aquecidos",
        schema: 984,
        hun: "Durv\xe1n F\xfclv\xe9d\u0151",
        swe: "Tuffa grabbars \xf6ronmuffar"
    },
    363: {
        img: "heavys_hockey_hair",
        eng: "Heavy's Hockey Hair",
        rus: "\u041F\u0440\u0438\u0447\u0435\u0441\u043A\u0430 \u0445\u043E\u043A\u043A\u0435\u0438\u0441\u0442\u0430",
        pol: "Hokejowe hery Grubego",
        sch: "\u673A\u67AA\u624B\u7684\u51B0\u7403\u5934",
        fre: "La nuque longue du Heavy hockeyeur",
        bra: "O Mullet do Marrento",
        schema: 985,
        hun: "\xdct\u0151s \xdcst\xf6k",
        swe: "Heavys hockeyfrilla"
    },
    364: {
        img: "mutton_mann",
        eng: "Mutton Mann",
        rus: "\u041C\u043E\u0445\u043D\u0430\u0442\u044B\u0439 \u041C\u0430\u043D\u043D",
        pol: "Faworyty prawdziwego gentlemanna",
        sch: "\u66FC\u6069\u5F0F\u7F8E\u9B13",
        fre: "Rouflaquettes Mann",
        bra: "As Costeletas do Cavalheiro",
        schema: 986,
        hun: "A Bajos Bark\xf3",
        swe: "Mannliga Polisonger"
    },
    365: {
        img: "mercs_muffler",
        eng: "Merc's Muffler",
        rus: "\u041A\u0430\u0448\u043D\u0435 \u043D\u0430\u0435\u043C\u043D\u0438\u043A\u0430",
        pol: "Arafata najemnika",
        sch: "\u4F63\u5175\u7684\u82B1\u56F4\u5DFE",
        fre: "Le cache-nez du mercenaire",
        bra: "O Cachecol do Mercen\xe1rio",
        schema: 987,
        hun: "A Fagyv\xe9dett Fejvad\xe1sz",
        swe: "Legosoldatens halsduk"
    },
    366: {
        img: "barnstormer",
        eng: "Barnstormer",
        rus: "\u0413\u0440\u043E\u0437\u0430 \u0441\u0430\u0440\u0430\u0435\u0432",
        pol: "Pilotka z polotem",
        sch: "\u9A6C\u620F\u98DE\u884C\u5458",
        fre: "Les lunettes d'aviateur",
        bra: "O Circense Voador",
        schema: 988,
        hun: "A Pajta\xfct\u0151",
        swe: "Ladug\xe5rdsstormaren"
    },
    367: {
        img: "strange_part_snipers_killed",
        eng: "Strange Part: Snipers Killed",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0442\u044B\u0435 \u0441\u043D\u0430\u0439\u043F\u0435\u0440\u044B",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zabici Snajperzy",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u72D9\u51FB\u624B\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Snipers tu\xe9s",
        bra: "Pe\xe7a Estranha: Snipers Mortos",
        schema: 6005,
        hun: "Fura Alkatr\xe9sz: Meg\xf6lt Mesterl\xf6v\xe9szek",
        swe: "M\xe4rklig del: Snipers d\xf6dade"
    },
    368: {
        img: "strange_part_kills_while_ubercharged",
        eng: "Strange Part: Kills While \xdcbercharged",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0439\u0441\u0442\u0432\u0430 \u043F\u043E\u0434 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435\u043C \u0443\u0431\u0435\u0440-\u0437\u0430\u0440\u044F\u0434\u0430",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zabici podczas \xdcbercharge'a",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1AUbercharge \u671F\u95F4\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Victimes pendant une \xdcbercharge",
        bra: "Pe\xe7a Estranha: V\xedtimas durante \xdcberCargas",
        schema: 6037,
        hun: "Fura Alkatr\xe9sz: \xdcberT\xf6lt\xe9s k\xf6zbeni \xf6l\xe9sek",
        swe: "M\xe4rklig del: D\xf6dade som \xfcberladdad"
    },
    369: {
        img: "strange_part_underwater_kills",
        eng: "Strange Part: Underwater Kills",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0439\u0441\u0442\u0432\u0430 \u043F\u043E\u0434 \u0432\u043E\u0434\u043E\u0439",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zabici pod wod\u0105",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u6C34\u4E0B\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Victimes se trouvant sous l'eau",
        bra: "Pe\xe7a Estranha: V\xedtimas Submersas",
        schema: 6036,
        hun: "Fura Alkatr\xe9sz: V\xedz alatti \xf6l\xe9sek",
        swe: "M\xe4rklig del: Undervattensmord"
    },
    370: {
        img: "hotties_hoodie",
        eng: "Hottie's Hoodie",
        rus: "\u041F\u043B\u0430\u043C\u0435\u043D\u043D\u044B\u0439 \u0431\u0430\u043B\u0430\u0445\u043E\u043D",
        pol: "Kaptur przystojniaka",
        sch: "\u706B\u8FA3\u7684\u515C\u5E3D",
        fre: "Sweat du Canon",
        bra: "Cabe\xe7a Quente",
        schema: 377,
        hun: "Pir\xf3ska Kapucnija",
        swe: "Heta Huvan"
    },
    371: {
        img: "surgeons_side_satchel",
        eng: "The Surgeon's Side Satchel",
        rus: "\u041F\u043E\u044F\u0441\u043D\u0430\u044F \u0441\u0443\u043C\u043A\u0430 \u0445\u0438\u0440\u0443\u0440\u0433\u0430",
        pol: "Chlebak chwackiego chirurga",
        sch: "\u5916\u79D1\u533B\u751F\u7684\u968F\u8EAB\u5C0F\u5305",
        fre: "La Sacoche du Chirurgien",
        bra: "A Pochete do Patologista",
        schema: 770,
        hun: "Az Orvosi Oldalt\xe1ska",
        swe: "Kirurgens Kappv\xe4ska"
    },
    372: {
        img: "baby_faces_blaster",
        eng: "Baby Face's Blaster",
        rus: "\u041E\u0431\u0440\u0435\u0437 \u041C\u0430\u043B\u044B\u0448\u0430",
        pol: "Browning Baby Face'a",
        sch: "\u5A03\u5A03\u8138\u7684\u51B2\u51FB\u6CE2",
        fre: "L'Exploseur de T\xeate d'Ange",
        bra: "A Destruidora do Degenerado",
        schema: 772,
        hun: "Babaarc Be\xfct\u0151je",
        swe: "Barnansiktets Bl\xe4strare"
    },
    373: {
        img: "strange_part_pyros_killed",
        eng: "Strange Part: Pyros Killed",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0442\u044B\u0435 \u043F\u043E\u0434\u0436\u0438\u0433\u0430\u0442\u0435\u043B\u0438",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zabici Pyro",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u706B\u7130\u5175\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Pyros tu\xe9s",
        bra: "Pe\xe7a Estranha: Pyros que Voc\xea Matou",
        schema: 6006,
        hun: "Fura Alkatr\xe9sz: Meg\xf6lt Pir\xf3k",
        swe: "M\xe4rklig del: Pyros d\xf6dade"
    },
    374: {
        img: "strange_part_defender_kills",
        eng: "Strange Part: Defender Kills",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0439\u0441\u0442\u0432 \u043F\u0440\u0438 \u0437\u0430\u0449\u0438\u0442\u0435",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zab\xf3jstwa w obronie",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u9632\u5B88\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Victimes en tant que d\xe9fenseur",
        bra: "Pe\xe7a Estranha: Capturadores Mortos",
        schema: 6035,
        hun: "Fura Alkatr\xe9sz: Meg\xf6lt v\xe9d\u0151k",
        swe: "M\xe4rklig del: F\xf6rsvarsmord"
    },
    375: {
        img: "counterfeit_billycock",
        eng: "The Counterfeit Billycock",
        rus: "\u041F\u043E\u0434\u0434\u0435\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u0442\u0435\u043B\u043E\u043A",
        pol: "Fa\u0142szywy melonik",
        sch: "\u5192\u724C\u7684\u5706\u9876\u793C\u5E3D",
        fre: "Le chapeau melon contrefait",
        bra: "O Chap\xe9u-Coco Disfar\xe7ado",
        schema: 602,
        hun: "A Kamu Kem\xe9nykalap",
        swe: "Den F\xf6rfalskade Kubben"
    },
    376: {
        img: "desert_marauder",
        eng: "Desert Marauder",
        rus: "\u041F\u0443\u0441\u0442\u044B\u043D\u043D\u044B\u0439 \u043C\u0430\u0440\u043E\u0434\u0435\u0440",
        pol: "Pustynny rabu\u015B",
        sch: "\u8352\u6F20\u5927\u76D7",
        fre: "Le Maraudeur du D\xe9sert",
        bra: "Saqueador do Deserto",
        schema: 400,
        hun: "Sivatagi Fosztogat\xf3",
        swe: "\xd6kenbandit"
    },
    377: {
        img: "fire_axe",
        eng: "Fire Axe",
        rus: "\u041F\u043E\u0436\u0430\u0440\u043D\u044B\u0439 \u0442\u043E\u043F\u043E\u0440",
        pol: "Top\xf3r stra\u017Cacki",
        sch: "\u6D88\u9632\u65A7",
        fre: "Hache",
        bra: "Machado de Inc\xeandio",
        schema: 192,
        hun: "t\u0171zolt\xf3fejsze",
        swe: "Brandyxa"
    },
    378: {
        img: "flying_guillotine",
        eng: "The Flying Guillotine",
        rus: "\u041B\u0435\u0442\u0430\u044E\u0449\u0430\u044F \u0433\u0438\u043B\u044C\u043E\u0442\u0438\u043D\u0430",
        pol: "Lataj\u0105ca gilotyna",
        sch: "\u6DF7\u6DF7\u7684\u83DC\u5200",
        fre: "La guillotine volante",
        bra: "A Guilhotina Voadora",
        schema: 812,
        hun: "A Rep\xfcl\u0151 Nyaktil\xf3",
        swe: "Flygande Giljotinen"
    },
    379: {
        img: "beggars_bazooka",
        eng: "The Beggar's Bazooka",
        rus: "\u0411\u0430\u0437\u0443\u043A\u0430 \u0431\u0440\u043E\u0434\u044F\u0433\u0438",
        pol: "Bazooka biedaka",
        sch: "\u4E5E\u4E10\u7684\u706B\u7BAD\u7B52",
        fre: "Bazooka du mendiant",
        bra: "O Lan\xe7a-Foguetes do Lament\xe1vel",
        schema: 730,
        hun: "A Kacatvet\u0151",
        swe: "Den Ruinerades Raketgev\xe4r"
    },
    380: {
        img: "strange_part_medics_killed",
        eng: "Strange Part: Medics Killed",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0442\u044B\u0435 \u043C\u0435\u0434\u0438\u043A\u0438",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zabici Medycy",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u533B\u751F\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Medics tu\xe9s",
        bra: "Pe\xe7a Estranha: Medics Mortos",
        schema: 6007,
        hun: "Fura Alkatr\xe9sz: Meg\xf6lt Szanit\xe9cek",
        swe: "M\xe4rklig del: Medics d\xf6dade"
    },
    381: {
        img: "strange_part_tanks_destroyed",
        eng: "Strange Part: Tanks Destroyed",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u043D\u0438\u0447\u0442\u043E\u0436\u0435\u043D\u043D\u044B\u0435 \u0442\u0430\u043D\u043A\u0438",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zniszczone czo\u0142gi",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u5766\u514B\u6467\u6BC1\u6570",
        fre: "Pi\xe8ce \xe9trange : Tanks d\xe9truits",
        bra: "Pe\xe7a Estranha: Tanques Destru\xeddos",
        schema: 6038,
        hun: "Fura Alkatr\xe9sz: Megsemmis\xedtett tankok",
        swe: "M\xe4rklig del: Pansarvagnar f\xf6rst\xf6rda"
    },
    382: {
        img: "strange_part_long_distance_kills",
        eng: "Strange Part: Long-Distance Kills",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0439\u0441\u0442\u0432\u0430 \u0438\u0437\u0434\u0430\u043B\u0435\u043A\u0430",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zab\xf3jstwa z du\u017Cej odleg\u0142o\u015Bci",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u8FDC\u8DDD\u79BB\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Victimes \xe0 longue distance",
        bra: "Pe\xe7a Estranha: Mortes a Longa Dist\xe2ncia",
        schema: 6039,
        hun: "Fura Alkatr\xe9sz: \xd6l\xe9sek nagy t\xe1vols\xe1gb\xf3l",
        swe: "M\xe4rklig del: D\xf6dade p\xe5 l\xe5ngt avst\xe5nd"
    },
    383: {
        img: "modest_pile_of_hat",
        eng: "Modest Pile of Hat",
        rus: "\u041D\u0435\u0431\u043E\u043B\u044C\u0448\u043E\u0439 \u043D\u0430\u0431\u043E\u0440 \u0448\u043B\u044F\u043F",
        pol: "Skromny stos kapelusza",
        sch: "\u4F4E\u8C03\u5185\u655B\u7684\u4E00\u5E3D\u4E4B\u67F1",
        fre: "Modeste pile de chapeaux",
        bra: "Pilha Modesta de Chap\xe9u",
        schema: 139,
        hun: "Szer\xe9ny Kalapkupac",
        swe: "Anspr\xe5ksl\xf6s H\xf6g Av Hatt"
    },
    384: {
        img: "neon_annihilator",
        eng: "The Neon Annihilator",
        rus: "\u041D\u0435\u043E\u043D\u043E\u0432\u044B\u0439 \u0430\u043D\u043D\u0438\u0433\u0438\u043B\u044F\u0442\u043E\u0440",
        pol: "Neonowy niszczyciel",
        sch: "\u9713\u8679\u6740\u624B",
        fre: "Le N\xe9onhilateur",
        bra: "O Aniquilador Ne\xf4nico",
        schema: 813,
        hun: "A Neon Megsemmis\xedt\u0151",
        swe: "Neonf\xf6rintaren"
    },
    385: {
        img: "mann_co_painting_set",
        eng: "Mann Co. Painting Set",
        rus: "\u041D\u0430\u0431\u043E\u0440 \u043A\u0440\u0430\u0441\u043E\u043A \u043E\u0442 \u041C\u0430\u043D\u043D \u041A\u043E",
        pol: "Zestaw farb Mann Co.",
        sch: "\u66FC\u6069\u516C\u53F8\u6CB9\u6F06\u5957\u88C5",
        fre: "Coffret de peinture Mann Co.",
        bra: "Kit de Pintura da Mann Co.",
        schema: 1027,
        hun: "Mann Co. Fest\u0151k\xe9szlet",
        swe: "Mann Co. M\xe5larset"
    },
    386: {
        img: "bolt_boy",
        eng: "Bolt Boy",
        rus: "\u0412\u043E\u043B\u044C\u0442-\u043F\u0430\u0440\u0435\u043D\u044C",
        pol: "Bolt Boy",
        sch: "\u87BA\u6813\u5C0F\u5B50",
        fre: "Le Bolt Boy",
        bra: "O Garoto Robonk",
        schema: 30027,
        hun: "Vill\xe1msr\xe1c",
        swe: "Bultpojken"
    },
    387: {
        img: "bonk_leadwear",
        eng: "Bonk Leadwear",
        rus: '\u0421\u0432\u0438\u043D\u0446\u043E\u0432\u044B\u0439 \u0448\u043B\u0435\u043C "\u0411\u043E\u043D\u043A"',
        pol: "O\u0142owiowy Bonk",
        sch: "\u996E\u6599\u94C5\u76D4",
        fre: "Casque Bonk en Plomb",
        bra: "Energ\xe9tico Bonk",
        schema: 30030,
        hun: "Poff! Villanysisak",
        swe: "Blytung Bonk"
    },
    388: {
        img: "bot_dogger",
        eng: "Bot Dogger",
        rus: "\u0411\u043E\u0442-\u0434\u043E\u0433\u0449\u0438\u043A",
        pol: "Botdoggista",
        sch: "\u673A\u5668\u70ED\u72D7\u5E3D",
        fre: "Le Bot Dog",
        bra: "O Circuit\xe3o Quente",
        schema: 30018,
        hun: "A Bot-Dogos",
        swe: "Korvbotten"
    },
    389: {
        img: "ye_oiled_baker_boy",
        eng: "Ye Oiled Baker Boy",
        rus: "\u041A\u0435\u043F\u043A\u0430 \u0440\u043E\u0431\u043E-\u0433\u0430\u0437\u0435\u0442\u0447\u0438\u043A\u0430",
        pol: "Usmarowana czapka gazeciarza",
        sch: "\u6D82\u6EE1\u673A\u6CB9\u7684\u8001\u5F0F\u62A5\u7AE5\u5E3D",
        fre: "Le M\xe9cha-Gavroche Huil\xe9",
        bra: "Padeirinho, bip bop!",
        schema: 30019,
        hun: "Roborikkancs-sapka",
        swe: "Oljeknyckarkeps"
    },
    390: {
        img: "full_metal_drill_hat",
        eng: "Full Metal Drill Hat",
        rus: "\u0426\u0435\u043B\u044C\u043D\u043E\u043C\u0435\u0442\u0430\u043B\u043B\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043A\u043E\u043C\u043F\u0430\u043D\u0435\u0439\u0441\u043A\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "Metalowy kapelusz musztry",
        sch: "\u5168\u91D1\u5C5E\u64CD\u7EC3\u5E3D",
        fre: "Le Sergent Instructeur 2.0",
        bra: "O Chapel\xe3o de Chumbo",
        schema: 30026,
        hun: "\u0150rmesteri Vaskalap",
        swe: "Helmantlad \xf6vningshatt"
    },
    391: {
        img: "soldiers_sparkplug",
        eng: "Soldier's Sparkplug",
        rus: "\u0421\u043E\u043B\u0434\u0430\u0442\u0441\u043A\u0430\u044F \u0441\u0432\u0435\u0447\u0430",
        pol: "\u015Awieca sier\u017Canta",
        sch: "\u58EB\u5175\u7684\u706B\u82B1\u585E",
        fre: "Bougie d'allumage du Soldier",
        bra: "Plugue do Soldier",
        schema: 30033,
        hun: "Katonai Gy\xfajt\xf3gyertya",
        swe: "Soldatens t\xe4ndstift"
    },
    392: {
        img: "steel_shako",
        eng: "Steel Shako",
        rus: "\u0421\u0442\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0438\u0432\u0435\u0440",
        pol: "Stalowe czako",
        sch: "\u94A2\u5236\u65AF\u6258\u7279\u519B\u5E3D",
        fre: "Fer shako",
        bra: "Shako Rob\xf3tico",
        schema: 30017,
        hun: "Ac\xe9lcs\xe1k\xf3",
        swe: "St\xe5lshako"
    },
    393: {
        img: "tyrantium_helmet",
        eng: "Tyrantium Helmet",
        rus: "\u0428\u043B\u0435\u043C \u0438\u0437 \u0432\u0438\u043A\u0438\u043D\u0433\u0438\u044F",
        pol: "He\u0142m z tyrantynium",
        sch: "\u66B4\u5143\u7D20\u5934\u76D4",
        fre: "Casque de tyrantium",
        bra: "O Elmo de Tir\xe2nio",
        schema: 30014,
        hun: "Zsarnokium Sisak",
        swe: "Tyrantiumhj\xe4lm"
    },
    394: {
        img: "bolted_birdcage",
        eng: "Bolted Birdcage",
        rus: "\u041A\u043B\u0435\u0442\u043A\u0430 \u043C\u0435\u0445\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043F\u0442\u0438\u0447\u043A\u0438",
        pol: "Poskr\u0119cana klatka dla ptak\xf3w",
        sch: "\u91D1\u5C5E\u9E1F\u7B3C",
        fre: "La voli\xe8re boulonn\xe9e",
        bra: "A Gaiola Parafusada",
        schema: 30057,
        hun: "A Szegecselt Kalitka",
        swe: "Fastbultade f\xe5gelburen"
    },
    395: {
        img: "electric_escorter",
        eng: "Electric Escorter",
        rus: "\u041D\u0430\u0432\u0438\u0433\u0430\u0442\u043E\u0440 \u043D\u0430\u043A\u0430\u043B\u0438\u0432\u0430\u043D\u0438\u044F",
        pol: "Elektryczny eskorter",
        sch: "\u6307\u8DEF\u7684\u706F\u6CE1\u5934",
        fre: "L'escorte \xe9lectrique",
        bra: "A Luz no Fio do T\xfanel",
        schema: 30025,
        hun: "Az Elektromos \xc9szvil\xe1g\xedt\xe1s",
        swe: "Elektriska eskorten"
    },
    396: {
        img: "filamental",
        eng: "Filamental",
        rus: "\u041D\u0438\u0442\u044C \u043D\u0430\u043A\u0430\u043B\u0430",
        pol: "\u017Barniko\u0142ak",
        sch: "\u706F\u6CE1\u9762\u7F69",
        fre: "Le Filamental",
        bra: "Filamental",
        schema: 30036,
        hun: "J\xf3f\xe9ny\u0171 Jelen\xe9s",
        swe: "Sj\xe4lagl\xf6den"
    },
    397: {
        img: "firewall_helmet",
        eng: "Firewall Helmet",
        rus: "\u0428\u043B\u0435\u043C-\u0431\u0440\u0430\u043D\u0434\u043C\u0430\u0443\u044D\u0440",
        pol: "He\u0142m zapory ogniowej",
        sch: "\u9632\u706B\u5899\u5934\u76D4",
        fre: "Casque pare-feu",
        bra: "O Capacete de Firewall",
        schema: 30038,
        hun: "T\u0171zfal-sisak",
        swe: "Brandv\xe4ggshj\xe4lmen"
    },
    398: {
        img: "googol_glass_eyes",
        eng: "Googol Glass Eyes",
        rus: "\u0412\u0437\u0433\u043B\u044F\u0434 \u0433\u0443\u0433\u043E\u043B-\u0433\u043B\u0430\u0437",
        pol: "Gogle Googol Glass",
        sch: "\u8C37\u9E3D\u773C\u955C",
        fre: "Proth\xe8se pour Vue pixellis\xe9e",
        bra: "Cad\xea?",
        schema: 30053,
        hun: "A Googol \xdcvegszemek",
        swe: "Googolglas\xf6gonen"
    },
    399: {
        img: "metal_slug",
        eng: "Metal Slug",
        rus: "\u0421\u0442\u0430\u043B\u044C\u043D\u043E\u0439 \u0441\u043B\u0438\u0437\u0435\u043D\u044C",
        pol: "Metalo\u015Blimak",
        sch: "\u5408\u91D1\u9F3B\u6D95\u866B",
        fre: "L'Envahisseur Enc\xe9phale",
        bra: "A Lesma de Metal",
        schema: 30028,
        hun: "A F\xe9msz\xedv\xf3",
        swe: "Metallsnigeln"
    },
    400: {
        img: "plumbers_pipe",
        eng: "Plumber's Pipe",
        rus: "\u0413\u0440\u0443\u0431\u043E\u0441\u0442\u044C \u0441\u0430\u043D\u0442\u0435\u0445\u043D\u0438\u043A\u0430",
        pol: "Rura hydrauliczna",
        sch: "\u7BA1\u9053\u5DE5\u7684\u7BA1\u5B50",
        fre: "Tuyau du Plombier",
        bra: "Of\xedcio do Encanador",
        schema: 30022,
        hun: "Pump\xe1s Cs\u0151k\xf6ny\xf6ke",
        swe: "R\xf6rmokarens R\xf6r"
    },
    401: {
        img: "pyros_boron_beanie",
        eng: "Pyro's Boron Beanie",
        rus: "\u0411\u043E\u0440\u043D\u0430\u044F \u0448\u0430\u043F\u043E\u0447\u043A\u0430 \u043F\u043E\u0434\u0436\u0438\u0433\u0430\u0442\u0435\u043B\u044F",
        pol: "Wolframowy wirniczek Pyro",
        sch: "\u706B\u7130\u5175\u7684\u787C\u5236\u7AE5\u5E3D",
        fre: "Bonnet en Bore du Pyro",
        bra: "O Pyroc\xf3ptero de Boro",
        schema: 30040,
        hun: "Pir\xf3 Platina Propellere",
        swe: "Pyros borm\xf6ssa"
    },
    402: {
        img: "respectless_robo_glove",
        eng: "Respectless Robo-Glove",
        rus: "\u041D\u0430\u0433\u043B\u0430\u044F \u0440\u043E\u0431\u043E-\u043F\u0435\u0440\u0447\u0430\u0442\u043A\u0430",
        pol: "Niepowa\u017Cna robor\u0119kawica",
        sch: "\u908B\u9062\u7684\u673A\u5668\u624B\u5957",
        fre: "Gant robotique ridicule",
        bra: "M\xe3o Rob\xf3tica Pat\xe9tica",
        schema: 30039,
        hun: "G\xfanyos G\xe9pkeszty\u0171",
        swe: "Respektl\xf6s robothandske"
    },
    403: {
        img: "rusty_reaper",
        eng: "Rusty Reaper",
        rus: "\u0420\u0436\u0430\u0432\u044B\u0439 \u0436\u043D\u0435\u0446",
        pol: "Rdzawy \u017Cniwiarz",
        sch: "\u94C1\u9508\u6536\u5272\u8005",
        fre: "Le Faucheur Rouill\xe9",
        bra: "O Ceifador Enferrujado",
        schema: 30032,
        hun: "A Rozsd\xe1s Kasz\xe1s",
        swe: "Den rostiga dr\xe4paren"
    },
    404: {
        img: "scrap_sack",
        eng: "Scrap Sack",
        rus: "\u0420\u0430\u043D\u0435\u0446 \u0441 \u043C\u0435\u0442\u0430\u043B\u043B\u043E\u043B\u043E\u043C\u043E\u043C",
        pol: "Szmelcowa sakwa",
        sch: "\u5E9F\u94C1\u5305",
        fre: "Le Sac de Ferraille",
        bra: "A Mochila de Sucata",
        schema: 30020,
        hun: "A Hullad\xe9kzs\xe1k",
        swe: "Sops\xe4cken"
    },
    405: {
        img: "bolted_bicorne",
        eng: "Bolted Bicorne",
        rus: "\u041A\u043B\u0451\u043F\u0430\u043D\u0430\u044F \u0434\u0432\u0443\u0443\u0433\u043E\u043B\u043A\u0430",
        pol: "Blaszany bikorn",
        sch: "\u87BA\u6813\u6D77\u76D7\u7684\u53CC\u89D2\u5E3D",
        fre: "Le bicorne boulonn\xe9",
        bra: "O Bic\xf3rnio Parafusado",
        schema: 30034,
        hun: "A Megr\xe1z\xf3 Martal\xf3c",
        swe: "Sj\xf6r\xf6varens st\xe5lhatt"
    },
    406: {
        img: "bolted_bombardier",
        eng: "Bolted Bombardier",
        rus: "\u0411\u043E\u043C\u0431\u0430\u0440\u0434\u0438\u0440 \u043D\u0430 \u0431\u043E\u043B\u0442\u0430\u0445",
        pol: "Skuty bombardier",
        sch: "\u70B8\u5F39\u5175\u7684\u87BA\u6813\u82B1\u767D\u80E1\u987B",
        fre: "Le Bombardier Boulonn\xe9",
        bra: "O Bombardeiro Brilhante",
        schema: 30011,
        hun: "A Szegecselt T\xfcz\xe9r",
        swe: "Bultade spr\xe4ngaren"
    },
    407: {
        img: "broadband_bonnet",
        eng: "Broadband Bonnet",
        rus: "\u0428\u0438\u0440\u043E\u043A\u043E\u043F\u043E\u043B\u043E\u0441\u043D\u044B\u0439 \u0431\u0435\u0440\u0435\u0442",
        pol: "Szerokopasmowy Szkot",
        sch: "\u65E0\u7EBF\u5BBD\u5E26\u8F6F\u5E3D",
        fre: "Le Bonnet \xe0 Haut D\xe9bit",
        bra: "A Boina Parab\xf3lica",
        schema: 30029,
        hun: "A Sz\xe9les S\xe1v\xfa Sapka",
        swe: "Bredbandsh\xe4ttan"
    },
    408: {
        img: "cyborg_stunt_helmet",
        eng: "Cyborg Stunt Helmet",
        rus: "\u0428\u043B\u0435\u043C \u043A\u0438\u0431\u043E\u0440\u0433\u0430-\u043A\u0430\u0441\u043A\u0430\u0434\u0435\u0440\u0430",
        pol: "He\u0142m cyborga-kaskadera",
        sch: "\u673A\u5668\u4EBA\u7279\u6280\u5934\u76D4",
        fre: "Le Casqu-adeur cyborg",
        bra: "O Capacete do Dubl\xea Ciborgue",
        schema: 30024,
        hun: "A Kiborgkaszkad\u0151r-sisak",
        swe: "Cyborgens stunthj\xe4lm"
    },
    409: {
        img: "fr_0",
        eng: "FR-0",
        rus: "\u0410\u0424\u0420-0",
        pol: "FR-0",
        sch: "\u96F6\u5F0F\u7206\u70B8\u5934",
        fre: "La FR-0",
        bra: "O AFR-0",
        schema: 30016,
        hun: "Az A-FR0",
        swe: "AFR-0"
    },
    410: {
        img: "hdmi_patch",
        eng: "HDMI Patch",
        rus: "HDMI-\u0437\u0430\u043F\u043B\u0430\u0442\u043A\u0430",
        pol: "Przepaska HDMI",
        sch: "\u9AD8\u6E05\u8865\u4E01",
        fre: "Le cache HDMI",
        bra: "O Tapa-Olho HDMI",
        schema: 30010,
        hun: "A HDMI Szemk\xf6t\u0151",
        swe: "HDMI-uppdateringen"
    },
    411: {
        img: "pure_tin_capotain",
        eng: "Pure Tin Capotain",
        rus: "\u041A\u043E\u043B\u043F\u0430\u043A \u0438\u0437 \u0436\u0435\u0441\u0442\u044F\u043D\u043A\u0438",
        pol: "Pirytowy purytanin",
        sch: "\u7EAF\u9521\u730E\u5DEB\u5E3D",
        fre: "L'Inquisiteur en aluminium pur",
        bra: "A Cartola de Lat\xe3o",
        schema: 30021,
        hun: "A Villamos Telepes",
        swe: "Ren Tennkapott"
    },
    412: {
        img: "scrumpy_strongbox",
        eng: "Scrumpy Strongbox",
        rus: "\u0421\u0435\u0439\u0444 \u0441\u043E \u0441\u043A\u043E\u0442\u0447\u0435\u043C",
        pol: "Sejf pe\u0142en szkockiej",
        sch: "\u82F9\u679C\u70C8\u9152\u4FDD\u9669\u7BB1",
        fre: "Le Coffre-fort de Scrumpy",
        bra: "A Caixa-Forte de Cidra",
        schema: 30055,
        hun: "A K\xf3dolt Kincsesl\xe1da",
        swe: "Spritkassask\xe5pet"
    },
    413: {
        img: "strontium_stove_pipe",
        eng: "Strontium Stove Pipe",
        rus: "\u0421\u0442\u0440\u043E\u043D\u0446\u0438\u0435\u0432\u044B\u0439 \u0446\u0438\u043B\u0438\u043D\u0434\u0440",
        pol: "Strontowy szapoklak",
        sch: "\u9536\u5143\u7D20\u5927\u793C\u5E3D",
        fre: "Le Haut-de-forme en Strontium",
        bra: "A Cartola de Estr\xf4ncio",
        schema: 30037,
        hun: "A Cink Cilinder",
        swe: "Skottens strontiumhatt"
    },
    414: {
        img: "bunsen_brave",
        eng: "Bunsen Brave",
        rus: "\u0413\u043E\u0440\u0434\u043E\u0441\u0442\u044C \u0411\u0443\u043D\u0437\u0435\u043D\u0430",
        pol: "Bunsenimo",
        sch: "\u706B\u7130\u5927\u914B\u957F",
        fre: "Le brave Bunsen",
        bra: "O Cacique das Chamas",
        schema: 30054,
        hun: "A L\xe1ngf\u0151n\xf6k",
        swe: "Bunsenkrigaren"
    },
    415: {
        img: "gridiron_guardian",
        eng: "Gridiron Guardian",
        rus: "\u0411\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A",
        pol: "Oksydowany obro\u0144ca",
        sch: "\u6A44\u6984\u7403\u573A\u4FDD\u536B\u8005",
        fre: "Le Gardien du Stade",
        bra: "O Zagueiro de Ferro",
        schema: 30013,
        hun: "Az Ac\xe9los Arcv\xe9d\u0151",
        swe: "Amerikansk j\xe4rnhj\xe4lm"
    },
    416: {
        img: "titanium_towel",
        eng: "Titanium Towel",
        rus: "\u041D\u0435\u0440\u0436\u0430\u0432\u0435\u044E\u0449\u0435\u0435 \u043F\u043E\u043B\u043E\u0442\u0435\u043D\u0446\u0435",
        pol: "Ferromagnetyczny r\u0119cznik",
        sch: "\u949B\u5236\u6BDB\u5DFE",
        fre: "La Serviette en Titane",
        bra: "A Toalha Antioxidante",
        schema: 30012,
        hun: "A Tit\xe1n T\xf6r\xf6lk\xf6z\u0151",
        swe: "Titanhandduken"
    },
    417: {
        img: "tungsten_toque",
        eng: "Tungsten Toque",
        rus: "\u0428\u0430\u043F\u043A\u0430 \u0442\u0443\u0433\u043E\u043F\u043B\u0430\u0432\u043A\u043E\u0433\u043E \u043F\u0430\u0440\u043D\u044F",
        pol: "Platynowy pomponik",
        sch: "\u94A8\u5236\u65E0\u8FB9\u5E3D",
        fre: "La tuque de tungst\xe8ne",
        bra: "A Touca de Tungst\xeanio",
        schema: 30049,
        hun: "A Kem\xe9nyrobot Mecha-sapija",
        swe: "Tuffingens volframluva"
    },
    418: {
        img: "data_mining_light",
        eng: "Data Mining Light",
        rus: "\u0424\u043E\u043D\u0430\u0440\u044C \u043F\u043E\u0438\u0441\u043A\u043E\u0432\u0438\u043A\u0430",
        pol: "Lampa dr\u0105\u017Cenia danych",
        sch: "\u6570\u636E\u6316\u6398\u706F",
        fre: "La Lampe d'explorateur de Donn\xe9es",
        bra: "A Luz de Minera\xe7\xe3o de Dados",
        schema: 30051,
        hun: "Adatb\xe1ny\xe1sz-l\xe1mpa",
        swe: "Datautvinningslampan"
    },
    419: {
        img: "dual_core_devil_doll",
        eng: "Dual-Core Devil Doll",
        rus: "\u0414\u0432\u0443\u0445\u044A\u044F\u0434\u0435\u0440\u043D\u0430\u044F \u0434\u044C\u044F\u0432\u043E\u043B\u044C\u0441\u043A\u0430\u044F \u043A\u0443\u043A\u043B\u0430",
        pol: "Dwurdzeniowa diabelska lalka",
        sch: "\u53CC\u6838\u6076\u9B54\u5A03\u5A03",
        fre: "La Poup\xe9e Double-c\u0153ur D\xe9moniaque",
        bra: "O Boneco Demon\xedaco Dual-Core",
        schema: 30056,
        hun: "A K\xe9tmagos K\xe9mb\xe1bu",
        swe: "Dubbelk\xe4rnig dj\xe4vulsdocka"
    },
    420: {
        img: "plug_in_prospector",
        eng: "Plug-In Prospector",
        rus: "\u0423\u0441\u0442\u0430\u0440\u0435\u0432\u0448\u0438\u0439 \u0440\u043E\u0431\u043E\u0442",
        pol: "Poszukiwacz wtyczek",
        sch: "\u63D2\u4EF6\u5F0F\u725B\u4ED4\u5E3D",
        fre: "Le prospecteur connect\xe9",
        bra: "O Garimpeiro de Gadgets",
        schema: 30031,
        hun: "A F\xe9m Szivar",
        swe: "Prospekt\xf6rens pl\xe5th\xe4tta"
    },
    421: {
        img: "teddy_robobelt",
        eng: "Teddy Robobelt",
        rus: "\u0420\u043E\u0431\u043E\u043F\u043E\u044F\u0441 \u0422\u0435\u0434\u0434\u0438",
        pol: "Teddy Robobelt",
        sch: "\u6CF0\u8FEA\u673A\u5668\u718A",
        fre: "Enginounours robotique",
        bra: "Ursinho de Plut\xf4nio",
        schema: 30023,
        swe: "Teddy Robob\xe4lte"
    },
    422: {
        img: "texas_tin_gallon",
        eng: "Texas Tin-Gallon",
        rus: "\u0422\u0435\u0445\u0430\u0441\u0441\u043A\u0430\u044F \u0442\u0435\u0445\u043D\u043E\u0448\u043B\u044F\u043F\u0430",
        pol: "Tytanowy teksa\u0144ski kapelusz",
        sch: "\u5FB7\u5DDE\u9521\u5236\u725B\u4ED4\u5E3D",
        fre: "Chapeau de cowboy en \xe9tain",
        bra: "O Caub\xf3i de Lat\xe3o",
        schema: 30044,
        hun: "Texasi B\xe1dogkalap",
        swe: "Texas Tennboy"
    },
    423: {
        img: "timeless_topper",
        eng: "Timeless Topper",
        rus: "\u041D\u0435\u0441\u0442\u0430\u0440\u0435\u044E\u0449\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "Ponadczasowy cylinder",
        sch: "\u6C38\u6052\u7684\u793C\u5E3D",
        fre: "Le Haut-de-forme Intemporel",
        bra: "A Cartola Atemporal",
        schema: 30035,
        hun: "Az Id\u0151\xe1ll\xf3 Viselet",
        swe: "Sheriffens st\xe5lthet"
    },
    424: {
        img: "byted_beak",
        eng: "Byte'd Beak",
        rus: "\u041B\u0443\u0436\u0435\u043D\u044B\u0439 \u043A\u043B\u044E\u0432",
        pol: "Megabajtowa maska",
        sch: "\u5B57\u8282\u5927\u592B\u7684\u9762\u5177",
        fre: "Le Bec \xe0 Octet",
        bra: "O Bico Booleano",
        schema: 30052,
        hun: "A Pol\xedrozott Pestisdoktor",
        swe: "F\xf6rd\xe4rvad pl\xe5tn\xe4bb"
    },
    425: {
        img: "halogen_head_lamp",
        eng: "Halogen Head Lamp",
        rus: "\u041D\u0430\u043B\u043E\u0431\u043D\u0430\u044F \u0433\u0430\u043B\u043E\u0433\u0435\u043D\u043D\u0430\u044F \u043B\u0430\u043C\u043F\u0430",
        pol: "Halogenowa lampa czo\u0142owa",
        sch: "\u5934\u6234\u5F0F\u5364\u7D20\u706F",
        fre: "Lampe Halog\xe8ne Frontale",
        bra: "L\xe2mpada de Halog\xeanio",
        schema: 30041,
        hun: "Halog\xe9n Fejl\xe1mpa",
        swe: "Halogen-pannlampa"
    },
    426: {
        img: "mecha_medes",
        eng: "Mecha-Medes",
        rus: "\u0410\u0440\u0445\u0438-\u043C\u0435\u0445",
        pol: "Mechamedes",
        sch: "\u963F\u673A\u7C73\u5FB7",
        fre: "Archi-Mech",
        bra: "Meca-medes",
        schema: 30048,
        hun: "Mecha-m\xe9d\xe9sz"
    },
    427: {
        img: "platinum_pickelhaube",
        eng: "Platinum Pickelhaube",
        rus: "\u041F\u043B\u0430\u0442\u0438\u043D\u043E\u0432\u044B\u0439 \u043F\u0438\u043A\u0435\u043B\u044C\u0445\u0435\u043B\u044C\u043C",
        pol: "Platynowa pikielhauba",
        sch: "\u94C2\u91D1\u5C16\u9876\u76D4",
        fre: "Casque \xe0 pointe en platine",
        bra: "O Pickelhaube Platinado",
        schema: 30042,
        hun: "Platina D\xedszsisak",
        swe: "Platinapickelhaube"
    },
    428: {
        img: "practitioners_processing_mask",
        eng: "Practitioner's Processing Mask",
        rus: "\u041C\u0435\u0445\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043C\u0430\u0441\u043A\u0430",
        pol: "Mechaniczna maska internisty",
        sch: "\u533B\u751F\u7684\u6570\u636E\u8C03\u63A7\u53E3\u7F69",
        fre: "Masque de traitement du praticien",
        bra: "M\xe1scara de Processamento do M\xe9dico",
        schema: 30046,
        hun: "Sav\xe1ll\xf3 Seb\xe9szeti Maszk",
        swe: "L\xe4karens robotmunskydd"
    },
    429: {
        img: "steam_pipe",
        eng: "Steam Pipe",
        rus: "\u0412\u044B\u0445\u043B\u043E\u043F\u043D\u0430\u044F \u0442\u0440\u0443\u0431\u043A\u0430",
        pol: "Fajka parowa",
        sch: "\u84B8\u6C7D\u7BA1\u7684\u5927\u95EE\u9898",
        fre: "La pipe \xe0 vapeur",
        bra: "A Engenhoca de Nove Tragadas",
        schema: 30050,
        hun: "A G\u0151zpip\xe1s Feladat",
        swe: "\xc5ngpipan"
    },
    430: {
        img: "titanium_tyrolean",
        eng: "Titanium Tyrolean",
        rus: "\u0422\u0438\u0442\u0430\u043D\u043E\u0432\u0430\u044F \u0442\u0438\u0440\u043E\u043B\u044C\u0441\u043A\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "Tytanowy kapelusz tyrolski",
        sch: "\u949B\u5236\u63D0\u6D1B\u5E3D",
        fre: "Chapeau tyrolien en titane",
        bra: "Tirol\xeas de Tit\xe2nio",
        schema: 30045,
        hun: "Tit\xe1n Tiroli",
        swe: "Gammal titanhatt"
    },
    431: {
        img: "virus_doctor",
        eng: "Virus Doctor",
        rus: "\u0410\u043D\u0442\u0438\u0432\u0438\u0440\u0443\u0441\u043D\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "Antywirus",
        sch: "\u75C5\u6BD2\u533B\u5E3D",
        fre: "Le Docteur Viral",
        bra: "O Doutor Antiv\xedrus",
        schema: 30043,
        hun: "A V\xedrusdoktor",
        swe: "Virusdoktorn"
    },
    432: {
        img: "letchs_led",
        eng: "Letch's LED",
        rus: "\u0418\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440 \u0448\u0435\u043B\u044C\u043C\u0435\u0446\u0430",
        pol: "LEDy lubie\u017Cnika",
        sch: "\u597D\u8272\u4E4B\u5F92\u7684 LED \u773C\u955C",
        fre: "Galurin \xe0 LED licencieuses",
        bra: "O Exterminador El\xe9trico",
        schema: 30002,
        hun: "Letch LED-je",
        swe: "Snuskets nattsyn"
    },
    433: {
        img: "shooters_tin_topi",
        eng: "Shooter's Tin Topi",
        rus: "\u0422\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0448\u043B\u0435\u043C \u0441\u0442\u0440\u0435\u043B\u043A\u0430",
        pol: "Chromowany he\u0142m strzelca",
        sch: "\u5C04\u624B\u7684\u9521\u5236\u906E\u9633\u5E3D",
        fre: "Tireur Colonial d'\xc9tain",
        bra: "Chap\xe9u de Safari Laminado",
        schema: 30005,
        hun: "B\xe1dog Szafari-kalap",
        swe: "Skyttens tin topi"
    },
    434: {
        img: "soldered_sensei",
        eng: "Soldered Sensei",
        rus: "\u0421\u0442\u0430\u043B\u044C\u043D\u0430\u044F \u043F\u043E\u0432\u044F\u0437\u043A\u0430 \u0441\u044D\u043D\u0441\u044D\u044F",
        pol: "Zespawany sensei",
        sch: "\u5927\u5E08\u7684\u94C1\u5E26",
        fre: "Sensei soud\xe9",
        bra: "O Sensei da Solda",
        schema: 30004,
        hun: "Forrasztott Szenszei",
        swe: "Metallm\xe4staren"
    },
    435: {
        img: "base_metal_billycock",
        eng: "Base Metal Billycock",
        rus: "\u041A\u043E\u0442\u0435\u043B\u043E\u043A \u0438\u0437 \u0441\u043F\u043B\u0430\u0432\u043E\u0432",
        pol: "Bezecny metalowy melonik",
        sch: "\u8D31\u91D1\u5C5E\u5C0F\u793C\u5E3D",
        fre: "Chapeau Boulon",
        bra: "Chap\xe9u-Coco de Cobre",
        schema: 30007,
        hun: "Egyszer\u0171 F\xe9m Kem\xe9nykalap",
        swe: "Kubb av grundmetall"
    },
    436: {
        img: "bootleg_base_metal_billycock",
        eng: "Bootleg Base Metal Billycock",
        rus: "\u041F\u043E\u0434\u0434\u0435\u043B\u044C\u043D\u044B\u0439 \u043C\u0435\u0442\u0430\u043B\u043B\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043A\u043E\u0442\u0435\u043B\u043E\u043A",
        pol: "Podrobiony bezecny metalowy melonik",
        sch: "\u76D7\u7248\u7684\u94C1\u76AE\u793C\u5E3D",
        fre: "Chapeau Boulon de contrebande",
        bra: "Chap\xe9u-Coco de Contrabanda Met\xe1lica",
        schema: 30047,
        hun: "Kr\xf3mozott Kem\xe9nykalap-k\xf3pia",
        swe: "O\xe4dla metallkubben"
    },
    437: {
        img: "megapixel_beard",
        eng: "Megapixel Beard",
        rus: "\u041C\u0435\u0433\u0430\u043F\u0438\u043A\u0441\u0435\u043B\u044C\u043D\u0430\u044F \u0431\u043E\u0440\u043E\u0434\u0430",
        pol: "Megapikselowa broda",
        sch: "\u767E\u4E07\u50CF\u7D20\u7EA7\u6444\u50CF\u80E1\u5B50",
        fre: "La Barbe M\xe9gapixel",
        bra: "A Barba Megapixel",
        schema: 30009,
        hun: "A Megapixel Szak\xe1ll",
        swe: "Megapixel-sk\xe4gget"
    },
    438: {
        img: "galvanized_gibus",
        eng: "Galvanized Gibus",
        rus: "\u041E\u0446\u0438\u043D\u043A\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0448\u0430\u043F\u043E\u043A\u043B\u044F\u043A",
        pol: "Cynkowany cylinder",
        sch: "\u9540\u950C\u6298\u53E0\u793C\u5E3D",
        fre: "Le Gibus Galvanis\xe9",
        bra: "A Cartola Met\xe1lica",
        schema: 30003,
        hun: "A Cinkezett Cilinder",
        swe: "Den galvaniserade stormhatten"
    },
    439: {
        img: "modest_metal_pile_of_scrap",
        eng: "Modest Metal Pile of Scrap",
        rus: "\u041D\u0435\u0431\u043E\u043B\u044C\u0448\u043E\u0439 \u043D\u0430\u0431\u043E\u0440 \u043C\u0435\u0442\u0430\u043B\u043B\u043E\u043B\u043E\u043C\u0430",
        pol: "Skromny stalowy stos z\u0142omu",
        sch: "\u4F4E\u8C03\u5185\u655B\u7684\u5E9F\u94C1\u5E3D\u4E4B\u67F1",
        fre: "Modeste pile de ferraille",
        bra: "Bateria Modesta de Chap\xe9us",
        schema: 30001,
        hun: "Szer\xe9ny Hullad\xe9kf\xe9m-kupac",
        swe: "Hyfsad h\xf6g med metallskrot"
    },
    440: {
        img: "noble_nickel_amassment_of_hats",
        eng: "Noble Nickel Amassment of Hats",
        rus: "\u0417\u043D\u0430\u0442\u043D\u0430\u044F \u043A\u0443\u0447\u0430 \u043D\u0438\u043A\u0435\u043B\u0435\u0432\u044B\u0445 \u0448\u043B\u044F\u043F",
        pol: "Zacna kadmowana miara kapeluszy",
        sch: "\u8363\u534E\u5BCC\u8D35\u7684\u954D\u94C1\u5E3D\u4E2D\u5E3D",
        fre: "Pile nobiliaire de couvre-chefs en nickel",
        bra: "Conjunto Niquelado de Chap\xe9us",
        schema: 30006,
        hun: "Nemes Kalapok Nikkelezett Gy\u0171jtem\xe9nye",
        swe: "St\xe5tlig hattansamling i nickel"
    },
    441: {
        img: "towering_titanium_pillar_of_hats",
        eng: "Towering Titanium Pillar of Hats",
        rus: "\u0413\u0438\u0433\u0430\u043D\u0442\u0441\u043A\u0430\u044F \u0442\u0438\u0442\u0430\u043D\u043E\u0432\u0430\u044F \u0431\u0430\u0448\u043D\u044F \u0438\u0437 \u0448\u043B\u044F\u043F",
        pol: "Niebotyczny tytanowy s\u0142up kapeluszy",
        sch: "\u5C42\u53E0\u9AD8\u8038\u7684\u949B\u91D1\u5E3D\u4E4B\u5854",
        fre: "Imposante pile de chapeaux en titane",
        bra: "Pilar Monumental de Chap\xe9us de Tit\xe2nio",
        schema: 30008,
        hun: "Magasan Tornyosul\xf3 Tit\xe1n Kalap-oszlop",
        swe: "Reslig pelare av titanhattar"
    },
    442: {
        img: "battery_canteens",
        eng: "Battery Canteens",
        rus: "\u0410\u043A\u043A\u0443\u043C\u0443\u043B\u044F\u0442\u043E\u0440 \u0431\u043E\u043D\u0443\u0441\u043E\u0432",
        pol: "Mannierki-baterie",
        sch: "\u673A\u5668\u6C34\u58F6",
        fre: "Gourdes Acides",
        bra: "Cantil de Baterias",
        schema: 30015,
        hun: "Akkumul\xe1tor Kulacsok",
        swe: "Batterikantiner"
    },
    443: {
        img: "kukri",
        eng: "Kukri",
        rus: "\u041A\u0443\u043A\u0440\u0438",
        pol: "Kukri",
        sch: "\u53CD\u66F2\u5200",
        fre: "Kukri",
        bra: "Kukri",
        schema: 193
    },
    444: {
        img: "huo_long_heater",
        eng: "The Huo-Long Heater",
        rus: "\u041E\u0433\u043D\u0435\u043D\u043D\u044B\u0439 \u0434\u0440\u0430\u043A\u043E\u043D",
        pol: "Wej\u015Bcie smoka",
        sch: "\u706B\u9F99\u8F6C\u8F6E\u673A\u67AA",
        fre: "Le Radiateur de Huo Long",
        bra: "As Chamas de Huo Long",
        schema: 811,
        hun: "A Huo-Long Bemeleg\xedt\u0151",
        swe: "Elddraksv\xe4rmaren"
    },
    445: {
        img: "enforcer",
        eng: "The Enforcer",
        rus: "\u041F\u0440\u0438\u043D\u0443\u0434\u0438\u0442\u0435\u043B\u044C",
        pol: "Egzekutor",
        sch: "\u6267\u6CD5\u8005",
        fre: "L'Ex\xe9cutant",
        bra: "O Capanga",
        schema: 460,
        hun: "A Behajt\xf3",
        swe: "Verkst\xe4llaren"
    },
    446: {
        img: "strange_part_medics_killed_that_have_full_ubercharge",
        eng: "Strange Part: Medics Killed That Have Full \xdcberCharge",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0442\u044B\u0435 \u043C\u0435\u0434\u0438\u043A\u0438 \u0441 \u043F\u043E\u043B\u043D\u044B\u043C \u0443\u0431\u0435\u0440-\u0437\u0430\u0440\u044F\u0434\u043E\u043C",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zabici Medycy z pe\u0142nym \xdcberCharge",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u6EE1 Ubercharge \u80FD\u91CF\u533B\u751F\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Medics tu\xe9s ayant une \xdcbercharge compl\xe8te",
        bra: "Pe\xe7a Estranha: Medics Mortos com a \xdcberCarga Pronta",
        schema: 6023,
        hun: "Fura alkatr\xe9sz: Teljes \xdcberT\xf6lt\xe9ssel meg\xf6lt Szanit\xe9cek",
        swe: "M\xe4rklig del: D\xf6dade Medics som hade full \xfcberladdning"
    },
    447: {
        img: "strange_part_giant_robots_destroyed",
        eng: "Strange Part: Giant Robots Destroyed",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u043D\u0438\u0447\u0442\u043E\u0436\u0435\u043D\u043D\u044B\u0435 \u0433\u0438\u0433\u0430\u043D\u0442\u0441\u043A\u0438\u0435 \u0440\u043E\u0431\u043E\u0442\u044B",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zniszczone gigantyczne roboty",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u5DE8\u578B\u673A\u5668\u4EBA\u6467\u6BC1\u6570",
        fre: "Pi\xe8ce \xe9trange : Robots g\xe9ants d\xe9truits",
        bra: "Pe\xe7a Estranha: Rob\xf4s Gigantes Destru\xeddos",
        schema: 6028,
        hun: "Fura Alkatr\xe9sz: Elpuszt\xedtott \xf3ri\xe1s-robotok",
        swe: "M\xe4rklig del: F\xf6rst\xf6rda j\xe4tterobotar"
    },
    448: {
        img: "fast_learner",
        eng: "The Fast Learner",
        rus: "\u0421\u043F\u043E\u0441\u043E\u0431\u043D\u044B\u0439 \u0443\u0447\u0435\u043D\u0438\u043A",
        pol: "B\u0142ysk geniuszu",
        sch: "\u901F\u5B66\u8005",
        fre: "L'\xe9clair de g\xe9nie",
        bra: "O Aluno Veloz",
        schema: 722,
        hun: "A Gyorsan Tanul\xf3",
        swe: "Den L\xe4ttl\xe4rde"
    },
    449: {
        img: "disciplinary_action",
        eng: "The Disciplinary Action",
        rus: "\u0414\u0438\u0441\u0446\u0438\u043F\u043B\u0438\u043D\u0430\u0440\u043D\u043E\u0435 \u0432\u0437\u044B\u0441\u043A\u0430\u043D\u0438\u0435",
        pol: "Post\u0119powanie dyscyplinarne",
        sch: "\u6307\u6325\u5B98\u7684\u519B\u97AD",
        fre: "L'Action Disciplinaire",
        bra: "A A\xe7\xe3o Disciplinar",
        schema: 447,
        hun: "A Fegyelmi Elj\xe1r\xe1s",
        swe: "Disciplin\xe5tg\xe4rden"
    },
    450: {
        img: "loose_cannon",
        eng: "The Loose Cannon",
        rus: "\u041F\u0443\u0448\u043A\u0430 \u0431\u0435\u0437 \u043B\u0430\u0444\u0435\u0442\u0430",
        pol: "Dzia\u0142o nawalone",
        sch: "\u8131\u7F30\u5DE8\u70AE",
        fre: "Danger public",
        bra: "Pavio Curto",
        schema: 996,
        hun: "Elszabadult \xc1gy\xfa",
        swe: "Laddad kanon"
    },
    451: {
        img: "fan_o_war",
        eng: "The Fan O'War",
        rus: "\u0412\u0435\u0435\u0440 \u0432\u043E\u0439\u043D\u044B",
        pol: "Wachlarz wojenny",
        sch: "\u519B\u914D\u6247",
        fre: "L'\xe9vent-taille",
        bra: "Leque d'Guerra",
        schema: 355,
        hun: "Hal\xe1li Legyez\u0151",
        swe: "Krigsfj\xe4der"
    },
    452: {
        img: "strangifier",
        eng: "#ITEM# Strangifier",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u043E\u0434\u0435\u043B",
        pol: "Kuriozonator: #ITEM#",
        sch: "#ITEM# \u5947\u5F02\u8F6C\u5316\u836F\u5242",
        fre: "\xc9trangifiant: #ITEM#",
        bra: "#ITEM# Estranhificador",
        schema: 6522,
        hun: "#ITEM# Fur\xe1s\xedt\xf3",
        swe: "#ITEM# M\xe4rkligifierare"
    },
    453: {
        img: "strange_part_kills_with_a_taunt_attack",
        eng: "Strange Part: Kills with a Taunt Attack",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0439\u0441\u0442\u0432\u0430 \u043D\u0430\u0441\u043C\u0435\u0448\u043A\u043E\u0439",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zab\xf3jstwa drwin\u0105",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u5632\u8BBD\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Victimes d'attaques par raillerie",
        bra: "Pe\xe7a Estranha: Provoca\xe7\xf5es Fatais",
        schema: 6051,
        hun: "Fura Alkatr\xe9sz: Besz\xf3l\xe1s-t\xe1mad\xe1ssal meg\xf6lt ellenfelek",
        swe: "M\xe4rklig del: D\xf6dade med h\xe5nattacker"
    },
    454: {
        img: "brotherhood_of_arms",
        eng: "The Brotherhood of Arms",
        rus: "\u0411\u0440\u0430\u0442\u044C\u044F \u043F\u043E \u043E\u0440\u0443\u0436\u0438\u044E",
        pol: "Braterstwo broni",
        sch: "\u5144\u5F1F\u4F1A\u515C\u5E3D",
        fre: "Le fr\xe8re d'armes",
        bra: "A Fraternidade das Ruas",
        schema: 30066,
        hun: "A Cs\xf6k\xf6ny\xf6s Csuklya",
        swe: "Broderluvan"
    },
    455: {
        img: "well_rounded_rifleman",
        eng: "The Well-Rounded Rifleman",
        rus: "\u0421\u043A\u0440\u0443\u0433\u043B\u0435\u043D\u043D\u044B\u0439 \u0441\u0442\u0440\u0435\u043B\u043E\u043A",
        pol: "Satysfakcjonuj\u0105cy strzelec",
        sch: "\u72D9\u51FB\u624B\u5706\u5E3D",
        fre: "Le fusilier accompli",
        bra: "O Atirador Completo",
        schema: 30067,
        hun: "A Felk\xe9sz\xfclt Fejl\xf6v\xe9sz",
        swe: "Den helt\xe4ckande infanteristen"
    },
    456: {
        img: "breakneck_baggies",
        eng: "The Breakneck Baggies",
        rus: "\u041E\u043F\u0430\u0441\u043D\u044B\u0435 \u0448\u0442\u0430\u043D\u0438\u0448\u043A\u0438",
        pol: "Karko\u0142omne szarawary",
        sch: "\u5DE1\u903B\u8005\u957F\u88E4",
        fre: "Les baggies \xe0 grande vitesse",
        bra: "O Esportista Expresso",
        schema: 30068,
        hun: "A Nyakt\xf6r\u0151 Mack\xf3als\xf3",
        swe: "Nackbrytarbyxor"
    },
    457: {
        img: "powdered_practitioner",
        eng: "The Powdered Practitioner",
        rus: "\u041F\u0440\u0438\u043F\u0443\u0434\u0440\u0435\u043D\u043D\u044B\u0439 \u0442\u0435\u0440\u0430\u043F\u0435\u0432\u0442",
        pol: "Przypudrowany konsyliarz",
        sch: "\u6251\u7C89\u884C\u5BB6",
        fre: "Le Praticien Emperruqu\xe9",
        bra: "O M\xe9dico Empoado",
        schema: 30069,
        hun: "A Kip\xfaderezett Kezel\u0151orvos",
        swe: "Den pudrade praktikern"
    },
    458: {
        img: "pocket_pyro",
        eng: "The Pocket Pyro",
        rus: "\u041A\u0430\u0440\u043C\u0430\u043D\u043D\u044B\u0439 \u043F\u043E\u0434\u0436\u0438\u0433\u0430\u0442\u0435\u043B\u044C",
        pol: "Kieszonkowy Pyro",
        sch: "\u53E3\u888B\u706B\u7130\u5175",
        fre: "Le Pyro de poche",
        bra: "Pyro de Bolso",
        schema: 30070,
        hun: "A Zsebpir\xf3",
        swe: "Fickpyron"
    },
    459: {
        img: "cloud_crasher",
        eng: "The Cloud Crasher",
        rus: "\u041A\u0440\u0443\u0448\u0438\u0442\u0435\u043B\u044C \u043D\u0435\u0431\u0435\u0441",
        pol: "Postrach przestworzy",
        sch: "\u88C2\u4E91\u5934\u76D4",
        fre: "Le fendeur de nuages",
        bra: "O Arranhador de C\xe9us",
        schema: 30071,
        hun: "A Felh\u0151fejel\u0151",
        swe: "Molnkrossaren"
    },
    460: {
        img: "pom_pommed_provocateur",
        eng: "The Pom-Pommed Provocateur",
        rus: "\u041F\u0440\u043E\u0432\u043E\u043A\u0430\u0442\u043E\u0440 \u0441 \u043F\u043E\u043C\u043F\u043E\u043D\u043E\u043C",
        pol: "Pomponowy prowokator",
        sch: "\u7ED2\u7403\u7279\u5DE5",
        fre: "Le provocateur \xe0 pompon",
        bra: "O Pompom Provocador",
        schema: 30072,
        hun: "A Pomponos Provok\xe1tor",
        swe: "Pompom-provokat\xf6ren"
    },
    461: {
        img: "dark_age_defender",
        eng: "The Dark Age Defender",
        rus: "\u0417\u0430\u0449\u0438\u0442\u043D\u0438\u043A \u0422\u0435\u043C\u043D\u043E\u0433\u043E \u0432\u0435\u043A\u0430",
        pol: "\u015Aredniowieczny \u015Bmia\u0142ek",
        sch: "\u6697\u9ED1\u62A4\u7532",
        fre: "Le D\xe9fenseur des Temps Obscurs",
        bra: "O Protetor da Idade das Trevas",
        schema: 30073,
        hun: "A Vasbord\xe1j\xfa V\xe1rv\xe9d\u0151",
        swe: "Den m\xf6rka tidens f\xf6rsvarare"
    },
    462: {
        img: "tyurtlenek",
        eng: "The Tyurtlenek",
        rus: "\u0412\u043E\u0434\u043E\u043B\u0430\u0437\u0438\u0449\u0435",
        pol: "Gyolfik",
        sch: "\u9AD8\u9886\u6BDB\u8863",
        fre: "Le Kol Roul\xe9",
        bra: "A Golya Alta",
        schema: 30074,
        hun: "A Gjarb\xf3",
        swe: "Polojtr\xf6djan"
    },
    463: {
        img: "mair_mask",
        eng: "The Mair Mask",
        rus: "\u041C\u043E\u0437\u0434\u0443\u0448\u043D\u0430\u044F \u043C\u0430\u0441\u043A\u0430",
        pol: "Maska MO2",
        sch: "\u66FC\u5C14\u9762\u5177",
        fre: "Le Masque \xe0 Mair",
        bra: "A M\xe1scara de SAM",
        schema: 30075,
        hun: "A M\xe9gz\u0151maszk",
        swe: "Mluftmasken"
    },
    464: {
        img: "stormin_norman",
        eng: "Stormin' Norman",
        rus: "\u041B\u0435\u0442\u0443\u0447\u0438\u0439 \u043D\u043E\u0440\u043C\u0430\u043D\u0434\u0435\u0446",
        pol: "Szalej\u0105cy Norman",
        sch: "\u8FDB\u51FB\u7684\u8BFA\u66FC\u4EBA",
        fre: "L'Assaillant Normand",
        bra: "O Comando Normando",
        schema: 30112,
        hun: "A Rohamoz\xf3 Normann",
        swe: "Stormande norrmannen"
    },
    465: {
        img: "das_gutenkutteharen",
        eng: "Das Gutenkutteharen",
        rus: "\u0414\u0430\u0441 \u0413\u0443\u0442\u0435\u043D\u0441\u0442\u0440\u0438\u0433\u0435\u0432\u043B\u0430\u0441\u0435\u043D",
        pol: "Das Dobren Fryzuren",
        sch: "\u4F7C\u4F7C\u8005",
        fre: "Das Gutenkutteharen",
        bra: "Das Toppetchen",
        schema: 30127,
        hun: "Das Gutenkuttehaj"
    },
    466: {
        img: "blood_banker",
        eng: "Blood Banker",
        rus: "\u0411\u0430\u043D\u043A\u0438\u0440 \u043A\u0440\u043E\u0432\u0438",
        pol: "Krwawy bankier",
        sch: "\u55DC\u8840\u94F6\u884C\u5BB6",
        fre: "Le Banquier Sanglant",
        bra: "O Banqueiro de Sangue",
        schema: 30132,
        hun: "A V\xe9rbankos",
        swe: "Blodbanken"
    },
    467: {
        img: "pardners_pompadour",
        eng: "Pardner's Pompadour",
        rus: "\u041F\u043E\u043C\u043F\u0430\u0434\u0443\u0440 \u043F\u0440\u0438\u044F\u0442\u0435\u043B\u044F",
        pol: "Preriowy pompadour",
        sch: "\u642D\u6863\u7684\u5E9E\u5E15\u591A\u53D1\u578B",
        fre: "Le Pompadour du Compagnon",
        bra: "A Peruca do Parceiro",
        schema: 30099,
        hun: "A P\xf3rias Pompad\xfar",
        swe: "Partnerns pompadourfrisyr"
    },
    468: {
        img: "heavy_weight_champ",
        eng: "Heavy-Weight Champ",
        rus: "\u0422\u044F\u0436\u0435\u043B\u043E\u0432\u0435\u0441\u043D\u044B\u0439 \u0447\u0435\u043C\u043F\u0438\u043E\u043D",
        pol: "Mistrz wagi ci\u0119\u017Ckiej",
        sch: "\u91CD\u91CF\u7EA7\u62F3\u51FB\u51A0\u519B",
        fre: "Le Champion Poids Lourd",
        bra: "O Campe\xe3o Peso-Pesado",
        schema: 30080,
        hun: "A Neh\xe9zs\xfaly\xfa Bajnok",
        swe: "Tungviktsm\xe4staren"
    },
    469: {
        img: "backpack_broiler",
        eng: "Backpack Broiler",
        rus: "\u0413\u0440\u0438\u043B\u044C-\u0440\u044E\u043A\u0437\u0430\u043A",
        pol: "Plecakowy opiekacz",
        sch: "\u70E4\u8089\u80CC\u5305",
        fre: "Le Sac \xe0 Dos Grill",
        bra: "O Churrasco de Lombo",
        schema: 30090,
        hun: "A Grillbatyu",
        swe: "Ryggstekaren"
    },
    470: {
        img: "virtual_viewfinder",
        eng: "Virtual Viewfinder",
        rus: "\u0412\u0438\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0439 \u0432\u0438\u0434\u043E\u0438\u0441\u043A\u0430\u0442\u0435\u043B\u044C",
        pol: "Wirtualny wizjer",
        sch: "\u865A\u62DF\u73B0\u5B9E\u53D6\u666F\u5668",
        fre: "Le Viseur Virtuel",
        bra: "O Visor Virtual",
        schema: 30140,
        hun: "A Virtu\xe1lis Vil\xe1gl\xe1t\xf3",
        swe: "Virtuell bilds\xf6kare"
    },
    471: {
        img: "federal_casemaker",
        eng: "Federal Casemaker",
        rus: "\u0424\u0435\u0434\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u0439 \u043A\u0440\u044B\u0448\u0435\u0432\u0430\u0442\u0435\u043B\u044C",
        pol: "Profesjonalny agent federalny",
        sch: "\u8054\u90A6\u95F9\u4E8B\u8005",
        fre: "L'inspecteur F\xe9d\xe9ral",
        bra: "O Investigador Federal",
        schema: 30119,
        hun: "A Sz\xf6vets\xe9gi \xdcgyel\u0151",
        swe: "Federala fedoran"
    },
    472: {
        img: "wet_works",
        eng: "Wet Works",
        rus: "\u041C\u043E\u043A\u0440\u044B\u0435 \u0434\u0435\u043B\u0438\u0448\u043A\u0438",
        pol: "Mokra robota",
        sch: "\u6697\u6740\u96E8\u5E3D",
        fre: "Oeuvres Sanglantes",
        bra: "O Golpe Sujo",
        schema: 30135,
        hun: "Mocskos Mel\xf3",
        swe: "Sydv\xe4stern"
    },
    473: {
        img: "dry_gulch_gulp",
        eng: "Dry Gulch Gulp",
        rus: "\u041E\u0441\u0443\u0448\u0430\u044E\u0449\u0438\u0439 \u0433\u043B\u043E\u0442\u043E\u043A",
        pol: "Haust z suchego kanionu",
        sch: "\u5FEB\u9910\u5E97\u996E\u6599\u676F",
        fre: "La Gorge S\xe8che",
        bra: "O Mata-Sede",
        schema: 30087,
        hun: "A Sz\xe1razs\xe1gi Szomjolt\xf3",
        swe: "T\xf6rstsl\xe4ckaren"
    },
    474: {
        img: "borscht_belt",
        eng: "Borscht Belt",
        rus: "\u041F\u043E\u044F\u0441 \u043F\u043E \u0431\u043E\u0440\u0449\u0443",
        pol: "Czerwony pas",
        sch: "\u7F57\u5B8B\u8170\u5E26",
        fre: "Gros plein de bortch",
        bra: "Cintur\xe3o de Borscht",
        schema: 30108,
        hun: "\xd3loms\xfaly",
        rom: "Cureaua de Bor\u015F",
        swe: "Borsjtj-b\xe4lte"
    },
    475: {
        img: "valley_forge",
        eng: "Valley Forge",
        rus: "\u0412\u044D\u043B\u043B\u0438 \u0424\u043E\u0440\u0434\u0436",
        pol: "Valley Forge",
        sch: "\u798F\u5409\u8C37\u603B\u7EDF\u5E3D",
        fre: "Le Tricorne de Valley Forge",
        bra: "O Vale Forge",
        schema: 30114,
        hun: "A Valley Forge",
        ger: "Der Valley Forge"
    },
    476: {
        img: "shoguns_shoulder_guard",
        eng: "Shogun's Shoulder Guard",
        rus: "\u0421\u0435\u0433\u0443\u043D\u0441\u043A\u0438\u0439 \u043D\u0430\u043F\u043B\u0435\u0447\u043D\u0438\u043A",
        pol: "Niewzruszone rami\u0119 szoguna",
        sch: "\u5E55\u5E9C\u5C06\u519B\u7684\u80A9\u7532",
        fre: "L'\xc9pauli\xe8re du Shogun",
        bra: "A Ombreira do Xogum",
        schema: 30126,
        hun: "A S\xf3gun V\xe1llv\xe9d\u0151je",
        swe: "Shogunens axelvakt"
    },
    477: {
        img: "gaelic_golf_bag",
        eng: "Gaelic Golf Bag",
        rus: "\u0413\u044D\u043B\u044C\u0441\u043A\u0430\u044F \u0441\u0443\u043C\u043A\u0430 \u0434\u043B\u044F \u0433\u043E\u043B\u044C\u0444\u0430",
        pol: "Gaelicka torba golfowa",
        sch: "\u76D6\u5C14\u4EBA\u7684\u9AD8\u5C14\u592B\u7403\u888B",
        fre: "Le Sac de Golf Ga\xe9lique",
        bra: "A Mochila de Golfe Galesa",
        schema: 30107,
        hun: "A Gael Golft\xe1ska",
        swe: "Galliska golfbagen"
    },
    478: {
        img: "das_feelinbeterbager",
        eng: "Das Feelinbeterbager",
        rus: "\u0414\u0430\u0441 \u041B\u0443\u0447\u0448\u0435\u0447\u0443\u0432\u0441\u0442\u0432\u0435\u043D\u0441\u0443\u043C\u043A\u0435\u0440",
        pol: "Das Ju\u017C Mi Lepiej Torben",
        sch: "\u611F\u89C9\u826F\u597D\u5957\u88C5",
        fre: "Das Feelinbeterbager",
        bra: "Das Poschetedecurativos",
        schema: 30096,
        hun: "Das Jobahnle\xdfelt\xf6hle",
        swe: "Das M\xe5besserbag"
    },
    479: {
        img: "belgian_detective",
        eng: "Belgian Detective",
        rus: "\u0411\u0435\u043B\u044C\u0433\u0438\u0439\u0441\u043A\u0438\u0439 \u0434\u0435\u0442\u0435\u043A\u0442\u0438\u0432",
        pol: "Belgijski detektyw",
        sch: "\u6BD4\u5229\u65F6\u4FA6\u63A2",
        fre: "Le d\xe9tective belge",
        bra: "Hercule Traidot",
        schema: 30128,
        hun: "A Belga Detekt\xedv",
        swe: "Den belgiska detektiven"
    },
    480: {
        img: "caribbean_conqueror",
        eng: "Caribbean Conqueror",
        rus: "\u041A\u0430\u0440\u0438\u0431\u0441\u043A\u0438\u0439 \u0437\u0430\u0432\u043E\u0435\u0432\u0430\u0442\u0435\u043B\u044C",
        pol: "Karaibski konkwistador",
        sch: "\u52A0\u52D2\u6BD4\u5F81\u670D\u8005",
        fre: "Le conqu\xe9rant des Cara\xefbes",
        bra: "O Conquistador do Caribe",
        schema: 30116,
        hun: "A Karibi Kapit\xe1ny",
        swe: "Den karibiska er\xf6vraren"
    },
    481: {
        img: "katyusha",
        eng: "Katyusha",
        rus: "\u041A\u0430\u0442\u044E\u0448\u0430",
        pol: "Katiusza",
        sch: "\u5580\u79CB\u838E",
        fre: "Le Katyusha",
        bra: "A Katyusha",
        schema: 30094,
        hun: "A Katyusa",
        swe: "Katiusjan"
    },
    482: {
        img: "das_hazmattenhatten",
        eng: "Das Hazmattenhatten",
        rus: "\u0414\u0430\u0441 \u0425\u0438\u043C\u0437\u0430\u0449\u0438\u0442\u0448\u043B\u0435\u043C\u0435\u043D",
        pol: "Das Hazmatten Kapelusz",
        sch: "\u5371\u9669\u54C1\u9632\u62A4\u9762\u7F69",
        fre: "Das Hazmattenhatten",
        bra: "Das Schapelantihadioatividaden",
        schema: 30095,
        hun: "Das Wiedwiedelemschapek"
    },
    483: {
        img: "pampered_pyro",
        eng: "Pampered Pyro",
        rus: "\u0418\u0437\u0431\u0430\u043B\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043F\u043E\u0434\u0436\u0438\u0433\u0430\u0442\u0435\u043B\u044C",
        pol: "Wypieszczony Pyro",
        sch: "\u9A84\u5962\u706B\u7130\u5175\u5934\u5DFE",
        fre: "Le Pyro Pomponn\xe9",
        bra: "Pyro com Privil\xe9gios",
        schema: 30139,
        hun: "A Kicicom\xe1zott Pir\xf3",
        swe: "Bortsk\xe4mda Pyro"
    },
    484: {
        img: "rogues_brogues",
        eng: "Rogue's Brogues",
        rus: "\u0411\u0430\u0448\u043C\u0430\u043A\u0438 \u0436\u0443\u043B\u0438\u043A\u0430",
        pol: "Bandyckie brogsy",
        sch: "\u6076\u68CD\u7684\u7C97\u9769\u76AE\u978B",
        fre: "Les Claquettes du Coquin",
        bra: "O Mocassim do Assassim",
        schema: 30125,
        hun: "A Lator L\xe1bbelije",
        swe: "Skurkens skodon"
    },
    485: {
        img: "hornblower",
        eng: "Hornblower",
        rus: "\u0414\u0443\u0434\u043A\u043E\u0434\u0443\u0439",
        pol: "Pan Hornblower",
        sch: "\u970D\u6069\u5E03\u6D1B\u5C14\u7684\u6D77\u519B\u670D",
        fre: "Le Hornblower",
        bra: "O Napole\xf4nico Naval",
        schema: 30129,
        swe: "Hornbl\xe5saren"
    },
    486: {
        img: "delinquents_down_vest",
        eng: "Delinquent's Down Vest",
        rus: "\u0416\u0438\u043B\u0435\u0442 \u0436\u0443\u043B\u0438\u043A\u0430",
        pol: "Bezr\u0119kawnik delikwenta",
        sch: "\u5C11\u5E74\u72AF\u7684\u7FBD\u7ED2\u80CC\u5FC3",
        fre: "La Doudoune de D\xe9linquant",
        bra: "O Colete do Criminoso",
        schema: 30134,
        hun: "A Tettleges Mell\xe9ny",
        swe: "Brottslingens dunv\xe4st"
    },
    487: {
        img: "glasgow_great_helm",
        eng: "Glasgow Great Helm",
        rus: "\u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0433\u043B\u0430\u0437\u0433\u043E\u0432\u0441\u043A\u0438\u0439 \u0448\u043B\u0435\u043C",
        pol: "He\u0142m garnczkowy z Glasgow",
        sch: "\u683C\u62C9\u65AF\u54E5\u5353\u8D8A\u5934\u76D4",
        fre: "Le Grand Heaume de Glasgow",
        bra: "O Grande Elmo de Glasgow",
        schema: 30082,
        hun: "A Glasgow-i Nagy Sisak",
        swe: "Glasgows storhj\xe4lm"
    },
    488: {
        img: "rebel_rouser",
        eng: "Rebel Rouser",
        rus: "\u0411\u0443\u043D\u0442\u043E\u0432\u0449\u0438\u043A",
        pol: "Skonfundowany konfederat",
        sch: "\u53DB\u4E71\u717D\u52A8\u8005",
        fre: "L'agitateur rebelle",
        bra: "O Agitador Adornado",
        schema: 30120,
        hun: "A L\xe1zad\xedt\xf3",
        swe: "Rebelleggaren"
    },
    489: {
        img: "el_muchacho",
        eng: "El Muchacho",
        rus: "\u042D\u043B\u044C \u041C\u0443\u0447\u0430\u0447\u043E",
        pol: "El muchacho",
        sch: "\u5C11\u5E74\u7684\u7F8A\u6BDB\u6597\u7BF7",
        fre: "El Muchacho",
        bra: "El Muchacho",
        schema: 30089
    },
    490: {
        img: "das_ubersternmann",
        eng: "Das Ubersternmann",
        rus: "\u0414\u0430\u0441 \u0423\u0431\u0435\u0440\u0448\u0442\u0435\u0440\u043D\u043C\u0430\u043D\u043D",
        pol: "Das \xfcber srogien cz\u0142owiekien",
        sch: "\u661F\u7EA7\u533B\u751F",
        fre: "Das \xdcbersternmann",
        bra: "Das \xdcberausteromann",
        schema: 30097,
        hun: "Das \xdcbermorzosmann",
        swe: "Das \xdcbersternmann"
    },
    491: {
        img: "bolshevik_biker",
        eng: "Bolshevik Biker",
        rus: "\u0411\u0430\u0439\u043A\u0435\u0440-\u0431\u043E\u043B\u044C\u0448\u0435\u0432\u0438\u043A",
        pol: "Bolszewicki motocyklista",
        sch: "\u5E03\u5C14\u4EC0\u7EF4\u514B\u9A91\u624B",
        fre: "Le Biker Bolchevik",
        bra: "O Motoqueiro Marxista",
        schema: 30138,
        hun: "A Marxista Motoros",
        swe: "Bolsjevikknutten"
    },
    492: {
        img: "tartan_spartan",
        eng: "Tartan Spartan",
        rus: "\u041D\u0430\u0441 \u043C\u0430\u043B\u043E, \u043D\u043E \u043C\u044B \u0432 \u043A\u0438\u043B\u0442\u0430\u0445",
        pol: "Demolka w krat\u0119",
        sch: "\u70B8\u5F39\u4E13\u5BB6",
        fre: "Spartiate \xc9cossais",
        bra: "Tartan Espartano",
        schema: 30106,
        hun: "Sk\xf3tkock\xe1s sp\xe1rtai",
        rom: "Spartan Tartan",
        swe: "Spr\xe4ngande Spartan"
    },
    493: {
        img: "cobber_chameleon",
        eng: "Cobber Chameleon",
        rus: "\u0425\u0430\u043C\u0435\u043B\u0435\u043E\u043D-\u043F\u0440\u0438\u044F\u0442\u0435\u043B\u044C",
        pol: "Kole\u017Cka kameleon",
        sch: "\u5BA0\u7269\u53D8\u8272\u9F99",
        fre: "Le Pote Cam\xe9l\xe9on",
        bra: "O Colega Camale\xe3o",
        schema: 30101,
        hun: "A Kam\xe9leon-kedvenc",
        swe: "Kamratliga kameleonten"
    },
    494: {
        img: "graybanns",
        eng: "Graybanns",
        rus: "\u0413\u0440\u0435\u0439-\u0411\u0430\u043D\u043D\u044B",
        pol: "Graybanny",
        sch: "\u7070\u670B\u592A\u9633\u955C",
        fre: "Graybanns",
        bra: "Graybanns",
        schema: 30104
    },
    495: {
        img: "after_dark",
        eng: "After Dark",
        rus: "\u041F\u043E\u0441\u043B\u0435\u043C\u0440\u0430\u043A",
        pol: "Po zmroku",
        sch: "\u591C\u751F\u6D3B",
        fre: "La Fin de Soir\xe9e",
        bra: "Altas Horas",
        schema: 30133,
        hun: "A K\xe9sei Vend\xe9g",
        swe: "Efter m\xf6rkret"
    },
    496: {
        img: "hive_minder",
        eng: "Hive Minder",
        rus: "\u041F\u0430\u0441\u0435\u0447\u043D\u0438\u043A",
        pol: "Opiekun roju",
        sch: "\u517B\u8702\u4EBA\u4E4B\u5E3D",
        fre: "L'apiculteur",
        bra: "O Abelhudo",
        schema: 30093,
        hun: "A Kas-lat\xf3",
        swe: "Bikupekupolen"
    },
    497: {
        img: "das_metalmeatencasen",
        eng: "Das Metalmeatencasen",
        rus: "\u0414\u0430\u0441 \u041C\u0435\u0442\u0430\u043B\u043C\u044F\u0441\u0444\u0443\u0442\u043B\u044F\u0440\u0435\u043D",
        pol: "Das Metal Ochrona fur Brust",
        sch: "\u91D1\u5C5E\u88F9\u8089\u7532",
        fre: "Das Metalmeatencasen",
        bra: "Das Protettordepeittodemetalen",
        schema: 30098,
        hun: "Das Metalhuschtok",
        swe: "Das Metallk\xf6ttpanzer"
    },
    498: {
        img: "gaelic_garb",
        eng: "Gaelic Garb",
        rus: "\u0413\u044D\u043B\u044C\u0441\u043A\u043E\u0435 \u043E\u0434\u0435\u044F\u043D\u0438\u0435",
        pol: "Celtyckie odzienie",
        sch: "\u9AD8\u5362\u5F0F\u5916\u5957",
        fre: "Les Habits Ga\xe9liques",
        bra: "O Gal\xeas Gabado",
        schema: 30124,
        hun: "A Kelta Kollekci\xf3",
        swe: "Gaeliska skruden"
    },
    499: {
        img: "half_pipe_hurdler",
        eng: "Half-Pipe Hurdler",
        rus: "\u0415\u0437\u0434\u043E\u043A \u043F\u043E \u0440\u0430\u043C\u043F\u0435",
        pol: "Ramposkoczek",
        sch: "\u90A6\u514B\u6ED1\u677F",
        fre: "Le Coureur des Rampes",
        bra: "O Rapaz do Rol\xea",
        schema: 30084,
        hun: "A F\xe9lcs\u0151-fut\xf3",
        swe: "Halfpipe-h\xe4ckl\xf6paren"
    },
    500: {
        img: "birdman_of_australiacatraz",
        eng: "Birdman of Australiacatraz",
        rus: "\u041F\u0442\u0438\u0446\u0435\u043B\u043E\u0432 \u0438\u0437 \u0410\u0432\u0441\u0442\u0440\u0430\u043B\u044C\u043A\u0430\u0442\u0440\u0430\u0441\u0430",
        pol: "Ptasznik z Australiacatraz",
        sch: "\u6FB3\u9B54\u5C9B\u9A6F\u9E1F\u8005",
        fre: "Homme-Oiseau d'Australcatraz",
        bra: "O Homem de Australiacatraz",
        schema: 30100,
        hun: "Ausztr\xe1lialcatraz Mad\xe1rembere",
        swe: "F\xe5gelmannen fr\xe5n Australcatraz."
    },
    501: {
        img: "tsarboosh",
        eng: "Tsarboosh",
        rus: "\u0426\u0430\u0440\u044C\u0431\u0443\u0448",
        pol: "Carbusz",
        sch: "\u6C99\u7687\u6BE1\u5E3D",
        fre: "Le Tsarboosh",
        bra: "O Tsarboosh",
        schema: 30081,
        hun: "A C\xe1rbus",
        ger: "Der Zarbusch"
    },
    502: {
        img: "macho_mann",
        eng: "Macho Mann",
        rus: "\u041C\u0430\u0447\u043E \u041C\u0430\u043D\u043D",
        pol: "M\u0119ski m\u0119\u017Cczyzna",
        sch: "\u731B\u7537\u66FC\u6069",
        fre: "Le Macho Mann",
        bra: "O Macho Mann",
        schema: 30085,
        hun: "A Macs\xf3 Mannus",
        ger: "Der Macho-Mann"
    },
    503: {
        img: "harmburg",
        eng: "Harmburg",
        rus: "\u0412\u0440\u0435\u0434\u043E\u043D\u043E\u0441\u043D\u044B\u0439 \u0445\u043E\u043C\u0431\u0443\u0440\u0433",
        pol: "Harmburg",
        sch: "\u90AA\u6076\u6C49\u5821\u5E3D",
        fre: "Le Harmburg",
        bra: "O Assassinomburg",
        schema: 30123,
        hun: "A Nempuha-kalap",
        swe: "Homburgern"
    },
    504: {
        img: "das_maddendoktor",
        eng: "Das Maddendoktor",
        rus: "\u0414\u0430\u0441 \u0411\u0435\u0437\u0443\u043C\u043C\u0435\u043D\u0434\u043E\u043A\u0442\u043E\u0440",
        pol: "Der Szalonenlekarzen",
        sch: "\u75AF\u72C2\u7684\u533B\u751F",
        fre: "Das Maddendoktor",
        bra: "Das Doktormaluco",
        schema: 30121,
        hun: "Das \xd6hr\xfcltdoktor",
        swe: "Das Vansinnesdoktor"
    },
    505: {
        img: "red_army_robin",
        eng: "Red Army Robin",
        rus: "\u041A\u0440\u0430\u0441\u043D\u043E\u0430\u0440\u043C\u0435\u0439\u0441\u043A\u0430\u044F \u043C\u0430\u043B\u0438\u043D\u043E\u0432\u043A\u0430",
        pol: "Rudzik Armii Czerwonej",
        sch: "\u7EA2\u519B\u6218\u58EB\u7684\u77E5\u66F4\u9E1F",
        fre: "Le Rouge-gorge de l'Arm\xe9e Rouge",
        bra: "O Pisco do Ex\xe9rcito Vermelho",
        schema: 30079,
        hun: "A V\xf6r\xf6s Begy",
        swe: "R\xf6da arm\xe9ns Robin"
    },
    506: {
        img: "greased_lightning",
        eng: "Greased Lightning",
        rus: "\u0421\u043C\u0430\u0437\u0430\u043D\u043D\u0430\u044F \u043C\u043E\u043B\u043D\u0438\u044F",
        pol: "Nat\u0142uszczona b\u0142yskawica",
        sch: "\u98CE\u9A70\u7535\u63A3",
        fre: "\xc9clair Gomin\xe9",
        bra: "Tempo da Brilhantina",
        schema: 30078,
        hun: "Olajozott Vill\xe1m",
        swe: "Oljad Blixt"
    },
    507: {
        img: "whiskey_bib",
        eng: "Whiskey Bib",
        rus: "\u0421\u0430\u043B\u0444\u0435\u0442\u043A\u0430 \u0434\u043B\u044F \u0432\u0438\u0441\u043A\u0438",
        pol: "Wy\u015Bwiechtany \u015Bliniak do whisky",
        sch: "\u5A01\u58EB\u5FCC\u9910\u5DFE\u5E03",
        fre: "Le Bavoir \xe0 Whisky",
        bra: "Os Babadores de U\xedsque",
        schema: 30110,
        hun: "A Whiskey-el\u0151ke",
        swe: "Whiskey-haklappen"
    },
    508: {
        img: "cool_cat_cardigan",
        eng: "Cool Cat Cardigan",
        rus: "\u041A\u0440\u0443\u0442\u0430\u044F \u043A\u043E\u0444\u0442\u0430",
        pol: "Prze go\u015B\u0107",
        sch: "\u9177\u732B\u7F8A\u6BDB\u886B",
        fre: "Le Cardigan du Mec Cool",
        bra: "O Cardig\xe3 do Carism\xe1tico",
        schema: 30077,
        hun: "A Kir\xe1ly Kardig\xe1n",
        swe: "Coola Cardigan"
    },
    509: {
        img: "colonial_clogs",
        eng: "Colonial Clogs",
        rus: "\u041A\u043E\u043B\u043E\u043D\u0438\u0430\u043B\u044C\u043D\u044B\u0435 \u0431\u0430\u0448\u043C\u0430\u043A\u0438",
        pol: "Kolonialne chodaki",
        sch: "\u6B96\u6C11\u6728\u5C50",
        fre: "Les Sabots Coloniaux",
        bra: "Os Cal\xe7ados Coloniais",
        schema: 30117,
        hun: "A Kolonista Klump\xe1i",
        swe: "Traditionella tr\xe4skor"
    },
    510: {
        img: "burning_bandana",
        eng: "Burning Bandana",
        rus: "\u0413\u043E\u0440\u044F\u0449\u0430\u044F \u0431\u0430\u043D\u0434\u0430\u043D\u0430",
        pol: "P\u0142on\u0105ca bandana",
        sch: "\u70C8\u7130\u5934\u5DFE",
        fre: "Le Bandana Ardent",
        bra: "A Bandana em Brasas",
        schema: 30091,
        hun: "A Lobog\xf3 Kend\u0151",
        swe: "Heta huvudduken"
    },
    511: {
        img: "falconer",
        eng: "Falconer",
        rus: "\u0421\u043E\u043A\u043E\u043B\u044C\u043D\u0438\u0447\u0438\u0439",
        pol: "Sokolnik",
        sch: "\u9A6F\u9E70\u624B\u5957",
        fre: "Le Fauconnier",
        bra: "O Falcoeiro",
        schema: 30103,
        hun: "A Solym\xe1sz",
        swe: "Falkeneraren"
    },
    512: {
        img: "black_watch",
        eng: "Black Watch",
        rus: "\u0427\u0435\u0440\u043D\u044B\u0439 \u0434\u043E\u0437\u043E\u0440",
        pol: "Czarna stra\u017C",
        sch: "\u9ED1\u536B\u90E8\u961F\u519B\u5E3D",
        fre: "La Sentinelle Noire",
        bra: "A Guarda Negra",
        schema: 30105,
        hun: "A Fekete Sereg",
        swe: "Svarta Vakten"
    },
    513: {
        img: "flared_frontiersman",
        eng: "Flared Frontiersman",
        rus: "\u0420\u0430\u0441\u043A\u043B\u0435\u0448\u0435\u043D\u043D\u044B\u0439 \u043F\u0435\u0440\u0435\u0434\u043E\u0432\u0438\u043A",
        pol: "Dzwoniasty pionier",
        sch: "\u62D3\u8352\u8005\u7684\u5587\u53ED\u88E4",
        fre: "Les Pattes d'eph du Pionnier",
        bra: "A Boca de Sino do Arraiano",
        schema: 30113,
        hun: "A Tart\xf3s Trap\xe9znadr\xe1g",
        swe: "Prydliga pionj\xe4ren"
    },
    514: {
        img: "compatriot",
        eng: "Compatriot",
        rus: "\u0421\u043E\u043E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A",
        pol: "Kompatriota",
        sch: "\u540C\u80DE",
        fre: "Le compatriote",
        bra: "A Compatriota",
        schema: 30115,
        hun: "A Patri\xf3t\xe1rs",
        swe: "Landsmannen"
    },
    515: {
        img: "das_fantzipantzen",
        eng: "Das Fantzipantzen",
        rus: "\u0414\u0430\u0441 \u041C\u043E\u0434\u0435\u043D\u0448\u043C\u043E\u0442\u0435\u043D",
        pol: "Das Krzykliwy Mantel",
        sch: "\u5962\u534E\u793C\u670D",
        fre: "Das Fantzipantzen",
        bra: "Das Calssaschiczen",
        schema: 30137,
        hun: "Das Tschiniepantallo"
    },
    516: {
        img: "bear_necessities",
        eng: "Bear Necessities",
        rus: "\u041C\u0435\u0434\u0432\u0435\u0436\u044C\u0438 \u0440\u0430\u0434\u043E\u0441\u0442\u0438",
        pol: "Nied\u017Awiedzie potrzeby",
        sch: "\u5DE8\u718A\u5FC5\u9700\u54C1",
        fre: "Il en faut peu pour \xeatre un Ours",
        bra: "O Abra\xe7o de Urso",
        schema: 30122,
        hun: "A Medve Akarta",
        swe: "Bj\xf6rntj\xe4nsten"
    },
    517: {
        img: "bigg_mann_on_campus",
        eng: "Bigg Mann on Campus",
        rus: "\u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0447\u0435\u043B\u043E\u0432\u0435\u043A \u0432 \u043A\u0430\u043C\u043F\u0443\u0441\u0435",
        pol: "Szycha z akademika",
        sch: "\u6821\u56ED\u5927\u5496",
        fre: "La Star du Campus",
        bra: "O Dono do Peda\xe7o",
        schema: 30076,
        hun: "Az Egyetem Fenemannusa",
        swe: "Viktig Mann p\xe5 campus"
    },
    518: {
        img: "lieutenant_bites",
        eng: "Lieutenant Bites",
        rus: "\u041B\u0435\u0439\u0442\u0435\u043D\u0430\u043D\u0442 \u041A\u0443\u0441\u0430\u043A\u0430",
        pol: "Porucznik Gryzak",
        sch: "\u54AC\u54AC\u4E2D\u5C09",
        fre: "Lieutenant Mordant",
        bra: "Tenente Mordida",
        schema: 30130,
        hun: "Harap Hadnagy",
        swe: "L\xf6jtnant Bett"
    },
    519: {
        img: "brawling_buccaneer",
        eng: "Brawling Buccaneer",
        rus: "\u0411\u0443\u043A\u0430\u043D\u044C\u0435\u0440-\u0431\u0443\u044F\u043D",
        pol: "Bitny bukanier",
        sch: "\u55A7\u95F9\u6D77\u76D7\u5916\u5957",
        fre: "Le Boucanier Bagarreur",
        bra: "O Bucaneiro Briguento",
        schema: 30131,
        hun: "Az \xdctleg Kapit\xe1nya",
        swe: "Den gormande sj\xf6r\xf6varen"
    },
    520: {
        img: "founding_father",
        eng: "Founding Father",
        rus: "\u041E\u0442\u0435\u0446-\u043E\u0441\u043D\u043E\u0432\u0430\u0442\u0435\u043B\u044C",
        pol: "Ojciec za\u0142o\u017Cyciel",
        sch: "\u5F00\u56FD\u5143\u52CB",
        fre: "Le p\xe8re fondateur",
        bra: "O Pai Fundador",
        schema: 30142,
        hun: "Az Alap\xedt\xf3 Atya",
        swe: "Grundaren"
    },
    521: {
        img: "caffeine_cooler",
        eng: "Caffeine Cooler",
        rus: "\u041A\u043E\u0444\u0435\u0438\u043D\u043E\u0432\u044B\u0439 \u0445\u043E\u043B\u043E\u0434\u0438\u043B\u044C\u043D\u0438\u043A",
        pol: "Ch\u0142odna kofeina",
        sch: "\u539F\u5B50\u996E\u6599\u51B0\u9547\u7BB1",
        fre: "La glaci\xe8re \xe0 caf\xe9ine",
        bra: "O Refrigerador de Refrescos",
        schema: 30083,
        hun: "A Koffeines T\xe1ska",
        swe: "Koffeinkylaren"
    },
    522: {
        img: "gabe_glasses",
        eng: "Gabe Glasses",
        rus: "\u041E\u0447\u043A\u0438 \u0413\u0435\u0439\u0431\u0430",
        pol: "Okulary Gabe'a",
        sch: "Gabe \u5F0F\u773C\u955C",
        fre: "Les lunettes de Gabe",
        bra: "Os \xd3culos do Gabe",
        schema: 30141,
        hun: "A Gabe Szem\xfcveg",
        swe: "Gabes glas\xf6gon"
    },
    523: {
        img: "trash_toter",
        eng: "Trash Toter",
        rus: "\u041C\u0443\u0441\u043E\u0440\u043E\u0432\u043E\u0437",
        pol: "Kopert\xf3wka klamociarza",
        sch: "\u5E9F\u7269\u630E\u5305",
        fre: "La Sacoche \xe0 D\xe9chets",
        bra: "A Sacola Recicl\xe1vel",
        schema: 30086,
        hun: "A Szem\xe9tszatyor",
        swe: "Reservdelsv\xe4skan"
    },
    524: {
        img: "baron_von_havenaplane",
        eng: "Baron von Havenaplane",
        rus: "\u0411\u0430\u0440\u043E\u043D \u0444\u043E\u043D \u041D\u0435\u0431\u0435\u0441\u0430\u043C\u043E\u043B\u0435\u0442\u0442",
        pol: "Baron von Awiatoren",
        sch: "\u7EA2\u7537\u7235\u7684\u8239\u5F62\u5E3D",
        fre: "Baron von Havenaplane",
        bra: "Bar\xe3o von Tonoavi\xe3o",
        schema: 30136,
        hun: "Baron von R\xf6puelohmvarn"
    },
    525: {
        img: "whirly_warrior",
        eng: "Whirly Warrior",
        rus: "\u0412\u0438\u0445\u0440\u0435\u0432\u044B\u0439 \u0432\u043E\u0438\u043D",
        pol: "Zakr\u0119cony wojownik",
        sch: "\u65CB\u7FFC\u6218\u58EB",
        fre: "L'H\xe9lico-Guerrier",
        bra: "O Voador Violento",
        schema: 30118,
        hun: "A 'Kopter Kapit\xe1nya",
        swe: "Virvelkrigaren"
    },
    526: {
        img: "das_naggenvatcher",
        eng: "Das Naggenvatcher",
        rus: "\u0414\u0430\u0441 \u0411\u043E\u0448\u043A\u0438\u043D\u0437\u0430\u0449\u0438\u0442\u0435\u0440",
        pol: "Das Ochrona Fur G\u0142owen",
        sch: "\u62A4\u989D\u94A2\u76D4",
        fre: "Das Naggenvatcher",
        bra: "Das Antirraschakucka",
        schema: 30109,
        hun: "Das Kobahkverdo"
    },
    527: {
        img: "soot_suit",
        eng: "Soot Suit",
        rus: "\u0417\u043E\u043B\u043E\u0432\u043E\u0439 \u043A\u043E\u0441\u0442\u044E\u043C",
        pol: "Gor\u0105cy garniak",
        sch: "\u70DF\u5C18\u897F\u88C5",
        fre: "La Tenue de Sooter",
        bra: "O Zoot Suit do Zombador",
        schema: 30092,
        hun: "A Koromzak\xf3",
        swe: "Stiliga sotarn"
    },
    528: {
        img: "hitmans_heatmaker",
        eng: "The Hitman's Heatmaker",
        rus: "\u0420\u0430\u0437\u0436\u0438\u0433\u0430\u0442\u0435\u043B\u044C \u0440\u0430\u0437\u0431\u043E\u0439\u043D\u0438\u043A\u0430",
        pol: "Zabawka zawodowca",
        sch: "\u804C\u4E1A\u6740\u624B\u7684\u624B\u611F",
        fre: "Le Br\xfbleur \xe0 Gages",
        bra: "O Assassino de Aluguel",
        schema: 752,
        hun: "A B\xe9rgyilkos Bemeleg\xedt\u0151je",
        swe: "Torpedens Trogna"
    },
    529: {
        img: "strange_part_kills_during_victory_time",
        eng: "Strange Part: Kills During Victory Time",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0439\u0441\u0442\u0432\u0430 \u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0431\u0435\u0434\u044B",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zab\xf3jstwa po zako\u0144czeniu rundy",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u80DC\u5229\u540E\u9003\u5175\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Victimes apr\xe8s victoire d'un round",
        bra: "Pe\xe7a Estranha: V\xedtimas ap\xf3s Vencer a Rodada",
        schema: 6041,
        hun: "Fura Alkatr\xe9sz: Gy\u0151zelmi id\u0151 alatti \xf6l\xe9sek",
        swe: "M\xe4rklig del: D\xf6dade under segertid"
    },
    530: {
        img: "strange_part_robot_spies_destroyed",
        eng: "Strange Part: Robot Spies Destroyed",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u043D\u0438\u0447\u0442\u043E\u0436\u0435\u043D\u043D\u044B\u0435 \u0440\u043E\u0431\u043E\u0442\u044B-\u0448\u043F\u0438\u043E\u043D\u044B",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zniszczeni roboszpiedzy",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u673A\u5668\u95F4\u8C0D\u6467\u6BC1\u6570",
        fre: "Pi\xe8ce \xe9trange : Spies Robots d\xe9truits",
        bra: "Pe\xe7a Estranha: Spies Rob\xf4s Destru\xeddos",
        schema: 6048,
        hun: "Fura Alkatr\xe9sz: Elpuszt\xedtott robot K\xe9mek",
        swe: "M\xe4rklig del: Robotspioner f\xf6rst\xf6rda"
    },
    531: {
        img: "viking_braider",
        eng: "The Viking Braider",
        rus: "\u0411\u043E\u0440\u043E\u0434\u0430 \u0432\u0438\u043A\u0438\u043D\u0433\u0430",
        pol: "Warkoczyki wikinga",
        sch: "\u7EF4\u4EAC\u5B56\u8FAB\u80E1",
        fre: "Les tresses vikings",
        bra: "As Tran\xe7as Vikings",
        schema: 30164,
        hun: "A Vikingszak\xe1ll",
        swe: "Vikingfl\xe4tan"
    },
    532: {
        img: "flapjack",
        eng: "The Flapjack",
        rus: "\u041A\u0443\u0440\u0442\u043A\u0430 \u043D\u0430 \u0437\u0430\u0441\u0442\u0435\u0436\u043A\u0430\u0445",
        pol: "Klapota",
        sch: "\u4E1C\u4EAC\u5954\u8DD1\u8005",
        fre: "Le Flapjack",
        bra: "A Jaquetsuo",
        schema: 30185,
        hun: "A Hajt\xf3k\xe1s",
        swe: "Uppkn\xe4ppta knappjackan"
    },
    533: {
        img: "gold_digger",
        eng: "The Gold Digger",
        rus: "\u0417\u043E\u043B\u043E\u0442\u043E\u0434\u043E\u0431\u044B\u0442\u0447\u0438\u043A",
        pol: "Poszukiwacz z\u0142ota",
        sch: "\u6DD8\u91D1\u8005",
        fre: "Le Chercheur d'or",
        bra: "O Garimpeiro",
        schema: 30172,
        hun: "Az Arany\xe1s\xf3",
        swe: "Guldgr\xe4varen"
    },
    534: {
        img: "weight_room_warmer",
        eng: "Weight Room Warmer",
        rus: "\u0422\u043E\u043B\u0441\u0442\u043E\u0432\u043A\u0430 \u0442\u043E\u043B\u0441\u0442\u044F\u043A\u0430",
        pol: "Docieplaj\u0105cy dres",
        sch: "\u5065\u8EAB\u623F\u68C9\u8884",
        fre: "Chauffeur de salle de sport",
        bra: "Blus\xe3o de Muscula\xe7\xe3o",
        schema: 30178,
        hun: "Edz\u0151terem Meleg\xedt\u0151",
        swe: "Skrotlyftaroverall"
    },
    535: {
        img: "special_eyes",
        eng: "The Special Eyes",
        rus: "\u041E\u0441\u043E\u0431\u044B\u0439 \u0432\u0437\u0433\u043B\u044F\u0434",
        pol: "Wyj\u0105tkowe oczy",
        sch: "\u72EC\u7279\u4E4B\u773C",
        fre: "Le Regard sp\xe9cial",
        bra: "Os Olhos Especiais",
        schema: 30168,
        hun: "A K\xfcl\xf6nleges Szemek",
        swe: "De Speciella \xd6gonen"
    },
    536: {
        img: "chronomancer",
        eng: "The Chronomancer",
        rus: "\u0425\u0440\u043E\u043D\u043E\u043C\u0430\u043D\u0442",
        pol: "Chronomanta",
        sch: "\u65F6\u7A7A\u4E4B\u4E3B",
        fre: "Le Chronomancien",
        bra: "O Cronomante",
        schema: 30170,
        hun: "Az Id\u0151z\u0151",
        swe: "Kronomantikern"
    },
    537: {
        img: "pirate_bandana",
        eng: "Pirate Bandana",
        rus: "\u041F\u0438\u0440\u0430\u0442\u0441\u043A\u0430\u044F \u0431\u0430\u043D\u0434\u0430\u043D\u0430",
        pol: "Piracka chusta",
        sch: "\u6D77\u76D7\u5934\u5DFE",
        fre: "Bandana de pirate",
        bra: "Bandana de Pirata",
        schema: 30180,
        hun: "Kal\xf3zkend\u0151",
        swe: "Piratbandana"
    },
    538: {
        img: "brim_full_of_bullets",
        eng: "Brim-Full of Bullets",
        rus: "\u041F\u0440\u0438\u0433\u043E\u0440\u0448\u043D\u044F \u043F\u0443\u043B\u044C",
        pol: "W kulach po brzegi",
        sch: "\u5927\u9556\u5BA2\u7684\u9576\u5F39\u5E3D",
        fre: "Pour une poign\xe9e de balles",
        bra: "Por um Punhado de Balas",
        schema: 30173,
        hun: "A Kalapos Felk\xe9sz\xfcl\xe9s",
        swe: "Hatten full med kulor"
    },
    539: {
        img: "lil_snaggletooth",
        eng: "Li'l Snaggletooth",
        rus: "\u041C\u0430\u043B\u044B\u0448 \u043A\u0440\u0438\u0432\u043E\u0437\u0443\u0431",
        pol: "Ma\u0142y Forfiter",
        sch: "\u5C0F\u9CC4\u9C7C\u9F85\u7259",
        fre: "Sacr\xe9 dentier junior",
        bra: "Filhote Dente-Torto",
        schema: 30181,
        hun: "Kis Csorbafog",
        swe: "Lille gadden"
    },
    540: {
        img: "escapist",
        eng: "Escapist",
        rus: "\u0411\u0435\u0433\u043B\u0435\u0446",
        pol: "Ucieczkowicz",
        sch: "\u9003\u72AF",
        fre: "L'\xe9vad\xe9",
        bra: "Fugitivo",
        schema: 30183,
        hun: "Szabadul\xf3m\u0171v\xe9sz",
        swe: "Eskapist"
    },
    541: {
        img: "lhomme_burglerre",
        eng: "L'homme Burglerre",
        rus: "\u0411\u0443\u043B\u043E\u0447\u043D\u044B\u0439 \u0433\u0440\u0430\u0431\u0438\u0442\u0435\u043B\u044C",
        pol: "L'homme Burglerre",
        sch: "\u574F\u5821\u795E\u5077",
        fre: "L'homme Burglerre",
        bra: "Le Papa Burglerre",
        schema: 30182,
        swe: "Spionenne L'homme"
    },
    542: {
        img: "ward",
        eng: "The Ward",
        rus: "\u0421\u043C\u043E\u0442\u0440\u0438\u0442\u0435\u043B\u044C",
        pol: "Oddzia\u0142owy",
        sch: "\u75C5\u623F\u5927\u8863",
        fre: "Le Dispensaire",
        bra: "O Oficial",
        schema: 30190,
        hun: "A Test-\u0151r",
        swe: "H\xe4rb\xe4rgaren"
    },
    543: {
        img: "beep_boy",
        eng: "The Beep Boy",
        rus: "\u0411\u0438\u043F-\u0431\u043E\u0439",
        pol: "Bip Boy",
        sch: "BB \u6E38\u620F\u673A",
        fre: "La Beep Boy",
        bra: "O Bip Boy",
        schema: 30167,
        hun: "A F\xfctty\xf6s Fi\xfa",
        ger: "Der Beep Boy",
        swe: "Beep Boy"
    },
    544: {
        img: "cuban_bristle_crisis",
        eng: "The Cuban Bristle Crisis",
        rus: "\u041A\u0430\u0440\u0438\u0431\u0441\u043A\u0438\u0439 \u0432\u043E\u043B\u043E\u0441\u044F\u043D\u043E\u0439 \u043A\u0440\u0438\u0437\u0438\u0441",
        pol: "Kuba\u0144ski kryzys szczecinowy",
        sch: "\u53E4\u5DF4\u5927\u80E1\u5B50\u5371\u673A",
        fre: "La Barbe de crise cubaine",
        bra: "A Crise de Charutos de Cuba",
        schema: 30165,
        hun: "A Kubai S\xf6rtev\xe1ls\xe1g",
        swe: "Kubastilen"
    },
    545: {
        img: "a_brush_with_death",
        eng: "A Brush with Death",
        rus: "\u0421\u043C\u0435\u0440\u0442\u043E\u043F\u0438\u0441\u043D\u0430\u044F \u043A\u0438\u0441\u0442\u044C",
        pol: "Konowa\u0142 z brod\u0105",
        sch: "\u81F4\u6B7B\u80E1\u9AED",
        fre: "En brosse avec la Mort",
        bra: "Por um Fio",
        schema: 30186,
        hun: "Sz\u0151rsz\xe1l H\xedj\xe1n",
        swe: "Se sk\xe4gget med vit\xf6gat"
    },
    546: {
        img: "tricksters_turnout_gear",
        eng: "Trickster's Turnout Gear",
        rus: "\u041E\u0431\u043C\u0430\u043D\u0447\u0438\u0432\u044B\u0439 \u043A\u043E\u0441\u0442\u044E\u043C \u043F\u043E\u0436\u0430\u0440\u043D\u043E\u0433\u043E",
        pol: "\u017Baroodporne wdzianko \u017Cartownisia",
        sch: "\u6B3A\u8BC8\u5927\u5E08\u7684\u6D88\u9632\u6218\u6597\u670D",
        fre: "Le faux pompier",
        bra: "Casaco Antifogo do Vigarista",
        schema: 30169,
        hun: "A Tr\xfckk\xf6s T\u0171zolt\xf3-felszerel\xe9s",
        swe: "Busens utryckningsutrustning"
    },
    547: {
        img: "hong_kong_cone",
        eng: "Hong Kong Cone",
        rus: "\u0413\u043E\u043D\u043A\u043E\u043D\u0433\u0441\u043A\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "S\u0142omiany sto\u017Cek",
        sch: "\u6E2F\u5F0F\u6597\u7B20",
        fre: "C\xf4ne de Hong Kong",
        bra: "Cone de Hong Kong",
        schema: 30177,
        hun: "Hongkong K\xfap",
        swe: "Hong Kong-kon"
    },
    548: {
        img: "hurt_locher",
        eng: "The Hurt Locher",
        rus: "\u041F\u043E\u0432\u0435\u043B\u0438\u0442\u0435\u043B\u044C \u041B\u043E\u0445\u043D\u0435\u0441\u0441\u0430",
        pol: "Wybuchowe wdzianko",
        sch: "\u62C6\u5F39\u90E8\u961F",
        fre: "Le D\xe9mineur",
        bra: "A Guerra ao Pudor",
        schema: 30179,
        hun: "A Bamb\xe1k F\xf6ldj\xe9n",
        swe: "Lochande bombdr\xe4kt"
    },
    549: {
        img: "bone_dome",
        eng: "The Bone Dome",
        rus: "\u041A\u043E\u0441\u0442\u044F\u043D\u0430\u044F \u0431\u0430\u0448\u043A\u0430",
        pol: "Ko\u015Bcista kopu\u0142a",
        sch: "\u53BB\u9AA8\u5706\u5E3D",
        fre: "Le Casque cr\xe2nien",
        bra: "A Prote\xe7\xe3o de Cabe\xe7\xe3o",
        schema: 30162,
        hun: "Csontkupola",
        swe: "Benskallen"
    },
    550: {
        img: "air_raider",
        eng: "The Air Raider",
        rus: "\u0412\u043E\u0437\u0434\u0443\u0448\u043D\u044B\u0439 \u0440\u0435\u0439\u0434\u0435\u0440",
        pol: "Kierowca bombowca",
        sch: "\u7A7A\u88AD\u8005",
        fre: "Le Pilleur d'air",
        bra: "O Combatente A\xe9reo",
        schema: 30163,
        hun: "A L\xe9gi T\xe1mad\xf3",
        swe: "Luftbanditen"
    },
    551: {
        img: "medical_mystery",
        eng: "The Medical Mystery",
        rus: "\u0412\u0440\u0430\u0447\u0435\u0431\u043D\u0430\u044F \u0442\u0430\u0439\u043D\u0430",
        pol: "Tajemnica lekarska",
        sch: "\u533B\u5B66\u4E4B\u8C1C",
        fre: "Le Myst\xe8re m\xe9dical",
        bra: "O Mist\xe9rio M\xe9dico",
        schema: 30171,
        hun: "Az Orvosi Rejt\xe9ly",
        swe: "Det Medicinska Mysteriet"
    },
    552: {
        img: "cotton_head",
        eng: "The Cotton Head",
        rus: "\u0425\u043B\u043E\u043F\u043A\u043E\u0432\u0430\u044F \u0431\u0430\u0448\u043A\u0430",
        pol: "Dziadkowe trilby",
        sch: "\u68C9\u5236\u9876\u5E3D",
        fre: "Le Cotton Head",
        bra: "A Cabe\xe7a de Algod\xe3o",
        schema: 30175,
        hun: "A Pamutfej",
        swe: "Bomullstoppen"
    },
    553: {
        img: "slick_cut",
        eng: "The Slick Cut",
        rus: "\u0421\u0442\u0438\u043B\u044C\u043D\u044B\u0439 \u0437\u0430\u0447\u0435\u0441",
        pol: "Dziarski fryz",
        sch: "\u624B\u672F\u5934\u5DFE",
        fre: "La Coupe fut\xe9e",
        bra: "O Corte Malandro",
        schema: 30187,
        hun: "A Sima V\xe1g\xe1s",
        swe: "Klipska klippet"
    },
    554: {
        img: "frenchmans_formals",
        eng: "The Frenchman's Formals",
        rus: "\u0412\u0435\u0447\u0435\u0440\u043D\u0438\u0439 \u043D\u0430\u0440\u044F\u0434 \u0444\u0440\u0430\u043D\u0446\u0443\u0437\u0430",
        pol: "Elegancja-Francja",
        sch: "\u6CD5\u5F0F\u793C\u670D",
        fre: "Le Fran\xe7ais classique",
        bra: "As Formalidades do Franc\xeas",
        schema: 30189,
        hun: "A Francia Formaruha",
        swe: "Fransmannens H\xf6gtidsdr\xe4kt"
    },
    555: {
        img: "halloweiner",
        eng: "Halloweiner",
        rus: "\u0421\u043E\u0441\u0438\u0441\u043A\u0430 \u0432\u0441\u0435\u0445 \u0441\u0432\u044F\u0442\u044B\u0445",
        pol: "Par\xf3ween",
        sch: "\u4E07\u5723\u70ED\u72D7",
        fre: "Le Hante-dog",
        bra: "O Malsich\xe3o",
        schema: 30248,
        hun: "A Halloweersli",
        swe: "Hallowienerkorven"
    },
    556: {
        img: "horrific_head_of_hare",
        eng: "Horrific Head of Hare",
        rus: "\u0423\u0436\u0430\u0441\u043D\u0430\u044F \u043A\u0440\u043E\u043B\u0438\u0447\u044C\u044F \u0433\u043E\u043B\u043E\u0432\u0430",
        pol: "Koszmarna kr\xf3licza kiepe\u0142a",
        sch: "\u91CE\u5154\u7684\u60CA\u60E7\u5934\u5957",
        fre: "L'affreuse t\xeate de li\xe8vre",
        bra: "A Cabe\xe7a de Coelho do Capeta",
        schema: 30211,
        hun: "A Hapsif\xfcles",
        swe: "Hemska harhuvudet"
    },
    557: {
        img: "hounds_hood",
        eng: "Hound's Hood",
        rus: "\u0421\u043E\u0431\u0430\u0447\u0438\u0439 \u043A\u0430\u043F\u044E\u0448\u043E\u043D",
        pol: "Kejterski kaptur",
        sch: "\u730E\u72AC\u5934\u5957",
        fre: "La Capuche du Chien",
        bra: "O Gorro de Cachorro",
        schema: 30207,
        hun: "A Kop\xf3 Kapucnija",
        swe: "Hundhuvan"
    },
    558: {
        img: "face_plante",
        eng: "Face Plante",
        rus: "\u0425\u043E\u043A\u043A\u0435\u0439\u043D\u0430\u044F \u043C\u0430\u0441\u043A\u0430",
        pol: "Twarzoplask",
        sch: "\u666E\u5170\u7279\u9762\u5177",
        fre: "La Face de Plante",
        bra: "A M\xe1scara de H\xf3quei",
        schema: 30231,
        hun: "A Plante Arc",
        swe: "Fredagsmasken"
    },
    559: {
        img: "faun_feet",
        eng: "Faun Feet",
        rus: "\u041D\u043E\u0433\u0438 \u0444\u0430\u0432\u043D\u0430",
        pol: "Faunie st\xf3pki",
        sch: "\u5730\u72F1\u4FE1\u5DEE",
        fre: "Pattes du faune",
        bra: "P\xe9s de Fauno",
        schema: 30247,
        hun: "Faunl\xe1b",
        swe: "Faunf\xf6tter"
    },
    560: {
        img: "sprinting_cephalopod",
        eng: "Sprinting Cephalopod",
        rus: "\u0413\u043E\u043B\u043E\u0432\u043E\u043D\u043E\u0433\u0438\u0439 \u0431\u0435\u0433\u0443\u043D",
        pol: "G\u0142owonogi goniec",
        sch: "\u75BE\u8DD1\u7684\u89E6\u987B",
        fre: "Les C\xe9phalopodes de course",
        bra: "O Corredor Cefal\xf3pode",
        schema: 30253,
        hun: "A Sprintel\u0151 Cephalopod",
        swe: "Snabba sugkoppar"
    },
    561: {
        img: "terrier_trousers",
        eng: "Terrier Trousers",
        rus: "\u0428\u0442\u0430\u043D-\u0442\u0435\u0440\u044C\u0435\u0440",
        pol: "Trzewiki teriera",
        sch: "\u6897\u72AC\u957F\u88E4",
        fre: "Le pantalon pattes de terrier",
        bra: "As Cal\xe7as Caninas",
        schema: 30208,
        hun: "Terrier T\xe9rdnadr\xe1g",
        swe: "Terrierbyxorna"
    },
    562: {
        img: "cadavers_capper",
        eng: "Cadaver's Capper",
        rus: "\u0428\u043B\u044F\u043F\u0430 \u043C\u0435\u0440\u0442\u0432\u044F\u043A\u0430",
        pol: "Mycka martwiaka",
        sch: "\u50F5\u5C38\u7684\u7B26\u5492\u5E3D",
        fre: "La Toque du vampire",
        bra: "A Marca do Morto-Vivo",
        schema: 30251,
        hun: "A K\xednai K\xeds\xe9rt\u0151",
        swe: "Kadavrets keps"
    },
    563: {
        img: "freedom_feathers",
        eng: "Freedom Feathers",
        rus: "\u041F\u0435\u0440\u044C\u044F \u0441\u0432\u043E\u0431\u043E\u0434\u044B",
        pol: "Pi\xf3ra wolno\u015Bci",
        sch: "\u81EA\u7531\u4E4B\u7FBD",
        fre: "L'Aigle de la libert\xe9",
        bra: "As Asas da Liberdade",
        schema: 30239,
        hun: "A Sz\xe1ll\xe1s Szabads\xe1ga",
        swe: "Frihetsfj\xe4drarna"
    },
    564: {
        img: "hardium_helm",
        eng: "Hardium Helm",
        rus: "\u0428\u043B\u0435\u043C \u0438\u0437 \u0442\u0432\u0435\u0440\u0434\u0438\u044F",
        pol: "Hardy he\u0142m",
        sch: "\u786C\u6D3E\u5934\u76D4",
        fre: "Le Casque de hardium",
        bra: "O Capacete de Coisad\xfario",
        schema: 30264,
        hun: "A Hardium Sisak",
        swe: "H\xe5rdiumhj\xe4lmen"
    },
    565: {
        img: "hidden_dragon",
        eng: "Hidden Dragon",
        rus: "\u0417\u0430\u0442\u0430\u0438\u0432\u0448\u0438\u0439\u0441\u044F \u0434\u0440\u0430\u043A\u043E\u043D",
        pol: "Ukryty smok",
        sch: "\u85CF\u9F99",
        fre: "Le Dragon tigr\xe9",
        bra: "O Drag\xe3o Oculto",
        schema: 30228,
        hun: "A Rejtett S\xe1rk\xe1ny",
        swe: "Den dolda draken"
    },
    566: {
        img: "larval_lid",
        eng: "Larval Lid",
        rus: "\u041B\u0438\u0447\u0438\u043D\u043E\u0447\u043D\u0430\u044F \u043A\u0430\u0441\u043A\u0430",
        pol: "Glizdog\u0142owa",
        sch: "\u5A01\u86C6\u5148\u751F",
        fre: "Le Casque ver",
        bra: "A Minhoca dos Miolos",
        schema: 30294,
        hun: "A Kalapkukac",
        swe: "Larviga larvhj\xe4lmen"
    },
    567: {
        img: "spellbinders_bonnet",
        eng: "Spellbinder's Bonnet",
        rus: "\u041A\u043E\u043B\u043F\u0430\u043A \u0447\u0430\u0440\u043E\u0434\u0435\u044F",
        pol: "Gandalf Szarobrewy",
        sch: "\u5DEB\u5E08\u7684\u8F6F\u5E3D",
        fre: "Le Chapeau de sorcier",
        bra: "A Fantasia de Feiticeiro",
        schema: 30268,
        hun: "A Var\xe1zslatos S\xfcveg",
        swe: "Trollkarlens topphatt"
    },
    568: {
        img: "faux_manchu",
        eng: "Faux Manchu",
        rus: "\u0423\u0441\u044B \u041C\u0430\u043D\u0447\u0443",
        pol: "Fa\u0142szywy Mand\u017Cur",
        sch: "\u4EBA\u9020\u6EE1\u6D32\u80E1",
        fre: "Le Faux Manchu",
        bra: "O Faux Manchu",
        schema: 30227,
        hun: "A Faux Manchu",
        ger: "Der Faux Man Chu"
    },
    569: {
        img: "grub_grenades",
        eng: "Grub Grenades",
        rus: "\u041B\u0438\u0447\u0438\u043D\u043A\u0438-\u043B\u0438\u043C\u043E\u043D\u043A\u0438",
        pol: "Granaty robalowe",
        sch: "\u86C6\u5F62\u624B\u96F7",
        fre: "Larves explosives",
        bra: "Granadas Gosmentas",
        schema: 30221,
        hun: "L\xe1rvagr\xe1n\xe1t",
        swe: "Larvgranater"
    },
    570: {
        img: "jupiter_jumpers",
        eng: "Jupiter Jumpers",
        rus: "\u042E\u043F\u0438\u0442\u0435\u0440\u0441\u043A\u0438\u0439 \u0440\u0430\u043D\u0435\u0446",
        pol: "Saturnowe skoczki",
        sch: "\u6728\u661F\u98DE\u8DC3\u519B\u9774",
        fre: "Les Bottes de Jupiter",
        bra: "Os Propulsores de Plut\xe3o",
        schema: 30265,
        hun: "A Jupiter-ugr\xf3k",
        swe: "Jupiters jetst\xf6vlar"
    },
    571: {
        img: "lieutenant_bites_the_dust",
        eng: "Lieutenant Bites the Dust",
        rus: "\u041B\u0435\u0439\u0442\u0435\u043D\u0430\u043D\u0442 \u0411\u043E\u043B\u044C\u0448\u0435-\u043D\u0435-\u041A\u0443\u0441\u0430\u043A\u0430",
        pol: "Porucznik Gryzie Piach",
        sch: "\u66B4\u6BD9\u7684\u54AC\u54AC\u4E2D\u5C09",
        fre: "Lieutenant Mord-la-poussi\xe8re",
        bra: "Tenente Mortinho da Silva",
        schema: 30276,
        hun: "F\u0171beharap Hadnagy",
        swe: "L\xf6jtnant Betts sista bett"
    },
    572: {
        img: "shaolin_sash",
        eng: "Shaolin Sash",
        rus: "\u0428\u0430\u043E\u043B\u0438\u043D\u044C\u0441\u043A\u0438\u0439 \u043F\u043E\u044F\u0441",
        pol: "Szaoli\u0144ska szarfa",
        sch: "\u5C11\u6797\u8170\u5E26",
        fre: "L'\xc9charpe shaolin",
        bra: "A Faixa de Shaolin",
        schema: 30281,
        hun: "A Saolin Selyem\xf6v",
        swe: "Shaolin-b\xe4ltet"
    },
    573: {
        img: "space_bracers",
        eng: "Space Bracers",
        rus: "\u041A\u043E\u0441\u043C\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043D\u0430\u0440\u0443\u0447\u0438",
        pol: "Galaktyczne karwasze",
        sch: "\u592A\u7A7A\u62A4\u8155",
        fre: "Les Brassards spatiaux",
        bra: "As Bra\xe7adeiras Espaciais",
        schema: 30266,
        hun: "Az \u0170rkarv\xe9rt",
        swe: "Astronomiska armskydd"
    },
    574: {
        img: "bozos_bouffant",
        eng: "Bozo's Bouffant",
        rus: "\u041A\u043B\u043E\u0443\u043D\u0441\u043A\u0438\u0439 \u043D\u0430\u0447\u0435\u0441",
        pol: "Czupryna pajaca",
        sch: "\u7B28\u86CB\u7684\u84EC\u677E\u53D1\u578B",
        fre: "Tronche de clown",
        bra: "O Cabelo do Comediante",
        schema: 30245,
        hun: "Boh\xf3cbozont",
        swe: "Bozos bouffant"
    },
    575: {
        img: "burnys_boney_bonnet",
        eng: "Burny's Boney Bonnet",
        rus: "\u0420\u043E\u0433\u0430\u0442\u044B\u0439 \u043A\u0430\u043F\u044E\u0448\u043E\u043D \u0416\u0433\u0443\u0447\u043A\u0438",
        pol: "Kolczasty kapturek Den\u017Cara",
        sch: "\u785D\u535A\u58EB\u7684\u90A6\u5C3C\u5E3D",
        fre: "Le Bonnet cornu de Burny",
        bra: "O Capuz de Chifres Chamuscados",
        schema: 30203,
        hun: "A T\xfczes T\xfclk\xf6s T\xf6kf\xf6d\u0151je",
        swe: "Brendas beniga bahytt"
    },
    576: {
        img: "corpsemopolitan",
        eng: "Corpsemopolitan",
        rus: "\u0422\u0440\u0443\u043F\u043C\u043E\u043F\u043E\u043B\u0438\u0442\u0430\u043D",
        pol: "Zw\u0142okopolitan",
        sch: "\u5927\u90FD\u4F1A\u679C\u6C41",
        fre: "Le Corpsmopolite",
        bra: "O Dry Mortini",
        schema: 30285,
        hun: "A Hullapolit\xe1n",
        swe: "Kroppsmopolitan"
    },
    577: {
        img: "crispy_golden_locks",
        eng: "Crispy Golden Locks",
        rus: "\u0417\u0430\u043F\u0435\u0447\u0435\u043D\u043D\u044B\u0435 \u043A\u0443\u0434\u0440\u044F\u0448\u043A\u0438",
        pol: "Chrupi\u0105co z\u0142ote loki",
        sch: "\u6613\u788E\u7684\u91D1\u5047\u53D1",
        fre: "Les Boucles d'or frites",
        bra: "Os Cachinhos Bem Dourados",
        schema: 30204,
        hun: "A Ropog\xf3s Arany F\xfcrt\xf6k",
        swe: "Svedda guldlockar"
    },
    578: {
        img: "gothic_guise",
        eng: "Gothic Guise",
        rus: "\u0413\u043E\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043E\u0431\u043B\u0438\u043A",
        pol: "Gotycka garderoba",
        sch: "\u54E5\u7279\u5F0F\u4F2A\u88C5",
        fre: "La Gargouille gothique",
        bra: "A G\xe1rgula G\xf3tica",
        schema: 30222,
        hun: "A T\u0171zk\xf6p\u0151 V\xedzk\xf6p\u0151",
        swe: "Gotiska hotet"
    },
    579: {
        img: "macabre_mask",
        eng: "Macabre Mask",
        rus: "\u041C\u0440\u0430\u0447\u043D\u0430\u044F \u043C\u0430\u0441\u043A\u0430",
        pol: "Makabryczna maska",
        sch: "\u9A87\u4EBA\u9762\u5177",
        fre: "Le masque macabre",
        bra: "A M\xe1scara Macabra",
        schema: 30269,
        hun: "Marcona Maszk",
        swe: "Makabra masken"
    },
    580: {
        img: "mucous_membrain",
        eng: "Mucous Membrain",
        rus: "\u0421\u043B\u0438\u0437\u0438\u0441\u0442\u044B\u0439 \u043C\u043E\u0437\u0436\u0435\u0447\u043E\u043A",
        pol: "Membrana \u015Bluzowa",
        sch: "\u7C98\u819C\u8111\u6D46",
        fre: "Le Mucus de la membrane cr\xe2nienne",
        bra: "O Miolo Mucoso",
        schema: 30235,
        hun: "A Ny\xe1lk\xe1s Agybr\xe1n",
        swe: "Slemmiga slemhinnan"
    },
    581: {
        img: "ravens_visage",
        eng: "Raven's Visage",
        rus: "\u0412\u043E\u0440\u043E\u043D\u0438\u0439 \u043A\u043B\u044E\u0432",
        pol: "Krucze oblicze",
        sch: "\u5DE8\u5927\u7684\u4E4C\u9E26\u5934\u9AA8",
        fre: "Le Cr\xe2ne du corbeau",
        bra: "O Cr\xe2nio de Corvo",
        schema: 30298,
        hun: "A Holl\xf3 Tekintete",
        swe: "Korpgluggarna"
    },
    582: {
        img: "spectralnaut",
        eng: "Spectralnaut",
        rus: "\u041F\u0440\u0438\u0437\u0440\u0430\u043A\u043E\u043D\u0430\u0432\u0442",
        pol: "Widmonauta",
        sch: "\u53E4\u602A\u7684\u5B87\u822A\u5934\u76D4",
        fre: "L'Explorateur spectral",
        bra: "O Espectronauta",
        schema: 30194,
        hun: "Az \u0170rk\xeds\xe9rtet",
        swe: "Sp\xf6konauten"
    },
    583: {
        img: "abhorrent_appendages",
        eng: "Abhorrent Appendages",
        rus: "\u041C\u0435\u0440\u0437\u043A\u0438\u0435 \u043F\u0440\u0438\u0447\u0438\u043D\u0434\u0430\u043B\u044B",
        pol: "Abominacyjne akcesoria",
        sch: "\u53EF\u618E\u7684\u56DB\u80A2",
        fre: "Les Appendices r\xe9pugnants",
        bra: "Os Membros do Monstro",
        schema: 30303,
        hun: "V\xe9rfagyaszt\xf3 V\xe9gtagok",
        swe: "L\xe4skiga lemmar"
    },
    584: {
        img: "beast_from_below",
        eng: "Beast from Below",
        rus: "\u0427\u0443\u0434\u043E\u0432\u0438\u0449\u0435 \u0438\u0437-\u043F\u043E\u0434 \u0437\u0435\u043C\u043B\u0438",
        pol: "Groza z g\u0142\u0119bin",
        sch: "\u4E0B\u754C\u6076\u517D",
        fre: "La b\xeate des profondeurs",
        bra: "A Criatura das Profundezas",
        schema: 30191,
        hun: "A M\xe9lys\xe9gi Bestia",
        swe: "Odjuret fr\xe5n djupet"
    },
    585: {
        img: "carrion_companion",
        eng: "Carrion Companion",
        rus: "\u041C\u0435\u0440\u0442\u0432\u044B\u0439 \u043A\u043E\u043C\u043F\u0430\u043D\u044C\u043E\u043D",
        pol: "Trupi towarzysz",
        sch: "\u8150\u8089\u540C\u4F34",
        fre: "La Charogne de compagnie",
        bra: "A Carni\xe7a Companheira",
        schema: 30288,
        hun: "Kim\xfalt Kishaver",
        swe: "Kamratliga kadavret"
    },
    586: {
        img: "cauterizers_caudal_appendage",
        eng: "Cauterizer's Caudal Appendage",
        rus: "\u0417\u0430\u0434\u043D\u044F\u044F \u043A\u043E\u043D\u0435\u0447\u043D\u043E\u0441\u0442\u044C \u043F\u0440\u0438\u0436\u0438\u0433\u0430\u0442\u0435\u043B\u044F",
        pol: "Ognisty ogon przy\u017Cegacza",
        sch: "\u70E7\u707C\u4E4B\u5C3E",
        fre: "L\u2019Appendice caudal caut\xe9ris\xe9",
        bra: "O Complemento Caudal do Cauterizador",
        schema: 30225,
        hun: "A T\xfczes Tompor-tartoz\xe9ka",
        swe: "Heta drakstj\xe4rten"
    },
    587: {
        img: "creature_from_the_heap",
        eng: "Creature from the Heap",
        rus: "\u041C\u0443\u0441\u043E\u0440\u043D\u043E\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043E",
        pol: "Bestia ze \u015Bmieciowiska",
        sch: "\u9690\u85CF\u5728\u5783\u573E\u6876\u5185\u7684\u751F\u7269",
        fre: "La cr\xe9ature des poubelles",
        bra: "A Criatura das Impurezas",
        schema: 30296,
        hun: "A R\xe9m a Rak\xe1sb\xf3l",
        swe: "Sopmonstret"
    },
    588: {
        img: "death_support_pack",
        eng: "Death Support Pack",
        rus: "\u0421\u0438\u0441\u0442\u0435\u043C\u0430 \u0441\u043C\u0435\u0440\u0442\u043E\u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F",
        pol: "Zestaw pierwszej po\u017Cogi",
        sch: "\u6B7B\u4EA1\u8865\u7ED9\u5305",
        fre: "Le Pack de survie",
        bra: "O Protetor do Psicopata",
        schema: 30257,
        hun: "A Hal\xe1lfenntart\xf3 Egys\xe9g",
        swe: "D\xf6dshj\xe4lpen"
    },
    589: {
        img: "external_organ",
        eng: "External Organ",
        rus: "\u0412\u043D\u0435\u0448\u043D\u0438\u0439 \u043E\u0440\u0433\u0430\u043D",
        pol: "Organ zewn\u0119trzny",
        sch: "\u9ED1\u8272\u7BA1\u5F26\u4E50",
        fre: "L'Orgue externe",
        bra: "O \xd3rg\xe3o Externo",
        schema: 30216,
        hun: "Az Orgoniz\xe1tor",
        swe: "Det Utv\xe4ndiga Organet"
    },
    590: {
        img: "glob",
        eng: "Glob",
        rus: "\u041A\u0430\u043F\u043B\u044F",
        pol: "Glut",
        sch: "\u5E7D\u6D6E\u5C0F\u7CBE\u7075",
        fre: "Le Glob",
        bra: "A Gosma",
        schema: 30286,
        hun: "A Glob",
        swe: "Blobben"
    },
    591: {
        img: "grisly_gumbo",
        eng: "Grisly Gumbo",
        rus: "\u0421\u043A\u0432\u0435\u0440\u043D\u044B\u0439 \u0441\u0443\u043F\u0447\u0438\u043A",
        pol: "Grobowa groch\xf3wa",
        sch: "\u6050\u6016\u7684\u6D53\u6C64",
        fre: "Le Gombo humain",
        bra: "A Sopa Misantropa",
        schema: 30277,
        hun: "A Borzalmas Bogr\xe1cs",
        swe: "Grisiga grytan"
    },
    592: {
        img: "handhunter",
        eng: "Handhunter",
        rus: "\u041E\u0445\u043E\u0442\u043D\u0438\u043A \u0437\u0430 \u0440\u0443\u043A\u0430\u043C\u0438",
        pol: "Palco\u015Bcinacz",
        sch: "\u65A9\u624B\u94E1\u5200",
        fre: "La Guillotine \xe0 mains",
        bra: "A Decepadora de M\xe3os",
        schema: 30267,
        hun: "A K\xe9zvad\xe1sz",
        swe: "Handj\xe4garen"
    },
    593: {
        img: "hard_headed_hardware",
        eng: "Hard-Headed Hardware",
        rus: "\u0422\u0432\u0435\u0440\u0434\u043E\u043B\u043E\u0431\u0430\u044F \u0430\u043F\u043F\u0430\u0440\u0430\u0442\u0443\u0440\u0430",
        pol: "Twardog\u0142owy osprz\u0119t",
        sch: "\u786C\u5934\u786C\u8111",
        fre: "T\xeate de pioche infernale",
        bra: "A M\xe1scara de Metal Maquiav\xe9lica",
        schema: 30192,
        hun: "Kem\xe9nyfej\u0171 Hardver",
        swe: "H\xe5rdhudad H\xe5rdvara"
    },
    594: {
        img: "hollowhead",
        eng: "Hollowhead",
        rus: "\u041F\u0443\u0441\u0442\u043E\u0433\u043E\u043B\u043E\u0432\u044B\u0439",
        pol: "Pustog\u0142owy",
        sch: "\u4E07\u5723\u7F69",
        fre: "La t\xeate vide",
        bra: "A Cabe\xe7a de Vento",
        schema: 30220,
        hun: "Az \xdcresfej\u0171",
        swe: "H\xe5lhuvudet"
    },
    595: {
        img: "maniacs_manacles",
        eng: "Maniac's Manacles",
        rus: "\u041E\u043A\u043E\u0432\u044B \u043C\u0430\u043D\u044C\u044F\u043A\u0430",
        pol: "Okowy op\u0119tanego",
        sch: "\u75AF\u5B50\u7684\u624B\u94D0",
        fre: "Les Menottes du maniaque",
        bra: "As Algemas do Alucinado",
        schema: 30196,
        hun: "Az Elszabadult Eszel\u0151s",
        swe: "Bl\xe5d\xe5rens bojor"
    },
    596: {
        img: "monsters_stompers",
        eng: "Monster's Stompers",
        rus: "\u041B\u0430\u043F\u0438\u0449\u0438 \u0447\u0443\u0434\u0438\u0449\u0430",
        pol: "Potworne przygniatacze",
        sch: "\u602A\u517D\u7684\u8DF5\u8E0F\u722A\u9774",
        fre: "Les Pattes de monstre",
        bra: "As Patas Paleontol\xf3gicas",
        schema: 30259,
        hun: "A Sz\xf6rny\u0171 Topog\xf3k",
        swe: "Monstermockasiner"
    },
    597: {
        img: "py_40_incinibot",
        eng: "PY-40 Incinibot",
        rus: "\u0418\u043D\u0441\u0438\u043D\u0438\u0431\u043E\u0442 PY-40",
        pol: "Spopielobot PY-40",
        sch: "\u706B\u7130\u673A\u5668\u4EBA 40 \u53F7",
        fre: "Incin\xe9robot PY-40",
        bra: "Incinerab\xf4 PY-40",
        schema: 30290,
        swe: "PY-40 brandbot"
    },
    598: {
        img: "rugged_respirator",
        eng: "Rugged Respirator",
        rus: "\u041A\u0440\u0435\u043F\u043A\u0438\u0439 \u0440\u0435\u0441\u043F\u0438\u0440\u0430\u0442\u043E\u0440",
        pol: "Rdzewiej\u0105cy respirator",
        sch: "\u575A\u56FA\u8010\u7528\u7684\u547C\u5438\u5668",
        fre: "Le respirateur robuste",
        bra: "O Respirador R\xfastico",
        schema: 30218,
        hun: "A Gonosz G\xe1z\xe1larc",
        swe: "Robust respirator"
    },
    599: {
        img: "scorched_skirt",
        eng: "Scorched Skirt",
        rus: "\u041F\u043E\u0434\u043F\u0430\u043B\u0435\u043D\u043D\u044B\u0439 \u043F\u043E\u0434\u043E\u043B",
        pol: "Spalona sp\xf3dnica",
        sch: "\u70E7\u7126\u7684\u56F4\u88D9",
        fre: "La Jupe carbonis\xe9e",
        bra: "A Saia Chamuscada",
        schema: 30205,
        hun: "A Szenes Szurkol\xf3",
        swe: "Br\xe4nda kjolen"
    },
    600: {
        img: "up_pyroscopes",
        eng: "Up Pyroscopes",
        rus: "\u041F\u043E\u0434\u043D\u044F\u0442\u044B\u0439 \u043F\u0438\u0440\u043E-\u0441\u043A\u043E\u043F",
        pol: "Pyroskopy",
        sch: "\u706B\u7130\u5175\u7684\u86D9\u4EBA\u4E4B\u9B42",
        fre: "Les Pyroscopes",
        bra: "Pyrosc\xf3pios \xe0 Vista",
        schema: 30213,
        hun: "Piroszk\xf3pot Fel",
        swe: "Pyroskop"
    },
    601: {
        img: "vicious_visage",
        eng: "Vicious Visage",
        rus: "\u0417\u043B\u043E\u0431\u043D\u0430\u044F \u043C\u0430\u0441\u043A\u0430",
        pol: "Fatalna facjata",
        sch: "\u6076\u6BD2\u9762\u7F69",
        fre: "Le Visage vicieux",
        bra: "A M\xe1scara do Monstro",
        schema: 30273,
        hun: "Az \xc1d\xe1z \xc1br\xe1zat",
        swe: "Griniga gasmasken"
    },
    602: {
        img: "headtakers_hood",
        eng: "Headtaker's Hood",
        rus: "\u041A\u0430\u043F\u044E\u0448\u043E\u043D \u0433\u043E\u043B\u043E\u0432\u043E\u0440\u0435\u0437\u0430",
        pol: "Kaptur kosig\u0142owy",
        sch: "\u884C\u5211\u8005\u7684\u9762\u7F69",
        fre: "La Cagoule du d\xe9capiteur",
        bra: "O Gorro da Guilhotina",
        schema: 30240,
        hun: "A Fejvev\u0151 Fejfed\u0151",
        swe: "Halshuggarens huva"
    },
    603: {
        img: "mann_bird_of_aberdeen",
        eng: "Mann-Bird of Aberdeen",
        rus: "\u041F\u0442\u0438\u0446\u0430-\u043B\u043E\u0432\u0435\u0446 \u0438\u0437 \u0410\u0431\u0435\u0440\u0434\u0438\u043D\u0430",
        pol: "Ptakocz\u0142ek z Aberdeen",
        sch: "\u963F\u4F2F\u4E01\u7684\u9E1F\u5934\u4EBA",
        fre: "L'Oiseau d'Aberdeen",
        bra: "O P\xe1ssaro de Aberdeen",
        schema: 30282,
        hun: "Az Aberdeeni Mad\xe1rember",
        swe: "F\xe5gelmann fr\xe5n Aberdeen"
    },
    604: {
        img: "squids_lid",
        eng: "Squid's Lid",
        rus: "\u041A\u0430\u043B\u044C\u043C\u0430\u0440\u043E\u0432\u0430 \u0448\u043B\u044F\u043F\u0430",
        pol: "Postrach owoc\xf3w morza",
        sch: "\u72EC\u773C\u4E4C\u8D3C",
        fre: "Le Chapeau de la M\xe9duse",
        bra: "O Pirata Es-tentacular",
        schema: 30219,
        hun: "A Tintahalas Fejfed\u0151",
        swe: "Bl\xe4ckfiskens Lock"
    },
    605: {
        img: "transylvania_top",
        eng: "Transylvania Top",
        rus: "\u0422\u0440\u0430\u043D\u0441\u0438\u043B\u044C\u0432\u0430\u043D\u0441\u043A\u0430\u044F \u043F\u0440\u0438\u0447\u0435\u0441\u043A\u0430",
        pol: "Transylwa\u0144ska czupryna",
        sch: "\u5438\u8840\u9B3C\u4E4B\u7956",
        fre: "La Coupe de Transylvanie",
        bra: "O Topete da Transilv\xe2nia",
        schema: 30241,
        hun: "Az Erd\xe9lyi Viselet",
        swe: "Transsylvanknoppen"
    },
    606: {
        img: "capn_calamari",
        eng: "Cap'n Calamari",
        rus: "\u041A\u0430\u043F\u0438\u0442\u0430\u043D \u041A\u0430\u043B\u044C\u043C\u0430\u0440",
        pol: "Kapitan Kalmar",
        sch: "\u9C7F\u9C7C\u8239\u957F",
        fre: "Cap'taine Calamar",
        bra: "Capit\xe3o Calamari",
        schema: 30193,
        hun: "Kalm\xe1r Kapit\xe1ny",
        swe: "Kapten Calamari"
    },
    607: {
        img: "horsemanns_hand_me_down",
        eng: "Horsemann's Hand-Me-Down",
        rus: "\u0418\u0437\u043D\u043E\u0448\u0435\u043D\u043D\u044B\u0439 \u043F\u043B\u0430\u0449 \u0432\u0441\u0430\u0434\u043D\u0438\u043A\u0430",
        pol: "Dziedzictwo Bezkonnego Je\u017Ad\u017Aca",
        sch: "\u65E0\u5934\u9A91\u58EB\u7684\u4F20\u5BB6\u4E4B\u5B9D",
        fre: "La Guenille du Cavalier sans T\xeate",
        bra: "A Capa do Cavaleiro Carente de Cavalo e Cabe\xe7a",
        schema: 30243,
        hun: "A Lovas Levetett Leple",
        swe: "Horsemanns gamla kappa"
    },
    608: {
        img: "lordly_lapels",
        eng: "Lordly Lapels",
        rus: "\u041D\u0430\u0434\u043C\u0435\u043D\u043D\u044B\u0435 \u043B\u0430\u0446\u043A\u0430\u043D\u044B",
        pol: "Ksi\u0105\u017C\u0119cy ko\u0142nierz",
        sch: "\u8D35\u65CF\u8863\u9886",
        fre: "Le Col comtois",
        bra: "As Lapelas do Lorde",
        schema: 30249,
        hun: "A Gr\xf3f Gall\xe9rja",
        swe: "Grevens krage"
    },
    609: {
        img: "parasight",
        eng: "Parasight",
        rus: "\u041F\u0430\u0440\u0430\u0432\u0438\u0434\u0435\u043D\u0438\u0435",
        pol: "Paso-wid",
        sch: "\u5BC4\u751F\u4E4B\u773C",
        fre: "L'oeil ind\xe9sirable",
        bra: "O Paravista",
        schema: 30292,
        hun: "A Paral\xe1tv\xe1ny",
        swe: "Parasikte-n"
    },
    610: {
        img: "polly_putrid",
        eng: "Polly Putrid",
        rus: "\u041F\u043E\u043A\u043E\u0439\u043D\u044B\u0439 \u041F\u043E\u043F\u043A\u0430",
        pol: "Plugawa Polly",
        sch: "\u8150\u70C2\u7684\u9E66\u9E49",
        fre: "Perroquet putride",
        bra: "Papagaio Putrefato",
        schema: 30226,
        hun: "Purcant Polly",
        swe: "Polly Pest"
    },
    611: {
        img: "chicken_kiev",
        eng: "Chicken Kiev",
        rus: "\u0426\u044B\u043F\u043B\u0435\u043D\u043E\u043A \u043F\u043E-\u043A\u0438\u0435\u0432\u0441\u043A\u0438",
        pol: "Kotlet de volaille",
        sch: "\u9E21\u8F85\u731B\u79BD",
        fre: "Le Poulet \xe0 la Kiev",
        bra: "O Frango \xe0 Kiev",
        schema: 30238,
        hun: "A Kijevi Csirke",
        swe: "Kievkycklingen"
    },
    612: {
        img: "horned_honcho",
        eng: "Horned Honcho",
        rus: "\u0420\u043E\u0433\u0430\u0442\u044B\u0439 \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044C",
        pol: "Piekielny prze\u0142o\u017Cony",
        sch: "\u53CC\u89D2\u961F\u957F",
        fre: "Le Honcho \xe0 cornes",
        bra: "O Chef\xe3o dos Chifres",
        schema: 30275,
        hun: "A Szarvas Szivar",
        swe: "H\xe5rdhudad huvudkl\xe4dnad"
    },
    613: {
        img: "ivan_the_inedible",
        eng: "Ivan the Inedible",
        rus: "\u0418\u0432\u0430\u043D \u041D\u0435\u0441\u044A\u0435\u0434\u043E\u0431\u043D\u044B\u0439",
        pol: "Iwan Niejadalny",
        sch: "\u6050\u6016\u7684\u4F0A\u51E1\u4E09\u660E\u6CBB",
        fre: "Ivan l'immangeable",
        bra: "Ivan, o Incomest\xedvel",
        schema: 30217,
        hun: "Iv\xe1n, az Ehetetlen",
        swe: "Ivan den o\xe4tliga"
    },
    614: {
        img: "last_bite",
        eng: "Last Bite",
        rus: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 \u0443\u043A\u0443\u0441",
        pol: "Ostatni k\u0119s",
        sch: "\u6700\u540E\u4E00\u53E3",
        fre: "L'Ultime bouch\xe9e",
        bra: "A \xdaltima Mordida",
        schema: 30199,
        hun: "Az Utols\xf3 Harap\xe1s",
        swe: "Det Sista Bettet"
    },
    615: {
        img: "monstrous_mandible",
        eng: "Monstrous Mandible",
        rus: "\u0427\u0443\u0434\u043E\u0432\u0438\u0449\u043D\u0430\u044F \u0447\u0435\u043B\u044E\u0441\u0442\u044C",
        pol: "Sztraszna szczena",
        sch: "\u5DE8\u5927\u7684\u4E0B\u989A",
        fre: "La mandibule monstrueuse",
        bra: "A Mand\xedbula Monstruosa",
        schema: 30280,
        hun: "Az \xc1llati \xc1llkapocs",
        swe: "Monsterk\xe4ken"
    },
    616: {
        img: "grease_monkey",
        eng: "Grease Monkey",
        rus: "\u041F\u0440\u0438\u043C\u0430\u0442-\u043C\u0435\u0445\u0430\u043D\u0438\u043A",
        pol: "Ma\u0142pi mechanik",
        sch: "\u6CB9\u7322\u72F2",
        fre: "Le M\xe9canosinge",
        bra: "O Macaco de Oficina",
        schema: 30223,
        hun: "A Szaki Maki",
        swe: "Makakmekanikern"
    },
    617: {
        img: "alternative_medicine_mann",
        eng: "Alternative Medicine Mann",
        rus: "\u0410\u043B\u044C\u0442\u0435\u0440-\u043C\u0430\u043D\u043D-\u0442\u0438\u0432\u043D\u0430\u044F \u043C\u0435\u0434\u0438\u0446\u0438\u043D\u0430",
        pol: "Szaman na perypetiach",
        sch: "\u975E\u4F20\u7EDF\u533B\u5B66\u533B\u5E08",
        fre: "Le M\xe9decin alternatif",
        bra: "O Homem da Medicina Alternativa",
        schema: 30224,
        hun: "Az Alternat\xedv Seb\xe9szmaszk",
        swe: "Alternativa medicinmannen"
    },
    618: {
        img: "das_blutliebhaber",
        eng: "Das Blutliebhaber",
        rus: "\u0414\u0430\u0441 \u041A\u0440\u043E\u0432\u043E\u043B\u044E\u0431",
        pol: "Das Blutliebhaber",
        sch: "\u55DC\u8840\u72C2\u9B54",
        fre: "Das Blutliebhaber",
        bra: "Das Blutliebhaber",
        schema: 30232
    },
    619: {
        img: "medimedes",
        eng: "Medimedes",
        rus: "\u041C\u0435\u0434\u0438\u043C\u0435\u0434",
        pol: "Medymedes",
        sch: "\u9EA6\u57FA\u7C73\u5FB7",
        fre: "Medim\xe8de",
        bra: "Medimedes",
        schema: 30237,
        hun: "Szanim\xe9d\xe9sz"
    },
    620: {
        img: "shamans_skull",
        eng: "Shaman's Skull",
        rus: "\u0427\u0435\u0440\u0435\u043F \u0448\u0430\u043C\u0430\u043D\u0430",
        pol: "Czaszka szamana",
        sch: "\u8428\u6EE1\u7684\u5934\u9AA8",
        fre: "Le Cr\xe2ne pour shaman",
        bra: "O Cr\xe2nio do Xam\xe3",
        schema: 30270,
        hun: "A S\xe1m\xe1n Kopony\xe1ja",
        swe: "Shamanskallen"
    },
    621: {
        img: "teutonkahmun",
        eng: "Teutonkahmun",
        rus: "\u0422\u0435\u0432\u0442\u043E\u043D\u0445\u0430\u043C\u043E\u043D",
        pol: "Teutonchamon",
        sch: "\u56FE\u5766\u5361\u8499\u7684\u8BC5\u5492",
        fre: "Teutonkahmon",
        bra: "Teutoc\xe2mon",
        schema: 30293,
        hun: "Teutonhamon",
        ger: "Teutonchamun"
    },
    622: {
        img: "trepanabotomizer",
        eng: "Trepanabotomizer",
        rus: "\u0422\u0440\u0435\u043F\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0442\u043E\u0440",
        pol: "Trepanabotomizer",
        sch: "\u6EE5\u533B\u5145\u6570",
        fre: "Le tr\xe9panolobotomiseur",
        bra: "O Trepanalobotomizador",
        schema: 30233,
        hun: "A Trepanabotomiz\xe1l\xf3",
        swe: "Trepalobotomeraren"
    },
    623: {
        img: "archimedes_the_undying",
        eng: "Archimedes the Undying",
        rus: "\u0410\u0440\u0445\u0438\u043C\u0435\u0434 \u0411\u0435\u0441\u0441\u043C\u0435\u0440\u0442\u043D\u044B\u0439",
        pol: "Archimedes Z",
        sch: "\u963F\u50F5\u7C73\u5FB7",
        fre: "Archim\xe8de zombie",
        bra: "Arquimedes, o Imortal",
        schema: 30279,
        hun: "Arkhim\xe9d\xe9sz, az \xe9l\u0151holt",
        swe: "Arkimedes den od\xf6dliga"
    },
    624: {
        img: "lo_grav_loafers",
        eng: "Lo-Grav Loafers",
        rus: "\u0422\u0443\u0444\u043B\u0438 \u043D\u0438\u0437\u043A\u043E\u0433\u043E \u043F\u0440\u0438\u0442\u044F\u0436\u0435\u043D\u0438\u044F",
        pol: "Ksi\u0119\u017Cycowe kamasze",
        sch: "\u4F4E\u91CD\u529B\u61D2\u6C49\u978B",
        fre: "Les Bottes anti-gravit\xe9",
        bra: "As Botas de Baixa Gravidade",
        schema: 30229,
        hun: "A Holdpapucs",
        swe: "Tyngdl\xf6sa loafers"
    },
    625: {
        img: "ramses_regalia",
        eng: "Ramses' Regalia",
        rus: "\u0420\u0435\u0433\u0430\u043B\u0438\u0438 \u0420\u0430\u043C\u0437\u0435\u0441\u0430",
        pol: "Regalia Ramzesa",
        sch: "\u62C9\u7F8E\u897F\u65AF\u7684\u7687\u5BB6\u9057\u7269",
        fre: "Le Costume de Rams\xe8s",
        bra: "Regalias de Rams\xe9s",
        schema: 30299,
        hun: "Ramszesz Rongyai",
        swe: "Ramses regalier"
    },
    626: {
        img: "second_opinion",
        eng: "Second Opinion",
        rus: "\u0414\u0440\u0443\u0433\u043E\u0435 \u043C\u043D\u0435\u043D\u0438\u0435",
        pol: "Druga opinia",
        sch: "\u7B2C\u4E8C\u8BCA\u65AD\u610F\u89C1",
        fre: "Deuxi\xe8me avis",
        bra: "Segunda Opini\xe3o",
        schema: 30197,
        hun: "M\xe1sodv\xe9lem\xe9ny",
        rom: "O a Doua Opinie",
        swe: "Andra konsultation"
    },
    627: {
        img: "surgeons_space_suit",
        eng: "Surgeon's Space Suit",
        rus: "\u0425\u0438\u0440\u0443\u0440\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0441\u043A\u0430\u0444\u0430\u043D\u0434\u0440",
        pol: "Skafander kosmiczny doktora",
        sch: "\u5916\u79D1\u533B\u751F\u7684\u592A\u7A7A\u670D",
        fre: "La combinaison d'astro-chirurgien",
        bra: "O Traje Espacial do Cirurgi\xe3o",
        schema: 30230,
        hun: "A Seb\xe9sz \u0170rruh\xe1ja",
        swe: "Kirurgens rymddr\xe4kt"
    },
    628: {
        img: "vicars_vestments",
        eng: "Vicar's Vestments",
        rus: "\u041E\u0431\u043B\u0430\u0447\u0435\u043D\u0438\u0435 \u0432\u0438\u043A\u0430\u0440\u0438\u044F",
        pol: "Szata wikarego",
        sch: "\u6559\u5802\u7267\u5E08\u7684\u5723\u8863",
        fre: "Les V\xeatements du vicaire",
        bra: "As Vestimentas do Vig\xe1rio",
        schema: 30263,
        hun: "A Magasztos Mell\xe9ny",
        swe: "Pastorns paltor"
    },
    629: {
        img: "hallowed_headcase",
        eng: "Hallowed Headcase",
        rus: "\u0421\u0432\u044F\u0449\u0435\u043D\u043D\u0430\u044F \u043C\u0430\u0441\u043A\u0430",
        pol: "Sakralny \u015Bwir",
        sch: "\u4E07\u5723\u72C2\u4EBA",
        fre: "Le Saint masque",
        bra: "A M\xe1scara M\xedstica",
        schema: 30287,
        hun: "A Megszentelt Maszk",
        swe: "Avskyv\xe4rda ansiktsmasken"
    },
    630: {
        img: "sir_shootsalot",
        eng: "Sir Shootsalot",
        rus: "\u0421\u044D\u0440 \u0421\u043E\u0432\u043E\u0441\u0442\u0440\u0435\u043B",
        pol: "Pan Du\u017Costrzel",
        sch: "\u591C\u88AD\u8005\u7235\u58EB",
        fre: "Sire Tirealot",
        bra: "Olho de Coruja",
        schema: 30284,
        hun: "Sir Lel\xf6vi"
    },
    631: {
        img: "carious_chameleon",
        eng: "Carious Chameleon",
        rus: "\u0413\u043D\u0438\u043B\u043E\u0439 \u0445\u0430\u043C\u0435\u043B\u0435\u043E\u043D",
        pol: "Nadgni\u0142y kameleon",
        sch: "\u8150\u70C2\u7684\u53D8\u8272\u9F99",
        fre: "Le Cam\xe9l\xe9on d\xe9charn\xe9",
        bra: "O Camale\xe3o Cariado",
        schema: 30258,
        hun: "Kinyiffant Kam\xe9leon",
        swe: "Karieskameleont"
    },
    632: {
        img: "hyperbaric_bowler",
        eng: "Hyperbaric Bowler",
        rus: "\u0413\u0438\u043F\u0435\u0440\u0431\u0430\u0440\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043A\u043E\u0442\u0435\u043B\u043E\u043A",
        pol: "Melonik m\xf3zgowca",
        sch: "\u9AD8\u538B\u5F0F\u5706\u9876\u5E3D",
        fre: "Le mental sous pression",
        bra: "O Chap\xe9u-Coco Cerebral",
        schema: 30256,
        hun: "A T\xfalnyom\xe1sos T\xf6kf\xf6d\u0151",
        swe: "Hyperbariska hatten"
    },
    633: {
        img: "candymans_cap",
        eng: "Candyman's Cap",
        rus: "\u0428\u043B\u044F\u043F\u0430 \u043A\u043E\u043D\u0434\u0438\u0442\u0435\u0440\u0430",
        pol: "Czapka cukierasa",
        sch: "\u8D29\u7CD6\u4EBA\u7684\u5E3D\u5B50",
        fre: "Le Chapeau de Candyman",
        bra: "A Cartola do Confeiteiro",
        schema: 30261,
        hun: "A Cukork\xe1s Kalap",
        swe: "Godisgubbens go'a hatt"
    },
    634: {
        img: "bountiful_bow",
        eng: "Bountiful Bow",
        rus: "\u0411\u0430\u043D\u0442 \u0431\u043E\u0433\u0430\u0447\u0430",
        pol: "Mi\u0142osierna muszka",
        sch: "\u6177\u6168\u7684\u8774\u8776\u7ED3",
        fre: "Le Costume du prodigue",
        bra: "A Gravata Generosa",
        schema: 30260,
        hun: "A Csinos Csokor",
        swe: "Fina flugan"
    },
    635: {
        img: "bozos_brogues",
        eng: "Bozo's Brogues",
        rus: "\u0411\u0430\u0448\u043C\u0430\u043A\u0438 \u043A\u043B\u043E\u0443\u043D\u0430",
        pol: "Buty Bozo",
        sch: "\u7B28\u86CB\u7684\u571F\u76AE\u978B",
        fre: "Croquenots du nigaud",
        bra: "Os Cal\xe7ados do Comediante",
        schema: 30301,
        hun: "Bolondos Bakancsok",
        swe: "Bozos brogues"
    },
    636: {
        img: "foul_cowl",
        eng: "Foul Cowl",
        rus: "\u041F\u043E\u0440\u043E\u0447\u043D\u044B\u0439 \u043F\u043B\u0430\u0449",
        pol: "Plugawa peleryna",
        sch: "\u6C61\u79FD\u7684\u6597\u7BF7",
        fre: "La Cape du vampire",
        bra: "O Conde von Piro",
        schema: 30283,
        hun: "Az Aljas K\xf6peny",
        swe: "Kusliga k\xe5pan"
    },
    637: {
        img: "baphomet_trotters",
        eng: "Baphomet Trotters",
        rus: "\u041A\u043E\u043F\u044B\u0442\u0446\u0430 \u0411\u0430\u0444\u043E\u043C\u0435\u0442\u0430",
        pol: "Kopyta Bafometa",
        sch: "\u5DF4\u98CE\u7279\u7F8A\u8E44",
        fre: "Les Baphomet trotteurs",
        bra: "Os P\xe9s de Bafom\xe9",
        schema: 30200,
        hun: "A Baphomet Cs\xfclk\xf6k",
        swe: "Baphomets kusliga kl\xf6var"
    },
    638: {
        img: "candleer",
        eng: "Candleer",
        rus: "\u0421\u0432\u0435\u0447\u0435\u043D\u043E\u0441\u0435\u0446",
        pol: "\u015Awiecznik",
        sch: "\u8721\u70DB\u624B\u96F7",
        fre: "La Bandouli\xe8re de bougies",
        bra: "O Candeeiro Humano",
        schema: 30242,
        hun: "A Gyerty\xe1s",
        swe: "Stearinljuskronan"
    },
    639: {
        img: "pin_pals",
        eng: "Pin Pals",
        rus: "\u041F\u043E\u043A\u043E\u043B\u043E\u0442\u044B\u0435 \u043F\u0440\u0438\u044F\u0442\u0435\u043B\u0438",
        pol: "Nieroz\u0142\u0105czki",
        sch: "\u9488\u53CB",
        fre: "Potes \xe9pingl\xe9s",
        bra: "Amigos do Peito",
        schema: 30236,
        hun: "Kit\u0171z\xf6tt Kisemberek",
        swe: "N\xe5ldynor"
    },
    640: {
        img: "snaggletoothed_stetson",
        eng: "Snaggletoothed Stetson",
        rus: "\u041A\u0440\u0438\u0432\u043E\u0437\u0443\u0431\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "Szczerbaty stetson",
        sch: "\u6EE1\u53E3\u70C2\u7259\u7684\u65AF\u6CF0\u68EE\u5E3D",
        fre: "Le Stetson dent\xe9",
        bra: "O Chap\xe9u de Caub\xf3i Carn\xedvoro",
        schema: 30212,
        hun: "A Csorbafogas Puhakalap",
        swe: "Huggtandad stetsonhatt"
    },
    641: {
        img: "ethereal_hood",
        eng: "Ethereal Hood",
        rus: "\u041F\u043E\u0442\u0443\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0438\u0439 \u043A\u0430\u043F\u044E\u0448\u043E\u043D",
        pol: "Eteryczny kaptur",
        sch: "\u7A7A\u7075\u515C\u5E3D",
        fre: "Capuche \xe9th\xe9r\xe9e",
        bra: "O Capuz Espectral",
        schema: 30195,
        hun: "\xc9teri Csuklya",
        swe: "Hemska huvan"
    },
    642: {
        img: "birdie_bonnet",
        eng: "Birdie Bonnet",
        rus: "\u0426\u044B\u043F\u043B\u044F\u0447\u044C\u044F \u0448\u0430\u043F\u043A\u0430",
        pol: "Kurczakaptur",
        sch: "\u5C0F\u9E1F\u90A6\u5C3C\u7279",
        fre: "Le Bonnet de poulet",
        bra: "O Gorro Galin\xe1ceo",
        schema: 30215,
        hun: "A Kakas Kalap",
        swe: "Tuppkammen"
    },
    643: {
        img: "dark_helm",
        eng: "Dark Helm",
        rus: "\u0422\u0435\u043C\u043D\u044B\u0439 \u0448\u043B\u0435\u043C",
        pol: "Mroczny he\u0142m",
        sch: "\u9ED1\u6697\u5934\u76D4",
        fre: "Le Heaume noir",
        bra: "O Elmo Sombrio",
        schema: 30278,
        hun: "A S\xf6t\xe9t Sisak",
        swe: "Svarta hj\xe4lmen"
    },
    644: {
        img: "haunted_hat",
        eng: "Haunted Hat",
        rus: "\u0417\u0430\u043A\u043B\u044F\u0442\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "Nawiedzona czapka",
        sch: "\u95F9\u9B3C\u7684\u6298\u53E0\u793C\u5E3D",
        fre: "Le Chapeau Hant\xe9",
        bra: "O Chap\xe9u Assombrado",
        schema: 30300,
        hun: "K\xeds\xe9rteties Kalap",
        swe: "Den Hems\xf6kta Hatten"
    },
    645: {
        img: "magical_mercenary",
        eng: "Magical Mercenary",
        rus: "\u0412\u043E\u043B\u0448\u0435\u0431\u043D\u044B\u0439 \u043D\u0430\u0435\u043C\u043D\u0438\u043A",
        pol: "Magiczny najemnik",
        sch: "\u9B54\u6CD5\u4F63\u5175",
        fre: "Le Mercenaire magique",
        bra: "O Mercen\xe1rio M\xe1gico",
        schema: 30297,
        hun: "A B\u0171b\xe1jos B\xe9rgyilkos",
        swe: "Magiska manen"
    },
    646: {
        img: "manneater",
        eng: "Manneater",
        rus: "\u041C\u0430\u043D\u043D\u043E\u0435\u0434",
        pol: "Ludo\u017Cerca",
        sch: "\u66FC\u6069\u5934\u9AA8",
        fre: "Le Crannibale",
        bra: "O Manntrop\xf3fago",
        schema: 30295,
        hun: "Az Emberev\u0151",
        swe: "Mannslukaren"
    },
    647: {
        img: "one_way_ticket",
        eng: "One-Way Ticket",
        rus: "\u0411\u0438\u043B\u0435\u0442 \u0432 \u043E\u0434\u0438\u043D \u043A\u043E\u043D\u0435\u0446",
        pol: "Bilet w jedn\u0105 stron\u0119",
        sch: "\u6B7B\u670B\u53CB",
        fre: "L'Aller simple",
        bra: "O Bilhete S\xf3 de Ida",
        schema: 30214,
        hun: "A Vonaljegy",
        swe: "Enkelbiljetten"
    },
    648: {
        img: "tuque_or_treat",
        eng: "Tuque or Treat",
        rus: "\u0428\u0430\u043F\u043A\u0430 \u0438\u043B\u0438 \u0436\u0438\u0437\u043D\u044C",
        pol: "Czapka albo psikus",
        sch: "\u4E0D\u7ED9\u5357\u74DC\u5C31\u6363\u86CB",
        fre: "La Tuque citrouille",
        bra: "Touca ou Travessuras",
        schema: 30274,
        hun: "A T\xf6k-f\xf6d\u0151",
        swe: "Hotfull halloweenm\xf6ssa"
    },
    649: {
        img: "accursed_apparition",
        eng: "Accursed Apparition",
        rus: "\u041F\u0440\u043E\u043A\u043B\u044F\u0442\u043E\u0435 \u043F\u0440\u0438\u0432\u0438\u0434\u0435\u043D\u0438\u0435",
        pol: "Wykl\u0119te widmo",
        sch: "\u53D7\u8BC5\u5492\u7684\u4EA1\u9B42",
        fre: "L'Apparition maudite",
        bra: "A Apari\xe7\xe3o Amaldi\xe7oada",
        schema: 30206,
        hun: "A K\xeds\xe9rt\u0151 K\xeds\xe9r\u0151",
        swe: "D\xf6mda d\xf6dskallen"
    },
    650: {
        img: "beacon_from_beyond",
        eng: "Beacon from Beyond",
        rus: "\u0421\u0432\u0435\u0442\u0438\u043B\u043E \u0441 \u0442\u043E\u0433\u043E \u0441\u0432\u0435\u0442\u0430",
        pol: "Latarnia z za\u015Bwiat\xf3w",
        sch: "\u542F\u8499\u4E4B\u706F",
        fre: "La Lanterne de l'au-del\xe0",
        bra: "A Lanterna do Al\xe9m",
        schema: 30255,
        hun: "A V\xe9rfagyaszt\xf3 Viharl\xe1mpa",
        swe: "Lyktgubben"
    },
    651: {
        img: "cryptic_keepsake",
        eng: "Cryptic Keepsake",
        rus: "\u0417\u0430\u0433\u0430\u0434\u043E\u0447\u043D\u044B\u0439 \u0430\u043C\u0443\u043B\u0435\u0442",
        pol: "Straszliwy suwenir",
        sch: "\u795E\u79D8\u7684\u9AA8\u94FE",
        fre: "La Relique cryptique",
        bra: "A Lembrancinha da L\xe1pide",
        schema: 30302,
        hun: "A Rejt\xe9lyes Eml\xe9kt\xe1rgy",
        swe: "D\xf6dsh\xe4ftigt d\xf6dskallesmycke"
    },
    652: {
        img: "guano",
        eng: "Guano",
        rus: "\u0413\u0443\u0430\u043D\u043E",
        pol: "Guano",
        sch: "\u706B\u8760",
        fre: "Guano",
        bra: "Guano",
        schema: 30252
    },
    653: {
        img: "pocket_horsemann",
        eng: "Pocket Horsemann",
        rus: "\u041A\u0430\u0440\u043C\u0430\u043D\u043D\u044B\u0439 \u0432\u0441\u0430\u0434\u043D\u0438\u043A",
        pol: "Kieszonkowy Je\u017Adziec",
        sch: "\u53E3\u888B\u9A91\u58EB",
        fre: "Le Cavalier sans T\xeate de poche",
        bra: "O Cavaleiro de Bolso",
        schema: 30198,
        hun: "A Zseb-Lovas",
        swe: "Horsemann i fickan"
    },
    654: {
        img: "quoth",
        eng: "Quoth",
        rus: "\u0412\u043E\u0440\u043E\u043D",
        pol: "Miodrzek\u0142",
        sch: "\u4E4C\u9E26",
        fre: "Quoth",
        bra: "Quoth",
        schema: 30289,
        hun: "Sz\xf3lta",
        ger: "Sprach"
    },
    655: {
        img: "sackcloth_spook",
        eng: "Sackcloth Spook",
        rus: "\u041C\u0435\u0448\u043A\u043E\u0432\u0430\u0442\u044B\u0439 \u043F\u0440\u0438\u0437\u0440\u0430\u043A",
        pol: "Parciany potworak",
        sch: "\u9EBB\u5E03\u5E7D\u7075",
        fre: "Le Sac de toile hant\xe9",
        bra: "O Espantalho de Estima\xe7\xe3o",
        schema: 30234,
        hun: "A Zs\xe1kv\xe1szon K\xeds\xe9rtet",
        swe: "Sp\xf6ket i s\xe4cken"
    },
    656: {
        img: "unidentified_following_object",
        eng: "Unidentified Following Object",
        rus: "\u041D\u0430\u0432\u044F\u0437\u0447\u0438\u0432\u044B\u0439 \u043B\u0435\u0442\u0430\u044E\u0449\u0438\u0439 \u043E\u0431\u044A\u0435\u043A\u0442",
        pol: "Niezidentyfikowany obiekt pod\u0105\u017Caj\u0105cy",
        sch: "\u4E0D\u660E\u8DDF\u8E2A\u7269",
        fre: "Objet Visqueux Non Identifi\xe9",
        bra: "Observador Voador N\xe3o Identificado",
        schema: 30254,
        hun: "Azonos\xedtatlan Ragaszkod\xf3 T\xe1rgy",
        swe: "Oidentifierat f\xf6rf\xf6ljande f\xf6rem\xe5l"
    },
    657: {
        img: "solemn_vow",
        eng: "The Solemn Vow",
        rus: "\u0421\u0432\u044F\u0449\u0435\u043D\u043D\u0430\u044F \u043A\u043B\u044F\u0442\u0432\u0430",
        pol: "Uroczysta przysi\u0119ga",
        sch: "\u795E\u5723\u8A93\u8A00\u50CF",
        fre: "Le Voeu Solennel",
        bra: "O Voto Solene",
        schema: 413,
        hun: "Az \xdcnnepi Fogadalom",
        swe: "Det h\xf6gtidliga l\xf6ftet"
    },
    658: {
        img: "strange_part_unusual_wearing_player_kills",
        eng: "Strange Part: Unusual-Wearing Player Kills",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0438\u0433\u0440\u043E\u043A\u0438 \u0441 \u043D\u0435\u043E\u0431\u044B\u0447\u043D\u044B\u043C\u0438 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u0430\u043C\u0438",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zabitych wrog\xf3w nosz\u0105cych nietypowy okaz",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u4F69\u6234\u7A00\u6709\u9970\u54C1\u73A9\u5BB6\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Victimes portant un objet inhabituel",
        bra: "Pe\xe7a Estranha: V\xedtimas com Itens Incomuns",
        schema: 6052,
        hun: "Fura Alkatr\xe9sz: Meg\xf6lt Rendk\xedv\xfclit visel\u0151 j\xe1t\xe9kosok",
        swe: "M\xe4rklig del: Ovanligt kl\xe4dda spelare d\xf6da"
    },
    659: {
        img: "strange_part_spies_killed",
        eng: "Strange Part: Spies Killed",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0442\u044B\u0435 \u0448\u043F\u0438\u043E\u043D\u044B",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zabici Szpiedzy",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u95F4\u8C0D\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Spies tu\xe9s",
        bra: "Pe\xe7a Estranha: Spies Mortos",
        schema: 6008,
        hun: "Fura Alkatr\xe9sz: Meg\xf6lt K\xe9mek",
        swe: "M\xe4rklig del: Spies d\xf6dade"
    },
    660: {
        img: "strange_part_burning_enemy_kills",
        eng: "Strange Part: Burning Enemy Kills",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0442\u044B\u0435 \u0433\u043E\u0440\u044F\u0449\u0438\u0435 \u0438\u0433\u0440\u043E\u043A\u0438",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zabici podpaleni wrogowie",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u7740\u706B\u654C\u4EBA\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Victimes enflamm\xe9e",
        bra: "Pe\xe7a Estranha: V\xedtimas em Chamas",
        schema: 6053,
        hun: "Fura Alkatr\xe9sz: Meg\xf6lt \xe9g\u0151 ellens\xe9gek",
        swe: "M\xe4rklig del: Brinnande fiender d\xf6dade"
    },
    661: {
        img: "concheror",
        eng: "The Concheror",
        rus: "\u0417\u0430\u0432\u043E\u0435\u0432\u0430\u0442\u0435\u043B\u044C",
        pol: "Sashimono strace\u0144ca",
        sch: "\u5F81\u670D\u8005\u6218\u65D7",
        fre: "Conque-\xe9rant",
        bra: "Conchistador",
        schema: 354,
        hun: "K\xfcrt-\xf6l\u0151",
        swe: "Trumpetsn\xe4cka"
    },
    662: {
        img: "eviction_notice",
        eng: "The Eviction Notice",
        rus: "\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \u043E \u0432\u044B\u0441\u0435\u043B\u0435\u043D\u0438\u0438",
        pol: "Nakaz eksmisji",
        sch: "\u9A71\u9010\u8B66\u544A",
        fre: "L'Avis d'Expulsion",
        bra: "O Aviso de Despejo",
        schema: 426,
        hun: "A Kilakoltat\xe1si Felsz\xf3l\xedt\xe1s",
        swe: "Vr\xe4kningsbeskedet"
    },
    663: {
        img: "strange_part_killstreaks_ended",
        eng: "Strange Part: Killstreaks Ended",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u043F\u0440\u0435\u0440\u0432\u0430\u043D\u043D\u044B\u0435 \u0441\u0435\u0440\u0438\u0438 \u0443\u0431\u0438\u0439\u0441\u0442\u0432",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Przerwane serie zab\xf3jstw",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u8FDE\u6740\u7EC8\u7ED3\u6570",
        fre: "Pi\xe8ce \xe9trange : Fin d'un killstreak",
        bra: "Pe\xe7a Estranha: Combos Interrompidos",
        schema: 6054,
        hun: "Fura Alkatr\xe9sz: Meg\xe1ll\xedtott \xe1mokfut\xe1sok",
        swe: "M\xe4rklig del: M\xf6rdarserier avbrutna"
    },
    664: {
        img: "strange_cosmetic_part_freezecam_taunt_appearances",
        eng: "Strange Cosmetic Part: Freezecam Taunt Appearances",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430: \u043D\u0430\u0441\u043C\u0435\u0448\u043A\u0438 \u043D\u0430 \u043F\u043E\u0441\u043C\u0435\u0440\u0442\u043D\u044B\u0445 \u0441\u043D\u0438\u043C\u043A\u0430\u0445",
        pol: "Kuriozalna cz\u0119\u015B\u0107 dla przedmiot\xf3w ozdobnych: Drwiny uwiecznione w migawce",
        sch: "\u5947\u5F02\u90E8\u4EF6\uFF1A\u6740\u654C\u540E\u5632\u8BBD\u6570",
        fre: "Pi\xe8ce cosm\xe9tique \xe9trange : Apparition en faisant une raillerie pendant un arr\xeat sur image",
        bra: "Pe\xe7a Estranha para Cosm\xe9ticos: Provoca\xe7\xf5es na C\xe2mera de Morte",
        schema: 6055,
        hun: "Fura D\xedszalkatr\xe9sz: Pillanatk\xe9pen r\xf6gz\xedtett besz\xf3l\xe1sok",
        swe: "M\xe4rklig kosmetisk del: Frysbildsh\xe5n"
    },
    665: {
        img: "strange_part_damage_dealt",
        eng: "Strange Part: Damage Dealt",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u043D\u0430\u043D\u0435\u0441\u0451\u043D\u043D\u044B\u0439 \u0443\u0440\u043E\u043D",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zadane obra\u017Cenia",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u9020\u6210\u4F24\u5BB3\u91CF",
        fre: "Pi\xe8ce \xe9trange : D\xe9g\xe2ts inflig\xe9s",
        bra: "Pe\xe7a Estranha: Dano Causado",
        schema: 6056,
        hun: "Fura Alkatr\xe9sz: Okozott sebz\xe9s",
        swe: "M\xe4rklig del: V\xe5llad skada"
    },
    666: {
        img: "front_runner",
        eng: "The Front Runner",
        rus: "\u041F\u0435\u0440\u0435\u0434\u043E\u0432\u043E\u0439 \u0444\u0430\u0432\u043E\u0440\u0438\u0442",
        pol: "Przodownik",
        sch: "\u9886\u8DD1\u8005",
        fre: "Le Coureur Frontal",
        bra: "A A\xe7\xe3o Silvestre",
        schema: 760,
        hun: "A Befut\xf3",
        swe: "Frontl\xf6paren"
    },
    667: {
        img: "rescue_ranger",
        eng: "The Rescue Ranger",
        rus: "\u0421\u043F\u0430\u0441\u0430\u0442\u0435\u043B\u044C",
        pol: "Ryzykowny ratunek",
        sch: "\u706B\u7EBF\u6551\u5175",
        fre: "Ranger du risque",
        bra: "Telescopeta",
        schema: 997,
        hun: "A Ment\u0151l\xf6v\xe9sz",
        swe: "R\xe4ddaren i N\xf6den"
    },
    668: {
        img: "scorch_shot",
        eng: "The Scorch Shot",
        rus: "\u041E\u0431\u0436\u0438\u0433\u0430\u044E\u0449\u0438\u0439 \u0432\u044B\u0441\u0442\u0440\u0435\u043B",
        pol: "Piek\u0105ca palba",
        sch: "\u7126\u5316\u67AA",
        fre: "La Torche rousse",
        bra: "A Queima-Roupa",
        schema: 740,
        hun: "Az Odap\xf6rk\xf6l\u0151",
        swe: "Svedskottet"
    },
    669: {
        img: "strange_cosmetic_part_fires_survived",
        eng: "Strange Cosmetic Part: Fires Survived",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430: \u043F\u0435\u0440\u0435\u0436\u0438\u0442\u044B\u0435 \u0432\u043E\u0437\u0433\u043E\u0440\u0430\u043D\u0438\u044F",
        pol: "Kuriozalna cz\u0119\u015B\u0107 dla przedmiot\xf3w ozdobnych: Przetrwane podpalenia",
        sch: "\u5947\u5F02\u90E8\u4EF6\uFF1A\u88AB\u70B9\u71C3\u540E\u5B58\u6D3B\u6B21\u6570",
        fre: "Pi\xe8ce de cosm\xe9tique \xe9trange : Incendies surv\xe9cus",
        bra: "Pe\xe7a Estranha para Cosm\xe9ticos: Fogos Sobrevividos",
        schema: 6057,
        hun: "Fura D\xedszalkatr\xe9sz: T\xfal\xe9lt \xe9g\xe9sek",
        swe: "M\xe4rklig kosmetisk del: Eldar \xf6verlevda"
    },
    670: {
        img: "strange_part_allied_healing_done",
        eng: "Strange Part: Allied Healing Done",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u043B\u0435\u0447\u0435\u043D\u0438\u0435 \u0441\u043E\u044E\u0437\u043D\u0438\u043A\u043E\u0432",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Uleczone punkty zdrowia dru\u017Cyny",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u961F\u53CB\u751F\u547D\u503C\u6062\u590D\u91CF",
        fre: "Pi\xe8ce \xe9trange : Soins apport\xe9s aux alli\xe9s",
        bra: "Pe\xe7a Estranha: Cura em Aliados",
        schema: 6058,
        hun: "Fura Alkatr\xe9sz: Sz\xf6vets\xe9geseken v\xe9gzett gy\xf3gy\xedt\xe1s",
        swe: "M\xe4rklig del: Helande p\xe5 allierade"
    },
    671: {
        img: "strange_part_point_blank_kills",
        eng: "Strange Part: Point-Blank Kills",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0439\u0441\u0442\u0432\u0430 \u0432 \u0443\u043F\u043E\u0440",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zab\xf3jstwa z bliska",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u8D85\u8FD1\u8DDD\u79BB\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Victimes \xe0 bout portant",
        bra: "Pe\xe7a Estranha: V\xedtimas \xe0 Queima-Roupa",
        schema: 6059,
        hun: "Fura Alkatr\xe9sz: K\xf6zvetlen k\xf6zeli \xf6l\xe9sek",
        swe: "M\xe4rklig del: D\xf6dade p\xe5 n\xe4ra h\xe5ll"
    },
    672: {
        img: "builders_blueprints",
        eng: "The Builder's Blueprints",
        rus: "\u0427\u0435\u0440\u0442\u0435\u0436\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044F",
        pol: "Plany budowniczego",
        sch: "\u5EFA\u7B51\u5E08\u7684\u84DD\u56FE",
        fre: "Les Plans du Constructeur",
        bra: "Os Projetos do Construtor",
        schema: 606,
        hun: "A Technikus Tervei",
        swe: "Byggarens Ritningar"
    },
    673: {
        img: "festive_force_a_nature",
        eng: "Festive Force-A-Nature",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u0430\u044F \u041D\u0435\u0443\u043C\u043E\u043B\u0438\u043C\u0430\u044F \u0441\u0438\u043B\u0430",
        pol: "\u015Awi\u0105teczna Si\u0142a natury",
        sch: "\u8282\u65E5\u81EA\u7136\u4E4B\u529B",
        fre: "Force-de-la-Nature festive",
        bra: "A For\xe7a da Natureza Festiva",
        schema: 1078,
        hun: "\xdcnnepi Els\xf6pr\xf6get\u0151",
        swe: "Festlig naturkraft"
    },
    674: {
        img: "festive_sapper",
        eng: "Festive Sapper",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u0436\u0443\u0447\u043E\u043A",
        pol: "\u015Awi\u0105teczny saper",
        sch: "\u8282\u65E5\u7535\u5B50\u5DE5\u5175",
        fre: "Saboteur festif",
        bra: "Sabotador Festivo",
        schema: 1080,
        hun: "\xdcnnepi Mentes\xedt\u0151",
        swe: "Festliga sapparen"
    },
    675: {
        img: "festive_crusaders_crossbow",
        eng: "Festive Crusader's Crossbow",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u0410\u0440\u0431\u0430\u043B\u0435\u0442 \u043A\u0440\u0435\u0441\u0442\u043E\u043D\u043E\u0441\u0446\u0430",
        pol: "\u015Awi\u0105teczna Kusza krzy\u017Cowca",
        sch: "\u8282\u65E5\u5341\u5B57\u519B\u4E4B\u5F29",
        fre: "Arbal\xe8te du Crois\xe9 festive",
        bra: "A Besta do Cruzado Festiva",
        schema: 1079,
        hun: "\xdcnnepi Szamarit\xe1nus Sz\xe1mszer\xedja",
        swe: "Festlig korsriddarens armborst"
    },
    676: {
        img: "festive_flare_gun",
        eng: "Festive Flare Gun",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u0430\u044F \u0420\u0430\u043A\u0435\u0442\u043D\u0438\u0446\u0430",
        pol: "\u015Awi\u0105teczny pistolet sygna\u0142owy",
        sch: "\u8282\u65E5\u4FE1\u53F7\u67AA",
        fre: "Pistolet de d\xe9tresse festif",
        bra: "Arma Sinalizadora Festiva",
        schema: 1081,
        hun: "\xdcnnepi Jelz\u0151pisztoly",
        swe: "Festlig signalpistol"
    },
    677: {
        img: "festive_eyelander",
        eng: "Festive Eyelander",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u041E\u0434\u043D\u043E\u0433\u043B\u0430\u0437\u044B\u0439 \u0433\u043E\u0440\u0435\u0446",
        pol: "\u015Awi\u0105teczny Wyszczerbiec",
        sch: "\u8282\u65E5\u82CF\u683C\u5170\u957F\u5251",
        fre: "Eyelander festif",
        bra: "A Eyelander Festiva",
        schema: 1082,
        hun: "\xdcnnepi Egyetlen",
        swe: "Festliga \xf6gl\xe4ndaren"
    },
    678: {
        img: "festive_jarate",
        eng: "Festive Jarate",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u043E\u0435 \u0411\u0430\u043D\u043A\u0430\u0442\u0435",
        pol: "\u015Awi\u0105teczne Sikwondo",
        sch: "\u8282\u65E5\u74F6\u624B\u9053",
        fre: "Jarat\xe9 festif",
        bra: "Jarrat\xea Festivo",
        schema: 1083,
        hun: "\xdcnnepi Vizelharc",
        swe: "Festlig Jarate"
    },
    679: {
        img: "festive_gloves_of_running_urgently",
        eng: "Festive Gloves of Running Urgently",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0435 \u0413\u043E\u0440\u044F\u0449\u0438\u0435 \u0420\u0443\u043A\u0430\u0432\u0438\u0446\u044B \u0423\u0441\u043A\u043E\u0440\u0435\u043D\u0438\u044F",
        pol: "\u015Awi\u0105teczne Gor\u0105ce r\u0119kawice uciekiniera",
        sch: "\u8282\u65E5\u7D27\u6025\u9003\u8DD1\u624B\u5957",
        fre: "Gants de Retraite Urgente festifs",
        bra: "As Geradoras de Rapidez Urgente Festivas",
        schema: 1084,
        hun: "\xdcnnepi F\xfcrge Sprintel\xe9s Bokszkeszty\u0171i",
        swe: "Festlig Gorbatjovs Rushande Uppercut"
    },
    680: {
        img: "festive_black_box",
        eng: "Festive Black Box",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u0427\u0451\u0440\u043D\u044B\u0439 \u044F\u0449\u0438\u043A",
        pol: "\u015Awi\u0105teczna Czarna skrzynka",
        sch: "\u8282\u65E5\u9ED1\u5323\u5B50",
        fre: "Bo\xeete Noire festive",
        bra: "A Caixa Preta Festiva",
        schema: 1085,
        hun: "\xdcnnepi Fekete Doboz",
        swe: "Festlig svart l\xe5da"
    },
    681: {
        img: "festive_wrangler",
        eng: "Festive Wrangler",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u041F\u043E\u0432\u043E\u0434\u044B\u0440\u044C",
        pol: "\u015Awi\u0105teczny Poskramiacz",
        sch: "\u8282\u65E5\u9065\u63A7\u624B\u67C4",
        fre: "Dompteur festif",
        bra: "O Pe\xe3o Festivo",
        schema: 1086,
        hun: "\xdcnnepi Idom\xedt\xf3",
        swe: "Festlig gr\xe4lmakare"
    },
    682: {
        img: "blizzard_breather",
        eng: "Blizzard Breather",
        rus: "\u0414\u044B\u0445\u0430\u043D\u0438\u0435 \u043C\u0435\u0442\u0435\u043B\u0438",
        pol: "Arktyczny oddech",
        sch: "\u66B4\u98CE\u96EA\u547C\u5438\u9762\u5177",
        fre: "Le respirateur du blizzard",
        bra: "O Respirador Resfriado",
        schema: 30304,
        hun: "H\xf3vihar-maszk",
        swe: "Sn\xf6storms-syrgasmasken"
    },
    683: {
        img: "sub_zero_suit",
        eng: "Sub Zero Suit",
        rus: "\u041D\u0438\u0437\u043A\u043E\u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u043D\u044B\u0439 \u043A\u043E\u0441\u0442\u044E\u043C",
        pol: "Azbestowy anorak",
        sch: "\u6781\u5730\u9632\u5BD2\u670D",
        fre: "La combinaison polaire",
        bra: "O Traje Abaixo de Zero",
        schema: 30305,
        hun: "A Fagyos Fel\xf6lt\u0151",
        swe: "Nollpunktsdr\xe4kten"
    },
    684: {
        img: "dictator",
        eng: "Dictator",
        rus: "\u0414\u0438\u043A\u0442\u0430\u0442\u043E\u0440",
        pol: "Dyktator",
        sch: "\u72EC\u88C1\u8005\u4E4B\u987B",
        fre: "Dictateur",
        bra: "O Ditador",
        schema: 30306,
        hun: "Dikt\xe1tor",
        swe: "Diktatorn"
    },
    685: {
        img: "neckwear_headwear",
        eng: "Neckwear Headwear",
        rus: "\u041D\u0430\u0448\u0435\u0439\u043D\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "Szalikapelusz",
        sch: "\u6234\u56F4\u5DFE\u7684\u5E3D\u5B50",
        fre: "L'\xe9charpe de chapeau",
        bra: "A Cartola com Cachecol",
        schema: 30307,
        hun: "Fejfed\u0151 Nyakfed\u0151",
        swe: "Huvudhalsduken"
    },
    686: {
        img: "trail_blazer",
        eng: "Trail-Blazer",
        rus: "\u041F\u0443\u0442\u0435\u043F\u0440\u043E\u0445\u043E\u0434\u0435\u0446",
        pol: "P\u0142omienne p\u0142ozy",
        sch: "\u5F00\u8DEF\u5148\u950B",
        fre: "Le pionnier des pistes",
        bra: "O Tren\xf3 Flamejante",
        schema: 30308,
        hun: "A Szakadt Sz\xe1nk\xf3",
        swe: "Sp\xe5rljuset"
    },
    687: {
        img: "dead_of_night",
        eng: "Dead of Night",
        rus: "\u0421\u043C\u0435\u0440\u0442\u044C \u0432 \u043D\u043E\u0447\u0438",
        pol: "\u015Amier\u0107 nadejdzie w nocy",
        sch: "\u51AC\u591C\u5939\u514B",
        fre: "C\u0153ur de la nuit",
        bra: "Noite Infeliz",
        schema: 30309,
        hun: "\xc9ji Hal\xe1l",
        swe: "Nattens skugga"
    },
    688: {
        img: "snow_scoper",
        eng: "Snow Scoper",
        rus: "\u0421\u043D\u0435\u0436\u043D\u044B\u0439 \u0441\u0442\u0440\u0435\u043B\u043E\u043A",
        pol: "Wiatr\xf3wka",
        sch: "\u96EA\u5730\u77AD\u671B\u8005",
        fre: "Le Snow Scoper",
        bra: "O Atirador Ant\xe1rtico",
        schema: 30310,
        hun: "A Havas L\xf6v\xe9sz",
        swe: "Sn\xf6siktaren"
    },
    689: {
        img: "nunhood",
        eng: "Nunhood",
        rus: "\u041C\u043E\u0446\u0446\u0435\u0442\u0442\u0430 \u043C\u043E\u043D\u0430\u0445\u0430",
        pol: "Kap\u0142a\u0144ski kaptur",
        sch: "\u4FEE\u5973\u515C\u5E3D",
        fre: "La capuche de l'ordre",
        bra: "A Santa Paci\xeancia",
        schema: 30311,
        hun: "Az Ap\xf3ca",
        swe: "Nunneluvan"
    },
    690: {
        img: "angel_of_death",
        eng: "Angel of Death",
        rus: "\u0410\u043D\u0433\u0435\u043B \u0441\u043C\u0435\u0440\u0442\u0438",
        pol: "Anio\u0142 \u015Bmierci",
        sch: "\u6B7B\u4EA1\u5929\u4F7F\u7684\u957F\u888D",
        fre: "L'ange de la mort",
        bra: "O Anjo da Morte",
        schema: 30312,
        hun: "A Hal\xe1l Angyala",
        swe: "D\xf6ds\xe4ngeln"
    },
    691: {
        img: "kiss_king",
        eng: "Kiss King",
        rus: "\u041A\u043E\u0440\u043E\u043B\u044C \u043F\u043E\u0446\u0435\u043B\u0443\u0435\u0432",
        pol: "Cesarz ca\u0142usk\xf3w",
        sch: "\u4EB2\u543B\u4E4B\u738B",
        fre: "Le roi du baiser",
        bra: "O Bar\xe3o dos Beijos",
        schema: 30313,
        hun: "A Cs\xf3kkir\xe1ly",
        swe: "Pussprinsen"
    },
    692: {
        img: "slo_poke",
        eng: "Slo-Poke",
        rus: "\u041A\u043E\u0432-\u0431\u043E\u0439",
        pol: "Kowbojskie zap\u0119dy",
        sch: "\u611A\u8005\u725B\u4ED4\u5E3D",
        fre: "Le Par-Essieux",
        bra: "O Marechal Mandriado",
        schema: 30314,
        hun: "A Nyugis",
        swe: "Sl\xf6focken"
    },
    693: {
        img: "minnesota_slick",
        eng: "Minnesota Slick",
        rus: "\u041C\u0438\u043D\u043D\u0435\u0441\u043E\u0442\u0441\u043A\u0438\u0439 \u0437\u0430\u0447\u0435\u0441",
        pol: "Minesocki fryz",
        sch: "\u660E\u5DDE\u7684\u8001\u7EC3\u6740\u624B",
        fre: "L'assassin du Minnesota",
        bra: "Mauricinho de Minnesota",
        schema: 30315,
        hun: "D\xf6rzs\xf6lt Minnesotai",
        swe: "Minnesota-stilen"
    },
    694: {
        img: "toy_soldier",
        eng: "Toy Soldier",
        rus: "\u0429\u0435\u043B\u043A\u0443\u043D\u0447\u0438\u043A",
        pol: "Zabawkowy \u017Co\u0142nierzyk",
        sch: "\u9521\u5175\u7684\u519B\u5E3D",
        fre: "Le soldat de plomb",
        bra: "O Soldadinho de Chumbo",
        schema: 30316,
        hun: "A J\xe1t\xe9kkatona",
        swe: "Leksakssoldaten"
    },
    695: {
        img: "five_month_shadow",
        eng: "Five-Month Shadow",
        rus: "\u041F\u044F\u0442\u0438\u043C\u0435\u0441\u044F\u0447\u043D\u0430\u044F \u0449\u0435\u0442\u0438\u043D\u0430",
        pol: "Sze\u015Bciomiesi\u0119czna szczecina",
        sch: "\u84C4\u534A\u5E74\u7684\u5927\u80E1\u5B50",
        fre: "La barbe de cinq mois",
        bra: "A Barba de Cinco Meses",
        schema: 30317,
        hun: "Az \xd6t H\xf3napos \xc1rny\xe9k",
        swe: "Femm\xe5nadersskuggan"
    },
    696: {
        img: "mann_of_reason",
        eng: "Mann of Reason",
        rus: "\u0420\u0430\u0446\u0438\u043E\u043D\u0430\u043B\u0438\u0441\u0442",
        pol: "G\u0142os rozs\u0105dku",
        sch: "\u968F\u4ECE\u4E4B\u5E3D",
        fre: "L'homme de raison",
        bra: "O Servo Germ\xe2nnico",
        schema: 30318,
        hun: "Az \xc9sz-szer\u0171",
        swe: "En Mann av Resonemang"
    },
    697: {
        img: "mann_of_the_house",
        eng: "Mann of the House",
        rus: "\u0413\u043B\u0430\u0432\u0430 \u0441\u0435\u043C\u0435\u0439\u0441\u0442\u0432\u0430",
        pol: "Pan domu",
        sch: "\u4E00\u5BB6\u4E4B\u4E3B",
        fre: "L'Homme de la Maison",
        bra: "O Homann da Casa",
        schema: 30319,
        hun: "A H\xe1z Ura",
        swe: "Mann-en i huset"
    },
    698: {
        img: "chucklenuts",
        eng: "Chucklenuts",
        rus: "\u041E\u0440\u0435\u0448\u043D\u0438\u043A",
        pol: "Druhna Basia",
        sch: "\u5B9D\u6765\u9F20",
        fre: "Chucklenuts",
        bra: "Bochechudo",
        schema: 30320,
        hun: "M\xf3kam\xf3kus",
        swe: "Korren"
    },
    699: {
        img: "tiny_timber",
        eng: "Tiny Timber",
        rus: "\u041C\u0430\u043B\u044B\u0439 \u043B\u0435\u0441\u043E\u0440\u0443\u0431",
        pol: "Podpa\u0142ka",
        sch: "\u5C0F\u5C0F\u67F4\u706B\u5806",
        fre: "Petit bois",
        bra: "O Rei de Paus",
        schema: 30321,
        hun: "Tartal\xe9k T\u0171zifa",
        swe: "Liten timmerstock"
    },
    700: {
        img: "face_full_of_festive",
        eng: "Face Full of Festive",
        rus: "\u0414\u043E\u0432\u043E\u043B\u044C\u043D\u043E \u043F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u043E\u0435 \u043B\u0438\u0446\u043E",
        pol: "O\u015Bwiecone oblicze \u015Ani\u0105t",
        sch: "\u6EE1\u5E26\u8282\u65E5\u6C14\u606F\u7684\u5927\u80E1\u5B50",
        fre: "Barbe festive",
        bra: "Rosto Festivo",
        schema: 30322,
        hun: "Teljesen \xdcnnepi Arc",
        swe: "Det festliga fejset"
    },
    701: {
        img: "ruffled_ruprecht",
        eng: "Ruffled Ruprecht",
        rus: "\u0412\u0437\u044A\u0435\u0440\u043E\u0448\u0435\u043D\u043D\u044B\u0439 \u0420\u0443\u043F\u0440\u0435\u0445\u0442",
        pol: "Brodaty Bawarczyk",
        sch: "\u968F\u4ECE\u4E4B\u80E1",
        fre: "Le p\xe8re froiss\xe9",
        bra: "O Ruprecht Ru\xe7o",
        schema: 30323,
        hun: "Borzas Ruprecht",
        swe: "Ruggiga Ruprecht"
    },
    702: {
        img: "golden_garment",
        eng: "Golden Garment",
        rus: "\u0417\u043E\u043B\u043E\u0442\u043E\u0435 \u043E\u0434\u0435\u044F\u043D\u0438\u0435",
        pol: "Ozdobne odzienie",
        sch: "\u91D1\u4E1D\u5927\u8863",
        fre: "L'habit dor\xe9",
        bra: "As Dragonas Douradas",
        schema: 30324,
        hun: "Az Aranyzubbony",
        swe: "Det gyllene plagget"
    },
    703: {
        img: "little_drummer_mann",
        eng: "Little Drummer Mann",
        rus: "\u041C\u0430\u043B\u0435\u043D\u044C\u043A\u0438\u0439 \u0431\u0430\u0440\u0430\u043C\u0430\u043D\u043D\u0449\u0438\u043A",
        pol: "Male\u0144ki dobosz",
        sch: "\u5C0F\u5C0F\u9F13\u624B",
        fre: "Le petit homme au tambour",
        bra: "O Pequeno Percussionista",
        schema: 30325,
        hun: "A Kis Dobos",
        swe: "Den lille trumslagaren"
    },
    704: {
        img: "scout_shako",
        eng: "Scout Shako",
        rus: "\u041A\u0438\u0432\u0435\u0440 \u0440\u0430\u0437\u0432\u0435\u0434\u0447\u0438\u043A\u0430",
        pol: "Skautowe czako",
        sch: "\u5C0F\u5175\u7684\u9AD8\u7B52\u519B\u5E3D",
        fre: "Le fr\xeale shako",
        bra: "O Shako do Scout",
        schema: 30326,
        hun: "A Cserk\xe9sz Cs\xe1k\xf3",
        swe: "Scouts schak\xe5"
    },
    705: {
        img: "toy_tailor",
        eng: "Toy Tailor",
        rus: "\u0418\u0433\u0440\u0443\u0448\u0435\u0447\u043D\u0438\u043A",
        pol: "Starszy elf podpalacz",
        sch: "\u73A9\u5177\u88C1\u7F1D",
        fre: "Le lutin des jouets",
        bra: "O Elfaiate de Brinquedos",
        schema: 30327,
        hun: "A J\xe1t\xe9kk\xe9sz\xedt\u0151",
        swe: "Leksaksskr\xe4ddaren"
    },
    706: {
        img: "extra_layer",
        eng: "Extra Layer",
        rus: "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0441\u043B\u043E\u0439",
        pol: "Dodatkowa warstwa",
        sch: "\u539A\u5B9E\u7684\u5939\u514B",
        fre: "La couche de plus",
        bra: "A Camada Extra",
        schema: 30328,
        hun: "Az Extra R\xe9teg",
        swe: "Det extra lagret"
    },
    707: {
        img: "polar_pullover",
        eng: "Polar Pullover",
        rus: "\u041F\u043E\u043B\u044F\u0440\u043D\u044B\u0439 \u043F\u0443\u043B\u043E\u0432\u0435\u0440",
        pol: "Kozacka kominiara",
        sch: "\u6781\u5730\u5934\u5957",
        fre: "Le pullover polaire",
        bra: "O Pul\xf4ver Polar",
        schema: 30329,
        hun: "Sarkvid\xe9ki Sityak",
        swe: "Polovern"
    },
    708: {
        img: "dogfighter",
        eng: "Dogfighter",
        rus: "\u0412\u043E\u0437\u0434\u0443\u0448\u043D\u044B\u0439 \u0431\u043E\u0435\u0446",
        pol: "As przestworzy",
        sch: "\u98DE\u884C\u5458\u7684\u5939\u514B\u886B",
        fre: "Le baroudeur",
        bra: "O Piloto Pelejador",
        schema: 30330,
        hun: "A L\xe9giharcos",
        swe: "Kurvstridaren"
    },
    709: {
        img: "antarctic_parka",
        eng: "Antarctic Parka",
        rus: "\u0410\u043D\u0442\u0430\u0440\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043F\u0430\u0440\u043A\u0430",
        pol: "Antarktyczna parka",
        sch: "\u5357\u6781\u5FA1\u5BD2\u5927\u8863",
        fre: "Parka antarctique",
        bra: "Parka Ant\xe1rtica",
        schema: 30331,
        hun: "Antarktika Parka",
        swe: "Antarktisk parka"
    },
    710: {
        img: "runners_warm_up",
        eng: "Runner's Warm-Up",
        rus: "\u0420\u0430\u0437\u043C\u0438\u043D\u043A\u0430 \u0431\u0435\u0433\u0443\u043D\u0430",
        pol: "Zimowa rozgrzewka",
        sch: "\u8DD1\u5792\u8005\u7684\u62A4\u8033\u5E3D",
        fre: "R\xe9chauffement du coureur",
        bra: "Aquecedor do Corredor",
        schema: 30332,
        hun: "A Fut\xf3 Bemeleg\xedt\u0151je",
        swe: "Springarens uppv\xe4rmning"
    },
    711: {
        img: "highland_high_heels",
        eng: "Highland High Heels",
        rus: "\u0412\u044B\u0441\u043E\u043A\u043E\u0433\u043E\u0440\u043D\u044B\u0435 \u0432\u044B\u0441\u043E\u043A\u0438\u0435 \u0441\u0430\u043F\u043E\u0433\u0438",
        pol: "Taternicze tartanowe trapery",
        sch: "\u9AD8\u5730\u4EBA\u7684\u9AD8\u8DDF\u9774",
        fre: "Talons des Highlands",
        bra: "Botas Altas das Terras Altas",
        schema: 30333,
        hun: "Magaslati Magas Sz\xe1r\xfa",
        swe: "H\xf6glandsk\xe4ngor"
    },
    712: {
        img: "tartan_tyrolean",
        eng: "Tartan Tyrolean",
        rus: "\u0422\u0438\u0440\u043E\u043B\u044C\u0441\u043A\u0430\u044F \u0442\u0430\u0440\u0442\u0430\u043D\u043E\u0432\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "Tyrolski tartan",
        sch: "\u82CF\u683C\u5170\u65B9\u683C\u82B1\u7EB9\u63D0\u6D1B\u5E3D",
        fre: "Tyrolien \xe9cossais",
        bra: "Tirol\xeas Tartan",
        schema: 30334,
        hun: "Tart\xe1n Tiroli",
        swe: "Tartantyrolern"
    },
    713: {
        img: "marshalls_mutton_chops",
        eng: "Marshall's Mutton Chops",
        rus: "\u0411\u0430\u043A\u0435\u043D\u0431\u0430\u0440\u0434\u044B \u043C\u0430\u0440\u0448\u0430\u043B\u0430",
        pol: "Pekaesy pu\u0142kownika",
        sch: "\u6CD5\u8B66\u7684\u7EDC\u816E\u80E1",
        fre: "Favoris du Marshall",
        bra: "Costeletas do Comandante",
        schema: 30335,
        hun: "A T\xe1bornagy Pofaszak\xe1lla",
        swe: "Marshallens kejsarsk\xe4gg"
    },
    714: {
        img: "ticket_boy",
        eng: "Ticket Boy",
        rus: "\u0411\u0438\u043B\u0435\u0442\u0435\u0440",
        pol: "Bileter",
        sch: "\u67E5\u7968\u5C0F\u54E5",
        fre: "Le Tickettier",
        bra: "O Bilheteiro",
        schema: 30376,
        hun: "A Jegyszed\u0151fi\xfa",
        swe: "Biljettpojken"
    },
    715: {
        img: "ground_control",
        eng: "Ground Control",
        rus: "\u0410\u0432\u0438\u0430\u0434\u0438\u0441\u043F\u0435\u0442\u0447\u0435\u0440",
        pol: "Halo, tu wie\u017Ca",
        sch: "\u5730\u9762\u63A7\u5236",
        fre: "Contr\xf4leur terrestre",
        bra: "Controlador Terrestre",
        schema: 30338,
        hun: "F\xf6ldi Ir\xe1ny\xedt\xe1s",
        swe: "Markkontroll"
    },
    716: {
        img: "killers_kit",
        eng: "Killer's Kit",
        rus: "\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442 \u043A\u0438\u043B\u043B\u0435\u0440\u0430",
        pol: "Zestaw zabijaki",
        sch: "\u6740\u624B\u7684\u5DE5\u5177\u5305",
        fre: "Le kit du tueur",
        bra: "Os Aparatos do Assassino",
        schema: 30339,
        hun: "A Gyilkos Fazon",
        swe: "Soldatens st\xe4ll"
    },
    717: {
        img: "cute_suit",
        eng: "Cute Suit",
        rus: "\u041C\u0438\u043B\u044B\u0439 \u043A\u043E\u0441\u0442\u044E\u043C",
        pol: "Ziomek b\u0142yskawiczny",
        sch: "\u8D85\u840C\u5916\u5957",
        fre: "La jolie combi",
        bra: "O Traje T\xedmido",
        schema: 30367,
        hun: "A Cuki Ruci",
        swe: "Den s\xf6ta dr\xe4kten"
    },
    718: {
        img: "sole_mate",
        eng: "Sole Mate",
        rus: "\u0420\u044B\u0431\u043D\u044B\u0439 \u0434\u0435\u043D\u044C",
        pol: "Bratnia gorbusza",
        sch: "\u5927\u5634\u60C5\u4FA3",
        fre: "Sole partenaire",
        bra: "Bacalhalma G\xeamea",
        schema: 30355,
        hun: "Lelki T\xe1rshal",
        swe: "Plattfiskkompisen"
    },
    719: {
        img: "bushi_dou",
        eng: "Bushi-Dou",
        rus: "\u0411\u0443\u0448\u0438\u0434\u043E",
        pol: "Bushi-Dou",
        sch: "\u6B66\u58EB\u9053",
        fre: "Bushi-Dou",
        bra: "Bushi-Dou",
        schema: 30348
    },
    720: {
        img: "dark_falkirk_helm",
        eng: "Dark Falkirk Helm",
        rus: "\u0427\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u043B\u043A\u0435\u0440\u043A\u0441\u043A\u0438\u0439 \u0448\u043B\u0435\u043C",
        pol: "Mroczna przy\u0142bica",
        sch: "\u9ED1\u6697\u7684\u798F\u5C14\u67EF\u514B\u5934\u76D4",
        fre: "Le sombre casque de Falkirk",
        bra: "O Elmo Sombrio de Falkirk",
        schema: 30357,
        hun: "A S\xf6t\xe9t Falkirk Sisak",
        swe: "M\xf6rka Falkirkhj\xe4lmen"
    },
    721: {
        img: "juggernaut_jacket",
        eng: "Juggernaut Jacket",
        rus: "\u0416\u0438\u043B\u0435\u0442 \u0440\u0430\u0437\u0440\u0443\u0448\u0438\u0442\u0435\u043B\u044F",
        pol: "Kozacki kevlar",
        sch: "\u9707\u5A01\u6218\u8863",
        fre: "Tenue anti-explosifs",
        bra: "O Colete Colossal",
        schema: 30363,
        hun: "A Z\xfaz\xf3s Zubbony",
        swe: "Juggernautjackan"
    },
    722: {
        img: "sangu_sleeves",
        eng: "Sangu Sleeves",
        rus: "\u0420\u0443\u043A\u0430\u0432\u0430 \u0441\u0430\u043C\u0443\u0440\u0430\u044F",
        pol: "Samurajskie sangu",
        sch: "\u7532\u80C4\u62A4\u8155",
        fre: "Les brassards Sangu",
        bra: "A Kobertura Kote",
        schema: 30366,
        hun: "A Sangu Karv\xe9rt",
        swe: "Sangu\xe4rmarna"
    },
    723: {
        img: "sole_saviors",
        eng: "Sole Saviors",
        rus: "\u0421\u043F\u0430\u0441\u0438\u0442\u0435\u043B\u0438 \u0441\u0442\u0443\u043F\u043D\u0435\u0439",
        pol: "Nikczemne nagolennice",
        sch: "\u811A\u4E2B\u6551\u4E16\u4E3B",
        fre: "Les sauveur de semelles",
        bra: "As Solas do Salvador",
        schema: 30358,
        hun: "A Talpal\xe1val\xf3k",
        swe: "St\xe5lsulorna"
    },
    724: {
        img: "stylish_degroot",
        eng: "Stylish DeGroot",
        rus: "\u0421\u0442\u0438\u043B\u044C\u043D\u044B\u0439 \u0414\u0435\u0413\u0440\u0443\u0442",
        pol: "Stylowy DeGroot",
        sch: "\u65F6\u9AE6\u7684\u5934\u5E26",
        fre: "\xc9l\xe9gant DeGroot",
        bra: "DeGroot Descolado",
        schema: 30340,
        hun: "St\xedlusos DeGroot",
        swe: "Stiliga DeGroot"
    },
    725: {
        img: "bullet_buzz",
        eng: "Bullet Buzz",
        rus: "\u0412\u0438\u0437\u0433 \u043F\u0443\u043B\u044C",
        pol: "Jak kula do je\u017Ca",
        sch: "\u5B50\u5F39\u914D\u5E73\u5934",
        fre: "Balle r\xe8glementaire",
        bra: "Corte Comando",
        schema: 30344,
        hun: "Goly\xf3z\xe1por",
        swe: "Kulsurret"
    },
    726: {
        img: "combat_slacks",
        eng: "Combat Slacks",
        rus: "\u0411\u043E\u0435\u0432\u044B\u0435 \u0431\u0440\u044E\u043A\u0438",
        pol: "Bitewne bambetle",
        sch: "\u683C\u6597\u4FBF\u88E4",
        fre: "Tenue de combat",
        bra: "As Cal\xe7as de Combate",
        schema: 30372,
        hun: "Csatacucc",
        swe: "Stridsbyxor"
    },
    727: {
        img: "eliminators_safeguard",
        eng: "Eliminator's Safeguard",
        rus: "\u0428\u043B\u0435\u043C \u0443\u043D\u0438\u0447\u0442\u043E\u0436\u0438\u0442\u0435\u043B\u044F",
        pol: "Ochrona likwidatora",
        sch: "\u6B7C\u706D\u8005\u7684\u9632\u66B4\u5934\u76D4",
        fre: "La protection du destructeur",
        bra: "A Prote\xe7\xe3o do Eliminador",
        schema: 30369,
        hun: "A T\xf6megoszlat\xf3k V\xe9delmez\u0151je",
        swe: "Eliminerarens skyddshj\xe4lm"
    },
    728: {
        img: "gone_commando",
        eng: "Gone Commando",
        rus: "\u041A\u043E\u043C\u043C\u0430\u043D\u0434\u043E",
        pol: "Kolosalny komandos",
        sch: "\u5265\u5149\u7684\u7A81\u51FB\u5175",
        fre: "Pass\xe9 commando",
        bra: "Cal\xe7\xe3o Antipredat\xf3rio",
        schema: 30343,
        hun: "Kommand\xf3s St\xedlus",
        swe: "Kommand\xf6ren"
    },
    729: {
        img: "heavy_lifter",
        eng: "Heavy Lifter",
        rus: "\u0422\u044F\u0436\u0435\u043B\u043E\u0432\u0435\u0441",
        pol: "Pot\u0119\u017Cny paker",
        sch: "\u5065\u7855\u7684\u4E3E\u91CD\u8FD0\u52A8\u5458",
        fre: "L'halt\xe9rophile",
        bra: "O Heavy Halterofilista",
        schema: 30342,
        hun: "A S\xfalyemel\u0151",
        swe: "Tyngdlyftaren"
    },
    730: {
        img: "leftover_trap",
        eng: "Leftover Trap",
        rus: "\u041F\u0435\u0440\u0435\u0436\u0438\u0442\u043E\u043A \u043F\u0440\u043E\u0448\u043B\u043E\u0433\u043E",
        pol: "Pu\u0142apka na okruchy",
        sch: "\u5927\u80E1\u5B50\u9677\u9631",
        fre: "Le pi\xe8ge \xe0 miettes",
        bra: "A Sujeira das Sobras",
        schema: 30345,
        hun: "A Morzsafog\xf3",
        swe: "Smulf\xe4llan"
    },
    731: {
        img: "rat_stompers",
        eng: "Rat Stompers",
        rus: "\u041A\u0440\u044B\u0441\u043E\u0434\u0430\u0432\u044B",
        pol: "Kamasze kloszarda",
        sch: "\u8017\u5B50\u8DF5\u8E0F\u8005",
        fre: "Les Bottes Anti-rat",
        bra: "As Botas Mata-Ratos",
        schema: 30354,
        hun: "A Patk\xe1nytapos\xf3",
        swe: "R\xe5ttstamparna"
    },
    732: {
        img: "sammy_cap",
        eng: "Sammy Cap",
        rus: "\u0411\u0443\u0442\u0435\u0440\u043D\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "Kanapu\u0142apka",
        sch: "\u4E09\u660E\u6CBB\u4E4B\u5E3D",
        fre: "L'attrape Sammy",
        bra: "A Vara de 'Viche",
        schema: 30374,
        hun: "A Szend\xf3-sapka",
        swe: "Sm\xf6rg\xe5shatten"
    },
    733: {
        img: "trash_man",
        eng: "Trash Man",
        rus: "\u041C\u0443\u0441\u043E\u0440\u0449\u0438\u043A",
        pol: "Mycka menela",
        sch: "\u62FE\u8352\u8005\u4E4B\u5E3D",
        fre: "\xc9boueur Man",
        bra: "O Homem do Lixo",
        schema: 30346,
        hun: "A Kuk\xe1s",
        swe: "Sopgubben"
    },
    734: {
        img: "war_goggles",
        eng: "War Goggles",
        rus: "\u0412\u043E\u0435\u043D\u043D\u044B\u0435 \u043A\u043E\u043D\u0441\u0435\u0440\u0432\u044B",
        pol: "Gogle wojenne",
        sch: "\u6218\u4E89\u62A4\u76EE\u955C",
        fre: "Les lunettes de guerre",
        bra: "Os \xd3culos de Guerra",
        schema: 30368,
        hun: "A Hadi Kukker",
        swe: "Krigsglas\xf6gonen"
    },
    735: {
        img: "warmth_preserver",
        eng: "Warmth Preserver",
        rus: "\u0422\u0435\u043F\u043B\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0435\u043B\u044C",
        pol: "Ocieplana kamizela",
        sch: "\u4FDD\u6696\u7684\u65E0\u8896\u7FBD\u7ED2",
        fre: "Le Conservateur de chaleur",
        bra: "O Conservador de Calor",
        schema: 30364,
        hun: "A Melegen Tart\xf3",
        swe: "V\xe4rmeh\xe5llaren"
    },
    736: {
        img: "antarctic_researcher",
        eng: "Antarctic Researcher",
        rus: "\u0418\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0410\u043D\u0442\u0430\u0440\u043A\u0442\u0438\u0434\u044B",
        pol: "Arktyczny odkrywca",
        sch: "\u5357\u6781\u7814\u7A76\u5458",
        fre: "Le chercheur polaire",
        bra: "O Pesquisador Ant\xe1rtico",
        schema: 30377,
        hun: "A Sarkkutat\xf3",
        swe: "Den antarktiska utforskaren"
    },
    737: {
        img: "ein",
        eng: "Ein",
        rus: "\u042D\u0439\u043D",
        pol: "Ein",
        sch: "\u77FF\u5DE5\u7684\u91D1\u4E1D\u96C0",
        fre: "Ein",
        bra: "Ein",
        schema: 30341
    },
    738: {
        img: "scotch_saver",
        eng: "Scotch Saver",
        rus: "\u0425\u0440\u0430\u043D\u0438\u0442\u0435\u043B\u044C \u0441\u043A\u043E\u0442\u0447\u0430",
        pol: "\u0141apacz whisky",
        sch: "\u82CF\u683C\u5170\u8282\u4FED\u8005",
        fre: "Le sauveur de scotch",
        bra: "A Barba B\xeabada",
        schema: 30347,
        hun: "A Sk\xf3t Megment\u0151",
        swe: "Whiskyspararen"
    },
    739: {
        img: "trenchers_topper",
        eng: "Trencher's Topper",
        rus: "\u0422\u0440\u0430\u043D\u0448\u0435\u0439\u043D\u044B\u0439 \u0448\u043B\u0435\u043C",
        pol: "Okopowa os\u0142ona",
        sch: "\u6218\u58D5\u5175\u7684\u793C\u5E3D",
        fre: "Le couvre-chef des tranch\xe9es",
        bra: "A Tranqueira da Trincheira",
        schema: 30336,
        hun: "A L\xf6v\xe9sz\xe1rok\xe1s\xf3 Fejfed\u0151je",
        swe: "Skyttegr\xe4varens hatt"
    },
    740: {
        img: "trenchers_tunic",
        eng: "Trencher's Tunic",
        rus: "\u041E\u0434\u0435\u0436\u0434\u0430 \u043E\u043A\u043E\u043F\u043D\u0438\u043A\u0430",
        pol: "Okopowe odzienie",
        sch: "\u6218\u58D5\u5175\u7684\u675F\u8170\u5916\u8863",
        fre: "La tunique des tranch\xe9es",
        bra: "A T\xfanica das Trincheiras",
        schema: 30337,
        hun: "A L\xf6v\xe9sz\xe1rok\xe1s\xf3 Kab\xe1tja",
        swe: "Skyttegr\xe4varens skjorta"
    },
    741: {
        img: "colonels_coat",
        eng: "Colonel's Coat",
        rus: "\u041F\u0430\u043B\u044C\u0442\u043E \u043F\u043E\u043B\u043A\u043E\u0432\u043D\u0438\u043A\u0430",
        pol: "Odzienie oficera",
        sch: "\u9646\u519B\u4E0A\u6821\u7684\u5927\u8863",
        fre: "La veste du colonel",
        bra: "O Casaco do Coronel",
        schema: 30361,
        hun: "Ezredesi Kab\xe1t",
        swe: "\xd6verstens Rock"
    },
    742: {
        img: "dough_puncher",
        eng: "Dough Puncher",
        rus: "\u041F\u043E\u043B\u0435\u0432\u043E\u0439 \u043F\u0435\u043A\u0430\u0440\u044C",
        pol: "Krawat kuchcika",
        sch: "\u63C9\u9762\u5927\u53A8\u7684\u5DE5\u4F5C\u670D",
        fre: "Le batteur de p\xe2te",
        bra: "O Amassador de Massas",
        schema: 30350,
        hun: "A T\xe9sztagy\xfar\xf3",
        swe: "Degkn\xe5daren"
    },
    743: {
        img: "fashionable_megalomaniac",
        eng: "Fashionable Megalomaniac",
        rus: "\u041C\u043E\u0434\u043D\u044B\u0439 \u043C\u0435\u0433\u0430\u043B\u043E\u043C\u0430\u043D\u044C\u044F\u043A",
        pol: "Modny megaloman",
        sch: "\u65F6\u9AE6\u7684\u81EA\u5927\u72C2",
        fre: "La mode du m\xe9galomane",
        bra: "O Megaloman\xedaco Magn\xedfico",
        schema: 30349,
        hun: "A Divatos Megalom\xe1ni\xe1s",
        swe: "Den moderiktiga megalomanisten"
    },
    744: {
        img: "gaiter_guards",
        eng: "Gaiter Guards",
        rus: "\u0421\u0442\u043E\u0440\u043E\u0436 \u0432 \u0433\u0435\u0442\u0440\u0430\u0445",
        pol: "Germa\u0144skie gamasze",
        sch: "\u7ED1\u817F\u5B88\u536B",
        fre: "Le protecteur des gu\xeatres",
        bra: "As Galochas do Galeno",
        schema: 30379,
        hun: "Kam\xe1slik",
        swe: "Damaskskydden"
    },
    745: {
        img: "heat_of_winter",
        eng: "Heat of Winter",
        rus: "\u0417\u0438\u043C\u043D\u0435\u0435 \u0442\u0435\u043F\u043B\u043E",
        pol: "Zimna wojna",
        sch: "\u51AC\u5929\u91CC\u7684\u4E00\u628A\u70ED",
        fre: "La Chaleur de l'hiver",
        bra: "O Calor do Inverno",
        schema: 30356,
        hun: "A T\xe9l Melege",
        swe: "Vinterns hetta"
    },
    746: {
        img: "heers_helmet",
        eng: "Heer's Helmet",
        rus: "\u0410\u0440\u043C\u0435\u0439\u0441\u043A\u0438\u0439 \u0448\u043B\u0435\u043C",
        pol: "He\u0142m Heeru",
        sch: "\u5FB7\u56FD\u9646\u519B\u7684\u5934\u76D4",
        fre: "Le Casque de la Heer",
        bra: "Stahlhelm da Heer",
        schema: 30378,
        hun: "Heer Sisak",
        swe: "Heers hj\xe4lm"
    },
    747: {
        img: "mustachioed_mann",
        eng: "Mustachioed Mann",
        rus: "\u0423\u0441\u0430\u0442\u044B\u0439 \u041C\u0430\u043D\u043D",
        pol: "W\u0105saty wodzirej",
        sch: "\u957F\u80E1\u5B50\u66FC\u6069",
        fre: "Le moustachu",
        bra: "O Semblante do Surrealista",
        schema: 30352,
        hun: "Mann\u0151 Bajusz",
        swe: "Den mustacherade mannen"
    },
    748: {
        img: "smock_surgeon",
        eng: "Smock Surgeon",
        rus: "\u041F\u0440\u0430\u043A\u0442\u0438\u0447\u043D\u044B\u0439 \u043F\u0435\u0440\u0435\u0434\u043D\u0438\u043A",
        pol: "Fartuch felczera",
        sch: "\u5916\u79D1\u533B\u751F\u7684\u5DE5\u4F5C\u670D",
        fre: "Le tablier de chirurgien",
        bra: "A Bata de Bi\xf3psia",
        schema: 30365,
        hun: "A Seb\xe9szk\xf6t\xe9ny",
        swe: "Kirurgens skyddsrock"
    },
    749: {
        img: "teutonic_toque",
        eng: "Teutonic Toque",
        rus: "\u0422\u0435\u0432\u0442\u043E\u043D\u0441\u043A\u0438\u0439 \u043A\u043E\u043B\u043F\u0430\u043A",
        pol: "Kapelusz kuchcika",
        sch: "\u65E5\u8033\u66FC\u5927\u53A8\u5E3D",
        fre: "La toque teutonique",
        bra: "O Toque Teut\xf4nico",
        schema: 30351,
        hun: "A Teuton Toque",
        swe: "Tyska kockm\xf6ssan"
    },
    750: {
        img: "archers_groudings",
        eng: "Archer's Groundings",
        rus: "\u041E\u043F\u043E\u0440\u0430 \u043B\u0443\u0447\u043D\u0438\u043A\u0430",
        pol: "Trzewiki \u0142ucznika",
        sch: "\u5F13\u7BAD\u624B\u4E4B\u9774",
        fre: "Bottines de l'archer",
        bra: "Os Apoios do Arqueiro",
        schema: 30371,
        hun: "Az \xcdj\xe1szat Alapjai",
        swe: "B\xe5gskyttens st\xf6vlar"
    },
    751: {
        img: "huntsmans_essentials",
        eng: "Huntsman's Essentials",
        rus: "\u041F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u043D\u043E\u0441\u0442\u0438 \u043E\u0445\u043E\u0442\u043D\u0438\u043A\u0430",
        pol: "Niezb\u0119dnik \u0142owcy",
        sch: "\u730E\u624B\u7684\u5FC5\u9700\u54C1",
        fre: "Les indispensables du Huntsman",
        bra: "O Equipamento do Ca\xe7ador",
        schema: 30359,
        hun: "A Levad\xe1sz-kell\xe9k",
        swe: "J\xe4garens n\xf6dv\xe4ndigheter"
    },
    752: {
        img: "toowoomba_tunic",
        eng: "Toowoomba Tunic",
        rus: "\u0422\u0443\u0432\u0443\u043C\u0431\u0441\u043A\u0430\u044F \u0442\u0443\u043D\u0438\u043A\u0430",
        pol: "Tunika z Toowoomba",
        sch: "\u56FE\u6587\u5DF4\u77ED\u888D",
        fre: "La Tunique de Toowoomba",
        bra: "A T\xfanica de Toowoomba",
        schema: 30373,
        hun: "A Toowoombai Tunika",
        swe: "Toowombatr\xf6jan"
    },
    753: {
        img: "backstabbers_boomslang",
        eng: "Backstabber's Boomslang",
        rus: "\u0423\u0436\u0438\u043A \u0443\u0431\u0438\u0439\u0446\u044B",
        pol: "Zdradziecki zaskroniec",
        sch: "\u80CC\u523A\u8005\u4E4B\u86C7",
        fre: "Le Boomslang du poignardage",
        bra: "A Pe\xe7onha do P\xe9rfido",
        schema: 30353,
        hun: "Az Alattomos K\xedgy\xf3",
        swe: "Rygghuggarens huggorm"
    },
    754: {
        img: "napoleon_complex",
        eng: "Napoleon Complex",
        rus: "\u041D\u0430\u043F\u043E\u043B\u0435\u043E\u043D\u0441\u043A\u0438\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441",
        pol: "Napoleon Szed\u0142-w-Zaparte",
        sch: "\u62FF\u7834\u4ED1\u60C5\u7ED3",
        fre: "Le Complexe de Napol\xe9on",
        bra: "O Complexo de Napole\xe3o",
        schema: 30360,
        hun: "A Nap\xf3leon-komplexus",
        swe: "Napoleonkomplexet"
    },
    755: {
        img: "deep_cover_operator",
        eng: "Deep Cover Operator",
        rus: "\u041E\u043F\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u0438\u043A \u043F\u043E\u0434 \u043F\u0440\u0438\u043A\u0440\u044B\u0442\u0438\u0435\u043C",
        pol: "Zabili go i uciek\u0142",
        sch: "\u6F5C\u884C\u5927\u5E08",
        fre: "L'agent sous couverture",
        bra: "A Faixa Furtiva",
        schema: 30375,
        hun: "A Nagyon Be\xe9p\xfclt \xdcgyn\xf6k",
        swe: "Dolda agenten"
    },
    756: {
        img: "law",
        eng: "Law",
        rus: "\u0417\u0430\u043A\u043E\u043D",
        pol: "Dzielnicowy",
        sch: "\u8B66\u5B98\u5927\u6A90\u5E3D",
        fre: "La loi",
        bra: "A Lei",
        schema: 30362,
        hun: "A T\xf6rv\xe9ny",
        swe: "Lagen"
    },
    757: {
        img: "pretty_boys_pocket_pistol",
        eng: "Pretty Boy's Pocket Pistol",
        rus: "\u0414\u0430\u043C\u0441\u043A\u0438\u0439 \u043F\u0438\u0441\u0442\u043E\u043B\u0435\u0442 \u041A\u0440\u0430\u0441\u0430\u0432\u0447\u0438\u043A\u0430",
        pol: "Por\u0119czny pistolet Pretty Boya",
        sch: "\u5E05\u6C14\u7537\u5B69\u7684\u8896\u73CD\u624B\u67AA",
        fre: "Le Pistolet de Poche du Beau Gosse",
        bra: "A Pistola Port\xe1til do Peralta",
        schema: 773,
        schema2: 5721,
        hun: "Sz\xe9pfi\xfas Zsebpisztoly",
        swe: "Snyggingens Pangpistol"
    },
    758: {
        img: "phlogistinator",
        eng: "Phlogistinator",
        rus: "\u0424\u043B\u043E\u0433\u0438\u0441\u0442\u043E\u043D\u0430\u0442\u043E\u0440",
        pol: "Flogistynator",
        sch: "\u71C3\u7D20\u55B7\u5C04\u5668",
        fre: "Le Phlogistinateur",
        bra: "O Flogistinador",
        schema: 594,
        schema2: 5722,
        hun: "A Flogisztoniz\xe1l\xf3",
        swe: "Flogistoneraren"
    },
    759: {
        img: "cleaners_carbine",
        eng: "Cleaner's Carbine",
        rus: "\u041A\u0430\u0440\u0430\u0431\u0438\u043D \u0427\u0438\u0441\u0442\u0438\u043B\u044C\u0449\u0438\u043A\u0430",
        pol: "Spluwa sprz\u0105tacza",
        sch: "\u626B\u8361\u8005\u5361\u5BBE",
        fre: "La Carabine du Nettoyeur",
        bra: "A Carabina do Carrasco",
        schema: 751,
        schema2: 5723,
        hun: "A Karbantart\xf3 Karab\xe9ly",
        swe: "Undanr\xf6jarens Umg\xe4nge"
    },
    760: {
        img: "strange_cosmetic_part_kills",
        eng: "Strange Cosmetic Part: Kills",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430: \u0443\u0431\u0438\u0439\u0441\u0442\u0432\u0430",
        pol: "Kuriozalna cz\u0119\u015B\u0107 dla przedmiot\xf3w ozdobnych: Zabici",
        sch: "\u5947\u5F02\u9970\u54C1\u90E8\u4EF6\uFF1A\u6740\u654C\u6570",
        fre: "Pi\xe8ce cosm\xe9tique \xe9trange : Victimes",
        bra: "Pe\xe7a Estranha para Cosm\xe9ticos: V\xedtimas",
        schema: 6060,
        hun: "Fura D\xedsz\xedt\u0151 Alkatr\xe9sz: \xd6l\xe9sek",
        swe: "M\xe4rklig kosmetisk del: Antal d\xf6dade"
    },
    761: {
        img: "strange_part_full_health_kills",
        eng: "Strange Part: Full Health Kills",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0439\u0441\u0442\u0432\u0430 \u0441 \u043F\u043E\u043B\u043D\u044B\u043C \u0437\u0434\u043E\u0440\u043E\u0432\u044C\u0435\u043C",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zab\xf3jstw z pe\u0142nym zdrowiem",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u6EE1\u8840\u51FB\u6740\u6570",
        fre: "Victimes lorsque sant\xe9 est au maximum",
        bra: "Pe\xe7a Estranha: V\xedtimas enquanto com Vida Cheia",
        schema: 6061,
        hun: "Fura Alkatr\xe9sz: Teljes \xe9leterej\u0171 \xf6l\xe9sek",
        swe: "M\xe4rklig del: D\xf6dade vid full h\xe4lsa"
    },
    762: {
        img: "giftapult",
        eng: "Giftapult",
        rus: "\u041F\u043E\u0434\u0430\u0440\u043A\u043E\u043F\u0443\u043B\u044C\u0442\u0430",
        pol: "Daropulta",
        fre: "Cadeaupulte",
        sch: "\u793C\u7269\u53D1\u5C04\u5668",
        bra: "Presentapulta",
        schema: 5083,
        hun: "Aj\xe1nd\xe9kkatapult",
        swe: "Presentkastare"
    },
    763: {
        img: "strange_count_transfer_tool",
        eng: "Strange Count Transfer Tool",
        rus: "\u041E\u0431\u043C\u0435\u043D\u043D\u0438\u043A \u0441\u0442\u0440\u0430\u043D\u043D\u044B\u0445 \u0441\u0447\u0451\u0442\u0447\u0438\u043A\u043E\u0432",
        pol: "Narz\u0119dzie przekazuj\u0105ce statystyk\u0119 kuriozum",
        fre: "Outil de transfert de compteur \xe9trange",
        sch: "\u5947\u5F02\u8BA1\u6570\u8F6C\u79FB\u5DE5\u5177",
        bra: "Ferramenta de Transfer\xeancia de Contagens Estranhas",
        schema: 5818,
        hun: "Fura Pont-\xe1tviv\u0151 Eszk\xf6z",
        swe: "Verktyg f\xf6r \xf6verf\xf6ring av m\xe4rklig r\xe4knare"
    },
    764: {
        img: "killstreak_kit",
        eng: "Killstreak #ITEM# Kit",
        rus: "\u041D\u0430\u0431\u043E\u0440 \u0441\u0435\u0440\u0438\u0438 \u0443\u0431\u0438\u0439\u0441\u0442\u0432 - #ITEM#",
        pol: "Zestaw serii zab\xf3jstw: #ITEM#",
        fre: "Kit: #ITEM# Killstreak",
        sch: "\u8FDE\u6740\u8BB0\u5F55\u5F0F #ITEM# \u5DE5\u5177\u5305",
        bra: "Kit de Combo para #ITEM#",
        schema: 6527,
        hun: "\xc1mokfut\xe1s-k\xe9szlet #ITEM#",
        swe: "M\xf6rdarserie #ITEM# Kit"
    },
    765: {
        img: "specialized_killstreak_kit",
        eng: "Specialized Killstreak #ITEM# Kit",
        rus: "\u041D\u0430\u0431\u043E\u0440 \u043E\u0441\u043E\u0431\u043E \u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u0443\u0431\u0438\u0439\u0446\u044B - #ITEM#",
        pol: "Zestaw wyspecjalizowanej serii zab\xf3jstw: #ITEM#",
        fre: "Kit: #ITEM# Killstreak sp\xe9cialis\xe9",
        sch: "\u9AD8\u7EA7\u8FDE\u6740\u8BB0\u5F55\u5F0F #ITEM# \u5DE5\u5177\u5305",
        bra: "Kit de Combo Especializado para #ITEM#",
        schema: 6523,
        hun: "Specializ\xe1lt \xc1mokfut\xe1s-k\xe9szlet #ITEM#",
        swe: "Specialiserad m\xf6rdarserie #ITEM# Kit"
    },
    766: {
        img: "professional_killstreak_kit",
        eng: "Professional Killstreak #ITEM# Kit",
        rus: "\u041D\u0430\u0431\u043E\u0440 \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0443\u0431\u0438\u0439\u0446\u044B - #ITEM#",
        pol: "Zestaw profesjonalnej serii zab\xf3jstw: #ITEM#",
        fre: "Kit: #ITEM# Killstreak professionnel",
        sch: "\u804C\u4E1A\u8FDE\u6740\u8BB0\u5F55\u5F0F #ITEM# \u5DE5\u5177\u5305",
        bra: "Kit de Combo Profissional para #ITEM#",
        schema: 6526,
        hun: "Hivat\xe1sos \xc1mokfut\xe1s-k\xe9szlet #ITEM#",
        swe: "Professionell m\xf6rdarserie #ITEM# Kit"
    },
    767: {
        img: "tour_of_duty_ticket",
        eng: "Tour of Duty Ticket",
        rus: "\u041A\u043E\u043C\u0430\u043D\u0434\u0438\u0440\u043E\u0432\u043E\u0447\u043D\u044B\u0439 \u0431\u0438\u043B\u0435\u0442",
        pol: "Bilet s\u0142u\u017Cby wojskowej",
        fre: "Ticket de Tour of Duty",
        sch: "\u4F7F\u547D\u4E4B\u65C5\u5165\u573A\u5238",
        bra: "Ingresso da Campanha",
        schema: 725,
        hun: "Szolg\xe1lati Turnus Jegy",
        swe: "Tj\xe4nstg\xf6ringsbiljett"
    },
    768: {
        img: "backpack_expander",
        eng: "Backpack Expander",
        rus: "\u0420\u0430\u0441\u0448\u0438\u0440\u0438\u0442\u0435\u043B\u044C \u0440\u044E\u043A\u0437\u0430\u043A\u0430",
        pol: "Rozszerzacz plecaka",
        fre: "Agrandisseur d'Inventaire",
        sch: "\u80CC\u5305\u6269\u5145\u5DE5\u5177",
        bra: "Expansor de Mochila",
        schema: 5050,
        hun: "H\xe1tizs\xe1kb\u0151v\xedt\u0151",
        swe: "Ryggs\xe4cksut\xf6kare"
    },
    769: {
        img: "decal_tool",
        eng: "Decal Tool",
        rus: "\u0418\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442 \u0434\u043B\u044F \u043D\u0430\u043D\u0435\u0441\u0435\u043D\u0438\u044F \u043D\u0430\u043A\u043B\u0435\u0435\u043A",
        pol: "Naklejka",
        fre: "Outil de d\xe9calcomanie",
        sch: "\u8D34\u7EB8\u5DE5\u5177",
        bra: "Ferramenta de Decalque",
        schema: 5026,
        hun: "Matrica eszk\xf6z",
        swe: "Dekalverktyg"
    },
    770: {
        img: "unusualifier",
        eng: "#ITEM# Unusualifier",
        rus: "\u041D\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0442\u0438\u0437\u0430\u0442\u043E\u0440 \u043D\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430 - #ITEM#",
        pol: "Uniezwyklacz: #ITEM#",
        fre: "Inhabituellisateur: #ITEM#",
        sch: "#ITEM# \u7A00\u6709\u8F6C\u5316\u9B54\u6CD5",
        bra: "#ITEM# Incomunizador",
        schema: 9258,
        hun: "#ITEM# Rendk\xedv\xfclies\xedt\u0151",
        swe: "#ITEM# Ovanligifierare"
    },
    771: {
        img: "aged_moustache_grey",
        eng: "Aged Moustache Grey",
        rus: "\u0421\u0435\u0440\u044B\u0439 \u0441\u0435\u0434\u043E\u0433\u043E \u0443\u0441\u0430\u0447\u0430",
        pol: "Szaro\u015B\u0107 wiekowych w\u0105s\xf3w",
        fre: "Gris Moustache Grisonnante",
        sch: "\u8001\u5E74\u80E1\u987B\u7070",
        bra: "Cinza Bigode Envelhecido",
        schema: 5038,
        hun: "\u0150sz\xfcl\u0151 Bajusz Sz\xfcrke",
        swe: "\xc5ldrad mustaschgr\xe5"
    },
    772: {
        img: "mutated_milk",
        eng: "Mutated Milk",
        rus: "\u041C\u0443\u0442\u0438\u0440\u043E\u0432\u0430\u0432\u0448\u0435\u0435 \u043C\u043E\u043B\u043E\u043A\u043E",
        pol: "Zmutowane mleko",
        sch: "\u7A81\u53D8\u725B\u5976",
        fre: "Lait mutant",
        bra: "A Larva do Leite",
        schema: 1121,
        hun: "Mut\xe1ns Tej",
        swe: "Muterad mj\xf6lk"
    },
    773: {
        img: "bread_bite",
        eng: "Bread Bite",
        rus: "\u041A\u0443\u0441\u0430\u0439-\u0445\u043B\u0435\u0431",
        pol: "Chlebogryzarka",
        sch: "\u54AC\u4EBA\u7684\u9762\u5305",
        fre: "La Morsure du pain",
        bra: "O P\xe3o de Muni\xe7\xe3o",
        schema: 1100,
        hun: "A Keny\xe9rfalat",
        swe: "Br\xf6dbettet"
    },
    774: {
        img: "self_aware_beauty_mark",
        eng: "Self-Aware Beauty Mark",
        rus: "\u0420\u043E\u0434\u0438\u043D\u043A\u0430 \u0441 \u0441\u0430\u043C\u043E\u0441\u043E\u0437\u043D\u0430\u043D\u0438\u0435\u043C",
        pol: "Samo\u015Bwiadomy pieprzyk",
        sch: "\u8FF7\u4EBA\u7684\u751F\u547D\u4F53",
        fre: "Le grain de beaut\xe9 conscient",
        bra: "A Bolota Senciente",
        schema: 1105,
        hun: "Az \xd6ntudatra \xc9bredt Anyajegy",
        swe: "Den sj\xe4lvmedvetna sk\xf6nhetsfl\xe4cken"
    },
    775: {
        img: "snack_attack",
        eng: "Snack Attack",
        rus: "\u0417\u0430\u043A\u0443\u0441\u043E\u0447\u043D\u0430\u044F \u0430\u0442\u0430\u043A\u0430",
        pol: "Atak przek\u0105sk\u0105",
        sch: "\u8FDB\u51FB\u7684\u96F6\u98DF",
        fre: "L'Attaque du snack",
        bra: "A Revanche do Lanche",
        schema: 1102,
        hun: "A Falatoz\xf3 Falat",
        swe: "Mellanm\xe5lsm\xf6rdaren"
    },
    776: {
        img: "argyle_ace",
        eng: "Argyle Ace",
        rus: "\u041E\u0444\u0438\u0441\u043D\u0430\u044F \u043E\u0431\u0443\u0432\u043A\u0430",
        pol: "Kraciasty krok",
        sch: "\u65F6\u9AE6\u978B\u889C",
        fre: "Les Chaussettes \xe0 carreaux",
        bra: "A Meia de Meia-Idade",
        schema: 30427,
        hun: "A Kock\xe1s Kir\xe1ly",
        swe: "Argyle\xe4sset"
    },
    777: {
        img: "frickin_sweet_ninja_hood",
        eng: "Frickin' Sweet Ninja Hood",
        rus: "\u0427\u0435\u0440\u0442\u043E\u0432\u0441\u043A\u0438 \u043A\u043B\u0435\u0432\u044B\u0439 \u043A\u0430\u043F\u044E\u0448\u043E\u043D \u043D\u0438\u043D\u0434\u0437\u044F",
        pol: "Przes\u0142odki kaptur ninja",
        sch: "\u5FCD\u8005\u5C0F\u6597\u7BF7",
        fre: "La Capuche ninja carr\xe9ment cool",
        bra: "O Capuz do Ninja Maloqueiro",
        schema: 30394,
        hun: "A Durva Men\u0151 Nindzsacsuklya",
        swe: "Den j\xe4kligt snygga ninjamasken"
    },
    778: {
        img: "paisley_pro",
        eng: "Paisley Pro",
        rus: "\u0422\u0443\u0440\u0435\u0446\u043A\u0438\u0439 \u043E\u0433\u0443\u0440\u0447\u0438\u043A",
        pol: "Paislejowe polo",
        sch: "\u4F69\u65AF\u5229\u82B1\u8FB9\u886C\u886B",
        fre: "Le Paisley du pro",
        bra: "O Profissional de Paisley",
        schema: 30426,
        hun: "A Paisley Profi",
        swe: "Paisleyproffset"
    },
    779: {
        img: "pomade_prince",
        eng: "Pomade Prince",
        rus: "\u041F\u0440\u0438\u043B\u0438\u0437\u0430\u043D\u043D\u044B\u0439 \u043F\u0440\u0438\u043D\u0446",
        pol: "Pan pomada",
        sch: "\u738B\u5B50\u7684\u53D1\u6CB9\u5934",
        fre: "Le Prince du gel",
        bra: "A Pomada do Pr\xedncipe",
        schema: 30428,
        hun: "A Hajzsel\xe9s Herceg",
        swe: "Pomadaprinsen"
    },
    780: {
        img: "red_socks",
        eng: "Red Socks",
        rus: "\u0420\u0435\u0434 \u0421\u043E\u043A\u0441",
        pol: "Czerwone skarpety",
        sch: "\u7EA2\u889C\u5B50",
        fre: "Les Chaussettes Rouges",
        bra: "As Meias Vermelhas",
        schema: 30396,
        hun: "A Piros Zoknik",
        swe: "De R\xf6da Sockorna"
    },
    781: {
        img: "southie_shinobi",
        eng: "Southie Shinobi",
        rus: "\u0421\u0438\u043D\u043E\u0431\u0438 \u044E\u0436\u043D\u043E\u0433\u043E \u0411\u043E\u0441\u0442\u043E\u043D\u0430",
        pol: "Ninja spod Bostonu",
        sch: "\u5357\u65B9\u5C0F\u5FCD\u8005",
        fre: "Le Shinobi de Boston",
        bra: "O Shinobi do Sul",
        schema: 30395,
        hun: "A D\xe9li Shinobi",
        swe: "S\xf6derns Shinobi"
    },
    782: {
        img: "classified_coif",
        eng: "Classified Coif",
        rus: "\u0417\u0430\u0441\u0435\u043A\u0440\u0435\u0447\u0435\u043D\u043D\u0430\u044F \u0448\u0430\u043F\u043A\u0430",
        pol: "Marynarka agenta",
        sch: "\u516C\u52A1\u5458\u7684\u98CE\u8863",
        fre: "Le Col Blanc",
        bra: "O Casaco Confidencial",
        schema: 30388,
        hun: "A Titkos T\xe9likab\xe1t",
        swe: "Den klassificerade coifen"
    },
    783: {
        img: "man_in_slacks",
        eng: "Man in Slacks",
        rus: "\u0421\u043B\u0430\u043A\u0441\u044B",
        pol: "Facet w spodniach",
        sch: "\u9ED1\u88E4\u4EBA",
        fre: "L'Homme de Go\xfbt",
        bra: "A Cal\xe7a que Sabia Demais",
        schema: 30392,
        hun: "A Laza Naci",
        swe: "Man i slacks"
    },
    784: {
        img: "spook_specs",
        eng: "Spook Specs",
        rus: "\u0428\u043F\u0438\u043E\u043D\u0441\u043A\u0438\u0435 \u043E\u0447\u043A\u0438",
        pol: "Okulary tajniaka",
        sch: "\u79D8\u5BC6\u63A2\u5458\u58A8\u955C",
        fre: "Les Lunettes Secr\xe8tes",
        bra: "O Detetive Destemido",
        schema: 30390,
        hun: "A K\xe9mles\u0151",
        swe: "Spionage-solglas\xf6gonen"
    },
    785: {
        img: "combustible_kabuto",
        eng: "Combustible Kabuto",
        rus: "\u041A\u0430\u0431\u0443\u0442\u043E \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0435\u0433\u043E \u0441\u0433\u043E\u0440\u0430\u043D\u0438\u044F",
        pol: "\u0141atwopalne kabuto",
        sch: "\u6613\u71C3\u6B66\u58EB\u76D4",
        fre: "Le Kabuto Inflammable",
        bra: "O Kabuto Kombust\xedvel",
        schema: 30418,
        hun: "A Gy\xfal\xe9kony Kabuto",
        swe: "Den br\xe4nnbara kabuton"
    },
    786: {
        img: "employee_of_the_mmmph",
        eng: "Employee of the Mmmph",
        rus: "\u0420\u0430\u0431\u043E\u0442\u043D\u0438\u043A \u043C\u043C\u043C\u043F\u0444\u0441\u0446\u0430",
        pol: "Pracownik mmmphca",
        sch: "\u9EA6\u545C\u5514\u5FEB\u9910\u5458\u5DE5",
        fre: "Employ\xe9 du Mmmph",
        bra: "Empregado do Mmmph",
        schema: 30416,
        hun: "A Hmmpf Dolgoz\xf3ja",
        swe: "Mmmphnadens anst\xe4lld"
    },
    787: {
        img: "frymaster",
        eng: "Frymaster",
        rus: "\u041C\u0430\u0441\u0442\u0435\u0440 \u043F\u043E\u0434\u0436\u0430\u0440\u043A\u0438",
        pol: "Mistrz kuchni",
        sch: "\u6CB9\u70B8\u6D3B\u4EBA",
        fre: "Le Ma\xeetre \xe8s Frites",
        bra: "O Mestre da Fritura",
        schema: 30417,
        hun: "A S\xfct-\u0151-mester",
        swe: "Friterm\xe4staren"
    },
    788: {
        img: "gas_guzzler",
        eng: "Gas Guzzler",
        rus: "\u041F\u043E\u0436\u0438\u0440\u0430\u0442\u0435\u043B\u044C \u0442\u043E\u043F\u043B\u0438\u0432\u0430",
        pol: "Po\u017Ceracz paliwa",
        sch: "\u8DD1\u8F66\u6392\u6C14\u7BA1",
        fre: "L'Usine \xe0 Gaz",
        bra: "O Gas\xf3lotra",
        schema: 30398,
        hun: "A Benzinzab\xe1l\xf3",
        swe: "Bensinslukaren"
    },
    789: {
        img: "lunatics_leathers",
        eng: "Lunatic's Leathers",
        rus: "\u041A\u043E\u0436\u0430\u043D\u043A\u0430 \u0431\u0435\u0437\u0443\u043C\u0446\u0430",
        pol: "Sk\xf3rzany szaleniec",
        sch: "\u75AF\u72C2\u8F66\u624B\u7684\u76AE\u8863",
        fre: "Le Cuir du D\xe9rang\xe9",
        bra: "Couro Chamuscado",
        schema: 30400,
        hun: "A Bolond B\u0151rkab\xe1tja",
        swe: "Psykfallets l\xe4derpaj"
    },
    790: {
        img: "sengoku_scorcher",
        eng: "Sengoku Scorcher",
        rus: "\u0421\u0442\u0438\u043B\u044F\u0433\u0430 \u0421\u044D\u043D\u0433\u043E\u043A\u0443",
        pol: "Podpalacz z Sengoku",
        sch: "\u672C\u80FD\u5BFA\u7EB5\u706B\u8005",
        fre: "Fougue Sengoku",
        bra: "Xogum Chamuscado",
        schema: 30391,
        hun: "Sengoku Perzsel\u0151",
        swe: "Sengoku-sotaren"
    },
    791: {
        img: "smoking_skid_lid",
        eng: "Smoking Skid Lid",
        rus: "\u0428\u0430\u043B\u044C\u043D\u043E\u0439 \u0448\u043B\u0435\u043C",
        pol: "Apokaliptyczny kask",
        sch: "\u5192\u70DF\u5C16\u9876\u76D4",
        fre: "Le Casque \xe0 pointe du flambeur",
        bra: "O Capacete de Fuma\xe7a",
        schema: 30399,
        hun: "A F\xfcst\xf6s Fejfed\u0151",
        swe: "Den pyromaniska pickelhuvan"
    },
    792: {
        img: "allbrero",
        eng: "Allbrero",
        rus: "\u041E\u043B\u043B\u0431\u0440\u0435\u0440\u043E",
        pol: "Bylibrero",
        sch: "\u58A8\u897F\u54E5\u8349\u5E3D",
        fre: "Le sombre h\xe9ros",
        bra: "O Solbrero",
        schema: 30429,
        hun: "A Mindbrero",
        swe: "Allbreron"
    },
    793: {
        img: "frontier_djustice",
        eng: "Frontier Djustice",
        rus: "\u0414\u0436\u0430\u043D\u0433\u043E\u0441\u0443\u0434",
        pol: "Dsamos\u0105d",
        sch: "\u8FB9\u7586\u6B63\u4E49",
        fre: "La Djustice Frontali\xe8re",
        bra: "O Djusticeiro",
        schema: 30421,
        hun: "Az Elszabadult \xd6nb\xedr\xe1skod\xf3",
        swe: "Frontens r\xe4ttvisa"
    },
    794: {
        img: "razor_cut",
        eng: "Razor Cut",
        rus: "\u0418\u0440\u043E\u043A\u0435\u0437",
        pol: "Ostry fryz",
        sch: "\u5243\u5200\u53D1\u578B",
        fre: "La Coupe au rasoir",
        bra: "O Corte \xe0 Navalha",
        schema: 30393,
        hun: "Az \xc9les V\xe1g\xe1s",
        swe: "Rakbladsklippningen"
    },
    795: {
        img: "seeing_double",
        eng: "Seeing Double",
        rus: "\u0414\u0432\u043E\u0439\u043D\u0430\u044F \u043F\u043E\u0440\u0446\u0438\u044F",
        pol: "Widzenie zdwojone",
        sch: "\u9189\u6C49\u592A\u9633\u955C",
        fre: "Double vision",
        bra: "Vis\xe3o Dobrada",
        schema: 30430,
        hun: "Dupl\xe1n L\xe1t\xf3",
        swe: "Ser dubbelt"
    },
    796: {
        img: "six_pack_abs",
        eng: "Six Pack Abs",
        rus: "\u041F\u0438\u0432\u043D\u043E\u0439 \u043F\u0440\u0435\u0441\u0441",
        pol: "Sze\u015Bciopak",
        sch: "\u516D\u74F6\u88C5\u5564\u9152",
        fre: "Les tablettes de chocolat",
        bra: "O Abdome Alco\xf3lico",
        schema: 30431,
        hun: "Kock\xe1s S\xf6rhas",
        swe: "Sexpacket"
    },
    797: {
        img: "yuris_revenge",
        eng: "Yuri's Revenge",
        rus: "\u041C\u0435\u0441\u0442\u044C \u042E\u0440\u0438\u044F",
        pol: "Zemsta Jurija",
        sch: "\u5C24\u91CC\u7684\u590D\u4EC7",
        fre: "Revanche de Yuri",
        bra: "A Vingan\xe7a do Yuri",
        schema: 30401,
        hun: "Yuri Bossz\xfaja",
        swe: "Yuris h\xe4mnd"
    },
    798: {
        img: "danger",
        eng: "Danger",
        rus: "\u041E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C",
        pol: "Zagro\u017Cenie",
        sch: "\u7EDD\u547D\u6BD2\u5DE5",
        fre: "Le Danger",
        bra: "O Perigo",
        schema: 30420,
        hun: "A Vesz\xe9ly",
        swe: "Faran"
    },
    799: {
        img: "eggheads_overalls",
        eng: "Egghead's Overalls",
        rus: "\u041A\u043E\u043C\u0431\u0438\u043D\u0435\u0437\u043E\u043D \u044F\u0439\u0446\u0435\u0433\u043E\u043B\u043E\u0432\u043E\u0433\u043E",
        pol: "Okr\u0105g\u0142o\u015Bci jajog\u0142owego",
        sch: "\u4E66\u5446\u5B50\u886C\u886B",
        fre: "La blouse de l'intello",
        bra: "O Barrig\xe3o do Cabe\xe7\xe3o",
        schema: 30408,
        hun: "Az Okostoj\xe1s Kardig\xe1nja",
        swe: "\xc4gghuvudets overaller"
    },
    800: {
        img: "endothermic_exowear",
        eng: "Endothermic Exowear",
        rus: "\u042D\u043D\u0434\u043E\u0442\u0435\u0440\u043C\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043E\u0434\u0435\u0436\u0434\u0430",
        pol: "Endotermiczne egzoubranie",
        sch: "\u5438\u70ED\u5916\u5957",
        fre: "L'Exo-combi Endothermique",
        bra: "A Exovestimenta Endot\xe9rmica",
        schema: 30412,
        hun: "A H\u0151elnyel\u0151 Meleg\xedt\u0151",
        swe: "De endotermiska exokl\xe4derna"
    },
    801: {
        img: "joe_on_the_go",
        eng: "Joe-on-the-Go",
        rus: "\u0414\u0436\u043E-\u0432-\u0440\u044E\u043A\u0437\u0430\u043A\u0435-\u0442\u0435\u0441\u043D\u043E",
        pol: "Przeno\u015Bny in\u017Cynier",
        sch: "\u5077\u8FD0\u5B87\u822A\u7334",
        fre: "Le Joe-Sac-\xe0-Dos",
        bra: "Macaco pra Toda Obra",
        schema: 30403,
        hun: "A Menetk\xe9sz M\xe9rn\xf6k",
        swe: "Portabel Joe"
    },
    802: {
        img: "level_three_chin",
        eng: "Level Three Chin",
        rus: "\u0422\u0440\u0435\u0445\u044D\u0442\u0430\u0436\u043D\u044B\u0439 \u043F\u043E\u0434\u0431\u043E\u0440\u043E\u0434\u043E\u043A",
        pol: "Potr\xf3jny podbr\xf3dek",
        sch: "\u8089\u8089\u7684\u4E0B\u5DF4",
        fre: "Le Triple Menton",
        bra: "O Queixo N\xedvel Tr\xeas",
        schema: 30407,
        hun: "A H\xe1rmas Szint\u0171 Toka",
        swe: "Trippelhaka"
    },
    803: {
        img: "lonesome_loafers",
        eng: "Lonesome Loafers",
        rus: "\u0423\u043D\u044B\u043B\u044B\u0439 \u0443\u043D\u0438\u043A\u0443\u043C",
        pol: "\u0141apcie \u0142amagi",
        sch: "\u5B64\u72EC\u4E00\u751F\u7684\u51C9\u978B",
        fre: "Les Mocassins du solitaire",
        bra: "As Meias Melanc\xf3licas",
        schema: 30409,
        hun: "A Mag\xe1nyos Mamusz",
        swe: "De solit\xe4ra sandalerna"
    },
    804: {
        img: "peaceniks_ponytail",
        eng: "Peacenik's Ponytail",
        rus: "\u041F\u043E\u043D\u044C\u0441\u043A\u0438\u0439 \u0445\u0432\u043E\u0441\u0442 \u043F\u0430\u0446\u0438\u0444\u0438\u0441\u0442\u0430",
        pol: "Kucyk pacyfisty",
        sch: "\u53CD\u6218\u5206\u5B50\u7684\u9A6C\u5C3E\u5934",
        fre: "La Queue de Cheval du Pacifiste",
        bra: "O Rabo de Cavalo do Revolucion\xe1rio",
        schema: 30406,
        hun: "A B\xe9keharcos Hajfonata",
        swe: "Hippiens h\xe4stsvans"
    },
    805: {
        img: "tools_of_the_trade",
        eng: "Tools of the Trade",
        rus: "\u041E\u0440\u0443\u0434\u0438\u044F \u0440\u0435\u043C\u0435\u0441\u043B\u0430",
        pol: "Narz\u0119dzia fachu",
        sch: "\u5DE5\u5177\u80CC\u5FC3",
        fre: "Les Bons Outils",
        bra: "Os Ossos do Of\xedcio",
        schema: 30402,
        hun: "A Munka Eszk\xf6zei",
        swe: "Branchens verktyg"
    },
    806: {
        img: "chronoscarf",
        eng: "Chronoscarf",
        rus: "\u0425\u0440\u043E\u043D\u043E\u0448\u0430\u0440\u0444",
        pol: "Chronoszalik",
        sch: "\u65F6\u7A7A\u56F4\u5DFE",
        fre: "L'\xc9charpe temporelle",
        bra: "O Cronocachecol",
        schema: 30419,
        hun: "Az Id\u0151s\xe1l",
        swe: "Krono-scarfen"
    },
    807: {
        img: "medicine_manpurse",
        eng: "Medicine Manpurse",
        rus: "\u0421\u0443\u043C\u043A\u0430 c\u0430\u043D\u0438\u0442\u0430\u0440\u0430",
        pol: "Torba medyczna",
        sch: "\u88C5\u836F\u7684\u7537\u5F0F\u630E\u5305",
        fre: "La sacoche m\xe9dicinale",
        bra: "A Mala M\xe9dica",
        schema: 30415,
        hun: "A Gy\xf3gyszeres Ersz\xe9ny",
        swe: "Den medicinska mansv\xe4skan"
    },
    808: {
        img: "ze_ubermensch",
        eng: "Ze \xdcbermensch",
        rus: "\u0421\u0432\u0435\u0440\u0445\u0447\u0435\u043B\u043E\u0432\u0435\u043A",
        pol: "Ze \xdcbermensch",
        sch: "\u5C3C\u91C7\u7684\u8D85\u4EBA\u80E1\u5B50",
        fre: "Ze \xdcbermensch",
        bra: "Ze \xdcbermensch",
        schema: 30410,
        hun: "A Felsch\u0151bbrend\u0171",
        ger: "Der \xdcbermensch"
    },
    809: {
        img: "scopers_smoke",
        eng: "Scoper's Smoke",
        rus: "\u041A\u0443\u0440\u0435\u0432\u043E \u043A\u0438\u043B\u043B\u0435\u0440\u0430",
        pol: "Fajka teleskopowa",
        sch: "\u70DF\u67AA\u72D9\u51FB\u624B",
        fre: "La Cigarette du Scoper",
        bra: "O Fumo do Franco-Atirador",
        schema: 30423,
        hun: "A T\xe1vcs\xf6ves F\xfcstje",
        swe: "Siktarens r\xf6k"
    },
    810: {
        img: "triggermans_tacticals",
        eng: "Triggerman's Tacticals",
        rus: "\u041A\u0430\u0440\u0433\u043E \u043A\u0438\u043B\u043B\u0435\u0440\u0430",
        pol: "Spodnie strzelca",
        sch: "\u5C04\u624B\u7684\u6218\u672F\u957F\u88E4",
        fre: "Le Bouffant du braqueur",
        bra: "As Cal\xe7as do Carabineiro",
        schema: 30424,
        hun: "A Taktikai L\xf6v\xe9sznadr\xe1g",
        swe: "Gev\xe4rsmannens taktiska"
    },
    811: {
        img: "au_courant_assassin",
        eng: "Au Courant Assassin",
        rus: "\u0417\u043D\u0430\u0442\u043E\u043A-\u0443\u0431\u0438\u0439\u0446\u0430",
        pol: "Zab\xf3jca au courant",
        sch: "\u6F6E\u6D41\u6740\u624B",
        fre: "L'assassin au courant",
        bra: "O Assassino Antenado",
        schema: 30411,
        hun: "A Penge B\xe9rgyilkos",
        swe: "Den dekorerade dr\xe4paren"
    },
    812: {
        img: "aviator_assassin",
        eng: "Aviator Assassin",
        rus: "\u041F\u0438\u043B\u043E\u0442-\u0443\u0431\u0438\u0439\u0446\u0430",
        pol: "Podniebny zab\xf3jca",
        sch: "\u7A7A\u4E2D\u523A\u5BA2",
        fre: "L'Aviateur Malfaiteur",
        bra: "O Assassino Aviador",
        schema: 30404,
        hun: "A Rep\xfcl\u0151s Mer\xe9nyl\u0151",
        swe: "Flygarm\xf6rdaren"
    },
    813: {
        img: "rogues_robe",
        eng: "Rogue's Robe",
        rus: "\u0412\u043E\u0440\u043E\u0432\u0441\u043A\u0430\u044F \u043E\u0434\u0435\u0436\u0434\u0430",
        pol: "Szlafrok \u0142otra",
        sch: "\u76D7\u8D3C\u77ED\u888D",
        fre: "Le Kimono du voyou",
        bra: "A Bata do Bandido",
        schema: 30389,
        hun: "A Zsiv\xe1ny K\xf6nt\xf6se",
        swe: "R\xf6varens Rock"
    },
    814: {
        img: "sky_captain",
        eng: "Sky Captain",
        rus: "\u041A\u0430\u043F\u0438\u0442\u0430\u043D \u043F\u043E\u0434\u043D\u0435\u0431\u0435\u0441\u044C\u044F",
        pol: "Podniebny kapitan",
        sch: "\u673A\u957F\u5236\u670D",
        fre: "Le Commandant de bord",
        bra: "O Capit\xe3o dos C\xe9us",
        schema: 30405,
        hun: "Az \xc9gi Kapit\xe1ny",
        swe: "Himmelskaptenen"
    },
    815: {
        img: "mercs_mohawk",
        eng: "Merc's Mohawk",
        rus: "\u0418\u0440\u043E\u043A\u0435\u0437 \u043D\u0430\u0435\u043C\u043D\u0438\u043A\u0430",
        pol: "Irokez najemnika",
        sch: "\u4F63\u5175\u7684\u83AB\u897F\u5E72\u53D1\u578B",
        fre: "Le Mohawk de mercenaire",
        bra: "O Moicano do Mercen\xe1rio",
        schema: 30413,
        hun: "A Zsoldos Taraja",
        swe: "Legosoldatens tuppkam"
    },
    816: {
        img: "bruisers_bandanna",
        eng: "Bruiser's Bandanna",
        rus: "\u0411\u0430\u043D\u0434\u0430\u043D\u0430 \u0411\u0430\u043D\u0434\u0438\u0442\u0430",
        pol: "Bandana pi\u0119\u015Bciarza",
        sch: "\u5F6A\u5F62\u5927\u6C49\u9762\u7F69",
        fre: "Le Bandana du Bandito",
        bra: "A Bandana do Brutamontes",
        schema: 30397,
        hun: "A Ki\xfct\u0151s Kend\u0151",
        swe: "Br\xe5kstakens Bandana"
    },
    817: {
        img: "eye_catcher",
        eng: "Eye-Catcher",
        rus: "\u041F\u043E\u0432\u044F\u0437\u043A\u0430 \u043F\u0438\u0440\u0430\u0442\u0430",
        pol: "Oczko w g\u0142owie",
        sch: "\u72EC\u773C\u9F99",
        fre: "Le Tape-\xe0-l'Oeil",
        bra: "O Papa-Olho",
        schema: 30414,
        hun: "A Szembe\xf6tl\u0151",
        swe: "Blickf\xe5ngaren"
    },
    818: {
        img: "tipped_lid",
        eng: "Tipped Lid",
        rus: "\u0411\u043B\u0430\u0433\u043E\u0442\u0432\u043E\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0448\u043B\u044F\u043F\u043A\u0430",
        pol: "Przechylony dekiel",
        sch: "\u5377\u8FB9\u5C0F\u793C\u5E3D",
        fre: "Le Chapeau bas",
        bra: "Chap\xe9u-Coco Caridoso",
        schema: 30425,
        hun: "Megbillentett Fejfed\u0151",
        swe: "Tippat Lock"
    },
    819: {
        img: "vive_la_france",
        eng: "Vive La France",
        rus: "\u0412\u0438\u0432 \u043B\u044F \u0424\u0440\u0430\u043D\u0441",
        pol: "Wiwat Fh\u0105sja",
        sch: "\u6CD5\u5170\u897F\u4E07\u5C81",
        fre: "Vive La France",
        bra: "Vive La France",
        schema: 30422
    },
    820: {
        img: "ye_olde_rustic_colour",
        eng: "Ye Olde Rustic Colour",
        rus: "\u0421\u0442\u0430\u0440\u044B\u0439 \u0433\u0440\u0443\u0431\u044B\u0439 \u0446\u0432\u0435\u0442",
        pol: "Odcie\u0144 zaiste rdzawy",
        fre: "La Bonne Vieille Couleur des Familles",
        sch: "\u4E61\u6751\u5C18\u571F\u8272",
        bra: "Vossa Velha Cor R\xfastica",
        schema: 5036,
        hun: "J\xf3 \xd6reg Rusztikus Sz\xednezet",
        swe: "Gammal lantlig f\xe4rg"
    },
    821: {
        img: "an_air_of_debonair",
        eng: "An Air of Debonair",
        rus: "\u0410\u0442\u043C\u043E\u0441\u0444\u0435\u0440\u0430 \u043B\u044E\u0431\u0435\u0437\u043D\u043E\u0441\u0442\u0438",
        pol: "Powiew elegancji",
        fre: "Un Air de D\xe9bonnaire",
        sch: "\u98CE\u5EA6\u7FE9\u7FE9\u7684\u683C\u8C03",
        bra: "Um Ar de Debochar",
        schema: 5063,
        hun: "Egy \xc1rnyalatnyi \xc1mulat",
        swe: "En doft av charm"
    },
    822: {
        img: "balaclavas_are_forever",
        eng: "Balaclavas Are Forever",
        rus: "\u0411\u0430\u043B\u0430\u043A\u043B\u0430\u0432\u044B \u043D\u0430\u0432\u0441\u0435\u0433\u0434\u0430",
        pol: "Kominiarki s\u0105 wieczne",
        fre: "Les Cagoules Sont \xc9ternelles",
        sch: "\u5DF4\u62C9\u514B\u62C9\u74E6\u4E07\u5C81",
        bra: "As Balaclavas s\xe3o Eternas",
        schema: 5062,
        hun: "A S\xedmaszk \xd6r\xf6k",
        swe: "Balaklavas f\xf6r alltid"
    },
    823: {
        img: "cream_spirit",
        eng: "Cream Spirit",
        rus: "\u041A\u0440\u0435\u043C\u043E\u0432\u044B\u0439 \u0434\u0443\u0445",
        pol: "Duch krem\xf3wki",
        fre: "Esprit Cr\xe8me",
        sch: "\u5976\u6CB9\u7CBE\u795E",
        bra: "Cremesp\xedrito de Equipe",
        schema: 5065,
        hun: "Kr\xe9mek Kr\xe9mje",
        swe: "Kr\xe4manda"
    },
    824: {
        img: "operators_overalls",
        eng: "Operator's Overalls",
        rus: "\u041A\u043E\u043C\u0431\u0438\u043D\u0435\u0437\u043E\u043D \u0440\u0430\u0431\u043E\u0447\u0435\u0433\u043E",
        pol: "Ogrodniczki operatora",
        fre: "Salopette de l'Engineer",
        sch: "\u6280\u5DE5\u7684\u5DE5\u88C5\u670D",
        bra: "Macac\xe3o do Oper\xe1rio",
        schema: 5060,
        hun: "A G\xe9p\xe9sz Szerel\u0151ruh\xe1ja",
        swe: "Operat\xf6rens Overaller"
    },
    825: {
        img: "the_value_of_teamwork",
        eng: "The Value of Teamwork",
        rus: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043A\u043E\u043C\u0430\u043D\u0434\u043D\u043E\u0439 \u0438\u0433\u0440\u044B",
        pol: "Warto\u015B\u0107 wsp\xf3\u0142pracy",
        fre: "L'Importance du Travail d'\xc9quipe",
        sch: "\u56E2\u961F\u4E4B\u529B",
        bra: "O Valor do Trabalho em Equipe",
        schema: 5064,
        hun: "A Csapatmunka \xc9rt\xe9ke",
        swe: "V\xe4rdet av lagarbete"
    },
    826: {
        img: "waterlogged_lab_coat",
        eng: "Waterlogged Lab Coat",
        rus: "\u041C\u043E\u043A\u0440\u044B\u0439 \u043B\u0430\u0431\u043E\u0440\u0430\u0442\u043E\u0440\u043D\u044B\u0439 \u0445\u0430\u043B\u0430\u0442",
        pol: "Przemokni\u0119ty kitel laboratoryjny",
        fre: "Blouse de Labo D\xe9tremp\xe9e",
        sch: "\u6CE1\u6C34\u7684\u767D\u5927\u8902",
        bra: "Jaleco Encharcado",
        schema: 5061,
        hun: "A Vizeny\u0151s K\xf6peny",
        swe: "Vattendr\xe4nkt labbrock"
    },
    827: {
        img: "aerobatics_demonstrator",
        eng: "Aerobatics Demonstrator",
        rus: "\u0418\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u043E\u0440 \u043F\u043E \u0430\u044D\u0440\u043E\u0431\u0430\u0442\u0438\u043A\u0435",
        pol: "Lot pokazowy",
        fre: "D\xe9monstrateur de voltige a\xe9rienne",
        sch: "\u9189\u9152\u9A7E\u673A",
        bra: "Demonstrador de Acrobacias A\xe9reas",
        schema: 30793,
        hun: "Bombasztikus L\xe9gi Akrobata",
        swe: "Konstflyguppvisare"
    },
    828: {
        img: "final_frontier_freighter",
        eng: "Final Frontier Freighter",
        rus: "\u0420\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0439 \u0444\u0440\u0430\u0445\u0442\u043E\u0432\u0449\u0438\u043A",
        pol: "Ko\u0144cowe odliczanie",
        fre: "Transporteur de l'ultime fronti\xe8re",
        sch: "\u822A\u5730\u98DE\u673A",
        bra: "Cargueiro da Fronteira Final",
        schema: 30794,
        hun: "Az Orbit\xe1lis M\xe9rn\xf6k",
        swe: "Gr\xe4nslandsfraktaren"
    },
    829: {
        img: "hovering_hotshot",
        eng: "Hovering Hotshot",
        rus: "\u0411\u0440\u0435\u044E\u0449\u0438\u0439 \u0432\u043E\u0441\u043F\u0430\u043B\u0438\u0442\u0435\u043B\u044C",
        pol: "Helikopter w ogniu",
        fre: "Super h\xe9lice",
        sch: "\u4EBA\u8089\u76F4\u5347\u673A",
        bra: "Ares Ardentes",
        schema: 30795,
        hun: "Lebeg\u0151 L\xe1nglovag",
        swe: "Hovrande h\xf6jdare"
    },
    830: {
        img: "classic",
        eng: "Classic",
        rus: "\u041A\u043B\u0430\u0441\u0441\u0438\u0447\u0435\u0441\u043A\u0438\u0439",
        pol: "Klasycznie",
        sch: "\u7ECF\u5178",
        fre: "Classique",
        bra: "Cl\xe1ssico",
        schema: 1098,
        schema2: 5754,
        hun: "Klasszikus",
        swe: "Klassisk"
    },
    831: {
        img: "manmelter",
        eng: "Manmelter",
        rus: "\u041B\u044E\u0434\u043E\u043F\u043B\u0430\u0432",
        pol: "Cz\u0142ekoroztapiacz",
        sch: "\u7194\u4EBA\u67AA",
        fre: "Le Fissionneur",
        bra: "A Derretedora de Homens",
        schema: 595,
        schema2: 5755,
        hun: "Az Emberolvaszt\xf3",
        swe: "M\xe4nniskosm\xe4ltaren"
    },
    832: {
        img: "crocodile_mun_dee",
        eng: "Crocodile Mun-Dee",
        rus: "\u041A\u0440\u043E\u043A\u043E\u0434\u0438\u043B \u041C\u0430\u043D\u0434\u0438",
        pol: "Krokodyl Mun-Dee",
        fre: "Crocodile Mun-Dee",
        sch: "\u5168\u5458\u9CC4\u4EBA",
        bra: "Crocodilo Mun-Dee",
        schema: 31009,
        hun: "Krokodil Mun-Dee",
        swe: "Krokodil Mun-Dee"
    },
    833: {
        img: "strange_part_robot_scouts_destroyed",
        eng: "Strange Part: Robot Scouts Destroyed",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u043D\u0438\u0447\u0442\u043E\u0436\u0435\u043D\u043D\u044B\u0435 \u0440\u043E\u0431\u043E\u0442\u044B-\u0440\u0430\u0437\u0432\u0435\u0434\u0447\u0438\u043A\u0438",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zniszczeni roboskauci",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u673A\u5668\u4FA6\u5BDF\u5175\u6467\u6BC1\u6570",
        fre: "Pi\xe8ce \xe9trange : Scouts Robots d\xe9truits",
        bra: "Pe\xe7a Estranha: Scouts Rob\xf4s Destru\xeddos",
        schema: 6042,
        hun: "Fura Alkatr\xe9sz: Elpuszt\xedtott Robot-felder\xedt\u0151k",
        swe: "M\xe4rklig del: Robotspanare f\xf6rst\xf6rda"
    },
    834: {
        img: "strange_part_taunting_player_kills",
        eng: "Strange Part: Taunting Player Kills",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0439\u0441\u0442\u0432\u0430 \u043D\u0430\u0441\u043C\u0435\u0445\u0430\u044E\u0449\u0438\u0445\u0441\u044F \u0438\u0433\u0440\u043E\u043A\u043E\u0432",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zabici drwi\u0105cy wrogowie",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u5632\u8BBD\u73A9\u5BB6\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Victimes effectuant une raillerie",
        bra: "Pe\xe7a Estranha: V\xedtimas Provocadoras",
        schema: 6062,
        hun: "Fura Alkatr\xe9sz: Meg\xf6lt besz\xf3l\xf3 j\xe1t\xe9kosok",
        swe: "M\xe4rklig del: H\xe5nande spelare d\xf6dade"
    },
    835: {
        img: "scopers_scales",
        eng: "Scoper's Scales",
        rus: "\u0421\u043D\u0430\u0439\u043F\u0435\u0440\u0441\u043A\u0430\u044F \u0447\u0435\u0448\u0443\u044F",
        pol: "\u0141uskowate \u0142apska",
        fre: "Reptile r\xe9put\xe9",
        sch: "\u9CC4\u4EBA\u9CDE\u7532",
        bra: "Escamas do Franco-Atirador",
        schema: 31005,
        hun: "Hidegv\xe9r\u0171 Mesterl\xf6v\xe9sz",
        swe: "Skyttens Skinn"
    },
    836: {
        img: "dell_in_the_shell",
        eng: "Dell in the Shell",
        rus: "\u041F\u0430\u043D\u0446\u0438\u0440\u043D\u044B\u0439 \u0414\u0435\u043B\u043B",
        pol: "Oczytany owodniowiec",
        fre: "Ovipare strat\xe8ge",
        sch: "\u5DE5\u58F3\u673A\u52A8\u961F",
        bra: "Conagher no Casco",
        schema: 30995,
        hun: "Dell a P\xe1nc\xe9lban",
        ger: "Schildkr\xf6tenschrauber",
        swe: "Pansarpadda"
    },
    837: {
        img: "a_shell_of_a_mann",
        eng: "A Shell of a Mann",
        rus: "\u041C\u0430\u043D\u043D-\u043F\u0430\u043D\u0446\u0438\u0440\u044C",
        pol: "Karapaks konstruktora",
        fre: "La carapace humaine",
        sch: "\u4ED9\u4EBA\u4E4B\u58F3",
        bra: "O Casco de um Homem",
        schema: 30994,
        hun: "F\xe9rfias P\xe1nc\xe9lok",
        swe: "Skalmann"
    },
    838: {
        img: "nugget_noggin",
        eng: "The Nugget Noggin",
        rus: "\u0426\u044B\u043F\u043B\u044F\u0447\u044C\u044F \u0433\u043E\u043B\u043E\u0432\u0430",
        pol: "Ptasi m\xf3\u017Cd\u017Cek",
        sch: "\u9E21\u5757\u5927\u738B",
        fre: "La Tronche d'Escalope Pan\xe9e",
        bra: "O Galo Galante",
        schema: 30491,
        hun: "A Csirkekobak",
        swe: "H\xf6nshuvud"
    },
    839: {
        img: "fowl_fists",
        eng: "The Fowl Fists",
        rus: "\u041A\u0443\u0440\u0438\u043D\u044B\u0435 \u043A\u0443\u043B\u0430\u0447\u043A\u0438",
        pol: "Drobiowe d\u0142onie",
        sch: "\u5C0F\u9E21\u5FEB\u8DD1",
        fre: "Les Poings Volatiles",
        bra: "Os Punhos Penosos",
        schema: 30492,
        hun: "A Sz\xe1rnyas \xd6kl\xf6k",
        swe: "H\xf6nsh\xe4nder"
    },
    840: {
        img: "talon_trotters",
        eng: "The Talon Trotters",
        rus: "\u041A\u0443\u0440\u044C\u0438 \u043D\u043E\u0436\u043A\u0438",
        pol: "Kamasze kurczaka",
        sch: "\u52B2\u8106\u9E21\u722A",
        fre: "Les Serres Trotteuses",
        bra: "As Garras Galin\xe1ceas",
        schema: 30493,
        hun: "A Karmos Cs\xfclk\xf6k",
        swe: "Kycklingklor"
    },
    841: {
        img: "head_hunter",
        eng: "The Head Hunter",
        rus: "\u041E\u0445\u043E\u0442\u043D\u0438\u043A \u0437\u0430 \u0433\u043E\u043B\u043E\u0432\u0430\u043C\u0438",
        pol: "G\u0142owca",
        sch: "Hunter \u7684\u5934",
        fre: "Le Chasseur de T\xeates",
        bra: "O Ca\xe7ador de Cabe\xe7as",
        schema: 30494,
        hun: "A Vad\xe1szf\u0151",
        swe: "Huvudj\xe4gare"
    },
    842: {
        img: "claws_and_infect",
        eng: "The Claws And Infect",
        rus: "\u0417\u0430\u0440\u0430\u0437\u043D\u044B\u0435 \u043A\u043E\u0433\u0442\u0438",
        pol: "Splugawione szpony",
        sch: "\u611F\u67D3\u4E4B\u722A",
        fre: "Les griffes infect\xe9es",
        bra: "Os Dedos Doentios",
        schema: 30495,
        hun: "A Karom \xe9s Fert\u0151z\xe9s",
        swe: "On\xe5diga naglar"
    },
    843: {
        img: "crazy_legs",
        eng: "The Crazy Legs",
        rus: "\u0421\u0443\u043C\u0430\u0441\u0448\u0435\u0434\u0448\u0438\u0435 \u043D\u043E\u0433\u0438",
        pol: "Szalone nogi",
        sch: "\u8150\u70C2\u4E4B\u8DB3",
        fre: "Les Crazy Legs",
        bra: "As Pernas Loucas",
        schema: 30496,
        hun: "Az Eszel\u0151s L\xe1bak",
        swe: "Galna ben"
    },
    844: {
        img: "battle_bird",
        eng: "The Battle Bird",
        rus: "\u0411\u043E\u0439\u0446\u043E\u0432\u044B\u0439 \u043F\u0435\u0442\u0443\u0445",
        pol: "Ptak wojny",
        sch: "\u5929\u9E70\u6218\u58EB",
        fre: "L'Oiseau de bataille",
        bra: "O Bicador de Batalha",
        schema: 30524,
        hun: "A Harci Sas",
        swe: "Frihetsk\xe4mparf\xe5gel"
    },
    845: {
        img: "ghoul_gibbin_gear",
        eng: "The Ghoul Gibbin' Gear",
        rus: "\u041D\u0430\u0431\u043E\u0440 \u0443\u0431\u0438\u0439\u0446\u044B \u0443\u043F\u044B\u0440\u0435\u0439",
        pol: "Ekwipunek egzorcysty",
        sch: "\u5C16\u5934\u5341\u5B57\u67B6",
        fre: "L'\xc9quipement du Massacreur de Goules",
        bra: "O Equipamento Explode-Esp\xedritos",
        schema: 30520,
        hun: "A Halvaj\xe1r\xf3-nyuvaszt\xf3 Holmi",
        swe: "Vampyrj\xe4garens vapenarsenal"
    },
    846: {
        img: "hellhunters_headpiece",
        eng: "The Hellhunter's Headpiece",
        rus: "\u0428\u043B\u044F\u043F\u0430 \u043E\u0445\u043E\u0442\u043D\u0438\u043A\u0430 \u0437\u0430 \u043D\u0435\u0447\u0438\u0441\u0442\u044C\u044E",
        pol: "\u0141owca demon\xf3w",
        sch: "\u5730\u72F1\u730E\u624B",
        fre: "Le Chapeau du Purificateur",
        bra: "O Chap\xe9u do Ca\xe7ador Infernal",
        schema: 30521,
        hun: "A Pokolj\xe1r\xf3 Kalapja",
        swe: "Helvetisk j\xe4garhatt"
    },
    847: {
        img: "supernatural_stalker",
        eng: "The Supernatural Stalker",
        rus: "\u041E\u0445\u043E\u0442\u043D\u0438\u043A \u0437\u0430 \u0441\u0432\u0435\u0440\u0445\u044A\u0435\u0441\u0442\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u043C",
        pol: "Upiorna chusta",
        sch: "\u8D85\u81EA\u7136\u884C\u8005",
        fre: "Le Traqueur Surnaturel",
        bra: "O Perseguidor Paranormal",
        schema: 30522,
        hun: "A Lid\xe9rces Lid\xe9rcvad\xe1sz",
        swe: "\xd6vernaturlig \xf6vervakare"
    },
    848: {
        img: "kritz_or_treat_canteen",
        eng: "The Kritz or Treat Canteen",
        rus: "\u041C\u0435\u0448\u043E\u0447\u0435\u043A \u0434\u043B\u044F \u0431\u043E\u043D\u0443\u0441\u043E\u0432",
        pol: "Mannierka smako\u0142yk albo krytyk",
        sch: "\u201C\u4E0D\u653E\u7206\u51FB\u5C31\u6363\u86CB\u201D\u6C34\u58F6",
        fre: "Gourde Kritz ou Friandises",
        bra: "Cantil de Doces e Travessuras",
        schema: 30535,
        hun: "A Csokit vagy Kritelek Kulacs",
        swe: "Krut eller godis-kantin"
    },
    849: {
        img: "creatures_grin",
        eng: "The Creature's Grin",
        rus: "\u0427\u0443\u0434\u043E\u0432\u0438\u0449\u043D\u044B\u0439 \u043E\u0441\u043A\u0430\u043B",
        pol: "Upiorny u\u015Bmiech",
        sch: "\u88C2\u9762\u8005",
        fre: "Le Sourire Monstrueux",
        bra: "A Boca Bem Aberta",
        schema: 30525,
        hun: "A L\xe9ny Vigyora",
        swe: "Monstru\xf6st flin"
    },
    850: {
        img: "arsonist_apparatus",
        eng: "The Arsonist Apparatus",
        rus: "\u041F\u0440\u0438\u0431\u043E\u0440 \u043F\u043E\u0434\u0436\u0438\u0433\u0430\u0442\u0435\u043B\u044F",
        pol: "Przyrz\u0105dy podpalacza",
        sch: "\u7EB5\u706B\u8005\u4E4B\u81C2",
        fre: "L'Appareil Incendiaire",
        bra: "A Pr\xf3tese Piroman\xedaca",
        schema: 30526,
        hun: "A Gy\xfajtogat\xf3k\xe9sz\xfcl\xe9k",
        swe: "Nedbr\xe4nnarens n\xe4ve"
    },
    851: {
        img: "moccasin_machinery",
        eng: "The Moccasin Machinery",
        rus: "\u041C\u0435\u0445\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043C\u043E\u043A\u0430\u0441\u0438\u043D",
        pol: "Mokasynowa maszyneria",
        sch: "\u83AB\u5361\u8F9B\u673A\u5668\u8DB3",
        fre: "Le Mocassin M\xe9canique",
        bra: "O Mocassim Mecatr\xf4nico",
        schema: 30527,
        hun: "A L\xe1bg\xe9p",
        swe: "Mockasinmaskineri"
    },
    852: {
        img: "lollichop_licker",
        eng: "The Lollichop Licker",
        rus: "\u041B\u0438\u0437\u0443\u043D \u043A\u043B\u0435\u0434\u0435\u043D\u0446\u0430",
        pol: "Lizacz Liza\u015Bka",
        sch: "\u7CD6\u4E0A\u8214\u8840",
        fre: "Le Sussache Lover",
        bra: "O Lambedor de Pyrolito",
        schema: 30528,
        hun: "A Nyalakv\xf3",
        swe: "Slickepinansiktet"
    },
    853: {
        img: "mr_juice",
        eng: "Mr. Juice",
        rus: "\u041C\u0438\u0441\u0442\u0435\u0440 \u0414\u0436\u0443\u0441",
        pol: "Sokopyr\xf3wka",
        sch: "\u679C\u6C41\u5148\u751F",
        fre: "M. Juteux",
        bra: "Sr. Suco",
        schema: 30529,
        hun: "L\xe9 \xdar",
        swe: "Fruktl\xf6s fruktsallad"
    },
    854: {
        img: "vampyro",
        eng: "The Vampyro",
        rus: "\u0412\u0430\u043C-\u043F\u0438\u0440\u043E",
        pol: "Wampyro",
        sch: "\u706B\u7130\u5438\u8840\u9B3C",
        fre: "Le Vampyro",
        bra: "Vampyro",
        schema: 30530,
        hun: "A V\xe1mpir\xf3",
        ger: "Der Vampyro",
        swe: "Vampyro"
    },
    855: {
        img: "forgotten_kings_restless_head",
        eng: "The Forgotten King's Restless Head",
        rus: "\u041D\u0435\u0443\u043F\u043E\u043A\u043E\u0435\u043D\u043D\u0430\u044F \u0433\u043E\u043B\u043E\u0432\u0430 \u0437\u0430\u0431\u044B\u0442\u043E\u0433\u043E \u043A\u043E\u0440\u043E\u043B\u044F",
        pol: "Nieznaj\u0105ca spoczynku g\u0142owa Zapomnianego Kr\xf3la",
        sch: "\u9B3C\u738B\u7684\u8111\u888B",
        fre: "La T\xeate D\xe9l\xe9t\xe8re du Roi Oubli\xe9",
        bra: "O Cr\xe2nio Inquieto do Rei Esquecido",
        schema: 30516,
        hun: "Az Elfeledett Kir\xe1ly Nyughatatlan Feje",
        swe: "F\xf6rg\xe4tna kungens rastl\xf6sa huvud"
    },
    856: {
        img: "forgotten_kings_pauldrons",
        eng: "The Forgotten King's Pauldrons",
        rus: "\u041D\u0430\u043F\u043B\u0435\u0447\u043D\u0438\u043A\u0438 \u0437\u0430\u0431\u044B\u0442\u043E\u0433\u043E \u043A\u043E\u0440\u043E\u043B\u044F",
        pol: "Naramienniki Zapomnianego Kr\xf3la",
        sch: "\u9B3C\u738B\u7684\u80A9\u7532",
        fre: "Les \xc9pauli\xe8res du Roi Oubli\xe9",
        bra: "As Ombreiras do Rei Esquecido",
        schema: 30517,
        hun: "Az Elfeledett Kir\xe1ly V\xe1llv\xe9rtje",
        swe: "F\xf6rg\xe4tna kungens axelskydd"
    },
    857: {
        img: "eyeborg",
        eng: "The Eyeborg",
        rus: "\u0413\u043B\u0430\u0437\u0431\u043E\u0440\u0433",
        pol: "Cyklopoborg",
        sch: "\u673A\u5668\u4E49\u773C",
        fre: "L'Oeilborg",
        bra: "O Ciclopeborgue",
        schema: 30518,
        hun: "A Szemborg",
        swe: "En\xf6gde mannens \xf6nskan"
    },
    858: {
        img: "mannhattan_project",
        eng: "The Mannhattan Project",
        rus: "\u041C\u0430\u043D\u043D\u0445\u044D\u0442\u0442\u0435\u043D\u0441\u043A\u0438\u0439 \u043F\u0440\u043E\u0435\u043A\u0442",
        pol: "Projekt Mannhattan",
        sch: "\u5934\u6234\u5F0F\u8611\u83C7\u4E91",
        fre: "Le Projet Manhattan",
        bra: "O Projeto Mannhattan",
        schema: 30519,
        hun: "A Mannhattan Terv",
        swe: "Mannhattanprojektet"
    },
    859: {
        img: "lil_dutchman",
        eng: "The Li'l Dutchman",
        rus: "\u041C\u0430\u043B\u0435\u043D\u044C\u043A\u0438\u0439 \u0433\u043E\u043B\u043B\u0430\u043D\u0434\u0435\u0446",
        pol: "Malu\u015Bki Holender",
        sch: "\u8BC5\u5492\u4E4B\u821F",
        fre: "Le P'tit Hollandais",
        bra: "O Pequeno Holand\xeas Voador",
        schema: 30536,
        hun: "A Kis Hollandi",
        swe: "Flytande holl\xe4ndaren"
    },
    860: {
        img: "bone_cut_belt",
        eng: "The Bone-Cut Belt",
        rus: "\u041A\u043E\u0441\u0442\u044F\u043D\u043E\u0439 \u043D\u0430\u043F\u043B\u0435\u0447\u043D\u0438\u043A",
        pol: "Naje\u017Cony naramiennik",
        sch: "\u5254\u9AA8\u62A4\u80A9",
        fre: "La Ceinture Coupe-Os",
        bra: "O Cinto Chifrudo",
        schema: 30531,
        hun: "A Csont\xf6v",
        swe: "Aggets axelrem"
    },
    861: {
        img: "bull_locks",
        eng: "The Bull Locks",
        rus: "\u0411\u044B\u0447\u044C\u044F \u0431\u043E\u0440\u043E\u0434\u0430",
        pol: "Bycza broda",
        sch: "\u516C\u725B\u6BDB\u53D1",
        fre: "Les Dreadlocks de Taureau",
        bra: "A Barba de Touro",
        schema: 30532,
        hun: "A Bikaszak\xe1ll",
        swe: "Tjuriga sk\xe4gglockar"
    },
    862: {
        img: "minsk_beef",
        eng: "The Minsk Beef",
        rus: "\u041C\u0438\u043D\u0441\u043A\u0430\u044F \u0433\u043E\u0432\u044F\u0434\u0438\u043D\u0430",
        pol: "W\xf3\u0142 z Mi\u0144ska",
        sch: "\u660E\u65AF\u514B\u516C\u725B",
        fre: "L' \xc9-Minsk-\xe9 de B\u0153uf",
        bra: "O Bife de Minsk",
        schema: 30533,
        hun: "A Minszki Bika",
        swe: "Tjurskallen"
    },
    863: {
        img: "immobile_suit",
        eng: "The Immobile Suit",
        rus: "\u0421\u043C\u0438\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u0441\u0442\u044E\u043C",
        pol: "Pancerz niemobilny",
        sch: "\u91CD\u578B\u80F8\u7532",
        fre: "La Combi-mmobile",
        bra: "O Traje Im\xf3vel",
        schema: 30534,
        hun: "Az Immobil Er\u0151",
        swe: "Immobil rustning"
    },
    864: {
        img: "hooded_haunter",
        eng: "The Hooded Haunter",
        rus: "\u041F\u0440\u0438\u0437\u0440\u0430\u043A \u0432 \u043A\u0430\u043F\u044E\u0448\u043E\u043D\u0435",
        pol: "Zakapturzona zjawa",
        sch: "\u62AB\u98CE\u5E7D\u7075",
        fre: "L'Esprit Capuchonn\xe9",
        bra: "O Espectro Encapuzado",
        schema: 30498,
        hun: "A Kapucnis K\xeds\xe9rt\u0151",
        swe: "Hems\xf6kande huvan"
    },
    865: {
        img: "iron_fist",
        eng: "The Iron Fist",
        rus: "\u0416\u0435\u043B\u0435\u0437\u043D\u044B\u0439 \u043A\u0443\u043B\u0430\u043A",
        pol: "\u017Belazna pi\u0119\u015B\u0107",
        sch: "\u94C1\u81C2",
        fre: "Le Poing de Fer",
        bra: "O Punho de Ferro",
        schema: 30508,
        hun: "A Vas\xf6k\xf6l",
        swe: "J\xe4rnn\xe4ven"
    },
    866: {
        img: "beep_man",
        eng: "The Beep Man",
        rus: "\u0411\u0438\u043F-\u043C\u0435\u043D",
        pol: "Cz\u0142owiek-konsola",
        sch: "\u5DE8\u578B\u6E38\u620F\u673A",
        fre: "Le Beep Man",
        bra: "O Bip Man",
        schema: 30509,
        hun: "A F\xfctty\xf6s F\xe9rfi",
        ger: "Der Beep Man",
        swe: "Beep Man"
    },
    867: {
        img: "soul_of_spensers_past",
        eng: "The Soul of 'Spensers Past",
        rus: "\u0414\u0443\u0448\u0430 \u0440\u0430\u0437\u0434\u0430\u0442\u0447\u0438\u043A\u0430",
        pol: "Duch minionego zasobnika",
        sch: "\u5E03.\u57FA\u9F50\u5148\u751F\u7684\u7075\u9B42",
        fre: "Le Fant\xf4me des Distributeurs D\xe9funts",
        bra: "O Fantasma de Fornecedores Falecidos",
        schema: 30510,
        hun: "R\xe9gvolt Adagol\xf3k Lelke",
        swe: "Utvalda utmatarens sj\xe4l"
    },
    868: {
        img: "garden_bristles",
        eng: "The Garden Bristles",
        rus: "\u0421\u0430\u0434\u043E\u0432\u0430\u044F \u0431\u043E\u0440\u043E\u0434\u0430",
        pol: "Krasnal obrodowy",
        sch: "\u82B1\u56ED\u77EE\u4EBA\u987B",
        fre: "La Barbe de Jardin",
        bra: "A Barba de Jardim",
        schema: 30523,
        hun: "A Kerti Fazon",
        swe: "Tr\xe4dg\xe5rdstomtesk\xe4gg"
    },
    869: {
        img: "tiny_texan",
        eng: "The Tiny Texan",
        rus: "\u041C\u0430\u043B\u0435\u043D\u044C\u043A\u0438\u0439 \u0442\u0435\u0445\u0430\u0441\u0435\u0446",
        pol: "Tyci Teksa\u0144czyk",
        sch: "\u5FAE\u578B\u5FB7\u5DDE\u4EBA",
        fre: "Le Petit Texan",
        bra: "A Cabe\xe7a Controladora",
        schema: 30511,
        hun: "A T\xf6rpe Texasi",
        swe: "Lillvilliga ingenj\xf6ren"
    },
    870: {
        img: "herzensbrecher",
        eng: "The Herzensbrecher",
        rus: "\u0421\u0435\u0440\u0434\u0446\u0435\u0435\u0434",
        pol: "Herzensbrecher",
        sch: "\u533B\u754C\u826F\u5FC3",
        fre: "Le Herzensbrecher",
        bra: "O Herzensbrecher",
        schema: 30486,
        hun: "A Herzensbrecher",
        ger: "Der Herzensbrecher",
        swe: "Herzensbrecher"
    },
    871: {
        img: "hundkopf",
        eng: "The Hundkopf",
        rus: "\u041F\u0441\u0438\u0433\u043B\u0430\u0432\u0435\u0446",
        pol: "Hundkopf",
        sch: "\u6B7B\u72D7\u5934",
        fre: "Le Hundkopf",
        bra: "O Hundkopf",
        schema: 30487,
        hun: "A Hundkopf",
        ger: "Der Hundekopf",
        swe: "Hundkopf"
    },
    872: {
        img: "kriegsmaschine_9000",
        eng: "The Kriegsmaschine-9000",
        rus: "\u041A\u0440\u0438\u0433\u0441\u043C\u0430\u0448\u0438\u043D\u0430-9000",
        pol: "Kriegsmaschine-9000",
        sch: "\u7206\u51FB\u673A\u5668\u4EBA 9000 \u578B",
        fre: "La Kriegsmaschine-9000",
        bra: "A Kriegsmaschine-9000",
        schema: 30488,
        hun: "A Kriegsmaschine-9000",
        ger: "Die Kriegsmaschine-9000",
        swe: "Kriegsmaschine-9000"
    },
    873: {
        img: "vampire_makeover",
        eng: "The Vampire Makeover",
        rus: "\u041C\u0430\u043A\u0438\u044F\u0436 \u0432\u0430\u043C\u043F\u0438\u0440\u0430",
        pol: "Wampirzy wiza\u017C",
        sch: "\u8840\u7AD9\u603B\u7BA1\u7684\u9762\u5BB9",
        fre: "Le Relooking Transylvanien",
        bra: "A Maquiagem Vampiresca",
        schema: 30489,
        hun: "A V\xe1mp\xedrszerk\xf3",
        swe: "Vacker vampyr"
    },
    874: {
        img: "vampiric_vesture",
        eng: "The Vampiric Vesture",
        rus: "\u041E\u0434\u0435\u044F\u043D\u0438\u0435 \u0432\u0430\u043C\u043F\u0438\u0440\u0430",
        pol: "Wampirze wdzianko",
        sch: "\u8840\u7AD9\u603B\u7BA1\u7684\u5927\u8863",
        fre: "L'Habit Vampirique",
        bra: "As Vestimentas Vamp\xedricas",
        schema: 30490,
        hun: "A V\xe1mp\xedros Viselet",
        swe: "Vampyrisk utstyrsel"
    },
    875: {
        img: "templars_spirit",
        eng: "The Templar's Spirit",
        rus: "\u0414\u0443\u0445 \u0445\u0440\u0430\u043C\u043E\u0432\u043D\u0438\u043A\u0430",
        pol: "Duch templariusza",
        sch: "\u5723\u6BBF\u9A91\u58EB\u4E4B\u7075",
        fre: "L\u2019\xc2me du Templier",
        bra: "O Esp\xedrito do Templ\xe1rio",
        schema: 30514,
        hun: "A Templomos Szelleme",
        swe: "Tempelriddarens sj\xe4l"
    },
    876: {
        img: "wings_of_purity",
        eng: "The Wings of Purity",
        rus: "\u041A\u0440\u044B\u043B\u044C\u044F \u043D\u0435\u043F\u043E\u0440\u043E\u0447\u043D\u043E\u0441\u0442\u0438",
        pol: "Skrzyd\u0142a cnoty",
        sch: "\u51C0\u5316\u4E4B\u7FFC",
        fre: "Les Ailes de Puret\xe9",
        bra: "As Asas da Pureza",
        schema: 30515,
        hun: "A Tisztas\xe1g Sz\xe1rnyai",
        swe: "Renhetens vingar"
    },
    877: {
        img: "cranial_conspiracy",
        eng: "The Cranial Conspiracy",
        rus: "\u0427\u0435\u0440\u0435\u043F\u043D\u0430\u044F \u043C\u0430\u0441\u043A\u0438\u0440\u043E\u0432\u043A\u0430",
        pol: "Czaszkowa zmowa",
        sch: "\u8725\u8734\u8111\u888B",
        fre: "La Conspiration Cr\xe2nienne",
        bra: "A Conspira\xe7\xe3o Craniana",
        schema: 30499,
        hun: "A Kopony\xe1lis \xd6sszeesk\xfcv\xe9s",
        swe: "Kraniell konspiration"
    },
    878: {
        img: "scaly_scrapers",
        eng: "The Scaly Scrapers",
        rus: "\u0427\u0435\u0448\u0443\u0439\u0447\u0430\u0442\u044B\u0435 \u043B\u0430\u043F\u044B",
        pol: "\u0141uskowe \u0142apsko",
        sch: "\u8725\u8734\u722A\u5B50",
        fre: "La D\xe9mangeaison d\u2019\xc9cailles",
        bra: "O Esfolador Escamoso",
        schema: 30500,
        hun: "A Pikkelyes Kapar\xf3k",
        swe: "Fj\xe4llfingrar"
    },
    879: {
        img: "mr_mundees_wild_ride",
        eng: "Mr. Mundee's Wild Ride",
        rus: "\u0414\u0438\u043A\u0438\u0435 \u0441\u043A\u0430\u0447\u043A\u0438 \u043C\u0438\u0441\u0442\u0435\u0440\u0430 \u041C\u0430\u043D\u0434\u0438",
        pol: "Strusia jazda bez trzymanki",
        sch: "\u7A46\u8FEA\u5148\u751F\u7684\u72C2\u91CE\u5EA7\u9A7E",
        fre: "La Chevauch\xe9e Sauvage de M. Mundee",
        bra: "As Aventuras do Mundee Animal",
        schema: 30513,
        hun: "A Mr. Mundee Vadfogata",
        swe: "Struttande struts"
    },
    880: {
        img: "marsupial_man",
        eng: "The Marsupial Man",
        rus: "\u0427\u0435\u043B\u043E\u0432\u0435\u043A-\u043A\u0435\u043D\u0433\u0443\u0440\u0443",
        pol: "Cz\u0142owiek-torbacz",
        sch: "\u888B\u9F20\u602A\u4EBA",
        fre: "L'Homme Marsupial",
        bra: "O Marsupial Maluco",
        schema: 30501,
        hun: "Az Ersz\xe9nyes Ember",
        swe: "Pungdjursmannen"
    },
    881: {
        img: "kanga_kickers",
        eng: "The Kanga Kickers",
        rus: "\u0411\u0440\u044B\u043A\u0430\u043B\u043A\u0438 \u043A\u0435\u043D\u0433\u0443\u0440\u0443",
        pol: "Kangurze kopyta",
        sch: "\u888B\u9F20\u5C3E\u5DF4",
        fre: "Les Kangous Kickers",
        bra: "Os Cangu-cal\xe7ados",
        schema: 30502,
        hun: "A Kengur-ugr\xf3",
        swe: "K\xe4nguruk\xe4ngor"
    },
    882: {
        img: "roo_rippers",
        eng: "The Roo Rippers",
        rus: "\u0425\u0432\u0430\u0442\u0430\u043B\u043A\u0438 \u043A\u0435\u043D\u0433\u0443\u0440\u0443",
        pol: "Kangurze ko\u0144czyny",
        sch: "\u888B\u9F20\u722A\u5B50",
        fre: "Le Kangourou \xc9ventreur",
        bra: "Garras de 'Guru",
        schema: 30503,
        hun: "A Kengurukarmok",
        swe: "K\xe4nguruklor"
    },
    883: {
        img: "marsupial_muzzle",
        eng: "The Marsupial Muzzle",
        rus: "\u041C\u043E\u0440\u0434\u0430 \u043A\u0435\u043D\u0433\u0443\u0440\u0443",
        pol: "Twarz torbacza",
        sch: "\u888B\u9F20\u8111\u888B",
        fre: "Le Museau Marsupial",
        bra: "O Focinho Marsupial",
        schema: 30504,
        hun: "Az Orrsz\xe9nyes",
        swe: "K\xe4nguruk\xe4ke"
    },
    884: {
        img: "shadowmans_shade",
        eng: "Shadowman's Shade",
        rus: "\u0422\u0435\u043D\u044C \u043A\u043E\u043B\u0434\u0443\u043D\u0430",
        pol: "Cie\u0144 cichociemnego",
        sch: "\u6697\u5F71\u4E4B\u4EBA\u7684\u793C\u5E3D",
        fre: "L'Ombre du Shadowman",
        bra: "O Visual do Outro Lado",
        schema: 30505,
        hun: "Az \xc1rny\xe9kember \xc1rny\xe9kol\xf3ja",
        swe: "Skuggmannens skugga"
    },
    885: {
        img: "nightmare_hunter",
        eng: "The Nightmare Hunter",
        rus: "\u041E\u0445\u043E\u0442\u043D\u0438\u043A \u0437\u0430 \u043A\u043E\u0448\u043C\u0430\u0440\u0430\u043C\u0438",
        pol: "Wi\u0105zowy koszmar",
        sch: "\u68A6\u9B47\u730E\u624B",
        fre: "Le Chasseur Cauchemardesque",
        bra: "O Ca\xe7ador da Meia-Noite",
        schema: 30506,
        hun: "A R\xe9m\xe1lomvad\xe1sz",
        swe: "Mardr\xf6msj\xe4garen"
    },
    886: {
        img: "rogues_rabbit",
        eng: "The Rogue's Rabbit",
        rus: "\u041A\u0440\u043E\u043B\u0438\u043A \u0436\u0443\u043B\u0438\u043A\u0430",
        pol: "Kr\xf3lik kr\u0119tacza",
        sch: "\u9B54\u672F\u5E08\u7684\u5154\u5B50\u5E3D",
        fre: "Le Lapin du Voyou",
        bra: "O Truque do Trapaceiro",
        schema: 30507,
        hun: "A Gazember Nyula",
        swe: "Knivmanskanin"
    },
    887: {
        img: "facepeeler",
        eng: "The Facepeeler",
        rus: "\u041B\u0438\u0446\u0435\u0441\u0440\u0435\u0437",
        pol: "Zdzieracz twarzy",
        sch: "\u753B\u76AE",
        fre: "L\u2019\xc9plucheur de Visages",
        bra: "O Descarado",
        schema: 30512,
        hun: "Az Arch\xe1moz\xf3",
        swe: "Avskalat ansikte"
    },
    888: {
        img: "ghost_of_spies_checked_past",
        eng: "The Ghost of Spies Checked Past",
        rus: "\u041F\u0440\u0438\u0437\u0440\u0430\u043A \u0431\u0435\u0441\u043F\u0435\u0447\u043D\u043E\u0441\u0442\u0438",
        pol: "D\u0142ugie rami\u0119 niesprawiedliwo\u015Bci",
        sch: "\u6B7B\u4E0D\u7791\u76EE\u7684\u95F4\u8C0D\u9B3C\u9B42",
        fre: "Le Fant\xf4me des D\xe9funts Spies Rep\xe9r\xe9s",
        bra: "O Fantasma de Spies Passados",
        schema: 30497,
        hun: "A Lebukott K\xe9mek Szelleme",
        swe: "P\xe5komna Spionens sp\xf6ke"
    },
    889: {
        img: "mishap_mercenary",
        eng: "The Mishap Mercenary",
        rus: "\u041D\u0430\u0435\u043C\u043D\u044B\u0439 \u043B\u0438\u043A\u0432\u0438\u0434\u0430\u0442\u043E\u0440",
        pol: "Niefortunny najemnik",
        sch: "\u5012\u9709\u7684\u96C7\u4F63\u5175",
        fre: "Le Mercenaire malchanceux",
        bra: "O Mercen\xe1rio Azarado",
        schema: 30475,
        hun: "A Katasztr\xf3fa-zsoldos",
        swe: "Kemikaliek\xe4mpen"
    },
    890: {
        img: "lady_killer",
        eng: "The Lady Killer",
        rus: "\u0416\u0430\u043A \u041F\u043E\u0442\u0440\u043E\u0448\u0438\u0442\u0435\u043B\u044C",
        pol: "Po\u017Ceracz damskich serc",
        sch: "\u5C11\u5987\u6740\u624B",
        fre: "Le Tombeur de ces Dames",
        bra: "O Espi\xe3o Estripador",
        schema: 30476,
        hun: "H\xf6lgyek Veszedelme",
        swe: "Ladykiller"
    },
    891: {
        img: "lone_survivor",
        eng: "The Lone Survivor",
        rus: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 \u0433\u0435\u0440\u043E\u0439",
        pol: "Jedyny ocala\u0142y",
        sch: "\u5B64\u72EC\u7684\u5E78\u5B58\u8005",
        fre: "Le Survivant Solitaire",
        bra: "O Sobrevivente",
        schema: 30477,
        hun: "A Mag\xe1nyos T\xfal\xe9l\u0151",
        swe: "Den ensamma \xf6verlevaren"
    },
    892: {
        img: "poachers_safari_jacket",
        eng: "Poacher's Safari Jacket",
        rus: "\u041A\u0443\u0440\u0442\u043A\u0430 \u0431\u0440\u0430\u043A\u043E\u043D\u044C\u0435\u0440\u0430",
        pol: "Kurtka safari k\u0142usownika",
        sch: "\u5077\u730E\u8005\u7684\u6E38\u730E\u5939\u514B",
        fre: "Veste safari du braconnier",
        bra: "A Jaqueta do Lar\xe1pio de Cabe\xe7as",
        schema: 30478,
        hun: "Vadorz\xf3k Szafarikab\xe1tja",
        swe: "Tjuvskyttens safarijacka"
    },
    893: {
        img: "thirst_blood",
        eng: "Thirst Blood",
        rus: "\u0416\u0430\u0436\u0434\u0430 \u043A\u0440\u043E\u0432\u0438",
        pol: "Po\u017C\u0105dana krew",
        sch: "\u55DC\u8840\u5934\u5E26",
        fre: "Pas ma Guerre",
        bra: "Sede de Sangue",
        schema: 30479,
        hun: "V\xe9rszomj\xfas\xe1g",
        swe: "Blodt\xf6rst"
    },
    894: {
        img: "mann_of_the_seven_sees",
        eng: "Mann of the Seven Sees",
        rus: "\u0411\u043E\u0446\u043C\u0430\u043D\u043D \u0441\u0435\u043C\u0438 \u043C\u043E\u0440\u0435\u0439",
        pol: "Chojrak siedmiu wynurze\u0144",
        sch: "\u7EB5\u6A2A\u4E03\u6D77",
        fre: "Le Conqu\xe9rant des Sept Mers",
        bra: "O Demolidor dos Sete Mares",
        schema: 30480,
        hun: "H\xe9t Tenger Leg\xe9nye",
        swe: "Mannen av de sju haven"
    },
    895: {
        img: "hillbilly_speed_bump",
        eng: "Hillbilly Speed Bump",
        rus: "\u0411\u0440\u043E\u043D\u0435\u043D\u043E\u0441\u0435\u0446 \u0432 \u043F\u043E\u0442\u0451\u043C\u043A\u0430\u0445",
        pol: "Prowincjonalny garbek",
        sch: "\u4E61\u5DF4\u4F6C\u51CF\u901F\u5E26",
        fre: "Bosse de p\xe9quenaud",
        bra: "Tatu do Ben",
        schema: 30481,
        hun: "Mucsai Fekv\u0151rend\u0151r",
        swe: "Lantisens farthinder"
    },
    896: {
        img: "unshaved_bear",
        eng: "The Unshaved Bear",
        rus: "\u041D\u0435\u0431\u0440\u0438\u0442\u044B\u0439 \u043C\u0435\u0434\u0432\u0435\u0434\u044C",
        pol: "Nieogolony nied\u017Awied\u017A",
        sch: "\u957F\u6BDB\u718A\u602A",
        fre: "L'Ours mal ras\xe9",
        bra: "O Urso Barbudo",
        schema: 30482,
        hun: "A Borotv\xe1latlan Medve",
        swe: "Den Orakade Bj\xf6rnen"
    },
    897: {
        img: "pocket_heavy",
        eng: "Pocket Heavy",
        rus: "\u041A\u0430\u0440\u043C\u0430\u043D\u043D\u044B\u0439 \u043F\u0443\u043B\u0435\u043C\u0451\u0442\u0447\u0438\u043A",
        pol: "Kieszonkowy Gruby",
        sch: "\u53E3\u888B\u673A\u67AA\u624B",
        fre: "Heavy de poche",
        bra: "Heavy de Bolso",
        schema: 30483,
        hun: "Zsebg\xe9p\xe1gy\xfas",
        swe: "Fickartillerist"
    },
    898: {
        img: "wartime_warmth",
        eng: "Wartime Warmth",
        rus: "\u0412\u043E\u0435\u043D\u043D\u0430\u044F \u0433\u0440\u0435\u043B\u043A\u0430",
        pol: "Wojenne ciepe\u0142ko",
        sch: "\u6218\u65F6\u4FDD\u6696\u9762\u7F69",
        fre: "Cagoule de guerre",
        bra: "Calor do Combate",
        schema: 30538,
        hun: "H\xe1bor\xfas H\u0151s\xe9g",
        swe: "Gasmaskv\xe4rmaren"
    },
    899: {
        img: "insulated_inventor",
        eng: "Insulated Inventor",
        rus: "\u0418\u0437\u043E\u0431\u0440\u0435\u0442\u0430\u0442\u0435\u043B\u044C-\u043E\u0442\u0448\u0435\u043B\u044C\u043D\u0438\u043A",
        pol: "Watowany wynalazca",
        sch: "\u4FDD\u6696\u53D1\u660E\u5BB6",
        fre: "Inventeur isol\xe9",
        bra: "Inventor Insulado",
        schema: 30539,
        hun: "Szigetelt Szakember",
        swe: "Isolerad Innovat\xf6r"
    },
    900: {
        img: "brooklyn_booties",
        eng: "Brooklyn Booties",
        rus: "\u0411\u0440\u0443\u043A\u043B\u0438\u043D\u0441\u043A\u0438\u0435 \u0431\u043E\u0442\u0438\u043D\u043E\u0447\u043A\u0438",
        pol: "Brookly\u0144skie buciki",
        sch: "\u5E03\u9C81\u514B\u6797\u77ED\u9774",
        fre: "Bottines de Brooklyn",
        bra: "Botinas de Brooklyn",
        schema: 30540,
        hun: "Brooklyni Bakancs",
        swe: "Brooklynk\xe4ngor"
    },
    901: {
        img: "double_dynamite",
        eng: "Double Dynamite",
        rus: "\u0414\u0432\u043E\u0439\u043D\u043E\u0439 \u0434\u0438\u043D\u0430\u043C\u0438\u0442",
        pol: "Sze\u015Bciopak Nobla",
        sch: "\u4E24\u6346\u70B8\u836F",
        fre: "Double Dynamite",
        bra: "Dupla Dinamite",
        schema: 30541,
        hun: "Dupla Dinamit",
        swe: "Dubbeldynamit"
    },
    902: {
        img: "coldsnap_cap",
        eng: "Coldsnap Cap",
        rus: "\u0422\u0435\u043F\u043B\u0430\u044F \u0448\u0430\u043F\u043A\u0430",
        pol: "Polarny pompon",
        sch: "\u5BD2\u6F6E\u9488\u7EC7\u5E3D",
        fre: "Bonnet de vague de froid",
        bra: "Forro de Frente Fria",
        schema: 30542,
        hun: "Fagyv\xe9d\u0151 Fejfed\u0151",
        swe: "K\xf6ldkn\xe4ppsm\xf6ssa"
    },
    903: {
        img: "snow_stompers",
        eng: "Snow Stompers",
        rus: "\u0421\u043D\u0435\u0433\u043E\u0441\u0442\u0443\u043F\u044B",
        pol: "Termiczne trepy",
        sch: "\u96EA\u5730\u8DF5\u8E0F\u8005",
        fre: "Grosses bottes de neige",
        bra: "Galochas de Gelo",
        schema: 30543,
        hun: "Hetyke H\xf3tapos\xf3",
        swe: "Sn\xf6pulsare"
    },
    904: {
        img: "north_polar_fleece",
        eng: "North Polar Fleece",
        rus: "\u0428\u0435\u0440\u0441\u0442\u044F\u043D\u0430\u044F \u043A\u043E\u0444\u0442\u0430 \u043F\u043E\u043B\u044F\u0440\u043D\u0438\u043A\u0430",
        pol: "Polarny polar",
        sch: "\u5317\u6781\u7F8A\u6BDB\u8863",
        fre: "Toison polaire",
        bra: "Pul\xf4ver do Polo Norte",
        schema: 30544,
        hun: "K\xf6t\xf6tt Pulcsi",
        swe: "Nordpolsfleece"
    },
    905: {
        img: "fur_lined_fighter",
        eng: "Fur-Lined Fighter",
        rus: "\u0411\u043E\u0435\u0446 \u0441 \u043C\u0435\u0445\u043E\u0432\u043E\u0439 \u043F\u043E\u0434\u043A\u043B\u0430\u0434\u043A\u043E\u0439",
        pol: "Uszanka emigranta",
        sch: "\u6BDB\u76AE\u6218\u58EB\u5E3D",
        fre: "Guerrier de fourrure",
        bra: "Protetores Peludos",
        schema: 30545,
        hun: "Pr\xe9mes Pofoz\xf3",
        swe: "P\xe4lsfodrad bj\xe4sse"
    },
    906: {
        img: "boxcar_bomber",
        eng: "Boxcar Bomber",
        rus: "\u0412\u0437\u0440\u044B\u0432\u043D\u043E\u0439 \u0442\u043E\u0432\u0430\u0440\u043D\u044F\u043A",
        pol: "Pilot poci\u0105gu-pu\u0142apki",
        sch: "\u68DA\u8F66\u8F70\u70B8\u5458",
        fre: "Fourvoyeur de fourgon",
        bra: "Vigilante do Vag\xe3o",
        schema: 30546,
        hun: "Vagon Vag\xe1ny",
        swe: "P\xe4lsm\xf6ssa"
    },
    907: {
        img: "bombers_bucket_hat",
        eng: "Bomber's Bucket Hat",
        rus: "\u041F\u0430\u043D\u0430\u043C\u0430 \u043F\u043E\u0434\u0440\u044B\u0432\u043D\u0438\u043A\u0430",
        pol: "Zamachowiec-amator",
        sch: "\u8F70\u70B8\u5458\u7684\u793C\u5E3D",
        fre: "Bob du bombardier",
        bra: "Barrete do Bombardeiro",
        schema: 30547,
        hun: "Bomb\xe1z\xf3 Hal\xe1szsapka",
        swe: "Spr\xe4ngarens fiskehatt"
    },
    908: {
        img: "screamin_eagle",
        eng: "Screamin' Eagle",
        rus: "\u041A\u043B\u0435\u043A\u043E\u0447\u0443\u0449\u0438\u0439 \u043E\u0440\u0451\u043B",
        pol: "As przestworzy",
        sch: "\u547C\u5578\u96C4\u9E70",
        fre: "Piqu\xe9 du faucon",
        bra: "Esquadr\xe3o Gavi\xe3o",
        schema: 30548,
        hun: "A sas lecsap",
        rom: "Strig\u0103tul Vulturului",
        swe: "Skriande \xf6rnen"
    },
    909: {
        img: "winter_woodsman",
        eng: "Winter Woodsman",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u043B\u0435\u0441\u043E\u0440\u0443\u0431",
        pol: "Dogrzany drwal",
        sch: "\u51AC\u5B63\u4F10\u6728\u4EBA",
        fre: "B\xfbcheron bor\xe9al",
        bra: "Lenhador de Lisburne",
        schema: 30549,
        hun: "T\xe9li Fav\xe1g\xf3",
        swe: "Vinterskogsarbetaren"
    },
    910: {
        img: "snow_sleeves",
        eng: "Snow Sleeves",
        rus: "\u0421\u043D\u0435\u0436\u043D\u044B\u0435 \u0440\u0443\u043A\u0430\u0432\u0430",
        pol: "R\u0119kawy \u015Bnie\u017Cne",
        sch: "\u96EA\u5730\u9632\u5BD2\u8896",
        fre: "Manches hivernales",
        bra: "Abomin\xe1veis Mangas da Neve",
        schema: 30550,
        hun: "H\xf3szeg\xe9ly",
        swe: "Vinterjacka"
    },
    911: {
        img: "flashdance_footies",
        eng: "Flashdance Footies",
        rus: "\u0422\u0430\u043D\u0446\u0435\u0432\u0430\u043B\u044C\u043D\u044B\u0435 \u0441\u0430\u043F\u043E\u0433\u0438",
        pol: "Froty z Flashdance",
        sch: "\u95EA\u821E\u51AC\u9774",
        fre: "Fa\xe7on Flashdance",
        bra: "Polaina do Polo",
        schema: 30551,
        hun: "Vill\xe1mcsuk\xe1k",
        swe: "Flashdanceskor"
    },
    912: {
        img: "thermal_tracker",
        eng: "Thermal Tracker",
        rus: "\u0422\u0435\u0440\u043C\u043E\u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442",
        pol: "Docieplony d\u0142ugodystansowiec",
        sch: "\u70ED\u80FD\u8FFD\u8E2A\u8005",
        fre: "Traqueur thermique",
        bra: "Camisa T\xe9rmica do Corredor",
        schema: 30552,
        hun: "H\u0151keres\u0151",
        swe: "Sp\xe5rarens v\xe4rmetr\xf6ja"
    },
    913: {
        img: "condor_cap",
        eng: "Condor Cap",
        rus: "\u041A\u043E\u043D\u0434\u043E\u0440\u0441\u043A\u0430\u044F \u0448\u0430\u043F\u043A\u0430",
        pol: "Dokerka Condor",
        sch: "\u79C3\u9E70\u4E4B\u5E3D",
        fre: "Bonnet de condor",
        bra: "Chap\xe9u de Condor",
        schema: 30553,
        hun: "Kesely\u0171sapka",
        swe: "Kondorens m\xf6ssa"
    },
    914: {
        img: "mistaken_movember",
        eng: "Mistaken Movember",
        rus: "\u041D\u0435\u0443\u043C\u0435\u0441\u0442\u043D\u044B\u0439 \u0443\u0441\u0430\u0431\u0440\u044C",
        pol: "Sp\xf3\u017Aniony Movember",
        sch: "\u80E1\u5B50\u8282\u7684\u8C2C\u8BEF",
        fre: "Mauvais Movember",
        bra: "Barbudo sem Bigode",
        schema: 30554,
        hun: "Eln\xe9zett Movember",
        swe: "Misstagen movember"
    },
    915: {
        img: "double_dog_dare_demo_pants",
        eng: "Double Dog Dare Demo Pants",
        rus: "\u0422\u0435\u043F\u043B\u044B\u0435 \u043F\u043E\u0434\u0440\u044B\u0432\u043D\u044B\u0435 \u0448\u0442\u0430\u043D\u044B \u043D\u0430 \u0441\u043F\u043E\u0440",
        pol: "Bombowe boj\xf3wki",
        sch: "\u65E0\u60E7\u4E4B\u7206\u7834\u624B\u51AC\u88E4",
        fre: "Pantalon \xe0 double d\xe9fi du Demoman",
        bra: "Cal\xe7as de Carga do Ciclope",
        schema: 30555,
        hun: "Zsebesnek \xc1ll a Vil\xe1g",
        swe: "Dj\xe4rva cargobyxor"
    },
    916: {
        img: "sleeveless_in_siberia",
        eng: "Sleeveless in Siberia",
        rus: "\u0421\u0438\u0431\u0438\u0440\u0441\u043A\u0430\u044F \u0431\u0435\u0437\u0440\u0443\u043A\u0430\u0432\u043A\u0430",
        pol: "Syberyjski bezr\u0119kawnik",
        sch: "\u897F\u4F2F\u5229\u4E9A\u65E0\u8896\u8863",
        fre: "D\xe9bardeur sib\xe9rien",
        bra: "Jaqueta de Geada",
        schema: 30556,
        hun: "Szib\xe9riai Ujjatlan",
        swe: "\xc4rml\xf6s i Sibirien"
    },
    917: {
        img: "hunter_heavy",
        eng: "Hunter Heavy",
        rus: "\u041F\u0443\u043B\u0435\u043C\u0451\u0442\u0447\u0438\u043A-\u043E\u0445\u043E\u0442\u043D\u0438\u043A",
        pol: "\u0141owca grubego zwierza",
        sch: "\u673A\u67AA\u730E\u624B",
        fre: "Heavy chasseur",
        bra: "Ca\xe7ador Camuflado",
        schema: 30557,
        hun: "Neh\xe9z Vad\xe1sz",
        swe: "Tung J\xe4gare"
    },
    918: {
        img: "coldfront_curbstompers",
        eng: "Coldfront Curbstompers",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0435 \u0431\u043E\u0442\u0438\u043D\u043A\u0438 \u0441 \u043D\u0430\u0431\u043E\u0439\u043A\u0430\u043C\u0438",
        pol: "Zimowe zgniatacze",
        sch: "\u51B7\u950B\u8DF5\u8E0F\u8005",
        fre: "Mange-trottoir de Coldfront",
        bra: "Frente Quente",
        schema: 30558,
        hun: "Hidegfront-harcos",
        swe: "Kallfrontens pansark\xe4ngor"
    },
    919: {
        img: "crossing_guard",
        eng: "The Crossing Guard",
        rus: "\u0420\u0435\u0433\u0443\u043B\u0438\u0440\u043E\u0432\u0449\u0438\u043A",
        pol: "Zawiadowca",
        sch: "\u94C1\u8F68\u7BA1\u5236\u5458",
        fre: "Le Passage \xe0 niveau",
        bra: "A Cruz de Santo Andr\xe9",
        schema: 1127,
        hun: "A Bakter",
        swe: "\xd6verg\xe5ngsvakten"
    },
    920: {
        img: "pool_party",
        eng: "Taunt: Pool Party",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0412\u0435\u0447\u0435\u0440\u0438\u043D\u043A\u0430 \u0432 \u0431\u0430\u0441\u0441\u0435\u0439\u043D\u0435",
        schema: 30570,
        pol: "Drwina: Impreza na basenie",
        sch: "\u5632\u8BBD\uFF1A\u6CF3\u6C60\u6D3E\u5BF9",
        fre: "Raillerie : Piscine festive",
        bra: "Provoca\xe7\xe3o: Festa na Piscina",
        hun: "Besz\xf3l\xe1s: Medenc\xe9s buli",
        swe: "H\xe5n: Poolparty"
    },
    921: {
        img: "cold_snap_coat",
        eng: "Cold Snap Coat",
        rus: "\u0422\u0435\u043F\u043B\u0430\u044F \u043A\u0443\u0440\u0442\u043A\u0430",
        pol: "Polarna parka",
        sch: "\u5BD2\u6F6E\u5916\u5957",
        fre: "Blouson Coupe Vent",
        bra: "Casaco Cala-Frio",
        schema: 30601,
        hun: "Hidegroham-kab\xe1t",
        swe: "K\xf6ldkn\xe4ppskappa"
    },
    922: {
        img: "festive_bonk_atomic_punch",
        eng: "Festive Bonk! Atomic Punch",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u0411\u043E\u043D\u043A! \u0410\u0442\u043E\u043C\u043D\u044B\u0439 \u0437\u0430\u043B\u043F",
        pol: "\u015Awi\u0105teczny Bonk! Atomowy kop",
        sch: "\u8282\u65E5\u539F\u5B50\u80FD\u996E\u6599",
        fre: "Bonk! Atomic Punch festif",
        bra: "Bonk! Pancada At\xf4mica Festiva",
        schema: 1145,
        hun: "\xdcnnepi Poff! Atompuncs",
        swe: "Festlig Bonk! Atomic Punch"
    },
    923: {
        img: "festive_backburner",
        eng: "Festive Backburner",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u0414\u043E\u0436\u0438\u0433\u0430\u0442\u0435\u043B\u044C",
        pol: "\u015Awi\u0105teczny Dupalacz",
        sch: "\u8282\u65E5\u5077\u88AD\u70C8\u7130\u55B7\u5C04\u5668",
        fre: "Br\xfbleur arri\xe8re festif",
        bra: "O Queima-Costas Festivo",
        schema: 1146,
        hun: "\xdcnnepi Be\xe9get\u0151",
        swe: "Festlig ryggbr\xe4nnare"
    },
    924: {
        img: "festive_chargin_targe",
        eng: "Festive Chargin' Targe",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u0428\u0442\u0443\u0440\u043C\u043E\u0432\u043E\u0439 \u0449\u0438\u0442",
        pol: "\u015Awi\u0105teczna Tarcza szar\u017Cy",
        sch: "\u8282\u65E5\u51B2\u950B\u76FE",
        fre: "Bouclier b\xe9lier festif",
        bra: "A Tarja de Investida Festiva",
        schema: 1144,
        hun: "\xdcnnepi Rohamoz\xf3 Paizs",
        swe: "Festlig anfallssk\xf6ld"
    },
    925: {
        img: "festive_bonesaw",
        eng: "Festive Bonesaw",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u0430\u044F \u043C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0430\u044F \u043F\u0438\u043B\u0430",
        pol: "\u015Awi\u0105teczna pi\u0142a do ko\u015Bci",
        sch: "\u8282\u65E5\u9AA8\u952F",
        fre: "Scie \xe0 amputation festive",
        bra: "Serra de Ossos Festiva",
        schema: 1143,
        hun: "\xdcnnepi Csontf\u0171r\xe9sz",
        swe: "Festlig bens\xe5g"
    },
    926: {
        img: "festive_smg",
        eng: "Festive SMG",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u043F\u0438\u0441\u0442\u043E\u043B\u0435\u0442-\u043F\u0443\u043B\u0435\u043C\u0451\u0442",
        pol: "\u015Awi\u0105teczny PM",
        sch: "\u8282\u65E5 SMG",
        fre: "Mitraillette festive",
        bra: "Submetralhadora Festiva",
        schema: 1149,
        hun: "\xdcnnepi G\xe9ppisztoly",
        swe: "Festlig SMG"
    },
    927: {
        img: "festive_revolver",
        eng: "Festive Revolver",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u0440\u0435\u0432\u043E\u043B\u044C\u0432\u0435\u0440",
        pol: "\u015Awi\u0105teczny rewolwer",
        sch: "\u8282\u65E5\u5DE6\u8F6E\u624B\u67AA",
        fre: "Revolver festif",
        bra: "Rev\xf3lver Festivo",
        schema: 1142,
        hun: "\xdcnnepi Revolver",
        swe: "Festlig revolver"
    },
    928: {
        img: "festive_shotgun",
        eng: "Festive Shotgun",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u0434\u0440\u043E\u0431\u043E\u0432\u0438\u043A",
        pol: "\u015Awi\u0105teczna strzelba",
        sch: "\u8282\u65E5\u9730\u5F39\u67AA",
        fre: "Fusil \xe0 pompe festif",
        bra: "Escopeta Festiva",
        schema: 1141,
        hun: "\xdcnnepi S\xf6r\xe9tespuska",
        swe: "Festlig shotgun"
    },
    929: {
        img: "co_pilot",
        eng: "Co-Pilot",
        rus: "\u0412\u0442\u043E\u0440\u043E\u0439 \u043F\u0438\u043B\u043E\u0442",
        pol: "Drugi pilot",
        sch: "\u526F\u9A7E\u9A76\u5934\u76D4",
        fre: "Co-Pilote",
        bra: "Copiloto",
        schema: 30576,
        hun: "M\xe1sodpil\xf3ta",
        swe: "Andrepilot"
    },
    930: {
        img: "courtiers_collar",
        eng: "Courtier's Collar",
        rus: "\u041F\u043E\u0432\u044F\u0437\u043A\u0430 \u043F\u0440\u0438\u0434\u0432\u043E\u0440\u043D\u043E\u0433\u043E",
        pol: "Ko\u0142nierzyk dworzanina",
        sch: "\u8C04\u5A9A\u8005\u7684\u8863\u9886",
        fre: "Col du Courtisan",
        bra: "Colarinho do Cortes\xe3o",
        schema: 30574,
        hun: "Az Udvaronc \xd6lt\xf6z\xe9ke",
        swe: "Hovmannens krage"
    },
    931: {
        img: "harlequins_hooves",
        eng: "Harlequin's Hooves",
        rus: "\u0411\u043E\u0442\u0438\u043D\u043A\u0438 \u0431\u0443\u0444\u0444\u043E\u043D\u0430",
        pol: "B\u0142aze\u0144skie buciki",
        sch: "\u5C0F\u4E11\u9774\u5B50",
        fre: "Souliers d'Arlequin",
        bra: "Andar do Arlequim",
        schema: 30575,
        hun: "Harlekin-pat\xe1k",
        swe: "Narrens hovar"
    },
    932: {
        img: "mountebanks_masque",
        eng: "Mountebank's Masque",
        rus: "\u041C\u0430\u0441\u043A\u0430 \u043C\u043E\u0448\u0435\u043D\u043D\u0438\u043A\u0430",
        pol: "Maska szarlatana",
        sch: "\u884C\u9A97\u8005\u7684\u9762\u5177",
        fre: "Masque de Charlatan",
        bra: "S\xedmbolo do Saltimbanco",
        schema: 30573,
        hun: "Mountebank Maszkja",
        swe: "Kvacksalvarens Maskspel"
    },
    933: {
        img: "skullcap",
        eng: "Skullcap",
        rus: "\u0411\u0435\u0440\u0435\u0442 \u0441 \u0447\u0435\u0440\u0435\u043F\u043E\u043C",
        pol: "Beret z czaszk\u0105",
        sch: "\u9AB7\u9AC5\u8D1D\u96F7\u5E3D",
        fre: "Le B\xe9ret d'Outre-Tombe",
        bra: "Comando Caveira",
        schema: 30578,
        hun: "Koponyasapka",
        swe: "Skallm\xf6ssa"
    },
    934: {
        img: "black_knights_bascinet",
        eng: "Black Knight's Bascinet",
        rus: "\u0411\u0430\u0446\u0438\u043D\u0435\u0442 \u0447\u0435\u0440\u043D\u043E\u0433\u043E \u0440\u044B\u0446\u0430\u0440\u044F",
        pol: "Psi pysk czarnego rycerza",
        sch: "\u9ED1\u9A91\u58EB\u9762\u7F69\u5934\u76D4",
        fre: "Bassinet du chevalier noir",
        bra: "Bacinete da Baixa Idade M\xe9dia",
        schema: 30582,
        hun: "A Fekete Lovag Fejv\xe9d\u0151je",
        swe: "Svarta riddarens bascinet"
    },
    935: {
        img: "charred_chainmail",
        eng: "Charred Chainmail",
        rus: "\u041A\u0430\u043B\u0435\u043D\u0430\u044F \u043A\u043E\u043B\u044C\u0447\u0443\u0433\u0430",
        pol: "Wypalana kolczuga",
        sch: "\u7126\u9ED1\u9CDE\u7532",
        fre: "Cotte de maille carbonis\xe9e",
        bra: "Cota de Malha Chamuscada",
        schema: 30584,
        hun: "L\xe1ngmarta L\xe1ncing",
        swe: "F\xf6rkolnad ringbrynjeskjorta"
    },
    936: {
        img: "pyromancers_hood",
        eng: "Pyromancer's Hood",
        rus: "\u041A\u0430\u043F\u044E\u0448\u043E\u043D \u043F\u0438\u0440\u043E\u043C\u0430\u043D\u0442\u0430",
        pol: "Kaptur piromanty",
        sch: "\u706B\u7130\u672F\u58EB\u7684\u515C\u5E3D",
        fre: "Capuche de Pyromancien",
        bra: "Capuz de Piromante",
        schema: 30580,
        hun: "A T\u0171zgy\xfajt\xf3 Csukly\xe1ja",
        swe: "Pyromanens huva"
    },
    937: {
        img: "pyromancers_raiments",
        eng: "Pyromancer's Raiments",
        rus: "\u041E\u0434\u0435\u044F\u043D\u0438\u0435 \u043F\u0438\u0440\u043E\u043C\u0430\u043D\u0442\u0430",
        pol: "Szaty piromanty",
        sch: "\u7EB5\u706B\u8005\u7684\u5236\u670D",
        fre: "Robe de Pyromancien",
        bra: "Vestes de Piromante",
        schema: 30581,
        hun: "A T\u0171zgy\xfajt\xf3 \xd6lt\xf6z\xe9ke",
        swe: "Pyromanens skrud"
    },
    938: {
        img: "torchers_tabard",
        eng: "Torcher's Tabard",
        rus: "\u041F\u043B\u0430\u0449 \u043F\u043E\u0434\u043F\u0430\u043B\u0438\u0442\u0435\u043B\u044F",
        pol: "Odzienie giermka",
        sch: "\u706B\u70AC\u624B\u7684\u6218\u888D",
        fre: "Tabard de l'incendiaire",
        bra: "Tabardo do Toca-Fogo",
        schema: 30583,
        hun: "A Gy\xfajtogat\xf3 Tunik\xe1ja",
        swe: "Br\xe4nnarens tabert"
    },
    939: {
        img: "scot_bonnet",
        eng: "Scot Bonnet",
        rus: "\u0428\u043E\u0442\u043B\u0430\u043D\u0434\u0441\u043A\u0430\u044F \u0448\u0430\u043F\u043E\u0447\u043A\u0430",
        pol: "Szkocka mycka",
        sch: "\u82CF\u683C\u5170\u6BDB\u7EBF\u5E3D",
        fre: "Bonnet du Scot",
        bra: "Boina Escocesa",
        schema: 30604,
        hun: "Sk\xf3t Sapka",
        swe: "Skotthuva"
    },
    940: {
        img: "storm_stompers",
        eng: "Storm Stompers",
        rus: "\u0411\u0443\u0440\u0435\u0441\u0442\u0443\u043F\u044B",
        pol: "Burzowe buciory",
        sch: "\u98CE\u66B4\u6218\u9774",
        fre: "L'Ecraseur de Flaques",
        bra: "Galochas Germ\xe2nicas",
        schema: 30587,
        hun: "Vihartipr\xf3",
        swe: "Sn\xf6k\xe4ngorna"
    },
    941: {
        img: "valhalla_helm",
        eng: "Valhalla Helm",
        rus: "\u0428\u043B\u0435\u043C \u0412\u0430\u043B\u044C\u0445\u0430\u043B\u043B\u044B",
        pol: "He\u0142m Walhalli",
        sch: "\u74E6\u5C14\u54C8\u62C9\u5934\u76D4",
        fre: "Casque du Valhalla",
        bra: "Elmo dos Einherjar",
        schema: 30586,
        hun: "Valhallai Sisak",
        swe: "Valhallahj\xe4lmen"
    },
    942: {
        img: "old_man_frost",
        eng: "Old Man Frost",
        rus: "\u0414\u044F\u0434\u044E\u0448\u043A\u0430 \u041C\u043E\u0440\u043E\u0437",
        pol: "Dziadek Mr\xf3z",
        sch: "\u68EE\u6797\u7237\u7237",
        fre: "Le vieil homme de No\xebl",
        bra: "A Malha de Morozko",
        schema: 30589,
        hun: "Az \xd6reg Fagy",
        swe: "Farfar Frost"
    },
    943: {
        img: "siberian_facehugger",
        eng: "Siberian Facehugger",
        rus: "\u0421\u0438\u0431\u0438\u0440\u0441\u043A\u0438\u0439 \u043B\u0438\u0446\u0435\u0445\u0432\u0430\u0442",
        pol: "Syberyjski ocieplacz g\u0142owy",
        sch: "\u897F\u4F2F\u5229\u4E9A\u88F9\u8138\u5E3D",
        fre: "Face-Hugger de Sib\xe9rie",
        bra: "Capuz Calorento",
        schema: 30588,
        hun: "Szib\xe9riai Arc\xf6lel\u0151",
        swe: "Sibirisk ansiktskramare"
    },
    944: {
        img: "clubsy_the_seal",
        eng: "Clubsy The Seal",
        rus: "\u0422\u044E\u043B\u0435\u043D\u044C \u0414\u0443\u0431\u0438\u043D\u0443\u0448\u043A\u0430",
        pol: "Foczka Bu\u0142awka",
        sch: "\u6D77\u8C79\u68D2\u68D2",
        fre: "Clubsy le Phoque",
        bra: "Parceiro Polar",
        schema: 30593,
        hun: "Zsebi, a F\xf3ka",
        swe: "S\xe4len Klubby"
    },
    945: {
        img: "conaghers_combover",
        eng: "Conagher's Combover",
        rus: "\u041F\u0435\u0440\u0435\u043F\u043B\u044E\u0439\u0447\u0438\u043A \u041A\u043E\u043D\u0430\u0433\u0435\u0440\u0430",
        pol: "Zaczes Conaghera",
        sch: "\u79C3\u9876\u725B\u4ED4\u7684\u88C5\u675F",
        fre: "Conagher D\xe9garni",
        bra: "Calv\xedcie Coberta do Conagher",
        schema: 30592,
        hun: "J\xf3lf\xe9s\xfclt Conagher",
        swe: "Conaghers \xf6verkamning"
    },
    946: {
        img: "cop_caller",
        eng: "Cop Caller",
        rus: "\u041F\u043E\u0437\u044B\u0432\u043D\u043E\u0439 \u043F\u043E\u043B\u0438\u0446\u0435\u0439\u0441\u043A\u0438\u0445",
        pol: "Kapu\u015B",
        sch: "\u62A5\u8B66\u5458",
        fre: "Demande de Renforts",
        bra: "Transceptor do Tira",
        schema: 30591,
        hun: "Zsaruh\xedv\xf3",
        swe: "Polisradio"
    },
    947: {
        img: "holstered_heaters",
        eng: "Holstered Heaters",
        rus: "\u041A\u043E\u0431\u0443\u0440\u0430 \u041A\u043E\u043D\u0430\u0433\u0435\u0440\u0430",
        pol: "Kaburowe ogrzewacze",
        sch: "\u68C0\u6D4B\u8005\u7684\u4FDD\u6696\u5927\u8863",
        fre: "\xc9tuis Chauffants",
        bra: "Aquecedores Armados",
        schema: 30590,
        hun: "H\xf3naljtokos Hidegretev\u0151",
        swe: "H\xf6lstrade v\xe4rmaren"
    },
    948: {
        img: "thermal_insulation_layer",
        eng: "Thermal Insulation Layer",
        rus: "\u0421\u043B\u043E\u0439 \u0442\u0435\u043F\u043B\u043E\u0438\u0437\u043E\u043B\u044F\u0446\u0438\u0438",
        pol: "Warstwa izolacji termicznej",
        sch: "\u7EDD\u70ED\u5C42",
        fre: "Couche d'isolation thermique",
        bra: "Camada de Isolante T\xe9rmico",
        schema: 30605,
        hun: "H\u0151szigetel\u0151 R\xe9teg",
        swe: "V\xe4rmeisolerat lager"
    },
    949: {
        img: "surgeons_shako",
        eng: "Surgeon's Shako",
        rus: "\u041A\u0438\u0432\u0435\u0440 \u043A\u043E\u0441\u0442\u043E\u0440\u0435\u0437\u0430",
        pol: "Czako chirurga",
        sch: "\u5916\u79D1\u533B\u5E08\u7684\u884C\u519B\u5E3D",
        fre: "Shako du chirurgien",
        bra: "Shako do Cirurgi\xe3o",
        schema: 30596,
        hun: "Seb\xe9szcs\xe1k\xf3",
        swe: "Kirurgens Shako"
    },
    950: {
        img: "unknown_mann",
        eng: "Unknown Mann",
        rus: "\u041C\u0430\u043D\u043D\u043E\u043D\u0438\u043C",
        pol: "Nieznany Mann",
        sch: "\u65E0\u540D\u4E4B\u4EBA",
        fre: "Mann Inconnu",
        bra: "Mann N\xe3o Identificado",
        schema: 30595,
        hun: "Az Ismeretlen Mannus",
        swe: "Ok\xe4nd Mann"
    },
    951: {
        img: "bushmans_bristles",
        eng: "Bushman's Bristles",
        rus: "\u0411\u043E\u0440\u043E\u0434\u0430 \u0431\u0443\u0448\u043C\u0435\u043D\u0430",
        pol: "Buszme\u0144ska szczecina",
        sch: "\u4E1B\u6797\u4E00\u65CF\u7684\u957F\u987B",
        fre: "Bacchantes du Bushman",
        bra: "Barba do Australiano",
        schema: 30597,
        hun: "Busman Bozont",
        swe: "Bushmannens borst"
    },
    952: {
        img: "marksmans_mohair",
        eng: "Marksman's Mohair",
        rus: "\u041C\u043E\u0445\u0435\u0440 \u043C\u0435\u0442\u043A\u043E\u0433\u043E \u0441\u0442\u0440\u0435\u043B\u043A\u0430",
        pol: "Ko\u017Cuch wyborowy",
        sch: "\u795E\u5C04\u624B\u7684\u9A6C\u6D77\u6BDB\u5927\u8863",
        fre: "Petite Laine du Tireur d'\xc9lite",
        bra: "Agasalho do Atirador",
        schema: 30599,
        hun: "A Mesterl\xf6v\xe9sz Sz\u0151rmell\xe9nye",
        swe: "Prickskyttens pl\xe4d"
    },
    953: {
        img: "professionals_ushanka",
        eng: "Professional's Ushanka",
        rus: "\u0423\u0448\u0430\u043D\u043A\u0430 \u0443\u0431\u0438\u0439\u0446\u044B",
        pol: "Uszanka profesjonalisty",
        sch: "\u804C\u4E1A\u6740\u624B\u7684\u62A4\u8033\u5E3D",
        fre: "Ouchanka du professionnel",
        bra: "Ushanka do Profissional",
        schema: 30598,
        hun: "A Hivat\xe1sos Usank\xe1ja",
        swe: "Proffsets usjanka"
    },
    954: {
        img: "wally_pocket",
        eng: "Wally Pocket",
        rus: "\u041A\u0430\u0440\u043C\u0430\u043D\u043D\u044B\u0439 \u043A\u0435\u043D\u0433\u0443\u0440\u0443",
        pol: "Kieszonkowy kangurek",
        sch: "\u53E3\u888B\u888B\u9F20",
        fre: "Wally de poche",
        bra: "Bolsa de Canguru",
        schema: 30600,
        hun: "Ersz\xe9ny Wally",
        swe: "K\xe4ngurufickan"
    },
    955: {
        img: "pocket_momma",
        eng: "Pocket Momma",
        rus: "\u041A\u0430\u0440\u043C\u0430\u043D\u043D\u0430\u044F \u043C\u0430\u043C\u043E\u0447\u043A\u0430",
        pol: "Kieszonkowa mamusia",
        sch: "\u8896\u73CD\u5988\u5988",
        fre: "Momma de poche",
        bra: "Mam\xe3e de Bolso",
        schema: 30606,
        hun: "Zsebanyuci",
        swe: "Fickmamma"
    },
    956: {
        img: "puffy_provocateur",
        eng: "Puffy Provocateur",
        rus: "\u041F\u043E\u0434\u0434\u0443\u0442\u044B\u0439 \u043F\u0440\u043E\u0432\u043E\u043A\u0430\u0442\u043E\u0440",
        pol: "Puszysta prowokatorka",
        sch: "\u84EC\u84EC\u5BC6\u63A2",
        fre: "Le Provocateur matelass\xe9",
        bra: "A Parka Provocateur",
        schema: 30602,
        hun: "A Pufidzsekis Provok\xe1tor",
        swe: "Puffad provokat\xf6r"
    },
    957: {
        img: "stealthy_scarf",
        eng: "Stealthy Scarf",
        rus: "\u0421\u043A\u0440\u044B\u0442\u043D\u044B\u0439 \u0448\u0430\u0440\u0444",
        pol: "Szal szalbierza",
        sch: "\u9690\u79D8\u56F4\u5DFE",
        fre: "\xc9charpe \xe9nigmatique",
        bra: "Cachecol Camuflado",
        schema: 30603,
        hun: "Surran\xf3 S\xe1l",
        swe: "Smygande halsduken"
    },
    958: {
        img: "cow_mangler_5000",
        eng: "Cow Mangler 5000",
        rus: "\u041B\u0438\u043D\u0447\u0435\u0432\u0430\u0442\u0435\u043B\u044C \u0441\u043A\u043E\u0442\u0430 5000",
        pol: "Wy\u017Cymaczka kr\xf3w 5000",
        sch: "\u7EDE\u725B\u673A 5000",
        fre: "Le Broyeur Bovin 5000",
        bra: "O Avacalhador 5000",
        schema: 441,
        schema2: 5783,
        hun: "A Teh\xe9ncsonk\xedt\xf3 5000",
        swe: "Komanglaren 5000"
    },
    959: {
        img: "third_degree",
        eng: "Third Degree",
        rus: "\u0422\u0440\u0435\u0442\u044C\u044F \u0441\u0442\u0435\u043F\u0435\u043D\u044C",
        pol: "Trzeci stopie\u0144",
        sch: "\u4E09\u5EA6\u70E7\u4F24",
        fre: "Le Troisi\xe8me Degr\xe9",
        bra: "O Terceiro Grau",
        schema: 593,
        schema2: 5784,
        hun: "A Harmadfok\xfa",
        swe: "Tredje graden"
    },
    960: {
        img: "winger",
        eng: "The Winger",
        rus: "\u041E\u043A\u0440\u044B\u043B\u0435\u043D\u043D\u044B\u0439",
        pol: "Skrzyd\u0142owy",
        sch: "\u8FB9\u950B\u7403\u5458",
        fre: "L'Ailier",
        bra: "Ala",
        schema: 449,
        hun: "A Sz\xe1rny-seg\xe9d",
        swe: "Yttern"
    },
    961: {
        img: "strange_part_not_crit_nor_minicrit_kills",
        eng: "Strange Part: Not Crit nor MiniCrit Kills",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u0443\u0431\u0438\u0439\u0441\u0442\u0432\u0430 \u043D\u0435\u043A\u0440\u0438\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u0443\u0440\u043E\u043D\u043E\u043C",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Zab\xf3jstwa niekrytyczne oraz nieminikrytyczne",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u975E\u7206\u51FB/\u8FF7\u4F60\u7206\u51FB\u51FB\u6740\u6570",
        fre: "Pi\xe8ce \xe9trange : Victimes sans coup critique ou mini-crit",
        bra: "Pe\xe7a Estranha: V\xedtimas sem Cr\xedticos ou Minicrits",
        schema: 6063,
        hun: "Fura Alkatr\xe9sz: Nem krites vagy mini-krites \xf6l\xe9sek",
        swe: "M\xe4rklig del: Varken kritiskt eller minikritiskt d\xf6dade"
    },
    962: {
        img: "strange_part_player_hits",
        eng: "Strange Part: Player Hits",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A: \u043F\u043E\u043F\u0430\u0434\u0430\u043D\u0438\u044F \u043F\u043E \u043F\u0440\u043E\u0442\u0438\u0432\u043D\u0438\u043A\u0430\u043C",
        pol: "Kuriozalna cz\u0119\u015B\u0107: Trafieni wrogowie",
        sch: "\u5947\u5F02\u5347\u7EA7\u90E8\u4EF6\uFF1A\u51FB\u4E2D\u73A9\u5BB6\u6570",
        fre: "Pi\xe8ce \xe9trange : Joueurs touch\xe9s",
        bra: "Pe\xe7a Estranha: Jogadores Atingidos",
        schema: 6064,
        hun: "Fura Alkatr\xe9sz: Eltal\xe1lt j\xe1t\xe9kosok",
        swe: "M\xe4rklig del: Spelare tr\xe4ffade"
    },
    963: {
        img: "strange_cosmetic_part_assists",
        eng: "Strange Cosmetic Part: Assists",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0439 \u0441\u0447\u0451\u0442\u0447\u0438\u043A \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430: \u043E\u0447\u043A\u0438 \u043F\u043E\u043C\u043E\u0449\u0438",
        pol: "Kuriozalna cz\u0119\u015B\u0107 dla przedmiot\xf3w ozdobnych: Asysty",
        sch: "\u5947\u5F02\u9970\u54C1\u90E8\u4EF6\uFF1A\u52A9\u653B\u6570",
        fre: "Pi\xe8ce de cosm\xe9tique \xe9trange : Coop\xe9rations",
        bra: "Pe\xe7a Estranha para Cosm\xe9ticos: Assist\xeancias",
        schema: 6065,
        hun: "Fura D\xedsz\xedt\u0151 Alkatr\xe9sz: Seg\xedt\xe9sek",
        swe: "M\xe4rklig kosmetisk del: Assister"
    },
    964: {
        img: "texas_ten_gallon",
        eng: "Texas Ten Gallon",
        rus: "\u0411\u043E\u043B\u044C\u0448\u0430\u044F \u0442\u0435\u0445\u0430\u0441\u0441\u043A\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "Teksa\u0144ski kapelusz",
        sch: "\u5FB7\u5DDE\u725B\u4ED4\u5E3D",
        fre: "Chapeau de cowboy",
        bra: "Caub\xf3i Texano",
        schema: 94,
        hun: "Texasi Cowboykalap",
        swe: "Texas cowboy"
    },
    965: {
        img: "awper_hand",
        eng: "The AWPer Hand",
        rus: "\u0421\u043B\u043E\u043D\u043E\u0431\u043E\u0439",
        pol: "Ale wielka pukawka",
        sch: "\u9AD8\u624B\u7684 AWP",
        fre: "L'AWPantage",
        bra: "A AWPer Capita",
        schema: 851,
        hun: "Az AWPr\xf3 El\u0151ny",
        swe: "AWPekaren"
    },
    966: {
        img: "war_blunder",
        eng: "War Blunder",
        rus: "\u0412\u043E\u0435\u043D\u043D\u044B\u0439 \u043F\u0440\u043E\u0441\u0447\u0451\u0442",
        pol: "Bitewny blama\u017C",
        fre: "Bavure de guerre",
        sch: "\u6218\u4E89\u633A\u7D2F",
        bra: "Esquadrilha da Desgra\xe7a",
        schema: 31137,
        hun: "Hadit\xe1kolm\xe1ny",
        swe: "Testpilot"
    },
    967: {
        img: "grounded_flyboy",
        eng: "Grounded Flyboy",
        rus: "\u041F\u0440\u0438\u0437\u0435\u043C\u043B\u0451\u043D\u043D\u044B\u0439 \u043B\u0435\u0442\u0443\u043D",
        pol: "Uziemiony lotnik",
        fre: "Pilote terrestre",
        sch: "\u7981\u6B62\u5347\u7A7A",
        bra: "Olha o Avi\xe3ozinho",
        schema: 31138,
        hun: "Gyalogrep\xfcl\u0151",
        swe: "Jordn\xe4ra flygar\xe4ss"
    },
    968: {
        img: "rolfe_copter",
        eng: "Rolfe Copter",
        rus: "\u0420\u043E\u043B\u044C\u0444-\u043A\u043E\u043F\u0442\u0435\u0440",
        pol: "Rolfokopter",
        fre: "M\xe9dicopt\xe8re",
        sch: "\u533B\u7597\u76F4\u5347\u673A",
        bra: "Rolfe-c\xf3ptero",
        schema: 31139,
        hun: "Ment\u0151helikop\xe1ter",
        swe: "Medikopter"
    },
    969: {
        img: "pug_mug",
        eng: "Pug Mug",
        rus: "\u041C\u043E\u0440\u0434\u0430 \u043C\u043E\u043F\u0441\u0430",
        pol: "Mopsowa mordka",
        fre: "Bouille de bouledogue",
        sch: "\u54C8\u5DF4\u5DE5",
        schema: 31140,
        bra: "Pugenheiro",
        hun: "Kutyapofa",
        swe: "Mopsnylle"
    },
    970: {
        img: "treehugger",
        eng: "Treehugger",
        rus: "\u0413\u043E\u043B\u043E\u0432\u0430 \u0441\u0430\u0434\u043E\u0432\u0430\u044F",
        pol: "Drzewolub",
        fre: "Souche s\xe8che",
        sch: "\u62B1\u6811\u72C2\u4EBA",
        bra: "Cara de Pau",
        schema: 31141,
        hun: "Fa\xf6lelget\u0151",
        swe: "Tr\xe4skalle"
    },
    971: {
        img: "mannvich",
        eng: "Mannvich",
        rus: "\u041C\u0430\u043D\u043D\u0434\u0432\u0438\u0447",
        pol: "Kanapkocz\u0142ek",
        fre: "Mannvich",
        sch: "\u5DE8\u578B\u4E09\u660E\u6CBB",
        bra: "Mannviche",
        schema: 31142,
        hun: "Szendvicsember"
    },
    972: {
        img: "festivizer",
        eng: "The Festivizer",
        rus: "\u0423\u043A\u0440\u0430\u0448\u0435\u043D\u0438\u0435",
        pol: "Dekorator",
        fre: "Enguirlandeur",
        sch: "\u5F69\u706F",
        bra: "Festivizador",
        schema: 5839,
        hun: "\xdcnnepies\xedt\u0151",
        swe: "Pyntare"
    },
    973: {
        img: "taunt_boston_breakdance",
        eng: "Taunt: The Boston Breakdance",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0411\u043E\u0441\u0442\u043E\u043D\u0441\u043A\u0438\u0439 \u0431\u0440\u0435\u0439\u043A",
        schema: 30572,
        pol: "Drwina: Bosto\u0144ski breakdance",
        fre: "Raillerie : La breakdance de Boston",
        sch: "\u5632\u8BBD\uFF1A\u6CE2\u58EB\u987F\u9739\u96F3\u821E",
        bra: "Provoca\xe7\xe3o: O Break de Boston",
        hun: "Besz\xf3l\xe1s: A bostoni breakt\xe1nc",
        swe: "H\xe5n: Boston Breakdance"
    },
    974: {
        img: "taunt_bunnyhopper",
        eng: "Taunt: The Bunnyhopper",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041F\u043E\u043F\u0440\u044B\u0433\u0443\u043D\u0447\u0438\u043A",
        schema: 30920,
        pol: "Drwina: Pogoskoczek",
        fre: "Raillerie : Le coup du lapin",
        sch: "\u5632\u8BBD\uFF1A\u8DF3\u8DF3\u5154",
        bra: "Provoca\xe7\xe3o: O Pula-Pula",
        hun: "Besz\xf3l\xe1s: A nyusziugr\xf3",
        swe: "H\xe5n: Kaninhopparen"
    },
    975: {
        img: "dalokohs_bar",
        eng: "The Dalokohs Bar",
        rus: '\u041F\u043B\u0438\u0442\u043A\u0430 "\u0414\u0430\u043B\u043E\u043A\u043E\u0448"',
        pol: "Tabliczka Ladyczeko",
        sch: "\u8FBE\u52D2\u514B\u65AF\u5DE7\u514B\u529B\u5757",
        fre: "La Barre de Dalokohs",
        bra: "A Barra de Dalokohs",
        schema: 159,
        hun: "A Dalokohs Szelet",
        swe: "Dalokohskakan"
    },
    976: {
        img: "warriors_spirit",
        eng: "The Warrior's Spirit",
        rus: "\u0412\u043E\u0438\u043D\u0441\u043A\u0438\u0439 \u0434\u0443\u0445",
        pol: "Dusza wojownika",
        sch: "\u52C7\u58EB\u4E4B\u9B42",
        fre: "L'Esprit du Guerrier",
        bra: "O Esp\xedrito do Guerreiro",
        schema: 310,
        hun: "A Harci Szellem",
        swe: "Krigarens anda"
    },
    977: {
        img: "apoco_fists",
        eng: "The Apoco-Fists",
        rus: "\u041A\u0443\u043B\u0430\u043A\u043E\u043F\u043E\u043A\u0430\u043B\u0438\u043F\u0441\u0438\u0441",
        pol: "Pi\u0105chokalipsa",
        sch: "\u5929\u707E\u4E4B\u62F3",
        fre: "A-poing-calypses",
        bra: "O Punhocalipse",
        schema: 587,
        hun: "V\xe9g\xfct\xe9let",
        swe: "Apoka-N\xe4var"
    },
    978: {
        img: "red_tape_recorder",
        eng: "The Red-Tape Recorder",
        rus: "\u041E\u0442\u043A\u0430\u0442\u043E\u0444\u043E\u043D",
        pol: "Magnetofon urz\u0119dasa",
        sch: "\u5B98\u50DA\u5F0F\u5F55\u97F3\u673A",
        fre: "L'enregistreur de formalit\xe9s",
        bra: "O Rebobinador",
        schema: 810,
        hun: "A V\xf6r\xf6s Propaganda",
        swe: "Avvecklaren"
    },
    979: {
        img: "shahanshah",
        eng: "The Shahanshah",
        rus: "\u0428\u0430\u0445\u0430\u043D\u0448\u0430\u0445",
        pol: "Szachinszach",
        sch: "\u8BF8\u738B\u4E4B\u738B",
        fre: "Le Shahanshah",
        bra: "A Shahanshah",
        schema: 401,
        hun: "A Sahinsah",
        swe: "Shahanshahen"
    },
    980: {
        img: "cloak_and_dagger",
        eng: "The Cloak and Dagger",
        rus: "\u041F\u043B\u0430\u0449 \u0438 \u043A\u0438\u043D\u0436\u0430\u043B",
        pol: "Peleryna no\u017Cownika",
        sch: "\u9690\u5F62\u523A\u5BA2",
        fre: "La Cloak and Dagger",
        bra: "O Manto e Adaga",
        schema: 60,
        hun: "Az \xc1llva\xe1lca",
        swe: "Stoppuret"
    },
    981: {
        img: "buff_banner",
        eng: "The Buff Banner",
        rus: "\u0412\u0434\u043E\u0445\u043D\u043E\u0432\u043B\u044F\u044E\u0449\u0435\u0435 \u0437\u043D\u0430\u043C\u044F",
        pol: "Sztandar chwa\u0142y",
        sch: "\u6218\u65D7",
        fre: "Le Drapeau Buff",
        bra: "O Estandarte de Encorajamento",
        schema: 129,
        hun: "A L\xe1z\xedt\xf3 Lobog\xf3",
        swe: "Buffbaneret"
    },
    982: {
        img: "righteous_bison",
        eng: "Righteous Bison",
        rus: "\u0411\u043B\u0430\u0433\u043E\u0447\u0435\u0441\u0442\u0438\u0432\u044B\u0439 \u0431\u0438\u0437\u043E\u043D",
        pol: "Prawy bizon",
        sch: "\u6B63\u4E49\u91CE\u725B",
        fre: "Le Bison Vertueux",
        bra: "O Bis\xe3o Justiceiro",
        schema: 442,
        schema2: 5804,
        hun: "Az Igaz B\xf6l\xe9ny",
        swe: "R\xe4ttskaffens bisonoxe"
    },
    983: {
        img: "turbine_torcher",
        eng: "Turbine Torcher | Flame Thrower",
        rus: "Turbine Torcher | \u041E\u0433\u043D\u0435\u043C\u0451\u0442",
        pol: "Palnik turbinowy | Miotacz ognia",
        sch: "\u6DA1\u8F6E\u55B7\u706F \u706B\u7130\u55B7\u5C04\u5668",
        bra: "Tocha Turbinada Lan\xe7a-chamas",
        fre: "Lance-flammes Torcheur \xe0 turbine",
        schema: 15054,
        schema2: 54,
        hun: "Turbine Torcher l\xe1ngsz\xf3r\xf3"
    },
    984: {
        img: "low_profile",
        eng: "Low Profile | SMG",
        rus: "Low Profile | \u041F\u0438\u0441\u0442\u043E\u043B\u0435\u0442-\u043F\u0443\u043B\u0435\u043C\u0451\u0442",
        pol: "Czysta dyskrecja | PM",
        sch: "\u4E0D\u9732\u572D\u89D2 SMG",
        bra: "Disparador Discreto Submetralhadora",
        fre: "Mitraillette Profil bas",
        schema: 15058,
        schema2: 58,
        hun: "Low Profile g\xe9ppisztoly"
    },
    985: {
        img: "aqua_marine",
        eng: "Aqua Marine | Rocket Launcher",
        rus: "Aqua Marine | \u0420\u0430\u043A\u0435\u0442\u043E\u043C\u0451\u0442",
        pol: "Akwamarynarz | Wyrzutnia rakiet",
        sch: "\u6D77\u519B\u9646\u6218\u961F \u706B\u7BAD\u53D1\u5C04\u5668",
        bra: "Matador Marinho Lan\xe7a-foguetes",
        fre: "Lance-Roquettes Aigue-marine",
        schema: 15057,
        schema2: 57,
        hun: "Aqua Marine rak\xe9tavet\u0151"
    },
    986: {
        img: "brick_house",
        eng: "Brick House | Minigun",
        rus: "Brick House | \u041F\u0443\u043B\u0435\u043C\u0451\u0442",
        pol: "Domek z cegie\u0142 | Minigun",
        sch: "\u7816\u5899 \u8F6C\u8F6E\u673A\u67AA",
        bra: "Casa Muito Metralhada Metralhadora Girat\xf3ria",
        fre: "Minigun Maison en brique",
        schema: 15055,
        schema2: 55,
        hun: "Brick House g\xe9p\xe1gy\xfa"
    },
    987: {
        img: "lightning_rod",
        eng: "Lightning Rod | Shotgun",
        rus: "Lightning Rod | \u0414\u0440\u043E\u0431\u043E\u0432\u0438\u043A",
        pol: "Piorunochron | Strzelba",
        sch: "\u5F15\u96F7\u9488 \u9730\u5F39\u67AA",
        bra: "Para-raios Escopeta",
        fre: "Fusil \xe0 pompe Paratonnerre",
        schema: 15047,
        schema2: 47,
        hun: "Lightning Rod s\xf6r\xe9tes puska"
    },
    988: {
        img: "sandstone_special",
        eng: "Sandstone Special | Pistol",
        rus: "Sandstone Special | \u041F\u0438\u0441\u0442\u043E\u043B\u0435\u0442",
        pol: "Piaskowcowy specja\u0142 | Pistolet",
        sch: "\u7802\u5CA9\u7279\u5236 \u624B\u67AA",
        bra: "Arsenal de Arenito Pistola",
        fre: "Pistolet Sp\xe9ciale gr\xe8s",
        schema: 15056,
        schema2: 56,
        hun: "Sandstone Special pisztoly"
    },
    989: {
        img: "black_dahlia",
        eng: "Black Dahlia | Pistol",
        rus: "Black Dahlia | \u041F\u0438\u0441\u0442\u043E\u043B\u0435\u0442",
        pol: "Czarna dalia | Pistolet",
        sch: "\u9ED1\u8272\u5927\u4E3D\u82B1 \u624B\u67AA",
        bra: "D\xe1lia Negra Pistola",
        fre: "Pistolet Dahlia noir",
        schema: 15046,
        schema2: 46,
        hun: "Black Dahlia pisztoly"
    },
    990: {
        img: "dead_reckoner",
        eng: "Dead Reckoner | Revolver",
        rus: "Dead Reckoner | \u0420\u0435\u0432\u043E\u043B\u044C\u0432\u0435\u0440",
        pol: "Trupi zwiad | Rewolwer",
        sch: "\u6B7B\u4EA1\u5224\u5B98 \u5DE6\u8F6E\u624B\u67AA",
        bra: "Cad\xe1ver Calculista Rev\xf3lver",
        fre: "Revolver Cible de la mort",
        schema: 15051,
        schema2: 51,
        hun: "Dead Reckoner revolver"
    },
    991: {
        img: "spark_of_life",
        eng: "Spark of Life | Medi Gun",
        rus: "Spark of Life | \u041B\u0435\u0447\u0435\u0431\u043D\u0430\u044F \u043F\u0443\u0448\u043A\u0430",
        pol: "Iskra \u017Cycia | Medigun",
        sch: "\u751F\u547D\u4E4B\u5149 \u533B\u7597\u67AA",
        bra: "Sinal de Vida Arma M\xe9dica",
        fre: "Medigun \xc9tincelle de vie",
        schema: 15050,
        schema2: 50,
        hun: "Spark of Life gy\xf3gypuska"
    },
    992: {
        img: "flash_fryer",
        eng: "Flash Fryer | Flame Thrower",
        rus: "Flash Fryer | \u041E\u0433\u043D\u0435\u043C\u0451\u0442",
        pol: "Szybki spalacz | Miotacz ognia",
        sch: "\u95EA\u7535\u70E7\u70E4 \u706B\u7130\u55B7\u5C04\u5668",
        bra: "Flama Fulminante Lan\xe7a-chamas",
        fre: "Lance-flammes Friteuse \xe9clair",
        schema: 15049,
        schema2: 49,
        hun: "Flash Fryer l\xe1ngsz\xf3r\xf3"
    },
    993: {
        img: "pink_elephant",
        eng: "Pink Elephant | Stickybomb Launcher",
        rus: "Pink Elephant | \u041B\u0438\u043F\u0443\u0447\u043A\u043E\u043C\u0451\u0442",
        pol: "R\xf3\u017Cowy s\u0142o\u0144 | Wyrzutnia bomb samoprzylepnych",
        sch: "\u7C89\u7EA2\u8C61 \u9ECF\u6027\u70B8\u5F39\u53D1\u5C04\u5668",
        bra: "Elefante Rosa Lan\xe7a-stickybombs",
        fre: "Lanceur de Bombes collantes \xc9l\xe9phant rose",
        schema: 15048,
        schema2: 48,
        hun: "Pink Elephant tapad\xf3bomba-vet\u0151"
    },
    994: {
        img: "current_event",
        eng: "Current Event | Scattergun",
        rus: "Current Event | \u041E\u0431\u0440\u0435\u0437",
        pol: "Aktualne wydarzenie | Dubelt\xf3wka",
        sch: "\u7D2B\u7535 \u730E\u67AA",
        bra: "Acontecimento Chocante Espingarda",
        fre: "Fusil \xe0 dispersion \xc9v\xe9nement actuel",
        schema: 15053,
        schema2: 53,
        hun: "Current Event repeszpuska"
    },
    995: {
        img: "shell_shocker",
        eng: "Shell Shocker | Rocket Launcher",
        rus: "Shell Shocker | \u0420\u0430\u043A\u0435\u0442\u043E\u043C\u0451\u0442",
        pol: "Traumatyczne wspomnienie | Wyrzutnia rakiet",
        sch: "\u9707\u8361\u5F39 \u706B\u7BAD\u53D1\u5C04\u5668",
        bra: "Ligad\xe3o Lan\xe7a-foguetes",
        fre: "Lance-Roquettes Horrible obus",
        schema: 15052,
        schema2: 52,
        hun: "Shell Shocker rak\xe9tavet\u0151"
    },
    996: {
        img: "liquid_asset",
        eng: "Liquid Asset | Stickybomb Launcher",
        rus: "Liquid Asset | \u041B\u0438\u043F\u0443\u0447\u043A\u043E\u043C\u0451\u0442",
        pol: "P\u0142ynny kapita\u0142 | Wyrzutnia bomb samoprzylepnych",
        sch: "\u6DB2\u6001\u70B8\u836F \u9ECF\u6027\u70B8\u5F39\u53D1\u5C04\u5668",
        bra: "Lucro L\xedquido Lan\xe7a-stickybombs",
        fre: "Lanceur de Bombes collantes Liquidateurs d'actifs",
        schema: 15045,
        schema2: 45,
        hun: "Liquid Asset tapad\xf3bomba-vet\u0151"
    },
    997: {
        img: "thunderbolt",
        eng: "Thunderbolt | Sniper Rifle",
        rus: "Thunderbolt | \u0421\u043D\u0430\u0439\u043F\u0435\u0440\u0441\u043A\u0430\u044F \u0432\u0438\u043D\u0442\u043E\u0432\u043A\u0430",
        pol: "Piorun | Karabin snajperski",
        sch: "\u96F7\u9706\u6253\u51FB \u72D9\u51FB\u6B65\u67AA",
        bra: "Rel\xe2mpago Rifle de Sniper",
        fre: "Fusil de sniper Coup de foudre",
        schema: 15059,
        schema2: 59,
        hun: "Thunderbolt mesterl\xf6v\xe9sz puska"
    },
    998: {
        img: "commissars_coat",
        eng: "Commissar's Coat",
        rus: "\u041A\u043E\u043C\u0438\u0441\u0441\u0430\u0440\u0441\u043A\u0438\u0439 \u043A\u0438\u0442\u0435\u043B\u044C",
        pol: "P\u0142aszcz komisarza",
        sch: "\u4EBA\u6C11\u59D4\u5458\u5927\u8863",
        fre: "Manteau du commissaire",
        bra: "Casaco do Comiss\xe1rio",
        schema: 30633,
        hun: "A Komissz\xe1r Kab\xe1tja",
        swe: "Kommissariens kappa"
    },
    999: {
        img: "flak_jack",
        eng: "Flak Jack",
        rus: "\u0410\u0440\u0442\u0438\u043B\u043B\u0435\u0440\u0438\u0439\u0441\u043A\u0438\u0439 \u0436\u0438\u043B\u0435\u0442",
        pol: "Dezaprobata policjanta",
        sch: "\u9632\u5F39\u80CC\u5FC3",
        fre: "Flak Jack",
        bra: "Colete do Corredor",
        schema: 30637,
        hun: "Mun\xedci\xf3s Mell\xe9ny",
        ger: "Flak-Jacke"
    },
    1000: {
        img: "lurkers_leathers",
        eng: "Lurker's Leathers",
        rus: "\u041F\u0430\u043B\u044C\u0442\u043E \u043F\u0440\u043E\u043D\u044B\u0440\u044B",
        pol: "Odzienie opryszka",
        sch: "\u6F5C\u884C\u8005\u7684\u76AE\u8863\u88E4",
        fre: "Le cuir du limier",
        bra: "A Jaqueta Secreta",
        schema: 30631,
        hun: "A Bujk\xe1l\xf3 B\u0151rkab\xe1tja",
        swe: "Smygarens skinndr\xe4kt"
    },
    1001: {
        img: "rotation_sensation",
        eng: "Rotation Sensation",
        rus: "\u041F\u043E\u0442\u0440\u044F\u0441\u0430\u044E\u0449\u0438\u0439 \u043F\u0435\u0440\u0435\u0432\u0435\u0440\u0442\u044B\u0448",
        pol: "Odwr\xf3cona furora",
        sch: "\u65CB\u8F6C\u611F\u5E94\u5E3D",
        fre: "La rotation sensass",
        bra: "A Sensa\xe7\xe3o da Rota\xe7\xe3o",
        schema: 30623,
        hun: "A Laza L\xe9t\xe9rz\xe9s",
        swe: "Roterande sensationen"
    },
    1002: {
        img: "support_spurs",
        eng: "Support Spurs",
        rus: "\u0428\u043F\u043E\u0440\u044B \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430",
        pol: "Ostrogi oparcia",
        sch: "\u9A6C\u523A\u9774",
        fre: "Supporte-\xe9perons",
        bra: "Esporas de Suporte",
        schema: 30629,
        hun: "Seg\xedt\u0151 Sarkanty\xfak",
        swe: "St\xf6dsporrar"
    },
    1003: {
        img: "vascular_vestment",
        eng: "Vascular Vestment",
        rus: "\u041A\u0440\u043E\u0432\u0435\u043D\u043E\u0441\u043D\u044B\u0439 \u043A\u043E\u0441\u0442\u044E\u043C",
        pol: "Naczyniowy napier\u015Bnik",
        sch: "\u533B\u751F\u7684\u7ECF\u5178\u80F8\u7532",
        fre: "Le gilet vasculaire",
        bra: "A Vestimenta Vascular",
        schema: 30626,
        hun: "A Szakorvosi Szerel\xe9s",
        swe: "Vaskul\xe4ra v\xe4sten"
    },
    1004: {
        img: "wild_west_waistcoat",
        eng: "Wild West Waistcoat",
        rus: "\u0416\u0438\u043B\u0435\u0442 \u0448\u0435\u0440\u0438\u0444\u0430",
        pol: "Kamizelka z Dzikiego Zachodu",
        sch: "\u897F\u90E8\u72C2\u91CE\u9A6C\u7532",
        fre: "Manteau du sh\xe9rif de l'ouest",
        bra: "O Colete do Caub\xf3i",
        schema: 30635,
        hun: "Vadnyugati Viselet",
        swe: "Vilda v\xe4stern-v\xe4st"
    },
    1005: {
        img: "fortunate_son",
        eng: "Fortunate Son",
        rus: "\u041B\u044E\u0431\u0438\u043C\u0447\u0438\u043A \u0444\u043E\u0440\u0442\u0443\u043D\u044B",
        pol: "Szcz\u0119\u015Bciarz",
        sch: "\u8D70\u8FD0\u7684\u65B0\u5175",
        fre: "Fils chanceux",
        bra: "Filho Afortunado",
        schema: 30636
    },
    1006: {
        img: "outta_sight",
        eng: "Outta Sight",
        rus: "\u0421\u043B\u0435\u043F\u0430\u044F \u0437\u043E\u043D\u0430",
        pol: "\u015Alepak",
        sch: "\u773C\u4E0D\u89C1\u5FC3\u4E0D\u70E6",
        fre: "Hyper loin",
        bra: "Visual Vistoso",
        schema: 30628,
        hun: "Tutker\xe1j",
        swe: "Hi-toppen"
    },
    1007: {
        img: "physicians_protector",
        eng: "Physician's Protector",
        rus: "\u0417\u0430\u0449\u0438\u0442\u043D\u044B\u0439 \u0448\u043B\u0435\u043C \u0446\u0435\u043B\u0438\u0442\u0435\u043B\u044F",
        pol: "Ochraniacz medyczny",
        sch: "\u5185\u79D1\u533B\u751F\u7684\u94A2\u76D4",
        fre: "La protection du physicien",
        bra: "O Protetor do Doutor",
        schema: 30625,
        hun: "A Felcser Fejv\xe9d\u0151je",
        swe: "Doktorns protektor"
    },
    1008: {
        img: "white_russian",
        eng: "White Russian",
        rus: "\u0411\u0435\u043B\u044B\u0439 \u0440\u0443\u0441\u0441\u043A\u0438\u0439",
        pol: "Bia\u0142y Rosjanin",
        sch: "\u767D\u8272\u4FC4\u7F57\u65AF",
        fre: "Le Caucasien",
        bra: "Russo Branco",
        schema: 30644
    },
    1009: {
        img: "bruces_bonnet",
        eng: "Bruce's Bonnet",
        rus: "\u0411\u0440\u044E\u0441\u043E\u0432\u0430 \u043A\u043E\u043B\u044C\u0447\u0443\u0433\u0430",
        pol: "Rycersko\u015B\u0107 Roberta",
        sch: "\u82CF\u683C\u5170\u738B\u5E03\u9C81\u65AF\u4E4B\u76D4",
        fre: "Cagoule de maille",
        bra: "Malha do Monarca",
        schema: 30627,
        hun: "Fens\xe9ges Fejfed\u0151",
        swe: "Bruces Bonnet"
    },
    1010: {
        img: "el_duderino",
        eng: "El Duderino",
        rus: "\u042D\u043B\u044C \u0427\u0443\u0432\u0430\u0447\u0438\u043D\u043E",
        pol: "El kolesino",
        sch: "\u5927\u4F6C\u52D2\u5E03\u65AF\u57FA",
        fre: "Le Duc",
        bra: "El Duderino",
        schema: 30645,
        hun: "A T\xf6k\xf6s Tek\xe9s"
    },
    1011: {
        img: "sheriffs_stetson",
        eng: "Sheriff's Stetson",
        rus: "\u0428\u043B\u044F\u043F\u0430 \u0448\u0435\u0440\u0438\u0444\u0430",
        pol: "Stetson szeryfa",
        sch: "\u8B66\u957F\u7684\u5BBD\u6A90\u5E3D",
        fre: "Chapeau de sh\xe9rif",
        bra: "Chap\xe9u do Xerife",
        schema: 30634,
        hun: "A Seriffkalap",
        swe: "Sheriffens Stetson"
    },
    1012: {
        img: "captain_cardbeard_cutthroat",
        eng: "Captain Cardbeard Cutthroat",
        rus: "\u041A\u0430\u043F\u0438\u0442\u0430\u043D \u041A\u0430\u0440\u0442\u043E\u043D\u043D\u0430\u044F \u0431\u043E\u0440\u043E\u0434\u0430",
        pol: "Kapitan Okrutny Kartonobrody",
        sch: "\u7EB8\u677F\u6D77\u76D7\u5E3D",
        fre: "Capitaine Barbenkarton",
        bra: "Pirata de Barbel\xe3o",
        schema: 30640,
        hun: "Kaszabol\xf3 Kartonszak\xe1ll Kapit\xe1ny",
        swe: "Kapten Kartongsk\xe4gg Knivhals"
    },
    1013: {
        img: "potassium_bonnett",
        eng: "Potassium Bonnet",
        rus: "\u041A\u0430\u043B\u0438\u0435\u0432\u044B\u0439 \u043A\u0430\u043F\u044E\u0448\u043E\u043D",
        pol: "Czapeczka potasowa",
        sch: "\u83B7\u5143\u94BE",
        fre: "Cagoule au potassium",
        bra: "A Banana do Banana",
        schema: 30643,
        hun: "K\xe1lium Kalap",
        swe: "Kaliumbonnett"
    },
    1014: {
        img: "universal_translator",
        eng: "Universal Translator",
        rus: "\u0423\u043D\u0438\u0432\u0435\u0440\u0441\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u0435\u0440\u0435\u0432\u043E\u0434\u0447\u0438\u043A",
        pol: "Uniwersalny t\u0142umacz",
        sch: "\u661F\u9645\u7FFB\u8BD1\u5B98",
        fre: "Traducteur universel",
        bra: "Tradutor Universal",
        schema: 30658,
        hun: "Univerz\xe1lis Ford\xedt\xf3",
        swe: "Universell \xf6vers\xe4ttare"
    },
    1015: {
        img: "phobos_filter",
        eng: "Phobos Filter",
        rus: "\u0424\u0438\u043B\u044C\u0442\u0440 \u0434\u043B\u044F \u0424\u043E\u0431\u043E\u0441\u0430",
        pol: "Filtr z Fobosa",
        sch: "\u706B\u536B\u4E00\u8FC7\u6EE4\u9762\u7F69",
        fre: "Filtre de Phobos",
        bra: "Filtro de Fobus",
        schema: 30652,
        hun: "Phobosz-l\xe9gsz\u0171r\u0151",
        swe: "Phobos-filter"
    },
    1016: {
        img: "final_frontiersman",
        eng: "Final Frontiersman",
        rus: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 \u043F\u0435\u0440\u0435\u0441\u0435\u043B\u0435\u043D\u0435\u0446",
        pol: "Ostatni pogranicznik",
        sch: "\u6700\u540E\u7684\u62D3\u8352\u8005",
        fre: "L'habitant de la fronti\xe8re finale",
        bra: "O Homem da \xdaltima Fronteira",
        schema: 30649,
        hun: "A Legv\xe9gs\u0151 Hat\xe1rvid\xe9ki",
        ger: "Letzter Grenzg\xe4nger"
    },
    1017: {
        img: "life_support_system",
        eng: "Life Support System",
        rus: "\u0421\u0438\u0441\u0442\u0435\u043C\u0430 \u0436\u0438\u0437\u043D\u0435\u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F",
        pol: "System podtrzymywania \u017Cycia",
        sch: "\u751F\u547D\u652F\u6301\u7CFB\u7EDF",
        fre: "Syst\xe8me de support vital",
        bra: "Sistema de Suporte Vital",
        schema: 30654,
        hun: "L\xe9tfenntart\xf3 Rendszer",
        swe: "Livsuppeh\xe5llande apparat"
    },
    1018: {
        img: "rocket_operator",
        eng: "Rocket Operator",
        rus: "\u041D\u0430\u0432\u043E\u0434\u0447\u0438\u043A \u0440\u0430\u043A\u0435\u0442",
        pol: "Operator rakiety",
        sch: "\u706B\u7BAD\u64CD\u4F5C\u5458",
        fre: "Op\xe9rateur de roquettes",
        bra: "Operador de Foguetes",
        schema: 30655,
        hun: "Rak\xe9tatechnikus",
        swe: "Raketmekanikern"
    },
    1019: {
        img: "captain_space_mann",
        eng: "Captain Space Mann",
        rus: "\u041A\u0430\u043F\u0438\u0442\u0430\u043D \u041A\u043E\u0441\u043C\u0430\u043D\u043D\u0430\u0432\u0442",
        pol: "Kapitan kosmannauta",
        sch: "\u592A\u7A7A\u961F\u957F\u66FC\u6069",
        fre: "Capitaine Space Mann",
        bra: "Capit\xe3o Cosmannauta",
        schema: 30646,
        hun: "\u0170rmannus kapit\xe1ny",
        swe: "Kapten Rymdmann"
    },
    1020: {
        img: "shooting_star",
        eng: "Shooting Star",
        rus: "\u041F\u0430\u0434\u0430\u044E\u0449\u0430\u044F \u0437\u0432\u0435\u0437\u0434\u0430",
        pol: "Strzelaj\u0105ca gwiazda",
        sch: "\u6D41\u661F\u72D9\u51FB\u8005",
        fre: "\xc9toile filante",
        bra: "Estrela Cadente",
        schema: 30665,
        hun: "Hullacsillag",
        swe: "Stj\xe4rnskott"
    },
    1021: {
        img: "giger_counter",
        eng: "Giger Counter",
        rus: "\u0421\u0447\u0451\u0442\u0447\u0438\u043A \u0413\u0438\u0433\u0435\u0440\u0430",
        pol: "Licznik Gigera",
        sch: "\u5F02\u5F62\u8BA1\u6570\u5668",
        fre: "Le compteur geiger",
        bra: "O Contador Giger",
        schema: 30668,
        hun: "A Giger-sz\xe1ml\xe1l\xf3",
        swe: "Giger-r\xe4knaren"
    },
    1022: {
        img: "starduster",
        eng: "Starduster",
        rus: "\u0417\u0432\u0435\u0437\u0434\u043D\u044B\u0439 \u043F\u044B\u043B\u044C\u043D\u0438\u043A",
        pol: "Gwiezdny \u0142ach",
        sch: "\u661F\u5C18\u62AB\u98CE",
        fre: "N\xe9buleuse",
        bra: "Espanador das Estrelas",
        schema: 30650,
        hun: "Csillagporos",
        ger: "Sternwanderer"
    },
    1023: {
        img: "corona_australis",
        eng: "Corona Australis",
        rus: "\u042E\u0436\u043D\u0430\u044F \u043A\u043E\u0440\u043E\u043D\u0430",
        pol: "Korona po\u0142udniowa",
        sch: "\u6FB3\u5195",
        fre: "Couronne australe",
        bra: "Corona Australis",
        schema: 30648
    },
    1024: {
        img: "sucker_slug",
        eng: "Sucker Slug",
        rus: "\u0421\u043B\u0438\u0437\u043D\u044F\u043A-\u0441\u043E\u0441\u0443\u043D\u043E\u043A",
        pol: "Ss\u0105cy glut",
        sch: "\u5438\u8111\u9F3B\u6D95\u866B",
        fre: "Limace suceuse",
        bra: "Sanguessuga Sideral",
        schema: 30653,
        hun: "Fejsz\xedv\xf3 F\xe9reg",
        swe: "Stolle-snigeln"
    },
    1025: {
        img: "graylien",
        eng: "The Graylien",
        rus: "\u0421\u0435\u0440\u043E\u043F\u043B\u0430\u043D\u0435\u0442\u044F\u043D\u0438\u043D",
        pol: "Szarmita",
        sch: "\u5C0F\u7070\u4EBA",
        fre: "Le Petit-Gris",
        bra: "O Alien\xedgena Apunhalador",
        schema: 30651,
        hun: "A Z\u0171rl\xe9ny",
        swe: "Gr\xe5lien"
    },
    1026: {
        img: "cadet_visor",
        eng: "Cadet Visor",
        rus: "\u041A\u0430\u0434\u0435\u0442\u0441\u043A\u0438\u0435 \u043D\u0430\u0433\u043B\u0430\u0437\u043D\u0438\u043A\u0438",
        pol: "Wizjer kadeta",
        sch: "\u5B66\u9662\u62A4\u76EE\u955C",
        fre: "Visi\xe8re du cadet",
        bra: "Visor do Cadete",
        schema: 30661,
        hun: "A Kad\xe9t Szemellenz\u0151je",
        swe: "Kadettvisir"
    },
    1027: {
        img: "space_diver",
        eng: "The Space Diver",
        rus: "\u041A\u043E\u0441\u043C\u043E\u043F\u043B\u0430\u0432\u0430\u0442\u0435\u043B\u044C",
        pol: "Kosmonurek",
        sch: "\u592A\u7A7A\u8DF3\u4F1E\u5458",
        fre: "Plong\xe9e spatiale",
        bra: "O Mergulhador Espacial",
        schema: 30664,
        hun: "Az \u0170rbuv\xe1r",
        swe: "Rymddykaren"
    },
    1028: {
        img: "a_head_full_of_hot_air",
        eng: "A Head Full of Hot Air",
        rus: "\u0413\u043E\u0440\u044F\u0447\u0430\u044F \u0441\u043E\u0440\u0432\u0438\u0433\u043E\u043B\u043E\u0432\u0430",
        pol: "G\u0142owa pe\u0142na gor\u0105cego powietrza",
        sch: "\u70ED\u6C14\u5934\u76D4",
        fre: "Une t\xeate pleine d'air chaud",
        bra: "Cabe\xe7a de Ar Quente",
        schema: 30662,
        hun: "Forr\xf3fej\u0171",
        swe: "Ett huvud fyllt med varm luft"
    },
    1029: {
        img: "capper",
        eng: "The C.A.P.P.E.R",
        rus: "\u0417.\u0410.\u0425.\u0412.\u0410.\u0422.\u0427.\u0418.\u041A.",
        pol: "C.A.P.P.E.R",
        sch: "\u9AD8\u80FD\u7535\u78C1\u8109\u51B2\u7C92\u5B50\u67AA",
        fre: "Le C.A.P.P.E.R",
        bra: "O C.A.U.B.O.I.",
        schema: 30666,
        hun: "A F.\xc9.Z.E.R.",
        ger: "Die C.A.P.P.E.R",
        swe: "C.A.P.P.E.R"
    },
    1030: {
        img: "phononaut",
        eng: "Phononaut",
        rus: "\u0423\u0445\u043E\u043D\u0430\u0432\u0442",
        pol: "Telenauta",
        sch: "\u592A\u7A7A\u5934\u76D4",
        fre: "Casque astronomique",
        bra: "Fononauta",
        schema: 30647,
        hun: "Hangonauta"
    },
    1031: {
        img: "jupiter_jetpack",
        eng: "Jupiter Jetpack",
        rus: "\u042E\u043F\u0438\u0442\u0435\u0440\u0441\u043A\u0438\u0439 \u0440\u0430\u043A\u0435\u0442\u043D\u044B\u0439 \u0440\u0430\u043D\u0435\u0446",
        pol: "Pluto\u0144ski plecak",
        sch: "\u6728\u661F\u98DE\u884C\u80CC\u5305",
        fre: "Jetpack jupit\xe9rien",
        bra: "Mochila a Jato de J\xfapiter",
        schema: 30663,
        hun: "Jupiteri R\xf6pt\xe1ska",
        ger: "Jupiter-Jetpack"
    },
    1032: {
        img: "space_hamster_hammy",
        eng: "Space Hamster Hammy",
        rus: "\u041A\u043E\u0441\u043C\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0445\u043E\u043C\u044F\u0447\u043E\u043A",
        pol: "Hammy - kosmiczny chomik",
        sch: "\u592A\u7A7A\u4ED3\u9F20\u54C8\u7C73",
        fre: "Hamster de l'espace au go\xfbt de jambon",
        bra: "Hammy, o Hamster Espacial",
        schema: 30669,
        hun: "Hammy, az \u0170rh\xf6rcs\xf6g",
        swe: "Rymdhamstern Hammy"
    },
    1033: {
        img: "burstchester",
        eng: "Taunt: Burstchester",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0413\u0440\u0443\u0434\u043E\u043B\u043E\u043C",
        schema: 30621,
        pol: "Drwina: Burstchester",
        sch: "\u5632\u8BBD\uFF1A\u88C2\u80F8\u8005",
        fre: "Raillerie : Ami de c\u0153ur",
        bra: "Provoca\xe7\xe3o: Amigo do Peito",
        hun: "Besz\xf3l\xe1s: Kikeleszt\u0151",
        swe: "H\xe5n: Burstchester"
    },
    1034: {
        img: "batsaber",
        eng: "Batsaber",
        rus: "\u0421\u0432\u0435\u0442\u043E\u0432\u0430\u044F \u0431\u0438\u0442\u0430",
        pol: "Kij \u015Bwietlny",
        sch: "\u5149\u5251\u7403\u68D2",
        fre: "Batsabre",
        bra: "Taco de Luz",
        schema: 30667,
        hun: "F\xe9ny\xfct\u0151",
        swe: "Ljus-slagtr\xe4"
    },
    1035: {
        img: "face_of_mercy",
        eng: "The Face of Mercy",
        rus: "\u041B\u0438\u0446\u043E \u043C\u0438\u043B\u043E\u0441\u0435\u0440\u0434\u0438\u044F",
        pol: "Twarz przebaczenia",
        sch: "\u4EC1\u6148\u8005\u7684\u9762\u5177",
        fre: "Visage de la mis\xe9ricorde",
        bra: "A Face da Miseric\xf3rdia",
        schema: 30676,
        hun: "Az Irgalom Arca",
        swe: "N\xe5dens ansikte"
    },
    1036: {
        img: "el_patron",
        eng: "El Patron",
        rus: "\u0417\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u043A",
        pol: "El patron",
        sch: "\u5927\u8001\u677F",
        fre: "El Patron",
        bra: "El Patr\xf3n",
        schema: 30681
    },
    1037: {
        img: "smokey_sombrero",
        eng: "Smokey Sombrero",
        rus: "\u0421\u043E\u043C\u0431\u0440\u0435\u0440\u043E \u0441 \u0434\u044B\u043C\u043A\u043E\u043C",
        pol: "Czadowe sombrero",
        sch: "\u70DF\u718F\u58A8\u897F\u54E5\u5E3D",
        fre: "Sombrero fum\xe9",
        bra: "Chap\xe9u de Charuto",
        schema: 30682,
        hun: "F\xfcst\xf6s Sombrero",
        swe: "Stilig sombrero"
    },
    1038: {
        img: "thrilling_tracksuit",
        eng: "Thrilling Tracksuit",
        rus: "\u0411\u0435\u0441\u0441\u0442\u0440\u0430\u0448\u043D\u044B\u0439 \u0431\u0435\u0433\u0443\u043D",
        pol: "Dreszczowiec",
        sch: "\u8D5B\u8F66\u624B\u5916\u5957",
        fre: "Surv\xeatement ph\xe9nom\xe9nal",
        bra: "Agasalho Assustador",
        schema: 30685,
        hun: "V\xe9rfagyaszt\xf3 Versenyruha",
        swe: "Racerf\xf6rarens overall"
    },
    1039: {
        img: "baaarrgh_n_britches",
        eng: "B'aaarrgh-n-Britches",
        rus: "\u041F\u0430\u043D\u0442\u0430\u043B\u043E\u043D\u044B \u043F\u0438\u0440-\u0440-\u0440\u0430\u0442\u0430",
        pol: "D-aaarrrmowe bryczesy",
        sch: "\u5EC9\u4EF7\u6D77\u76D7\u88E4",
        fre: "Haaauts-de-chaaausses",
        bra: "Cal\xe7as da Pechincha Pirata",
        schema: 30719,
        hun: "Koszlott Kal\xf3znadr\xe1g",
        swe: "Piratbyxor"
    },
    1040: {
        img: "prehistoric_pullover",
        eng: "Prehistoric Pullover",
        rus: "\u0414\u043E\u0438\u0441\u0442\u043E\u0440\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0434\u0438\u043D\u043E\u0437\u0430\u0432\u0440",
        pol: "Prehistoryczny pulower",
        sch: "\u53F2\u524D\u722C\u884C\u52A8\u7269\u515C\u5E3D",
        fre: "Pullover Pr\xe9historique",
        bra: "Capuz Pr\xe9-Hist\xf3rico",
        schema: 30704,
        hun: "\u0150skori Pul\xf3ver",
        swe: "Dinohuva"
    },
    1041: {
        img: "roboot",
        eng: "Roboot",
        rus: "\u0420\u043E\u0431\u043E\u0442\u0438\u043D\u043E\u043A",
        pol: "Robut",
        sch: "\u67AA\u70AE\u5DE5\u4E4B\u8DB3",
        fre: "Robotte",
        bra: "Robota",
        schema: 30675,
        hun: "Ro-botl\xe1b\xfa",
        swe: "Robuut"
    },
    1042: {
        img: "duck_billed_hatypus",
        eng: "Duck Billed Hatypus",
        rus: "\u0423\u0442\u043A\u043E\u043D\u043E\u0441",
        pol: "Kacza czapa",
        sch: "\u771F.\u9E2D\u820C\u5E3D",
        fre: "Coincoinsquette",
        bra: "Bon\xe9-torrinco",
        schema: 30700,
        hun: "Kacsacs\u0151r\u0171 Sapka",
        swe: "N\xe4bbkeps"
    },
    1043: {
        img: "iron_lung",
        eng: "Iron Lung",
        rus: "\u0416\u0435\u043B\u0435\u0437\u043D\u043E\u0435 \u043B\u0435\u0433\u043A\u043E\u0435",
        pol: "\u017Belazne p\u0142uco",
        sch: "\u94C1\u80BA",
        fre: "Poumon d'acier",
        bra: "Pulm\xe3o de Ferro",
        schema: 30698,
        hun: "Vast\xfcd\u0151",
        swe: "J\xe4rnlunga"
    },
    1044: {
        img: "neptunes_nightmare",
        eng: "Neptune's Nightmare",
        rus: "\u041D\u043E\u0447\u043D\u043E\u0439 \u043A\u043E\u0448\u043C\u0430\u0440 \u041D\u0435\u043F\u0442\u0443\u043D\u0430",
        pol: "Koszmar Neptuna",
        sch: "\u6D77\u738B\u4E4B\u9B47",
        fre: "Cauchemar de Neptune",
        bra: "Pesadelo de Netuno",
        schema: 30684,
        hun: "Neptunusz R\xe9m\xe1lma",
        swe: "Neptunus mardr\xf6m"
    },
    1045: {
        img: "el_caballero",
        eng: "El Caballero",
        rus: "\u042D\u043B\u044C \u043A\u0430\u0431\u0430\u043B\u044C\u0435\u0440\u043E",
        pol: "El caballero",
        sch: "\u897F\u73ED\u7259\u7EC5\u58EB",
        fre: "El Caballero",
        bra: "El Caballero",
        schema: 30680
    },
    1046: {
        img: "baaarrgh_n_bicorne",
        eng: "B'aaarrgh-n-Bicorne",
        rus: "\u0414\u0432\u0443\u0443\u0433\u043E\u043B\u043A\u0430 \u043F\u0438\u0440-\u0440-\u0440\u0430\u0442\u0430",
        pol: "D-aaarrrmowy bikorn",
        sch: "\u5EC9\u4EF7\u6D77\u76D7\u5E3D",
        fre: "Bicorrrne",
        bra: "Bic\xf3rnio da Pechincha Pirata",
        schema: 30718,
        hun: "Koszlott Kal\xf3zkalap",
        swe: "Pirathatt"
    },
    1047: {
        img: "death_racers_helmet",
        eng: "Death Racer's Helmet",
        rus: "\u0428\u043B\u0435\u043C \u0433\u043E\u043D\u0449\u0438\u043A\u0430 \u0441\u043E \u0441\u043C\u0435\u0440\u0442\u044C\u044E",
        pol: "He\u0142m death racera",
        sch: "\u7EDD\u547D\u8D5B\u8F66\u624B",
        fre: "Casque du pilote de la mort",
        bra: "Capacete do Corredor da Morte",
        schema: 30686,
        hun: "Hal\xe1lfutam-sisak",
        swe: "Racerf\xf6rarens hj\xe4lm"
    },
    1048: {
        img: "grim_tweeter",
        eng: "Grim Tweeter",
        rus: "\u041F\u0442\u0438\u0447\u0438\u0439 \u0436\u043D\u0435\u0446",
        pol: "Ponury \u0107wierkacz",
        sch: "\u62A5\u4EA1\u4E4B\u96C0",
        fre: "Le titi faucheur",
        bra: "Ceifador Depenado",
        schema: 30693,
        hun: "A Kis Kasz\xe1s",
        swe: "Lief\xe5geln"
    },
    1049: {
        img: "crusaders_getup",
        eng: "Crusader's Getup",
        rus: "\u041E\u0434\u0435\u044F\u043D\u0438\u0435 \u043E\u0447\u0438\u0449\u0435\u043D\u0438\u044F",
        pol: "Kubrak krzy\u017Cowca",
        sch: "\u5341\u5B57\u519B\u6218\u670D",
        fre: "Combinaison du d\xe9fenseur",
        bra: "Uniforme do Cruzado",
        schema: 30716,
        hun: "Keresztes Hacuka",
        swe: "Lysmaskens stil"
    },
    1050: {
        img: "deader_alive",
        eng: "Dead'er Alive",
        rus: "\u0416\u0438\u0432\u043E\u0439 \u0438\u043B\u0438 \u043C\u0435\u0440\u0442\u0432\u044B\u0439",
        pol: "\u017Bywy lub martwy",
        sch: "\u8981\u585E\u5A01\u9F99",
        fre: "Engicop",
        bra: "Vivo ou Morto",
        schema: 30707,
        hun: "\xc9lve Holtabb",
        swe: "D\xf6d eller levande"
    },
    1051: {
        img: "arthropods_aspect",
        eng: "Arthropod's Aspect",
        rus: "\u041C\u0430\u0441\u043A\u0430 \u043C\u0443\u0440\u0430\u0432\u044C\u044F",
        pol: "Mr\xf3wcze oblicze",
        sch: "\u7EB5\u706B\u72C2\u8681",
        fre: "Le look arthropode",
        bra: "Aspecto do Artr\xf3pode",
        schema: 30717,
        hun: "Rovarpofa",
        swe: "Lysmaskens anlete"
    },
    1052: {
        img: "catastrophic_companions",
        eng: "Catastrophic Companions",
        rus: "\u041A\u043E\u0442\u043E\u0441\u0442\u0440\u043E\u0444\u0430",
        pol: "Katastroficzni towarzysze",
        sch: "\u5927\u89C4\u6A21\u6740\u4F24\u6027\u5C0F\u4F19\u4F34",
        fre: "Compagnons catastrophiques",
        bra: "Companheiros Gatastr\xf3ficos",
        schema: 30706,
        hun: "Katasztrof\xe1lis K\xeds\xe9r\u0151k",
        swe: "Kattastrofiska kompanjoner"
    },
    1053: {
        img: "hellmet",
        eng: "The Hellmet",
        rus: "\u0427\u0438\u0441\u0442\u0438\u043B\u0438\u0448\u043B\u0435\u043C",
        pol: "Piek\u0142ohe\u0142m",
        sch: "\u5730\u72F1\u9AA8\u76D4",
        fre: "Le Purgacasque",
        bra: "O Capacete Infernal",
        schema: 30708,
        hun: "A Pokolsisak",
        swe: "Helvetshj\xe4lmen"
    },
    1054: {
        img: "flower_power_shotgun",
        eng: "Flower Power | Shotgun",
        rus: "Flower Power | \u0414\u0440\u043E\u0431\u043E\u0432\u0438\u043A",
        pol: "Strzelba | Dzieci kwiaty",
        sch: "\u9C9C\u82B1\u4E4B\u529B\u9730\u5F39\u67AA",
        fre: "Le fusil \xe0 pompe Flower Power",
        bra: "Escopeta | Campo Florido",
        schema: 15109,
        schema2: 72,
        hun: "A Vir\xe1ger\u0151 S\xf6r\xe9tes Puska",
        swe: "Hagelgev\xe4r | Flower Power"
    },
    1055: {
        img: "flower_power_scattergun",
        eng: "Flower Power | Scattergun",
        rus: "Flower Power | \u041E\u0431\u0440\u0435\u0437",
        pol: "Dubelt\xf3wka | Dzieci kwiaty",
        sch: "\u9C9C\u82B1\u4E4B\u529B\u730E\u67AA",
        fre: "Le fusil \xe0 dispersion Flower Power",
        bra: "Espingarda | Campo Florido",
        schema: 15107,
        schema2: 72,
        hun: "A Vir\xe1ger\u0151 Repeszpuska",
        swe: "Hagelb\xf6ssa | Flower Power"
    },
    1056: {
        img: "flower_power_revolver",
        eng: "Flower Power | Revolver",
        rus: "Flower Power | \u0420\u0435\u0432\u043E\u043B\u044C\u0432\u0435\u0440",
        pol: "Rewolwer | Dzieci kwiaty",
        sch: "\u9C9C\u82B1\u4E4B\u529B\u5DE6\u8F6E\u624B\u67AA",
        fre: "Le revolver Flower Power",
        bra: "Rev\xf3lver | Campo Florido",
        schema: 15103,
        schema2: 72,
        hun: "A Vir\xe1ger\u0151 Revolver",
        swe: "Revolver | Flower Power"
    },
    1057: {
        img: "flower_power_medi_gun",
        eng: "Flower Power | Medi Gun",
        rus: "Flower Power | \u041B\u0435\u0447\u0435\u0431\u043D\u0430\u044F \u043F\u0443\u0448\u043A\u0430",
        pol: "Medigun | Dzieci kwiaty",
        sch: "\u9C9C\u82B1\u4E4B\u529B\u533B\u7597\u67AA",
        fre: "Le medigun Flower Power",
        bra: "Arma M\xe9dica | Campo Florido",
        schema: 15097,
        schema2: 72,
        hun: "A Vir\xe1ger\u0151 Gy\xf3gypuska",
        swe: "H\xe4lsovapen | Flower Power"
    },
    1058: {
        img: "brain_candy_rocket_launcher",
        eng: "Brain Candy | Rocket Launcher",
        rus: "Brain Candy | \u0420\u0430\u043A\u0435\u0442\u043E\u043C\u0451\u0442",
        pol: "Wyrzutnia rakiet | Cukieraski",
        sch: "\u8111\u6D46\u7CD6\u679C\u706B\u7BAD\u53D1\u5C04\u5668",
        fre: "Le lance-roquettes sucette",
        bra: "Lan\xe7a-foguetes | Doce Mental",
        schema: 15105,
        schema2: 70,
        hun: "Az Agynyal\xf3ka Rak\xe9tavet\u0151",
        swe: "Raketgev\xe4r | Sockers\xf6t"
    },
    1059: {
        img: "brain_candy_pistol",
        eng: "Brain Candy | Pistol",
        rus: "Brain Candy | \u041F\u0438\u0441\u0442\u043E\u043B\u0435\u0442",
        pol: "Pistolet | Cukieraski",
        sch: "\u8111\u6D46\u7CD6\u679C\u624B\u67AA",
        fre: "Le pistolet sucette",
        bra: "Pistola | Doce Mental",
        schema: 15101,
        schema2: 70,
        hun: "Az Agynyal\xf3ka Pisztoly",
        swe: "Pistol | Sockers\xf6t"
    },
    1060: {
        img: "brain_candy_minigun",
        eng: "Brain Candy | Minigun",
        rus: "Brain Candy | \u041F\u0443\u043B\u0435\u043C\u0451\u0442",
        pol: "Minigun | Cukieraski",
        sch: "\u8111\u6D46\u7CD6\u679C\u8F6C\u8F6E\u673A\u67AA",
        fre: "Le minigun sucette",
        bra: "Metralhadora Girat\xf3ria | Doce Mental",
        schema: 15098,
        schema2: 70,
        hun: "Az Agynyal\xf3ka G\xe9p\xe1gy\xfa",
        swe: "Minigun | Sockers\xf6t"
    },
    1061: {
        img: "brain_candy_knife",
        eng: "Brain Candy | Knife",
        rus: "Brain Candy | \u041D\u043E\u0436",
        pol: "N\xf3\u017C | Cukieraski",
        sch: "\u8111\u6D46\u7CD6\u679C\u5200\u5B50",
        fre: "Le couteau sucette",
        bra: "Faca | Doce Mental",
        schema: 15095,
        schema2: 70,
        hun: "Az Agynyal\xf3ka K\xe9s",
        swe: "Kniv | Sockers\xf6t"
    },
    1062: {
        img: "shot_to_hell_pistol",
        eng: "Shot to Hell | Pistol",
        rus: "Shot to Hell | \u041F\u0438\u0441\u0442\u043E\u043B\u0435\u0442",
        pol: "Pistolet | Z piek\u0142a rodem",
        sch: "\u5C04\u5230\u6B7B\u624B\u67AA",
        fre: "Le pistolet infernal",
        bra: "Pistola | Balas Infernais",
        schema: 15102,
        schema2: 74,
        hun: "A Pokolra L\u0151tt Pisztoly",
        swe: "Pistol | Helvetesbr\xe4nd"
    },
    1063: {
        img: "stabbed_to_hell_knife",
        eng: "Stabbed to Hell | Knife",
        rus: "Stabbed to Hell | \u041D\u043E\u0436",
        pol: "N\xf3\u017C | Z piek\u0142a rodem",
        sch: "\u80CC\u523A\u5230\u6B7B\u5200\u5B50",
        fre: "Le couteau infernal",
        bra: "Faca | Facadas Infernais",
        schema: 15096,
        schema2: 71,
        hun: "A Pokolra Sz\xfart K\xe9s",
        swe: "Kniv | Knivad \xe5t helvete"
    },
    1064: {
        img: "blue_mew_smg",
        eng: "Blue Mew | SMG",
        rus: "Blue Mew | \u041F\u0438\u0441\u0442\u043E\u043B\u0435\u0442-\u043F\u0443\u043B\u0435\u043C\u0451\u0442",
        pol: "PM | Kote\u0142",
        sch: "\u84DD\u55B5 SMG",
        fre: "La mitraillette miaou",
        bra: "Submetralhadora | C\xe9u de Gatinhos",
        schema: 15110,
        schema2: 69,
        hun: "A K\xe9k Miau G\xe9ppisztoly",
        swe: "Kpist | Bl\xe5tt jam"
    },
    1065: {
        img: "torqued_to_hell_wrench",
        eng: "Torqued to Hell | Wrench",
        rus: "Torqued to Hell | \u0413\u0430\u0435\u0447\u043D\u044B\u0439 \u043A\u043B\u044E\u0447",
        pol: "Klucz | Z piek\u0142a rodem",
        sch: "\u626D\u66F2\u5230\u6B7B\u6273\u624B",
        fre: "La cl\xe9 infernale",
        bra: "Chave Inglesa | Torcidas Infernais",
        schema: 15114,
        schema2: 75,
        hun: "A Pokolra Tekert Franciakulcs",
        swe: "Skiftnyckel | Helvetesbr\xe4nd"
    },
    1066: {
        img: "shot_to_hell_scattergun",
        eng: "Shot to Hell | Scattergun",
        rus: "Shot to Hell | \u041E\u0431\u0440\u0435\u0437",
        pol: "Dubelt\xf3wka | Z piek\u0142a rodem",
        sch: "\u5C04\u5230\u6B7B\u730E\u67AA",
        fre: "Le fusil \xe0 dispersion infernal",
        bra: "Espingarda | Balas Infernais",
        schema: 15108,
        schema2: 74,
        hun: "A Pokolra L\u0151tt Repeszpuska",
        swe: "Hagelb\xf6ssa | Helvetesbr\xe4nd"
    },
    1067: {
        img: "blue_mew_scattergun",
        eng: "Blue Mew | Scattergun",
        rus: "Blue Mew | \u041E\u0431\u0440\u0435\u0437",
        pol: "Dubelt\xf3wka | Kote\u0142",
        sch: "\u84DD\u55B5\u730E\u67AA",
        fre: "Le fusil \xe0 dispersion miaou",
        bra: "Espingarda | C\xe9u de Gatinhos",
        schema: 15106,
        schema2: 69,
        hun: "A K\xe9k Miau Repeszpuska",
        swe: "Hagelb\xf6ssa | Bl\xe5tt jam"
    },
    1068: {
        img: "blue_mew_rocket_launcher",
        eng: "Blue Mew | Rocket Launcher",
        rus: "Blue Mew | \u0420\u0430\u043A\u0435\u0442\u043E\u043C\u0451\u0442",
        pol: "Wyrzutnia rakiet | Kote\u0142",
        sch: "\u84DD\u55B5\u706B\u7BAD\u53D1\u5C04\u5668",
        fre: "Le lance-roquettes miaou",
        bra: "Lan\xe7a-foguetes | C\xe9u de Gatinhos",
        schema: 15104,
        schema2: 69,
        hun: "A K\xe9k Miau Rak\xe9tavet\u0151",
        swe: "Raketgev\xe4r | Bl\xe5tt jam"
    },
    1069: {
        img: "blue_mew_pistol",
        eng: "Blue Mew | Pistol",
        rus: "Blue Mew | \u041F\u0438\u0441\u0442\u043E\u043B\u0435\u0442",
        pol: "Pistolet | Kote\u0142",
        sch: "\u84DD\u55B5\u624B\u67AA",
        fre: "Le pistolet miaou",
        bra: "Pistola | C\xe9u de Gatinhos",
        schema: 15100,
        schema2: 69,
        hun: "A K\xe9k Miau Pisztoly",
        swe: "Pistol | Bl\xe5tt jam"
    },
    1070: {
        img: "blue_mew_knife",
        eng: "Blue Mew | Knife",
        rus: "Blue Mew | \u041D\u043E\u0436",
        pol: "N\xf3\u017C | Kote\u0142",
        sch: "\u84DD\u55B5\u5200\u5B50",
        fre: "Le couteau miaou",
        bra: "Faca | C\xe9u de Gatinhos",
        schema: 15094,
        schema2: 69,
        hun: "A K\xe9k Miau K\xe9s",
        swe: "Kniv | Bl\xe5tt jam"
    },
    1071: {
        img: "mister_cuddles_minigun",
        eng: "Mister Cuddles | Minigun",
        rus: "Mister Cuddles | \u041F\u0443\u043B\u0435\u043C\u0451\u0442",
        pol: "Pan Przytula\u015Bny | Minigun",
        sch: "\u62B1\u62B1\u5148\u751F \u8F6C\u8F6E\u673A\u67AA",
        bra: "Senhor Fofinho Metralhadora Girat\xf3ria",
        fre: "Le Minigun Monsieur C\xe2lin",
        schema: 15099,
        schema2: 73,
        hun: "Mister Cuddles g\xe9p\xe1gy\xfa"
    },
    1072: {
        img: "balloonicorn_flame_thrower",
        eng: "Balloonicorn | Flame Thrower",
        rus: "Balloonicorn | \u041E\u0433\u043D\u0435\u043C\u0451\u0442",
        pol: "Miotacz ognia | Balonoro\u017Cec",
        sch: "\u6C14\u7403\u72EC\u89D2\u517D\u706B\u7130\u55B7\u5C04\u5668",
        fre: "Le lance-flammes Ballicorne",
        bra: "Lan\xe7a-chamas | Bal\xe3onic\xf3rnio",
        schema: 15089,
        schema2: 66,
        hun: "A Lufikornis L\xe1ngsz\xf3r\xf3",
        swe: "Eldkastare | Ballongh\xf6rning"
    },
    1073: {
        img: "sweet_dreams_stickybomb_launcher",
        eng: "Sweet Dreams | Stickybomb Launcher",
        rus: "Sweet Dreams | \u041B\u0438\u043F\u0443\u0447\u043A\u043E\u043C\u0451\u0442",
        pol: "Wyrzutnia bomb samoprzylepnych | S\u0142odkich sn\xf3w",
        sch: "\u751C\u871C\u68A6\u5883\u9ECF\u6027\u70B8\u5F39\u53D1\u5C04\u5668",
        fre: "Le lanceur de bombes collantes des beaux r\xeaves",
        bra: "Lan\xe7a-stickybombs | Bons Sonhos",
        schema: 15113,
        hun: "Az \xc9des \xc1lom Tapad\xf3bomba-vet\u0151",
        swe: "Klisterbombskastare | S\xf6ta dr\xf6mmar"
    },
    1074: {
        img: "sweet_dreams_grenade_launcher",
        eng: "Sweet Dreams | Grenade Launcher",
        rus: "Sweet Dreams | \u0413\u0440\u0430\u043D\u0430\u0442\u043E\u043C\u0451\u0442",
        pol: "Granatnik | S\u0142odkich sn\xf3w",
        sch: "\u751C\u871C\u68A6\u5883\u69B4\u5F39\u53D1\u5C04\u5668",
        fre: "Le lance-grenades des beaux r\xeaves",
        bra: "Lan\xe7a-granadas | Bons Sonhos",
        schema: 15092,
        schema2: 68,
        hun: "Az \xc9des \xc1lom Gr\xe1n\xe1tvet\u0151",
        swe: "Granatkastare | S\xf6ta dr\xf6mmar"
    },
    1075: {
        img: "balloonicorn_sniper_rifle",
        eng: "Balloonicorn | Sniper Rifle",
        rus: "Balloonicorn | \u0421\u043D\u0430\u0439\u043F\u0435\u0440\u0441\u043A\u0430\u044F \u0432\u0438\u043D\u0442\u043E\u0432\u043A\u0430",
        pol: "Karabin snajperski | Balonoro\u017Cec",
        sch: "\u6C14\u7403\u72EC\u89D2\u517D\u72D9\u51FB\u6B65\u67AA",
        fre: "Le fusil de sniper Ballicorne",
        bra: "Rifle de Sniper | Bal\xe3onic\xf3rnio",
        schema: 15111,
        schema2: 66,
        hun: "A Lufikornis Mesterl\xf6v\xe9sz Puska",
        swe: "Krypskyttegev\xe4r | Ballongh\xf6rning"
    },
    1076: {
        img: "rainbow_flame_thrower",
        eng: "Rainbow | Flame Thrower",
        rus: "Rainbow | \u041E\u0433\u043D\u0435\u043C\u0451\u0442",
        pol: "Miotacz ognia | T\u0119cza",
        sch: "\u5F69\u8679\u706B\u7130\u55B7\u5C04\u5668",
        fre: "Le lance-flammes arc-en-ciel",
        bra: "Lan\xe7a-chamas | Arco-\xedris",
        schema: 15090,
        schema2: 67,
        hun: "A Sziv\xe1rv\xe1ny L\xe1ngsz\xf3r\xf3",
        swe: "Eldkastare | Regnb\xe5ge"
    },
    1077: {
        img: "rainbow_sniper_rifle",
        eng: "Rainbow | Sniper Rifle",
        rus: "Rainbow | \u0421\u043D\u0430\u0439\u043F\u0435\u0440\u0441\u043A\u0430\u044F \u0432\u0438\u043D\u0442\u043E\u0432\u043A\u0430",
        pol: "Karabin snajperski | T\u0119cza",
        sch: "\u5F69\u8679\u72D9\u51FB\u6B65\u67AA",
        fre: "Le fusil de sniper arc-en-ciel",
        bra: "Rifle de Sniper | Arco-\xedris",
        schema: 15112,
        schema2: 67,
        hun: "A Sziv\xe1rv\xe1ny Mesterl\xf6v\xe9sz Puska",
        swe: "Krypskyttegev\xe4r | Regnb\xe5ge"
    },
    1078: {
        img: "rainbow_grenade_launcher",
        eng: "Rainbow | Grenade Launcher",
        rus: "Rainbow | \u0413\u0440\u0430\u043D\u0430\u0442\u043E\u043C\u0451\u0442",
        pol: "Granatnik | T\u0119cza",
        sch: "\u5F69\u8679\u69B4\u5F39\u53D1\u5C04\u5668",
        fre: "Le lance-grenades arc-en-ciel",
        bra: "Lan\xe7a-granadas | Arco-\xedris",
        schema: 15091,
        schema2: 67,
        hun: "A Sziv\xe1rv\xe1ny Gr\xe1n\xe1tvet\u0151",
        swe: "Granatkastare | Regnb\xe5ge"
    },
    1079: {
        img: "blitzkrieg_knife",
        eng: "Blitzkrieg | Knife",
        rus: "Blitzkrieg | \u041D\u043E\u0436",
        pol: "N\xf3\u017C | Blitzkrieg",
        sch: "\u96F7\u9706\u95EA\u51FB\u5200\u5B50",
        fre: "Le couteau Blitzkrieg",
        bra: "Faca | Blitzkrieg",
        schema: 15143,
        schema2: 81,
        hun: "A Vill\xe1mh\xe1bor\xfa K\xe9s",
        swe: "Kniv | Blitzkrieg"
    },
    1080: {
        img: "butcher_bird_grenade_launcher",
        eng: "Butcher Bird | Grenade Launcher",
        rus: "Butcher Bird | \u0413\u0440\u0430\u043D\u0430\u0442\u043E\u043C\u0451\u0442",
        pol: "Granatnik | Srokacz",
        sch: "\u4F2F\u52B3\u9E1F\u69B4\u5F39\u53D1\u5C04\u5668",
        fre: "Le lance-grenades rapace",
        bra: "Lan\xe7a-granadas | Gralha",
        schema: 15158,
        schema2: 84,
        hun: "A M\xe9sz\xe1rmad\xe1r Gr\xe1n\xe1tvet\u0151",
        swe: "Granatkastare | Stridsflygplan"
    },
    1081: {
        img: "corsair_scattergun",
        eng: "Corsair | Scattergun",
        rus: "Corsair | \u041E\u0431\u0440\u0435\u0437",
        pol: "Dubelt\xf3wka | Korsarz",
        sch: "\u6D77\u76D7\u730E\u67AA",
        fre: "Le fusil \xe0 dispersion pirate",
        bra: "Espingarda | Cors\xe1rio",
        schema: 15157,
        schema2: 83,
        hun: "A Kal\xf3z Repeszpuska",
        swe: "Hagelb\xf6ssa | Korseld"
    },
    1082: {
        img: "airwolf_wrench",
        eng: "Airwolf | Wrench",
        rus: "Airwolf | \u0413\u0430\u0435\u0447\u043D\u044B\u0439 \u043A\u043B\u044E\u0447",
        pol: "Klucz | Airwolf",
        sch: "\u98DE\u72FC\u6273\u624B",
        fre: "La cl\xe9 Airwolf",
        bra: "Chave Inglesa | Lobo dos Ares",
        schema: 15156,
        schema2: 82,
        hun: "A L\xe9gifarkas Franciakulcs",
        swe: "Skiftnyckel | Airwolf"
    },
    1083: {
        img: "blitzkrieg_smg",
        eng: "Blitzkrieg | SMG",
        rus: "Blitzkrieg | \u041F\u0438\u0441\u0442\u043E\u043B\u0435\u0442-\u043F\u0443\u043B\u0435\u043C\u0451\u0442",
        pol: "PM | Blitzkrieg",
        sch: "\u96F7\u9706\u95EA\u51FB SMG",
        fre: "La mitraillette Blitzkrieg",
        bra: "Submetralhadora | Blitzkrieg",
        schema: 15153,
        schema2: 81,
        hun: "A Vill\xe1mh\xe1bor\xfa G\xe9ppisztoly",
        swe: "Kpist | Blitzkrieg"
    },
    1084: {
        img: "blitzkrieg_revolver",
        eng: "Blitzkrieg | Revolver",
        rus: "Blitzkrieg | \u0420\u0435\u0432\u043E\u043B\u044C\u0432\u0435\u0440",
        pol: "Rewolwer | Blitzkrieg",
        sch: "\u96F7\u9706\u95EA\u51FB\u5DE6\u8F6E\u624B\u67AA",
        fre: "Le revolver Blitzkrieg",
        bra: "Rev\xf3lver | Blitzkrieg",
        schema: 15149,
        schema2: 81,
        hun: "A Vill\xe1mh\xe1bor\xfa Revolver",
        swe: "Revolver | Blitzkrieg"
    },
    1085: {
        img: "blitzkrieg_pistol",
        eng: "Blitzkrieg | Pistol",
        rus: "Blitzkrieg | \u041F\u0438\u0441\u0442\u043E\u043B\u0435\u0442",
        pol: "Pistolet | Blitzkrieg",
        sch: "\u96F7\u9706\u95EA\u51FB\u624B\u67AA",
        fre: "Le pistolet Blitzkrieg",
        bra: "Pistola | Blitzkrieg",
        schema: 15148,
        schema2: 81,
        hun: "A Vill\xe1mh\xe1bor\xfa Pisztoly",
        swe: "Pistol | Blitzkrieg"
    },
    1086: {
        img: "blitzkrieg_medi_gun",
        eng: "Blitzkrieg | Medi Gun",
        rus: "Blitzkrieg | \u041B\u0435\u0447\u0435\u0431\u043D\u0430\u044F \u043F\u0443\u0448\u043A\u0430",
        pol: "Medigun | Blitzkrieg",
        sch: "\u96F7\u9706\u95EA\u51FB\u533B\u7597\u67AA",
        fre: "Le medigun Blitzkrieg",
        bra: "Arma M\xe9dica | Blitzkrieg",
        schema: 15145,
        schema2: 81,
        hun: "A Vill\xe1mh\xe1bor\xfa Gy\xf3gypuska",
        swe: "H\xe4lsovapen | Blitzkrieg"
    },
    1087: {
        img: "airwolf_knife",
        eng: "Airwolf | Knife",
        rus: "Airwolf | \u041D\u043E\u0436",
        pol: "N\xf3\u017C | Airwolf",
        sch: "\u98DE\u72FC\u5200\u5B50",
        fre: "Le couteau Airwolf",
        bra: "Faca | Lobo dos Ares",
        schema: 15144,
        schema2: 82,
        hun: "A L\xe9gifarkas K\xe9s",
        swe: "Kniv | Airwolf"
    },
    1088: {
        img: "corsair_medi_gun",
        eng: "Corsair | Medi Gun",
        rus: "Corsair | \u041B\u0435\u0447\u0435\u0431\u043D\u0430\u044F \u043F\u0443\u0448\u043A\u0430",
        pol: "Medigun | Korsarz",
        sch: "\u6D77\u76D7\u533B\u7597\u67AA",
        fre: "Le medigun pirate",
        bra: "Arma M\xe9dica | Cors\xe1rio",
        schema: 15146,
        schema2: 83,
        hun: "A Kal\xf3z Gy\xf3gypuska",
        swe: "H\xe4lsovapen | Korseld"
    },
    1089: {
        img: "blitzkrieg_stickybomb_launcher",
        eng: "Blitzkrieg | Stickybomb Launcher",
        rus: "Blitzkrieg | \u041B\u0438\u043F\u0443\u0447\u043A\u043E\u043C\u0451\u0442",
        pol: "Wyrzutnia bomb samoprzylepnych | Blitzkrieg",
        sch: "\u96F7\u9706\u95EA\u51FB\u9ECF\u6027\u70B8\u5F39\u53D1\u5C04\u5668",
        fre: "Le lanceur de bombes collantes Blitzkrieg",
        bra: "Lan\xe7a-stickybombs | Blitzkrieg",
        schema: 15155,
        schema2: 81,
        hun: "A Vill\xe1mh\xe1bor\xfa Tapad\xf3bomba-vet\u0151",
        swe: "Klisterbombskastare | Blitzkrieg"
    },
    1090: {
        img: "airwolf_sniper_rifle",
        eng: "Airwolf | Sniper Rifle",
        rus: "Airwolf | \u0421\u043D\u0430\u0439\u043F\u0435\u0440\u0441\u043A\u0430\u044F \u0432\u0438\u043D\u0442\u043E\u0432\u043A\u0430",
        pol: "Karabin snajperski | Airwolf",
        sch: "\u98DE\u72FC\u72D9\u51FB\u6B65\u67AA",
        fre: "Le fusil de sniper Airwolf",
        bra: "Rifle de Sniper | Lobo dos Ares",
        schema: 15154,
        schema2: 82,
        hun: "A L\xe9gifarkas Mesterl\xf6v\xe9sz Puska",
        swe: "Krypskyttegev\xe4r | Airwolf"
    },
    1091: {
        img: "butcher_bird_minigun",
        eng: "Butcher Bird | Minigun",
        rus: "Butcher Bird | \u041F\u0443\u043B\u0435\u043C\u0451\u0442",
        pol: "Minigun | Srokacz",
        sch: "\u4F2F\u52B3\u9E1F\u8F6C\u8F6E\u673A\u67AA",
        fre: "Le minigun rapace",
        bra: "Metralhadora Girat\xf3ria | Gralha",
        schema: 15147,
        schema2: 84,
        hun: "A M\xe9sz\xe1rmad\xe1r G\xe9p\xe1gy\xfa",
        swe: "Minigun | Stridsflygplan"
    },
    1092: {
        img: "warhawk_flame_thrower",
        eng: "Warhawk | Flame Thrower",
        rus: "Warhawk | \u041E\u0433\u043D\u0435\u043C\u0451\u0442",
        pol: "Miotacz ognia | Warhawk",
        sch: "\u9E70\u6D3E\u706B\u7130\u55B7\u5C04\u5668",
        fre: "Le lance-flammes du faucon guerrier",
        bra: "Lan\xe7a-chamas | Gavi\xe3o de Guerra",
        schema: 15141,
        schema2: 80,
        hun: "A Harci H\xe9ja L\xe1ngsz\xf3r\xf3",
        swe: "Eldkastare | Krigsh\xf6k"
    },
    1093: {
        img: "red_bear_shotgun",
        eng: "Red Bear | Shotgun",
        rus: "Red Bear | \u0414\u0440\u043E\u0431\u043E\u0432\u0438\u043A",
        pol: "Strzelba | Czerwony nied\u017Awied\u017A",
        sch: "\u8D64\u7EA2\u4E4B\u718A\u9730\u5F39\u67AA",
        fre: "Le fusil \xe0 pompe de l'ours rouge",
        bra: "Escopeta | Ursovi\xe9tico",
        schema: 15152,
        schema2: 86,
        hun: "A V\xf6r\xf6s Medve S\xf6r\xe9tes Puska",
        swe: "Hagelgev\xe4r | R\xf6d bj\xf6rn"
    },
    1094: {
        img: "warhawk_grenade_launcher",
        eng: "Warhawk | Grenade Launcher",
        rus: "Warhawk | \u0413\u0440\u0430\u043D\u0430\u0442\u043E\u043C\u0451\u0442",
        pol: "Granatnik | Warhawk",
        sch: "\u9E70\u6D3E\u69B4\u5F39\u53D1\u5C04\u5668",
        fre: "Le lance-grenades du faucon guerrier",
        bra: "Lan\xe7a-granadas | Gavi\xe3o de Guerra",
        schema: 15142,
        schema2: 80,
        hun: "A Harci H\xe9ja Gr\xe1n\xe1tvet\u0151",
        swe: "Granatkastare | Krigsh\xf6k"
    },
    1095: {
        img: "warhawk_rocket_launcher",
        eng: "Warhawk | Rocket Launcher",
        rus: "Warhawk | \u0420\u0430\u043A\u0435\u0442\u043E\u043C\u0451\u0442",
        pol: "Wyrzutnia rakiet | Warhawk",
        sch: "\u9E70\u6D3E\u706B\u7BAD\u53D1\u5C04\u5668",
        fre: "Le lance-roquettes du faucon guerrier",
        bra: "Lan\xe7a-foguetes | Gavi\xe3o de Guerra",
        schema: 15150,
        schema2: 80,
        hun: "A Harci H\xe9ja Rak\xe9tavet\u0151",
        swe: "Raketgev\xe4r | Krigsh\xf6k"
    },
    1096: {
        img: "killer_bee_scattergun",
        eng: "Killer Bee | Scattergun",
        rus: "Killer Bee | \u041E\u0431\u0440\u0435\u0437",
        pol: "Dubelt\xf3wka | Zab\xf3jcza pszczo\u0142a",
        sch: "\u6740\u4EBA\u8702\u730E\u67AA",
        fre: "Le fusil \xe0 dispersion ruche",
        bra: "Espingarda | Abelha Assassina",
        schema: 15151,
        schema2: 85,
        hun: "A Gyilkos M\xe9h Repeszpuska",
        swe: "Hagelb\xf6ssa | M\xf6rdarbi"
    },
    1097: {
        img: "patriot_peak",
        eng: "The Patriot Peak",
        rus: "\u041F\u0438\u043A \u043F\u0430\u0442\u0440\u0438\u043E\u0442\u0438\u0437\u043C\u0430",
        pol: "Rogatywka patrioty",
        sch: "\u7231\u56FD\u4E4B\u9E70",
        fre: "L'apog\xe9e patriotique",
        bra: "O Pico Patriota",
        schema: 30743,
        hun: "A Cs\xfacshazafi",
        swe: "Patriotens prydnad"
    },
    1098: {
        img: "berlin_brain_bowl",
        eng: "Berlin Brain Bowl",
        rus: "\u041C\u044E\u043D\u0445\u0435\u043D\u0441\u043A\u0430\u044F \u043C\u0438\u0441\u043A\u0430 \u043C\u043E\u0437\u0433\u043E\u0432",
        pol: "Berli\u0144ski he\u0142m sanitariusza",
        sch: "\u67CF\u6797\u8111\u76D4",
        fre: "Protection berlinoise",
        bra: "Batalhador de Berlim",
        schema: 30755,
        hun: "Berlini B\xfara-b\xfara",
        swe: "Berlinsk hj\xe4rnhj\xe4lm"
    },
    1099: {
        img: "hot_heels",
        eng: "Hot Heels",
        rus: "\u0420\u0430\u0441\u043A\u0430\u043B\u0435\u043D\u043D\u044B\u0435 \u043A\u0440\u043E\u0441\u0441\u044B",
        pol: "Mattelowe trampki",
        sch: "\u70ED\u529B\u8DD1\u978B",
        fre: "Talons chauts",
        bra: "Cal\xe7ados Chama-tivos",
        schema: 30754,
        hun: "L\xe1ngol\xf3 L\xe1bbeli",
        swe: "Heta h\xe4lar"
    },
    1100: {
        img: "a_hat_to_kill_for",
        eng: "A Hat to Kill For",
        rus: "\u0423\u0431\u0438\u0439\u0441\u0442\u0432\u0435\u043D\u043D\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "Kapelusz wart zab\xf3jstwa",
        sch: "\u8C0B\u5E3D\u5BB3\u547D",
        fre: "Un chapeau \xe0 en mourir",
        bra: "Um Chap\xe9u de Matar",
        schema: 30753,
        hun: "\xc9letedet Egy Kalap\xe9rt",
        swe: "En hatt att d\xf6da f\xf6r"
    },
    1101: {
        img: "shin_shredders",
        eng: "Shin Shredders",
        rus: "\u041D\u043E\u0436\u043D\u044B\u0435 \u043B\u0435\u0437\u0432\u0438\u044F",
        pol: "Samurajskie haidate",
        sch: "\u6B66\u58EB\u94A2\u7532",
        fre: "Prot\xe8ge-tibias du conqu\xe9rant",
        bra: "Caneleiras do Conquistador",
        schema: 30742,
        hun: "L\xe1bsz\xe1rt\xe9p\u0151k",
        swe: "Smalbensskydd"
    },
    1102: {
        img: "medical_monarch",
        eng: "Medical Monarch",
        rus: "\u041A\u043E\u0440\u043E\u043B\u0435\u0432\u0441\u043A\u0438\u0439 \u043A\u043B\u0438\u043D\u0438\u0446\u0438\u0441\u0442",
        pol: "Monarcha medycyny",
        sch: "\u533B\u7597\u4E4B\u738B",
        fre: "Monarque m\xe9dical",
        bra: "Monarca da Medicina",
        schema: 30750,
        hun: "Szanit\xe9ckir\xe1ly",
        swe: "Medicinsk monark"
    },
    1103: {
        img: "siberian_sweater",
        eng: "Siberian Sweater",
        rus: "\u0421\u0438\u0431\u0438\u0440\u0441\u043A\u0438\u0439 \u0441\u0432\u0438\u0442\u0435\u0440",
        pol: "Syberyjski sweter",
        sch: "\u897F\u4F2F\u5229\u4E9A\u5C0F\u6BDB\u8863",
        fre: "Pull sib\xe9rien",
        bra: "Su\xe9ter Siberiano",
        schema: 30745,
        hun: "Szib\xe9riai Szvetter",
        swe: "Siberiska stickade tr\xf6jan"
    },
    1104: {
        img: "chicago_overcoat",
        eng: "Chicago Overcoat",
        rus: "\u0427\u0438\u043A\u0430\u0433\u0441\u043A\u043E\u0435 \u043F\u0430\u043B\u044C\u0442\u043E",
        pol: "Chicagowski p\u0142aszcz",
        sch: "\u829D\u52A0\u54E5\u5916\u5957",
        fre: "Pardessus de Chicago",
        bra: "O Casac\xe3o de Chicago",
        schema: 30752,
        hun: "Chicag\xf3i Fel\xf6lt\u0151",
        swe: "Chicagorocken"
    },
    1105: {
        img: "diplomat",
        eng: "The Diplomat",
        rus: "\u0414\u0438\u043F\u043B\u043E\u043C\u0430\u0442",
        pol: "Dyplomata",
        sch: "\u9A7B\u5916\u6B66\u5B98",
        fre: "Le diplomate",
        bra: "O Diplomata",
        schema: 30744,
        hun: "A Diplomata",
        swe: "Diplomaten"
    },
    1106: {
        img: "bunnyhoppers_ballistics_vest",
        eng: "Bunnyhopper's Ballistics Vest",
        rus: "\u0411\u0440\u043E\u043D\u0435\u0436\u0438\u043B\u0435\u0442 \u043F\u043E\u043F\u0440\u044B\u0433\u0443\u043D\u0447\u0438\u043A\u0430",
        pol: "Kamizelka kuloodporna skoczka",
        sch: "\u8DF3\u8DF3\u5154\u7684\u5F39\u9053\u5B66\u80CC\u5FC3",
        fre: "Pare-balle du Bunnyhopper",
        bra: "Veste Bal\xedstica",
        schema: 30756,
        hun: "A Bakugr\xf3 Ballisztikus Mell\xe9nye",
        swe: "Bunnyhopparens ballistikv\xe4st"
    },
    1107: {
        img: "winter_backup",
        eng: "Winter Backup",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438",
        pol: "Zimowe wsparcie",
        sch: "\u51AC\u65E5\u80CC\u5305",
        fre: "Provisions hivernales",
        bra: "Ferramentas do Frio",
        schema: 30749,
        hun: "T\xe9li T\xe1mogat\xe1s",
        swe: "Vinterreserven"
    },
    1108: {
        img: "bonk_batters_backup",
        eng: "Bonk Batter's Backup",
        rus: "\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442 \u0431\u0435\u0439\u0441\u0431\u043E\u043B\u0438\u0441\u0442\u0430",
        pol: "Sprz\u0119t pa\u0142karza Bonka",
        sch: "\u539F\u5B50\u80FD\u68D2\u7403\u624B\u7684\u5FC5\u5907\u7269\u54C1",
        fre: "Sac de baseball de Bonk",
        bra: "A Bolsa do Batedor Bonk",
        schema: 30751,
        hun: "Az \xdct\u0151s Felszerel\xe9s",
        swe: "Slagmannens reserv"
    },
    1109: {
        img: "gift_bringer",
        eng: "The Gift Bringer",
        rus: "\u041F\u043E\u0434\u0430\u0440\u043A\u043E\u043D\u043E\u0441\u0435\u0446",
        pol: "\u015Ani\u0119ty Miko\u0142aj",
        sch: "\u8D60\u793C\u4E4B\u4EBA",
        fre: "Le p\xe8re Soldier",
        bra: "O Papai dos Presentes",
        schema: 30747,
        hun: "Az Aj\xe1nd\xe9khoz\xf3",
        swe: "G\xe5vogivaren"
    },
    1110: {
        img: "chill_chullo",
        eng: "The Chill Chullo",
        rus: "\u0422\u0435\u043F\u043B\u0430\u044F \u0443\u0448\u0430\u0441\u0442\u0430\u044F \u0448\u0430\u043F\u043A\u0430",
        pol: "Zmro\u017Cone chullo",
        sch: "\u5FA1\u5BD2\u6BDB\u7ED2\u5E3D",
        fre: "Chill Chullo",
        bra: "O Gorro Glacial",
        schema: 30748,
        hun: "A Fagyos F\xfcltakar\xf3s",
        swe: "Kyliga chullon"
    },
    1111: {
        img: "a_well_wrapped_hat",
        eng: "A Well Wrapped Hat",
        rus: "\u0425\u043E\u0440\u043E\u0448\u043E \u0437\u0430\u0432\u0435\u0440\u043D\u0443\u0442\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "Dobrze zapakowany cylinder",
        sch: "\u7CBE\u7F8E\u793C\u7269\u5305\u88C5\u5E3D",
        fre: "Un chapeau bien emball\xe9",
        bra: "Um Chap\xe9u Bem Embrulhado",
        schema: 30746,
        hun: "Rendesen Becsomagolt Kalap",
        swe: "En v\xe4linslagen hatt"
    },
    1112: {
        img: "courtly_cuirass",
        eng: "Courtly Cuirass",
        rus: "\u041B\u043E\u043A\u0442\u0435\u0432\u044B\u0435 \u043B\u0430\u0442\u044B",
        pol: "Dworski kirys",
        sch: "\u5178\u96C5\u7684\u81C2\u7532",
        fre: "Prot\xe8ge-bras moyen\xe2geux",
        bra: "A Prote\xe7\xe3o Platinada",
        schema: 30770,
        hun: "A Pomp\xe1s P\xe1nc\xe9l",
        swe: "H\xf6visk harnesk"
    },
    1113: {
        img: "demos_dustcatcher",
        eng: "The Demo's Dustcatcher",
        rus: "\u041F\u043E\u043D\u0447\u043E \u043F\u043E\u0434\u0440\u044B\u0432\u043D\u0438\u043A\u0430",
        pol: "Peleryna z prerii",
        sch: "\u7206\u7834\u624B\u7684\u906E\u98CE\u56F4\u5DFE",
        fre: "Plumeau du Demo",
        bra: "O Poncho do Demolidor",
        schema: 30788,
        hun: "A Robbant\xf3s Porfog\xf3ja",
        swe: "Dammsamlaren"
    },
    1114: {
        img: "surgical_survivalist",
        eng: "The Surgical Survivalist",
        rus: "\u041F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u0439 \u043F\u0435\u0434\u0438\u0430\u0442\u0440",
        pol: "Sanitariusz frontowy",
        sch: "\u5916\u79D1\u5B66\u62A4\u819D",
        fre: "Chirurgien survivaliste",
        bra: "O Sobrevivencialista Cir\xfargico",
        schema: 30773,
        hun: "A Seb\xe9szeti T\xfal\xe9l\u0151",
        swe: "Kirurgens kamouflage"
    },
    1115: {
        img: "squires_sabatons",
        eng: "Squire's Sabatons",
        rus: "\u041E\u0431\u0443\u0432\u043A\u0430 \u043E\u0440\u0443\u0436\u0435\u043D\u043E\u0441\u0446\u0430",
        pol: "Trzewiki giermka",
        sch: "\u4F8D\u4ECE\u7684\u94E0\u9774",
        fre: "Soleret de l'\xe9cuyer",
        bra: "Os Calcantes do Cavaleiro",
        schema: 30771,
        hun: "A Pajzshord\xf3 P\xe1nc\xe9lcsizm\xe1i",
        swe: "Knektens k\xe4ngor"
    },
    1116: {
        img: "airdog",
        eng: "The Airdog",
        rus: "\u0410\u0432\u0438\u0430\u043D\u0430\u043B\u0435\u0442\u0447\u0438\u043A",
        pol: "Awiator",
        sch: "\u5929\u72D7\u6ED1\u96EA\u76D4",
        fre: "Pro de la glisse",
        bra: "O Esqui-ardor",
        schema: 30767,
        hun: "A L\xe9gikutya",
        swe: "Skidhj\xe4lmen"
    },
    1117: {
        img: "scoped_spartan",
        eng: "Scoped Spartan",
        rus: "\u0421\u043F\u0430\u0440\u0442\u0430\u043D\u0441\u043A\u0438\u0439 \u0441\u0442\u0440\u0435\u043B\u043E\u043A",
        pol: "Wcelowany Spartanin",
        sch: "\u65AF\u5DF4\u8FBE\u62AB\u98CE",
        fre: "Cape spartiate",
        bra: "A Capa do Espartano",
        schema: 30789,
        hun: "A T\xe1vcs\xf6ves Sp\xe1rtai",
        swe: "Siktande spartanen"
    },
    1118: {
        img: "heralds_helm",
        eng: "Herald's Helm",
        rus: "\u0428\u043B\u0435\u043C \u0433\u043B\u0430\u0448\u0430\u0442\u0430\u044F",
        pol: "He\u0142m herolda",
        sch: "\u5148\u950B\u4E4B\u76D4",
        fre: "Casque de h\xe9raut",
        bra: "O Elmo do Mensageiro",
        schema: 30769,
        hun: "A H\xedrn\xf6k Sisakja",
        swe: "H\xe4roldens hj\xe4lm"
    },
    1119: {
        img: "gauzed_gaze",
        eng: "Gauzed Gaze",
        rus: "\u0412\u0437\u0433\u043B\u044F\u0434 \u0438\u0437 \u0432\u0430\u0442\u044B",
        pol: "Gazowe gogle",
        sch: "\u8499\u9762\u795E\u533B",
        fre: "Masque chirurgical",
        bra: "O Olhar do Cirurgi\xe3o",
        schema: 30786,
        hun: "A F\xe1slis F\xfcrk\xe9sz",
        swe: "Narkosl\xe4karens nylle"
    },
    1120: {
        img: "lurking_legionnaire",
        eng: "The Lurking Legionnaire",
        rus: "\u0421\u043A\u0440\u044B\u0442\u044B\u0439 \u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C",
        pol: "Czyhaj\u0105cy legionista",
        sch: "\u5916\u7C4D\u519B\u56E2\u7684\u519B\u88C5",
        fre: "Tenue du l\xe9gionnaire",
        bra: "O Legion\xe1rio Ladino",
        schema: 30777,
        hun: "A Lopakod\xf3 L\xe9gi\xf3s",
        swe: "Lurande legion\xe4ren"
    },
    1121: {
        img: "patriots_pouches",
        eng: "Patriot's Pouches",
        rus: "\u041A\u0430\u043F\u0440\u0430\u043B\u044C\u0441\u043A\u0438\u0435 \u043A\u0430\u0440\u043C\u0430\u0448\u043A\u0438",
        pol: "\u0141adownica patrioty",
        sch: "\u7231\u56FD\u8005\u7684\u5F39\u836F\u888B",
        fre: "\xc9quipement du patriote",
        bra: "Os Bolsos do Patriota",
        schema: 30780,
        hun: "A Hazafias Hordt\xe1sk\xe1k",
        swe: "Fosterlandsv\xe4nnens fickor"
    },
    1122: {
        img: "dad_duds",
        eng: "Dad Duds",
        rus: "\u041E\u0442\u0446\u043E\u0432\u0441\u043A\u0430\u044F \u043E\u0434\u0435\u0436\u043A\u0430",
        pol: "Ojcowski ciuch",
        sch: "\u5DE5\u7A0B\u8001\u7239\u7684\u683C\u7EB9\u886C\u886B",
        fre: "Chemise \xe0 carreaux",
        bra: "A Camisa do Paiz\xe3o",
        schema: 30785,
        hun: "Az Apuka-hacuka",
        swe: "Pappans Paltor"
    },
    1123: {
        img: "dayjogger",
        eng: "The Dayjogger",
        rus: "\u0414\u043D\u0435\u0432\u043D\u043E\u0439 \u0441\u0442\u0438\u043B\u044F\u0433\u0430",
        pol: "Wieczny biegacz",
        sch: "\u65E5\u884C\u8005",
        fre: "Dayjogger",
        bra: "O Demolidor do Dia",
        schema: 30779,
        hun: "A F\xe9nybenkocog\xf3",
        swe: "Dagjoggaren"
    },
    1124: {
        img: "dead_head",
        eng: "The Dead Head",
        rus: "\u041C\u0435\u0440\u0442\u0432\u043E\u0435 \u043B\u0438\u0446\u043E",
        pol: "Twarzoczaszka",
        sch: "\u65E0\u9762\u4E4B\u4EBA",
        fre: "Masque de mort",
        bra: "A Cabe\xe7a Cadav\xe9rica",
        schema: 30775,
        hun: "A Holtfej",
        swe: "D\xf6dskallen"
    },
    1125: {
        img: "bedouin_bandana",
        eng: "Bedouin Bandana",
        rus: "\u0411\u0435\u0434\u0443\u0438\u043D\u0441\u043A\u0430\u044F \u0431\u0430\u043D\u0434\u0430\u043D\u0430",
        pol: "Bandana Beduina",
        sch: "\u8D1D\u7763\u56E0\u8499\u9762\u5934\u5DFE",
        fre: "Bandana b\xe9douin",
        bra: "A Bandana do Bedu\xedno",
        schema: 30768,
        hun: "A Beduin Fejkend\u0151",
        swe: "Beduinsk bandana"
    },
    1126: {
        img: "sandvich",
        eng: "The Sandvich",
        rus: "\u0411\u0443\u0442\u0435\u0440\u0431\u0440\u043E\u0434",
        pol: "Kanapka",
        sch: "\u4E09\u660E\u6CBB",
        fre: "Le Sandvich",
        bra: "O Sandviche",
        schema: 42,
        hun: "A Szendvics",
        swe: "Sm\xf6rgosen"
    },
    1127: {
        img: "quickiebomb_launcher",
        eng: "The Quickiebomb Launcher",
        rus: "\u0411\u044B\u0441\u0442\u0440\u043E\u043C\u0451\u0442",
        pol: "Wyrzutnik szybkobomb",
        sch: "\u5FEB\u901F\u9ECF\u5F39\u53D1\u5C04\u5668",
        fre: "Le Lanceur de Bombes rapides",
        bra: "O Lan\xe7a-R\xe1pibombs",
        schema: 1150,
        hun: "A Gyorsbomba-vet\u0151",
        swe: "Kvickbombsskjutaren"
    },
    1128: {
        img: "back_scatter",
        eng: "The Back Scatter",
        rus: "\u0421\u043F\u0438\u043D\u043E\u0431\u0440\u0435\u0437",
        pol: "Dupelt\xf3wka",
        sch: "\u5077\u88AD\u4E4B\u529B",
        fre: "Le Back Scatter",
        bra: "A Fuziladora de Costas",
        schema: 1103,
        hun: "A H\xe1trepeszt\u0151",
        swe: "Ryggsplittraren"
    },
    1129: {
        img: "panic_attack",
        eng: "The Panic Attack",
        rus: "\u041F\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0430\u0442\u0430\u043A\u0430",
        pol: "Atak paniki",
        sch: "\u6050\u614C\u6253\u51FB",
        fre: "La Crise de Panique",
        bra: "O Ataque de P\xe2nico",
        schema: 1153,
        hun: "A P\xe1nikroham",
        swe: "Panikattacken"
    },
    1130: {
        img: "iron_bomber",
        eng: "The Iron Bomber",
        rus: "\u0416\u0435\u043B\u0435\u0437\u043D\u044B\u0439 \u0431\u043E\u043C\u0431\u0430\u0440\u0434\u0438\u0440",
        pol: "\u017Belazny bombardier",
        sch: "\u94C1\u5F39\u53D1\u5C04\u5668",
        fre: "Le Canonneur",
        bra: "O Bombardeiro de Ferro",
        schema: 1151,
        hun: "A Vas Bomb\xe1z\xf3",
        swe: "J\xe4rnbombaren"
    },
    1131: {
        img: "showstopper",
        eng: "Showstopper",
        rus: "\u0413\u0432\u043E\u0437\u0434\u044C \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B",
        pol: "fajerwerki",
        sch: "\u70DF\u82B1\u8868\u6F14",
        fre: "Clou du spectacle",
        bra: "Fim de show",
        schema: 30797,
        hun: "\xdcnnepront\xf3",
        swe: "Showstoppare"
    },
    1132: {
        img: "mad_mask",
        eng: "Mad Mask",
        rus: "\u0411\u0435\u0437\u0443\u043C\u043D\u044B\u0439 \u0432 \u043C\u0430\u0441\u043A\u0435",
        pol: "Mad maska",
        sch: "\u75AF\u72C2\u9762\u5177",
        fre: "Mad Mask",
        bra: "M\xe1scara da Loucura",
        schema: 30815,
        hun: "Mad Maszk"
    },
    1133: {
        img: "surgeons_sidearms",
        eng: "The Surgeon's Sidearms",
        rus: "\u042D\u043A\u0438\u043F\u0438\u0440\u043E\u0432\u043A\u0430 \u044D\u0441\u043A\u0443\u043B\u0430\u043F\u0430",
        pol: "Przybornik chirurga",
        sch: "\u5916\u79D1\u533B\u751F\u7684\u5C0F\u5DE5\u5177",
        fre: "Armes de poing du chirurgien",
        bra: "As Ferramentas do Cirurgi\xe3o",
        schema: 30813,
        hun: "Az Orvos Oldalfegyverei",
        swe: "Sjukv\xe5rdarens sidovapen"
    },
    1134: {
        img: "nasty_norsemann",
        eng: "Nasty Norsemann",
        rus: "\u041D\u0435\u0441\u043D\u043E\u0441\u043D\u044B\u0439 \u043D\u043E\u0440\u043C\u0430\u043D\u043D",
        pol: "Gro\u017Any nord",
        sch: "\u5317\u6B27\u725B\u89D2\u76D4",
        fre: "Vil viking",
        bra: "N\xf3rdico Nefasto",
        schema: 30810,
        hun: "Gal\xe1d Normann",
        swe: "Nedsmutsad Nordmann"
    },
    1135: {
        img: "colossal_cranium",
        eng: "Colossal Cranium",
        rus: "\u0427\u0443\u0434\u043E\u0432\u0438\u0449\u043D\u044B\u0439 \u0447\u0435\u0440\u0435\u043F",
        pol: "Kolosalna \u0142ysina",
        sch: "\u5DE8\u578B\u5149\u5934",
        fre: "Bo\xeete cr\xe2nienne colossale",
        bra: "Cr\xe2nio Colossal",
        schema: 30792,
        hun: "Kolossz\xe1lis Koponya",
        swe: "Kolossalt Kranium"
    },
    1136: {
        img: "el_paso_poncho",
        eng: "The El Paso Poncho",
        rus: "\u041F\u043E\u043D\u0447\u043E \u042D\u043B\u044C-\u041F\u0430\u0441\u043E",
        pol: "Ponczo el paso",
        sch: "\u5E15\u7D22\u7684\u6BDB\u8863",
        fre: "Le El Paso Poncho",
        bra: "El Paso Poncho",
        schema: 30804,
        hun: "Az El Paso Poncs\xf3",
        swe: "El Paso-ponchon"
    },
    1137: {
        img: "spooktacles",
        eng: "Spooktacles",
        rus: "\u0422\u0440\u0435\u043F\u0435\u0441\u043A\u043E\u043F\u044B",
        pol: "Strasznokulary",
        sch: "\u9AB7\u9AC5\u58A8\u955C",
        fre: "Luneffrayantes",
        bra: "Horripil\xf3culos",
        schema: 30801,
        hun: "R\xe9m\xfcveg",
        swe: "Skr\xe4ckglas\xf6gon"
    },
    1138: {
        img: "wide_brimmed_bandito",
        eng: "The Wide-Brimmed Bandito",
        rus: "\u0428\u0438\u0440\u043E\u043A\u043E\u043F\u043E\u043B\u044B\u0439 \u0431\u0430\u043D\u0434\u0438\u0442\u0442\u043E",
        pol: "Bandyckie sombrero",
        sch: "\u5BBD\u8FB9\u58A8\u897F\u54E5\u5E3D",
        fre: "Le Bandito \xe0 larges bords",
        bra: "O Bandido de Aba Larga",
        schema: 30805,
        hun: "A Sz\xe9les Sombrero",
        swe: "Bredbr\xe4ttad bandito"
    },
    1139: {
        img: "cranial_carcharodon",
        eng: "The Cranial Carcharodon",
        rus: "\u0410\u043A\u0443\u043B\u044C\u0435 \u0442\u0435\u043C\u044F",
        pol: "Czaszkowy megalodon",
        sch: "\u9CA8\u9C7C\u5934\u5957",
        fre: "Le carcharodon cr\xe2nien",
        bra: "O Carcharodon Craniano",
        schema: 30800,
        hun: "A Fejc\xe1pa",
        swe: "Huvudhajen"
    },
    1140: {
        img: "wing_mann",
        eng: "The Wing Mann",
        rus: "\u041A\u0443\u0440\u043E\u043C\u0430\u043D\u043D",
        pol: "Skrzyde\u0142kowy",
        sch: "\u9E21\u7FC5\u5927\u4FA0",
        fre: "Le Mann ail\xe9",
        bra: "A Asinha de Frango",
        schema: 30809,
        hun: "A Comb-boss",
        swe: "Vingmannen"
    },
    1141: {
        img: "toadstool_topper",
        eng: "The Toadstool Topper",
        rus: "\u0428\u0430\u043F\u043A\u0430-\u043F\u043E\u0433\u0430\u043D\u043A\u0430",
        pol: "Muchomor czapkog\u0142owy",
        sch: "\u5C0F\u4F63\u5175\u91C7\u8611\u83C7",
        fre: "Chapignon",
        bra: "O Chap\xe9u de Cogumelo",
        schema: 30796,
        hun: "A Gal\xf3cafed\u0151",
        swe: "Svamprikets servit\xf6rshatt"
    },
    1142: {
        img: "spirit_of_the_bombing_past",
        eng: "Spirit of the Bombing Past",
        rus: "\u0414\u0443\u0445 \u0432\u0437\u0440\u044B\u0432\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0448\u043B\u043E\u0433\u043E",
        pol: "Duch wybuchowej przesz\u0142o\u015Bci",
        sch: "\u7206\u7834\u72C2\u9B54",
        fre: "Esprit des anciennes explosions",
        bra: "Espirito das Explos\xf5es Passadas",
        schema: 30807,
        hun: "R\xe9ms\xe9ges Robbant\xf3s R\xe9gm\xfalt",
        swe: "Anden av f\xf6rflutna bombningar"
    },
    1143: {
        img: "corpus_christi_cranium",
        eng: "The Corpus Christi Cranium",
        rus: "\u0422\u0432\u0435\u0440\u0434\u043E\u043B\u043E\u0431\u044B\u0439 \u0442\u0435\u0445\u0430\u0441\u0435\u0446",
        pol: "Corpus Christi cranium",
        sch: "\u5723\u4F53\u4E4B\u9885",
        fre: "Le cr\xe2ne de Corpus Christi",
        bra: "O Cr\xe2nio de Corpus Christi",
        schema: 30806,
        hun: "A Corpus Christi Koponya",
        swe: "Kristi Lekamens kranium"
    },
    1144: {
        img: "heavy_tourism",
        eng: "Heavy Tourism",
        rus: "\u041A\u0440\u0443\u043F\u043D\u043E\u043A\u0430\u043B\u0438\u0431\u0435\u0440\u043D\u044B\u0439 \u0442\u0443\u0440\u0438\u0437\u043C",
        pol: "Grube wakacje",
        sch: "\u8D85\u91CD\u578B\u6E38\u5BA2",
        fre: "Chemise \xe0 fleurs",
        bra: "Turismo Pesado",
        schema: 30803,
        hun: "Turistaoszt\xe1ly-harcos",
        swe: "Tung turism"
    },
    1145: {
        img: "big_topper",
        eng: "Big Topper",
        rus: "\u0426\u0438\u043B\u0438\u043D\u0434\u0440\u0438\u0449\u0435",
        pol: "Wielka szycha",
        sch: "\u9B54\u672F\u5E08\u7684\u9AD8\u5E3D\u5B50",
        fre: "Haut-de-plume",
        bra: "Cartol\xe3o Circense",
        schema: 30798,
        hun: "Kapit\xe1lis Kalap",
        swe: "H\xf6g hatt"
    },
    1146: {
        img: "lil_bitey",
        eng: "Lil' Bitey",
        rus: "\u041F\u043E\u043A\u0443\u0441\u0430\u0448\u043A\u0430",
        pol: "Gacu\u015B",
        sch: "\u5438\u8840\u8759\u8760\u5E3D",
        fre: "P'tite morsure",
        bra: "Mordidinha",
        schema: 30814,
        hun: "Kis Harap\xf3s",
        swe: "Lill-bitarn"
    },
    1147: {
        img: "mohorn",
        eng: "Mo'Horn",
        rus: "\u0418-\u0440\u043E\u0433-\u0435\u0437",
        pol: "Mo-czub",
        sch: "\u706B\u7130\u53D1\u578B",
        fre: "Mo'Horn",
        bra: "Moi'chifre",
        schema: 30812,
        hun: "Kakastar\xe9j",
        swe: "Tjurkam"
    },
    1148: {
        img: "pestering_jester",
        eng: "Pestering Jester",
        rus: "\u0412\u0440\u0435\u0434\u043D\u044B\u0439 \u0448\u0443\u0442",
        pol: "Wnerwiaj\u0105cy b\u0142azen",
        sch: "\u5F04\u81E3\u4E4B\u5E3D",
        fre: "Bouffon badin",
        bra: "Bobo da Corte Importuno",
        schema: 30811,
        hun: "Bosszant\xf3 Bolond",
        swe: "St\xf6rande skojare"
    },
    1149: {
        img: "burly_beast",
        eng: "Burly Beast",
        rus: "\u0414\u0438\u043A\u0438\u0439 \u043D\u0440\u0430\u0432",
        pol: "Muskularna bestia",
        sch: "\u80F8\u6BDB\u602A\u517D",
        fre: "Brute baraqu\xe9e",
        bra: "Besta Corpulenta",
        schema: 30817,
        hun: "D\xf6g\xf6s D\xf6g\xe9sz",
        swe: "V\xe4ldig vilde"
    },
    1150: {
        img: "class_crown",
        eng: "Class Crown",
        rus: "\u041A\u043B\u0430\u0441\u0441\u043E\u0432\u0430\u044F \u043A\u043E\u0440\u043E\u043D\u0430",
        pol: "Korona z klas\u0105",
        sch: "\u4F63\u5175\u4E4B\u51A0",
        fre: "Couronne royale",
        bra: "Coroa de Classe",
        schema: 30808,
        hun: "Kir\xe1lyi Korona",
        swe: "Klasskronan"
    },
    1151: {
        img: "combustible_cutie",
        eng: "Combustible Cutie",
        rus: "\u0413\u043E\u0440\u044E\u0447\u0438\u0439 \u043E\u0447\u0430\u0440\u043E\u0432\u0430\u0448\u043A\u0430",
        pol: "\u0141atwopalny s\u0142odziak",
        sch: "\u706B\u7206\u840C\u7269",
        fre: "Beaut\xe9 combustible",
        bra: "Fofura Combust\xedvel",
        schema: 30799,
        hun: "Lobban\xe9kony Cukipofa",
        swe: "L\xe4ttant\xe4ndlig ljuvhet"
    },
    1152: {
        img: "handy_canes",
        eng: "Handy Canes",
        rus: "\u041A\u0430\u0440\u0430\u043C\u0435\u043B\u044C\u043D\u044B\u0439 \u0437\u0430\u043F\u0430\u0441",
        pol: "Por\u0119czne laski",
        sch: "\u62D0\u6756\u7CD6",
        fre: "Canne \xe0 bombe",
        bra: "Doces Explosivos",
        schema: 30822,
        hun: "\xc9des L\u0151szer",
        swe: "Polkaprydnader"
    },
    1153: {
        img: "readers_choice",
        eng: "Reader's Choice",
        rus: "\u0412\u044B\u0431\u043E\u0440 \u0447\u0438\u0442\u0430\u0442\u0435\u043B\u044F",
        pol: "Nagroda czytelnik\xf3w",
        sch: "\u7779\u8005\u4E4B\u9009",
        fre: "Choix des lecteurs",
        bra: "Escolha do Leitor",
        schema: 30831,
        hun: "Olvas\xf3k V\xe1laszt\xe1sa",
        swe: "L\xe4sarnas val"
    },
    1154: {
        img: "brain_warming_wear",
        eng: "Brain-Warming Wear",
        rus: "\u041C\u043E\u0437\u0433\u043E\u0433\u0440\u0435\u0439\u043A\u0430",
        pol: "M\xf3zgogrzewacz",
        sch: "\u6696\u8111\u6BDB\u7ED2\u5E3D",
        fre: "Couvre-cerveau",
        bra: "O Aquecedor de C\xe9rebros",
        schema: 30827,
        hun: "Agymelenget\u0151 Viselet",
        swe: "Krabbm\xf6ssa"
    },
    1155: {
        img: "packable_provisions",
        eng: "Packable Provisions",
        rus: "\u0420\u0443\u0447\u043D\u043E\u0439 \u0440\u0430\u0437\u0434\u0430\u0442\u0447\u0438\u043A",
        pol: "Pakowalny prowiant",
        sch: "\u968F\u8EAB\u8865\u7ED9\u5668",
        fre: "Provisions de No\xebl",
        bra: "Provis\xf5es Port\xe1teis",
        schema: 30821,
        hun: "T\xe1sk\xe1nyi T\xe1pl\xe1l\xe9k",
        swe: "Packbara Provisioner"
    },
    1156: {
        img: "elf_esteem",
        eng: "Elf Esteem",
        rus: "\u042D\u043B\u044C\u0444\u0438\u0439\u0441\u043A\u043E\u0435 \u044D\u0433\u043E",
        pol: "Elfia estyma",
        sch: "\u9ECF\u5F39\u5C0F\u7CBE\u7075",
        fre: "L'elfet de No\xebl",
        bra: "Elfoestima",
        schema: 30836,
        hun: "Man\xf3s\xe1g",
        swe: "D\xf6dligt alvar"
    },
    1157: {
        img: "sweet_smissmas_sweater",
        eng: "Sweet Smissmas Sweater",
        rus: "\u0428\u043C\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043D\u0441\u043A\u0438\u0439 \u0441\u0432\u0438\u0442\u0435\u0440",
        pol: "S\u0142odzia\u015Bny \u015Bni\u0105teczny sweter",
        sch: "\u751C\u871C\u7684\u5723\u8BDE\u6BDB\u8863",
        fre: "Doux tricot de Smissmas",
        bra: "Suave Su\xe9ter de Natal",
        schema: 30826,
        hun: "Gy\xf6ny\xf6r\u0171 Gal\xe1csonyi Garb\xf3",
        swe: "S\xf6t Smissmastr\xf6ja"
    },
    1158: {
        img: "santarchimedes",
        eng: "Santarchimedes",
        rus: "\u0410\u0440\u0445\u0438\u043C\u0435\u0434 \u041A\u043B\u0430\u0443\u0441",
        pol: "\u015Awi\u0119ty Mikomedes",
        sch: "\u5723\u57FA\u7C73\u5FB7",
        fre: "Paparchim\xe8de",
        bra: "Arquinoeldes",
        schema: 30825,
        hun: "Mikul\xe1d\xe9sz"
    },
    1159: {
        img: "socked_and_loaded",
        eng: "Socked and Loaded",
        rus: "\u0412\u043E\u043E\u0440\u0443\u0436\u0435\u043D \u0438 \u0443\u043A\u0440\u0430\u0448\u0435\u043D",
        pol: "Skarpeta s\u0142odko\u015Bci",
        sch: "\u6B66\u88C5\u4E4B\u889C",
        fre: "Enchauss\xe9, c'est pes\xe9",
        bra: "Meia Munida",
        schema: 30818,
        hun: "Zokniba T\xf6ltve",
        rom: "\xcen\u0219osetat \u0219i \xeenc\u0103rcat",
        swe: "Julstrumpan"
    },
    1160: {
        img: "flammable_favor",
        eng: "Flammable Favor",
        rus: "\u0412\u043E\u0441\u043F\u043B\u0430\u043C\u0435\u043D\u044F\u0435\u043C\u044B\u0439 \u0432\u043E\u0441\u0442\u043E\u0440\u0433",
        pol: "Pal\u0105ca przys\u0142uga",
        sch: "\u6613\u71C3\u4E4B\u793C",
        fre: "Faveur inflammable",
        bra: "Favor Inflam\xe1vel",
        schema: 30819,
        hun: "Meleg Meglepet\xe9s",
        swe: "Brandfarlig g\xe5va"
    },
    1161: {
        img: "bomb_beanie",
        eng: "Bomb Beanie",
        rus: "\u0428\u0430\u043F\u043A\u0430-\u043B\u0438\u043F\u0443\u0447\u043A\u0430",
        pol: "Niesamoprzylepna czapka",
        sch: "\u9ECF\u5F39\u5934\u5957",
        fre: "Boonnet",
        bra: "Touca Bomb\xe1stica",
        schema: 30823,
        hun: "Bombasapka",
        swe: "Bombm\xf6ssa"
    },
    1162: {
        img: "electric_twanger",
        eng: "The Electric Twanger",
        rus: "\u0414\u0440\u0430\u0439\u0432-\u043B\u043E\u043F\u0430\u0442\u0430",
        pol: "Pan elektryk",
        sch: "\u4E09\u6627\u7535\u5F26",
        fre: "La vibration \xe9lectrique",
        bra: "O Suingue El\xe9trico",
        schema: 30824,
        hun: "Az Elektromos Pengetty\u0171",
        swe: "Elguran"
    },
    1163: {
        img: "woolen_warmer",
        eng: "The Woolen Warmer",
        rus: "\u0428\u0435\u0440\u0441\u0442\u044F\u043D\u0430\u044F \u0448\u0430\u043F\u043A\u0430",
        pol: "We\u0142enka ciepe\u0142ka",
        sch: "\u7F8A\u6BDB\u9488\u7EC7\u5E3D",
        fre: "Bonnet de laine",
        bra: "Gorro de L\xe3",
        schema: 30833,
        hun: "Gyapj\xfab\xfara",
        swe: "Ullm\xf6ssa"
    },
    1164: {
        img: "snowwing",
        eng: "Snowwing",
        rus: "\u0421\u043D\u0435\u0433\u043E-\u0441\u043A\u0430\u0442",
        pol: "\u015Aniegolot",
        sch: "\u96EA\u7FFC\u6ED1\u677F",
        fre: "Ailes des neiges",
        bra: "Pranchasa",
        schema: 30820,
        hun: "Sz\xe1rnyboard",
        ger: "Schneewehe"
    },
    1165: {
        img: "pyro_the_flamedeer",
        eng: "Pyro the Flamedeer",
        rus: "\u0417\u0430\u0436\u0438\u0433\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043E\u043B\u0435\u043D\u0435\u043D\u043E\u043A",
        pol: "P\u0142omienifer Pyro",
        sch: "\u706B\u7130\u9A6F\u9E7F",
        fre: "Pyro le cerflamboyant",
        bra: "Pyro, a Rena das Chamas",
        schema: 30835,
        hun: "Pir\xf3, a L\xe1ngszarvas",
        swe: "Eldrenen Pyro"
    },
    1166: {
        img: "head_prize",
        eng: "The Head Prize",
        rus: "\u0413\u043E\u043B\u043E\u0432\u043D\u043E\u0439 \u043F\u0440\u0438\u0437",
        pol: "G\u0142owna nagroda",
        sch: "\u5934\u7B49\u5927\u5956",
        fre: "Renard empaill\xe9",
        bra: "Gorro de Raposa",
        schema: 30838,
        hun: "A Fejd\xedj",
        swe: "Huvudpriset"
    },
    1167: {
        img: "bomber_knight",
        eng: "The Bomber Knight",
        rus: "\u0411\u043E\u043C\u0431\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0440\u044B\u0446\u0430\u0440\u044C",
        pol: "Bombowy rycerz",
        sch: "\u70B8\u5F39\u9A91\u58EB\u5934\u76D4",
        fre: "Le chevalier boum",
        bra: "O Cavaleiro Bombardeiro",
        schema: 30830,
        hun: "A Bombaj\xf3 Lovag",
        swe: "Bombriddaren"
    },
    1168: {
        img: "snowmann",
        eng: "The Snowmann",
        rus: "\u0421\u043D\u0435\u0433\u043E\u0432\u0438\u043A",
        pol: "Ba\u0142wanek",
        sch: "\u66FC\u6069\u96EA\u4EBA\u5E3D",
        fre: "Le Mann de neige",
        bra: "O Mann de Neve",
        schema: 30829,
        hun: "A H\xf3mannus",
        swe: "Sn\xf6mannen"
    },
    1169: {
        img: "airtight_arsonist",
        eng: "Airtight Arsonist",
        rus: "\u0413\u0435\u0440\u043C\u0435\u0442\u0438\u0447\u043D\u043E\u0435 \u0433\u043E\u0440\u0435\u043D\u0438\u0435",
        pol: "Hermetyczny podpalacz",
        sch: "\u6C14\u5BC6\u5F0F\u7EB5\u706B\u72C2\u9762\u7F69",
        fre: "Masque \xe0 oxyg\xe8ne de l'incendiaire",
        bra: "Incendi\xe1rio Impenetr\xe1vel",
        schema: 30859,
        hun: "L\xe9gmentes L\xe1nglovag",
        swe: "Luftt\xe4tt ljushuvud"
    },
    1170: {
        img: "flakcatcher",
        eng: "Flakcatcher",
        rus: "\u0417\u0435\u043D\u0438\u0442\u043D\u044B\u0439 \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A",
        pol: "Flakamizela",
        sch: "\u706B\u529B\u96C6\u4E2D\u80CC\u5FC3",
        fre: "Gilet attrape-balles",
        bra: "Para-Flak",
        schema: 30853,
        hun: "Repeszmell\xe9ny",
        swe: "Splitterf\xe5ngaren"
    },
    1171: {
        img: "airborne_attire",
        eng: "Airborne Attire",
        rus: "\u041F\u0438\u043B\u043E\u0442\u0441\u043A\u0438\u0439 \u043F\u0440\u0438\u043A\u0438\u0434",
        pol: "Powietrzne przyodzienie",
        sch: "\u98DE\u884C\u5458\u5939\u514B",
        fre: "Veste d'aviateur",
        bra: "Adornos do Aviador",
        schema: 30873,
        hun: "Rep\xfcl\u0151s Ruh\xe1zat",
        swe: "Pilotjacka"
    },
    1172: {
        img: "warhood",
        eng: "Warhood",
        rus: "\u0411\u0430\u043D\u0434\u0438\u0442\u0441\u043A\u0438\u0439 \u0434\u043E\u043B\u0433",
        pol: "Kaptur wojenny",
        sch: "\u8499\u9762\u515C\u5E3D",
        fre: "Ch\xe8che de guerre",
        bra: "Capuz de Guerra",
        schema: 30866,
        hun: "Hadicsuklya",
        swe: "Krigsluvan"
    },
    1173: {
        img: "field_practice",
        eng: "Field Practice",
        rus: "\u041F\u043E\u043B\u0435\u0432\u0430\u044F \u043F\u0440\u0430\u043A\u0442\u0438\u043A\u0430",
        pol: "Praktyka polowa",
        sch: "\u6218\u5730\u533B\u751F\u8D1D\u96F7\u5E3D",
        fre: "M\xe9decin de terrain",
        bra: "M\xe9dico Militar",
        schema: 30862,
        hun: "Terepgyakorlat",
        swe: "F\xe4lt\xf6vning"
    },
    1174: {
        img: "head_mounted_double_observatory",
        eng: "Head Mounted Double Observatory",
        rus: "\u041B\u0438\u0446\u0435\u0432\u043E\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u043D\u0430\u0431\u043B\u044E\u0434\u0435\u043D\u0438\u044F",
        pol: "Podw\xf3jne patrza\u0142ki",
        sch: "\u5934\u6234\u5F0F\u53CC\u7B52\u89C2\u6D4B\u5668",
        fre: "Visiolunettes",
        bra: "Biobservat\xf3rio Cranial",
        schema: 30872,
        hun: "Fejre Illeszthet\u0151 Kett\u0151s Obszervat\xf3rium",
        swe: "Huvudmonterat dubbelobservatorium"
    },
    1175: {
        img: "blast_defense",
        eng: "Blast Defense",
        rus: "\u0412\u0437\u0440\u044B\u0432\u043D\u0430\u044F \u043E\u0431\u043E\u0440\u043E\u043D\u0430",
        pol: "Wystrza\u0142owa obrona",
        sch: "\u94A2\u94C1\u9632\u7206\u76D4",
        fre: "Protection du forgeron",
        bra: "Defesa Explosiva",
        schema: 30863,
        hun: "Robban\xe1sv\xe9delem",
        swe: "Bombskyddet"
    },
    1176: {
        img: "upgrade",
        eng: "The Upgrade",
        rus: "\u0423\u043B\u0443\u0447\u0448\u0435\u043D\u0438\u0435",
        pol: "Ulepszenie",
        sch: "\u5347\u7EA7",
        fre: "Am\xe9lioration",
        bra: "Melhoria",
        schema: 30848,
        hun: "Fejleszt\xe9s",
        swe: "Uppgradering"
    },
    1177: {
        img: "speedsters_spandex",
        eng: "Speedster's Spandex",
        rus: "\u0421\u043A\u043E\u0440\u043E\u0441\u0442\u043D\u043E\u0439 \u0441\u043F\u0430\u043D\u0434\u0435\u043A\u0441",
        pol: "Lycra biegacza",
        sch: "\u75BE\u8DD1\u8005\u7684\u80A9\u5E26",
        fre: "Veste du pistard prompt",
        bra: "Tecido Expans\xedvel",
        schema: 30875,
        hun: "A Sz\xe1guld\xf3 Spandexe",
        swe: "Fartd\xe5rens fartdr\xe4kt"
    },
    1178: {
        img: "down_under_duster",
        eng: "Down Under Duster",
        rus: "\u041F\u044B\u043B\u044C\u043D\u0438\u043A-\u043F\u0435\u0440\u0435\u0432\u0435\u0440\u0442\u044B\u0448",
        pol: "P\u0142aszcz z pustkowi",
        sch: "\u906E\u5C18\u98CE\u8863",
        fre: "Manteau antipodal",
        bra: "Espanador Australiano",
        schema: 30856,
        hun: "Ausztr\xe1lca",
        swe: "Kiwi-kappa"
    },
    1179: {
        img: "hawk_eyed_hunter",
        eng: "Hawk-Eyed Hunter",
        rus: "\u041E\u0445\u043E\u0442\u043D\u0438\u0447\u0438\u0439 \u043E\u043A\u0443\u043B\u044F\u0440",
        pol: "Jastrz\u0119biooki \u0142owca",
        sch: "\u9E70\u773C\u730E\u624B",
        fre: "\u0152il de lynx",
        bra: "Olho do Predador",
        schema: 30858,
        hun: "V\xe9rcseszem\u0171 Vad\xe1sz",
        swe: "Skarpsynt skytte"
    },
    1180: {
        img: "messengers_mail_bag",
        eng: "Messenger's Mail Bag",
        rus: "\u041F\u043E\u0447\u0442\u043E\u0432\u044B\u0439 \u043F\u043E\u0441\u044B\u043B\u044C\u043D\u044B\u0439",
        pol: "Listonoszka go\u0144ca",
        sch: "\u4FE1\u4F7F\u90AE\u5305",
        fre: "Sacoche du facteur",
        bra: "Mochila do Mensageiro",
        schema: 30869,
        hun: "A H\xedrn\xf6k Postazs\xe1kja",
        swe: "Brevb\xe4rarens brevv\xe4ska"
    },
    1181: {
        img: "pocket_pauling",
        eng: "Pocket Pauling",
        rus: "\u041A\u0430\u0440\u043C\u0430\u043D\u043D\u0430\u044F \u041F\u043E\u043B\u0438\u043D\u0433",
        pol: "Kieszonkowa Pauling",
        sch: "\u5B9D\u7433\u73A9\u5076",
        fre: "Pauling de poche",
        bra: "Pauling de Bolso",
        schema: 30849,
        hun: "Zseb-Pauling",
        swe: "Fick-Pauling"
    },
    1182: {
        img: "archers_sterling",
        eng: "Archer's Sterling",
        rus: "\u041B\u0443\u0436\u0435\u043D\u044B\u0439 \u043B\u0443\u0447\u043D\u0438\u043A",
        pol: "Niezawodny strzelec",
        sch: "\u5F13\u624B\u7684\u62A4\u9F3B\u5934\u76D4",
        fre: "Archer australien",
        bra: "Arqueiro Certeiro",
        schema: 30874,
        hun: "Kit\u0171n\u0151 \xcdj\xe1szsisak",
        swe: "B\xe5gskyttehj\xe4lm"
    },
    1183: {
        img: "guilden_guardian",
        eng: "Guilden Guardian",
        rus: "\u041F\u0440\u0438\u0434\u0432\u043E\u0440\u043D\u044B\u0439 \u043F\u0430\u0442\u0440\u0443\u043B\u044C",
        pol: "Obro\u0144ca cechu",
        sch: "\u7687\u5BB6\u536B\u961F",
        fre: "Gardien m\xe9di\xe9val",
        bra: "Guardi\xe3o da Guilda",
        schema: 30857,
        hun: "Veretes V\xe9delmez\u0151",
        swe: "Slottets skyddsvakt"
    },
    1184: {
        img: "legendary_lid",
        eng: "Legendary Lid",
        rus: "\u041A\u0440\u0443\u0442\u0430\u044F \u043A\u0430\u0441\u0430",
        pol: "Legendarny dekiel",
        sch: "\u4F20\u5947\u6B66\u58EB\u7684\u6597\u7B20",
        fre: "Casque l\xe9gendaire",
        bra: "O Disco da Dinastia",
        schema: 30868,
        hun: "Legend\xe1s Kalap",
        swe: "Mytomspunnen m\xe4starhatt"
    },
    1185: {
        img: "plumbers_cap",
        eng: "Plumber's Cap",
        rus: "\u0412\u043E\u0434\u043E\u043F\u0440\u043E\u0432\u043E\u0434\u043D\u0430\u044F \u0444\u0443\u0440\u0430\u0436\u043A\u0430",
        pol: "Zestaw hydraulika",
        sch: "\u6C34\u7BA1\u5DE5\u4E4B\u5E3D",
        fre: "Casquette du plombier",
        bra: "Boina di Encanadore",
        schema: 30846,
        hun: "A V\xedzszerel\u0151 Sapk\xe1ja",
        swe: "R\xf6rmokarkeps"
    },
    1186: {
        img: "lightning_lid",
        eng: "The Lightning Lid",
        rus: "\u041C\u043E\u043B\u043D\u0438\u0435\u043D\u043E\u0441\u043D\u0430\u044F \u043C\u0430\u0441\u043A\u0430",
        pol: "Piorunuj\u0105cy czerep",
        sch: "\u95EA\u7535\u4E4B\u76D4",
        fre: "Casque \xe0 \xe9clairs",
        bra: "O Capacete Cin\xe9tico",
        schema: 30867,
        hun: "A Vill\xe1msisak",
        swe: "Blixthuvudet"
    },
    1187: {
        img: "flash_of_inspiration",
        eng: "Flash of Inspiration",
        rus: "\u0412\u0441\u043F\u044B\u0448\u043A\u0430 \u0432\u0434\u043E\u0445\u043D\u043E\u0432\u0435\u043D\u0438\u044F",
        pol: "B\u0142ysk inspiracji",
        sch: "\u7075\u5149\u4E00\u95EA",
        fre: "Tonnerre de Zeus",
        bra: "Fa\xedsca da Inspira\xe7\xe3o",
        schema: 30871,
        hun: "Isteni Szikra",
        swe: "Snilleblixt"
    },
    1188: {
        img: "firemans_essentials",
        eng: "Fireman's Essentials",
        rus: "\u041F\u0440\u0438\u043C\u0435\u0442\u044B \u043F\u043E\u0436\u0430\u0440\u043D\u0438\u043A\u0430",
        pol: "Niezb\u0119dnik stra\u017Caka",
        sch: "\u6D88\u9632\u5458\u7684\u5FC5\u5907\u54C1",
        fre: "Les essentiels du pompier",
        bra: "Ferramentas para Fogo",
        schema: 30900,
        hun: "T\u0171zolt\xf3-alapfelszerel\xe9s",
        swe: "Brandmannens v\xe4sentligheter"
    },
    1189: {
        img: "conaghers_utility_idol",
        eng: "Conaghers' Utility Idol",
        rus: "\u041A\u043E\u043D\u0430\u0433\u0435\u0440\u0441\u043A\u0438\u0439 \u0438\u0434\u043E\u043B \u043F\u043E\u043B\u0435\u0437\u043D\u043E\u0441\u0442\u0438",
        pol: "Bo\u017Cek po\u017Cytku Conaghera",
        sch: "\u5DE5\u7A0B\u4E4B\u795E\u7684\u5851\u50CF",
        fre: "Idole de Conagher",
        bra: "\xcddolo de Utilidades do Conagher",
        schema: 30908,
        hun: "Conagher M\u0171szaki B\xe1lv\xe1nya",
        swe: "Conaghers h\xe4ndiga avbildning"
    },
    1190: {
        img: "pithy_professional",
        eng: "The Pithy Professional",
        rus: "\u041F\u0440\u0438\u0434\u0438\u0440\u0447\u0438\u0432\u044B\u0439 \u043F\u0440\u043E\u0444\u0438",
        pol: "Rdzenny profesjonalista",
        sch: "\u7CBE\u5E72\u7684\u4E13\u4E1A\u4F63\u5175",
        fre: "Salacot",
        bra: "O Profissional de Poucas Palavras",
        schema: 30915,
        hun: "L\xe9nyegret\xf6r\u0151 Szak\xe9rt\u0151",
        swe: "Proffsets tropikhj\xe4lm"
    },
    1191: {
        img: "classy_capper",
        eng: "The Classy Capper",
        rus: "\u0428\u0438\u043A-\u0448\u043B\u044F\u043F\u0430",
        pol: "Klasyczny kapelusznik",
        sch: "\u6C14\u6D3E\u7684\u9A91\u58EB\u5E3D",
        fre: "Le couvre-chef \xe9l\xe9gant",
        bra: "O Ca\xe7ador de Classe",
        schema: 30893,
        hun: "A Klassz Kalap",
        swe: "Stilig skyddare"
    },
    1192: {
        img: "most_dangerous_mane",
        eng: "The Most Dangerous Mane",
        rus: "\u041D\u0435\u0431\u0440\u0438\u0442 \u0438 \u043E\u043F\u0430\u0441\u0435\u043D",
        pol: "Najniebezpieczniejsza naro\u015Bl",
        sch: "\u8D85\u7EA7\u5371\u9669\u7684\u80E1\u987B",
        fre: "La crini\xe8re la plus dangereuse",
        bra: "A Perigos\xedssima Juba",
        schema: 30894,
        hun: "A Legvesz\xe9lyesebb S\xf6r\xe9ny",
        swe: "Den farligaste manen"
    },
    1193: {
        img: "forest_footwear",
        eng: "Forest Footwear",
        rus: "\u0411\u043E\u0442\u0438\u043D\u043A\u0438 \u0434\u043B\u044F \u0431\u0435\u0437\u0434\u043E\u0440\u043E\u0436\u044C\u044F",
        pol: "Obuwie le\u015Bnika",
        sch: "\u4E1B\u6797\u4E4B\u9774",
        fre: "Chaussures foresti\xe8res",
        bra: "Botas Selvagens",
        schema: 30890,
        hun: "Erdei L\xe1braval\xf3",
        swe: "Skogskor"
    },
    1194: {
        img: "shellmet",
        eng: "The Shellmet",
        rus: "\u041F\u0430\u0442\u0440\u043E\u043D-\u043A\u0430\u0441\u043A\u0430",
        pol: "\u0141uskohe\u0142m",
        sch: "\u4E1B\u6797\u8001\u5175\u7684\u5934\u76D4",
        fre: "Le cascrapace",
        bra: "O Cartuchete",
        schema: 30897,
        hun: "A Nagy Kaliber",
        swe: "Djungelhj\xe4lmen"
    },
    1195: {
        img: "attack_packs",
        eng: "Attack Packs",
        rus: "\u0420\u0430\u0437\u0433\u0440\u0443\u0437\u043A\u0430 \u043D\u0430 \u0433\u0443\u0437\u043A\u0430\u0445",
        pol: "Szelki szturmu",
        sch: "\u4F5C\u6218\u88C5\u5177",
        fre: "R\xe9serves militaires",
        bra: "Colete de Combate",
        schema: 30896,
        hun: "T\xe1mad\xf3csomag",
        swe: "Attackfack"
    },
    1196: {
        img: "nuke",
        eng: "Nuke",
        rus: "\u042F\u0434\u0435\u0440\u043D\u044B\u0439 \u0433\u0435\u0440\u0446\u043E\u0433",
        pol: "Ksi\u0105\u017C\u0119",
        sch: "\u516C\u7235\u53D1\u578B",
        fre: "Le Duke",
        bra: "O Corte sem Chiclete",
        schema: 30885,
        hun: "Az Atom",
        ger: "Der Nuke"
    },
    1197: {
        img: "bait_and_bite",
        eng: "Bait and Bite",
        rus: "\u0423\u043B\u043E\u0432 \u0438 \u0443\u043B\u043E\u0432\u043A\u0438",
        pol: "Du\u017Ca sztuka",
        sch: "\u9493\u9C7C\u5DE5\u5177\u5305",
        fre: "App\xe2ts et hame\xe7ons",
        bra: "Peixinho Pescado",
        schema: 30916,
        hun: "Harap\xf3s Csali",
        swe: "Bete och byte"
    },
    1198: {
        img: "riflemans_regalia",
        eng: "Rifleman's Regalia",
        rus: "\u041F\u0440\u0438\u0432\u0438\u043B\u0435\u0433\u0438\u0438 \u043F\u0440\u043E\u0444\u0438",
        pol: "Insygnia strzelca",
        sch: "\u6B65\u67AA\u624B\u519B\u88C5",
        fre: "Tenue du fusilleur",
        bra: "Farda do Franco-Atirador",
        schema: 30895,
        hun: "A Karab\xe9lyos \xc9kess\xe9ge",
        swe: "F\xe4ltj\xe4garens finkl\xe4der"
    },
    1199: {
        img: "croaking_hazard",
        eng: "The Croaking Hazard",
        rus: "\u041B\u044F\u0433\u0443\u0448\u0430\u0447\u044C\u044F \u0443\u0433\u0440\u043E\u0437\u0430",
        pol: "Rechocz\u0105ce niebezpiecze\u0144stwo",
        sch: "\u5371\u9669\u7684\u5471\u5471",
        fre: "Le danger coassant",
        bra: "O Sapo Solid\xe1rio",
        schema: 30881,
        hun: "A Brekeg\u0151 Vesz\xe9ly",
        swe: "Kv\xe4kande faran"
    },
    1200: {
        img: "transparent_trousers",
        eng: "Transparent Trousers",
        rus: "\u041A\u0430\u043C\u0443\u0444\u043B\u044F\u0436\u043D\u044B\u0435 \u043A\u0430\u043B\u044C\u0441\u043E\u043D\u044B",
        pol: "Boj\xf3wki bojownika",
        sch: "\u663E\u800C\u6613\u89C1\u7684\u88E4\u5B50",
        fre: "Pantalons transparents",
        bra: "Cal\xe7as Camufladas",
        schema: 30889,
        hun: "Neml\xe1tsz\xf3 Nadr\xe1g",
        swe: "Kamouflagebyxor"
    },
    1201: {
        img: "d_eye_monds",
        eng: "D-eye-monds",
        rus: "\u0413\u043B\u0430\u0437-\u0430\u043B\u043C\u0430\u0437",
        pol: "B\u0142yskoczki",
        sch: "\u5B9D\u77F3\u4E4B\u773C",
        fre: "D-yeux-mants",
        bra: "Olhos Diamantes",
        schema: 30901,
        hun: "Gy\xe9m\xe1ntszemek",
        swe: "\xd6gonglitter"
    },
    1202: {
        img: "hunter_in_darkness",
        eng: "The Hunter in Darkness",
        rus: "\u041E\u0445\u043E\u0442\u043D\u0438\u043A \u0432\u043E \u0442\u044C\u043C\u0435",
        pol: "Nocny \u0142owca",
        sch: "\u6697\u591C\u730E\u624B",
        fre: "Chasseur de nuit",
        bra: "O Ca\xe7ador Noturno",
        schema: 30877,
        hun: "A S\xf6t\xe9tben Vad\xe1sz\xf3",
        swe: "J\xe4garen i m\xf6rkret"
    },
    1203: {
        img: "tropical_toad",
        eng: "Tropical Toad",
        rus: "\u0416\u0430\u0431\u0430 \u0438\u0437 \u0434\u0436\u0443\u043D\u0433\u043B\u0435\u0439",
        pol: "Tropikalna ropucha",
        sch: "\u70ED\u5E26\u87FE\u870D",
        fre: "Crapaud tropical",
        bra: "Sapo Tropical",
        schema: 30909,
        hun: "Tr\xf3pusi Varangy",
        swe: "Portabel padda"
    },
    1204: {
        img: "jungle_jersey",
        eng: "Jungle Jersey",
        rus: "\u0416\u0430\u043A\u0435\u0442 \u0434\u043B\u044F \u0434\u0436\u0443\u043D\u0433\u043B\u0435\u0439",
        pol: "D\u017Cunglowy d\u017Cersej",
        sch: "\u4E1B\u6797\u6BDB\u7EBF\u886B",
        fre: "Veste foresti\xe8re",
        bra: "Colete Selvagem",
        schema: 30888,
        hun: "Dzsungel\xf6lt\xf6zet",
        swe: "Djungeljacka"
    },
    1205: {
        img: "aztec_aggressor",
        eng: "The Aztec Aggressor",
        rus: "\u0410\u0446\u0442\u0435\u043A\u0441\u043A\u0438\u0439 \u0430\u0433\u0440\u0435\u0441\u0441\u043E\u0440",
        pol: "Aztecki agresor",
        sch: "\u963F\u5179\u7279\u514B\u72C2\u6218\u58EB",
        fre: "L'agresseur azt\xe8que",
        bra: "O Agressor Asteca",
        schema: 30914,
        hun: "Az Azt\xe9k Agresszor",
        swe: "Aztekiska angriparen"
    },
    1206: {
        img: "war_eagle",
        eng: "The War Eagle",
        rus: "\u041E\u0440\u0451\u043B \u0432\u043E\u0439\u043D\u044B",
        pol: "Orze\u0142 wojny",
        sch: "\u6218\u9E70\u56FE\u817E\u9762\u5177",
        fre: "Aigle tiki",
        bra: "A \xc1guia de Guerra",
        schema: 30887,
        hun: "A Harci Sas",
        swe: "Krigs\xf6rnen"
    },
    1207: {
        img: "quizzical_quetzal",
        eng: "Quizzical Quetzal",
        rus: "\u041A\u0440\u0430\u0441\u043E\u0447\u043D\u044B\u0439 \u043A\u0435\u0442\u0446\u0430\u043B\u044C",
        pol: "Dziwaczny kwezal",
        sch: "\u53E4\u602A\u7684\u683C\u67E5\u5C14\u9E1F",
        fre: "Quizzalcoalt",
        bra: "Quetzal Questionador",
        schema: 30878,
        hun: "K\xf6teked\u0151 Kv\xe9z\xe1l",
        swe: "Qacklande Quetzal"
    },
    1208: {
        img: "aloha_apparel",
        eng: "Aloha Apparel",
        rus: "\u041E\u0441\u0442\u0440\u043E\u0432\u043D\u043E\u0435 \u043E\u0431\u043B\u0430\u0447\u0435\u043D\u0438\u0435",
        pol: "\u015Arednia hawajska",
        sch: "\u590F\u5A01\u5937\u886C\u886B",
        fre: "Chemise hawa\xefenne",
        bra: "Colarinho Calorento",
        schema: 30884,
        hun: "Hawaii Hacuka",
        swe: "Semesterskjortan"
    },
    1209: {
        img: "commando_elite",
        eng: "Commando Elite",
        rus: "\u042D\u043B\u0438\u0442\u043D\u044B\u0439 \u043E\u0442\u0440\u044F\u0434",
        pol: "Elitarny komandos",
        sch: "\u7CBE\u82F1\u7279\u79CD\u5175",
        fre: "Commando d'\xe9lite",
        bra: "Capacete do Comando",
        schema: 30912,
        hun: "Elit K\xfcl\xf6n\xedtm\xe9ny",
        swe: "Kommandoelit"
    },
    1210: {
        img: "siberian_tigerstripe",
        eng: "Siberian Tigerstripe",
        rus: "\u0422\u0430\u0451\u0436\u043D\u044B\u0439 \u0442\u0438\u0433\u0440",
        pol: "Tygrys syberyjski",
        sch: "\u897F\u4F2F\u5229\u4E9A\u4E4B\u864E",
        fre: "Uniforme militaire sib\xe9rien",
        bra: "Soldado da Sib\xe9ria",
        schema: 30913,
        hun: "Szib\xe9riai Tigriscs\xedkos",
        swe: "Sibiriska tigerstreck"
    },
    1211: {
        img: "cammy_jammies",
        eng: "The Cammy Jammies",
        rus: "\u0411\u043E\u0435\u0432\u044B\u0435 \u0431\u0440\u044E\u043A\u0438",
        pol: "Pid\u017Cama moro",
        sch: "\u8FF7\u5F69\u4E4B\u88E4",
        fre: "Le pyj' de camouflage",
        bra: "A Farda Parda",
        schema: 30891,
        hun: "Terepmint\xe1s Pizsi",
        swe: "Kamo-pyjamasen"
    },
    1212: {
        img: "deitys_dress",
        eng: "Deity's Dress",
        rus: "\u0421\u0432\u044F\u0449\u0435\u043D\u043D\u044B\u0435 \u0441\u0438\u043C\u0432\u043E\u043B\u044B",
        pol: "Szata b\xf3stwa",
        sch: "\u7FBD\u86C7\u795E\u796D\u670D",
        fre: "Tenue du Quetzalcoatl",
        bra: "A Serpente Incendiada",
        schema: 30902,
        hun: "Isteni Viselet",
        swe: "Gudomskl\xe4dsel"
    },
    1213: {
        img: "sharp_chest_pain",
        eng: "Sharp Chest Pain",
        rus: "\u041E\u0441\u0442\u0440\u0430\u044F \u0431\u043E\u043B\u044C \u0432 \u0433\u0440\u0443\u0434\u0438",
        pol: "K\u0142uj\u0105cy b\xf3l",
        sch: "\u80F8\u53E3\u63D2\u5927\u5200",
        fre: "Douleur aigu\xeb \xe0 la poitrine",
        bra: "Dor Afiada no Peito",
        schema: 30898,
        hun: "Sz\xfar\xf3 Mellkasi F\xe1jdalom",
        swe: "Skarp br\xf6stsm\xe4rta"
    },
    1214: {
        img: "vitals_vest",
        eng: "Vitals Vest",
        rus: "\u0416\u0438\u043B\u0435\u0442 \u0436\u0438\u0437\u043D\u0435\u043B\u044E\u0431\u0430",
        pol: "Kamizelka konieczno\u015Bci",
        sch: "\u533B\u7597\u5FC5\u5907\u54C1\u80CC\u5FC3",
        fre: "Veste du toubib",
        bra: "Colete M\xe9dico",
        schema: 30906,
        hun: "Ment\u0151 Mell\xe9ny",
        swe: "Vitala v\xe4sten"
    },
    1215: {
        img: "battle_boonie",
        eng: "Battle Boonie",
        rus: "\u041F\u0430\u0442\u0440\u0443\u043B\u044C\u043D\u0430\u044F \u043F\u0430\u043D\u0430\u043C\u043A\u0430",
        pol: "Bitewne boonie",
        sch: "\u519B\u533B\u5E03\u5C3C\u5E3D",
        fre: "Couvre-chef m\xe9dical",
        bra: "Chap\xe9u de Selva",
        schema: 30907,
        hun: "Harct\xe9ri Satyek",
        swe: "Stridsboonie"
    },
    1216: {
        img: "heavy_harness",
        eng: "Heavy Harness",
        rus: "\u041F\u0443\u0434\u043E\u0432\u0430\u044F \u043F\u043E\u0440\u0442\u0443\u043F\u0435\u044F",
        pol: "Gruba uprz\u0105\u017C",
        sch: "\u91CD\u578B\u80CC\u5E26",
        fre: "Harnais du Heavy",
        bra: "Arn\xeas do Heavy",
        schema: 30910,
        hun: "G\xe9p\xe1gy\xfas H\xe1m",
        swe: "Heavys h\xe4ngslen"
    },
    1217: {
        img: "fat_mans_field_cap",
        eng: "Fat Man's Field Cap",
        rus: "\u041F\u043E\u043B\u0435\u0432\u0430\u044F \u043A\u0435\u043F\u043A\u0430 \u0442\u043E\u043B\u0441\u0442\u044F\u043A\u0430",
        pol: "Masywna czapka polowa",
        sch: "\u80A5\u4F6C\u7684\u91CE\u6218\u5E3D",
        fre: "Chapeau du replet",
        bra: "Quepe de Campo",
        schema: 30911,
        hun: "K\xf6v\xe9r Ember T\xe1bori Sapk\xe1ja",
        swe: "Feta mannens f\xe4ltm\xf6ssa"
    },
    1218: {
        img: "conspicuous_camouflage",
        eng: "The Conspicuous Camouflage",
        rus: "\u041A\u0440\u0438\u0447\u0430\u0449\u0438\u0439 \u043A\u0430\u043C\u0443\u0444\u043B\u044F\u0436",
        pol: "Ostentacyjny kamufla\u017C",
        sch: "\u5F15\u4EBA\u6CE8\u76EE\u7684\u4F2A\u88C5\u670D",
        fre: "Camouflage remarquable",
        bra: "A Camuflagem Chamativa",
        schema: 30892,
        hun: "A Felt\u0171n\u0151 \xc1lca",
        swe: "I\xf6gonfallande kamouflage"
    },
    1219: {
        img: "feathered_fiend",
        eng: "Feathered Fiend",
        rus: "\u041F\u0435\u0440\u043D\u0430\u0442\u044B\u0439 \u043F\u0440\u043E\u0445\u0432\u043E\u0441\u0442",
        pol: "Pierzasty demon",
        sch: "\u7FBD\u86C7\u795E\u9762\u5177",
        fre: "Heaume du Quetzalcoatl",
        bra: "Esp\xedrito Emplumado",
        schema: 30903,
        hun: "Tollas D\xe9mon",
        swe: "Befj\xe4drad best"
    },
    1220: {
        img: "hot_huaraches",
        eng: "The Hot Huaraches",
        rus: "\u0413\u043E\u0440\u044F\u0447\u0438\u0435 \u0433\u0443\u0430\u0440\u0430\u0447\u0438",
        pol: "Gor\u0105ce sanda\u0142y",
        sch: "\u707C\u70ED\u4EBA\u5B57\u62D6",
        fre: "Huaraches embras\xe9es",
        bra: "O Chinelo Abrasado",
        schema: 30905,
        hun: "A Forr\xf3 Saruk",
        swe: "Varma sandalerna"
    },
    1221: {
        img: "pocket_saxton",
        eng: "Pocket Saxton",
        rus: "\u041A\u0430\u0440\u043C\u0430\u043D\u043D\u044B\u0439 \u0421\u0430\u043A\u0441\u0442\u043E\u043D",
        pol: "Kieszonkowy Saxton",
        sch: "\u53E3\u888B\u8428\u514B\u65AF\u987F",
        fre: "Saxton de poche",
        bra: "Saxton de Bolso",
        schema: 30880,
        hun: "Zseb-Saxton",
        swe: "Fick-Saxton"
    },
    1222: {
        img: "crit_cloak",
        eng: "The Crit Cloak",
        rus: "\u041A\u0440\u0438\u0442-\u043A\u0430\u043F\u044E\u0448\u043E\u043D",
        pol: "Krytyczny kaptur",
        sch: "\u7206\u51FB\u706B\u7BAD\u795E\u6559\u5F92",
        fre: "Voile maya",
        bra: "O Capuz Cr\xedtico",
        schema: 30899,
        hun: "A Krit K\xf6peny",
        swe: "Crithuvan"
    },
    1223: {
        img: "sacrificial_stone",
        eng: "Sacrificial Stone",
        rus: "\u0416\u0435\u0440\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u043A\u0430\u043C\u0435\u043D\u044C",
        pol: "Kamie\u0144 ofiarny",
        sch: "\u732E\u796D\u4E4B\u77F3",
        fre: "Pierre sacrificielle",
        bra: "Pedra Sacrificial",
        schema: 30904,
        hun: "\xc1ldoz\xf3k\u0151",
        swe: "Offersten"
    },
    1224: {
        img: "bananades",
        eng: "Bananades",
        rus: "\u0411\u0430\u043D\u0430\u043D\u043E\u0432\u044B\u0435 \u0431\u043E\u043C\u0431\u044B",
        pol: "Bomby bananowe",
        sch: "\u9999\u8549\u70B8\u5F39",
        fre: "Bananades",
        bra: "Bananadas",
        schema: 30886,
        hun: "Robban\xe1nok",
        swe: "Banater"
    },
    1225: {
        img: "jungle_wreath",
        eng: "Jungle Wreath",
        rus: "\u0412\u0435\u043D\u043E\u043A \u0438\u0437 \u0434\u0436\u0443\u043D\u0433\u043B\u0435\u0439",
        pol: "D\u017Cunglowy wieniec",
        sch: "\u4E1B\u6797\u91CC\u7684\u82B1\u73AF",
        fre: "Couronne de fleurs",
        bra: "Coroa Florestal",
        schema: 30882,
        hun: "Dzsungelkoszor\xfa",
        swe: "Djungelkrans"
    },
    1226: {
        img: "aztec_warrior",
        eng: "The Aztec Warrior",
        rus: "\u0410\u0446\u0442\u0435\u043A\u0441\u043A\u0438\u0439 \u0432\u043E\u0438\u043D",
        pol: "Aztecki wojownik",
        sch: "\u963F\u5179\u7279\u514B\u6218\u76D4",
        fre: "Le guerrier azt\xe8que",
        bra: "O Guerreiro Asteca",
        schema: 30879,
        hun: "Az Azt\xe9k Harcos",
        swe: "Aztekiska Krigaren"
    },
    1227: {
        img: "slithering_scarf",
        eng: "The Slithering Scarf",
        rus: "\u0428\u0438\u043F\u044F\u0449\u0438\u0439 \u0448\u0430\u0440\u0444",
        pol: "Sycz\u0105cy szal",
        sch: "\u5636\u5636\u4F5C\u54CD\u7684\u56F4\u5DFE",
        fre: "L'essarpe",
        bra: "O Cachecol Rastejante",
        schema: 30883,
        hun: "A Sikl\xf3 S\xe1l",
        swe: "Slingrande scarf"
    },
    1228: {
        img: "mannana_peeled_war_paint",
        eng: "Mannana Peeled War Paint",
        rus: '"\u041C\u0430\u043D\u043D\u0430\u043D\u043E\u0432\u0430\u044F \u043A\u043E\u0436\u0443\u0440\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Obrany banan Barwy wojenne",
        sch: "\u66FC\u6069\u9999\u8549 \u6218\u7ED8",
        fre: "Mannanas Peinture de guerre",
        bra: "| Mannana Descascada | Tinta de Guerra",
        schema: 16302,
        hun: "H\xe1mozott Mann\xe1nos Harci fest\xe9s",
        rom: "Mannana Peeled Vopsea de r\u0103zboi",
        swe: "Mannanskalad Krigsf\xe4rg"
    },
    1229: {
        img: "leopard_printed_war_paint",
        eng: "Leopard Printed War Paint",
        rus: '"\u041B\u0435\u043E\u043F\u0430\u0440\u0434\u043E\u0432\u0430\u044F \u0448\u043A\u0443\u0440\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Panterka Barwy wojenne",
        sch: "\u6591\u70B9\u8C79\u7EB9 \u6218\u7ED8",
        fre: "L\xe9opard Peinture de guerre",
        bra: "| Pele de Leopardo | Tinta de Guerra",
        schema: 16310,
        hun: "Leop\xe1rdmint\xe1s Harci fest\xe9s",
        rom: "Leopard Printed Vopsea de r\u0103zboi",
        swe: "Leopardm\xf6nstrad Krigsf\xe4rg"
    },
    1230: {
        img: "tiger_buffed_war_paint",
        eng: "Tiger Buffed War Paint",
        rus: '"\u0422\u0438\u0433\u0440\u043E\u0432\u044B\u0439 \u043E\u043A\u0440\u0430\u0441" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Tygrysi pazur Barwy wojenne",
        sch: "\u8001\u864E\u6761\u7EB9 \u6218\u7ED8",
        fre: "Tigre Peinture de guerre",
        bra: "| Pele de Tigre | Tinta de Guerra",
        schema: 16307,
        hun: "Tigriscs\xedkozott Harci fest\xe9s",
        rom: "Tiger Buffed Vopsea de r\u0103zboi",
        swe: "Tigerputsad Krigsf\xe4rg"
    },
    1231: {
        img: "bamboo_brushed_war_paint",
        eng: "Bamboo Brushed War Paint",
        rus: '"\u0411\u0430\u043C\u0431\u0443\u043A\u043E\u0432\u044B\u0435 \u043C\u0430\u0437\u043A\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Bambusowe krycie Barwy wojenne",
        sch: "\u52BF\u5982\u7834\u7AF9 \u6218\u7ED8",
        fre: "Bambou Peinture de guerre",
        bra: "| Pintura de Bambu | Tinta de Guerra",
        schema: 16306,
        hun: "Bambusszal Bor\xedtott Harci fest\xe9s",
        rom: "Bamboo Brushed Vopsea de r\u0103zboi",
        swe: "Bambuborstad Krigsf\xe4rg"
    },
    1232: {
        img: "anodized_aloha_war_paint",
        eng: "Anodized Aloha War Paint",
        rus: '"\u0410\u043B\u043E\u0445\u0430 \u0432 \u0437\u0430\u043A\u0430\u0442\u0435" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Anodowane aloha Barwy wojenne",
        sch: "\u6930\u6797\u98CE\u5149 \u6218\u7ED8",
        fre: "Aloha Peinture de guerre",
        bra: "| Aloha-diza\xe7\xe3o | Tinta de Guerra",
        schema: 16305,
        hun: "Aloh\xe1san Elox\xe1lt Harci fest\xe9s",
        rom: "Anodized Aloha Vopsea de r\u0103zboi",
        swe: "Anodiserad Aloha Krigsf\xe4rg"
    },
    1233: {
        img: "pina_polished_war_paint",
        eng: "Pi\xf1a Polished War Paint",
        rus: '"\u0418\u0437\u044B\u0441\u043A\u0430\u043D\u043D\u044B\u0439 \u0430\u043D\u0430\u043D\u0430\u0441" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Pi\xf1a colada Barwy wojenne",
        sch: "\u83E0\u841D\u56FE\u6848 \u6218\u7ED8",
        fre: "Pi\xf1a Peinture de guerre",
        bra: "| Aroma de Abacaxi | Tinta de Guerra",
        schema: 16309,
        hun: "Anan\xe1szos Harci fest\xe9s",
        rom: "Pi\xf1a Polished Vopsea de r\u0103zboi",
        swe: "Pi\xf1a-polerad Krigsf\xe4rg"
    },
    1234: {
        img: "croc_dusted_war_paint",
        eng: "Croc Dusted War Paint",
        rus: '"\u041A\u0440\u043E\u043A\u043E\u0434\u0438\u043B\u0438\u0439 \u043E\u0442\u0442\u0435\u043D\u043E\u043A" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Si\u0142a krokodyla Barwy wojenne",
        sch: "\u9CC4\u9C7C\u6C60\u5858 \u6218\u7ED8",
        fre: "Croco Peinture de guerre",
        bra: "| Crocodilos Cromados | Tinta de Guerra",
        schema: 16308,
        hun: "Krokodilos Harci fest\xe9s",
        rom: "Croc Dusted Vopsea de r\u0103zboi",
        swe: "Krokodildammad Krigsf\xe4rg"
    },
    1235: {
        img: "macaw_masked_war_paint",
        eng: "Macaw Masked War Paint",
        rus: '"\u041C\u0430\u0441\u043A\u0430 \u043C\u0430\u043A\u0430\u043E" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Papuzi kamufla\u017C Barwy wojenne",
        sch: "\u91D1\u521A\u9E66\u9E49 \u6218\u7ED8",
        fre: "Ara macao Peinture de guerre",
        bra: "| Disfarce de Arara | Tinta de Guerra",
        schema: 16303,
        hun: "Papag\xe1jbor\xedt\xe1s\xfa Harci fest\xe9s",
        rom: "Macaw Masked Vopsea de r\u0103zboi",
        swe: "Aramaskerad Krigsf\xe4rg"
    },
    1236: {
        img: "yeti_coated_war_paint",
        eng: "Yeti Coated War Paint",
        rus: '"\u041C\u0435\u0445\u043E\u0432\u043E\u0439 \u0439\u0435\u0442\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Sk\xf3ra z yeti Barwy wojenne",
        sch: "\u96EA\u4EBA\u4E4B\u773C \u6218\u7ED8",
        fre: "Y\xe9ti Peinture de guerre",
        bra: "| Revestimento Abomin\xe1vel | Tinta de Guerra",
        schema: 16300,
        hun: "Jetibor\xedt\xe1s\xfa Harci fest\xe9s",
        rom: "Yeti Coated Vopsea de r\u0103zboi",
        swe: "Yetikl\xe4dd Krigsf\xe4rg"
    },
    1237: {
        img: "sax_waxed_war_paint",
        eng: "Sax Waxed War Paint",
        rus: '"\u041B\u043E\u0449\u0451\u043D\u044B\u0439 \u0421\u0430\u043A\u0441\u0442\u043E\u043D" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Z\u0142oty mat Barwy wojenne",
        sch: "\u8428\u514B\u65AF\u987F \u6218\u7ED8",
        fre: "Saxton Peinture de guerre",
        bra: "| Saxton \xe0 Cera | Tinta de Guerra",
        schema: 16304,
        hun: "Saxin Sima Harci fest\xe9s",
        rom: "Sax Waxed Vopsea de r\u0103zboi",
        swe: "Saxvaxad Krigsf\xe4rg"
    },
    1238: {
        img: "park_pigmented_war_paint",
        eng: "Park Pigmented War Paint",
        rus: '"\u041F\u0438\u0433\u043C\u0435\u043D\u0442 \u043F\u0430\u0440\u043A\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Nastr\xf3j parku Barwy wojenne",
        sch: "\u516C\u56ED\u6D77\u62A5 \u6218\u7ED8",
        fre: "Yeti Park Peinture de guerre",
        bra: "| Passeio no Parque | Tinta de Guerra",
        schema: 16301,
        hun: "Parkst\xedlus\xfa Harci fest\xe9s",
        rom: "Park Pigmented Vopsea de r\u0103zboi",
        swe: "Parkpigmenterad Krigsf\xe4rg"
    },
    1239: {
        img: "bloom_buffed_war_paint",
        eng: "Bloom Buffed War Paint",
        rus: '"\u0426\u0432\u0435\u0442\u043E\u0447\u043D\u044B\u0439 \u0433\u043B\u044F\u043D\u0435\u0446" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Kwiecisty rozkwit Barwy wojenne",
        sch: "\u9C9C\u82B1\u76DB\u5F00 \u6218\u7ED8",
        fre: "Floraison Peinture de guerre",
        bra: "| Forro Florido | Tinta de Guerra",
        schema: 17200,
        hun: "Vir\xe1gba Borult Harci fest\xe9s",
        rom: "Bloom Buffed Vopsea de r\u0103zboi",
        swe: "Blomputsad Krigsf\xe4rg"
    },
    1240: {
        img: "cardboard_boxed_war_paint",
        eng: "Cardboard Boxed War Paint",
        rus: '"\u041A\u0430\u0440\u0442\u043E\u043D\u043D\u0430\u044F \u043A\u043E\u0440\u043E\u0431\u043A\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Kartonowe opakowanie Barwy wojenne",
        sch: "\u7EB8\u76D2\u5305\u88F9 \u6218\u7ED8",
        fre: "Emboit\xe9 Peinture de guerre",
        bra: "| Papel\xe3o | Tinta de Guerra",
        schema: 17211,
        hun: "Kartondobozolt Harci fest\xe9s",
        rom: "Cardboard Boxed Vopsea de r\u0103zboi",
        swe: "Kartongl\xe5da Krigsf\xe4rg"
    },
    1241: {
        img: "star_crossed_war_paint",
        eng: "Star Crossed War Paint",
        rus: '"\u0417\u0432\u0451\u0437\u0434\u043D\u0430\u044F \u043E\u0431\u0451\u0440\u0442\u043A\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Gwiezdna podr\xf3\u017C Barwy wojenne",
        sch: "\u7480\u74A8\u661F\u7A7A \u6218\u7ED8",
        fre: "Stellaire Peinture de guerre",
        bra: "| Estrelado | Tinta de Guerra",
        schema: 17208,
        hun: "Rossz Csillagzat\xfa Harci fest\xe9s",
        rom: "Star Crossed Vopsea de r\u0103zboi",
        swe: "Stj\xe4rnkorsad Krigsf\xe4rg"
    },
    1242: {
        img: "merc_stained_war_paint",
        eng: "Merc Stained War Paint",
        rus: '"\u0421\u0438\u043C\u0432\u043E\u043B\u044B \u043D\u0430\u0451\u043C\u043D\u0438\u043A\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Symbol najemnika Barwy wojenne",
        sch: "\u4F63\u5175\u4E4B\u5370 \u6218\u7ED8",
        fre: "Mercenaire Peinture de guerre",
        bra: "| Mercen\xe1rio C\xfabico | Tinta de Guerra",
        schema: 17203,
        hun: "Zsoldfoltos Harci fest\xe9s",
        rom: "Merc Stained Vopsea de r\u0103zboi",
        swe: "Soldatst\xe4nkt Krigsf\xe4rg"
    },
    1243: {
        img: "quack_canvassed_war_paint",
        eng: "Quack Canvassed War Paint",
        rus: '"\u041A\u0440\u044F\u043A\u043D\u0443\u0442\u044B\u0439 \u0443\u0437\u043E\u0440" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Kwacze opowie\u015Bci Barwy wojenne",
        sch: "\u81F4\u547D\u4E4B\u9E2D \u6218\u7ED8",
        fre: "Coincoin Peinture de guerre",
        bra: "| Patos Estam-patos | Tinta de Guerra",
        schema: 17201,
        hun: "Kacs\xe1kkal Tark\xedtott Harci fest\xe9s",
        rom: "Quack Canvassed Vopsea de r\u0103zboi",
        swe: "Kvack-kanvasen Krigsf\xe4rg"
    },
    1244: {
        img: "clover_camod_war_paint",
        eng: "Clover Camo'd War Paint",
        rus: '"\u041A\u043B\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043A\u0430\u043C\u0443\u0444\u043B\u044F\u0436" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Irlandzkie szcz\u0119\u015Bcie Barwy wojenne",
        sch: "\u56DB\u53F6\u8349\u7EB9 \u6218\u7ED8",
        fre: "Porte-bonheur Peinture de guerre",
        bra: "| Camuflagem de Trevos | Tinta de Guerra",
        schema: 17209,
        hun: "L\xf3her\xe9kkel \xc1lc\xe1zott Harci fest\xe9s",
        rom: "Clover Camo'd Vopsea de r\u0103zboi",
        swe: "Kl\xf6verkamouflerad Krigsf\xe4rg"
    },
    1245: {
        img: "pizza_polished_war_paint",
        eng: "Pizza Polished War Paint",
        rus: '"\u041F\u043E\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u043F\u0438\u0446\u0446\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Palce liza\u0107 Barwy wojenne",
        sch: "\u98DF\u6B32\u5927\u632F \u6218\u7ED8",
        fre: "Pizza Peinture de guerre",
        bra: "| Polimento de Pizza | Tinta de Guerra",
        schema: 17206,
        hun: "Pizz\xe1val Pol\xedrozott Harci fest\xe9s",
        rom: "Pizza Polished Vopsea de r\u0103zboi",
        swe: "Pizzapolerad Krigsf\xe4rg"
    },
    1246: {
        img: "kill_covered_war_paint",
        eng: "Kill Covered War Paint",
        rus: '"\u041F\u043E\u0441\u043C\u0435\u0440\u0442\u043D\u044B\u0435 \u0437\u0430\u0441\u0435\u0447\u043A\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Zab\xf3jstwo potwierdzone Barwy wojenne",
        sch: "\u6740\u622E\u523B\u75D5 \u6218\u7ED8",
        fre: "D\xe9nombrement Peinture de guerre",
        bra: "| Contando V\xedtimas | Tinta de Guerra",
        schema: 17204,
        hun: "Gyilokrovott Harci fest\xe9s",
        rom: "Kill Covered Vopsea de r\u0103zboi",
        swe: "Mordt\xe4ckt Krigsf\xe4rg"
    },
    1247: {
        img: "bank_rolled_war_paint",
        eng: "Bank Rolled War Paint",
        rus: '"\u041A\u0440\u0443\u043F\u043D\u044B\u0439 \u043D\u043E\u043C\u0438\u043D\u0430\u043B" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Na bogato Barwy wojenne",
        sch: "\u4E3A\u6240\u6B32\u4E3A \u6218\u7ED8",
        fre: "Billets de banque Peinture de guerre",
        bra: "| Cobertura de C\xe9dulas | Tinta de Guerra",
        schema: 17202,
        hun: "P\xe9nzelt Harci fest\xe9s",
        rom: "Bank Rolled Vopsea de r\u0103zboi",
        swe: "Bankrullad Krigsf\xe4rg"
    },
    1248: {
        img: "bonk_varnished_war_paint",
        eng: "Bonk Varnished War Paint",
        rus: '"\u0413\u0430\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u043F\u043E\u043A\u0440\u044B\u0442\u0438\u0435" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Bonkowo Barwy wojenne",
        sch: "\u8F90\u5C04\u8D85\u6807 \u6218\u7ED8",
        fre: "Bonk Peinture de guerre",
        bra: "| Verniz Bonk | Tinta de Guerra",
        schema: 17207,
        hun: "Poffra F\xe9nyezett Harci fest\xe9s",
        rom: "Bonk Varnished Vopsea de r\u0103zboi",
        swe: "Bonk-lackerad Krigsf\xe4rg"
    },
    1249: {
        img: "dream_piped_war_paint",
        eng: "Dream Piped War Paint",
        rus: '"\u041D\u0435\u0436\u043D\u044B\u0435 \u043C\u0435\u0447\u0442\u044B" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "S\u0142odzia\u015Bne sny Barwy wojenne",
        sch: "\u5E7B\u5883\u4E4B\u7269 \u6218\u7ED8",
        fre: "Rose bonbon Peinture de guerre",
        bra: "| Animais Fofinhos | Tinta de Guerra",
        schema: 17212,
        hun: "V\xe1gy\xe1lmodott Harci fest\xe9s",
        rom: "Dream Piped Vopsea de r\u0103zboi",
        swe: "Dr\xf6mdekor Krigsf\xe4rg"
    },
    1250: {
        img: "freedom_wrapped_war_paint",
        eng: "Freedom Wrapped War Paint",
        rus: '"\u041E\u0431\u0451\u0440\u0442\u043A\u0430 \u0441\u0432\u043E\u0431\u043E\u0434\u044B" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Waleczna wolno\u015B\u0107 Barwy wojenne",
        sch: "\u661F\u6761\u82B1\u7EB9 \u6218\u7ED8",
        fre: "Libertaire Peinture de guerre",
        bra: "| Padr\xe3o Patriota | Tinta de Guerra",
        schema: 17210,
        hun: "Szabads\xe1gba Csomagolt Harci fest\xe9s",
        rom: "Freedom Wrapped Vopsea de r\u0103zboi",
        swe: "Frihetsinslaget Krigsf\xe4rg"
    },
    1251: {
        img: "fire_glazed_war_paint",
        eng: "Fire Glazed War Paint",
        rus: '"\u042F\u0437\u044B\u043A\u0438 \u043F\u043B\u0430\u043C\u0435\u043D\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Glazurowany ogie\u0144 Barwy wojenne",
        sch: "\u70C8\u7130\u4E4B\u7EB9 \u6218\u7ED8",
        fre: "Brasier Peinture de guerre",
        bra: "| Chama Esmaltada | Tinta de Guerra",
        schema: 17205,
        hun: "T\u0171znyalta Harci fest\xe9s",
        rom: "Fire Glazed Vopsea de r\u0103zboi",
        swe: "Eldglaserad Krigsf\xe4rg"
    },
    1252: {
        img: "civic_duty_mk_ii_war_paint",
        eng: "Civic Duty Mk.II War Paint",
        rus: '"\u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u0438\u0439 \u0434\u043E\u043B\u0433, \u0432\u0435\u0440. 2.0" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Obywatelski obowi\u0105zek wz. II Barwy wojenne",
        sch: "\u516C\u6C11\u4E49\u52A1 Mk.II \u6218\u7ED8",
        fre: "Devoir civique Mk.II Peinture de guerre",
        bra: "| Dever Civil Mk.II | Tinta de Guerra",
        schema: 16144,
        hun: "\xc1llampolg\xe1ri K\xf6teless\xe9g, II. sz\xe9ria Harci fest\xe9s",
        rom: "Civic Duty Mk.II Vopsea de r\u0103zboi",
        swe: "Medborgerliga Plikten Mk.II Krigsf\xe4rg"
    },
    1253: {
        img: "civil_servant_mk_ii_war_paint",
        eng: "Civil Servant Mk.II War Paint",
        rus: '"\u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u0438\u0439 \u0432\u0440\u0430\u0447, \u0432\u0435\u0440. 2.0" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "S\u0142u\u017Cba cywilna wz. II Barwy wojenne",
        sch: "\u516C\u4EC6 Mk.II \u6218\u7ED8",
        fre: "Fonctionnaire Mk.II Peinture de guerre",
        bra: "| Servidor P\xfablico Mk.II | Tinta de Guerra",
        schema: 16139,
        hun: "K\xf6ztisztvisel\u0151, II. sz\xe9ria Harci fest\xe9s",
        rom: "Civil Servant Mk.II Vopsea de r\u0103zboi",
        swe: "Statstj\xe4nstemannen Mk.II Krigsf\xe4rg"
    },
    1254: {
        img: "autumn_mk_ii_war_paint",
        eng: "Autumn Mk.II War Paint",
        rus: '"\u041E\u0441\u0435\u043D\u044C, \u0432\u0435\u0440. 2.0" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Jesie\u0144 wz. II Barwy wojenne",
        sch: "\u79CB\u65E5 Mk.II \u6218\u7ED8",
        fre: "Automne Mk.II Peinture de guerre",
        bra: "| Outono Mk.II | Tinta de Guerra",
        schema: 16160,
        hun: "\u0150szi, II. sz\xe9ria Harci fest\xe9s",
        rom: "Autumn Mk.II Vopsea de r\u0103zboi",
        swe: "H\xf6st Mk.II Krigsf\xe4rg"
    },
    1255: {
        img: "plaid_potshotter_mk_ii_war_paint",
        eng: "Plaid Potshotter Mk.II War Paint",
        rus: '"\u041F\u043B\u0435\u0434 \u0432 \u043A\u043B\u0435\u0442\u043E\u0447\u043A\u0443, \u0432\u0435\u0440. 2.0" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Strzelec w krat\u0119 wz. II Barwy wojenne",
        sch: "\u683C\u7EB9\u731B\u51FB\u8005 Mk.II \u6218\u7ED8",
        fre: "Tir \xe0 carreau Mk.II Peinture de guerre",
        bra: "| Saia Mk.II | Tinta de Guerra",
        schema: 16122,
        hun: "Kock\xe1s Kocal\xf6v\xe9sz, II. sz\xe9ria Harci fest\xe9s",
        rom: "Plaid Potshotter Mk.II Vopsea de r\u0103zboi",
        swe: "Pl\xe4dpisten Mk.II Krigsf\xe4rg"
    },
    1256: {
        img: "night_owl_mk_ii_war_paint",
        eng: "Night Owl Mk.II War Paint",
        rus: '"\u041D\u043E\u0447\u043D\u043E\u0439 \u0433\u0443\u043B\u044F\u043A\u0430, \u0432\u0435\u0440. 2.0" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Nocna sowa wz. II Barwy wojenne",
        sch: "\u591C\u67AD Mk.II \u6218\u7ED8",
        fre: "Oiseau de nuit Mk.II Peinture de guerre",
        bra: "| Coruja da Noite Mk.II | Tinta de Guerra",
        schema: 16114,
        hun: "\xc9jjeli Bagoly, II. sz\xe9ria Harci fest\xe9s",
        rom: "Night Owl Mk.II Vopsea de r\u0103zboi",
        swe: "Nattugglan Mk.II Krigsf\xe4rg"
    },
    1257: {
        img: "woodsy_widowmaker_mk_ii_war_paint",
        eng: "Woodsy Widowmaker Mk.II War Paint",
        rus: '"\u041B\u0435\u0441\u043D\u043E\u0439 \u043E\u0432\u0434\u043E\u0432\u0438\u0442\u0435\u043B\u044C, \u0432\u0435\u0440. 2.0" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Lesisty owdawiacz wz. II Barwy wojenne",
        sch: "\u7EDD\u540E\u4E4B\u6728 Mk.II \u6218\u7ED8",
        fre: "Endeuilleur bois\xe9 Mk.II Peinture de guerre",
        bra: "| Viuvadora Verdejante Mk.II | Tinta de Guerra",
        schema: 16113,
        hun: "Erdei \xd6zvegycsin\xe1l\xf3, II. sz\xe9ria Harci fest\xe9s",
        rom: "Woodsy Widowmaker Mk.II Vopsea de r\u0103zboi",
        swe: "Skogens \xc4nkmakare Mk.II Krigsf\xe4rg"
    },
    1258: {
        img: "forest_fire_mk_ii_war_paint",
        eng: "Forest Fire Mk.II War Paint",
        rus: '"\u041B\u0435\u0441\u043D\u043E\u0439 \u043F\u043E\u0436\u0430\u0440, \u0432\u0435\u0440. 2.0" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Le\u015Bny ogie\u0144 wz. II Barwy wojenne",
        sch: "\u68EE\u6797\u4E4B\u706B Mk.II \u6218\u7ED8",
        fre: "Feu de for\xeat Mk.II Peinture de guerre",
        bra: "| Fogo na Floresta Mk.II | Tinta de Guerra",
        schema: 16109,
        hun: "Erd\u0151t\u0171z, II. sz\xe9ria Harci fest\xe9s",
        rom: "Forest Fire Mk.II Vopsea de r\u0103zboi",
        swe: "Skogsbrand Mk.II Krigsf\xe4rg"
    },
    1259: {
        img: "woodland_warrior_mk_ii_war_paint",
        eng: "Woodland Warrior Mk.II War Paint",
        rus: '"\u041B\u0435\u0441\u043D\u043E\u0439 \u0432\u043E\u0438\u0442\u0435\u043B\u044C, \u0432\u0435\u0440. 2.0" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Le\u015Bny wojownik wz. II Barwy wojenne",
        sch: "\u6797\u5730\u6218\u58EB Mk.II \u6218\u7ED8",
        fre: "Va-t-en-guerre des bois Mk.II Peinture de guerre",
        bra: "| Matador do Matagal Mk.II | Tinta de Guerra",
        schema: 16106,
        hun: "Erdei Harcos, II. sz\xe9ria Harci fest\xe9s",
        rom: "Woodland Warrior Mk.II Vopsea de r\u0103zboi",
        swe: "Skogskrigaren Mk.II Krigsf\xe4rg"
    },
    1260: {
        img: "carpet_bomber_mk_ii_war_paint",
        eng: "Carpet Bomber Mk.II War Paint",
        rus: '"\u041A\u043E\u0432\u0440\u043E\u0432\u044B\u0439 \u0431\u043E\u043C\u0431\u0430\u0440\u0434\u0438\u0440\u043E\u0432\u0449\u0438\u043A, \u0432\u0435\u0440. 2.0" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Nalot dywanowy wz. II Barwy wojenne",
        sch: "\u5730\u6BEF\u5F0F\u8F70\u70B8 Mk.II \u6218\u7ED8",
        fre: "Bombardier tapiss\xe9 Mk.II Peinture de guerre",
        bra: "| Arrasa Quarteir\xe3o Mk.II | Tinta de Guerra",
        schema: 16104,
        hun: "Sz\u0151nyegbomb\xe1z\xf3, II. sz\xe9ria Harci fest\xe9s",
        rom: "Carpet Bomber Mk.II Vopsea de r\u0103zboi",
        swe: "Mattbombaren Mk.II Krigsf\xe4rg"
    },
    1261: {
        img: "wrapped_reviver_mk_ii_war_paint",
        eng: "Wrapped Reviver Mk.II War Paint",
        rus: '"\u041E\u0431\u043C\u043E\u0442\u0430\u043D\u043D\u044B\u0439 \u043E\u0436\u0438\u0432\u0438\u0442\u0435\u043B\u044C, \u0432\u0435\u0440. 2.0" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Spakowany o\u017Cywiciel wz. II Barwy wojenne",
        sch: "\u8FF7\u5F69\u6551\u63F4\u8005 Mk.II \u6218\u7ED8",
        fre: "R\xe9surrection emball\xe9e Mk.II Peinture de guerre",
        bra: "| Revivedor Embrulhado Mk.II | Tinta de Guerra",
        schema: 16102,
        hun: "Becsomagolt Fel\xe9leszt\u0151, II. sz\xe9ria Harci fest\xe9s",
        rom: "Wrapped Reviver Mk.II Vopsea de r\u0103zboi",
        swe: "Omlindade \xc5terupplivaren Mk.II Krigsf\xe4rg"
    },
    1262: {
        img: "nutcracker_mk_ii_war_paint",
        eng: "Nutcracker Mk.II War Paint",
        rus: '"\u0429\u0435\u043B\u043A\u0443\u043D\u0447\u0438\u043A, \u0432\u0435\u0440. 2.0" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Dziadek do orzech\xf3w wz. II Barwy wojenne",
        sch: "\u80E1\u6843\u5939\u5B50 Mk.II \u6218\u7ED8",
        fre: "Casse-noix Mk.II Peinture de guerre",
        bra: "| Quebra-Nozes Mk.II | Tinta de Guerra",
        schema: 16161,
        hun: "Di\xf3t\xf6r\u0151, II. sz\xe9ria Harci fest\xe9s",
        rom: "Nutcracker Mk.II Vopsea de r\u0103zboi",
        swe: "N\xf6tkn\xe4pparen Mk.II Krigsf\xe4rg"
    },
    1263: {
        img: "smalltown_bringdown_mk_ii_war_paint",
        eng: "Smalltown Bringdown Mk.II War Paint",
        rus: '"\u041F\u0440\u043E\u0432\u0438\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0430\u0437\u0440\u0443\u0448\u0438\u0442\u0435\u043B\u044C, \u0432\u0435\u0440. 2.0" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Miasteczkowy \u0142omot wz. II Barwy wojenne",
        sch: "\u5937\u5E73\u5C0F\u9547 Mk.II \u6218\u7ED8",
        fre: "Casse-village Mk.II Peinture de guerre",
        bra: "| Vil\xe3o do Vilarejo Mk.II | Tinta de Guerra",
        schema: 16143,
        hun: "Kisv\xe1rosi Ked\xe9lyront\xf3, II. sz\xe9ria Harci fest\xe9s",
        rom: "Smalltown Bringdown Mk.II Vopsea de r\u0103zboi",
        swe: "Ortutpl\xe5naren Mk.II Krigsf\xe4rg"
    },
    1264: {
        img: "macabre_web_mk_ii_war_paint",
        eng: "Macabre Web Mk.II War Paint",
        rus: '"\u041F\u0430\u0443\u0442\u0438\u043D\u0430, \u0432\u0435\u0440. 2.0" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Makabryczna sie\u0107 wz. II Barwy wojenne",
        sch: "\u4EA1\u8005\u4E4B\u7F51 Mk.II \u6218\u7ED8",
        fre: "Toiles macabres Mk.II Peinture de guerre",
        bra: "| Teia Macabra Mk.II | Tinta de Guerra",
        schema: 16163,
        hun: "K\xeds\xe9rteth\xe1l\xf3s, II. sz\xe9ria Harci fest\xe9s",
        rom: "Macabre Web Mk.II Vopsea de r\u0103zboi",
        swe: "Kusligt n\xe4t Mk.II Krigsf\xe4rg"
    },
    1265: {
        img: "iron_wood_mk_ii_war_paint",
        eng: "Iron Wood Mk.II War Paint",
        rus: '"\u0416\u0435\u043B\u0435\u0437\u043D\u043E\u0435 \u0434\u0435\u0440\u0435\u0432\u043E, \u0432\u0435\u0440. 2.0" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Drzewo \u017Celazne wz. II Barwy wojenne",
        sch: "\u94C1\u6728 Mk.II \u6218\u7ED8",
        fre: "Bois m\xe9tallique Mk.II Peinture de guerre",
        bra: "| Madeira de Ferro Mk.II | Tinta de Guerra",
        schema: 16120,
        hun: "Vasfa, II. sz\xe9ria Harci fest\xe9s",
        rom: "Iron Wood Mk.II Vopsea de r\u0103zboi",
        swe: "J\xe4rntr\xe4 Mk.II Krigsf\xe4rg"
    },
    1266: {
        img: "backwoods_boomstick_mk_ii_war_paint",
        eng: "Backwoods Boomstick Mk.II War Paint",
        rus: '"\u041A\u0430\u043C\u0443\u0444\u043B\u044F\u0436\u043D\u044B\u0439 \u043E\u0433\u043D\u0435\u0441\u0442\u0440\u0435\u043B, \u0432\u0435\u0440. 2.0" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Grzmi\u0105cy kij z puszczy wz. II Barwy wojenne",
        sch: "\u8352\u91CE\u795E\u5175 Mk.II \u6218\u7ED8",
        fre: "Fusil de derri\xe8re les fagots Mk.II Peinture de guerre",
        bra: "| Sert\xe3o Mk.II | Tinta de Guerra",
        schema: 16112,
        hun: "Susny\xe1s-s\xf6r\xe9tes, II. sz\xe9ria Harci fest\xe9s",
        rom: "Backwoods Boomstick Mk.II Vopsea de r\u0103zboi",
        swe: "Skogshaglet Mk.II Krigsf\xe4rg"
    },
    1267: {
        img: "masked_mender_mk_ii_war_paint",
        eng: "Masked Mender Mk.II War Paint",
        rus: '"\u0412\u043E\u0435\u043D\u043D\u044B\u0439 \u0432\u0440\u0430\u0447, \u0432\u0435\u0440. 2.0" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Zakamuflowany uzdrowiciel wz. II Barwy wojenne",
        sch: "\u8499\u9762\u8005 Mk.II \u6218\u7ED8",
        fre: "D\xe9pannage masqu\xe9 Mk.II Peinture de guerre",
        bra: "| Medicamento Mascarado Mk.II | Tinta de Guerra",
        schema: 16105,
        hun: "Maszkos Befoltoz\xf3, II. sz\xe9ria Harci fest\xe9s",
        rom: "Masked Mender Mk.II Vopsea de r\u0103zboi",
        swe: "Maskerade Helaren Mk.II Krigsf\xe4rg"
    },
    1268: {
        img: "dead_reckoner_mk_ii_war_paint",
        eng: "Dead Reckoner Mk.II War Paint",
        rus: '"\u0421\u0447\u0438\u0441\u043B\u0438\u0442\u0435\u043B\u044C \u043F\u0443\u0442\u0438, \u0432\u0435\u0440. 2.0" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Trupi zwiad wz. II Barwy wojenne",
        sch: "\u6B7B\u4EA1\u5224\u5B98 Mk.II \u6218\u7ED8",
        fre: "Cible de la mort Mk.II Peinture de guerre",
        bra: "| Cad\xe1ver Calculista Mk.II | Tinta de Guerra",
        schema: 16151,
        hun: "Hal\xe1los Lesz\xe1mol\xf3, II. sz\xe9ria Harci fest\xe9s",
        rom: "Dead Reckoner Mk.II Vopsea de r\u0103zboi",
        swe: "D\xf6da Rannsakaren Mk.II Krigsf\xe4rg"
    },
    1269: {
        img: "bovine_blazemaker_mk_ii_war_paint",
        eng: "Bovine Blazemaker Mk.II War Paint",
        rus: '"\u0411\u044B\u0447\u0438\u0439 \u043F\u043B\u0430\u043C\u0435\u043C\u0451\u0442, \u0432\u0435\u0440. 2.0" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Bawoli podpalacz wz. II Barwy wojenne",
        sch: "\u5976\u725B\u82B1\u7EB9 Mk.II \u6218\u7ED8",
        fre: "Bovin Mk.II Peinture de guerre",
        bra: "| Bovino na Brasa Mk.II | Tinta de Guerra",
        schema: 16130,
        hun: "T\xfczes Teh\xe9n, II. sz\xe9ria Harci fest\xe9s",
        rom: "Bovine Blazemaker Mk.II Vopsea de r\u0103zboi",
        swe: "Oxlika Osaren Mk.II Krigsf\xe4rg"
    },
    1270: {
        img: "blast_blocker",
        eng: "Blast Blocker",
        rus: "\u0421\u0430\u043F\u0451\u0440\u043D\u044B\u0439 \u0441\u043B\u043E\u0439",
        pol: "Pancerz przeciwwybuchowy",
        sch: "\u9632\u7206\u80CC\u5FC3",
        fre: "Gilet pare-bombes",
        bra: "Exploqueio",
        schema: 30945,
        hun: "L\xf6ketfog\xf3",
        swe: "Spr\xe4ngskyddet"
    },
    1271: {
        img: "caribou_companion",
        eng: "The Caribou Companion",
        rus: "\u041E\u0442\u0432\u0430\u0436\u043D\u044B\u0439 \u043E\u043B\u0435\u043D\u044C",
        pol: "Kompan karibu",
        sch: "\u9A6F\u9E7F\u9632\u5BD2\u5E3D",
        fre: "Caribonnet",
        bra: "O Caribu Companheiro",
        schema: 30974,
        hun: "Karibu Koma",
        swe: "Renm\xf6ssa"
    },
    1272: {
        img: "pocket_santa",
        eng: "Pocket Santa",
        rus: "\u041A\u0430\u0440\u043C\u0430\u043D\u043D\u044B\u0439 \u0421\u0430\u043D\u0442\u0430",
        pol: "Kieszonkowy Miko\u0142aj",
        sch: "\u53E3\u888B\u5723\u8BDE\u8001\u4EBA",
        fre: "P\xe8re No\xebl de poche",
        bra: "Noel de Bolso",
        schema: 30972,
        hun: "Zsebmikul\xe1s",
        swe: "Ficktomte"
    },
    1273: {
        img: "down_tundra_coat",
        eng: "Down Tundra Coat",
        rus: "\u041F\u043E\u043B\u044F\u0440\u043D\u044B\u0439 \u043F\u0443\u0445\u043E\u0432\u0438\u043A",
        pol: "Puchowa kurtka",
        sch: "\u51BB\u539F\u9632\u5BD2\u5927\u8863",
        fre: "Veste du sniper de la toundra",
        bra: "Casaco da Tundra",
        schema: 30971,
        hun: "Ny\xe1ri Tundrakab\xe1t",
        swe: "Tundrajacka"
    },
    1274: {
        img: "puffy_polar_cap",
        eng: "Puffy Polar Cap",
        rus: "\u0421\u0442\u0451\u0433\u0430\u043D\u0430\u044F \u0444\u0443\u0440\u0430\u0436\u043A\u0430",
        pol: "Puszysta polarna czapa",
        sch: "\u6781\u5730\u6BDB\u7ED2\u5E3D",
        fre: "Casquette rembourr\xe9e",
        bra: "Bon\xe9 Polar Acolchoado",
        schema: 30958,
        hun: "Pufi Pol\xe1rsapka",
        swe: "Vinterm\xf6ssa"
    },
    1275: {
        img: "polar_bear",
        eng: "Polar Bear",
        rus: "\u041F\u043E\u043B\u044F\u0440\u043D\u044B\u0439 \u043C\u0435\u0434\u0432\u0435\u0434\u044C",
        pol: "Nied\u017Awied\u017A polarny",
        sch: "\u5317\u6781\u5DE8\u718A",
        fre: "Ours polaire",
        bra: "Urso Polar",
        schema: 30964,
        hun: "Jegesmedve",
        swe: "Isbj\xf6rnen"
    },
    1276: {
        img: "sinners_shade",
        eng: "Sinner's Shade",
        rus: "\u0428\u0438\u0440\u043E\u043A\u043E\u043F\u043E\u043B\u044B\u0439 \u0433\u0440\u0435\u0448\u043D\u0438\u043A",
        pol: "Grzeszny grubas",
        sch: "\u7F6A\u8005\u4E4B\u955C",
        fre: "Duelliste au soleil",
        bra: "Sombra do Pecador",
        schema: 30959,
        hun: "A K\xf6t\xe9lreval\xf3 Kalapja",
        swe: "Syndarens solskydd"
    },
    1277: {
        img: "brass_bucket",
        eng: "Brass Bucket",
        rus: "\u0411\u0440\u043E\u043D\u0437\u043E\u0432\u0430\u044F \u0431\u0430\u0434\u044C\u044F",
        pol: "Rakietowy wiadrog\u0142owy",
        sch: "\u706B\u7BAD\u5341\u5B57\u76D4",
        fre: "Heaume du suzerain",
        bra: "O Balde de Bronze",
        schema: 30969,
        hun: "R\xe9zv\xf6d\xf6r",
        swe: "M\xe4ssingshj\xe4lm"
    },
    1278: {
        img: "pocket_yeti",
        eng: "Pocket Yeti",
        rus: "\u041A\u0430\u0440\u043C\u0430\u043D\u043D\u044B\u0439 \u0439\u0435\u0442\u0438",
        pol: "Kieszonkowy yeti",
        sch: "\u53E3\u888B\u96EA\u4EBA",
        fre: "Y\xe9ti de poche",
        bra: "Yeti de Bolso",
        schema: 30929,
        hun: "Zsebjeti",
        swe: "Fickyeti"
    },
    1279: {
        img: "truckers_topper",
        eng: "Trucker's Topper",
        rus: "\u041A\u0435\u043F\u043A\u0430 \u0434\u0430\u043B\u044C\u043D\u043E\u0431\u043E\u0439\u0449\u0438\u043A\u0430",
        pol: "Typowy tirowiec",
        sch: "\u5361\u8F66\u53F8\u673A\u5E3D",
        fre: "Casquette du routier",
        bra: "Bon\xe9 do Caminhoneiro",
        schema: 30930,
        hun: "Kik\xf6p\xf6tt Kamionos",
        swe: "Truckerkepsen"
    },
    1280: {
        img: "sledders_sidekick",
        eng: "Sledder's Sidekick",
        rus: "\u041F\u043E\u043C\u043E\u0449\u043D\u0438\u043A \u043F\u043E\u043B\u044F\u0440\u043D\u0438\u043A\u0430",
        pol: "Psi pomocnik",
        sch: "\u96EA\u6A47\u5C0F\u4F19\u4F34",
        fre: "Copain canin",
        bra: "O Amigo do Ombro",
        schema: 30923,
        hun: "Sz\xe1nk\xf3pajt\xe1s",
        swe: "Sl\xe4df\xf6rarens s\xe4llskap"
    },
    1281: {
        img: "wild_west_whiskers",
        eng: "Wild West Whiskers",
        rus: "\u0414\u0438\u043A\u043E \u0437\u0430\u043F\u0430\u0434\u043D\u044B\u0435 \u0443\u0441\u044B",
        pol: "Bardzo dzikie bokobrody",
        sch: "\u72C2\u91CE\u897F\u90E8\u80E1\u987B",
        fre: "Moustache du Far West",
        bra: "Bigode do Velho Oeste",
        schema: 30960,
        hun: "Al\xe1val\xf3 Arcsz\u0151rzet",
        swe: "Vilda v\xe4sternsk\xe4gg"
    },
    1282: {
        img: "coldfront_commander",
        eng: "Coldfront Commander",
        rus: "\u0421\u043D\u0435\u0436\u043D\u044B\u0439 \u0441\u043E\u043B\u0434\u0430\u0442",
        pol: "Dow\xf3dca z zimnego frontu",
        sch: "\u4E25\u5BD2\u6218\u7EBF\u6307\u6325\u5B98",
        fre: "Visi\xe8re du front froid",
        bra: "Comandante Frente Fria",
        schema: 30939,
        hun: "Coldfront Parancsnok",
        swe: "Kallfrontkaptenen"
    },
    1283: {
        img: "burning_beanie",
        eng: "Burning Beanie",
        rus: "\u041F\u043B\u0430\u043C\u0435\u043D\u043D\u0430\u044F \u0448\u0430\u043F\u043A\u0430",
        pol: "Dogrzany dekiel",
        sch: "\u70C8\u7130\u9020\u578B\u65E0\u8FB9\u5E3D",
        fre: "Bonnet chauffant",
        bra: "Gorro Flamejante",
        schema: 30936,
        hun: "T\xfczes T\xf6kf\xf6d\u0151",
        swe: "Het hatt"
    },
    1284: {
        img: "melody_of_misery",
        eng: "Melody of Misery",
        rus: "\u0417\u0432\u0443\u043A\u0438 \u0437\u043B\u043E\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0439",
        pol: "Melodia m\u0119ki",
        sch: "\u60B2\u60E8\u4E4B\u58F0",
        fre: "M\xe9lodie de mis\xe8re",
        bra: "Melodia da Mis\xe9ria",
        schema: 30973,
        hun: "Szenved\xe9s Szimf\xf3nia",
        swe: "Mis\xe4rens melodi"
    },
    1285: {
        img: "handsome_hitman",
        eng: "The Handsome Hitman",
        rus: "\u041D\u0435\u043E\u0442\u0440\u0430\u0437\u0438\u043C\u044B\u0439 \u043D\u0430\u0451\u043C\u043D\u0438\u043A",
        pol: "Zniewalaj\u0105cy zab\xf3jca",
        sch: "\u98CE\u6D41\u6740\u624B",
        fre: "S\xe9ducteur \xe0 gages",
        bra: "Assassino Bonit\xe3o",
        schema: 30955,
        hun: "J\xf3k\xe9p\u0171 J\xe9gretev\u0151",
        swe: "Tjusig torped"
    },
    1286: {
        img: "cats_pajamas",
        eng: "The Cat's Pajamas",
        rus: "\u041A\u043E\u0448\u0430\u0447\u0438\u0439 \u043A\u043E\u043C\u0431\u0438\u043D\u0435\u0437\u043E\u043D",
        pol: "Koci kostium",
        sch: "\u732B\u8033\u7761\u8863",
        fre: "Pychama",
        bra: "Pijama de Gatinho",
        schema: 30937,
        hun: "Cicapizsi",
        swe: "Kattens pyjamas"
    },
    1287: {
        img: "coldfront_carapace",
        eng: "Coldfront Carapace",
        rus: "\u0421\u043D\u0435\u0436\u043D\u044B\u0439 \u043F\u0430\u043D\u0446\u0438\u0440\u044C",
        pol: "Pancerz z zimnego frontu",
        sch: "\u4E25\u5BD2\u6218\u7EBF\u9632\u62A4\u8863",
        fre: "Attirail du front froid",
        bra: "Carapa\xe7a Frente Fria",
        schema: 30940,
        hun: "Coldfront P\xe1nc\xe9l",
        swe: "K\xf6ldskyddet"
    },
    1288: {
        img: "hungover_hero",
        eng: "Hungover Hero",
        rus: "\u041F\u043E\u0445\u043C\u0435\u043B\u044C\u043D\u044B\u0439 \u0433\u0435\u0440\u043E\u0439",
        pol: "Mro\u017Cone mamrotanie",
        sch: "\u5BBF\u9189\u82F1\u96C4",
        fre: "Gueule de bois",
        bra: "Her\xf3i de Ressaca",
        schema: 30954,
        hun: "M\xe1snapos H\u0151s",
        swe: "Superdr\xe4kten"
    },
    1289: {
        img: "balloonihoodie",
        eng: "Balloonihoodie",
        rus: "\u041D\u0430\u0434\u0443\u0432\u043D\u043E\u0448\u043E\u043D",
        pol: "Balonokaptur",
        sch: "\u6C14\u7403\u72EC\u89D2\u517D\u515C\u5E3D",
        fre: "Ballicapuche",
        bra: "Capuznic\xf3rnio",
        schema: 30928,
        hun: "Kapucnikornis",
        swe: "Ballonghuva"
    },
    1290: {
        img: "geometrical_teams_war_paint",
        eng: "Geometrical Teams War Paint",
        rus: '"\u0413\u0435\u043E\u043C\u0435\u0442\u0440\u0438\u044F \u043A\u043E\u043C\u0430\u043D\u0434" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Geometria Barwy wojenne",
        sch: "\u51E0\u4F55\u56FE\u6848 \u6218\u7ED8",
        fre: "G\xe9om\xe9trie Peinture de guerre",
        bra: "| Formas Geom\xe9tricas | Tinta de Guerra",
        schema: 17215,
        hun: "Geometriai csapatok Harci fest\xe9s",
        rom: "Geometrical Teams Vopsea de r\u0103zboi",
        swe: "Geometriska lag Krigsf\xe4rg"
    },
    1291: {
        img: "bomber_soul_war_paint",
        eng: "Bomber Soul War Paint",
        rus: '"\u0414\u0443\u0448\u0430 \u0438\u0441\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u044F" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Dusza bombardiera Barwy wojenne",
        sch: "\u9AD8\u7A7A\u8F70\u70B8 \u6218\u7ED8",
        fre: "Militaire Peinture de guerre",
        bra: "| Alma do Bombardeiro | Tinta de Guerra",
        schema: 17217,
        hun: "Bomb\xe1z\xf3 l\xe9lek Harci fest\xe9s",
        rom: "Bomber Soul Vopsea de r\u0103zboi",
        swe: "Flygplanspl\xe5t Krigsf\xe4rg"
    },
    1292: {
        img: "polar_surprise_war_paint",
        eng: "Polar Surprise War Paint",
        rus: '"\u041F\u043E\u043B\u044F\u0440\u043D\u044B\u0439 \u0441\u044E\u0440\u043F\u0440\u0438\u0437" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Polarna niespodzianka Barwy wojenne",
        sch: "\u5723\u8BDE\u840C\u7269 \u6218\u7ED8",
        fre: "Ours polaire Peinture de guerre",
        bra: "| Surpresa Polar | Tinta de Guerra",
        schema: 17221,
        hun: "Sarkvid\xe9ki meglepet\xe9s Harci fest\xe9s",
        rom: "Polar Surprise Vopsea de r\u0103zboi",
        swe: "Nordpolspresent Krigsf\xe4rg"
    },
    1293: {
        img: "cabin_fevered_war_paint",
        eng: "Cabin Fevered War Paint",
        rus: '"\u041A\u043B\u0430\u0443\u0441\u0442\u0440\u043E\u0444\u043E\u0431\u0438\u044F" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "L\u015Bnienie Barwy wojenne",
        sch: "\u5E7D\u95ED\u6050\u60E7 \u6218\u7ED8",
        fre: "Hexagone Peinture de guerre",
        bra: "| Claustrofobia | Tinta de Guerra",
        schema: 17220,
        hun: "Bez\xe1rts\xe1g Harci fest\xe9s",
        rom: "Cabin Fevered Vopsea de r\u0103zboi",
        swe: "Klaustrofobi Krigsf\xe4rg"
    },
    1294: {
        img: "alien_tech_war_paint",
        eng: "Alien Tech War Paint",
        rus: '"\u0412\u043D\u0435\u0437\u0435\u043C\u043D\u044B\u0435 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Technologia obcych Barwy wojenne",
        sch: "\u5916\u661F\u79D1\u6280 \u6218\u7ED8",
        fre: "Extraterrestre Peinture de guerre",
        bra: "| Tecnologia Alien\xedgena | Tinta de Guerra",
        schema: 17232,
        hun: "F\xf6ld\xf6nk\xedv\xfcli technol\xf3gia Harci fest\xe9s",
        rom: "Alien Tech Vopsea de r\u0103zboi",
        swe: "Alienteknologi Krigsf\xe4rg"
    },
    1295: {
        img: "dovetailed_war_paint",
        eng: "Dovetailed War Paint",
        rus: '"\u0413\u043E\u043B\u0443\u0431\u044F\u0442\u043D\u044F" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Go\u0142\u0119bie serce Barwy wojenne",
        sch: "\u963F\u57FA\u7C73\u5FB7 \u6218\u7ED8",
        fre: "Plumes d'Archim\xe8de Peinture de guerre",
        bra: "| Pombos | Tinta de Guerra",
        schema: 17224,
        hun: "Fecskefarkas Harci fest\xe9s",
        rom: "Dovetailed Vopsea de r\u0103zboi",
        swe: "Duvflock Krigsf\xe4rg"
    },
    1296: {
        img: "damascus_and_mahogany_war_paint",
        eng: "Damascus & Mahogany War Paint",
        rus: '"\u0421\u0442\u0430\u043B\u044C \u0438 \u0434\u0435\u0440\u0435\u0432\u043E" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Stal damasce\u0144ska i maho\u0144 Barwy wojenne",
        sch: "\u5927\u9A6C\u58EB\u9769 \u6218\u7ED8",
        fre: "Damascus et Mahogany Peinture de guerre",
        bra: "| Damasco e Mogno | Tinta de Guerra",
        schema: 17234,
        hun: "Damaszkusz \xe9s mahag\xf3ni Harci fest\xe9s",
        rom: "Damascus & Mahogany Vopsea de r\u0103zboi",
        swe: "Damaskus och mahogny Krigsf\xe4rg"
    },
    1297: {
        img: "hazard_warning_war_paint",
        eng: "Hazard Warning War Paint",
        rus: '"\u0423\u0433\u0440\u043E\u0437\u0430 \u0436\u0438\u0437\u043D\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Zagro\u017Cenie \u015Brodowiskowe Barwy wojenne",
        sch: "\u5371\u9669\u8B66\u544A \u6218\u7ED8",
        fre: "Danger Peinture de guerre",
        bra: "| Aviso de Perigo | Tinta de Guerra",
        schema: 17226,
        hun: "Vesz\xe9lyjelz\xe9s Harci fest\xe9s",
        rom: "Hazard Warning Vopsea de r\u0103zboi",
        swe: "Varningsm\xf6nster Krigsf\xe4rg"
    },
    1298: {
        img: "neo_tokyo_war_paint",
        eng: "Neo Tokyo War Paint",
        rus: '"\u041D\u0435\u043E-\u0422\u043E\u043A\u0438\u043E" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Neo Tokio Barwy wojenne",
        sch: "\u65B0\u4E1C\u4EAC\u90FD \u6218\u7ED8",
        fre: "Neo Tokyo Peinture de guerre",
        bra: "| Neo Tokyo | Tinta de Guerra",
        schema: 17214,
        hun: "Neo Tokyo Harci fest\xe9s",
        rom: "Neo Tokyo Vopsea de r\u0103zboi",
        swe: "Neo Tokyo Krigsf\xe4rg"
    },
    1299: {
        img: "uranium_war_paint",
        eng: "Uranium War Paint",
        rus: '"\u0423\u0440\u0430\u043D" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Uran Barwy wojenne",
        sch: "\u6838\u5B50\u52A8\u529B \u6218\u7ED8",
        fre: "Uranium Peinture de guerre",
        bra: "| Ur\xe2nio | Tinta de Guerra",
        schema: 17218,
        hun: "Ur\xe1n Harci fest\xe9s",
        rom: "Uranium Vopsea de r\u0103zboi",
        swe: "Uranium Krigsf\xe4rg"
    },
    1300: {
        img: "hana_war_paint",
        eng: "Hana War Paint",
        rus: '"\u0426\u0432\u0435\u0442\u0435\u043D\u0438\u0435" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Hana Barwy wojenne",
        sch: "\u5BD2\u6885\u76DB\u5F00 \u6218\u7ED8",
        fre: "Hana Peinture de guerre",
        bra: "| Hana | Tinta de Guerra",
        schema: 17223,
        hun: "Hana Harci fest\xe9s",
        rom: "Hana Vopsea de r\u0103zboi",
        swe: "Hana Krigsf\xe4rg"
    },
    1301: {
        img: "cosmic_calamity_war_paint",
        eng: "Cosmic Calamity War Paint",
        rus: '"\u041A\u043E\u0441\u043C\u043E\u0443\u0433\u0440\u043E\u0437\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Kosmiczna katastrofa Barwy wojenne",
        sch: "\u5B87\u5B99\u707E\u96BE \u6218\u7ED8",
        fre: "Cosmos Peinture de guerre",
        bra: "| Calamidade C\xf3smica | Tinta de Guerra",
        schema: 17225,
        hun: "Kozmikus felfordul\xe1s Harci fest\xe9s",
        rom: "Cosmic Calamity Vopsea de r\u0103zboi",
        swe: "Kosmisk katastrof Krigsf\xe4rg"
    },
    1302: {
        img: "mosaic_war_paint",
        eng: "Mosaic War Paint",
        rus: '"\u041C\u043E\u0437\u0430\u0438\u043A\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Mozaika Barwy wojenne",
        sch: "\u53E4\u5178\u5DE5\u827A \u6218\u7ED8",
        fre: "Mosa\xefque Peinture de guerre",
        bra: "| Mosaico | Tinta de Guerra",
        schema: 17228,
        hun: "Mozaik Harci fest\xe9s",
        rom: "Mosaic Vopsea de r\u0103zboi",
        swe: "Mosaik Krigsf\xe4rg"
    },
    1303: {
        img: "jazzy_war_paint",
        eng: "Jazzy War Paint",
        rus: '"\u0414\u0436\u0430\u0437" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Bajer Barwy wojenne",
        sch: "\u53D8\u5E7B\u4E4B\u8272 \u6218\u7ED8",
        fre: "Jazzy Peinture de guerre",
        bra: "| Jazz | Tinta de Guerra",
        schema: 17230,
        hun: "Dzsesszes Harci fest\xe9s",
        rom: "Jazzy Vopsea de r\u0103zboi",
        swe: "Jazzig Krigsf\xe4rg"
    },
    1304: {
        img: "miami_element_war_paint",
        eng: "Miami Element War Paint",
        rus: '"\u042D\u043B\u0435\u043C\u0435\u043D\u0442 \u041C\u0430\u0439\u0430\u043C\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Klimat Miami Barwy wojenne",
        sch: "\u4E94\u5F69\u50CF\u7D20 \u6218\u7ED8",
        fre: "Miami Peinture de guerre",
        bra: "| Elemento Miami | Tinta de Guerra",
        schema: 17213,
        hun: "A Miami-t\xe9nyez\u0151 Harci fest\xe9s",
        rom: "Miami Element Vopsea de r\u0103zboi",
        swe: "Miamim\xf6nster Krigsf\xe4rg"
    },
    1305: {
        img: "antarctic_eyewear",
        eng: "Antarctic Eyewear",
        rus: "\u0410\u043D\u0442\u0430\u0440\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043E\u0447\u043A\u0438",
        pol: "Szk\u0142a sz\xf3stego kontynentu",
        sch: "\u5357\u6781\u62A4\u76EE\u955C",
        fre: "Lunettes de l'Antarctique",
        bra: "Visual Invernal",
        schema: 30977,
        hun: "Zimank\xf3s Szem\xfcveg",
        swe: "Sydpolsglas\xf6gon"
    },
    1306: {
        img: "assassins_attire",
        eng: "Assassin's Attire",
        rus: "\u0423\u043A\u0440\u0430\u0448\u0435\u043D\u0438\u044F \u0443\u0431\u0438\u0439\u0446\u044B",
        pol: "Szykowny skrytob\xf3jca",
        sch: "\u523A\u6740\u8005\u897F\u88C5",
        fre: "Gentleman assassin",
        bra: "Assassino Aprumado",
        schema: 30989,
        hun: "Orgyilkos \xd6lt\xf6zet",
        swe: "L\xf6nnm\xf6rdarkostym"
    },
    1307: {
        img: "hot_case",
        eng: "The Hot Case",
        rus: "\u041F\u044B\u043B\u043A\u0438\u0439 \u0441\u043B\u0435\u0434\u043E\u043F\u044B\u0442",
        pol: "Gor\u0105ca sprawa",
        sch: "\u70EB\u624B\u795E\u63A2",
        fre: "Inspecteur rouget",
        bra: "Gabardina do Gatuno",
        schema: 30986,
        hun: "Forr\xf3 Nyomon",
        swe: "Hett fall"
    },
    1308: {
        img: "sky_high_fly_guy",
        eng: "Sky High Fly Guy",
        rus: "\u041F\u0438\u043B\u043E\u0442 \u0431\u0435\u0437 \u0437\u0430\u0431\u043E\u0442",
        pol: "Lotnik wysokich lot\xf3w",
        sch: "\u706B\u7BAD\u98DE\u4EBA",
        fre: "L'aviateur",
        bra: "\xc1s dos Ares",
        schema: 30984,
        hun: "Magasr\xf6pt\u0171 Mannus",
        swe: "Idiotpilot"
    },
    1309: {
        img: "tsar_platinum",
        eng: "Tsar Platinum",
        rus: "\u0426\u0430\u0440\u044C-\u043F\u043B\u0430\u0442\u0438\u043D\u0430",
        pol: "Platynowy car",
        sch: "\u767D\u91D1\u6C99\u7687",
        fre: "Tsar platinum",
        bra: "Czar Platinado",
        schema: 30980,
        hun: "C\xe1ri Platina",
        ger: "Zar Platinum"
    },
    1310: {
        img: "head_hedge",
        eng: "The Head Hedge",
        rus: "\u0413\u043E\u043B\u043E\u0432\u043D\u044B\u0435 \u0437\u0430\u0440\u043E\u0441\u043B\u0438",
        pol: "Krzaczasty kamufla\u017C",
        sch: "\u4E1B\u6797\u4F2A\u88C5\u76D4",
        fre: "Haie-de-forme",
        bra: "Arbusto Astuto",
        schema: 30978,
        hun: "Sisaks\xf6v\xe9ny",
        swe: "Huvudbuske"
    },
    1311: {
        img: "tundra_top",
        eng: "The Tundra Top",
        rus: "\u0412\u0435\u0447\u043D\u043E\u043C\u0451\u0440\u0437\u043B\u0430\u044F \u0448\u0430\u043F\u043E\u0447\u043A\u0430",
        pol: "Polarna przykrywka",
        sch: "\u6781\u5730\u6BDB\u7EBF\u5E3D",
        fre: "Bonnet de la toundra",
        bra: "Touca de Tundra",
        schema: 30976,
        hun: "Fagyos Fejfed\u0151",
        swe: "Polarpirka"
    },
    1312: {
        img: "wipe_out_wraps",
        eng: "Wipe Out Wraps",
        rus: "\u041B\u0430\u0432\u0438\u043D\u043D\u0430\u044F \u043A\u0443\u0440\u0442\u043A\u0430",
        pol: "Ocieplane okrycie",
        sch: "\u6ED1\u96EA\u65B0\u624B",
        fre: "Bandages essuie-tout",
        bra: "Agasalho Arrasador",
        schema: 30990,
        hun: "H\xf3viharkab\xe1t",
        swe: "Vurpajacka"
    },
    1313: {
        img: "punks_pomp",
        eng: "Punk's Pomp",
        rus: "\u041F\u043E\u043C\u043F\u0435\u0437\u043D\u044B\u0439 \u043F\u0440\u043E\u0439\u0434\u043E\u0445\u0430",
        pol: "Punkowa pomada",
        sch: "\u6D6E\u5938\u7684\u670B\u514B\u53D1\u578B",
        fre: "Pompadour punk",
        bra: "Cabeleira do Cafajeste",
        schema: 30993,
        hun: "Suhanc S\xe9r\xf3",
        swe: "Raggarfrilla"
    },
    1314: {
        img: "starboard_crusader",
        eng: "Starboard Crusader",
        rus: "\u0417\u0432\u0451\u0437\u0434\u043D\u044B\u0439 \u043A\u0440\u0435\u0441\u0442\u043E\u043D\u043E\u0441\u0435\u0446",
        pol: "Gwiezdny krzy\u017Cowiec",
        sch: "\u53F3\u8237\u6597\u58EB",
        fre: "H\xe9ritage du futur",
        bra: "O Capit\xe3o Dito-Kujo",
        schema: 30981,
        hun: "Haj\xf3skapit\xe1ny"
    },
    1315: {
        img: "aristotle",
        eng: "Aristotle",
        rus: "\u0410\u0440\u0438\u0441\u0442\u043E\u0442\u0435\u043B\u044C",
        pol: "Arystoteles",
        sch: "\u9E26\u91CC\u58EB\u591A\u5FB7",
        fre: "Aristote",
        bra: "Arist\xf3teles",
        schema: 30988,
        hun: "Arisztotel\xe9sz",
        swe: "Aristoteles"
    },
    1316: {
        img: "burning_question",
        eng: "The Burning Question",
        rus: "\u0413\u043E\u0440\u044F\u0447\u0438\u0439 \u0441\u043B\u0435\u0434",
        pol: "Pal\u0105ce pytanie",
        sch: "\u707C\u4EBA\u5947\u6848",
        fre: "Question br\xfblante",
        bra: "Interroga\xe7\xe3o Incendi\xe1ria",
        schema: 30987,
        hun: "\xc9get\u0151 K\xe9rd\xe9s",
        swe: "Br\xe4nnande fr\xe5ga"
    },
    1317: {
        img: "veterans_attire",
        eng: "Veteran's Attire",
        rus: "\u041A\u0430\u043C\u0437\u043E\u043B \u0432\u0435\u0442\u0435\u0440\u0430\u043D\u0430",
        pol: "Kurtka kombatanta",
        sch: "\u8001\u5175\u7684\u519B\u670D",
        fre: "La vest\xe9ran",
        bra: "Vestes do Veterano",
        schema: 30983,
        hun: "Veter\xe1n Viselet",
        swe: "Krigsveteranens kl\xe4dsel"
    },
    1318: {
        img: "scourge_of_the_sky",
        eng: "Scourge of the Sky",
        rus: "\u0411\u0438\u0447 \u043D\u0435\u0431\u043E\u0441\u043A\u043B\u043E\u043D\u0430",
        pol: "Nieszcz\u0119\u015Bcie niebosk\u0142onu",
        sch: "\u7A7A\u4E2D\u6D69\u52AB",
        fre: "Appui a\xe9rien",
        bra: "Flagelo dos C\xe9us",
        schema: 30982,
        hun: "\xc9gi Veszedelem",
        swe: "Luftens herre"
    },
    1319: {
        img: "blizzard_britches",
        eng: "Blizzard Britches",
        rus: "\u041C\u0435\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0448\u0442\u0430\u043D\u044B",
        pol: "Zmro\u017Cone wycierusy",
        sch: "\u66B4\u98CE\u6ED1\u96EA\u88E4",
        fre: "Le fute \xe0 peuf",
        bra: "Cal\xe7ados Congelantes",
        schema: 30991,
        hun: "H\xf3viharnadr\xe1g",
        swe: "Sn\xf6ov\xe4dersbyxor"
    },
    1320: {
        img: "cold_case",
        eng: "The Cold Case",
        rus: "\u0417\u0430\u043F\u0430\u0441 \u0445\u043B\u0430\u0434\u043D\u043E\u043A\u0440\u043E\u0432\u0438\u044F",
        pol: "Sch\u0142odzony schowek",
        sch: "\u4FBF\u643A\u5F0F\u5564\u9152\u51B7\u5374\u88C5\u7F6E",
        fre: "R\xe9frig\xe9rateur portatif",
        bra: "Frigobolsa",
        schema: 30992,
        hun: "H\xe1tih\u0171t\u0151",
        swe: "Kylv\xe4ska"
    },
    1321: {
        img: "private_maggot_muncher",
        eng: "Private Maggot Muncher",
        rus: "\u0420\u044F\u0434\u043E\u0432\u043E\u0439 \u0427\u0435\u0440\u0432\u0435\u0433\u043B\u043E\u0442",
        pol: "Szeregowy Larwo\u017Cerca",
        sch: "\u86C6\u866B\u6BC1\u706D\u8005",
        fre: "D\xe9vermineur personnel",
        bra: "\xc1guia Aspira",
        schema: 30985,
        hun: "Kukaccs\xf3cs\xe1l\xf3 K\xf6zleg\xe9ny",
        swe: "Menig mask\xe4tare"
    },
    1322: {
        img: "frag_proof_fragger",
        eng: "The Frag Proof Fragger",
        rus: "\u0412\u0437\u0440\u044B\u0432\u043E\u0437\u0430\u0449\u0438\u0442\u043D\u044B\u0439 \u0432\u0437\u0440\u044B\u0432\u0430\u0442\u0435\u043B\u044C",
        pol: "Os\u0142ona oczodo\u0142\xf3w",
        sch: "\u9632\u7834\u7247\u5934\u76D4",
        fre: "Casque r\xe9solument s\xe9curis\xe9",
        bra: "Bombardeador Antibomba",
        schema: 30979,
        hun: "Bombabiztos Buk\xf3sisak",
        swe: "Skotts\xe4ker skotte"
    },
    1323: {
        img: "robin_walkers",
        eng: "Robin Walkers",
        rus: "\u0421\u043D\u0435\u0433\u0438\u0440\u044C\u0438 \u0442\u0430\u043F\u043E\u0447\u043A\u0438",
        pol: "Ptasie papucie",
        fre: "Charentaises de Robin",
        sch: "Robin Walkers",
        bra: "Pantufas do Robin",
        schema: 30975,
        hun: "Csicseri Pacsker"
    },
    1324: {
        img: "deadbeats",
        eng: "Deadbeats",
        rus: "\u0417\u0432\u0443\u043A\u0438 \u0441\u043C\u0435\u0440\u0442\u0438",
        pol: "\u015Amier\u0107heisery",
        sch: "\u4F4E\u97F3\u81F3\u6B7B",
        fre: "Sono mortelle",
        bra: "Fones de Morrido",
        schema: 30997,
        hun: "Csontf\xfcles",
        swe: "D\xf6dlurar"
    },
    1325: {
        img: "murderers_motif",
        eng: "Murderer's Motif",
        rus: "\u041C\u0430\u0441\u043A\u0430 \u043C\u0430\u043D\u044C\u044F\u043A\u0430",
        pol: "Motyw mordercy",
        sch: "\u6740\u624B\u9762\u5177",
        fre: "Masque de z\xe9ro",
        bra: "Aspecto do Assassino",
        schema: 31016,
        hun: "\xc1lnok \xc1larcos",
        swe: "M\xf6rdarens motiv"
    },
    1326: {
        img: "bandits_boots",
        eng: "Bandit's Boots",
        rus: "\u0411\u043E\u0442\u0438\u043D\u043A\u0438 \u0431\u0430\u043D\u0434\u0438\u0442\u0430",
        pol: "Bandyckie buciska",
        sch: "\u6076\u68CD\u4E4B\u9774",
        fre: "Bottes de bandit",
        bra: "Botas do Bandido",
        schema: 31015,
        hun: "Banditacsizma",
        swe: "Banditst\xf6vlar"
    },
    1327: {
        img: "highway_star",
        eng: "Highway Star",
        rus: "\u0417\u0432\u0435\u0437\u0434\u0430 \u0434\u043E\u0440\u043E\u0433",
        pol: "Kr\xf3l szos",
        sch: "\u516C\u8DEF\u4E4B\u661F",
        fre: "Biker de l'outback",
        bra: "Estrela da Estrada",
        schema: 31010,
        hun: "Orsz\xe1g\xfati Harcos",
        swe: "Motorv\xe4gsstj\xe4rna"
    },
    1328: {
        img: "mann_o_war",
        eng: "Mann-O-War",
        rus: "\u041A\u043E\u0440\u0430\u0431\u043B\u044C \u041C\u0430\u043D\u043D\u0430",
        pol: "Zawzi\u0119ty \u017Ceglarz",
        sch: "\u91CD\u578B\u6D77\u76D7",
        fre: "Corsaire de l'Arctique",
        bra: "Capit\xe3o Mann",
        schema: 31008,
        hun: "Hadihaj\xf3 Kapit\xe1ny",
        swe: "\xd6rlogsmann"
    },
    1329: {
        img: "olympic_leapers",
        eng: "Olympic Leapers",
        rus: "\u041E\u043B\u0438\u043C\u043F\u0438\u0439\u0441\u043A\u0438\u0435 \u043F\u0440\u044B\u0433\u0443\u043D\u044B",
        pol: "Pantofle pos\u0142a\u0144ca",
        sch: "\u5965\u6797\u5339\u4E9A\u4FE1\u4F7F",
        fre: "Sandales d'Herm\xe8s",
        bra: "Saltador Ol\xedmpico",
        schema: 30999,
        hun: "Sz\xe1rnyas Surran\xf3k",
        swe: "Olympiska dojor"
    },
    1330: {
        img: "hephaistos_handcraft",
        eng: "Hephaistos' Handcraft",
        rus: "\u0413\u0435\u0444\u0435\u0441\u0442\u043E\u0432 \u0433\u043E\u043B\u043E\u0432\u043D\u044F\u043A",
        pol: "Chluba Hefajstosa",
        sch: "\u706B\u795E\u4E4B\u76D4",
        fre: "Hoplite bondissant",
        bra: "Elmo de Hefesto",
        schema: 31000,
        hun: "Sp\xe1rtai Sisak",
        swe: "Hefaistos Hantverk"
    },
    1331: {
        img: "vampire_vanquisher",
        eng: "Vampire Vanquisher",
        rus: "\u0413\u0440\u043E\u0437\u0430 \u0432\u0430\u043C\u043F\u0438\u0440\u043E\u0432",
        pol: "Wyganiacz wampir\xf3w",
        sch: "\u5438\u8840\u9B3C\u730E\u4EBA",
        fre: "Terreur des vampires",
        bra: "Carrasco do Conde",
        schema: 31003,
        hun: "V\xe1mp\xedrvad\xe1sz",
        swe: "Vampyrf\xf6rg\xf6raren"
    },
    1332: {
        img: "mini_engy",
        eng: "Mini-Engy",
        rus: "\u041C\u0438\u043D\u0438-\u0438\u043D\u0436\u0435\u043D\u0435\u0440",
        pol: "Miniaturowy In\u017Cynier",
        sch: "\u8FF7\u4F60\u5DE5\u7A0B\u5E08",
        fre: "Enjouetneer",
        bra: "Engizinho",
        schema: 31013,
        hun: "Mini-M\xe9rn\xf6k"
    },
    1333: {
        img: "arachno_arsonist",
        eng: "The Arachno-Arsonist",
        rus: "\u041F\u0430\u0443\u0442\u0438\u043D\u043E\u0436\u0438\u0433\u0430\u0442\u0435\u043B\u044C",
        pol: "Paj\u0119czy podpalacz",
        sch: "\u86DB\u5F62\u7EB5\u706B\u72C2",
        fre: "Cracheur de venin",
        bra: "Piracnofobia",
        schema: 31007,
        hun: "Pirom\xe1n P\xf3kszab\xe1s\xfa",
        swe: "Spindel-pyro-mannen"
    },
    1334: {
        img: "gaelic_glutton",
        eng: "Gaelic Glutton",
        rus: "\u0413\u044D\u043B\u044C\u0441\u043A\u0438\u0439 \u0433\u043B\u043E\u0442\u0430\u0442\u0435\u043B\u044C",
        pol: "Szkocki spa\u015Blak",
        sch: "\u82CF\u683C\u5170\u5927\u80C3\u738B",
        fre: "Glouton ga\xe9lique",
        bra: "Gula Ga\xe9lica",
        schema: 31017,
        hun: "Fal\xe1nk Felf\xf6ldi",
        swe: "Keltisk korpulens"
    },
    1335: {
        img: "dressperado",
        eng: "Dressperado",
        rus: "\u041E\u0442\u0447\u0430\u044F\u043D\u043D\u044B\u0439",
        pol: "Katalo\u0144ski kryminalista",
        sch: "\u66B4\u5F92\u578B\u7537",
        fre: "Renard rus\xe9",
        bra: "Farda do Forasteiro",
        schema: 31014,
        hun: "Trendk\xedv\xfcli"
    },
    1336: {
        img: "pyro_in_chinatown",
        eng: "Pyro in Chinatown",
        rus: "\u041F\u043E\u0434\u0436\u0438\u0433\u0430\u0442\u0435\u043B\u044C \u0432 \u043A\u0438\u0442\u0430\u0439\u0441\u043A\u043E\u043C \u043A\u0432\u0430\u0440\u0442\u0430\u043B\u0435",
        pol: "Pyro w Chinatown",
        sch: "\u9713\u8679\u706F\u9970",
        fre: "Incendiaire de Chinatown",
        bra: "Pyro em Chinatown",
        schema: 31004,
        hun: "Neonl\xe1mp\xe1s Negyed",
        swe: "Pyro i Chinatown"
    },
    1337: {
        img: "athenian_attire",
        eng: "Athenian Attire",
        rus: "\u0410\u0444\u0438\u043D\u0441\u043A\u0438\u0439 \u0430\u0442\u0440\u0438\u0431\u0443\u0442",
        pol: "Grecka garderoba",
        sch: "\u96C5\u5178\u6218\u888D",
        fre: "Habit d'Ath\xe9nien",
        bra: "Adornos Atenienses",
        schema: 31001,
        hun: "G\xf6r\xf6g G\xf6nc",
        swe: "Atensk tunika"
    },
    1338: {
        img: "tank_top",
        eng: "The Tank Top",
        rus: "\u0422\u0430\u043D\u043A\u043E\u0432\u0430\u044F \u0433\u043E\u043B\u043E\u0432\u0430",
        pol: "Czo\u0142owy czo\u0142g",
        sch: "\u88C5\u7532\u4E4B\u5E3D",
        fre: "Chauve d'assaut",
        bra: "Guerra Psicol\xf3gica",
        schema: 31002,
        hun: "Tanksapka",
        swe: "Tankm\xf6ssa"
    },
    1339: {
        img: "aim_assistant",
        eng: "Aim Assistant",
        rus: "\u041F\u043E\u043C\u043E\u0449\u043D\u0438\u043A \u043F\u043E \u043D\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u044E",
        pol: "Asystent celowania",
        sch: "\u6B65\u54E8\u52A9\u7406",
        fre: "Aide \xe0 la vis\xe9e",
        bra: "Senhor Sentinela",
        schema: 31012,
        hun: "C\xe9lz\xe1si Seg\xe9d",
        swe: "Siktesassistent"
    },
    1340: {
        img: "defragmenting_hard_hat_17",
        eng: "Defragmenting Hard Hat 17%",
        rus: "\u0414\u0435\u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044F \u043A\u0430\u0441\u043A\u0438: 17%",
        pol: "Defragmentacja kasku 17%",
        sch: "\u788E\u7247\u6E05\u7406\u5E3D",
        fre: "Casque d\xe9fragment\xe9 \xe0 17 %",
        bra: "Desfragmentando Capacete 17%",
        schema: 31011,
        hun: "Sisakt\xf6redezetts\xe9g-mentes\xedt\xe9s: 17%",
        swe: "Defragmenterar hj\xe4lm 17%"
    },
    1341: {
        img: "terror_antula",
        eng: "Terror-antula",
        rus: "\u0421\u0442\u0440\u0430\u0445\u043E\u0440\u0430\u043D\u0442\u0443\u043B",
        pol: "Terrorantula",
        sch: "\u6050\u6016\u5927\u8718\u86DB",
        fre: "Terreur-tula",
        bra: "Terror-\xe2ntula",
        schema: 30996
    },
    1342: {
        img: "mr_quackers",
        eng: "Mr. Quackers",
        rus: "\u041C\u0438\u0441\u0442\u0435\u0440 \u041A\u0440\u044F\u043A\u0435\u0440\u0441",
        pol: "Pan Kwaczak",
        sch: "\u9E2D\u5634\u9762\u5177",
        fre: "Canard d\xe9cha\xeen\xe9",
        bra: "Patr\xe3o Pat\xe3o",
        schema: 31006,
        hun: "H\xe1pi \xdar",
        swe: "Mr. Kvack"
    },
    1343: {
        img: "lucky_cat_hat",
        eng: "Lucky Cat Hat",
        rus: "\u0423\u0434\u0430\u0447\u043B\u0438\u0432\u0430\u044F \u043A\u043E\u0448\u043A\u043E\u0448\u043B\u044F\u043F\u0430",
        pol: "Mycka manekineko",
        sch: "\u597D\u8FD0\u62DB\u8D22\u732B",
        fre: "Chat-peau porte-bonheur",
        bra: "Gorro do Gato da Sorte",
        schema: 30998,
        hun: "Macskalap",
        swe: "Lyckokatt-hatt"
    },
    1344: {
        img: "haunted_ghosts_war_paint",
        eng: "Haunted Ghosts War Paint",
        rus: '"\u041F\u0440\u0438\u0437\u0440\u0430\u0447\u043D\u044B\u0435 \u043F\u0440\u0438\u0437\u0440\u0430\u043A\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Nawiedzone duchy Barwy wojenne",
        sch: "\u6050\u6016\u9B3C\u9B42 \u6218\u7ED8",
        fre: "Vert de peur Peinture de guerre",
        bra: "| Fantasmas Assombrados | Tinta de Guerra",
        schema: 17236,
        hun: "K\xeds\xe9rteties szellemek Harci fest\xe9s",
        rom: "Haunted Ghosts Vopsea de r\u0103zboi",
        swe: "Hems\xf6kta sp\xf6ken Krigsf\xe4rg"
    },
    1345: {
        img: "totally_boned_war_paint",
        eng: "Totally Boned War Paint",
        rus: '"\u041A\u043E\u0441\u0442\u044F\u0448\u043A\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Ca\u0142kowite skostnienie Barwy wojenne",
        sch: "\u767D\u9AA8\u7D2F\u7D2F \u6218\u7ED8",
        fre: "Paquet d'os Peinture de guerre",
        bra: "| Puro Osso | Tinta de Guerra",
        schema: 17240,
        hun: "Kicsontozva Harci fest\xe9s",
        rom: "Totally Boned Vopsea de r\u0103zboi",
        swe: "Helt benad Krigsf\xe4rg"
    },
    1346: {
        img: "horror_holiday_war_paint",
        eng: "Horror Holiday War Paint",
        rus: '"\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u043A \u0443\u0436\u0430\u0441\u043E\u0432" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Straszne \u015Bwi\u0119ta Barwy wojenne",
        sch: "\u6050\u6016\u5047\u65E5 \u6218\u7ED8",
        fre: "Vacances mortelles Peinture de guerre",
        bra: "| Passeio Pavoroso | Tinta de Guerra",
        schema: 17239,
        hun: "R\xe9m\xfcnnep Harci fest\xe9s",
        rom: "Horror Holiday Vopsea de r\u0103zboi",
        swe: "Skr\xe4ckh\xf6gtid Krigsf\xe4rg"
    },
    1347: {
        img: "spirit_of_halloween_war_paint",
        eng: "Spirit of Halloween War Paint",
        rus: '"\u0414\u0443\u0445 \u0425\u0435\u043B\u043B\u043E\u0443\u0438\u043D\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Duch Halloween Barwy wojenne",
        sch: "\u4E07\u5723\u4E4B\u9B42 \u6218\u7ED8",
        fre: "Esprit d'Halloween Peinture de guerre",
        bra: "| Esp\xedrito de Dia das Bruxas | Tinta de Guerra",
        schema: 17238,
        hun: "Halloweeni hangulat Harci fest\xe9s",
        rom: "Spirit of Halloween Vopsea de r\u0103zboi",
        swe: "Halloweensp\xf6ken Krigsf\xe4rg"
    },
    1348: {
        img: "calavera_canvas_war_paint",
        eng: "Calavera Canvas War Paint",
        rus: '"\u041A\u0430\u043B\u0430\u0432\u0435\u0440\u0441\u043A\u0430\u044F \u043A\u0430\u043D\u0432\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Kolorowa calavera Barwy wojenne",
        sch: "\u4EA1\u7075\u72C2\u6B22 \u6218\u7ED8",
        fre: "Calaveras Peinture de guerre",
        bra: "| Caveiras Coloridas | Tinta de Guerra",
        schema: 17244,
        hun: "Calavera v\xe1szon Harci fest\xe9s",
        rom: "Calavera Canvas Vopsea de r\u0103zboi",
        swe: "Calavera-kanvas Krigsf\xe4rg"
    },
    1349: {
        img: "spectral_shimmered_war_paint",
        eng: "Spectral Shimmered War Paint",
        rus: '"\u041C\u0435\u0440\u0446\u0430\u044E\u0449\u0438\u0435 \u0434\u0443\u0448\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Duchowy b\u0142ysk Barwy wojenne",
        sch: "\u5E7D\u7075\u7F20\u8EAB \u6218\u7ED8",
        fre: "Fant\xf4luminescence Peinture de guerre",
        bra: "| Brilho Espectral | Tinta de Guerra",
        schema: 17237,
        hun: "Szellemesen szipork\xe1z\xf3 Harci fest\xe9s",
        rom: "Spectral Shimmered Vopsea de r\u0103zboi",
        swe: "Sp\xf6kskimmer Krigsf\xe4rg"
    },
    1350: {
        img: "skull_study_war_paint",
        eng: "Skull Study War Paint",
        rus: '"\u0427\u0435\u0440\u0435\u0434\u0430 \u0447\u0435\u0440\u0435\u043F\u043E\u0432" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Czaszkowa krata Barwy wojenne",
        sch: "\u6697\u8272\u9AB7\u9AC5 \u6218\u7ED8",
        fre: "\xc9tude de cr\xe2nes Peinture de guerre",
        bra: "| Estudo Esquel\xe9tico | Tinta de Guerra",
        schema: 17235,
        hun: "Koponyatanulm\xe1ny Harci fest\xe9s",
        rom: "Skull Study Vopsea de r\u0103zboi",
        swe: "D\xf6dskallekontor Krigsf\xe4rg"
    },
    1351: {
        img: "ghost_town_war_paint",
        eng: "Ghost Town War Paint",
        rus: '"\u0413\u043E\u0440\u043E\u0434 \u043F\u0440\u0438\u0437\u0440\u0430\u043A\u043E\u0432" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Miasto duch\xf3w Barwy wojenne",
        sch: "\u9634\u68EE\u4E4B\u57CE \u6218\u7ED8",
        fre: "Ville fant\xf4me | Peinture de guerre",
        bra: "| Cidade Fantasma | Tinta de Guerra",
        schema: 17242,
        hun: "Szellemlakta Harci fest\xe9s",
        rom: "Ghost Town Vopsea de r\u0103zboi",
        swe: "Sp\xf6kstad Krigsf\xe4rg"
    },
    1352: {
        img: "tumor_toasted_war_paint",
        eng: "Tumor Toasted War Paint",
        rus: '"\u041E\u043F\u0443\u0445\u0448\u0435\u0435 \u0442\u0435\u0441\u0442\u043E" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Wypieczone nowotwory Barwy wojenne",
        sch: "\u80BF\u7624\u9644\u4F53 \u6218\u7ED8",
        fre: "Tu meurs Peinture de guerre",
        bra: "| Torrada com Tumor | Tinta de Guerra",
        schema: 17243,
        hun: "Tumoros Harci fest\xe9s",
        rom: "Tumor Toasted Vopsea de r\u0103zboi",
        swe: "Tum\xf6r-toast Krigsf\xe4rg"
    },
    1353: {
        img: "electroshocked_war_paint",
        eng: "Electroshocked War Paint",
        rus: '"\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u0448\u043E\u043A" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Elektrowstrz\u0105s Barwy wojenne",
        sch: "\u7535\u5211\u5904\u51B3 \u6218\u7ED8",
        fre: "\xc9lectrochocs Peinture de guerre",
        bra: "| Eletrochoque | Tinta de Guerra",
        schema: 17241,
        hun: "Delejes Harci fest\xe9s",
        rom: "Electroshocked Vopsea de r\u0103zboi",
        swe: "Elektrochockad Krigsf\xe4rg"
    },
    1354: {
        img: "batters_helmet",
        eng: "Batter's Helmet",
        rus: "\u0411\u0435\u0439\u0441\u0431\u043E\u043B\u044C\u043D\u044B\u0439 \u0448\u043B\u0435\u043C",
        pol: "He\u0142m pa\u0142karza",
        sch: "\u51FB\u7403\u624B\u5934\u76D4",
        fre: "Casque de batteur",
        bra: "Capacete do Rebatedor",
        schema: 52,
        hun: "Baseball-sisak",
        swe: "Slagmanshj\xe4lm"
    },
    1355: {
        img: "bonk_helm",
        eng: "Bonk Helm",
        rus: '\u0428\u043B\u0435\u043C "\u0411\u043E\u043D\u043A"',
        pol: "He\u0142m Bonk",
        sch: "\u996E\u6599\u5934\u76D4",
        fre: "Casque Bonk",
        bra: "Capacete Bonk",
        schema: 106,
        hun: "Poff! Sisak",
        swe: "Bonk-Hj\xe4lm"
    },
    1356: {
        img: "bonk_boy",
        eng: "Bonk Boy",
        rus: "\u0411\u043E\u043D\u043A-\u043F\u0430\u0440\u0435\u043D\u044C",
        pol: "Bonk Boy",
        sch: "\u539F\u5B50\u5C0F\u5B50",
        fre: "Bonk Boy",
        bra: "Garoto Bonk",
        schema: 451,
        hun: "Bonksr\xe1c",
        swe: "Bonk-pojken"
    },
    1357: {
        img: "el_jefe",
        eng: "El Jefe",
        rus: "\u042D\u043B\u044C \u0425\u0435\u0444\u0435",
        pol: "El Jefe",
        sch: "\u9769\u547D\u5BB6\u4E4B\u5E3D",
        fre: "El Jefe",
        bra: "El Jefe",
        schema: 539,
        swe: "Bossen"
    },
    1358: {
        img: "hermes",
        eng: "Hermes",
        rus: "\u0413\u0435\u0440\u043C\u0435\u0441",
        pol: "Hermes",
        sch: "\u8D6B\u8033\u58A8\u65AF\u4E4B\u5E3D",
        fre: "L'Herm\xe8s",
        bra: "O Hermes",
        schema: 633,
        hun: "A Herm\xe9sz",
        ger: "Der G\xf6tterbote"
    },
    1359: {
        img: "soldiers_stash",
        eng: "Soldier's Stash",
        rus: "\u0421\u043E\u043B\u0434\u0430\u0442\u0441\u043A\u0430\u044F \u043A\u0430\u0441\u043A\u0430",
        pol: "Skarb \u017Bo\u0142nierza",
        sch: "\u58EB\u5175\u7684\u732B\u773C\u5E26",
        fre: "Planque du Soldier",
        bra: "Suprimentos do Soldier",
        schema: 54,
        hun: "Katonai v\xe9sztartal\xe9k",
        swe: "Soldatens G\xf6mma"
    },
    1360: {
        img: "stainless_pot",
        eng: "Stainless Pot",
        rus: "\u041A\u0430\u0441\u0442\u0440\u044E\u043B\u044F \u0438\u0437 \u043D\u0435\u0440\u0436\u0430\u0432\u0435\u0439\u043A\u0438",
        pol: "Rondel nierdzewny",
        sch: "\u4E0D\u9508\u9505",
        fre: "Casserole en acier",
        bra: "Panela Inoxid\xe1vel",
        schema: 98,
        hun: "Rohamfaz\xe9k",
        swe: "Rostfri kastrull"
    },
    1361: {
        img: "honchos_headgear",
        eng: "Honcho's Headgear",
        rus: "\u0424\u0443\u0440\u0430\u0436\u043A\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0438\u0440\u0430",
        pol: "Oficerka przyw\xf3dcy",
        sch: "\u9886\u5BFC\u8005\u7684\u519B\u5E3D",
        fre: "La Casquette du Honcho",
        bra: "Acess\xf3rios do Honcho",
        schema: 391,
        hun: "Tisztes T\xe1ny\xe9rsapka",
        swe: "Honchos Huvudbonad"
    },
    1362: {
        img: "brain_bucket",
        eng: "Brain Bucket",
        rus: "\u0417\u0430\u0449\u0438\u0442\u043D\u043E\u0435 \u0432\u0435\u0434\u0440\u043E",
        pol: "Wiadro na m\xf3zg",
        sch: "\u50F5\u5C38\u7684\u94C1\u6876",
        fre: "Seau de Cerveau",
        bra: "Balde de C\xe9rebros",
        schema: 434,
        hun: "Agyv\xf6d\xf6r",
        swe: "Hj\xe4rnhink"
    },
    1363: {
        img: "team_captain",
        eng: "Team Captain",
        rus: "\u041A\u0430\u043F\u0438\u0442\u0430\u043D \u043A\u043E\u043C\u0430\u043D\u0434\u044B",
        pol: "Kapitan brygady",
        sch: "\u56E2\u961F\u9886\u8896\u4E4B\u5E3D",
        fre: "Le Capitaine d'\xc9quipe",
        bra: "O Capit\xe3o da Equipe",
        schema: 378,
        hun: "A Csapatkapit\xe1ny",
        swe: "Lagkaptenen"
    },
    1364: {
        img: "armored_authority",
        eng: "Armored Authority",
        rus: "\u0416\u0435\u043B\u0435\u0437\u043D\u044B\u0439 \u0430\u0432\u0442\u043E\u0440\u0438\u0442\u0435\u0442",
        pol: "Pancerny autorytet",
        sch: "\u5C06\u519B\u7684\u519B\u76D4",
        fre: "Autorit\xe9 Blind\xe9e",
        bra: "Autoridade Blindada",
        schema: 445,
        hun: "Hetyke Hat\xf3s\xe1g",
        swe: "Bepansrad befogenhet"
    },
    1365: {
        img: "jumpers_jeepcap",
        eng: "Jumper's Jeepcap",
        rus: "\u041A\u0435\u043F\u043A\u0430 \u043F\u0440\u044B\u0433\u0443\u043D\u0430",
        pol: "Patrol\xf3wka desantowca",
        sch: "\u4F1E\u5175\u7684\u7F8A\u6BDB\u5E3D",
        fre: "Casquette de parachutiste",
        bra: "Boina do Paraquedista",
        schema: 417,
        hun: "Ejt\u0151erny\u0151s Jeepcap",
        swe: "Hopparens Jeephatt"
    },
    1366: {
        img: "lord_cockswains_pith_helmet",
        eng: "Lord Cockswain's Pith Helmet",
        rus: "\u041A\u043E\u043B\u043E\u043D\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u0448\u043B\u0435\u043C \u043B\u043E\u0440\u0434\u0430 \u041A\u043E\u043A\u0441\u0432\u0435\u0439\u043D\u0430",
        pol: "He\u0142m korkowy lorda Cockswaina",
        sch: "\u8003\u514B\u65AF\u6587\u516C\u7235\u7684\u795E\u6C14\u5934\u76D4",
        fre: "Casque Colonial de Lord Cockswain",
        bra: "Chap\xe9u de Safari do Lorde Cockswain",
        schema: 439,
        hun: "Lord Cockswain Tr\xf3pusi Sisakja",
        swe: "Lord Cockswains tropikhj\xe4lm"
    },
    1367: {
        img: "lucky_shot",
        eng: "Lucky Shot",
        rus: "\u0412\u0435\u0437\u0443\u043D\u0447\u0438\u043A",
        pol: "Szcz\u0119\u015Bliwy traf",
        sch: "\u5E78\u8FD0\u4E00\u51FB",
        fre: "Le Coup de Chance",
        bra: "O Tiro de Sorte",
        schema: 701,
        hun: "A Szerencs\xe9s L\xf6v\xe9s",
        swe: "Lyckotr\xe4ffen"
    },
    1368: {
        img: "conquistador",
        eng: "Conquistador",
        rus: "\u041A\u043E\u043D\u043A\u0438\u0441\u0442\u0430\u0434\u043E\u0440",
        pol: "Konkwistador",
        sch: "\u897F\u73ED\u7259\u5F81\u670D\u8005",
        fre: "Le Conquistador",
        bra: "El Conquistador",
        schema: 721,
        hun: "A Konkviszt\xe1dor",
        swe: "Conquistadoren"
    },
    1369: {
        img: "infernal_impaler",
        eng: "Infernal Impaler",
        rus: "\u0410\u0434\u0441\u043A\u0438\u0439 \u0431\u043E\u0434\u0430\u0442\u0435\u043B\u044C",
        pol: "Piekielny palownik",
        sch: "\u70BC\u72F1\u7A7F\u773C\u9B54",
        fre: "L'Empaleur Infernal",
        bra: "O Empalador Infernal",
        schema: 575,
        hun: "Az \xd6rd\xf6gi \xd6klel\u0151",
        swe: "Dj\xe4vulska Genomborraren"
    },
    1370: {
        img: "pyros_beanie",
        eng: "Pyro's Beanie",
        rus: "\u0428\u0430\u043F\u043E\u0447\u043A\u0430 \u043F\u043E\u0434\u0436\u0438\u0433\u0430\u0442\u0435\u043B\u044F",
        pol: "Wirniczek Pyro",
        sch: "\u706B\u7130\u5175\u7684\u5C0F\u7AE5\u5E3D",
        fre: "Bonnet du Pyro",
        bra: "Pyroc\xf3ptero",
        schema: 51,
        hun: "Pir\xf3 piciny propellere",
        swe: "Pyrons Propellerm\xf6ssa"
    },
    1371: {
        img: "brigade_helm",
        eng: "Brigade Helm",
        rus: "\u0428\u043B\u0435\u043C \u043F\u043E\u0436\u0430\u0440\u043D\u043E\u0433\u043E",
        pol: "He\u0142m brygadzisty",
        sch: "\u519B\u7528\u6D88\u9632\u5934\u76D4",
        fre: "Casque de pompier",
        bra: "Capacete da Brigada",
        schema: 105,
        hun: "T\u0171zolt\xf3siak",
        swe: "Brandmanshj\xe4lm"
    },
    1372: {
        img: "triboniophorus_tyrannus",
        eng: "Triboniophorus Tyrannus",
        rus: "\u0422\u0440\u0438\u0431\u043E\u043D\u0438\u043E\u0444\u043E\u0440\u0443\u0441 \u0422\u0438\u0440\u0430\u043D\u0443\u0441",
        pol: "Triboniophorus Tyrannus",
        sch: "\u61D2\u60F0\u7684\u9F3B\u6D95\u866B",
        fre: "Triboniophorus Tyrannus",
        bra: "Triboniophorus Tyrannus",
        schema: 151
    },
    1373: {
        img: "vintage_merryweather",
        eng: "Vintage Merryweather",
        rus: "\u0412\u0438\u043D\u0442\u0430\u0436\u043D\u044B\u0439 \u0448\u043B\u0435\u043C \u043F\u043E\u0436\u0430\u0440\u043D\u043E\u0433\u043E",
        pol: "Zabytek stra\u017Caka",
        sch: "\u8001\u5F0F\u6D88\u9632\u5934\u76D4",
        fre: "Casque Mill\xe9sim\xe9",
        bra: "Capacete Cl\xe1ssico de Bombeiro",
        schema: 182,
        hun: "\xd3sdi T\u0171zolt\xf3sisak",
        swe: "Gammaldags Brandhj\xe4lm"
    },
    1374: {
        img: "dead_cone",
        eng: "Dead Cone",
        rus: "\u041A\u043E\u043D\u0443\u0441 \u043C\u0435\u0440\u0442\u0432\u0435\u0446\u0430",
        pol: "Martwy pacho\u0142ek",
        sch: "\u50F5\u5C38\u7684\u8DEF\u969C",
        fre: "C\xf4ne du Mort",
        bra: "Cone Morto",
        schema: 435,
        hun: "Hal\xe1li B\xf3ja",
        swe: "D\xf6d Kon"
    },
    1375: {
        img: "connoisseurs_cap",
        eng: "Connoisseur's Cap",
        rus: "\u041A\u043E\u043B\u043F\u0430\u043A \u0437\u043D\u0430\u0442\u043E\u043A\u0430",
        pol: "Czapka konesera",
        sch: "\u884C\u5BB6\u7684\u53A8\u5E08\u5E3D",
        fre: "Toque du Connaisseur",
        bra: "Chap\xe9u do Chef",
        schema: 394,
        hun: "\xc9telm\u0171v\xe9sz \xc9ke",
        swe: "M\xe4sterkockens M\xf6ssa"
    },
    1376: {
        img: "birdcage",
        eng: "Birdcage",
        rus: "\u041F\u0442\u0438\u0447\u044C\u044F \u043A\u043B\u0435\u0442\u043A\u0430",
        pol: "Klatka dla ptak\xf3w",
        sch: "\u9E1F\u7B3C",
        fre: "La Voli\xe8re",
        bra: "A Gaiola",
        schema: 615,
        hun: "A Kalitka",
        swe: "F\xe5gelburen"
    },
    1377: {
        img: "little_buddy",
        eng: "Little Buddy",
        rus: "\u0414\u0440\u0443\u0436\u043E\u043A",
        pol: "Kole\u017Cka",
        sch: "\u6C34\u624B\u5E3D",
        fre: "Le Petit Moussaillon",
        bra: "O Tesouro",
        schema: 612,
        hun: "A Kis Matr\xf3z",
        swe: "Skepparens Kompis"
    },
    1378: {
        img: "bubble_pipe",
        eng: "Bubble Pipe",
        rus: "\u0422\u0440\u0443\u0431\u043A\u043E\u0448\u043B\u0435\u043C",
        pol: "Ba\u0144kowa fajka",
        sch: "\u5E26\u70DF\u6597\u7684\u6C27\u6C14\u7F69",
        fre: "La Bulle \xe0 Pipe",
        bra: "A Bolha de Fumo",
        schema: 597,
        hun: "A Pipabubor\xe9k",
        swe: "Bubbelbubblan"
    },
    1379: {
        img: "waxy_wayfinder",
        eng: "Waxy Wayfinder",
        rus: "\u041F\u0430\u0440\u0430\u0444\u0438\u043D\u043E\u0432\u044B\u0439 \u043F\u0443\u0442\u0435\u043F\u0440\u043E\u0445\u043E\u0434\u0435\u0446",
        pol: "Ob\u0142\u0119dny ognik",
        sch: "\u5BFB\u8DEF\u7684\u8721\u70DB\u5934",
        fre: "La Bougie \xe0 T\xeate Chercheuse",
        bra: "A Luz no Fim do T\xfanel",
        schema: 753,
        hun: "A Viaszos V\xe9szvil\xe1g\xedt\xe1s",
        swe: "Vaxade v\xe4gvisaren"
    },
    1380: {
        img: "scotsmans_stove_pipe",
        eng: "Scotsman's Stove Pipe",
        rus: "\u0428\u043E\u0442\u043B\u0430\u043D\u0434\u0441\u043A\u0438\u0439 \u0446\u0438\u043B\u0438\u043D\u0434\u0440",
        pol: "Szapoklak Szkota",
        sch: "\u82CF\u683C\u5170\u5927\u793C\u5E3D",
        fre: "Chapeau haut de forme",
        bra: "Cartola do Escoc\xeas",
        schema: 120,
        hun: "Sk\xf3t Cilinder",
        swe: "Skottens Cylinderhatt"
    },
    1381: {
        img: "carousers_capotain",
        eng: "Carouser's Capotain",
        rus: "\u041A\u043E\u043B\u043F\u0430\u043A \u0433\u0443\u043B\u044F\u043A\u0438",
        pol: "Pijany purytanin",
        sch: "\u95F9\u4E8B\u8005\u7684\u730E\u5DEB\u5E3D",
        fre: "Chapeau de beuverie",
        bra: "Cartola do Inquisidor",
        schema: 259,
        hun: "Kapatos Telepes",
        swe: "Festprissens Kapott"
    },
    1382: {
        img: "samur_eye",
        eng: "Samur-Eye",
        rus: "\u041E\u0434\u043D\u043E\u0433\u043B\u0430\u0437\u044B\u0439 \u0441\u0430\u043C\u0443\u0440\u0430\u0439",
        pol: "Samur-Eye",
        sch: "\u6B66\u58EB\u4E4B\u773C",
        fre: "Samour-Oeil",
        bra: "Samur-ai",
        schema: 359,
        hun: "Szemtelen Szamur\xe1j",
        swe: "Samur-Aj"
    },
    1383: {
        img: "conjurers_cowl",
        eng: "Conjurer's Cowl",
        rus: "\u041A\u0430\u043F\u044E\u0448\u043E\u043D \u0432\u043E\u043B\u0448\u0435\u0431\u043D\u0438\u043A\u0430",
        pol: "Kaptur magika",
        sch: "\u9B54\u672F\u5E08\u7684\u515C\u5E3D",
        fre: "Le Capuchon du Magicien",
        bra: "O Capuz do M\xe1gicko",
        schema: 465,
        hun: "A Csodatev\u0151 Csukly\xe1ja",
        swe: "H\xe4xm\xe4starens huva"
    },
    1384: {
        img: "sultans_ceremonial",
        eng: "Sultan's Ceremonial",
        rus: "\u0426\u0435\u0440\u0435\u043C\u043E\u043D\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u0442\u044E\u0440\u0431\u0430\u043D \u0441\u0443\u043B\u0442\u0430\u043D\u0430",
        pol: "Su\u0142ta\u0144ski turban ceremonialny",
        sch: "\u82CF\u4E39\u7684\u7FBD\u6BDB\u5934\u5DFE",
        fre: "Turban C\xe9r\xe9monial du Sultan",
        bra: "Cerimonial do Sult\xe3o",
        schema: 403,
        hun: "Szeml\xe1tom\xe1st Szult\xe1n",
        swe: "Sultanens ceremonier"
    },
    1385: {
        img: "mask_of_the_shaman",
        eng: "Mask of the Shaman",
        rus: "\u041C\u0430\u0441\u043A\u0430 \u0448\u0430\u043C\u0430\u043D\u0430",
        pol: "Maska szamana",
        sch: "\u8428\u6EE1\u9762\u5177",
        fre: "Le Masque du Chaman",
        bra: "A M\xe1scara do Xam\xe3",
        schema: 514,
        hun: "A S\xe1m\xe1n Maszkja",
        swe: "Shamanens mask"
    },
    1386: {
        img: "buccaneers_bicorne",
        eng: "The Buccaneer's Bicorne",
        rus: "\u0414\u0432\u0443\u0443\u0433\u043E\u043B\u043A\u0430 \u0431\u0443\u043A\u0430\u043D\u044C\u0435\u0440\u0430",
        pol: "Bikorn bukaniera",
        sch: "\u6D77\u76D7\u7684\u53CC\u89D2\u5E3D",
        fre: "Le bicorne de flibustier",
        bra: "O Bic\xf3rnio do Bucaneiro",
        schema: 607,
        hun: "A Moh\xf3 Martal\xf3c",
        swe: "Sj\xf6r\xf6varens Skeppshatt"
    },
    1387: {
        img: "pugilists_protector",
        eng: "Pugilist's Protector",
        rus: "\u0411\u043E\u043A\u0441\u0451\u0440\u0441\u043A\u0430\u044F \u0437\u0430\u0449\u0438\u0442\u0430",
        pol: "Ochraniacz pi\u0119\u015Bciarza",
        sch: "\u62F3\u51FB\u624B\u5934\u5957",
        fre: "Protecteur du pugiliste",
        bra: "Protetor do Pugilista",
        schema: 246,
        hun: "Az \xd6k\xf6lv\xedv\xf3 Arcv\xe9d\u0151je",
        swe: "Boxarens Beskyddare"
    },
    1388: {
        img: "dread_knot",
        eng: "Dread Knot",
        rus: "\u0411\u0435\u0441\u0441\u0442\u0440\u0430\u0448\u043D\u044B\u0439 \u0443\u0437\u0435\u043B",
        pol: "Kok sumity",
        sch: "\u65E0\u754F\u8005\u7684\u5510\u8F6E\u5934",
        fre: "Cuir Assez Chevelu",
        bra: "N\xf3 Pavoroso",
        schema: 358,
        hun: "Rettent\u0151 Csatahaj",
        swe: "Tungviktsknut"
    },
    1389: {
        img: "capos_capper",
        eng: "Capo's Capper",
        rus: "\u0428\u043B\u044F\u043F\u0430 \u043A\u0430\u043F\u043E",
        pol: "Kapelusz capo",
        sch: "\u5E72\u90E8\u7684\u8F6F\u5462\u5E3D",
        fre: "Feutre du Capo",
        bra: "Chap\xe9u do Capo",
        schema: 427,
        hun: "Capone Kalap\xf3ja",
        swe: "Mafiosons M\xf6ssa"
    },
    1390: {
        img: "dragonborn_helmet",
        eng: "Dragonborn Helmet",
        rus: "\u0428\u043B\u0435\u043C \u0434\u0440\u0430\u043A\u043E\u043D\u043E\u0440\u043E\u0436\u0434\u0435\u043D\u043D\u043E\u0433\u043E",
        pol: "He\u0142m smoczego dzieci\u0119cia",
        sch: "\u9F99\u88D4\u5934\u76D4",
        fre: "Casque du Dovahkiin",
        bra: "Capacete do Dragonborn",
        schema: 517,
        hun: "S\xe1rk\xe1nyfi-sisak",
        swe: "Den drakf\xf6ddes hj\xe4lm"
    },
    1391: {
        img: "gym_rat",
        eng: "Gym Rat",
        rus: "\u041A\u0430\u0447\u043E\u043A",
        pol: "Gimnasta",
        sch: "\u8FD0\u52A8\u5934\u5E26",
        fre: "Le Rat de la Salle de Gym",
        bra: "O Rato de Academia",
        schema: 613,
        hun: "A Kigy\xfart Fazon",
        swe: "Gymr\xe5ttan"
    },
    1392: {
        img: "one_man_army",
        eng: "One-Man Army",
        rus: "\u0427\u0435\u043B\u043E\u0432\u0435\u043A-\u0430\u0440\u043C\u0438\u044F",
        pol: "Jednoosobowa armia",
        sch: "\u5170\u535A\u7684\u5934\u5E26",
        fre: "L'Arm\xe9e Fatale",
        bra: "O Ex\xe9rcito de um Homem S\xf3",
        schema: 601,
        hun: "Az Egyszem\xe9lyes Hadsereg",
        swe: "Enmans-arm\xe9n"
    },
    1393: {
        img: "engineers_cap",
        eng: "Engineer's Cap",
        rus: "\u0424\u0443\u0440\u0430\u0436\u043A\u0430 \u043C\u0430\u0448\u0438\u043D\u0438\u0441\u0442\u0430",
        pol: "Czapka maszynisty",
        sch: "\u5DE5\u7A0B\u5E08\u7684\u9E2D\u820C\u5E3D",
        fre: "Casquette de l'Engineer",
        bra: "Bon\xe9 do Maquinista",
        schema: 95,
        hun: "Masiniszta-sapka",
        swe: "Lokf\xf6rarkeps"
    },
    1394: {
        img: "big_country",
        eng: "Big Country",
        rus: "\u041F\u0440\u0438\u0447\u0435\u0441\u043A\u0430 \u0441\u0442\u0435\u043F\u043D\u043E\u0433\u043E \u043C\u0443\u0437\u044B\u043A\u0430\u043D\u0442\u0430",
        pol: "Dusza country",
        sch: "\u5E05\u6C14\u7684\u9A6C\u83B1\u53D1\u578B",
        fre: "Grand pays",
        bra: "Da Cabe\xe7a Nasce o Cabelo",
        schema: 382,
        hun: "A Nagy Lobonc",
        swe: "Vackra V\xe4stern"
    },
    1395: {
        img: "hetmans_headpiece",
        eng: "Hetman's Headpiece",
        rus: "\u0413\u0435\u0442\u043C\u0430\u043D\u0441\u043A\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        pol: "Chluba hetmana",
        sch: "\u54E5\u8428\u514B\u914B\u957F\u7684\u7FBD\u6BDB\u5E3D",
        fre: "Chapeau de Hetman",
        bra: "Chap\xe9u do Hetman",
        schema: 436,
        hun: "Hetman Fejv\xe9d\u0151je",
        swe: "Hetmans hatt"
    },
    1396: {
        img: "pencil_pusher",
        eng: "Pencil Pusher",
        rus: "\u041A\u0430\u043D\u0446\u0435\u043B\u044F\u0440\u0441\u043A\u0430\u044F \u043A\u0440\u044B\u0441\u0430",
        pol: "Ufryzowany urz\u0119das",
        sch: "\u4F1A\u8BA1\u5E08\u7684\u94C5\u7B14",
        fre: "Le Gratte-papier",
        bra: "O Faz-Tudo",
        schema: 605,
        hun: "Az Irodista",
        swe: "Kontorsnissen"
    },
    1397: {
        img: "virtual_reality_headset",
        eng: "Virtual Reality Headset",
        rus: "\u0413\u0430\u0440\u043D\u0438\u0442\u0443\u0440\u0430 \u0432\u0438\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u043E\u0439 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438",
        pol: "Zestaw wirtualnej rzeczywisto\u015Bci",
        sch: "\u865A\u62DF\u73B0\u5B9E\u5934\u6234\u5F0F\u663E\u793A\u5668",
        fre: "Le Casque de R\xe9alit\xe9 Virtuelle",
        bra: "O Headset de Realidade Virtual",
        schema: 628,
        hun: "A Virtu\xe1lis-val\xf3s\xe1g Sisak",
        swe: "Virtuella verklighetsheadsetet"
    },
    1398: {
        img: "brainiac_hairpiece",
        eng: "Brainiac Hairpiece",
        rus: "\u0428\u0438\u043D\u044C\u043E\u043D \u0443\u043C\u043D\u0438\u043A\u0430",
        pol: "Peruka m\xf3zgowca",
        sch: "\u53D1\u660E\u5BB6\u7684\u767D\u53D1",
        fre: "La Coiffure du Brainiac",
        bra: "O Cabelo Neural",
        schema: 590,
        hun: "Az Agyas Haja",
        swe: "Geniets l\xf6sh\xe5r"
    },
    1399: {
        img: "geisha_boy",
        eng: "Geisha Boy",
        rus: "\u041C\u0430\u043B\u044C\u0447\u0438\u043A-\u0433\u0435\u0439\u0448\u0430",
        pol: "M\u0119ska gejsza",
        sch: "\u7537\u827A\u5993\u5934\u9970",
        fre: "Geisha Boy",
        bra: "Garoto Gueixa",
        schema: 363,
        hun: "G\xe9safi\xfa",
        swe: "Geisha-pojke"
    },
    1400: {
        img: "medics_mountain_cap",
        eng: "Medic's Mountain Cap",
        rus: "\u041A\u0430\u0440\u0442\u0443\u0437 \u0434\u043E\u043A\u0442\u043E\u0440\u0430",
        pol: "G\xf3rska czapka Medyka",
        sch: "\u533B\u751F\u7684\u91CE\u6218\u5E3D",
        fre: "Casquette de Montagnard du Medic",
        bra: "Quepe Montanh\xeas do M\xe9dico",
        schema: 381,
        hun: "A Szanit\xe9c Sildes Sapk\xe1ja",
        swe: "F\xe4ltsjukv\xe5rdarens Fj\xe4llm\xf6ssa"
    },
    1401: {
        img: "doctors_sack",
        eng: "Doctor's Sack",
        rus: "\u0414\u043E\u043A\u0442\u043E\u0440\u0441\u043A\u0438\u0439 \u043C\u0435\u0448\u043E\u043A",
        pol: "Torebka doktora",
        sch: "\u533B\u751F\u7684\u51B0\u888B",
        fre: "Bouillotte du Docteur",
        bra: "Bolsa do Doutor",
        schema: 398,
        hun: "Orvos J\xe9gzacsk\xf3ja",
        swe: "Doktorns Isp\xe5se"
    },
    1402: {
        img: "masters_yellow_belt",
        eng: "Master's Yellow Belt",
        rus: "\u0416\u0451\u043B\u0442\u0430\u044F \u043F\u043E\u0432\u044F\u0437\u043A\u0430 \u043C\u0430\u0441\u0442\u0435\u0440\u0430",
        pol: "\u017B\xf3\u0142ty pas mistrza",
        sch: "\u5927\u5E08\u7684\u9EC4\u5E26",
        fre: "Ceinture jaune du ma\xeetre",
        bra: "Faixa Amarela do Mestre",
        schema: 110,
        hun: "A Mester S\xe1rga \xd6ve",
        swe: "M\xe4starens gula b\xe4lte"
    },
    1403: {
        img: "crocleather_slouch",
        eng: "Crocleather Slouch",
        rus: "\u0428\u043B\u044F\u043F\u0430 \u0438\u0437 \u043A\u0440\u043E\u043A\u043E\u0434\u0438\u043B\u043E\u0432\u043E\u0439 \u043A\u043E\u0436\u0438",
        pol: "Kapelusz z krokodylej sk\xf3ry",
        sch: "\u9CC4\u9C7C\u76AE\u5BBD\u8FB9\u8F6F\u5E3D",
        fre: "Chapeau Mou en Cuir de Croco",
        bra: "Crocourodilo Pregui\xe7oso",
        schema: 344,
        hun: "Krokodilb\u0151r Kalap",
        swe: "Krokodilslokhatt"
    },
    1404: {
        img: "anger",
        eng: "Anger",
        rus: "\u042F\u0440\u043E\u0441\u0442\u044C",
        pol: "W\u015Bciek\u0142y",
        sch: "\u66B4\u6012\u515C\u5E3D",
        fre: "Le rageux",
        bra: "Raiva",
        schema: 518,
        schema2: 5758,
        hun: "D\xfch",
        rom: "Furie",
        ger: "Zorn"
    },
    1405: {
        img: "your_worst_nightmare",
        eng: "Your Worst Nightmare",
        rus: "\u0422\u0432\u043E\u0439 \u0445\u0443\u0434\u0448\u0438\u0439 \u043A\u043E\u0448\u043C\u0430\u0440",
        pol: "Tw\xf3j najgorszy koszmar",
        sch: "\u8BA9\u4F60\u505A\u6076\u68A6\u7684\u5934\u5DFE",
        fre: "Votre pire cauchemar",
        bra: "Seu Pior Pesadelo",
        schema: 600,
        hun: "A Legrosszabb R\xe9m\xe1lmod",
        swe: "Din V\xe4rsta Mardr\xf6m"
    },
    1406: {
        img: "swagmans_swatter",
        eng: "Swagman's Swatter",
        rus: "\u041C\u0443\u0445\u043E\u0431\u043E\u0439\u043A\u0430 \u0431\u0440\u043E\u0434\u044F\u0433\u0438",
        pol: "Zas\u0142ona swagmana",
        sch: "\u6D41\u6D6A\u8005\u7684\u8F6F\u6728\u5E3D",
        fre: "Le chasse-mouche de vagabond",
        bra: "O Esmaga-Moscas do Moiteiro",
        schema: 626,
        hun: "A F\xe9ny\u0171z\u0151 L\xe9gy\u0171z\u0151",
        swe: "Strykarens Sm\xe4lla"
    },
    1407: {
        img: "fruit_shoot",
        eng: "Fruit Shoot",
        rus: "\u0412 \u044F\u0431\u043B\u043E\u0447\u043A\u043E",
        pol: "Owocny strza\u0142",
        sch: "\u82F9\u679C\u5C04\u51FB\u5E3D",
        fre: "Tir fruit\xe9",
        bra: "O Chap\xe9u do Tell",
        schema: 759,
        hun: "A Gy\xfcm\xf6lcs-\xd6l\u0151",
        swe: "Fruktskadan"
    },
    1408: {
        img: "magistrates_mullet",
        eng: "Magistrate's Mullet",
        rus: "\u0421\u0443\u0434\u0435\u0439\u0441\u043A\u0438\u0439 \u043F\u0430\u0440\u0438\u043A",
        pol: "Peruka s\u0119dziego",
        sch: "\u88C1\u5224\u5B98\u7684\u5047\u53D1",
        fre: "Perruque de Magistrat",
        bra: "Mullet do Magistrado",
        schema: 147,
        hun: "Uras\xe1g Par\xf3k\xe1ja",
        swe: "Magistratens Hockeyfrilla"
    },
    1409: {
        img: "noh_mercy",
        eng: "Noh Mercy",
        rus: "\u0411\u0435\u0437\u0436\u0430\u043B\u043E\u0441\u0442\u043D\u044B\u0439 \u0434\u0435\u043C\u043E\u043D",
        pol: "Horrendalna hannya",
        sch: "\u822C\u82E5\u80FD\u9762",
        fre: "N\xf4 Merci",
        bra: "Noh Terei Miseric\xf3rdia",
        schema: 361,
        hun: "A Kegyetlen",
        swe: "Ingen Nohd"
    },
    1410: {
        img: "charmers_chapeau",
        eng: "Charmer's Chapeau",
        rus: "\u0428\u043B\u044F\u043F\u0430 \u043E\u0431\u043E\u043B\u044C\u0441\u0442\u0438\u0442\u0435\u043B\u044F",
        pol: "Kapelusz szarmanckiego kawalera",
        sch: "\u9B45\u5F71\u9A91\u58EB\u5E3D",
        fre: "Chapeau du Charmeur",
        bra: "Chapeau Charmoso",
        schema: 397,
        hun: "S\xe1rmos Chapeau",
        swe: "Charm\xf6rens Chapeau"
    },
    1411: {
        img: "janissary_ketche",
        eng: "Janissary Ketche",
        rus: "\u042F\u043D\u044B\u0447\u0430\u0440\u0441\u043A\u0430\u044F \u043A\u043B\u044F\u0442\u0432\u0430",
        pol: "Janczarskie kece",
        sch: "\u8036\u5C3C\u5207\u91CC\u5934\u51A0",
        fre: "Ketche du Janissaire",
        bra: "Ketche do Jan\xedzaro",
        schema: 437,
        hun: "Janics\xe1r Kecs\xe9je",
        swe: "Janitsjar Ketche"
    },
    1412: {
        img: "nanobalaclava",
        eng: "Nanobalaclava",
        rus: "\u041D\u0430\u043D\u043E\u0431\u0430\u043B\u0430\u043A\u043B\u0430\u0432\u0430",
        pol: "Nanokominiarka",
        sch: "\u7EB3\u7C73\u79D1\u6280\u9762\u7F69",
        fre: "La Nanocagoule",
        bra: "O Nanobalaclava",
        schema: 521,
        hun: "A Nanos\xedmaszk",
        swe: "Nanobalaklavan"
    },
    1413: {
        img: "linspecteur",
        eng: "L'Inspecteur",
        rus: "\u0418\u043D\u0441\u043F\u0435\u043A\u0442\u043E\u0440",
        pol: "L'Inspecteur",
        sch: "\u6CD5\u56FD\u8B66\u7763",
        fre: "L'inspecteur",
        bra: "L'Inspecteur",
        schema: 622,
        swe: "L'Inspekteur"
    },
    1414: {
        img: "noble_amassment_of_hats",
        eng: "Noble Amassment of Hats",
        rus: "\u0417\u043D\u0430\u0442\u043D\u0430\u044F \u043A\u0443\u0447\u0430 \u0448\u043B\u044F\u043F",
        pol: "Zacna miara kapeluszy",
        sch: "\u8363\u534E\u5BCC\u8D35\u7684\u5E3D\u4E2D\u4E4B\u5E3D",
        fre: "Pile nobiliaire de couvre-chefs",
        bra: "Conjunto Nobre de Chap\xe9us",
        schema: 137,
        hun: "Nemes Kalapok Gy\u0171jtem\xe9nye",
        swe: "Nobel Anhopning Av Hattar"
    },
    1415: {
        img: "towering_pillar_of_hats",
        eng: "Towering Pillar of Hats",
        rus: "\u0413\u0438\u0433\u0430\u043D\u0442\u0441\u043A\u0430\u044F \u0431\u0430\u0448\u043D\u044F \u0438\u0437 \u0448\u043B\u044F\u043F",
        pol: "Niebotyczny s\u0142up kapeluszy",
        sch: "\u5C42\u53E0\u9AD8\u8038\u7684\u7FA4\u5E3D\u4E4B\u5854",
        fre: "Imposante pile de chapeaux",
        bra: "Pilar Monumental de Chap\xe9us",
        schema: 135,
        hun: "Magasan Tornyosul\xf3 Kalap-oszlop",
        swe: "Reslig Pelare Av Hattar"
    },
    1416: {
        img: "company_man",
        eng: "Company Man",
        rus: "\u041F\u0440\u0435\u0434\u0430\u043D\u043D\u044B\u0439 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A",
        pol: "Cz\u0142owiek korporacji",
        sch: "\u8428\u91CC\u592B\u5DE5\u4E1A\u516C\u53F8\u5458\u5DE5\u5E3D",
        fre: "Casquette de l'Employ\xe9",
        bra: "O Homem da Empresa",
        schema: 523,
        hun: "A C\xe9g Embere",
        swe: "F\xf6retagsmannen"
    },
    1417: {
        img: "killer_exclusive",
        eng: "Killer Exclusive",
        rus: "\u0423\u0431\u0438\u0439\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u0440\u0435\u043F\u043E\u0440\u0442\u0430\u0436",
        pol: "\u0141owca sensacji",
        sch: "\u72EC\u5BB6\u6740\u624B",
        fre: "Le Scoop Meurtrier",
        bra: "O Furo de Reportagem",
        schema: 538,
        hun: "Az Irt\xf3-k\xfcl\xf6nkiad\xe1s",
        swe: "M\xf6rdande Ensamr\xe4tt"
    },
    1418: {
        img: "hot_dogger",
        eng: "Hot Dogger",
        rus: "\u0425\u043E\u0442-\u0434\u043E\u0433\u0449\u0438\u043A",
        pol: "Hotdoggista",
        sch: "\u70ED\u72D7\u644A\u552E\u8D27\u5458\u5E3D\u5B50",
        fre: "Le vendeur de hot dogs",
        bra: "O Cachorr\xe3o Quente",
        schema: 614,
        hun: "A Hot-Dogos",
        swe: "Korvgubben"
    },
    1419: {
        img: "human_cannonball",
        eng: "Human Cannonball",
        rus: "\u0427\u0435\u043B\u043E\u0432\u0435\u043A-\u044F\u0434\u0440\u043E",
        pol: "Ludzka kula armatnia",
        sch: "\u4EBA\u8089\u70AE\u5F39",
        fre: "L'Homme-canon",
        bra: "A Bala de Canh\xe3o Humana",
        schema: 817,
        hun: "Az Emberi \xc1gy\xfagoly\xf3",
        swe: "Den M\xe4nskliga Kanonkulan"
    },
    1420: {
        img: "antlers",
        eng: "Antlers",
        rus: "\u0420\u043E\u0433\u0430",
        pol: "Poro\u017Ce",
        sch: "\u9A6F\u9E7F\u9E7F\u89D2",
        fre: "Ramures",
        bra: "Galhadas",
        schema: 993,
        hun: "agancs",
        swe: "Horn"
    },
    1421: {
        img: "dread_hiding_hood",
        eng: "Dread Hiding Hood",
        rus: "\u041E\u0434\u0435\u044F\u043D\u0438\u0435 \u043E\u0431\u043C\u0430\u043D\u0449\u0438\u043A\u0430",
        pol: "Z\u0142owieszczy kapturek",
        sch: "\u60CA\u60E7\u9690\u853D\u515C\u5E3D",
        fre: "Le redoutable petit chaperon",
        bra: "Chapeuzinho Voraz",
        schema: 1095,
        hun: "A Rettent\u0151 Rejt\u0151csuklya",
        swe: "D\xf6dluvan"
    },
    1422: {
        img: "pocket_pardner",
        eng: "Pocket Pardner",
        rus: "\u041A\u0430\u0440\u043C\u0430\u043D\u043D\u044B\u0439 \u043A\u043E\u0440\u0435\u0448",
        pol: "Kieszonkowy partner",
        sch: "\u53E3\u888B\u5DE5\u7A0B\u5E08",
        fre: "Partenaire de poche",
        bra: "Parceiro de Bolso",
        schema: 31026,
        hun: "Zsebpajt\xe1s",
        swe: "Fickpartner"
    },
    1423: {
        img: "wise_whiskers",
        eng: "Wise Whiskers",
        rus: "\u0423\u0441\u044B \u043C\u0443\u0434\u0440\u0435\u0446\u0430",
        pol: "Wykwintne w\u0105siska",
        sch: "\u4ED9\u4EBA\u4E4B\u987B",
        fre: "Moustache de sage",
        bra: "Barba do Velho S\xe1bio",
        schema: 31031,
        hun: "B\xf6lcs Szak\xe1ll",
        swe: "Visdomssk\xe4gg"
    },
    1424: {
        img: "snowcapped",
        eng: "Snowcapped",
        rus: "\u0421\u043D\u0435\u0436\u043D\u044B\u0439 \u043A\u043E\u0437\u044B\u0440\u0451\u043A",
        pol: "\u015Anie\u017Cna czapa",
        sch: "\u62A4\u8033\u519B\u5E3D",
        fre: "Guerre froide",
        bra: "Ushanka de Inverno",
        schema: 31028,
        hun: "H\xf3sapka",
        swe: "Sn\xf6keps"
    },
    1425: {
        img: "paka_parka",
        eng: "Paka Parka",
        rus: "\u041F\u0440\u043E\u0449\u0430\u043B\u044C\u043D\u0430\u044F \u043F\u0430\u0440\u043A\u0430",
        pol: "Parka pakera",
        sch: "\u56E0\u7EBD\u7279\u5927\u8863",
        fre: "Parka de l'Alaska",
        bra: "Parca Paka",
        schema: 31030,
        swe: "Pakaparka"
    },
    1426: {
        img: "catchers_companion",
        eng: "The Catcher's Companion",
        rus: "\u041A\u043E\u043C\u043F\u0430\u043D\u044C\u043E\u043D \u043A\u044D\u0442\u0447\u0435\u0440\u0430",
        pol: "Pobratymiec pa\u0142karza",
        sch: "\u68D2\u7403\u5C0F\u9E1F",
        fre: "Bec non clou\xe9",
        bra: "Ajudante do Arremessador",
        schema: 31021,
        hun: "Az Elkap\xf3 T\xe1rsa",
        swe: "F\xe5ngarens f\xe5gelkompis"
    },
    1427: {
        img: "juveniles_jumper",
        eng: "Juvenile's Jumper",
        rus: "\u042E\u043D\u043E\u0448\u0435\u0441\u043A\u0438\u0439 \u0441\u0432\u0438\u0442\u0435\u0440",
        pol: "Szczeniacki sweter",
        sch: "\u5C11\u5E74\u7684\u6BDB\u8863",
        fre: "Classique de No\xebl",
        bra: "Malha do Mancebo",
        schema: 31022,
        hun: "Fiatalos Pulcsi",
        swe: "Ungdomlig ulltr\xf6ja"
    },
    1428: {
        img: "crack_pot",
        eng: "The Crack Pot",
        rus: "\u0413\u043E\u0440\u0448\u043A\u043E\u0433\u043E\u043B\u043E\u0432\u044B\u0439",
        pol: "Doniczkowy dure\u0144",
        sch: "\u8111\u888B\u5F00\u82B1",
        fre: "Fine fleur",
        bra: "Vaso Capilar",
        schema: 31024,
        hun: "Taktikai Vir\xe1gcser\xe9p",
        swe: "Blomkruka"
    },
    1429: {
        img: "climbing_commander",
        eng: "Climbing Commander",
        rus: "\u0413\u043E\u0440\u043D\u044B\u0439 \u0441\u043E\u043B\u0434\u0430\u0442",
        pol: "Docieplony dow\xf3dca",
        sch: "\u767B\u5C71\u6307\u6325\u5B98",
        fre: "Grimpeur des Rocheuses",
        bra: "Comandante do Cume",
        schema: 31025,
        hun: "Hegym\xe1sz\xf3 Parancsnok",
        swe: "Kl\xe4ttringskommend\xf6r"
    },
    1430: {
        img: "mighty_mitre",
        eng: "Mighty Mitre",
        rus: "\u041C\u043E\u0433\u0443\u0447\u0430\u044F \u043C\u0438\u0442\u0440\u0430",
        pol: "Mocarna mitra",
        sch: "\u4E3B\u6559\u4E4B\u51A0",
        fre: "Miracle de la m\xe9decine",
        bra: "Mitra Majestosa",
        schema: 31034,
        hun: "Fens\xe9ges F\xf6veg",
        swe: "M\xe4ktig mitra"
    },
    1431: {
        img: "puggyback",
        eng: "The Puggyback",
        rus: "\u0417\u0430\u043F\u043B\u0435\u0447\u043D\u044B\u0439 \u043C\u043E\u043F\u0441",
        pol: "Przeno\u015Bna psiarnia",
        sch: "\u5DF4\u54E5\u80CC\u5305",
        fre: "Sac \xe0 dogue",
        bra: "C\xe3o de Retaguarda",
        schema: 31032,
        hun: "Mopsz M\xe1lha",
        swe: "Ryggmops"
    },
    1432: {
        img: "cool_capuchon",
        eng: "Cool Capuchon",
        rus: "\u041A\u0440\u0443\u0442\u043E\u0439 \u043A\u0430\u043F\u044E\u0448\u043E\u043D",
        pol: "Kozacki capuchon",
        sch: "\u51B7\u98CE\u515C\u5E3D",
        fre: "Capuche styl\xe9e",
        bra: "Capuz Caloroso",
        schema: 31029,
        hun: "Klassz Kapucni",
        swe: "Vinterkapuschong"
    },
    1433: {
        img: "pocket_admin",
        eng: "Pocket Admin",
        rus: "\u041A\u0430\u0440\u043C\u0430\u043D\u043D\u044B\u0439 \u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440",
        pol: "Kieszonkowa Administratorka",
        sch: "\u53E3\u888B\u7BA1\u7406\u5458",
        fre: "Admin de poche",
        bra: "Administradora de Bolso",
        schema: 31019,
        hun: "Zsebadmin",
        swe: "Fickadministrat\xf6r"
    },
    1434: {
        img: "harry",
        eng: "Harry",
        rus: "\u0413\u0430\u0440\u0440\u0438",
        pol: "Harry",
        sch: "\u61D2\u732B\u54C8\u91CC",
        fre: "Harry",
        bra: "Harry",
        schema: 31033,
        hun: "Bundi"
    },
    1435: {
        img: "misers_muttonchops",
        eng: "Miser's Muttonchops",
        rus: "\u0411\u0430\u043A\u0435\u043D\u0431\u0430\u0440\u0434\u044B \u0441\u043A\u0440\u044F\u0433\u0438",
        pol: "Szczecina sknerusa",
        sch: "\u541D\u556C\u9B3C\u7EDC\u816E\u80E1",
        fre: "Rouflaquettes",
        bra: "Patilhas do P\xe3o-Duro",
        schema: 31027,
        hun: "Fukar Bark\xf3",
        swe: "Sn\xe5lj\xe5pens sk\xe4gg"
    },
    1436: {
        img: "polar_pal",
        eng: "The Polar Pal",
        rus: "\u041F\u043E\u043B\u044F\u0440\u043D\u044B\u0439 \u043F\u0440\u0438\u044F\u0442\u0435\u043B\u044C",
        pol: "Polarny przyjaciel",
        sch: "\u6781\u5730\u4F34\u4FA3",
        fre: "Pote du p\xf4le",
        bra: "Amigo Polar",
        schema: 31018,
        hun: "Medvekoma",
        swe: "Polarpolare"
    },
    1437: {
        img: "dumb_bell",
        eng: "The Dumb Bell",
        rus: "\u041A\u043E\u043B\u043E\u043A\u043E\u043B \u043A\u0440\u0435\u0442\u0438\u043D\u0430",
        pol: "Cymba\u0142 brzmi\u0105cy",
        sch: "\u4E0D\u54D1\u7684\u94C3",
        fre: "Sonneur de cloche",
        bra: "Sino do Asinino",
        schema: 31035,
        hun: "Kerge Kolomp",
        swe: "Bj\xe4llerklant"
    },
    1438: {
        img: "millennial_mercenary",
        eng: "Millennial Mercenary",
        rus: "\u041D\u0430\u0451\u043C\u043D\u0438\u043A-\u043C\u0438\u043B\u043B\u0435\u043D\u0438\u0430\u043B",
        pol: "Militarny milenials",
        sch: "00\u540E\u4F63\u5175",
        fre: "Mercenaire de la g\xe9n\xe9ration Y",
        bra: "Mercen\xe1rio Moderninho",
        schema: 31023,
        hun: "Z-gener\xe1ci\xf3s Zsoldos",
        swe: "Sekelskiftessoldat"
    },
    1439: {
        img: "bread_heads",
        eng: "Bread Heads",
        rus: "\u0425\u043B\u0435\u0431\u043D\u0430\u044F \u0433\u043E\u043B\u043E\u0432\u0430",
        pol: "Chlebog\u0142owy",
        sch: "\u9762\u5305\u602A\u517D",
        fre: "Mangeur de pain",
        bra: "Cabe\xe7a de P\xe3o",
        schema: 31020,
        hun: "Borzaszt\xf3 Buci",
        swe: "Br\xf6dhuvud"
    },
    1440: {
        img: "melted_mop",
        eng: "Melted Mop",
        rus: "\u041F\u043E\u0434\u0442\u0451\u043A\u0448\u0438\u0439 \u043F\u0440\u0438\u043A\u0438\u0434",
        pol: "Roztopiony ro\u017Cek",
        fre: "Fonte des glaces",
        sch: "\u878D\u5316\u7684\u51B0\u6DC7\u6DCB",
        bra: "Congelador de C\xe9rebro",
        schema: 31041,
        hun: "Leolvad\xe1s",
        swe: "Sm\xe4ltande strutglass"
    },
    1441: {
        img: "staplers_specs",
        eng: "Stapler's Specs",
        rus: "\u041E\u0444\u0438\u0441\u043D\u044B\u0435 \u043E\u043A\u0443\u043B\u044F\u0440\u044B",
        pol: "Szk\u0142a zszywacza",
        fre: "Officier de bureau",
        sch: "\u8BA2\u4E66\u673A\u82F1\u96C4",
        bra: "O Estressado do Escrit\xf3rio",
        schema: 31036,
        hun: "T\xfczetes Tekintet",
        swe: "Byr\xe5kratiska brillor"
    },
    1442: {
        img: "shutterbug",
        eng: "Shutterbug",
        rus: "\u0417\u0430\u0442\u0432\u043E\u0440\u043D\u0438\u043A",
        pol: "Fotopluskwa",
        fre: "Cam\xe9ra cach\xe9e",
        sch: "\u76F8\u673A\u793C\u5E3D",
        bra: "Chap\xe9u Espi\xe3o",
        schema: 31048,
        hun: "K\xe9mk\xe9p\xe9sz",
        swe: "Kubbkamera"
    },
    1443: {
        img: "backbreakers_guards",
        eng: "Backbreaker's Guards",
        rus: "\u0417\u0430\u0449\u0438\u0442\u0430 \u043A\u043E\u0441\u0442\u043E\u043B\u043E\u043C\u0430",
        pol: "Ochraniacze rozwalaj\u0105cego",
        fre: "Protections du footballeur am\xe9ricain",
        sch: "\u9ECF\u5F39\u6A44\u6984\u7403\u62A4\u80A9",
        bra: "Ombreiras do Quebra-Costas",
        schema: 31039,
        hun: "Let\xe1mad\xf3 V\xe1llv\xe9d\u0151",
        swe: "Anfallarens axelskydd"
    },
    1444: {
        img: "mediterranean_mercenary",
        eng: "Mediterranean Mercenary",
        rus: "\u0421\u043B\u0443\u0433\u0430 \u0421\u0440\u0435\u0434\u0438\u0437\u0435\u043C\u043D\u043E\u043C\u043E\u0440\u044C\u044F",
        pol: "\u015Ar\xf3dziemnomorski najemnik",
        fre: "Mercenaire m\xe9diterran\xe9en",
        sch: "\u5730\u4E2D\u6D77\u4F63\u5175",
        bra: "Mercen\xe1rio Mediterr\xe2neo",
        schema: 31052,
        hun: "Mediterr\xe1n Martal\xf3c",
        swe: "Medelhavser\xf6vrare"
    },
    1445: {
        img: "dancing_doe",
        eng: "Dancing Doe",
        rus: "\u0422\u0438\u0442\u0430\u043D \u0442\u0430\u043D\u0446\u043F\u043E\u043B\u0430",
        pol: "Rozta\u0144czony Ricardo",
        fre: "Bandana exaltant",
        sch: "\u7BAD\u8FDF\u4F46\u5230",
        bra: "Doe Dan\xe7ante",
        schema: 31045,
        hun: "T\xe1ncos Cs\xe1v\xf3",
        swe: "Bandanadans"
    },
    1446: {
        img: "pompous_privateer",
        eng: "The Pompous Privateer",
        rus: "\u041A\u0443\u043B\u044C\u0442\u0443\u0440\u043D\u044B\u0439 \u043A\u0430\u043F\u0435\u0440",
        pol: "Kozacki kaper",
        fre: "Corsaire cabotin",
        sch: "\u81EA\u5927\u7684\u6D77\u76D7",
        bra: "Cors\xe1rio Convencido",
        schema: 31043,
        hun: "Ki\xf6lt\xf6z\xf6tt Kal\xf3z",
        swe: "Storslagen sj\xf6r\xf6vare"
    },
    1447: {
        img: "bottle_cap",
        eng: "The Bottle Cap",
        rus: "\u0413\u0430\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u043A\u0435\u043F\u043A\u0430",
        pol: "Kapsl\xf3wka",
        fre: "Casquette anti-soif",
        sch: "\u539F\u5B50\u80FD\u996E\u6599\u5E3D",
        bra: "Bon\xe9 At\xf4mico",
        schema: 31042,
        hun: "Kupak",
        swe: "L\xe4skkeps"
    },
    1448: {
        img: "brain_interface",
        eng: "Brain Interface",
        rus: "\u041C\u043E\u0437\u0433\u043E\u0432\u043E\u0439 \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441",
        pol: "Inteligentny interfejs",
        fre: "Interface neuronale",
        sch: "\u8111\u673A\u63A5\u53E3\u5934\u76D4",
        bra: "Interface Cerebral",
        schema: 31049,
        hun: "Agyinterf\xe9sz",
        swe: "Hj\xe4rngr\xe4nssnitt"
    },
    1449: {
        img: "wanderers_wear",
        eng: "Wanderer's Wear",
        rus: "\u0421\u043D\u0430\u0440\u044F\u0436\u0435\u043D\u0438\u0435 \u0441\u043A\u0438\u0442\u0430\u043B\u044C\u0446\u0430",
        pol: "Warstwa w\u0119drowca",
        fre: "Tenue de rando",
        sch: "\u65C5\u884C\u8005\u7684\u5927\u8863",
        bra: "Casaco do Viajante",
        schema: 31051,
        hun: "V\xe1ndorviselet",
        swe: "Vandrarens v\xe4rmejacka"
    },
    1450: {
        img: "spawn_camper",
        eng: "Spawn Camper",
        rus: "\u041F\u043E\u0434\u0436\u0438\u0434\u0430\u0442\u0435\u043B\u044C",
        pol: "Obozowicz na bazie",
        fre: "Campeur en feu",
        sch: "\u51FA\u751F\u70B9\u770B\u5B88\u8005",
        bra: "Campista da Base",
        schema: 31050,
        hun: "Sz\xfcletett T\xe1boroz\xf3",
        swe: "Bast\xe4ltaren"
    },
    1451: {
        img: "backbreakers_skullcracker",
        eng: "Backbreaker's Skullcracker",
        rus: "\u0413\u043E\u043B\u043E\u0432\u043D\u044F\u043A \u043A\u043E\u0441\u0442\u043E\u043B\u043E\u043C\u0430",
        pol: "Roz\u0142upywacz rozwalaj\u0105cego",
        fre: "Brise-cr\xe2nes du footballeur am\xe9ricain",
        sch: "\u9ECF\u5F39\u6A44\u6984\u7403\u5934\u76D4",
        bra: "Quebra-Cr\xe2nios do Quebra-Costas",
        schema: 31038,
        hun: "Let\xe1mad\xf3 L\xe9gi\xf3s",
        swe: "Romersk skallkrossare"
    },
    1452: {
        img: "kapitans_kaftan",
        eng: "Kapitan's Kaftan",
        rus: "\u041A\u0430\u043F\u0438\u0442\u0430\u043D\u0441\u043A\u0438\u0439 \u043A\u0430\u0444\u0442\u0430\u043D",
        pol: "Kaftan kapitana",
        fre: "Caftan du capitaine",
        sch: "\u961F\u957F\u7684\u957F\u888D",
        bra: "Cafet\xe3 do Capit\xe3o",
        schema: 31053,
        hun: "Kapit\xe1nyi Kaft\xe1n",
        swe: "Kaptenens kaftan"
    },
    1453: {
        img: "wagga_wagga_wear",
        eng: "Wagga Wagga Wear",
        rus: "\u0421\u0442\u0438\u043B\u044F\u0433\u0430 \u0438\u0437 \u0412\u0430\u0433\u0433\u0430-\u0412\u0430\u0433\u0433\u0430",
        pol: "Pustynne palto",
        fre: "Manteau de Wagga Wagga",
        sch: "\u74E6\u52A0\u74E6\u52A0\u5916\u5957",
        bra: "Veste de Wagga Wagga",
        schema: 31055,
        hun: "Wagga Wagga Viselet",
        swe: "Wagga Wagga-kappa"
    },
    1454: {
        img: "speedy_scoundrel",
        eng: "Speedy Scoundrel",
        rus: "\u041F\u0440\u043E\u0432\u043E\u0440\u043D\u044B\u0439 \u043F\u0440\u043E\u0439\u0434\u043E\u0445\u0430",
        pol: "\u015Apieszny szubrawiec",
        fre: "Moussaillon magnanime",
        sch: "\u795E\u901F\u6D41\u6C13",
        bra: "Pirata Perspicaz",
        schema: 31056,
        hun: "Sz\xe9lsebes Sz\xe9lh\xe1mos",
        swe: "Sj\xf6farande skurk"
    },
    1455: {
        img: "dynamite_abs",
        eng: "Dynamite Abs",
        rus: "\u0411\u043E\u043C\u0431\u0435\u0437\u043D\u044B\u0439 \u043F\u0440\u0435\u0441\u0441",
        pol: "Bombowy bebech",
        fre: "Abdynamites",
        sch: "\u70B8\u836F\u8179\u808C",
        bra: "Tanquinho Turbinado",
        schema: 31037,
        hun: "Kirobban\xf3 Forma",
        swe: "Dynamitmuskler"
    },
    1456: {
        img: "unforgiven_glory",
        eng: "Unforgiven Glory",
        rus: "\u041D\u0435\u043F\u0440\u043E\u0449\u0451\u043D\u043D\u0430\u044F \u0441\u043B\u0430\u0432\u0430",
        pol: "Nieprzebaczona chwa\u0142a",
        fre: "Glorieux borgne",
        sch: "\u65E0\u53EF\u9976\u6055\u4E4B\u8363\u8000",
        bra: "Gl\xf3ria Imperdo\xe1vel",
        schema: 31040,
        hun: "Megbocs\xe1thatatlan Dics\u0151s\xe9g",
        ger: "Unverziehener Ruhm",
        swe: "Of\xf6rl\xe5ten \xe4ra"
    },
    1457: {
        img: "bobby_bonnet",
        eng: "Bobby Bonnet",
        rus: "\u0421\u0442\u0440\u0430\u0436 \u043F\u043E\u0440\u044F\u0434\u043A\u0430",
        pol: "Garniec gliniarza",
        fre: "Policier de Sa Majest\xe9",
        sch: "\u82F1\u5F0F\u8B66\u5BDF\u5934\u76D4",
        bra: "Boina Brit\xe2nica",
        schema: 31057,
        hun: "Bobby-kalap",
        swe: "Bobbyhj\xe4lm"
    },
    1458: {
        img: "bare_necessities",
        eng: "The Bare Necessities",
        rus: "\u041F\u0440\u043E\u0441\u0442\u044B\u0435 \u0440\u0430\u0434\u043E\u0441\u0442\u0438",
        pol: "Podstawowe potrzeby",
        fre: "Le minimum vital",
        sch: "\u57FA\u672C\u5FC5\u9700\u54C1",
        bra: "Necessidades B\xe1sicas",
        schema: 31054,
        hun: "Alapell\xe1tm\xe1ny",
        swe: "N\xf6dv\xe4ndigheter"
    },
    1459: {
        img: "fiery_phoenix",
        eng: "The Fiery Phoenix",
        rus: "\u041F\u043B\u0430\u043C\u0435\u043D\u043D\u044B\u0439 \u0444\u0435\u043D\u0438\u043A\u0441",
        pol: "Ognisty Feniks",
        fre: "Ph\xe9nix flamboyant",
        sch: "\u4E0D\u6B7B\u4E4B\u9E1F",
        bra: "F\xeanix Flamejante",
        schema: 31047,
        hun: "Forr\xf3 F\u0151nix",
        swe: "Flammande fenix"
    },
    1460: {
        img: "peacebreaker",
        eng: "The Peacebreaker",
        rus: "\u041C\u0438\u0440\u043E\u043B\u043E\u043C\u0435\u0446",
        pol: "Siewca wojny",
        fre: "T\xeate chercheuse",
        sch: "\u548C\u5E73\u7834\u574F\u8005",
        bra: "Provocador",
        schema: 31044,
        hun: "B\xe9kefeltart\xf3",
        swe: "Fredsbrytaren"
    },
    1461: {
        img: "texas_toast",
        eng: "Texas Toast",
        rus: "\u0422\u0435\u0445\u0430\u0441\u0441\u043A\u0438\u0435 \u0442\u043E\u0441\u0442\u044B",
        pol: "Teksa\u0144ski tost",
        fre: "Pain gagn\xe9",
        sch: "\u5FB7\u5DDE\u9762\u5305\u673A",
        bra: "Torradeira Texana",
        schema: 31046,
        swe: "Br\xf6drostshatt"
    },
    1462: {
        img: "baseball_bills_sports_shine",
        eng: "Baseball Bill's Sports Shine",
        rus: "\u0421\u043F\u043E\u0440\u0442\u0438\u0432\u043D\u044B\u0439 \u0433\u0435\u043B\u044C \u0434\u043B\u044F \u0432\u043E\u043B\u043E\u0441",
        pol: "Sportowy po\u0142ysk baseballowego Bogusia",
        sch: "\u68D2\u7403\u6BD4\u5C14\u7684\u53D1\u8721\u5934",
        fre: "Cheveux gomin\xe9s",
        bra: "Bill, Estrela Esportiva do Beisebol",
        schema: 111,
        hun: "Baseball Bill bel\u0151tt b\xfar\xe1ja",
        swe: "Baseboll-Bills Vaxade V\xe5gor"
    },
    1463: {
        img: "boston_boom_bringer",
        eng: "Boston Boom-Bringer",
        rus: "\u0411\u043E\u0441\u0442\u043E\u043D\u0441\u043A\u0438\u0439 \u0431\u0443\u043C\u0431\u0438\u043B\u0430",
        pol: "Bosto\u0144ski boom-bringer",
        sch: "\u6CE2\u58EB\u987F\u566A\u97F3\u5236\u9020\u8005",
        fre: "Le Bon Son de Boston",
        bra: "O Pancad\xe3o da Periferia",
        schema: 707,
        hun: "A Bostoni Bed\xf6nget\u0151",
        swe: "Bostonbergspr\xe4ngaren"
    },
    1464: {
        img: "stereoscopic_shades",
        eng: "Stereoscopic Shades",
        rus: "\u0421\u0442\u0435\u0440\u0435\u043E\u0441\u043A\u043E\u043F\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043E\u0447\u043A\u0438",
        pol: "Stereoskopowe szk\u0142a",
        sch: "3D \u7ACB\u4F53\u773C\u955C",
        fre: "Les Lunettes St\xe9r\xe9oscopiques",
        bra: "Os \xd3culos Estereosc\xf3picos",
        schema: 630,
        hun: "A Sztereoszkopikus Szem\xfcveg",
        swe: "Stereoskopiska Solglas\xf6gon"
    },
    1465: {
        img: "soldiers_stogie",
        eng: "Soldier's Stogie",
        rus: "\u0421\u043E\u043B\u0434\u0430\u0442\u0441\u043A\u0430\u044F \u0441\u0438\u0433\u0430\u0440\u0430",
        pol: "Puro piechura",
        sch: "\u58EB\u5175\u7684\u5EC9\u4EF7\u96EA\u8304",
        fre: "Le cigare du Soldier",
        bra: "O Fumo do Soldier",
        schema: 852,
        hun: "A Katona Staubja",
        swe: "Soldatens Cigarill"
    },
    1466: {
        img: "apparitions_aspect",
        eng: "Apparition's Aspect",
        rus: "\u041F\u0440\u0438\u0437\u0440\u0430\u0447\u043D\u0430\u044F \u0443\u0445\u043C\u044B\u043B\u043A\u0430",
        pol: "Zjawisko nadpyrodzone",
        sch: "\u5E7D\u7075\u9762\u7F69",
        fre: "L'aspect de l'apparition",
        bra: "Aspecto da Apari\xe7\xe3o",
        schema: 571,
        schema2: 5759,
        hun: "J\xf3k\xe9p\u0171 Jelen\xe9s",
        swe: "Sp\xf6kbildens Synpunkt"
    },
    1467: {
        img: "burning_bongos",
        eng: "Burning Bongos",
        rus: "\u0417\u0430\u0436\u0438\u0433\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0431\u043E\u043D\u0433\u043E",
        pol: "P\u0142on\u0105ce bongosy",
        sch: "\u7EB5\u706B\u72C2\u7684\u5C0F\u9F13",
        fre: "Les Bongos Ardents",
        bra: "Os Bong\xf4s em Brasas",
        schema: 746,
        hun: "A L\xe1ngol\xf3 Bong\xf3k",
        swe: "Brinnande Bongotrummorna"
    },
    1468: {
        img: "cremators_conscience",
        eng: "Cremator's Conscience",
        rus: "\u0421\u043E\u0432\u0435\u0441\u0442\u044C \u043F\u043E\u0434\u0436\u0438\u0433\u0430\u0442\u0435\u043B\u044F",
        pol: "Sumienie sadysty",
        sch: "\u711A\u5C38\u8005\u7684\u826F\u5FC3",
        fre: "La Conscience du Cr\xe9mateur",
        bra: "A Consci\xeancia do Cremador",
        schema: 632,
        hun: "A L\xe1ngsz\xf3r\xf3s Lelkiismerete",
        swe: "Kremat\xf6rens Samvete"
    },
    1469: {
        img: "last_breath",
        eng: "Last Breath",
        rus: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 \u0432\u0437\u0434\u043E\u0445",
        pol: "Ostatnie tchnienie",
        sch: "\u9AB7\u9AC5\u5934\u9AA8",
        fre: "Le Dernier Souffle",
        bra: "O \xdaltimo Suspiro",
        schema: 570,
        hun: "Az Utols\xf3 L\xe9legzet",
        swe: "Det sista andetaget"
    },
    1470: {
        img: "popeyes",
        eng: "Pop-Eyes",
        rus: "\u0413\u043B\u0430\u0437\u0430 \u043D\u0430\u0432\u044B\u043A\u0430\u0442",
        pol: "Gibaj\u0105ce ga\u0142y",
        sch: "\u5F39\u7C27\u773C",
        fre: "Pop-eyes",
        bra: "Olhos Zarolhos",
        schema: 30176,
        hun: "A kid\xfclled\u0151 szemek",
        swe: "\xd6gonab\xf6j"
    },
    1471: {
        img: "a_whiff_of_the_old_brimstone",
        eng: "A Whiff of the Old Brimstone",
        rus: "\u0410\u0440\u043E\u043C\u0430\u0442 \u0441\u0442\u0430\u0440\u043E\u0439 \u0434\u043E\u0431\u0440\u043E\u0439 \u0441\u0435\u0440\u044B",
        pol: "Powiew siareczki",
        sch: "\u4E00\u4E1D\u53E4\u8001\u7684\u786B\u78FA\u6C14\u606F",
        fre: "Une bouff\xe9e de soufre \xe0 l'ancienne",
        bra: "Uma Baforada de Enxofre",
        schema: 610,
        hun: "Egy Szippant\xe1s a J\xf3 \xd6reg K\xe9nk\u0151b\u0151l",
        swe: "En pust av det gamla svavlet"
    },
    1472: {
        img: "aladdins_private_reserve",
        eng: "Aladdin's Private Reserve",
        rus: "\u041D\u0435\u043F\u0440\u0438\u043A\u043E\u0441\u043D\u043E\u0432\u0435\u043D\u043D\u044B\u0439 \u0437\u0430\u043F\u0430\u0441 \u0410\u043B\u0430\u0434\u0434\u0438\u043D\u0430",
        pol: "Osobista rezerwa Aladyna",
        sch: "\u963F\u62C9\u4E01\u7684\u79C1\u4EBA\u85CF\u54C1",
        fre: "La r\xe9serve priv\xe9e d'Aladdin",
        bra: "Reserva Especial do Aladim",
        schema: 708,
        hun: "Aladdin Dugipi\xe1ja",
        swe: "Aladdins privata reserv"
    },
    1473: {
        img: "liquor_locker",
        eng: "Liquor Locker",
        rus: "\u0420\u043E\u043C\u043E\u0432\u044B\u0439 \u0440\u0443\u043D\u0434\u0443\u043A",
        pol: "Bombowy barek",
        sch: "\u70C8\u9152\u50A8\u5B58\u7BB1",
        fre: "Le Coffre \xe0 liqueurs",
        bra: "O Ba\xfa de Bebidas",
        schema: 771,
        hun: "A L\xf6tty\xf6s L\xe1dik\xf3",
        swe: "Spritsk\xe5pet"
    },
    1474: {
        img: "snapped_pupil",
        eng: "Snapped Pupil",
        rus: "\u0421\u043D\u0438\u043C\u043E\u043A \u0433\u043B\u0430\u0437\u0430",
        pol: "Za\u015Blepka",
        sch: "\u72EC\u773C\u5FEB\u7167",
        fre: "La Photo de la pupille",
        bra: "A Pupila Dilatada",
        schema: 709,
        hun: "A Lekapott Pupilla",
        swe: "Den pl\xe5tade pupillen"
    },
    1475: {
        img: "little_bear",
        eng: "Little Bear",
        rus: "\u041C\u0430\u043B\u0435\u043D\u044C\u043A\u0438\u0439 \u043C\u0435\u0434\u0432\u0435\u0436\u043E\u043D\u043E\u043A",
        pol: "Ma\u0142y mi\u015B",
        sch: "\u80B2\u718A\u888B",
        fre: "Petit Ours Robot",
        bra: "O Ursinho",
        schema: 1097,
        hun: "A Kismaci",
        swe: "Den lilla bj\xf6rnen"
    },
    1476: {
        img: "toss_proof_towel",
        eng: "Toss-Proof Towel",
        rus: "\u041D\u0435\u0441\u043F\u0430\u0434\u0430\u044E\u0449\u0435\u0435 \u043F\u043E\u043B\u043E\u0442\u0435\u043D\u0446\u0435",
        pol: "Rzutoodporny r\u0119cznik",
        sch: "\u6254\u4E0D\u6389\u7684\u6BDB\u5DFE",
        fre: "Serviette du vainqueur",
        bra: "Toalha Antidesist\xeancia",
        schema: 757,
        hun: "Bedob\xe1s-\xc1ll\xf3 T\xf6r\xf6lk\xf6z\u0151",
        swe: "Kasts\xe4kra Handduken"
    },
    1477: {
        img: "texas_half_pants",
        eng: "Texas Half-Pants",
        rus: "\u0422\u0435\u0445\u0430\u0441\u0441\u043A\u0438\u0435 \u0447\u0430\u043F\u0441\u044B",
        pol: "Wyczesane czapsy",
        sch: "\u5FB7\u5DDE\u4E94\u5206\u88E4",
        fre: "Le Demi-Pantalon du Texas",
        bra: "Meia-cal\xe7a Texana",
        schema: 755,
        hun: "Texasi F\xe9lnadr\xe1g",
        swe: "Halvbyxor fr\xe5n Texas"
    },
    1478: {
        img: "texas_slims_dome_shine",
        eng: "Texas Slim's Dome Shine",
        rus: "\u0422\u0435\u0445\u0430\u0441\u0441\u043A\u0430\u044F \u0431\u043B\u0435\u0441\u0442\u044F\u0449\u0430\u044F \u043B\u044B\u0441\u0438\u043D\u0430",
        pol: "B\u0142yszcz\u0105ca glaca teksa\u0144skiego Sta\u015Bka",
        sch: "\u5FB7\u5DDE\u7626\u5B50\u4E09\u5206\u5934",
        fre: "Cr\xe2ne chauve et luisant",
        bra: "C\xfapula Brilhante do Texas Slim",
        schema: 118,
        hun: "Texas Slim Kop\xe1r Kobakja",
        swe: "Texas Slims Skallglans"
    },
    1479: {
        img: "archimedes",
        eng: "Archimedes",
        rus: "\u0410\u0440\u0445\u0438\u043C\u0435\u0434",
        pol: "Archimedes",
        sch: "\u963F\u57FA\u7C73\u5FB7",
        fre: "Archim\xe8de",
        bra: "Arquimedes",
        schema: 828,
        hun: "Arkhim\xe9d\xe9sz",
        rom: "Arhimede",
        swe: "Arkimedes"
    },
    1480: {
        img: "couvre_corner",
        eng: "Couvre Corner",
        rus: "\u0421\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0439 \u043F\u043B\u0430\u0442\u043E\u043A",
        pol: "Powa\u017Cna poszetka",
        sch: "\u6574\u6D01\u7684\u624B\u5E15",
        fre: "Mouchoir en coin",
        bra: "Canto Encouvrerto",
        schema: 620,
        hun: "Csinos Cs\xfccs\xf6k",
        swe: "N\xe4tt N\xe4sduk"
    },
    1481: {
        img: "nine_pipe_problem",
        eng: "Nine-Pipe Problem",
        rus: "\u0417\u0430\u0434\u0430\u0447\u0430 \u043D\u0430 \u0434\u0435\u0432\u044F\u0442\u044C \u0442\u0440\u0443\u0431\u043E\u043A",
        pol: "Problem na dziewi\u0119\u0107 fajek",
        sch: "\u4E5D\u53E3\u70DF\u7684\u5927\u95EE\u9898",
        fre: "Le probl\xe8me pour neuf pipes",
        bra: "O Enigma de Nove Tragadas",
        schema: 657,
        hun: "A Kilencpip\xe1s Feladat",
        swe: "Niopiporsproblemet"
    },
    1482: {
        img: "surgeons_stethoscope",
        eng: "Surgeon's Stethoscope",
        rus: "\u0412\u0440\u0430\u0447\u0435\u0431\u043D\u044B\u0439 \u0441\u0442\u0435\u0442\u043E\u0441\u043A\u043E\u043F",
        pol: "Stetoskop Eskulapa",
        sch: "\u5916\u79D1\u533B\u751F\u7684\u542C\u8BCA\u5668",
        fre: "Le St\xe9thoscope de Chirurgien",
        bra: "O Estetosc\xf3pio do Cirurgi\xe3o",
        schema: 621,
        hun: "A Seb\xe9szi Sztetoszk\xf3p",
        swe: "Sjukv\xe5rdarens Stetoskop"
    },
    1483: {
        img: "ritzy_ricks_hair_fixative",
        eng: "Ritzy Rick's Hair Fixative",
        rus: "\u041B\u0430\u043A \u0434\u043B\u044F \u0440\u043E\u0441\u043A\u043E\u0448\u043D\u043E\u0439 \u0448\u0435\u0432\u0435\u043B\u044E\u0440\u044B",
        pol: "Utrwalacz do w\u0142os\xf3w Ry\u017Cawego Ry\u015Bka",
        sch: "\u65F6\u9AE6\u745E\u514B\u7684\u540E\u68B3\u5934",
        fre: "Coupe parfaite, fixation extr\xeame",
        bra: "Gel de Cabelo do Ritzy Rick",
        schema: 117,
        hun: "Ritzy Rick Sir\xe1ly S\xe9r\xf3ja",
        swe: "Ritzy Ricks H\xe5rfixativ"
    },
    1484: {
        img: "camera_beard",
        eng: "Camera Beard",
        rus: "\u0411\u043E\u0440\u043E\u0434\u0430 \u0441 \u043A\u0430\u043C\u0435\u0440\u043E\u0439",
        pol: "Broda z aparatem",
        sch: "\u76F8\u673A\u80E1\u5B50",
        fre: "Barbe-appareil photo",
        bra: "Barba C\xe2mera",
        schema: 103,
        hun: "F\xe9nyk\xe9pez\u0151-szak\xe1ll",
        swe: "Kamerask\xe4gg"
    },
    1485: {
        img: "sneaky_spats_of_sneaking",
        eng: "Sneaky Spats of Sneaking",
        rus: "\u041D\u0435\u0441\u043B\u044B\u0448\u043D\u044B\u0435 \u0448\u0442\u0438\u0431\u043B\u0435\u0442\u044B \u0442\u0438\u0448\u0438\u043D\u044B",
        pol: "Ciche cholewniki cichociemnego",
        sch: "\u9B3C\u9B3C\u795F\u795F\u6F5C\u884C\u978B\u7F69",
        fre: "Les Gu\xeatres furtives de furetage",
        bra: "Os Sapatos Sorrateiros de Sorrateiridade",
        schema: 763,
        hun: "A Lopva Lop\xf3dz\xf3 Kam\xe1slik",
        swe: "De Smygiga Smygardamaskerna"
    },
    1486: {
        img: "spectres_spectacles",
        eng: "Spectre's Spectacles",
        rus: "\u041E\u0447\u043A\u0438 \u043F\u0440\u0438\u0437\u0440\u0430\u043A\u0430",
        pol: "Binokle widma",
        sch: "\u5E7D\u7075\u7684\u773C\u955C",
        fre: "Les Lunettes de spectre",
        bra: "O Espet\xe1culo do Espectro",
        schema: 629,
        hun: "A Szellemes Szem\xfcveg",
        swe: "Gastens Glas\xf6gon"
    },
    1487: {
        img: "champ_stamp",
        eng: "Champ Stamp",
        rus: "\u041A\u043B\u0435\u0439\u043C\u043E \u0447\u0435\u043C\u043F\u0438\u043E\u043D\u0430",
        pol: "Tatua\u017C twardziela",
        sch: "\u4F63\u5175\u7684\u9F99\u523A\u9752",
        fre: "Le Tampon du Champion",
        bra: "A Marca do Campe\xe3o",
        schema: 815,
        hun: "A Bajnoki Pecs\xe9t",
        swe: "M\xe4starm\xe4rket"
    },
    1488: {
        img: "clan_pride",
        eng: "Clan Pride",
        rus: "\u0413\u043E\u0440\u0434\u043E\u0441\u0442\u044C \u043A\u043B\u0430\u043D\u0430",
        pol: "Duma klanu",
        sch: "\u5BB6\u65CF\u5FBD\u7AE0",
        fre: "Fiert\xe9 de l'\xc9quipe",
        bra: "Orgulho do Cl\xe3",
        schema: 625,
        hun: "Kl\xe1nb\xfcszkes\xe9g",
        swe: "Klanens Stolthet"
    },
    1489: {
        img: "dr_whoa",
        eng: "Dr. Whoa",
        rus: "\u0414-\u0440 \u041A\u0442\u043E\u0439",
        pol: "Dr Whoa",
        sch: "\u7EC5\u58EB\u7684\u8774\u8776\u7ED3",
        fre: "Dr. Whoa",
        bra: "TARDIS Demais",
        schema: 639,
        hun: "Dr. H\xfa"
    },
    1490: {
        img: "flair",
        eng: "Flair!",
        rus: "\u0417\u043D\u0430\u0447\u043A\u0438!",
        pol: "Przypinki!",
        sch: "\u6F02\u4EAE\u7684\u5C0F\u5FBD\u7AE0",
        fre: "Flair !",
        bra: "Broches(!)",
        schema: 619,
        hun: "csecsebecse!",
        swe: "K\xe4nsla!"
    },
    1491: {
        img: "itsy_bitsy_spyer",
        eng: "Itsy Bitsy Spyer",
        rus: "\u041A\u0440\u043E\u0445\u0430 \u0428\u043F\u0430\u0443\u0447\u043E\u043A",
        pol: "Tyci-tyci Szpieg",
        sch: "\u5C0F\u4E0D\u70B9\u95F4\u8C0D",
        fre: "Le Itsy Bitsy Spyer",
        bra: "O Espi\xe3ozinho",
        schema: 646,
        hun: "Az Ici-Pici-K\xe9m",
        swe: "Imse Vimse Spion"
    },
    1492: {
        img: "marxman",
        eng: "Marxman",
        rus: "\u041E\u0447\u043A\u0438 \u041C\u0430\u0440\u043A\u0441\u0430",
        pol: "Marksowe oblicze",
        sch: "\u5927\u9F3B\u7B11\u5496",
        fre: "Le Marxman",
        bra: "O Grouchin\xeas",
        schema: 816,
        hun: "A Bukt\xe1s",
        rom: "\u0162int\u0103 Fix\u0103",
        swe: "Marxmannen"
    },
    1493: {
        img: "photo_badge",
        eng: "Photo Badge",
        rus: "\u041B\u0438\u0447\u043D\u044B\u0439 \u043F\u0440\u043E\u043F\u0443\u0441\u043A",
        pol: "Odznaka ze zdj\u0119ciem",
        sch: "\u7167\u7247\u5FBD\u7AE0",
        fre: "Badge Photo",
        bra: "Crach\xe1 com Foto",
        schema: 623,
        hun: "F\xe9nyk\xe9pes Jelv\xe9ny",
        swe: "Fotom\xe4rke"
    },
    1494: {
        img: "reindoonicorn",
        eng: "Reindoonicorn",
        rus: "\u041D\u0430\u0434\u0443\u0432\u043E\u043B\u0435\u043D\u0435\u0440\u043E\u0433",
        pol: "Renifero\u017Cec",
        sch: "\u6C14\u7403\u9A6F\u9E7F\u72EC\u89D2\u517D",
        fre: "Le Rennicorne",
        bra: "O Renac\xf3rnio",
        schema: 995,
        hun: "A R\xe9nkornis",
        swe: "Renh\xf6rningen"
    },
    1495: {
        img: "teufort_tooth_kicker",
        eng: "Teufort Tooth Kicker",
        rus: "\u0422\u0443\u0444\u043E\u0440\u0442\u0441\u043A\u0438\u0439 \u0437\u0443\u0431\u043E\u043B\u043E\u043C",
        pol: "Teufordzkie kopacze trzonowc\xf3w",
        sch: "\u53CC\u57CE\u788E\u9F7F\u8005",
        fre: "Le botteur de dents de Teufort",
        bra: "O Tira Dentes de Teufort",
        schema: 734,
        hun: "A Teuforti Sz\xe1jbar\xfag\xf3",
        swe: "Teufort-tandsparkarna"
    },
    1496: {
        img: "triad_trinket",
        eng: "Triad Trinket",
        rus: "\u0426\u0435\u043F\u043E\u0447\u043A\u0430 \u0422\u0440\u0438\u0430\u0434\u044B",
        pol: "Ozdoba opryszka",
        sch: "\u4E09\u5408\u4F1A\u9970\u8863",
        fre: "Le Colifichet de la Triade",
        bra: "O Talism\xe3 da Tr\xedade",
        schema: 814,
        hun: "A Tri\xe1d Bizsu",
        swe: "Brottssyndikatets Skr\xe4psmycke"
    },
    1497: {
        img: "tuxxy",
        eng: "Tuxxy",
        rus: "\u0422\u0443\u043A\u0441\u0438",
        pol: "Saxxowny smoking",
        sch: "\u8428\u6C0F\u71D5\u5C3E\u670D",
        fre: "Le Tuxxy",
        bra: "O Tuxxy",
        schema: 955,
        hun: "A Szmoxxy",
        ger: "Der Tuxxy"
    },
    1498: {
        img: "DUMMY",
        eng: "DUMMY"
    },
    1499: {
        img: "derangement_garment",
        eng: "Derangement Garment",
        rus: "\u0420\u0443\u0431\u0430\u0448\u043A\u0430 \u0440\u0443\u0431\u0438\u0442\u0435\u043B\u044F",
        pol: "Pasy psychola",
        fre: "Camisole de sadiste",
        sch: "\u72C2\u4EBA\u7EA6\u675F\u8863",
        bra: "Indulto do Maluco",
        schema: 31078,
        hun: "Eszel\u0151s \xd6lt\xf6z\xe9k",
        swe: "Tv\xe5ngstr\xf6ja"
    },
    1500: {
        img: "fuel_injector",
        eng: "Fuel Injector",
        rus: "\u0422\u043E\u043F\u043B\u0438\u0432\u043D\u044B\u0439 \u0438\u043D\u0436\u0435\u043A\u0442\u043E\u0440",
        pol: "Po\u0142ykacz paliwa",
        fre: "Pompe \xe0 d\xe9mence",
        sch: "\u71C3\u6599\u55B7\u5C04\u5668",
        bra: "Injetor de Combust\xedvel",
        schema: 31081,
        hun: "\xdczemanyag-befecskendez\u0151",
        swe: "Br\xe4nsleslangar"
    },
    1501: {
        img: "party_poncho",
        eng: "Party Poncho",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u043E\u0435 \u043F\u043E\u043D\u0447\u043E",
        pol: "Przyj\u0119ciowe ponczo",
        fre: "Poncho de fiesta",
        sch: "\u6D3E\u5BF9\u6597\u7BF7",
        bra: "Poncho Pitoresco",
        schema: 31070,
        hun: "Parti-poncs\xf3",
        swe: "Partyponcho"
    },
    1502: {
        img: "pocket_halloween_boss",
        eng: "Pocket Halloween Boss",
        rus: "\u041A\u0430\u0440\u043C\u0430\u043D\u043D\u044B\u0439 \u0431\u043E\u0441\u0441 \u0425\u0435\u043B\u043B\u043E\u0443\u0438\u043D\u0430",
        pol: "Kieszonkowy boss halloweenowy",
        fre: "Boss d'Halloween de poche",
        sch: "\u53E3\u888B\u5996\u602A",
        bra: "Chef\xe3o de Bolso",
        schema: 31061,
        hun: "Zseb-halloweeni-f\u0151ellens\xe9g",
        swe: "Fick-Halloweenboss"
    },
    1503: {
        img: "binoculus",
        eng: "BINOCULUS!",
        rus: "\u041E\u0427\u041A\u0410\u0421\u0422\u0423\u0421!",
        pol: "BINOKULUS!",
        fre: "BINOCULUS !",
        sch: "\u9B54\u773C\uFF08\u955C\uFF09",
        bra: "BIN\xd3CULUS!",
        schema: 31060,
        ger: "BINOKULUS!"
    },
    1504: {
        img: "candy_cranium",
        eng: "Candy Cranium",
        rus: "\u0421\u043B\u0430\u0434\u043A\u0438\u0439 \u0441\u043A\u0430\u043B\u044C\u043F",
        pol: "Cukrowa czacha",
        fre: "Pochette surprise",
        sch: "\u7CD6\u679C\u8111\u888B",
        bra: "Cr\xe2nio Confeitado",
        schema: 31067,
        hun: "Cukorpofa",
        swe: "Skallekaramell"
    },
    1505: {
        img: "el_mostacho",
        eng: "El Mostacho",
        rus: "\u042D\u043B\u044C \u0423\u0441\u0438\u0449\u0438\u043E",
        pol: "El w\u0105saczo",
        fre: "El Mostacho",
        sch: "\u957F\u987B\u795E\u5DE5",
        bra: "El Bigod\xf3n",
        schema: 31074,
        hun: "El Bajuszo"
    },
    1506: {
        img: "bat_hat",
        eng: "Bat Hat",
        rus: "\u0411\u0435\u0439\u0441\u0431\u043E\u043B\u044C\u043D\u0430\u044F \u043C\u044B\u0448\u044C",
        pol: "Nietoperze nakrycie",
        fre: "Chauve souriant",
        sch: "\u5361\u901A\u8759\u8760\u5E3D",
        bra: "Capelo Morcego",
        schema: 31058,
        hun: "Denev\xe9rsapka",
        swe: "Fladderm\xf6ssa"
    },
    1507: {
        img: "convict_cap",
        eng: "Convict Cap",
        rus: "\u0422\u044E\u0440\u0435\u043C\u043D\u0430\u044F \u0442\u044E\u0431\u0435\u0442\u0435\u0439\u043A\u0430",
        pol: "Obity osadzony",
        fre: "Bonnet de bagnard",
        sch: "\u56DA\u72AF\u4E4B\u5E3D",
        bra: "Chap\xe9u do Condenado",
        schema: 31080,
        hun: "Fegyencsapka",
        swe: "F\xe4ngelsem\xf6ssa"
    },
    1508: {
        img: "bread_biter",
        eng: "Bread Biter",
        rus: "\u0425\u043B\u0435\u0431\u043D\u044B\u0439 \u0445\u0438\u0449\u043D\u0438\u043A",
        pol: "Chrupacz chleba",
        fre: "Un pain c'est tout",
        sch: "\u9762\u5305\u53E3\u7F69",
        bra: "Dentada Mofada",
        schema: 31062,
        hun: "Keny\xe9rharap\xf3",
        swe: "Br\xf6dbitaren"
    },
    1509: {
        img: "el_zapateador",
        eng: "El Zapateador",
        rus: "\u042D\u043B\u044C \u0421\u0430\u043F\u0430\u0442\u0430\u0434\u043E\u0440",
        pol: "El Zapateador",
        fre: "El Zapateador",
        sch: "\u9769\u547D\u9886\u8896",
        bra: "El Zapateador",
        schema: 31069
    },
    1510: {
        img: "voodoo_vizier",
        eng: "Voodoo Vizier",
        rus: "\u0412\u0438\u0437\u0438\u0440\u044C \u0432\u0443\u0434\u0443",
        pol: "Wezyr voodoo",
        fre: "Vizir vaudou",
        sch: "\u5DEB\u6BD2\u9762\u5177",
        bra: "Vizir Vudu",
        schema: 31072,
        hun: "Vudu Vez\xedr",
        swe: "Voodoomask"
    },
    1511: {
        img: "soviet_strongmann",
        eng: "Soviet Strongmann",
        rus: "\u0421\u043E\u0432\u0435\u0442\u0441\u043A\u0438\u0439 \u0441\u0438\u043B\u0430\u0447",
        pol: "Sowiecki strongmann",
        fre: "Force sovi\xe9tique",
        sch: "\u82CF\u7EF4\u57C3\u731B\u7537",
        bra: "Musculatura M\xe1rxima",
        schema: 31079,
        hun: "Szovjet Er\u0151sember",
        swe: "Sovjetisk styrkelyftare"
    },
    1512: {
        img: "skullbrero",
        eng: "Skullbrero",
        rus: "\u0427\u0435\u0440\u0435\u0431\u0440\u0435\u0440\u043E",
        pol: "Czaszkombrero",
        fre: "Sombrero sinistre",
        sch: "\u4EA1\u8005\u4E4B\u5E3D",
        bra: "Cavero",
        schema: 31066,
        hun: "Koponyero",
        swe: "Skallebrero"
    },
    1513: {
        img: "horrible_horns",
        eng: "The Horrible Horns",
        rus: "\u0420\u043E\u043A\u043E\u0432\u044B\u0435 \u0440\u043E\u0433\u0430",
        pol: "Potworne poro\u017Ce",
        fre: "Cornes horribles",
        sch: "\u6050\u6016\u9B54\u89D2",
        bra: "Chifres Cabulosos",
        schema: 31063,
        hun: "Sz\xf6rny\u0171 Szarvak",
        swe: "Hemska horn"
    },
    1514: {
        img: "madmanns_muzzle",
        eng: "Madmann's Muzzle",
        rus: "\u041C\u0430\u0441\u043A\u0430 \u043C\u044F\u0441\u043E\u0435\u0434\u0430",
        pol: "Namordnik niepoczytalnego",
        fre: "Museli\xe8re meurtri\xe8re",
        sch: "\u72C2\u4EBA\u9762\u7F69",
        bra: "Morda\xe7a do Maluco",
        schema: 31077,
        hun: "Az \u0150r\xfclt Sz\xe1jkosara",
        swe: "Manikerns munkorg"
    },
    1515: {
        img: "trick_stabber",
        eng: "The Trick Stabber",
        rus: "\u041E\u0431\u043C\u0430\u043D\u043A\u0430",
        pol: "Szmaciany spryciarz",
        fre: "Poignardeur",
        sch: "\u9762\u523A\u4E13\u5BB6",
        bra: "Apanhador de Costas",
        schema: 31064,
        hun: "Tr\xfckk\xf6s B\xf6k\u0151",
        swe: "Knivhuggsknep"
    },
    1516: {
        img: "elizabeth_the_third",
        eng: "Elizabeth the Third",
        rus: "\u0415\u043B\u0438\u0437\u0430\u0432\u0435\u0442\u0430 III",
        pol: "El\u017Cbieta Trzecia",
        fre: "\xc9lisabeth III",
        sch: "\u4F0A\u4E3D\u838E\u767D\u4E09\u4E16",
        bra: "Elizabeth III",
        schema: 31084,
        hun: "Harmadik Elizabeth",
        swe: "Elizabeth III"
    },
    1517: {
        img: "head_of_the_dead",
        eng: "Head of the Dead",
        rus: "\u041B\u0438\u043A \u043C\u0451\u0440\u0442\u0432\u044B\u0445",
        pol: "Twarz truposza",
        fre: "T\xeate de mort",
        sch: "\u4EA1\u8005\u4E4B\u738B",
        bra: "Cabe\xe7a dos Mortos",
        schema: 31065,
        hun: "A Hal\xe1l-fejes",
        swe: "D\xf6dens skalle"
    },
    1518: {
        img: "racc_mann",
        eng: "Racc Mann",
        rus: "\u0415\u043D\u043E\u0442\u043E\u0432\u0438\u0434\u043D\u044B\u0439 \u0432\u043E\u044F\u043A\u0430",
        pol: "Superszop",
        fre: "Raton tueur",
        sch: "\u6D63\u718A\u4FA0",
        bra: "Guaxe-Mann",
        schema: 31071,
        hun: "Mos\xf3mannus",
        swe: "Tv\xe4ttbj\xf6rnsmannen"
    },
    1519: {
        img: "pyro_lantern",
        eng: "Pyr'o Lantern",
        rus: "\u041F\u043B\u0430\u043C\u0435\u043D\u043D\u044B\u0439 \u0444\u043E\u043D\u0430\u0440\u044C",
        pol: "Dyniowa \u015Bwiat\u0142o\u015B\u0107",
        fre: "Citrouille lanterne",
        sch: "\u706B\u7130\u5357\u74DC\u706F",
        bra: "Pyro Sem Cabe\xe7a",
        schema: 31076,
        hun: "Pirol\xe1mp\xe1s",
        swe: "Pyrolykta"
    },
    1520: {
        img: "mister_bones",
        eng: "Mister Bones",
        rus: "\u041C\u0438\u0441\u0442\u0435\u0440 \u0441\u043A\u0435\u043B\u0435\u0442",
        pol: "Pan Kostek",
        fre: "Monsieur Bones",
        sch: "\u9AB7\u9AC5\u5148\u751F",
        bra: "Senhor Ossos",
        schema: 31059,
        hun: "Csont \xfar",
        swe: "Herr Bones"
    },
    1521: {
        img: "pebbles_the_penguin",
        eng: "Pebbles the Penguin",
        rus: "\u041F\u0438\u043D\u0433\u0432\u0438\u043D \u041F\u0435\u0431\u043B\u0441",
        pol: "Pingwin Pierzu\u015B",
        fre: "Manchot l'empereur",
        sch: "\u5C0F\u4F01\u9E45\u5375\u77F3",
        bra: "Pedro, o Pinguim",
        schema: 31086,
        hun: "Pajti, a pingvin",
        swe: "Pingvinen Pebbles"
    },
    1522: {
        img: "citizen_cane",
        eng: "Citizen Cane",
        rus: "\u0421\u044D\u0440 \u0421\u043B\u0430\u0434\u043E\u0441\u0442\u044C",
        pol: "Cukrowy cudak",
        fre: "Chapeau d'orge",
        sch: "\u516C\u6C11\u7CD6\u6756",
        bra: "Cidad\xe3o A\xe7ucarado",
        schema: 31091,
        hun: "Cukorpolg\xe1r",
        swe: "Sockertopp"
    },
    1523: {
        img: "missing_piece",
        eng: "Missing Piece",
        rus: "\u0423\u0442\u0435\u0440\u044F\u043D\u043D\u044B\u0439 \u0443\u0431\u043E\u0440",
        pol: "Brakuj\u0105cy element",
        fre: "Bonnet introuvable",
        sch: "\u5931\u8E2A\u4EBA\u53E3",
        bra: "Pe\xe7a Perdida",
        schema: 31101,
        hun: "Hi\xe1nyz\xf3 Darab",
        ger: "Fehlendes St\xfcck",
        swe: "Saknad bit"
    },
    1524: {
        img: "glittering_garland",
        eng: "Glittering Garland",
        rus: "\u0413\u043E\u0440\u0434\u0435\u043B\u0438\u0432\u0430\u044F \u0433\u0438\u0440\u043B\u044F\u043D\u0434\u0430",
        pol: "Wymuskany wieniec",
        fre: "Guirlande enguirland\xe9e",
        sch: "\u70AB\u76EE\u82B1\u73AF",
        bra: "Guirlanda Brilhante",
        schema: 31093,
        hun: "F\xe9nyl\u0151 F\xfcz\xe9r",
        swe: "Glittrig krans"
    },
    1525: {
        img: "yule_hog",
        eng: "Yule Hog",
        rus: "\u0421\u0432\u044F\u0442\u043E\u0447\u043D\u0430\u044F \u0441\u0432\u0438\u043D\u0438\u043D\u0430",
        pol: "Szapoklak z szynki",
        fre: "Jambon de No\xebl",
        sch: "\u5723\u8BDE\u706B\u817F",
        bra: "Presunto Presun\xe7oso",
        schema: 31087,
        hun: "Kar\xe1csonyi Malac",
        swe: "Honungsgriljerad hatt"
    },
    1526: {
        img: "gingerbread_mann",
        eng: "Gingerbread Mann",
        rus: "\u041F\u0440\u044F\u043D\u0438\u0447\u043D\u044B\u0439 \u043F\u0440\u0438\u044F\u0442\u0435\u043B\u044C",
        pol: "Lukrowy ludzik",
        fre: "Mercenaire d'\xe9pice",
        sch: "\u59DC\u997C\u66FC\u6069",
        bra: "Mann-Biscoito",
        schema: 31088,
        hun: "M\xe9zeskal\xe1cs Mannus",
        swe: "Pepparkaksmann"
    },
    1527: {
        img: "bumble_beenie",
        eng: "Bumble Beenie",
        rus: "\u041F\u0447\u0435\u043B\u043E\u0433\u0440\u0435\u0439\u043A\u0430",
        pol: "Trzmiela czapa",
        fre: "Roi de la ruche",
        sch: "\u871C\u8702\u4E4B\u5E3D",
        bra: "Gorrobelha",
        schema: 31085,
        hun: "M\xe9hessapka",
        swe: "Humleluva"
    },
    1528: {
        img: "spiky_viking",
        eng: "Spiky Viking",
        rus: "\u0428\u0438\u043F\u0430\u0441\u0442\u044B\u0439 \u0432\u0438\u043A\u0438\u043D\u0433",
        pol: "Kolczasty wiking",
        fre: "Casque \xe0 pointes",
        sch: "\u7EF4\u4EAC\u523A\u76D4",
        bra: "Espinhos Escandinavos",
        schema: 31100,
        hun: "T\xfcsk\xe9s Viking",
        swe: "Vass viking"
    },
    1529: {
        img: "pocket_medes",
        eng: "Pocket-Medes",
        rus: "\u041A\u0430\u0440\u043C\u0430\u043D\u043D\u044B\u0439 \u0410\u0440\u0445\u0438\u043C\u0435\u0434",
        pol: "Kieszonkomedes",
        fre: "Archim\xe8de de poche",
        sch: "\u888B\u57FA\u7C73\u5FB7",
        bra: "Arquimedes de Bolso",
        schema: 31099,
        hun: "Zseb-m\xe9d\xe9sz",
        ger: "Taschen-Medes",
        swe: "Fick-Medes"
    },
    1530: {
        img: "discovision",
        eng: "Discovision",
        rus: "\u0414\u0438\u0441\u043A\u043E\u0437\u0440\u0435\u043D\u0438\u0435",
        pol: "Discowizja",
        fre: "Discovision",
        sch: "\u8FEA\u65AF\u79D1\u4E4B\u773C",
        bra: "Discot\xe9cnico",
        schema: 31096,
        hun: "Diszk\xf3l\xe1t\xe1s"
    },
    1531: {
        img: "telefragger_toque",
        eng: "Telefragger Toque",
        rus: "\u0422\u0435\u043B\u0435\u0448\u0430\u043F\u043E\u0447\u043A\u0430",
        pol: "Toczek telefraggera",
        fre: "Toque t\xe9l\xe9portatrice",
        sch: "\u4F20\u9001\u7EDE\u8089\u673A",
        bra: "Touca da Teletransmorte",
        schema: 31098,
        hun: "Teleport-t\xf6kf\xf6d\u0151",
        swe: "Telefraggarens m\xf6ssa"
    },
    1532: {
        img: "globetrotter",
        eng: "Globetrotter",
        rus: "\u0421\u043D\u0435\u0436\u043D\u044B\u0439 \u043A\u043E\u0442\u0435\u043B\u043E\u043A",
        pol: "Okr\u0105g\u0142y odkrywca",
        fre: "Souvenir de 2fort",
        sch: "\u96EA\u666F\u4E4B\u5E3D",
        bra: "Lembrancinha de 2Fort",
        schema: 31090,
        hun: "Vil\xe1gj\xe1r\xf3",
        ger: "Weltenbummler"
    },
    1533: {
        img: "winter_wrap_up",
        eng: "Winter Wrap Up",
        rus: "\u041E\u0431\u0451\u0440\u0442\u043A\u0430 \u043F\u043E \u0443\u0448\u0438",
        pol: "Zimowe zakrycie",
        fre: "Emmitouflage",
        sch: "\u51AC\u65E5\u5957\u88C5",
        bra: "Agasalho \xc1lgido",
        schema: 31094,
        hun: "Sapka, S\xe1l",
        ger: "Winterschal",
        swe: "Vinterbyltad"
    },
    1534: {
        img: "mislaid_sweater",
        eng: "The Mislaid Sweater",
        rus: "\u0421\u043A\u0440\u044B\u0442\u043D\u044B\u0439 \u0441\u0432\u0438\u0442\u0435\u0440",
        pol: "Zapodziany sweter",
        fre: "Pull introuvable",
        sch: "\u8FF7\u5931\u6BDB\u8863",
        bra: "Su\xe9ter do Sorrateiro",
        schema: 31102,
        hun: "Elhagyott Pul\xf3ver",
        swe: "Borttappad tr\xf6ja"
    },
    1535: {
        img: "public_speaker",
        eng: "Public Speaker",
        rus: "\u0413\u0440\u043E\u043C\u043A\u0438\u0439 \u0433\u043E\u0432\u043E\u0440\u0438\u0442\u0435\u043B\u044C",
        pol: "Chodz\u0105ca rozg\u0142o\u015Bnia",
        fre: "Annonceur",
        sch: "\u9AD8\u97F3\u5587\u53ED",
        bra: "Palestrinha",
        schema: 31095,
        hun: "Harci Hangad\xf3",
        swe: "Offentlig talare"
    },
    1536: {
        img: "smissmas_saxton",
        eng: "Smissmas Saxton",
        rus: "\u0428\u043C\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043D\u0441\u043A\u0438\u0439 \u0421\u0430\u043A\u0441\u0442\u043E\u043D",
        pol: "\u015Ani\u0105teczny Saxton",
        fre: "P\xe8re Saxton",
        sch: "\u8428\u514B\u65AF\u987F\u5723\u8BDE\u5E3D",
        bra: "Saxton Noel",
        schema: 31089,
        hun: "Gal\xe1csonyi Saxton",
        ger: "Smissmas-Saxton",
        swe: "Smissmas-Saxton"
    },
    1537: {
        img: "provisions_cap",
        eng: "Provisions Cap",
        rus: "\u0424\u0443\u0440\u0430\u0436\u043A\u0430 \u0441\u043D\u0430\u0431\u0436\u0435\u043D\u0446\u0430",
        pol: "Czapka zapas\xf3w",
        fre: "Casquette Provisions",
        sch: "\u8865\u7ED9\u5E3D",
        bra: "Patroc\xednio do Fornecedor",
        schema: 31097,
        hun: "Ell\xe1tm\xe1nysapka",
        swe: "Provisionskeps"
    },
    1538: {
        img: "candy_crown",
        eng: "Candy Crown",
        rus: "\u041A\u043E\u043D\u0444\u0435\u0442\u043D\u0430\u044F \u043A\u043E\u0440\u043E\u043D\u0430",
        pol: "Piernikowe panisko",
        fre: "Monsieur Tartine",
        sch: "\u7CD6\u679C\u4E4B\u51A0",
        bra: "Adorno A\xe7ucarado",
        schema: 31092,
        hun: "M\xe9zeskal\xe1cs-korona",
        swe: "Karamellkungen"
    },
    1539: {
        img: "alpine_war_paint",
        eng: "Alpine War Paint",
        rus: '"\u0412\u044B\u0441\u043E\u043A\u043E\u0433\u043E\u0440\u044C\u0435" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Alpy Barwy wojenne",
        fre: "Alpin Peinture de guerre",
        sch: "\u963F\u5C14\u5351\u65AF \u6218\u7ED8",
        bra: "| Alpina | Tinta de Guerra",
        schema: 17252,
        hun: "Alpesi Harci fest\xe9s",
        rom: "Alpine Vopsea de r\u0103zboi",
        swe: "Alpint Krigsf\xe4rg"
    },
    1540: {
        img: "gift_wrapped_war_paint",
        eng: "Gift Wrapped War Paint",
        rus: '"\u041F\u043E\u0434\u0430\u0440\u043E\u0447\u043D\u0430\u044F \u0431\u0443\u043C\u0430\u0433\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Zapakowany prezent Barwy wojenne",
        fre: "Cadeau emball\xe9 Peinture de guerre",
        sch: "\u5723\u8BDE\u793C\u76D2 \u6218\u7ED8",
        bra: "| Embrulho de Presente | Tinta de Guerra",
        schema: 17253,
        hun: "Becsomagolt Harci fest\xe9s",
        rom: "Gift Wrapped Vopsea de r\u0103zboi",
        swe: "Presentpapper Krigsf\xe4rg"
    },
    1541: {
        img: "seriously_snowed_war_paint",
        eng: "Seriously Snowed War Paint",
        rus: '"\u0421\u0438\u043B\u044C\u043D\u044B\u0439 \u0441\u043D\u0435\u0433\u043E\u043F\u0430\u0434" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Straszna \u015Bnie\u017Cyca Barwy wojenne",
        fre: "Neige abondante Peinture de guerre",
        sch: "\u96EA\u4EBA\u4F63\u5175 \u6218\u7ED8",
        bra: "| Mercen\xe1riozinhos de Neve | Tinta de Guerra",
        schema: 17249,
        hun: "S\xfalyosan behavazott Harci fest\xe9s",
        rom: "Seriously Snowed Vopsea de r\u0103zboi",
        swe: "Sn\xf6soldater Krigsf\xe4rg"
    },
    1542: {
        img: "igloo_war_paint",
        eng: "Igloo War Paint",
        rus: '"\u0418\u0433\u043B\u0443" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Igloo Barwy wojenne",
        fre: "Igloo Peinture de guerre",
        sch: "\u51B0\u7816\u5C0F\u5C4B \u6218\u7ED8",
        bra: "| Iglu | Tinta de Guerra",
        schema: 17248,
        hun: "J\xe9gkunyh\xf3 Harci fest\xe9s",
        rom: "Igloo Vopsea de r\u0103zboi",
        swe: "Igloo Krigsf\xe4rg"
    },
    1543: {
        img: "sleighin_style_war_paint",
        eng: "Sleighin' Style War Paint",
        rus: '"\u0421\u0442\u0438\u043B\u044C\u043D\u044B\u0435 \u0441\u0430\u043D\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Kulig Barwy wojenne",
        fre: "Traineau styl\xe9 Peinture de guerre",
        sch: "\u96EA\u6A47\u5F69\u5E26 \u6218\u7ED8",
        bra: "| Tren\xf3 | Tinta de Guerra",
        schema: 17251,
        hun: "Sz\xe1nk\xf3z\xf3s st\xedlus\xfa Harci fest\xe9s",
        rom: "Sleighin' Style Vopsea de r\u0103zboi",
        swe: "Bj\xe4llerbang Krigsf\xe4rg"
    },
    1544: {
        img: "snow_covered_war_paint",
        eng: "Snow Covered War Paint",
        rus: '"\u0421\u043D\u0435\u0436\u043D\u044B\u0439 \u043F\u043E\u043A\u0440\u043E\u0432" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Pokrywa \u015Bnie\u017Cna Barwy wojenne",
        fre: "Couvert de neige Peinture de guerre",
        sch: "\u96EA\u82B1\u8986\u76D6 \u6218\u7ED8",
        bra: "| Flocos de Neve | Tinta de Guerra",
        schema: 17245,
        hun: "H\xf3fedte Harci fest\xe9s",
        rom: "Snow Covered Vopsea de r\u0103zboi",
        swe: "Sn\xf6t\xe4ckt Krigsf\xe4rg"
    },
    1545: {
        img: "frost_ornamented_war_paint",
        eng: "Frost Ornamented War Paint",
        rus: '"\u041C\u043E\u0440\u043E\u0437\u043D\u044B\u0435 \u0443\u0437\u043E\u0440\u044B" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Mro\u017Ane zdobienie Barwy wojenne",
        fre: "D\xe9corations givr\xe9es Peinture de guerre",
        sch: "\u51B0\u971C\u4E4B\u9970 \u6218\u7ED8",
        bra: "| Ornamento Congelado | Tinta de Guerra",
        schema: 17246,
        hun: "Fagy d\xedsz\xedtette Harci fest\xe9s",
        rom: "Frost Ornamented Vopsea de r\u0103zboi",
        swe: "Frostsnirkel Krigsf\xe4rg"
    },
    1546: {
        img: "smissmas_camo_war_paint",
        eng: "Smissmas Camo War Paint",
        rus: '"\u0428\u043C\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043D\u0441\u043A\u0438\u0439 \u043A\u0430\u043C\u0443\u0444\u043B\u044F\u0436" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "\u015Ani\u0105teczny kamufla\u017C Barwy wojenne",
        fre: "Camouflage Smissmas Peinture de guerre",
        sch: "\u5723\u8BDE\u8FF7\u5F69 \u6218\u7ED8",
        bra: "| Camuflagem Festiva | Tinta de Guerra",
        schema: 17250,
        hun: "Gal\xe1csonyi \xe1lca Harci fest\xe9s",
        rom: "Smissmas Camo Vopsea de r\u0103zboi",
        swe: "Julkamouflage Krigsf\xe4rg"
    },
    1547: {
        img: "smissmas_village_war_paint",
        eng: "Smissmas Village War Paint",
        rus: '"\u0428\u043C\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043D\u0441\u043A\u0430\u044F \u0434\u0435\u0440\u0435\u0432\u043D\u044F" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "\u015Ani\u0105teczna wioska Barwy wojenne",
        fre: "Village Smissmas Peinture de guerre",
        sch: "\u5723\u8BDE\u6751\u5E84 \u6218\u7ED8",
        bra: "| Vila do Polo Norte | Tinta de Guerra",
        schema: 17247,
        hun: "Gal\xe1csonyi falu Harci fest\xe9s",
        rom: "Smissmas Village Vopsea de r\u0103zboi",
        swe: "Julpynt Krigsf\xe4rg"
    },
    1548: {
        img: "winterland_wrapped_war_paint",
        eng: "Winterland Wrapped War Paint",
        rus: '"\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0435 \u043F\u043E\u043B\u043E\u0441\u044B" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Zimowa kraina Barwy wojenne",
        fre: "Emballage hivernal Peinture de guerre",
        sch: "\u51AC\u65E5\u6761\u7EB9 \u6218\u7ED8",
        bra: "| Embrulho de Natal | Tinta de Guerra",
        schema: 17254,
        hun: "Gal\xe1csonyra csomagolt Harci fest\xe9s",
        rom: "Winterland Wrapped Vopsea de r\u0103zboi",
        swe: "Julklappspapper Krigsf\xe4rg"
    },
    1549: {
        img: "self_care",
        eng: "Self-Care",
        rus: "\u0421\u0430\u043C\u043E\u043B\u0435\u0447\u0435\u043D\u0438\u0435",
        pol: "Samoopieka",
        sch: "\u533B\u8005\u81EA\u533B",
        bra: "Autoajuda",
        schema: 31122,
        hun: "\xd6ngy\xf3gy\xedt\xf3",
        fre: "Bandages de fortune",
        swe: "Egenv\xe5rd"
    },
    1550: {
        img: "the_jarmaments",
        eng: "The Jarmaments",
        rus: "\u0411\u0430\u043D\u043A\u043E\u043B\u044C\u0435\u0440",
        pol: "Sikwondowe s\u0142oiki",
        sch: "\u74F6\u624B\u9053\u6B66\u88C5",
        bra: "Jarmamentos",
        schema: 31120,
        hun: "Harci \xdcvegcs\xe9k",
        fre: "Jarmements",
        ger: "Jarateg\xfcrtel",
        swe: "Jaratev\xe4st"
    },
    1551: {
        img: "sophisticated_smoker",
        eng: "The Sophisticated Smoker",
        rus: "\u041A\u0443\u043B\u044C\u0442\u0443\u0440\u043D\u044B\u0439 \u043A\u0443\u0440\u044F\u0433\u0430",
        pol: "Nienaganny na\u0142ogowiec",
        fre: "Fumeur fumeux",
        sch: "\u96EA\u8304\u5927\u4F6C",
        bra: "Charuto Charmoso",
        schema: 31106,
        hun: "Szivaros Szivar",
        swe: "Raffinerad r\xf6kare"
    },
    1552: {
        img: "soda_specs",
        eng: "Soda Specs",
        rus: "\u0413\u0430\u0437\u0438\u0440\u043E\u0432-\u043E\u0447\u043A\u0438",
        pol: "Sodowe szk\u0142a",
        sch: "\u539F\u5B50\u80FD\u773C\u955C",
        bra: "Olhar Refrescante",
        schema: 31116,
        hun: "\xdcdcsiszemcsi",
        fre: "Lunettes rafraichissantes",
        swe: "Bonkbrillor"
    },
    1553: {
        img: "fire_fighter",
        eng: "Fire Fighter",
        rus: "\u041F\u044B\u043B\u043A\u0438\u0439 \u0431\u043E\u0440\u0435\u0446",
        pol: "Wojownik ognia",
        fre: "Combattant enflamm\xe9",
        sch: "\u8857\u5934\u706B\u9738\u738B",
        bra: "Lutador em Chamas",
        schema: 31108,
        hun: "L\xe1nglovag",
        ger: "Feuerk\xe4mpfer",
        swe: "Eldig fighter"
    },
    1554: {
        img: "poolside_polo",
        eng: "Poolside Polo",
        rus: "\u041F\u0440\u0438\u0431\u0440\u0435\u0436\u043D\u043E\u0435 \u043F\u043E\u043B\u043E",
        pol: "Pla\u017Cowe polo",
        sch: "\u6C60\u8FB9\u886C\u886B",
        bra: "Polo do Praieiro",
        schema: 31118,
        hun: "V\xedzip\xf3l\xf3",
        fre: "Polo du croisi\xe9riste",
        ger: "Pool-Polo",
        swe: "Poolpolo"
    },
    1555: {
        img: "crabe_de_chapeau",
        eng: "Crabe de Chapeau",
        rus: "\u0428\u0430\u043F\u043E\u043A\u0440\u0430\u0431",
        pol: "Crabe de chapeau",
        fre: "Crabe de chapeau",
        sch: "\u87F9\u87F9\u4E4B\u5E3D",
        bra: "Chapeau de Karranguejo",
        schema: 31109,
        ger: "Krabbenhut"
    },
    1556: {
        img: "california_cap",
        eng: "California Cap",
        rus: "\u041A\u0430\u043B\u0438\u0444\u043E\u0440\u043D\u0438\u0439\u0441\u043A\u0430\u044F \u043A\u0435\u043F\u043A\u0430",
        pol: "Kalifornijska czapka",
        sch: "\u52A0\u5DDE\u68D2\u7403\u5E3D",
        bra: "Bon\xe9 Californiano",
        schema: 31117,
        hun: "Strandsatyek",
        fre: "Casquette californienne",
        swe: "Kalifornisk keps"
    },
    1557: {
        img: "bazaar_bauble",
        eng: "Bazaar Bauble",
        rus: "\u0411\u0430\u0437\u0430\u0440\u043D\u044B\u0439 \u0431\u043E\u043B\u0432\u0430\u043D\u0447\u0438\u043A",
        pol: "Bazarowe bawide\u0142ko",
        sch: "\u60CA\u559C\u5C0F\u5175",
        bra: "Bugiganga do Bazar",
        schema: 31112,
        hun: "Baz\xe1ri Bigy\xf3",
        fre: "Soldier \xe0 ressort",
        ger: "Basarspielerei",
        swe: "Basargubben"
    },
    1558: {
        img: "head_of_defense",
        eng: "Head of Defense",
        rus: "\u0413\u043B\u0430\u0432\u0430 \u043E\u0431\u043E\u0440\u043E\u043D\u044B",
        pol: "Czo\u0142owy obro\u0144ca",
        sch: "\u6B65\u54E8\u5934\u76D4",
        bra: "Mini-stro da Defesa",
        schema: 31114,
        hun: "A F\u0151v\xe9dn\xf6k",
        fre: "Mitraille ent\xeat\xe9e",
        swe: "F\xf6rsvarets \xf6verhuvud"
    },
    1559: {
        img: "flatliner",
        eng: "The Flatliner",
        rus: "\u0411\u0435\u0441\u0441\u0435\u0440\u0434\u0435\u0447\u043D\u0438\u043A",
        pol: "Pulsowizjer",
        sch: "\u5E73\u7EBF\u5EB8\u533B",
        bra: "Vis\xe3o Vascular",
        schema: 31121,
        hun: "Sz\xedvmonitor",
        fre: "\xc9lectroenc\xe9phalographe",
        swe: "Hj\xe4rtflimmer"
    },
    1560: {
        img: "tools_of_the_tourist",
        eng: "Tools of the Tourist",
        rus: "\u041F\u0440\u0438\u0447\u0438\u043D\u0434\u0430\u043B\u044B \u043F\u0443\u0442\u0435\u0448\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u0430",
        pol: "Torba turysty",
        sch: "\u6E38\u5BA2\u7684\u630E\u5305",
        bra: "Ferramentas do Farofeiro",
        schema: 31119,
        hun: "Turistakell\xe9kek",
        fre: "Attirail du touriste",
        ger: "Urlauberutensilien",
        swe: "Turistens duffel"
    },
    1561: {
        img: "hazard_headgear",
        eng: "Hazard Headgear",
        rus: "\u0423\u0441\u0442\u0440\u0430\u043D\u0438\u0442\u0435\u043B\u044C \u0443\u0433\u0440\u043E\u0437",
        pol: "Niezabezpieczone nakrycie",
        sch: "\u5371\u7206\u4E4B\u76D4",
        bra: "Equipamento de Prote\xe7\xe3o Parcial",
        schema: 31115,
        hun: "Biztons\xe1gi Buk\xf3sisak",
        fre: "Casque casse-cou",
        ger: "Gefahrschutzglocke",
        swe: "S\xe4kerhetshj\xe4lm"
    },
    1562: {
        img: "birds_eye_viewer",
        eng: "Bird's Eye Viewer",
        rus: "\u041F\u0442\u0438\u0447\u0438\u0439 \u0433\u043B\u0430\u0437",
        pol: "Ptasia perspektywa",
        fre: "Espigeon",
        sch: "\u95F4\u8C0D\u9E3D",
        bra: "Pombo de Vista",
        schema: 31110,
        hun: "Mad\xe1rt\xe1vlati Megfigyel\u0151",
        swe: "F\xe5gelperspektiv"
    },
    1563: {
        img: "breach_and_bomb",
        eng: "Breach and Bomb",
        rus: "\u041F\u0440\u043E\u0440\u044B\u0432 \u0438 \u043F\u043E\u0434\u0440\u044B\u0432",
        pol: "Wywa\u017Cy\u0107 i wysadzi\u0107",
        sch: "\u4EE5\u7206\u5236\u66B4",
        bra: "Infiltrar e Detonar",
        schema: 31113,
        hun: "Behatol\xe1s \xe9s Bomb\xe1z\xe1s",
        fre: "Force sp\xe9ciale",
        ger: "Bombenschutzhelm",
        swe: "Insatsstyrka"
    },
    1564: {
        img: "momma_kiev",
        eng: "Momma Kiev",
        rus: "\u041A\u0432\u043E\u0447\u043A\u0430 \u043A\u0438\u0435\u0432\u0441\u043A\u0430\u044F",
        pol: "Kijowska kwoka",
        sch: "\u57FA\u8F85\u8001\u6BCD\u9E21",
        bra: "Mam\xe3e Kiev",
        schema: 31123,
        hun: "Kijev Mama",
        fre: "Mama Kiev",
        swe: "Mamma Kiev"
    },
    1565: {
        img: "flamehawk",
        eng: "Flamehawk",
        rus: "\u041F\u0438\u0440\u043E\u043A\u0435\u0437",
        pol: "Iskrz\u0105cy irokez",
        fre: "Pyroquois",
        sch: "\u83AB\u706B\u514B\u53D1\u578B",
        bra: "Flamoicano",
        schema: 31107,
        hun: "T\u0171zs\xf6r\xe9ny",
        swe: "P\xe5tuttad tuppkam"
    },
    1566: {
        img: "loaf_loafers",
        eng: "Loaf Loafers",
        rus: "\u0425\u043B\u0435\u0431\u043E\u0445\u043E\u0434\u044B",
        pol: "Bochenkowe buty",
        fre: "Paintoufles",
        sch: "\u9762\u5305\u5927\u811A",
        bra: "P\xe3otufas",
        schema: 31105,
        hun: "Bucibakancs",
        swe: "Limploafers"
    },
    1567: {
        img: "smoking_jacket",
        eng: "Smoking Jacket",
        rus: "\u041A\u0443\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043F\u0438\u0434\u0436\u0430\u043A",
        pol: "Bon\u017Curka palacza",
        sch: "\u70DF\u9B3C\u5939\u514B",
        bra: "Traje de Tabaco",
        schema: 31124,
        hun: "Szmoking",
        fre: "Costabac",
        swe: "R\xf6krock"
    },
    1568: {
        img: "hawk_warrior",
        eng: "Hawk Warrior",
        rus: "\u042F\u0441\u0442\u0440\u0435\u0431-\u0432\u043E\u044F\u043A\u0430",
        pol: "Jastrz\u0119bi wojownik",
        fre: "Faucon de guerre",
        sch: "\u767D\u5934\u9E70\u6218\u58EB",
        bra: "Guerreiro \xc1guia",
        schema: 31111,
        hun: "S\xf3lyomharcos",
        swe: "\xd6rnkrigare"
    },
    1569: {
        img: "breadcrab",
        eng: "Breadcrab",
        rus: "\u0425\u043B\u0435\u0431\u043A\u0440\u0430\u0431",
        pol: "Chlebokrab",
        fre: "Pain de t\xeate",
        sch: "\u9762\u5305\u5934\u87F9",
        bra: "P\xe3orasita",
        schema: 31104,
        hun: "R\xe1g\xf3s Keny\xe9r",
        swe: "Krabbkaka"
    },
    1570: {
        img: "hypno_eyes",
        eng: "Hypno-Eyes",
        rus: "\u0413\u0438\u043F\u043D\u043E\u0433\u043B\u0430\u0437\u0430",
        pol: "Hipnowzrok",
        fre: "Yeuxpnotiseurs",
        sch: "\u50AC\u7720\u4E4B\u773C",
        bra: "Hipnolhos",
        schema: 31103,
        hun: "Hipno-szemek",
        swe: "Hypno-brillor"
    },
    1571: {
        img: "vaccinator",
        eng: "Vaccinator",
        rus: "\u0412\u0430\u043A\u0446\u0438\u043D\u0430\u0442\u043E\u0440",
        pol: "Zaszczepiacz",
        fre: "Vaccinateur",
        sch: "\u75AB\u82D7\u63A5\u79CD\u67AA",
        bra: "Vacinadora",
        schema: 998,
        schema2: 5756,
        hun: "Beolt\xf3",
        swe: "Vaccinat\xf6r"
    },
    1572: {
        img: "air_strike",
        eng: "Air Strike",
        rus: "\u0410\u0432\u0438\u0430\u0443\u0434\u0430\u0440",
        pol: "Atak powietrzny",
        fre: "La Frappe a\xe9rienne",
        sch: "\u7A7A\u88AD\u706B\u7BAD\u7B52",
        bra: "O Ataque A\xe9reo",
        schema: 1104,
        schema2: 5753,
        hun: "A L\xe9gicsap\xe1s",
        swe: "Luftangreppet"
    },
    1573: {
        img: "pomson_6000",
        eng: "The Pomson 6000",
        rus: "\u041F\u043E\u043C\u0441\u043E\u043D 6000",
        pol: "Pomson 6000",
        fre: "Le Pomson 6000",
        sch: "\u6B7C\u706D\u8005 6000",
        bra: "O Pomson 6000",
        schema: 588,
        schema2: 5661,
        hun: "A Pomson 6000",
        ger: "Der Pomson 6000",
        swe: "Pomson 6000"
    },
    1574: {
        img: "the_seared_sorcerer",
        eng: "The Seared Sorcerer",
        rus: "\u0427\u0451\u0440\u0441\u0442\u0432\u044B\u0439 \u0447\u0430\u0440\u043E\u0434\u0435\u0439",
        pol: "Zapalaj\u0105cy zaklinacz",
        fre: "Pyromage",
        sch: "\u7126\u707C\u708E\u672F\u5E08",
        bra: "Bruxo das Brasas",
        schema: 31143,
        hun: "T\u0171zm\xe1gus",
        swe: "Svedd svartmagiker"
    },
    1575: {
        img: "the_boom_boxers",
        eng: "The Boom Boxers",
        rus: "\u0412\u0437\u0440\u044B\u0432-\u0431\u043E\u043A\u0441\u0435\u0440\u044B",
        pol: "Bumbokserki",
        fre: "Box-c\u0153urs",
        sch: "\u751C\u5FC3\u5185\u88E4",
        schema: 31133,
        hun: "Kirobban\xf3 \xdclep",
        bra: "Samba Cora\xe7\xe3o",
        swe: "Pang i brallan"
    },
    1576: {
        img: "king_cardbeard",
        eng: "King Cardbeard",
        rus: "\u041A\u043E\u0440\u043E\u043B\u044C \u041A\u0430\u0440\u0442\u043E\u043D\u043D\u0430\u044F \u0431\u043E\u0440\u043E\u0434\u0430",
        pol: "Kr\xf3l Kartonobrody",
        fre: "Monarque en carton",
        sch: "\u7EB8\u677F\u7687\u51A0",
        bra: "Rei Barbel\xe3o",
        schema: 31130,
        hun: "Kartonszak\xe1ll Kir\xe1ly",
        swe: "Kartongkungen"
    },
    1577: {
        img: "flavorful_baggies",
        eng: "Flavorful Baggies",
        rus: "\u0411\u0440\u044E\u043A\u0438 \u0441 \u0438\u0437\u044E\u043C\u0438\u043D\u043A\u043E\u0439",
        pol: "Pstrokate pumpy",
        fre: "Pantalon de bon gout",
        sch: "\u5C0F\u4E11\u6CE2\u70B9\u88E4",
        schema: 31145,
        bra: "Cal\xe7as da Palha\xe7ada",
        hun: "P\xf6tty\xf6s Buggyos",
        swe: "Pajasens p\xf6sbyxor"
    },
    1578: {
        img: "calamitous_cauldron",
        eng: "Calamitous Cauldron",
        rus: "\u041A\u043E\u0442\u0451\u043B \u043A\u0430\u0442\u0430\u0441\u0442\u0440\u043E\u0444",
        pol: "Katastrofalny kocio\u0142",
        fre: "Chaudron calamiteux",
        sch: "\u5012\u9709\u900F\u9876",
        bra: "Caldeir\xe3o Calamitoso",
        schema: 31146,
        hun: "\xdcst\xf6k-\xfcst",
        swe: "Katastrofal kittel"
    },
    1579: {
        img: "a_handsome_handy_thing",
        eng: "A Handsome Handy Thing",
        rus: "\u041F\u0440\u0435\u043B\u0435\u0441\u0442\u043D\u0430\u044F \u043F\u043E\u0434\u0440\u0443\u0447\u043D\u0430\u044F \u0440\u0443\u043A\u0430",
        pol: "Por\u0119czna r\u0105sia",
        fre: "T\xeate paum\xe9e",
        sch: "\u7559\u4E86\u4E00\u624B",
        bra: "Uma M\xe3o Vai Na Cabe\xe7a",
        schema: 31129,
        hun: "K\xe9zr\xe1t\xe9tel",
        swe: "Huvudsaken"
    },
    1580: {
        img: "handsome_devil",
        eng: "Handsome Devil",
        rus: "\u0414\u044C\u044F\u0432\u043E\u043B\u044C\u0441\u043A\u0438\u0439 \u043A\u0440\u0430\u0441\u0430\u0432\u0447\u0438\u043A",
        pol: "Przystojny diabe\u0142",
        fre: "Diable distingu\xe9",
        sch: "\u6F47\u6D12\u9B54\u7537",
        bra: "Dem\xf4nio Elegante",
        schema: 31135,
        hun: "J\xf3k\xe9p\u0171 \xd6rd\xf6g",
        swe: "DemOni"
    },
    1581: {
        img: "hollowed_helm",
        eng: "Hollowed Helm",
        rus: "\u041F\u043E\u043B\u044B\u0439 \u0448\u043B\u0435\u043C",
        pol: "Dyniowa defensywa",
        fre: "Cascourge",
        sch: "\u7A7A\u5FC3\u5357\u74DC\u76D4",
        bra: "Elmo Espantador",
        schema: 31128,
        hun: "Kiv\xe1jt T\xf6kf\xf6d\u0151",
        swe: "Karvad hj\xe4lm"
    },
    1582: {
        img: "goblineer",
        eng: "Goblineer",
        rus: "\u0413\u043E\u0431\u043B\u0438\u043D\u0435\u0440",
        pol: "Goblinier",
        fre: "Goblineer",
        sch: "\u5DE5\u5E03\u6797",
        bra: "Goblinheiro",
        schema: 31150,
        hun: "T\xf6rpn\xf6k",
        swe: "Ingeniare ingenium kobold"
    },
    1583: {
        img: "the_ghoul_box",
        eng: "The Ghoul Box",
        rus: "\u042F\u0449\u0438\u043A \u0441 \u0443\u0436\u0430\u0441\u0430\u043C\u0438",
        pol: "Ghul narz\u0119dziowy",
        fre: "Goule \xe0 outils",
        sch: "\u602A\u7269\u5DE5\u5177\u7BB1",
        bra: "Mal-eta de Ferramentas",
        schema: 31151,
        hun: "R\xe9mszersz\xe1mos",
        swe: "Sattygsl\xe5da"
    },
    1584: {
        img: "glow_from_below",
        eng: "Glow from Below",
        rus: "\u0421\u0432\u0435\u0447\u0435\u043D\u0438\u0435 \u0431\u0435\u0437\u0434\u043D\u044B",
        pol: "\u015Awiate\u0142ko z otch\u0142ani",
        fre: "Baudroie luminescente",
        sch: "\u6DF1\u6D77\u4E4B\u5149",
        bra: "Brilho das Profundezas",
        schema: 31149,
        hun: "F\xe9ny a M\xe9lyben",
        swe: "Djuphavets ljushuvud"
    },
    1585: {
        img: "eye_see_you",
        eng: "Eye-See-You",
        rus: "\u0413\u043B\u0430\u0437-\u0434\u0430-\u0433\u043B\u0430\u0437",
        pol: "Mam na ciebie oko",
        fre: "Yeux-te-vois",
        sch: "\u522B\u5177\u6167\u773C",
        bra: "Olho-por-Olho",
        schema: 31134,
        hun: "Szemt\u0151l Szemben",
        swe: "\xd6gon p\xe5 skaft"
    },
    1586: {
        img: "impish_ears",
        eng: "Impish Ears",
        rus: "\u0423\u0448\u043A\u0438 \u0431\u0435\u0441\u0451\u043D\u043A\u0430",
        pol: "Chochlikowe uszy",
        fre: "Oreilles de farfadet",
        sch: "\u5C0F\u9B3C\u8033\u6735",
        schema: 31125,
        bra: "Orelhas Pontiagudas",
        hun: "Koboldf\xfclek",
        swe: "Spetsade \xf6ron"
    },
    1587: {
        img: "sir_pumpkinton",
        eng: "Sir Pumpkinton",
        rus: "\u0421\u044D\u0440 \u0422\u044B\u043A\u0432\u0438\u043D\u0433\u0442\u043E\u043D",
        pol: "Sir Dy\u0144kinton",
        fre: "Sieur citrouille",
        sch: "\u5357\u74DC\u7235\u58EB\u793C\u5E3D",
        bra: "Senhor Cabe\xe7a-de-Ab\xf3bora",
        schema: 31131,
        hun: "Sir T\xf6kkobaki",
        swe: "Von Pumpa"
    },
    1588: {
        img: "gourd_grin",
        eng: "Gourd Grin",
        rus: "\u0422\u044B\u043A\u0432\u0435\u043D\u043D\u0430\u044F \u0443\u0445\u043C\u044B\u043B\u043A\u0430",
        pol: "Dyniowy u\u015Bmiech",
        fre: "Rictus sardonique",
        sch: "\u88C2\u53E3\u5357\u74DC\u5DFE",
        bra: "Cara de Caba\xe7o",
        schema: 31127,
        hun: "T\xf6kre Vigyorog",
        swe: "Oktobernattens leende"
    },
    1589: {
        img: "semi_tame_trappers_hat",
        eng: "Semi-Tame Trapper's Hat",
        rus: "\u041F\u043E\u043B\u0443\u0434\u043E\u043C\u0430\u0448\u043D\u044F\u044F \u043E\u0445\u043E\u0442\u043D\u0438\u0447\u044C\u044F \u0448\u0430\u043F\u043A\u0430",
        pol: "P\xf3\u0142oswojona czapka trapera",
        fre: "Raton laveur empaill\xe9",
        sch: "\u83DC\u9E1F\u730E\u4EBA",
        schema: 31147,
        bra: "Guaxi-ni-mim",
        hun: "F\xe9lszel\xedd Pr\xe9msapka",
        swe: "Halvtam sjubbskinnsm\xf6ssa"
    },
    1590: {
        img: "the_fire_tooth",
        eng: "Fire Tooth",
        rus: "\u041E\u0433\u043D\u0435\u0435\u0436\u043A\u0430",
        pol: "Ognisty z\u0105b",
        fre: "Clown incendiaire",
        sch: "\u5927\u7259\u5C0F\u4E11",
        schema: 31144,
        bra: "Sorveteiro Sinistro",
        hun: "T\xfczes Pofa",
        swe: "Pyrande pajas"
    },
    1591: {
        img: "wavefinder",
        eng: "Wavefinder",
        rus: "\u0412\u043E\u043B\u043D\u043E\u043B\u043E\u0432",
        pol: "Wykrywacz fal",
        fre: "Ondoscope",
        sch: "\u5BFB\u6CE2\u88C5\u7F6E",
        bra: "Sente a Sintonia",
        schema: 31148,
        hun: "\xc1llom\xe1skeres\u0151",
        swe: "Elmuffar"
    },
    1592: {
        img: "misfortune_fedora",
        eng: "Misfortune Fedora",
        rus: "\u0424\u0435\u0434\u043E\u0440\u0430 \u043D\u0435\u0432\u0435\u0437\u0435\u043D\u0438\u044F",
        pol: "Niefortunna fedora",
        fre: "Feutre maudit",
        sch: "\u5384\u8FD0\u8FF7\u96FE\u793C\u5E3D",
        bra: "Fedora Futurista",
        schema: 31136,
        hun: "A Balsors Puhakalapja",
        swe: "Faslig fedora"
    },
    1593: {
        img: "wrap_a_khamon",
        eng: "Wrap-A-Khamon",
        rus: "\u0411\u0438\u043D\u0442\u043E\u0445\u0430\u043C\u043E\u043D",
        pol: "Banda\u017Cochamon",
        fre: "Momie-cyclope",
        sch: "\u6CD5\u8001\u7684\u6298\u53E0\u793C\u5E3D",
        bra: "Tut\xe2ncam\xfamia",
        schema: 31132,
        hun: "Kalapm\xfamia",
        swe: "Tutankhamons bandage"
    },
    1594: {
        img: "balloonicorpse",
        eng: "Balloonicorpse",
        rus: "\u041D\u0430\u0434\u0443\u0432\u043D\u043E\u043A\u043E\u0441\u0442",
        pol: "Balonozw\u0142oki",
        fre: "Ballicorps",
        sch: "\u6C14\u7403\u72EC\u89D2\u5C38",
        bra: "Bal\xe3onecr\xf3rnio",
        schema: 31126,
        hun: "Csontlufikornis",
        swe: "Ballongd\xf6ingen"
    },
    1595: {
        img: "all_hallows_hatte",
        eng: "All Hallows' Hatte",
        rus: "\u0428\u043B\u044F\u043F\u0430 \u0432\u0441\u0435\u0445 \u0441\u0432\u044F\u0442\u044B\u0445",
        pol: "Kapelusz wszystkich \u015Bwi\u0119tych",
        fre: "Toussorcier",
        sch: "\u4E07\u7075\u5F69\u706F\u4E4B\u5E3D",
        bra: "Bruxo B\xe1sico",
        schema: 31152,
        hun: "K\xeds\xe9rt\u0151 Kalpag",
        swe: "Allhelgonahatt"
    },
    1596: {
        img: "organically_hellraised_war_paint",
        eng: "Organ-ically Hellraised War Paint",
        rus: '"\u0412\u044B\u0440\u0430\u0449\u0435\u043D\u043E \u0432 \u0430\u0434\u0443" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Organiczny pomiot Barwy wojenne",
        sch: "\u539F\u751F\u72F1\u706B \u6218\u7ED8",
        bra: "| Terror Org\xe2nico | Tinta de Guerra",
        schema: 17256,
        fre: "Incin\xe9ration infernale Peinture de guerre",
        hun: "Szerv-esen pokolbantermesztett Harci fest\xe9s",
        rom: "Organ-ically Hellraised Vopsea de r\u0103zboi",
        swe: "Helvetets l\xe5gor Krigsf\xe4rg"
    },
    1597: {
        img: "spider_season_war_paint",
        eng: "Spider Season War Paint",
        rus: '"\u041F\u0430\u0443\u0447\u044C\u044F \u043F\u043E\u0440\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Paj\u0119cza pora Barwy wojenne",
        sch: "\u8718\u86DB\u4E4B\u5B63 \u6218\u7ED8",
        bra: "| Temporada de Aranhas | Tinta de Guerra",
        schema: 17269,
        fre: "Araign\xe9es g\xe9antes Peinture de guerre",
        hun: "P\xf3kszezon Harci fest\xe9s",
        rom: "Spider Season Vopsea de r\u0103zboi",
        swe: "Spindels\xe4song Krigsf\xe4rg"
    },
    1598: {
        img: "gourdy_green_war_paint",
        eng: "Gourdy Green War Paint",
        rus: '"\u0422\u044B\u043A\u0432\u0435\u043D\u043D\u044B\u0439 \u043A\u0430\u043C\u0443\u0444\u043B\u044F\u0436" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Dyniowa ziele\u0144 Barwy wojenne",
        sch: "\u5357\u74DC\u8FF7\u5F69 \u6218\u7ED8",
        bra: "| Horta de Ab\xf3boras | Tinta de Guerra",
        schema: 17267,
        fre: "Gazon maudit Peinture de guerre",
        hun: "T\xf6k\xf6s z\xf6ld Harci fest\xe9s",
        rom: "Gourdy Green Vopsea de r\u0103zboi",
        swe: "Pumpaodling Krigsf\xe4rg"
    },
    1599: {
        img: "eyestalker_war_paint",
        eng: "Eyestalker War Paint",
        rus: '"\u0413\u043B\u0430\u0437\u0430\u0441\u0442\u044B\u0435 \u0437\u0430\u0440\u043E\u0441\u043B\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Podgl\u0105daczka Barwy wojenne",
        sch: "\u773C\u7403\u679C\u5B9E \u6218\u7ED8",
        schema: 17265,
        fre: "Phyt\u0153il Peinture de guerre",
        bra: "| Guaran-ahhhhh | Tinta de Guerra",
        hun: "Szemkocs\xe1nyos Harci fest\xe9s",
        rom: "Eyestalker Vopsea de r\u0103zboi",
        swe: "Coreopsis Krigsf\xe4rg"
    },
    1600: {
        img: "death_deluxe_war_paint",
        eng: "Death Deluxe War Paint",
        rus: '"\u041F\u044B\u0448\u043D\u0430\u044F \u043F\u043E\u0433\u0438\u0431\u0435\u043B\u044C" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Luksusowa \u015Bmier\u0107 Barwy wojenne",
        sch: "\u6B7B\u4EA1\u73AB\u7470 \u6218\u7ED8",
        bra: "| Morte de Luxo | Tinta de Guerra",
        schema: 17263,
        fre: "Cercueil Peinture de guerre",
        hun: "D\xedszes hal\xe1l Harci fest\xe9s",
        rom: "Death Deluxe Vopsea de r\u0103zboi",
        swe: "D\xf6dslyx Krigsf\xe4rg"
    },
    1601: {
        img: "portal_plastered_war_paint",
        eng: "Portal Plastered War Paint",
        rus: '"\u041F\u043E\u0440\u0442\u0430\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043A\u0440\u044B\u0442\u0438\u0435" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Portalowa tapeta Barwy wojenne",
        sch: "\u51A5\u754C\u4E4B\u95E8 \u6218\u7ED8",
        bra: "| Pintura de Portal | Tinta de Guerra",
        schema: 17262,
        fre: "Portail magique Peinture de guerre",
        hun: "Port\xe1ltapaszos Harci fest\xe9s",
        rom: "Portal Plastered Vopsea de r\u0103zboi",
        swe: "Portalsnurr Krigsf\xe4rg"
    },
    1602: {
        img: "candy_coated_war_paint",
        eng: "Candy Coated War Paint",
        rus: '"\u041A\u0430\u0440\u0430\u043C\u0435\u043B\u044C\u043D\u044B\u0439 \u043A\u0440\u043E\u0432" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Cukierek Barwy wojenne",
        sch: "\u4E07\u5723\u7CD6\u679C \u6218\u7ED8",
        bra: "| Revestimento Doce | Tinta de Guerra",
        schema: 17258,
        fre: "Friandise Peinture de guerre",
        hun: "Cukorkapap\xedros Harci fest\xe9s",
        rom: "Candy Coated Vopsea de r\u0103zboi",
        swe: "Kanderat Krigsf\xe4rg"
    },
    1603: {
        img: "spiders_cluster_war_paint",
        eng: "Spider's Cluster War Paint",
        rus: '"\u041F\u0430\u0443\u0447\u0438\u0439 \u043F\u0435\u0440\u0435\u043F\u043B\u0451\u0442" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Sie\u0107 paj\u0105ka Barwy wojenne",
        sch: "\u6BD2\u5DE2\u86DB\u7F51 \u6218\u7ED8",
        bra: "| Aglomerado de Aranhas | Tinta de Guerra",
        schema: 17266,
        fre: "Toiles d'araign\xe9e Peinture de guerre",
        hun: "P\xf3kf\xfcrt\xf6s Harci fest\xe9s",
        rom: "Spider's Cluster Vopsea de r\u0103zboi",
        swe: "Spindeldesign Krigsf\xe4rg"
    },
    1604: {
        img: "raving_dead_war_paint",
        eng: "Raving Dead War Paint",
        rus: '"\u0414\u043E\u0445\u043B\u0430\u044F \u0442\u0443\u0441\u043E\u0432\u043A\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Ta\u0144cz\u0105cy umarli Barwy wojenne",
        sch: "\u4EA1\u8005\u72C2\u8A00 \u6218\u7ED8",
        bra: "| Mortos Muito Loucos | Tinta de Guerra",
        schema: 17264,
        fre: "Squelette Peinture de guerre",
        hun: "Hal\xe1li buli Harci fest\xe9s",
        rom: "Raving Dead Vopsea de r\u0103zboi",
        swe: "D\xf6dsparty Krigsf\xe4rg"
    },
    1605: {
        img: "crawlspace_critters_war_paint",
        eng: "Crawlspace Critters War Paint",
        rus: '"\u0422\u0432\u0430\u0440\u0438 \u0438\u0437 \u043F\u043E\u0434\u043F\u043E\u043B\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Piwniczne pe\u0142zacze Barwy wojenne",
        sch: "\u72ED\u7F1D\u751F\u7269 \u6218\u7ED8",
        bra: "| Criaturinhas Escondidas | Tinta de Guerra",
        schema: 17261,
        fre: "Galetas Peinture de guerre",
        hun: "Falban motoszk\xe1l\xf3s Harci fest\xe9s",
        rom: "Crawlspace Critters Vopsea de r\u0103zboi",
        swe: "Kryp i krypin Krigsf\xe4rg"
    },
    1606: {
        img: "sweet_toothed_war_paint",
        eng: "Sweet Toothed War Paint",
        rus: '"\u0421\u043B\u0430\u0441\u0442\u0451\u043D\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "\u0141akomczuch Barwy wojenne",
        sch: "\u55DC\u751C\u6210\u763E \u6218\u7ED8",
        bra: "| Dentinhos Doces | Tinta de Guerra",
        schema: 17260,
        fre: "Bec sucr\xe9 Peinture de guerre",
        hun: "\xc9dessz\xe1j\xfa Harci fest\xe9s",
        rom: "Sweet Toothed Vopsea de r\u0103zboi",
        swe: "Gottegris Krigsf\xe4rg"
    },
    1607: {
        img: "helldriver_war_paint",
        eng: "Helldriver War Paint",
        rus: '"\u0410\u0434\u0441\u043A\u0438\u0439 \u0433\u043E\u043D\u0449\u0438\u043A" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Piekielnik Barwy wojenne",
        sch: "\u5730\u72F1\u8FFD\u9010 \u6218\u7ED8",
        bra: "| \xc1cido Mort\xedfero | Tinta de Guerra",
        schema: 17255,
        fre: "Chlorophylle Peinture de guerre",
        hun: "Pokolhajt\xf3 Harci fest\xe9s",
        rom: "Helldriver Vopsea de r\u0103zboi",
        swe: "Gr\xf6nt inferno Krigsf\xe4rg"
    },
    1608: {
        img: "mummified_mimic_war_paint",
        eng: "Mummified Mimic War Paint",
        rus: '"\u041C\u0443\u043C\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043C\u0438\u043C\u0438\u043A" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Mumifikowany mimik Barwy wojenne",
        sch: "\u72DE\u7B11\u5E72\u5C38 \u6218\u7ED8",
        bra: "| M\xedmico Mumificado | Tinta de Guerra",
        schema: 17268,
        fre: "Momification Peinture de guerre",
        hun: "M\xfamia-mimikri Harci fest\xe9s",
        rom: "Mummified Mimic Vopsea de r\u0103zboi",
        swe: "Mumiebandage Krigsf\xe4rg"
    },
    1609: {
        img: "pumpkin_pied_war_paint",
        eng: "Pumpkin Pied War Paint",
        rus: '"\u0422\u044B\u043A\u0432\u0435\u043D\u043D\u044B\u0439 \u043F\u0438\u0440\u043E\u0433" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Dyniowe ciasto Barwy wojenne",
        sch: "\u5357\u74DC\u751C\u70B9 \u6218\u7ED8",
        bra: "| Torta de Ab\xf3bora | Tinta de Guerra",
        schema: 17259,
        fre: "Tarte \xe0 la citrouille Peinture de guerre",
        hun: "T\xf6k\xf6s-pit\xe9s Harci fest\xe9s",
        rom: "Pumpkin Pied Vopsea de r\u0103zboi",
        swe: "H\xf6stmys Krigsf\xe4rg"
    },
    1610: {
        img: "spectrum_splattered_war_paint",
        eng: "Spectrum Splattered War Paint",
        rus: '"\u0421\u043F\u0435\u043A\u0442\u0440\u0430\u043B\u044C\u043D\u044B\u0439 \u0432\u0441\u043F\u043B\u0435\u0441\u043A" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Rozbryzgany duch Barwy wojenne",
        sch: "\u9B54\u8840\u6CFC\u6E85 \u6218\u7ED8",
        bra: "| Gotas Crom\xe1ticas | Tinta de Guerra",
        schema: 17257,
        fre: "Spectre Peinture de guerre",
        hun: "Spektr\xe1lpac\xe1s Harci fest\xe9s",
        rom: "Spectrum Splattered Vopsea de r\u0103zboi",
        swe: "Spektrumsplatter Krigsf\xe4rg"
    },
    1611: {
        img: "taunt_carlton",
        eng: "Taunt: The Carlton",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0422\u0430\u043D\u0435\u0446 \u041A\u0430\u0440\u043B\u0442\u043E\u043D\u0430",
        schema: 1168,
        pol: "Drwina: Carlton",
        fre: "Raillerie : Le Carlton",
        sch: "\u5632\u8BBD\uFF1A\u5361\u5C14\u987F\u4E4B\u821E",
        bra: "Provoca\xe7\xe3o: O Carlton",
        hun: "Besz\xf3l\xe1s: A Carlton",
        swe: "H\xe5n: The Carlton"
    },
    1612: {
        img: "taunt_runners_rhythm",
        eng: "Taunt: Runner's Rhythm",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0420\u0438\u0442\u043C \u0440\u044B\u0441\u0430\u043A\u0430",
        schema: 30921,
        pol: "Drwina: B\u0119bny biegacza",
        fre: "Raillerie : Garde le rythme",
        sch: "\u5632\u8BBD\uFF1A\u6572\u5C0F\u9F13",
        bra: "Provoca\xe7\xe3o: Ritmo do Corredor",
        hun: "Besz\xf3l\xe1s: F\xfcrge ritmus",
        swe: "H\xe5n: L\xf6parens rytm"
    },
    1613: {
        img: "taunt_scooty_scoot",
        eng: "Taunt: The Scooty Scoot",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0421\u043A\u0443\u0434\u043D\u044B\u0439 \u0441\u043A\u0443\u0442\u0435\u0440",
        schema: 1197,
        pol: "Drwina: Skauci skuter",
        fre: "Raillerie : Le Scouteur",
        sch: "\u5632\u8BBD\uFF1A\u5B9D\u7433\u7684\u6469\u6258",
        bra: "Provoca\xe7\xe3o: Scooter do Scout",
        hun: "Besz\xf3l\xe1s: R\xe1\xe9r\u0151sen robog\xf3",
        swe: "H\xe5n: Skoter-Scout"
    },
    1614: {
        img: "taunt_trackmans_touchdown",
        eng: "Taunt: The Trackman's Touchdown",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0411\u0440\u043E\u0441\u043E\u043A \u0431\u0435\u0433\u0443\u043D\u0430",
        schema: 30917,
        pol: "Drwina: Pierwszorz\u0119dne przy\u0142o\u017Cenie",
        fre: "Raillerie : Le footballeur am\xe9ricain",
        sch: "\u5632\u8BBD\uFF1A\u89E6\u5730\u5F97\u5206",
        bra: "Provoca\xe7\xe3o: Touchdown do Atleta",
        hun: "Besz\xf3l\xe1s: T\xf6kre touchdown",
        swe: "H\xe5n: Triathletens touchdown"
    },
    1615: {
        img: "taunt_fubar_fanfare",
        eng: "Taunt: The Fubar Fanfare",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0424\u0438\u0430\u0441\u043A\u043E-\u0444\u0430\u043D\u0444\u0430\u0440\u0430",
        schema: 30761,
        pol: "Drwina: Fanfara defetysty",
        fre: "Raillerie : La fanfare Fubar",
        sch: "\u5632\u8BBD\uFF1A\u5751\u7239\u7684\u957F\u53F7",
        bra: "Provoca\xe7\xe3o: Fanfarra da Falha",
        hun: "Besz\xf3l\xe1s: A Hogyaza Harsona",
        swe: "H\xe5n: Fubar-fanfaren"
    },
    1616: {
        img: "taunt_panzer_pants",
        eng: "Taunt: Panzer Pants",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0422\u0430\u043D\u043A\u043E\u0432\u044B\u0435 \u0448\u0442\u0430\u043D\u044B",
        schema: 1196,
        pol: "Drwina: Pancerne pantalony",
        fre: "Raillerie : Le sot d'assaut",
        sch: "\u5632\u8BBD\uFF1A\u88C5\u7532\u4E4B\u88E4",
        bra: "Provoca\xe7\xe3o: Passeio de Panzer",
        hun: "Besz\xf3l\xe1s: Tankol\xe1s",
        swe: "H\xe5n: Pansarpantalonger"
    },
    1617: {
        img: "taunt_soldiers_requiem",
        eng: "Taunt: Soldier's Requiem",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0421\u043E\u043B\u0434\u0430\u0442\u0441\u043A\u0430\u044F \u0441\u043A\u043E\u0440\u0431\u044C",
        schema: 30673,
        pol: "Drwina: Requiem \u017Bo\u0142nierza",
        fre: "Raillerie : Requiem du Soldier",
        sch: "\u5632\u8BBD\uFF1A\u58EB\u5175\u7684\u5B89\u9B42\u66F2",
        bra: "Provoca\xe7\xe3o: R\xe9quiem do Soldier",
        hun: "Besz\xf3l\xe1s: A Katona rekviemje",
        swe: "H\xe5n: Soldatens Rekviem"
    },
    1618: {
        img: "taunt_balloonibouncer",
        eng: "Taunt: The Balloonibouncer",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041D\u0430\u0434\u0443\u0432\u043D\u043E\u043A\u0430\u0447\u0430\u043B\u043A\u0430",
        schema: 30763,
        pol: "Drwina: Balonohu\u015Btawka",
        fre: "Raillerie : La Ballicorne \xe0 ressort",
        sch: "\u5632\u8BBD\uFF1A\u6447\u6447\u72EC\u89D2\u517D",
        bra: "Provoca\xe7\xe3o: O Brinquedoc\xf3rnio",
        hun: "Besz\xf3l\xe1s: A ballonhint\xe1z\xf3",
        swe: "H\xe5n: Balloonihopparen"
    },
    1619: {
        img: "taunt_headcase",
        eng: "Taunt: The Headcase",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0413\u043B\u0430\u0432\u043D\u043E\u0435 \u0431\u043B\u044E\u0434\u043E",
        schema: 30876,
        pol: "Drwina: Danie g\u0142owne",
        fre: "Raillerie : Le plat de r\xe9sistance",
        sch: "\u5632\u8BBD\uFF1A\u5934\u7B49\u5927\u9910",
        bra: "Provoca\xe7\xe3o: Antropofagia",
        hun: "Besz\xf3l\xe1s: Fejt\xe1l",
        swe: "H\xe5n: Huvudr\xe4tten"
    },
    1620: {
        img: "taunt_skating_scorcher",
        eng: "Taunt: The Skating Scorcher",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0424\u0438\u0433\u0443\u0440\u043D\u043E\u0435 \u0441\u0436\u0438\u0433\u0430\u043D\u0438\u0435",
        schema: 30919,
        pol: "Drwina: Spopielaj\u0105cy sportowiec",
        fre: "Raillerie : Le patineur arsoniste",
        sch: "\u5632\u8BBD\uFF1A\u6E9C\u51B0\u5065\u5C06",
        bra: "Provoca\xe7\xe3o: O Patinador Incendi\xe1rio",
        hun: "Besz\xf3l\xe1s: A kormos korcsoly\xe1z\xf3",
        swe: "H\xe5n: Skridskouppv\xe4rmning"
    },
    1621: {
        img: "taunt_bad_pipes",
        eng: "Taunt: Bad Pipes",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041F\u043B\u043E\u0445\u043E\u043B\u044B\u043D\u043A\u0430",
        schema: 30671,
        pol: "Drwina: Kiepskie dudy",
        fre: "Raillerie : Corne'amuse",
        sch: "\u5632\u8BBD\uFF1A\u5DEE\u52B2\u7684\u98CE\u7B1B\u624B",
        bra: "Provoca\xe7\xe3o: Gaita de Falha",
        hun: "Besz\xf3l\xe1s: Hamis duda",
        swe: "H\xe5n: S\xe4ckiga pipor"
    },
    1622: {
        img: "taunt_scotsmanns_stagger",
        eng: "Taunt: Scotsmann's Stagger",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0428\u043E\u0442\u043B\u0430\u043D\u0434\u0441\u043A\u043E\u0435 \u0448\u0430\u0442\u0430\u043D\u0438\u0435",
        schema: 30840,
        pol: "Drwina: Szkocki spacer",
        fre: "Raillerie : L'\xe9cossais pompette",
        sch: "\u5632\u8BBD\uFF1A\u4E1C\u5012\u897F\u6B6A",
        bra: "Provoca\xe7\xe3o: Escoc\xeas Estonteado",
        hun: "Besz\xf3l\xe1s: Sk\xf3t d\xfcl\xf6ng\xe9l\u0151s",
        swe: "H\xe5n: Skottens Suprunda"
    },
    1623: {
        img: "taunt_table_tantrum",
        eng: "Taunt: The Table Tantrum",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0421\u0442\u043E\u043B\u043E\u0432\u043E\u0435 \u0441\u0430\u043B\u044C\u0442\u043E",
        schema: 1174,
        pol: "Drwina: Rozr\xf3ba przy stole",
        fre: "Raillerie : Le lancer de table",
        sch: "\u5632\u8BBD\uFF1A\u5723\u8BDE\u5927\u9910",
        bra: "Provoca\xe7\xe3o: Virada de Mesa",
        hun: "Besz\xf3l\xe1s: Borulj, borulj, asztalk\xe1m!",
        swe: "H\xe5n: Bordsv\xe4ltaren"
    },
    1624: {
        img: "taunt_proletariat_posedown",
        eng: "Taunt: The Proletariat Posedown",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041C\u043E\u0449\u044C \u043F\u0440\u043E\u043B\u0435\u0442\u0430\u0440\u0438\u0430\u0442\u0430",
        schema: 30616,
        pol: "Drwina: Proletariacka poza",
        fre: "Raillerie : La pose prol\xe9taire",
        sch: "\u5632\u8BBD\uFF1A\u5DE5\u4EBA\u9636\u7EA7\u4E4B\u6012",
        bra: "Provoca\xe7\xe3o: A Pose do Proletariado",
        hun: "Besz\xf3l\xe1s: A prolet\xe1r p\xf3zol\xe1s",
        swe: "H\xe5n: Arbetarklassens uppvisning"
    },
    1625: {
        img: "taunt_russian_arms_race",
        eng: "Taunt: The Russian Arms Race",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0413\u043E\u043D\u043A\u0430 \u0432 \u0442\u044F\u0436\u0451\u043B\u043E\u043C \u0432\u0435\u0441\u0435",
        schema: 30843,
        pol: "Drwina: Rosyjski wy\u015Bcig zbroje\u0144",
        fre: "Raillerie : Les grandes pompes",
        sch: "\u5632\u8BBD\uFF1A\u72EC\u81C2\u4FEF\u5367\u6491",
        bra: "Provoca\xe7\xe3o: Flex\xe3o da Revolu\xe7\xe3o",
        hun: "Besz\xf3l\xe1s: Az orosz karizma",
        swe: "H\xe5n: Tung tr\xe4ning"
    },
    1626: {
        img: "taunt_soviet_strongarm",
        eng: "Taunt: The Soviet Strongarm",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0421\u0438\u043B\u0430 \u0441\u043E\u0432\u0435\u0442\u043E\u0432",
        schema: 30844,
        pol: "Drwina: Sowiecki si\u0142acz",
        fre: "Raillerie : Halte aux halt\xe8res",
        sch: "\u5632\u8BBD\uFF1A\u82CF\u7EF4\u57C3\u5927\u529B\u58EB",
        bra: "Provoca\xe7\xe3o: Treino de B\xedceps",
        hun: "Besz\xf3l\xe1s: Szovjet karhatalom",
        swe: "H\xe5n: Lyftkranen fr\xe5n Sovjet"
    },
    1627: {
        img: "taunt_bucking_bronco",
        eng: "Taunt: Bucking Bronco",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041D\u0435\u043E\u0431\u0443\u0437\u0434\u0430\u043D\u043D\u044B\u0439 \u0431\u044B\u0447\u043E\u043A",
        schema: 30618,
        pol: "Drwina: Dziki je\u017Adziec",
        fre: "Raillerie : Rod\xe9o sauvage",
        sch: "\u5632\u8BBD\uFF1A\u9A6F\u670D\u91CE\u9A6C",
        bra: "Provoca\xe7\xe3o: Tecnotouro do Texas",
        hun: "Besz\xf3l\xe1s: Ugr\xe1l\xf3 vadbika",
        swe: "H\xe5n: Hoppande hingsten"
    },
    1628: {
        img: "taunt_dueling_banjo",
        eng: "Taunt: The Dueling Banjo",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0414\u0443\u044D\u043B\u044C\u043D\u043E\u0435 \u0431\u0430\u043D\u0434\u0436\u043E",
        schema: 30842,
        pol: "Drwina: Bajeranckie banjo",
        fre: "Raillerie : Le pro du banjo",
        sch: "\u5632\u8BBD\uFF1A\u6597\u7434",
        bra: "Provoca\xe7\xe3o: Duelo de Banjo",
        hun: "Besz\xf3l\xe1s: Bendzs\xf3p\xe1rbaj",
        swe: "H\xe5n: Banjospelaren"
    },
    1629: {
        img: "taunt_jumping_jack",
        eng: "Taunt: The Jumping Jack",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041E\u0442\u0431\u043E\u0439\u043D\u044B\u0435 \u0441\u043A\u0430\u0447\u043A\u0438",
        schema: 30845,
        pol: "Drwina: Pneumoskoczek",
        fre: "Raillerie : Marteau piqueur",
        sch: "\u5632\u8BBD\uFF1A\u8DF3\u8DF3\u94BB",
        bra: "Provoca\xe7\xe3o: A Britadeira",
        hun: "Besz\xf3l\xe1s: Paprikajancsi",
        swe: "H\xe5n: Rida slagborr"
    },
    1630: {
        img: "taunt_meet_the_medic",
        eng: "Taunt: The Meet the Medic",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0417\u043D\u0430\u043A\u043E\u043C\u044C\u0442\u0435\u0441\u044C, \u041C\u0435\u0434\u0438\u043A",
        schema: 477,
        pol: "Drwina: Poznajcie Medyka",
        fre: "Raillerie : \xc0 la Rencontre du Medic",
        sch: "\u5632\u8BBD\uFF1A\u533B\u751F\u7684\u82F1\u59FF",
        bra: "Provoca\xe7\xe3o: O Conhe\xe7a o Medic",
        hun: "Besz\xf3l\xe1s: Meet the Medic",
        swe: "H\xe5n: M\xf6t sjukv\xe5rdaren"
    },
    1631: {
        img: "taunt_surgeons_squeezebox",
        eng: "Taunt: Surgeon's Squeezebox",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0410\u043A\u0443\u0448\u0435\u0440\u0441\u043A\u0438\u0439 \u0430\u043A\u043A\u043E\u0440\u0434\u0435\u043E\u043D",
        schema: 30918,
        pol: "Drwina: Arteterapia akordeonowa",
        fre: "Raillerie : La m\xe9lodie du docteur",
        sch: "\u5632\u8BBD\uFF1A\u624B\u98CE\u7434\u72EC\u594F",
        bra: "Provoca\xe7\xe3o: Acorde\xe3o do Cirurgi\xe3o",
        hun: "Besz\xf3l\xe1s: Zeneter\xe1pia",
        swe: "H\xe5n: Doktorns dragspel"
    },
    1632: {
        img: "taunt_didgeridrongo",
        eng: "Taunt: Didgeridrongo",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0414\u0438\u0434\u0436\u0435\u0440\u0438\u0434\u0443\u0440\u0435\u043D\u044C",
        schema: 30839,
        pol: "Drwina: Didgeridure\u0144",
        fre: "Raillerie : Didgeridrongo",
        sch: "\u5632\u8BBD\uFF1A\u8FEA\u5409\u91CC\u675C\u7BA1",
        bra: "Provoca\xe7\xe3o: Didgeridiota",
        hun: "Besz\xf3l\xe1s: Didzseridi\xf3ta",
        swe: "H\xe5n: Didgeridrongo"
    },
    1633: {
        img: "taunt_killer_solo",
        eng: "Taunt: The Killer Solo",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0423\u0431\u0438\u0439\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0435 \u0441\u043E\u043B\u043E",
        schema: 30609,
        pol: "Drwina: Zab\xf3jcze solo",
        fre: "Raillerie : Le solo de la mort",
        sch: "\u5632\u8BBD\uFF1A\u5B64\u80C6\u6740\u624B",
        bra: "Provoca\xe7\xe3o: O Solo Matador",
        hun: "Besz\xf3l\xe1s: A gyilkos sz\xf3l\xf3ja",
        swe: "H\xe5n: Killer-solot"
    },
    1634: {
        img: "taunt_most_wanted",
        eng: "Taunt: Most Wanted",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041E\u0441\u043E\u0431\u043E \u043E\u043F\u0430\u0441\u0435\u043D",
        schema: 30614,
        pol: "Drwina: Najbardziej poszukiwany",
        fre: "Raillerie : Recherch\xe9",
        sch: "\u5632\u8BBD\uFF1A\u6700\u9AD8\u901A\u7F09",
        bra: "Provoca\xe7\xe3o: Lista de Alvos",
        hun: "Besz\xf3l\xe1s: A legkeresettebb",
        swe: "H\xe5n: Most Wanted"
    },
    1635: {
        img: "taunt_box_trot",
        eng: "Taunt: The Box Trot",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041A\u043E\u0440\u043E\u0431\u043E\u0442\u0440\u043E\u0442",
        schema: 30615,
        pol: "Drwina: Kartonowe szpiegostwo",
        fre: "Raillerie : La Box Trot",
        sch: "\u5632\u8BBD\uFF1A\u76D2\u5B50\u620F\u6CD5",
        bra: "Provoca\xe7\xe3o: A Caixa Camuflada",
        hun: "Besz\xf3l\xe1s: Dobozba b\xfajva",
        swe: "H\xe5n: Gubben i l\xe5dan"
    },
    1636: {
        img: "taunt_disco_fever",
        eng: "Taunt: Disco Fever",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0414\u0438\u0441\u043A\u043E-\u043B\u0438\u0445\u043E\u0440\u0430\u0434\u043A\u0430",
        schema: 30762,
        pol: "Drwina: Gor\u0105czka disco",
        fre: "Raillerie : La fi\xe8vre du disco",
        sch: "\u5632\u8BBD\uFF1A\u72C2\u70ED\u8FEA\u65AF\u79D1",
        bra: "Provoca\xe7\xe3o: Disco Contagiante",
        hun: "Besz\xf3l\xe1s: Diszk\xf3l\xe1z",
        swe: "H\xe5n: Discofeber"
    },
    1637: {
        img: "taunt_luxury_lounge",
        eng: "Taunt: Luxury Lounge",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041F\u0440\u0430\u0437\u0434\u043D\u0430\u044F \u043F\u0430\u0443\u0437\u0430",
        schema: 30922,
        pol: "Drwina: Wykwintny wypoczynek",
        fre: "Raillerie : Le fauteuil d'argent",
        sch: "\u5632\u8BBD\uFF1A\u5934\u7B49\u4E4B\u5EA7",
        bra: "Provoca\xe7\xe3o: Conforto Luxuoso",
        hun: "Besz\xf3l\xe1s: Luxuslakoszt\xe1ly",
        swe: "H\xe5n: En stund f\xf6r dig sj\xe4lv"
    },
    1638: {
        img: "taunt_directors_vision",
        eng: "Taunt: The Director's Vision",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0412\u0437\u0433\u043B\u044F\u0434 \u0440\u0435\u0436\u0438\u0441\u0441\u0435\u0440\u0430",
        schema: 438,
        pol: "Drwina: Wizja re\u017Cysera",
        fre: "Raillerie : La vue du R\xe9alisateur",
        sch: "\u5632\u8BBD\uFF1A\u5BFC\u6F14\u7684\u89C6\u89D2",
        bra: "Provoca\xe7\xe3o: A Vis\xe3o do Diretor",
        hun: "Besz\xf3l\xe1s: A rendez\u0151 elk\xe9pzel\xe9se",
        swe: "H\xe5n: Regiss\xf6rens Synvinkel"
    },
    1639: {
        img: "taunt_kazotsky_kick",
        eng: "Taunt: Kazotsky Kick",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0412\u043F\u0440\u0438\u0441\u044F\u0434\u043A\u0443",
        schema: 1157,
        pol: "Drwina: Kozacki kop",
        fre: "Raillerie : La danse Kazotsky",
        sch: "\u5632\u8BBD\uFF1A\u4FC4\u7F57\u65AF\u8E22\u8E0F\u821E",
        bra: "Provoca\xe7\xe3o: Dan\xe7a dos Cossacos",
        hun: "Besz\xf3l\xe1s: Koz\xe1kt\xe1nc",
        swe: "H\xe5n: Kazotskyspark"
    },
    1640: {
        img: "taunt_mannrobics",
        eng: "Taunt: Mannrobics",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041C\u0430\u043D\u043D\u0440\u043E\u0431\u0438\u043A\u0430",
        schema: 1162,
        pol: "Drwina: Mannorobik",
        fre: "Raillerie : Mannrobic",
        sch: "\u5632\u8BBD\uFF1A\u66FC\u6069\u56E2\u4F53\u64CD",
        bra: "Provoca\xe7\xe3o: Manner\xf3bica",
        hun: "Besz\xf3l\xe1s: Mannerobik",
        swe: "H\xe5n: Mannrobics"
    },
    1641: {
        img: "taunt_second_rate_sorcery",
        eng: "Taunt: Second Rate Sorcery",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0412\u0442\u043E\u0440\u043E\u0441\u043E\u0440\u0442\u043D\u044B\u0439 \u0432\u043E\u043B\u0448\u0435\u0431\u043D\u0438\u043A",
        schema: 30816,
        pol: "Drwina: Czary z drugiej r\u0119ki",
        fre: "Raillerie : Sorcellerie de seconde classe",
        sch: "\u5632\u8BBD\uFF1A\u4E8C\u6D41\u9B54\u6CD5\u5E08",
        bra: "Provoca\xe7\xe3o: Feiti\xe7aria de Segunda Classe",
        hun: "Besz\xf3l\xe1s: M\xe1sodrend\u0171 b\u0171b\xe1j",
        swe: "H\xe5n: Andrasorteringsmagi"
    },
    1642: {
        img: "taunt_shred_alert",
        eng: "Taunt: The Shred Alert",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0411\u043E\u0435\u0432\u043E\u0439 \u0437\u0430\u043F\u0438\u043B",
        schema: 1015,
        pol: "Drwina: Szyderstwo szarpidruta",
        fre: "Raillerie : B\xeate de sc\xe8ne",
        sch: "\u5632\u8BBD\uFF1A\u5409\u4ED6\u8B66\u62A5",
        bra: "Provoca\xe7\xe3o: O Metalerta Vermelho",
        hun: "Besz\xf3l\xe1s: A karmol\xe1sz",
        swe: "H\xe5n: D\xf6dsriffet"
    },
    1643: {
        img: "taunt_victory_lap",
        eng: "Taunt: The Victory Lap",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041A\u0440\u0443\u0433 \u043F\u043E\u0447\u0435\u0442\u0430",
        schema: 1172,
        pol: "Drwina: Zwyci\u0119skie okr\u0105\u017Cenie",
        fre: "Raillerie : Tour d'honneur",
        sch: "\u5632\u8BBD\uFF1A\u6211\u662F\u8001\u53F8\u673A",
        bra: "Provoca\xe7\xe3o: A Volta da Vit\xf3ria",
        hun: "Besz\xf3l\xe1s: A gy\u0151zelmi k\xf6r",
        swe: "H\xe5n: Segervarvet"
    },
    1644: {
        img: "taunt_yeti_punch",
        eng: "Taunt: Yeti Punch",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0423\u0434\u0430\u0440 \u043F\u043E \u0439\u0435\u0442\u0438",
        schema: 1182,
        pol: "Drwina: Uderzenie yeti",
        fre: "Raillerie : En plein dans le migou",
        sch: "\u5632\u8BBD\uFF1A\u62F3\u6253\u96EA\u4EBA",
        bra: "Provoca\xe7\xe3o: Soco no Yeti",
        hun: "Besz\xf3l\xe1s: Jeti-pofon",
        swe: "H\xe5n: Yeti-slag"
    },
    1645: {
        img: "taunt_yeti_smash",
        eng: "Taunt: Yeti Smash",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0419\u0435\u0442\u0438 \u043A\u0440\u0443\u0448\u0438\u0442\u044C",
        schema: 1183,
        pol: "Drwina: Zniszczenie yeti",
        fre: "Raillerie : L'abominable mercenaire des neiges",
        sch: "\u5632\u8BBD\uFF1A\u53D8\u8EAB\u96EA\u4EBA",
        bra: "Provoca\xe7\xe3o: Yeti Esmaga",
        hun: "Besz\xf3l\xe1s: Jeti-z\xfaz\xe1s",
        swe: "H\xe5n: Yeti-smash"
    },
    1646: {
        img: "taunt_zoomin_broom",
        eng: "Taunt: Zoomin' Broom",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0423\u043B\u0451\u0442\u043D\u044B\u0435 \u043C\u0451\u0442\u043B\u044B",
        schema: 30672,
        pol: "Drwina: Lot na miotle",
        fre: "Raillerie : Le balai filant",
        sch: "\u5632\u8BBD\uFF1A\u626B\u5E1A\u98DE\u884C\u672F",
        bra: "Provoca\xe7\xe3o: Vassoura Veloz",
        hun: "Besz\xf3l\xe1s: Sepr\u0171n s\xf6pr\xe9s",
        swe: "H\xe5n: Hast p\xe5 Kvast"
    },
    1647: {
        img: "pyro_shark",
        eng: "Pyro Shark",
        rus: "\u0414\u0438\u0437\u0435\u043B\u044C\u043D\u0430\u044F \u0430\u043A\u0443\u043B\u0430",
        pol: "\u017Barz\u0105cy \u017Car\u0142acz",
        fre: "Pyrequin",
        sch: "\u6012\u706B\u72C2\u9CA8",
        bra: "Tuba-Pyro",
        schema: 31068,
        hun: "C\xe1pir\xf3",
        swe: "Pyrohaj"
    },
    1648: {
        img: "avian_amante",
        eng: "Avian Amante",
        rus: "\u041B\u0435\u0442\u0443\u0447\u0438\u0439 \u043B\u043E\u0432\u0435\u043B\u0430\u0441",
        pol: "Ptasi pasjonat",
        fre: "Corbeau m\xe9got",
        sch: "\u9E26\u4EBA\u9762\u5177",
        bra: "Amante Avi\xe1rio",
        schema: 31073,
        hun: "Sz\xe1rnyasszeret\u0151",
        swe: "Kacklande kr\xe5ka"
    },
    1649: {
        img: "eingineer",
        eng: "Eingineer",
        rus: "\u042D\u0439\u043D\u0436\u0435\u043D\u0435\u0440",
        pol: "Ein\u017Cynier",
        fre: "Eingineer",
        sch: "\u91D1\u4E1D\u96C0\u77FF\u5DE5",
        bra: "Eingineer",
        schema: 31075,
        hun: "M\xe9rn\xf6kkan\xe1ri",
        swe: "Eingenj\xf6r"
    },
    1650: {
        img: "remorseless_raptor",
        eng: "Remorseless Raptor",
        rus: "\u042F\u0440\u043E\u0441\u0442\u043D\u044B\u0439 \u044F\u0449\u0435\u0440",
        pol: "Gro\u017Ana gadzina",
        fre: "Raptor sans remords",
        sch: "\u65E0\u60C5\u8FC5\u731B\u9F99",
        bra: "Predador Perverso",
        schema: 31082,
        hun: "Rettent\u0151 Raptor",
        swe: "Velociraptor"
    },
    1651: {
        img: "wild_whip",
        eng: "Wild Whip",
        rus: "\u0425\u0432\u043E\u0441\u0442 \u0445\u0438\u0449\u043D\u0438\u043A\u0430",
        pol: "Dziki dromeozaur",
        fre: "Reliquat d'\xe9volution",
        sch: "\u72C2\u91CE\u5C3E\u97AD",
        bra: "Cauda Cret\xe1cea",
        schema: 31083,
        hun: "S\xf6pr\xf6get\u0151",
        swe: "Sn\xe4rtande svans"
    },
    1652: {
        img: "horseless_headless_horsemanns_headtaker",
        eng: "Horseless Headless Horsemann's Headtaker",
        rus: "\u0421\u0435\u043A\u0438\u0440\u0430 \u041F\u0435\u0448\u0435\u0433\u043E \u0432\u0441\u0430\u0434\u043D\u0438\u043A\u0430 \u0431\u0435\u0437 \u0433\u043E\u043B\u043E\u0432\u044B",
        pol: "\u015Acinacz g\u0142\xf3w Bezkonnego Bezg\u0142owego Je\u017Ad\u017Aca",
        fre: "Le D\xe9capiteur du Cavalier sans T\xeate et sans Cheval",
        sch: "\u8131\u7F30\u65E0\u5934\u9A91\u58EB\u7684\u65A9\u9996\u65A7",
        bra: "O Corta-Cabe\xe7as do Cavaleiro Carente de Cavalo e Cabe\xe7a",
        schema: 266,
        hun: "A Lovatlan Fejetlen Lovas Fejvev\u0151je",
        swe: "H\xe4stl\xf6se huvudl\xf6se Horsemanns halshuggare"
    },
    1653: {
        img: "necro_smasher",
        eng: "Necro Smasher",
        rus: "\u0422\u0440\u0443\u043F\u043E\u043A\u043E\u043B\u043E\u0442\u0443\u0448\u043A\u0430",
        pol: "Nekrozgniatacz",
        fre: "Necro Smasher",
        sch: "\u5927\u529B\u788E\u5C38\u9524",
        bra: "Necroesmagador",
        schema: 1123,
        hun: "Hullaal\xe1z\xf3",
        swe: "Kusliga klubban"
    },
    1654: {
        img: "ghastly_gibus",
        eng: "Ghastly Gibus",
        rus: "\u0416\u0443\u0442\u043A\u0438\u0439 \u0448\u0430\u043F\u043E\u043A\u043B\u044F\u043A",
        pol: "Upiorny cylinder",
        fre: "Horrible Gibus",
        sch: "\u53EF\u6015\u7684\u6298\u53E0\u793C\u5E3D",
        bra: "Cartola Medonha",
        schema: 584,
        hun: "Cudar Cilinder",
        swe: "Sp\xf6klik Stormhatt"
    },
    1655: {
        img: "mildly_disturbing_halloween_mask",
        eng: "Mildly Disturbing Halloween Mask",
        rus: "\u041F\u0443\u0433\u0430\u044E\u0449\u0430\u044F \u043C\u0430\u0441\u043A\u0430 \u043D\u0430 \u0425\u0435\u043B\u043B\u043E\u0443\u0438\u043D",
        pol: "Lekko niepokoj\u0105ca maska halloweenowa",
        fre: "Masque d'Halloween un peu d\xe9rangeant",
        sch: "\u9634\u68EE\u68EE\u7684\u4E07\u5723\u8282\u9762\u5177",
        bra: "M\xe1scara Levemente Perturbadora de Dia das Bruxas",
        schema: 115,
        hun: "Enyh\xe9n Ijeszt\u0151 Halloween-\xe1larc",
        swe: "Aningen L\xe4skig Halloween-Mask"
    },
    1656: {
        img: "ghastlier_gibus",
        eng: "Ghastlier Gibus",
        rus: "\u0416\u0443\u0442\u0447\u0430\u0439\u0448\u0438\u0439 \u0448\u0430\u043F\u043E\u043A\u043B\u044F\u043A",
        pol: "Upiorniejszy cylinder",
        fre: "Inf\xe2me Gibus",
        sch: "\u66F4\u53EF\u6015\u7684\u6298\u53E0\u793C\u5E3D",
        bra: "Cartola Mais Medonha",
        schema: 279,
        hun: "Cudarabb Cilinder",
        swe: "Sp\xf6klikare Stormhatt"
    },
    1657: {
        img: "horseless_headless_horsemanns_head",
        eng: "Horseless Headless Horsemann's Head",
        rus: "\u0413\u043E\u043B\u043E\u0432\u0430 \u041F\u0435\u0448\u0435\u0433\u043E \u0432\u0441\u0430\u0434\u043D\u0438\u043A\u0430 \u0431\u0435\u0437 \u0433\u043E\u043B\u043E\u0432\u044B",
        pol: "G\u0142owa Bezkonnego Bezg\u0142owego Je\u017Ad\u017Aca",
        fre: "T\xeate du Cavalier sans T\xeate et sans Cheval",
        sch: "\u8131\u7F30\u7684\u65E0\u5934\u9A91\u58EB\u5357\u74DC\u5934",
        bra: "A Cabe\xe7a do Cavaleiro Carente de Cavalo e Cabe\xe7a",
        schema: 278,
        hun: "A Lovatlan Fejetlen Lovas Feje",
        swe: "H\xe4stl\xf6se Huvudl\xf6se Horsemanns Huvud"
    },
    1658: {
        img: "spine_chilling_skull",
        eng: "Spine-Chilling Skull",
        rus: "\u0411\u0443\u0434\u043E\u0440\u0430\u0436\u0430\u0449\u0438\u0439 \u043A\u0440\u043E\u0432\u044C \u0447\u0435\u0440\u0435\u043F",
        pol: "Mro\u017C\u0105ca krew w \u017Cy\u0142ach czacha",
        fre: "Cr\xe2ne qui vous glace le sang",
        sch: "\u6BDB\u9AA8\u609A\u7136\u7684\u9AB7\u9AC5\u5934",
        bra: "O Cr\xe2nio Arrepiante",
        schema: 287,
        hun: "K\xeds\xe9rteties Koponya",
        swe: "Ryslig D\xf6dskalle"
    },
    1659: {
        img: "voodoo_juju",
        eng: "Voodoo Juju",
        rus: "\u0410\u043C\u0443\u043B\u0435\u0442 \u0432\u0443\u0434\u0443",
        pol: "Juju voodoo",
        fre: "Juju Vaudou",
        sch: "\u5DEB\u6BD2\u62A4\u7B26",
        bra: "O Vudu Juju",
        schema: 289,
        hun: "Vudu Juju"
    },
    1660: {
        img: "ghastlierest_gibus",
        eng: "Ghastlierest Gibus",
        rus: "\u041D\u0430\u0438\u0436\u0443\u0442\u0447\u0430\u0439\u0448\u0438\u0439 \u0448\u0430\u043F\u043E\u043A\u043B\u044F\u043A",
        pol: "Najupiorniejszy cylinder",
        fre: "\xc9pouvantable Gibus",
        sch: "\u6700\u53EF\u6015\u7684\u6298\u53E0\u793C\u5E3D",
        bra: "Cartola Muito Mais Medonha",
        schema: 116,
        hun: "Legcudarabb Cilinder",
        swe: "Sp\xf6klikareast Stormhatt"
    },
    1661: {
        img: "monoculus",
        eng: "MONOCULUS!",
        rus: "\u0413\u041B\u0410\u0417\u0410\u0421\u0422\u0423\u0421!",
        pol: "MONOCULUS!",
        fre: "Le MONOCULUS !",
        sch: "\u72EC\u773C\u602A\u80CE\uFF01",
        bra: "O MONOCULUS!",
        schema: 581,
        hun: "A MONOCULUS!",
        ger: "Der MONOKULUS!"
    },
    1662: {
        img: "spine_chilling_skull_2011",
        eng: "Spine-Chilling Skull 2011",
        rus: "\u041B\u0435\u0434\u0435\u043D\u044F\u0449\u0438\u0439 \u043A\u0440\u043E\u0432\u044C \u0447\u0435\u0440\u0435\u043F 2011",
        pol: "Mro\u017C\u0105ca krew w \u017Cy\u0142ach czacha 2011",
        fre: "Le Cr\xe2ne qui vous glace le sang 2011",
        sch: "\u6BDB\u9AA8\u609A\u7136\u7684\u9AB7\u9AC5\u5934 2011 \u5E74\u7248",
        bra: "O Cr\xe2nio Arrepiante de 2011",
        schema: 576,
        hun: "A K\xeds\xe9rteties Koponya 2011",
        swe: "Ryslig D\xf6dskalle 2011"
    },
    1663: {
        img: "ghostly_gibus",
        eng: "Ghostly Gibus",
        rus: "\u041F\u0440\u0438\u0437\u0440\u0430\u0447\u043D\u044B\u0439 \u0448\u0430\u043F\u043E\u043A\u043B\u044F\u043A",
        pol: "Widmowy cylinder",
        fre: "Fantomatique Gibus",
        sch: "\u5E7D\u7075\u6298\u53E0\u793C\u5E3D",
        bra: "Cartola Fantasmedonha",
        schema: 940,
        hun: "Cidris Cilinder",
        swe: "Sp\xf6klik Stormhatt"
    },
    1664: {
        img: "skull_island_topper",
        eng: "Skull Island Topper",
        rus: "\u0428\u043B\u044F\u043F\u0430 \u0441 \u043E\u0441\u0442\u0440\u043E\u0432\u0430 \u0427\u0435\u0440\u0435\u043F\u0430",
        pol: "Czaszkowy cylinder czarnoksi\u0119\u017Cnika",
        fre: "Le couvre-chef de l'\xcele au cr\xe2ne",
        sch: "\u9AB7\u9AC5\u5C9B\u4E3B",
        bra: "O Cr\xe2nio da Ilha da Caveira",
        schema: 941,
        hun: "A Koponyaszigeti Kalap",
        swe: "D\xf6dskalle\xf6ns Huvudprydnad"
    },
    1665: {
        img: "pallet_of_crates",
        eng: "Pallet of Crates",
        rus: "\u0413\u0440\u0443\u0434\u0430 \u044F\u0449\u0438\u043A\u043E\u0432",
        pol: "Paleta skrzynek",
        fre: "Palette de caisses",
        sch: "\u6210\u5806\u7684\u8865\u7ED9\u7BB1",
        bra: "Palete de Caixas",
        schema: 1037,
        hun: "Egy raklap L\xe1da",
        swe: "Lastpall med l\xe5dor"
    },
    1666: {
        img: "elf_care_provider",
        eng: "Elf Care Provider",
        rus: "\u0414\u043E\u043A\u0442\u043E\u0440 \u044D\u043B\u044C\u0444\u0438\u0439\u0441\u043A\u0438\u0445 \u043D\u0430\u0443\u043A",
        schema: 31176,
        pol: "Elfia s\u0142u\u017Cba zdrowia",
        bra: "Cuidado Pr\xe9-Natal",
        hun: "Man\xf3ment\u0151-szolg\xe1lat",
        fre: "Lutin-soignant",
        swe: "H\xe4lsonisse",
        sch: "\u7CBE\u7075\u533B\u5E08"
    },
    1667: {
        img: "bear_walker",
        eng: "Bear Walker",
        rus: "\u041C\u0435\u0434\u0432\u0435\u0445\u043E\u0434\u044B",
        schema: 31180,
        pol: "Syberyjskie spanko",
        bra: "Passo do Ursinho",
        hun: "Medvetappancs",
        fre: "Pantoufles velues",
        swe: "Toffelhj\xe4lte",
        sch: "\u68A6\u6E38\u4E4B\u718A"
    },
    1668: {
        img: "festive_flip_thwomps",
        eng: "Festive Flip-Thwomps",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u0430\u044F \u043F\u043E\u0445\u043E\u0434\u043A\u0430",
        schema: 31167,
        pol: "Prezentowe p\u0142askostopie",
        bra: "Embrulho de P\xe9-sente",
        hun: "D\xedszdobozos Kivitel",
        fre: "Savates emball\xe9es",
        ger: "Geschenkpantoffeln",
        sch: "\u793C\u76D2\u5927\u811A",
        swe: "Festliga tipp tapp"
    },
    1669: {
        img: "shoestring_santa",
        eng: "Shoestring Santa",
        rus: "\u0421\u043A\u0443\u0434\u043D\u044B\u0439 \u0421\u0430\u043D\u0442\u0430",
        schema: 31169,
        pol: "Miko\u0142aj z przeceny",
        bra: "Noel de Araque",
        hun: "Megszorult Mikul\xe1s",
        fre: "P\xe8re No\xebl fauch\xe9",
        swe: "L\xe5gpristomte",
        sch: "\u5269\u86CB\u8001\u4EBA"
    },
    1670: {
        img: "jolly_jingler",
        eng: "Jolly Jingler",
        rus: "\u0411\u043E\u0439\u043A\u0438\u0439 \u0431\u0443\u0431\u0435\u043D\u0447\u0438\u043A",
        schema: 31165,
        pol: "Rozdzwoniony weso\u0142ek",
        bra: "Guizo Natalino",
        hun: "Csavaros Csingilingi",
        fre: "Clochette pimpante",
        swe: "Fj\xe4der i hatten",
        sch: "\u5723\u8BDE\u94C3\u94DB\u5E3D"
    },
    1671: {
        img: "candy_cantlers",
        eng: "Candy Cantlers",
        rus: "\u0421\u0430\u0445\u0430\u0440\u043D\u044B\u0435 \u0440\u043E\u0436\u043A\u0438",
        schema: 31164,
        pol: "Cukierkowe poro\u017Ce",
        bra: "Galhada Adocicada",
        hun: "Cukorkagancs",
        fre: "Ramures sucr\xe9es",
        ger: "Kandisgeweih",
        sch: "\u7CD6\u679C\u9E7F\u89D2",
        swe: "Godishjort"
    },
    1672: {
        img: "festive_fascinator",
        eng: "Festive Fascinator",
        rus: "\u041E\u0447\u0430\u0440\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043E\u0431\u043E\u0434\u043E\u043A",
        schema: 31172,
        pol: "Fiku\u015Bny fascynator",
        bra: "Fascinador Festivo",
        hun: "Vid\xe1m Villong\xe1s",
        fre: "Serre-t\xeate festif",
        ger: "Festliches Stirnband",
        sch: "\u5F69\u706F\u53D1\u5E26",
        swe: "Festligt diadem"
    },
    1673: {
        img: "reindoonibeanie",
        eng: "Reindoonibeanie",
        rus: "\u041D\u0430\u0434\u0443\u0432\u043E\u043B\u0435\u043D\u0435\u0448\u0430\u043F\u043A\u0430",
        schema: 31171,
        pol: "Renifero\u017Ccowe beanie",
        bra: "Renagorro",
        hun: "R\xe9nkornisapka",
        fre: "Bonnet rennicorne",
        sch: "\u9A6F\u9E7F\u72EC\u89D2\u517D\u4E4B\u5E3D",
        swe: "Renh\xf6rningsm\xf6ssa"
    },
    1674: {
        img: "particulate_protector",
        eng: "Particulate Protector",
        rus: "\u0411\u043B\u043E\u043A\u0438\u0440\u0430\u0442\u043E\u0440 \u0431\u0430\u043A\u0442\u0435\u0440\u0438\u0439",
        schema: 31163,
        pol: "Przeciwcz\u0105steczkowa protekcja",
        bra: "Protetor Particular",
        hun: "R\xe9szecskesz\u0171r\u0151",
        fre: "Protecteur de particules",
        ger: "Partikelmaske",
        sch: "\u6709\u5BB3\u5FAE\u7C92\u8FC7\u6EE4\u5668",
        swe: "Partikelskydd"
    },
    1675: {
        img: "the_killing_tree",
        eng: "The Killing Tree",
        rus: "\u0414\u0440\u0435\u0432\u043E \u0443\u0431\u0438\u0439\u0441\u0442\u0432",
        schema: 31181,
        pol: "\u015Amierciono\u015Bny starodrzew",
        bra: "Pinheiro Certeiro",
        hun: "Kar\xe1csonyfa Al\xe1val\xf3",
        fre: "Sapin mortel",
        ger: "Serienf\xf6rster",
        sch: "\u4F1A\u8BF4\u8BDD\u7684\u6811",
        swe: "Mordgran"
    },
    1676: {
        img: "the_smissmass_sorcerer",
        eng: "Smissmas Sorcerer",
        rus: "\u0428\u043C\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043D\u0441\u043A\u0438\u0439 \u0447\u0430\u0440\u043E\u0434\u0435\u0439",
        schema: 31166,
        pol: "\u015Ani\u0105teczny czarodziej",
        bra: "Feiticeiro Festivo",
        sch: "\u5723\u8BDE\u6CD5\u5E08",
        fre: "Chapeau de Smissmas",
        hun: "Gal\xe1csonyi Var\xe1zsl\xf3",
        swe: "Julgrann"
    },
    1677: {
        img: "sandmanns_brush",
        eng: "SandMann's Brush",
        rus: "\u0421\u043E\u043D\u043D\u0430\u044F \u043A\u0438\u0441\u0442\u043E\u0447\u043A\u0430",
        schema: 31178,
        pol: "Mu\u015Bni\u0119cie Piaskuna",
        bra: "Gorrinho do Soninho",
        hun: "\xc1lommannus Sipka",
        fre: "Marchand de sommeil",
        ger: "SandMannm\xfctze",
        sch: "\u7761\u9B54\u4E4B\u89E6",
        swe: "John Blunds borste"
    },
    1678: {
        img: "bedbug_protection",
        eng: "BedBug Protection",
        rus: "\u041A\u043B\u043E\u043F-\u0441\u0442\u043E\u043F",
        schema: 31179,
        pol: "Pi\u017Camka proletariusza",
        bra: "Prote\xe7\xe3o Anti-Pap\xe3o",
        hun: "\xc1lombiztons\xe1gi Egyenruha",
        fre: "Pyjama protecteur",
        ger: "Anti-Bettwanzen-Pyjama",
        sch: "\u778C\u7761\u866B\u4E4B\u8863",
        swe: "Lusskydd"
    },
    1679: {
        img: "professionals_pom_pom",
        eng: "Professional's Pom-Pom",
        rus: "\u041F\u043E\u043C\u043F\u043E\u043D \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u0430",
        schema: 31170,
        pol: "Pompon profesjonalisty",
        bra: "Pompom do Profissional",
        hun: "Profi Pompon",
        fre: "Pro du pompon",
        ger: "Profi-Bommelm\xfctze",
        sch: "\u4E13\u4E1A\u4F63\u5175\u7684\u6BDB\u7403\u5E3D",
        swe: "Proffstoffs"
    },
    1680: {
        img: "blitzen_bowl",
        eng: "Blitzen Bowl",
        rus: "\u041A\u0430\u0441\u043A\u0430 \u041A\u043E\u043C\u0435\u0442\u044B",
        schema: 31175,
        pol: "B\u0142yskawiczny kask",
        bra: "Engenharia Renal",
        hun: "R\xe9nb\xe1ny\xe1sz-sisak",
        fre: "L'\xe9cuelle de Com\xe8te",
        ger: "Blitzenhelm",
        sch: "\u7535\u5149\u9A6F\u9E7F\u76D4",
        swe: "Rudolfs hink"
    },
    1681: {
        img: "night_ward",
        eng: "Night Ward",
        rus: "\u041D\u043E\u0447\u043D\u0430\u044F \u0441\u0438\u0434\u0435\u043B\u043A\u0430",
        schema: 31177,
        pol: "Nocny dy\u017Cur",
        bra: "Plant\xe3o Noturno",
        hun: "\xc9jjeli \xdcgyelet",
        fre: "M\xe9decin de garde",
        swe: "Nattjour",
        sch: "\u591C\u73ED\u533B\u751F"
    },
    1682: {
        img: "helm_helm",
        eng: "Helm Helm",
        rus: "\u0428\u0442\u0443\u0440\u0432\u0430\u043B\u044C\u043D\u0430\u044F \u0448\u043B\u044F\u043F\u0430",
        schema: 31182,
        pol: "Ster u steru",
        bra: "O Estrondoso Tim\xe3o",
        hun: "Haj\xf3ssapka",
        fre: "Commandant de bord",
        swe: "Skepparhatt",
        sch: "\u5E06\u8239\u4E4B\u76D4"
    },
    1683: {
        img: "towering_pillar_of_beanies",
        eng: "Towering Pillar of Beanies",
        rus: "\u0413\u0438\u0433\u0430\u043D\u0442\u0441\u043A\u0430\u044F \u0431\u0430\u0448\u043D\u044F \u0438\u0437 \u0448\u0430\u043F\u043E\u043A",
        schema: 31168,
        pol: "Niebotyczny s\u0142up beanie",
        bra: "Pilar Monumental de Gorros",
        hun: "Magasan Tornyosul\xf3 T\xe9li Sapk\xe1k",
        fre: "Imposante pile de bonnets",
        ger: "Hochragende S\xe4ule von Beanies",
        sch: "\u5C42\u53E0\u9AD8\u8038\u7684\u9488\u7EC7\u5E3D",
        swe: "Reslig luvpelare"
    },
    1684: {
        img: "the_round_a_bout",
        eng: "The Round-A-Bout",
        rus: "\u041A\u0430\u0440\u0443\u0441\u0435\u043B\u044C",
        schema: 31174,
        pol: "Karnawa\u0142owa karuzela",
        bra: "Pyrossel",
        hun: "K\xf6rhinta",
        fre: "Man\xe8ge portable",
        swe: "Karusellkrona",
        sch: "\u65CB\u8F6C\u72EC\u89D2\u517D"
    },
    1685: {
        img: "towering_pile_of_presents",
        eng: "Towering Pile of Presents",
        rus: "\u0413\u0438\u0433\u0430\u043D\u0442\u0441\u043A\u0430\u044F \u0433\u0440\u0443\u0434\u0430 \u043F\u043E\u0434\u0430\u0440\u043A\u043E\u0432",
        pol: "Niebotyczny s\u0142up prezent\xf3w",
        bra: "Pilha Monumental de Presentes",
        hun: "Magasan Tornyosul\xf3 Aj\xe1nd\xe9khalom",
        fre: "Imposante pile de cadeaux",
        ger: "Hochragender Geschenkehaufen",
        schema: 31173,
        sch: "\u5C42\u53E0\u9AD8\u8038\u7684\u793C\u7269\u76D2",
        swe: "H\xf6g presenth\xf6g"
    },
    1686: {
        img: "snowflake_swirled_war_paint",
        eng: "Snowflake Swirled War Paint",
        rus: '"\u0421\u043D\u0435\u0436\u043D\u0430\u044F \u0441\u043F\u0438\u0440\u0430\u043B\u044C" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17277,
        pol: "Wir z p\u0142atkami \u015Bniegu Barwy wojenne",
        bra: "| Espiral Flocada | Tinta de Guerra",
        hun: "Kavarg\xf3s-h\xf3pih\xe9s Harci fest\xe9s",
        rom: "Snowflake Swirled Vopsea de r\u0103zboi",
        fre: "Tourbillon de flocons Peinture de guerre",
        swe: "Virvlande sn\xf6flingor Krigsf\xe4rg",
        sch: "\u98DE\u96EA\u8FDE\u5929 \u6218\u7ED8"
    },
    1687: {
        img: "snow_globalization_war_paint",
        eng: "Snow Globalization War Paint",
        rus: '"\u0421\u043D\u0435\u0436\u043D\u044B\u0439 \u0448\u0430\u0440" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17275,
        pol: "\u015Anie\u017Cna globalizacja Barwy wojenne",
        bra: "| Globaliza\xe7\xe3o de Neve | Tinta de Guerra",
        hun: "H\xf3csat\xe1roz\xe1s Harci fest\xe9s",
        rom: "Snow Globalization Vopsea de r\u0103zboi",
        fre: "Hiver universel Peinture de guerre",
        swe: "Sn\xf6gubbar och t\xf6gubbar Krigsf\xe4rg",
        sch: "\u5168\u7403\u964D\u96EA \u6218\u7ED8"
    },
    1688: {
        img: "glacial_glazed_war_paint",
        eng: "Glacial Glazed War Paint",
        rus: '"\u041B\u0435\u0434\u043D\u0438\u043A\u043E\u0432\u044B\u0439 \u043B\u0430\u043A" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17282,
        pol: "Zimowe zeszklenie Barwy wojenne",
        bra: "| Azulejos Glaciais | Tinta de Guerra",
        hun: "Gleccserbevonat\xfa Harci fest\xe9s",
        rom: "Glacial Glazed Vopsea de r\u0103zboi",
        fre: "Banquise polaire Peinture de guerre",
        swe: "Kristallklar Krigsf\xe4rg"
    },
    1689: {
        img: "gifting_manns_wrapping_paper_war_paint",
        eng: "Gifting Mann's Wrapping Paper War Paint",
        rus: '"\u041E\u0431\u0451\u0440\u0442\u043E\u0447\u043D\u0430\u044F \u0431\u0443\u043C\u0430\u0433\u0430 \u0449\u0435\u0434\u0440\u043E\u0433\u043E \u041C\u0430\u043D\u043D\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17276,
        pol: "Prezentowy papier do pakowania Barwy wojenne",
        bra: "| Papel de Presente do Mann Presente | Tinta de Guerra",
        hun: "Manntasztikus csomagol\xf3pap\xedr Harci fest\xe9s",
        rom: "Gifting Mann's Wrapping Paper Vopsea de r\u0103zboi",
        fre: "Papier cadeau Mannifique Peinture de guerre",
        swe: "Manntastiskt presentpapper Krigsf\xe4rg"
    },
    1690: {
        img: "peppermint_swirl_war_paint",
        eng: "Peppermint Swirl War Paint",
        rus: '"\u041C\u044F\u0442\u043D\u044B\u0439 \u0432\u0438\u0445\u0440\u044C" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17273,
        pol: "Cukierkowy wir Barwy wojenne",
        bra: "| Espiral de Hortel\xe3-Pimenta | Tinta de Guerra",
        hun: "Borsmenta forgatag Harci fest\xe9s",
        rom: "Peppermint Swirl Vopsea de r\u0103zboi",
        fre: "Berlingot Peinture de guerre",
        swe: "Polkagrisrandig Krigsf\xe4rg"
    },
    1691: {
        img: "gingerbread_winner_war_paint",
        eng: "Gingerbread Winner War Paint",
        rus: '"\u041F\u0440\u044F\u043D\u0438\u0447\u043D\u044B\u0439 \u043F\u043E\u0431\u0435\u0434\u0438\u0442\u0435\u043B\u044C" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17270,
        pol: "Piernikowy zwyci\u0119zca Barwy wojenne",
        bra: "| Ganha-P\xe3o de Mel | Tinta de Guerra",
        hun: "Nyer\u0151 m\xe9zeskal\xe1cs Harci fest\xe9s",
        rom: "Gingerbread Winner Vopsea de r\u0103zboi",
        fre: "Gagne-pain d'\xe9pice Peinture de guerre",
        swe: "Pepparkakskrusidull Krigsf\xe4rg"
    },
    1692: {
        img: "smissmas_spycrabs_war_paint",
        eng: "Smissmas Spycrabs War Paint",
        rus: '"\u0428\u043C\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043D\u0441\u043A\u0438\u0435 \u043A\u0440\u0430\u0431\u044B-\u0448\u043F\u0438\u043E\u043D\u044B" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17278,
        pol: "\u015Ani\u0105teczne szpiegokraby Barwy wojenne",
        bra: "| Spyranguejos de Natal | Tinta de Guerra",
        hun: "Gal\xe1csonyi k\xe9mr\xe1kok Harci fest\xe9s",
        rom: "Smissmas Spycrabs Vopsea de r\u0103zboi",
        fre: "Spycrabs de Smissmas Peinture de guerre",
        swe: "Spionkrabban firar jul Krigsf\xe4rg",
        sch: "\u8783\u95E8\u5DE6\u9053 \u6218\u7ED8"
    },
    1693: {
        img: "elfin_enamel_war_paint",
        eng: "Elfin Enamel War Paint",
        rus: '"\u042D\u043B\u044C\u0444\u0438\u0439\u0441\u043A\u0430\u044F \u044D\u043C\u0430\u043B\u044C" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17272,
        pol: "Elfia emalia Barwy wojenne",
        bra: "| Esmalte \xc9lfico | Tinta de Guerra",
        hun: "Man\xf3s m\xe1z Harci fest\xe9s",
        rom: "Elfin Enamel Vopsea de r\u0103zboi",
        fre: "Elfe \xe9maill\xe9 Peinture de guerre",
        swe: "Alvisk emalj Krigsf\xe4rg"
    },
    1694: {
        img: "frozen_aurora_war_paint",
        eng: "Frozen Aurora War Paint",
        rus: '"\u0417\u0430\u0441\u0442\u044B\u0432\u0448\u0430\u044F \u0437\u0430\u0440\u044F" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17279,
        pol: "Mro\u017Ana zorza Barwy wojenne",
        bra: "| Aurora Congelada | Tinta de Guerra",
        hun: "Fagyott sarki f\xe9ny Harci fest\xe9s",
        rom: "Frozen Aurora Vopsea de r\u0103zboi",
        fre: "Aurore gel\xe9e Peinture de guerre",
        swe: "Iskall Aurora Krigsf\xe4rg",
        sch: "\u51B0\u5C01\u6781\u5149 \u6218\u7ED8"
    },
    1695: {
        img: "cookie_fortress_war_paint",
        eng: "Cookie Fortress War Paint",
        rus: '"\u041F\u0440\u044F\u043D\u0438\u0447\u043D\u044B\u0435 \u043D\u0430\u0451\u043C\u043D\u0438\u0447\u043A\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17283,
        pol: "Ciasteczkowa forteca Barwy wojenne",
        bra: "| Fortaleza de Biscolachas | Tinta de Guerra",
        hun: "S\xfctier\u0151d Harci fest\xe9s",
        rom: "Cookie Fortress Vopsea de r\u0103zboi",
        fre: "Pain d'\xe9pice Peinture de guerre",
        swe: "Kaksoldater Krigsf\xe4rg"
    },
    1696: {
        img: "frosty_delivery_war_paint",
        eng: "Frosty Delivery War Paint",
        rus: '"\u041C\u043E\u0440\u043E\u0437\u043D\u0430\u044F \u043F\u043E\u0441\u044B\u043B\u043A\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17281,
        pol: "Mro\u017Ana dostawa Barwy wojenne",
        bra: "| Entrega G\xe9lida | Tinta de Guerra",
        hun: "Deres sz\xe1ll\xedtm\xe1ny Harci fest\xe9s",
        rom: "Frosty Delivery Vopsea de r\u0103zboi",
        fre: "Livraison givr\xe9e Peinture de guerre",
        swe: "Frostpost Krigsf\xe4rg"
    },
    1697: {
        img: "saccharine_striped_war_paint",
        eng: "Saccharine Striped War Paint",
        rus: '"\u0421\u043B\u0430\u0434\u043A\u0438\u0435 \u043F\u043E\u043B\u043E\u0441\u043A\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17271,
        pol: "Przes\u0142odkie pasy Barwy wojenne",
        bra: "| Listras Adocicadas | Tinta de Guerra",
        hun: "Cukorkacs\xedkos Harci fest\xe9s",
        rom: "Saccharine Striped Vopsea de r\u0103zboi",
        fre: "Stries saccharines Peinture de guerre",
        swe: "Raffigt r\xe4fflad Krigsf\xe4rg"
    },
    1698: {
        img: "starlight_serenity_war_paint",
        eng: "Starlight Serenity War Paint",
        rus: '"\u041F\u043E\u043B\u0443\u043D\u043E\u0447\u043D\u044B\u0439 \u043F\u043E\u043A\u043E\u0439" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17280,
        pol: "Gwiezdne ukojenie Barwy wojenne",
        bra: "| Serenidade Estrelada | Tinta de Guerra",
        hun: "Csillagf\xe9nyes csendess\xe9g Harci fest\xe9s",
        rom: "Starlight Serenity Vopsea de r\u0103zboi",
        fre: "Astres radieux Peinture de guerre",
        swe: "Rogivande stj\xe4rnljus Krigsf\xe4rg"
    },
    1699: {
        img: "taunt_the_pooped_deck",
        eng: "Taunt: The Pooped Deck",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0423\u044E\u0442\u043D\u044B\u0439 \u044E\u0442",
        schema: 31153,
        pol: "Drwina: Pijacki pok\u0142ad",
        bra: "Provoca\xe7\xe3o: Escoc\xeas Exausto",
        hun: "Besz\xf3l\xe1s: Napoz\xf3fed\xe9lzet",
        fre: "Raillerie : En poupe",
        ger: "Verspottung: Locker im Liegestuhl",
        swe: "H\xe5n: D\xe4ckad",
        sch: "\u5632\u8BBD\uFF1A\u70C2\u9189\u5982\u6CE5"
    },
    1700: {
        img: "taunt_time_out_therapy",
        eng: "Taunt: Time Out Therapy",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0426\u0435\u043B\u0435\u0431\u043D\u044B\u0439 \u043F\u0435\u0440\u0435\u0440\u044B\u0432",
        schema: 31154,
        pol: "Drwina: Teufordzki terapeuta",
        bra: "Provoca\xe7\xe3o: Pausa Fora de Hora",
        hun: "Besz\xf3l\xe1s: Pihentet\u0151 ter\xe1pia",
        fre: "Raillerie : Une pause bien m\xe9rit\xe9e",
        ger: "Verspottung: Auszeittherapie",
        swe: "H\xe5n: Soffterapi",
        sch: "\u5632\u8BBD\uFF1A\u6682\u6B47\u7597\u6CD5"
    },
    1701: {
        img: "taunt_rocket_jockey",
        eng: "Taunt: Rocket Jockey",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0420\u0430\u043A\u0435\u0442\u043D\u044B\u0435 \u0441\u043A\u0430\u0447\u043A\u0438",
        schema: 31155,
        pol: "Drwina: Rakietowy d\u017Cokej",
        bra: "Provoca\xe7\xe3o: Fogueteiro Fant\xe1stico",
        hun: "Besz\xf3l\xe1s: Rak\xe9tazsok\xe9",
        fre: "Raillerie : Rod\xe9o sur fus\xe9e",
        swe: "H\xe5n: Raketjockey",
        sch: "\u5632\u8BBD\uFF1A\u706B\u7BAD\u9A91\u5E08"
    },
    1702: {
        img: "taunt_the_boston_boarder",
        eng: "Taunt: The Boston Boarder",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0411\u043E\u0441\u0442\u043E\u043D\u0441\u043A\u0438\u0439 \u0441\u043A\u0435\u0439\u0442\u0431\u043E\u0440\u0434\u0438\u0441\u0442",
        schema: 31156,
        pol: "Drwina: Bosto\u0144ski skejter",
        bra: "Provoca\xe7\xe3o: Charlie Bonk Jr.",
        hun: "Besz\xf3l\xe1s: Bostoni aszfaltbety\xe1r",
        fre: "Raillerie : Le skateur de Boston",
        ger: "Verspottung: Der Boston-Boarder",
        swe: "H\xe5n: Bostonboard",
        sch: "\u5632\u8BBD\uFF1A\u6CE2\u58EB\u987F\u6ED1\u677F"
    },
    1703: {
        img: "taunt_scorchers_solo",
        eng: "Taunt: Scorcher's Solo",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041F\u043B\u0430\u043C\u0435\u043D\u043D\u043E\u0435 \u0441\u043E\u043B\u043E",
        schema: 31157,
        pol: "Drwina: Sol\xf3wka spopielacza",
        bra: "Provoca\xe7\xe3o: Fique Pianinho",
        hun: "Besz\xf3l\xe1s: T\xfczes sz\xf3l\xf3",
        fre: "Raillerie : Solo d'enfer",
        ger: "Verspottung: Schwelendes Solo",
        swe: "H\xe5n: Sk\xe5llande solo",
        sch: "\u5632\u8BBD\uFF1A\u7EB5\u706B\u8005\u7684\u72EC\u594F"
    },
    1704: {
        img: "taunt_texas_truckin",
        eng: "Taunt: Texas Truckin'",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0422\u0435\u0445\u0430\u0441\u0441\u043A\u0438\u0439 \u0442\u0440\u0430\u043A\u0442\u043E\u0440\u0438\u0441\u0442",
        schema: 31160,
        pol: "Drwina: Teksa\u0144ski traktorzysta",
        bra: "Provoca\xe7\xe3o: Tratorzinho do Texas",
        hun: "Besz\xf3l\xe1s: Texasi traktoros",
        fre: "Raillerie : Transport texan",
        ger: "Verspottung: Texas-Traktor",
        swe: "H\xe5n: Texastruck",
        sch: "\u5632\u8BBD\uFF1A\u5F97\u5DDE\u62D6\u62C9\u673A"
    },
    1705: {
        img: "taunt_spin_to_win",
        eng: "Taunt: Spin-to-Win",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041A\u0440\u0443\u0447\u0443-\u0432\u0435\u0440\u0447\u0443",
        schema: 31161,
        pol: "Drwina: Znak zwyci\u0119stwa",
        bra: "Provoca\xe7\xe3o: Dando a Seta",
        hun: "Besz\xf3l\xe1s: Szerencseker\xe9k",
        fre: "Raillerie : Signalisation",
        ger: "Verspottung: Schild schmei\xdfen",
        swe: "H\xe5n: Ingen \xe5terv\xe4ndo",
        sch: "\u5632\u8BBD\uFF1A\u8F6C\u8F6C\u8DEF\u724C"
    },
    1706: {
        img: "taunt_the_fist_bump",
        eng: "Taunt: The Fist Bump",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041A\u0443\u043B\u0430\u0447\u043E\u043A",
        schema: 31162,
        pol: "Drwina: \u017B\xf3\u0142wik",
        bra: "Provoca\xe7\xe3o: Soquinho",
        hun: "Besz\xf3l\xe1s: \xd6k\xf6lpacsi",
        fre: "Raillerie : Check",
        ger: "Verspottung: Fauststo\xdf",
        swe: "H\xe5n: Fist bump"
    },
    1707: {
        img: "manndatory_attire",
        eng: "Manndatory Attire",
        rus: "\u041D\u0435\u043F\u0440\u0435-\u041C\u0430\u043D\u043D\u044B\u0439 \u0430\u0442\u0440\u0438\u0431\u0443\u0442",
        schema: 31184,
        pol: "Pod krawatem",
        hun: "K\xf6telez\u0151 Viselet",
        bra: "Gravata Mann\xedfica",
        fre: "Tenue Manndatoire",
        sch: "\u66FC\u6069\u516C\u53F8\u804C\u5458\u9886\u5E26",
        swe: "Obligatorisk kl\xe4dsel"
    },
    1708: {
        img: "roaming_roman",
        eng: "Roaming Roman",
        rus: "\u0420\u044B\u0441\u043A\u0430\u044E\u0449\u0438\u0439 \u0440\u0438\u043C\u043B\u044F\u043D\u0438\u043D",
        schema: 31198,
        pol: "\u017Bwawy Rzymianin",
        bra: "Centuri\xe3o Errante",
        hun: "Rombol\xf3 R\xf3mai",
        fre: "Romain r\xe9tif",
        sch: "\u7F57\u9A6C\u81EA\u7531\u5BA2",
        swe: "Runtresande romare"
    },
    1709: {
        img: "brim_of_fire",
        eng: "Brim of Fire",
        rus: "\u041F\u043B\u0430\u043C\u0435\u043D\u043D\u044B\u0435 \u043F\u043E\u043B\u044F",
        schema: 31185,
        pol: "Ogniste rondo",
        bra: "Aba Labareda",
        hun: "T\xfczes Karima",
        fre: "Sh\xe9rif flamboyant",
        sch: "\u70C8\u7130\u725B\u4ED4",
        swe: "Brinnbr\xe4tte"
    },
    1710: {
        img: "wild_brim_slouch",
        eng: "Wild Brim Slouch",
        rus: "\u0414\u0438\u043A\u043E\u043F\u043E\u043B\u044B\u0439 \u043B\u0435\u043D\u0442\u044F\u0439",
        schema: 31192,
        pol: "Z\u0119bata zdobycz",
        bra: "Couro do P\xe2ntano",
        hun: "Vadonkalap",
        fre: "Chapeau mou croc-croco",
        sch: "\u5BBD\u6A90\u9CC4\u76AE\u5E3D",
        swe: "Vild slokhatt"
    },
    1711: {
        img: "fried_batter",
        eng: "Fried Batter",
        rus: "\u041A\u0443\u0445\u043E\u043D\u043D\u044B\u0439 \u0431\u043E\u043B\u0442\u0443\u043D",
        schema: 31197,
        pol: "Sma\u017Cony sprinter",
        bra: "Corredor do Caixa",
        hun: "\xdct\u0151s S\xfct\u0151",
        fre: "Batteur frit",
        sch: "\u714E\u70B8\u5927\u53A8",
        swe: "Smetsm\xe4ck"
    },
    1712: {
        img: "reel_fly_hat",
        eng: "Reel Fly Hat",
        rus: "\u0428\u043B\u044F\u043F\u043A\u0430-\u043D\u0430\u0436\u0438\u0432\u043A\u0430",
        schema: 31186,
        pol: "Kapelusz fanatyka",
        bra: "Isca Cocuruta",
        hun: "Pec\xe1skalap",
        fre: "Chap\xeache",
        sch: "\u5706\u6EE1\u6536\u6746\u5E3D",
        swe: "Hatt p\xe5 krok"
    },
    1713: {
        img: "two_punch_mann",
        eng: "Two Punch Mann",
        rus: "\u041C\u0435\u0441\u0442\u044C \u0431\u043E\u043A\u0441\u0451\u0440\u0430",
        schema: 31191,
        pol: "Dwubij",
        bra: "Porta-Luvas de Boxe",
        hun: "Dupl\xe1n \xdct\u0151s",
        fre: "Caboxe",
        sch: "\u4E8C\u62F3\u8D85\u4EBA"
    },
    1714: {
        img: "hook_line_and_cinder",
        eng: "Hook, Line, and Cinder",
        rus: "\u041F\u043E\u0434\u0436\u0430\u0440\u044B\u0439 \u043F\u043E\u043F\u043B\u0430\u0432\u043E\u043A",
        schema: 31187,
        pol: "Haczyk, \u017Cy\u0142ka i popi\xf3\u0142",
        bra: "Vai Pesc\xe1",
        hun: "Kifogta, Hazavitte, Megs\xfct\xf6tte",
        fre: "Grillades de poisson",
        sch: "\u653E\u957F\u7EBF\u9493\u70E4\u9C7C",
        swe: "Grillad fisk"
    },
    1715: {
        img: "thousand_yard_stare",
        eng: "Thousand-Yard Stare",
        rus: "\u0412\u0437\u0433\u043B\u044F\u0434 \u043D\u0430 \u0442\u044B\u0441\u044F\u0447\u0443 \u044F\u0440\u0434\u043E\u0432",
        schema: 31200,
        pol: "Wojenny wytrzeszcz",
        bra: "Olho no Olho",
        hun: "T\xe1gra Ny\xedlt Szemek",
        fre: "Regard exorbit\xe9",
        sch: "\u5343\u7801\u51DD\u89C6",
        swe: "Tom i blick"
    },
    1716: {
        img: "snack_stack",
        eng: "Snack Stack",
        rus: "\u0411\u0443\u0442\u0435\u0440\u0431\u0430\u0448\u043D\u044F",
        schema: 31190,
        pol: "Sterta smako\u0142yk\xf3w",
        bra: "Pilha de Sandviches",
        hun: "Harapnival\xf3 Halom",
        fre: "Crane-croute",
        sch: "\u5C42\u5C42\u7F8E\u5473",
        swe: "Mellanm\xe5lstorn"
    },
    1717: {
        img: "crocodile_dandy",
        eng: "Crocodile Dandy",
        rus: "\u041A\u0440\u043E\u043A\u043E\u0434\u0438\u043B-\u0434\u0435\u043D\u0434\u0438",
        schema: 31193,
        pol: "Krokodyl dandys",
        bra: "Crocodilo D\xe2ndi",
        hun: "Krokodilos Piperk\u0151c",
        fre: "Costume croco",
        sch: "\u9CC4\u9C7C\u4E39\u8FEA",
        swe: "Krokodildandy"
    },
    1718: {
        img: "meal_dealer",
        eng: "Meal Dealer",
        rus: "\u0421\u0442\u0440\u0435\u043C\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u0440\u043C\u0438\u0442\u0435\u043B\u044C",
        schema: 31196,
        pol: "Sprzedawca smakowito\u015Bci",
        bra: "Atendente de Lanchonete",
        hun: "\xc9telfut\xe1r",
        fre: "Serveur ultrarapide",
        sch: "\u901F\u98DF\u4E13\u8425",
        swe: "Snabbservering"
    },
    1719: {
        img: "water_waders",
        eng: "Water Waders",
        rus: "\u0423\u0431\u0440\u0430\u043D\u0441\u0442\u0432\u043E \u0443\u0434\u0438\u043B\u044C\u0449\u0438\u043A\u0430",
        schema: 31188,
        pol: "Wodne wdzianko",
        bra: "Pesca \xe0 Prova d'\xc1gua",
        hun: "G\xe1zl\xf3nadr\xe1g",
        fre: "Salopette de p\xeache",
        sch: "\u6E14\u5BB6\u6D89\u6C34\u670D",
        swe: "Vadare"
    },
    1720: {
        img: "the_sightliner",
        eng: "The Sightliner",
        rus: "\u041F\u0440\u0438\u0446\u0435\u043B\u043E\u0432\u0438\u0437\u043E\u0440",
        schema: 31189,
        pol: "Dzia\u0142kowizor",
        hun: "C\xe9lbam\xe9r\u0151",
        bra: "Os Sentinolhos",
        fre: "Technobinocles",
        sch: "\u5934\u6234\u5F0F\u6B65\u54E8\u67AA",
        swe: "Siktlinjen"
    },
    1721: {
        img: "the_panisher",
        eng: "The Panisher",
        rus: "\u041F\u0440\u0438\u0433\u043E\u0440\u0430\u0442\u0435\u043B\u044C",
        schema: 31199,
        pol: "Patelniowy pogromca",
        bra: "O Frigideiro",
        hun: "A Serpeny\xedt\u0151",
        fre: "Po\xealeur",
        sch: "\u9876\u9505\u4FA0",
        swe: "Stekarn"
    },
    1722: {
        img: "fast_food",
        eng: "Fast Food",
        rus: "\u0411\u044B\u0441\u0442\u0440\u044B\u0439 \u043F\u0435\u0440\u0435\u043A\u0443\u0441",
        schema: 31195,
        pol: "Szybka szama",
        bra: "Entrega R\xe1pida",
        hun: "Gyorskaja",
        fre: "Pr\xeat-\xe0-manger",
        sch: "\u5FEB\u9910\u7279\u9012",
        swe: "Snabbmat"
    },
    1723: {
        img: "crustaceous_cowl",
        eng: "Crustaceous Cowl",
        rus: "\u041A\u0440\u0430\u0431\u043E\u0432\u044B\u0439 \u043A\u0430\u043F\u044E\u0448\u043E\u043D",
        schema: 31194,
        pol: "Krabowy kaptur",
        bra: "Capuz Crust\xe1ceo",
        hun: "R\xe1k\xe1mzsa",
        fre: "Capuchon crustac\xe9",
        sch: "\u95F4\u8C0D\u87F9\u515C\u5E3D",
        swe: "Kr\xe4ftk\xe5pa"
    },
    1724: {
        img: "ballooniphones",
        eng: "Ballooniphones",
        rus: "\u041D\u0430\u0434\u0443\u0432\u043D\u0430\u0443\u0448\u043D\u0438\u043A\u0438",
        schema: 31183,
        pol: "Balonofonia",
        bra: "Bal\xe3onifones",
        hun: "Lufif\xfcles",
        fre: "Balliphones",
        sch: "\u6C14\u7403\u72EC\u89D2\u517D\u8033\u673A",
        swe: "Ballonglurar"
    },
    1725: {
        img: "beanie_the_all_gnawing",
        eng: "Beanie The All-Gnawing",
        rus: "\u0412\u0441\u0435\u043F\u043E\u0433\u043B\u043E\u0449\u0430\u044E\u0449\u0430\u044F \u0448\u0430\u043F\u043A\u0430",
        schema: 31212,
        pol: "Wszechjedz\u0105ce beanie",
        hun: "Mindentr\xe1g\xf3 Sapi",
        swe: "Beanie, den evigt gnagande",
        bra: "Gorronzo, o Atormentador",
        fre: "Bonnet rongeur de savoir",
        sch: "\u9876\u4E0A\u5DE8\u53E3"
    },
    1726: {
        img: "death_stare",
        eng: "Death Stare",
        rus: "\u0423\u0431\u0438\u0439\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u0432\u0437\u0433\u043B\u044F\u0434",
        schema: 31225,
        pol: "\u015Amiertelne spojrzenie",
        bra: "Olho Gordo",
        hun: "Hal\xe1los Pillant\xe1s",
        swe: "D\xf6dens blick",
        fre: "Cr\xe2ne borgne",
        sch: "\u6B7B\u4EA1\u51DD\u89C6"
    },
    1727: {
        img: "hat_outta_hell",
        eng: "Hat Outta Hell",
        rus: "\u041F\u0440\u0438\u043A\u0438\u0434 \u0438\u0437 \u0430\u0434\u0430",
        schema: 31216,
        pol: "Czorcia czapka",
        hun: "Pokolsityak",
        swe: "Dj\xe4vulskepa",
        bra: "Bon\xe9 do Belzebu",
        fre: "Casque des enfers",
        sch: "\u6050\u6016\u9AB8\u51A0"
    },
    1728: {
        img: "the_scariest_mask_ever",
        eng: "The Scariest Mask EVER",
        rus: "\u0421\u0410\u041C\u0410\u042F \u0436\u0443\u0442\u043A\u0430\u044F \u043C\u0430\u0441\u043A\u0430",
        schema: 31219,
        pol: "Najstraszniejsza maska JAKA ISTNIEJE",
        hun: "A LEGESlegf\xe9lelmetesebb \xc1larc",
        swe: "L\xe4skigaste masken N\xc5GONSIN",
        bra: "A M\xe1scara Mais Assustadora de TODAS",
        fre: "Griboutrouille",
        sch: "\u53F2\u4E0A\u6700\u51F6\u6076\u9762\u5177"
    },
    1729: {
        img: "twisted_topper",
        eng: "Twisted Topper",
        rus: "\u0417\u0430\u043A\u0440\u0443\u0447\u0435\u043D\u043D\u044B\u0439 \u0446\u0438\u043B\u0438\u043D\u0434\u0440",
        schema: 31211,
        pol: "Pokr\u0119cony cylinder",
        hun: "Cs\xedkos Cilinder",
        swe: "Tjusig tigerhatt",
        bra: "Cartola Corrompida",
        fre: "Haut-de-forme haut en terreur",
        sch: "\u602A\u90AA\u793C\u5E3D"
    },
    1730: {
        img: "creepy_crawlers",
        eng: "Creepy Crawlers",
        rus: "\u041F\u043E\u043B\u0437\u0443\u0447\u0438\u0435 \u043F\u0430\u043A\u043E\u0441\u0442\u043D\u0438\u043A\u0438",
        schema: 31208,
        pol: "Przera\u017Caj\u0105ce pe\u0142zaki",
        hun: "R\xe9ms\xe9ges P\xf3kok",
        swe: "Kr\xe4lande kryp",
        bra: "Aranhas Arrepiantes",
        fre: "Araign\xe9es abominables",
        sch: "\u6218\u6817\u86DB\u7FA4"
    },
    1731: {
        img: "spooky_head_bouncers",
        eng: "Spooky Head-Bouncers",
        rus: "\u0416\u0443\u0442\u043A\u0438\u0435 \u0430\u043D\u0442\u0435\u043D\u043D\u043E\u0447\u043A\u0438",
        schema: 31209,
        pol: "Przera\u017Caj\u0105ce podskakiwacze",
        hun: "Ijeszt\u0151 Fejenrezg\u0151k",
        swe: "L\xe4skiga antenner",
        bra: "Tiara Tenebrosa",
        fre: "Ricoche-t\xeates effrayants",
        sch: "\u9B54\u7269\u5F39\u5F39\u4E50"
    },
    1732: {
        img: "tricksters_treats",
        eng: "Trickster's Treats",
        rus: "\u041F\u043E\u043E\u0449\u0440\u0435\u043D\u0438\u044F \u043F\u0440\u043E\u0439\u0434\u043E\u0445\u0438",
        schema: 31220,
        pol: "S\u0142odko\u015Bci szachraja",
        bra: "Gostosuras do Travesso",
        hun: "A Rosszcsont \xc9dess\xe9ge",
        swe: "Busens godis",
        fre: "Bonbons ensorcel\xe9s",
        sch: "\u6363\u86CB\u9B3C\u7684\u751C\u54C1"
    },
    1733: {
        img: "the_corpse_carrier",
        eng: "The Corpse Carrier",
        rus: "\u0422\u0440\u0443\u043F\u043E\u043D\u043E\u0441\u0435\u0446",
        schema: 31226,
        pol: "Tragarz zw\u0142ok",
        bra: "Carregador de Corpos",
        hun: "Hullahordoz\xf3",
        swe: "Likbud",
        fre: "\xc0 d\xe9carcasser",
        sch: "\u643A\u4F34\u800C\u884C"
    },
    1734: {
        img: "smiling_somen",
        eng: "Smiling Somen",
        rus: "\u0423\u0441\u043C\u0435\u0448\u043B\u0438\u0432\u044B\u0439 \u0441\u043E\u043C\u044D\u043D",
        schema: 31222,
        pol: "\u015Amieszkuj\u0105cy s\u014Dmen",
        hun: "Vigyorg\xf3 Somen",
        swe: "Grymolle",
        bra: "Somen Sorridente",
        fre: "Dr\xf4le de d\xe9mon",
        sch: "\u55E4\u7B11\u6076\u9B3C"
    },
    1735: {
        img: "second_head_headwear",
        eng: "Second-Head Headwear",
        rus: "\u0413\u043E\u043B\u043E\u0432\u043D\u043E\u0439 \u0433\u043E\u043B\u043E\u0432\u043D\u043E\u0439 \u0443\u0431\u043E\u0440",
        schema: 31214,
        pol: "Co dwie g\u0142owy, to nie jedna",
        bra: "Chap\xe9u em Segunda Cabe\xe7a",
        hun: "Fejfed\u0151 M\xe1sodfejt\u0151l",
        swe: "Andrahuvuds huvudbonad",
        fre: "Chapeau pour deuxi\xe8me melon",
        sch: "\u4E8C\u9996\u5934\u9970"
    },
    1736: {
        img: "eyequarium",
        eng: "Eyequarium",
        rus: "\u041E\u043A\u043E\u0432\u0430\u0440\u0438\u0443\u043C",
        schema: 31213,
        pol: "Okwarium",
        hun: "Szemnedves\xedt\u0151",
        swe: "\xd6gonfuktare",
        bra: "Aquarolho",
        fre: "Aquar\u0153il",
        sch: "\u773C\u4E2D\u6C34\u4E16\u754C"
    },
    1737: {
        img: "goalkeeper",
        eng: "Goalkeeper",
        rus: "\u0412\u0440\u0430\u0442\u0430\u0440\u044C",
        schema: 31217,
        pol: "Bramkarz",
        hun: "Kapus",
        swe: "M\xe5lvakt",
        bra: "Goleiro do Gelo",
        fre: "Num\xe9ro 13",
        sch: "\u5B88\u95E8\u4EBA"
    },
    1738: {
        img: "alakablamicon",
        eng: "Alakablamicon",
        rus: "\u041A\u043E\u043B\u0434\u0443\u043D\u043E\u043C\u0438\u043A\u043E\u043D",
        schema: 31215,
        pol: "Abrakabumicon",
        hun: "Bummbanomicon",
        sch: "\u70B8\u5F39\u9B54\u5E3D"
    },
    1739: {
        img: "the_hook_line_and_thinker",
        eng: "The Hook, Line, and Thinker",
        rus: "\u0423\u043B\u043E\u0432 \u043C\u043E\u0437\u0433\u043E\u0432",
        schema: 31223,
        pol: "Pomys\u0142owy po\u0142\xf3w",
        hun: "Megakasztott Agyal\xe1s",
        swe: "Fiskarens olycka",
        bra: "Pesque e Pense",
        fre: "La prise de t\xeate",
        sch: "\u611A\u8005\u4E0A\u94A9"
    },
    1740: {
        img: "optic_nerve",
        eng: "Optic Nerve",
        rus: "\u0417\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043D\u0435\u0440\u0432",
        schema: 31224,
        pol: "Nerw wzrokowy",
        hun: "L\xe1t\xf3ideg",
        swe: "Synnerv",
        bra: "Nervo \xd3ptico",
        fre: "Nerf optique",
        sch: "\u4EBA\u5DE5\u89C6\u89C9\u8111"
    },
    1741: {
        img: "gruesome_gourd",
        eng: "Gruesome Gourd",
        rus: "\u0422\u044B\u043A\u0432\u0435\u043D\u043D\u044B\u0439 \u0442\u0438\u0440\u0430\u043D",
        schema: 31227,
        pol: "Gustowna gurda",
        hun: "Irt\xf3zatos T\xf6kfej",
        swe: "Pampig pumpamask",
        bra: "Caba\xe7a do Carrasco",
        fre: "Courge cauchemardesque",
        sch: "\u74DC\u9762\u60CA\u9B42"
    },
    1742: {
        img: "the_bone_cone",
        eng: "The Bone Cone",
        rus: "\u041A\u043E\u0441\u0442\u044F\u043D\u043E\u0439 \u043A\u043E\u043B\u043F\u0430\u043A",
        schema: 31218,
        pol: "Sto\u017Cek ko\u015Bci",
        hun: "Csontk\xfap",
        swe: "Benstrut",
        bra: "Cone \xd3sseo",
        fre: "Chapeau de sossier",
        sch: "\u767D\u9AA8\u5DEB\u5E08\u5E3D"
    },
    1743: {
        img: "wandering_wraith",
        eng: "Wandering Wraith",
        rus: "\u041F\u043B\u0443\u0442\u0430\u044E\u0449\u0438\u0439 \u043F\u0440\u0438\u0437\u0440\u0430\u043A",
        schema: 31221,
        pol: "W\u0119druj\u0105ce widmo",
        hun: "L\xe1ngol\xf3 Lid\xe9rc",
        swe: "Vandrande v\xe5lnad",
        bra: "Apari\xe7\xe3o Ardente",
        fre: "Cr\xe2ne cornu",
        sch: "\u5E7D\u7130\u4EA1\u9AA8"
    },
    1744: {
        img: "towering_patch_of_pumpkins",
        eng: "Towering Patch of Pumpkins",
        rus: "\u0413\u0438\u0433\u0430\u043D\u0442\u0441\u043A\u0430\u044F \u0431\u0430\u0448\u043D\u044F \u0438\u0437 \u0442\u044B\u043A\u0432",
        schema: 31210,
        pol: "Niebotyczny s\u0142up dy\u0144",
        hun: "Magasan Tornyosul\xf3 T\xf6k\xf6k",
        swe: "Reslig pumpapelare",
        bra: "Pilha Monumental de Ab\xf3boras",
        fre: "Haut comme trois citrouilles",
        sch: "\u5C42\u53E0\u9AD8\u8038\u7684\u5357\u74DC\u58F3"
    },
    1745: {
        img: "poopy_doe",
        eng: "Poopy Doe",
        rus: "\u041F\u0440\u043E\u0441\u0442\u043E\u0444\u0438\u043B\u044F \u0414\u043E\u0443",
        schema: 31228,
        sch: "\u7834\u7A7A\u98DE\u733F"
    },
    1746: {
        img: "batters_beak",
        eng: "Batter's Beak",
        rus: "\u041F\u0435\u0440\u043D\u0430\u0442\u044B\u0439 \u043F\u0438\u0442\u0447\u0435\u0440",
        schema: 31229,
        pol: "Pierzasty pa\u0142karz",
        hun: "Cs\u0151r\xf6s \xdct\u0151s",
        swe: "Flink fink",
        bra: "Bico de Atleta",
        fre: "Bec du baseballeur",
        sch: "\u68D2\u7403\u8001\u9E1F"
    },
    1747: {
        img: "war_dog",
        eng: "War Dog",
        rus: "\u041F\u0451\u0441 \u0432\u043E\u0439\u043D\u044B",
        schema: 31230,
        pol: "Pies wojny",
        hun: "Harci Kutya",
        swe: "Stridshund",
        bra: "C\xe3o de Guerra",
        fre: "Chien de guerre",
        sch: "\u7586\u573A\u8001\u72D7"
    },
    1748: {
        img: "miami_rooster",
        eng: "The Miami Rooster",
        rus: "\u041C\u0430\u0439\u0430\u043C\u0441\u043A\u0438\u0439 \u043F\u0435\u0442\u0443\u0448\u043E\u043A",
        schema: 31231,
        pol: "Kogut z Miami",
        bra: "Galo de Miami",
        fre: "Coq de Miami",
        hun: "Miami Kakas",
        swe: "Miamituppen",
        sch: "\u8FC8\u57CE\u51F6\u79BD"
    },
    1749: {
        img: "computron_5000",
        eng: "Computron 5000",
        rus: "\u041A\u043E\u043C\u043F\u044C\u044E\u0442\u0440\u043E\u043D 5000",
        schema: 31232,
        pol: "Komputron 5000",
        fre: "Robespion 5000",
        sch: "\u6F14\u7B97\u673A\u4F53 5000"
    },
    1750: {
        img: "sarsparilla_sprayed_war_paint",
        eng: "Sarsparilla Sprayed War Paint",
        rus: '"\u0413\u0430\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u0433\u0440\u0430\u0444\u0444\u0438\u0442\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17284,
        pol: "\u015Amiechu warte Barwy wojenne",
        hun: "Sarsaparilla-mint\xe1s Harci fest\xe9s",
        swe: "Sarsaparillasprejad Krigsf\xe4rg",
        bra: "| Salsaparrilhado | Tinta de Guerra",
        fre: "Salsepareille Peinture de guerre"
    },
    1751: {
        img: "kiln_conquer_war_paint",
        eng: "Kiln & Conquer War Paint",
        rus: '"\u041F\u0435\u0447\u043D\u044B\u0435 \u043C\u0443\u043A\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17296,
        pol: "Pali\u0107 i podbija\u0107 Barwy wojenne",
        hun: "\xd6lj \xe9s h\xf3d\xedts Harci fest\xe9s",
        bra: "| Assar e Conquistar | Tinta de Guerra",
        fre: "Conqu\xeate \xe0 chaud Peinture de guerre",
        swe: "Br\xe4nna och er\xf6vra Krigsf\xe4rg"
    },
    1752: {
        img: "searing_souls_war_paint",
        eng: "Searing Souls War Paint",
        rus: '"\u0413\u043E\u0440\u044F\u0449\u0438\u0435 \u0434\u0443\u0448\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17293,
        pol: "P\u0142on\u0105ce dusze Barwy wojenne",
        hun: "L\xe1ngol\xf3 Lelkek Harci fest\xe9s",
        bra: "| Almas Agonizantes | Tinta de Guerra",
        fre: "\xc2mes ardentes Peinture de guerre",
        swe: "Brinnande sj\xe4lar Krigsf\xe4rg"
    },
    1753: {
        img: "potent_poison_war_paint",
        eng: "Potent Poison War Paint",
        rus: '"\u042F\u0434\u0440\u0451\u043D\u044B\u0439 \u044F\u0434" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17292,
        pol: "Silna trucizna Barwy wojenne",
        hun: "Hat\xe1sos m\xe9reg Harci fest\xe9s",
        bra: "| Caldeir\xe3o Borbulhante | Tinta de Guerra",
        fre: "Poison puissant Peinture de guerre",
        swe: "Starkt gift Krigsf\xe4rg"
    },
    1754: {
        img: "simple_spirits_war_paint",
        eng: "Simple Spirits War Paint",
        rus: '"\u041F\u0440\u043E\u0441\u0442\u044B\u0435 \u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u0438\u044F" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17290,
        pol: "Drobne duszki Barwy wojenne",
        hun: "Egyszer\u0171en szellemes Harci fest\xe9s",
        bra: "| Fantasminhas | Tinta de Guerra",
        fre: "Petits esprits Peinture de guerre",
        swe: "Simpla sp\xf6ken Krigsf\xe4rg",
        sch: "\u5C0F\u9B3C\u5F53\u5BB6 \u6218\u7ED8"
    },
    1755: {
        img: "skull_cracked_war_paint",
        eng: "Skull Cracked War Paint",
        rus: '"\u0425\u0440\u0443\u0441\u0442 \u0447\u0435\u0440\u0435\u043F\u043E\u0432" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17286,
        pol: "Sp\u0119kane czaszki Barwy wojenne",
        hun: "Koponyarepeszt\u0151 Harci fest\xe9s",
        bra: "| Cr\xe2nios Quebrados | Tinta de Guerra",
        fre: "Cr\xe2nes f\xeal\xe9s Peinture de guerre",
        swe: "Skallspr\xe4ckare Krigsf\xe4rg",
        sch: "\u7834\u788E\u5934\u9AA8 \u6218\u7ED8"
    },
    1756: {
        img: "necromanced_war_paint",
        eng: "Necromanced War Paint",
        rus: '"\u041D\u0435\u0436\u0438\u0442\u044C" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17297,
        pol: "Nekromancja Barwy wojenne",
        hun: "Fel\xe9lesztve Harci fest\xe9s",
        bra: "| Necromante | Tinta de Guerra",
        fre: "N\xe9cromancie Peinture de guerre",
        swe: "Nekromantad Krigsf\xe4rg"
    },
    1757: {
        img: "polter_guised_war_paint",
        eng: "Polter-Guised War Paint",
        rus: '"\u041F\u043E\u043A\u0440\u043E\u0432 \u043F\u043E\u043B\u0442\u0435\u0440\u0433\u0435\u0439\u0441\u0442\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17295,
        pol: "Cierpi\u0105ce dusze Barwy wojenne",
        hun: "K\xeds\xe9rteties k\xfcls\u0151 Harci fest\xe9s",
        bra: "| Paranormal | Tinta de Guerra",
        fre: "Apparition Peinture de guerre",
        swe: "Begeistrad Krigsf\xe4rg"
    },
    1758: {
        img: "neon_ween_war_paint",
        eng: "Neon-ween War Paint",
        rus: '"\u041D\u0435\u043E\u043D\u043E\u0443\u0438\u043D" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17289,
        pol: "Neonween Barwy wojenne",
        hun: "Neon-ween Harci fest\xe9s",
        bra: "| Travessuras de Neon | Tinta de Guerra",
        fre: "N\xe9onween Peinture de guerre",
        swe: "Neonween Krigsf\xe4rg",
        sch: "\u4E07\u5723\u9713\u8679 \u6218\u7ED8"
    },
    1759: {
        img: "swashbuckled_war_paint",
        eng: "Swashbuckled War Paint",
        rus: '"\u041A\u043E\u043D\u0442\u0440\u0430\u0431\u0430\u043D\u0434\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17285,
        pol: "Pirat Barwy wojenne",
        hun: "Kal\xf3zos Harci fest\xe9s",
        bra: "| Pirata | Tinta de Guerra",
        fre: "Flibuste Peinture de guerre",
        swe: "Buckanj\xe4rad Krigsf\xe4rg",
        sch: "\u4EA1\u547D\u4E4B\u5F92 \u6218\u7ED8"
    },
    1760: {
        img: "broken_bones_war_paint",
        eng: "Broken Bones War Paint",
        rus: '"\u041A\u043E\u0441\u0442\u0438 \u0432 \u043A\u0440\u043E\u0448\u043A\u0443" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17291,
        pol: "Po\u0142amane ko\u015Bci Barwy wojenne",
        hun: "T\xf6r\xf6tt csontok Harci fest\xe9s",
        bra: "| Quebra-Ossos | Tinta de Guerra",
        fre: "Os broy\xe9s Peinture de guerre",
        swe: "Brutna ben Krigsf\xe4rg",
        sch: "\u788E\u9AA8\u904D\u5730 \u6218\u7ED8"
    },
    1761: {
        img: "party_phantoms_war_paint",
        eng: "Party Phantoms War Paint",
        rus: '"\u0414\u0438\u0441\u043A\u043E\u0442\u0435\u043A\u0430 \u0434\u0443\u0445\u043E\u0432" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17294,
        pol: "Imprezowe upiory Barwy wojenne",
        hun: "Bulifantomok Harci fest\xe9s",
        bra: "| Fantasmas Festeiros | Tinta de Guerra",
        fre: "Fant\xf4mes f\xeatards Peinture de guerre",
        swe: "Partyfantomer Krigsf\xe4rg"
    },
    1762: {
        img: "misfortunate_war_paint",
        eng: "Misfortunate War Paint",
        rus: '"\u041D\u0435\u0443\u0434\u0430\u0447\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17287,
        pol: "Nieszcz\u0119\u015Bcie Barwy wojenne",
        hun: "Szerencs\xe9tlen Harci fest\xe9s",
        bra: "| Desafortunado | Tinta de Guerra",
        fre: "Colvert Peinture de guerre",
        swe: "Otursben\xe4gen Krigsf\xe4rg",
        sch: "\u5384\u8FD0\u5F53\u5934 \u6218\u7ED8"
    },
    1763: {
        img: "taunt_the_drunken_sailor",
        eng: "Taunt: The Drunken Sailor",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041F\u044C\u044F\u043D\u044B\u0439 \u043C\u043E\u0440\u044F\u043A",
        schema: 31201,
        pol: "Drwina: Pijany \u017Ceglarz",
        hun: "Besz\xf3l\xe1s: A r\xe9szeg tenger\xe9sz",
        swe: "H\xe5n: Den berusade matrosen",
        bra: "Provoca\xe7\xe3o: O Marinheiro B\xeabado",
        fre: "Raillerie : Marin ivre"
    },
    1764: {
        img: "taunt_the_profane_puppeteer",
        eng: "Taunt: The Profane Puppeteer",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041A\u043E\u0449\u0443\u043D\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u043A\u0443\u043A\u043B\u043E\u0432\u043E\u0434",
        schema: 31202,
        pol: "Drwina: Pyskaty pacynkarz",
        hun: "Besz\xf3l\xe1s: A borzaszt\xf3 b\xe1bos",
        bra: "Provoca\xe7\xe3o: O General de Pano",
        fre: "Raillerie : Marionnettiste grossier",
        swe: "H\xe5n: Plump buktalare"
    },
    1765: {
        img: "taunt_the_mannbulance",
        eng: "Taunt: The Mannbulance!",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041C\u0430\u043D\u043D\u0438\u0442\u0430\u0440!",
        schema: 31203,
        pol: "Drwina: Mannbulans!",
        hun: "Besz\xf3l\xe1s: A Mannt\u0151aut\xf3!",
        bra: "Provoca\xe7\xe3o: A Mannbul\xe2ncia!",
        fre: "Raillerie : Mannbulance !",
        swe: "H\xe5n: Mannbulansen!"
    },
    1766: {
        img: "taunt_bare_knuckle_beatdown",
        eng: "Taunt: Bare Knuckle Beatdown",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041A\u0443\u043B\u0430\u0447\u043D\u043E\u0435 \u043A\u043E\u043B\u043E\u0442\u0438\u043B\u043E\u0432\u043E",
        schema: 31207,
        pol: "Drwina: Srogi \u0142omot",
        hun: "Beszl\xe1s: Pusztakezes lez\xfaz\xe1s",
        bra: "Provoca\xe7\xe3o: Batedor de Moscou",
        fre: "Raillerie : Boxon du boxeur",
        swe: "H\xe5n: Knytn\xe4vsknockout"
    },
    1767: {
        img: "taunt_the_homerunners_hobby",
        eng: "Taunt: The Homerunner's Hobby",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0411\u0435\u0437\u0434\u0435\u043B\u044C\u0435 \u0431\u0435\u0433\u0443\u043D\u0430",
        schema: 31233,
        pol: "Drwina: Hobby ch\u0142ystka",
        hun: "Besz\xf3l\xe1s: A hazafut\xf3 hobbija",
        bra: "Provoca\xe7\xe3o: Passatempo do Batedor",
        fre: "Raillerie : un coup de batte et basta",
        swe: "H\xe5n: Springpojkens hobby",
        sch: "\u5632\u8BBD\uFF1A\u60EC\u610F\u65F6\u5149"
    },
    1768: {
        img: "festive_cover_up",
        eng: "Festive Cover-Up",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u043E\u0435 \u043F\u0440\u0438\u043A\u0440\u044B\u0442\u0438\u0435",
        schema: 31257,
        pol: "\u015Awi\u0105teczna przykrywka",
        hun: "\xdcnnepi Fed\xe9s",
        bra: "Fachada Festiva",
        fre: "Accoutrement abi\xe9tin",
        swe: "Grann t\xe4ckmantel",
        sch: "\u8282\u65E5\u4EFF\u751F\u6811"
    },
    1769: {
        img: "el_fiestibrero",
        eng: "El Fiestibrero",
        rus: "\u042D\u043B\u044C \u0444\u0438\u0435\u0441\u0442\u0431\u0440\u0435\u0440\u0440\u043E",
        schema: 31241,
        sch: "\u5609\u5E74\u534E\u72C2\u6B22\u5E3D"
    },
    1770: {
        img: "ominous_offering",
        eng: "Ominous Offering",
        rus: "\u0421\u043E\u043C\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0441\u044E\u0440\u043F\u0440\u0438\u0437",
        schema: 31251,
        pol: "Podejrzany prezent",
        bra: "Oferenda Obscura",
        hun: "Aljas Aj\xe1nd\xe9k",
        fre: "Cadeau sinistre",
        swe: "G\xe5tfull g\xe5va",
        sch: "\u8BE1\u5F02\u5C0F\u73A9\u610F"
    },
    1771: {
        img: "brain_cane",
        eng: "Brain Cane",
        rus: "\u041C\u043E\u0437\u0433\u043E\u0432\u0430\u044F \u0442\u0440\u043E\u0441\u0442\u044C",
        schema: 31248,
        pol: "Laska m\xf3zgowa",
        hun: "Agysz\xfar\xe1s",
        bra: "Apunhalada A\xe7ucarada",
        fre: "Sucre d'organe",
        swe: "Hj\xe4rnpolka",
        sch: "\u7A7F\u9885\u7CD6\u68CD"
    },
    1772: {
        img: "cozy_catchers",
        eng: "Cozy Catchers",
        rus: "\u0423\u044E\u0442\u043D\u044B\u0439 \u0443\u043B\u043E\u0432\u0438\u0442\u0435\u043B\u044C",
        schema: 31250,
        pol: "Lodowate \u0142apacze",
        hun: "H\xf3goly\xf3fog\xf3",
        bra: "Pegadores Aconchegantes",
        fre: "Boule moufle",
        swe: "Sn\xf6f\xe5ngare",
        sch: "\u96EA\u7403\u6355\u624B"
    },
    1773: {
        img: "the_giftcrafter",
        eng: "The Giftcrafter",
        rus: "\u041F\u043E\u0434\u0430\u0440\u043E\u0447\u043D\u044B\u0439 \u043C\u0430\u0441\u0442\u0435\u0440",
        schema: 31246,
        pol: "Pakowacz prezent\xf3w",
        hun: "Aj\xe1nd\xe9kcsin\xe1l\xf3",
        bra: "O Artes\xe3o Agasalhado",
        fre: "Chapeau lutin",
        swe: "Presenttillverkare",
        sch: "\u793C\u7269\u5305\u88C5\u5DE5"
    },
    1774: {
        img: "festive_frames",
        eng: "Festive Frames",
        rus: "\u041E\u0442\u0440\u0430\u0434\u043D\u0430\u044F \u043E\u043F\u0440\u0430\u0432\u0430",
        schema: 31252,
        pol: "Bo\u017Conarodzeniowe bryle",
        bra: "\xd3culos Ornamentais",
        hun: "Kar\xe1csonyi Keret",
        fre: "Binocles enguirland\xe9s",
        swe: "Festliga b\xe5gar",
        sch: "\u5F69\u706F\u773C\u955C\u6846"
    },
    1775: {
        img: "mooshanka",
        eng: "Mooshanka",
        rus: "\u0421\u043E\u0445\u0430\u0442\u0430\u044F \u0443\u0448\u0430\u043D\u043A\u0430",
        schema: 31255,
        pol: "Karibuszanka",
        hun: "Holds\xe1nka",
        bra: "Ushankalce",
        fre: "Beuhshanka",
        swe: "Muushanka",
        sch: "\u9A7C\u9E7F\u6BDB\u76AE\u5E3D"
    },
    1776: {
        img: "elf_defense",
        eng: "Elf Defense",
        rus: "\u042D\u043B\u044C\u0444\u043E\u043E\u0431\u043E\u0440\u043E\u043D\u0430",
        schema: 31256,
        pol: "Elfia obrona",
        hun: "Man\xf3v\xe9delem",
        bra: "Protetor do Polo Norte",
        fre: "Delfense",
        swe: "Tomtelycka",
        sch: "\u7CBE\u7075\u963B\u51FB\u5175"
    },
    1777: {
        img: "gnome_dome",
        eng: "Gnome Dome",
        rus: "\u0413\u043D\u043E\u043C\u0438\u0439 \u0443\u0431\u043E\u0440",
        schema: 31242,
        pol: "Kartonowy krasnal",
        bra: "Natal Artesanal",
        hun: "T\xf6rpfed\xe9l",
        fre: "Gnome de No\xebl",
        swe: "Nisseluva"
    },
    1778: {
        img: "elf_made_bandanna",
        eng: "Elf-Made Bandanna",
        rus: "\u042D\u043B\u044C\u0444\u043E\u0434\u0435\u043B\u044C\u043D\u0430\u044F \u0431\u0430\u043D\u0434\u0430\u043D\u043D\u0430",
        schema: 31260,
        pol: "Wyelfiona bandana",
        hun: "Man\xf3 Kend\u0151",
        bra: "Bandana \xc9lfica",
        fre: "Bandana elfique",
        swe: "Nissens snusn\xe4sduk",
        sch: "\u7EAF\u624B\u5DE5\u7CBE\u7075\u9762\u7F69"
    },
    1779: {
        img: "seasonal_spring",
        eng: "Seasonal Spring",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u0430\u044F \u043F\u0440\u0443\u0436\u0438\u043D\u0430",
        schema: 31244,
        pol: "Sezonowy skoczek",
        hun: "Feltekert Fejfeny\u0151",
        bra: "Espiral de Natal",
        fre: "Spirale sapin",
        swe: "Julfj\xe4der",
        sch: "\u8282\u65E5\u8E66\u8E66\u661F"
    },
    1780: {
        img: "elf_ignition",
        eng: "Elf Ignition",
        rus: "\u042D\u043B\u044C\u0444\u043E\u0432\u043E\u0437\u0433\u043E\u0440\u0430\u043D\u0438\u0435",
        schema: 31253,
        pol: "Elfia po\u017Coga",
        hun: "Man\xf3gy\xfajt\xe1s",
        bra: "Igni\xe7\xe3o Elfervescente",
        fre: "Pyrelfe",
        swe: "Jult\xe4ndning",
        sch: "\u81EA\u71C3\u7CBE\u7075"
    },
    1781: {
        img: "train_of_thought",
        eng: "Train of Thought",
        rus: "\u0413\u043B\u0430\u0432\u044D\u043A\u0441\u043F\u0440\u0435\u0441\u0441",
        schema: 31254,
        pol: "Tor my\u015Blenia",
        hun: "Mozdonyg\xe9p\xe9sz",
        bra: "Fumacinha Polar",
        fre: "Wagon de t\xeate",
        swe: "Huvudkondukt\xf6r",
        sch: "\u601D\u8DEF\u76F4\u901A\u8F66"
    },
    1782: {
        img: "seasonal_employee",
        eng: "Seasonal Employee",
        rus: "\u0421\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A",
        schema: 31258,
        pol: "Pracownik sezonowy",
        hun: "Szezon\xe1lis Alkalmazott",
        bra: "Profissional Sazonal",
        fre: "Employ\xe9 saisonnier",
        swe: "S\xe4songsanst\xe4lld",
        sch: "\u7279\u62DB\u5B63\u96C7\u5458"
    },
    1783: {
        img: "reindoonihorns",
        eng: "Reindoonihorns",
        rus: "\u0420\u043E\u0433\u0430 \u041D\u0430\u0434\u0443\u0432\u043E\u043B\u0435\u043D\u0435\u0440\u043E\u0433\u0430",
        schema: 31249,
        pol: "Renifero\u017Ccowe poro\u017Ce",
        hun: "R\xe9nkornissszarv",
        bra: "Renachifres",
        fre: "Rennicornes",
        swe: "Renh\xf6rningshorn",
        sch: "\u72EC\u89D2\u9E7F\u8033\u7F69"
    },
    1784: {
        img: "jolly_jester",
        eng: "Jolly Jester",
        rus: "\u0428\u043C\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043D\u0441\u043A\u0438\u0439 \u0448\u0443\u0442",
        schema: 31243,
        pol: "\u015Awi\u0105teczny \u015Bmieszek",
        bra: "Bobo do Norte",
        hun: "Boldog Bolondoz\xf3",
        fre: "Bouffon no\xeblesque",
        swe: "Munter narr",
        sch: "\u72C2\u6B22\u5F04\u81E3"
    },
    1785: {
        img: "merry_cone",
        eng: "Merry Cone",
        rus: "\u0412\u0435\u0441\u0451\u043B\u044B\u0439 \u043A\u043E\u043B\u043F\u0430\u0447\u043E\u043A",
        schema: 31247,
        pol: "\u015Awi\u0105teczny sto\u017Cek",
        hun: "Vid\xe1m Cs\xfacsd\xedsz",
        bra: "Papai Chap\xe9u",
        fre: "Chapeau pointu de No\xebl",
        swe: "Munter strut",
        sch: "\u5723\u8BDE\u5C16\u9876\u5E3D"
    },
    1786: {
        img: "hat_chocolate",
        eng: "Hat Chocolate",
        rus: "\u0413\u043E\u0440\u044F\u0447\u0438\u0439 \u0448\u0430\u043F\u043A\u043E\u043B\u0430\u0434",
        schema: 31259,
        pol: "Czapka na ciep\u0142o",
        hun: "Fejcsokol\xe1d\xe9",
        bra: "Chap\xe9ulate Quente",
        fre: "Chapeaucolat chaud",
        swe: "Knoppkopp",
        sch: "\u5934\u9876\u70ED\u5DE7"
    },
    1787: {
        img: "oh_deer",
        eng: "Oh Deer!",
        rus: "\u041D\u0443 \u0438 \u043E\u043B\u0435\u043D\u044C!",
        schema: 31245,
        pol: "Ale jele\u0144!",
        hun: "Szarvamra!",
        bra: "Cervos Me Mordam",
        fre: "Cerf-t\xeate",
        swe: "Rudolf",
        sch: "\u5C0F\u9E7F\u4E71\u649E\uFF01"
    },
    1788: {
        img: "taunt_doctors_defibrillators",
        eng: "Taunt: Doctor's Defibrillators",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0414\u0435\u0444\u0438\u0431\u0440\u0438\u043B\u043B\u044F\u0442\u043E\u0440 \u0434\u043E\u043A\u0442\u043E\u0440\u0430",
        schema: 31236,
        pol: "Drwina: Defibrylatory doktora",
        bra: "Provoca\xe7\xe3o: Desfibrilador do Doutor",
        hun: "Besz\xf3l\xe1s: Orvosi defibrill\xe1tor",
        fre: "Raillerie : D\xe9fibrillateurs du docteur",
        swe: "H\xe5n: Doktorns defibrillatorer"
    },
    1789: {
        img: "taunt_shooters_stakeout",
        eng: "Taunt: Shooter's Stakeout",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041A\u0435\u043C\u043F\u0438\u043D\u0433 \u043A\u0438\u043B\u043B\u0435\u0440\u0430",
        schema: 31237,
        pol: "Drwina: Obcykany obserwator",
        hun: "Besz\xf3l\xe1s: L\xf6v\xe9sz\xe1ll\xe1s",
        bra: "Provoca\xe7\xe3o: A Tocaia do Atirador",
        fre: "Raillerie : Planque du tireur",
        swe: "H\xe5n: Spaningsuppdrag",
        sch: "\u5632\u8BBD\uFF1A\u8E72\u70B9\u653E\u54E8"
    },
    1790: {
        img: "taunt_the_hot_wheeler",
        eng: "Taunt: The Hot Wheeler",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041F\u043B\u0430\u043C\u0435\u043D\u043D\u044B\u0439 \u0433\u043E\u043D\u0449\u0438\u043A",
        schema: 31239,
        pol: "Drwina: Spalacz gum",
        hun: "Besz\xf3l\xe1s: T\xfczes j\xe1rg\xe1ny",
        bra: "Provoca\xe7\xe3o: Triciclo Tunado",
        fre: "Raillerie : Chauffard",
        swe: "H\xe5n: Asfaltsbr\xe4nnaren"
    },
    1791: {
        img: "undercover_brolly",
        eng: "Undercover Brolly",
        rus: "\u041F\u0430\u0440\u0430\u0441\u043E\u043B\u044C \u043F\u0440\u0438\u043A\u0440\u044B\u0442\u0438\u044F",
        schema: 31262,
        pol: "Przeciws\u0142oneczna przykrywka",
        hun: "Naperny\u0151fedett \xdcgyn\xf6k",
        fre: "Ombrelle incognito",
        bra: "Guarda-Solit\xe1rio",
        swe: "Paraflax"
    },
    1792: {
        img: "team_player",
        eng: "The Team Player",
        rus: "\u041A\u043E\u043C\u0430\u043D\u0434\u043D\u044B\u0439 \u0438\u0433\u0440\u043E\u043A",
        schema: 31283,
        pol: "Gracz zespo\u0142owy",
        hun: "Csapatj\xe1t\xe9kos",
        bra: "O Camisa 1",
        fre: "Esprit d'\xe9quipe",
        swe: "Lagspelare",
        sch: "\u56E2\u961F\u7B2C\u4E00"
    },
    1793: {
        img: "throttlehead",
        eng: "The Throttlehead",
        rus: "\u0414\u0438\u0442\u044F \u0434\u043E\u0440\u043E\u0433",
        schema: 31282,
        pol: "Motog\u0142owy",
        bra: "O Sem Destino",
        hun: "G\xe1zos Fej\u0171",
        fre: "Casse-cou",
        swe: "Motorskalle",
        sch: "\u9AD8\u901F\u5934\u5DFE"
    },
    1794: {
        img: "tactical_turtleneck",
        eng: "Tactical Turtleneck",
        rus: "\u0412\u043E\u0434\u043E\u043B\u0430\u0437\u043A\u0430 \u0432\u043D\u0435\u0434\u0440\u0435\u043D\u0446\u0430",
        schema: 31278,
        pol: "Taktyczny golf",
        bra: "Traje T\xe1tico",
        hun: "Taktikai Garb\xf3",
        fre: "Col roul\xe9 tactique",
        swe: "Taktisk polo",
        sch: "\u6218\u672F\u9AD8\u9886\u886B"
    },
    1795: {
        img: "combat_casual",
        eng: "Combat Casual",
        rus: "\u0411\u0443\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u0431\u043E\u0435\u0446",
        schema: 31268,
        pol: "Lu\u017Any wojak",
        bra: "Combatente Casual",
        hun: "Laza Harciass\xe1g",
        fre: "Mercenaire d\xe9contract\xe9",
        swe: "Vardagsk\xe4mpe",
        sch: "\u4F5C\u6218\u4F11\u95F2\u88C5"
    },
    1796: {
        img: "barefoot_brawler",
        eng: "Barefoot Brawler",
        rus: "\u0411\u043E\u0441\u043E\u0439 \u0431\u043E\u0435\u0446",
        schema: 31275,
        pol: "Bosy buntownik",
        bra: "Pugnador Praiano",
        hun: "Mez\xedtl\xe1bas Buny\xf3s",
        fre: "Baroudeur en claquettes",
        sch: "\u8D64\u8DB3\u640F\u547D\u6C49",
        swe: "Barfota br\xe5kmakare"
    },
    1797: {
        img: "hawaiian_hunter",
        eng: "Hawaiian Hunter",
        rus: "\u0413\u0430\u0432\u0430\u0439\u0441\u043A\u0438\u0439 \u0433\u0443\u0431\u0438\u0442\u0435\u043B\u044C",
        schema: 31271,
        pol: "Hawajski \u0142owca",
        bra: "Atirador Havaiano",
        hun: "Hawaii Vad\xe1sz",
        fre: "Chasseur hawa\xefen",
        sch: "\u590F\u5A01\u5937\u730E\u624B",
        swe: "Tropisk j\xe4gare"
    },
    1798: {
        img: "chaser",
        eng: "The Chaser",
        rus: "\u041F\u0440\u0435\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C",
        schema: 31276,
        pol: "\u015Acigaj\u0105cy",
        bra: "O Perseguidor",
        hun: "\xdcld\xf6z\u0151",
        fre: "Trench",
        sch: "\u8FFD\u7F09\u98CE\u8863",
        swe: "F\xf6rf\xf6ljare"
    },
    1799: {
        img: "western_wraps",
        eng: "The Western Wraps",
        rus: "\u0417\u0430\u043F\u0430\u0434\u043D\u043E\u0435 \u043E\u0434\u0435\u044F\u043D\u0438\u0435",
        schema: 31264,
        pol: "Zachodni ko\u017Cuch",
        bra: "Agasalho do Velho Oeste",
        hun: "Nyugati Hacuka",
        fre: "Blouson du Far West",
        sch: "\u897F\u90E8\u8352\u91CE\u5939\u514B",
        swe: "Vilda v\xe4sten"
    },
    1800: {
        img: "pests_pads",
        eng: "Pest's Pads",
        rus: "\u0417\u0430\u0449\u0438\u0442\u0430 \u0437\u0430\u0434\u0438\u0440\u044B",
        schema: 31285,
        pol: "Ochraniacze zawadiaki",
        bra: "Prote\xe7\xf5es do Pestinha",
        hun: "Pancserv\xe9d\u0151k",
        fre: "Genouill\xe8res du casse-pieds",
        swe: "Pl\xe5gans kn\xe4skydd",
        sch: "\u5BB3\u4EBA\u866B\u7684\u62A4\u57AB"
    },
    1801: {
        img: "boston_brain_bucket",
        eng: "Boston Brain Bucket",
        rus: "\u041C\u0430\u0441\u0441\u0430\u0447\u0443\u0441\u0435\u0442\u0441\u043A\u0430\u044F \u043C\u0438\u0441\u043A\u0430 \u043C\u043E\u0437\u0433\u043E\u0432",
        schema: 31284,
        pol: "M\xf3zgonosz z Massachusetts",
        bra: "Balde de Miolos de Boston",
        hun: "Bostoni Agyv\xf6d\xf6r",
        fre: "Prot\xe8ge-caboche",
        sch: "\u6CE2\u58EB\u987F\u62A4\u8111\u76D4",
        swe: "Bostonhink"
    },
    1802: {
        img: "ripped_rider",
        eng: "The Ripped Rider",
        rus: "\u0411\u0435\u0437\u0440\u0443\u043A\u0430\u0432\u043A\u0430 \u0431\u0430\u0439\u043A\u0435\u0440\u0430",
        schema: 31281,
        pol: "Przetarty je\u017Adziec",
        bra: "O Motoqueiro Marrento",
        hun: "Szakadt Sz\xe9ltol\xf3",
        fre: "Doudoune d\xe9chir\xe9e",
        swe: "Tuff knutte",
        sch: "\u6495\u8896\u5939\u514B"
    },
    1803: {
        img: "fizzy_pharmacist",
        eng: "Fizzy Pharmacist",
        rus: "\u0428\u0438\u043F\u0443\u0447\u0438\u0439 \u0444\u0430\u0440\u043C\u0430\u0446\u0435\u0432\u0442",
        schema: 31266,
        pol: "Gazowany farmaceuta",
        hun: "Pezsg\u0151 Patikus",
        bra: "Farmac\xeautico Gasoso",
        fre: "Pharmacien p\xe9tillant",
        swe: "Kolsyrad apotekare",
        sch: "\u6C7D\u6C34\u8C03\u5242\u5E08"
    },
    1804: {
        img: "detective",
        eng: "The Detective",
        rus: "\u0414\u0435\u0442\u0435\u043A\u0442\u0438\u0432",
        schema: 31277,
        pol: "Detektyw",
        bra: "O Detetive",
        hun: "Nyomoz\xf3",
        fre: "F\xe9dora",
        sch: "\u8B66\u90E8\u4E4B\u5E3D",
        swe: "Detektiv"
    },
    1805: {
        img: "hawaiian_hangover",
        eng: "The Hawaiian Hangover",
        rus: "\u041F\u043B\u044F\u0436\u043D\u043E\u0435 \u043F\u043E\u0445\u043C\u0435\u043B\u044C\u0435",
        schema: 31274,
        pol: "Kac po hawajsku",
        bra: "A Ressaca do Recesso",
        hun: "Hawaii M\xe1snaposs\xe1g",
        fre: "Gueule de bois tropicale",
        sch: "\u5BBF\u9189\u590F\u5A01\u5937",
        swe: "Tropisk baksm\xe4lla"
    },
    1806: {
        img: "tropical_camo",
        eng: "Tropical Camo",
        rus: "\u0422\u0440\u043E\u043F\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043A\u0430\u043C\u0443\u0444\u043B\u044F\u0436",
        schema: 31270,
        pol: "Tropikalny kamufla\u017C",
        bra: "Camuflagem Tropical",
        hun: "Tr\xf3pusi \xc1lca",
        fre: "Camouflage Tropical",
        swe: "Tropisk kamouflage",
        sch: "\u70ED\u5E26\u8FF7\u5F69\u886B"
    },
    1807: {
        img: "squatters_right",
        eng: "Squatter's Right",
        rus: "\u041B\u044E\u0431\u0438\u0442\u0435\u043B\u044C \u043F\u0440\u0438\u0441\u0435\u0441\u0442\u044C",
        schema: 31267,
        pol: "Prawo blokersa",
        bra: "O Estilo Eslavo",
        hun: "A H\xe1zfoglal\xf3 Jog\xe1n",
        fre: "Squatteur r\xe9calcitrant",
        swe: "Ligistkeps",
        sch: "\u5360\u70B9\u4E3A\u738B"
    },
    1808: {
        img: "lawnmaker",
        eng: "Lawnmaker",
        rus: "\u0413\u0430\u0437\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C",
        schema: 31272,
        pol: "Trawodawca",
        hun: "F\u0171m\xe9rn\xf6k",
        fre: "Paysagiste",
        bra: "O Jardineer",
        swe: "Tr\xe4dg\xe5rdsm\xe4stare",
        sch: "\u82B1\u56ED\u5272\u8349\u5DE5"
    },
    1809: {
        img: "night_vision_gawkers",
        eng: "Night Vision Gawkers",
        rus: "\u041E\u0447\u043A\u0438 \u043D\u043E\u0447\u043D\u043E\u0433\u043E \u0433\u043B\u0430\u0437\u0435\u043D\u0438\u044F",
        schema: 31279,
        pol: "Noktowizyjny wytrzeszcz",
        bra: "\xd3culos de Terceiro Escal\xe3o",
        hun: "\xc9jjell\xe1t\xf3 Kukker",
        fre: "Binocles de vision nocturne",
        swe: "Nattfluktare",
        sch: "\u7AA5\u63A2\u8005\u7684\u591C\u89C6\u4EEA"
    },
    1810: {
        img: "head_banger",
        eng: "Head Banger",
        rus: "\u0412\u0437\u0440\u044B\u0432 \u043C\u043E\u0437\u0433\u0430",
        schema: 31273,
        pol: "Bombowa impreza",
        bra: "Cabe\xe7a Explosiva",
        hun: "Agydurrant\xf3",
        fre: "Casque explosif",
        swe: "Hj\xe4rnspr\xe4ngare",
        sch: "\u5934\u8111\u75AF\u7206"
    },
    1811: {
        img: "monsieur_grenouille",
        eng: "Monsieur Grenouille",
        rus: "\u041C\u0435\u0441\u044C\u0435 \u041B\u044F \u0413\u0443\u0448\u043A\u0430",
        schema: 31280,
        sch: "\u9752\u86D9\u8001\u7237"
    },
    1812: {
        img: "soda_cap",
        eng: "Soda Cap",
        rus: "\u0428\u0430\u043F\u043A\u0430 \u0433\u0430\u0437\u0438\u0440\u043E\u0432\u0449\u0438\u043A\u0430",
        schema: 31265,
        pol: "Sprzedawca sod\xf3wki",
        hun: "B\xfcf\xe9s Cs\xe1k\xf3",
        fre: "Calot du vendeur de soda",
        bra: "Refresco de Cabe\xe7a",
        swe: "Sodagubben",
        sch: "\u82CF\u6253\u6C7D\u6C34\u5E3D"
    },
    1813: {
        img: "kazan_karategi",
        eng: "Kazan Karategi",
        rus: "\u041A\u0430\u043B\u0451\u043D\u043E\u0435 \u043A\u0430\u0440\u0430\u0442\u044D\u0433\u0438",
        schema: 31263,
        pol: "Wulkaniczny wojownik",
        fre: "Kimono flamboyant",
        sch: "\u706B\u5C71\u9053\u670D"
    },
    1814: {
        img: "rocko",
        eng: "Rocko",
        rus: "\u0420\u043E\u043A\u043A\u043E",
        schema: 31269,
        pol: "Roko",
        hun: "Kroki",
        sch: "\u9CC4\u9C7C\u6D1B\u53EF"
    },
    1815: {
        img: "decorated_veteran",
        eng: "Decorated Veteran",
        rus: "\u0423\u043A\u0440\u0430\u0448\u0435\u043D\u043D\u044B\u0439 \u0432\u0435\u0442\u0435\u0440\u0430\u043D",
        schema: 31261,
        pol: "Udekorowany weteran",
        bra: "Veterano Decorado",
        hun: "Kit\xfcntetett Veter\xe1n",
        fre: "V\xe9t\xe9ran d\xe9cor\xe9",
        swe: "Dekorerad veteran",
        sch: "\u7CBE\u88C5\u8001\u5175"
    },
    1816: {
        img: "nightbane_brim",
        eng: "Nightbane Brim",
        rus: "\u041F\u043E\u043B\u0443\u043D\u043E\u0447\u043D\u044B\u0439 \u043F\u0443\u0433\u0430\u0442\u0435\u043B\u044C",
        schema: 31308,
        pol: "W mroku nocy",
        bra: "Inquisidor Demolidor",
        fre: "Inquisiteur nocturne",
        hun: "R\xe9mes Kalap",
        sch: "\u6697\u591C\u4E4B\u9B47",
        swe: "Pilgrimsbr\xe4tte"
    },
    1817: {
        img: "more_gun_marshal",
        eng: "More Gun Marshal",
        rus: "\u041C\u043D\u043E\u0433\u043E\u043F\u0443\u0448\u0435\u0447\u043D\u044B\u0439 \u043C\u0430\u0440\u0448\u0430\u043B",
        schema: 31298,
        pol: "Stra\u017Cnik dzia\u0142ek stra\u017Cniczych",
        bra: "Marechal Munido",
        fre: "Marshal surarm\xe9",
        hun: "\u201ET\xf6bb Fegyver\u201D Rend\u0151rb\xedr\xf3",
        sch: "\u67AA\u591A\u52BF\u4F17",
        swe: "Ammunitionsmarskalk"
    },
    1818: {
        img: "hunting_cloak",
        eng: "Hunting Cloak",
        rus: "\u041E\u0445\u043E\u0442\u043D\u0438\u0447\u044C\u044F \u043D\u0430\u043A\u0438\u0434\u043A\u0430",
        schema: 31314,
        bra: "Capa de Ca\xe7a",
        fre: "Veston de chasse",
        hun: "Vad\xe1szk\xf6peny",
        pol: "Peleryna poluj\u0105cego",
        sch: "\u730E\u5934\u8005\u7684\u6F5C\u884C\u670D",
        swe: "Jaktmantel"
    },
    1819: {
        img: "the_imps_imprint",
        eng: "The Imp's Imprint",
        rus: "\u0427\u0451\u0440\u0442\u043E\u0432\u044B \u043D\u0430\u0447\u0435\u0440\u0442\u0430\u043D\u0438\u044F",
        schema: 31302,
        pol: "Diabelski nadruk",
        bra: "O Colete do Capetinha",
        fre: "La veste du vandale",
        hun: "\xd6rd\xf6gi Lenyomat",
        sch: "\u602A\u886B\u9177\u5B69",
        swe: "Od\xe5gans symbol"
    },
    1820: {
        img: "starlight_sorcerer",
        eng: "Starlight Sorcerer",
        rus: "\u0417\u0432\u0451\u0437\u0434\u043D\u044B\u0439 \u0437\u0430\u043A\u043B\u0438\u043D\u0430\u0442\u0435\u043B\u044C",
        schema: 31294,
        pol: "Gwiezdny czarodziej",
        bra: "Feiticeiro Estrelado",
        fre: "Sorcier du firmament",
        hun: "Csillagos Var\xe1zsl\xf3",
        sch: "\u661F\u8F89\u672F\u58EB",
        swe: "Stj\xe4rnmagiker"
    },
    1821: {
        img: "beaten_and_bruised",
        eng: "Beaten and Bruised",
        rus: "\u0421\u0438\u043D\u044F\u043A\u0438 \u0438 \u0441\u0441\u0430\u0434\u0438\u043D\u044B",
        schema: 31293,
        pol: "Pobity i posiniaczony",
        bra: "Espancado e Esmurrado",
        fre: "Ross\xe9 et caboss\xe9",
        hun: "Legy\u0151zve \xe9s \xd6sszeverve",
        sch: "\u9F3B\u9752\u8138\u80BF",
        swe: "Illa tilltygad"
    },
    1822: {
        img: "bombard_brigadier",
        eng: "Bombard Brigadier",
        rus: "\u0411\u0440\u0438\u0433\u0430\u0434\u043D\u044B\u0439 \u0431\u043E\u043C\u0431\u0430\u0440\u0434\u0438\u0440",
        schema: 31309,
        bra: "Brigadeiro Bombardeiro",
        fre: "Brigadier bombardier",
        hun: "Bomb\xe1z\xf3-brigad\xe9ros",
        pol: "Bombowy brygadier",
        swe: "Bombbrigad\xf6r",
        sch: "\u7206\u7834\u5C06\u519B"
    },
    1823: {
        img: "firearm_protector",
        eng: "Firearm Protector",
        rus: "\u041E\u0433\u043D\u0435\u0441\u0442\u0440\u0435\u043B\u0435\u0446",
        schema: 31310,
        pol: "Ochrona ogniomistrza",
        bra: "Bombeiro Incivil",
        fre: "Soldat des flammes",
        hun: "T\u0171zfegyver-vizsg\xe1l\xf3",
        sch: "\u6D88\u9632\u4FDD\u62A4\u76D4",
        swe: "Brandskydd"
    },
    1824: {
        img: "horror_shawl",
        eng: "Horror Shawl",
        rus: "\u0425\u043E\u0440\u0440\u043E\u0440\u0448\u0438\u0441\u0442",
        schema: 31304,
        pol: "Makabryczna chusta",
        bra: "Xale de Horrores",
        fre: "Capuchon de l'horreur",
        hun: "R\xe9mcsuklya",
        sch: "\u9A87\u7136\u7855\u7269",
        swe: "Skr\xe4cksjal"
    },
    1825: {
        img: "the_turncoat",
        eng: "The Turncoat",
        rus: "\u041F\u0435\u0440\u0435\u0432\u0451\u0440\u0442\u044B\u0448",
        schema: 31301,
        bra: "O Casaco do Vira-Casaca",
        fre: "Redingote",
        hun: "Nagykab\xe1t",
        pol: "Renegat",
        sch: "\u65E0\u95F4\u9053\u5927\u8863",
        swe: "\xd6verl\xf6pare"
    },
    1826: {
        img: "dustbowl_devil",
        eng: "Dustbowl Devil",
        rus: "\u041F\u043E\u0432\u0435\u043B\u0438\u0442\u0435\u043B\u044C \u043F\u0443\u0441\u0442\u044B\u043D\u044C",
        schema: 31297,
        pol: "Diabe\u0142 z Dustbowl",
        bra: "Dem\xf4nio de Dustbowl",
        fre: "Diable du Dustbowl",
        hun: "A Homokvihar \xd6rd\xf6ge",
        sch: "\u6C99\u573A\u9B3C\u624D",
        swe: "\xd6kenfan"
    },
    1827: {
        img: "the_masked_fiend",
        eng: "The Masked Fiend",
        rus: "\u041C\u043E\u043D\u0441\u0442\u0440 \u0432 \u043C\u0430\u0441\u043A\u0435",
        schema: 31303,
        pol: "Zamaskowany demon",
        bra: "A M\xe1scara do Malvado",
        fre: "D\xe9mon masqu\xe9",
        hun: "\xc1larcos \xd6rd\xf6g",
        sch: "\u8986\u9762\u5C0F\u9B3C",
        swe: "Maskerad pl\xe5goande"
    },
    1828: {
        img: "safety_stripes",
        eng: "Safety Stripes",
        rus: "\u041F\u043E\u043B\u043E\u0441\u043A\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u043E\u0440\u043E\u0436\u043D\u043E\u0441\u0442\u0438",
        schema: 31311,
        pol: "Pasy bezpiecze\u0144stwa",
        bra: "Listras Refletivas",
        fre: "Bandes r\xe9fl\xe9chissantes",
        hun: "L\xe1that\xf3s\xe1gi Cs\xedkok",
        sch: "\u5B89\u4FDD\u6761\u7EB9\u670D",
        swe: "Reflexr\xe4nder"
    },
    1829: {
        img: "road_block",
        eng: "Road Block",
        rus: "\u0414\u043E\u0440\u043E\u0436\u043D\u044B\u0439 \u0437\u0430\u0441\u043B\u043E\u043D",
        schema: 31306,
        bra: "O Bloqueio de Rua",
        fre: "Route barr\xe9e",
        hun: "\xdattorlasz",
        pol: "Blokada drogowa",
        sch: "\u62E6\u8DEF\u6076\u9738",
        swe: "V\xe4gsp\xe4rr"
    },
    1830: {
        img: "the_lavish_labwear",
        eng: "The Lavish Labwear",
        rus: "\u041B\u043E\u0449\u0451\u043D\u044B\u0439 \u043B\u0430\u0431\u043E\u0440\u0430\u043D\u0442",
        schema: 31299,
        bra: "O Laboratorista Luxuoso",
        fre: "Blouse de luxe",
        hun: "F\xe9ny\u0171z\u0151 Labork\xf6peny",
        pol: "Lito\u015Bciwy laborant",
        sch: "\u7AED\u8C0B\u8086\u6076",
        swe: "Schangtil labbrock"
    },
    1831: {
        img: "headhunters_brim",
        eng: "Headhunter's Brim",
        rus: "\u0428\u043B\u044F\u043F\u0430 \u043E\u0445\u043E\u0442\u043D\u0438\u043A\u0430 \u0437\u0430 \u0433\u043E\u043B\u043E\u0432\u0430\u043C\u0438",
        schema: 31313,
        bra: "Chap\xe9u do Ca\xe7ador de Cabe\xe7as",
        fre: "Chapeau du chasseur de t\xeates",
        hun: "Fejvad\xe1sz-kalap",
        pol: "Kapelusz \u0142owcy g\u0142\xf3w",
        sch: "\u730E\u5934\u8005\u7684\u5BBD\u6A90\u5E3D",
        swe: "Huvudj\xe4garens br\xe4tte"
    },
    1832: {
        img: "cranial_cowl",
        eng: "Cranial Cowl",
        rus: "\u041A\u0440\u0430\u043D\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u043A\u0430\u043F\u044E\u0448\u043E\u043D",
        schema: 31312,
        bra: "Capuz Craniano",
        fre: "Capuchon cr\xe2nien",
        hun: "Koponyak\xe1mzsa",
        pol: "Czaszkowy kaptur",
        sch: "\u9885\u9AA8\u515C\u5E3D",
        swe: "Skallek\xe5pa"
    },
    1833: {
        img: "alcoholic_automaton",
        eng: "Alcoholic Automaton",
        rus: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0430\u043B\u043A\u043E\u0433\u043E\u043B\u0438\u043A",
        schema: 31307,
        pol: "Automatyczny alkoholik",
        bra: "Aut\xf4mato Movido a \xc1lcool",
        fre: "Automate alcoolique",
        hun: "Alkoholos Automata",
        sch: "\u55DC\u9152\u673A\u4F53",
        swe: "Fyllbult"
    },
    1834: {
        img: "road_rage",
        eng: "Road Rage",
        rus: "\u0414\u043E\u0440\u043E\u0436\u043D\u044B\u0439 \u0434\u0440\u0430\u0447\u0443\u043D",
        schema: 31305,
        bra: "A F\xfaria da Estrada",
        fre: "Rage au volant",
        hun: "Orsz\xe1g\xfati D\xfch\xf6ng\xe9s",
        pol: "Agresja drogowa",
        sch: "\u516C\u8DEF\u66B4\u5F92",
        swe: "V\xe4gbuse"
    },
    1835: {
        img: "victorian_villainy",
        eng: "Victorian Villainy",
        rus: "\u0412\u0440\u0435\u0434\u043D\u044B\u0439 \u0432\u0438\u043A\u0442\u043E\u0440\u0438\u0430\u043D\u0435\u0446",
        schema: 31300,
        bra: "Vilania Vitoriana",
        fre: "Infamie victorienne",
        hun: "Viktori\xe1nus V\xe9rengz\xe9s",
        pol: "Wiktoria\u0144ski winowajca",
        sch: "\u90AA\u667A\u5178\u8303",
        swe: "Viktoriansk skurk"
    },
    1836: {
        img: "propaniac",
        eng: "Propaniac",
        rus: "\u041F\u0440\u043E\u043F\u0430\u043D\u044C\u044F\u043A",
        schema: 31296,
        pol: "Propaniak",
        bra: "Propan\xedaco",
        fre: "Propaniaque",
        hun: "G\xe1zos S\xe9r\xf3",
        sch: "\u55B7\u7130\u83AB\u897F\u5E72",
        swe: "Propan"
    },
    1837: {
        img: "the_onimann",
        eng: "The Onimann",
        rus: "\u041E\u043D\u0438-\u043C\u0430\u043D\u043D",
        schema: 31295,
        pol: "Onimann",
        bra: "Onimann",
        fre: "Onimann",
        hun: "Onimann",
        sch: "\u9B3C\u4F8D\u5047\u9762",
        swe: "Onimann"
    },
    1838: {
        img: "mishas_maw",
        eng: "Misha's Maw",
        rus: "\u041C\u0438\u0448\u043A\u0438\u043D\u0430 \u043C\u043E\u0440\u0434\u0430",
        schema: 31315,
        bra: "Russo Urso",
        fre: "T\xeate d'ours",
        hun: "Mack\xf3pofa",
        pol: "Nied\u017Awiedzia przys\u0142uga",
        sch: "\u5DE8\u718A\u7C73\u6C99",
        swe: "Mishas mule"
    },
    1839: {
        img: "cabinet_mann",
        eng: "Cabinet Mann",
        rus: "\u0418\u0433\u0440\u043E-\u041C\u0430\u043D\u043D",
        schema: 31316,
        pol: "Cz\u0142owiek-automat",
        bra: "Fliperamann",
        fre: "Manitou de l'arcade",
        hun: "J\xe1t\xe9kg\xe9p-g\xe9p\xe9sz",
        sch: "\u5934\u53F7\u8857\u673A",
        swe: "Arkadmannen"
    },
    1840: {
        img: "fire_breather",
        eng: "Fire Breather",
        rus: "\u041E\u0433\u043D\u0435\u0434\u044B\u0448\u0430\u0449\u0438\u0439 \u043E\u0441\u043A\u0430\u043B",
        schema: 31317,
        pol: "Zion\u0105cy ogniem",
        bra: "O Bafo do Drag\xe3o",
        fre: "Cracheur de feu",
        hun: "T\u0171zk\xf6p\u0151",
        sch: "\u708E\u606F\u5C0F\u9F99",
        swe: "Eldsprutare"
    },
    1841: {
        img: "magical_mount",
        eng: "Magical Mount",
        rus: "\u0421\u043A\u0430\u0437\u043E\u0447\u043D\u044B\u0439 \u0441\u043A\u0430\u043A\u0443\u043D",
        schema: 31318,
        pol: "Magiczny wierzchowiec",
        bra: "Montaria M\xe1gica",
        fre: "Monture magique",
        hun: "M\xe1gikus H\xe1tas",
        sch: "\u72EC\u89D2\u517D\u5750\u9A91",
        swe: "Magiskt riddjur"
    },
    1842: {
        img: "pony_express",
        eng: "Pony Express",
        rus: "\u041F\u043E\u043D\u0438-\u044D\u043A\u0441\u043F\u0440\u0435\u0441\u0441",
        schema: 31319,
        pol: "Poczta konna",
        bra: "A Cavalgada Maldita",
        fre: "Le Poney Express",
        sch: "\u5C0F\u9A6C\u5FEB\u8DD1",
        swe: "Ponnyexpressen"
    },
    1843: {
        img: "cream_corned_war_paint",
        eng: "Cream Corned War Paint",
        rus: '"\u041A\u0430\u0440\u0430\u043C\u0435\u043B\u044C\u043D\u0430\u044F \u043A\u0443\u043A\u0443\u0440\u0443\u0437\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17401,
        pol: "Krem kukurydziany Barwy wojenne",
        bra: "| Creme de Ab\xf3bora | Tinta de Guerra",
        fre: "Estampill\xe9 ma\xefs Peinture de guerre",
        hun: "Cukorkabevonat Harci fest\xe9s",
        swe: "Stuvad majs Krigsf\xe4rg",
        sch: "\u5976\u6CB9\u6D78\u6CE1 \u6218\u7ED8"
    },
    1844: {
        img: "hypergon_war_paint",
        eng: "Hypergon War Paint",
        rus: '"\u0413\u0438\u043F\u0435\u0440\u0443\u0433\u043E\u043B\u044C\u043D\u0438\u043A" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17408,
        pol: "Hipergon Barwy wojenne",
        bra: "| Hipergono | Tinta de Guerra",
        fre: "Hypergone Peinture de guerre",
        hun: "H\xfahatsz\xf6g Harci fest\xe9s",
        swe: "Hypergonal Krigsf\xe4rg",
        sch: "\u6D77\u666E\u5188\u900F\u955C \u6218\u7ED8"
    },
    1845: {
        img: "health_and_hell_green_war_paint",
        eng: "Health and Hell (Green) War Paint",
        rus: '"\u041F\u043E\u043B\u044C\u0437\u0430 \u043F\u0440\u0435\u0438\u0441\u043F\u043E\u0434\u043D\u0435\u0439 (\u0437\u0435\u043B\u0451\u043D\u0430\u044F)" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17407,
        pol: "Zdrowie i piek\u0142o (ziele\u0144) Barwy wojenne",
        bra: "| Verde e Inferno | Tinta de Guerra",
        fre: "Vie et enfer (vert) | Peinture de guerre",
        hun: "\xc9let \xe9s Pokol (z\xf6ld) Harci fest\xe9s",
        swe: "H\xe4lsa och helvete (gr\xf6n) Krigsf\xe4rg",
        sch: "\u751F\u547D\u707E\u72F1 \u6218\u7ED8"
    },
    1846: {
        img: "health_and_hell_war_paint",
        eng: "Health and Hell War Paint",
        rus: '"\u041F\u043E\u043B\u044C\u0437\u0430 \u043F\u0440\u0435\u0438\u0441\u043F\u043E\u0434\u043D\u0435\u0439" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17406,
        pol: "Zdrowie i piek\u0142o Barwy wojenne",
        bra: "| Vida e Inferno | Tinta de Guerra",
        fre: "Vie et enfer Peinture de guerre",
        hun: "\xc9let \xe9s Pokol Harci fest\xe9s",
        swe: "H\xe4lsa och helvete Krigsf\xe4rg",
        sch: "\u751F\u547D\u70BC\u72F1 \u6218\u7ED8"
    },
    1847: {
        img: "sunriser_war_paint",
        eng: "Sunriser War Paint",
        rus: '"\u0412\u0435\u0441\u0442\u043D\u0438\u043A \u0440\u0430\u0441\u0441\u0432\u0435\u0442\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17402,
        pol: "Wsch\xf3d s\u0142o\u0144ca Barwy wojenne",
        bra: "| Forja Solar | Tinta de Guerra",
        fre: "Force solaire Peinture de guerre",
        hun: "Napkelteget\u0151 Harci fest\xe9s",
        swe: "Solg\xe5ngare Krigsf\xe4rg",
        sch: "\u9ECE\u660E\u5347\u817E \u6218\u7ED8"
    },
    1848: {
        img: "chilly_autumn_war_paint",
        eng: "Chilly Autumn War Paint",
        rus: '"\u041F\u0440\u043E\u0445\u043B\u0430\u0434\u043D\u0430\u044F \u043E\u0441\u0435\u043D\u044C" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17410,
        pol: "Ch\u0142odna jesie\u0144 Barwy wojenne",
        bra: "| Calafrios em Outono | Tinta de Guerra",
        fre: "Frimas d'automne Peinture de guerre",
        hun: "H\u0171v\xf6s \u0150sz Harci fest\xe9s",
        swe: "Kylig h\xf6st Krigsf\xe4rg",
        sch: "\u79CB\u610F\u8427\u745F \u6218\u7ED8"
    },
    1849: {
        img: "pumpkin_plastered_war_paint",
        eng: "Pumpkin Plastered War Paint",
        rus: '"\u0422\u044B\u043A\u0432\u0435\u043D\u043D\u044B\u0439 \u0442\u0440\u0430\u0444\u0430\u0440\u0435\u0442" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17409,
        pol: "Dyniowa dekoracja Barwy wojenne",
        bra: "| Pintura de Ab\xf3bora | Tinta de Guerra",
        fre: "Torch\xe9 \xe0 la citrouille Peinture de guerre",
        hun: "T\xf6kre M\xe1zolt Harci fest\xe9s",
        swe: "Pumpapackad Krigsf\xe4rg",
        sch: "\u6D53\u90C1\u5357\u74DC \u6218\u7ED8"
    },
    1850: {
        img: "metalized_soul_war_paint",
        eng: "Metalized Soul War Paint",
        rus: '"\u041C\u0435\u0442\u0430\u043B\u043B\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0434\u0443\u0448\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17404,
        pol: "Metaliczna dusza Barwy wojenne",
        bra: "| Alma Metalizada | Tinta de Guerra",
        fre: "\xc2me m\xe9tallis\xe9e Peinture de guerre",
        hun: "F\xe9mlelk\u0171 Harci fest\xe9s",
        swe: "Metallisk sj\xe4l Krigsf\xe4rg",
        sch: "\u91D1\u5C5E\u9B42\u9AB8 \u6218\u7ED8"
    },
    1851: {
        img: "ghoul_blaster_war_paint",
        eng: "Ghoul Blaster War Paint",
        rus: '"\u0423\u0431\u043E\u0440\u0449\u0438\u043A \u0437\u0430 \u043F\u0440\u0438\u0437\u0440\u0430\u043A\u0430\u043C\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17400,
        pol: "Pogromca duch\xf3w Barwy wojenne",
        bra: "| Ca\xe7a-Esp\xedritos | Tinta de Guerra",
        fre: "Brise-fant\xf4me Peinture de guerre",
        hun: "Szellemapr\xedt\xf3 Harci fest\xe9s",
        swe: "Sp\xf6kspr\xe4ngare Krigsf\xe4rg",
        sch: "\u5C38\u9B42\u8D76\u6B7B\u603C \u6218\u7ED8"
    },
    1852: {
        img: "bonzo_gnawed_war_paint",
        eng: "Bonzo Gnawed War Paint",
        rus: '"\u0423\u043A\u0443\u0441\u044B \u0411\u043E\u043D\u0437\u043E" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17405,
        pol: "Obgryzaj\u0105cy Bonzo Barwy wojenne",
        bra: "| Tormento do Bonzo | Tinta de Guerra",
        fre: "Bonzo rong\xe9 Peinture de guerre",
        hun: "Bonzo-r\xe1gcs\xe1lta Harci fest\xe9s",
        swe: "Bonzo-biten Krigsf\xe4rg",
        sch: "\u90A6\u4F50\u4E4B\u55B0 \u6218\u7ED8"
    },
    1853: {
        img: "sacred_slayer_war_paint",
        eng: "Sacred Slayer War Paint",
        rus: '"\u041F\u0440\u0430\u0432\u0435\u0434\u043D\u044B\u0439 \u043F\u0430\u043B\u0430\u0447" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17403,
        pol: "\u015Awi\u0119ty zab\xf3jca Barwy wojenne",
        bra: "| Assassino Sagrado | Tinta de Guerra",
        fre: "Occision sacr\xe9e Peinture de guerre",
        hun: "Felszentelt Fegyverzet Harci fest\xe9s",
        swe: "Helgad baneman Krigsf\xe4rg",
        sch: "\u5723\u7075\u5C60\u622E \u6218\u7ED8"
    },
    1854: {
        img: "taunt_drunk_manns_cannon",
        eng: "Taunt: Drunk Mann's Cannon",
        rus: "Taunt: \u041C\u0430\u043D\u043D-\u0442\u0438\u0440\u0430 \u043F\u044C\u044F\u043D\u0438\u0446\u044B",
        schema: 31291,
        bra: "Provoca\xe7\xe3o: Canh\xe3o do Cachaceiro",
        fre: "Raillerie : Le canon du poivrot",
        hun: "Besz\xf3l\xe1s: R\xe9szeges \xe1gy\xfat\xf6ltel\xe9k",
        pol: "Drwina: Armata alkoholika",
        swe: "H\xe5n: Drunk Mann's Cannon",
        sch: "\u5632\u8BBD\uFF1A\u9189\u884C\u706B\u70AE"
    },
    1855: {
        img: "taunt_shanty_shipmate",
        eng: "Taunt: Shanty Shipmate",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041D\u0435\u043F\u0443\u0442\u0451\u0432\u044B\u0439 \u0441\u0443\u0445\u043E\u043F\u0443\u0442",
        schema: 31292,
        pol: "Drwina: Pijackie szanty",
        bra: "Provoca\xe7\xe3o: O Marambaia",
        fre: "Raillerie : Terre en vue",
        hun: "Besz\xf3l\xe1s: Tint\xe1s tenger\xe9sz",
        swe: "H\xe5n: Shanty Shipmate",
        sch: "\u5632\u8BBD\uFF1A\u65F1\u5730\u884C\u821F"
    },
    1856: {
        img: "taunt_texas_twirl_em",
        eng: "Taunt: Texas Twirl 'Em",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0422\u0435\u0445\u0430\u0441\u0441\u043A\u0438\u0439 \u0442\u0440\u044E\u043A\u0430\u0447",
        schema: 31286,
        pol: "Drwina: Teksa\u0144ski tupaniec",
        bra: "Provoca\xe7\xe3o: Pula-La\xe7o Texano",
        fre: "Raillerie : Pro du lasso",
        hun: "Besz\xf3l\xe1s: Texasi torn\xe1d\xf3",
        swe: "H\xe5n: Texas Twirl 'Em",
        sch: "\u5632\u8BBD\uFF1A\u5F97\u5DDE\u7EF3\u5708\u821E"
    },
    1857: {
        img: "taunt_the_travel_agent",
        eng: "Taunt: The Travel Agent",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041F\u0435\u0440\u0435\u043B\u0451\u0442\u043D\u044B\u0439 \u0430\u0433\u0435\u043D\u0442",
        schema: 31290,
        bra: "Provoca\xe7\xe3o: O Agente de Viagem",
        fre: "Raillerie : L'h\xe9lico-gadget",
        hun: "Besz\xf3l\xe1s: Az utaz\xf3 \xfcgyn\xf6k",
        swe: "H\xe5n: Resebyr\xe5n",
        sch: "\u5632\u8BBD\uFF1A\u98DE\u5929\u5BC6\u8C0D",
        pol: "Drwina: Agent podr\xf3\u017Cny"
    },
    1858: {
        img: "taunt_the_scaredycat",
        eng: "Taunt: The Scaredy-cat!",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0422\u0440\u0443\u0441\u0438\u0448\u043A\u0430!",
        schema: 31288,
        bra: "Provoca\xe7\xe3o: Que Susto!",
        fre: "Raillerie : La poule mouill\xe9e !",
        hun: "Besz\xf3l\xe1s: A macskajancsi!",
        pol: "Drwina: P\u0142ochliwy jak zaj\u0105c!",
        swe: "H\xe5n: R\xe4ddhare!",
        sch: "\u5632\u8BBD\uFF1A\u5413\u6211\u4E00\u8DF3\uFF01"
    },
    1859: {
        img: "lumbercap",
        eng: "Lumbercap",
        rus: "\u0414\u0440\u043E\u0432\u043E\u043A\u0435\u043F\u043A\u0430",
        schema: 31326,
        pol: "R\u0119bacz",
        bra: "Chap\xe9u do Lenhador",
        fre: "Chapeau de b\xfbcheron",
        hun: "Fav\xe1g\xf3sapka",
        sch: "\u91C7\u4F10\u5DE5\u4E4B\u5E3D",
        swe: "Timmerkeps"
    },
    1860: {
        img: "the_soft_hard_hat",
        eng: "The Soft Hard Hat",
        rus: "\u041A\u0430\u0441\u043A\u043E\u0432\u044F\u0437\u043A\u0430",
        schema: 31331,
        pol: "Dziergany kask",
        bra: "O L\xe3-pacete",
        fre: "Casque tricot\xe9",
        hun: "Puha V\xe9d\u0151sisak",
        sch: "\u7C97\u7EBA\u7CBE\u88C5\u5934\u76D4",
        swe: "Stickad skyddshj\xe4lm"
    },
    1861: {
        img: "heavy_heating",
        eng: "Heavy Heating",
        rus: "\u0423\u0441\u0438\u043B\u0435\u043D\u043D\u043E\u0435 \u0443\u0442\u0435\u043F\u043B\u0435\u043D\u0438\u0435",
        schema: 31346,
        pol: "Grube grzanie",
        bra: "Aquecimento Pesado",
        fre: "R\xe9chauffe-Heavy",
        hun: "Bemeleg\xedt\u0151",
        sch: "\u70ED\u8840\u91CD\u88C5",
        swe: "Tung v\xe4rme"
    },
    1862: {
        img: "arctic_mole",
        eng: "Arctic Mole",
        rus: "\u0410\u0440\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043A\u0440\u043E\u0442",
        schema: 31333,
        pol: "Arktyczny kret",
        bra: "Toupeira do \xc1rtico",
        fre: "Taupe arctique",
        hun: "Sarki Vakond",
        sch: "\u6781\u5730\u9F39\u9F20",
        swe: "Arktisk mullvad"
    },
    1863: {
        img: "glasgow_bankroll",
        eng: "Glasgow Bankroll",
        rus: "\u0411\u043E\u0433\u0430\u0447 \u0438\u0437 \u0413\u043B\u0430\u0437\u0433\u043E",
        schema: 31342,
        pol: "Krezus z Glasgow",
        bra: "Gala de Glasgow",
        fre: "Flambeur de Glasgow",
        hun: "Glasgow-i P\xe9nzeszs\xe1k",
        sch: "\u683C\u62C9\u65AF\u54E5\u8001\u94B1",
        swe: "Glasgow-h\xf6jdare"
    },
    1864: {
        img: "partizan",
        eng: "Partizan",
        rus: "\u041F\u0430\u0440\u0442\u0438\u0437\u0430\u043D",
        schema: 31329,
        pol: "Partyzant",
        bra: "Incendi\xe1rio Apartid\xe1rio",
        fre: "Partisan",
        hun: "Partiz\xe1n",
        sch: "\u6E38\u51FB\u961F\u4E4B\u5E3D"
    },
    1865: {
        img: "cold_blooded_coat",
        eng: "Cold Blooded Coat",
        rus: "\u041F\u0430\u043B\u044C\u0442\u043E \u043F\u0435\u0434\u0430\u043D\u0442\u0430",
        schema: 31336,
        pol: "Zimnokrwisty p\u0142aszcz",
        bra: "Sobretudo do Sangue-Frio",
        fre: "Manteau d'assassin",
        hun: "Hidegv\xe9r\u0171 Kab\xe1t",
        sch: "\u51B7\u8840\u5927\u8863",
        swe: "Kallblodig kappa"
    },
    1866: {
        img: "bulb_bonnet",
        eng: "Bulb Bonnet",
        rus: "\u0428\u0430\u0440\u043E\u0432\u043E\u0439 \u0448\u043B\u0435\u043C",
        schema: 31335,
        pol: "Bombkowy beret",
        bra: "Ornamento do Briguento",
        fre: "Bonnet \xe0 boule",
        hun: "G\xf6mbd\xedsz Sapka",
        sch: "\u5723\u8BDE\u5F69\u7403\u76D4",
        swe: "Julkula"
    },
    1867: {
        img: "crosshair_cardigan",
        eng: "Crosshair Cardigan",
        rus: "\u041A\u0430\u0440\u0434\u0438\u0433\u0430\u043D \u043A\u0438\u043B\u043B\u0435\u0440\u0430",
        schema: 31340,
        pol: "Sweter w dziesi\u0105tk\u0119",
        bra: "Cardig\xe3 do Ca\xe7ador",
        fre: "Cardigan du tireur",
        hun: "Sz\xe1lkeresztes Kardig\xe1n",
        sch: "\u51C6\u661F\u7F8A\u6BDB\u886B",
        swe: "Korsh\xe5rskofta"
    },
    1868: {
        img: "oktoberfester",
        eng: "Oktoberfester",
        rus: "\u041E\u043A\u0442\u043E\u0431\u0435\u0440\u0444\u0435\u0441\u0442\u0435\u0440",
        schema: 31344,
        pol: "Oktoberfestowicz",
        bra: "Oktoberfesteiro",
        fre: "Oktoberf\xeatard",
        hun: "Oktoberfest-el\u0151",
        sch: "\u5564\u9152\u72C2\u6B22\u5BA2",
        swe: "Oktoberfestare"
    },
    1869: {
        img: "the_cool_warm_sweater",
        eng: "The Cool Warm Sweater",
        rus: "\u041E\u0441\u0432\u0435\u0436\u0430\u044E\u0449\u0438\u0439 \u0441\u0432\u0438\u0442\u0435\u0440",
        schema: 31332,
        pol: "Swetrogrodniczki",
        bra: "O L\xe3-gasalho",
        fre: "Pull en laine",
        hun: "Men\u0151 Meleg Pul\xf3ver",
        sch: "\u5BD2\u51AC\u6696\u610F\u6BDB\u8863",
        swe: "Cool varm tr\xf6ja"
    },
    1870: {
        img: "ol_reliable",
        eng: "Ol' Reliable",
        rus: "\u0421\u0442\u0430\u0440\u044B\u0439 \u0434\u043E\u0431\u0440\u044B\u0439",
        schema: 31345,
        pol: "Stary niezawodny",
        bra: "Velharia Vigorosa",
        fre: "L'incassable",
        hun: "A J\xf3 \xd6reg",
        sch: "\u767E\u70BC\u6218\u76D4",
        swe: "Gamle trofast"
    },
    1871: {
        img: "underminers_overcoat",
        eng: "Underminer's Overcoat",
        rus: "\u041F\u0430\u043B\u044C\u0442\u043E \u0441\u0430\u0431\u043E\u0442\u0430\u0436\u043D\u0438\u043A\u0430",
        schema: 31334,
        pol: "P\u0142aszcz podkopywacza",
        bra: "Casac\xe3o do Construtor",
        fre: "Manteau du sapeur-minier",
        hun: "Az Al\xe1\xe1s\xf3 Fel\xf6lt\u0151je",
        sch: "\u7A74\u5C45\u602A\u5BA2",
        swe: "Gruvarbetarens \xf6verrock"
    },
    1872: {
        img: "plaid_lad",
        eng: "Plaid Lad",
        rus: "\u0411\u0440\u0430\u0442\u0430\u043D \u0432 \u0442\u0430\u0440\u0442\u0430\u043D",
        schema: 31341,
        pol: "Kraciasty kole\u015B",
        bra: "Chap\xe9u Xadrez do Escoc\xeas",
        fre: "B\xe9ret \xe9cossais",
        hun: "Sk\xf3tkock\xe1s Leg\xe9ny",
        sch: "\u82B1\u5462\u683C\u7EB9\u5C0F\u4F19",
        swe: "Skotskrutig keps"
    },
    1873: {
        img: "firebrand",
        eng: "Firebrand",
        rus: "\u0420\u0430\u0437\u0436\u0438\u0433\u0430\u0442\u0435\u043B\u044C",
        schema: 31328,
        pol: "\u017Bar powstania",
        bra: "Manifestante Flamejante",
        fre: "R\xe9volution ardente",
        hun: "\xc9getnival\xf3",
        sch: "\u53CD\u6297\u519B\u5927\u8863",
        swe: "Eldm\xe4rkt"
    },
    1874: {
        img: "frostbite_bonnet",
        eng: "Frostbite Bonnet",
        rus: "\u0423\u0442\u0435\u043F\u043B\u044F\u044E\u0449\u0438\u0439 \u0443\u0431\u043E\u0440",
        schema: 31337,
        pol: "Alpejski agent",
        bra: "Chap\xe9u do Sangue-Frio",
        fre: "Chapka rembourr\xe9e",
        hun: "Fagy\xe1ll\xf3 Us\xe1nka",
        sch: "\u8986\u971C\u76AE\u5E3D",
        swe: "Frostbiten usjanka"
    },
    1875: {
        img: "infiltrators_insulation",
        eng: "Infiltrator's Insulation",
        rus: "\u0418\u0437\u043E\u043B\u044F\u0446\u0438\u044F \u0438\u043D\u0444\u0438\u043B\u044C\u0442\u0440\u0430\u0442\u043E\u0440\u0430",
        schema: 31338,
        pol: "Izolacja infiltratora",
        bra: "Isolamento do Infiltrador",
        fre: "Sous couverture",
        hun: "Besziv\xe1rg\xf3-szigetel\xe9s",
        sch: "\u6E17\u900F\u8005\u7684\u5FA1\u5BD2\u670D",
        swe: "Infiltrat\xf6rens tr\xf6ja"
    },
    1876: {
        img: "the_wooly_pulli",
        eng: "The Wooly Pulli",
        rus: "\u041F\u0443\u043B\u044C\u0441\u043E\u0432\u044B\u0439 \u043F\u0443\u043B\u043E\u0432\u0435\u0440",
        schema: 31343,
        pol: "Krzykliwy kitel",
        bra: "O Su\xe9ter do Cirurgi\xe3o",
        fre: "Pull\xfcber",
        hun: "Gyapj\xfapulcsi",
        sch: "\u67D4\u987A\u7F8A\u6BDB\u886B",
        swe: "P-ull-over"
    },
    1877: {
        img: "colonel_kringle",
        eng: "Colonel Kringle",
        rus: "\u041F\u043E\u043B\u043A\u043E\u0432\u043D\u0438\u043A \u041A\u0440\u0438\u043D\u0433\u043B",
        schema: 31325,
        pol: "Pu\u0142kownik Kringle",
        bra: "Coronel Noel",
        fre: "Colonel No\xebl",
        hun: "T\xe9lap\xf3 Ezredes",
        sch: "\u5723\u8BDE\u4E0A\u6821",
        swe: "Kapten Klapp"
    },
    1878: {
        img: "battle_bear",
        eng: "Battle Bear",
        rus: "\u041A\u043E\u0441\u043E\u043B\u0430\u043F\u044B\u0439 \u043A\u043E\u043C\u043C\u0430\u043D\u0434\u043E",
        schema: 31324,
        pol: "Waleczny Wojtek",
        bra: "Ursinho de Guerra",
        fre: "Ourson de combat",
        hun: "Harci Maci",
        sch: "\u6218\u6597\u5C0F\u718A",
        swe: "Stridsbamse"
    },
    1879: {
        img: "motley_sleeves",
        eng: "Motley Sleeves",
        rus: "\u0420\u0430\u0437\u043D\u043E\u0446\u0432\u0435\u0442\u043D\u044B\u0435 \u0440\u0443\u043A\u0430\u0432\u0430",
        schema: 31339,
        pol: "Dziarskie dziary",
        bra: "Mangas Maneiras",
        fre: "Tatou\xe9 de partout",
        hun: "Tarka Karok",
        sch: "\u82B1\u81C2\u6DF7\u6DF7",
        swe: "Brokiga \xe4rmar"
    },
    1880: {
        img: "festive_rack",
        eng: "Festive Rack",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0435 \u0440\u043E\u0433\u0430",
        schema: 31327,
        pol: "\u015Awi\u0105teczne poro\u017Ce",
        bra: "Galhadas Festivas",
        fre: "Bois festifs",
        hun: "\xdcnnepi Agancs",
        sch: "\u8282\u65E5\u9E7F\u89D2",
        swe: "Festlig krona"
    },
    1881: {
        img: "trappers_flap",
        eng: "Trapper's Flap",
        rus: "\u0423\u0448\u0430\u043D\u043A\u0430 \u043B\u043E\u0432\u0447\u0435\u0433\u043E",
        schema: 31323,
        pol: "Uszanka trapera",
        bra: "Armadilheiro Aquecido",
        fre: "Toque du trappeur",
        hun: "Pr\xe9mvad\xe1sz Pr\xe9msapka",
        sch: "\u6355\u730E\u8005\u7684\u7ED2\u76AE\u5E3D",
        swe: "Pompongm\xf6ssa"
    },
    1882: {
        img: "taunt_russian_rubdown",
        eng: "Taunt: Russian Rubdown",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0420\u0443\u0441\u0441\u043A\u043E\u0435 \u0440\u0430\u0441\u0442\u0438\u0440\u0430\u043D\u0438\u0435",
        schema: 31320,
        pol: "Drwina: Odpicowany or\u0119\u017C",
        bra: "Provoca\xe7\xe3o: Limpeza Pesada",
        fre: "Raillerie : Astiquage \xe0 la russe.",
        hun: "Besz\xf3l\xe1s: Orosz tisztogat\xe1s",
        swe: "H\xe5n: Rysk rutin",
        sch: "\u5632\u8BBD\uFF1A\u4FC4\u5F0F\u64E6\u67AA"
    },
    1883: {
        img: "taunt_tailored_terminal",
        eng: "Taunt: Tailored Terminal",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0422\u0435\u0440\u043C\u0438\u043D\u0430\u043B \u0442\u0430\u0439\u043D",
        schema: 31321,
        pol: "Drwina: Teczkowy terminal",
        bra: "Provoca\xe7\xe3o: Terminal Port\xe1til",
        fre: "Raillerie : Terminal sur mesure.",
        hun: "Besz\xf3l\xe1s: Szem\xe9lyi termin\xe1l",
        swe: "H\xe5n: Skr\xe4ddarsydd terminal",
        sch: "\u5632\u8BBD\uFF1A\u7279\u5236\u7EC8\u7AEF"
    },
    1884: {
        img: "taunt_roasty_toasty",
        eng: "Taunt: Roasty Toasty",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041F\u043E\u043B\u043D\u0430\u044F \u043F\u0440\u043E\u0436\u0430\u0440\u043A\u0430",
        schema: 31322,
        pol: "Drwina: Pieczone pianki",
        bra: "Provoca\xe7\xe3o: Acampado e Tostado",
        fre: "Raillerie : Grillade au coin du feu.",
        hun: "Besz\xf3l\xe1s: Pir\xedt\xf3 Pir\xf3",
        swe: "H\xe5n: L\xe4gereldsmys",
        sch: "\u5632\u8BBD\uFF1A\u91CE\u5916\u70E7\u70E4"
    },
    1885: {
        img: "stealth_bomber",
        eng: "Stealth Bomber",
        rus: "\u0421\u0442\u0435\u043B\u0441-\u0431\u043E\u043C\u0431\u0430\u0440\u0434\u0438\u0440",
        schema: 31379,
        bra: "Bombardeiro Sorrateiro",
        fre: "Le pantalon camouflage",
        hun: "Lopakod\xf3 Bomb\xe1z\xf3",
        sch: "\u6F5C\u884C\u7206\u7834\u6302\u5E26",
        swe: "Smygbyxor",
        pol: "Przyczajony piechur"
    },
    1886: {
        img: "le_professionnel",
        eng: "Le Professionnel",
        rus: "\u041B\u0451 \u041F\u0440\u043E\u0444\u0435\u0441\u044C\u043E\u043D\u0435\u043B\u044C",
        schema: 31377,
        pol: "Francuski fachura",
        fre: "L\xe9on",
        sch: "\u804C\u4E1A\u8303\u5927\u8863"
    },
    1887: {
        img: "cargo_constructor",
        eng: "Cargo Constructor",
        rus: "\u0413\u0440\u043E\u0437\u0430 \u0433\u0440\u0443\u0437\u043E\u0432",
        schema: 31373,
        pol: "In\u017Cynieria inwentarza",
        fre: "Contremaitre",
        hun: "Rakod\xf3munk\xe1s",
        bra: "Construtor de Carga",
        sch: "\u8D27\u4ED3\u5EFA\u8BBE\u5DE5",
        swe: "Reflexv\xe4st"
    },
    1888: {
        img: "blast_bowl",
        eng: "The Blast Bowl",
        rus: "\u0412\u0438\u0437\u043E\u0440 \u0432\u0437\u0440\u044B\u0432\u043D\u0438\u043A\u0430",
        schema: 31371,
        pol: "Samoprzylepny szyszak",
        bra: "O Capacete de Stickies",
        fre: "La t\xeate dure",
        hun: "Bombasisak",
        sch: "\u7206\u5F39\u5706\u9876\u76D4",
        swe: "Risktagarn"
    },
    1889: {
        img: "heavy_metal",
        eng: "Heavy Metal",
        rus: "\u0422\u044F\u0436\u0451\u043B\u044B\u0439 \u043C\u0435\u0442\u0430\u043B\u043B",
        schema: 31369,
        pol: "Metal ci\u0119\u017Cki",
        fre: "Heavy m\xe9tal",
        sch: "\u91CD\u91D1\u5C5E\u5939\u514B"
    },
    1890: {
        img: "brimmed_bootlegger",
        eng: "Brimmed Bootlegger",
        rus: "\u0424\u0435\u0442\u0440\u043E\u0432\u044B\u0439 \u0430\u0444\u0435\u0440\u0438\u0441\u0442",
        schema: 31366,
        pol: "Kapeluszowa kontrabanda",
        bra: "Fora-da-Lei Seca",
        fre: "F\xe9dora du contrebandier",
        hun: "Karim\xe1s Szeszcsemp\xe9sz",
        sch: "\u79C1\u9152\u8D29\u8FD0\u5546",
        swe: "Hembr\xe4nnaren"
    },
    1891: {
        img: "medical_emergency",
        eng: "Medical Emergency",
        rus: "\u041D\u0435\u043E\u0442\u043B\u043E\u0436\u043D\u0430\u044F \u043F\u043E\u043C\u043E\u0449\u044C",
        schema: 31365,
        pol: "Pierwsza pomoc",
        bra: "Emerg\xeancia M\xe9dica",
        fre: "Urgence m\xe9dicale",
        hun: "Orvosi V\xe9szhelyzet",
        sch: "\u533B\u7597\u6025\u6551\u5305",
        swe: "N\xf6dsituation"
    },
    1892: {
        img: "bushman",
        eng: "The Bushman",
        rus: "\u041B\u044E\u0431\u0438\u0442\u0435\u043B\u044C \u0437\u0430\u0440\u043E\u0441\u043B\u0435\u0439",
        schema: 31361,
        pol: "Buszmen",
        bra: "O Homem Robusto do Arbusto",
        fre: "Le bushman",
        hun: "Boz\xf3tj\xe1r\xf3",
        sch: "\u4E1B\u6797\u731B\u7537",
        swe: "Bushmannen"
    },
    1893: {
        img: "firestalker",
        eng: "The Firestalker",
        rus: "\u0412\u043E\u0441\u043F\u043B\u0430\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u043B\u0438\u0447\u043D\u043E\u0441\u0442\u0438",
        schema: 31359,
        pol: "P\u0142omienny prze\u015Bladowca",
        bra: "O Detetive Elementar",
        fre: "Le d\xe9tective chaud bouillant",
        hun: "T\u0171zvad\xe1sz",
        sch: "\u706B\u573A\u5BC6\u5BA2",
        swe: "Element\xe4r m\xf6ssa"
    },
    1894: {
        img: "brothers_in_blues",
        eng: "Brothers in Blues",
        rus: "\u0411\u0440\u0430\u0442\u044C\u044F \u043F\u043E \u0431\u043B\u044E\u0437\u0443",
        schema: 31356,
        pol: "Bracia w bluesie",
        bra: "Chap\xe9u do Cara de Pau",
        fre: "Les BLU Brothers",
        hun: "Blues Testv\xe9rek",
        sch: "\u84DD\u8C03\u5144\u5F1F\u5E3D",
        swe: "Bluesbr\xf6der"
    },
    1895: {
        img: "prohibition_opposition",
        eng: "Prohibition Opposition",
        rus: "\u041D\u0435\u043B\u044E\u0431\u0438\u0442\u0435\u043B\u044C \u0437\u0430\u043F\u0440\u0435\u0442\u0438\u0442\u0435\u043B\u0435\u0439",
        schema: 31367,
        pol: "Przeciwnik prohibicji",
        bra: "Oposi\xe7\xe3o \xe0 Proibi\xe7\xe3o",
        fre: "Antiprohibition",
        hun: "Tilalomellenz\u0151",
        sch: "\u7981\u9152\u53CD\u5BF9\u6D3E",
        swe: "F\xf6rbudsmotst\xe5nd"
    },
    1896: {
        img: "preventative_measure",
        eng: "Preventative Measure",
        rus: "\u041F\u0440\u0435\u0432\u0435\u043D\u0442\u0438\u0432\u043D\u0430\u044F \u043C\u0435\u0440\u0430",
        schema: 31363,
        pol: "\u015Arodek zapobiegawczy",
        bra: "Medida Preventiva",
        fre: "Mesure pr\xe9ventive",
        hun: "Megel\u0151z\u0151 Int\xe9zked\xe9s",
        sch: "\u6709\u5907\u65E0\u60A3\u80CC\u5FC3",
        swe: "F\xf6rebyggande \xe5tg\xe4rd"
    },
    1897: {
        img: "hazard_handler",
        eng: "Hazard Handler",
        rus: "\u0417\u0430\u0449\u0438\u0442\u043D\u043E\u0435 \u0437\u0430\u0431\u0440\u0430\u043B\u043E",
        schema: 31374,
        pol: "Ryzykowna robota",
        bra: "Equipamento de Prote\xe7\xe3o Total",
        fre: "Visi\xe8re \xe0 toute \xe9preuve",
        hun: "Vesz\xe9lykezel\u0151",
        sch: "\u5371\u9669\u54C1\u5904\u7406\u5458",
        swe: "S\xe4kerhetsansvarig"
    },
    1898: {
        img: "soho_sleuth",
        eng: "The Soho Sleuth",
        rus: "\u0421\u044B\u0449\u0438\u043A \u0438\u0437 \u0421\u043E\u0445\u043E",
        schema: 31358,
        pol: "Wywiad z Westminster",
        bra: "Investigador Londrino",
        fre: "Le limier londonien",
        hun: "Soh\xf3i Szimat",
        sch: "\u82CF\u8C6A\u795E\u63A2",
        swe: "Snokrock"
    },
    1899: {
        img: "close_quarters_cover",
        eng: "Close Quarters Cover",
        rus: "\u041F\u0430\u0442\u0440\u0438\u043E\u0442 \u043F\u043E\u0434 \u043F\u0440\u0438\u043A\u0440\u044B\u0442\u0438\u0435\u043C",
        schema: 31378,
        pol: "Bandana bliskiej batalii",
        bra: "Semblante S\xf3lido da Serpente",
        fre: "Combat rapproch\xe9",
        hun: "K\xf6zelharci Fedez\xe9k",
        sch: "\u8FD1\u8EAB\u5934\u5E26",
        swe: "N\xe4rsynt pannband"
    },
    1900: {
        img: "hog_heels",
        eng: "Hog Heels",
        rus: "\u0411\u0430\u0439\u043A\u0435\u0440\u0441\u043A\u0438\u0435 \u0431\u043E\u0442\u044B",
        schema: 31370,
        pol: "Okucie oprycha",
        fre: "Bottes de baroudeur",
        hun: "S\xe1rdagaszt\xf3",
        bra: "Moda do Motoqueiro",
        sch: "\u673A\u8F66\u94C1\u8E44\u9774",
        swe: "Hojklackat"
    },
    1901: {
        img: "shrapnel_shell",
        eng: "The Shrapnel Shell",
        rus: "\u041F\u043E\u0434\u0440\u044B\u0432\u043D\u043E\u0439 \u043F\u0430\u043D\u0446\u0438\u0440\u044C",
        schema: 31372,
        pol: "Od\u0142amkowe odzienie",
        bra: "A Estileira Stickeira",
        fre: "La cuirasse coriace",
        hun: "Tapad\xf3bomba H\xe9j",
        sch: "\u7206\u5F39\u643A\u884C\u5177",
        swe: "Splitterskal"
    },
    1902: {
        img: "cleaners_cap",
        eng: "Cleaner's Cap",
        rus: "\u0428\u0430\u043F\u043A\u0430 \u0447\u0438\u0441\u0442\u0438\u043B\u044C\u0449\u0438\u043A\u0430",
        schema: 31376,
        pol: "Czapka czy\u015Bciciela",
        bra: "Touca do Assassino",
        fre: "Bonnet de l'assassin",
        hun: "Takar\xedt\xf3sapka",
        sch: "\u8083\u6E05\u8005\u7684\u5E3D\u5B50",
        swe: "Undanr\xf6jarens keps"
    },
    1903: {
        img: "brother_mann",
        eng: "Brother Mann",
        rus: "\u0411\u0440\u0430\u0442\u043E\u043A \u0441 \u0434\u043E\u0440\u043E\u0433",
        schema: 31368,
        pol: "Za Mann brat",
        fre: "Le biker",
        hun: "Mann Testv\xe9r",
        bra: "Mano Mann",
        sch: "\u66FC\u6069\u8001\u54E5",
        swe: "Broder Mann"
    },
    1904: {
        img: "cranium_cover",
        eng: "Cranium Cover",
        rus: "\u0417\u0430\u0449\u0438\u0442\u0430 \u0434\u043B\u044F \u0437\u0430\u0442\u044B\u043B\u043A\u0430",
        schema: 31362,
        pol: "Przes\u0142ona potylicy",
        bra: "A\xe7\xe3o Defensiva",
        fre: "Couverture cr\xe2nienne",
        hun: "Koponyafed\xe9l",
        sch: "\u9996\u7EA7\u9632\u62A4\u5934\u76D4",
        swe: "Kraniumskydd"
    },
    1905: {
        img: "uber_wear",
        eng: "\xdcber-Wear",
        rus: "\u0423\u0431\u0435\u0440-\u043D\u0430\u0440\u044F\u0434",
        schema: 31364,
        pol: "\xdcberubranie",
        bra: "\xdcbercolete",
        fre: "S\xfcber classe",
        hun: "\xdcber-Viselet",
        sch: "\u8D85\u80FD\u9A6C\u7532",
        swe: "\xdcber-kl\xe4der"
    },
    1906: {
        img: "flame_warrior",
        eng: "The Flame Warrior",
        rus: "\u0412\u043E\u0438\u043D \u043E\u0433\u043D\u044F",
        schema: 31357,
        pol: "\u017Barz\u0105cy \u017Co\u0142nierz",
        bra: "Guerreiro das Chamas",
        fre: "Le guerrier tout feu tout flamme",
        hun: "L\xe1ngharcos",
        sch: "\u706B\u7130\u6B66\u58EB",
        swe: "Flamma"
    },
    1907: {
        img: "glorious_gambeson",
        eng: "The Glorious Gambeson",
        rus: "\u0421\u043B\u0430\u0432\u043D\u0430\u044F \u0441\u0442\u0451\u0433\u0430\u043D\u043A\u0430",
        schema: 31360,
        pol: "Pierwszorz\u0119dna przeszywanica",
        bra: "O Gib\xe3o Glorioso",
        fre: "Le joli jaque",
        hun: "Dics\u0151 Dolm\xe1ny",
        sch: "\u626C\u540D\u6218\u7532",
        swe: "H\xe4rlig gambeson"
    },
    1908: {
        img: "full_metal_helmet",
        eng: "Full Metal Helmet",
        rus: "\u0426\u0435\u043B\u044C\u043D\u043E\u043C\u0435\u0442\u0430\u043B\u043B\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0448\u043B\u0435\u043C",
        schema: 31355,
        pol: "\u017Belazne zapasy",
        bra: "Capacete Nascido para Matar",
        fre: "Casque fourre-tout",
        hun: "K\u0151kem\xe9ny F\xe9msisak",
        sch: "\u5168\u91D1\u5C5E\u5934\u76D4",
        swe: "Helmantlad hj\xe4lm"
    },
    1909: {
        img: "cranium_cooler",
        eng: "Cranium Cooler",
        rus: "\u041A\u0440\u0430\u043D\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u043A\u0443\u043B\u0435\u0440",
        schema: 31375,
        pol: "Sch\u0142odzona skro\u0144",
        bra: "Cabe\xe7a Fria",
        fre: "Ventilo frontal",
        hun: "Koponyah\u0171t\u0151",
        sch: "\u9996\u7EA7\u6563\u70ED\u76D4",
        swe: "Kraniumkylare"
    },
    1910: {
        img: "secretly_serviced_war_paint",
        eng: "Secretly Serviced War Paint",
        rus: '"\u0421\u0435\u043A\u0440\u0435\u0442\u043D\u0430\u044F \u0441\u043B\u0443\u0436\u0431\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17412,
        pol: "Sekretny serwis Barwy wojenne",
        bra: "| Servi\xe7o Secreto | Tinta de Guerra",
        fre: "Services secrets Peinture de guerre",
        hun: "Titkosszolg\xe1lati Harci fest\xe9s",
        swe: "Hemlig elegans Krigsf\xe4rg",
        sch: "\u5BC6\u63A2\u7279\u4F9B \u6218\u7ED8"
    },
    1911: {
        img: "pacific_peacemaker_war_paint",
        eng: "Pacific Peacemaker War Paint",
        rus: '"\u0422\u0438\u0445\u043E\u043E\u043A\u0435\u0430\u043D\u0441\u043A\u0438\u0439 \u0442\u0438\u0445\u043E\u043D\u044F" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17419,
        pol: "Pacyficzny pacyfista Barwy wojenne",
        bra: "| Pacificador do Pac\xedfico | Tinta de Guerra",
        fre: "Pacificateur du Pacifique Peinture de guerre",
        hun: "B\xe9k\xe9s B\xe9k\xe9ltet\u0151 Harci fest\xe9s",
        swe: "S\xf6derhavets fredsm\xe4klare Krigsf\xe4rg",
        sch: "\u592A\u5E73\u6D0B\u548C\u5E73\u4F7F\u8005 \u6218\u7ED8"
    },
    1912: {
        img: "team_serviced_war_paint",
        eng: "Team Serviced War Paint",
        rus: '"\u041A\u043E\u043C\u0430\u043D\u0434\u043D\u0430\u044F \u0441\u043B\u0443\u0436\u0431\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17417,
        pol: "Praca zespo\u0142owa Barwy wojenne",
        bra: "| Agente de Campo | Tinta de Guerra",
        fre: "Au service de l'\xe9quipe Peinture de guerre",
        hun: "Csapatszolg\xe1lati Harci fest\xe9s",
        swe: "Laganda Krigsf\xe4rg",
        sch: "\u56E2\u961F\u6548\u529B \u6218\u7ED8"
    },
    1913: {
        img: "bomb_carrier_war_paint",
        eng: "Bomb Carrier War Paint",
        rus: '"\u0411\u043E\u043C\u0431\u043E\u043D\u043E\u0441\u0435\u0446" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17414,
        pol: "Przenosz\u0105cy bomb\u0119 Barwy wojenne",
        bra: "| Demoli\xe7\xe3o Blindada | Tinta de Guerra",
        fre: "Machine de guerre Peinture de guerre",
        hun: "Bombahordoz\xf3 Harci fest\xe9s",
        swe: "Bombhangar Krigsf\xe4rg",
        sch: "\u70B8\u5F39\u8FD0\u5BA2 \u6218\u7ED8"
    },
    1914: {
        img: "mechanized_monster_war_paint",
        eng: "Mechanized Monster War Paint",
        rus: '"\u041C\u0435\u0445\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043C\u043E\u043D\u0441\u0442\u0440" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17420,
        pol: "Mechaniczne monstrum Barwy wojenne",
        bra: "| Monstro Mecanizado | Tinta de Guerra",
        fre: "Monstre m\xe9canis\xe9 Peinture de guerre",
        hun: "G\xe9pes\xedtett Sz\xf6rny Harci fest\xe9s",
        swe: "Mekaniserat monster Krigsf\xe4rg",
        sch: "\u673A\u68B0\u9020\u7269 \u6218\u7ED8"
    },
    1915: {
        img: "warborn_war_paint",
        eng: "Warborn War Paint",
        rus: '"\u0420\u043E\u0436\u0434\u0451\u043D\u043D\u044B\u0439 \u0432 \u0431\u043E\u044E" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17418,
        pol: "Zrodzony z wojny Barwy wojenne",
        bra: "| Nascido para Matar | Tinta de Guerra",
        fre: "Destin de guerre Peinture de guerre",
        hun: "H\xe1bor\xfas Harci fest\xe9s",
        swe: "Krigsf\xf6dd Krigsf\xe4rg",
        sch: "\u6218\u4E89\u4E4B\u5B50 \u6218\u7ED8"
    },
    1916: {
        img: "steel_brushed_war_paint",
        eng: "Steel Brushed War Paint",
        rus: '"\u041C\u0430\u0442\u043E\u0432\u0430\u044F \u0441\u0442\u0430\u043B\u044C" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17411,
        pol: "Stalowy szlif Barwy wojenne",
        bra: "| Banho de Prata | Tinta de Guerra",
        fre: "Acier Peinture de guerre",
        hun: "Sz\xe1lcsiszolt Harci fest\xe9s",
        swe: "St\xe5lborstad Krigsf\xe4rg",
        sch: "\u4E0D\u9508\u94A2 \u6218\u7ED8"
    },
    1917: {
        img: "business_class_war_paint",
        eng: "Business Class War Paint",
        rus: '"\u0411\u0438\u0437\u043D\u0435\u0441-\u043A\u043B\u0430\u0441\u0441" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17415,
        pol: "Klasa biznesowa Barwy wojenne",
        bra: "| Classe Executiva | Tinta de Guerra",
        fre: "Classe affaires Peinture de guerre",
        hun: "Els\u0151 Oszt\xe1ly Harci fest\xe9s",
        swe: "Aff\xe4rsklass Krigsf\xe4rg",
        sch: "\u8D44\u4EA7\u9636\u7EA7 \u6218\u7ED8"
    },
    1918: {
        img: "deadly_dragon_war_paint",
        eng: "Deadly Dragon War Paint",
        rus: '"\u042F\u0440\u043E\u0441\u0442\u043D\u044B\u0439 \u044F\u0449\u0435\u0440" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17416,
        pol: "Zab\xf3jczy smok Barwy wojenne",
        bra: "| Destrui\xe7\xe3o do Drag\xe3o | Tinta de Guerra",
        fre: "Dragon mortel Peinture de guerre",
        hun: "Hal\xe1los S\xe1rk\xe1ny Harci fest\xe9s",
        swe: "D\xf6dlig drake Krigsf\xe4rg",
        sch: "\u6B7B\u4EA1\u4E4B\u9F99 \u6218\u7ED8"
    },
    1919: {
        img: "sky_stallion_war_paint",
        eng: "Sky Stallion War Paint",
        rus: '"\u0416\u0435\u043B\u0435\u0437\u043D\u044B\u0439 \u0436\u0435\u0440\u0435\u0431\u0435\u0446" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        schema: 17413,
        pol: "Podniebny ogier Barwy wojenne",
        bra: "| \xc1s do Ar | Tinta de Guerra",
        fre: "\xc9talon c\xe9leste Peinture de guerre",
        hun: "\xc9gi M\xe9n Harci fest\xe9s",
        swe: "Himmelshingsten Krigsf\xe4rg",
        sch: "\u7A7A\u4E2D\u731B\u7537 \u6218\u7ED8"
    },
    1920: {
        img: "taunt_killer_joke",
        eng: "Taunt: Killer Joke",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0423\u0431\u043E\u0439\u043D\u0430\u044F \u0448\u0443\u0442\u043A\u0430",
        schema: 31348,
        pol: "Drwina: Zab\xf3jczy \u017Cart",
        bra: "Provoca\xe7\xe3o: Piada de Matar",
        fre: "Raillerie : Mort de rire",
        hun: "Besz\xf3l\xe1s: Durva vicces",
        swe: "H\xe5n: Galghumor",
        sch: "\u5632\u8BBD\uFF1A\u81F4\u547D\u73A9\u7B11"
    },
    1921: {
        img: "taunt_star_spangled_strategy",
        eng: "Taunt: Star-Spangled Strategy",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0417\u0432\u0451\u0437\u0434\u043D\u043E-\u043F\u043E\u043B\u043E\u0441\u0430\u0442\u044B\u0439 \u043F\u043B\u0430\u043D",
        schema: 31347,
        pol: "Drwina: Strategia na pi\u0119\u0107dziesi\u0105t gwiazdek",
        bra: "Provoca\xe7\xe3o: Plano Infal\xedvel",
        fre: "Raillerie : Strat\xe9gie \xe9toil\xe9e",
        hun: "Besz\xf3l\xe1s: Csillagos-s\xe1vos strat\xe9gia",
        swe: "H\xe5n: Soldatstrategi",
        sch: "\u5632\u8BBD\uFF1A\u661F\u6761\u65D7\u6218\u672F"
    },
    1922: {
        img: "taunt_head_doctor",
        eng: "Taunt: The Head Doctor",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0412\u0440\u0430\u0447 \u0441 \u0433\u043E\u043B\u043E\u0432\u043E\u0439",
        schema: 31349,
        pol: "Drwina: Dekapitacyjny doktor",
        bra: "Provoca\xe7\xe3o: O M\xe9dico da Cabe\xe7a",
        fre: "Raillerie : Le docteur a la grosse t\xeate",
        hun: "Besz\xf3l\xe1s: A f\u0151orvos",
        swe: "H\xe5n: Huvudl\xe4karen",
        sch: "\u5632\u8BBD\uFF1A\u5934\u75DB\u533B\u5934"
    },
    1923: {
        img: "taunt_teufort_tango",
        eng: "Taunt: Teufort Tango",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0422\u0443\u0444\u043E\u0440\u0442\u0441\u043A\u043E\u0435 \u0442\u0430\u043D\u0433\u043E",
        schema: 31351,
        pol: "Drwina: Teuforckie tango",
        bra: "Provoca\xe7\xe3o: Tango de Teufort",
        fre: "Raillerie : Tango de Teufort",
        hun: "Besz\xf3l\xe1s: Teufort tang\xf3",
        swe: "H\xe5n: Teufort-tango",
        sch: "\u5632\u8BBD\uFF1A\u53CC\u57CE\u63A2\u6208"
    },
    1924: {
        img: "taunt_road_rager",
        eng: "Taunt: The Road Rager",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041B\u044E\u0442\u044B\u0439 \u043B\u0438\u0445\u0430\u0447",
        schema: 31352,
        pol: "Drwina: Krzycz\u0105cy kierowca",
        bra: "Provoca\xe7\xe3o: O Perigo na Estrada",
        fre: "Raillerie : Le cacou de la route",
        hun: "Besz\xf3l\xe1s: Orsz\xe1g\xfati d\xfch\xf6ng\u0151",
        swe: "H\xe5n: V\xe4gbusen",
        sch: "\u5632\u8BBD\uFF1A\u516C\u8DEF\u6076\u9738"
    },
    1925: {
        img: "taunt_killer_signature",
        eng: "Taunt: The Killer Signature",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041F\u043E\u0447\u0435\u0440\u043A \u0443\u0431\u0438\u0439\u0446\u044B",
        schema: 31354,
        pol: "Drwina: Zab\xf3jczy podpis",
        bra: "Provoca\xe7\xe3o: Agrado aos Admiradores",
        fre: "Raillerie : La signature meurtri\xe8re",
        hun: "Besz\xf3l\xe1s: D\xf6gleszt\u0151 szign\xf3",
        swe: "H\xe5n: Rama in det",
        sch: "\u5632\u8BBD\uFF1A\u6740\u624B\u7B7E\u540D"
    },
    1926: {
        img: "make_ogre",
        eng: "Make Ogre",
        rus: "\u041F\u0440\u0435\u043E\u0433\u0440\u0430\u0436\u0435\u043D\u0438\u0435",
        schema: 31403,
        pol: "Ogromorfoza",
        bra: "Harmoniza\xe7\xe3o Ogr\xedvel",
        fre: "M\xe9tamorphogre",
        hun: "Ogresszivit\xe1s",
        sch: "\u98DF\u4EBA\u9B54\u9762\u76EE",
        swe: "F\xf6rtrollande look"
    },
    1927: {
        img: "medical_mummy",
        eng: "Medical Mummy",
        rus: "\u041C\u0435\u0434\u0438\u0446\u0438\u043D\u0441\u043A\u0430\u044F \u043C\u0443\u043C\u0438\u044F",
        schema: 31399,
        pol: "Medyczna mumia",
        bra: "M\xfamia M\xe9dica",
        fre: "Mommie m\xe9dicale",
        hun: "Orvosi M\xfamia",
        sch: "\u533B\u7528\u6728\u4E43\u4F0A",
        swe: "Medicinsk mumie"
    },
    1928: {
        img: "six_eyed_specs",
        eng: "Six-Eyed Specs",
        rus: "\u0428\u0435\u0441\u0442\u0438\u0433\u043B\u0430\u0437\u044B\u0439 \u0448\u043F\u0438\u043E\u043D",
        schema: 31398,
        pol: "Sze\u015Bciooki",
        bra: "S\xe3o Seis Olhos",
        fre: "Verres hexoculaires",
        hun: "Hatszem-optika",
        sch: "\u516D\u773C\u76EE\u955C",
        swe: "Spindelbrillor"
    },
    1929: {
        img: "concealed_convict",
        eng: "Concealed Convict",
        rus: "\u0420\u043E\u0431\u0430 \u0440\u0435\u0446\u0438\u0434\u0438\u0432\u0438\u0441\u0442\u0430",
        schema: 31397,
        pol: "Schowany skazaniec",
        bra: "Condenado Camuflado",
        fre: "Prisonnier planqu\xe9",
        hun: "Fedett Fegyenc",
        sch: "\u533F\u8FF9\u56DA\u5F92",
        swe: "Diskret f\xe5nge"
    },
    1930: {
        img: "constructors_cover",
        eng: "Constructor's Cover",
        rus: "\u041A\u043E\u0441\u0442\u044E\u043C \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u043E\u0440\u0430",
        schema: 31395,
        pol: "Kamizelka konstruktora",
        bra: "Cobertura do Construtor",
        fre: "Cuirasse du contremaitre",
        hun: "Szerel\u0151-szerel\xe9s",
        sch: "\u7CBE\u5DE5\u7EC6\u7B51\u7532",
        swe: "Byggarens beskydd"
    },
    1931: {
        img: "thunder_dome",
        eng: "Thunder Dome",
        rus: "\u0413\u0440\u043E\u043C\u043E\u0432\u043E\u0439 \u043A\u0443\u043C\u043F\u043E\u043B",
        schema: 31391,
        pol: "Hukowy he\u0142m",
        bra: "C\xfapula do Trov\xe3o",
        fre: "Casque du tonnerre",
        hun: "Viharkupola",
        sch: "\u96F7\u9706\u5706\u76D4",
        swe: "Dunderkruka"
    },
    1932: {
        img: "splitting_headache",
        eng: "Splitting Headache",
        rus: "\u0420\u0430\u0437\u0434\u0432\u043E\u0435\u043D\u0438\u0435 \u043B\u0438\u0447\u043D\u043E\u0441\u0442\u0438",
        schema: 31390,
        pol: "Przeszywaj\u0105cy b\xf3l",
        bra: "Mente Afiada",
        fre: "Lame de t\xeate",
        hun: "Hasogat\xf3 Fejf\xe1j\xe1s",
        sch: "\u5934\u75DB\u952F\u88C2",
        swe: "Splittrande huvudv\xe4rk"
    },
    1933: {
        img: "shortness_of_breath",
        eng: "Shortness Of Breath",
        rus: "\u0423\u0434\u0443\u0448\u0438\u0442\u0435\u043B\u044C",
        schema: 31387,
        pol: "Bezdech",
        bra: "Falta de Ar",
        fre: "Souffle court",
        hun: "L\xe9gszomj",
        sch: "\u7EDD\u606F\u9762\u5177",
        swe: "Andn\xf6d"
    },
    1934: {
        img: "mean_captain",
        eng: "Mean Captain",
        rus: "\u041E\u043A\u043A\u0443\u043B\u044C\u0442\u043D\u044B\u0439 \u043E\u0444\u0438\u0446\u0435\u0440",
        schema: 31385,
        pol: "Karygodny kapitan",
        bra: "O Capet\xe3o da Equipe",
        fre: "Capitaine cornu",
        hun: "A Gonoszkapit\xe1ny",
        sch: "\u5351\u9119\u9886\u8896\u4E4B\u5E3D",
        swe: "Obehagskaptenen"
    },
    1935: {
        img: "ludicrously_lunatic_lunon_fedora",
        eng: "Ludicrously Lunatic Lunon Fedora",
        rus: "\u0421\u043C\u0435\u0445\u043E\u0442\u0432\u043E\u0440\u043D\u043E \u0441\u0443\u043C\u0430\u0441\u0448\u0435\u0434\u0448\u0430\u044F \u0441\u0438\u044F\u044E\u0449\u0430\u044F \u0444\u0435\u0434\u043E\u0440\u0430",
        schema: 31383,
        pol: "Niedorzecznie na\u015Bwietlona freonowa fedora",
        bra: "Fedora de Lun\xf4nio Loucamente Lun\xe1tico",
        fre: "Loufoque et lunatique fedora fluo",
        hun: "F\xf6l\xf6tt\xe9bb Fantasztikus F\xe9nyl\u0151 Fedora",
        sch: "\u9646\u79BB\u5149\u602A\u4E4B\u6708\u6676\u8F6F\u5462\u5E3D",
        swe: "Bef\xe4ngd lunonfedora"
    },
    1936: {
        img: "jumping_jester",
        eng: "Jumping Jester",
        rus: "\u0428\u0443\u0441\u0442\u0440\u044B\u0439 \u0448\u0443\u0442",
        schema: 31407,
        pol: "Podskakuj\u0105cy pajac",
        bra: "Buf\xe3o Brincalh\xe3o",
        fre: "Bouffon bondissant",
        hun: "Pattog\xf3 Boh\xf3c",
        sch: "\u8DC3\u52A8\u5C0F\u4E11",
        swe: "Hoppande hovnarr"
    },
    1937: {
        img: "sharpshooters_shroud",
        eng: "Sharpshooter's Shroud",
        rus: "\u041C\u0430\u043D\u0442\u0438\u044F \u043C\u0435\u0442\u043A\u043E\u0441\u0442\u0438",
        schema: 31405,
        pol: "Ca\u0142un celowniczego",
        bra: "Fachada do Feiticeiro",
        fre: "Tabar du tireur",
        hun: "Mesterl\xf6v\xe9sz-k\xf6p\xf6nyeg",
        sch: "\u795E\u5C04\u624B\u7684\u62AB\u98CE",
        swe: "Skarpskyttens cape"
    },
    1938: {
        img: "main_cast",
        eng: "Main Cast",
        rus: "\u041C\u043D\u043E\u0436\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u043F\u0435\u0440\u0435\u043B\u043E\u043C",
        schema: 31400,
        pol: "Gruby gips",
        bra: "O Gesso Espesso",
        fre: "Pl\xe2tre principal",
        hun: "\xd6ngy\xf3gy\xedt\xf3",
        sch: "\u904D\u4F53\u77F3\u818F",
        swe: "Gipsf\xf6rband"
    },
    1939: {
        img: "classic_criminal",
        eng: "Classic Criminal",
        rus: "\u041A\u043B\u0430\u0441\u0441\u0438\u043A\u0430 \u043A\u0440\u0438\u043C\u0438\u043D\u0430\u043B\u0430",
        schema: 31396,
        pol: "Klasyczny kryminalista",
        bra: "Criminoso Cl\xe1ssico",
        fre: "Criminel classique",
        hun: "Klasszikus B\u0171n\xf6z\u0151",
        sch: "\u5178\u578B\u60EF\u72AF",
        swe: "Klassisk kriminell"
    },
    1940: {
        img: "dell_dynamic",
        eng: "Dell Dynamic",
        rus: "\u0414\u0438\u043D\u0430\u043C\u043E-\u0414\u0435\u043B\u043B",
        schema: 31394,
        pol: "Dynamiczny Dell",
        bra: "Dell Din\xe2mico",
        fre: "Dell dynamique",
        hun: "Dinamikus Dell",
        sch: "\u7FF1\u7FD4\u52A8\u529B\u76D4",
        swe: "Dynamiska Dell"
    },
    1941: {
        img: "stunt_suit",
        eng: "Stunt Suit",
        rus: "\u041A\u043E\u0441\u0442\u044E\u043C \u043A\u0430\u0441\u043A\u0430\u0434\u0451\u0440\u0430",
        schema: 31392,
        pol: "Konfekcja kaskadera",
        bra: "Traje do Acrobata",
        fre: "Tenue de cascadeur",
        hun: "Kaszkad\u0151rruha",
        sch: "\u70AB\u76EE\u6218\u8863",
        swe: "Stuntdr\xe4kt"
    },
    1942: {
        img: "dead_heat",
        eng: "Dead Heat",
        rus: "\u0423\u0431\u0438\u0439\u0441\u0442\u0432\u0435\u043D\u043D\u0430\u044F \u0436\u0430\u0440\u0430",
        pol: "Gor\u0105czka \u015Bmierci",
        sch: "\u711A\u706D\u70BD\u94C1",
        bra: "Face da Fornalha",
        fre: "Chaleur mortelle",
        hun: "Forr\xf3 v\xe9rf\xfcrd\u0151",
        swe: "D\xf6dshet",
        schema: 31389
    },
    1943: {
        img: "warlocks_warcloak",
        eng: "Warlock's Warcloak",
        rus: "\u041D\u0430\u043A\u0438\u0434\u043A\u0430 \u043D\u0435\u043A\u0440\u043E\u043C\u0430\u043D\u0442\u0430",
        schema: 31388,
        pol: "Peleryna prestidigitatora",
        bra: "Manto do Mago",
        fre: "Cape du sorcier belliqueux",
        hun: "Csatam\xe1gusi Csatak\xf6peny",
        sch: "\u6218\u5DEB\u6218\u888D",
        swe: "Trollkarlens krigsmantel"
    },
    1944: {
        img: "clowns_coverup",
        eng: "Clown's Cover-Up",
        rus: "\u041A\u043B\u043E\u0443\u043D \u043F\u043E\u0434 \u043F\u0440\u0438\u043A\u0440\u044B\u0442\u0438\u0435\u043C",
        schema: 31386,
        pol: "Skryty \u015Bmieszek",
        bra: "Cobertura Circense",
        fre: "Masque de clown",
        hun: "Boh\xf3c\xe1lca",
        sch: "\u5C0F\u4E11\u5316\u8EAB",
        swe: "Clownfeja"
    },
    1945: {
        img: "mad_lad",
        eng: "Mad Lad",
        rus: "\u0411\u0435\u0437\u0443\u043C\u043D\u044B\u0439 \u043F\u0430\u0440\u0435\u043D\u044C",
        schema: 31393,
        pol: "Szaleniec",
        bra: "Farda da Estrada",
        fre: "Maboul",
        hun: "\u0150r\xfclt Leg\xe9ny",
        sch: "\u706B\u7206\u6012\u6C49",
        swe: "Token"
    },
    1946: {
        img: "last_laugh",
        eng: "Last Laugh",
        rus: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 \u0441\u043C\u0435\u0445",
        schema: 31406,
        pol: "Kto si\u0119 \u015Bmieje ostatni",
        bra: "A \xdaltima Risada",
        fre: "Qui rira le dernier",
        hun: "Az Utols\xf3 Nevet\xe9s",
        sch: "\u7B11\u5230\u6700\u540E",
        swe: "Sista skrattet"
    },
    1947: {
        img: "sightseer",
        eng: "Sightseer",
        rus: "\u042F\u0441\u043D\u043E\u0432\u0438\u0434\u0435\u0446",
        schema: 31404,
        pol: "Jasnowidz",
        bra: "Assassino Arcano",
        fre: "Chapeau pointu",
        hun: "Messzel\xe1t\xf3",
        sch: "\u900F\u89C6\u5148\u77E5",
        swe: "Allseende siare"
    },
    1948: {
        img: "power_spike",
        eng: "Power Spike",
        rus: "\u0428\u043E\u043A-\u0448\u0435\u0432\u0435\u043B\u044E\u0440\u0430",
        schema: 31401,
        pol: "Skok mocy",
        bra: "Penteado Potente",
        fre: "Survoltage",
        hun: "\xc1raml\xf6ket",
        sch: "\u8D85\u7EA7\u523A\u732C\u5934",
        swe: "Sp\xe4nnande spret"
    },
    1949: {
        img: "demonic_dome",
        eng: "Demonic Dome",
        rus: "\u0427\u0451\u0440\u0442\u043E\u0432 \u0447\u0435\u0440\u0435\u043F",
        schema: 31384,
        pol: "Szata\u0144skie sklepienie",
        bra: "Domo Demon\xedaco",
        fre: "Casque d\xe9moniaque",
        hun: "D\xe9moni B\xfara",
        sch: "\u9B54\u65CF\u9885\u76D4",
        swe: "Demonisk hj\xe4lm"
    },
    1950: {
        img: "bare_bear_bones",
        eng: "Bare Bear Bones",
        rus: "\u041C\u0438\u0448\u0443\u0442\u043A\u0438\u043D\u0430 \u0447\u0435\u0440\u0435\u043F\u0443\u0448\u043A\u0430",
        schema: 31402,
        pol: "Nie\u017Cywy nied\u017Awied\u017A",
        bra: "Osso de Urso Grosso",
        fre: "Cr\xe2ne d'ours",
        hun: "Medvekoponya",
        sch: "\u96C4\u5A01\u718A\u9AA8",
        swe: "Bara bj\xf6rnben"
    },
    1951: {
        img: "blastphomet",
        eng: "Blastphomet",
        rus: "\u0411\u0430\u0445\u043E\u043C\u0435\u0442",
        schema: 31408,
        pol: "Bombomet",
        bra: "Bafom\xe9 das Bombas",
        fre: "Boumphomet",
        sch: "\u7206\u98CE\u7279"
    },
    1952: {
        img: "spyder",
        eng: "Spyder",
        rus: "\u0428\u043F\u0430\u0443\u043A",
        schema: 31409,
        pol: "Szpaj\u0105k",
        bra: "Spyracn\xeddeo",
        hun: "P\xf3k\xe9m",
        sch: "\u95F4\u8C0D\u8718\u86DB"
    },
    1953: {
        img: "carry_van",
        eng: "Carry-Van",
        rus: "\u041F\u0435\u0440\u0435\u043D\u043E\u0441\u043D\u043E\u0439 \u0444\u0443\u0440\u0433\u043E\u043D",
        schema: 31410,
        pol: "Nosibus",
        bra: "Furg\xe3o de Papel\xe3o",
        fre: "V\xe9hicule autoport\xe9",
        hun: "Lak\xf3gaty\xf3",
        sch: "\u81EA\u9A7E\u6E38",
        swe: "Eko-bil"
    },
    1954: {
        img: "fiercesome_fluorescence",
        eng: "Fiercesome Fluorescence",
        rus: "\u0423\u0436\u0430\u0441\u0430\u044E\u0449\u0438\u0439 \u0443\u0434\u0438\u043B\u044C\u0449\u0438\u043A",
        schema: 31411,
        pol: "Fluorescencyjna trwoga",
        bra: "Fluoresc\xeancia Feroz",
        fre: "Fluorescence abyssale",
        hun: "F\xe9lelmetes Fluoreszcencia",
        sch: "\u6C79\u6D8C\u8367\u5149",
        swe: "Fr\xe4n fluorescens"
    },
    1955: {
        img: "taunt_neck_snap",
        eng: "Taunt: Neck Snap",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0425\u0440\u0443\u0441\u0442 \u0448\u0435\u0438",
        schema: 31381,
        pol: "Drwina: Karkoskr\u0119t",
        bra: "Provoca\xe7\xe3o: Quiroprata da Casa",
        fre: "Raillerie : Brisage de nuque",
        hun: "Besz\xf3l\xe1s: Nyakropogtat\xf3",
        swe: "H\xe5n: Nacksp\xe4rr",
        sch: "\u5632\u8BBD\uFF1A\u62E7\u8F6C\u8116\u5B50"
    },
    1956: {
        img: "taunt_roar_o_war",
        eng: "Taunt: Roar O'War",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0412\u043E\u0439 \u0432\u043E\u0439\u043D\u044B",
        schema: 31380,
        pol: "Drwina: Ryk wojenny",
        bra: "Provoca\xe7\xe3o: Rugido de Guerra",
        fre: "Raillerie : Cri de guerre",
        hun: "Besz\xf3l\xe1s: Csatakurjant\xe1s",
        swe: "H\xe5n: Krigsvr\xe5l",
        sch: "\u5632\u8BBD\uFF1A\u6218\u6597\u5486\u54EE"
    },
    1957: {
        img: "taunt_borrowed_bones",
        eng: "Taunt: Borrowed Bones",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0421\u043A\u0435\u043B\u0435\u0442 \u0441\u043E \u0441\u0442\u043E\u0440\u043E\u043D\u044B",
        schema: 31382,
        pol: "Drwina: Lekarska lichwa",
        bra: "Provoca\xe7\xe3o: Esqueleto Emprestado",
        fre: "Raillerie : Squelette emprunt\xe9",
        hun: "Besz\xf3l\xe1s: K\xf6lcs\xf6ncsontv\xe1z",
        swe: "H\xe5n: Knyckta knotor",
        sch: "\u5632\u8BBD\uFF1A\u9AA8\u67B6\u5916\u501F"
    },
    1958: {
        img: "taunt_crypt_creeper",
        eng: "Taunt: The Crypt Creeper",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041C\u043E\u0433\u0438\u043B\u044C\u043D\u044B\u0439 \u043C\u043E\u0448\u0435\u043D\u043D\u0438\u043A",
        schema: 31289,
        pol: "Drwina: Strach do szpiegu ko\u015Bci",
        bra: "Provoca\xe7\xe3o: Descanso do Dr\xe1cula",
        fre: "Raillerie : Vagabond des cryptes",
        hun: "Besz\xf3l\xe1s: A kript\xe1k k\xe9mje",
        swe: "H\xe5n: Gravv\xe4ktaren",
        sch: "\u5632\u8BBD\uFF1A\u5893\u7A74\u7A83\u8D3C"
    },
    1959: {
        img: "bigger_mann_on_campus",
        eng: "Bigger Mann on Campus",
        rus: "\u0421\u0442\u0430\u0442\u0443\u0441\u043D\u044B\u0439 \u0441\u0442\u0443\u0434\u0435\u043D\u0442",
        schema: 31435,
        pol: "Wi\u0119ksza szycha z akademika",
        bra: "O Verdadeiro Dono do Peda\xe7o",
        fre: "Grande star du Campus",
        hun: "Az Egyetem Nagy Fenemannusa",
        swe: "Viktig Mann p\xe5 campus",
        sch: "\u6821\u56ED\u5DE8\u5496"
    },
    1960: {
        img: "balkans_brute",
        eng: "Balkan's Brute",
        rus: "\u0411\u0440\u0443\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u0431\u0430\u043B\u043A\u0430\u043D\u0435\u0446",
        schema: 31434,
        pol: "Ba\u0142ka\u0144ski brutal",
        bra: "Brutamontes dos B\xe1lc\xe3s",
        fre: "Brute des Balkans",
        hun: "Balk\xe1ni Bajkever\u0151",
        swe: "P\xe5p\xe4lsad",
        sch: "\u5DF4\u5C14\u5E72\u86EE\u65CF"
    },
    1961: {
        img: "impact_impaler",
        eng: "Impact Impaler",
        rus: "\u0428\u0442\u044B\u043A-\u0448\u043B\u0435\u043C",
        schema: 31432,
        pol: "Szpiczasty spopielacz",
        bra: "Empalador de Impactos",
        fre: "Empaleur percutant",
        hun: "D\xf6fk\xf6d\u0151 T\xf6kf\xf6d\u0151",
        swe: "Pickelhuva",
        sch: "\u51B2\u51FB\u523A\u76D4"
    },
    1962: {
        img: "rugged_rags",
        eng: "Rugged Rags",
        rus: "\u041E\u0431\u043D\u043E\u0441\u043A\u0438 \u043E\u0431\u043E\u0440\u0432\u0430\u043D\u0446\u0430",
        schema: 31430,
        pol: "Poszarpane \u0142achmany",
        bra: "Maltrapilho Bom de Mira",
        fre: "Veilles sapes",
        hun: "Kitart\xf3 Kab\xe1t",
        swe: "Slitstarka trasor",
        sch: "\u786C\u6838\u5939\u514B\u886B"
    },
    1963: {
        img: "the_covert_covers",
        eng: "The Covert Covers",
        rus: "\u0421\u043A\u0440\u044B\u0442\u043D\u043E\u0435 \u043F\u0440\u0438\u043A\u0440\u044B\u0442\u0438\u0435",
        schema: 31428,
        pol: "Os\u0142oni\u0119te oblicze",
        bra: "Assassino Alpino",
        fre: "Cagoule int\xe9grale",
        hun: "\xc1lca\xe1lc\xe1z\xf3",
        swe: "Hemliga omslag",
        sch: "\u9690\u79D8\u9762\u7F69"
    },
    1964: {
        img: "sleuth_suit",
        eng: "Sleuth Suit",
        rus: "\u0421\u044B\u0441\u043A\u043D\u043E\u0439 \u043D\u0430\u0440\u044F\u0434",
        schema: 31426,
        pol: "Wymi\u0119ty prochowiec",
        bra: "Investigador de Rastros",
        fre: "Tenue de limier",
        hun: "Szimatkab\xe1t",
        swe: "Detektivens kostym",
        sch: "\u795E\u63A2\u7740\u88C5"
    },
    1965: {
        img: "nightcap",
        eng: "Nightcap",
        rus: "\u0421\u043D\u043E\u0442\u0432\u043E\u0440\u043D\u043E\u0435 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E",
        schema: 31422,
        pol: "Dobranocna czapeczka",
        bra: "Descanso do Demolidor",
        fre: "Bonnet de nuit",
        hun: "H\xe1l\xf3sipka",
        swe: "Nattm\xf6ssa",
        sch: "\u9189\u68A6\u7761\u5E3D"
    },
    1966: {
        img: "the_puffed_practitioner",
        eng: "The Puffed Practitioner",
        rus: "\u041F\u0443\u0445\u043E\u0432\u0438\u043A \u043F\u0440\u0430\u043A\u0442\u0438\u043A\u0430",
        schema: 31420,
        pol: "Puchaty praktyk",
        bra: "O Doutor Almofadado",
        fre: "Praticien douillet",
        hun: "B\xe9lelt Betegell\xe1t\xf3",
        swe: "Doktorns dunjacka",
        sch: "\u7FBD\u7ED2\u670D\u533B\u5E08"
    },
    1967: {
        img: "wanderers_wool",
        eng: "Wanderer's Wool",
        rus: "\u0428\u0430\u043F\u043A\u0430 \u0441\u043A\u0438\u0442\u0430\u043B\u044C\u0446\u0430",
        schema: 31419,
        pol: "We\u0142niany w\u0142\xf3czykij",
        bra: "Do Bom Velhinho",
        fre: "Bonnet du vagabond",
        hun: "Gyalogs\xe1gi Gyapj\xfa",
        swe: "Vandrarens ullm\xf6ssa",
        sch: "\u6D41\u6D6A\u6C49\u7684\u7F8A\u6BDB\u5E3D"
    },
    1968: {
        img: "cozy_cover_up",
        eng: "Cozy Cover-Up",
        rus: "\u0423\u044E\u0442\u043D\u044B\u0439 \u0443\u0442\u0435\u043F\u043B\u0438\u0442\u0435\u043B\u044C",
        schema: 31416,
        pol: "Przytulne przyodzienie",
        bra: "Cobertura Confort\xe1vel",
        fre: "Bien au chaud",
        hun: "Meghitt Mened\xe9k",
        swe: "Ombonad",
        sch: "\u6E29\u99A8\u56F4\u88F9"
    },
    1969: {
        img: "isotopic_insulator",
        eng: "Isotopic Insulator",
        rus: "\u0418\u0437\u043E\u0442\u043E\u043F\u043D\u044B\u0439 \u0438\u0437\u043E\u043B\u044F\u0442\u043E\u0440",
        schema: 31436,
        pol: "Izotopowy izolator",
        bra: "Agasalho At\xf4mico",
        fre: "Doudoune isotopique",
        hun: "Poff! Pufidzseki",
        swe: "Isotopisk isolator",
        sch: "\u540C\u4F4D\u7D20\u7EDD\u7F18\u8863"
    },
    1970: {
        img: "torchers_trench_coat",
        eng: "Torcher's Trench Coat",
        rus: "\u041F\u0430\u043B\u044C\u0442\u043E \u043E\u043F\u0430\u043B\u0438\u0442\u0435\u043B\u044F",
        schema: 31433,
        pol: "Pochodny p\u0142aszcz",
        bra: "Terror da Trincheira",
        fre: "Trench du pyromane",
        hun: "L\xe1ng\xe1ll\xf3 L\xf3denkab\xe1t",
        swe: "Pyromanens trenchcoat",
        sch: "\u706B\u70AC\u624B\u7684\u5811\u58D5\u98CE\u8863"
    },
    1971: {
        img: "strasbourg_scholar",
        eng: "Strasbourg Scholar",
        rus: "\u0421\u0442\u0440\u0430\u0441\u0431\u0443\u0440\u0433\u0441\u043A\u0438\u0439 \u0441\u043F\u0435\u0446",
        schema: 31427,
        pol: "Uczony ze Strasburga",
        bra: "O Estudioso de Estrasburgo",
        fre: "Universitaire strasbourgeois",
        hun: "Oxfordi \xd3raad\xf3",
        swe: "Strasbourg-l\xe4rjunge",
        sch: "\u65AF\u7279\u62C9\u65AF\u5821\u5B66\u8005"
    },
    1972: {
        img: "clue_hairdo",
        eng: "Clue Hairdo",
        rus: "\u0421\u0442\u0438\u043B\u044C \u0441\u044B\u0449\u0438\u043A\u0430",
        schema: 31425,
        pol: "Znamienna zaczeska",
        bra: "Perito em Pistas",
        fre: "Coiffure de l'inspecteur",
        hun: "Agyaf\xfart Hajzat",
        swe: "Detektivfrisyr",
        sch: "\u7834\u6848\u5F0F\u53D1\u578B"
    },
    1973: {
        img: "slumber_slacks",
        eng: "Slumber Slacks",
        rus: "\u041F\u0430\u043D\u0442\u0430\u043B\u043E\u043D\u044B \u043F\u043E\u043B\u0443\u0441\u043E\u043D\u043D\u043E\u0433\u043E",
        schema: 31424,
        pol: "Senne spodnie",
        bra: "Cal\xe7as do Cochilo",
        fre: "Bas de pyjama",
        hun: "Pihen\u0151 Pantall\xf3",
        swe: "Slummerbyxor",
        sch: "\u52A9\u7720\u7761\u88E4"
    },
    1974: {
        img: "the_frigid_fashion",
        eng: "The Frigid Fashion",
        rus: "\u041C\u043E\u0440\u043E\u0437\u043D\u0430\u044F \u043C\u043E\u0434\u0430",
        schema: 31421,
        pol: "Ozi\u0119b\u0142y modni\u015B",
        bra: "O Estilo do Gelo",
        fre: "Frime d'hiver",
        hun: "Deres Divat",
        swe: "Iskall",
        sch: "\u51B7\u6DE1\u98CE\u5C1A"
    },
    1975: {
        img: "trench_warefarer",
        eng: "Trench Warfarer",
        rus: "\u041E\u043A\u043E\u043F\u043D\u044B\u0439 \u0432\u043E\u0438\u043D",
        schema: 31418,
        pol: "Bitewny trencz",
        bra: "Casaco das Trincheiras",
        fre: "Trench \xe0 toute \xe9preuve",
        hun: "L\xf6v\xe9sz\xe1rkol\xf3",
        swe: "Skyttegravskrigare",
        sch: "\u6218\u58D5\u5947\u5175"
    },
    1976: {
        img: "the_dapper_dickens",
        eng: "The Dapper Dickens",
        rus: "\u0429\u0435\u043F\u0435\u0442\u0438\u043B\u044C\u043D\u044B\u0439 \u0449\u0451\u0433\u043E\u043B\u044C",
        schema: 31417,
        pol: "Elegancki Ebenezer",
        bra: "O Dickens Distinto",
        fre: "Haut de forme",
        hun: "Dickensi Dalia",
        swe: "Stilig Dickens",
        sch: "\u72C4\u66F4\u65AF\u5927\u793C\u5E3D"
    },
    1977: {
        img: "bonk_beanie",
        eng: "Bonk Beanie",
        rus: "\u0411\u043E\u043D\u043A-\u0448\u0430\u043F\u043A\u0430",
        schema: 31437,
        pol: "Bonkowe beanie",
        bra: "Gorro Gaseificante",
        fre: "Bonnet Bonk",
        hun: "Atomsapka",
        swe: "Bonk-m\xf6ssa",
        sch: "\u539F\u5B50\u80FD\u6ED1\u96EA\u5E3D"
    },
    1978: {
        img: "masked_loyalty",
        eng: "Masked Loyalty",
        rus: "\u041C\u0430\u0441\u043A\u0430 \u043F\u0440\u0435\u0434\u0430\u043D\u043D\u043E\u0441\u0442\u0438",
        schema: 31431,
        pol: "Zamaskowana lojalno\u015B\u0107",
        bra: "Lealdade Mascarada",
        fre: "Loyaut\xe9 masqu\xe9e",
        hun: "Elfedett H\u0171s\xe9g",
        swe: "Maskerad lojalitet",
        sch: "\u6548\u5FE0\u8005\u7684\u9762\u7F69"
    },
    1979: {
        img: "lazy_lounger",
        eng: "Lazy Lounger",
        rus: "\u041B\u0435\u043D\u0438\u0432\u044B\u0439 \u043B\u0435\u0436\u0435\u0431\u043E\u043A\u0430",
        schema: 31423,
        pol: "Ospa\u0142y obibok",
        bra: "Pijama da Pregui\xe7a",
        fre: "Peignoir",
        hun: "Heny\xe9l\u0151 H\xe1zikab\xe1t",
        swe: "Latmasken",
        sch: "\u95F2\u6563\u61D2\u6C49"
    },
    1980: {
        img: "boarders_beanie",
        eng: "Boarder's Beanie",
        rus: "\u0428\u0430\u043F\u043A\u0430 \u0441\u043D\u043E\u0443\u0431\u043E\u0440\u0434\u0438\u0441\u0442\u0430",
        schema: 31415,
        pol: "Czapka pensjonariusza",
        bra: "Touca de Classe",
        fre: "Bonnet de surf",
        hun: "St\xedlusos Sapka",
        swe: "Skid\xe5karens luva",
        sch: "\u6ED1\u96EA\u9488\u7EC7\u5E3D"
    },
    1981: {
        img: "scruffed_n_stitched",
        eng: "Scruffed 'n Stitched",
        rus: "\u041F\u043E\u0442\u0440\u0451\u043F\u0430\u043D\u043D\u044B\u0439 \u0438 \u043F\u043E\u0434\u0448\u0438\u0442\u044B\u0439",
        schema: 31429,
        pol: "Zadrapany i zszyty",
        bra: "Desocupado e Esfarrapado",
        fre: "Baroudeur",
        hun: "Sz\u0151r\xf6s \xe9s Szakadt",
        swe: "Sliten och sydd",
        sch: "\u7834\u65E7\u9488\u7EC7\u5E3D"
    },
    1982: {
        img: "taunt_foul_play",
        eng: "Taunt: Foul Play",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041D\u0435\u0447\u0435\u0441\u0442\u043D\u0430\u044F \u0438\u0433\u0440\u0430",
        schema: 31414,
        pol: "Drwina: Nieczysta zagrywka",
        bra: "Provoca\xe7\xe3o: Cart\xe3o Vermelho",
        fre: "Raillerie : Carton rouge",
        hun: "Besz\xf3l\xe1s: Piros lap",
        swe: "H\xe5n: R\xf6tt kort",
        sch: "\u5632\u8BBD\uFF1A\u72AF\u89C4\u52A8\u4F5C"
    },
    1983: {
        img: "taunt_cheers",
        eng: "Taunt: Cheers!",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0422\u043E\u0441\u0442!",
        schema: 31412,
        pol: "Drwina: Na zdrowie!",
        bra: "Provoca\xe7\xe3o: Um Brinde!",
        fre: "Raillerie : Sant\xe9 !",
        hun: "Besz\xf3l\xe1s: Eg\xe9szs\xe9g\xfcnkre!",
        swe: "H\xe5n: Sk\xe5l!",
        sch: "\u5632\u8BBD\uFF1A\u5E72\u676F\uFF01"
    },
    1984: {
        img: "taunt_mourning_mercs",
        eng: "Taunt: Mourning Mercs",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0413\u043E\u0440\u044E\u044E\u0449\u0438\u0435 \u0433\u043E\u043B\u043E\u0432\u043E\u0440\u0435\u0437\u044B",
        schema: 31413,
        pol: "Drwina: Najemnicze nieszcz\u0119\u015Bcie",
        bra: "Provoca\xe7\xe3o: Mercen\xe1rio Melanc\xf3lico",
        fre: "Raillerie : Les mercenaires ont le bourdon",
        hun: "Besz\xf3l\xe1s: Sir\xe1nkoz\xf3 zsoldosok",
        swe: "H\xe5n: S\xf6rjande soldater",
        sch: "\u5632\u8BBD\uFF1A\u60B2\u6078\u4F63\u5175"
    },
    1985: {
        img: "invisible_flame",
        eng: "Invisible Flame",
        rus: "\u041D\u0435\u0432\u0438\u0434\u0438\u043C\u043E\u0435 \u043F\u043B\u0430\u043C\u044F",
        schema: 31463,
        pol: "Niewidzialny p\u0142omie\u0144",
        sch: "\u65E0\u5F62\u8D64\u7130",
        bra: "Chama Camuflada",
        fre: "Flamme invisible",
        hun: "L\xe1thatatlan L\xe1ng",
        swe: "Osynlig flamma"
    },
    1986: {
        img: "the_vaudeville_visor",
        eng: "The Vaudeville Visor",
        rus: "\u0417\u043B\u043E\u0434\u0435\u0439\u0441\u043A\u043E\u0435 \u0437\u0430\u0431\u0440\u0430\u043B\u043E",
        schema: 31461,
        pol: "Wizja wodewilu",
        sch: "\u6742\u800D\u9762\u7F69",
        bra: "A Viseira Vaudeville",
        fre: "Visi\xe8re vaudevillesque",
        hun: "Vaudeville-maszk",
        swe: "Vaudeville-visir"
    },
    1987: {
        img: "commonwealth_commando",
        eng: "Commonwealth Commando",
        rus: "\u0421\u0442\u0440\u0435\u043B\u043E\u043A \u0421\u043E\u0434\u0440\u0443\u0436\u0435\u0441\u0442\u0432\u0430",
        schema: 31459,
        pol: "Wojskowy wsp\xf3lnoty",
        sch: "\u82F1\u8054\u90A6\u7A81\u51FB\u961F",
        bra: "Comandante da Comunidade",
        fre: "Commando du Commonwealth",
        hun: "K\xf6zt\xe1rsas\xe1gi Kommand\xf3",
        swe: "Statsmaktens strateg"
    },
    1988: {
        img: "the_aimframe",
        eng: "The Aimframe",
        rus: "\u0426\u0435\u043B\u0435\u0443\u0441\u043C\u043E\u0442\u0440\u0438\u0442\u0435\u043B\u044C",
        schema: 31458,
        pol: "Celny czerep",
        sch: "\u7784\u51C6\u8F85\u52A9\u4EEA",
        bra: "Equipamento de Precis\xe3o",
        fre: "Monture de vis\xe9e",
        hun: "C\xe9lkeret",
        swe: "Hj\xe4lmvisir"
    },
    1989: {
        img: "watchmanns_wetsuit",
        eng: "Watchmann's Wetsuit",
        rus: "\u0414\u043E\u0437\u043E\u0440\u043D\u044B\u0439 \u0434\u0430\u0439\u0432\u0435\u0440",
        schema: 31457,
        pol: "Piankowy podkoszulek",
        sch: "\u6551\u751F\u5458\u7684\u6CF3\u88C5",
        bra: "Macac\xe3o de Mergulho do M\xe9dico",
        fre: "Combi du surveillant de baignade",
        hun: "\xdasz\xf3mannster",
        swe: "Livvaktens v\xe5tdr\xe4kt"
    },
    1990: {
        img: "brutes_braces",
        eng: "Brute's Braces",
        rus: "\u041F\u043E\u0434\u0442\u044F\u0436\u043A\u0438 \u043F\u043E\u0434\u0435\u043B\u044C\u043D\u0438\u043A\u0430",
        schema: 31453,
        pol: "Szelki szumowiny",
        sch: "\u83BD\u592B\u7684\u540A\u88E4\u5E26",
        bra: "Suspens\xf3rios Sovi\xe9ticos",
        fre: "Bretelles de la brute",
        hun: "A Nagydarab Nadr\xe1gtart\xf3ja",
        swe: "Busens h\xe4ngslen"
    },
    1991: {
        img: "pathfinder",
        eng: "Pathfinder",
        rus: "\u041F\u0435\u0440\u0432\u043E\u043E\u0442\u043A\u0440\u044B\u0432\u0430\u0442\u0435\u043B\u044C",
        schema: 31450,
        pol: "Szlakoprzecieracz",
        sch: "\u63A2\u8DEF\u731B\u58EB",
        bra: "Patrulha das Trilhas",
        fre: "\xc9claireur",
        hun: "\xdatt\xf6r\u0151",
        swe: "V\xe4gvisare"
    },
    1992: {
        img: "daring_dell",
        eng: "Daring Dell",
        rus: "\u0414\u0435\u0440\u0437\u043A\u0438\u0439 \u0414\u0435\u043B\u043B",
        schema: 31445,
        pol: "Dziarski Dell",
        sch: "\u65E0\u754F\u6234\u5C14",
        bra: "Dell Destemido",
        fre: "Dell l'Intr\xe9pide",
        hun: "Mer\xe9sz Dell",
        swe: "Dj\xe4rva Dell"
    },
    1993: {
        img: "desk_engineer",
        eng: "Desk Engineer",
        rus: "\u041E\u0444\u0438\u0441\u043D\u044B\u0439 \u0438\u043D\u0436\u0435\u043D\u0435\u0440",
        schema: 31444,
        pol: "In\u017Cynier wsparcia",
        sch: "\u767D\u9886\u5DE5\u7A0B\u5E08",
        bra: "Engenheiro de Escrit\xf3rio",
        fre: "Ing\xe9nieur-cadre",
        hun: "Asztali M\xe9rn\xf6k",
        swe: "Skrivbordsingenj\xf6r"
    },
    1994: {
        img: "the_brand_loyalist",
        eng: "The Brand Loyalist",
        rus: "\u041F\u0440\u0435\u0434\u0430\u043D\u043D\u044B\u0439 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u044C",
        schema: 31443,
        pol: "Wielbiciel marki",
        sch: "\u54C1\u724C\u4EE3\u8A00\u5E3D",
        bra: "O Fregu\xeas Fiel",
        fre: "Fid\xe8le client",
        hun: "M\xe1rkah\u0171",
        swe: "Varum\xe4rkeslojalist"
    },
    1995: {
        img: "scorched_earth_stompers",
        eng: "Scorched Earth Stompers",
        rus: "\u0412\u044B\u0442\u0430\u043F\u0442\u044B\u0432\u0430\u0442\u0435\u043B\u0438 \u0432\u044B\u0436\u0436\u0435\u043D\u043D\u043E\u0439 \u0437\u0435\u043C\u043B\u0438",
        schema: 31464,
        pol: "T\u0105pni\u0119cie spalonej ziemi",
        sch: "\u7126\u571F\u6218\u9774",
        bra: "Cal\xe7as Cargo Queimadas",
        fre: "D\xe9gaine de la terre brul\xe9e",
        hun: "Par\xe1zstapos\xf3k",
        swe: "Sotsulor"
    },
    1996: {
        img: "tankers_top",
        eng: "Tanker's Top",
        rus: "\u041A\u0443\u0440\u0442\u043A\u0430 \u0442\u0430\u043D\u043A\u0438\u0441\u0442\u0430",
        schema: 31460,
        pol: "Wiatr\xf3wka wojaka",
        sch: "\u5766\u514B\u624B\u4E0A\u8863",
        bra: "Casaco do Combatente",
        fre: "Blouson d'aviateur",
        hun: "Harckocsiz\xf3 Zubbony",
        swe: "Tankerjacka"
    },
    1997: {
        img: "the_tropical_brim",
        eng: "The Tropical Brim",
        rus: "\u0428\u0438\u0440\u043E\u043A\u043E\u043F\u043E\u043B\u044B\u0435 \u0442\u0440\u043E\u043F\u0438\u043A\u0438",
        schema: 31456,
        pol: "Tropikalne rondo",
        sch: "\u70ED\u5E26\u5BBD\u6A90\u5E3D",
        bra: "A Aba Tropical",
        fre: "Bord tropical",
        hun: "Tr\xf3pusi Karima",
        swe: "Tropiskt br\xe4tte"
    },
    1998: {
        img: "crooks_cap",
        eng: "Crook's Cap",
        rus: "\u041A\u0435\u043F\u0430\u0440\u044C \u043A\u0438\u0434\u0430\u043B\u044B",
        schema: 31452,
        pol: "Kaszkiet kanciarza",
        sch: "\u6076\u5F92\u4E4B\u5E3D",
        bra: "Boina do Brig\xe3o",
        fre: "Casquette de l'escroc",
        hun: "A Simlis Sapk\xe1ja",
        swe: "Tjuvm\xf6ssa"
    },
    1999: {
        img: "justice_johns",
        eng: "Justice Johns",
        rus: "\u0421\u0430\u043F\u043E\u0433\u0438 \u0441\u043F\u0440\u0430\u0432\u0435\u0434\u043B\u0438\u0432\u043E\u0441\u0442\u0438",
        schema: 31451,
        pol: "Szorty sprawiedliwo\u015Bci",
        sch: "\u6B63\u4E49\u743C\u65AF",
        bra: "Justi\xe7a Justa",
        fre: "Justicier \xe0 la culotte courte",
        hun: "Szafarigatya",
        swe: "Korta kortbyxor"
    },
    2000: {
        img: "sneaky_blinder",
        eng: "Sneaky Blinder",
        rus: "\u0421\u043A\u0440\u044B\u0442\u043D\u044B\u0439 \u043A\u043E\u0437\u044B\u0440\u0451\u043A",
        schema: 31447,
        pol: "Sztorc szpiona",
        sch: "\u6D74\u8840\u8C0D\u5E2E",
        bra: "Sangue, Sabotadas e Facadas",
        hun: "Birminghami Bandatag",
        swe: "Smygkeps"
    },
    2001: {
        img: "the_big_star",
        eng: "The Big Star",
        rus: "\u0411\u043E\u043B\u044C\u0448\u0430\u044F \u0437\u0432\u0435\u0437\u0434\u0430",
        schema: 31446,
        pol: "Wielka gwiazda",
        sch: "\u5927\u724C\u660E\u661F",
        bra: "O Engenheiro Espetacular",
        fre: "\xc9toile montante",
        hun: "Nagy Szt\xe1r",
        swe: "Stora stj\xe4rnan"
    },
    2002: {
        img: "tuxedo_royale",
        eng: "Tuxedo Royale",
        rus: '\u0421\u043C\u043E\u043A\u0438\u043D\u0433 "\u0420\u043E\u044F\u043B\u044C"',
        schema: 31448,
        pol: "Szykowny smoking",
        sch: "\u7687\u5BB6\u793C\u670D",
        bra: "Assassino Royale",
        fre: "Smoking de casino",
        hun: "Smoking Royale",
        swe: "F\xf6rstklassig smoking"
    },
    2003: {
        img: "fire_marshal",
        eng: "Fire Marshal",
        rus: "\u041D\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A \u0431\u0440\u0438\u0433\u0430\u0434\u044B",
        schema: 31462,
        pol: "Marsza\u0142ek p\u0142onny",
        sch: "\u70C8\u706B\u961F\u957F",
        bra: "Marechal do Fogo",
        fre: "Capitaine pompier",
        hun: "T\u0171zparancsnok",
        swe: "Brandmarskalk"
    },
    2004: {
        img: "free_manns_fashion",
        eng: "Free Mann's Fashion",
        rus: "\u0424\u0438\u0437\u0438\u043E\u043D\u043E\u043C\u0438\u044F \u0444\u0438\u0437\u0438\u043A\u0430",
        schema: 31454,
        pol: "Aparycja antyobywatela",
        sch: "\u5F17\u91CC\u66FC\u535A\u58EB",
        bra: "Face do F\xedsico",
        fre: "\xc0 la Freeman",
        hun: "Free Mann \xc1br\xe1zata",
        swe: "Freemanns mode"
    },
    2005: {
        img: "control_patrol",
        eng: "Control Patrol",
        rus: "\u041A\u043E\u043D\u0442\u0440\u043E\u043B\u044C\u043D\u044B\u0439 \u043F\u0430\u0442\u0440\u0443\u043B\u044C\u043D\u044B\u0439",
        schema: 31449,
        pol: "Patrol kontrolny",
        sch: "\u63A7\u5236\u70B9\u5DE1\u903B\u5175",
        bra: "Patrulha do Controle",
        fre: "Garde forestier",
        hun: "Ellen\u0151rz\u0151 Fel\xfcgyel\u0151",
        swe: "Kontrollpatrull"
    },
    2006: {
        img: "botler_2000",
        eng: "Botler 2000",
        rus: "\u0411\u043E\u0442\u0435\u0446\u043A\u0438\u0439 2000",
        schema: 31442,
        pol: "Robolokaj 2000",
        sch: "\u673A\u5668\u670D\u52A1\u5458 2000",
        bra: "Mordomob\xf4 2000",
        fre: "Robeau 2000",
        hun: "Komornyik 2000"
    },
    2007: {
        img: "hazardous_environment_vest",
        eng: "Hazardous Environment Vest",
        rus: "\u0417\u0430\u0449\u0438\u0442\u043D\u044B\u0439 \u0436\u0438\u043B\u0435\u0442",
        schema: 31455,
        pol: "Kamizelka HEV",
        sch: "\u5371\u9669\u73AF\u5883\u9632\u62A4\u670D",
        bra: "Traje para Condi\xe7\xf5es Biol\xf3gicas Adversas",
        fre: "Veste Hazmat",
        hun: "Vesz\xe9lyes K\xf6rnyezeti Mell\xe9ny",
        swe: "V\xe4st f\xf6r farlig milj\xf6"
    },
    2008: {
        img: "taunt_can_it",
        eng: "Taunt: Can It!",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041D\u0430 \u043F\u043E\u043C\u043E\u0439\u043A\u0443!",
        schema: 31438,
        pol: "Drwina: Do kosza!",
        sch: "\u5632\u8BBD\uFF1A\u5FEB\u5230\u6876\u91CC\u6765\uFF01",
        bra: "Provoca\xe7\xe3o: Na Lata!",
        fre: "Raillerie : \xc0 la poubelle !",
        hun: "Besz\xf3l\xe1s: Szem\xe9t!",
        swe: "H\xe5n: In i tunnan!"
    },
    2009: {
        img: "taunt_cremators_condolences",
        eng: "Taunt: Cremators Condolences",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0421\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044F \u0441\u043E\u0436\u0436\u0451\u043D\u043D\u044B\u043C",
        schema: 31439,
        pol: "Drwina: Kondolencje krematora",
        sch: "\u5632\u8BBD\uFF1A\u706B\u846C\u54C0\u60BC",
        bra: "Provoca\xe7\xe3o: P\xeasames Piroman\xedacos",
        fre: "Raillerie : Condol\xe9ances du cr\xe9matorium",
        hun: "Besz\xf3l\xe1s: A hamvaszt\xf3 r\xe9szv\xe9tnyilv\xe1n\xedt\xe1sa",
        swe: "H\xe5n: Sympati fr\xe5n krematoriet"
    },
    2010: {
        img: "taunt_straight_shooter_tutor",
        eng: "Taunt: Straight Shooter Tutor",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041F\u0440\u0438\u0446\u0435\u043B\u044C\u043D\u0430\u044F \u043F\u043E\u043C\u043E\u0449\u044C",
        schema: 31440,
        pol: "Drwina: Szkoleniowiec solidnych strzelc\xf3w",
        sch: "\u5632\u8BBD\uFF1A\u5C04\u51FB\u52A9\u6559",
        bra: "Provoca\xe7\xe3o: Instrutor Atirador",
        fre: "Raillerie : Coach de tir",
        hun: "Besz\xf3l\xe1s: J\xf3ll\xf6v\xe9szeti oktat\xf3",
        swe: "H\xe5n: Lektion i att sikta"
    },
    2011: {
        img: "taunt_unleashed_rage",
        eng: "Taunt: Unleashed Rage",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041F\u0440\u0438\u0441\u0442\u0443\u043F \u0433\u043D\u0435\u0432\u0430",
        schema: 31441,
        pol: "Drwina: Wyzwolona w\u015Bciek\u0142o\u015B\u0107",
        sch: "\u5632\u8BBD\uFF1A\u6012\u4E0D\u53EF\u904F",
        bra: "Provoca\xe7\xe3o: S\xf3 Pra Contrariado",
        fre: "Raillerie : Acc\xe8s de col\xe8re",
        hun: "Besz\xf3l\xe1s: Szabadj\xe1ra engedett d\xfch",
        swe: "H\xe5n: Frigjort raseri"
    },
    2012: {
        img: "school_nuisance",
        eng: "School Nuisance",
        rus: "\u0428\u043A\u043E\u043B\u044C\u043D\u0430\u044F \u0448\u043F\u0430\u043D\u0430",
        pol: "Uci\u0105\u017Cliwy ucze\u0144",
        sch: "\u6821\u56ED\u523A\u5934",
        bra: "Pestinha da Turma",
        fre: "Petite teigne",
        hun: "Iskolai Ny\u0171g",
        swe: "Skolmobbaren",
        schema: 31479
    },
    2013: {
        img: "strikeout",
        eng: "Strikeout",
        rus: "\u0421\u0442\u0440\u0430\u0439\u043A\u043E\u043C \u043F\u043E \u0433\u043E\u043B\u043E\u0432\u0435",
        pol: "Wynaturzone wyautowanie",
        sch: "\u4E09\u632F\u51FA\u4EBA\u547D",
        bra: "O Batedor Abatido",
        fre: "Mauvaise frappe",
        hun: "Kidobott",
        swe: "Huvudtr\xe4ff",
        schema: 31480
    },
    2014: {
        img: "chiromancer's_kit",
        eng: "Chiromancer's Kit",
        rus: "\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442 \u0445\u0438\u0440\u043E\u043C\u0430\u043D\u0442\u0430",
        pol: "Przyrz\u0105dy proroka",
        sch: "\u5360\u535C\u5E08\u7684\u884C\u5934",
        bra: "Kit do Quiromante",
        fre: "Kit du voyant",
        hun: "T\u0171zgy\xfajt\xf3 K\xe9szlet",
        swe: "Chiromancers kit",
        schema: 31478
    },
    2015: {
        img: "sear_seer",
        eng: "Sear Seer",
        rus: "\u041F\u0440\u043E\u0432\u0438\u0434\u0435\u0446 \u043F\u043B\u0430\u043C\u0435\u043D\u0438",
        pol: "Wrz\u0105cy wr\xf3\u017Cbita",
        sch: "\u7126\u707C\u5148\u77E5",
        bra: "Vidente Ardente",
        fre: "Proph\xe8te pyromane",
        hun: "Zsar\xe1tnok-l\xe1tnok",
        swe: "Svedd siare",
        schema: 31477
    },
    2016: {
        img: "badlands_bandido",
        eng: "Badlands Bandido",
        rus: "\u041F\u0440\u0435\u0441\u0442\u0443\u043F\u043D\u0438\u043A \u043F\u0443\u0441\u0442\u043E\u0448\u0435\u0439",
        pol: "Bandyta z Badland\xf3w",
        sch: "\u6076\u5730\u52AB\u532A",
        bra: "Bandido das Badlands",
        fre: "Bandido des Badlands",
        hun: "Pusztai Bandita",
        swe: "Badlandsbandit",
        schema: 31488
    },
    2017: {
        img: "defaced_detonator",
        eng: "Defaced Detonator",
        rus: "\u0414\u0432\u0443\u043B\u0438\u043A\u0438\u0439 \u0434\u0435\u0442\u043E\u043D\u0430\u0442\u043E\u0440",
        pol: "Zeszpecony zapalnik",
        sch: "\u534A\u8138\u7206\u5BA2",
        bra: "Detonador Descarado",
        fre: "D\xe9tonateur d\xe9figur\xe9",
        hun: "Arctalan Robbantgat\xf3",
        swe: "Ansiktslyft",
        schema: 31489
    },
    2018: {
        img: "dusk_duster",
        eng: "Dusk Duster",
        rus: "\u041F\u043E\u043B\u0443\u043D\u043E\u0447\u043D\u044B\u0439 \u043F\u044B\u043B\u044C\u043D\u0438\u043A",
        pol: "Pudermantel p\xf3\u0142mroku",
        sch: "\u66AE\u5149\u9632\u5C18\u8863",
        bra: "Casac\xe3o do Crep\xfasculo",
        fre: "Cache-poussi\xe8re du cr\xe9puscule",
        hun: "Alkonyat-g\xfanya",
        swe: "Aftonrock",
        schema: 31483
    },
    2019: {
        img: "hellish_overlord",
        eng: "Hellish Overlord",
        rus: "\u0410\u0434\u0441\u043A\u0438\u0439 \u0432\u043B\u0430\u0441\u0442\u0435\u043B\u0438\u043D",
        pol: "Diabelski dominator",
        sch: "\u5730\u72F1\u9738\u4E3B",
        bra: "Senhor do Inferno",
        fre: "Seigneur infernal",
        hun: "Pokoli Nagy\xfar",
        swe: "Dj\xe4vulsk herre",
        schema: 31481
    },
    2020: {
        img: "strigoi_stare",
        eng: "Strigoi Stare",
        rus: "\u0412\u0437\u0433\u043B\u044F\u0434 \u0432\u0430\u043C\u043F\u0438\u0440\u0430",
        pol: "Spojrzenie strzygonia",
        sch: "\u8840\u65CF\u51DD\u89C6",
        bra: "Strigoi Estiloso",
        fre: "Regard de strigo\xef",
        hun: "Sztrigojpillant\xe1s",
        swe: "Strigois \xf6gon",
        schema: 31482
    },
    2021: {
        img: "contaminated_carryall",
        eng: "Contaminated Carryall",
        rus: "\u0420\u0430\u0434\u0438\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0439 \u0440\u0430\u043D\u0435\u0446",
        pol: "Ska\u017Cona sakwa",
        sch: "\u6838\u6C61\u67D3\u80CC\u5305",
        bra: "Carga Contaminada",
        fre: "Fourretout contamin\xe9",
        hun: "Szennyezett Taty\xf3",
        swe: "Radioaktiv ryggs\xe4ck",
        schema: 31486
    },
    2022: {
        img: "delldozer",
        eng: "Delldozer",
        rus: "\u0414\u0435\u043B\u043B\u044C\u0434\u043E\u0437\u0435\u0440",
        pol: "Delldo\u017Cer",
        sch: "\u5FB7\u5DDE\u63A8\u571F\u673A",
        bra: "Homem-Sentinela",
        fre: "Buzzer",
        hun: "Delld\xf3zer",
        schema: 31487
    },
    2023: {
        img: "contaminated_carryall",
        eng: "Contaminated Carryall",
        rus: "\u0420\u0430\u0434\u0438\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0439 \u0440\u0430\u043D\u0435\u0446",
        pol: "Ska\u017Cona sakwa",
        sch: "\u6838\u6C61\u67D3\u80CC\u5305",
        bra: "Carga Contaminada",
        fre: "Fourretout contamin\xe9",
        hun: "Szennyezett Taty\xf3",
        swe: "Radioaktiv ryggs\xe4ck"
    },
    2024: {
        img: "mannhattan_protect",
        eng: "Mannhattan Protect",
        rus: "\u041C\u0430\u043D\u043D\u0445\u044D\u0442\u0442\u0435\u043D\u0441\u043A\u0438\u0439 \u043F\u0440\u043E\u0442\u0435\u043A\u0442\u043E\u0440",
        pol: "Protektor Mannhattanu",
        sch: "\u6838\u5A01\u80C1\u9632\u62A4",
        bra: "Protetor Mannhattan",
        fre: "Combi Hazmat",
        hun: "Mannhattan V\xe9delem",
        swe: "Mannhattanskydd",
        schema: 31484
    },
    2025: {
        img: "nuclear_necessity",
        eng: "Nuclear Necessity",
        rus: "\u042F\u0434\u0435\u0440\u043D\u044B\u0439 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0442\u0435\u0442",
        pol: "Nuklearny niezb\u0119dnik",
        sch: "\u6838\u707E\u5FC5\u5907\u670D",
        bra: "Necessidade Nuclear",
        fre: "N\xe9cessit\xe9 nucl\xe9aire",
        hun: "Nukle\xe1ris Sz\xfcks\xe9glet",
        swe: "Nukle\xe4r n\xf6dv\xe4ndighet",
        schema: 31485
    },
    2026: {
        img: "surgeon_general",
        eng: "Surgeon General",
        rus: "\u0413\u0435\u043D\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u0439 \u0445\u0438\u0440\u0443\u0440\u0433",
        pol: "Naczelny chirurg",
        sch: "\u519B\u533B\u5904\u957F",
        bra: "Cirurgi\xe3o-Geral",
        fre: "Chirurgien en chef",
        hun: "Tiszti F\u0151orvos",
        swe: "Generalkirurg",
        schema: 31476
    },
    2027: {
        img: "witch_doctor",
        eng: "Witch Doctor",
        rus: "\u0412\u0443\u0434\u0443-\u0432\u0440\u0430\u0447\u0435\u0432\u0430\u0442\u0435\u043B\u044C",
        pol: "Szpitalny szaman",
        sch: "\u5DEB\u533B\u793C\u5E3D",
        bra: "O Curandeiro",
        fre: "Chaman",
        hun: "Boszork\xe1nydoktor",
        swe: "H\xe4xdoktor",
        schema: 31475
    },
    2028: {
        img: "nightfall_veil",
        eng: "Nightfall Veil",
        rus: "\u0421\u0443\u043C\u0440\u0430\u0447\u043D\u043E\u0435 \u043A\u0438\u043C\u043E\u043D\u043E",
        pol: "Zas\u0142ona zmroku",
        sch: "\u591C\u5E55\u9690\u8EAB\u8863",
        bra: "V\xe9u do Crep\xfasculo",
        fre: "Ombre du cr\xe9puscule",
        hun: "Napsz\xe1llta-lepel",
        swe: "Nattsl\xf6ja",
        schema: 31474
    },
    2029: {
        img: "shadow_shroud",
        eng: "Shadow Shroud",
        rus: "\u0421\u043A\u0440\u044B\u0442\u044B\u0439 \u0441\u0443\u043C\u0440\u0430\u043A\u043E\u043C",
        pol: "Ca\u0142un cienia",
        sch: "\u6697\u5F71\u8499\u9762\u7F69",
        bra: "Capuz das Sombras",
        fre: "Silhouette de l'ombre",
        hun: "\xc1rnylepel",
        swe: "G\xf6md i skuggan",
        schema: 31473
    },
    2030: {
        img: "duality_of_mantle",
        eng: "Duality of Mantle",
        rus: "\u041C\u0430\u043D\u043D\u0442\u0438\u044F \u0434\u0432\u043E\u0439\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438",
        pol: "Dwoisto\u015B\u0107 okrycia",
        sch: "\u795E\u9B54\u515C\u5E3D",
        bra: "Dualidade de um Manto",
        fre: "Double-cap",
        hun: "A K\xf6p\xf6nyeg Kett\u0151ss\xe9ge",
        swe: "Mantelns dualitet",
        schema: 31472
    },
    2031: {
        img: "fleet_commander",
        eng: "Fleet Commander",
        rus: "\u0424\u043B\u043E\u0442\u0441\u043A\u0438\u0439 \u043A\u043E\u043C\u043C\u0430\u043D\u0434\u0435\u0440",
        pol: "Komandor floty",
        sch: "\u8230\u8239\u6307\u6325\u5B98",
        bra: "Comandante da Frota",
        fre: "Commandant de flotte",
        hun: "Flottaparancsnok",
        swe: "Flottans bef\xe4lhavare",
        schema: 31469
    },
    2032: {
        img: "spider_sights",
        eng: "Spider Sights",
        rus: "\u041F\u0430\u0443\u0447-\u043E\u0447\u043A\u0438",
        pol: "Paj\u0119cze patrza\u0142ki",
        sch: "\u8718\u86DB\u773C\u955C",
        bra: "Caracn\xeddea",
        fre: "Yeux d'araign\xe9e",
        hun: "P\xf3kszemcsi",
        swe: "Spindel\xf6gon",
        schema: 31471
    },
    2033: {
        img: "triboniophorus_gentlemannus",
        eng: "Triboniophorus Gentlemannus",
        rus: "\u0422\u0440\u0438\u0431\u043E\u043D\u0438\u043E\u0444\u043E\u0440\u0443\u0441 \u0414\u0436\u0435\u043D\u0442\u043B\u044C\u043C\u0430\u043D\u043D\u0443\u0441",
        pol: "Triboniophorus D\u017Centelmennus",
        sch: "\u9F3B\u6D95\u866B\u7EC5\u58EB",
        bra: "Triboniophorus Cavalheirus",
        schema: 31470
    },
    2034: {
        img: "peace_out",
        eng: "Taunt: Peace Out",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0417\u0435\u043C\u043B\u044F \u0441\u0442\u0435\u043A\u043B\u043E\u0432\u0430\u0442\u043E\u0439",
        pol: "Drwina: Nara",
        sch: "\u5632\u8BBD\uFF1A\u6162\u8D70\u4E0D\u9001",
        bra: "Provoca\xe7\xe3o: J\xe1 Vai Tarde",
        fre: "Raillerie : Repos illusoire",
        hun: "Besz\xf3l\xe1s: B\xe9ke veled!",
        swe: "H\xe5n: Vila i frid",
        schema: 31466
    },
    2035: {
        img: "crushing_defeat",
        eng: "Taunt: Crushing Defeat",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0421\u043E\u043A\u0440\u0443\u0448\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u0440\u0430\u0436\u0435\u043D\u0438\u0435",
        pol: "Drwina: Mia\u017Cd\u017C\u0105ca pora\u017Cka",
        sch: "\u5632\u8BBD\uFF1A\u7C89\u788E\u5BF9\u624B",
        bra: "Provoca\xe7\xe3o: Derrota Esmagadora",
        fre: "Raillerie : D\xe9faite \xe9crasante",
        hun: "Besz\xf3l\xe1s: Z\xfaz\xf3s veres\xe9g",
        swe: "H\xe5n: F\xf6rkrossande f\xf6rlust",
        schema: 31465
    },
    2036: {
        img: "punchline",
        eng: "Taunt: The Punchline",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0420\u043E\u0437\u044B\u0433\u0440\u044B\u0448",
        pol: "Drwina: Puenta",
        sch: "\u5632\u8BBD\uFF1A\u6296\u4E2A\u5305\u88B1",
        bra: "Provoca\xe7\xe3o: R\xe1-volver",
        fre: "Raillerie : R\xe9plique qui tue",
        hun: "Besz\xf3l\xe1s: A csattan\xf3",
        swe: "H\xe5n: Slutkl\xe4m",
        schema: 31468
    },
    2037: {
        img: "commending_clap",
        eng: "Taunt: Commending Clap",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0425\u0432\u0430\u043B\u0435\u0431\u043D\u044B\u0435 \u0445\u043B\u043E\u043F\u043A\u0438",
        pol: "Drwina: Aprobuj\u0105cy aplauz",
        sch: "\u5632\u8BBD\uFF1A\u9F13\u638C\u8868\u626C",
        bra: "Provoca\xe7\xe3o: Salva de Palmas",
        fre: "Raillerie : Applaudissements admiratifs",
        hun: "Besz\xf3l\xe1s: Elismer\u0151 taps",
        swe: "H\xe5n: St\xe5ende ovationer",
        schema: 31467
    },
    2038: {
        img: "broken_record_war_paint",
        eng: "Broken Record War Paint",
        rus: '"\u0411\u0438\u0442\u0430\u044F \u043F\u043B\u0430\u0441\u0442\u0438\u043D\u043A\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "rozbita p\u0142yta Barwy wojenne",
        sch: "\u6B8B\u8D25\u5531\u7247 \u6218\u7ED8",
        bra: "| Vinil Rachado | Tinta de Guerra",
        fre: "Disque bris\xe9 Peinture de guerre",
        hun: "T\xf6r\xf6tt lemez Harci fest\xe9s",
        swe: "Repad skiva Krigsf\xe4rg",
        schema: 17432
    },
    2039: {
        img: "necropolish_war_paint",
        eng: "Necropolish War Paint",
        rus: '"\u041D\u0435\u043A\u0440\u043E\u043F\u043E\u043B\u0438\u0440\u043E\u043B\u044C" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "nekropolerka Barwy wojenne",
        sch: "\u767D\u9AA8\u7D2F\u7D2F \u6218\u7ED8",
        bra: "| Necropolimento | Tinta de Guerra",
        fre: "N\xe9cropolish Peinture de guerre",
        hun: "Nekropol\xedr Harci fest\xe9s",
        swe: "Nekropolerad Krigsf\xe4rg",
        schema: 17430
    },
    2040: {
        img: "stardust_war_paint",
        eng: "Stardust War Paint",
        rus: '"\u0417\u0432\u0451\u0437\u0434\u043D\u0430\u044F \u043F\u044B\u043B\u044C" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "gwiezdny py\u0142 Barwy wojenne",
        sch: "\u661F\u5C18\u5999\u60F3 \u6218\u7ED8",
        bra: "| Poeira C\xf3smica | Tinta de Guerra",
        fre: "Poussi\xe8re d'\xe9toile Peinture de guerre",
        hun: "Csillagpor Harci fest\xe9s",
        swe: "Stj\xe4rnstoft Krigsf\xe4rg",
        schema: 17421
    },
    2041: {
        img: "graphite_gripped_war_paint",
        eng: "Graphite Gripped War Paint",
        rus: '"\u0413\u0440\u0430\u043D\u0438 \u0433\u0440\u0430\u0444\u0438\u0442\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "grafitowe okrycie Barwy wojenne",
        sch: "\u77F3\u58A8\u63E1\u628A \u6218\u7ED8",
        bra: "| Fibra de Carbono | Tinta de Guerra",
        fre: "Crosse graphite Peinture de guerre",
        hun: "Grafit markolat\xfa Harci fest\xe9s",
        swe: "Grafitgrepp Krigsf\xe4rg",
        schema: 17425
    },
    2042: {
        img: "piranha_mania_war_paint",
        eng: "Piranha Mania War Paint",
        rus: '"\u041F\u0440\u043E\u0431\u0430 \u043F\u0438\u0440\u0430\u043D\u044C\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "piraniowy zawr\xf3t g\u0142owy Barwy wojenne",
        sch: "\u98DF\u4EBA\u9C7C\u72C2\u6F6E \u6218\u7ED8",
        bra: "| Piranha Mania | Tinta de Guerra",
        fre: "Piranha mania Peinture de guerre",
        hun: "Piranha m\xe1nia Harci fest\xe9s",
        swe: "Pirayamani Krigsf\xe4rg",
        schema: 17427
    },
    2043: {
        img: "stealth_specialist_war_paint",
        eng: "Stealth Specialist War Paint",
        rus: '"\u0421\u043F\u0435\u0446 \u043F\u043E \u0441\u043A\u0440\u044B\u0442\u043D\u043E\u0441\u0442\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "specjalista skradania Barwy wojenne",
        sch: "\u9690\u5F62\u4E13\u5BB6 \u6218\u7ED8",
        bra: "| Especialista Furtivo | Tinta de Guerra",
        fre: "Sp\xe9cialit\xe9 furtive Peinture de guerre",
        hun: "Lopakod\xe1s-specialista Harci fest\xe9s",
        swe: "Smygspecialisten Krigsf\xe4rg",
        schema: 17426
    },
    2044: {
        img: "blackout_war_paint",
        eng: "Blackout War Paint",
        rus: '"\u0417\u0430\u0442\u0435\u043C\u043D\u0435\u043D\u0438\u0435" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "zaciemnienie Barwy wojenne",
        sch: "\u9177\u9ED1\u6B66\u58EB \u6218\u7ED8",
        bra: "| Blecaute | Tinta de Guerra",
        fre: "Noir c'est noir Peinture de guerre",
        hun: "Els\xf6t\xe9t\xedt\xe9s Harci fest\xe9s",
        swe: "Blackout Krigsf\xe4rg",
        schema: 17431
    },
    2045: {
        img: "brawler's_iron_war_paint",
        eng: "Brawler's Iron War Paint",
        rus: '"\u041A\u043B\u0435\u0439\u043C\u043E \u0432\u043E\u044F\u043A\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "spluwa siepacza Barwy wojenne",
        sch: "\u6597\u58EB\u94C1\u62F3 \u6218\u7ED8",
        bra: "| Ferro do Valent\xe3o | Tinta de Guerra",
        fre: "Fonte du bagarreur Peinture de guerre",
        hun: "Buny\xf3s vas Harci fest\xe9s",
        swe: "J\xe4rnskinn Krigsf\xe4rg",
        schema: 17429
    },
    2046: {
        img: "gobi_glazed_war_paint",
        eng: "Gobi Glazed War Paint",
        rus: '"\u041F\u0443\u0441\u0442\u044B\u043D\u043D\u043E\u0435 \u043F\u043E\u043A\u0440\u044B\u0442\u0438\u0435" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "gobijska glazura Barwy wojenne",
        sch: "\u6208\u58C1\u91C9\u5F69 \u6218\u7ED8",
        bra: "| Camuflagem Des\xe9rtica | Tinta de Guerra",
        fre: "\xc9mail de Gobi Peinture de guerre",
        hun: "Sivatagi bevonat\xfa Harci fest\xe9s",
        swe: "Gobiglaserad Krigsf\xe4rg",
        schema: 17423
    },
    2047: {
        img: "sleek_greek_war_paint",
        eng: "Sleek Greek War Paint",
        rus: '"\u0413\u0440\u0435\u0447\u0435\u0441\u043A\u0430\u044F \u0433\u0440\u0430\u0446\u0438\u044F" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "gustowny Grek Barwy wojenne",
        sch: "\u5E0C\u814A\u6D6A\u7EB9 \u6218\u7ED8",
        bra: "| Gregeleg\xe2ncia | Tinta de Guerra",
        fre: "Carrelage grec Peinture de guerre",
        hun: "Men\u0151 g\xf6r\xf6g Harci fest\xe9s",
        swe: "Grekisk elegans Krigsf\xe4rg",
        schema: 17424
    },
    2048: {
        img: "team_charged_war_paint",
        eng: "Team Charged War Paint",
        rus: '"\u0417\u0430\u0440\u044F\u0434 \u043A\u043E\u043C\u0430\u043D\u0434\u044B" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "\u0142adunek zespo\u0142owy Barwy wojenne",
        sch: "\u5168\u961F\u5145\u80FD \u6218\u7ED8",
        bra: "| Equipe Eletrizante | Tinta de Guerra",
        fre: "\xc9quipe charg\xe9e \xe0 bloc Peinture de guerre",
        hun: "Csapatra t\xf6lt\xf6tt Harci fest\xe9s",
        swe: "Teamladdad Krigsf\xe4rg",
        schema: 17428
    },
    2049: {
        img: "team_detail_war_paint",
        eng: "Team Detail War Paint",
        rus: '"\u041A\u043E\u043C\u0430\u043D\u0434\u043D\u0430\u044F \u043E\u0442\u0434\u0435\u043B\u043A\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "dru\u017Cynowy detal Barwy wojenne",
        sch: "\u7070\u5F71\u5E62\u5E62 \u6218\u7ED8",
        bra: "| Detalhe da Equipe | Tinta de Guerra",
        fre: "Couleur d'\xe9quipe Peinture de guerre",
        hun: "Csapatjelz\u0151 Harci fest\xe9s",
        swe: "Lagdetalj Krigsf\xe4rg",
        schema: 17422
    },
    2050: {
        img: "snug_sharpshooter",
        eng: "Snug Sharpshooter",
        schema: 31516,
        pol: "Sweterkowy strzelec",
        sch: "\u5B89\u9038\u5C04\u624B\u670D",
        bra: "Atirador Agasalhado",
        fre: "Tire-laine",
        hun: "Lezser Mesterl\xf6v\xe9sz",
        swe: "Mysskytt",
        rus: "\u0423\u0431\u0438\u0439\u0446\u0430 \u0432 \u0443\u044E\u0442\u0435"
    },
    2051: {
        img: "the_westcoat",
        eng: "The Westcoat",
        schema: 31515,
        pol: "Kowbojska kamizelka",
        sch: "\u897F\u90E8\u82B1\u9A6C\u7532",
        bra: "A Veste do Vaqueiro",
        fre: "Veste du Far West",
        hun: "Nagymell\xe9ny",
        swe: "V\xe4sternv\xe4st",
        rus: "\u0428\u0430\u0440\u043C \u0448\u0435\u0440\u0438\u0444\u0430"
    },
    2052: {
        img: "commanding_presence",
        eng: "Commanding Presence",
        schema: 31512,
        pol: "Prezencja przyw\xf3dcy",
        sch: "\u51DB\u51DB\u5A01\u98CE",
        bra: "Casaco do Comandante",
        fre: "Pr\xe9sence imposante",
        hun: "Parancsol\xf3 Megjelen\xe9s",
        swe: "Befallande n\xe4rvaro",
        rus: "\u0412\u043D\u0443\u0448\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0432\u0438\u0434"
    },
    2053: {
        img: "field_fatigues",
        eng: "Field Fatigues",
        schema: 31508,
        pol: "Zlodowacia\u0142e zm\u0119czenie",
        sch: "\u91CE\u5730\u4F5C\u6218\u670D",
        bra: "Farda de Campo",
        fre: "Manteau du front",
        hun: "Terepi Egyenruha",
        swe: "F\xe4ltmundering",
        rus: "\u041F\u043E\u043B\u0435\u0432\u043E\u0439 \u043D\u0430\u0440\u044F\u0434"
    },
    2054: {
        img: "the_crimbo_cap",
        eng: "The Crimbo Cap",
        schema: 31505,
        pol: "Gwiazdkowa czapeczka",
        sch: "\u8282\u5E86\u9E2D\u820C\u5E3D",
        bra: "O Papai Bon\xe9l",
        fre: "Bonnet des f\xeates",
        hun: "Kari-sapka",
        swe: "Smulan",
        rus: "\u041A\u0435\u043F\u043A\u0430 \u0434\u043B\u044F \u043A\u0430\u043D\u0438\u043A\u0443\u043B"
    },
    2055: {
        img: "consiglieres_coverup",
        eng: "Consigliere's Coverup",
        schema: 31504,
        pol: "Styl\xf3wa syndykatu",
        sch: "\u987E\u95EE\u98CE\u8863",
        bra: "Casaco do Consigliere",
        fre: "Manteau du consigliere",
        hun: "A Consigliere Leple",
        swe: "Skyld consigliere",
        rus: "\u041A\u043E\u0441\u0442\u044E\u043C \u043A\u043E\u043D\u0441\u0438\u043B\u044C\u0435\u0440\u0438"
    },
    2056: {
        img: "poleur_voyeur",
        eng: "Poleur Voyeur",
        schema: 31500,
        pol: "Parka podgl\u0105dacza",
        sch: "\u6781\u5730\u7AA5\u63A2\u8005",
        bra: "Voyeur Poleur",
        swe: "Poler voyeur",
        rus: "\u041F\u043E\u043B\u044F\u0440\u043D\u044B\u0439 \u043F\u043E\u0434\u0433\u043B\u044F\u0434\u044B\u0432\u0430\u0442\u0435\u043B\u044C"
    },
    2057: {
        img: "hot_spaniel",
        eng: "Hot Spaniel",
        schema: 31497,
        pol: "Grzej\u0105cy go\u0144czak",
        sch: "\u70ED\u706B\u72AC\u8033\u5E3D",
        bra: "Spaniel Esquentado",
        fre: "\xc9pagneul de braise",
        hun: "Meleg F\xfcles",
        swe: "Kokhet spaniel",
        rus: "\u0418\u0441\u043A\u0440\u043E\u043C\u0451\u0442\u043D\u0430\u044F \u0438\u0449\u0435\u0439\u043A\u0430"
    },
    2058: {
        img: "the_battle_music",
        eng: "The Battle Music",
        schema: 31496,
        pol: "Bitewny beat",
        sch: "\u5F00\u6218\u5C0F\u66F2",
        bra: "A M\xfasica de Batalha",
        fre: "Bande-son de baston",
        hun: "Harci Zene",
        swe: "Stridsmusik",
        rus: "\u0411\u043E\u0435\u0432\u0430\u044F \u043C\u0443\u0437\u044B\u043A\u0430"
    },
    2059: {
        img: "dapper_noel",
        eng: "Dapper Noel",
        schema: 31494,
        pol: "\u015Ani\u0105teczne oblicze",
        sch: "\u76DB\u88C5\u5E86\u8282",
        bra: "Papai Noelegante",
        fre: "Santa classe",
        hun: "Eleg\xe1ns Mikl\xf3s",
        swe: "Stilig Noel",
        rus: "\u041F\u044B\u0448\u043D\u044B\u0439 \u043F\u0440\u0430\u0437\u0434\u043D\u0438\u043A"
    },
    2060: {
        img: "bucks_brim",
        eng: "Buck's Brim",
        schema: 31514,
        pol: "Zaklinacz koni",
        sch: "\u96C4\u9E7F\u5BBD\u6A90\u5E3D",
        bra: "O Chap\xe9u do Vaqueiro",
        fre: "Chapeau vachette",
        hun: "Kev\xe9lykalap",
        swe: "Cowboybr\xe4tte",
        rus: "\u041A\u043E\u0437\u044B\u0440\u043D\u043E\u0439 \u043A\u043E\u0432\u0431\u043E\u0439"
    },
    2061: {
        img: "mine_sweepers",
        eng: "Mine Sweepers",
        schema: 31513,
        pol: "Tra\u0142\xf3wki",
        sch: "\u626B\u96F7\u5175\u4E4B\u9774",
        bra: "Coturnos do Comandante",
        fre: "D\xe9mineuses",
        hun: "Aknakeres\u0151k",
        swe: "Minr\xf6jare",
        rus: "\u041C\u0438\u043D\u043E\u0434\u0430\u0432\u044B"
    },
    2062: {
        img: "cossack_camo",
        eng: "Cossack Camo",
        schema: 31509,
        pol: "Kozacki kamufla\u017C",
        sch: "\u54E5\u8428\u514B\u519B\u5927\u8863",
        bra: "Camuflagem Cossaca",
        fre: "Camouflage cosaque",
        hun: "Koz\xe1k\xe1lca",
        swe: "Kosackkamouflage",
        rus: "\u041A\u0430\u0437\u0430\u0446\u043A\u0438\u0439 \u043A\u0430\u043C\u0443\u0444\u043B\u044F\u0436"
    },
    2063: {
        img: "polar_charger",
        eng: "Polar Charger",
        schema: 31507,
        pol: "Polarne natarcie",
        sch: "\u6781\u5730\u608D\u5175",
        bra: "Atacante Ant\xe1rtico",
        fre: "Chargeur polaire",
        hun: "Sarkvid\xe9ki Rohamosztag",
        swe: "Polarens usjanka",
        rus: "\u041F\u043E\u043B\u044F\u0440\u043D\u044B\u0439 \u043F\u0430\u0442\u0440\u043E\u043D\u0442\u0430\u0448"
    },
    2064: {
        img: "the_triple_jumper",
        eng: "The Triple Jumper",
        schema: 31506,
        pol: "Potr\xf3jny skoczek",
        sch: "\u8FDE\u8DF3\u8FD0\u52A8\u886B",
        bra: "O Su\xe9ter do Saltador",
        fre: "Triple \xe9paisseur",
        hun: "H\xe1rmasugr\xf3",
        swe: "Topplager",
        rus: "\u0422\u0440\u043E\u0439\u043D\u043E\u0439 \u043F\u0440\u044B\u0433\u0443\u043D"
    },
    2065: {
        img: "the_checkered_past",
        eng: "The Checkered Past",
        schema: 31503,
        pol: "Przesz\u0142o\u015B\u0107 w kratk\u0119",
        sch: "\u574E\u5777\u5F80\u6614",
        bra: "Frio e Calculista",
        fre: "B\xe9ret \xe0 carreaux",
        hun: "K\xe9tes M\xfalt",
        swe: "Brokig bakgrund",
        rus: "\u041A\u043B\u0435\u0442\u0447\u0430\u0442\u044B\u0439 \u043A\u043E\u0437\u044B\u0440\u0451\u043A"
    },
    2066: {
        img: "le_frosteaux",
        eng: "Le Frosteaux",
        schema: 31501,
        sch: "\u8E0F\u971C\u884C\u8005",
        bra: "Les Cal\xe7eaux Congeladeaux",
        fre: "Les Frosteaux",
        rus: "\u041B\u0451 \u041C\u043E\u0440\u043E\u0437\u044C\u0451"
    },
    2067: {
        img: "frostbite_fit",
        eng: "Frostbite Fit",
        schema: 31498,
        pol: "Odzienie odmro\u017Conego",
        sch: "\u91CF\u8EAB\u51BB\u5BB3",
        bra: "Traje de Frio",
        fre: "Pull anti-gel",
        hun: "Fagyos Felszerel\xe9s",
        swe: "Ullpolo",
        rus: "\u0421\u043D\u0430\u0440\u044F\u0436\u0435\u043D\u0438\u0435 \u043E\u0442 \u043E\u0431\u043C\u043E\u0440\u043E\u0436\u0435\u043D\u0438\u044F"
    },
    2068: {
        img: "laire_filteure",
        eng: "L'aire Filteure",
        schema: 31499,
        pol: "Facjatowy filtr",
        sch: "\u8FC7\u6EE4\u5F0F\u547C\u5438\u9762\u7F69",
        bra: "Le Filtre d'Aire",
        rus: "\u0424\u0438\u043B\u044C\u0442\u0440 \u0430-\u043B\u044F \u0432\u043E\u0437\u0434\u0443\u0445"
    },
    2069: {
        img: "the_top_brass",
        eng: "The Top Brass",
        schema: 31511,
        pol: "Zwierzchnik",
        sch: "\u9876\u5934\u8981\u5458",
        bra: "O Quepe do Comandante",
        fre: "Haut grad\xe9",
        hun: "F\u0151tiszt",
        swe: "H\xf6jdaren",
        rus: "\u041C\u0435\u0434\u043D\u044B\u0439 \u043C\u0430\u0440\u0448\u0430\u043B"
    },
    2070: {
        img: "battle_balaclava",
        eng: "Battle Balaclava",
        schema: 31510,
        pol: "Bitewna balaklawa",
        sch: "\u683C\u6597\u8499\u9762\u7F69",
        bra: "Balaclava de Batalha",
        fre: "Cagoule de combat",
        hun: "Csatas\xedmaszk",
        swe: "Stridsluva",
        rus: "\u0411\u043E\u0435\u0432\u0430\u044F \u0431\u0430\u043B\u0430\u043A\u043B\u0430\u0432\u0430"
    },
    2071: {
        img: "scrooge_mcdoc",
        eng: "Scrooge McDoc",
        schema: 31502,
        pol: "Sknerus McKonowa\u0142",
        sch: "\u5B88\u8D22\u5974\u9EA6\u514B\u5927\u592B",
        bra: "Doutor Patinhas",
        fre: "Dr Scrooge",
        hun: "Doktor Scrooge",
        swe: "Doktor Scrooge",
        rus: "\u0421\u043A\u0440\u0443\u0434\u0436 \u041C\u0430\u043A\u0434\u043E\u043A"
    },
    2072: {
        img: "the_necroprancer",
        eng: "The Necroprancer",
        schema: 31495,
        pol: "Nekrok\u0142usak",
        sch: "\u4EA1\u9A87\u98DE\u9E7F",
        bra: "A Necrorrena",
        fre: "N\xe9croblagueur",
        hun: "R\xe9mszarvas",
        swe: "Nekroprancer",
        rus: "\u041D\u0435\u043A\u0440\u043E\u043A\u043E\u043F\u044B\u0442"
    },
    2073: {
        img: "taunt_forehead_slice",
        eng: "Taunt: Fore-Head Slice",
        schema: 31493,
        pol: "Drwina: Zamach z g\u0142ow\u0105",
        sch: "\u5632\u8BBD\uFF1A\u4E00\u6746\u7206\u5934",
        bra: "Provoca\xe7\xe3o: Golfe Degolado",
        fre: "Raillerie : Swing de ciboulot",
        hun: "Besz\xf3l\xe1s: Homlokegyenes \xfct\xe9s",
        swe: "H\xe5n: Sista svingen",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0411\u0435\u0440\u0435\u0433\u0438 \u0433\u043E\u043B\u043E\u0432\u0443"
    },
    2074: {
        img: "taunt_peace",
        eng: "Taunt: Peace!",
        schema: 31492,
        pol: "Drwina: Pok\xf3j!",
        sch: "\u5632\u8BBD\uFF1A\u76F8\u5904\u6109\u5FEB\uFF01",
        bra: "Provoca\xe7\xe3o: Paz!",
        fre: "Raillerie : Peace and love",
        hun: "Besz\xf3l\xe1s: B\xe9ke!",
        swe: "H\xe5n: Peace and love!",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041C\u0438\u0440!"
    },
    2075: {
        img: "taunt_curtain_call",
        eng: "Taunt: Curtain Call",
        schema: 31491,
        pol: "Drwina: Entuzjasta estrady",
        sch: "\u5632\u8BBD\uFF1A\u8C22\u5E55",
        bra: "Provoca\xe7\xe3o: Rever\xeancia",
        fre: "Raillerie : Rappel sur sc\xe8ne",
        hun: "Besz\xf3l\xe1s: F\xfcgg\xf6ny!",
        swe: "H\xe5n: Rid\xe5",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0412\u044B\u0445\u043E\u0434 \u043D\u0430 \u043F\u043E\u043A\u043B\u043E\u043D"
    },
    2076: {
        img: "spy_ties",
        eng: "Spy Ties",
        schema: 31542,
        pol: "Szpiegowskie krawaty",
        sch: "\u95F4\u8C0D\u9886\u5E26",
        bra: "Gravata do Magnata",
        fre: "Cravates du Spy",
        hun: "K\xe9mes Nyakkend\u0151k",
        swe: "Smusselslips",
        rus: "\u0428\u043F\u0438\u043E\u043D \u0432 \u0437\u0430\u0432\u044F\u0437\u043A\u0435"
    },
    2077: {
        img: "le_sapeur",
        eng: "Le Sapeur",
        schema: 31540,
        sch: "\u5148\u950B\u5DE5\u5175\u76D4",
        bra: "Le Sabotadeur",
        rus: "\u041B\u0451 \u0421\u0430\u0431\u043E\u0442\u0451\u0440"
    },
    2078: {
        img: "shady_shelby",
        eng: "Shady Shelby",
        schema: 31535,
        pol: "Kapota spod ciemnej gwiazdy",
        sch: "\u897F\u88C5\u66B4\u5F92",
        bra: "O Shelby Soturno",
        fre: "Veste de l'\xe9cornifleur",
        hun: "S\xf6t\xe9t Shelby",
        swe: "Skumma Shelby",
        rus: "\u0428\u0435\u043B\u044C\u043C\u043E\u0432\u0430\u0442\u044B\u0439 \u0428\u0435\u043B\u0431\u0438"
    },
    2079: {
        img: "hunk_of_monk",
        eng: "Hunk Of Monk",
        schema: 31525,
        pol: "Zakonna tonsura",
        sch: "\u5927\u5757\u5934\u50E7\u4FA3",
        bra: "Um Monge da Pesada",
        fre: "Tonsure de moine",
        hun: "Atyafej",
        swe: "Munkhunken",
        rus: "\u041C\u043E\u0433\u0443\u0447\u0438\u0439 \u043C\u043E\u043D\u0430\u0445"
    },
    2080: {
        img: "esprit_de_corps",
        eng: "Esprit De Corps",
        schema: 31528,
        sch: "\u8B66\u961F\u4E4B\u9B42",
        rus: "\u041F\u043E\u043B\u0438\u0446\u0435\u0439\u0441\u043A\u0430\u044F \u0432\u043E\u043B\u043D\u0430"
    },
    2081: {
        img: "mann_of_the_hour",
        eng: "Mann of the Hour",
        schema: 31536,
        pol: "Gw\xf3\u017Ad\u017A programu",
        sch: "\u98CE\u4E91\u4EBA\u7269",
        bra: "Mann do Momento",
        fre: "Bluesmann",
        hun: "A Pillanatnyi Szenz\xe1ci\xf3",
        swe: "Charm\xf6ren",
        rus: "\u0412\u0438\u043D\u043E\u0432\u043D\u0438\u043A \u0442\u043E\u0440\u0436\u0435\u0441\u0442\u0432\u0430"
    },
    2082: {
        img: "frogmanns_fittings",
        eng: "Frogmann's Fittings",
        schema: 31531,
        pol: "Op\u0142ywowe oporz\u0105dzenie",
        sch: "\u86D9\u4EBA\u6F5C\u6C34\u5957\u4EF6",
        bra: "O Mannf\xedbio",
        fre: "La combinaison de l'homme-grenouille",
        hun: "B\xe9kamannus-felszerel\xe9s",
        swe: "Grodmannsdr\xe4kt",
        rus: "\u0410\u043C\u0443\u043D\u0438\u0446\u0438\u044F \u0430\u043A\u0432\u0430\u043B\u0430\u043D\u0433\u0438\u0441\u0442\u0430"
    },
    2083: {
        img: "clinical_investigator",
        eng: "Clinical Investigator",
        schema: 31544,
        pol: "Szpitalny \u015Bledczy",
        sch: "\u4E34\u5E8A\u8C03\u67E5\u5458",
        bra: "Investigador Cl\xednico",
        fre: "Enqu\xeateur clinique",
        hun: "Orvosi Kivizsg\xe1l\xf3",
        swe: "Klinisk utredare",
        rus: "\u041A\u043B\u0438\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0434\u043E\u0437\u043D\u0430\u0432\u0430\u0442\u0435\u043B\u044C"
    },
    2084: {
        img: "cattlemans_kettle",
        eng: "Cattleman's Kettle",
        schema: 31523,
        pol: "Kapalin krowopasa",
        sch: "\u7267\u573A\u4E3B\u7684\u94C1\u58F6\u76D4",
        bra: "Morri\xe3o de Constru\xe7\xe3o",
        fre: "Chapel du vacher",
        hun: "Teh\xe9np\xe1sztor-t\xe1ny\xe9rsisak",
        swe: "Koherdens kittelhj\xe4lm",
        rus: "\u041A\u043E\u0442\u0435\u043B\u043E\u043A \u0441\u043A\u043E\u0442\u043E\u0432\u043E\u0434\u0430"
    },
    2085: {
        img: "jarhead",
        eng: "Jarhead",
        schema: 31539,
        pol: "Trep",
        sch: "\u9505\u76D6\u5934",
        bra: "Soldado An\xf4nimo",
        fre: "Coupe militaire",
        hun: "B\u0151rnyak\xfa",
        swe: "Rekryt",
        rus: "\u041C\u043E\u0440\u043F\u0435\u0445"
    },
    2086: {
        img: "le_morne_uniforme",
        eng: "Le Morne Uniforme",
        schema: 31541,
        sch: "\u8083\u7A46\u519B\u88C5",
        rus: "\u041B\u0451 \u0423\u043D\u044B\u043B\u044C\u0451"
    },
    2087: {
        img: "blindin_bonnett",
        eng: "Blindin' Bonnett",
        schema: 31534,
        pol: "O\u015Blepiaj\u0105ca oprych\xf3wka",
        sch: "\u63A9\u76EE\u5243\u5200\u5E3D",
        bra: "Boina de Birmingham",
        fre: "Bonnet du brigandeau",
        hun: "Beretv\xe1s Ellenz\u0151",
        swe: "Gubbkeps",
        rus: "\u041A\u043E\u0441\u043E\u0439 \u043A\u043E\u0437\u044B\u0440\u0451\u043A"
    },
    2088: {
        img: "fat_friar",
        eng: "Fat Friar",
        schema: 31526,
        pol: "Du\u017Cy duchowny",
        sch: "\u80D6\u4FEE\u58EB",
        bra: "Irm\xe3o Barrig\xe3o",
        fre: "Fr\xe8re bidoche",
        hun: "Testes Szerzetes",
        swe: "Broder Rund",
        rus: "\u041F\u0443\u0437\u0430\u0442\u044B\u0439 \u043F\u0440\u043E\u043F\u043E\u0432\u0435\u0434\u043D\u0438\u043A"
    },
    2089: {
        img: "hardcore_pantalon",
        eng: "Hardcore Pantalon",
        schema: 31529,
        pol: "Hardkorowe pantalony",
        sch: "\u786C\u6838\u5587\u53ED\u88E4",
        bra: "Cal\xe7as Hardcore",
        fre: "Pantalon du f\xeatard",
        hun: "Karak\xe1n Pantall\xf3",
        swe: "Hardcorehosor",
        rus: "\u041F\u0430\u043D\u0442\u0430\u043B\u043E\u043D\u044B \u0445\u0430\u0440\u0434\u043A\u043E\u0440\u0430"
    },
    2090: {
        img: "the_headliner",
        eng: "The Headliner",
        schema: 31537,
        pol: "Gwiazda wieczoru",
        sch: "\u5F53\u7EA2\u660E\u661F",
        bra: "A Atra\xe7\xe3o Principal",
        fre: "Le photog\xe9nique",
        hun: "A C\xedmlapsztori",
        swe: "Huvudattraktionen",
        rus: "\u0413\u0432\u043E\u0437\u0434\u044C \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B"
    },
    2091: {
        img: "oxygen_provider",
        eng: "Oxygen Provider",
        schema: 31532,
        pol: "Zaopatrzenie tlenu",
        sch: "\u6C27\u6C14\u4F9B\u7ED9\u88C5\u7F6E",
        bra: "Provedor de Oxig\xeanio",
        fre: "La bombonne d'oxyg\xe8ne",
        hun: "Oxig\xe9nell\xe1t\xf3",
        swe: "Syreleverant\xf6r",
        rus: "\u041A\u043B\u0430\u0434\u0435\u0437\u044C \u043A\u0438\u0441\u043B\u043E\u0440\u043E\u0434\u0430"
    },
    2092: {
        img: "shadow_of_doubt",
        eng: "Shadow of Doubt",
        schema: 31543,
        pol: "Cie\u0144 w\u0105tpliwo\u015Bci",
        sch: "\u7591\u4E91\u91CD\u91CD",
        bra: "Sombra de D\xfavida",
        fre: "L'ombre du doute",
        hun: "A K\xe9tely \xc1rny\xe9ka",
        swe: "Skuggan av tvivel",
        rus: "\u0422\u0435\u043D\u044C \u0441\u043E\u043C\u043D\u0435\u043D\u0438\u044F"
    },
    2093: {
        img: "sir_buildsalot",
        eng: "Sir Buildsalot",
        schema: 31524,
        pol: "Murgrabia Murator",
        sch: "\u591A\u5EFA\u76CA\u5584\u7235\u58EB",
        bra: "Prote\xe7\xe3o do Pastoreio",
        fre: "Sire Bricolot",
        hun: "Sir T\xe1kol\xf3",
        swe: "Byggm\xe4staren",
        rus: "\u0421\u044D\u0440 \u0414\u0435\u043B\u043B-\u043D\u0435\u0432\u043F\u0440\u043E\u0432\u043E\u0440\u043E\u0442"
    },
    2094: {
        img: "the_abyss_diver",
        eng: "The Abyss Diver",
        schema: 31530,
        pol: "Zanurzony w otch\u0142ani",
        sch: "\u6DF1\u6D77\u6F5C\u6C34\u5458",
        bra: "Mergulhador Abissal",
        fre: "Le Plongeur des abysses",
        hun: "A M\xe9lyb\xfav\xe1r",
        swe: "Avgrundsdykare",
        rus: "\u041D\u044B\u0440\u044F\u043B\u044C\u0449\u0438\u043A \u0432 \u0431\u0435\u0437\u0434\u043D\u0443"
    },
    2095: {
        img: "short_fuse",
        eng: "Short Fuse",
        schema: 31533,
        pol: "Zapalczywy",
        sch: "\u66B4\u813E\u6C14\u5C0F\u5E3D",
        bra: "Toucabum",
        fre: "M\xe8che courte",
        hun: "K\xf6t\xf6tt Kan\xf3c",
        swe: "Kort stubin",
        rus: "\u041A\u043E\u0440\u043E\u0442\u043A\u0438\u0439 \u0444\u0438\u0442\u0438\u043B\u044C"
    },
    2096: {
        img: "mr_rostov",
        eng: "Mr. Rostov",
        schema: 31527,
        pol: "Pan Rostow",
        sch: "\u7F57\u65AF\u6258\u592B\u5148\u751F",
        bra: "Sr. Rostov",
        fre: "Monsieur Rostov",
        hun: "Mr. Rosztov",
        swe: "Herr Rostov",
        rus: "\u0413\u043E\u0441\u043F\u043E\u0434\u0438\u043D \u0420\u043E\u0441\u0442\u043E\u0432"
    },
    2097: {
        img: "case_of_the_blues",
        eng: "Case of the Blues",
        schema: 31538,
        pol: "Bluesowy futera\u0142",
        sch: "\u84DD\u8C03\u5409\u4ED6\u5305",
        bra: "Estojo do Formoso",
        fre: "Coup de blues",
        hun: "Szint\xe9n Zen\xe9sz",
        swe: "Sista ackordet",
        rus: "\u0413\u0440\u0443\u0437 \u0442\u043E\u0441\u043A\u0438"
    },
    2098: {
        img: "team_cap",
        eng: "Team Cap",
        schema: 31522,
        pol: "Dru\u017Cynowe zadaszenie",
        sch: "\u6218\u961F\u9E2D\u820C\u5E3D",
        bra: "Bon\xe9 da Equipe",
        fre: "Casquette d'\xe9quipe",
        hun: "Csapatsapka",
        swe: "Lagkeps",
        rus: "\u041A\u043E\u043C\u0430\u043D\u0434\u043D\u0430\u044F \u043A\u0435\u043F\u043A\u0430"
    },
    2099: {
        img: "taunt_bear_hug",
        eng: "Taunt: Bear Hug",
        schema: 31519,
        pol: "Drwina: Nied\u017Awiedzi u\u015Bcisk",
        sch: "\u5632\u8BBD\uFF1A\u718A\u62B1",
        bra: "Provoca\xe7\xe3o: Abra\xe7o de Urso",
        fre: "Raillerie : Accolade fraternelle",
        hun: "Besz\xf3l\xe1s: Medve\xf6lel\xe9s",
        swe: "H\xe5n: Bj\xf6rntj\xe4nst",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041C\u0435\u0434\u0432\u0435\u0436\u044C\u0438 \u043E\u0431\u044A\u044F\u0442\u044C\u044F"
    },
    2100: {
        img: "taunt_texan_trickshot",
        eng: "Taunt: Texan Trickshot",
        schema: 31520,
        pol: "Drwina: Teksa\u0144ski trik",
        sch: "\u5632\u8BBD\uFF1A\u5FB7\u5DDE\u800D\u67AA\u672F",
        bra: "Provoca\xe7\xe3o: Firula do Faroeste",
        fre: "Raillerie : Tir texan",
        hun: "Besz\xf3l\xe1s: Texasi kap\xe1sl\xf6v\xe9s",
        swe: "H\xe5n: Trickskott fr\xe5n Texas",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0422\u0435\u0445\u0430\u0441\u0441\u043A\u0438\u0439 \u0442\u0440\u044E\u043A"
    },
    2101: {
        img: "taunt_final_score",
        eng: "Taunt: The Final Score",
        schema: 31518,
        pol: "Drwina: Wynik ko\u0144cowy",
        sch: "\u5632\u8BBD\uFF1A\u5F97\u5206\u7ED3\u679C",
        bra: "Provoca\xe7\xe3o: Nota Final",
        fre: "Raillerie : Score final",
        hun: "Besz\xf3l\xe1s: V\xe9geredm\xe9ny",
        swe: "H\xe5n: Slutresultatet",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0418\u0442\u043E\u0433\u043E\u0432\u0430\u044F \u043E\u0446\u0435\u043D\u043A\u0430"
    },
    2102: {
        img: "taunt_flying_colors",
        eng: "Taunt: Flying Colors",
        schema: 31521,
        pol: "Drwina: Powiewaj\u0105ce barwy",
        sch: "\u5632\u8BBD\uFF1A\u6218\u65D7\u98D8\u626C",
        bra: "Provoca\xe7\xe3o: Marcando Posi\xe7\xe3o",
        fre: "Raillerie : La banni\xe8re solennelle",
        hun: "Besz\xf3l\xe1s: A lobog\xf3",
        swe: "H\xe5n: Med glans",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041F\u043E\u0431\u0435\u0434\u043D\u044B\u0435 \u0432\u0435\u044F\u043D\u0438\u044F"
    },
    2103: {
        img: "viscera_visor",
        eng: "Viscera Visor",
        schema: 31571,
        pol: "Wgl\u0105d do wn\u0119trzno\u015Bci",
        sch: "\u7834\u810F\u62A4\u8138\u7F69",
        bra: "Visor Antiv\xedsceras",
        fre: "Visi\xe8re \xe0 visc\xe8res",
        hun: "V\xe9rellenz\u0151",
        swe: "Splattersk\xe4rm",
        rus: "\u041F\u0440\u0435\u0433\u0440\u0430\u0434\u0430 \u0434\u043B\u044F \u043F\u043E\u0442\u0440\u043E\u0445\u043E\u0432"
    },
    2104: {
        img: "professor_photon",
        eng: "Professor Photon",
        schema: 31569,
        pol: "Profesor Foton",
        sch: "\u5149\u5B50\u6559\u6388",
        bra: "Professor Pr\xf3ton",
        fre: "Professeur Photon",
        hun: "Foton Professzor",
        swe: "Professor Foton",
        rus: "\u041F\u0440\u043E\u0444\u0435\u0441\u0441\u043E\u0440 \u0424\u043E\u0442\u043E\u043D"
    },
    2105: {
        img: "the_misdirector",
        eng: "The Misdirector",
        schema: 31566,
        pol: "Dezorientor",
        sch: "\u8BEF\u5BFC\u827A\u672F",
        bra: "O Ilusionista Ilusivo",
        fre: "L'escamoteur",
        hun: "Eligazgat\xf3",
        swe: "Vilseledare",
        rus: "\u0413\u043B\u0430\u0437\u043E\u043E\u0442\u0432\u043E\u0434"
    },
    2106: {
        img: "seamanns_stubble",
        eng: "Seamann's Stubble",
        schema: 31565,
        pol: "Szczecina morskiej wygi",
        sch: "\u6C34\u624B\u7684\u7EDC\u816E\u80E1",
        bra: "A Barba Vai Fumar",
        fre: "Barbe du marin",
        hun: "Matr\xf3zszak\xe1ll",
        swe: "Sj\xf6mannens stubb",
        rus: "\u041C\u043E\u0440\u044F\u0446\u043A\u0438\u0435 \u0437\u0430\u0440\u043E\u0441\u043B\u0438"
    },
    2107: {
        img: "torn_terror",
        eng: "Torn Terror",
        schema: 31563,
        pol: "Podarty postrach",
        sch: "\u975E\u4E3B\u6D41\u5206\u5B50",
        bra: "Metidinho e Maltrapilho",
        fre: "Gredin d\xe9penaill\xe9",
        hun: "Szakadt Sz\xf6rny\u0171s\xe9g",
        swe: "Rivj\xe4rnet",
        rus: "\u0420\u0432\u0430\u043D\u044B\u0439 \u0440\u0430\u0437\u0431\u043E\u0439"
    },
    2108: {
        img: "feathered_villain",
        eng: "Feathered Villain",
        schema: 31559,
        pol: "Pierzasty przeciwnik",
        sch: "\u4EC7\u654C\u7684\u5939\u7FBD\u5E3D",
        bra: "Emplumado e Preparado",
        fre: "Vaurien volatile",
        hun: "Tollas Ellens\xe9g",
        swe: "Befj\xe4drad best",
        rus: "\u041E\u043F\u0435\u0440\u0451\u043D\u043D\u044B\u0439 \u043E\u043F\u043F\u043E\u043D\u0435\u043D\u0442"
    },
    2109: {
        img: "air_exchanger",
        eng: "Air Exchanger",
        schema: 31555,
        pol: "Filtrator",
        sch: "\u65B0\u98CE\u6362\u6C14\u9762\u7F69",
        bra: "Trocador de Ar",
        fre: "\xc9changeur d'air",
        hun: "L\xe9gcser\xe9l\u0151",
        swe: "Luftv\xe4xlare",
        rus: "\u041A\u043E\u043D\u0432\u0435\u0440\u0442\u0435\u0440 \u043A\u0438\u0441\u043B\u043E\u0440\u043E\u0434\u0430"
    },
    2110: {
        img: "poncho_del_pesado",
        eng: "Poncho del Pesado",
        schema: 31554,
        pol: "Ponczo del przytuszy",
        sch: "\u539A\u91CD\u62AB\u98CE",
        rus: "\u041F\u043E\u043D\u0447\u043E \u0434\u0435\u043B\u044C \u043F\u0435\u0441\u0430\u0434\u043E"
    },
    2111: {
        img: "service_satchel",
        eng: "Service Satchel",
        schema: 31551,
        pol: "S\u0142u\u017Cbowa sakwa",
        sch: "\u7EF4\u62A4\u5C0F\u5DE5\u5177",
        bra: "Ferramentas do Fundidor",
        fre: "Sacoche de service",
        hun: "Szervizt\xe1ska",
        swe: "Tj\xe4nstev\xe4ska",
        rus: "\u0421\u0435\u0440\u0432\u0438\u0441\u043D\u0430\u044F \u0441\u0443\u043C\u043A\u0430"
    },
    2112: {
        img: "technicians_tunic",
        eng: "Technician's Tunic",
        schema: 31550,
        pol: "Tunika technika",
        sch: "\u6280\u672F\u5458\u7684\u5236\u670D",
        bra: "T\xfanica do T\xe9cnico",
        fre: "Combi du technicien",
        hun: "Technikusi Tunika",
        swe: "Teknikerns tunika",
        rus: "\u0422\u0443\u043D\u0438\u043A\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0430"
    },
    2113: {
        img: "mad_drip",
        eng: "Mad Drip",
        schema: 31570,
        pol: "Szalona styl\xf3wa",
        sch: "\u72C2\u5984\u4E4B\u4EBA",
        bra: "Insanamente Estiloso",
        fre: "Esbroufe",
        hun: "Bolondcseppek",
        swe: "Sjukt stilig",
        rus: "\u0421\u0443\u043C\u0430\u0441\u0448\u0435\u0434\u0448\u0438\u0439 \u0441\u0442\u0438\u043B\u044C"
    },
    2114: {
        img: "sleight_of_hand",
        eng: "Sleight of Hand",
        schema: 31567,
        pol: "Kuglarz",
        sch: "\u9B54\u672F\u5999\u5999\u624B",
        bra: "Truque na Manga",
        fre: "Prestidigitateur",
        hun: "Sima Leoszt\xe1s",
        swe: "Fingerf\xe4rdig fl\xe4rd",
        rus: "\u041B\u043E\u0432\u043A\u043E\u0441\u0442\u044C \u0440\u0443\u043A"
    },
    2115: {
        img: "ripped_runts",
        eng: "Ripped Runts",
        schema: 31564,
        pol: "Narwany typ",
        sch: "\u729F\u725B\u7834\u6D1E\u88E4",
        bra: "Rasgos Radicais",
        fre: "Avorton d\xe9guenill\xe9",
        hun: "Szakadt Szerk\xf3",
        swe: "Trasbyxor",
        rus: "\u041B\u044E\u0442\u044B\u0435 \u043B\u043E\u0445\u043C\u043E\u0442\u044C\u044F"
    },
    2116: {
        img: "pantaloons_of_unabashed_villainy",
        eng: "Pantaloons of Unabashed Villainy",
        schema: 31561,
        pol: "Pantalony bezwstydnej nikczemno\u015Bci",
        sch: "\u65E0\u803B\u884C\u5F84",
        bra: "Cal\xe7as Orgulhosamente Vilanescas",
        fre: "Futal d'infamie culott\xe9e",
        hun: "A Sz\xe9gyentelen Gazs\xe1g Pantall\xf3ja",
        swe: "Gentlemannaskurkens dj\xe4rva pantalonger",
        rus: "\u041F\u0430\u043D\u0442\u0430\u043B\u043E\u043D\u044B \u0431\u0435\u0441\u0441\u0442\u044B\u0434\u043D\u043E\u0433\u043E \u0431\u0435\u0437\u0437\u0430\u043A\u043E\u043D\u0438\u044F"
    },
    2117: {
        img: "industrial_insurgent",
        eng: "Industrial Insurgent",
        schema: 31556,
        pol: "Przemys\u0142owy powstaniec",
        sch: "\u5DE5\u4E1A\u53DB\u4E71\u8005",
        bra: "Insurgente Industrial",
        fre: "Insurg\xe9 industriel",
        hun: "Ipari Felkel\u0151",
        swe: "Industriell upprorsmakare",
        rus: "\u0417\u0430\u0432\u043E\u0434\u0441\u043A\u043E\u0439 \u0437\u0430\u0447\u0438\u043D\u0449\u0438\u043A"
    },
    2118: {
        img: "el_gigantes_gunbelt",
        eng: "El Gigante's Gunbelt",
        schema: 31553,
        pol: "El pulchne pasy",
        sch: "\u5DE8\u6C49\u7684\u6B66\u88C5\u6302\u888B",
        bra: "Munici\xf3n del Gigante",
        fre: "Ceinture \xe0 munitions d'El Gigante",
        hun: "El Gigante T\xf6lt\xe9ny\xf6ve",
        swe: "El Gigantes pistolb\xe4lte",
        rus: "\u041F\u0430\u0442\u0440\u043E\u043D\u0442\u0430\u0448 \u042D\u043B\u044C \u0413\u0438\u0433\u0430\u043D\u0442\u0435"
    },
    2119: {
        img: "heat_shield",
        eng: "Heat Shield",
        schema: 31549,
        pol: "Termiczna tarcza",
        sch: "\u9694\u70ED\u9762\u7F69",
        bra: "Escudo T\xe9rmico",
        fre: "Protection thermique",
        hun: "H\u0151pajzs",
        swe: "V\xe4rmesk\xf6ld",
        rus: "\u041F\u0440\u0438\u043A\u0440\u044B\u0442\u0438\u0435 \u043E\u0442 \u043F\u0435\u043A\u043B\u0430"
    },
    2120: {
        img: "cigarillo_caballero",
        eng: "Cigarillo Caballero",
        schema: 31552,
        pol: "Cygarro c'awalera",
        sch: "\u53FC\u96EA\u8304\u7684\u7EC5\u58EB",
        bra: "Cigarro del Caballero",
        rus: "\u0421\u0435\u043D\u044C\u043E\u0440 \u0421\u0438\u0433\u0430\u0440\u0438\u043B\u043B\u043E"
    },
    2121: {
        img: "vanishing_act",
        eng: "Vanishing Act",
        schema: 31568,
        pol: "Sztuka znikania",
        sch: "\u5927\u53D8\u6D3B\u4EBA",
        bra: "Capa da Camuflagem",
        fre: "Cape \xe9clipsante",
        hun: "Elt\u0171n\u0151sz\xe1m",
        swe: "Sp\xe5rl\xf6s",
        rus: "\u0422\u0440\u044E\u043A \u0441 \u0438\u0441\u0447\u0435\u0437\u043D\u043E\u0432\u0435\u043D\u0438\u0435\u043C"
    },
    2122: {
        img: "buzz_kill",
        eng: "Buzz Kill",
        schema: 31562,
        pol: "Psuja",
        sch: "\u626B\u5174\u9B3C",
        bra: "Pestinha da Primavera",
        fre: "Teigne imp\xe9tueuse",
        hun: "Hangulatgyilkos",
        swe: "Barret",
        rus: "\u041E\u0431\u043B\u043E\u043C\u0449\u0438\u043A"
    },
    2123: {
        img: "velveteen_villain",
        eng: "Velveteen Villain",
        schema: 31560,
        pol: "Aksamitny adwersarz",
        sch: "\u53CD\u6D3E\u7684\u4EFF\u9E45\u7ED2\u5927\u8863",
        bra: "Vil\xe3o de Veludo",
        fre: "Le Teigneux de velours",
        hun: "B\xe1rsony Bajkever\u0151",
        swe: "Sammetskval",
        rus: "\u0412\u0435\u043B\u044C\u0432\u0435\u0442\u043E\u0432\u044B\u0439 \u0432\u0440\u0435\u0434\u0438\u0442\u0435\u043B\u044C"
    },
    2124: {
        img: "hellscape",
        eng: "Hellscape",
        schema: 31557,
        pol: "Piek\u0142obraz",
        sch: "\u72F1\u706B\u77F3\u9AB8",
        bra: "Visual Infernal",
        fre: "Tronche infernale",
        hun: "Pokoln\xe9z\u0151",
        rus: "\u0410\u0434\u0441\u043A\u0438\u0439 \u0440\u0435\u043B\u044C\u0435\u0444"
    },
    2125: {
        img: "fused_plates",
        eng: "Fused Plates",
        schema: 31558,
        pol: "Z\u0142\u0105czone zbrojenie",
        sch: "\u6613\u7206\u677F\u7532",
        bra: "Pavio Cr\xe2nio",
        fre: "Panoplie p\xe9taradante",
        hun: "Egyes\xedtett Lemezek",
        swe: "Svets och blod",
        rus: "\u0424\u0438\u0442\u0438\u043B\u044C\u043D\u044B\u0435 \u043B\u0430\u0442\u044B"
    },
    2126: {
        img: "pyromantic_plumage",
        eng: "Pyromantic Plumage",
        schema: 31572,
        pol: "Piromanckie pi\xf3rka",
        sch: "\u6D74\u706B\u91D1\u7FBD",
        bra: "Plumagem Pirom\xe2ntica",
        fre: "Plumage pyromantique",
        hun: "Piromantikus Tollazat",
        swe: "Flammande fj\xe4derskrud",
        rus: "\u041F\u043B\u044E\u043C\u0430\u0436 \u043F\u0438\u0440\u043E\u043C\u0430\u043D\u0442\u0430"
    },
    2127: {
        img: "one_man_convoy",
        eng: "One-Man Convoy",
        schema: 31573,
        pol: "Jednoosobowy konw\xf3j",
        sch: "\u4E00\u4EBA\u6210\u519B",
        bra: "Otimiza\xe7\xe3o de Primeira",
        fre: "Convoi cuirass\xe9",
        hun: "Egyf\u0151s Konvoj",
        swe: "Enmanskonvoj",
        rus: "\u041A\u043E\u043D\u0432\u043E\u0439-\u043E\u0434\u0438\u043D\u043E\u0447\u043A\u0430"
    },
    2128: {
        img: "face_lift",
        eng: "Face Lift",
        schema: 31574,
        pol: "Lifting twarzy",
        sch: "\u4EBA\u76AE\u9762\u5177",
        bra: "\xc9 a Sua Cara",
        fre: "Lifting",
        hun: "\xc1l-arc",
        swe: "Ansiktslyft",
        rus: "\u041F\u043E\u0434\u0442\u044F\u0436\u043A\u0430 \u043B\u0438\u0446\u0430"
    },
    2129: {
        img: "zepheniahs_shroud",
        eng: "Zepheniah's Shroud",
        schema: 31575,
        pol: "Zas\u0142ona Zefeniasza",
        sch: "\u6CFD\u8001\u7684\u88F9\u5C38\u5E8A\u5355",
        bra: "Semblante do Zepheniah",
        fre: "Voile de Zepheniah",
        hun: "Zepheniah Leple",
        swe: "Zepheniahs svepning",
        rus: "\u0417\u0430\u0432\u0435\u0441\u0430 \u0417\u0435\u0444\u0435\u043D\u0430\u0439\u0438"
    },
    2130: {
        img: "taunt_healthcare_hog",
        eng: "Taunt: Healthcare Hog",
        schema: 31546,
        pol: "Drwina: Z\u0142odziej zdrowia",
        sch: "\u5632\u8BBD\uFF1A\u6709\u836F\u4E0D\u7ED9\u62FF",
        bra: "Provoca\xe7\xe3o: Primeiro Eu me Socorro",
        fre: "Raillerie : Privation de soins",
        hun: "Besz\xf3l\xe1s: Ment\u0151 cukkol\xe1s",
        swe: "H\xe5n: V\xe5rdsl\xf6st beteende (Healthcare Hog)",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041B\u0438\u0448\u0435\u043D\u0438\u0435 \u043B\u0435\u0447\u0435\u043D\u0438\u044F"
    },
    2131: {
        img: "taunt_ring_king",
        eng: "Taunt: Ring King",
        schema: 31547,
        pol: "Drwina: Kr\xf3l ringu",
        sch: "\u5632\u8BBD\uFF1A\u738B\u8005\u91D1\u8170\u5E26",
        bra: "Provoca\xe7\xe3o: Rei do Ringue",
        fre: "Raillerie : Roi du ring",
        hun: "Besz\xf3l\xe1s: A ring kir\xe1lya",
        swe: "H\xe5n: Ringkungen (Ring King)",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041A\u043E\u0440\u043E\u043B\u044C \u0440\u0438\u043D\u0433\u0430"
    },
    2132: {
        img: "taunt_heartbreaker",
        eng: "Taunt: Heartbreaker",
        schema: 31545,
        pol: "Drwina: \u0141amacz serc",
        sch: "\u5632\u8BBD\uFF1A\u4EE4\u4EBA\u5FC3\u788E",
        bra: "Provoca\xe7\xe3o: Explode-Cora\xe7\xe3o",
        fre: "Raillerie : Brisec\u0153ur",
        hun: "Besz\xf3l\xe1s: Sz\xedvtipr\xf3",
        swe: "H\xe5n: Hj\xe4rtekrossaren (Heartbreaker)",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0421\u0435\u0440\u0434\u0446\u0435\u0433\u0443\u0431"
    },
    2133: {
        img: "sydney_shearling",
        eng: "Sydney Shearling",
        schema: 31592,
        pol: "Sydnejski ko\u017Cuch",
        sch: "\u6089\u5C3C\u7F8A\u76AE\u5939\u514B",
        bra: "Sobretudo de Sydney",
        fre: "Peau lain\xe9e",
        hun: "Sydney-i B\xe1r\xe1nyb\u0151r",
        swe: "F\xe5rskinn fr\xe5n Sydney",
        rus: "\u0421\u0438\u0434\u043D\u0435\u0439\u0441\u043A\u0430\u044F \u043E\u0432\u0447\u0438\u043D\u043A\u0430"
    },
    2134: {
        img: "black_tie_affair",
        eng: "Black Tie Affair",
        schema: 31597,
        pol: "Str\xf3j wieczorowy",
        sch: "\u9ED1\u9886\u7ED3\u4E4B\u7EA6",
        bra: "Traje Afiado",
        fre: "Soir\xe9e de gala",
        hun: "Szmokingos Esem\xe9ny",
        swe: "Finkostymen",
        rus: "\u0413\u0430\u043B\u0441\u0442\u0443\u043A \u0438\u043D\u0442\u0440\u0438\u0433\u0430\u043D\u0430"
    },
    2135: {
        img: "alpine_apparel",
        eng: "Alpine Apparel",
        schema: 31583,
        pol: "Alpejska odzie\u017C",
        sch: "\u9AD8\u539F\u9632\u5BD2\u670D",
        bra: "Traje Alpino",
        fre: "Accoutrement alpin",
        hun: "Alpesi \xd6lt\xf6z\xe9k",
        swe: "Fj\xe4llkl\xe4der",
        rus: "\u0410\u043B\u044C\u043F\u0438\u0439\u0441\u043A\u0430\u044F \u0430\u043B\u044F\u0441\u043A\u0430"
    },
    2136: {
        img: "scrub_stompers",
        eng: "Scrub Stompers",
        schema: 31601,
        pol: "Ho\u017Ce chodaki",
        sch: "\u624B\u672F\u4E13\u7528\u76AE\u978B",
        bra: "Mocassim Medicinal",
        fre: "Mocassins m\xe9dicaux",
        hun: "T\xfck\xf6rf\xe9nyes Topog\xf3k",
        swe: "Kirurgsko",
        rus: "\u0414\u043E\u043A\u0442\u043E\u0440\u0441\u043A\u0438\u0435 \u0434\u0430\u0432\u0438\u0442\u0435\u043B\u0438"
    },
    2137: {
        img: "epilogue_locks",
        eng: "Epilogue Locks",
        schema: 31593,
        pol: "Wie\u0144cz\u0105ca czupryna",
        sch: "\u5C18\u57C3\u843D\u5B9A",
        bra: "Corte do Crescidinho",
        fre: "Coupe de l'\xe9pilogue",
        hun: "Epil\xf3gus Loknik",
        swe: "Epilogens lockar",
        rus: "\u041B\u043E\u043A\u043E\u043D\u044B \u0438\u0437 \u044D\u043F\u0438\u043B\u043E\u0433\u0430"
    },
    2138: {
        img: "deserters_duster",
        eng: "Deserter's Duster",
        schema: 31588,
        pol: "Dyplomatka dezertera",
        sch: "\u53DB\u9003\u8005\u7684\u9632\u5C18\u5916\u5957",
        bra: "Desertor do Deserto",
        fre: "Cache-poussi\xe8re du d\xe9serteur",
        hun: "Fut\xe1rkab\xe1t",
        swe: "Desert\xf6rens dammrock",
        rus: "\u041F\u044B\u043B\u044C\u043D\u0438\u043A \u043F\u0435\u0440\u0435\u0431\u0435\u0436\u0447\u0438\u043A\u0430"
    },
    2139: {
        img: "air_head",
        eng: "Air Head",
        schema: 31591,
        pol: "\u015Amigacz",
        sch: "\u5929\u9645\u68A6\u6E38\u5BB6",
        bra: "Atirador das Alturas",
        fre: "Casque d'aviateur",
        hun: "Pil\xf3tasapka",
        swe: "Luftkrukan",
        rus: "\u0423\u043B\u0451\u0442\u043D\u044B\u0439 \u0448\u043B\u0435\u043C"
    },
    2140: {
        img: "punchers_polar_puffer",
        eng: "Puncher's Polar Puffer",
        schema: 31585,
        pol: "Pikowany polar pi\u0119\u015Bciarza",
        sch: "\u62F3\u51FB\u624B\u7684\u6781\u5730\u7FBD\u7ED2\u670D",
        bra: "Prote\xe7\xe3o Polar Peso-Pesado",
        fre: "Parka pugnace",
        hun: "Pufidzsekis Pofonoszt\xf3",
        swe: "Polarens polarjacka",
        rus: "\u041F\u0443\u0445\u043E\u0432\u0438\u043A \u043F\u043E\u043B\u044F\u0440\u043D\u043E\u0433\u043E \u043F\u043E\u0442\u0430\u0441\u043E\u0432\u0449\u0438\u043A\u0430"
    },
    2141: {
        img: "lazer_gazers",
        eng: "Lazer Gazers",
        schema: 31579,
        pol: "Laserowy wzrok",
        sch: "\u76EE\u5149\u5982\u70AC",
        bra: "Lentes de Laser",
        fre: "Lunettes laser",
        hun: "L\xe9zerszem\xfcveg",
        swe: "Laserbrillor",
        rus: "\u0413\u043B\u0430\u0437\u0435\u0440\u044B"
    },
    2142: {
        img: "snow_merc",
        eng: "Snow Merc",
        schema: 31580,
        pol: "\u015Anie\u017Cny najemnik",
        sch: "\u5C0F\u96EA\u4EBA\u4F63\u5175",
        bra: "Mercenariozinho de Neve",
        fre: "Merceneige",
        hun: "H\xf3zsoldos",
        swe: "Sn\xf6soldat",
        rus: "\u0421\u043D\u0435\u0433\u043E\u0432\u0438\u043A-\u043D\u0430\u0451\u043C\u043D\u0438\u043A"
    },
    2143: {
        img: "aristocravat",
        eng: "Aristocravat",
        schema: 31598,
        pol: "Arystokrawat",
        sch: "\u8D35\u65CF\u9886\u5DFE",
        bra: "Aristogravata",
        fre: "Aristocravate",
        hun: "Arisztokrav\xe1tli",
        swe: "Aristokravatt",
        rus: "\u0410\u0440\u0438\u0441\u0442\u043E\u043A\u0440\u0430\u0432\u0430\u0442"
    },
    2144: {
        img: "alpine_hawk",
        eng: "Alpine Hawk",
        schema: 31582,
        pol: "Alpejski jastrz\u0105b",
        sch: "\u9AD8\u5C71\u96C4\u9E70",
        bra: "\xc1guia Alpina",
        fre: "Faucon alpin",
        hun: "Alpesi S\xf3lyom",
        swe: "Fj\xe4llh\xf6k",
        rus: "\u0410\u043B\u044C\u043F\u0438\u0439\u0441\u043A\u0438\u0439 \u044F\u0441\u0442\u0440\u0435\u0431"
    },
    2145: {
        img: "flatline_flatcap",
        eng: "Flatline Flatcap",
        schema: 31599,
        pol: "Pulsuj\u0105cy kaszkiet",
        sch: "\u5FC3\u8DF3\u505C\u640F\u62A5\u7AE5\u5E3D",
        bra: "Chap\xe9u do Cirurgi\xe3o",
        fre: "Casquette terminale",
        hun: "Sz\xedvd\xf6gleszt\u0151 Sapka",
        swe: "Hj\xe4rtstillest\xe5ndshatt",
        rus: "\u0425\u0443\u043B\u0438\u0433\u0430\u043D\u043A\u0430 \u0445\u0438\u0440\u0443\u0440\u0433\u0430"
    },
    2146: {
        img: "the_sole_providers",
        eng: "The Sole Providers",
        schema: 31595,
        pol: "\u017Bywiciele rodziny",
        sch: "\u559C\u5F53\u7239",
        bra: "As Pantalonas da Paternidade",
        fre: "Pantalon de papa",
        hun: "Talpal\xe1val\xf3k",
        swe: "Pappabyxor",
        rus: "\u0428\u0442\u0430\u043D\u0446\u044B \u043A\u043E\u0440\u043C\u0438\u043B\u044C\u0446\u0430"
    },
    2147: {
        img: "commonwealth_commander",
        eng: "Commonwealth Commander",
        schema: 31586,
        pol: "W\xf3dz wsp\xf3lnoty",
        sch: "\u8054\u90A6\u6307\u6325\u5B98",
        bra: "Comandante da Commonwealth",
        fre: "Commandant du Commonwealth",
        hun: "K\xf6zt\xe1rsas\xe1gi Parancsnok",
        swe: "Statsbitr\xe4de",
        rus: "\u041A\u043E\u043C\u0430\u043D\u0434\u0438\u0440 \u0421\u043E\u0434\u0440\u0443\u0436\u0435\u0441\u0442\u0432\u0430"
    },
    2148: {
        img: "festive_fleece",
        eng: "Festive Fleece",
        schema: 31590,
        pol: "\u015Awi\u0105teczny polar",
        sch: "\u8282\u5E86\u7F8A\u6BDB\u5916\u5957",
        bra: "Demo-l\xe3-dor",
        fre: "Polaire festive",
        hun: "\xdcnnepi Irha",
        swe: "Festlig fleece",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u0430\u044F \u0444\u043B\u0438\u0441\u043A\u0430"
    },
    2149: {
        img: "chill_seeker",
        eng: "Chill-Seeker",
        schema: 31584,
        pol: "Poszukiwacz dreszczyku",
        sch: "\u98CE\u96EA\u63A2\u9669\u5BB6",
        bra: "Esquiberiano",
        fre: "T\xeate-gel\xe9e",
        hun: "Fagyf\xf6d\u0151",
        swe: "Sn\xf6lust",
        rus: "\u041B\u044E\u0431\u0438\u0442\u0435\u043B\u044C \u043F\u0440\u043E\u0445\u043B\u0430\u0436\u0434\u0430\u0442\u044C\u0441\u044F"
    },
    2150: {
        img: "scrooge_mccrocket",
        eng: "Scrooge McCrocket",
        schema: 31596,
        pol: "Sknerus McKrytyk",
        sch: "\u541D\u556C\u9B3C\u9EA6\u514B\u8001\u70AE",
        bra: "Soldado Sovina",
        fre: "Pingre briscard",
        rus: "\u0421\u043A\u0440\u0443\u0434\u0436 \u041C\u0430\u043A\u0440\u0430\u043A\u0435\u0442\u0430"
    },
    2151: {
        img: "blizzard_bonnet",
        eng: "Blizzard Bonnet",
        schema: 31589,
        pol: "We\u0142niany wicher",
        sch: "\u66B4\u96EA\u65E0\u6A90\u5706\u5E3D",
        bra: "Boina da Nevasca",
        fre: "Bonnet de blizzard",
        hun: "H\xf3sipka",
        swe: "Bitande basker",
        rus: "\u0421\u043D\u0435\u0433\u043E\u0437\u0430\u0449\u0438\u0442\u043D\u044B\u0439 \u0431\u0435\u0440\u0435\u0442"
    },
    2152: {
        img: "cardiologists_cardigan",
        eng: "Cardiologist's Cardigan",
        schema: 31600,
        pol: "Kardigan kardiologa",
        sch: "\u5FC3\u8840\u7BA1\u79D1\u4E13\u5BB6\u7684\u7F8A\u6BDB\u886B",
        bra: "Cardig\xe3 do Cardiologista",
        fre: "Cardigan de cardiologue",
        hun: "Kardiol\xf3gus Kardig\xe1n",
        swe: "Kardiologens kofta",
        rus: "\u041A\u0430\u0440\u0434\u0438\u0433\u0430\u043D \u043A\u0430\u0440\u0434\u0438\u043E\u043B\u043E\u0433\u0430"
    },
    2153: {
        img: "willis_warmer",
        eng: "Willis' Warmer",
        schema: 31594,
        pol: "Ocieplacz Willisa",
        sch: "\u5A01\u5229\u7684\u6BDB\u8863",
        bra: "Su\xe9ter da Saudade",
        fre: "Col roul\xe9 de Willis",
        hun: "Willis Pul\xf3vere",
        swe: "Willis polotr\xf6ja",
        rus: "\u0423\u0442\u0435\u043F\u043B\u0438\u0442\u0435\u043B\u044C \u0423\u0438\u043B\u043B\u0438\u0441\u0430"
    },
    2154: {
        img: "veterans_visor",
        eng: "Veteran's Visor",
        schema: 31587,
        pol: "Wizjer weterana",
        sch: "\u8001\u5175\u7684\u9762\u7F69",
        bra: "Visor do Veterano",
        fre: "Visi\xe8re du v\xe9t\xe9ran",
        hun: "Veter\xe1n \xc1larc",
        swe: "Veteranvisir",
        rus: "\u0412\u0438\u0437\u043E\u0440 \u0432\u0435\u0442\u0435\u0440\u0430\u043D\u0430"
    },
    2155: {
        img: "the_old_days_devotion",
        eng: "The Old Days Devotion",
        schema: 31581,
        pol: "Dewota dawnych czas\xf3w",
        sch: "\u65E7\u65E5\u8654\u8BDA",
        bra: "A Devo\xe7\xe3o dos Velhos Tempos",
        fre: "D\xe9votion du temps jadis",
        hun: "R\xe9gi Id\u0151k Rajong\xf3ja",
        swe: "Gammaldags h\xe4ngivenhet",
        rus: "\u041F\u0440\u0435\u0434\u0430\u043D\u043D\u043E\u0441\u0442\u044C \u0443\u0448\u0435\u0434\u0448\u0435\u0439 \u044D\u043F\u043E\u0445\u0435"
    },
    2156: {
        img: "taunt_the_critical_fail",
        eng: "Taunt: The Critical Fail",
        schema: 31577,
        pol: "Drwina: Totalna pora\u017Cka",
        sch: "\u5632\u8BBD\uFF1A\u4E22\u4EBA\u73B0\u773C",
        bra: "Provoca\xe7\xe3o: Fracasso Cr\xedtico",
        fre: "Raillerie : La bourde",
        hun: "Besz\xf3l\xe1s: Kritikus hiba",
        swe: "H\xe5n: Kritiskt fel",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041B\u044E\u0442\u044B\u0439 \u0441\u0442\u044B\u0434"
    },
    2157: {
        img: "taunt_dead_manns_drink",
        eng: "Taunt: Dead Mann's Drink",
        schema: 31576,
        pol: "Drwina: Drink dr\u0119twiaka",
        sch: "\u5632\u8BBD\uFF1A\u597D\u9152\u4E0A\u8DEF",
        bra: "Provoca\xe7\xe3o: Uma pro Zepheniah",
        fre: "Raillerie : Le verre du mort",
        hun: "Besz\xf3l\xe1s: Halott Mannus itala",
        swe: "H\xe5n: D\xf6d manns dryck",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041F\u043E\u0439\u043B\u043E \u043F\u043E\u043A\u043E\u0439\u043D\u0438\u043A\u0430"
    },
    2158: {
        img: "taunt_chairholder",
        eng: "Taunt: Chairholder",
        schema: 31578,
        pol: "Drwina: Pieni\u0119\u017Cny przewodnicz\u0105cy",
        sch: "\u5632\u8BBD\uFF1A\u7EB8\u9189\u91D1\u8FF7",
        bra: "Provoca\xe7\xe3o: Trono do Dono",
        fre: "Raillerie : Fauteuil en biftons",
        hun: "Besz\xf3l\xe1s: K\xe1p\xe9kanap\xe9",
        swe: "H\xe5n: Stolfr\xe4sare",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0424\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u0430\u044F \u0441\u0438\u0434\u0443\u0448\u043A\u0430"
    },
    2159: {
        img: "bald_spotter",
        eng: "Bald Spotter",
        schema: 31628,
        sch: "\u79C3\u9876\u8001\u533B",
        hun: "Kopasz Megfigyel\u0151",
        rus: "\u0423\u0445\u043E-\u0433\u043E\u0440\u043B\u043E-\u043B\u044B\u0441",
        pol: "\u0141ysy obserwator",
        bra: "Careca do Cirurgi\xe3o",
        fre: "Observateur d\xe9garni",
        swe: "Pannspegel"
    },
    2160: {
        img: "unruly_ruler",
        eng: "Unruly Ruler",
        schema: 31627,
        sch: "\u6840\u9A9C\u541B\u4E3B",
        hun: "Neveletlen Nagyvez\xe9r",
        rus: "\u041D\u0435\u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0439 \u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B\u044C",
        pol: "Irytuj\u0105cy imperator",
        bra: "Imperador Impostor",
        fre: "Consul cabochard",
        swe: "Ostyrig styresman"
    },
    2161: {
        img: "inglorious_patriot",
        eng: "Inglorious Patriot",
        schema: 31625,
        sch: "\u65E0\u803B\u7231\u56FD\u8005",
        hun: "Becstelen Hazafi",
        rus: "\u0411\u0435\u0441\u0441\u043B\u0430\u0432\u043D\u044B\u0439 \u043F\u0430\u0442\u0440\u0438\u043E\u0442",
        pol: "Przeokropny patriota",
        bra: "Patriota Ingl\xf3rio",
        fre: "Patriote sans honneur",
        swe: "L\xf6msk landsman"
    },
    2162: {
        img: "the_night_riders",
        eng: "The Night Riders",
        schema: 31621,
        sch: "\u5348\u591C\u9A91\u624B",
        hun: "\xc9jszakai Lovas",
        rus: "\u041D\u043E\u0447\u043D\u043E\u0439 \u043D\u0430\u0435\u0437\u0434\u043D\u0438\u043A",
        pol: "Nocny je\u017Adziec",
        bra: "Cavaleiros da Noite",
        fre: "Cavaliers de la nuit",
        swe: "Nattryttare"
    },
    2163: {
        img: "the_long_shot",
        eng: "The Long Shot",
        schema: 31620,
        sch: "\u5B64\u6CE8\u4E00\u63B7",
        hun: "T\xe1voli L\xf6v\xe9s",
        rus: "\u0410\u0437\u0430\u0440\u0442\u043D\u044B\u0439 \u0441\u0442\u0440\u0435\u043B\u043E\u043A",
        pol: "Strzelny spekulant",
        bra: "O Faroeste do Extremo Leste",
        fre: "Veste d'\xe9lite",
        swe: "L\xe5ngskott"
    },
    2164: {
        img: "the_deadliest_match",
        eng: "The Deadliest Match",
        schema: 31617,
        sch: "\u593A\u547D\u706B\u67F4",
        hun: "Hal\xe1los Gyuf\xe1s",
        rus: "\u041A\u0440\u0430\u0442\u0447\u0430\u0439\u0448\u0438\u0439 \u0437\u0430\u043F\u0430\u043B",
        pol: "Zapa\u0142ki zag\u0142ady",
        bra: "Os F\xf3sforos do Faroeste",
        fre: "Craquage d'allumettes",
        swe: "Hetlevrad huligan"
    },
    2165: {
        img: "tropical_torcher",
        eng: "Tropical Torcher",
        schema: 31615,
        sch: "\u70ED\u5E26\u706B\u70AC\u624B",
        hun: "Tr\xf3pusi T\u0171zgy\xfajt\xf3",
        rus: "\u041A\u0443\u0440\u043E\u0440\u0442\u043D\u044B\u0439 \u043A\u043E\u0441\u0442\u0440\u043E\u0432\u043E\u0439",
        pol: "Podzwrotnikowe przyodzienie",
        bra: "Calor dos Tr\xf3picos",
        fre: "Flamme des Tropiques",
        swe: "Strandsvedd"
    },
    2166: {
        img: "the_unknown_warrior",
        eng: "The Unknown Warrior",
        schema: 31614,
        sch: "\u65E0\u540D\u6218\u58EB",
        hun: "Ismeretlen Harcos",
        rus: "\u0411\u0435\u0437\u043B\u0438\u043A\u0438\u0439 \u0431\u043E\u0435\u0446",
        pol: "Nieznany \u017Co\u0142nierz",
        bra: "O Guerreiro Desconhecido",
        fre: "Soldat Inconnu",
        swe: "Ok\xe4nd krigare"
    },
    2167: {
        img: "barbeque_bacon_britches",
        eng: "Barbeque Bacon Britches",
        schema: 31613,
        sch: "\u78B3\u70E4\u57F9\u6839\u9A6C\u88E4",
        hun: "Barbeque Bacon Bricsesz",
        rus: "\u0411\u0443\u0440\u0433\u0435\u0440\u043D\u044B\u0435 \u0431\u0440\u044E\u043A\u0438",
        pol: "Bekonowe bryczesy",
        bra: "Cal\xe7as para Churrasco",
        fre: "Pantalon graisseux",
        swe: "Grillbyxor"
    },
    2168: {
        img: "vested_investors_vest",
        eng: "Vested Investor's Vest",
        schema: 31610,
        sch: "\u6295\u8D44\u8005\u7684\u9A6C\u7532",
        hun: "A Be\xf6lt\xf6z\xf6tt Befektet\u0151 Mell\xe9nye",
        rus: "\u0410\u043D\u0433\u0430\u0436\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0430\u043A\u0446\u0438\u043E\u043D\u0435\u0440",
        pol: "Kamizelka kapitalisty",
        bra: "Colete do Cabe\xe7a da Companhia",
        fre: "Veste de l'investisseur investi",
        swe: "V\xe4stkl\xe4dd investerare"
    },
    2169: {
        img: "surgical_shroud",
        eng: "Surgical Shroud",
        schema: 31629,
        sch: "\u5916\u79D1\u8499\u9762\u9886",
        hun: "Seb\xe9szi Lepel",
        rus: "\u0425\u0430\u043B\u0430\u0442 \u0445\u0438\u0440\u0443\u0440\u0433\u0430",
        pol: "Ca\u0142un chirurga",
        bra: "Agasalho Antiss\xe9ptico",
        fre: "Linceul chirurgical",
        swe: "Kirurgisk kl\xe4dnad"
    },
    2170: {
        img: "delusions_of_grandeur",
        eng: "Delusions of Grandeur",
        schema: 31626,
        sch: "\u5984\u81EA\u5C0A\u5927",
        hun: "Nagyz\xe1si H\xf3bort",
        rus: "\u041C\u0435\u0433\u0430\u043B\u043E\u043C\u0430\u043D\u043D",
        pol: "Mania wielko\u015Bci",
        bra: "Del\xedrio de Grandeza",
        fre: "La Folie des Grandeurs",
        swe: "Storhetsvansinne"
    },
    2171: {
        img: "lieutenants_cut",
        eng: "Lieutenant's Cut",
        schema: 31624,
        sch: "\u4E2D\u5C09\u7684\u96EA\u8304",
        hun: "Hadnagyhajzat",
        rus: "\u041B\u0438\u043A \u043B\u0435\u0439\u0442\u0435\u043D\u0430\u043D\u0442\u0430",
        pol: "Peruka podporucznika",
        bra: "Corte do Tenente",
        fre: "Coupe du Lieutenant",
        swe: "L\xf6jtnantsfrilla"
    },
    2172: {
        img: "atomic_bomber",
        eng: "Atomic Bomber",
        schema: 31622,
        sch: "\u539F\u5B50\u80FD\u5939\u514B",
        hun: "Atombomb\xe1z\xf3",
        rus: "\u0410\u0442\u043E\u043C\u043D\u044B\u0439 \u0431\u043E\u043C\u0431\u0435\u0440",
        pol: "Atomowa wiatr\xf3wka",
        bra: "Bombardeiro At\xf4mico",
        fre: "Blouson Atomique",
        swe: "Atombombare"
    },
    2173: {
        img: "the_handsome_ranger",
        eng: "The Handsome Ranger",
        schema: 31619,
        sch: "\u6F47\u6D12\u5DE1\u8B66",
        hun: "J\xf3k\xe9p\u0171 L\xf6v\xe9sz",
        rus: "\u041A\u0440\u0430\u0441\u0430\u0432\u0447\u0438\u043A \u0432 \u0437\u0430\u043A\u043E\u043D\u0435",
        pol: "Przystojny patrolowiec",
        bra: "Patrulheiro Bonit\xe3o",
        fre: "Garde bon chic bon genre",
        swe: "R\xe5barkad ranger"
    },
    2174: {
        img: "bomb_blanket",
        eng: "Bomb Blanket",
        schema: 31618,
        sch: "\u706B\u836F\u62AB\u80A9",
        hun: "Bombatakar\xf3",
        rus: "\u041F\u043E\u0434\u0440\u044B\u0432\u043D\u043E\u0439 \u043F\u043E\u043A\u0440\u043E\u0432",
        pol: "Derka detonacji",
        bra: "Bandoleira da Fronteira",
        fre: "Couverture explosive",
        swe: "Bombfilt"
    },
    2175: {
        img: "tzar_athlete",
        eng: "Tzar Athlete",
        schema: 31612,
        sch: "\u6C99\u7687\u8FD0\u52A8\u5458",
        hun: "C\xe1r-atl\xe9ta",
        rus: "\u0426\u0430\u0440\u044C-\u0430\u0442\u043B\u0435\u0442",
        pol: "Atletyczny car",
        bra: "Czartleta",
        fre: "Athl\xe8te tsar",
        swe: "Idrottstsar"
    },
    2176: {
        img: "standing_offer",
        eng: "Standing Offer",
        schema: 31611,
        sch: "\u957F\u671F\u62A5\u4EF7\u88E4",
        hun: "Fenn\xe1ll\xf3 Aj\xe1nlat",
        rus: "\u041F\u043E\u0440\u0442\u043A\u0438 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0442\u0435\u043B\u044F",
        pol: "Sta\u0142a stawka",
        bra: "Oferta de P\xe9",
        fre: "Offre d'aplomb",
        swe: "St\xe5ende erbjudande"
    },
    2177: {
        img: "deadwave_communicator",
        eng: "Deadwave Communicator",
        schema: 31607,
        sch: "\u6B7B\u6CE2\u901A\u8BAF\u5668",
        hun: "Halotthull\xe1m-vev\u0151",
        rus: "\u041F\u0435\u0440\u0435\u0434\u0430\u0442\u0447\u0438\u043A \u043C\u0451\u0440\u0442\u0432\u044B\u0445 \u0447\u0430\u0441\u0442\u043E\u0442",
        pol: "G\u0142uche \u0142\u0105cze",
        bra: "Comunicador de Ondas Mortas",
        fre: "Transpondeur d'ondes mortes",
        swe: "V\xe5gformskommunikator"
    },
    2178: {
        img: "bonk_atomic_kicks",
        eng: "Bonk! Atomic Kicks",
        schema: 31623,
        sch: "\u539F\u5B50\u80FD\u6F6E\u724C\u978B",
        hun: "Poff! Atomcsuka",
        rus: "\u0411\u043E\u043D\u043A! \u0410\u0442\u043E\u043C\u043D\u044B\u0439 \u0431\u0430\u0448\u043C\u0430\u043A",
        pol: "Bonk! Atomowy kopniak",
        bra: "Bonk! T\xeanis At\xf4micos",
        fre: "Boing ! Godasses atomiques",
        swe: "Bonk! Atompjuckar"
    },
    2179: {
        img: "chief_executor",
        eng: "Chief Executor",
        schema: 31609,
        sch: "\u9996\u5E2D\u6267\u884C\u5B98",
        hun: "F\u0151v\xe9grehajt\xf3",
        rus: "\u0413\u0435\u043D\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u0439 \u0438\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C",
        pol: "Elegancka egzekucja",
        bra: "Executor-Chefe",
        fre: "Directeur g\xe9n\xe9ral",
        swe: "Exekutiv chef"
    },
    2180: {
        img: "beachcombers_brim",
        eng: "Beachcomber's Brim",
        schema: 31608,
        sch: "\u8D76\u6D77\u4EBA\u7684\u8349\u5E3D",
        bra: "Palha do Praiano",
        hun: "Strandgy\u0171jt\xf6get\u0151-kalap",
        swe: "Str\xe5hatt",
        rus: "\u0411\u0440\u044B\u043B\u044C \u0431\u0435\u0437\u0434\u0435\u043B\u044C\u043D\u0438\u043A\u0430",
        pol: "Przes\u0142ona pla\u017Cowego przeczesywacza",
        fre: "Chapeau de paille"
    },
    2181: {
        img: "hard_hearing",
        eng: "Hard Hearing",
        schema: 31606,
        sch: "\u964D\u566A\u76D1\u542C\u5668",
        hun: "Nagyothall\xf3",
        swe: "Nedsatt h\xf6rsel",
        rus: "\u0421\u043B\u0443\u0445\u043E\u043F\u043E\u0434\u0430\u0432\u0438\u0442\u0435\u043B\u0438",
        pol: "Hardos\u0142ysz\u0105cy",
        bra: "Som Pesado",
        fre: "Troubles auditifs"
    },
    2182: {
        img: "pyros_overalls",
        eng: "Pyro's Overalls",
        schema: 31616,
        sch: "\u706B\u7130\u5175\u7684\u5DE5\u88C5\u88E4",
        bra: "Macac\xe3o do Incendi\xe1rio",
        hun: "Pir\xf3 Kezesl\xe1basa",
        swe: "Pyros h\xe4ngselbyxor",
        rus: "\u041A\u043E\u043C\u0431\u0438\u043D\u0435\u0437\u043E\u043D\u0447\u0438\u043A \u043A\u0440\u0435\u043C\u0430\u0442\u043E\u0440\u0430",
        pol: "Ogrodniczki Pyro",
        fre: "Salopette du Pyro"
    },
    2183: {
        img: "beachy_boy_war_paint",
        eng: "Beachy Boy War Paint",
        schema: 17434,
        hun: "Tengerparti Sr\xe1c Harci fest\xe9s",
        swe: "Strandpojken Krigsf\xe4rg",
        rus: '"\u041F\u043B\u044F\u0436\u043D\u044B\u0439 \u043F\u0430\u0440\u0435\u043D\u0451\u043A" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Pla\u017Cowicz Barwy wojenne",
        sch: "\u6C99\u6EE9\u7537\u5B69 \u6218\u7ED8",
        bra: "Garoto da Praia Tinta de Guerra",
        fre: "Roi de la plage Peinture de guerre"
    },
    2184: {
        img: "sideshow_war_paint",
        eng: "Sideshow War Paint",
        schema: 17440,
        bra: "Atra\xe7\xe3o Secund\xe1ria Tinta de Guerra",
        fre: "F\xeate foraine Peinture de guerre",
        hun: "Oldals\xe1vos Harci fest\xe9s",
        swe: "Sideshow Krigsf\xe4rg",
        rus: '"\u0421\u0430\u0439\u0434\u0448\u043E\u0443" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Pokaz Barwy wojenne",
        sch: "\u6742\u800D\u8868\u6F14 \u6218\u7ED8"
    },
    2185: {
        img: "ocean_mapped_war_paint",
        eng: "Ocean Mapped War Paint",
        schema: 17437,
        hun: "\xd3ce\xe1nt\xe9rk\xe9pes Harci fest\xe9s",
        rus: '"\u041F\u043E\u0434\u0432\u043E\u0434\u043D\u0430\u044F \u043A\u0430\u0440\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u044F" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Morskie mapowanie Barwy wojenne",
        sch: "\u5927\u6D0B\u7ED8\u56FE \u6218\u7ED8",
        bra: "Cartografia Oce\xe2nica Tinta de Guerra",
        fre: "Cartographie oc\xe9anique Peinture de guerre",
        swe: "Havskarta Krigsf\xe4rg"
    },
    2186: {
        img: "army_guns_war_paint",
        eng: "Army Guns War Paint",
        schema: 17435,
        hun: "Katonai Fegyverek Harci fest\xe9s",
        rus: '"\u0410\u0440\u043C\u0435\u0439\u0441\u043A\u0438\u0435 \u043F\u0443\u0448\u043A\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Wojskowy arsena\u0142 Barwy wojenne",
        sch: "\u9646\u6218\u519B\u68B0 \u6218\u7ED8",
        bra: "Armas do Ex\xe9rcito Tinta de Guerra",
        fre: "Arsenal militaire Peinture de guerre",
        swe: "Arm\xe9vapen Krigsf\xe4rg"
    },
    2187: {
        img: "die_n_dasher_war_paint",
        eng: "Die'n Dasher War Paint",
        schema: 17442,
        hun: "Bisztr\xf3kock\xe1s Harci fest\xe9s",
        rus: '"\u0423\u0431\u0438\u043B \u0434\u0430 \u0443\u0448\u0451\u043B" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Jad\u0142o i jatka Barwy wojenne",
        sch: "\u7EDD\u547D\u5FEB\u9910 \u6218\u7ED8",
        bra: "Lanchonete Letal Tinta de Guerra",
        fre: "Resto baskets Peinture de guerre",
        swe: "Springnota Krigsf\xe4rg"
    },
    2188: {
        img: "krak_coated_war_paint",
        eng: "Krak-coated War Paint",
        schema: 17438,
        hun: "Krakenbor\xedt\xe1s\xfa Harci fest\xe9s",
        rus: '"\u041E\u0431\u044A\u044F\u0442\u0438\u044F \u041A\u0440\u0430\u043A\u0435\u043D\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Krakenowy kamufla\u017C Barwy wojenne",
        sch: "\u6D77\u602A\u7F20\u8EAB \u6218\u7ED8",
        bra: "Krak-elado Tinta de Guerra",
        fre: "Enrobage kraken Peinture de guerre",
        swe: "Krakenbelagd Krigsf\xe4rg"
    },
    2189: {
        img: "sandwich_diner_war_paint",
        eng: "Sandwich Diner War Paint",
        schema: 17433,
        bra: "Sanduicheria Tinta de Guerra",
        fre: "Sandwich Diner Peinture de guerre",
        hun: "Szendvicsbisztr\xf3 Harci fest\xe9s",
        swe: "Sandwich Diner Krigsf\xe4rg",
        rus: '"\u0417\u0430\u043A\u0443\u0441\u043E\u0447\u043D\u0430\u044F" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Bar kanapkowy Barwy wojenne",
        sch: "\u4E09\u660E\u6CBB\u5403\u8D27 \u6218\u7ED8"
    },
    2190: {
        img: "taxi_cabbed_war_paint",
        eng: "Taxi Cabbed War Paint",
        schema: 17436,
        hun: "Taxikock\xe1s Harci fest\xe9s",
        rus: '"\u041F\u043E\u0434\u0442\u0430\u043A\u0441\u043E\u0432\u043A\u0430" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Taryfa Barwy wojenne",
        sch: "\u51FA\u79DF\u7684\u58EB \u6218\u7ED8",
        bra: "Taxiado Tinta de Guerra",
        fre: "Jaune taxi Peinture de guerre",
        swe: "Taxif\xe4rgad Krigsf\xe4rg"
    },
    2191: {
        img: "storage_war_war_paint",
        eng: "Storage War War Paint",
        schema: 17441,
        hun: "Rakt\xe1rh\xe1bor\xfa Harci fest\xe9s",
        rus: '"\u0421\u043A\u043B\u0430\u0434\u0441\u043A\u0438\u0435 \u0441\u043A\u043B\u043E\u043A\u0438" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Wojna magazynowa Barwy wojenne",
        sch: "\u540E\u52E4\u6218\u4E89 \u6218\u7ED8",
        bra: "Guerra de P\xf3sito Tinta de Guerra",
        fre: "Guerre des garde-meubles Peinture de guerre",
        swe: "Fyndkrig Krigsf\xe4rg"
    },
    2192: {
        img: "team_union_war_paint",
        eng: "Team Union War Paint",
        schema: 17439,
        bra: "Uni\xe3o da Equipe Tinta de Guerra",
        fre: "\xc9quipe unie Peinture de guerre",
        hun: "Csapategys\xe9g Harci fest\xe9s",
        swe: "Team Union Krigsf\xe4rg",
        rus: '"\u0415\u0434\u0438\u043D\u0441\u0442\u0432\u043E \u043A\u043E\u043C\u0430\u043D\u0434\u044B" \u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430',
        pol: "Jedno\u015B\u0107 dru\u017Cyny Barwy wojenne",
        sch: "\u6218\u961F\u8054\u76DF \u6218\u7ED8"
    },
    2193: {
        img: "taunt_buffoons_bivouac",
        eng: "Taunt: Buffoon's Bivouac",
        schema: 31603,
        sch: "\u5632\u8BBD\uFF1A\u7F3A\u5FC3\u773C\u7684\u9732\u8425\u5730",
        hun: "Besz\xf3l\xe1s: A t\xf6kkel\xfct\xf6tt t\xe1borhelye",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0411\u0438\u0432\u0430\u043A \u0431\u043E\u043B\u0432\u0430\u043D\u0430",
        pol: "Drwina: Biwak bufona",
        bra: "Provoca\xe7\xe3o: Bivaque do Buf\xe3o",
        fre: "Raillerie : Le Bivouac du bouffon",
        swe: "H\xe5n: Pajasens h\xe4ngmatta"
    },
    2194: {
        img: "taunt_friendly_fire",
        eng: "Taunt: Friendly Fire",
        schema: 31605,
        sch: "\u5632\u8BBD\uFF1A\u53CB\u519B\u52FF\u70E7",
        hun: "Besz\xf3l\xe1s: Bar\xe1ti t\u0171z",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0414\u0440\u0443\u0436\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u043E\u0433\u043E\u043D\u044C",
        pol: "Drwina: Przyjacielskie podpalenie",
        bra: "Provoca\xe7\xe3o: Fogo Amigo",
        fre: "Raillerie : feux de l'amiti\xe9",
        swe: "H\xe5n: Friendly Fire"
    },
    2195: {
        img: "taunt_the_circuit_breaker",
        eng: "Taunt: The Circuit Breaker",
        schema: 31602,
        sch: "\u5632\u8BBD\uFF1A\u5F3A\u884C\u62C9\u95F8",
        hun: "Besz\xf3l\xe1s: Az \xe1ramk\xf6r-megszak\xedt\xf3",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u0412\u044B\u043A\u043B\u044E\u0447\u0430\u0442\u0435\u043B\u044C",
        pol: "Drwina: Brutalny bezpiecznik",
        bra: "Provoca\xe7\xe3o: O Disjuntor",
        fre: "Raillerie : Le court-circuiteur",
        swe: "H\xe5n: Str\xf6mbrytaren"
    },
    2196: {
        img: "taunt_faux_calization",
        eng: "Taunt: Faux-calization",
        schema: 31604,
        sch: "\u5632\u8BBD\uFF1A\u88C5\u8154\u4F5C\u52BF",
        hun: "Besz\xf3l\xe1s: \xc1lbesz\xe9d",
        rus: "\u041D\u0430\u0441\u043C\u0435\u0448\u043A\u0430: \u041B\u043E\u0436\u043D\u044B\u0439 \u043B\u0435\u043F\u0435\u0442",
        pol: "Drwina: Kamuflizacja",
        bra: "Provoca\xe7\xe3o: Imita\xe7\xe3o Impostora",
        fre: "Raillerie : Faux-calise",
        swe: "H\xe5n: Falskalisering"
    },
    2197: {
        img: "twain_tassets",
        eng: "Twain Tassets",
        schema: 31657
    },
    2198: {
        img: "bounty_hunters_brim",
        eng: "Bounty Hunter's Brim",
        schema: 31653
    },
    2199: {
        img: "grenadiers_goggles",
        eng: "Grenadier's Goggles",
        schema: 31651
    },
    2200: {
        img: "batters_jersey",
        eng: "Batter's Jersey",
        schema: 31650
    },
    2201: {
        img: "rough_rider",
        eng: "Rough Rider",
        schema: 31648
    },
    2202: {
        img: "vances_vest",
        eng: "Vance's Vest",
        schema: 31645
    },
    2203: {
        img: "two_faced_terror",
        eng: "Two Faced Terror",
        schema: 31643
    },
    2204: {
        img: "high_caliber_earner",
        eng: "High Caliber Earner",
        schema: 31640
    },
    2205: {
        img: "mined_mind",
        eng: "Mined Mind",
        schema: 31638
    },
    2206: {
        img: "skeleton_crew",
        eng: "Skeleton Crew",
        schema: 31635
    },
    2207: {
        img: "bone_chiller",
        eng: "Bone Chiller",
        schema: 31636
    },
    2208: {
        img: "showdown_slacks",
        eng: "Showdown Slacks",
        schema: 31641
    },
    2209: {
        img: "clowning_cowl",
        eng: "Clowning Cowl",
        schema: 31642
    },
    2210: {
        img: "cogwork_cargos",
        eng: "Cogwork Cargos",
        schema: 31646
    },
    2211: {
        img: "hell_bent_leather",
        eng: "Hell-Bent Leather",
        schema: 31649
    },
    2212: {
        img: "generals_greatcoat",
        eng: "General's Greatcoat",
        schema: 31652
    },
    2213: {
        img: "desperado_disguise",
        eng: "Desperado Disguise",
        schema: 31654
    },
    2214: {
        img: "crown_of_the_ye_olde_kingdom",
        eng: "Crown of the Ye Olde Kingdom",
        schema: 31655
    },
    2215: {
        img: "the_damage_dealer",
        eng: "The Damage Dealer",
        schema: 31639
    },
    2216: {
        img: "scaled_surcoat",
        eng: "Scaled Surcoat",
        schema: 31656
    },
    2217: {
        img: "wayward_wrap",
        eng: "Wayward Wrap",
        schema: 31647
    },
    2218: {
        img: "gunpowder_grin",
        eng: "Gunpowder Grin",
        schema: 31644
    },
    2219: {
        img: "royal_remains",
        eng: "Royal Remains",
        schema: 31637
    },
    2220: {
        img: "taunt_hippocratic_hypocrite",
        eng: "Taunt: Hippocratic Hypocrite",
        schema: 31630
    },
    2221: {
        img: "taunt_showrunners_spirit",
        eng: "Taunt: Showrunner's Spirit",
        schema: 31632
    },
    2222: {
        img: "taunt_barrel_roll",
        eng: "Taunt: Barrel Roll",
        schema: 31633
    },
    2223: {
        img: "taunt_one_eyed_punt",
        eng: "Taunt: One-Eyed Punt!",
        schema: 31631
    },
    2224: {
        img: "taunt_sear_you_later",
        eng: "Taunt: Sear You Later",
        schema: 31634
    }
};


let $171d92d71d8943db$export$6483fd36607ee9f2 = {
    1: {
        img: "mann_co_supply_crate",
        eng: "Mann Co. Supply Crate",
        rus: "\u042F\u0449\u0438\u043A \u041C\u0430\u043D\u043D \u041A\u043E",
        pol: "Skrzynka Mann Co.",
        sch: "\u66FC\u6069\u516C\u53F8\u4F9B\u5E94\u7BB1",
        fre: "Caisse Mann Co.",
        bra: "Caixa de Suprimentos da Mann Co.",
        hun: "Mann Co. Ell\xe1tm\xe1nyl\xe1da",
        swe: "F\xf6rr\xe5dsl\xe5da Fr\xe5n Mann Co."
    },
    2: {
        img: "festive_winter_crate",
        eng: "Festive Winter Crate",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u0437\u0438\u043C\u043D\u0438\u0439 \u044F\u0449\u0438\u043A",
        pol: "\u015Awi\u0105teczna zimowa skrzynka",
        sch: "\u6B22\u51AC\u8865\u7ED9\u7BB1",
        fre: "Caisse festive de No\xebl",
        bra: "Caixa Festiva de Fim de Ano",
        hun: "\xdcnnep\xe9lyes T\xe9li L\xe1da",
        swe: "Festlig vinterl\xe5da"
    },
    3: {
        img: "mann_co_audition_reel",
        eng: "Mann Co. Audition Reel",
        rus: "\u041A\u043E\u0440\u043E\u0431\u043A\u0430 \u0441 \u0437\u0430\u043F\u0438\u0441\u044F\u043C\u0438 \u043E\u0442 \u041C\u0430\u043D\u043D \u041A\u043E",
        pol: "Ta\u015Bma pr\xf3b nagraniowych Mann Co.",
        sch: "\u66FC\u6069\u516C\u53F8\u5F71\u50CF\u8D44\u6599\u7BB1",
        fre: "Bobine Mann Co.",
        bra: "Rolo de Filme da Mann Co.",
        hun: "Mann Co. Filmtekercs",
        swe: "Auditionrulle fr\xe5n Mann Co."
    },
    4: {
        img: "concealed_killer_weapons_case",
        eng: "Concealed Killer Weapons Case",
        rus: '\u041A\u0435\u0439\u0441 "\u0421\u043A\u0440\u044B\u0442\u043D\u044B\u0439 \u0443\u0431\u0438\u0439\u0446\u0430"',
        pol: "Pojemnik skrytego mordercy",
        sch: "\u9690\u79D8\u6740\u624B\u6B66\u5668\u7BB1",
        fre: "Caisse d'armes de la Collection du Tueur Dissimul\xe9",
        bra: "Caixa de Arma do Assassino Furtivo",
        hun: "A Rejtett Gyilkos Fegyvert\xe1ska",
        rom: "Cutie cu arme Concealed Killer",
        swe: "Maskerade m\xf6rdaren-vapenv\xe4ska"
    },
    5: {
        img: "refreshing_summer_cooler",
        eng: "Refreshing Summer Cooler",
        rus: "\u041E\u0441\u0432\u0435\u0436\u0430\u044E\u0449\u0438\u0439 \u043B\u0435\u0442\u043D\u0438\u0439 \u043C\u0438\u043D\u0438-\u0445\u043E\u043B\u043E\u0434\u0438\u043B\u044C\u043D\u0438\u043A",
        pol: "Orze\u017Awiaj\u0105ca letnia lod\xf3wka",
        sch: "\u51B0\u51C9\u590F\u65E5\u51B7\u85CF\u7BB1",
        fre: "Glaci\xe8re Rafra\xeechissante de l'\xc9t\xe9",
        bra: "Cooler Refrescante de F\xe9rias",
        hun: "Friss\xedt\u0151 Ny\xe1ri H\u0171t\u0151t\xe1ska",
        swe: "Uppfriskande frysbox"
    },
    6: {
        img: "salvaged_mann_co_supply_crate",
        eng: "Salvaged Mann Co. Supply Crate",
        rus: "\u042F\u0449\u0438\u043A \u043F\u043E\u043C\u043E\u0449\u0438 \u043E\u0442 \u041C\u0430\u043D\u043D \u041A\u043E",
        pol: "Ocalona skrzynka Mann Co.",
        sch: "\u5E9F\u5F03\u7684\u66FC\u6069\u516C\u53F8\u4F9B\u5E94\u7BB1",
        fre: "Caisse Mann Co. de r\xe9cup\xe9ration",
        bra: "Caixa Recuperada de Suprimentos da Mann Co.",
        hun: "Megmentett Mann Co. Ell\xe1tm\xe1nyl\xe1da",
        swe: "B\xe4rgad f\xf6rr\xe5dsl\xe5da fr\xe5n Mann Co."
    },
    7: {
        img: "naughty_winter_crate",
        eng: "Naughty Winter Crate",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u044F\u0449\u0438\u043A \u0434\u043B\u044F \u043D\u0435\u043F\u043E\u0441\u043B\u0443\u0448\u043D\u044B\u0445",
        pol: "Niegrzeczna zimowa skrzynka",
        sch: "\u908B\u9062\u7684\u6B22\u51AC\u4F9B\u5E94\u7BB1",
        fre: "Caisse d'hiver vilaine",
        bra: "Caixa Malcomportada de Fim de Ano",
        hun: "Rosszcsont T\xe9li L\xe1da",
        swe: "Stygg vinterl\xe5da"
    },
    8: {
        img: "nice_winter_crate",
        eng: "Nice Winter Crate",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u044F\u0449\u0438\u043A \u0434\u043B\u044F \u043F\u043E\u0441\u043B\u0443\u0448\u043D\u044B\u0445",
        pol: "Grzeczna zimowa skrzynka",
        sch: "\u7CBE\u7F8E\u7684\u6B22\u51AC\u4F9B\u5E94\u7BB1",
        fre: "Caisse d'hiver bien sage",
        bra: "Caixa Bem-Comportada de Fim de Ano",
        hun: "Rendes T\xe9li L\xe1da",
        swe: "Sn\xe4ll vinterl\xe5da"
    },
    9: {
        img: "scorched_crate",
        eng: "Scorched Crate",
        rus: "\u041E\u043F\u0430\u043B\u0435\u043D\u043D\u044B\u0439 \u044F\u0449\u0438\u043A",
        pol: "Osmalona skrzynka",
        sch: "\u88AB\u70E7\u7126\u7684\u7BB1\u5B50",
        fre: "Caisse roussie",
        bra: "Caixa Chamuscada",
        hun: "Megperzselt L\xe1da",
        swe: "Br\xe4nd l\xe5da"
    },
    10: {
        img: "fall_crate",
        eng: "Fall Crate",
        rus: "\u041E\u0441\u0435\u043D\u043D\u0438\u0439 \u044F\u0449\u0438\u043A",
        pol: "Jesienna skrzynka",
        sch: "\u79CB\u5B63\u8865\u7ED9\u7BB1",
        fre: "Caisse d'automne",
        bra: "Caixa de Outono",
        hun: "\u0150szi L\xe1da",
        swe: "H\xf6stl\xe5da"
    },
    11: {
        img: "eerie_crate",
        eng: "Eerie Crate",
        rus: "\u0416\u0443\u0442\u043A\u0438\u0439 \u044F\u0449\u0438\u043A",
        pol: "Upiorna skrzynka",
        sch: "\u602A\u5F02\u7684\u8865\u7ED9\u7BB1",
        fre: "Caisse sinistre",
        bra: "Caixa Sombria",
        hun: "K\xeds\xe9rteties L\xe1da",
        swe: "Kuslig l\xe5da"
    },
    12: {
        img: "naughty_winter_crate_2012",
        eng: "Naughty Winter Crate 2012",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u044F\u0449\u0438\u043A \u0434\u043B\u044F \u043D\u0435\u043F\u043E\u0441\u043B\u0443\u0448\u043D\u044B\u0445 \u0432 2012",
        pol: "Niegrzeczna zimowa skrzynka 2012",
        sch: "\u908B\u9062\u6B22\u51AC\u8865\u7ED9\u7BB12012",
        fre: "Caisse d'hiver vilaine 2012",
        bra: "Caixa Malcomportada de Fim de Ano de 2012",
        hun: "Rosszcsont T\xe9li L\xe1da 2012",
        swe: "Stygg Vinterl\xe5da 2012"
    },
    13: {
        img: "nice_winter_crate_2012",
        eng: "Nice Winter Crate 2012",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u044F\u0449\u0438\u043A \u0434\u043B\u044F \u043F\u043E\u0441\u043B\u0443\u0448\u043D\u044B\u0445 \u0432 2012",
        pol: "Grzeczna zimowa skrzynka 2012",
        sch: "\u7CBE\u7F8E\u6B22\u51AC\u4F9B\u5E94\u7BB1 2012",
        fre: "Caisse d'hiver bien sage 2012",
        bra: "Caixa Bem-Comportada de Fim de Ano de 2012",
        hun: "Rendes T\xe9li L\xe1da 2012",
        swe: "Sn\xe4ll Vinterl\xe5da 2012"
    },
    14: {
        img: "robo_community_crate",
        eng: "Robo Community Crate",
        rus: "\u0420\u043E\u0431\u043E-\u044F\u0449\u0438\u043A \u043E\u0442 \u0441\u043E\u043E\u0431\u0449\u0435\u0441\u0442\u0432\u0430",
        pol: "Roboskrzynka spo\u0142eczno\u015Bci",
        sch: "\u673A\u5668\u793E\u533A\u8865\u7ED9\u7BB1",
        fre: "RoboCaisse Communautaire",
        bra: "RoboCaixa",
        hun: "Robo K\xf6z\xf6ss\xe9gi L\xe1da",
        swe: "Robogemenskapsl\xe5da"
    },
    15: {
        img: "select_reserve_mann_co_supply_crate",
        eng: "Select Reserve Mann Co. Supply Crate",
        rus: "\u042F\u0449\u0438\u043A \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u044B\u0445 \u0437\u0430\u043F\u0430\u0441\u043E\u0432 \u041C\u0430\u043D\u043D \u041A\u043E",
        pol: "Skrzynka specjalnej rezerwy Mann Co.",
        sch: "\u66FC\u6069\u516C\u53F8\u7279\u9009\u4FDD\u5B58\u8865\u7ED9\u7BB1",
        fre: "Caisse de s\xe9lection Mann Co.",
        bra: "Caixa Seleta de Suprimentos da Mann Co.",
        hun: "Pr\xe9mium Tartal\xe9k Mann Co. Ell\xe1tm\xe1nyl\xe1da",
        rom: "Selecteaz\u0103 Reserve Mann Co. Supply Crate",
        swe: "S\xe4rskilt utvald f\xf6rr\xe5dsl\xe5da"
    },
    16: {
        img: "summer_appetizer_crate",
        eng: "Summer Appetizer Crate",
        rus: "\u041B\u0435\u0442\u043D\u0438\u0439 \u044F\u0449\u0438\u043A \u0434\u043B\u044F \u043F\u0438\u043A\u043D\u0438\u043A\u0430",
        pol: "Letnia skrzynka przystawek",
        sch: "\u590F\u65E5\u795E\u79D8\u8865\u7ED9\u7BB1",
        fre: "L'Ap\xe9ricaisse Estivale",
        bra: "Caixa de Entrada das F\xe9rias",
        hun: "Ny\xe1ri \xc9tv\xe1gygerjeszt\u0151 L\xe1da",
        swe: "Sommarf\xf6rr\xe4ttsl\xe5da"
    },
    17: {
        img: "red_summer_2013_cooler",
        eng: "Red Summer 2013 Cooler",
        rus: "\u041A\u0440\u0430\u0441\u043D\u044B\u0439 \u043B\u0435\u0442\u043D\u0438\u0439 \u0445\u043E\u043B\u043E\u0434\u0438\u043B\u044C\u043D\u0438\u043A 2013",
        pol: "Czerwona letnia lod\xf3wka 2013",
        sch: "2013 \u771F\u7EA2\u590F\u65E5\u51B7\u85CF\u7BB1",
        fre: "Glaci\xe8re Estivale Rouge 2013",
        bra: "Cooler Vermelho das F\xe9rias de 2013",
        hun: "2013-as Piros Ny\xe1ri H\u0171t\u0151t\xe1ska",
        swe: "R\xf6d Sommarl\xe5da (2013)"
    },
    18: {
        img: "orange_summer_2013_cooler",
        eng: "Orange Summer 2013 Cooler",
        rus: "\u041E\u0440\u0430\u043D\u0436\u0435\u0432\u044B\u0439 \u043B\u0435\u0442\u043D\u0438\u0439 \u0445\u043E\u043B\u043E\u0434\u0438\u043B\u044C\u043D\u0438\u043A 2013",
        pol: "Pomara\u0144czowa letnia lod\xf3wka 2013",
        sch: "2013 \u6F84\u6A59\u590F\u65E5\u51B7\u85CF\u7BB1",
        fre: "Glaci\xe8re Estivale Orange 2013",
        bra: "Cooler Laranja das F\xe9rias de 2013",
        hun: "2013-as Narancss\xe1rga Ny\xe1ri H\u0171t\u0151t\xe1ska",
        swe: "Orange Sommarl\xe5da (2013)"
    },
    19: {
        img: "yellow_summer_2013_cooler",
        eng: "Yellow Summer 2013 Cooler",
        rus: "\u0416\u0435\u043B\u0442\u044B\u0439 \u043B\u0435\u0442\u043D\u0438\u0439 \u0445\u043E\u043B\u043E\u0434\u0438\u043B\u044C\u043D\u0438\u043A 2013",
        pol: "\u017B\xf3\u0142ta letnia lod\xf3wka 2013",
        sch: "2013 \u70AB\u9EC4\u590F\u65E5\u51B7\u85CF\u7BB1",
        fre: "Glaci\xe8re Estivale Jaune 2013",
        bra: "Cooler Amarelo das F\xe9rias de 2013",
        hun: "2013-as S\xe1rga Ny\xe1ri H\u0171t\u0151t\xe1ska",
        swe: "Gul Sommarl\xe5da (2013)"
    },
    20: {
        img: "green_summer_2013_cooler",
        eng: "Green Summer 2013 Cooler",
        rus: "\u0417\u0435\u043B\u0435\u043D\u044B\u0439 \u043B\u0435\u0442\u043D\u0438\u0439 \u0445\u043E\u043B\u043E\u0434\u0438\u043B\u044C\u043D\u0438\u043A 2013",
        pol: "Zielona letnia lod\xf3wka 2013",
        sch: "2013 \u9C9C\u7EFF\u590F\u65E5\u51B7\u85CF\u7BB1",
        fre: "Glaci\xe8re Estivale Verte 2013",
        bra: "Cooler Verde das F\xe9rias de 2013",
        hun: "2013-as Z\xf6ld Ny\xe1ri H\u0171t\u0151t\xe1ska",
        swe: "Gr\xf6n Sommarl\xe5da (2013)"
    },
    21: {
        img: "aqua_summer_2013_cooler",
        eng: "Aqua Summer 2013 Cooler",
        rus: "\u0410\u043A\u0432\u0430\u043C\u0430\u0440\u0438\u043D\u043E\u0432\u044B\u0439 \u043B\u0435\u0442\u043D\u0438\u0439 \u0445\u043E\u043B\u043E\u0434\u0438\u043B\u044C\u043D\u0438\u043A 2013",
        pol: "Turkusowa letnia lod\xf3wka 2013",
        sch: "2013 \u6C34\u7EFF\u590F\u65E5\u51B7\u85CF\u7BB1",
        fre: "Glaci\xe8re Estivale Aquatique 2013",
        bra: "Cooler Azul-Piscina das F\xe9rias de 2013",
        hun: "2013-as V\xedzk\xe9k Ny\xe1ri H\u0171t\u0151t\xe1ska",
        swe: "Turkos Sommarl\xe5da (2013)"
    },
    22: {
        img: "blue_summer_2013_cooler",
        eng: "Blue Summer 2013 Cooler",
        rus: "\u0421\u0438\u043D\u0438\u0439 \u043B\u0435\u0442\u043D\u0438\u0439 \u0445\u043E\u043B\u043E\u0434\u0438\u043B\u044C\u043D\u0438\u043A 2013",
        pol: "Niebieska letnia lod\xf3wka 2013",
        sch: "2013 \u5B9D\u84DD\u590F\u65E5\u51B7\u85CF\u7BB1",
        fre: "Glaci\xe8re Estivale Bleue 2013",
        bra: "Cooler Azul das F\xe9rias de 2013",
        hun: "2013-as K\xe9k Ny\xe1ri H\u0171t\u0151t\xe1ska",
        swe: "Bl\xe5 Sommarl\xe5da (2013)"
    },
    23: {
        img: "brown_summer_2013_cooler",
        eng: "Brown Summer 2013 Cooler",
        rus: "\u041A\u043E\u0440\u0438\u0447\u043D\u0435\u0432\u044B\u0439 \u043B\u0435\u0442\u043D\u0438\u0439 \u0445\u043E\u043B\u043E\u0434\u0438\u043B\u044C\u043D\u0438\u043A 2013",
        pol: "Br\u0105zowa letnia lod\xf3wka 2013",
        sch: "2013 \u68D5\u6728\u590F\u65E5\u51B7\u85CF\u7BB1",
        fre: "Glaci\xe8re Estivale Marron 2013",
        bra: "Cooler Marrom das F\xe9rias de 2013",
        hun: "2013-as Barna Ny\xe1ri H\u0171t\u0151t\xe1ska",
        swe: "Brun Sommarl\xe5da (2013)"
    },
    24: {
        img: "black_summer_2013_cooler",
        eng: "Black Summer 2013 Cooler",
        rus: "\u0427\u0435\u0440\u043D\u044B\u0439 \u043B\u0435\u0442\u043D\u0438\u0439 \u0445\u043E\u043B\u043E\u0434\u0438\u043B\u044C\u043D\u0438\u043A 2013",
        pol: "Czarna letnia lod\xf3wka 2013",
        sch: "2013 \u9177\u9ED1\u590F\u65E5\u51B7\u85CF\u7BB1",
        fre: "Glaci\xe8re Estivale Noire 2013",
        bra: "Cooler Preto das F\xe9rias de 2013",
        hun: "2013-as Fekete Ny\xe1ri H\u0171t\u0151t\xe1ska",
        swe: "Svart Sommarl\xe5da (2013)"
    },
    25: {
        img: "fall_2013_acorns_crate",
        eng: "Fall 2013 Acorns Crate",
        rus: "\u041E\u0441\u0435\u043D\u043D\u0438\u0439 \u044F\u0449\u0438\u043A \u0441 \u0436\u0435\u043B\u0443\u0434\u044F\u043C\u0438 2013",
        pol: "Jesienna \u017Co\u0142\u0119dziowa skrzynka 2013",
        sch: "2013 \u79CB\u5B63\u6A61\u5B50\u8865\u7ED9\u7BB1",
        fre: "Caisse Automnale \xe0 Glands 2013",
        bra: "Caixa de Bolotas das Folhas Secas de 2013",
        hun: "2013 \u0150szi Makkos L\xe1da",
        swe: "H\xf6stens Ekollonl\xe5da (2013)"
    },
    26: {
        img: "fall_2013_gourd_crate",
        eng: "Fall 2013 Gourd Crate",
        rus: "\u041E\u0441\u0435\u043D\u043D\u0438\u0439 \u044F\u0449\u0438\u043A \u0441 \u0442\u044B\u043A\u0432\u0430\u043C\u0438 2013",
        pol: "Jesienna dyniowa skrzynka 2013",
        sch: "2013 \u79CB\u5B63\u74E0\u5B50\u8865\u7ED9\u7BB1",
        fre: "Caisse Automnale \xe0 Citrouilles 2013",
        bra: "Caixa de Porongo das Folhas Secas de 2013",
        hun: "2013 \u0150szi T\xf6k\xf6s L\xe1da",
        swe: "H\xf6stens Kalebassl\xe5da (2013)"
    },
    27: {
        img: "spooky_crate",
        eng: "Spooky Crate",
        rus: "\u0417\u043B\u043E\u0432\u0435\u0449\u0438\u0439 \u044F\u0449\u0438\u043A",
        pol: "Upiorna skrzynka",
        sch: "\u8BE1\u5F02\u7684\u8865\u7ED9\u7BB1",
        fre: "Caisse effrayante",
        bra: "Caixa Apavorante",
        hun: "K\xeds\xe9rteties L\xe1da",
        swe: "Sp\xf6klik l\xe5da"
    },
    28: {
        img: "naughty_winter_crate_2013",
        eng: "Naughty Winter Crate 2013",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u044F\u0449\u0438\u043A \u0434\u043B\u044F \u043D\u0435\u043F\u043E\u0441\u043B\u0443\u0448\u043D\u044B\u0445 \u0432 2013",
        pol: "Niegrzeczna zimowa skrzynka 2013",
        sch: "\u908B\u9062\u7684\u6B22\u51AC\u4F9B\u5E94\u7BB1 2013",
        fre: "Caisse d'hiver vilaine 2013",
        bra: "Caixa Malcomportada de Fim de Ano de 2013",
        hun: "Rosszcsont T\xe9li L\xe1da 2013",
        rom: "Cutie de Iarn\u0103 Naughty 2013",
        swe: "Stygg Vinterl\xe5da 2013"
    },
    29: {
        img: "nice_winter_crate_2013",
        eng: "Nice Winter Crate 2013",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u044F\u0449\u0438\u043A \u0434\u043B\u044F \u043F\u043E\u0441\u043B\u0443\u0448\u043D\u044B\u0445 \u0432 2013",
        pol: "Grzeczna zimowa skrzynka 2013",
        sch: "\u7CBE\u7F8E\u7684\u6B22\u51AC\u4F9B\u5E94\u7BB1 2013",
        fre: "Caisse d'hiver bien sage 2013",
        bra: "Caixa Bem-Comportada de Fim de Ano de 2013",
        hun: "Rendes T\xe9li L\xe1da 2013",
        swe: "Sn\xe4ll Vinterl\xe5da 2013"
    },
    30: {
        img: "mann_co_strongbox",
        eng: "Mann Co. Strongbox",
        rus: "\u0421\u0435\u0439\u0444 \u041C\u0430\u043D\u043D \u041A\u043E",
        pol: "Wzmocniona skrzynka Mann Co.",
        sch: "\u66FC\u6069\u516C\u53F8\u4FDD\u9669\u7BB1",
        fre: "Coffre-fort Mann Co.",
        bra: "Caixa-Forte da Mann Co.",
        hun: "Mann Co. P\xe1nc\xe9lkazetta",
        swe: "Mann Co.-kassask\xe5p"
    },
    31: {
        img: "mann_co_supply_munition",
        eng: "Mann Co. Supply Munition",
        rus: "\u042F\u0449\u0438\u043A \u0441\u043E \u0441\u043D\u0430\u0440\u044F\u0436\u0435\u043D\u0438\u0435\u043C \u041C\u0430\u043D\u043D \u041A\u043E",
        pol: "Uzbrojenie Mann Co.",
        sch: "\u66FC\u6069\u516C\u53F8\u4F9B\u7ED9\u519B\u9700\u54C1",
        fre: "Munitions Mann Co.",
        bra: "Caixa de Provis\xf5es da Mann Co.",
        hun: "Mann Co. L\u0151szerell\xe1tm\xe1ny",
        swe: "Ammunitionsl\xe5da fr\xe5n Mann Co."
    },
    32: {
        img: "bread_box",
        eng: "Bread Box",
        rus: "\u0425\u043B\u0435\u0431\u043D\u0438\u0446\u0430",
        pol: "Chlebak",
        sch: "\u9762\u5305\u602A\u517D\u7BB1",
        fre: "Bo\xeete \xe0 pain",
        bra: "Caixa de P\xe3o",
        hun: "Keny\xe9rtart\xf3",
        swe: "Br\xf6dl\xe5da"
    },
    33: {
        img: "mann_co_stockpile_crate",
        eng: "Mann Co. Stockpile Crate",
        rus: "\u042F\u0449\u0438\u043A \u0441 \u0437\u0430\u043F\u0430\u0441\u0430\u043C\u0438 \u041C\u0430\u043D\u043D \u041A\u043E",
        pol: "Skrzynka zapas\xf3w Mann Co.",
        sch: "\u66FC\u6069\u516C\u53F8\u50A8\u5907\u7269\u8D44\u7BB1",
        fre: "Caisse de la r\xe9serve Mann Co.",
        bra: "Caixa do Estoque da Mann Co.",
        hun: "Mann Co. Rakt\xe1rl\xe1da",
        swe: "Lagerl\xe5da fr\xe5n Mann Co."
    },
    34: {
        img: "unlocked_creepy_scout_crate",
        eng: "Unlocked Creepy Scout Crate",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u0436\u0443\u0442\u043A\u0438\u0439 \u044F\u0449\u0438\u043A \u0420\u0430\u0437\u0432\u0435\u0434\u0447\u0438\u043A\u0430",
        pol: "Otwarta straszna skrzynka Skauta",
        sch: "\u4FA6\u5BDF\u5175\u7684\u65E0\u9501\u6050\u6016\u7BB1",
        fre: "Caisse sinistre d\xe9verrouill\xe9e de Scout",
        bra: "Caixa Destrancada Horripilante do Scout",
        hun: "Bez\xe1ratlan R\xe9miszt\u0151 Felder\xedt\u0151 L\xe1da",
        swe: "Uppl\xe5st kuslig Scout-l\xe5da"
    },
    35: {
        img: "unlocked_creepy_soldier_crate",
        eng: "Unlocked Creepy Soldier Crate",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u0436\u0443\u0442\u043A\u0438\u0439 \u044F\u0449\u0438\u043A \u0421\u043E\u043B\u0434\u0430\u0442\u0430",
        pol: "Otwarta straszna skrzynka \u017Bo\u0142nierza",
        sch: "\u58EB\u5175\u7684\u65E0\u9501\u6050\u6016\u7BB1",
        fre: "Caisse sinistre d\xe9verrouill\xe9e de Soldier",
        bra: "Caixa Destrancada Horripilante do Soldier",
        hun: "Bez\xe1ratlan R\xe9miszt\u0151 Katona L\xe1da",
        swe: "Uppl\xe5st kuslig Soldier-l\xe5da"
    },
    36: {
        img: "unlocked_creepy_pyro_crate",
        eng: "Unlocked Creepy Pyro Crate",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u0436\u0443\u0442\u043A\u0438\u0439 \u044F\u0449\u0438\u043A \u041F\u043E\u0434\u0436\u0438\u0433\u0430\u0442\u0435\u043B\u044F",
        pol: "Otwarta straszna skrzynka Pyro",
        sch: "\u706B\u7130\u5175\u7684\u65E0\u9501\u6050\u6016\u7BB1",
        fre: "Caisse sinistre d\xe9verrouill\xe9e de Pyro",
        bra: "Caixa Destrancada Horripilante de Pyro",
        hun: "Bez\xe1ratlan R\xe9miszt\u0151 Pir\xf3 L\xe1da",
        swe: "Uppl\xe5st kuslig Pyro-l\xe5da"
    },
    37: {
        img: "unlocked_creepy_demo_crate",
        eng: "Unlocked Creepy Demo Crate",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u0436\u0443\u0442\u043A\u0438\u0439 \u044F\u0449\u0438\u043A \u041F\u043E\u0434\u0440\u044B\u0432\u043D\u0438\u043A\u0430",
        pol: "Otwarta straszna skrzynka Demomana",
        sch: "\u7206\u7834\u624B\u7684\u65E0\u9501\u6050\u6016\u7BB1",
        fre: "Caisse sinistre d\xe9verrouill\xe9e de Demoman",
        bra: "Caixa Destrancada Horripilante do Demoman",
        hun: "Bez\xe1ratlan R\xe9miszt\u0151 Robbant\xf3s L\xe1da",
        swe: "Uppl\xe5st kuslig Demoman-l\xe5da"
    },
    38: {
        img: "unlocked_creepy_heavy_crate",
        eng: "Unlocked Creepy Heavy Crate",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u0436\u0443\u0442\u043A\u0438\u0439 \u044F\u0449\u0438\u043A \u043F\u0443\u043B\u0435\u043C\u0451\u0442\u0447\u0438\u043A\u0430",
        pol: "Otwarta straszna skrzynka Grubego",
        sch: "\u673A\u67AA\u624B\u7684\u65E0\u9501\u6050\u6016\u7BB1",
        fre: "Caisse sinistre d\xe9verrouill\xe9e de Heavy",
        bra: "Caixa Destrancada Horripilante do Heavy",
        hun: "Bez\xe1ratlan R\xe9miszt\u0151 G\xe9p\xe1gy\xfas L\xe1da",
        swe: "Uppl\xe5st kuslig Heavy-l\xe5da"
    },
    39: {
        img: "unlocked_creepy_engineer_crate",
        eng: "Unlocked Creepy Engineer Crate",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u0436\u0443\u0442\u043A\u0438\u0439 \u044F\u0449\u0438\u043A \u0418\u043D\u0436\u0435\u043D\u0435\u0440\u0430",
        pol: "Otwarta straszna skrzynka In\u017Cyniera",
        sch: "\u5DE5\u7A0B\u5E08\u7684\u65E0\u9501\u6050\u6016\u7BB1",
        fre: "Caisse sinistre d\xe9verrouill\xe9e d'Engineer",
        bra: "Caixa Destrancada Horripilante do Engineer",
        hun: "Bez\xe1ratlan R\xe9miszt\u0151 M\xe9rn\xf6k L\xe1da",
        swe: "Uppl\xe5st kuslig Engineer-l\xe5da"
    },
    40: {
        img: "unlocked_creepy_medic_crate",
        eng: "Unlocked Creepy Medic Crate",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u0436\u0443\u0442\u043A\u0438\u0439 \u044F\u0449\u0438\u043A \u041C\u0435\u0434\u0438\u043A\u0430",
        pol: "Otwarta straszna skrzynka Medyka",
        sch: "\u533B\u751F\u7684\u65E0\u9501\u6050\u6016\u7BB1",
        fre: "Caisse sinistre d\xe9verrouill\xe9e de Medic",
        bra: "Caixa Destrancada Horripilante do Medic",
        hun: "Bez\xe1ratlan R\xe9miszt\u0151 Szanit\xe9c L\xe1da",
        swe: "Uppl\xe5st kuslig Medic-l\xe5da"
    },
    41: {
        img: "unlocked_creepy_sniper_crate",
        eng: "Unlocked Creepy Sniper Crate",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u0436\u0443\u0442\u043A\u0438\u0439 \u044F\u0449\u0438\u043A \u0421\u043D\u0430\u0439\u043F\u0435\u0440\u0430",
        pol: "Otwarta straszna skrzynka Snajpera",
        sch: "\u72D9\u51FB\u624B\u7684\u65E0\u9501\u6050\u6016\u7BB1",
        fre: "Caisse sinistre d\xe9verrouill\xe9e de Sniper",
        bra: "Caixa Destrancada Horripilante do Sniper",
        hun: "Bez\xe1ratlan R\xe9miszt\u0151 Mesterl\xf6v\xe9sz L\xe1da",
        swe: "Uppl\xe5st kuslig Sniper-l\xe5da"
    },
    42: {
        img: "unlocked_creepy_spy_crate",
        eng: "Unlocked Creepy Spy Crate",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u0436\u0443\u0442\u043A\u0438\u0439 \u044F\u0449\u0438\u043A \u0428\u043F\u0438\u043E\u043D\u0430",
        pol: "Otwarta straszna skrzynka Szpiega",
        sch: "\u95F4\u8C0D\u7684\u65E0\u9501\u6050\u6016\u7BB1",
        fre: "Caisse sinistre d\xe9verrouill\xe9e de Spy",
        bra: "Caixa Destrancada Horripilante do Spy",
        hun: "Bez\xe1ratlan R\xe9miszt\u0151 K\xe9m L\xe1da",
        swe: "Uppl\xe5st kuslig Spy-l\xe5da"
    },
    43: {
        img: "limited_late_summer_crate",
        eng: "Limited Late Summer Crate",
        rus: "\u042F\u0449\u0438\u043A \u0437\u0430\u043F\u043E\u0437\u0434\u0430\u0432\u0448\u0435\u0433\u043E \u043B\u0435\u0442\u0430 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u043E\u0439 \u0441\u0435\u0440\u0438\u0438",
        pol: "Limitowana sp\xf3\u017Aniona letnia skrzynka",
        sch: "\u9650\u91CF\u590F\u672B\u8865\u7ED9\u7BB1",
        fre: "Caisse limit\xe9e de fin d'\xe9t\xe9",
        bra: "Caixa Limitada de F\xe9rias Atrasada",
        hun: "Limit\xe1lt K\xe9s\u0151 Ny\xe1ri L\xe1da",
        swe: "Begr\xe4nsad sensommarl\xe5da"
    },
    44: {
        img: "end_of_the_line_community_crate",
        eng: "End of the Line Community Crate",
        rus: '\u042F\u0449\u0438\u043A \u043E\u0442 \u0441\u043E\u043E\u0431\u0449\u0435\u0441\u0442\u0432\u0430 "The End of the Line"',
        pol: "Skrzynka aktualizacji spo\u0142eczno\u015Bci \u201EKoniec trasy\u201D",
        sch: "End of the Line \u793E\u533A\u8865\u7ED9\u7BB1",
        fre: "Caisse communautaire End of the Line",
        bra: "Caixa do End of the Line",
        hun: "V\xe9g\xe1llom\xe1s K\xf6z\xf6ss\xe9gi L\xe1da",
        rom: "Cutie Comunitar\u0103 \u201EEnd of the Line\u201D",
        swe: "End of the Line-gemenskapsl\xe5da"
    },
    45: {
        img: "naughty_winter_crate_2014",
        eng: "Naughty Winter Crate 2014",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u044F\u0449\u0438\u043A \u0434\u043B\u044F \u043D\u0435\u043F\u043E\u0441\u043B\u0443\u0448\u043D\u044B\u0445 \u0432 2014",
        pol: "Niegrzeczna zimowa skrzynka 2014",
        sch: "\u908B\u9062\u6B22\u51AC\u8865\u7ED9\u7BB1 2014",
        fre: "Caisse d'hiver vilaine 2014",
        bra: "Caixa Malcomportada de Fim de Ano de 2014",
        hun: "Rosszcsont T\xe9li L\xe1da 2014",
        swe: "Stygg Vinterl\xe5da 2014"
    },
    46: {
        img: "nice_winter_crate_2014",
        eng: "Nice Winter Crate 2014",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u044F\u0449\u0438\u043A \u0434\u043B\u044F \u043F\u043E\u0441\u043B\u0443\u0448\u043D\u044B\u0445 \u0432 2014",
        pol: "Grzeczna zimowa skrzynka 2014",
        sch: "\u7CBE\u7F8E\u6B22\u51AC\u8865\u7ED9\u7BB1 2014",
        fre: "Caisse d'hiver bien sage 2014",
        bra: "Caixa Bem-Comportada de Fim de Ano de 2014",
        hun: "Rendes T\xe9li L\xe1da 2014",
        swe: "Sn\xe4ll Vinterl\xe5da 2014"
    },
    47: {
        img: "powerhouse_weapons_case",
        eng: "Powerhouse Weapons Case",
        rus: '\u041A\u0435\u0439\u0441 "\u041E\u0440\u0443\u0436\u0438\u0435 \u0441 Powerhouse"',
        pol: "Pojemnik Powerhouse",
        sch: "Powerhouse \u6B66\u5668\u7BB1",
        fre: "La caisse d'armes Powerhouse",
        bra: "Caixa de Arma da Cole\xe7\xe3o Powerhouse",
        hun: "Powerhouse Fegyvert\xe1ska",
        swe: "Powerhouse-vapenv\xe4ska",
        rom: "Cutie cu arme Powerhouse"
    },
    48: {
        img: "gun_mettle_cosmetic_case",
        eng: "Gun Mettle Cosmetic Case",
        rus: "\u041B\u0438\u0445\u043E\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438",
        pol: "Pojemnik ozd\xf3b aktualizacji \u201ESi\u0142a charakteru\u201D",
        sch: "\u67AA\u9B42\u9970\u54C1\u7BB1",
        fre: "Caisse de cosm\xe9tiques Gun Mettle",
        bra: "Caixa de Cosm\xe9ticos do Arsenal Art\xedstico",
        hun: "Fegyverre Termett D\xedsz\xedt\u0151 T\xe1ska",
        swe: "Gun Mettle-kosmetikl\xe5da",
        rom: "Cutie cu accesorii Gun Mettle"
    },
    49: {
        img: "quarantined_collection_case",
        eng: "Quarantined Collection Case",
        rus: '\u041A\u0435\u0439\u0441 \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u0438 "\u041A\u0430\u0440\u0430\u043D\u0442\u0438\u043D"',
        pol: "Pojemnik kolekcji kwarantanny",
        sch: "\u9694\u79BB\u6536\u85CF\u54C1\u7BB1",
        fre: "Caisse de la collection Quarantaine",
        bra: "Caixa da Cole\xe7\xe3o Quarentena",
        hun: "Elk\xfcl\xf6n\xedtett Gy\u0171jtem\xe9ny T\xe1ska",
        swe: "Isolerad-kollektionsl\xe5da",
        cze: "Kolekce Quarantined",
        rom: "Colec\u021Bia Quarantined"
    },
    50: {
        img: "confidential_collection_case",
        eng: "Confidential Collection Case",
        rus: '\u041A\u0435\u0439\u0441 \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u0438 "\u0417\u0430\u0441\u0435\u043A\u0440\u0435\u0447\u0435\u043D\u043E"',
        pol: "Pojemnik kolekcji poufne",
        sch: "\u673A\u5BC6\u6536\u85CF\u54C1\u7BB1",
        fre: "Caisse de la collection Confidentielle",
        bra: "Caixa da Cole\xe7\xe3o Confidencial",
        hun: "Bizalmas Gy\u0171jtem\xe9ny T\xe1ska",
        swe: "Konfidentiell-kollektionsl\xe5da",
        cze: "Kolekce Confidential",
        rom: "Colec\u021Bia Confidential"
    },
    51: {
        img: "gargoyle_case",
        eng: "Gargoyle Case",
        rus: "\u0413\u0430\u0440\u0433\u0443\u043B\u0438\u0439 \u043A\u0435\u0439\u0441",
        pol: "Pojemnik gargulca",
        sch: "\u77F3\u50CF\u9B3C\u77F3\u5323",
        fre: "Caisse gargouille",
        bra: "Caixa da G\xe1rgula",
        hun: "V\xedzk\xf6p\u0151 T\xe1ska",
        swe: "Gargoyle-l\xe5da",
        rom: "Cutie Gargoyle"
    },
    52: {
        img: "pyroland_weapons_case",
        eng: "Pyroland Weapons Case",
        rus: '\u041A\u0435\u0439\u0441 "\u041F\u0438\u0440\u043E\u043B\u0430\u043D\u0434\u0438\u044F"',
        pol: "Pojemnik Pyrolandu",
        sch: "\u706B\u7130\u5E7B\u5883\u6B66\u5668\u7BB1",
        fre: "Caisse d'armes Pyroland",
        bra: "Caixa de Arma da Pyrol\xe2ndia",
        hun: "Pir\xf3f\xf6lde Fegyvert\xe1ska",
        swe: "Pyroland-vapenl\xe5da",
        rom: "Cutie cu arme Pyroland"
    },
    53: {
        img: "warbird_weapons_case",
        eng: "Warbird Weapons Case",
        rus: '\u041A\u0435\u0439\u0441 "\u041B\u0435\u0442\u0443\u0447\u0438\u0439 \u043E\u0442\u0440\u044F\u0434"',
        pol: "Pojemnik Warbird",
        sch: "\u6218\u9E1F\u6B66\u5668\u7BB1",
        fre: "Caisse d'armes Warbird",
        bra: "Caixa de Arma da Ave de Guerra",
        hun: "Viharmad\xe1r Fegyvert\xe1ska",
        swe: "Warbird-vapenl\xe5da",
        rom: "Cutie cu arme Warbird"
    },
    54: {
        img: "tough_break_cosmetic_case",
        eng: "Tough Break Cosmetic Case",
        rus: "\u041E\u0442\u043F\u0443\u0441\u043A\u043D\u043E\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438",
        pol: "Pojemnik ozd\xf3b aktualizacji \u201E\u015Ani\u0105teczne fatum\u201D",
        sch: "\u8270\u96BE\u5047\u65E5\u9970\u54C1\u7BB1",
        fre: "Caisse de cosm\xe9tiques Tough Break",
        bra: "Caixa de Cosm\xe9ticos das F\xe9rias Frustradas",
        hun: "Balszerencse D\xedsz\xedt\u0151 T\xe1ska",
        swe: "Tough Break-kosmetikl\xe5da",
        rom: "Cutie cu accesorii Tough Break"
    },
    55: {
        img: "mayflower_cosmetic_case",
        eng: "Mayflower Cosmetic Case",
        rus: "\u041C\u0430\u0439\u0441\u043A\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438",
        pol: "Pojemnik ozd\xf3b kwiecia majowego",
        sch: "\u4E94\u6708\u82B1\u9970\u54C1\u7BB1",
        fre: "Caisse de cosm\xe9tiques Mayflower",
        bra: "Caixa de Cosm\xe9ticos da Flor de Maio",
        hun: "Galagonya D\xedsz\xedt\u0151 T\xe1ska",
        swe: "Mayflower-kosmetikl\xe5da",
        rom: "Cutie cu accesorii Mayflower"
    },
    56: {
        img: "creepy_crawly_case",
        eng: "Creepy Crawly Case",
        rus: "\u041A\u0435\u0439\u0441 \u043F\u043E\u043B\u0437\u0443\u0447\u0435\u0439 \u0442\u0432\u0430\u0440\u0438",
        pol: "Pojemnik g\u0119siej sk\xf3rki",
        sch: "\u6050\u6016\u8718\u86DB\u77F3\u5323",
        fre: "Caisse arachn\xe9enne",
        bra: "Caixa da Aranha Arrepiante",
        hun: "Cs\xfasz\xf3m\xe1sz\xf3 T\xe1ska",
        swe: "Kusliga kryp-l\xe5da",
        rom: "Cutie Creepy Crawly"
    },
    57: {
        img: "unlocked_winter_2016_cosmetic_case",
        eng: "Unlocked Winter 2016 Cosmetic Case",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u0437\u0438\u043C\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 2016",
        pol: "Otwarty zimowy pojemnik ozd\xf3b 2016",
        sch: "2016 \u5E74\u65E0\u9501\u51AC\u5B63\u9970\u54C1\u7BB1",
        fre: "Caisse cosm\xe9tique d'hiver 2016 d\xe9verrouill\xe9e",
        bra: "Caixa de Cosm\xe9ticos Destrancada de Fim de Ano de 2016",
        hun: "Kinyitott 2016 T\xe9li D\xedsz\xedt\u0151 T\xe1ska",
        rom: "Cutie cu accesorii Winter 2016 deblocat\u0103",
        swe: "Uppl\xe5st Vinter 2016-kosmetikl\xe5da"
    },
    58: {
        img: "rainy_day_cosmetic_case",
        eng: "Rainy Day Cosmetic Case",
        rus: "\u041A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 \u043D\u0430 \u0447\u0451\u0440\u043D\u044B\u0439 \u0434\u0435\u043D\u044C",
        pol: "Pojemnik ozd\xf3b deszczowego dnia",
        sch: "\u96E8\u5B63\u9970\u54C1\u7BB1",
        fre: "Caisse de cosm\xe9tiques Rainy Day",
        bra: "Caixa de Cosm\xe9ticos do Dia Chuvoso",
        hun: "Es\u0151s Napi D\xedsz\xedt\u0151 T\xe1ska",
        swe: "Rainy Day-kosmetikl\xe5da",
        rom: "Cutie cu accesorii Rainy Day"
    },
    59: {
        img: "abominable_cosmetic_case",
        eng: "Abominable Cosmetic Case",
        rus: "\u0427\u0443\u0434\u043E\u0432\u0438\u0449\u043D\u044B\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438",
        pol: "Pojemnik ozd\xf3b okropie\u0144stwa",
        sch: "\u618E\u6076\u4E4B\u7269\u9970\u54C1\u7BB1",
        fre: "Caisse de cosm\xe9tiques abominables",
        bra: "Caixa de Cosm\xe9ticos Abomin\xe1veis",
        hun: "F\xf6rtelmes D\xedsz\xedt\u0151 T\xe1ska",
        swe: "Abominable Cosmetic-v\xe4ska",
        rom: "Cutie cu accesorii Abominable"
    },
    60: {
        img: "unleash_the_beast_cosmetic_case",
        eng: "Unleash the Beast Cosmetic Case",
        rus: "\u0417\u0432\u0435\u0440\u0441\u043A\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438",
        pol: "Pojemnik ozd\xf3b uwolnionej bestii",
        sch: "\u91CA\u653E\u91CE\u517D\u9970\u54C1\u7BB1",
        fre: "Caisse de cosm\xe9tiques Unleash the Beast",
        bra: "Caixa de Cosm\xe9ticos da Fera Libertada",
        hun: "Szabadon a Fenevaddal D\xedsz\xedt\u0151 T\xe1ska",
        rom: "Cutie cu accesorii Unleash the Beast",
        swe: "Unleash the Beast-v\xe4ska"
    },
    61: {
        img: "jungle_jackpot_war_paint_case",
        eng: "Jungle Jackpot War Paint Case",
        rus: "\u0422\u0440\u043E\u043F\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0431\u043E\u0435\u0432\u043E\u0439 \u043A\u0440\u0430\u0441\u043A\u043E\u0439",
        pol: "Pojemnik barw wojennych d\u017Cunglowej nagrody",
        sch: "\u4E1B\u6797\u5927\u5956\u6218\u7ED8\u7BB1",
        fre: "Caisse de peintures Jungle Jackpot",
        bra: "Caixa de Tintas de Guerra da Sorte Selvagem",
        hun: "Dzsungelf\u0151nyerem\xe9ny Harci Fest\xe9s T\xe1ska",
        swe: "Jungle Jackpot-krigsf\xe4rgv\xe4ska",
        rom: "Cutie cu vopsea de r\u0103zboi Jungle Jackpot"
    },
    62: {
        img: "infernal_reward_war_paint_case",
        eng: "Infernal Reward War Paint Case",
        rus: "\u0410\u0434\u0441\u043A\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0431\u043E\u0435\u0432\u043E\u0439 \u043A\u0440\u0430\u0441\u043A\u043E\u0439",
        pol: "Pojemnik barw wojennych piekielnych nagr\xf3d",
        sch: "\u70BC\u72F1\u4E4B\u8D50\u6218\u7ED8\u7BB1",
        fre: "Caisse de peintures Infernal Reward",
        bra: "Caixa de Tintas de Guerra da Recompensa Infernal",
        hun: "Pokoli Jutalom Harci Fest\xe9s T\xe1ska",
        swe: "Infernal Reward-krigsf\xe4rgv\xe4ska",
        rom: "Cutie cu vopsea de r\u0103zboi Infernal Reward"
    },
    63: {
        img: "war_paint_civilian_grade_keyless_case",
        eng: "Decorated War Hero War Paint Civilian Grade Keyless Case",
        rus: "\u041A\u0435\u0439\u0441 c \u0431\u043E\u0435\u0432\u043E\u0439 \u043A\u0440\u0430\u0441\u043A\u043E\u0439 \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u043E\u0433\u043E \u043A\u043B\u0430\u0441\u0441\u0430 \xab\u0413\u0435\u0440\u043E\u0439 \u0432\u043E\u0439\u043D\u044B\xbb \u0431\u0435\u0437 \u043A\u043B\u044E\u0447\u0430",
        pol: "Barwy wojenne bohatera wojennego Otwarty pojemnik stopnia cywil",
        sch: "\u529F\u52CB\u82F1\u96C4 \u6C11\u7528\u7EA7\u65E0\u9501\u6218\u7ED8\u7BB1",
        fre: "Peinture de guerre Decorated War Hero Caisse ouverte de niveau Civil",
        bra: "Tinta de Guerra \"Veterano Condecorado\" Caixa Destrancada Nv. Civil",
        hun: "\u201EKit\xfcntetett H\xe1bor\xfas H\u0151s\u201D harci fest\xe9s Civil fokozat\xfa kulcs n\xe9lk\xfcli t\xe1ska",
        rom: "Vopsea de r\u0103zboi \u201EDecorated War Hero\u201D Cutie ne\xeencuiat\u0103 de ordin civil",
        cze: "Decorated War Hero Civilian Grade Keyless Case",
        swe: "'Decorated War Hero'-krigsf\xe4rg Civilklassad nyckell\xf6s v\xe4ska"
    },
    64: {
        img: "war_paint_civilian_grade_keyless_case",
        eng: "Contract Campaigner War Paint Civilian Grade Keyless Case",
        rus: "\u0411\u043E\u0435\u0432\u0430\u044F \u043A\u0440\u0430\u0441\u043A\u0430 \xab\u041A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u043D\u044B\u0439 \u0430\u043A\u0442\u0438\u0432\u0438\u0441\u0442\xbb \u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u043A\u0435\u0439\u0441 \u043D\u0430\u0451\u043C\u043D\u0438\u043A\u0430",
        pol: "Barwy wojenne najemnika kontraktowego Otwarty pojemnik stopnia cywil",
        sch: "\u5408\u540C\u5C65\u884C\u8005 \u6C11\u7528\u7EA7\u65E0\u9501\u6218\u7ED8\u7BB1",
        fre: "Peinture de guerre \xab Contract Campaigner \xbb Caisse ouverte de niveau Civil",
        bra: "Tinta de Guerra \"Contratado da Campanha\" Caixa Destrancada Nv. Civil",
        hun: "\u201ESzerz\u0151d\xe9ses Hadj\xe1ratoz\xf3\u201D harci fest\xe9s Civil fokozat\xfa kulcs n\xe9lk\xfcli t\xe1ska",
        rom: "Vopsea de r\u0103zboi \u201EContract Campaigner\u201D Cutie ne\xeencuiat\u0103 de ordin civil",
        cze: "Contract Campaigner Civilian Grade Keyless Case",
        swe: "'Contract Campaigner'-krigsf\xe4rg Civilklassad nyckell\xf6s v\xe4ska"
    },
    65: {
        img: "winter_2017_cosmetic_case",
        eng: "Winter 2017 Cosmetic Case",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 2017",
        pol: "Zimowy pojemnik ozd\xf3b 2017",
        sch: "2017 \u51AC\u5B63\u9970\u54C1\u7BB1",
        fre: "Caisse de cosm\xe9tiques d'hiver 2017",
        bra: "Caixa de Cosm\xe9ticos de Fim de Ano de 2017",
        hun: "T\xe9l 2017 D\xedsz\xedt\u0151 T\xe1ska",
        swe: "Vinter 2017-l\xe5da",
        rom: "Cutie cu accesorii Winter 2017"
    },
    66: {
        img: "winter_2017_war_paint_case",
        eng: "Winter 2017 War Paint Case",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0431\u043E\u0435\u0432\u043E\u0439 \u043A\u0440\u0430\u0441\u043A\u043E\u0439 2017",
        pol: "Zimowy pojemnik barw wojennych 2017",
        sch: "2017 \u51AC\u5B63\u6218\u7ED8\u7BB1",
        fre: "Caisse de peintures d'hiver 2017",
        bra: "Caixa de Tintas de Guerra de Fim de Ano de 2017",
        hun: "T\xe9l 2017 Harci Fest\xe9s T\xe1ska",
        swe: "Vinter 2017-krigsf\xe4rgv\xe4ska",
        rom: "Cutie cu vopsea de r\u0103zboi Winter 2017"
    },
    67: {
        img: "blue_moon_cosmetic_case",
        eng: "Blue Moon Cosmetic Case",
        rus: "\u041B\u0443\u043D\u043D\u044B\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438",
        pol: "Pojemnik ozd\xf3b b\u0142\u0119kitnego ksi\u0119\u017Cyca",
        sch: "\u84DD\u6708\u9970\u54C1\u7BB1",
        fre: "Caisse de cosm\xe9tiques Blue Moon",
        bra: "Caixa de Cosm\xe9ticos da Lua Azul",
        hun: "K\xe9k Hold D\xedsz\xedt\u0151 T\xe1ska",
        swe: "Blue Moon-l\xe5da",
        rom: "Cutie cu accesorii Blue Moon"
    },
    68: {
        img: "violet_vermin_case",
        eng: "Violet Vermin Case",
        rus: "\u041A\u0435\u0439\u0441 \u0444\u0438\u043E\u043B\u0435\u0442\u043E\u0432\u043E\u0433\u043E \u043F\u0430\u0440\u0430\u0437\u0438\u0442\u0430",
        pol: "Pojemnik purpurowego paj\u0105ka",
        sch: "\u7D2B\u8272\u5BB3\u866B\u77F3\u5323",
        fre: "Caisse de cosm\xe9tiques veuve violette",
        bra: "Caixa do Verme Violeta",
        hun: "Ibolyasz\xedn \xcdzeltl\xe1b\xfaak T\xe1ska",
        swe: "Violet Vermin-l\xe5da",
        rom: "Cutie Violet Vermin"
    },
    69: {
        img: "scream_fortress_x_war_paint_case",
        eng: "Scream Fortress X War Paint Case",
        rus: '\u041A\u0435\u0439\u0441 \u0441 \u0431\u043E\u0435\u0432\u043E\u0439 \u043A\u0440\u0430\u0441\u043A\u043E\u0439 "\u0412\u0438\u0438\u0438\u0437\u0433 \u0424\u043E\u0440\u0442\u0440\u0435\u0441\u0441 X"',
        pol: "Pojemnik barw wojennych Scream Fortress X",
        sch: "\u5C16\u53EB\u8981\u585E X \u6218\u7ED8\u7BB1",
        fre: "Caisse de peintures Scream Fortress X",
        bra: "Caixa de Tintas de Guerra do Scream Fortress X",
        hun: "Scream Fortress X Harci Fest\xe9s T\xe1ska",
        swe: "Scream Fortress X-krigsf\xe4rgv\xe4ska",
        rom: "Cutie cu vopsea de r\u0103zboi Scream Fortress X"
    },
    70: {
        img: "winter_2018_cosmetic_case",
        eng: "Winter 2018 Cosmetic Case",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 2018",
        pol: "Zimowy pojemnik ozd\xf3b 2018",
        sch: "2018 \u51AC\u5B63\u9970\u54C1\u7BB1",
        fre: "Caisse de cosm\xe9tiques d'hiver 2018",
        bra: "Caixa de Cosm\xe9ticos de Fim de Ano de 2018",
        hun: "T\xe9l 2018 D\xedsz\xedt\u0151 T\xe1ska",
        swe: "Vinter 2018-l\xe5da",
        rom: "Cutie cu accesorii Winter 2018"
    },
    71: {
        img: "summer_2019_cosmetic_case",
        eng: "Summer 2019 Cosmetic Case",
        rus: "\u041B\u0435\u0442\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 2019",
        pol: "Letni pojemnik ozd\xf3b 2019",
        fre: "Caisse de cosm\xe9tiques d'\xe9t\xe9 2019",
        sch: "2019 \u590F\u5B63\u9970\u54C1\u7BB1",
        bra: "Caixa de Cosm\xe9ticos das F\xe9rias de 2019",
        hun: "Ny\xe1r 2019 D\xedsz\xedt\u0151 T\xe1ska",
        swe: "Sommar 2019-l\xe5da",
        rom: "Cutie cu accesorii Summer 2019"
    },
    72: {
        img: "unlocked_cosmetic_crate_scout",
        eng: "Unlocked Cosmetic Crate Scout",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u044F\u0449\u0438\u043A \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 \u0440\u0430\u0437\u0432\u0435\u0434\u0447\u0438\u043A\u0430",
        pol: "Otwarta skrzynka ozd\xf3b Skauta",
        sch: "\u65E0\u9501\u4FA6\u5BDF\u5175\u9970\u54C1\u7BB1",
        fre: "Caisse cosm\xe9tique du Scout ouverte",
        bra: "Caixa de Cosm\xe9ticos Destrancada do Scout",
        hun: "Kinyitott Felder\xedt\u0151 D\xedsz\xedt\u0151 L\xe1da",
        swe: "Uppl\xe5st kosmetikl\xe5da (Scout)"
    },
    73: {
        img: "unlocked_cosmetic_crate_soldier",
        eng: "Unlocked Cosmetic Crate Soldier",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u044F\u0449\u0438\u043A \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 \u0441\u043E\u043B\u0434\u0430\u0442\u0430",
        pol: "Otwarta skrzynka ozd\xf3b \u017Bo\u0142nierza",
        sch: "\u65E0\u9501\u58EB\u5175\u9970\u54C1\u7BB1",
        fre: "Caisse cosm\xe9tique du Soldier ouverte",
        bra: "Caixa de Cosm\xe9ticos Destrancada do Soldier",
        hun: "Kinyitott Katona D\xedsz\xedt\u0151 L\xe1da",
        swe: "Uppl\xe5st kosmetikl\xe5da (Soldier)"
    },
    74: {
        img: "unlocked_cosmetic_crate_pyro",
        eng: "Unlocked Cosmetic Crate Pyro",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u044F\u0449\u0438\u043A \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 \u043F\u043E\u0434\u0436\u0438\u0433\u0430\u0442\u0435\u043B\u044F",
        pol: "Otwarta skrzynka ozd\xf3b Pyro",
        sch: "\u65E0\u9501\u706B\u7130\u5175\u9970\u54C1\u7BB1",
        fre: "Caisse cosm\xe9tique du Pyro ouverte",
        bra: "Caixa de Cosm\xe9ticos Destrancada de Pyro",
        hun: "Kinyitott Pir\xf3 D\xedsz\xedt\u0151 L\xe1da",
        swe: "Uppl\xe5st kosmetikl\xe5da (Pyro)"
    },
    75: {
        img: "unlocked_cosmetic_crate_demo",
        eng: "Unlocked Cosmetic Crate Demo",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u044F\u0449\u0438\u043A \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 \u043F\u043E\u0434\u0440\u044B\u0432\u043D\u0438\u043A\u0430",
        pol: "Otwarta skrzynka ozd\xf3b Demomana",
        sch: "\u65E0\u9501\u7206\u7834\u624B\u9970\u54C1\u7BB1",
        fre: "Caisse cosm\xe9tique du Demo ouverte",
        bra: "Caixa de Cosm\xe9ticos Destrancada do Demoman",
        hun: "Kinyitott Robbant\xf3s D\xedsz\xedt\u0151 L\xe1da",
        swe: "Uppl\xe5st kosmetikl\xe5da (Demoman)"
    },
    76: {
        img: "unlocked_cosmetic_crate_heavy",
        eng: "Unlocked Cosmetic Crate Heavy",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u044F\u0449\u0438\u043A \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 \u043F\u0443\u043B\u0435\u043C\u0451\u0442\u0447\u0438\u043A\u0430",
        pol: "Otwarta skrzynka ozd\xf3b Grubego",
        sch: "\u65E0\u9501\u673A\u67AA\u624B\u9970\u54C1\u7BB1",
        fre: "Caisse cosm\xe9tique du Heavy ouverte",
        bra: "Caixa de Cosm\xe9ticos Destrancada do Heavy",
        hun: "Kinyitott G\xe9p\xe1gy\xfas D\xedsz\xedt\u0151 L\xe1da",
        swe: "Uppl\xe5st kosmetikl\xe5da (Heavy)"
    },
    77: {
        img: "unlocked_cosmetic_crate_engineer",
        eng: "Unlocked Cosmetic Crate Engineer",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u044F\u0449\u0438\u043A \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 \u0438\u043D\u0436\u0435\u043D\u0435\u0440\u0430",
        pol: "Otwarta skrzynka ozd\xf3b In\u017Cyniera",
        sch: "\u65E0\u9501\u5DE5\u7A0B\u5E08\u9970\u54C1\u7BB1",
        fre: "Caisse cosm\xe9tique de l'Engineer ouverte",
        bra: "Caixa de Cosm\xe9ticos Destrancada do Engineer",
        hun: "Kinyitott M\xe9rn\xf6k D\xedsz\xedt\u0151 L\xe1da",
        swe: "Uppl\xe5st kosmetikl\xe5da (Engineer)"
    },
    78: {
        img: "unlocked_cosmetic_crate_medic",
        eng: "Unlocked Cosmetic Crate Medic",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u044F\u0449\u0438\u043A \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 \u043C\u0435\u0434\u0438\u043A\u0430",
        pol: "Otwarta skrzynka ozd\xf3b Medyka",
        sch: "\u65E0\u9501\u533B\u751F\u9970\u54C1\u7BB1",
        fre: "Caisse cosm\xe9tique du Medic ouverte",
        bra: "Caixa de Cosm\xe9ticos Destrancada do Medic",
        hun: "Kinyitott Szanit\xe9c D\xedsz\xedt\u0151 L\xe1da",
        swe: "Uppl\xe5st kosmetikl\xe5da (Medic)"
    },
    79: {
        img: "unlocked_cosmetic_crate_sniper",
        eng: "Unlocked Cosmetic Crate Sniper",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u044F\u0449\u0438\u043A \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 \u0441\u043D\u0430\u0439\u043F\u0435\u0440\u0430",
        pol: "Otwarta skrzynka ozd\xf3b Snajpera",
        sch: "\u65E0\u9501\u72D9\u51FB\u624B\u9970\u54C1\u7BB1",
        fre: "Caisse cosm\xe9tique du Sniper ouverte",
        bra: "Caixa de Cosm\xe9ticos Destrancada do Sniper",
        hun: "Kinyitott Mesterl\xf6v\xe9sz D\xedsz\xedt\u0151 L\xe1da",
        swe: "Uppl\xe5st kosmetikl\xe5da (Sniper)"
    },
    80: {
        img: "unlocked_cosmetic_crate_spy",
        eng: "Unlocked Cosmetic Crate Spy",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u044F\u0449\u0438\u043A \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 \u0448\u043F\u0438\u043E\u043D\u0430",
        pol: "Otwarta skrzynka ozd\xf3b Szpiega",
        sch: "\u65E0\u9501\u95F4\u8C0D\u9970\u54C1\u7BB1",
        fre: "Caisse cosm\xe9tique du Spy ouverte",
        bra: "Caixa de Cosm\xe9ticos Destrancada do Spy",
        hun: "Kinyitott K\xe9m D\xedsz\xedt\u0151 L\xe1da",
        swe: "Uppl\xe5st kosmetikl\xe5da (Spy)"
    },
    81: {
        img: "unlocked_cosmetic_crate_multi_class",
        eng: "Unlocked Cosmetic Crate Multi-Class",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u044F\u0449\u0438\u043A \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u0445 \u043A\u043B\u0430\u0441\u0441\u043E\u0432",
        pol: "Otwarta skrzynka ozd\xf3b wielu klas",
        sch: "\u65E0\u9501\u591A\u804C\u4E1A\u9970\u54C1\u7BB1",
        fre: "Caisse cosm\xe9tique Multi-classe ouverte",
        bra: "Caixa de Cosm\xe9ticos Destrancada Multiclasses",
        hun: "Kinyitott T\xf6bb Oszt\xe1ly\xfa D\xedsz\xedt\u0151 L\xe1da",
        swe: "Uppl\xe5st kosmetikl\xe5da (flera klasser)"
    },
    82: {
        img: "spooky_spoils_case",
        eng: "Spooky Spoils Case",
        rus: "\u041A\u0435\u0439\u0441 \u0442\u0440\u0435\u0432\u043E\u0436\u043D\u044B\u0445 \u0442\u0440\u043E\u0444\u0435\u0435\u0432",
        pol: "Pojemnik potwornych \u0142up\xf3w",
        fre: "Caisse des spoliations sinistres",
        sch: "\u5E7D\u7075\u6218\u5229\u54C1\u77F3\u5323",
        bra: "Caixa dos Esp\xf3lios Assustadores",
        hun: "K\xeds\xe9rteties Kincsek T\xe1ska",
        swe: "Sp\xf6klik skattv\xe4ska",
        rom: "Cutie Spooky Spoils"
    },
    83: {
        img: "winter_2019_cosmetic_case",
        eng: "Winter 2019 Cosmetic Case",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 2019",
        pol: "Zimowy pojemnik ozd\xf3b 2019",
        fre: "Caisse de cosm\xe9tiques d'hiver 2019",
        sch: "2019 \u51AC\u5B63\u9970\u54C1\u7BB1",
        bra: "Caixa de Cosm\xe9ticos de Fim de Ano de 2019",
        hun: "T\xe9l 2019 D\xedsz\xedt\u0151 T\xe1ska",
        swe: "Vinter 2019-kosmetikl\xe5da",
        rom: "Cutie cu accesorii Winter 2019"
    },
    84: {
        img: "winter_2019_war_paint_case",
        eng: "Winter 2019 War Paint Case",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0431\u043E\u0435\u0432\u043E\u0439 \u043A\u0440\u0430\u0441\u043A\u043E\u0439 2019",
        pol: "Zimowy pojemnik barw wojennych 2019",
        fre: "Caisse de peintures d'hiver 2019",
        sch: "2019 \u51AC\u5B63\u6218\u7ED8\u7BB1",
        bra: "Caixa de Tintas de Guerra de Fim de Ano de 2019",
        hun: "T\xe9l 2019 Harci Fest\xe9s T\xe1ska",
        swe: "Vinter 2019-krigsf\xe4rgv\xe4ska",
        rom: "Cutie cu vopsea de r\u0103zboi Winter 2019"
    },
    85: {
        img: "summer_2020_cosmetic_case",
        eng: "Summer 2020 Cosmetic Case",
        rus: "\u041B\u0435\u0442\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 2020",
        pol: "Letni pojemnik ozd\xf3b 2020",
        fre: "Caisse de cosm\xe9tiques d'\xe9t\xe9 2020",
        sch: "2020 \u590F\u5B63\u9970\u54C1\u7BB1",
        bra: "Caixa de Cosm\xe9ticos das F\xe9rias de 2020",
        hun: "Ny\xe1r 2020 D\xedsz\xedt\u0151 T\xe1ska",
        swe: "Sommar 2020-kosmetikv\xe4ska",
        rom: "Cutie cu accesorii Summer 2020"
    },
    86: {
        img: "wicked_windfall_case",
        eng: "Wicked Windfall Case",
        rus: "\u041A\u0435\u0439\u0441 \u043F\u043E\u0434\u043B\u043E\u0439 \u043F\u0430\u0434\u0430\u043B\u0438\u0446\u044B",
        pol: "Pojemnik paskudnej jesieni",
        fre: "Caisse Wicked Windfall",
        sch: "\u98DE\u6765\u6A2A\u7978\u77F3\u5323",
        bra: "Caixa da Heran\xe7a Sinistra",
        hun: "Sz\xf6rny\u0171 Szerencse T\xe1ska",
        swe: "Giftig fallfrukt-l\xe5da",
        rom: "Cutie Wicked Windfall"
    },
    87: {
        img: "scream_fortress_xii_war_paint_case",
        eng: "Scream Fortress XII War Paint Case",
        rus: '\u041A\u0435\u0439\u0441 \u0441 \u0431\u043E\u0435\u0432\u043E\u0439 \u043A\u0440\u0430\u0441\u043A\u043E\u0439 "\u0412\u0438\u0438\u0438\u0437\u0433 \u0424\u043E\u0440\u0442\u0440\u0435\u0441\u0441 XII"',
        pol: "Pojemnik barw wojennych Scream Fortress XII",
        fre: "Caisse de peintures Scream Fortress XII",
        sch: "\u5C16\u53EB\u8981\u585E XII \u6218\u7ED8\u7BB1",
        bra: "Caixa de Tintas de Guerra do Scream Fortress XII",
        hun: "Scream Fortress XII Harci Fest\xe9s T\xe1ska",
        swe: "Scream Fortress XII-krigsf\xe4rgv\xe4ska",
        rom: "Cutie cu vopsea de r\u0103zboi Scream Fortress XII"
    },
    88: {
        img: "winter_2020_cosmetic_case",
        eng: "Winter 2020 Cosmetic Case",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 2020",
        pol: "Zimowy pojemnik ozd\xf3b 2020",
        bra: "Caixa de Cosm\xe9ticos de Fim de Ano de 2020",
        fre: "Caisse de cosm\xe9tiques d'hiver 2020",
        hun: "T\xe9l 2020 D\xedsz\xedt\u0151 T\xe1ska",
        swe: "Vinter 2020-kosmetikv\xe4ska",
        rom: "Cutie cu accesorii Winter 2020"
    },
    89: {
        img: "winter_2020_war_paint_case",
        eng: "Winter 2020 War Paint Case",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0431\u043E\u0435\u0432\u043E\u0439 \u043A\u0440\u0430\u0441\u043A\u043E\u0439 2020",
        pol: "Zimowy pojemnik barw wojennych 2020",
        bra: "Caixa de Tintas de Guerra de Fim de Ano de 2020",
        fre: "Caisse de peintures d'hiver 2020",
        hun: "T\xe9l 2020 Harci Fest\xe9s T\xe1ska",
        swe: "Vinter 2020-krigsf\xe4rgv\xe4ska",
        rom: "Cutie cu vopsea de r\u0103zboi Winter 2020"
    },
    90: {
        img: "summer_2021_cosmetic_case",
        eng: "Summer 2021 Cosmetic Case",
        rus: "\u041B\u0435\u0442\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 2021",
        pol: "Letni pojemnik ozd\xf3b 2021",
        fre: "Caisse de cosm\xe9tiques d'\xe9t\xe9 2021",
        sch: "2021 \u590F\u5B63\u9970\u54C1\u7BB1",
        bra: "Caixa de Cosm\xe9ticos das F\xe9rias de 2021",
        hun: "Ny\xe1r 2021 D\xedsz\xedt\u0151 T\xe1ska",
        swe: "Sommar 2021-kosmetikv\xe4ska",
        rom: "Cutie cu accesorii Summer 2021"
    },
    91: {
        img: "crimson_cache_case",
        eng: "Crimson Cache Case",
        rus: "\u041A\u0435\u0439\u0441 \u043A\u0440\u0430\u0441\u043D\u043E\u0439 \u043A\u043B\u0430\u0434\u0435\u0437\u0438",
        pol: "Pojemnik szkar\u0142atnej skrytki",
        hun: "Karmazsin K\xe9szlet T\xe1ska",
        swe: "Crimson Cache-v\xe4ska",
        bra: "Caixa da Lembran\xe7a Carmesim",
        fre: "Caisse du magot cramoisi",
        rom: "Cutie Crimson Cache"
    },
    92: {
        img: "scream_fortress_xiii_war_paint_case",
        eng: "Scream Fortress XIII War Paint Case",
        rus: '\u041A\u0435\u0439\u0441 \u0441 \u0431\u043E\u0435\u0432\u043E\u0439 \u043A\u0440\u0430\u0441\u043A\u043E\u0439 "\u0412\u0438\u0438\u0438\u0437\u0433 \u0424\u043E\u0440\u0442\u0440\u0435\u0441\u0441 XIII"',
        pol: "Pojemnik barw wojennych Scream Fortress XIII",
        hun: "Scream Fortress XIII Harci Fest\xe9s T\xe1ska",
        swe: "Scream Fortress XIII-krigsf\xe4rgv\xe4ska",
        bra: "Caixa de Tintas de Guerra do Scream Fortress XIII",
        fre: "Caisse de peintures Scream Fortress XIII",
        rom: "Cutie cu vopsea de r\u0103zboi Scream Fortress XIII",
        sch: "\u5C16\u53EB\u8981\u585E XIII \u6218\u7ED8\u7BB1"
    },
    93: {
        img: "winter_2021_cosmetic_case",
        eng: "Winter 2021 Cosmetic Case",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 2021",
        pol: "Zimowy pojemnik ozd\xf3b 2021",
        bra: "Caixa de Cosm\xe9ticos de Fim de Ano de 2021",
        hun: "T\xe9l 2021 D\xedsz\xedt\u0151 T\xe1ska",
        fre: "Caisse de cosm\xe9tiques d'hiver 2021",
        rom: "Cutie cu accesorii Winter 2021",
        swe: "Vinter 2021-kosmetikv\xe4ska"
    },
    94: {
        img: "summer_2022_cosmetic_case",
        eng: "Summer 2022 Cosmetic Case",
        rus: "\u041B\u0435\u0442\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 2022",
        pol: "Letni pojemnik ozd\xf3b 2022",
        bra: "Caixa de Cosm\xe9ticos das F\xe9rias de 2022",
        hun: "Ny\xe1r 2022 D\xedsz\xedt\u0151 T\xe1ska",
        fre: "Caisse de cosm\xe9tiques d'\xe9t\xe9 2022",
        rom: "Cutie cu accesorii Summer 2022",
        sch: "2022 \u590F\u5B63\u9970\u54C1\u7BB1",
        swe: "Sommar 2022-kosmetikv\xe4ska"
    },
    95: {
        img: "ghoulish_gains_case",
        eng: "Ghoulish Gains Case",
        rus: "\u041A\u0435\u0439\u0441 \u043F\u0440\u0438\u0437\u0440\u0430\u0447\u043D\u044B\u0445 \u043F\u0440\u0438\u0437\u043E\u0432",
        pol: "Pojemnik upiornych zdobyczy",
        bra: "Caixa do Ghoul",
        fre: "Caisse du butin des goules",
        hun: "H\xe1tborzongat\xf3 Haszon T\xe1ska",
        rom: "Cutie Ghoulish Gains",
        swe: "Ghoulish Gains-v\xe4ska",
        sch: "\u90AA\u79FD\u8D43\u6C61\u77F3\u5323"
    },
    96: {
        img: "scream_fortress_xiv_war_paint_case",
        eng: "Scream Fortress XIV War Paint Case",
        rus: '\u041A\u0435\u0439\u0441 \u0441 \u0431\u043E\u0435\u0432\u043E\u0439 \u043A\u0440\u0430\u0441\u043A\u043E\u0439 "\u0412\u0438\u0438\u0438\u0437\u0433 \u0424\u043E\u0440\u0442\u0440\u0435\u0441\u0441 XIV"',
        pol: "Pojemnik barw wojennych Scream Fortress XIV",
        bra: "Caixa de Tintas de Guerra do Scream Fortress XIV",
        fre: "Caisse de peintures Scream Fortress XIV",
        hun: "Scream Fortress XIV Harci Fest\xe9s T\xe1ska",
        rom: "Cutie cu vopsea de r\u0103zboi Scream Fortress XIV",
        swe: "Scream Fortress XIV-krigsf\xe4rgv\xe4ska",
        sch: "\u5C16\u53EB\u8981\u585E XIV \u6218\u7ED8\u7BB1"
    },
    97: {
        img: "winter_2022_cosmetic_case",
        eng: "Winter 2022 Cosmetic Case",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 2022",
        pol: "Zimowy pojemnik ozd\xf3b 2022",
        bra: "Caixa de Cosm\xe9ticos de Fim de Ano de 2022",
        fre: "Caisse de cosm\xe9tiques d'hiver 2022",
        hun: "T\xe9l 2022 D\xedsz\xedt\u0151 T\xe1ska",
        rom: "Cutie cu accesorii Winter 2022",
        swe: "Vinter 2022-kosmetikv\xe4ska",
        sch: "2022 \u51AC\u5B63\u9970\u54C1\u7BB1"
    },
    98: {
        img: "summer_2023_cosmetic_case",
        eng: "Summer 2023 Cosmetic Case",
        rus: "\u041B\u0435\u0442\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 2023",
        pol: "Letni pojemnik ozd\xf3b 2023",
        bra: "Caixa de Cosm\xe9ticos das F\xe9rias de 2023",
        fre: "Caisse de cosm\xe9tiques d'\xe9t\xe9 2023",
        hun: "Ny\xe1r 2023 D\xedsz\xedt\u0151 T\xe1ska",
        rom: "Cutie cu accesorii Summer 2023",
        sch: "2023 \u590F\u5B63\u9970\u54C1\u7BB1",
        swe: "Sommar 2023-kosmetikv\xe4ska"
    },
    99: {
        img: "summer_2023_war_paint_case",
        eng: "Summer 2023 War Paint Case",
        rus: "\u041B\u0435\u0442\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0431\u043E\u0435\u0432\u043E\u0439 \u043A\u0440\u0430\u0441\u043A\u043E\u0439 2023",
        pol: "Letni pojemnik barw wojennych 2023",
        bra: "Caixa de Tintas de Guerra das F\xe9rias de 2023",
        fre: "Caisse de peintures d'\xe9t\xe9 2023",
        hun: "Ny\xe1r 2023 Harci Fest\xe9s T\xe1ska",
        rom: "Cutie cu vopsea de r\u0103zboi Summer 2023",
        swe: "Sommar 2023-krigsf\xe4rgv\xe4ska",
        sch: "2023 \u590F\u5B63\u6218\u7ED8\u7BB1"
    },
    100: {
        img: "bone_chilling_bonanza_case",
        eng: "Bone-Chilling Bonanza Case",
        rus: "\u041A\u0435\u0439\u0441 \u0431\u0435\u0448\u0435\u043D\u044B\u0445 \u0431\u043E\u0433\u0430\u0442\u0441\u0442\u0432",
        pol: "Pojemnik mro\u017C\u0105cej krew bonanzy",
        bra: "Caixa da B\xean\xe7\xe3o Sinistra",
        fre: "Caisse du Magot macabre",
        hun: "Borzongat\xf3 Bonanza T\xe1ska",
        rom: "Cutie Bone-Chilling Bonanza",
        swe: "Bone-Chilling Bonanza-v\xe4ska",
        sch: "\u523A\u9AA8\u66B4\u5BCC\u77F3\u5323"
    },
    101: {
        img: "winter_2023_cosmetic_case",
        eng: "Winter 2023 Cosmetic Case",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 2023",
        pol: "Zimowy pojemnik ozd\xf3b 2023",
        bra: "Caixa de Cosm\xe9ticos de Fim de Ano de 2023",
        fre: "Caisse de cosm\xe9tiques d'hiver 2023",
        hun: "T\xe9l 2023 D\xedsz\xedt\u0151 T\xe1ska",
        rom: "Cutie cu accesorii Winter 2023",
        swe: "Vinter 2023-kosmetikl\xe5da",
        sch: "2023 \u51AC\u5B63\u9970\u54C1\u7BB1"
    },
    102: {
        img: "summer_2024_cosmetic_case",
        eng: "Summer 2024 Cosmetic Case",
        rus: "\u041B\u0435\u0442\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 2024",
        pol: "Letni pojemnik ozd\xf3b 2024",
        sch: "2024 \u590F\u5B63\u9970\u54C1\u7BB1",
        bra: "Caixa de Cosm\xe9ticos das F\xe9rias de 2024",
        fre: "Caisse de cosm\xe9tiques d'\xe9t\xe9 2024",
        hun: "Ny\xe1r 2024 D\xedsz\xedt\u0151 T\xe1ska",
        rom: "Cutie cu accesorii Summer 2024",
        swe: "Sommar 2024-kosmetikl\xe5da"
    },
    103: {
        img: "terrifying_trove_case",
        eng: "Terrifying Trove Case",
        rus: "\u041A\u0435\u0439\u0441 \u0441\u0442\u0440\u0430\u0448\u0430\u0449\u0438\u0445 \u0441\u043E\u043A\u0440\u043E\u0432\u0438\u0449",
        pol: "Pojemnik przera\u017Caj\u0105cych skarb\xf3w",
        sch: "\u6050\u60E7\u5B9D\u5E93\u77F3\u5323",
        bra: "Caixa do Tesouro Terr\xedvel",
        fre: "Caisse du Tr\xe9sor terrifiant",
        hun: "K\xeds\xe9rteties Kincslelet T\xe1ska",
        rom: "Cutie Terrifying Trove",
        swe: "Skr\xe4ckg\xf6mman-v\xe4ska"
    },
    104: {
        img: "scream_fortress_xvi_war_paint_case",
        eng: "Scream Fortress XVI War Paint Case",
        rus: '\u041A\u0435\u0439\u0441 \u0441 \u0431\u043E\u0435\u0432\u043E\u0439 \u043A\u0440\u0430\u0441\u043A\u043E\u0439 "\u0412\u0438\u0438\u0438\u0437\u0433 \u0424\u043E\u0440\u0442\u0440\u0435\u0441\u0441 XVI"',
        pol: "Pojemnik barw wojennych Scream Fortress XVI",
        sch: "\u5C16\u53EB\u8981\u585E XVI \u6218\u7ED8\u7BB1",
        bra: "Caixa de Tintas de Guerra do Scream Fortress XVI",
        fre: "Caisse de peintures Scream Fortress XVI",
        hun: "Scream Fortress XVI Harci Fest\xe9s T\xe1ska",
        rom: "Cutie cu vopsea de r\u0103zboi Scream Fortress XVI",
        swe: "Scream Fortress XVI-krigsf\xe4rgv\xe4ska"
    },
    105: {
        img: "winter_2024_cosmetic_case",
        eng: "Winter 2024 Cosmetic Case",
        pol: "Zimowy pojemnik ozd\xf3b 2024",
        sch: "2024 \u51AC\u5B63\u9970\u54C1\u7BB1",
        bra: "Caixa de Cosm\xe9ticos de Fim de Ano de 2024",
        fre: "Caisse de cosm\xe9tiques d'hiver 2024",
        hun: "T\xe9l 2024 D\xedsz\xedt\u0151 T\xe1ska",
        rom: "Cutie cu accesorii Winter 2024",
        swe: "Vinter 2024-kosmetikv\xe4ska",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 2024"
    },
    106: {
        img: "summer_2025_cosmetic_case",
        eng: "Summer 2025 Cosmetic Case",
        pol: "Letni pojemnik ozd\xf3b 2025",
        sch: "2025 \u590F\u5B63\u9970\u54C1\u7BB1",
        bra: "Caixa de Cosm\xe9ticos das F\xe9rias de 2025",
        fre: "Caisse de cosm\xe9tiques d'\xe9t\xe9 2025",
        hun: "Ny\xe1r 2025 D\xedsz\xedt\u0151 T\xe1ska",
        rom: "Cutie cu accesorii Summer 2025",
        swe: "Sommar 2025-kosmetikv\xe4ska",
        rus: "\u041B\u0435\u0442\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 2025"
    },
    107: {
        img: "spectral_stash_case",
        eng: "Spectral Stash Case",
        pol: "Pojemnik spektralnej skrytki",
        sch: "\u60CA\u9B42\u79D8\u85CF\u77F3\u5323",
        bra: "Caixa do Estoque Espectral",
        fre: "Caisse du Surplus spectral",
        hun: "Spektr\xe1lis Tartal\xe9k T\xe1ska",
        rom: "Cutie Spectral Stash",
        swe: "Sp\xf6kskatt-v\xe4ska",
        rus: '\u041A\u0435\u0439\u0441 "\u0421\u043F\u0435\u043A\u0442\u0440\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0445\u0440\u043E\u043D"'
    },
    108: {
        img: "winter_2025_cosmetic_case",
        eng: "Winter 2025 Cosmetic Case",
        pol: "Zimowy pojemnik ozd\xf3b 2025",
        sch: "2025 \u51AC\u5B63\u9970\u54C1\u7BB1",
        bra: "Caixa de Cosm\xe9ticos de Fim de Ano de 2025",
        fre: "Caisse de cosm\xe9tiques d'hiver 2025",
        hun: "T\xe9l 2025 D\xedsz\xedt\u0151 T\xe1ska",
        rom: "Cutie cu accesorii Winter 2025",
        swe: "Vinter 2025-kosmetikv\xe4ska",
        rus: "\u0417\u0438\u043C\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 2025 \u0433\u043E\u0434\u0430"
    },
    109: {
        img: "summer_2026_cosmetic_case",
        eng: "Summer 2026 Cosmetic Case",
        sch: "2026 \u590F\u5B63\u9970\u54C1\u7BB1",
        hun: "Ny\xe1r 2026 D\xedsz\xedt\u0151 T\xe1ska",
        rom: "Cutie cu accesorii Summer 2026",
        rus: "\u041B\u0435\u0442\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C\u0438 2026 \u0433\u043E\u0434\u0430",
        pol: "Letni pojemnik ozd\xf3b 2026",
        bra: "Caixa de Cosm\xe9ticos das F\xe9rias de 2026",
        fre: "Caisse de cosm\xe9tiques d'\xe9t\xe9 2026",
        swe: "Sommar 2026-kosmetikv\xe4ska"
    },
    110: {
        img: "summer_2026_war_paint_case",
        eng: "Summer 2026 War Paint Case",
        sch: "2026 \u590F\u5B63\u6218\u7ED8\u7BB1",
        hun: "Ny\xe1r 2026 Harci Fest\xe9s T\xe1ska",
        rom: "Cutie cu vopsea de r\u0103zboi Summer 2026",
        rus: "\u041B\u0435\u0442\u043D\u0438\u0439 \u043A\u0435\u0439\u0441 \u0441 \u0431\u043E\u0435\u0432\u043E\u0439 \u043A\u0440\u0430\u0441\u043A\u043E\u0439 2026 \u0433\u043E\u0434\u0430",
        pol: "Letni pojemnik barw wojennych 2026",
        bra: "Caixa de Tintas de Guerra das F\xe9rias de 2026",
        fre: "Caisse de peintures d'\xe9t\xe9 2026",
        swe: "Sommar 2026-krigsf\xe4rgv\xe4ska"
    },
    111: {
        img: "haunted_hoard_case",
        eng: "Haunted Hoard Case"
    }
};


let $c53c4707280d53b6$export$f0ce432f9ace41f0 = {
    1: {
        img: "burning_flames",
        eng: "Burning Flames",
        rus: "\u042F\u0437\u044B\u0447\u043A\u0438 \u043F\u043B\u0430\u043C\u0435\u043D\u0438",
        schema: 13,
        pol: "pal\u0105ce p\u0142omienie",
        sch: "\u718A\u718A\u70C8\u7130",
        fre: "Flammes br\xfblantes",
        bra: "Chamas ardentes",
        hun: "Lobog\xf3 l\xe1ngok",
        swe: "Brinnande l\xe5gor"
    },
    2: {
        img: "circling_heart",
        eng: "Circling Heart",
        rus: "\u041A\u0440\u0443\u0436\u0430\u0449\u0435\u0435\u0441\u044F \u0441\u0435\u0440\u0434\u0446\u0435",
        schema: 19,
        pol: "wiruj\u0105ce serce",
        sch: "\u65CB\u8F6C\u4E4B\u5FC3",
        fre: "Coeur tournant",
        bra: "Cora\xe7\xe3o circulante",
        hun: "Kering\u0151 sz\xedv",
        swe: "Cirklande hj\xe4rta"
    },
    3: {
        img: "circling_peace_sign",
        eng: "Circling Peace Sign",
        rus: "\u041A\u0440\u0443\u0436\u0430\u0449\u0438\u0439\u0441\u044F \u0437\u043D\u0430\u043A \u043C\u0438\u0440\u0430",
        schema: 18,
        pol: "wiruj\u0105cy znak pokoju",
        sch: "\u65CB\u8F6C\u548C\u5E73\u6807\u5FD7",
        fre: "Symbole Peace tournant",
        bra: "S\xedmbolo de paz circulante",
        hun: "Kering\u0151 b\xe9ke-jel",
        swe: "Cirklande fredstecken"
    },
    4: {
        img: "circling_tf_logo",
        eng: "Circling TF Logo",
        rus: "\u041A\u0440\u0443\u0436\u0430\u0449\u0438\u0439\u0441\u044F \u043B\u043E\u0433\u043E\u0442\u0438\u043F TF",
        schema: 11,
        pol: "wiruj\u0105ce logo TF",
        sch: "\u65CB\u8F6CTF\u5FBD\u6807",
        fre: "Logo TF tournant",
        bra: "Logo do TF circulante",
        hun: "Kering\u0151 TF log\xf3",
        swe: "Cirklande TF-logotyp"
    },
    5: {
        img: "green_confetti",
        eng: "Green Confetti",
        rus: "\u0417\u0435\u043B\u0451\u043D\u043E\u0435 \u043A\u043E\u043D\u0444\u0435\u0442\u0442\u0438",
        schema: 6,
        pol: "zielone konfetti",
        sch: "\u7EFF\u8272\u5F69\u5E26",
        fre: "Confetti verts",
        bra: "Confete verde",
        hun: "Z\xf6ld konfetti",
        swe: "Gr\xf6n konfetti"
    },
    6: {
        img: "green_energy",
        eng: "Green Energy",
        rus: "\u0417\u0435\u043B\u0451\u043D\u043E\u0435 \u0441\u0432\u0435\u0447\u0435\u043D\u0438\u0435",
        schema: 9,
        pol: "zielona energia",
        sch: "\u7EFF\u8272\u80FD\u91CF",
        fre: "\xc9nergie verte",
        bra: "Energia verde",
        hun: "Z\xf6ld energia",
        swe: "Gr\xf6n energi"
    },
    7: {
        img: "haunted_ghosts",
        eng: "Haunted Ghosts",
        rus: "\u041D\u0430\u0437\u043E\u0439\u043B\u0438\u0432\u044B\u0435 \u043F\u0440\u0438\u0432\u0438\u0434\u0435\u043D\u0438\u044F",
        schema: 8,
        pol: "straszliwe duchy",
        sch: "\u7075\u9B42\u9644\u4F53",
        fre: "Fant\xf4mes",
        bra: "Fantasmas assombrados",
        hun: "K\xeds\xe9rt\u0151 szellemek",
        swe: "Hems\xf6kta sp\xf6ken"
    },
    8: {
        img: "massed_flies",
        eng: "Massed Flies",
        rus: "\u0422\u0443\u0447\u0430 \u043C\u0443\u0445",
        schema: 12,
        pol: "chmara much",
        sch: "\u82CD\u8747\u4E91\u96C6",
        fre: "Cort\xe8ge de mouches",
        bra: "Moscas em massa",
        hun: "Legyek",
        swe: "Flugsv\xe4rm"
    },
    9: {
        img: "purple_confetti",
        eng: "Purple Confetti",
        rus: "\u041F\u0443\u0440\u043F\u0443\u0440\u043D\u043E\u0435 \u043A\u043E\u043D\u0444\u0435\u0442\u0442\u0438",
        schema: 7,
        pol: "fioletowe konfetti",
        sch: "\u7D2B\u8272\u5F69\u5E26",
        fre: "Confetti violets",
        bra: "Confete roxo",
        hun: "Lila konfetti",
        swe: "Lila konfetti"
    },
    10: {
        img: "purple_energy",
        eng: "Purple Energy",
        rus: "\u041F\u0443\u0440\u043F\u0443\u0440\u043D\u043E\u0435 \u0441\u0432\u0435\u0447\u0435\u043D\u0438\u0435",
        schema: 10,
        pol: "fioletowa energia",
        sch: "\u7D2B\u8272\u80FD\u91CF",
        fre: "\xc9nergie violette",
        bra: "Energia roxa",
        hun: "Lila energia",
        swe: "Lila energi"
    },
    11: {
        img: "scorching_flames",
        eng: "Scorching Flames",
        rus: "\u041E\u043F\u0430\u043B\u044F\u044E\u0449\u0435\u0435 \u043F\u043B\u0430\u043C\u044F",
        schema: 14,
        pol: "piek\u0105ce p\u0142omienie",
        sch: "\u7089\u706B\u7EAF\u9752",
        fre: "Flammes \xe9corcheuses",
        bra: "Chamas escaldantes",
        hun: "Perzsel\u0151 l\xe1ngok",
        swe: "Br\xe4nnheta l\xe5gor"
    },
    12: {
        img: "searing_plasma",
        eng: "Searing Plasma",
        rus: "\u0412\u044B\u0436\u0438\u0433\u0430\u044E\u0449\u0430\u044F \u043F\u043B\u0430\u0437\u043C\u0430",
        schema: 15,
        pol: "pal\u0105ca plazma",
        sch: "\u5267\u70C8\u79BB\u5B50\u4F53",
        fre: "Plasma br\xfblant",
        bra: "Plasma escaldante",
        hun: "\xc9get\u0151 plazma",
        swe: "Gl\xf6dande plasma"
    },
    13: {
        img: "sunbeams",
        eng: "Sunbeams",
        rus: "\u0421\u043E\u043B\u043D\u0435\u0447\u043D\u044B\u0435 \u043B\u0443\u0447\u0438",
        schema: 17,
        pol: "promienie S\u0142o\u0144ca",
        sch: "\u592A\u9633\u4E4B\u5149",
        fre: "Rayons de soleil",
        bra: "Raios de sol",
        hun: "Napsugarak",
        swe: "Solstr\xe5lar"
    },
    14: {
        img: "vivid_plasma",
        eng: "Vivid Plasma",
        rus: "\u042F\u0440\u043A\u0430\u044F \u043F\u043B\u0430\u0437\u043C\u0430",
        schema: 16,
        pol: "\u017Cywa plazma",
        sch: "\u6D3B\u6CFC\u79BB\u5B50\u4F53",
        fre: "Plasma \xe9clatant",
        bra: "Plasma v\xedvido",
        hun: "\xc9l\xe9nk plazma",
        rom: "Plasm\u0103 Str\u0103lucitoare",
        swe: "Intensiv plasma"
    },
    15: {
        img: "72",
        eng: "'72",
        rus: "72-\u0439",
        schema: 3004,
        pol: "1972",
        sch: "\u70AB\u76EE\u821E\u4F1A",
        fre: "'72",
        bra: "1972"
    },
    16: {
        img: "fountain_of_delight",
        eng: "Fountain of Delight",
        rus: "\u0424\u043E\u043D\u0442\u0430\u043D \u0436\u0435\u043B\u0430\u043D\u0438\u0439",
        schema: 3005,
        pol: "fontanna rozkoszy",
        sch: "\u5FEB\u4E50\u4E4B\u6E90",
        fre: "Fontaine des D\xe9lices",
        bra: "Fonte do deleite",
        hun: "\xc9lvezet sz\xf6k\u0151k\xfatja",
        swe: "Gl\xe4djefont\xe4n"
    },
    17: {
        img: "holy_grail",
        eng: "Holy Grail",
        rus: "\u0421\u0432\u044F\u0442\u043E\u0439 \u0413\u0440\u0430\u0430\u043B\u044C",
        schema: 3003,
        pol: "\u015Awi\u0119ty Graal",
        sch: "\u5723\u676F\u4E4B\u5149",
        fre: "Saint Graal",
        bra: "Santo Graal",
        hun: "Szent Gr\xe1l",
        rom: "Sf\xe2ntul Graal",
        swe: "Helig graal"
    },
    18: {
        img: "mega_strike",
        eng: "Mega Strike",
        rus: "\u041C\u0435\u0433\u0430-\u0443\u0434\u0430\u0440",
        schema: 3010,
        pol: "megapiorun",
        sch: "\u8D85\u7EA7\u95EA\u7535",
        fre: "Frappe foudroyante",
        bra: "Mega golpe",
        hun: "Mega csap\xe1s",
        swe: "Megaslag"
    },
    19: {
        img: "midnight_whirlwind",
        eng: "Midnight Whirlwind",
        rus: "\u041F\u043E\u043B\u0443\u043D\u043E\u0447\u043D\u044B\u0439 \u0443\u0440\u0430\u0433\u0430\u043D",
        schema: 3008,
        pol: "p\xf3\u0142nocne tornado",
        sch: "\u5348\u591C\u98CE\u66B4",
        fre: "Tornade de minuit",
        bra: "Redemoinho da meia-noite",
        hun: "\xc9jf\xe9li forg\xf3sz\xe9l",
        swe: "Midnattsvirvelvind"
    },
    20: {
        img: "screaming_tiger",
        eng: "Screaming Tiger",
        rus: "\u0420\u0435\u0432\u0443\u0449\u0438\u0439 \u0442\u0438\u0433\u0440",
        schema: 3006,
        pol: "rycz\u0105cy tygrys",
        sch: "\u706B\u7403\u73AF\u7ED5",
        fre: "Tigre hurlant",
        bra: "Tigre rugidor",
        hun: "\xdcv\xf6lt\u0151 tigris",
        swe: "Skrikande Tigern"
    },
    21: {
        img: "showstopper",
        eng: "Showstopper",
        rus: "\u0413\u0432\u043E\u0437\u0434\u044C \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B",
        schema: 3001,
        pol: "fajerwerki",
        sch: "\u70DF\u82B1\u8868\u6F14",
        fre: "Clou du spectacle",
        bra: "Fim de show",
        hun: "\xdcnnepront\xf3",
        swe: "Showstoppare"
    },
    22: {
        img: "silver_cyclone",
        eng: "Silver Cyclone",
        rus: "\u0421\u0435\u0440\u0435\u0431\u0440\u0438\u0441\u0442\u044B\u0439 \u0446\u0438\u043A\u043B\u043E\u043D",
        schema: 3009,
        pol: "srebrny cyklon",
        sch: "\u767D\u94F6\u65CB\u98CE",
        fre: "Tornade d'argent",
        bra: "Ciclone prateado",
        hun: "Ez\xfcst ciklon",
        swe: "Silvercyklon"
    },
    23: {
        img: "skill_gotten_gains",
        eng: "Skill Gotten Gains",
        rus: "\u041D\u0435\u0447\u0435\u0441\u0442\u043D\u043E\u0435 \u043C\u0430\u0441\u0442\u0435\u0440\u0441\u0442\u0432\u043E",
        schema: 3007,
        pol: "umiej\u0119tnie wycwaniona forsa",
        sch: "\u571F\u8C6A\u5149\u73AF",
        fre: "Biens bien acquis",
        bra: "Dinheiro sujo",
        hun: "\xdcgyesnek \xe1ll a vil\xe1g",
        swe: "Erfaret f\xf6rtj\xe4nta pengar"
    },
    24: {
        img: "isotope",
        eng: "Isotope",
        rus: "\u0418\u0437\u043E\u0442\u043E\u043F",
        schema: 702,
        pol: "izotop",
        sch: "\u7EFF\u8272\u8F90\u5C04",
        fre: "Isotope",
        bra: "Is\xf3topo",
        hun: "Izot\xf3p",
        swe: "Isotop"
    },
    25: {
        img: "hot",
        eng: "Hot",
        rus: "\u0416\u0430\u0440",
        schema: 701,
        pol: "\u017Car",
        sch: "\u70BD\u70ED\u53D1\u70DF",
        fre: "Chaud",
        bra: "Quente",
        hun: "Forr\xf3s\xe1g",
        swe: "Varm"
    },
    26: {
        img: "cool",
        eng: "Cool",
        rus: "\u0425\u043E\u043B\u043E\u0434",
        schema: 703,
        pol: "ch\u0142\xf3d",
        sch: "\u51B7\u82E5\u51B0\u971C",
        fre: "Frais",
        bra: "Frio",
        hun: "H\u0171v\xf6ss\xe9g",
        swe: "Kall"
    },
    27: {
        img: "energy_orb",
        eng: "Energy Orb",
        rus: "\u042D\u043D\u0435\u0440\u0433\u0435\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0448\u0430\u0440",
        schema: 704,
        pol: "kula energii",
        sch: "\u80FD\u91CF\u5149\u675F",
        fre: "Orbe d'\xe9nergie",
        bra: "Orbe de energia",
        hun: "Energiag\xf6mb",
        swe: "Energiklot"
    },
    28: {
        img: "blizzardy_storm",
        eng: "Blizzardy Storm",
        rus: "\u041C\u043E\u0440\u043E\u0437\u043D\u0430\u044F \u043C\u0435\u0442\u0435\u043B\u044C",
        schema: 30,
        pol: "\u015Bnie\u017Cna zamie\u0107",
        sch: "\u66B4\u96EA\u4E91",
        fre: "Temp\xeate et Blizzard",
        bra: "Tempestade de neve",
        hun: "H\xf3vihar",
        swe: "Sn\xf6ig Storm"
    },
    29: {
        img: "bubbling",
        eng: "Bubbling",
        rus: "\u041F\u0443\u0437\u044B\u0440\u044C\u043A\u0438",
        schema: 34,
        pol: "b\u0105belki",
        sch: "\u6CA4\u6D6E\u6CE1\u5F71",
        fre: "Bullant",
        bra: "Borbulhando",
        hun: "Bubor\xe9kok",
        swe: "Bubblande"
    },
    30: {
        img: "nuts_n_bolts",
        eng: "Nuts n' Bolts",
        rus: "\u0411\u043E\u043B\u0442\u0438\u043A\u0438 \u0438 \u0433\u0430\u0439\u043A\u0438",
        schema: 31,
        pol: "\u015Brubki i nakr\u0119tki",
        sch: "\u87BA\u6813\u548C\u87BA\u6BCD",
        fre: "\xc9crous & Boulons",
        bra: "Porcas e parafusos",
        hun: "Any\xe1k \xe9s csavarok",
        swe: "Muttrar \xe5 skruvar"
    },
    31: {
        img: "orbiting_fire",
        eng: "Orbiting Fire",
        rus: "\u041E\u0433\u043D\u0435\u043D\u043D\u044B\u0439 \u0448\u0430\u0440",
        schema: 33,
        pol: "b\u0142\u0119dny ognik",
        sch: "\u706B\u7130\u7F20\u7ED5",
        fre: "Flamme en Orbite",
        bra: "Fogo orbitante",
        hun: "Kering\u0151 t\u0171zcs\xf3va",
        swe: "Kretsande eld"
    },
    32: {
        img: "orbiting_planets",
        eng: "Orbiting Planets",
        rus: "\u041F\u043B\u0430\u043D\u0435\u0442\u0430\u0440\u043D\u0430\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u0430",
        schema: 32,
        pol: "uk\u0142ad planetarny",
        sch: "\u884C\u661F\u73AF\u7ED5",
        fre: "Plan\xe8tes en Orbite",
        bra: "Planetas orbitantes",
        hun: "Kering\u0151 bolyg\xf3k",
        swe: "Kretsande planeter"
    },
    33: {
        img: "smoking",
        eng: "Smoking",
        rus: "\u0414\u044B\u043C\u043E\u043A",
        schema: 35,
        pol: "dym",
        sch: "\u4E4C\u70DF\u7634\u6C14",
        fre: "Fum\xe9e",
        bra: "Fumante",
        hun: "F\xfcst\xf6lg\xe9s",
        swe: "Rykande"
    },
    34: {
        img: "steaming",
        eng: "Steaming",
        rus: "\u0421\u0442\u0440\u0443\u044F \u043F\u0430\u0440\u0430",
        schema: 36,
        pol: "para",
        sch: "\u84B8\u6C7D\u817E\u817E",
        fre: "Vapeur",
        bra: "Soltando vapor",
        hun: "G\u0151z\xf6lg\xe9s",
        swe: "\xc5ngande"
    },
    35: {
        img: "stormy_storm",
        eng: "Stormy Storm",
        rus: "\u0413\u0440\u043E\u0437\u043D\u0430\u044F \u0433\u0440\u043E\u0437\u0430",
        schema: 29,
        pol: "burzliwa burza",
        sch: "\u66B4\u96E8\u4E91",
        fre: "Temp\xeate et \xc9clairs",
        bra: "Tempestade tempestuosa",
        hun: "Z\xe1por-zivatar",
        swe: "Stormig Storm"
    },
    36: {
        img: "cauldron_bubbles",
        eng: "Cauldron Bubbles",
        rus: "\u042F\u0434\u043E\u0432\u0438\u0442\u044B\u0435 \u043F\u0430\u0440\u044B",
        schema: 39,
        pol: "b\u0105belki z kocio\u0142ka",
        sch: "\u9B54\u57DA\u6C14\u6CE1",
        fre: "Bulles de Chaudron",
        bra: "Bolhas de caldeir\xe3o",
        hun: "Bugybor\xe9kol\xf3 \xfcst",
        swe: "Kittelbubblor"
    },
    37: {
        img: "cloudy_moon",
        eng: "Cloudy Moon",
        rus: "\u041C\u0440\u0430\u0447\u043D\u0430\u044F \u043B\u0443\u043D\u0430",
        schema: 38,
        pol: "zachmurzony ksi\u0119\u017Cyc",
        sch: "\u4E4C\u4E91\u76D6\u6708",
        fre: "Lune voil\xe9e",
        bra: "Lua nublada",
        hun: "Felh\u0151s hold",
        swe: "Molnig m\xe5ne"
    },
    38: {
        img: "eerie_orbiting_fire",
        eng: "Eerie Orbiting Fire",
        rus: "\u0416\u0443\u0442\u043A\u0438\u0439 \u043E\u0433\u043D\u0435\u043D\u043D\u044B\u0439 \u0448\u0430\u0440",
        schema: 40,
        pol: "straszliwy b\u0142\u0119dny ognik",
        sch: "\u5996\u5A06\u7075\u7130",
        fre: "Sinistre flamme en orbite",
        bra: "Fogo assustador orbitante",
        hun: "H\xe1tborzongat\xf3 kering\u0151 t\u0171z",
        swe: "Kuslig kretsande eld"
    },
    39: {
        img: "flaming_lantern",
        eng: "Flaming Lantern",
        rus: "\u0413\u043E\u0440\u044F\u0449\u0438\u0439 \u0444\u043E\u043D\u0430\u0440\u044C",
        schema: 37,
        pol: "p\u0142on\u0105ca latarnia",
        sch: "\u706B\u7130\u5357\u74DC",
        fre: "Lanterne enflamm\xe9e",
        bra: "Lanterna flamejante",
        hun: "L\xe1ngol\xf3 l\xe1mp\xe1s",
        swe: "Flammande lykta"
    },
    40: {
        img: "harvest_moon",
        eng: "Harvest Moon",
        rus: "\u041B\u0443\u043D\u0430 \u0436\u0430\u0442\u0432\u044B",
        schema: 45,
        pol: "urodzajny ksi\u0119\u017Cyc",
        sch: "\u7267\u573A\u7269\u8BED",
        fre: "Lune des moissons",
        bra: "Lua de colheita",
        hun: "Holdt\xf6lte",
        swe: "Sk\xf6rdem\xe5ne"
    },
    41: {
        img: "its_a_secret_to_everybody",
        eng: "It's a Secret to Everybody",
        rus: "\u0412\u0435\u043B\u0438\u043A\u0430\u044F \u0442\u0430\u0439\u043D\u0430",
        schema: 46,
        pol: "dla wszystkich jest to sekretem",
        sch: "\u6F5C\u5F71\u9AB7\u9AC5",
        fre: "C'est un secret pour tout le monde",
        bra: "\xc9 um segredo para todos",
        hun: "Senki sem tud r\xf3la",
        swe: "Det \xe4r en hemlighet f\xf6r alla"
    },
    42: {
        img: "knifestorm",
        eng: "Knifestorm",
        rus: "\u041D\u043E\u0436\u0435\u0432\u043E\u0439 \u0448\u0442\u043E\u0440\u043C",
        schema: 43,
        pol: "ostra ulewa",
        sch: "\u5200\u5149\u5251\u5F71",
        fre: "Couteaunnerre",
        bra: "Tempestade de facas",
        hun: "K\xe9svihar",
        swe: "Knivstorm"
    },
    43: {
        img: "misty_skull",
        eng: "Misty Skull",
        rus: "\u0422\u0443\u043C\u0430\u043D\u043D\u044B\u0439 \u0447\u0435\u0440\u0435\u043F",
        schema: 44,
        pol: "tajemnicza czaszka",
        sch: "\u8FF7\u96FE\u9AB7\u9AC5",
        fre: "Cr\xe2ne mystique",
        bra: "Caveira nebulosa",
        hun: "K\xf6d\xf6s koponya",
        swe: "Dimmig d\xf6dskalle"
    },
    44: {
        img: "stormy_13th_hour",
        eng: "Stormy 13th Hour",
        rus: "\u0414\u043E\u0436\u0434\u043B\u0438\u0432\u044B\u0439 13-\u0439 \u0447\u0430\u0441",
        schema: 47,
        pol: "trzynasta burzliwa godzina",
        sch: "\u8BC5\u5492\u98CE\u66B4",
        fre: "Orage de la 13\u1D49 heure",
        bra: "D\xe9cima terceira hora tempestuosa",
        hun: "Viharos 13. \xf3ra",
        swe: "Den stormiga 13:e timmen"
    },
    45: {
        img: "anti_freeze",
        eng: "Anti-Freeze",
        rus: "\u0410\u043D\u0442\u0438\u0444\u0440\u0438\u0437",
        schema: 69,
        pol: "p\u0142yn ch\u0142odz\u0105cy",
        sch: "\u51B0\u971C\u4E4B\u62B5",
        fre: "Antigel",
        bra: "Anticongelante",
        hun: "Fagy\xe1ll\xf3",
        swe: "Antifrys"
    },
    46: {
        img: "electrostatic",
        eng: "Electrostatic",
        rus: "\u0421\u0442\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u044D\u043B\u0435\u043A\u0442\u0440\u0438\u0447\u0435\u0441\u0442\u0432\u043E",
        schema: 67,
        pol: "elektrostatyczno\u015B\u0107",
        sch: "\u9759\u7535\u706B\u82B1",
        fre: "\xc9lectrostatique",
        bra: "Eletrost\xe1tico",
        hun: "Elektrosztatikus",
        swe: "Elektrostatisk"
    },
    47: {
        img: "green_black_hole",
        eng: "Green Black Hole",
        rus: "\u0427\u0435\u0440\u043D\u043E-\u0437\u0435\u043B\u0435\u043D\u0430\u044F \u0434\u044B\u0440\u0430",
        schema: 71,
        pol: "zielona czarna dziura",
        sch: "\u7EFF\u8272\u9ED1\u6D1E",
        fre: "Trou noir vert",
        bra: "Buraco negro verde",
        hun: "Z\xf6ld fekete lyuk",
        swe: "Gr\xf6nt svart h\xe5l"
    },
    48: {
        img: "memory_leak",
        eng: "Memory Leak",
        rus: "\u0423\u0442\u0435\u0447\u043A\u0430 \u043F\u0430\u043C\u044F\u0442\u0438",
        schema: 65,
        pol: "wyciek pami\u0119ci",
        sch: "\u5185\u5B58\u6EA2\u51FA",
        fre: "Fuite m\xe9moire",
        bra: "Vazamento de mem\xf3ria",
        hun: "Mem\xf3riasziv\xe1rg\xe1s",
        rom: "Scurgere de memorie",
        swe: "Minnesl\xe4cka"
    },
    49: {
        img: "overclocked",
        eng: "Overclocked",
        rus: "\u0420\u0430\u0437\u043E\u0433\u043D\u0430\u043D\u043D\u044B\u0439 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0440",
        schema: 66,
        pol: "podkr\u0119cenie",
        sch: "\u8D85\u9891\u8FC7\u5EA6",
        fre: "Overclock\xe9",
        bra: "Overclock",
        hun: "Tuningolt",
        swe: "\xd6verklockad"
    },
    50: {
        img: "phosphorous",
        eng: "Phosphorous",
        rus: "\u0424\u043E\u0441\u0444\u043E\u0440\u0438\u0441\u0442\u044B\u0439",
        schema: 63,
        pol: "fosfor",
        sch: "\u78F7\u706B",
        fre: "Phosphorescent",
        bra: "Fosforoso",
        hun: "Foszforos",
        swe: "Fosforhaltigt"
    },
    51: {
        img: "power_surge",
        eng: "Power Surge",
        rus: "\u0421\u043A\u0430\u0447\u043E\u043A \u043D\u0430\u043F\u0440\u044F\u0436\u0435\u043D\u0438\u044F",
        schema: 68,
        pol: "przepi\u0119cie",
        sch: "\u7535\u5F27\u653E\u5C04",
        fre: "Surtension",
        bra: "Surto de energia",
        hun: "T\xfalfesz\xfclts\xe9g",
        swe: "Energiv\xe5g"
    },
    52: {
        img: "roboactive",
        eng: "Roboactive",
        rus: "\u0420\u043E\u0431\u043E\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0439 \u044D\u043B\u0435\u043C\u0435\u043D\u0442",
        schema: 72,
        pol: "roboaktywno\u015B\u0107",
        sch: "\u673A\u60C5\u7D2B\u9732",
        fre: "Roboactif",
        bra: "Roboativo",
        hun: "Roboakt\xedv",
        swe: "Roboaktiv"
    },
    53: {
        img: "sulphurous",
        eng: "Sulphurous",
        rus: "\u0421\u0435\u0440\u043D\u0438\u0441\u0442\u044B\u0439",
        schema: 64,
        pol: "siarka",
        sch: "\u786B\u706B",
        fre: "Sulfureux",
        bra: "Sulfuroso",
        hun: "K\xe9nes",
        rom: "Sulfuros",
        swe: "Svavelaktig"
    },
    54: {
        img: "time_warp",
        eng: "Time Warp",
        rus: "\u0412\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0439 \u0440\u0430\u0437\u043B\u043E\u043C",
        schema: 70,
        pol: "zakrzywienie czasu",
        sch: "\u65F6\u95F4\u626D\u66F2",
        fre: "Distorsion temporelle",
        bra: "Viagem no tempo",
        hun: "Id\u0151hurok",
        swe: "Tidsf\xf6rvr\xe4ngning"
    },
    55: {
        img: "aces_high",
        eng: "Aces High",
        rus: "\u041A\u043E\u0437\u044B\u0440\u043D\u044B\u0435 \u0442\u0443\u0437\u044B",
        schema: 59,
        pol: "asy pik",
        sch: "\u5934\u724C\u9AD8\u60AC",
        fre: "As des As",
        bra: "\xc1s de espadas",
        hun: "Magas \xe1sz",
        swe: "Flygande \xe4ss"
    },
    56: {
        img: "cloud_9",
        eng: "Cloud 9",
        rus: "\u0421\u0435\u0434\u044C\u043C\u043E\u0435 \u043D\u0435\u0431\u043E",
        schema: 58,
        pol: "niczym w niebie",
        sch: "\u9B54\u5FC3\u8FDE\u73AF",
        fre: "Sur un petit nuage",
        bra: "Nuvem 9",
        hun: "Sz\xedvfelh\u0151",
        swe: "Moln 9"
    },
    57: {
        img: "dead_presidents",
        eng: "Dead Presidents",
        rus: "\u041C\u0435\u0440\u0442\u0432\u044B\u0435 \u043F\u0440\u0435\u0437\u0438\u0434\u0435\u043D\u0442\u044B",
        schema: 60,
        pol: "du\u017Cy nomina\u0142",
        sch: "\u603B\u7EDF\u4E4B\u6B87",
        fre: "Pr\xe9sidents morts",
        bra: "Verdinhas",
        hun: "Halott eln\xf6k\xf6k",
        swe: "D\xf6da presidenter"
    },
    58: {
        img: "disco_beat_down",
        eng: "Disco Beat Down",
        rus: "\u0420\u0438\u0442\u043C\u044B \u0434\u0438\u0441\u043A\u043E",
        schema: 62,
        pol: "w b\u0142ysku disco",
        sch: "\u75AF\u72C2\u8FEA\u65AF\u79D1",
        fre: "Fi\xe8vre du Disco",
        bra: "Estouro bacana",
        hun: "Diszk\xf3l\xe1z",
        swe: "Discokv\xe4ll"
    },
    59: {
        img: "kill_a_watt",
        eng: "Kill-a-Watt",
        rus: "\u0423\u0431\u0438-\u0432\u0430\u0442\u0442",
        schema: 56,
        pol: "gigawat",
        sch: "\u91D1\u8272\u7535\u6D41",
        fre: "Wattueur",
        bra: "Eletromatador",
        hun: "Kil\u0151watt",
        swe: "D\xf6d-a-Watt"
    },
    60: {
        img: "miami_nights",
        eng: "Miami Nights",
        rus: "\u041D\u043E\u0447\u043D\u043E\u0439 \u041C\u0430\u0439\u0430\u043C\u0438",
        schema: 61,
        pol: "noce Miami",
        sch: "\u8FC8\u963F\u5BC6\u4E4B\u591C",
        fre: "Miami Nights",
        bra: "Noites de Miami",
        hun: "Miami \xe9jszak\xe1k",
        swe: "Miamin\xe4tter"
    },
    61: {
        img: "terror_watt",
        eng: "Terror-Watt",
        rus: "\u0416\u0443\u0442\u043A\u043E-\u0432\u0430\u0442\u0442",
        schema: 57,
        pol: "megawat",
        sch: "\u9752\u8272\u7535\u6D41",
        fre: "Terreur-Watt",
        bra: "Eleterrorficado",
        hun: "Terrorwatt"
    },
    62: {
        img: "arcana",
        eng: "Arcana",
        rus: "\u0417\u0430\u0433\u0430\u0434\u043A\u0438",
        schema: 73,
        pol: "arkana",
        sch: "\u5965\u79D8\u4E4B\u9AD3",
        fre: "Arcane",
        bra: "Arcano",
        hun: "Titokzatos",
        swe: "Arkanisk"
    },
    63: {
        img: "chiroptera_venenata",
        eng: "Chiroptera Venenata",
        rus: "\u042F\u0434\u043E\u0432\u0438\u0442\u0443\u0441 \u0440\u0443\u043A\u043E\u043A\u0440\u044B\u043B\u0443\u0441",
        schema: 75,
        pol: "chiroptera venenata",
        sch: "\u5E7D\u51A5\u4E4B\u706B",
        fre: "Chiroptera Venenata",
        bra: "Chiroptera venenata",
        ger: "Giftige Fledermaus"
    },
    64: {
        img: "darkblaze",
        eng: "Darkblaze",
        rus: "\u0422\u0435\u043C\u043D\u043E\u0435 \u043F\u043B\u0430\u043C\u044F",
        schema: 79,
        pol: "ciemny p\u0142omie\u0144",
        sch: "\u9ED1\u6697\u5927\u706B",
        fre: "Flammes mal\xe9fiques",
        bra: "Labareda sombria",
        hun: "S\xf6t\xe9t l\xe1ng",
        swe: "M\xf6rk Eld"
    },
    65: {
        img: "demonflame",
        eng: "Demonflame",
        rus: "\u0414\u0435\u043C\u043E\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043F\u043B\u0430\u043C\u044F",
        schema: 80,
        pol: "demoniczny p\u0142omie\u0144",
        sch: "\u6076\u9B54\u4E4B\u706B",
        fre: "Flammes d\xe9moniaques",
        bra: "Chama demon\xedaca",
        hun: "D\xe9moni l\xe1ng",
        swe: "Demonflamma"
    },
    66: {
        img: "hellfire",
        eng: "Hellfire",
        rus: "\u0410\u0434\u0441\u043A\u043E\u0435 \u043F\u043B\u0430\u043C\u044F",
        schema: 78,
        pol: "piekielny ogie\u0144",
        sch: "\u5730\u72F1\u4E4B\u7130",
        fre: "Flammes infernales",
        bra: "Fogo infernal",
        hun: "Pokolt\u0171z",
        swe: "Helveteseld"
    },
    67: {
        img: "poisoned_shadows",
        eng: "Poisoned Shadows",
        rus: "\u042F\u0434\u043E\u0432\u0438\u0442\u044B\u0435 \u0442\u0435\u043D\u0438",
        schema: 76,
        pol: "zatrute cienie",
        sch: "\u6BD2\u8548\u4E4B\u5F71",
        fre: "Ombre empoisonn\xe9e",
        bra: "Veneno sombrio",
        hun: "M\xe9rgezett \xe1rnyak",
        swe: "F\xf6rgiftade skuggor"
    },
    68: {
        img: "something_burning_this_way_comes",
        eng: "Something Burning This Way Comes",
        rus: "\u0427\u0442\u043E-\u0442\u043E \u0436\u0433\u0443\u0447\u0435\u0435 \u0433\u0440\u044F\u0434\u0435\u0442",
        schema: 77,
        pol: "jaki\u015B p\u0142omie\u0144 tu nadchodzi",
        sch: "\u70BC\u72F1\u4E4B\u8DEF",
        fre: "Ombre enflamm\xe9e",
        bra: "Arder ou n\xe3o arder",
        hun: "L\xe1ngol\xf3 l\xe9lek k\xf6zeleg",
        swe: "N\xe5got brinnande hit\xe5t r\xe4nner"
    },
    69: {
        img: "spellbound",
        eng: "Spellbound",
        rus: "\u0417\u0430\u043A\u043B\u044F\u0442\u044C\u0435",
        schema: 74,
        pol: "urok",
        sch: "\u6DF7\u4E71\u9B54\u5492",
        fre: "Envoutement",
        bra: "Feiti\xe7o de artif\xedcio",
        hun: "Var\xe1zsos",
        swe: "Trollbunden"
    },
    70: {
        img: "amaranthine",
        eng: "Amaranthine",
        rus: "\u041F\u0443\u0440\u043F\u0443\u0440",
        schema: 82,
        pol: "amarant",
        sch: "\u4E0D\u673D\u4E4B\u7075",
        fre: "Amarante",
        bra: "Amarantino",
        hun: "Amar\xe1nt",
        swe: "Amarantin"
    },
    71: {
        img: "bonzo_the_all_gnawing",
        eng: "Bonzo the All-Gnawing",
        rus: "\u0412\u0441\u0435\u043F\u043E\u0433\u043B\u043E\u0449\u0430\u044E\u0449\u0438\u0439 \u0411\u043E\u043D\u0437\u043E",
        schema: 81,
        pol: "wszechjedz\u0105cy Bonzo",
        sch: "\u5730\u4E0B\u5DE8\u53E3",
        fre: "Bonzo le rongeur de savoir",
        bra: "Bonzo, o atormentador",
        hun: "Bonz\xf3, a Mindentr\xe1g\xf3",
        swe: "Bonzo, den evigt gnagande"
    },
    72: {
        img: "ghastly_ghosts_jr",
        eng: "Ghastly Ghosts Jr",
        rus: "\u041C\u0430\u043B\u044B\u0435 \u0436\u0443\u0442\u043A\u0438\u0435 \u043F\u0440\u0438\u0437\u0440\u0430\u043A\u0438",
        schema: 85,
        pol: "m\u0142odsze upiorne upiory",
        fre: "Horribles fant\xf4mes Jr",
        sch: "\u7D2B\u8272\u5C0F\u9B3C\u9B42",
        bra: "Fantasminhas fantasmag\xf3ricos",
        hun: "Ifj. Szellemes szellemek",
        swe: "Gastande minigastar"
    },
    73: {
        img: "haunted_phantasm_jr",
        eng: "Haunted Phantasm Jr",
        rus: "\u041F\u0440\u043E\u043A\u043B\u044F\u0442\u044B\u0439 \u041F\u0440\u0438\u0437\u0440\u0430\u043A \u043C\u043B.",
        schema: 86,
        pol: "ma\u0142e nawiedzone widziad\u0142o",
        sch: "\u9752\u8272\u5C0F\u9B3C\u9B42",
        fre: "Fant\xf4me hanteur Jr.",
        bra: "Fantasminha assombrado",
        hun: "ifj. K\xeds\xe9rt\u0151 L\xe1tom\xe1s",
        swe: "Lilla hems\xf6kande sp\xf6ket"
    },
    74: {
        img: "stare_from_beyond",
        eng: "Stare From Beyond",
        rus: "\u0412\u0437\u0433\u043B\u044F\u0434 \u0438\u0437 \u0431\u0435\u0437\u0434\u043D\u044B",
        schema: 83,
        pol: "spojrzenie z za\u015Bwiat\xf3w",
        sch: "\u575F\u5893\u4E4B\u773C",
        fre: "Regards de l'au-del\xe0",
        bra: "Olhar do al\xe9m",
        hun: "T\xfalvil\xe1gi tekintet",
        swe: "Blicken fr\xe5n andra sidan"
    },
    75: {
        img: "ooze",
        eng: "Ooze",
        rus: "\u0421\u043B\u0438\u0437\u044C",
        schema: 84,
        pol: "szlam",
        sch: "\u6CE5\u4E2D\u6709\u773C",
        fre: "La Bourbe",
        bra: "O Pantanoso",
        hun: "A Ny\xe1lka",
        rom: "The Ooze",
        swe: "Slemmet"
    },
    76: {
        img: "death_at_dusk",
        eng: "Death at Dusk",
        rus: "\u0421\u0443\u043C\u0435\u0440\u0435\u0447\u043D\u0430\u044F \u0441\u043C\u0435\u0440\u0442\u044C",
        schema: 90,
        pol: "\u015Bmier\u0107 o zmroku",
        sch: "\u843D\u65E5",
        fre: "Mort cr\xe9pusculaire",
        bra: "Morte ao anoitecer",
        hun: "Esti elm\xfal\xe1s",
        swe: "Solnedg\xe5ng"
    },
    77: {
        img: "frostbite",
        eng: "Frostbite",
        rus: "\u041C\u043E\u0440\u043E\u0437",
        schema: 87,
        pol: "odmro\u017Cenie",
        sch: "\u5BD2\u971C",
        fre: "Engelure",
        bra: "Congelamento",
        hun: "D\xe9rcs\xedp\xe9s",
        swe: "K\xf6ldskada"
    },
    78: {
        img: "molten_mallard",
        eng: "Molten Mallard",
        rus: "\u041F\u044B\u043B\u0430\u044E\u0449\u0430\u044F \u043F\u0442\u0438\u0446\u0430",
        schema: 88,
        pol: "stopiona kaczka krzy\u017C\xf3wka",
        sch: "\u9E2D\u5B50\u7130\u706B",
        fre: "Canartifice",
        bra: "Gratinado",
        hun: "V\xf6r\xf6sizz\xf3 vadkacsa",
        swe: "Spr\xe4ngd anka"
    },
    79: {
        img: "morning_glory",
        eng: "Morning Glory",
        rus: "\u0414\u043E\u0431\u0440\u043E\u0435 \u0443\u0442\u0440\u043E",
        schema: 89,
        pol: "poranna chwa\u0142a",
        sch: "\u6668\u66E6",
        fre: "Splendeur matinale",
        bra: "Gl\xf3ria da manh\xe3",
        hun: "Reggeli ragyog\xe1s",
        swe: "Soluppg\xe5ng"
    },
    80: {
        img: "abduction",
        eng: "Abduction",
        rus: "\u041F\u043E\u0445\u0438\u0449\u0435\u043D\u0438\u0435",
        schema: 91,
        pol: "porwanie",
        sch: "\u5438\u6536\u5149\u675F",
        fre: "Enl\xe8vement",
        bra: "Abdu\xe7\xe3o",
        hun: "Elrabl\xe1s",
        swe: "Bortf\xf6rande"
    },
    81: {
        img: "atomic",
        eng: "Atomic",
        rus: "\u0410\u0442\u043E\u043C\u043D\u044B\u0439",
        schema: 92,
        pol: "atomy",
        sch: "\u539F\u5B50\u6838",
        fre: "Atomique",
        bra: "At\xf4mico",
        hun: "Atomi",
        swe: "Atomisk"
    },
    82: {
        img: "subatomic",
        eng: "Subatomic",
        rus: "\u0421\u0443\u0431\u0430\u0442\u043E\u043C\u043D\u044B\u0439",
        schema: 93,
        pol: "subatomy",
        sch: "\u4E9A\u539F\u5B50\u7C92\u5B50",
        fre: "Subatomique",
        bra: "Subat\xf4mico",
        hun: "Szubatomi",
        swe: "Subatom\xe4r"
    },
    83: {
        img: "electric_hat_protector",
        eng: "Electric Hat Protector",
        rus: "\u042D\u043B\u0435\u043A\u0442\u0440\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A",
        schema: 94,
        pol: "elektryczna bariera ochronna",
        sch: "\u7535\u5F27\u4FDD\u62A4\u7F69",
        fre: "Protection \xe9lectrique",
        bra: "Protetor el\xe9trico de chap\xe9us",
        hun: "Elektromos sapkav\xe9d\u0151",
        swe: "Elektrisk hattskyddare"
    },
    84: {
        img: "magnetic_hat_protector",
        eng: "Magnetic Hat Protector",
        rus: "\u041C\u0430\u0433\u043D\u0435\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A",
        schema: 95,
        pol: "magnetyczna bariera ochronna",
        sch: "\u78C1\u80FD\u4FDD\u62A4\u7F69",
        fre: "Protection magn\xe9tique",
        bra: "Protetor magn\xe9tico de chap\xe9us",
        hun: "M\xe1gneses sapkav\xe9d\u0151",
        swe: "Magnetisk hattskyddare"
    },
    85: {
        img: "voltaic_hat_protector",
        eng: "Voltaic Hat Protector",
        rus: "\u0413\u0430\u043B\u044C\u0432\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A",
        schema: 96,
        pol: "galwaniczna bariera ochronna",
        sch: "\u9AD8\u538B\u4FDD\u62A4\u7F69",
        fre: "Protection volta\xefque",
        bra: "Protetor voltaico de chap\xe9us",
        hun: "Voltaikus sapkav\xe9d\u0151",
        swe: "Sp\xe4nning-hattskyddare"
    },
    86: {
        img: "galactic_codex",
        eng: "Galactic Codex",
        rus: "\u0413\u0430\u043B\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043A\u043E\u0434\u0435\u043A\u0441",
        schema: 97,
        pol: "kodeks galaktyczny",
        sch: "\u661F\u9645\u5BC6\u7801",
        fre: "Codex galactique",
        bra: "C\xf3dice gal\xe1tico",
        hun: "Galaktikus K\xf3dex",
        swe: "Galaktiskt kodex"
    },
    87: {
        img: "ancient_codex",
        eng: "Ancient Codex",
        rus: "\u0414\u0440\u0435\u0432\u043D\u0438\u0439 \u043A\u043E\u0434\u0435\u043A\u0441",
        schema: 98,
        pol: "kodeks staro\u017Cytnych",
        sch: "\u8FDC\u53E4\u5BC6\u7801",
        fre: "Codex ancien",
        bra: "C\xf3dice ancestral",
        hun: "\u0150si K\xf3dex",
        swe: "Antikt kodex"
    },
    88: {
        img: "nebula",
        eng: "Nebula",
        rus: "\u0422\u0443\u043C\u0430\u043D\u043D\u043E\u0441\u0442\u044C",
        schema: 99,
        pol: "mg\u0142awica",
        sch: "\u661F\u4E91",
        fre: "N\xe9buleuse",
        bra: "N\xe9bula",
        hun: "Csillagk\xf6d",
        ger: "Nebel"
    },
    89: {
        img: "death_by_disco",
        eng: "Death by Disco",
        rus: "\u0421\u043C\u0435\u0440\u0442\u044C \u0432 \u0441\u0442\u0438\u043B\u0435 \u0434\u0438\u0441\u043A\u043E",
        schema: 100,
        pol: "\u015Bmier\u0107 w rytmie disco",
        sch: "\u9AB7\u9AC5\u8E66\u8FEA",
        fre: "Disco de la mort",
        bra: "Requebrando o esqueleto",
        hun: "Diszk\xf3 \xe1ltali hal\xe1l",
        swe: "Dog av Disco"
    },
    90: {
        img: "its_a_mystery_to_everyone",
        eng: "It's a Mystery to Everyone",
        rus: "\u0417\u0430\u0433\u0430\u0434\u043A\u0430 \u0434\u043B\u044F \u0432\u0441\u0435\u0445",
        schema: 101,
        pol: "dla wszystkich jest to tajemnic\u0105",
        sch: "\u7D2B\u8272\u5E7D\u7075",
        fre: "C'est un myst\xe8re pour tout le monde",
        bra: "\xc9 um mist\xe9rio",
        hun: "Rejt\xe9ly mindenki sz\xe1m\xe1ra",
        swe: "Det \xe4r ett mysterium f\xf6r alla"
    },
    91: {
        img: "its_a_puzzle_to_me",
        eng: "It's a puzzle to me",
        rus: "\u042F \u0441\u0430\u043C \u0432 \u0448\u043E\u043A\u0435",
        schema: 102,
        pol: "zagadka dla mnie",
        sch: "\u7EFF\u8272\u5E7D\u7075",
        fre: "C'est une \xe9nigme pour moi",
        bra: "\xc9 uma charada",
        hun: "Rejt\xe9ly sz\xe1momra",
        cze: "It's a puzzle to me ",
        rom: "It's a puzzle to me ",
        swe: "Det \xe4r en g\xe5ta f\xf6r mig"
    },
    92: {
        img: "ether_trail",
        eng: "Ether Trail",
        rus: "\u042D\u0444\u0438\u0440\u043D\u044B\u0439 \u0448\u043B\u0435\u0439\u0444",
        schema: 103,
        pol: "\u015Blad eteru",
        sch: "\u5E7D\u51A5\u4E4B\u75D5",
        fre: "Train\xe9e c\xe9leste",
        bra: "Rastro et\xe9reo",
        hun: "\xc9teri cs\xf3va",
        swe: "Etersp\xe5r"
    },
    93: {
        img: "nether_trail",
        eng: "Nether Trail",
        rus: "\u0411\u0435\u0441\u043F\u043B\u043E\u0442\u043D\u044B\u0439 \u0448\u043B\u0435\u0439\u0444",
        schema: 104,
        pol: "\u015Blad piekie\u0142",
        sch: "\u8BE1\u5F02\u4E4B\u75D5",
        fre: "Train\xe9e infernale",
        bra: "Rastro sombrio",
        hun: "Alvil\xe1gi cs\xf3va",
        swe: "Nedresp\xe5r"
    },
    94: {
        img: "ancient_eldritch",
        eng: "Ancient Eldritch",
        rus: "\u041F\u0435\u0440\u0432\u043E\u0431\u044B\u0442\u043D\u044B\u0439 \u0443\u0436\u0430\u0441",
        schema: 105,
        pol: "prastare dziwactwo",
        sch: "\u8FDC\u53E4\u90AA\u7075",
        fre: "Feu Eldritch",
        bra: "Assombra\xe7\xe3o ancestral",
        hun: "\u0150si r\xe9ms\xe9g",
        swe: "Ur\xe5ldrigt Sp\xf6ke"
    },
    95: {
        img: "eldritch_flame",
        eng: "Eldritch Flame",
        rus: "\u0414\u0443\u0445 \u043F\u043B\u0430\u043C\u0435\u043D\u0438",
        schema: 106,
        pol: "nadprzyrodzony p\u0142omie\u0144",
        sch: "\u90AA\u7075\u4E4B\u7130",
        fre: "Flamme d'Eldritch",
        bra: "Chama ancestral",
        hun: "R\xe9ms\xe9ges l\xe1ng",
        swe: "Sp\xf6keld"
    },
    96: {
        img: "neutron_star",
        eng: "Neutron Star",
        rus: "\u041D\u0435\u0439\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u0437\u0432\u0435\u0437\u0434\u0430",
        schema: 107,
        pol: "gwiazda neutronowa",
        sch: "\u4E2D\u5B50\u661F",
        fre: "\xc9toile \xe0 neutrons",
        bra: "Estrela de n\xeautron",
        hun: "Neutroncsillag",
        swe: "Neutronstj\xe4rna"
    },
    97: {
        img: "starstorm_slumber",
        eng: "Starstorm Slumber",
        rus: "\u0413\u0430\u043B\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0433\u0440\u0435\u0437\u0430",
        schema: 110,
        pol: "gwie\u017Adzisty sen",
        sch: "\u84DD\u8272\u6D41\u661F\u96E8",
        fre: "Sommeil \xe9toil\xe9",
        bra: "Sonol\xeancia estelar",
        hun: "Csillagz\xe1poros szuny\xf3k\xe1l\xe1s",
        swe: "Stj\xe4rnstormslummer"
    },
    98: {
        img: "starstorm_insomnia",
        eng: "Starstorm Insomnia",
        rus: "\u0413\u0430\u043B\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0431\u0435\u0441\u0441\u043E\u043D\u043D\u0438\u0446\u0430",
        schema: 109,
        pol: "gwia\u017Adzista bezsenno\u015B\u0107",
        sch: "\u7EFF\u8272\u6D41\u661F\u96E8",
        fre: "Insomnie \xe9toil\xe9e",
        bra: "Ins\xf4nia estelar",
        hun: "Csillagz\xe1poros \xe1lmatlans\xe1g",
        swe: "Stj\xe4rnstorms\xf6mnl\xf6shet"
    },
    99: {
        img: "tesla_coil",
        eng: "Tesla Coil",
        rus: "\u041A\u0430\u0442\u0443\u0448\u043A\u0430 \u0422\u0435\u0441\u043B\u0430",
        schema: 108,
        pol: "transformator Tesli",
        sch: "\u78C1\u66B4\u7EBF\u5708",
        fre: "Bobine Tesla",
        bra: "Bobina de Tesla",
        hun: "Tesla-tekercs",
        swe: "Teslaspole"
    },
    100: {
        img: "brain_drain",
        eng: "Brain Drain",
        rus: "\u041C\u043E\u0437\u0433\u043E\u0442\u0435\u0447\u043A\u0430",
        schema: 111,
        pol: "drena\u017C m\xf3zgu",
        sch: "\u8111\u6D46\u5916\u6CC4",
        fre: "Fuite des cerveaux",
        bra: "Vaz\xe3o cerebral",
        hun: "Agyszipka",
        swe: "Hj\xe4rnt\xf6mning"
    },
    101: {
        img: "open_mind",
        eng: "Open Mind",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u0440\u0430\u0437\u0443\u043C",
        schema: 112,
        pol: "otwarty umys\u0142",
        sch: "\u8111\u6D1E\u5927\u5F00",
        fre: "Esprit ouvert",
        bra: "Mente aberta",
        hun: "Nyitott elme",
        swe: "\xd6ppet sinne"
    },
    102: {
        img: "head_of_steam",
        eng: "Head of Steam",
        rus: "\u041F\u0430\u0440\u043E\u0432\u0430\u044F \u0433\u043E\u043B\u043E\u0432\u0430",
        schema: 113,
        pol: "paruj\u0105ca g\u0142owa",
        sch: "\u8111\u6D46\u8FF8\u88C2",
        fre: "\xc0 toute vapeur",
        bra: "Cabe\xe7a fervente",
        hun: "G\u0151zbugyor",
        swe: "Huvudv\xe4rk"
    },
    103: {
        img: "galactic_gateway",
        eng: "Galactic Gateway",
        rus: "\u0413\u0430\u043B\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0432\u0440\u0430\u0442\u0430",
        schema: 114,
        pol: "galaktyczne przej\u015Bcie",
        sch: "\u661F\u754C\u4E4B\u95E8",
        fre: "Portail intergalactique",
        bra: "Noite nebulosa",
        hun: "Galaktikus \xe1tj\xe1r\xf3",
        swe: "Galaktisk portal"
    },
    104: {
        img: "the_eldritch_opening",
        eng: "Eldritch Opening",
        rus: "\u0417\u043B\u043E\u0432\u0435\u0449\u0438\u0439 \u043F\u0440\u043E\u0441\u0432\u0435\u0442",
        schema: 115,
        pol: "nadprzyrodzone przej\u015Bcie",
        sch: "\u795E\u79D8\u4E4B\u95E8",
        fre: "Passage funeste",
        bra: "Limiar sobrenatural",
        hun: "A v\xe9rfagyaszt\xf3 nyilad\xe9k",
        rom: "The Eldritch Opening",
        swe: "Kuslig skymning"
    },
    105: {
        img: "the_dark_doorway",
        eng: "Dark Doorway",
        rus: "\u0422\u0451\u043C\u043D\u044B\u0439 \u043F\u0440\u043E\u0445\u043E\u0434",
        schema: 116,
        pol: "mroczne przej\u015Bcie",
        sch: "\u9ED1\u6697\u4E4B\u95E8",
        fre: "Voie lugubre",
        bra: "Port\xe3o da penumbra",
        hun: "A s\xf6t\xe9t kapu",
        rom: "The Dark Doorway",
        swe: "M\xf6rk d\xf6rr\xf6ppning"
    },
    106: {
        img: "ring_of_fire",
        eng: "Ring of Fire",
        rus: "\u041A\u043E\u043B\u044C\u0446\u043E \u043F\u043B\u0430\u043C\u0435\u043D\u0438",
        schema: 117,
        pol: "pier\u015Bcie\u0144 ognia",
        sch: "\u70C8\u7130\u4E4B\u73AF",
        fre: "Anneau de feu",
        bra: "C\xedrculo de fogo",
        hun: "T\u0171zgy\u0171r\u0171",
        swe: "Eldring"
    },
    107: {
        img: "vicious_circle",
        eng: "Vicious Circle",
        rus: "\u041F\u043E\u0440\u043E\u0447\u043D\u044B\u0439 \u043A\u0440\u0443\u0433",
        schema: 118,
        pol: "b\u0142\u0119dne ko\u0142o",
        sch: "\u5815\u843D\u90AA\u73AF",
        fre: "Cercle vicieux",
        bra: "C\xedrculo vicioso",
        hun: "Gonosz k\xf6r",
        swe: "Ond cirkel"
    },
    108: {
        img: "white_lightning",
        eng: "White Lightning",
        rus: "\u0411\u0435\u043B\u0430\u044F \u043C\u043E\u043B\u043D\u0438\u044F",
        schema: 119,
        pol: "bia\u0142a b\u0142yskawica",
        sch: "\u767D\u5149\u4E4B\u73AF",
        fre: "\xc9clair \xe9tincelant",
        bra: "Rel\xe2mpago reluzente",
        hun: "Feh\xe9r f\xe9ny",
        swe: "Vitt ljus"
    },
    109: {
        img: "omniscient_orb",
        eng: "Omniscient Orb",
        rus: "\u0412\u0441\u0435\u0432\u0435\u0434\u0443\u0449\u0438\u0439 \u0448\u0430\u0440",
        schema: 120,
        pol: "kryszta\u0142owa kula",
        sch: "\u5168\u77E5\u4E4B\u7403",
        fre: "Orbe de l'omniscience",
        bra: "Orbe onisciente",
        hun: "Mindentud\xf3 g\xf6mb",
        swe: "Allvetande kula"
    },
    110: {
        img: "clairvoyance",
        eng: "Clairvoyance",
        rus: "\u042F\u0441\u043D\u043E\u0432\u0438\u0434\u0435\u043D\u0438\u0435",
        schema: 121,
        pol: "jasnowidzenie",
        sch: "\u5168\u77E5\u4E4B\u773C",
        fre: "Clairvoyance",
        bra: "Clarivid\xeancia",
        hun: "Harmadik szem",
        swe: "Kl\xe4rvoajans"
    },
    111: {
        img: "fifth_dimension",
        eng: "Fifth Dimension",
        rus: "\u041F\u044F\u0442\u043E\u0435 \u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u0435",
        schema: 122,
        pol: "pi\u0105ty wymiar",
        fre: "Cinqui\xe8me dimension",
        sch: "\u7B2C\u4E94\u7EF4\u5EA6",
        bra: "Quinta dimens\xe3o",
        hun: "\xd6t\xf6dik dimenzi\xf3",
        swe: "Femte dimensionen"
    },
    112: {
        img: "vicious_vortex",
        eng: "Vicious Vortex",
        rus: "\u0412\u0440\u0435\u0434\u043D\u044B\u0439 \u0432\u0438\u0445\u0440\u044C",
        schema: 123,
        pol: "wyst\u0119pny wir",
        fre: "Vortex vicieux",
        sch: "\u90AA\u6076\u6F29\u6DA1",
        bra: "Turbilh\xe3o turbulento",
        hun: "\u0150rj\xedt\u0151 \xf6rv\xe9ny",
        swe: "V\xe5ldsam virvelvind"
    },
    113: {
        img: "menacing_miasma",
        eng: "Menacing Miasma",
        rus: "\u041C\u0438\u0441\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043C\u0438\u0430\u0437\u043C\u044B",
        schema: 124,
        pol: "makabryczny miazmat",
        fre: "Miasme mena\xe7ant",
        sch: "\u6076\u6BD2\u7634\u6C14",
        bra: "Miasma medonho",
        hun: "Komisz kip\xe1rolg\xe1s",
        swe: "Mystisk miasma"
    },
    114: {
        img: "abyssal_aura",
        eng: "Abyssal Aura",
        rus: "\u0410\u0441\u0442\u0440\u0430\u043B\u044C\u043D\u0430\u044F \u0430\u0443\u0440\u0430",
        schema: 125,
        pol: "aura otch\u0142ani",
        fre: "Aura abyssale",
        sch: "\u6DF1\u6E0A\u5149\u73AF",
        bra: "Aura abissal",
        hun: "Alvil\xe1gi aura",
        ger: "Abgrundtiefe Aura"
    },
    115: {
        img: "wicked_wood",
        eng: "Wicked Wood",
        rus: "\u0427\u0443\u0434\u043E\u0432\u0438\u0449\u043D\u0430\u044F \u0447\u0430\u0449\u0430",
        schema: 126,
        pol: "nikczemny las",
        fre: "For\xeat funeste",
        sch: "\u6697\u5F71\u4E4B\u6797",
        bra: "Madeira maligna",
        hun: "Borzaszt\xf3 boz\xf3tos",
        swe: "Sp\xf6kande skog"
    },
    116: {
        img: "ghastly_grove",
        eng: "Ghastly Grove",
        rus: "\u0420\u043E\u043A\u043E\u0432\u0430\u044F \u0440\u043E\u0449\u0430",
        schema: 127,
        pol: "upiorny gaj",
        fre: "Bosquet hant\xe9",
        sch: "\u6050\u6016\u4E4B\u6797",
        bra: "Floresta fantasmag\xf3rica",
        hun: "Lid\xe9rces liget",
        swe: "Dunkel dunge"
    },
    117: {
        img: "mystical_medley",
        eng: "Mystical Medley",
        rus: "\u0417\u0430\u0433\u0430\u0434\u043E\u0447\u043D\u043E\u0435 \u0437\u0430\u0440\u0435\u0432\u043E",
        schema: 128,
        pol: "mistyczna mieszanina",
        fre: "M\xe9lange mystique",
        sch: "\u795E\u79D8\u4E4B\u6D8C",
        bra: "Misto m\xedstico",
        hun: "Misztikus mindenf\xe9le",
        swe: "Mystisk magi"
    },
    118: {
        img: "ethereal_essence",
        eng: "Ethereal Essence",
        rus: "\u0414\u0443\u0445\u043E\u0432\u043D\u0430\u044F \u0434\u044B\u043C\u043A\u0430",
        schema: 129,
        pol: "eteryczna esencja",
        fre: "Essence \xe9th\xe9r\xe9e",
        sch: "\u98D8\u6E3A\u4E4B\u534E",
        bra: "Ess\xeancia et\xe9rea",
        hun: "\xc9teri esszencia",
        swe: "Eterisk essens"
    },
    119: {
        img: "twisted_radiance",
        eng: "Twisted Radiance",
        rus: "\u0421\u043F\u0438\u0440\u0430\u043B\u044C\u043D\u043E\u0435 \u0441\u0438\u044F\u043D\u0438\u0435",
        schema: 130,
        pol: "pokr\u0119tne promieniowanie",
        fre: "Rayonnement rocambolesque",
        sch: "\u626D\u66F2\u4E4B\u8F89",
        bra: "Espiral do resplendor",
        hun: "Ront\xf3 ragyog\xe1s",
        swe: "Str\xe5lande sken"
    },
    120: {
        img: "violet_vortex",
        eng: "Violet Vortex",
        rus: "\u0412\u0438\u043D\u043E\u0433\u0440\u0430\u0434\u043D\u044B\u0439 \u0432\u0438\u0445\u0440\u044C",
        schema: 131,
        pol: "wrzosowy wir",
        fre: "Vortex violet",
        sch: "\u7D2B\u8272\u6F29\u6DA1",
        bra: "V\xf3rtice violeta",
        hun: "Ibolyasz\xedn \xf6rv\xe9ny",
        swe: "Violett virvelvind"
    },
    121: {
        img: "verdant_vortex",
        eng: "Verdant Vortex",
        rus: "\u0412\u0435\u0441\u0435\u043D\u043D\u0438\u0439 \u0432\u0438\u0445\u0440\u044C",
        schema: 132,
        pol: "zielenisty wir",
        fre: "Vortex verdoyant",
        sch: "\u7FE0\u7EFF\u6F29\u6DA1",
        bra: "V\xf3rtice verdejante",
        hun: "Z\xf6ldell\u0151 \xf6rv\xe9ny",
        swe: "Smaragdgr\xf6n storm"
    },
    122: {
        img: "valiant_vortex",
        eng: "Valiant Vortex",
        rus: "\u0412\u043E\u043B\u0435\u0432\u043E\u0439 \u0432\u0438\u0445\u0440\u044C",
        schema: 133,
        pol: "wi\u015Bniowy wir",
        fre: "Vortex vaillant",
        sch: "\u82F1\u52C7\u6F29\u6DA1",
        bra: "V\xf3rtice valoroso",
        hun: "H\u0151sies \xf6rv\xe9ny",
        swe: "Tapper turbulens"
    },
    123: {
        img: "sparkling_lights",
        eng: "Sparkling Lights",
        rus: "\u0421\u0432\u0435\u0440\u043A\u0430\u044E\u0449\u0438\u0435 \u043E\u0433\u043E\u043D\u044C\u043A\u0438",
        schema: 134,
        pol: "migocz\u0105ce \u015Bwiate\u0142ka",
        fre: "Lumi\xe8res \xe9tincelantes",
        sch: "\u6D6E\u6E38\u5F69\u5149",
        bra: "Brilho cintilante",
        hun: "Szipork\xe1z\xf3 f\xe9nyek",
        swe: "Gnistrande ljus"
    },
    124: {
        img: "frozen_icefall",
        eng: "Frozen Icefall",
        rus: "\u041C\u043E\u0440\u043E\u0437\u043D\u044B\u0439 \u043B\u0435\u0434\u043E\u043F\u0430\u0434",
        schema: 135,
        pol: "spadaj\u0105ce sople",
        fre: "Chute de neige",
        sch: "\u51B0\u7011",
        bra: "Cascata congelada",
        hun: "Fagyott j\xe9ges\u0151",
        swe: "Fallande istappar"
    },
    125: {
        img: "fragmented_gluons",
        eng: "Fragmented Gluons",
        rus: "\u0424\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0433\u043B\u044E\u043E\u043D\u044B",
        schema: 136,
        pol: "rozproszone gluony",
        fre: "Gluons fragment\xe9s",
        sch: "\u80F6\u5B50",
        bra: "Gl\xfaons fragmentados",
        hun: "T\xf6redezett gluonok",
        swe: "Fragmenterade gluoner"
    },
    126: {
        img: "fragmented_quarks",
        eng: "Fragmented Quarks",
        rus: "\u0424\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u043A\u0432\u0430\u0440\u043A\u0438",
        schema: 137,
        pol: "rozproszone kwarki",
        fre: "Quarks fragment\xe9s",
        sch: "\u5938\u514B",
        bra: "Quarks fragmentados",
        hun: "T\xf6redezett kvarkok",
        swe: "Fragmenterade kvarkar"
    },
    127: {
        img: "fragmented_photons",
        eng: "Fragmented Photons",
        rus: "\u0424\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0444\u043E\u0442\u043E\u043D\u044B",
        schema: 138,
        pol: "rozproszone fotony",
        fre: "Photons fragment\xe9s",
        sch: "\u5149\u5B50",
        bra: "F\xf3tons fragmentados",
        hun: "T\xf6redezett fotonok",
        swe: "Fragmenterade fotoner"
    },
    128: {
        img: "defragmenting_reality",
        eng: "Defragmenting Reality",
        rus: "\u0414\u0435\u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044F \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438",
        schema: 139,
        pol: "defragmentacja rzeczywisto\u015Bci",
        fre: "R\xe9alit\xe9 d\xe9fragment\xe9e",
        sch: "\u73B0\u5B9E\u91CD\u6784",
        bra: "Desfragmentando a realidade",
        hun: "Val\xf3s\xe1g-t\xf6redezetts\xe9gmentes\xedt\xe9s",
        swe: "Defragmenterar verkligheten"
    },
    129: {
        img: "fragmenting_reality",
        eng: "Fragmenting Reality",
        rus: "\u0424\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044F \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438",
        schema: 141,
        pol: "fragmentacja rzeczywisto\u015Bci",
        fre: "R\xe9alit\xe9 fragment\xe9e",
        sch: "\u73B0\u5B9E\u89E3\u4F53",
        bra: "Fragmentando a realidade",
        hun: "T\xf6redez\u0151 val\xf3s\xe1g",
        swe: "Fragmenterar verkligheten"
    },
    130: {
        img: "refragmenting_reality",
        eng: "Refragmenting Reality",
        rus: "\u041F\u0435\u0440\u0435\u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044F \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438",
        schema: 142,
        pol: "refragmentacja rzeczywisto\u015Bci",
        fre: "R\xe9alit\xe9 r\xe9fragment\xe9e",
        sch: "\u73B0\u5B9E\u91CD\u7EC4",
        bra: "Realidade refragmentada",
        hun: "\xdajrat\xf6redez\u0151 val\xf3s\xe1g",
        swe: "Fragmenterar om verkligheten"
    },
    131: {
        img: "snowfalled",
        eng: "Snowfallen",
        rus: "\u041F\u0430\u0434\u0430\u044E\u0449\u0438\u0439 \u0441\u043D\u0435\u0433",
        schema: 143,
        pol: "spadaj\u0105cy \u015Bnieg",
        fre: "Neige tomb\xe9e",
        sch: "\u96EA\u82B1\u98D8\u843D",
        bra: "Nevasca",
        hun: "Behavazott",
        swe: "Sn\xf6gnistrande"
    },
    132: {
        img: "snowblinded",
        eng: "Snowblinded",
        rus: "\u0421\u043B\u0435\u043F\u044F\u0449\u0438\u0439 \u0441\u043D\u0435\u0433",
        schema: 144,
        pol: "o\u015Blepiaj\u0105cy \u015Bnieg",
        fre: "Aveugl\xe9 par la neige",
        sch: "\u832B\u832B\u5927\u96EA",
        bra: "Cortina de neve",
        hun: "H\xf3vak\xedtott",
        swe: "Sn\xf6bl\xe4ndande"
    },
    133: {
        img: "pyroland_daydream",
        eng: "Pyroland Daydream",
        rus: "\u0413\u0440\u0451\u0437\u0430 \u041F\u0438\u0440\u043E\u043B\u0430\u043D\u0434\u0438\u0438",
        schema: 145,
        pol: "pyrolandowy sen na jawie",
        fre: "R\xeave de Pyroland",
        sch: "\u5E7B\u5883\u8FF7\u68A6",
        bra: "Sonhos da Pyrol\xe2ndia",
        hun: "Pir\xf3f\xf6ldi \xe1lmodoz\xe1s",
        swe: "Dagdr\xf6m i Pyroland"
    },
    134: {
        img: "verdatica",
        eng: "Verdatica",
        rus: "\u0412\u0438\u0440\u0438\u0434\u0438\u0430\u0442\u0438\u043A\u0430",
        schema: 147,
        pol: "werdatyka",
        fre: "Verdatica",
        sch: "\u7EFF\u8272\u6D41\u5149",
        bra: "Verd\xe1tico",
        hun: "Z\xf6ldell\u0151",
        ger: "Verdatisch",
        swe: "Verdatika"
    },
    135: {
        img: "aromatica",
        eng: "Aromatica",
        rus: "\u0410\u0440\u043E\u043C\u0430\u0442\u0438\u043A\u0430",
        schema: 148,
        pol: "aromatyka",
        fre: "Aromatica",
        sch: "\u6A59\u8272\u6D41\u5149",
        bra: "Arom\xe1tico",
        hun: "Arom\xe1s",
        ger: "Aromatisch",
        swe: "Aromatika"
    },
    136: {
        img: "chromatica",
        eng: "Chromatica",
        rus: "\u0425\u0440\u043E\u043C\u0430\u0442\u0438\u043A\u0430",
        schema: 149,
        pol: "chromatyka",
        fre: "Chromatica",
        sch: "\u7D2B\u8272\u6D41\u5149",
        bra: "Crom\xe1tico",
        hun: "Kromatikus",
        ger: "Chromatisch",
        swe: "Kromatisk"
    },
    137: {
        img: "prismatica",
        eng: "Prismatica",
        rus: "\u041F\u0440\u0438\u0437\u043C\u0430\u0442\u0438\u043A\u0430",
        schema: 150,
        pol: "pryzmatyka",
        fre: "Prismatica",
        sch: "\u84DD\u8272\u6D41\u5149",
        bra: "Prism\xe1tico",
        hun: "Prizmatikus",
        ger: "Prismatisch",
        swe: "Prismatisk"
    },
    138: {
        img: "bee_swarm",
        eng: "Bee Swarm",
        rus: "\u0420\u043E\u0439 \u043F\u0447\u0451\u043B",
        schema: 151,
        pol: "pszczeli r\xf3j",
        fre: "Essaim d'abeilles",
        sch: "\u6124\u6012\u8702\u7FA4",
        bra: "Enxame de abelhas",
        hun: "M\xe9hraj",
        swe: "Bisv\xe4rm"
    },
    139: {
        img: "frisky_fireflies",
        eng: "Frisky Fireflies",
        rus: "\u041E\u0437\u043E\u0440\u043D\u044B\u0435 \u0441\u0432\u0435\u0442\u043B\u044F\u0447\u043A\u0438",
        schema: 152,
        pol: "\u015Bwietliste \u015Bwietliki",
        fre: "Lucioles lumineuses",
        sch: "\u6B22\u8DC3\u8424\u706B",
        bra: "Pirilampos pimp\xf5es",
        hun: "J\xe1t\xe9kos szentj\xe1nosbogarak",
        swe: "Eldiga eldflugor"
    },
    140: {
        img: "smoldering_spirits",
        eng: "Smoldering Spirits",
        rus: "\u0422\u043B\u0435\u044E\u0449\u0438\u0435 \u0434\u0443\u0445\u0438",
        schema: 153,
        pol: "zapalone zjawy",
        fre: "Esprits espi\xe8gles",
        sch: "\u9634\u90C1\u4E4B\u7075",
        bra: "Esp\xedritos espirituosos",
        hun: "Par\xe1zsl\xf3 lelkecsk\xe9k",
        ger: "Gl\xfchende Geister",
        swe: "Rykande andar"
    },
    141: {
        img: "wandering_wisps",
        eng: "Wandering Wisps",
        rus: "\u0411\u043B\u0443\u0436\u0434\u0430\u044E\u0449\u0438\u0435 \u043E\u0433\u043E\u043D\u044C\u043A\u0438",
        schema: 154,
        pol: "w\u0119druj\u0105ce ogniki",
        fre: "F\xe9es f\xeatardes",
        sch: "\u6F2B\u6E38\u8424\u706B",
        bra: "Fogo-f\xe1tuo",
        hun: "Libben\u0151 lid\xe9rcek",
        swe: "Irrande irrbloss"
    },
    142: {
        img: "kaleidoscope",
        eng: "Kaleidoscope",
        rus: "\u041A\u0430\u043B\u0435\u0439\u0434\u043E\u0441\u043A\u043E\u043F",
        schema: 155,
        pol: "kalejdoskop",
        fre: "Kal\xe9idoscope",
        sch: "\u4E07\u82B1\u7B52",
        bra: "Caleidosc\xf3pio",
        hun: "Kaleidoszk\xf3p",
        swe: "Kalejdoskop"
    },
    143: {
        img: "green_giggler",
        eng: "Green Giggler",
        rus: "\u0417\u0435\u043B\u0451\u043D\u044B\u0435 \u0437\u0430\u0431\u0430\u0432\u044B",
        schema: 156,
        pol: "zielony zgrywus",
        fre: "Vert de peur",
        sch: "\u61A8\u7B11\u7EFF\u74DC",
        bra: "Verde de alegria",
        hun: "Z\xf6lden kacag\xf3",
        swe: "Gr\xf6nt garv"
    },
    144: {
        img: "laugh_o_lantern",
        eng: "Laugh-O-Lantern",
        rus: "\u0421\u0432\u0435\u0442\u0438\u043B\u044C\u043D\u0438\u043A \u0441\u043C\u0435\u0445\u0430",
        schema: 157,
        pol: "\u015Bmiechobuzie",
        fre: "Rire citrouille",
        sch: "\u72C2\u7B11\u4E4B\u74DC",
        bra: "Ab\xf3boras animadas",
        hun: "R\xf6ty\xf6g\u0151 t\xf6k",
        swe: "Brandgult skratt"
    },
    145: {
        img: "plum_prankster",
        eng: "Plum Prankster",
        rus: "\u041F\u0443\u0440\u043F\u0443\u0440\u043D\u044B\u0439 \u043F\u0440\u043E\u043A\u0430\u0437\u043D\u0438\u043A",
        schema: 158,
        pol: "\u015Bliwkowy \u015Bmieszek",
        fre: "Raillerie violente",
        sch: "\u5632\u7B11\u7D2B\u74DC",
        bra: "Roxo de tanto rir",
        hun: "Lila hahota",
        swe: "Lila flabb"
    },
    146: {
        img: "pyroland_nightmare",
        eng: "Pyroland Nightmare",
        rus: "\u041A\u043E\u0448\u043C\u0430\u0440 \u041F\u0438\u0440\u043E\u043B\u0430\u043D\u0434\u0438\u0438",
        schema: 159,
        pol: "koszmar z Pyrolandu",
        fre: "Cauchemar de Pyroland",
        sch: "\u5E7B\u5883\u68A6\u9B47",
        bra: "Pesadelos da Pyrol\xe2ndia",
        hun: "Pir\xf3f\xf6ldi r\xe9m\xe1lom",
        swe: "Mardr\xf6m fr\xe5n Pyroland"
    },
    147: {
        img: "gravelly_ghoul",
        eng: "Gravelly Ghoul",
        rus: "\u0413\u0440\u0430\u0432\u0438\u0435\u0432\u044B\u0439 \u0433\u0443\u043B\u044C",
        schema: 160,
        pol: "\u017Cwirowy ghul",
        fre: "Goule p\xe9trifi\xe9e",
        sch: "\u5E84\u4E25\u77F3\u50CF\u9B3C",
        bra: "Criatura de cascalho",
        hun: "K\u0151szellem",
        swe: "Grusgast"
    },
    148: {
        img: "vexed_volcanics",
        eng: "Vexed Volcanics",
        rus: "\u0412\u0437\u0431\u0435\u0448\u0451\u043D\u043D\u044B\u0439 \u0432\u0443\u043B\u043A\u0430\u043D\u0438\u0442",
        schema: 161,
        pol: "wkurzaj\u0105cy wulkanit",
        fre: "Goule volcanique",
        sch: "\u7194\u5CA9\u77F3\u50CF\u9B3C",
        bra: "Vulto vulc\xe2nico",
        hun: "Vulkanikus zargat\xf3",
        swe: "Vulkanisk vrede"
    },
    149: {
        img: "gourdian_angel",
        eng: "Gourdian Angel",
        rus: "\u0422\u044B\u043A\u0432\u0430-\u0445\u0440\u0430\u043D\u0438\u0442\u0435\u043B\u044C",
        schema: 162,
        pol: "dynio\u0142 str\xf3\u017C",
        fre: "Citrouille flottante",
        sch: "\u5B88\u62A4\u4E4B\u74DC",
        bra: "Ab\xf3bora angelical",
        hun: "T\xf6kangyal",
        ger: "K\xfcrbisengel",
        swe: "Kalebass\xe4ngel"
    },
    150: {
        img: "pumpkin_party",
        eng: "Pumpkin Party",
        rus: "\u0422\u044B\u043A\u0432\u0435\u043D\u043D\u0430\u044F \u0442\u0443\u0441\u043E\u0432\u043A\u0430",
        schema: 163,
        pol: "dyniowa dom\xf3wka",
        fre: "F\xeate de la citrouille",
        sch: "\u5357\u74DC\u5F00\u4F1A",
        bra: "Festa das ab\xf3boras",
        hun: "T\xf6k j\xf3 buli",
        ger: "K\xfcrbisparty",
        swe: "Pumpaparty"
    },
    151: {
        img: "blighted_snowstorm",
        eng: "Blighted Snowstorm",
        rus: "\u041F\u0440\u043E\u043A\u043B\u044F\u0442\u044B\u0439 \u0431\u0443\u0440\u0430\u043D",
        schema: 170,
        pol: "zniweczona burza \u015Bnie\u017Cna",
        hun: "El\xe1tkozott h\xf3vihar",
        bra: "Nevasca p\xfarpura",
        fre: "Glace fun\xe8bre",
        ger: "Tobender Schneesturm",
        swe: "H\xe4rjande sn\xf6storm"
    },
    152: {
        img: "distant_dream",
        eng: "Distant Dream",
        rus: "\u0414\u0430\u043B\u0451\u043A\u0438\u0435 \u0434\u0440\u0451\u043C\u044B",
        schema: 168,
        pol: "odleg\u0142y sen",
        bra: "Ilus\xe3o distante",
        hun: "\xc1h\xedtatos \xe1br\xe1nd",
        fre: "R\xeave lointain",
        ger: "Ferner Traum",
        swe: "Avl\xe4gsen dr\xf6m"
    },
    153: {
        img: "divine_desire",
        eng: "Divine Desire",
        rus: "\u0412\u0435\u043B\u0438\u043A\u043E\u0435 \u0432\u043B\u0435\u0447\u0435\u043D\u0438\u0435",
        schema: 167,
        pol: "boskie po\u017C\u0105danie",
        bra: "Desejo divino",
        hun: "\xc1h\xedtatos \xe1h\xedtoz\xe1s",
        fre: "D\xe9sir divin",
        ger: "G\xf6ttliches Verlangen",
        swe: "Gudomlig \xf6nskan"
    },
    154: {
        img: "frozen_fractals",
        eng: "Frozen Fractals",
        rus: "\u0421\u0438\u043D\u0438\u0439 \u0441\u043D\u0435\u0433\u043E\u043F\u0430\u0434",
        schema: 164,
        pol: "zamro\u017Cone fraktale",
        bra: "Fractais congelados",
        hun: "Fagyott frakt\xe1lok",
        fre: "Flocons glac\xe9s",
        ger: "Eiskristalle",
        swe: "Frysta fraktaler"
    },
    155: {
        img: "genus_plasmos",
        eng: "Genus Plasmos",
        rus: "\u0413\u0435\u043D\u0443\u0441 \u041F\u043B\u0430\u0437\u043C\u043E\u0441",
        schema: 172,
        pol: "genus plasmos",
        fre: "Origine de la cr\xe9ation"
    },
    156: {
        img: "lavender_landfall",
        eng: "Lavender Landfall",
        rus: "\u041B\u0430\u0432\u0430\u043D\u0434\u043E\u0432\u044B\u0439 \u043B\u0435\u0434\u043E\u043F\u0430\u0434",
        schema: 165,
        pol: "lawendowa lawina",
        bra: "Flocos de lavanda",
        hun: "Levendula lebeg\xe9s",
        fre: "Poudreuse violette",
        ger: "Lavendelfarbener Flockentanz",
        swe: "Lavender lavin"
    },
    157: {
        img: "mirthful_mistletoe",
        eng: "Mirthful Mistletoe",
        rus: "\u041E\u0442\u0440\u0430\u0434\u043D\u0430\u044F \u043E\u043C\u0435\u043B\u0430",
        schema: 175,
        pol: "radosna jemio\u0142a",
        hun: "Felvid\xedt\xf3 fagy\xf6ngy",
        bra: "Visco vistoso",
        fre: "Gui festif",
        ger: "Heiterer Mistelzweig",
        swe: "Munter mistel"
    },
    158: {
        img: "pale_nimbus",
        eng: "Pale Nimbus",
        rus: "\u0411\u043B\u0435\u0434\u043D\u044B\u0439 \u043E\u0440\u0435\u043E\u043B",
        schema: 171,
        pol: "blada chmura",
        hun: "Halv\xe1ny dicsf\xe9ny",
        fre: "Nuage p\xe2le",
        ger: "Graupelschauer",
        swe: "Blek nimbus"
    },
    159: {
        img: "serenus_lumen",
        eng: "Serenus Lumen",
        rus: "\u0421\u0435\u0440\u0435\u043D\u0443\u0441 \u041B\u044E\u043C\u0435\u043D",
        schema: 173,
        pol: "serenus lumen",
        bra: "Serenum lumen",
        fre: "Lumi\xe8re sereine"
    },
    160: {
        img: "special_snowfall",
        eng: "Special Snowfall",
        rus: "\u041C\u0435\u0434\u043E\u0432\u0430\u044F \u043C\u0435\u0442\u0435\u043B\u044C",
        schema: 166,
        pol: "specjalny \u015Bnieg",
        bra: "Flocos especiais",
        hun: "Szokatlan sz\xe1lling\xf3z\xe1s",
        fre: "Neige d'exception",
        ger: "Ungew\xf6hnlicher Schneefall",
        swe: "S\xe4reget sn\xf6fall"
    },
    161: {
        img: "ventum_maris",
        eng: "Ventum Maris",
        rus: "\u0412\u0435\u043D\u0442\u0443\u043C \u041C\u0430\u0440\u0438\u0441",
        schema: 174,
        pol: "ventum maris",
        bra: "Ventus maris",
        fre: "Vents et mar\xe9es"
    },
    162: {
        img: "violent_wintertide",
        eng: "Violent Wintertide",
        rus: "\u0421\u0443\u0440\u043E\u0432\u0430\u044F \u0437\u0438\u043C\u0430",
        schema: 169,
        pol: "gwa\u0142towna fala zimy",
        hun: "Heves h\xf3fergeteg",
        bra: "Vendaval violento",
        fre: "Blizzard",
        ger: "St\xfcrmische Winterzeit",
        swe: "V\xe5ldsam vintertid"
    },
    163: {
        img: "resonation",
        eng: "Resonation",
        rus: "\u0420\u0435\u0437\u043E\u043D\u0430\u043D\u0441",
        schema: 177,
        pol: "rezonowanie",
        bra: "Resson\xe2ncia",
        hun: "Rezonancia",
        fre: "R\xe9sonance",
        swe: "Resonans",
        sch: "\u5171\u9E23\u7535\u5149"
    },
    164: {
        img: "aggradation",
        eng: "Aggradation",
        rus: "\u0410\u0433\u0440\u0430\u0434\u0430\u043D\u0441",
        schema: 178,
        pol: "agradacja",
        bra: "Agrada\xe7\xe3o",
        hun: "Ingerencia",
        swe: "Aggradering",
        sch: "\u9AD8\u80FD\u7535\u5149"
    },
    165: {
        img: "lucidation",
        eng: "Lucidation",
        rus: "\u042F\u0441\u043D\u043E\u043D\u0430\u043D\u0441",
        schema: 179,
        pol: "na\u015Bwietlenie",
        bra: "Elucida\xe7\xe3o",
        hun: "Luminencia",
        fre: "\xc9lucidation",
        swe: "Upplysande",
        sch: "\u660E\u6F88\u7535\u5149"
    },
    166: {
        img: "stunning",
        eng: "Stunning",
        rus: "\u041E\u0433\u043B\u0443\u0448\u0435\u043D\u0438\u0435",
        schema: 180,
        pol: "og\u0142uszenie",
        bra: "Estonteante",
        hun: "K\xe1bulatos",
        fre: "Stellaire",
        swe: "Fantastisk"
    },
    167: {
        img: "ardentum_saturnalis",
        eng: "Ardentum Saturnalis",
        rus: "\u041F\u044B\u043B\u043A\u0443\u0441 \u0421\u0430\u0442\u0443\u0440\u043D\u0430\u043B\u0438\u0441",
        schema: 181,
        sch: "\u7480\u74A8\u661F\u5F26"
    },
    168: {
        img: "fragrancium_elementalis",
        eng: "Fragrancium Elementalis",
        rus: "\u0411\u043B\u0430\u0433\u043E\u0443\u0445\u0430\u0442\u0443\u0441 \u042D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u043B\u0438\u0441",
        schema: 182,
        sch: "\u8FF7\u79BB\u661F\u5F26"
    },
    169: {
        img: "reverium_irregularis",
        eng: "Reverium Irregularis",
        rus: "\u0412\u0440\u0430\u0449\u0430\u0442\u0443\u0441 \u041D\u0435\u043F\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0441",
        schema: 183,
        sch: "\u68A6\u5E7B\u661F\u5F26"
    },
    170: {
        img: "perennial_petals",
        eng: "Perennial Petals",
        rus: "\u0412\u0435\u0447\u043D\u043E\u0435 \u0446\u0432\u0435\u0442\u0435\u043D\u0438\u0435",
        schema: 185,
        pol: "okwiaty",
        bra: "P\xe9talas perenes",
        hun: "\xd6r\xf6ksz\xe9p szirmok",
        fre: "P\xe9tales p\xe9rennes",
        swe: "Fler\xe5riga kronblad",
        sch: "\u82B1\u9999\u5E38\u6F2B"
    },
    171: {
        img: "flavorsome_sunset",
        eng: "Flavorsome Sunset",
        rus: "\u0410\u0440\u043E\u043C\u0430\u0442\u043D\u044B\u0439 \u0437\u0430\u043A\u0430\u0442",
        schema: 186,
        pol: "bogaty zach\xf3d S\u0142o\u0144ca",
        bra: "Ocaso saboroso",
        hun: "\xcdzl\xe9ses naplemente",
        fre: "Coucher de soleil pittoresque",
        swe: "Smakfull solnedg\xe5ng",
        sch: "\u843D\u5E55\u4F59\u6656"
    },
    172: {
        img: "raspberry_bloom",
        eng: "Raspberry Bloom",
        rus: "\u041C\u0430\u043B\u0438\u043D\u043E\u0432\u044B\u0439 \u043E\u0440\u0435\u043E\u043B",
        schema: 187,
        pol: "malinowy rozkwit",
        bra: "Explos\xe3o de framboesa",
        hun: "M\xe1lnavir\xe1g",
        fre: "\xc9closion fruit\xe9e",
        swe: "Hallonblomster",
        sch: "\u534E\u5F69\u7EFD\u653E"
    },
    173: {
        img: "iridescence",
        eng: "Iridescence",
        rus: "\u041F\u0435\u0440\u0435\u043B\u0438\u0432\u0447\u0430\u0442\u043E\u0441\u0442\u044C",
        schema: 188,
        pol: "iryzacja",
        bra: "Iridesc\xeancia",
        hun: "Sz\xednj\xe1tsz\xe1s",
        swe: "Regnb\xe5gsskimmer",
        sch: "\u8679\u5F69\u8426\u7ED5"
    },
    174: {
        img: "tempered_thorns",
        eng: "Tempered Thorns",
        rus: "\u0420\u043E\u043A\u043E\u0432\u044B\u0435 \u0440\u043E\u0433\u0430",
        schema: 189,
        pol: "zahartowane ciernie",
        hun: "Szolid szarvak",
        swe: "H\xe4rdade horn",
        bra: "Chifres temperados",
        fre: "Cornes canon",
        sch: "\u68D8\u523A\u9B54\u89D2"
    },
    175: {
        img: "devilish_diablo",
        eng: "Devilish Diablo",
        rus: "\u0414\u044C\u044F\u0432\u043E\u043B\u044C\u0441\u043A\u0438\u0439 \u0434\u0435\u043C\u043E\u043D",
        schema: 190,
        pol: "diabelski pomiot",
        bra: "Diabo diab\xf3lico",
        hun: "\xd6rd\xf6gi \xf6rd\xf6g",
        swe: "Diabolisk dj\xe4vul",
        fre: "Diable d\xe9moniaque",
        sch: "\u8D64\u708E\u9B54\u89D2"
    },
    176: {
        img: "severed_serration",
        eng: "Severed Serration",
        rus: "\u041E\u0442\u0432\u0440\u0430\u0442\u043D\u044B\u0435 \u043E\u0442\u0440\u043E\u0441\u0442\u043A\u0438",
        schema: 191,
        pol: "wyostrzone zmys\u0142y",
        hun: "Heves hegyess\xe9g",
        swe: "Tjusiga taggar",
        bra: "Sali\xeancia serrilhada",
        fre: "Perches pourpres",
        sch: "\u5E7D\u80FD\u9B54\u89D2"
    },
    177: {
        img: "shrieking_shades",
        eng: "Shrieking Shades",
        rus: "\u0412\u0438\u0437\u0436\u0430\u0449\u0438\u0435 \u0432\u0438\u0434\u0435\u043D\u0438\u044F",
        schema: 192,
        pol: "wrzeszcz\u0105ce cienie",
        hun: "Sikolt\xf3 \xe1rnyak",
        swe: "Gapande gastar",
        bra: "Apari\xe7\xe3o aflita",
        fre: "Cris cr\xe2niens",
        sch: "\u9B3C\u54ED\u72FC\u568E"
    },
    178: {
        img: "restless_wraiths",
        eng: "Restless Wraiths",
        rus: "\u0411\u0435\u0441\u043F\u043E\u043A\u043E\u0439\u043D\u044B\u0435 \u0434\u0443\u0445\u0438",
        schema: 193,
        pol: "niespokojne upiory",
        hun: "Nyugtalan lid\xe9rcek",
        swe: "Osaliga andar",
        bra: "Assombro agitado",
        fre: "Apparitions agit\xe9es",
        sch: "\u60CA\u795E\u6CE3\u9B3C"
    },
    179: {
        img: "infernal_wraith",
        eng: "Infernal Wraith",
        rus: "\u0414\u0443\u0448\u0438 \u0438\u0437 \u043F\u0440\u0435\u0438\u0441\u043F\u043E\u0434\u043D\u0435\u0439",
        schema: 195,
        pol: "piekielne upiory",
        hun: "Pokoli lid\xe9rc",
        swe: "Infernaliska v\xe5lnader",
        bra: "Esp\xedritos infernais",
        fre: "Spectres sulfureux",
        sch: "\u5E7D\u51A5\u9B42\u51A0"
    },
    180: {
        img: "phantom_crown",
        eng: "Phantom Crown",
        rus: "\u0424\u0430\u043D\u0442\u043E\u043C\u043D\u044B\u0439 \u0432\u0435\u043D\u0435\u0446",
        schema: 196,
        pol: "widmowa korona",
        hun: "Fantomkorona",
        swe: "Fantomkrona",
        bra: "Coroa fantasmag\xf3rica",
        fre: "Couronne fantomatique",
        sch: "\u5E7B\u5F71\u9B42\u51A0"
    },
    181: {
        img: "ancient_specter",
        eng: "Ancient Specter",
        rus: "\u0414\u0440\u0435\u0432\u043D\u0438\u0439 \u0434\u0443\u0445",
        schema: 197,
        pol: "staro\u017Cytne widmo",
        hun: "\u0150si jelen\xe9s",
        swe: "Forntida sp\xf6ke",
        bra: "Espectro ancestral",
        fre: "Spectres anciens",
        sch: "\u4E0A\u53E4\u9B42\u51A0"
    },
    182: {
        img: "viridescent_peeper",
        eng: "Viridescent Peeper",
        rus: "\u0417\u0435\u043B\u0435\u043D\u043E\u0432\u0430\u0442\u044B\u0439 \u0437\u043E\u0434\u0447\u0438\u0439",
        schema: 198,
        pol: "zielonkawy podgl\u0105dacz",
        hun: "Z\xf6ld k\xe9mlel\u0151",
        swe: "Kusliga korpgluggar",
        bra: "Vis\xe3o viridescente",
        fre: "Visage verdoyant",
        sch: "\u5992\u610F\u51DD\u89C6"
    },
    183: {
        img: "eyes_of_molten",
        eng: "Eyes of Molten",
        rus: "\u041E\u0433\u043D\u0435\u043D\u043D\u044B\u0439 \u043E\u0431\u0437\u043E\u0440",
        schema: 199,
        pol: "oczy stopionego",
        hun: "Izz\xf3 szemek",
        swe: "Br\xe4nnande blick",
        bra: "Testemunha das chamas",
        fre: "Regard retors",
        sch: "\u707C\u6012\u51DD\u89C6"
    },
    184: {
        img: "ominous_stare",
        eng: "Ominous Stare",
        rus: "\u0413\u0440\u043E\u0437\u043D\u044B\u0435 \u0433\u043B\u0430\u0437\u0430",
        schema: 200,
        pol: "z\u0142owieszcze spojrzenie",
        hun: "Balj\xf3s tekintet",
        swe: "Olycksb\xe5dande blick",
        bra: "Olhar odioso",
        fre: "Pr\xe9sence pesante",
        sch: "\u602A\u8BDE\u51DD\u89C6"
    },
    185: {
        img: "pumpkin_moon",
        eng: "Pumpkin Moon",
        rus: "\u0422\u044B\u043A\u0432\u0435\u043D\u043D\u0430\u044F \u043B\u0443\u043D\u0430",
        schema: 201,
        pol: "dyniowy ksi\u0119\u017Cyc",
        hun: "T\xf6khold",
        swe: "Pumpam\xe5ne",
        bra: "Lua de ab\xf3bora",
        fre: "Lune citrouille",
        sch: "\u74DC\u6708\u5F53\u7A7A"
    },
    186: {
        img: "frantic_spooker",
        eng: "Frantic Spooker",
        rus: "\u041D\u0435\u0438\u0441\u0442\u043E\u0432\u044B\u0439 \u0441\u0442\u0440\u0430\u0448\u0438\u043B\u0430",
        schema: 202,
        pol: "szalony straszak",
        hun: "K\xe9ts\xe9gbeesett k\xeds\xe9rtet",
        swe: "Frenetiskt sp\xf6ke",
        bra: "Camarada ansioso",
        fre: "Fant\xf4me fr\xe9n\xe9tique",
        sch: "\u72C2\u4E71\u602A\u7075"
    },
    187: {
        img: "frightened_poltergeist",
        eng: "Frightened Poltergeist",
        rus: "\u041F\u0443\u0433\u043B\u0438\u0432\u044B\u0439 \u043F\u043E\u043B\u0442\u0435\u0440\u0433\u0435\u0439\u0441\u0442",
        schema: 203,
        pol: "przestraszony duch",
        bra: "Poltergeist p\xe1vido",
        hun: "R\xe9m\xfclt k\xeds\xe9rtet",
        swe: "Skr\xe4md poltergeist",
        fre: "Ectoplasme effray\xe9",
        sch: "\u60CA\u6050\u602A\u7075"
    },
    188: {
        img: "energetic_haunter",
        eng: "Energetic Haunter",
        rus: "\u042D\u043D\u0435\u0440\u0433\u0438\u0447\u043D\u044B\u0439 \u043F\u0440\u0435\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C",
        schema: 204,
        pol: "energetyczna zjawa",
        hun: "Energikus k\xeds\xe9rt\u0151",
        swe: "Energisk gast",
        bra: "Espectro energ\xe9tico",
        fre: "Revenant remuant",
        sch: "\u6B22\u8131\u602A\u7075"
    },
    189: {
        img: "smissmas_tree",
        eng: "Smissmas Tree",
        rus: "\u0428\u043C\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043D\u0441\u043A\u0430\u044F \u0451\u043B\u043A\u0430",
        schema: 205,
        pol: "\u015Bni\u0105teczne drzewko",
        bra: "\xc1rvore de Natal",
        hun: "Gal\xe1csonyfa",
        fre: "Arbre de Smissmas",
        swe: "Smissmas-gran"
    },
    190: {
        img: "hospitable_festivity",
        eng: "Hospitable Festivity",
        rus: "\u0413\u043E\u0441\u0442\u0435\u043F\u0440\u0438\u0438\u043C\u043D\u043E\u0435 \u0442\u043E\u0440\u0436\u0435\u0441\u0442\u0432\u043E",
        schema: 206,
        pol: "w go\u015Bci na \u015Awi\u0119ta",
        bra: "Festividade hospitaleira",
        hun: "Vend\xe9gszeret\u0151 \xfcnnepiess\xe9g",
        fre: "C\xe9l\xe9bration stellaire",
        swe: "Festlig g\xe4stfrihet",
        sch: "\u76DB\u60C5\u6B22\u5E86"
    },
    191: {
        img: "condescending_embrace",
        eng: "Condescending Embrace",
        rus: "\u0421\u043D\u0438\u0441\u0445\u043E\u0434\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043E\u0431\u044A\u044F\u0442\u0438\u0435",
        schema: 207,
        pol: "wzgardliwe obj\u0119cie",
        hun: "Leereszked\u0151 \xf6lel\xe9s",
        bra: "Condescend\xeancia acolhedora",
        fre: "Accolade condescendante",
        swe: "Nedl\xe5tande omfamning",
        sch: "\u50B2\u6162\u6000\u62B1"
    },
    192: {
        img: "sparkling_spruce",
        eng: "Sparkling Spruce",
        rus: "\u0421\u0432\u0435\u0440\u043A\u0430\u044E\u0449\u0430\u044F \u0441\u043E\u0441\u043D\u0430",
        schema: 209,
        pol: "iskrz\u0105cy \u015Bwierk",
        hun: "Szipork\xe1z\xf3 luc",
        bra: "Abeto radiante",
        fre: "\xc9pic\xe9a \xe9tincelant",
        swe: "Glittrande gran",
        sch: "\u7480\u74A8\u4E91\u6749"
    },
    193: {
        img: "glittering_juniper",
        eng: "Glittering Juniper",
        rus: "\u0411\u043B\u0435\u0441\u0442\u044F\u0449\u0438\u0439 \u043C\u043E\u0436\u0436\u0435\u0432\u0435\u043B\u044C\u043D\u0438\u043A",
        schema: 210,
        pol: "l\u015Bni\u0105cy ja\u0142owiec",
        hun: "Csillog\xf3 bor\xf3ka",
        bra: "Jubila\xe7\xe3o jun\xedpera",
        fre: "Gen\xe9vrier scintillant",
        swe: "Glittrande enb\xe4r",
        sch: "\u95EA\u8000\u675C\u677E"
    },
    194: {
        img: "prismatic_pine",
        eng: "Prismatic Pine",
        rus: "\u041F\u0440\u0438\u0437\u043C\u0435\u043D\u043D\u0430\u044F \u043F\u0438\u0445\u0442\u0430",
        schema: 211,
        pol: "pryzmatyczna sosna",
        bra: "Pinheiro prism\xe1tico",
        hun: "Sz\xednj\xe1tsz\xf3 feny\u0151",
        fre: "Pin prismatique",
        swe: "Prismatisk gran",
        sch: "\u4E03\u5F69\u51B7\u6749"
    },
    195: {
        img: "smissmas_swirl",
        eng: "Spiraling Lights",
        rus: "\u0421\u043F\u0438\u0440\u0430\u043B\u044C\u043D\u0430\u044F \u0433\u0438\u0440\u043B\u044F\u043D\u0434\u0430",
        schema: 212,
        pol: "spiralne \u015Bwiate\u0142ka",
        hun: "Forg\xf3 f\xe9nyek",
        swe: "Spiralljus",
        bra: "Espiral cintilante",
        fre: "Tourbillon de lumi\xe8res"
    },
    196: {
        img: "twisting_lights",
        eng: "Twisting Lights",
        rus: "\u0412\u044C\u044E\u0449\u0430\u044F\u0441\u044F \u0433\u0438\u0440\u043B\u044F\u043D\u0434\u0430",
        schema: 213,
        pol: "pokr\u0119cone \u015Bwiate\u0142ka",
        hun: "T\xe1ncol\xf3 f\xe9nyek",
        bra: "Sinuosidade radiante",
        fre: "Guirlande tournante",
        swe: "Snurrande ljusslinga"
    },
    197: {
        img: "stardust_pathway",
        eng: "Stardust Pathway",
        rus: "\u041F\u0443\u0442\u0435\u0432\u043E\u0434\u043D\u0430\u044F \u0437\u0432\u0435\u0437\u0434\u0430",
        schema: 214,
        pol: "gwiezdna \u015Bcie\u017Cka",
        bra: "Estrada estrelada",
        hun: "Csillagpor\xf6sv\xe9ny",
        fre: "Voie \xe9toil\xe9e",
        swe: "Stj\xe4rnv\xe4g"
    },
    198: {
        img: "flurry_rush",
        eng: "Flurry Rush",
        rus: "\u0421\u043D\u0435\u0436\u043D\u044B\u0439 \u0432\u0437\u043B\u0451\u0442",
        schema: 215,
        pol: "\u015Bnie\u017Cna gor\u0105czka",
        hun: "Pelyhes pukkan\xe1s",
        bra: "Estrada adornada",
        fre: "Boule de neige",
        swe: "Sn\xf6yra",
        sch: "\u55B7\u8584\u96EA\u82B1"
    },
    199: {
        img: "spark_of_smissmas",
        eng: "Spark of Smissmas",
        rus: "\u0428\u043C\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043D\u0441\u043A\u0430\u044F \u0438\u0441\u043A\u0440\u0430",
        schema: 216,
        pol: "iskra \u015Ani\u0105t",
        bra: "Chama do Natal",
        hun: "Gal\xe1csonyi szikra",
        fre: "\xc9tincelle de Smissmas",
        swe: "Munter gnista"
    },
    200: {
        img: "polar_forecast",
        eng: "Polar Forecast",
        rus: "\u041F\u043E\u043B\u044F\u0440\u043D\u0430\u044F \u043F\u043E\u0433\u043E\u0434\u0430",
        schema: 218,
        pol: "polarna prognoza",
        bra: "Previs\xe3o polar",
        hun: "Sarkvid\xe9ki el\u0151rejelz\xe9s",
        fre: "M\xe9t\xe9o polaire",
        swe: "Polarprognos"
    },
    201: {
        img: "shining_stag",
        eng: "Shining Stag",
        rus: "\u041E\u0441\u043B\u0435\u043F\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043E\u043B\u0435\u043D\u044C",
        schema: 219,
        pol: "l\u015Bni\u0105cy jele\u0144",
        hun: "Ragyog\xf3 r\xe9nszarvas",
        bra: "Galhada \xe1urea",
        fre: "Cerf scintillant",
        swe: "Gl\xe4nsande hjort"
    },
    202: {
        img: "holiday_horns",
        eng: "Holiday Horns",
        rus: "\u0420\u0430\u0437\u0432\u0435\u0441\u0451\u043B\u044B\u0435 \u0440\u043E\u0433\u0430",
        schema: 220,
        pol: "\u015Bwi\u0105teczne rogi",
        bra: "Galhada galharda",
        hun: "\xdcnnepi szarvak",
        fre: "Cornes festives",
        swe: "Julhorn"
    },
    203: {
        img: "ardent_antlers",
        eng: "Ardent Antlers",
        rus: "\u0420\u043E\u0441\u043A\u043E\u0448\u043D\u044B\u0435 \u0440\u043E\u0433\u0430",
        schema: 221,
        pol: "p\u0142omienne poro\u017Ce",
        hun: "L\xe1ngagancsok",
        bra: "Galhada ardente",
        fre: "Bois brulants",
        swe: "Gl\xf6dande horn"
    },
    204: {
        img: "festive_lights",
        eng: "Festive Lights",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0435 \u043B\u0430\u043C\u043F\u043E\u0447\u043A\u0438",
        schema: 223,
        pol: "\u015Bwi\u0105teczne \u015Bwiate\u0142ka",
        bra: "Luzes festivas",
        hun: "\xdcnnepi f\xe9nyek",
        fre: "Lumi\xe8res festives",
        swe: "Festliga ljus"
    },
    205: {
        img: "crustacean_sensation",
        eng: "Crustacean Sensation",
        rus: "\u041A\u0440\u0430\u0431\u043E\u0432\u044B\u0435 \u043A\u0440\u0430\u0441\u0430\u0432\u0447\u0438\u043A\u0438",
        schema: 224,
        pol: "sensacyjne skorupiaki",
        bra: "Sensa\xe7\xe3o crust\xe1cea",
        hun: "Tengerparti \xe9rz\xe9s",
        fre: "Instant crustac\xe9",
        swe: "Kr\xe4ftskiva",
        sch: "\u87F9\u610F\u6EE1\u9762"
    },
    206: {
        img: "frosted_decadence",
        eng: "Frosted Decadence",
        rus: "\u0413\u043B\u0430\u043C\u0443\u0440\u043D\u0430\u044F \u0433\u043B\u0430\u0437\u0443\u0440\u044C",
        schema: 226,
        pol: "mro\u017Ana dekadencja",
        bra: "Decad\xeancia glac\xea",
        hun: "Deres dekadencia",
        fre: "Gla\xe7age d\xe9cadent",
        swe: "Frostad dekadens",
        sch: "\u971C\u843D\u7EB7\u7EB7"
    },
    207: {
        img: "sprinkled_delights",
        eng: "Sprinkled Delights",
        rus: "\u0412\u043A\u0443\u0441\u043D\u044B\u0439 \u0432\u043E\u0441\u0442\u043E\u0440\u0433",
        schema: 228,
        pol: "posypkowe przysmaki",
        bra: "Prazeres granulados",
        hun: "Sz\xf3rt finoms\xe1g",
        fre: "Sucreries saupoudr\xe9es",
        swe: "Str\xf6sselfr\xf6jd"
    },
    208: {
        img: "terrestrial_favor",
        eng: "Terrestrial Favor",
        rus: "\u0417\u0435\u043C\u043D\u044B\u0435 \u0437\u0430\u0431\u043E\u0442\u044B",
        schema: 229,
        pol: "ziemska \u017Cyczliwo\u015B\u0107",
        bra: "Benevol\xeancia terrestre",
        hun: "F\xf6ldi kegy",
        fre: "Faveur terrestre",
        swe: "Galaktisk gunst",
        sch: "\u4EA4\u7EC7\u4E4B\u5883"
    },
    209: {
        img: "tropical_thrill",
        eng: "Tropical Thrill",
        rus: "\u0422\u0440\u043E\u043F\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0442\u0440\u0435\u043F\u0435\u0442",
        schema: 230,
        pol: "tropikalny dreszcz",
        bra: "Agita\xe7\xe3o tropical",
        hun: "Tr\xf3pusi izgalom",
        fre: "Frisson tropical",
        swe: "Tropisk magi",
        sch: "\u4EA4\u7EC7\u4E4B\u529B"
    },
    210: {
        img: "flourishing_passion",
        eng: "Flourishing Passion",
        rus: "\u0426\u0432\u0435\u0442\u0430\u0441\u0442\u044B\u0435 \u0441\u0442\u0440\u0430\u0441\u0442\u0438",
        schema: 231,
        pol: "kwitn\u0105ca pasja",
        bra: "Paix\xe3o florescente",
        hun: "Vir\xe1gz\xf3 szenved\xe9ly",
        fre: "Passion florissante",
        swe: "Sprakande passion",
        sch: "\u4EA4\u7EC7\u4E4B\u610F"
    },
    211: {
        img: "dazzling_fireworks",
        eng: "Dazzling Fireworks",
        rus: "\u0418\u0441\u043A\u0440\u0438\u0441\u0442\u044B\u0439 \u0444\u0435\u0439\u0435\u0440\u0432\u0435\u0440\u043A",
        schema: 232,
        pol: "ol\u015Bniewaj\u0105ce fajerwerki",
        bra: "Pirotecnia deslumbrante",
        hun: "K\xe1pr\xe1zatos t\u0171zij\xe1t\xe9k",
        fre: "Feux d'artifice \xe9blouissants",
        swe: "Bl\xe4ndande fyrverkerier",
        sch: "\u95EA\u6620\u7206\u7AF9"
    },
    212: {
        img: "blazing_fireworks",
        eng: "Blazing Fireworks",
        rus: "\u041F\u043E\u043B\u044B\u0445\u0430\u044E\u0449\u0438\u0439 \u0444\u0435\u0439\u0435\u0440\u0432\u0435\u0440\u043A",
        schema: 233,
        pol: "ogniste fajerwerki",
        bra: "Pirotecnia ardente",
        hun: "L\xe1ngol\xf3 t\u0171zij\xe1t\xe9k",
        fre: "Feux d'artifice explosifs",
        swe: "Flammande fyrverkerier"
    },
    213: {
        img: "shimmering_fireworks",
        eng: "Shimmering Fireworks",
        rus: "\u0411\u043B\u0438\u0441\u0442\u0430\u044E\u0449\u0438\u0439 \u0444\u0435\u0439\u0435\u0440\u0432\u0435\u0440\u043A",
        schema: 234,
        pol: "l\u015Bni\u0105ce fajerwerki",
        bra: "Pirotecnia lustrosa",
        hun: "Szipork\xe1z\xf3 t\u0171zij\xe1t\xe9k",
        fre: "Feux d'artifice scintillants",
        swe: "Skimrande fyrverkerier",
        sch: "\u95EA\u8000\u7206\u7AF9"
    },
    214: {
        img: "twinkling_fireworks",
        eng: "Twinkling Fireworks",
        rus: "\u041C\u0435\u0440\u0446\u0430\u044E\u0449\u0438\u0439 \u0444\u0435\u0439\u0435\u0440\u0432\u0435\u0440\u043A",
        schema: 235,
        pol: "migocz\u0105ce fajerwerki",
        bra: "Pirotecnia reluzente",
        hun: "Pisl\xe1kol\xf3 t\u0171zij\xe1t\xe9k",
        fre: "Feux d'artifice rutilants",
        swe: "Tindrande fyrverkerier"
    },
    215: {
        img: "sparkling_fireworks",
        eng: "Sparkling Fireworks",
        rus: "\u0421\u0432\u0435\u0440\u043A\u0430\u044E\u0449\u0438\u0439 \u0444\u0435\u0439\u0435\u0440\u0432\u0435\u0440\u043A",
        schema: 236,
        pol: "iskrz\u0105ce fajerwerki",
        bra: "Pirotecnia resplandecente",
        hun: "Szikr\xe1z\xf3 t\u0171zij\xe1t\xe9k",
        fre: "Feux d'artifice \xe9tincelants",
        swe: "Gnistrande fyrverkerier"
    },
    216: {
        img: "glowing_fireworks",
        eng: "Glowing Fireworks",
        rus: "\u0421\u0438\u044F\u044E\u0449\u0438\u0439 \u0444\u0435\u0439\u0435\u0440\u0432\u0435\u0440\u043A",
        schema: 237,
        pol: "jaskrawe fajerwerki",
        bra: "Pirotecnia luminosa",
        hun: "Par\xe1zsl\xf3 t\u0171zij\xe1t\xe9k",
        fre: "Feux d'artifice rayonnants",
        swe: "Gl\xf6dande fyrverkerier"
    },
    217: {
        img: "glimmering_fireworks",
        eng: "Glimmering Fireworks",
        rus: "\u041F\u0435\u0440\u0435\u043B\u0438\u0432\u0447\u0430\u0442\u044B\u0439 \u0444\u0435\u0439\u0435\u0440\u0432\u0435\u0440\u043A",
        schema: 238,
        pol: "b\u0142yszcz\u0105ce fajerwerki",
        bra: "Pirotecnia cintilante",
        hun: "F\xe9nyl\u0151 t\u0171zij\xe1t\xe9k",
        fre: "Feux d'artifice miroitants",
        swe: "Glittrande fyrverkerier",
        sch: "\u95EA\u8272\u7206\u7AF9"
    },
    218: {
        img: "flying_lights",
        eng: "Flying Lights",
        rus: "\u041D\u0435\u0431\u0435\u0441\u043D\u044B\u0435 \u0444\u043E\u043D\u0430\u0440\u0438\u043A\u0438",
        schema: 239,
        pol: "lataj\u0105ce latarnie",
        hun: "Rep\xfcl\u0151 f\xe9nyek",
        bra: "Lanternas voadoras",
        fre: "Lanternes volantes",
        swe: "Sv\xe4vande ljus",
        sch: "\u6620\u798F\u5929\u706F"
    },
    219: {
        img: "limelight",
        eng: "Limelight",
        rus: "\u0417\u0435\u043B\u0451\u043D\u044B\u0435 \u043E\u0433\u043E\u043D\u044C\u043A\u0438",
        schema: 241,
        pol: "limonkowe latarnie",
        bra: "Holofotes",
        hun: "Reflektorf\xe9ny",
        fre: "Lampions citron vert",
        swe: "Rampljus",
        sch: "\u5BD3\u798F\u5929\u706F"
    },
    220: {
        img: "shining_star",
        eng: "Shining Star",
        rus: "\u0421\u0438\u044F\u044E\u0449\u0438\u0435 \u0437\u0432\u0451\u0437\u0434\u043E\u0447\u043A\u0438",
        schema: 242,
        pol: "l\u015Bni\u0105ca gwiazda",
        bra: "Estrela cintilante",
        hun: "Ragyog\xf3 csillag",
        fre: "Lumi\xe8res orange",
        swe: "Gl\xe4nsande stj\xe4rna",
        sch: "\u7948\u798F\u5929\u706F"
    },
    221: {
        img: "cold_cosmos",
        eng: "Cold Cosmos",
        rus: "\u0412\u0435\u0447\u0435\u0440\u043D\u044F\u044F \u0432\u0441\u0435\u043B\u0435\u043D\u043D\u0430\u044F",
        schema: 243,
        pol: "zimny kosmos",
        hun: "Hideg kozmosz",
        bra: "Cosmo g\xe9lido",
        fre: "Cosmos glacial",
        swe: "Kall kosmos",
        sch: "\u5BD2\u66AE\u661F\u8FB0"
    },
    222: {
        img: "refracting_fractals",
        eng: "Refracting Fractals",
        rus: "\u0424\u043B\u0443\u043A\u0442\u0443\u0430\u0446\u0438\u044F \u0444\u0440\u0430\u043A\u0442\u0430\u043B\u043E\u0432",
        schema: 244,
        pol: "fraktalne za\u0142amanie",
        bra: "Fractais refratores",
        hun: "T\xf6redez\u0151 frakt\xe1lok",
        fre: "Fractales r\xe9fractantes",
        swe: "Brytande fraktaler",
        sch: "\u53CC\u5347\u87BA\u65CB"
    },
    223: {
        img: "startrance",
        eng: "Startrance",
        rus: "\u0417\u0432\u0451\u0437\u0434\u043D\u044B\u0439 \u0447\u0430\u0441",
        schema: 245,
        pol: "gwiezdny trans",
        hun: "Csillagtransz",
        bra: "Transe astral",
        fre: "Transe stellaire",
        swe: "Stj\xe4rntrans",
        sch: "\u661F\u5F8B\u6CE2\u7EB9"
    },
    224: {
        img: "starlush",
        eng: "Starlush",
        rus: "\u0417\u0432\u0451\u0437\u0434\u043D\u0430\u044F \u0431\u043E\u043B\u0435\u0437\u043D\u044C",
        schema: 247,
        pol: "gwiezdny gaj",
        hun: "Csillagf\xe9ny",
        bra: "Verdor espacial",
        fre: "Vert luisant",
        swe: "Stj\xe4rngr\xf6nska",
        sch: "\u661F\u8403\u6CE2\u7EB9"
    },
    225: {
        img: "stardust",
        eng: "Stardust",
        rus: "\u0417\u0432\u0451\u0437\u0434\u043D\u0430\u044F \u043F\u044B\u043B\u044C",
        schema: 249,
        pol: "gwiezdny py\u0142",
        hun: "Csillagpor",
        bra: "Poeira c\xf3smica",
        fre: "Poussi\xe8re d'\xe9toile",
        sch: "\u661F\u5C18\u6CE2\u7EB9",
        swe: "Stj\xe4rnstoft"
    },
    226: {
        img: "contagious_eruption",
        eng: "Contagious Eruption",
        rus: "\u0412\u0438\u0440\u0443\u0441\u043D\u043E\u0435 \u0438\u0437\u0432\u0435\u0440\u0436\u0435\u043D\u0438\u0435",
        schema: 250,
        pol: "zara\u017Aliwa erupcja",
        hun: "Fert\u0151z\u0151 kit\xf6r\xe9s",
        bra: "Erup\xe7\xe3o epid\xeamica",
        fre: "\xc9ruption contagieuse",
        swe: "Smittsamt utbrott"
    },
    227: {
        img: "daydream_eruption",
        eng: "Daydream Eruption",
        rus: "\u0412\u043E\u043E\u0431\u0440\u0430\u0436\u0451\u043D\u043D\u043E\u0435 \u0438\u0437\u0432\u0435\u0440\u0436\u0435\u043D\u0438\u0435",
        schema: 251,
        pol: "senna erupcja",
        hun: "\xc1lmodoz\xf3 kit\xf6r\xe9s",
        bra: "Erup\xe7\xe3o estelar",
        fre: "\xc9ruption onirique",
        swe: "Dagdr\xf6msutbrott",
        sch: "\u68A6\u5883\u55B7\u53D1"
    },
    228: {
        img: "volcanic_eruption",
        eng: "Volcanic Eruption",
        rus: "\u0412\u0443\u043B\u043A\u0430\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u0438\u0437\u0432\u0435\u0440\u0436\u0435\u043D\u0438\u0435",
        schema: 252,
        pol: "wulkaniczna erupcja",
        bra: "Erup\xe7\xe3o vulc\xe2nica",
        hun: "Vulk\xe1nkit\xf6r\xe9s",
        fre: "\xc9ruption volcanique",
        swe: "Vulkanutbrott",
        sch: "\u7194\u5CA9\u55B7\u53D1"
    },
    229: {
        img: "divine_sunlight",
        eng: "Divine Sunlight",
        rus: "\u0411\u043E\u0436\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u0441\u0432\u0435\u0442",
        schema: 253,
        pol: "boskie \u015Bwiat\u0142o",
        bra: "Alvorada divina",
        hun: "Isteni napf\xe9ny",
        fre: "Soleil divin",
        swe: "Gudomliga str\xe5lar",
        sch: "\u795E\u5723\u65E5\u5149"
    },
    230: {
        img: "audiophile",
        eng: "Audiophile",
        rus: "\u0410\u0443\u0434\u0438\u043E\u0444\u0438\u043B\u0438\u044F",
        schema: 254,
        pol: "audiofil",
        bra: "Audi\xf3filo",
        hun: "Audiofil",
        swe: "Musik\xe4lskare",
        sch: "\u97F5\u611F\u58F0\u6CE2"
    },
    231: {
        img: "soundwave",
        eng: "Soundwave",
        rus: "\u0417\u0432\u0443\u043A\u043E\u0442\u0435\u0440\u0430\u043F\u0438\u044F",
        schema: 255,
        pol: "fala d\u017Awi\u0119kowa",
        bra: "Onda sonora",
        hun: "Hanghull\xe1m",
        fre: "Fr\xe9quence sonore",
        swe: "Ljudv\xe5g",
        sch: "\u52A8\u611F\u58F0\u6CE2"
    },
    232: {
        img: "synesthesia",
        eng: "Synesthesia",
        rus: "\u0421\u0438\u043D\u0435\u0441\u0442\u0435\u0437\u0438\u044F",
        schema: 256,
        pol: "synestezja",
        bra: "Sinestesia",
        hun: "Szineszt\xe9zia",
        fre: "Synesth\xe9sie",
        swe: "Synestesi",
        sch: "\u52B2\u611F\u58F0\u6CE2"
    },
    233: {
        img: "haunted_kraken",
        eng: "Haunted Kraken",
        rus: "\u041F\u0440\u043E\u043A\u043B\u044F\u0442\u044B\u0439 \u041A\u0440\u0430\u043A\u0435\u043D",
        schema: 257,
        pol: "nawiedzony Kraken",
        bra: "Kraken assombrado",
        fre: "Kraken hant\xe9",
        hun: "Lid\xe9rces kraken",
        swe: "Hems\xf6kt Kraken",
        sch: "\u6D77\u9B54\u89E6\u987B"
    },
    234: {
        img: "eerie_kraken",
        eng: "Eerie Kraken",
        rus: "\u0416\u0443\u0442\u043A\u0438\u0439 \u041A\u0440\u0430\u043A\u0435\u043D",
        schema: 258,
        bra: "Kraken sombrio",
        fre: "Kraken sinistre",
        hun: "Hajmereszt\u0151 kraken",
        pol: "upiorny Kraken",
        swe: "Kusliga Kraken",
        sch: "\u6D77\u5996\u89E6\u987B"
    },
    235: {
        img: "soulful_slice",
        eng: "Soulful Slice",
        rus: "\u041F\u0440\u043E\u043D\u0438\u043A\u043D\u043E\u0432\u0435\u043D\u043D\u044B\u0439 \u043F\u043E\u0440\u0435\u0437",
        schema: 259,
        bra: "Golpe gosmento",
        fre: "Une tranche d'\xe2me",
        hun: "Szellemes fejsze",
        pol: "straszliwa siekiera",
        swe: "Sp\xf6khugg",
        sch: "\u65AD\u9B42\u7075\u65A7"
    },
    236: {
        img: "horsemanns_hack",
        eng: "Horsemann's Hack",
        rus: "\u0412\u043E\u0437\u043C\u0435\u0437\u0434\u0438\u0435 \u0432\u0441\u0430\u0434\u043D\u0438\u043A\u0430",
        schema: 260,
        bra: "Corte certeiro",
        fre: "Coup de hache du cavalier sans t\xeate",
        hun: "A Lovas csap\xe1sa",
        pol: "jatka Je\u017Ad\u017Aca",
        swe: "Horsemannens hugg",
        sch: "\u65A9\u9996\u7075\u65A7"
    },
    237: {
        img: "haunted_forever",
        eng: "Haunted Forever!",
        rus: "\u0412\u0435\u0447\u043D\u043E\u0435 \u043F\u0440\u043E\u043A\u043B\u044F\u0442\u0438\u0435!",
        schema: 261,
        pol: "wieczyste nawiedzenie",
        bra: "Assombrado para sempre!",
        fre: "Hant\xe9 \xe0 vie",
        hun: "\xd6r\xf6kk\xe9 k\xeds\xe9rtett!",
        swe: "Evigt hems\xf6kt!",
        sch: "\u6C38\u52AB\u8BC5\u5492\uFF01"
    },
    238: {
        img: "forever_and_forever",
        eng: "Forever And Forever!",
        rus: "\u041D\u0430 \u0432\u0435\u043A\u0438 \u0432\u0435\u0447\u043D\u044B\u0435!",
        schema: 263,
        pol: "ju\u017C zawsze, na zawsze",
        bra: "Para todo o sempre!",
        fre: "Pour toujours et \xe0 tout jamais !",
        hun: "\xd6r\xf6kk\xf6n \xf6r\xf6kk\xe9!",
        swe: "F\xf6r evigt och f\xf6r alltid!",
        sch: "\u6C38\u6052\u8BC5\u5492\uFF01"
    },
    239: {
        img: "cursed_forever",
        eng: "Cursed Forever!",
        rus: "\u0412\u0435\u0447\u043D\u043E\u0435 \u0437\u0430\u043A\u043B\u044F\u0442\u0438\u0435!",
        schema: 264,
        pol: "permamentne przekle\u0144stwo",
        bra: "Amaldi\xe7oado para sempre!",
        fre: "Maudit pour toujours !",
        hun: "\xd6r\xf6kk\xe9 \xe1tkozott!",
        swe: "Evigt f\xf6rbannad!",
        sch: "\u6C38\u4E16\u8BC5\u5492\uFF01"
    },
    240: {
        img: "moth_plague",
        eng: "Moth Plague",
        rus: "\u041D\u0430\u0448\u0435\u0441\u0442\u0432\u0438\u0435 \u043C\u043E\u0442\u044B\u043B\u044C\u043A\u043E\u0432",
        schema: 265,
        pol: "plaga ciem",
        bra: "Praga de mariposas",
        fre: "Nu\xe9e de papillons de nuit",
        hun: "Molyhad",
        swe: "Malpest",
        sch: "\u86FE\u75AB\u98CE\u6CE2"
    },
    241: {
        img: "malevolent_monoculi",
        eng: "Malevolent Monoculi",
        rus: "\u0413\u0430\u0434\u043A\u0438\u0435 \u0413\u043B\u0430\u0437\u0430\u0441\u0442\u0443\u0441\u044B",
        schema: 266,
        bra: "Monoculi malevolentes",
        fre: "\u0152il mal\xe9fique",
        hun: "Rosszakar\xf3 Monoculusok",
        pol: "mroczne Monoculusy",
        swe: "En\xf6gd ondska",
        sch: "\u773C\u89C2\u516D\u8DEF"
    },
    242: {
        img: "haunted_wick",
        eng: "Haunted Wick",
        rus: "\u041F\u0440\u043E\u043A\u043B\u044F\u0442\u044B\u0439 \u0444\u0438\u0442\u0438\u043B\u044C",
        schema: 267,
        pol: "nawiedzony knot",
        bra: "Pavio assombrado",
        fre: "M\xe8che hant\xe9e",
        hun: "K\xeds\xe9rteties kan\xf3c",
        swe: "Sp\xf6kveke",
        sch: "\u4EA1\u7075\u9B42\u706B"
    },
    243: {
        img: "wicked_wick",
        eng: "Wicked Wick",
        rus: "\u041E\u0434\u0435\u0440\u0436\u0438\u043C\u044B\u0439 \u0444\u0438\u0442\u0438\u043B\u044C",
        schema: 269,
        pol: "nikczemny knot",
        bra: "Pavio perverso",
        fre: "M\xe8che m\xe9chante",
        hun: "Komisz kan\xf3c",
        swe: "Vek veke",
        sch: "\u90AA\u7075\u9B42\u706B"
    },
    244: {
        img: "spectral_wick",
        eng: "Spectral Wick",
        rus: "\u041F\u0440\u0438\u0437\u0440\u0430\u0447\u043D\u044B\u0439 \u0444\u0438\u0442\u0438\u043B\u044C",
        schema: 270,
        pol: "widmowy knot",
        bra: "Pavio espectral",
        fre: "M\xe8che spectrale",
        hun: "Lid\xe9rces kan\xf3c",
        swe: "V\xe5lnadsveke",
        sch: "\u5E7D\u7075\u9B42\u706B"
    },
    245: {
        img: "musical_maelstrom",
        eng: "Musical Maelstrom",
        rus: "\u041A\u0440\u0443\u0436\u0430\u0449\u0430\u044F \u043A\u043E\u043C\u043F\u043E\u0437\u0438\u0446\u0438\u044F",
        schema: 271,
        pol: "muzyczny m\u0119tlik",
        bra: "Turbilh\xe3o musical",
        fre: "Malstr\xf6m musical",
        hun: "Zen\xe9s forgatag",
        swe: "Musikalisk malstr\xf6m",
        sch: "\u97F3\u4E50\u6F29\u6DA1"
    },
    246: {
        img: "verdant_virtuoso",
        eng: "Verdant Virtuoso",
        rus: "\u0412\u0435\u0447\u043D\u043E\u0437\u0435\u043B\u0451\u043D\u044B\u0439 \u0432\u0438\u0440\u0442\u0443\u043E\u0437",
        schema: 272,
        pol: "zielony wirtuoz",
        bra: "Virtuoso verdejante",
        fre: "Virtuose verdoyant",
        hun: "Z\xf6ld virtu\xf3z",
        swe: "Smaragdvirtuos",
        sch: "\u9752\u7EFF\u827A\u5320"
    },
    247: {
        img: "silver_serenade",
        eng: "Silver Serenade",
        rus: "\u0421\u0435\u0440\u0435\u0431\u0440\u044F\u043D\u0430\u044F \u0441\u0435\u0440\u0435\u043D\u0430\u0434\u0430",
        schema: 273,
        pol: "srebrzysta serenada",
        bra: "Serenata prateada",
        fre: "S\xe9r\xe9nade argent\xe9e",
        hun: "Ez\xfcst szeren\xe1d",
        swe: "Silverserenad",
        sch: "\u94F6\u767D\u591C\u66F2"
    },
    248: {
        img: "cosmic_constellations",
        eng: "Cosmic Constellations",
        rus: "\u041A\u043E\u0441\u043C\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0441\u043E\u0437\u0432\u0435\u0437\u0434\u0438\u044F",
        schema: 274,
        pol: "kosmiczne konstelacje",
        bra: "Constela\xe7\xf5es c\xf3smicas",
        fre: "Constellations cosmiques",
        hun: "Kozmikus csillagk\xe9pek",
        swe: "Kosmiska konstellationer",
        sch: "\u5B87\u5B99\u661F\u5EA7"
    },
    249: {
        img: "dazzling_constellations",
        eng: "Dazzling Constellations",
        rus: "\u041E\u0441\u043B\u0435\u043F\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0441\u043E\u0437\u0432\u0435\u0437\u0434\u0438\u044F",
        schema: 276,
        pol: "o\u015Blepiaj\u0105ce konstelacje",
        bra: "Constela\xe7\xf5es deslumbrantes",
        fre: "Constellations \xe9blouissantes",
        hun: "K\xe1pr\xe1zatos csillagk\xe9pek",
        swe: "F\xf6rtrollande konstellationer",
        sch: "\u707F\u70C2\u661F\u56E2"
    },
    250: {
        img: "tainted_frost",
        eng: "Tainted Frost",
        rus: "\u0417\u0430\u043F\u044F\u0442\u043D\u0430\u043D\u043D\u044B\u0439 \u043C\u043E\u0440\u043E\u0437",
        schema: 277,
        pol: "ska\u017Cona szad\u017A",
        bra: "Geada manchada",
        fre: "Flocons sanglants",
        hun: "Piszkos h\xf3",
        swe: "F\xf6rorenad frost",
        sch: "\u8840\u67D3\u5BD2\u971C"
    },
    251: {
        img: "starlight_haze",
        eng: "Starlight Haze",
        rus: "\u0417\u0432\u0451\u0437\u0434\u043D\u044B\u0439 \u0442\u0443\u043C\u0430\u043D",
        schema: 278,
        pol: "gwiezdna mg\u0142awica",
        bra: "Neblina estelar",
        fre: "N\xe9on n\xe9buleux",
        hun: "Csillagf\xe9nyk\xf6d",
        swe: "Stj\xe4rnljusdimma",
        sch: "\u661F\u5149\u8FF7\u96FE"
    },
    252: {
        img: "hard_carry",
        eng: "Hard Carry",
        rus: "\u0422\u044F\u0436\u0451\u043B\u0430\u044F \u043D\u043E\u0448\u0430",
        schema: 279,
        pol: "tajna teczka",
        bra: "Carregador sonhador",
        fre: "Malette mal lun\xe9e",
        hun: "Kem\xe9ny t\xe1ska",
        swe: "Ryggskott",
        sch: "\u786C\u6838\u8FD0\u9001"
    },
    253: {
        img: "jellyfish_field",
        eng: "Jellyfish Field",
        rus: "\u041F\u043E\u043B\u0435 \u043C\u0435\u0434\u0443\u0437",
        schema: 281,
        pol: "mielizna meduz",
        bra: "Campo de \xe1guas-vivas",
        fre: "Champ de m\xe9duses",
        hun: "Med\xfazamez\u0151",
        swe: "Manetf\xe4lt",
        sch: "\u6C34\u6BCD\u79D8\u5883"
    },
    254: {
        img: "jellyfish_hunter",
        eng: "Jellyfish Hunter",
        rus: "\u041E\u0445\u043E\u0442\u043D\u0438\u043A \u043D\u0430 \u043C\u0435\u0434\u0443\u0437",
        schema: 283,
        pol: "\u0142owca meduz",
        bra: "Ca\xe7ador de \xe1guas-vivas",
        fre: "Chasse-m\xe9duses",
        hun: "Med\xfazavad\xe1sz",
        swe: "Manetj\xe4gare",
        sch: "\u6C34\u6BCD\u6355\u624B"
    },
    255: {
        img: "jellyfish_jam",
        eng: "Jellyfish Jam",
        rus: "\u041C\u0435\u043B\u043E\u0434\u0438\u044F \u043C\u0435\u0434\u0443\u0437",
        schema: 284,
        pol: "meduzi melan\u017C",
        bra: "Dan\xe7a das \xe1guas-vivas",
        fre: "Confiture de m\xe9duses",
        hun: "Med\xfazalekv\xe1r",
        swe: "Manetstoj",
        sch: "\u6C34\u6BCD\u679C\u9171"
    },
    256: {
        img: "global_clusters",
        eng: "Global Clusters",
        rus: "\u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u044B\u0435 \u0441\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u044F",
        schema: 285,
        pol: "gromada globalna",
        bra: "Constela\xe7\xe3o",
        fre: "N\xe9buleuse turquoise",
        hun: "Csillagrajok",
        swe: "Klothop",
        sch: "\u7403\u72B6\u661F\u56E2"
    },
    257: {
        img: "celestial_starburst",
        eng: "Celestial Starburst",
        rus: "\u041D\u0435\u0431\u0435\u0441\u043D\u044B\u0435 \u0432\u0441\u043F\u044B\u0448\u043A\u0438",
        schema: 286,
        pol: "wybuch na niebosk\u0142onie",
        bra: "Explos\xe3o estelar",
        fre: "N\xe9buleuse mauve",
        hun: "\xc9gi csillagrobban\xe1s",
        swe: "Himmelsk stj\xe4rnexplosion",
        sch: "\u5929\u57DF\u661F\u7206"
    },
    258: {
        img: "sylicone_succiduous",
        eng: "Sylicone Succiduous",
        rus: "\u041A\u0440\u0435\u043C\u043D\u0438\u0435\u0432\u044B\u0439 \u043A\u0440\u0435\u043D",
        schema: 287,
        pol: "spadaj\u0105cy silikon",
        bra: "Sil\xedcio cadente",
        fre: "N\xe9buleuse navel",
        hun: "Narancs csillaghull\xe1s",
        sch: "\u7845\u534E\u661F\u6D41"
    },
    259: {
        img: "sakura_smoke_bomb",
        eng: "Sakura Smoke Bomb",
        rus: "\u0414\u044B\u043C\u043D\u0430\u044F \u0441\u0430\u043A\u0443\u0440\u0430",
        schema: 288,
        pol: "wi\u015Bniowa bomba dymna",
        bra: "Bomba de cerejeira",
        fre: "Fumig\xe8ne fleuri",
        hun: "Sakura f\xfcstbomba",
        swe: "Blomstrande r\xf6kbomb",
        sch: "\u6A31\u82B1\u70DF\u96FE\u5F39"
    },
    260: {
        img: "treasure_trove",
        eng: "Treasure Trove",
        rus: "\u0421\u044B\u043F\u0443\u0447\u0438\u0435 \u0441\u043E\u043A\u0440\u043E\u0432\u0438\u0449\u0430",
        schema: 289,
        pol: "\u017Cy\u0142a z\u0142ota",
        bra: "Ba\xfa do tesouro",
        fre: "Jackpot",
        hun: "Kincsesb\xe1nya",
        swe: "Guldgruva",
        sch: "\u65E0\u4E3B\u5B9D\u85CF"
    },
    261: {
        img: "bubble_breeze",
        eng: "Bubble Breeze",
        rus: "\u041F\u043E\u043B\u0451\u0442 \u043F\u0443\u0437\u044B\u0440\u044C\u043A\u043E\u0432",
        schema: 290,
        pol: "b\u0105belkowa bryza",
        bra: "Borbulho de bolhas",
        fre: "Bubulles",
        hun: "Bubor\xe9kfuvallat",
        swe: "Bubbelbris",
        sch: "\u6CE1\u5F71\u5FAE\u5C9A"
    },
    262: {
        img: "fireflies",
        eng: "Fireflies",
        rus: "\u0421\u0432\u0435\u0442\u043B\u044F\u0447\u043A\u0438",
        schema: 291,
        pol: "\u015Bwietliki",
        bra: "Vaga-lumes",
        fre: "Lucioles",
        hun: "Szentj\xe1nosbogarak",
        swe: "Eldflugor",
        sch: "\u8424\u706B\u866B"
    },
    263: {
        img: "mountain_halo",
        eng: "Mountain Halo",
        rus: "\u0413\u043E\u0440\u043D\u044B\u0439 \u043D\u0438\u043C\u0431",
        schema: 292,
        pol: "g\xf3rska aureola",
        bra: "Mundo das nuvens",
        fre: "Halo alpin",
        hun: "Hegyi f\xe9nykoszor\xfa",
        swe: "Bergsgloria",
        sch: "\u5C71\u5CE6\u5149\u6655"
    },
    264: {
        img: "celestial_summit",
        eng: "Celestial Summit",
        rus: "\u041D\u0435\u0431\u0435\u0441\u043D\u044B\u0439 \u043E\u0440\u0435\u043E\u043B",
        schema: 293,
        pol: "niebia\u0144ski szczyt",
        bra: "Cume celestial",
        fre: "Sommet c\xe9leste",
        hun: "Mennyei cs\xfacs",
        swe: "Stj\xe4rntopp",
        sch: "\u661F\u9645\u4E4B\u5DC5"
    },
    265: {
        img: "stellar_ascent",
        eng: "Stellar Ascent",
        rus: "\u0417\u0432\u0451\u0437\u0434\u043D\u044B\u0439 \u0432\u043E\u0441\u0445\u043E\u0434",
        schema: 294,
        pol: "gwiezdna wznios\u0142o\u015B\u0107",
        bra: "Ascens\xe3o estelar",
        fre: "Ascension stellaire",
        hun: "Szipork\xe1z\xf3 emelked\xe9s",
        swe: "Stj\xe4rnstigning",
        sch: "\u5347\u817E\u661F\u8F89"
    },
    266: {
        img: "sapped",
        eng: "Sapped",
        rus: "\u0416\u0435\u0440\u0442\u0432\u0430 \u0436\u0443\u0447\u043A\u0430",
        schema: 295,
        pol: "zasapowany",
        bra: "Sabotado",
        fre: "Sabot\xe9",
        hun: "Mentes\xedtve",
        swe: "Sappad",
        sch: "\u7535\u5B50\u762B\u75EA"
    },
    267: {
        img: "hellspawned_horns",
        eng: "Hellspawned Horns",
        rus: "\u0410\u0434\u0441\u043A\u0438\u0435 \u0440\u043E\u0433\u0430",
        schema: 297,
        pol: "rogi z piek\u0142a rodem",
        bra: "Chifres diab\xf3licos",
        fre: "Cornes diaboliques",
        hun: "Pokol sz\xfclte szarvak",
        swe: "Helvetshorn",
        sch: "\u5730\u72F1\u53F7\u89D2"
    },
    268: {
        img: "demonic_impaler",
        eng: "Demonic Impaler",
        rus: "\u0414\u0435\u043C\u043E\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0431\u043E\u0434\u0430\u0442\u0435\u043B\u044C",
        schema: 299,
        pol: "palownik z czelu\u015Bci",
        bra: "Empaladores demon\xedacos",
        fre: "Empaleur d\xe9moniaque",
        hun: "D\xe9moni ny\xe1rsal\xf3",
        swe: "Demonisk spetsare",
        sch: "\u6076\u9B54\u8D2F\u523A"
    },
    269: {
        img: "revenants_rack",
        eng: "Revenant's Rack",
        rus: "\u0418\u043D\u0444\u0435\u0440\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u043D\u0430\u0440\u043E\u0441\u0442\u044B",
        schema: 300,
        pol: "piekielne poro\u017Ce",
        bra: "Retalia\xe7\xe3o pontiaguda",
        fre: "Cornes du revenant",
        hun: "Sz\xf6rny\u0171 szarvak",
        swe: "Geng\xe5ngarens taggar",
        sch: "\u4EA1\u9B42\u9B54\u89D2"
    },
    270: {
        img: "sixth_sense",
        eng: "Sixth Sense",
        rus: "\u0428\u0435\u0441\u0442\u043E\u0435 \u0447\u0443\u0432\u0441\u0442\u0432\u043E",
        schema: 301,
        pol: "sz\xf3sty zmys\u0142",
        bra: "Sexto sentido",
        fre: "Sixi\xe8me sens",
        hun: "Hatodik \xe9rz\xe9k",
        swe: "Sj\xe4tte sinnet",
        sch: "\u7B2C\u516D\u611F"
    },
    271: {
        img: "amygdala",
        eng: "Amygdala",
        rus: "\u0410\u043C\u0438\u0433\u0434\u0430\u043B\u0430",
        schema: 303,
        pol: "cia\u0142o migda\u0142owate",
        bra: "Am\xedgdala",
        fre: "Amygdales",
        hun: "Amigdala",
        sch: "\u68A6\u9B47\u4E4B\u773C"
    },
    272: {
        img: "the_bone_zone",
        eng: "Bone Zone",
        rus: "\u0427\u0435\u0440\u0435\u043F\u043E\u043A\u0440\u0443\u0436\u0435\u043D\u0438\u0435",
        schema: 304,
        pol: "strefa gnat\xf3w",
        bra: "Zona \xf3ssea",
        fre: "Cr\xe2nerie",
        hun: "A csontz\xf3na",
        rom: "The Bone Zone",
        swe: "Benzonen",
        sch: "\u9AB8\u9AA8\u5730\u5E26"
    },
    273: {
        img: "arachnes_web",
        eng: "Arachne's Web",
        rus: "\u041F\u0430\u0443\u0442\u0438\u043D\u0430 \u0410\u0440\u0430\u0445\u043D\u044B",
        schema: 305,
        pol: "paj\u0119cza paj\u0119czyna",
        bra: "Teia da tecel\xe3",
        fre: "Toile d'araign\xe9e",
        hun: "Arachn\xe9 h\xe1l\xf3ja",
        swe: "Arachnes webb",
        sch: "\u8BE1\u4E1D\u8FF7\u7F51"
    },
    274: {
        img: "acidic_climate",
        eng: "Acidic Climate",
        rus: "\u041A\u0438\u0441\u043B\u043E\u0442\u043D\u044B\u0439 \u043A\u043B\u0438\u043C\u0430\u0442",
        schema: 306,
        pol: "kwa\u015Bny deszcz",
        bra: "Tempestade \xe1cida",
        fre: "Climat acide",
        hun: "Savas \xe9ghajlat",
        swe: "Surt klimat",
        sch: "\u9178\u6027\u6C14\u5019"
    },
    275: {
        img: "otherworldly_weather",
        eng: "Otherworldly Weather",
        rus: "\u041F\u043E\u0442\u0443\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u044F\u044F \u043F\u043E\u0433\u043E\u0434\u0430",
        schema: 307,
        pol: "pogoda poza\u015Bwiata",
        bra: "Tempestade c\xf3smica",
        fre: "M\xe9t\xe9o surnaturelle",
        hun: "T\xfalvil\xe1gi id\u0151j\xe1r\xe1s",
        swe: "Utomjordiskt v\xe4der",
        sch: "\u8D85\u51E1\u5929\u8C61"
    },
    276: {
        img: "nightmarish_storm",
        eng: "Nightmarish Storm",
        rus: "\u0423\u0440\u0430\u0433\u0430\u043D \u0443\u0436\u0430\u0441\u043E\u0432",
        schema: 308,
        pol: "koszmarna burza",
        bra: "Tempestade sinistra",
        fre: "Temp\xeate cauchemardesque",
        hun: "R\xe9m\xe1lomvihar",
        swe: "Mardr\xf6msstorm",
        sch: "\u5669\u68A6\u98CE\u66B4"
    },
    277: {
        img: "icestruck",
        eng: "Icestruck",
        rus: "\u041B\u0435\u0434\u044F\u043D\u0430\u044F \u0441\u0442\u0440\u0435\u043B\u0430",
        schema: 309,
        pol: "lodowate uderzenie",
        bra: "Flechada gelada",
        fre: "Fl\xe8che glac\xe9e",
        hun: "J\xe9gny\xedl",
        swe: "Istr\xe4ff",
        sch: "\u51B0\u971C\u98DE\u7BAD"
    },
    278: {
        img: "goldstruck",
        eng: "Goldstruck",
        rus: "\u0417\u043E\u043B\u043E\u0442\u0430\u044F \u0441\u0442\u0440\u0435\u043B\u0430",
        schema: 311,
        pol: "z\u0142ote uderzenie",
        bra: "Flechada dourada",
        fre: "Fl\xe8che dor\xe9e",
        hun: "Aranyny\xedl",
        swe: "Guldtr\xe4ff",
        sch: "\u9EC4\u91D1\u98DE\u7BAD"
    },
    279: {
        img: "radiant_rivalry",
        eng: "Radiant Rivalry",
        rus: "\u0421\u0438\u044F\u044E\u0449\u0438\u0439 \u0441\u043E\u043F\u0435\u0440\u043D\u0438\u043A",
        schema: 312,
        pol: "rozpromieniona rywalizacja",
        bra: "Rivalidade radiante",
        fre: "Rivalit\xe9 radieuse",
        hun: "Ragyog\xf3 rivaliz\xe1l\xe1s",
        swe: "Lysande rivalitet",
        sch: "\u8000\u4E16\u4E4B\u4E89"
    },
    280: {
        img: "radiant_legacy",
        eng: "Radiant Legacy",
        rus: "\u0411\u043B\u0438\u0441\u0442\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043D\u0430\u0441\u043B\u0435\u0434\u0438\u0435",
        schema: 314,
        pol: "rozpromieniona sukcesja",
        bra: "Legado luminoso",
        fre: "Promo radieuse",
        hun: "Sug\xe1rz\xf3 hagyat\xe9k",
        swe: "Lysande arv",
        sch: "\u8000\u4E16\u9057\u4EA7"
    },
    281: {
        img: "frosty_flavours",
        eng: "Frosty Flavours",
        rus: "\u041F\u043E\u0437\u0451\u043C\u043E\u0447\u043D\u0430\u044F \u043F\u0440\u0438\u0441\u044B\u043F\u043A\u0430",
        schema: 315,
        pol: "mro\u017Ane posmaki",
        bra: "C\xe9rebro congelado",
        fre: "Saveurs givr\xe9es",
        hun: "Fagyos finoms\xe1gok",
        swe: "Frostiga smaker",
        sch: "\u51B0\u971C\u98CE\u5473"
    },
    282: {
        img: "mint_frost",
        eng: "Mint Frost",
        rus: "\u041C\u044F\u0442\u043D\u044B\u0439 \u043C\u043E\u0440\u043E\u0437",
        schema: 317,
        pol: "mro\u017Ana mi\u0119ta",
        bra: "Geada de menta",
        fre: "Menthe givr\xe9e",
        hun: "Deres menta",
        swe: "Mintfrost",
        sch: "\u51B0\u723D\u8584\u8377"
    },
    283: {
        img: "north_star",
        eng: "North Star",
        rus: "\u041F\u043E\u043B\u044F\u0440\u043D\u0430\u044F \u0437\u0432\u0435\u0437\u0434\u0430",
        schema: 318,
        pol: "Gwiazda Polarna",
        bra: "Estrela Polar",
        fre: "\xc9toile polaire",
        hun: "Sarkcsillag",
        swe: "Nordstj\xe4rnan",
        sch: "\u5317\u6781\u661F"
    },
    284: {
        img: "prettiest_star",
        eng: "Prettiest Star",
        rus: "\u041F\u0440\u0435\u043A\u0440\u0430\u0441\u043D\u0435\u0439\u0448\u0430\u044F \u0437\u0432\u0435\u0437\u0434\u0430",
        schema: 320,
        pol: "naj\u0142adniejsza gwiazda",
        bra: "Estrela bela",
        fre: "Belle \xe9toile",
        hun: "Legszebb csillag",
        swe: "Finaste stj\xe4rnan",
        sch: "\u7480\u74A8\u660E\u661F"
    },
    285: {
        img: "festive_falling_star",
        eng: "Festive Falling Star",
        rus: "\u041F\u0440\u0430\u0437\u0434\u043D\u0438\u0447\u043D\u044B\u0439 \u0437\u0432\u0435\u0437\u0434\u043E\u043F\u0430\u0434",
        schema: 321,
        pol: "\u015Bwi\u0105teczna opadaj\u0105ca gwiazda",
        bra: "Estrela-cadente festiva",
        fre: "\xc9toile filante festive",
        hun: "\xdcnnepi hull\xf3csillag",
        swe: "Festligt stj\xe4rnfall",
        sch: "\u76DB\u5178\u6D41\u5149"
    },
    286: {
        img: "lunar_lights",
        eng: "Lunar Lights",
        rus: "\u041B\u0443\u043D\u043D\u044B\u0435 \u043E\u0433\u043D\u0438",
        schema: 322,
        pol: "ksi\u0119\u017Cycowe \u015Bwiate\u0142ka",
        bra: "Fa\xedscas lunares",
        fre: "Lumi\xe8res lunaires",
        hun: "Holdf\xe9nyek",
        swe: "M\xe5nljus",
        sch: "\u660E\u6708\u4E4B\u5149"
    },
    287: {
        img: "fairly_lights",
        eng: "Fairy Lights",
        rus: "\u0421\u043A\u0430\u0437\u043E\u0447\u043D\u044B\u0435 \u043E\u0433\u043D\u0438",
        schema: 324,
        pol: "wr\xf3\u017Ckowe \u015Bwiate\u0142ka",
        bra: "Fa\xedscas fant\xe1sticas",
        fre: "Lumi\xe8res f\xe9eriques",
        hun: "T\xfcnd\xe9rf\xe9nyek",
        swe: "Feljus",
        sch: "\u7AE5\u8BDD\u4E4B\u5149"
    },
    288: {
        img: "natural_lights",
        eng: "Natural Lights",
        rus: "\u041B\u0435\u0441\u043D\u044B\u0435 \u043E\u0433\u043D\u0438",
        schema: 325,
        pol: "naturalne \u015Bwiate\u0142ka",
        bra: "Fa\xedscas naturais",
        fre: "Lumi\xe8res naturelles",
        hun: "Term\xe9szetes f\xe9nyek",
        swe: "Naturligt ljus",
        sch: "\u81EA\u7136\u4E4B\u5149"
    },
    289: {
        img: "loyalists_coronet",
        eng: "Loyalist's Coronet",
        rus: "\u041A\u043E\u0440\u043E\u043D\u0435\u0442 \u043B\u043E\u044F\u043B\u0438\u0441\u0442\u0430",
        schema: 327,
        pol: "diadem lojalno\u015Bci",
        sch: "\u8654\u8BDA\u51A0\u5195",
        bra: "Coroa do legalista",
        fre: "Diad\xe8me du loyaliste",
        hun: "A lojalista koron\xe1ja",
        swe: "Lojalistens adelskrona"
    },
    290: {
        img: "knights_prideful_spirit",
        eng: "Knight's Prideful Spirit",
        rus: "\u0413\u043E\u0440\u0434\u044B\u0439 \u0434\u0443\u0445 \u0440\u044B\u0446\u0430\u0440\u044F",
        schema: 329,
        pol: "dumny duch rycerza",
        sch: "\u9A91\u58EB\u50B2\u7075",
        bra: "Esp\xedrito orgulhoso do cavaleiro",
        fre: "Orgueil du chevalier",
        hun: "A lovag b\xfcszke szelleme",
        swe: "Riddarens stolthet"
    },
    291: {
        img: "barons_cherished_chaplet",
        eng: "Baron's Cherished Chaplet",
        rus: "\u0417\u0430\u0432\u0435\u0442\u043D\u044B\u0439 \u0432\u0435\u043D\u043E\u043A \u0431\u0430\u0440\u043E\u043D\u0430",
        schema: 330,
        pol: "cenny wieniec barona",
        sch: "\u8D35\u65CF\u73CD\u51A0",
        bra: "Diadema digno do bar\xe3o",
        fre: "Chapelet ch\xe9ri du baron",
        hun: "A b\xe1r\xf3 d\xe9delgetett f\xfcz\xe9re",
        swe: "Baronens krans"
    },
    292: {
        img: "lure_of_the_deep",
        eng: "Lure of the Deep",
        rus: "\u041F\u0440\u0438\u043C\u0430\u043D\u043A\u0430 \u0433\u043B\u0443\u0431\u0438\u043D",
        schema: 331,
        pol: "wabik z g\u0142\u0119bin",
        sch: "\u6DF1\u6D77\u8BF1\u9975",
        bra: "Atra\xe7\xe3o das profundezas",
        fre: "Charme des profondeurs",
        hun: "Cs\xe1b\xedt\xf3 m\xe9lys\xe9g",
        swe: "Djupet lockar"
    },
    293: {
        img: "violent_viridian",
        eng: "Violent Viridian",
        rus: "\u0418\u0437\u0443\u043C\u0440\u0443\u0434\u043D\u044B\u0439 \u0438\u0437\u0443\u0432\u0435\u0440",
        schema: 333,
        pol: "zdzicza\u0142a ziele\u0144",
        sch: "\u51F6\u731B\u7EFF\u9CCD",
        bra: "Viol\xeancia verde",
        fre: "Viride vivace",
        hun: "Vad viridi\xe1n",
        swe: "V\xe5ldsam viridian"
    },
    294: {
        img: "magenta_monstrum",
        eng: "Magenta Monstrum",
        rus: "\u041F\u0443\u0440\u043F\u0443\u0440\u043D\u044B\u0439 \u043F\u0430\u043B\u0430\u0447",
        schema: 334,
        pol: "magentowe monstrum ",
        sch: "\u7D2B\u7EA2\u602A\u9CCD",
        bra: "Monstro magenta",
        fre: "Monstre magenta",
        swe: "Magenta-monstrum"
    },
    295: {
        img: "rainbow_reverie",
        eng: "Rainbow Reverie",
        rus: "\u0420\u0430\u0434\u0443\u0436\u043D\u0430\u044F \u0440\u0430\u0434\u043E\u0441\u0442\u044C",
        schema: 335,
        pol: "pryzmatyczne przemy\u015Blenia",
        sch: "\u5F69\u8679\u5E7B\u68A6",
        bra: "Devaneio multicolorido",
        fre: "Abstraction arc-en-ciel",
        hun: "Sziv\xe1rv\xe1nyos \xe1br\xe1nd",
        swe: "Regnb\xe5gsdr\xf6m"
    },
    296: {
        img: "cuban_smoke",
        eng: "Cuban Smoke",
        rus: "\u041A\u0443\u0431\u0438\u043D\u0441\u043A\u0438\u0439 \u0434\u044B\u043C\u043E\u043A",
        schema: 336,
        pol: "kuba\u0144ska zadyma",
        sch: "\u53E4\u5DF4\u96EA\u8304",
        bra: "Fuma\xe7a cubana",
        fre: "Fum\xe9e cubaine",
        hun: "Kubai par\xe1zs",
        swe: "Kubansk r\xf6k"
    },
    297: {
        img: "melting_mohawk",
        eng: "Melting Mohawk",
        rus: "\u0418\u0441\u043F\u0435\u043F\u0435\u043B\u044F\u044E\u0449\u0438\u0439 \u0438\u0440\u043E\u043A\u0435\u0437",
        schema: 337,
        pol: "iskrz\u0105cy irokez",
        sch: "\u7194\u52A8\u83AB\u897F\u5E72",
        bra: "Moicano ardente",
        fre: "Mohawk ardent",
        hun: "Olvad\xf3 taraj",
        swe: "P\xe5t\xe4nt h\xe5r"
    },
    298: {
        img: "scorched_scalp",
        eng: "Scorched Scalp",
        rus: "\u0416\u0433\u0443\u0447\u0438\u0439 \u0447\u0435\u0440\u0435\u043F",
        schema: 339,
        pol: "spieczony skalp",
        sch: "\u5934\u76AE\u53D1\u70ED",
        bra: "Cabe\xe7a chamuscada",
        fre: "Cr\xe2ne torride",
        hun: "Perzselt skalp",
        swe: "Flammande h\xe5rbotten"
    },
    299: {
        img: "ignited_crest",
        eng: "Ignited Crest",
        rus: "\u0422\u043B\u0435\u044E\u0449\u0435\u0435 \u0442\u0435\u043C\u044F",
        schema: 340,
        pol: "p\u0142on\u0105cy herb",
        sch: "\u5F15\u706B\u7FBD\u51A0",
        bra: "Crista crepitante",
        fre: "Cap incandescent",
        hun: "Kigyulladt tar\xe9j",
        swe: "Brandfarlig hj\xe4lm"
    },
    300: {
        img: "rare_shine",
        eng: "Rare Shine",
        rus: "\u0420\u0435\u0434\u043A\u043E\u0435 \u0441\u0438\u044F\u043D\u0438\u0435",
        schema: 341,
        pol: "niespotykany po\u0142ysk",
        sch: "\u7A00\u7269\u95EA\u8000",
        bra: "Brilho raro",
        fre: "T\xeate dans les \xe9toiles",
        hun: "Ritka ragyog\xe1s",
        swe: "S\xe4llsynt glans"
    },
    301: {
        img: "distant_drift",
        eng: "Distant Drift",
        rus: "\u0414\u0430\u043B\u044C\u043D\u0438\u0439 \u0434\u0440\u0435\u0439\u0444",
        schema: 342,
        pol: "daleki dryf",
        sch: "\u6F02\u6CCA\u7F81\u65C5",
        bra: "Deriva distante",
        fre: "Glorieuse galaxie",
        hun: "Kozmikus csillagtenger",
        swe: "Avl\xe4gsen drift"
    },
    302: {
        img: "warp_drive",
        eng: "Warp Drive",
        rus: "\u0412\u0430\u0440\u043F-\u0434\u0432\u0438\u0433\u0430\u0442\u0435\u043B\u044C",
        schema: 344,
        pol: "nap\u0119d nad\u015Bwietlny",
        sch: "\u66F2\u901F\u5F15\u64CE",
        bra: "Dobra espacial",
        fre: "Distorsion gravitationnelle",
        hun: "F\xe9nysebess\xe9g",
        swe: "Tidsresa"
    },
    303: {
        img: "overdrive",
        eng: "Overdrive",
        rus: "\u041E\u0432\u0435\u0440\u0434\u0440\u0430\u0439\u0432",
        schema: 345,
        pol: "nadbieg",
        sch: "\u8D85\u8D1F\u8377",
        bra: "Sobrecarga",
        fre: "Hyperd\xe9formation",
        hun: "\u0170rsebess\xe9g",
        swe: "\xd6verbelastning"
    },
    304: {
        img: "butterfly_season",
        eng: "Butterfly Season",
        rus: "\u0421\u0435\u0437\u043E\u043D \u0431\u0430\u0431\u043E\u0447\u0435\u043A",
        schema: 346,
        pol: "sezon na motylki",
        sch: "\u8774\u8776\u70ED\u5B63",
        bra: "Temporada de borboletas",
        fre: "Papillons palpitants",
        hun: "Pillang\xf3szezon",
        swe: "Fj\xe4rils\xe4song"
    },
    305: {
        img: "psycho_delic",
        eng: "Psycho-delic",
        rus: "\u041F\u0441\u0438\u0445\u043E-\u0434\u0435\u043B\u0438\u044F",
        schema: 348,
        pol: "kwiatogenny",
        sch: "\u7CBE\u795E\u8FF7\u5E7B",
        bra: "Psico-d\xe9lico",
        fre: "Psychod\xe9lique",
        hun: "Pszicho-delikus",
        swe: "Psykodelisk"
    },
    306: {
        img: "bewitching_bugs",
        eng: "Bewitching Bugs",
        rus: "\u041E\u0431\u0430\u044F\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0431\u0430\u0431\u043E\u0447\u043A\u0438",
        schema: 349,
        pol: "urzekaj\u0105ce owady",
        sch: "\u8FF7\u4EBA\u98DE\u866B",
        bra: "Belas borboletas",
        fre: "Insectes irr\xe9els",
        hun: "Elb\u0171v\xf6l\u0151 bogarak",
        swe: "F\xf6rtrollade fj\xe4rilar"
    },
    307: {
        img: "spectral_fire",
        eng: "Spectral Fire",
        rus: "\u0421\u043F\u0435\u043A\u0442\u0440\u0430\u043B\u044C\u043D\u044B\u0439 \u043E\u0433\u043E\u043D\u044C",
        schema: 350,
        pol: "widmowy ogie\u0144",
        sch: "\u5E7B\u5F71\u9B42\u706B",
        bra: "Fogo espectral",
        fre: "Feu spectral",
        hun: "Lid\xe9rces l\xe1ng",
        swe: "V\xe5lnadseld"
    },
    308: {
        img: "galactic_flame",
        eng: "Galactic Flame",
        rus: "\u0413\u0430\u043B\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043F\u043B\u0430\u043C\u044F",
        schema: 351,
        pol: "galaktyczny p\u0142omie\u0144",
        sch: "\u94F6\u6CB3\u4E4B\u706B",
        bra: "Chama gal\xe1tica",
        fre: "Nu\xe9e galactique",
        hun: "Galaktikus l\xe1ng",
        swe: "Galaktisk l\xe5ga"
    },
    309: {
        img: "revived_recharge",
        eng: "Revived Recharge",
        rus: "\u0420\u0435\u0430\u043D\u0438\u043C\u0438\u0440\u0443\u044E\u0449\u0438\u0439 \u0440\u0430\u0437\u0440\u044F\u0434",
        schema: 352,
        pol: "wy\u0142adowanie wskrzeszonego",
        sch: "\u56DE\u751F\u5145\u80FD",
        bra: "Recarga revivida",
        fre: "D\xe9charge r\xe9animatrice",
        hun: "\xdajra\xe9ledt \xfajrat\xf6lt\xe9s",
        swe: "\xc5terladdad"
    },
    310: {
        img: "frankencharged",
        eng: "Frankencharged",
        rus: "\u0424\u0440\u0430\u043D\u043A\u0435\u043D\u0448\u0442\u043E\u0440\u043C",
        schema: 353,
        pol: "frankenna\u0142adowany",
        sch: "\u7206\u80FD\u602A\u4EBA",
        bra: "Frankarregado",
        fre: "Frankencharge",
        hun: "Frankent\xf6ltve",
        swe: "Frankenladdad"
    },
    311: {
        img: "undead_electricity",
        eng: "Undead Electricity",
        rus: "\u042D\u043D\u0435\u0440\u0433\u0438\u044F \u043D\u0435\u0436\u0438\u0442\u0438",
        schema: 354,
        pol: "elektryczno\u015B\u0107 nieumar\u0142ego",
        sch: "\u4E0D\u6B7B\u7535\u6D41",
        bra: "Eletricidade morta-viva",
        fre: "\xc9lectricit\xe9 macabre",
        hun: "\xc9l\u0151halott elektromoss\xe1g",
        swe: "Vand\xf6d elektricitet"
    },
    312: {
        img: "phantom_plague",
        eng: "Phantom Plague",
        rus: "\u0422\u0440\u0443\u043F\u043D\u044B\u0439 \u0442\u0443\u043C\u0430\u043D",
        schema: 355,
        pol: "przywidziana plaga",
        sch: "\u5E7B\u5F71\u761F\u75AB",
        bra: "Praga fantasma",
        fre: "Peste fant\xf4me",
        hun: "Fantompestis",
        swe: "Fantompest"
    },
    313: {
        img: "haunting_haze",
        eng: "Haunting Haze",
        rus: "\u041F\u0440\u043E\u043A\u043B\u044F\u0442\u0430\u044F \u043F\u0435\u043B\u0435\u043D\u0430",
        schema: 356,
        pol: "nawiedzona mg\u0142a",
        sch: "\u9634\u973E\u8426\u7ED5",
        bra: "N\xe9voa assombrada",
        fre: "Fum\xe9e maudite",
        hun: "K\xeds\xe9rt\u0151 k\xf6d",
        swe: "Hems\xf6kt dimma"
    },
    314: {
        img: "vicious_vampires",
        eng: "Vicious Vampires",
        rus: "\u041C\u044B\u0448\u0438-\u043C\u0443\u0447\u0438\u0442\u0435\u043B\u0438",
        schema: 357,
        pol: "w\u015Bciek\u0142e wampiry",
        sch: "\u51F6\u6B8B\u8840\u8760",
        bra: "Vampiros vis",
        fre: "Vampires vicieux",
        hun: "Veszedelmes v\xe1mp\xedrok",
        swe: "Bitska vampyrer"
    },
    315: {
        img: "ravenous_ravens",
        eng: "Ravenous Ravens",
        rus: "\u0412\u043E\u0440\u043E\u0432\u0430\u0442\u044B\u0435 \u0432\u043E\u0440\u043E\u043D\u044B",
        schema: 358,
        pol: "wyg\u0142odnia\u0142e wrony",
        sch: "\u9965\u997F\u9ED1\u9E26",
        bra: "Corvos carniceiros",
        fre: "Corbeaux carnassiers",
        hun: "Harap\xf3s holl\xf3k",
        swe: "Glupska korpar"
    },
    316: {
        img: "delightful_doves",
        eng: "Delightful Doves",
        rus: "\u0413\u0440\u0430\u0446\u0438\u043E\u0437\u043D\u044B\u0435 \u0433\u043E\u043B\u0443\u0431\u0438",
        schema: 359,
        pol: "go\u0142\u0119bia gloria",
        sch: "\u6B22\u6109\u767D\u9E3D",
        bra: "Pombas pac\xedficas",
        fre: "Colombes conciliantes",
        hun: "G\xe1l\xe1ns galambok",
        swe: "Ljuvliga duvor"
    },
    317: {
        img: "searing_stove",
        eng: "Searing Stove",
        rus: "\u041F\u044B\u043B\u0430\u044E\u0449\u0430\u044F \u043F\u043B\u0438\u0442\u0430",
        schema: 360,
        pol: "pal\u0105cy palnik",
        sch: "\u707C\u70ED\u7089\u706B",
        bra: "Fog\xe3o flamejante",
        fre: "Gazini\xe8re d'artifice",
        hun: "Perzsel\u0151 t\u0171zhely",
        swe: "Osande spis"
    },
    318: {
        img: "uber_blaze",
        eng: "\xdcber Blaze",
        rus: "\u0423\u0431\u0435\u0440-\u0437\u0430\u043F\u0430\u043B",
        schema: 362,
        pol: "\xfcber\u017Car",
        sch: "\u8D85\u80FD\u70AB\u5149",
        bra: "\xdcberraios",
        fre: "\xdcber ardent",
        hun: "\xdcberl\xe1ng",
        swe: "\xdcberl\xe5ga"
    },
    319: {
        img: "sizzling",
        eng: "Sizzling",
        schema: 364,
        pol: "skwierczenie",
        sch: "\u6ECB\u6ECB\u5192\u6C14",
        bra: "Escaldante",
        fre: "Brulant",
        hun: "Sisterg\u0151",
        swe: "Rykande",
        rus: "\u041E\u0431\u0436\u0430\u0440\u043A\u0430"
    },
    320: {
        img: "crystal_crown",
        eng: "Crystal Crown",
        schema: 365,
        pol: "kryszta\u0142owa korona",
        sch: "\u6C34\u6676\u738B\u51A0",
        bra: "Coroa de cristal",
        fre: "Couronne de cristal",
        hun: "Krist\xe1lykorona",
        swe: "Kristallkrona",
        rus: "\u041A\u0440\u0438\u0441\u0442\u0430\u043B\u044C\u043D\u0430\u044F \u043A\u043E\u0440\u043E\u043D\u0430"
    },
    321: {
        img: "halcyon_halo",
        eng: "Halcyon Halo",
        schema: 367,
        pol: "cudowna aureola",
        sch: "\u592A\u5E73\u5149\u73AF",
        bra: "Aur\xe9ola pac\xedfica",
        fre: "Halo merveilleux",
        hun: "Boldog gl\xf3ria",
        swe: "Salig gloria",
        rus: "\u041D\u0435\u0432\u043E\u0437\u043C\u0443\u0442\u0438\u043C\u044B\u0439 \u043D\u0438\u043C\u0431"
    },
    322: {
        img: "ghosts_of_smissmas_time",
        eng: "Ghosts of Smissmas Time",
        schema: 368,
        pol: "duch \u015Bni\u0105t",
        sch: "\u5723\u8BDE\u4F17\u7075",
        bra: "Fantasmas das festividades",
        fre: "Fant\xf4mes de Smissmas",
        hun: "Gal\xe1csonyi szellemek",
        swe: "Smissmas andar",
        rus: "\u0414\u0443\u0445\u0438 \u0428\u043C\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u0430"
    },
    323: {
        img: "aurora_skies",
        eng: "Aurora Skies",
        schema: 369,
        pol: "zorzowe niebo",
        sch: "\u6781\u5730\u591C\u7A7A",
        bra: "C\xe9us auroreais",
        fre: "Ciel bor\xe9al",
        hun: "Aur\xf3ra \xe9gbolt",
        swe: "Polarsky",
        rus: "\u041F\u043E\u043B\u044F\u0440\u043D\u044B\u0435 \u043D\u0435\u0431\u0435\u0441\u0430"
    },
    324: {
        img: "shining_bokeh",
        eng: "Shining Bokeh",
        schema: 370,
        pol: "b\u0142yszcz\u0105ce rozmycie",
        sch: "\u95EA\u4EAE\u6563\u7126",
        bra: "Bokeh brilhante",
        fre: "Bokeh brillant",
        hun: "F\xe9nyl\u0151 bokr\xe9ta",
        swe: "Gl\xe4nsande bokeh",
        rus: "\u0411\u043B\u0435\u0441\u0442\u044F\u0449\u0435\u0435 \u0431\u043E\u043A\u0435"
    },
    325: {
        img: "playful_aurora",
        eng: "Playful Aurora",
        schema: 371,
        pol: "zorzowa zabawa",
        sch: "\u6B22\u817E\u6781\u5149",
        bra: "Aurora brincalhona",
        fre: "Aurore espi\xe8gle",
        hun: "J\xe1t\xe9kos aur\xf3ra",
        swe: "Lekfull aurora",
        rus: "\u0418\u0433\u0440\u0438\u0432\u043E\u0435 \u0441\u0438\u044F\u043D\u0438\u0435"
    },
    326: {
        img: "frisky_morning",
        eng: "Frisky Morning",
        schema: 372,
        pol: "rozbrykany poranek",
        sch: "\u84EC\u52C3\u671D\u6C14",
        bra: "Manh\xe3 animada",
        fre: "Matin fringant",
        hun: "Cs\xedp\u0151s reggel",
        swe: "Frisk morgon",
        rus: "\u0420\u0435\u0437\u0432\u043E\u0435 \u0443\u0442\u0440\u043E"
    },
    327: {
        img: "drunkard",
        eng: "Drunkard",
        schema: 373,
        pol: "moczymorda",
        sch: "\u9169\u914A\u5927\u9189",
        bra: "Bebum",
        fre: "Ivresse",
        hun: "Isz\xe1kos",
        swe: "Fyllbult",
        rus: "\u041F\u044C\u044F\u043D\u0438\u0446\u0430"
    },
    328: {
        img: "blades_of_betrayal",
        eng: "Blades of Betrayal",
        schema: 374,
        pol: "ostrza zdrady",
        sch: "\u80CC\u53DB\u4E4B\u5203",
        bra: "L\xe2minas da trai\xe7\xe3o",
        fre: "Dagues d\xe9loyales",
        hun: "Az \xe1rul\xe1s peng\xe9i",
        swe: "Hundra hugg",
        rus: "\u041A\u0438\u043D\u0436\u0430\u043B\u044B \u043A\u043E\u0432\u0430\u0440\u0441\u0442\u0432\u0430"
    },
    329: {
        img: "deaths_daggers",
        eng: "Death's Daggers",
        schema: 376,
        pol: "sztylety \u015Bmierci",
        sch: "\u6B7B\u795E\u5315\u9996",
        bra: "Punhais apunhalados",
        fre: "Lames lugubres",
        hun: "Hal\xe1los t\u0151r\xf6k",
        swe: "D\xf6dens dolkar",
        rus: "\u041F\u0440\u043E\u043D\u0437\u0430\u044E\u0449\u0430\u044F \u043F\u043E\u0433\u0438\u0431\u0435\u043B\u044C"
    },
    330: {
        img: "fully_charged",
        eng: "Fully Charged",
        schema: 377,
        pol: "w pe\u0142ni na\u0142adowany",
        sch: "\u80FD\u91CF\u7206\u68DA",
        bra: "Carga completa",
        fre: "Charg\xe9 \xe0 bloc",
        hun: "Teljesen felt\xf6ltve",
        swe: "Maxladdad",
        rus: "\u041F\u043E\u043B\u043D\u044B\u0439 \u0437\u0430\u0440\u044F\u0434"
    },
    331: {
        img: "overcharged",
        eng: "Overcharged",
        schema: 379,
        pol: "prze\u0142adowany",
        sch: "\u8D85\u91CF\u5145\u80FD",
        bra: "Sobrecarga",
        fre: "Surcharge",
        hun: "T\xfalt\xf6ltve",
        swe: "\xd6verladdad",
        rus: "\u0421\u0432\u0435\u0440\u0445\u0437\u0430\u0440\u044F\u0434"
    },
    332: {
        img: "piercing_headache",
        eng: "Piercing Headache",
        schema: 380,
        pol: "przeszywaj\u0105cy b\xf3l g\u0142owy",
        sch: "\u8111\u6D1E\u5927\u5F00",
        bra: "Enxaqueca perfurante",
        fre: "Migraine mortelle",
        hun: "Sz\xfar\xf3 fejf\xe1j\xe1s",
        swe: "Genomborrande huvudv\xe4rk",
        rus: "\u041C\u0438\u043C\u043E\u043B\u0451\u0442\u043D\u0430\u044F \u043C\u0438\u0433\u0440\u0435\u043D\u044C"
    },
    333: {
        img: "decimating_wind",
        eng: "Decimating Wind",
        schema: 381,
        pol: "niszczycielska wichura",
        sch: "\u98CE\u5377\u6B8B\u4E91",
        bra: "Tornado de tubar\xf5es",
        fre: "Bourrasque brutale",
        hun: "C\xe1patorn\xe1d\xf3",
        swe: "Vansinnig vindstyrka",
        rus: "\u041F\u0430\u0433\u0443\u0431\u043D\u044B\u0439 \u0432\u0435\u0442\u0435\u0440"
    },
    334: {
        img: "ocean_swirl",
        eng: "Ocean Swirl",
        schema: 382,
        pol: "oceaniczny wir",
        sch: "\u5927\u6D0B\u6F29\u6DA1",
        bra: "Redemoinho",
        fre: "Tourbillon oc\xe9anique",
        hun: "\xd3ce\xe1ni \xf6rv\xe9ny",
        swe: "Havsvirvel",
        rus: "\u041E\u043A\u0435\u0430\u043D\u0441\u043A\u043E\u0435 \u0437\u0430\u0432\u0438\u0445\u0440\u0435\u043D\u0438\u0435"
    },
    335: {
        img: "toxic_swirl",
        eng: "Toxic Swirl",
        schema: 384,
        pol: "toksyczny wir",
        sch: "\u5267\u6BD2\u6F29\u6DA1",
        bra: "Venenoinho",
        fre: "Tourbillon toxique",
        hun: "M\xe9rgez\u0151 \xf6rv\xe9ny",
        swe: "Giftvirvel",
        rus: "\u0422\u043E\u043A\u0441\u0438\u0447\u043D\u043E\u0435 \u0437\u0430\u0432\u0438\u0445\u0440\u0435\u043D\u0438\u0435"
    },
    336: {
        img: "candle_flame",
        eng: "Candle Flame",
        schema: 385,
        pol: "p\u0142omie\u0144 \u015Bwiecy",
        sch: "\u6447\u66F3\u70DB\u706B",
        bra: "Fogo de vela",
        fre: "Flamme de bougie",
        hun: "Gyertyal\xe1ng",
        swe: "Ljusl\xe5ga",
        rus: "\u041F\u043B\u0430\u043C\u044F \u0441\u0432\u0435\u0447\u0438"
    },
    337: {
        img: "sizzling_aroma",
        eng: "Sizzling Aroma",
        schema: 387,
        pol: "skwiercz\u0105cy aromat",
        sch: "\u6ECB\u6CB9\u55B7\u9999",
        bra: "Aroma ardente",
        fre: "Ar\xf4me flamb\xe9",
        hun: "Sisterg\u0151 aroma",
        swe: "Rykande arom",
        rus: "\u041E\u0431\u0436\u0438\u0433\u0430\u044E\u0449\u0438\u0439 \u0430\u0440\u043E\u043C\u0430\u0442"
    },
    338: {
        img: "toxic_aroma",
        eng: "Toxic Aroma",
        schema: 389,
        pol: "toksyczny aromat",
        sch: "\u6BD2\u6DB2\u8FF7\u81ED",
        bra: "Aroma t\xf3xico",
        fre: "Ar\xf4me toxique",
        hun: "M\xe9rgez\u0151 aroma",
        swe: "Giftig arom",
        rus: "\u0422\u043E\u043A\u0441\u0438\u0447\u043D\u044B\u0439 \u0430\u0440\u043E\u043C\u0430\u0442"
    },
    339: {
        img: "current_conductor",
        eng: "Current Conductor",
        schema: 390,
        pol: "przewodnik pr\u0105du",
        sch: "\u7535\u6D41\u5BFC\u4F53",
        bra: "Condutor de corrente",
        fre: "Conducteur de courant",
        hun: "\xc1ramvezet\u0151",
        swe: "Str\xf6mledare",
        rus: "\u041F\u0435\u0440\u0435\u043C\u0435\u043D\u0447\u0438\u0432\u044B\u0439 \u043F\u0440\u043E\u0432\u043E\u0434\u043D\u0438\u043A"
    },
    340: {
        img: "sandy",
        eng: "Sandy",
        schema: 392,
        pol: "piaskowiec",
        sch: "\u7070\u5934\u571F\u8138",
        bra: "Arenoso",
        fre: "Sableux",
        hun: "Homokos",
        swe: "Sandig",
        rus: "\u041F\u0435\u0441\u043E\u0447\u043D\u0438\u043A"
    },
    341: {
        img: "chromatic_blaze",
        eng: "Chromatic Blaze",
        schema: 393,
        pol: "chromatyczny p\u0142omie\u0144",
        sch: "\u70AB\u5F69\u70C8\u7130",
        bra: "Chama crom\xe1tica",
        fre: "Flamme chromatique",
        hun: "Kromatikus l\xe1ng",
        swe: "Kromatisk eld",
        rus: "\u0425\u0440\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043F\u043B\u0430\u043C\u044F"
    },
    342: {
        img: "frostfire",
        eng: "Frostfire",
        schema: 394,
        pol: "lodowy p\u0142omie\u0144",
        sch: "\u971C\u51BB\u4E4B\u706B",
        bra: "Fogo frio",
        fre: "Flamme bor\xe9ale",
        hun: "Fagyt\u0171z",
        swe: "Frostflamma",
        rus: "\u041B\u0435\u0434\u044F\u043D\u043E\u0439 \u043E\u0433\u043E\u043D\u044C"
    },
    343: {
        img: "spectrum_inferno",
        eng: "Spectrum Inferno",
        schema: 395,
        pol: "piekielne spektrum",
        sch: "\u5149\u8C31\u71C3\u70E7",
        bra: "Inferno espectral",
        fre: "Brasier prismatique",
        hun: "Spektr\xe1lis t\u0171zv\xe9sz",
        swe: "Spektralinferno",
        rus: "\u0421\u043F\u0435\u043A\u0442\u0440\u0430\u043B\u044C\u043D\u043E\u0435 \u043F\u044B\u043B\u0430\u043D\u0438\u0435"
    },
    344: {
        img: "calm_snowfall",
        eng: "Calm Snowfall",
        schema: 396,
        pol: "pr\xf3sz\u0105cy \u015Bnieg",
        sch: "\u5B81\u9759\u98D8\u96EA",
        bra: "Neve tranquila",
        fre: "Neige calme",
        hun: "Nyugodt h\xf3es\xe9s",
        swe: "Stilla sn\xf6fall",
        rus: "\u0421\u043F\u043E\u043A\u043E\u0439\u043D\u044B\u0439 \u0441\u043D\u0435\u0433\u043E\u043F\u0430\u0434"
    },
    345: {
        img: "team_recognition",
        eng: "Team Recognition",
        schema: 397,
        pol: "przedstawienie dru\u017Cyny",
        sch: "\u56E2\u961F\u8BA4\u8BC1",
        bra: "Reconhecimento da equipe",
        fre: "Marque d'\xe9quipe",
        hun: "Csapatelismer\xe9s",
        swe: "Laguppvisning",
        rus: "\u041F\u0440\u0438\u0437\u043D\u0430\u043D\u0438\u0435 \u043A\u043E\u043C\u0430\u043D\u0434\u044B"
    },
    346: {
        img: "old_hire",
        eng: "Old Hire",
        schema: 399,
        pol: "stary wyjadacz",
        sch: "\u8D44\u6DF1\u8001\u8F88",
        bra: "Contratado cl\xe1ssico",
        fre: "Vieux de la vieille",
        hun: "\xd6reg r\xf3ka",
        swe: "Gammalt kontrakt",
        rus: "\u0411\u044B\u0432\u0430\u043B\u044B\u0439 \u043D\u0430\u0451\u043C\u043D\u0438\u043A"
    },
    347: {
        img: "analog_fortress",
        eng: "Analog Fortress",
        schema: 401,
        pol: "analogowa forteca",
        sch: "\u6A21\u62DF\u8981\u585E",
        bra: "Fortaleza anal\xf3gica",
        fre: "TF analogique",
        swe: "Analog f\xe4stning",
        rus: "\u0410\u043D\u0430\u043B\u043E\u0433\u043E\u0432\u044B\u0439 \u043B\u043E\u0433\u043E\u0442\u0438\u043F"
    },
    348: {
        img: "winter_whiteout",
        eng: "Winter Whiteout",
        schema: 402,
        pol: "zimowa biel",
        sch: "\u51AC\u65E5\u767D\u663C",
        bra: "Nevasca invernal",
        fre: "Manteau de neige",
        hun: "T\xe9li feh\xe9rs\xe9g",
        swe: "Sn\xf6flingor",
        rus: "\u041C\u043E\u0440\u043E\u0437\u043D\u0430\u044F \u043C\u0433\u043B\u0430"
    },
    349: {
        img: "midnight_frostfall",
        eng: "Midnight Frostfall",
        schema: 403,
        pol: "p\xf3\u0142nocny przymrozek",
        sch: "\u5348\u591C\u971C\u534E",
        bra: "Geada da meia-noite",
        fre: "Gel\xe9e de minuit",
        hun: "\xc9jf\xe9li fagy",
        swe: "Midnattsfrost",
        rus: "\u041F\u043E\u043B\u0443\u043D\u043E\u0447\u043D\u044B\u0439 \u043C\u043E\u0440\u043E\u0437"
    },
    350: {
        img: "twilight_snowfall",
        eng: "Twilight Snowfall",
        schema: 404,
        pol: "\u015Bnie\u017Cek o zmierzchu",
        sch: "\u66AE\u8272\u843D\u96EA",
        bra: "Neve do anoitecer",
        fre: "Neige cr\xe9pusculaire",
        hun: "Alkonyi h\xf3es\xe9s",
        swe: "Skymningssn\xf6fall",
        rus: "\u0421\u0443\u043C\u0435\u0440\u0435\u0447\u043D\u0430\u044F \u043C\u0435\u0442\u0435\u043B\u044C"
    },
    351: {
        img: "cryogenic",
        eng: "Cryogenic",
        schema: 405,
        pol: "kriogenika",
        sch: "\u4F4E\u6E29\u51B7\u51BB",
        bra: "Criog\xeanico",
        fre: "Cryogel",
        hun: "M\xe9lyh\u0171t\xf6tt",
        swe: "Kryogen",
        rus: "\u041A\u0440\u0438\u043E\u0433\u0435\u043D"
    },
    352: {
        img: "umbral_lights",
        eng: "Umbral Lights",
        schema: 407,
        sch: "\u672C\u5F71\u591C\u5149",
        bra: "Luzes na escurid\xe3o",
        hun: "Elmos\xf3dott f\xe9nyek",
        swe: "Skuggljus",
        rus: "\u0421\u043C\u0443\u0442\u043D\u043E\u0435 \u0441\u0438\u044F\u043D\u0438\u0435",
        pol: "cieniste \u015Bwiat\u0142a",
        fre: "Lueurs lilas"
    },
    353: {
        img: "polar_prism",
        eng: "Polar Prism",
        schema: 408,
        sch: "\u6781\u5730\u68F1\u955C",
        bra: "Prisma polar",
        hun: "Sarki prizma",
        swe: "Polarprism",
        rus: "\u041F\u043E\u043B\u044F\u0440\u043D\u0430\u044F \u043F\u0440\u0438\u0437\u043C\u0430",
        cze: "Northern Nights",
        rom: "Northern Nights",
        pol: "polarny pryzmat",
        fre: "Prisme polaire"
    },
    354: {
        img: "solar_singed",
        eng: "Solar Singed",
        schema: 409,
        sch: "\u65E5\u5149\u707C\u70E7",
        bra: "Queimadura solar",
        hun: "Napperzselte",
        swe: "Solsvedd",
        rus: "\u0421\u043E\u043B\u043D\u0435\u0447\u043D\u043E\u0435 \u0441\u0432\u0435\u0440\u043A\u0430\u043D\u0438\u0435",
        pol: "s\u0142oneczna spalenizna",
        fre: "Radiation solaire"
    },
    355: {
        img: "floral_growth",
        eng: "Floral Growth",
        schema: 410,
        sch: "\u82B1\u5349\u4E1B\u751F",
        hun: "Vir\xe1g\xf6z\xf6n",
        rus: "\u0426\u0432\u0435\u0442-\u0440\u0430\u0441\u0446\u0432\u0435\u0442",
        pol: "kwiecisty rozrost",
        bra: "Crescimento floral",
        fre: "Croissance florale",
        swe: "Blomsterprakt"
    },
    356: {
        img: "stellar_orbit",
        eng: "Stellar Orbit",
        schema: 412,
        sch: "\u5760\u661F\u8F68\u9053",
        hun: "Csillagp\xe1lya",
        rus: "\u0417\u0432\u0451\u0437\u0434\u043D\u0430\u044F \u043E\u0440\u0431\u0438\u0442\u0430",
        pol: "gwiezdna orbita",
        bra: "\xd3rbita estelar",
        fre: "Orbite stellaire",
        swe: "Omloppsbana"
    },
    357: {
        img: "blissful_butterflies",
        eng: "Blissful Butterflies",
        schema: 413,
        sch: "\u6781\u4E50\u98DE\u8776",
        bra: "Borboletas bonitas",
        hun: "Boldog pillang\xf3k",
        swe: "F\xf6rn\xf6jda fj\xe4rilar",
        rus: "\u0411\u043B\u0430\u0436\u0435\u043D\u043D\u044B\u0435 \u0431\u0430\u0431\u043E\u0447\u043A\u0438",
        pol: "milusie motylki",
        fre: "Papillons prodigieux"
    },
    358: {
        img: "wispful_wings",
        eng: "Wispful Wings",
        schema: 415,
        sch: "\u98D8\u9038\u4ED9\u7075",
        bra: "Asas espirituais",
        hun: "Leheletfinom sz\xe1rnyak",
        swe: "Vindsvepta vingar",
        rus: "\u0412\u043E\u043B\u0448\u0435\u0431\u043D\u044B\u0435 \u0432\u0437\u043C\u0430\u0445\u0438",
        pol: "st\u0119sknione skrzyde\u0142ka",
        fre: "L\xe9pidospectre"
    },
    359: {
        img: "flor_de_muerto",
        eng: "Flor de Muerto",
        schema: 416
    },
    360: {
        img: "autumn_breeze",
        eng: "Autumn Breeze",
        schema: 418
    },
    361: {
        img: "spirit_swirl",
        eng: "Spirit Swirl",
        schema: 419
    },
    362: {
        img: "ghost_swirl",
        eng: "Ghost Swirl",
        schema: 420
    },
    363: {
        img: "fable_feathers",
        eng: "Fable Feathers",
        schema: 421
    },
    364: {
        img: "fable_quills",
        eng: "Fable Quills",
        schema: 423
    },
    365: {
        img: "grudge_n_drudge",
        eng: "Grudge n' Drudge",
        schema: 424
    },
    366: {
        img: "boil_n_toil",
        eng: "Boil n' Toil",
        schema: 425
    },
    367: {
        img: "screaming_soul",
        eng: "Screaming Soul",
        schema: 426
    },
    368: {
        img: "screeching_soul",
        eng: "Screeching Soul",
        schema: 427
    },
    369: {
        img: "shrieking_soul",
        eng: "Shrieking Soul",
        schema: 428
    }
};


let $d1e5a223d1ff5d82$export$a665a64cc334a157 = {
    1: {
        eng: "Weapons obtained from this crate will have the Strange quality.",
        rus: "\u041E\u0440\u0443\u0436\u0438\u0435, \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u043E\u0435 \u0438\u0437 \u044D\u0442\u043E\u0433\u043E \u044F\u0449\u0438\u043A\u0430, \u0431\u0443\u0434\u0435\u0442 \u0438\u043C\u0435\u0442\u044C \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u043E \u0421\u0442\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430.",
        pol: "Bronie otrzymane z tej skrzynki b\u0119d\u0105 posiada\u0142y jako\u015B\u0107 Kuriozum.",
        sch: "\u4ECE\u8FD9\u4E2A\u7BB1\u5B50\u4E2D\u83B7\u5F97\u7684\u6B66\u5668\u5177\u6709\u5947\u5F02\u54C1\u8D28\u3002",
        bra: "Armas obtidas por essa caixa ter\xe3o a qualidade Estranha.",
        fre: "Les armes obtenues de cette caisse seront de qualit\xe9 \xc9trange.",
        cze: "Zbran\u011B uvnit\u0159 maj\xed Strange kvalitu.",
        hun: "Ebben a l\xe1d\xe1ban tal\xe1lhat\xf3 fegyverek Fura min\u0151s\xe9g\u0171ek lesznek.",
        rom: "Armele obtinute din aceasta cutie vor avea o calitate Stranie.",
        swe: "Vapen som erh\xe5lls fr\xe5n denna l\xe5da kommer att ha den Avvikande kvaliteten.",
        fil: "Ang mga armas na makukuha sa kahon ay magkakaroon ng kalidad na Strange."
    },
    2: {
        eng: "Items obtained from this crate might have the Strange quality.",
        rus: "\u041F\u0440\u0435\u0434\u043C\u0435\u0442\u044B, \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u044B\u0435 \u0438\u0437 \u044D\u0442\u043E\u0433\u043E \u044F\u0449\u0438\u043A\u0430, \u043C\u043E\u0433\u0443\u0442 \u0438\u043C\u0435\u0442\u044C \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u043E \u0421\u0442\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430.",
        pol: "Przedmioty otrzymane z tej skrzynki mog\u0105 posiada\u0107 jako\u015B\u0107 Kuriozum.",
        sch: "\u4ECE\u8FD9\u4E2A\u7BB1\u5B50\u4E2D\u83B7\u5F97\u7684\u7269\u54C1\u53EF\u80FD\u5177\u6709\u5947\u5F02\u54C1\u8D28\u3002",
        bra: "Itens obtidos por essa caixa podem ter a qualidade Estranha.",
        fre: "Les objets obtenus de cette caisse peuvent \xeatre de qualit\xe9 \xc9trange.",
        cze: "P\u0159edm\u011Bty z\xedskan\xe9 z t\xe9to krabice mohou m\xedt Strange kvalitu.",
        hun: "Ebben a l\xe1d\xe1ban tal\xe1lhat\xf3 t\xe1rgyak Fura min\u0151s\xe9g\u0171ek lehetnek.",
        rom: "Obiectele obtinute din aceasta cutie pot avea o calitate Stranie.",
        swe: "F\xf6rem\xe5l som erh\xe5lls fr\xe5n denna l\xe5da kan ha den Avvikande kvaliteten.",
        fil: "Mga aytem na makukuha sa kahon ay maaring magkakaroon ng kalidad na Strange."
    },
    3: {
        eng: "Items obtained from this crate will have the Haunted quality.",
        rus: "\u041F\u0440\u0435\u0434\u043C\u0435\u0442\u044B, \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u044B\u0435 \u0438\u0437 \u044D\u0442\u043E\u0433\u043E \u044F\u0449\u0438\u043A\u0430, \u0431\u0443\u0434\u0443\u0442 \u0438\u043C\u0435\u0442\u044C \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u043E \u041F\u0440\u0438\u0437\u0440\u0430\u0447\u043D\u043E\u0433\u043E \u0432\u0438\u0434\u0430.",
        pol: "Przedmioty otrzymane z tej skrzynki b\u0119d\u0105 posiada\u0142y jako\u015B\u0107 Przekle\u0144stwo.",
        sch: "\u4ECE\u8FD9\u4E2A\u7BB1\u5B50\u4E2D\u83B7\u5F97\u7684\u7269\u54C1\u5177\u6709\u95F9\u9B3C\u54C1\u8D28\u3002",
        bra: "Itens obtidos por essa caixa ter\xe3o a qualidade Assombrada.",
        fre: "Les objets obtenus de cette caisse seront de qualit\xe9 Hant\xe9e.",
        cze: "P\u0159edm\u011Bty uvnit\u0159 maj\xed Haunted kvalitu.",
        hun: "Ebben a l\xe1d\xe1ban tal\xe1lhat\xf3 t\xe1rgyak K\xeds\xe9rtetj\xe1rta min\u0151s\xe9g\u0171ek lesznek.",
        rom: "Obiectele obtinute din aceasta cutie vor avea o calitate Bantuita.",
        swe: "F\xf6rem\xe5l som erh\xe5lls fr\xe5n denna l\xe5da kommer att ha den Hems\xf6kta kvaliteten.",
        fil: "Mga aytem na makukuha sa kahon ay magkakaroon ng kalidad na Haunted."
    },
    4: {
        eng: "Items obtained from this crate may have Strange and/or Unusual quality.",
        rus: "\u041F\u0440\u0435\u0434\u043C\u0435\u0442\u044B, \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u044B\u0435 \u0438\u0437 \u044D\u0442\u043E\u0433\u043E \u044F\u0449\u0438\u043A\u0430, \u043C\u043E\u0433\u0443\u0442 \u0438\u043C\u0435\u0442\u044C \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u043E \u0421\u0442\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0438/\u0438\u043B\u0438 \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430.",
        pol: "Przedmioty otrzymane z tej skrzynki mog\u0105 posiada\u0107 jako\u015B\u0107 Kuriozum i/lub Nietypowy Okaz.",
        sch: "\u4ECE\u8FD9\u4E2A\u7BB1\u5B50\u4E2D\u83B7\u5F97\u7684\u7269\u54C1\u53EF\u80FD\u5177\u6709\u5947\u5F02\u548C/\u6216\u7A00\u6709\u54C1\u8D28\u3002",
        bra: "Itens obtidos por essa caixa podem ter a qualidade Estranha e/ou Incomum.",
        fre: "Les objets obtenus de cette caisse peuvent \xeatre de qualit\xe9 \xc9trange et/ou Inhabituelle.",
        cze: "P\u0159edm\u011Bty z\xedskan\xe9 z t\xe9to krabice m\u016F\u017Eou m\xedt Strange a/nebo Unusual kvalitu.",
        hun: "Ebben a l\xe1d\xe1ban tal\xe1lhat\xf3 t\xe1rgyak Fura \xe9s/vagy Rendk\xedv\xfcli min\u0151s\xe9g\u0171ek lehetnek.",
        rom: "Obiectele obtinute din aceasta cutie pot avea calitate Stranie si/sau calitate Neobisnuita.",
        swe: "F\xf6rem\xe5l som erh\xe5lls fr\xe5n denna l\xe5da kan ha den Avvikande och/eller Ovanlig kvaliteten.",
        fil: "Mga aytem na makukuha sa kahon ay maaring Strange at/o Unusual na kalidad."
    },
    5: {
        eng: "Items obtained from this case may have Strange and/or Unusual quality.",
        rus: "\u041F\u0440\u0435\u0434\u043C\u0435\u0442\u044B, \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u044B\u0435 \u0438\u0437 \u044D\u0442\u043E\u0433\u043E \u043A\u0435\u0439\u0441\u0430, \u043C\u043E\u0433\u0443\u0442 \u0438\u043C\u0435\u0442\u044C \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u043E \u0421\u0442\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0438/\u0438\u043B\u0438 \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430.",
        pol: "Przedmioty otrzymane z tej skrzynki mog\u0105 posiada\u0107 jako\u015B\u0107 Kuriozum i/lub Nietypowy Okaz.",
        sch: "\u4ECE\u8FD9\u4E2A\u7BB1\u5B50\u4E2D\u83B7\u5F97\u7684\u7269\u54C1\u53EF\u80FD\u5177\u6709\u5947\u5F02\u548C/\u6216\u7A00\u6709\u54C1\u8D28\u3002",
        bra: "Itens obtidos por essa caixa podem ter a qualidade Estranha e/ou Incomum.",
        fre: "Les objets obtenus de cette caisse peuvent \xeatre de qualit\xe9 \xc9trange et/ou Inhabituelle.",
        cze: "P\u0159edm\u011Bty z\xedskan\xe9 z t\xe9to krabice m\u016F\u017Eou m\xedt Strange a/nebo Unusual kvalitu.",
        hun: "Ebben a t\xe1sk\xe1ban tal\xe1lhat\xf3 t\xe1rgyak Fura \xe9s/vagy Rendk\xedv\xfcli min\u0151s\xe9g\u0171ek lehetnek.",
        rom: "Obiectele obtinuite din aceasta cutie pot avea calitate Stranie si/sau calitate Neobisnuita.",
        swe: "F\xf6rem\xe5l som erh\xe5lls fr\xe5n denna l\xe5da kan ha den Avvikande och/eller Ovanlig kvaliteten.",
        fil: "Mga aytem na makukuha sa kaso ay maaring Strange at/o Unusual na kalidad."
    },
    6: {
        eng: "Weapons obtained from this crate will have the Strange quality and cosmetics might have the Strange quality.",
        rus: "\u041E\u0440\u0443\u0436\u0438\u0435, \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u043E\u0435 \u0438\u0437 \u044D\u0442\u043E\u0433\u043E \u044F\u0449\u0438\u043A\u0430, \u0431\u0443\u0434\u0435\u0442 \u0438\u043C\u0435\u0442\u044C \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u043E \u0421\u0442\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430, \u0430 \u043A\u043E\u0441\u043C\u0435\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0438\u043C\u0435\u0442\u044C \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u043E \u0421\u0442\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430.",
        pol: "Bronie otrzymane z tej skrzynki b\u0119d\u0105 posiada\u0142y jako\u015B\u0107 Kuriozum, a przedmioty ozdobne mog\u0105 posiada\u0107 jako\u015B\u0107 Kuriozum.",
        sch: "\u4ECE\u8FD9\u4E2A\u7BB1\u5B50\u4E2D\u83B7\u5F97\u7684\u6B66\u5668\u5177\u6709\u5947\u5F02\u54C1\u8D28\uFF0C\u9970\u54C1\u53EF\u80FD\u5177\u6709\u5947\u5F02\u54C1\u8D28\u3002",
        bra: "Armas obtidas por essa caixa ter\xe3o a qualidade Estranha e cosm\xe9ticos obtidos por essa caixa podem ter a qualidade Estranha.",
        fre: "Les armes obtenues de cette caisse seront de qualit\xe9 \xc9trange et les cosm\xe9tiques peuvent \xeatre de qualit\xe9 \xc9trange.",
        cze: "Zbran\u011B z\xedskan\xe9 z t\xe9to krabice budou m\xedt Strange kvalitu a kosmetick\xe9 p\u0159edm\u011Bty m\u016F\u017Eou m\xedt Strange kvalitu.",
        hun: "Ebben a l\xe1d\xe1ban tal\xe1lhat\xf3 fegyverek Fura min\u0151s\xe9g\u0171ek lesznek \xe9s a d\xedsz\xedt\u0151k Fura min\u0151s\xe9g\u0171ek lehetnek.",
        rom: "Armele obtinute din aceasta cutie vor avea o calitate Stranie iar cosmeticele pot avea o calitate Stranie.",
        swe: "Vapen som erh\xe5lls fr\xe5n denna l\xe5da kommer att ha den Avvikande kvaliteten, och kosmetiker kan ha den Avvikande kvaliteten.",
        fil: "Ang mga armas na makukuha sa kahon ay magkakaroon ng kalidad na Strange at ang mga kosmetiko ay maaring magkaroon ng Strange na kalidad."
    },
    7: {
        eng: "Items obtained from this crate may have Unusual quality.",
        rus: "\u041F\u0440\u0435\u0434\u043C\u0435\u0442\u044B, \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u044B\u0435 \u0438\u0437 \u044D\u0442\u043E\u0433\u043E \u044F\u0449\u0438\u043A\u0430, \u043C\u043E\u0433\u0443\u0442 \u0438\u043C\u0435\u0442\u044C \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u043E \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430.",
        pol: "Przedmioty otrzymane z tej skrzynki mog\u0105 posiada\u0107 jako\u015B\u0107 Nietypowy Okaz.",
        sch: "\u4ECE\u8FD9\u4E2A\u7BB1\u5B50\u4E2D\u83B7\u5F97\u7684\u7269\u54C1\u53EF\u80FD\u5177\u6709\u7A00\u6709\u54C1\u8D28\u3002",
        bra: "Itens obtidos por essa caixa podem ter qualidade Incomum.",
        fre: "Les objets obtenus de cette caisse peuvent \xeatre de qualit\xe9 Inhabituelle.",
        cze: "P\u0159edm\u011Bty z\xedskan\xe9 z t\xe9to krabice mohou m\xedt Unusual kvalitu.",
        hun: "Ebben a l\xe1d\xe1ban tal\xe1lhat\xf3 t\xe1rgyak Rendk\xedv\xfcli min\u0151s\xe9g\u0171ek lehetnek.",
        rom: "Obiectele obtinute din aceasta cutie pot avea calitate Neobisnuita.",
        swe: "F\xf6rem\xe5l som erh\xe5lls fr\xe5n denna l\xe5da kan ha den Ovanlig kvaliteten.",
        fil: "Mga aytem na makukuha sa kahon ay maaring Unusual na kalidad."
    },
    8: {
        eng: "Items obtained from this crate may have Strange and Haunted quality.",
        rus: "\u041F\u0440\u0435\u0434\u043C\u0435\u0442\u044B, \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u044B\u0435 \u0438\u0437 \u044D\u0442\u043E\u0433\u043E \u044F\u0449\u0438\u043A\u0430, \u043C\u043E\u0433\u0443\u0442 \u0438\u043C\u0435\u0442\u044C \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u043E \u0421\u0442\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0438 \u041F\u0440\u0438\u0437\u0440\u0430\u0447\u043D\u043E\u0433\u043E \u0432\u0438\u0434\u0430.",
        pol: "Przedmioty otrzymane z tej skrzynki mog\u0105 posiada\u0107 jako\u015B\u0107 Kuriozum i Przekle\u0144stwo.",
        sch: "\u4ECE\u8FD9\u4E2A\u7BB1\u5B50\u4E2D\u83B7\u5F97\u7684\u7269\u54C1\u53EF\u80FD\u5177\u6709\u5947\u5F02\u548C\u95F9\u9B3C\u54C1\u8D28\u3002",
        bra: "Itens obtidos por essa caixa podem ter qualidade Estranha e Assombrada.",
        fre: "Les objets obtenus de cette caisse peuvent \xeatre de qualit\xe9 \xc9trange et Hant\xe9e.",
        cze: "P\u0159edm\u011Bty z\xedskan\xe9 z t\xe9to krabice mohou m\xedt Strange a Haunted kvalitu.",
        hun: "Ebben a l\xe1d\xe1ban tal\xe1lhat\xf3 t\xe1rgyak Fura \xe9s K\xeds\xe9rtetj\xe1rta min\u0151s\xe9g\u0171ek lehetnek.",
        rom: "Obiectele obtinute din aceasta cutie pot avea calitate Stranie si calitate Bantuita.",
        swe: "F\xf6rem\xe5l som erh\xe5lls fr\xe5n denna l\xe5da kan ha den Avvikande och Hems\xf6kta kvaliteten.",
        fil: "Mga aytem na makukuha sa kahon ay maaring Strange o Haunted na kalidad."
    },
    9: {
        eng: "Options",
        rus: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
        pol: "Opcje",
        sch: "\u9009\u9879",
        bra: "Op\xe7\xf5es",
        fre: "Param\xe8tres",
        cze: "Nastaven\xed",
        hun: "Be\xe1ll\xedt\xe1sok",
        rom: "Optiuni",
        swe: "Alternativ",
        fil: "Pagpipilian"
    },
    10: {
        eng: "Statistics",
        rus: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430",
        pol: "Statystyki",
        sch: "\u7EDF\u8BA1",
        bra: "Estatisticas",
        fre: "Statistiques",
        cze: "Statistiky",
        hun: "Statisztik\xe1k",
        rom: "Statistici",
        swe: "Statistik",
        fil: "Istatistika"
    },
    11: {
        eng: "Grid view",
        rus: "\u0412\u0438\u0434 \u0441\u0435\u0442\u043A\u043E\u0439",
        pol: "Widok siatki",
        sch: "\u7F51\u683C\u89C6\u56FE",
        bra: "Visualiza\xe7\xe3o \xe0 grade",
        fre: "Vue en grille",
        cze: "M\u0159\xed\u017Ekovan\xfd pohled",
        hun: "T\xe1bl\xe1zat",
        rom: "Vizualizare grila",
        swe: "Rutn\xe4tvy",
        fil: "Tingnan ang parilya"
    },
    12: {
        eng: "Details view",
        rus: "\u0414\u0435\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u0432\u0438\u0434",
        pol: "Widok szczeg\xf3\u0142owy",
        sch: "\u8BE6\u60C5\u89C6\u56FE",
        bra: "Visualiza\xe7\xe3o de detalhes",
        fre: "Vue d\xe9taill\xe9e",
        cze: "Detailn\xed pohled",
        hun: "R\xe9szletes n\xe9zet",
        rom: "Vizualizare detalii",
        swe: "Detaljvy",
        fil: "Tingnan ang mga ditalye"
    },
    13: {
        eng: "Unbox my loot!",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043C\u043E\u0439 \u043B\u0443\u0442!",
        pol: "Otw\xf3rz skrzynk\u0119!",
        sch: "\u5F00\u542F\u6218\u5229\u54C1\uFF01",
        bra: "Desencaixotar a minha recompensa!",
        fre: "D\xe9baller mon butin!",
        cze: "Otev\u0159\xedt!",
        hun: "Zs\xe1km\xe1ny kibont\xe1sa!",
        rom: "Deschidemi bunurile!",
        swe: "\xd6ppna min byte!",
        fil: "Buksan ang aking sako!"
    },
    14: {
        eng: "Random crate",
        rus: "\u0421\u043B\u0443\u0447\u0430\u0439\u043D\u044B\u0439 \u044F\u0449\u0438\u043A",
        pol: "Losowa skrzynka",
        sch: "\u968F\u673A\u7BB1\u5B50",
        bra: "Caixa aleat\xf3ria",
        fre: "Caisse al\xe9atoire",
        cze: "N\xe1hodn\xe1 bedna",
        hun: "V\xe9letlenszer\u0171 l\xe1da",
        rom: "Cutie aleatorie",
        swe: "Slumpm\xe4ssig l\xe5da",
        fil: "Sapalaran na kahon"
    },
    15: {
        eng: "Return",
        rus: "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F",
        pol: "Wr\xf3\u0107",
        sch: "\u8FD4\u56DE",
        bra: "Retornar",
        fre: "Retour",
        cze: "Zp\xe1tky",
        hun: "Vissza",
        rom: "Intoarce",
        swe: "\xc5terv\xe4nd",
        fil: "Balik"
    },
    16: {
        eng: "Effects",
        rus: "\u042D\u0444\u0444\u0435\u043A\u0442\u044B",
        pol: "Efekty",
        sch: "\u6548\u679C",
        bra: "Efeitos",
        fre: "Effets",
        cze: "Efekty",
        hun: "Effektek",
        rom: "Efecte",
        swe: "Effekter",
        fil: "Mga epekto"
    },
    17: {
        eng: "Loot",
        rus: "\u041F\u0440\u0435\u0434\u043C\u0435\u0442\u044B",
        pol: "Przedmioty",
        sch: "\u6218\u5229\u54C1",
        bra: "Recompensas",
        fre: "Butin",
        cze: "P\u0159edm\u011Bty",
        hun: "Zs\xe1km\xe1ny",
        rom: "Bunuri",
        swe: "Byte",
        fil: "Sako"
    },
    18: {
        eng: "More info",
        rus: "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435",
        pol: "Wi\u0119cej informacji",
        sch: "\u66F4\u591A\u4FE1\u606F",
        bra: "Mais informa\xe7\xf5es",
        fre: "Plus d'informations",
        cze: "V\xedce informac\xed",
        hun: "Tov\xe1bbi inform\xe1ci\xf3k",
        rom: "Mai multe informatii",
        swe: "Mer information",
        fil: "Iba pang impormasyon"
    },
    19: {
        eng: "Unbox again",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0441\u043D\u043E\u0432\u0430",
        pol: "Otw\xf3rz kolejn\u0105",
        sch: "\u518D\u6B21\u5F00\u7BB1",
        bra: "Desencaixotar novamente",
        fre: "D\xe9baller \xe0 nouveau",
        cze: "Otev\u0159\xedt znova",
        hun: "Kinyit\xe1s \xfajb\xf3l",
        rom: "Deschide iar",
        swe: "\xd6ppna igen",
        fil: "Ibuksan ulit"
    },
    20: {
        eng: "General",
        rus: "\u041E\u0431\u0449\u0435\u0435",
        pol: "Og\xf3lne",
        sch: "\u5E38\u89C4",
        bra: "Geral",
        fre: "G\xe9n\xe9ral",
        cze: "P\u0159ehled",
        hun: "\xc1ltal\xe1nos",
        rom: "General",
        swe: "Allm\xe4n",
        fil: "Pangkalahatan"
    },
    21: {
        eng: "Unusuals",
        rus: "\u041D\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430",
        pol: "Nietypowe Okazy",
        sch: "\u7A00\u6709",
        bra: "Incomuns",
        fre: "Inhabituels",
        cze: "Unusual p\u0159edm\u011Bty",
        hun: "Rendk\xedv\xfcliek",
        rom: "Obiecte neobisnuite",
        swe: "Ovanliga"
    },
    22: {
        eng: "Inventory",
        rus: "\u0418\u043D\u0432\u0435\u043D\u0442\u0430\u0440\u044C",
        pol: "Ekwipunek",
        sch: "\u5E93\u5B58",
        bra: "Invent\xe1rio",
        fre: "Inventaire",
        cze: "Invent\xe1\u0159",
        hun: "Lelt\xe1r",
        rom: "Inventar",
        swe: "Lager",
        fil: "Imbentaryo"
    },
    23: {
        eng: "Return to main menu",
        rus: "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u0432 \u0433\u043B\u0430\u0432\u043D\u043E\u0435 \u043C\u0435\u043D\u044E",
        pol: "Wr\xf3\u0107 do menu g\u0142\xf3wnego",
        sch: "\u8FD4\u56DE\u4E3B\u83DC\u5355",
        bra: "Retornar ao menu principal",
        fre: "Retour au menu principal",
        cze: "Zp\u011Bt na hlavn\xed menu",
        hun: "Vissza a f\u0151men\xfcbe",
        rom: "Intoarce-te la meniu",
        swe: "\xc5terv\xe4nd till huvudmenyn",
        fil: "Bumalik sa pangunahing menu"
    },
    24: {
        eng: "Return to list",
        rus: "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043A \u0441\u043F\u0438\u0441\u043A\u0443",
        pol: "Wr\xf3\u0107 do listy",
        sch: "\u8FD4\u56DE\u5217\u8868",
        bra: "Retornar \xe0 lista",
        fre: "Retour \xe0 la liste",
        cze: "Zp\xe1tky do Invent\xe1\u0159e",
        hun: "Vissza a list\xe1hoz",
        rom: "Intoarce-te la lista",
        swe: "\xc5terv\xe4nd till lista",
        fil: "Bumalik sa listahan"
    },
    25: {
        eng: "Changelog",
        rus: "\u0421\u043F\u0438\u0441\u043E\u043A \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439",
        pol: "Lista zmian",
        sch: "\u66F4\u65B0\u65E5\u5FD7",
        bra: "Hist\xf3rico de mudan\xe7as",
        fre: "Changements r\xe9cents",
        cze: "P\u0159ehled zm\u011Bn",
        hun: "V\xe1ltoz\xe1si napl\xf3",
        rom: "Actualizari",
        swe: "F\xf6r\xe4ndringslogg",
        fil: "Ang pagbabago"
    },
    26: {
        eng: "Credits",
        rus: "\u0410\u0432\u0442\u043E\u0440\u044B",
        pol: "Tw\xf3rcy",
        sch: "\u5F00\u53D1\u4EBA\u5458",
        bra: "Cr\xe9ditos",
        fre: "Cr\xe9dits",
        cze: "Pod\u011Bkov\xe1n\xed",
        hun: "K\xe9sz\xedt\u0151k",
        rom: "Credite",
        swe: "Medverkande",
        fil: "Mga Kredito"
    },
    27: {
        eng: "Off",
        rus: "\u0412\u044B\u043A\u043B",
        pol: "Wy\u0142.",
        sch: "\u5173",
        bra: "Desativado",
        fre: "D\xe9sactiv\xe9",
        cze: "Vyp",
        hun: "Ki",
        rom: "Oprit",
        swe: "Av",
        fil: "Ipatay"
    },
    28: {
        eng: "On",
        rus: "\u0412\u043A\u043B",
        pol: "W\u0142.",
        sch: "\u5F00",
        bra: "Ativado",
        fre: "Activ\xe9",
        cze: "Zap",
        hun: "Be",
        rom: "Deschis",
        swe: "P\xe5",
        fil: "Ibukas"
    },
    29: {
        eng: "Reset",
        rus: "\u0421\u0431\u0440\u043E\u0441",
        pol: "Resetuj",
        sch: "\u91CD\u7F6E",
        bra: "Resetar",
        fre: "R\xe9initialiser",
        cze: "Reset",
        hun: "Vissza\xe1ll\xedt\xe1s",
        rom: "Resetare",
        swe: "\xc5terst\xe4ll",
        fil: "I-reset"
    },
    30: {
        eng: "This crate contains one of the following items:",
        rus: "\u042D\u0442\u043E\u0442 \u044F\u0449\u0438\u043A \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043E\u0434\u0438\u043D \u0438\u0437 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432:",
        pol: "Ta skrzynka zawiera jeden z nast\u0119puj\u0105cych przedmiot\xf3w:",
        sch: "\u8FD9\u4E2A\u7BB1\u5B50\u5305\u542B\u4E0B\u5217\u7269\u54C1\u4E4B\u4E00\uFF1A",
        bra: "Essa caixa cont\xe9m um dos itens a seguir:",
        fre: "Cette caisse contient un des objets suivant:",
        cze: "Tato krabice obsahuje jeden z n\xe1sleduj\xedc\xedch p\u0159edm\u011Bt\u016F:",
        hun: "Ez a l\xe1da az al\xe1bbiak egyik\xe9t tartalmazza:",
        rom: "Aceasta cutie contine unul dintre urmatoarele obiecte:",
        swe: "Denna l\xe5da inneh\xe5ller n\xe5got av f\xf6ljande:",
        fil: "Itong kahon ay naglalaman ng isa sa sumusunod na mga aytem:"
    },
    31: {
        eng: "Unusuals may have one of the following effects:",
        rus: "\u041D\u0435\u043E\u0431\u044B\u0447\u043D\u044B\u0435 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0438\u043C\u0435\u0442\u044C \u043E\u0434\u0438\u043D \u0438\u0437 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u044D\u0444\u0444\u0435\u043A\u0442\u043E\u0432:",
        pol: "Nietypowe Okazy mog\u0105 posiada\u0107 jeden z nast\u0119puj\u0105cych efekt\xf3w:",
        sch: "\u7A00\u6709\u7269\u54C1\u53EF\u80FD\u542B\u6709\u4EE5\u4E0B\u6548\u679C\u4E4B\u4E00\uFF1A",
        bra: "Itens incomuns poder\xe3o ter um dos efeitos a seguir:",
        fre: "Les objets Inhabituels peuvent \xeatre parmis les effets suivant:",
        cze: "Unusual p\u0159edm\u011Bty budou mohou m\xedt jeden z n\xe1sleduj\xedc\xedch efekt\u016F:",
        hun: "A Rendk\xedv\xfcli effektek az al\xe1bbiak egyike lehet:",
        rom: "Obiectele Neobisnuite pot avea unul dintre urmatoarele efecte:",
        swe: "Ovanliga f\xf6rem\xe5l kan ha en av f\xf6ljande effekter:",
        fil: "Unusuals ay maaring merong isa sa sumusunod na mga epekto:"
    },
    32: {
        eng: "Unusuals cannot be unboxed from this crate.",
        rus: "\u041D\u0435\u043E\u0431\u044B\u0447\u043D\u044B\u0435 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u044B \u043D\u0435 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u044B \u0438\u0437 \u044D\u0442\u043E\u0433\u043E \u044F\u0449\u0438\u043A\u0430.",
        pol: "Ta skrzynka nie zawiera Nietypowych Okaz\xf3w.",
        sch: "\u65E0\u6CD5\u4ECE\u8FD9\u4E2A\u7BB1\u5B50\u4E2D\u83B7\u5F97\u7A00\u6709\u7269\u54C1\u3002",
        bra: "Itens incomuns n\xe3o poder\xe3o ser obtidos por essa caixa.",
        fre: "Les objets Inhabituels ne peuvent pas \xeatre d\xe9ball\xe9s de cette caisse.",
        cze: "Unusual p\u0159edm\u011Bty nem\u016F\u017Eou b\xfdt z\xedsk\xe1ny z t\xe9to krabice.",
        hun: "Ebb\u0151l a l\xe1d\xe1b\xf3l nem nyithat\xf3k Rendk\xedv\xfcliek",
        rom: "Nu se pot deschide obiecte Neobisnuite din aceasta cutie.",
        swe: "Ovanliga f\xf6rem\xe5l kan inte \xf6ppnas fr\xe5n denna l\xe5da.",
        fil: "Hindi maaring magbukas ng Unusuals sa kahon na ito."
    },
    33: {
        eng: "Unboxing your loot",
        rus: "\u0418\u0434\u0435\u0442 \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u0435 \u044F\u0449\u0438\u043A\u0430...",
        pol: "Odpakowywanie twojego \u0142upu",
        sch: "\u6B63\u5728\u5F00\u542F\u60A8\u7684\u6218\u5229\u54C1",
        bra: "Desencaixotando a sua recompensa",
        fre: "D\xe9ballement du butin",
        cze: "Rozbalov\xe1n\xed obsahu",
        hun: "Zs\xe1km\xe1nyod kinyit\xe1sa",
        rom: "Deschizanduti bunurile",
        swe: "\xd6ppnar ditt byte",
        fil: "Binubukas ang iyong sako"
    },
    34: {
        eng: "New item acquired!",
        rus: "\u041F\u043E\u043B\u0443\u0447\u0435\u043D \u043D\u043E\u0432\u044B\u0439 \u043F\u0440\u0435\u0434\u043C\u0435\u0442!",
        pol: "Zdobyto nowy przedmiot!",
        sch: "\u5DF2\u83B7\u5F97\u65B0\u7269\u54C1\uFF01",
        bra: "Novo item adquirido!",
        fre: "Nouvel objet acquis!",
        cze: "Z\xedskal jsi nov\xfd p\u0159edm\u011Bt!",
        hun: "\xdaj t\xe1rgyat kapt\xe1l!",
        rom: "Obiect nou dobandit!",
        swe: "Nytt f\xf6rem\xe5l inf\xf6rskaffad!",
        fil: "Bagong aytem ang nakuha mo!"
    },
    35: {
        eng: 'You <span id="unboxedtext">unboxed</span>:',
        rus: '\u0412\u044B <span id="unboxedtext">\u043E\u0442\u043A\u0440\u044B\u043B\u0438</span>:',
        pol: '<span id="unboxedtext">Odpakowujesz</span>:',
        sch: '\u60A8<span id="unboxedtext">\u5F00\u51FA\u4E86</span>\uFF1A',
        bra: 'Voc\xea <span id="unboxedtext">desencaixotou</span>:',
        fre: 'Vous <span id="unboxedtext">avez ouvert</span>:',
        cze: '<span id="unboxedtext">Otev\u0159el jsi</span>:',
        hun: '<span id="unboxedtext">Kibontottad</span>:',
        rom: 'Tu <span id="unboxedtext">deschis</span>:',
        swe: 'Du <span id="unboxedtext">\xf6ppnade</span>:',
        fil: 'Ikaw ay <span id="unboxedtext">bumukas</span>'
    },
    36: {
        eng: "\u2605 Unusual Effect: ",
        rus: "\u2605 \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u044B\u0439 \u044D\u0444\u0444\u0435\u043A\u0442: ",
        pol: "\u2605 Efekt: ",
        sch: "\u2605 \u7C92\u5B50\u6548\u679C\uFF1A",
        bra: "\u2605 Efeito Incomum: ",
        fre: "\u2605 Effet Inhabituel: ",
        cze: "\u2605 Unusual Efekt:",
        hun: "\u2605 Rendk\xedv\xfcli effekt:",
        rom: "\u2605 Efect Neobisnuit: ",
        swe: "\u2605 Ovanlig effekt: ",
        fik: "\u2605 Unusual epekto:"
    },
    37: {
        eng: "Chance to unbox:",
        rus: "\u0428\u0430\u043D\u0441 \u0432\u044B\u043F\u0430\u0434\u0435\u043D\u0438\u044F:",
        pol: "Szansa na zdobycie:",
        sch: "\u5F00\u51FA\u51E0\u7387\uFF1A",
        bra: "Chance de desencaixotar:",
        fre: "Chances de d\xe9baller:",
        cze: "\u0160ance na otev\u0159en\xed:",
        hun: "Es\xe9ly a kibont\xe1sra:",
        rom: "Sansa de a deschide:",
        swe: "M\xf6jlighet att \xf6ppna:",
        fil: "Tsansa sa pagbubukas:"
    },
    38: {
        eng: "Times unboxed:",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u043E \u0440\u0430\u0437:",
        pol: "Ilo\u015B\u0107 posiadanych:",
        sch: "\u5F00\u51FA\u6B21\u6570\uFF1A",
        bra: "Vezes desencaixotadas:",
        fre: "Quantit\xe9 d\xe9ball\xe9e:",
        cze: "Otev\u0159eno tolikr\xe1t:",
        hun: "Kibontva ennyiszer:",
        rom: "Numarul deschiderilor:",
        swe: "G\xe5nger \xf6ppnad:",
        fil: "Ilang times nabukas:"
    },
    39: {
        eng: "Unboxes since last Unusual:",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u0438\u0439 \u0441 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u0430 \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430:",
        pol: "Otwarcia pod rz\u0105d bez Nietypowego Okazu:",
        sch: "\u81EA\u4E0A\u4E2A\u7A00\u6709\u4EE5\u6765\u5F00\u7BB1\u6570\uFF1A",
        bra: "Desencaixotes desde o \xfaltimo item Incomum:",
        fre: "Caisses d\xe9ball\xe9es depuis le dernier Inhabituel:",
        cze: "Otev\u0159en\xed od posledn\xedho Unusual p\u0159edm\u011Btu:",
        hun: "Kibont\xe1sok az utols\xf3 Rendk\xedv\xfcli \xf3ta:",
        rom: "Deschideri de la ultimul obiect Neobisnuit:",
        swe: "Antalet \xf6ppnade sedan senaste Ovanliga f\xf6rem\xe5l:",
        fil: "Mga nabukas mula noong huling Unusual:"
    },
    40: {
        eng: "Unusuals unboxed:",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u043E \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430:",
        pol: "Otrzymane Nietypowe Okazy:",
        sch: "\u5DF2\u5F00\u51FA\u7A00\u6709\uFF1A",
        bra: "Itens Incomuns desencaixotados:",
        fre: "Inhabituels d\xe9ball\xe9s:",
        cze: "Z\xedsk\xe1no Unusual p\u0159edm\u011Bt\u016F:",
        hun: "Rendk\xedv\xfcliek kibontva:",
        rom: "Obiecte Neobisnuite deschise:",
        swe: "Ovanliga f\xf6rem\xe5l \xf6ppnade:",
        fil: "Nabukas na Unusual:"
    },
    41: {
        eng: "Total crates/cases opened:",
        rus: "\u0412\u0441\u0435\u0433\u043E \u043E\u0442\u043A\u0440\u044B\u0442\u043E \u044F\u0449\u0438\u043A\u043E\u0432/\u043A\u0435\u0439\u0441\u043E\u0432:",
        pol: "Otwarte skrzynki:",
        sch: "\u5DF2\u5F00\u7BB1\uFF1A",
        bra: "Total de caixas abertas:",
        fre: "Total des caisses d\xe9ball\xe9es:",
        cze: "Rozbalen\xe9 krabice/bedny:",
        hun: "Kibontott l\xe1d\xe1k/t\xe1sk\xe1k sz\xe1ma \xf6sszesen:",
        rom: "Totalitatea cutiilor deschise:",
        swe: "Totalt \xf6ppnade l\xe5dor:",
        fil: "Kabuuan na kahon/kaso nabukas:"
    },
    42: {
        eng: "Money wasted on keys:",
        rus: "\u041F\u043E\u0442\u0440\u0430\u0447\u0435\u043D\u043E \u0434\u0435\u043D\u0435\u0433 \u043D\u0430 \u043A\u043B\u044E\u0447\u0438:",
        pol: "Pieni\u0105dze zmarnowane na klucze:",
        sch: "\u94A5\u5319\u603B\u82B1\u8D39\uFF1A",
        bra: "Dinheiro gastado em chaves:",
        fre: "Argent gaspill\xe9e sur les cl\xe9es:",
        cze: "Pen\xedze utracen\xe9 za kl\xed\u010De:",
        hun: "Kulcsokra elpazarolt p\xe9nz:",
        rom: "Bani folositi pe chei:",
        swe: "Pengar som sl\xf6sas bort p\xe5 nycklar:",
        fil: "Pera nasayang sa mga keys:"
    },
    43: {
        eng: "Shortest Unusual drought:",
        rus: "\u0421\u0430\u043C\u0430\u044F \u043A\u043E\u0440\u043E\u0442\u043A\u0430\u044F \u0441\u0435\u0440\u0438\u044F \u0431\u0435\u0437 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430:",
        pol: "Najkr\xf3tsza przerwa w Nietypowych Okazach:",
        sch: "\u8FDE\u7EED\u672A\u5F00\u51FA\u7A00\u6709\u6700\u77ED\u8BB0\u5F55\uFF1A",
        bra: "A menor seca de itens Incomuns:",
        fre: "Suite \xe0 sec d'Inhabituel la plus courte:",
        cze: "Nejkrat\u0161\xed prodleva mezi Unusual p\u0159edm\u011Bty:",
        hun: "K\xe9t Rendk\xedv\xfcli k\xf6z\xf6tt kinyitott legkevesebb l\xe1da/t\xe1ska:",
        rom: "Cele mai putine cutii deschise fara a deschide un obiect Neobisnuit:",
        swe: "Kortaste Ovanliga f\xf6rem\xe5l-torka:",
        fil: "Pinakamaikling kawalan ng Unusual:"
    },
    44: {
        eng: "Longest Unusual drought:",
        rus: "\u0421\u0430\u043C\u0430\u044F \u0434\u043B\u0438\u043D\u043D\u0430\u044F \u0441\u0435\u0440\u0438\u044F \u0431\u0435\u0437 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430:",
        pol: "Najd\u0142u\u017Csza przerwa w Nietypowych Okazach:",
        sch: "\u8FDE\u7EED\u672A\u5F00\u51FA\u7A00\u6709\u6700\u957F\u8BB0\u5F55\uFF1A",
        bra: "A maior seca de itens Incomuns:",
        fre: "Suite \xe0 sec d 'Inhabituel la plus longue:",
        cze: "Nejdel\u0161\xed prodleva mezi Unusual p\u0159edm\u011Bty:",
        hun: "K\xe9t Rendk\xedv\xfcli k\xf6z\xf6tt kinyitott legt\xf6bb l\xe1da/t\xe1ska:",
        rom: "Cele mai multe cutii deschise fara a deschide un obiect Neobisnuit:",
        swe: "L\xe4ngsta Ovanliga f\xf6rem\xe5l-torka:",
        fil: "Pinakamahabang kawalan ng Unusual:"
    },
    45: {
        eng: '<span class="colorunique">Unique</span> items unboxed:',
        rus: '<span class="colorunique">\u0423\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445</span> \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u043E\u0442\u043A\u0440\u044B\u0442\u043E:',
        pol: 'Zdobyte <span class="colorunique">Unikalne</span> przedmioty:',
        sch: '\u5DF2\u5F00\u51FA<span class="colorunique">\u72EC\u7279</span>\u7269\u54C1\uFF1A',
        bra: 'Itens <span class="colorunique">\xdanicos</span> desencaixotados:',
        fre: 'Objet d\xe9ball\xe9 <span class="colorunique">Unique</span>:',
        cze: '<span class="colorunique">Unique</span> p\u0159edm\u011Bt\u016F z\xedsk\xe1no:',
        hun: '<span class="colorunique">Egyedi</span> t\xe1rgyak kibontva:',
        rom: '<span class="colorunique">unic</span> obiecte deschise:',
        swe: '<span class="colorunique">Unika</span> f\xf6rem\xe5l \xf6ppnade:',
        fil: '<span class="colorunique">Unique</span> aytem nabukas:'
    },
    46: {
        eng: '<span class="colorstrange">Strange</span> items unboxed:',
        rus: '<span class="colorstrange">\u0421\u0442\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430</span> \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u043E\u0442\u043A\u0440\u044B\u0442\u043E:',
        pol: 'Zdobyte przedmioty <span class="colorstrange">Kuriozalne</span>:',
        sch: '\u5DF2\u5F00\u51FA<span class="colorstrange">\u5947\u5F02</span>\u7269\u54C1\uFF1A',
        bra: 'Itens <span class="colorstrange">Estranhos</span> desencaixotados:',
        fre: 'Objet d\xe9ball\xe9 <span class="colorstrange">\xc9trange</span>:',
        cze: '<span class="colorstrange">Strange</span> p\u0159edm\u011Bt\u016F z\xedsk\xe1no:',
        hun: '<span class="colorstrange">Fura</span> t\xe1rgyak kibontva:',
        rom: '<span class="colorstrange">Straniu</span> obiecte deschise:',
        swe: '<span class="colorstrange">Avvikande</span> f\xf6rem\xe5l \xf6ppnade:',
        fil: '<span class="colorstrange">Strange</span> aytem nabukas:'
    },
    47: {
        eng: '<span class="colorhaunted">Haunted</span> items unboxed:',
        rus: '<span class="colorhaunted">\u041F\u0440\u0438\u0437\u0440\u0430\u0447\u043D\u043E\u0433\u043E \u0432\u0438\u0434\u0430</span> \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u043E\u0442\u043A\u0440\u044B\u0442\u043E:',
        pol: 'Zdobyte <span class="colorhaunted">Przekl\u0119te</span> przedmioty:',
        sch: '\u5DF2\u5F00\u51FA<span class="colorhaunted">\u95F9\u9B3C</span>\u7269\u54C1\uFF1A',
        bra: 'Itens <span class="colorhaunted">Assombrados</span> desencaixotados:',
        fre: 'Objet d\xe9ball\xe9 <span class="colorhaunted">Hant\xe9</span>:',
        cze: '<span class="colorhaunted">Haunted</span> p\u0159edm\u011Bt\u016F z\xedsk\xe1no:',
        hun: '<span class="colorhaunted">K\xeds\xe9rtetj\xe1rta</span> t\xe1rgyak kibontva:',
        rom: '<span class="colorhaunted">Bantuit</span> obiecte deschise:',
        swe: '<span class="colorhaunted">Hems\xf6kta</span> f\xf6rem\xe5l \xf6ppnade:',
        fil: '<span class="colorhaunted">Haunted</span> aytem nabukas:'
    },
    48: {
        eng: '<span class="colordecorated">Decorated</span> items unboxed:',
        rus: '<span class="colordecorated">\u0420\u0430\u0441\u043A\u0440\u0430\u0448\u0435\u043D\u043D\u043E\u0435</span> \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u043E\u0442\u043A\u0440\u044B\u0442\u043E:',
        pol: 'Zdobyte <span class="colordecorated">Dekorowane</span> przedmioty:',
        sch: '\u5DF2\u5F00\u51FA<span class="colordecorated">\u88C5\u9970</span>\u7269\u54C1\uFF1A',
        bra: 'Itens <span class="colordecorated">Decorados</span> desencaixotados:',
        fre: 'Objet d\xe9ball\xe9 <span class="colordecorated">D\xe9cor\xe9</span>:',
        cze: '<span class="colordecorated">Decorated</span> p\u0159edm\u011Bt\u016F z\xedsk\xe1no:',
        hun: '<span class="colordecorated">D\xedsz\xedtett fegyverek</span> kibontva:',
        rom: '<span class="colordecorated">Decorat</span> obiecte deschise:',
        swe: '<span class="colordecorated">Decorated</span> f\xf6rem\xe5l \xf6ppnade:',
        fil: '<span class="colordecorated">Decorated</span> aytem nabukas:'
    },
    49: {
        eng: '<span class="colorunusual">Unusuals</span> unboxed:',
        rus: '<span class="colorunusual">\u041D\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430</span> \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u043E\u0442\u043A\u0440\u044B\u0442\u043E:',
        pol: 'Zdobyte <span class="colorunusual">Nietypowe Okazy</span>:',
        sch: '\u5DF2\u5F00\u51FA<span class="colorunusual">\u7A00\u6709</span>\u7269\u54C1\uFF1A',
        bra: 'Itens <span class="colorunusual">Incomuns</span> desencaixotados:',
        fre: 'Objet d\xe9ball\xe9 <span class="colordecorated">Inhabituel</span>:',
        cze: '<span class="colorunusual">Unusual</span> p\u0159edm\u011Bt\u016F z\xedsk\xe1no:',
        hun: '<span class="colorunusual">Rendk\xedv\xfcliek</span> kibontva:',
        rom: '<span class="colorunusual">Neobisnuite</span> deschis:',
        swe: '<span class="colorunusual">Ovanliga</span> f\xf6rem\xe5l \xf6ppnade:',
        fil: '<span class="colorunusual">Unusuals</span> nabukas:'
    },
    50: {
        eng: "No unusuals... yet.",
        rus: "\u041F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442.",
        pol: "Brak Nietypowych Okaz\xf3w.",
        sch: "\u8FD8...\u6CA1\u6709\u7A00\u6709\u7269\u54C1\u3002",
        bra: "Nenhum item Incomum... por enquanto.",
        fre: "Pas d'inhabituels...pour l 'instant.",
        cze: "Zat\xedm \u017E\xe1dn\xe9 Unusual p\u0159edm\u011Bty... zat\xedm.",
        hun: "Nincsenek Rendk\xedv\xfcliek... m\xe9g.",
        rom: "Niciun obiect Neobisnuit... inca.",
        swe: "Inga Ovanliga f\xf6rem\xe5l... \xe4n.",
        fil: "Wala pang unusuals... hanggat sa ngayon."
    },
    51: {
        eng: 'Unboxed <span id="statscratesdetailsunbox">0</span> times',
        rus: '\u041E\u0442\u043A\u0440\u044B\u0442\u043E <span id="statscratesdetailsunbox">0</span> \u0440\u0430\u0437',
        pol: 'Otwarto <span id="statscratesdetailsunbox">0</span> razy',
        sch: '\u5F00\u7BB1 <span id="statscratesdetailsunbox">0</span> \u6B21',
        bra: 'Desencaixotado <span id="statscratesdetailsunbox">0</span> vezes',
        fre: 'D\xe9bal\xe9 <span id="statscratesdetailsunbox">0</span> fois',
        cze: 'Otev\u0159eno <span id="statscratesdetailsunbox">0</span> kr\xe1t',
        hun: 'Kibontva ennyiszer: <span id="statscratesdetailsunbox">0</span>',
        rom: 'Deschis <span id="statscratesdetailsunbox">0</span> timpuri',
        swe: '\xd6ppnad <span id="statscratesdetailsunbox">0</span> g\xe5nger',
        fil: 'Ilang <span id="statscratesdetailsunbox">0</span> nabukas'
    },
    52: {
        eng: "No items... yet.<br>Go open some crates!",
        rus: "\u041F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442.<br>\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u044F\u0449\u0438\u043A\u043E\u0432!",
        pol: "Brak przedmiot\xf3w.<br>Id\u017A pootwiera\u0107 skrzynki!",
        sch: "\u8FD8...\u6CA1\u6709\u4EFB\u4F55\u7269\u54C1\u3002<br>\u53BB\u5F00\u542F\u4E00\u4E9B\u7BB1\u5B50\u5427\uFF01",
        bra: "Sem itens... por enquanto.<br>Vai abrir algumas caixas!",
        fre: "Pas d'objets... pour l 'instant.<br>Allez d\xe9baller des caisses!",
        cze: "Zat\xedm \u017E\xe1dn\xe9 p\u0159edm\u011Bty.. zat\xedm.<br>B\u011B\u017E otev\u0159\xedt n\u011Bjak\xe9 bedny!",
        hun: "Nincsenek t\xe1rgyak... m\xe9g.<br>Nyiss ki p\xe1r l\xe1d\xe1t!",
        rom: "Niciun obict... inca.<br>Deschide niste cutii!",
        swe: "Inga f\xf6rem\xe5l... \xe4n.<br>G\xe5 och \xf6ppna n\xe5gra l\xe5dor!",
        fil: "Wala pang unusuals... hanggat ngayon.<br>Magbukas ka ng mga kahon!"
    },
    53: {
        eng: "Unboxed ",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u043E ",
        pol: "Otrzymano ",
        sch: "\u5F00\u51FA ",
        bra: "Desencaixotou ",
        fre: "D\xe9ball\xe9 ",
        cze: "Otev\u0159eno ",
        hun: "Kibontva",
        rom: "Deschis ",
        swe: "\xd6ppnad ",
        fil: "Nabukas "
    },
    54: {
        eng: " times",
        rus: " \u0440\u0430\u0437",
        pol: " razy",
        sch: " \u6B21",
        bra: " vezes",
        fre: " fois",
        cze: " kr\xe1t",
        hun: " alkalommal",
        rom: " timpuri",
        swe: " g\xe5nger",
        fil: " beses"
    },
    55: {
        eng: "Language:",
        rus: "\u042F\u0437\u044B\u043A:",
        pol: "J\u0119zyk:",
        sch: "\u8BED\u8A00\uFF1A",
        bra: "Idioma:",
        fre: "Langue:",
        cze: "Jazyk:",
        hun: "Nyelv:",
        rom: "Limba:",
        swe: "Spr\xe5k:",
        fil: "Lengguwahe:"
    },
    56: {
        eng: "Fast unboxing:",
        rus: "\u0411\u044B\u0441\u0442\u0440\u043E\u0435 \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u0435:",
        pol: "Szybkie otwieranie:",
        sch: "\u5FEB\u901F\u5F00\u7BB1\uFF1A",
        bra: "Desencaixotamento r\xe1pido:",
        fre: "D\xe9ballage rapide:",
        cze: "Rychl\xe9 otev\xedr\xe1n\xed:",
        hun: "Gyors kibont\xe1s:",
        rom: "Deschidere rapida:",
        swe: "Snabb\xf6ppning:",
        fil: "Pag-bilis sa bukas:"
    },
    57: {
        eng: 'Skips the unboxing countdown.<br>Also allows you to unbox rapidly by holding Space or the "Unbox again" button on the crate results screen.',
        rus: '\u041F\u0440\u043E\u043F\u0443\u0441\u043A\u0430\u0435\u0442 \u0430\u043D\u0438\u043C\u0430\u0446\u0438\u044E \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F.<br>\u0422\u0430\u043A\u0436\u0435 \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u0431\u044B\u0441\u0442\u0440\u043E \u043E\u0442\u043A\u0440\u044B\u0432\u0430\u0442\u044C \u044F\u0449\u0438\u043A\u0438, \u0443\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u044F \u041F\u0440\u043E\u0431\u0435\u043B \u0438\u043B\u0438 \u043A\u043D\u043E\u043F\u043A\u0443 "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0441\u043D\u043E\u0432\u0430" \u043D\u0430 \u044D\u043A\u0440\u0430\u043D\u0435 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432.',
        pol: 'Pomija odliczanie podczas otwierania skrzynek.<br>Pozwala tak\u017Ce na szybkie otwieranie skrzynek, przytrzymuj\u0105c spacj\u0119 lub przycisk "Otw\xf3rz kolejn\u0105" na ekranie wynik\xf3w otwarcia.',
        sch: "\u8DF3\u8FC7\u5F00\u7BB1\u5012\u8BA1\u65F6\u3002 <br>\u8FD9\u4E5F\u4F7F\u60A8\u53EF\u4EE5\u6309\u4F4F\u7A7A\u683C\u952E\u6216\u8005\u70B9\u51FB\u5F00\u7BB1\u7ED3\u679C\u7684\u201C\u518D\u6B21\u5F00\u7BB1\u201D\u6309\u94AE\u6765\u5FEB\u901F\u5F00\u7BB1\u3002",
        bra: 'Desativa a contagem regressiva.<br>Tamb\xe9m permite que voc\xea desencaixote rapidamente segurando a tecla Espa\xe7o ou o bot\xe3o "Desencaixotar novamente" nos resultados do seu desencaixotamento.',
        fre: "Saute le compte-\xe0-rebours du d\xe9ballage.",
        cze: 'P\u0159eskakuje rozbalovac\xed odpo\u010Det.<br>Takt\xe9\u017E umo\u017E\u0148uje rychl\xe9 otev\xedr\xe1n\xed dr\u017Een\xedm mezern\xedku nebo "Otev\u0159\xedt znova" tla\u010D\xedtka na obrazovce v\xfdsledk\u016F.',
        hun: 'Kihagyja a visszasz\xe1ml\xe1l\xe1st kibont\xe1skor.<br>\xcdgy tudsz gyorsabban kibontani a Space gomb lenyomva tart\xe1s\xe1val vagy a "Kinyit\xe1s \xfajb\xf3l" gomb lenyom\xe1s\xe1val a kibontott zs\xe1km\xe1ny k\xe9perny\u0151n.',
        rom: 'Treci peste timpul pentru deschiderea cutiei.<br>Deasemenea iti permite sa deschizi rapid tinand apasat Space sau butonul "Deschide iar" afisat pe ecranul rezultatului cutiei.',
        swe: 'Hoppar \xf6ver nedr\xe4kningen f\xf6r \xf6ppningen.<br>L\xe5ter dig ocks\xe5 \xf6ppna snabbt genom att h\xe5lla ner mellanslag eller knappen "\xd6ppna igen" p\xe5 l\xe5dans resultatsk\xe4rm.',
        fil: 'I-skip ang pag-bilang ng pagbubukas.<br>Ay rin pinapayagan ka magbukas ng mabilis ipag hinawakan mo ang Space o ang "Ibuksan ulit" button sa mga resulta ng mga kahon na screen.'
    },
    58: {
        eng: "Amoled theme:",
        rus: "AMOLED \u0442\u0435\u043C\u0430:",
        pol: "Tryb Amoled:",
        sch: "Amoled \u4E3B\u9898\uFF1A",
        bra: "Tema escuro:",
        fre: "Th\xe8me Amoled:",
        cze: "Amoled pozad\xed:",
        hun: "Amoled t\xe9ma:",
        rom: "Tema amoled:",
        Swe: "Amoled-tema:",
        fil: "Amoled-tema:"
    },
    59: {
        eng: "Change background color to black.",
        rus: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0446\u0432\u0435\u0442 \u0444\u043E\u043D\u0430 \u043D\u0430 \u0447\u0451\u0440\u043D\u044B\u0439.",
        pol: "Zmienia kolor t\u0142a na czarny.",
        sch: "\u4FEE\u6539\u80CC\u666F\u989C\u8272\u4E3A\u9ED1\u8272\u3002",
        bra: "Altera a cor do fundo para preto.",
        fre: "Change la couleur de fond au noir.",
        cze: "Zm\u011Bn\xed barvu pozad\xed na \u010Dernou.",
        hun: "Fekete h\xe1tt\xe9r be\xe1ll\xedt\xe1sa.",
        rom: "Schimba culoarea fundalului ca negru.",
        swe: "\xc4ndra bakgrundsf\xe4rg till svart.",
        fil: "Baguhin ang kulay ng background na itim."
    },
    60: {
        eng: "Reset save:",
        rus: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435:",
        pol: "Zresetuj zapis:",
        sch: "\u91CD\u7F6E\u5B58\u6863\uFF1A",
        bra: "Resetar a sua data:",
        fre: "R\xe9initialiser la sauvegarde:",
        cze: "Resetovat historii:",
        hun: "Ment\xe9sek t\xf6rl\xe9se:",
        rom: "Reseteaza salvarea:",
        swe: "\xc5terst\xe4ll sparning:",
        fil: "I-reset ang save:"
    },
    61: {
        eng: "Reset stats and all unboxed items, including unusuals.<br>Will ask for confirmation only once.",
        rus: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0443 \u0438 \u0432\u0441\u0435 \u043E\u0442\u043A\u0440\u044B\u0442\u044B\u0435 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u044B, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u043D\u0435\u043E\u0431\u044B\u0447\u043D\u044B\u0435.<br>\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u043E\u0434\u0438\u043D \u0440\u0430\u0437.",
        pol: "Resetuje statystyki i wszystkie zdobyte przedmioty, \u0142\u0105cznie z Nietypowymi Okazami.",
        sch: "\u91CD\u7F6E\u6240\u6709\u7EDF\u8BA1\u6570\u636E\u4E0E\u7269\u54C1\uFF0C\u5305\u62EC\u7A00\u6709\u7269\u54C1\u3002<br>\u6211\u4EEC\u53EA\u4F1A\u8BE2\u95EE\u4E00\u6B21\u3002",
        bra: "Reseta as suas estat\xedsticas e todos itens desencaixotados, incluindo itens Incomuns.<br>S\xf3 vai pedir confirma\xe7\xe3o uma vez.",
        fre: "R\xe9initialise les statistiques ainsi que les objets d\xe9ball\xe9s, incluants les Inhabituels.<br>Ne demande la confirmation qu'une fois.",
        cze: "Resetuje statistiky a historii v\u0161ech rozbalen\xfdch p\u0159edm\u011Bt\u016F, v\u010Detn\u011B Unusual.<br>Na potvrzen\xed se zept\xe1m pouze jednou.",
        hun: "Lenull\xe1zza a statisztik\xe1kat \xe9s az \xf6sszes kibontott t\xe1rgyat elt\xfcnteti, a Rendk\xedv\xfclieket is.<br>Megnyom\xe1s ut\xe1n m\xe9g egyszer j\xf3v\xe1 kell hagyni.",
        rom: "Reseteaza statisticile si toate obiectele deschise, incluzand obiectele Neobisnuite.<br>Se va intreba decat o singura data pentru confirmare.",
        swe: "\xc5terst\xe4ll statistik och alla objekt, inklusive Ovanliga.<br>Ber bara om bekr\xe4ftelse en g\xe5ng.",
        fil: "I-reset ang mga istatistika at ang lahat nabukas mong aytems,kabilang unusuals.<br>Itatanong ka para sa kumpirmasyon isa lang."
    },
    62: {
        eng: "Custom Crate Depression Mode:",
        rus: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0439 \u0440\u0435\u0436\u0438\u043C \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u044F\u0449\u0438\u043A\u043E\u0432:",
        pol: "W\u0142asny tryb Skrzynkowej Depresji:",
        sch: "\u81EA\u5B9A\u4E49\u6218\u5229\u54C1\u5927\u7206\u53D1\u6A21\u5F0F\uFF1A",
        bra: "Modo Personalizado da Grande Depress\xe3o de Caixas:",
        fre: "Mode Custom Caisse D\xe9pression:",
        cze: "Vlastn\xed Crate Depression m\xf3d:",
        hun: "Egyedi l\xe1danyit\xe1si m\xf3d:",
        rom: "Cutie Personalizata Modul Depresie:",
        swe: "Anpassat L\xe5ddepressionsl\xe4ge:",
        fil: "Custom Kahon Depresyon Mode:"
    },
    63: {
        eng: "Crash the economy in your own style! This option lets you always unbox Unusuals, Stranges, professional killstreak kits, bonus items or items of specific grade.<br>Enabling any of those options will disable stats and saving!",
        rus: "\u041E\u0431\u0440\u0443\u0448\u044C\u0442\u0435 \u044D\u043A\u043E\u043D\u043E\u043C\u0438\u043A\u0443 \u0432 \u0441\u0432\u043E\u0451\u043C \u0441\u0442\u0438\u043B\u0435! \u042D\u0442\u0430 \u043E\u043F\u0446\u0438\u044F \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u0432\u0441\u0435\u0433\u0434\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u044B\u0435, \u0421\u0442\u0440\u0430\u043D\u043D\u044B\u0435, \u041F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u043D\u0430\u0431\u043E\u0440\u044B \u0443\u0431\u0438\u0439\u0441\u0442\u0432, \u0411\u043E\u043D\u0443\u0441\u043D\u044B\u0435 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u044B \u0438\u043B\u0438 \u041F\u0440\u0435\u0434\u043C\u0435\u0442\u044B \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0451\u043D\u043D\u043E\u0433\u043E \u043A\u043B\u0430\u0441\u0441\u0430.<br>\u0412\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043B\u044E\u0431\u043E\u0439 \u0438\u0437 \u044D\u0442\u0438\u0445 \u043E\u043F\u0446\u0438\u0439 \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u0442 \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0443 \u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435!",
        pol: "Rozwal ekonomi\u0119 w swoim w\u0142asnym stylu! Ta opcja pozwoli ci zawsze otrzyma\u0107 Nietypowe Okazy, przedmioty Kuriozalne, zestawy z profesjonaln\u0105 seri\u0105 zab\xf3jstw, przedmioty dodatkowe lub przedmioty o okre\u015Blonym stopniu.<br>W\u0142\u0105czenie jakiejkolwiek z tych opcji wy\u0142\u0105czy statystyki i zapisywanie!",
        sch: "\u7528\u60A8\u81EA\u5DF1\u7684\u65B9\u5F0F\u6467\u6BC1\u6E38\u620F\u5185\u7ECF\u6D4E\uFF01\u6B64\u9009\u9879\u53EF\u4EE5\u8BA9\u60A8\u603B\u662F\u5F00\u51FA\u7A00\u6709\u3001\u5947\u5F02\u3001\u804C\u4E1A\u8FDE\u6740\u8BB0\u5F55\u5F0F\u6216\u8005\u6307\u5B9A\u7B49\u7EA7\u7684\u7269\u54C1\uFF0C\u4EE5\u53CA\u989D\u5916\u5956\u52B1\u7269\u54C1\u3002<br>\u542F\u7528\u6B64\u5904\u4EFB\u4F55\u9009\u9879\u90FD\u4F1A\u7981\u7528\u7EDF\u8BA1\u4E0E\u5B58\u6863\uFF01",
        bra: "Destrua a economia no seu estilo! Essa op\xe7\xe3o te deixa sempre desencaixotar itens Incomuns, Estranhos, Kits de Combo Profissionais, itens de b\xf4nus ou itens de n\xedvel especifico.<br>Ativando qualquer uma dessas op\xe7\xf5es vai desativar estat\xedsticas e a habilidade de salvar a sua data!",
        fre: "Ruinez l'\xe9conomie \xe0 votre fa\xe7on! Cette option vous laisse ouvrir que des Inhabituels, \xc9tranges, kits de killstreak professionels, objets bonus ou objets d'un grade sp\xe9cifique.<br>Activer une ce des options d\xe9sactive les statistiques et la sauvegarde!",
        cze: "Zni\u010D ekonomiku ve sv\xe9m vlastn\xedm stylu! Tato mo\u017Enost ti umo\u017E\u0148\xed poka\u017Ed\xe9 z\xedskat Unusual nebo Strange p\u0159edm\u011Bt, p\u0159\xedpadn\u011B prof. killstreak kit, bonusov\xe9 p\u0159edm\u011Bty, nebo p\u0159edm\u011Bt ur\u010Dit\xe9 kvality.<br>Povolen\xedm t\xe9to funkce se pozastav\xed ukl\xe1d\xe1n\xed statistiky a historie otev\u0159en\xed!",
        hun: "Tedd t\xf6nkre a gazdas\xe1got a saj\xe1t st\xedlusodban! Ezekkel a be\xe1ll\xedt\xe1sokkal el\xe9rheted, hogy mindig Rendk\xedv\xfcliket, Fur\xe1kat, Hivat\xe1sos \xe1mokfut\xe1s k\xe9szleteket, b\xf3nusz t\xe1rgyakat vagy t\xe1rgyakat bizonyos fokozatba nyiss ki. B\xe1rmelyik bekapcsol\xe1sa eset\xe9n nem sz\xe1m\xedtanak bele a statisztik\xe1kba \xe9s nem lesz elmentve sem!",
        rom: "Distruge economia in propriul stil! Aceasta optiune te va lasa intotdeauna sa deschizi obiecte Neobisnuite, obiecte Stranii, Truse Profesionale de Omoruri Consecutive, obiecte bonus sau obiecte de un grad specific.<br>Pornirea oricarui optiune dintre acestea va dezactiva statisticile si salvarile!",
        swe: "Krascha ekonomin i din egen stil! Med det h\xe4r alternativet kan du alltid \xf6ppna Ovanliga, Avvikande, professionella killstreak-kit, bonusartiklar eller f\xf6rem\xe5l av specifik kvalitet.<br>Om du aktiverar n\xe5got av dessa alternativ inaktiveras statistik och sparning!",
        fil: "I-crash mo ang ekonomiya sa iyong sariling style! Itong opsyon ay ipapaalam ka napalagi magbukas ng mga Unusuals, Stranges, professional killstreak kits, bonus aytem o mga ibang aytem na sa tiyak na grado.<br>Pag-gamit ng isa sa mga opsyons ay ipapatay ang istatistika at saving!"
    },
    64: {
        eng: 'Made by <a href="https://steamcommunity.com/id/kubikill" target="_blank" rel="noopener">kubikill</a>',
        rus: '\u0421\u043E\u0437\u0434\u0430\u043D\u043E <a href="https://steamcommunity.com/id/kubikill" target="_blank" rel="noopener">kubikill</a>',
        pol: 'Stworzone przez <a href="https://steamcommunity.com/id/kubikill" target="_blank" rel="noopener">kubikilla</a>',
        sch: '\u7531 <a href="https://steamcommunity.com/id/kubikill" target="_blank" rel="noopener">kubikill</a> \u5236\u4F5C',
        bra: 'Feito por <a href="https://steamcommunity.com/id/kubikill" target="_blank" rel="noopener">kubikill</a>',
        fre: 'Cr\xe9\xe9 par <a href="https://steamcommunity.com/id/kubikill" target="_blank" rel="noopener">kubikill</a>',
        cze: 'Vytvo\u0159eno <a href="https://steamcommunity.com/id/kubikill" target="_blank" rel="noopener">kubikillem</a>',
        hun: 'K\xe9sz\xedtette: <a href="https://steamcommunity.com/id/kubikill" target="_blank" rel="noopener">kubikill</a>',
        rom: 'Creata de <a href="https://steamcommunity.com/id/kubikill" target="_blank" rel="noopener">kubikill</a>',
        swe: 'Gjord av <a href="https://steamcommunity.com/id/kubikill" target="_blank" rel="noopener">kubikill</a>',
        fil: 'Gawa ni <a href="https://steamcommunity.com/id/kubikill" target="_blank" rel="noopener">kubikill</a>'
    },
    65: {
        eng: 'Special thanks to <a href="https://steamcommunity.com/profiles/76561198117761965" target="_blank" rel="noopener">Gorno</a>',
        rus: '\u041E\u0441\u043E\u0431\u0430\u044F \u0431\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u043D\u043E\u0441\u0442\u044C <a href="https://steamcommunity.com/profiles/76561198117761965" target="_blank" rel="noopener">Gorno</a>',
        pol: 'Specjalne podzi\u0119kowania dla <a href="https://steamcommunity.com/profiles/76561198117761965" target="_blank" rel="noopener">Gorno</a>',
        sch: '\u7279\u522B\u611F\u8C22 <a href="https://steamcommunity.com/profiles/76561198117761965" target="_blank" rel="noopener">Gorno</a>',
        bra: 'Agradecimentos especiais para <a href="https://steamcommunity.com/profiles/76561198117761965" target="_blank" rel="noopener">Gorno</a>',
        fre: 'Remerciments sp\xe9ciaux \xe0 <a href="https://steamcommunity.com/profiles/76561198117761965">Gorno</a>',
        cze: 'Speci\xe1ln\xed pod\u011Bkov\xe1n\xed <a href="https://steamcommunity.com/profiles/76561198117761965" target="_blank" rel="noopener">Gornovi</a>',
        hun: 'K\xfcl\xf6n k\xf6sz\xf6net <a href="https://steamcommunity.com/profiles/76561198117761965" target="_blank" rel="noopener">Gornonak</a>',
        rom: 'Multumiri multe lui <a href="https://steamcommunity.com/profiles/76561198117761965" target="_blank" rel="noopener">Gorno</a>',
        swe: 'S\xe4rskilt tack till <a href="https://steamcommunity.com/profiles/76561198117761965" target="_blank" rel="noopener">Gorno</a>',
        fil: 'Maraming salamat kay <a href="https://steamcommunity.com/profiles/76561198117761965" target="_blank" rel="noopener">Gorno</a>'
    },
    66: {
        eng: 'Unusual effect images made by <a href="https://backpack.tf" target="_blank" rel="noopener">backpack.tf</a>',
        rus: '\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u043D\u0435\u043E\u0431\u044B\u0447\u043D\u044B\u0445 \u044D\u0444\u0444\u0435\u043A\u0442\u043E\u0432 \u0432\u0437\u044F\u0442\u044B \u0438\u0437 <a href="https://backpack.tf" target="_blank" rel="noopener">backpack.tf</a>',
        pol: 'Obrazki efekt\xf3w Nietypowych Okaz\xf3w stworzone przez <a href="https://backpack.tf" target="_blank" rel="noopener">backpack.tf</a>',
        sch: '\u7A00\u6709\u6548\u679C\u56FE\u50CF\u7531 <a href="https://backpack.tf" target="_blank" rel="noopener">backpack.tf</a> \u5236\u4F5C',
        bra: 'Imagens de efeitos incomuns feito por <a href="https://backpack.tf" target="_blank" rel="noopener">backpack.tf</a>',
        fre: "Images d'effets Inhabituels faites par <a href='https://backpack.tf'>backpack.tf</a>",
        cze: 'Obr\xe1zky Unusual efekt\u016F ze str\xe1nky <a href="https://backpack.tf" target="_blank" rel="noopener">backpack.tf</a>',
        hun: 'Rendk\xedv\xfcli effekt k\xe9peket k\xe9sz\xedtette: <a href="https://backpack.tf" target="_blank" rel="noopener">backpack.tf</a>',
        rom: 'Pozele cu efectele Neobisnuite facute de <a href="https://backpack.tf" target="_blank" rel="noopener">backpack.tf</a>',
        swe: 'Ovanliga effektbilder gjorda av <a href="https://backpack.tf" target="_blank" rel="noopener">backpack.tf</a>',
        fil: 'Ang mga imahe ng epekto ng Unusual ay gawa ng <a href="https://backpack.tf" target="_blank" rel="noopener">backpack.tf</a>'
    },
    67: {
        eng: "Bulk unboxing",
        rus: "\u041C\u0430\u0441\u0441\u043E\u0432\u043E\u0435 \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u0435",
        pol: "Otw\xf3rz wiele skrzynek",
        sch: "\u6279\u91CF\u5F00\u7BB1",
        bra: "Desencaixotamento em massa",
        fre: "D\xe9ballage de masse",
        cze: "Hromadn\xe9 otev\xedr\xe1n\xed",
        hun: "Kinyit\xe1s nagy t\xe9telben",
        rom: "Deschidere in masa",
        swe: "Mass\xf6ppning",
        fil: "Maramihang pagbukas"
    },
    68: {
        eng: "How many crates/cases do you want to open?",
        rus: "\u0421\u043A\u043E\u043B\u044C\u043A\u043E \u044F\u0449\u0438\u043A\u043E\u0432/\u043A\u0435\u0439\u0441\u043E\u0432 \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u043E\u0442\u043A\u0440\u044B\u0442\u044C?",
        pol: "Ile skrzynek chcesz otworzy\u0107?",
        sch: "\u60A8\u60F3\u8981\u5F00\u542F\u51E0\u4E2A\u7BB1\u5B50\uFF1F",
        bra: "Quantas caixas voc\xea deseja abrir?",
        fre: "Combien de caisses voulez-vous d\xe9baller?",
        cze: "Kolik krabic/beden si p\u0159eje\u0161 otev\u0159\xedt?",
        hun: "Mennyi l\xe1d\xe1t/t\xe1sk\xe1t szeretn\xe9l kinyitni?",
        rom: "Cate cutii vrei sa deschizi?",
        swe: "Hur m\xe5nga l\xe5dor vill du \xf6ppna?",
        fil: "Ilang mga kahon/kaso ang gusto mong ibuksan?"
    },
    69: {
        eng: "Translators:",
        rus: "\u041F\u0435\u0440\u0435\u0432\u043E\u0434\u0447\u0438\u043A\u0438:",
        pol: "T\u0142umacze:",
        sch: "\u8BD1\u8005\uFF1A",
        bra: "Tradutores:",
        fre: "Traducteurs:",
        cze: "P\u0159ekladatel\xe9:",
        hun: "Ford\xedt\xf3k:",
        rom: "Traducatori:",
        swe: "\xd6vers\xe4ttare:",
        fil: "Tagasalin:"
    },
    70: {
        eng: 'Simplified Chinese',
        rus: "\u0423\u043F\u0440\u043E\u0449\u0451\u043D\u043D\u044B\u0439 \u043A\u0438\u0442\u0430\u0439\u0441\u043A\u0438\u0439",
        pol: "Chi\u0144ski (uproszczony)",
        sch: "\u202A\u4E2D\u6587\uFF08\u7B80\u4F53\uFF09",
        bra: "Chin\xeas Simplificado",
        fre: "Chinois simplifi\xe9",
        cze: "Zjednodu\u0161en\xe1 \u010C\xedn\u0161tina",
        hun: "Egyszer\u0171s\xedtett k\xednai",
        rom: 'Chineaza simplificata',
        swe: "F\xf6renklad Kinesiska",
        fil: 'Simpleng Tsino'
    },
    71: {
        eng: "Strange",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430",
        pol: "Kuriozum",
        sch: "\u5947\u5F02",
        bra: "Estranho",
        fre: "\xc9trange",
        cze: "Strange",
        hun: "Fura",
        rom: "Straniu",
        swe: "Avvikande"
    },
    72: {
        eng: "Haunted",
        rus: "\u041F\u0440\u0438\u0437\u0440\u0430\u0447\u043D\u043E\u0433\u043E \u0432\u0438\u0434\u0430",
        pol: "Przekle\u0144stwo",
        sch: "\u95F9\u9B3C",
        bra: "Assombrado",
        fre: "Hant\xe9",
        cze: "Haunted",
        hun: "K\xeds\xe9rtetj\xe1rta",
        rom: "Bantuit",
        swe: "Hems\xf6kt"
    },
    73: {
        eng: "Unusual",
        rus: "\u041D\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430",
        pol: "Nietypowy Okaz",
        sch: "\u7A00\u6709",
        bra: "Incomum",
        fre: "Inhabituel",
        cze: "Unusual",
        hun: "Rendk\xedv\xfcli",
        rom: "Neobisnuit",
        swe: "Ovanlig"
    },
    74: {
        eng: "or a random Unusual hat!",
        rus: "\u0438\u043B\u0438 \u0441\u043B\u0443\u0447\u0430\u0439\u043D\u0430\u044F \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u0430\u044F \u0448\u0430\u043F\u043A\u0430!",
        pol: "lub losowy Nietypowy Okaz!",
        sch: "\u6216\u8005\u662F\u4E00\u4EF6\u968F\u673A\u7684\u7A00\u6709\u9970\u54C1\uFF01",
        bra: "ou um item Incomum aleat\xf3rio!",
        fre: "ou encore un chapeau Inhabituel al\xe9atoire!",
        cze: "nebo speci\xe1ln\xed extr\xe9mn\u011B vz\xe1cn\xfd p\u0159edm\u011Bt!",
        hun: "vagy egy v\xe9letlenszer\u0171 Rendk\xedv\xfcli sapka!",
        rom: "sau o palarie Neobisnuita aleatorie!",
        swe: "eller en slumpm\xe4ssig ovanlig hatt!",
        fil: "o isang sapalarang sumbrerong Unusual"
    },
    75: {
        eng: "Series #(NUM)",
        rus: "\u0421\u0435\u0440\u0438\u044F #(NUM)",
        pol: "Seria #(NUM)",
        sch: "\u7F16\u53F7 #(NUM)",
        bra: "S\xe9rie #(NUM)",
        fre: "S\xe9ries #(NUM)",
        cze: "S\xe9rie #(NUM)",
        hun: "(NUM). sorozat\xfa",
        rom: "Seria #(NUM)",
        swe: "Serie #(NUM)",
        fil: "Serye #(NUM)"
    },
    76: {
        eng: "Seriesless",
        rus: "\u0411\u0435\u0437 \u0441\u0435\u0440\u0438\u0438",
        pol: "Bez serii",
        sch: "\u65E0\u7F16\u53F7",
        bra: "Sem s\xe9ries",
        fre: "Sans s\xe9rie",
        cze: "Bez s\xe9rie",
        hun: "Sorozat n\xe9lk\xfcli",
        rom: "Fara serie",
        swe: "Seriel\xf6s",
        fil: "Walang serye"
    },
    77: {
        eng: "Save reset!",
        rus: "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u0441\u0431\u0440\u043E\u0448\u0435\u043D\u043E!",
        pol: "Zresetowano!",
        sch: "\u5B58\u6863\u5DF2\u91CD\u7F6E\uFF01",
        bra: "Resetar a sua data",
        fre: "Sauvegarde r\xe9initialis\xe9e!",
        cze: "Ulo\u017Eit reset!",
        hun: "Ment\xe9sek t\xf6r\xf6lve!",
        rom: "Salveaza resetarea!",
        swe: "Spara \xe5terst\xe4llning!",
        fil: "I-save ang reset!"
    },
    78: {
        eng: "Are you sure?",
        rus: "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B?",
        pol: "Na pewno?",
        sch: "\u60A8\u786E\u5B9A\u5417\uFF1F",
        bra: "Voc\xea tem certeza?",
        fre: "\xcates-vous certain?",
        cze: "Opravdu?",
        hun: "Biztos vagy benne?",
        rom: "Esti sigur?",
        swe: "\xc4r du s\xe4ker?",
        fil: "Sigurado ka ba?"
    },
    79: {
        eng: "Effect:",
        rus: "\u042D\u0444\u0444\u0435\u043A\u0442:",
        pol: "Efekt:",
        sch: "\u6548\u679C\uFF1A",
        bra: "Efeito:",
        fre: "Effet:",
        cze: "Efekt:",
        hun: "Effekt:",
        rom: "Efect:",
        swe: "Effekt",
        fil: "Epekto"
    },
    80: {
        eng: "Factory New",
        rus: "\u041F\u0440\u044F\u043C\u043E \u0441 \u0437\u0430\u0432\u043E\u0434\u0430",
        pol: "Prosto z fabryki",
        sch: "\u5D2D\u65B0\u51FA\u5382",
        bra: "Nova de F\xe1brica",
        fre: "Neuve",
        cze: "Zbrusu nov\xfd",
        hun: "Gy\xe1ri \xfaj",
        rom: "Nou din fabrica",
        swe: "Fabriksny"
    },
    81: {
        eng: "Minimal Wear",
        rus: "\u041D\u0435\u043C\u043D\u043E\u0433\u043E \u043F\u043E\u043D\u043E\u0448\u0435\u043D\u043D\u043E\u0435",
        pol: "Lekkie zu\u017Cycie",
        sch: "\u7565\u6709\u78E8\u635F",
        bra: "Pouco Usada",
        fre: "Tr\xe8s peu us\xe9e",
        cze: "Lehce opot\u0159eben\xfd",
        hun: "Kev\xe9ss\xe9 haszn\xe1lt",
        rom: "Uzura minima",
        swe: "Minimalt slitage"
    },
    82: {
        eng: "Field-Tested",
        rus: "\u041F\u043E\u0441\u043B\u0435 \u043F\u043E\u043B\u0435\u0432\u044B\u0445 \u0438\u0441\u043F\u044B\u0442\u0430\u043D\u0438\u0439",
        pol: "Po testach bojowych",
        sch: "\u4E45\u7ECF\u6C99\u573A",
        bra: "Testada em Campo",
        fre: "Test\xe9e sur le terrain",
        cze: "Opot\u0159eben\xfd",
        hun: "Harct\xe9ren tesztelt",
        rom: "Testat pe teren",
        swe: "F\xe4lt-Testad"
    },
    83: {
        eng: "Well-Worn",
        rus: "\u041F\u043E\u043D\u043E\u0448\u0435\u043D\u043D\u043E\u0435",
        pol: "Mocne zu\u017Cycie",
        sch: "\u7834\u635F\u4E0D\u582A",
        bra: "Bem Desgastada",
        fre: "Us\xe9e",
        cze: "Siln\u011B opot\u0159eben\xfd",
        hun: "Viseltes",
        rom: "Bine folosit",
        swe: "V\xe4l sliten"
    },
    84: {
        eng: "Battle Scarred",
        rus: "\u0417\u0430\u043A\u0430\u043B\u0451\u043D\u043D\u043E\u0435 \u0432 \u0431\u043E\u044F\u0445",
        pol: "Po ci\u0119\u017Ckich walkach",
        sch: "\u6218\u75D5\u7D2F\u7D2F",
        bra: "Veterana de Guerra",
        fre: "Marqu\xe9es par les combats",
        cze: "Poni\u010Den\xfd bojem",
        hun: "H\xe1bor\xfa t\xe9p\xe1zta",
        rom: "Zgariat in lupta",
        swe: "Kamp-\xe4rrad"
    },
    85: {
        eng: "Steam Group",
        rus: "\u0413\u0440\u0443\u043F\u043F\u0430 Steam",
        pol: "Grupa na Steamie",
        sch: "Steam \u7EC4",
        bra: "Grupo da Steam",
        fre: "Groupe Steam",
        cze: "Steam skupina",
        hun: "Steam csoport",
        rom: "Grup de steam",
        swe: "Steam Grupp",
        fil: "Grupo sa Steam"
    },
    86: {
        eng: "Mute sound",
        rus: "\u041E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0437\u0432\u0443\u043A",
        pol: "Wycisz d\u017Awi\u0119k",
        sch: "\u9759\u97F3",
        bra: "Silenciar sons",
        fre: "Mettre en sourdine",
        cze: "Ztlumit zvuky",
        hun: "N\xe9m\xedt\xe1s",
        rom: "Opreste sunetul",
        swe: "St\xe4ng av ljud",
        fil: "Ipatay ang tunog"
    },
    87: {
        eng: "Settings",
        rus: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
        pol: "Ustawienia",
        sch: "\u8BBE\u7F6E",
        bra: "Defini\xe7\xf5es",
        fre: "Param\xe8tres",
        cze: "Nastaven\xed",
        hun: "Be\xe1ll\xedt\xe1sok",
        rom: "Setari",
        swe: "Inst\xe4llningar"
    },
    88: {
        eng: "About/Donate",
        rus: "\u041E \u0441\u0430\u0439\u0442\u0435/\u041F\u043E\u0436\u0435\u0440\u0442\u0432\u043E\u0432\u0430\u043D\u0438\u044F",
        pol: "Info/Dotacje",
        sch: "\u5173\u4E8E/\u6350\u8D60",
        bra: "Sobre/Doar",
        fre: "Infos/Faire un don",
        cze: "Info/P\u0159\xedsp\u011Bvky",
        hun: "R\xf3lunk/adom\xe1ny",
        rom: "Despre/Doneaza",
        swe: "Om/donera",
        fil: "Impormasyon/Donate"
    },
    89: {
        eng: "Donations",
        rus: "\u041F\u043E\u0436\u0435\u0440\u0442\u0432\u043E\u0432\u0430\u043D\u0438\u044F",
        pol: "Dotacje",
        sch: "\u6350\u8D60",
        bra: "Doa\xe7\xf5es",
        fre: "Dons",
        cze: "P\u0159\xedsp\u011Bvky",
        hun: "Adom\xe1nyok",
        rom: "Donatii",
        swe: "Donationer"
    },
    90: {
        eng: '<span class="colorstrange">Strange</span> <span class="colorunusual">Unusuals</span> unboxed:',
        rus: '<span class="colorstrange">\u0421\u0442\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430</span> & <span class="colorunusual">\u041D\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430</span> \u043E\u0442\u043A\u0440\u044B\u0442\u043E:',
        pol: 'Zdobyte <span class="colorstrange">Kuriozalne</span> <span class="colorunusual">Nietypowe Okazy</span>:',
        sch: '\u5DF2\u5F00\u51FA<span class="colorstrange">\u5947\u5F02</span><span class="colorunusual">\u7A00\u6709</span>\u7269\u54C1\uFF1A',
        bra: 'Itens <span class="colorstrange">Estranhos</span> <span class="colorunusual">Incomuns</span> desencaixotados:',
        fre: 'Objets <span class="colorstrange">\xc9tranges</span> <span class="colorunusual">Inhabituels</span> d\xe9ball\xe9s:',
        cze: '<span class="colorstrange">Strange</span> <span class="colorunusual">Unusual</span> p\u0159edm\u011Bt\u016F z\xedsk\xe1no:',
        hun: '<span class="colorstrange">Fura</span> <span class="colorunusual">Rendk\xedv\xfcliek</span> kibontva:',
        rom: '<span class="colorstrange">Straniu</span> <span class="colorunusual">Neobisnuite</span> unboxed:',
        swe: '<span class="colorstrange">Avvikande</span> <span class="colorunusual">Ovanliga</span> \xf6ppnade:',
        fil: '<span class="colorstrange">Strange</span> <span class="colorunusual">Unusuals</span> nabukas:'
    },
    91: {
        eng: "Graded items unboxed:",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u043E \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u0441 \u043A\u043B\u0430\u0441\u0441\u0430\u043C\u0438:",
        pol: "Zdobyte przedmioty z stopniem:",
        sch: "\u5DF2\u5F00\u51FA\u7B49\u7EA7\u7269\u54C1\uFF1A",
        bra: "Itens com n\xedvel desencaixotados:",
        fre: "Objets grad\xe9s d\xe9ball\xe9s:",
        cze: "Z\xedsk\xe1no p\u0159edm\u011Bt\u016F dan\xe9 t\u0159\xeddy:",
        hun: "T\xe1rgyak fokozattal kibontva:",
        rom: "Obiecte gradate deschise:",
        swe: "Betygsatta objekt \xf6ppnade:",
        fil: "Gradong aytem nabukas:"
    },
    92: {
        eng: '<span class="colorcivilian">Civilian</span> items unboxed:',
        rus: '<span class="colorcivilian">\u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u043A\u043E\u0433\u043E</span> \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u043E\u0442\u043A\u0440\u044B\u0442\u043E:',
        pol: 'Zdobyte przedmioty st. <span class="colorcivilian">Cywil</span>:',
        sch: '\u5DF2\u5F00\u51FA<span class="colorcivilian">\u6C11\u7528\u7EA7</span>\u7269\u54C1\uFF1A',
        bra: 'Itens de n\xedvel <span class="colorcivilian">Civil</span> desencaixotados:',
        fre: 'Objets de grade <span class="colorcivilian">Civil</span> d\xe9ball\xe9s:',
        cze: '<span class="colorcivilian">Civilian</span> p\u0159edm\u011Bt\u016F z\xedsk\xe1no:',
        hun: '<span class="colorcivilian">Civil</span> t\xe1rgyak kibontva:',
        rom: '<span class="colorcivilian">Civil</span> obiecte deschise:',
        swe: '<span class="colorcivilian">Civil</span> f\xf6rem\xe5l \xf6ppnad:',
        fil: '<span class="colorcivilian">Sibilyan</span> aytem nabukas:'
    },
    93: {
        eng: '<span class="colorfreelance">Freelance</span> items unboxed:',
        rus: '<span class="colorfreelance">\u0412\u043D\u0435\u0448\u0442\u0430\u0442\u043D\u0438\u043A\u0430</span> \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u043E\u0442\u043A\u0440\u044B\u0442\u043E:',
        pol: 'Zdobyte przedmioty st. <span class="colorfreelance">Wolny Strzelec</span>:',
        sch: '\u5DF2\u5F00\u51FA<span class="colorfreelance">\u4E0D\u7F81\u7EA7</span>\u7269\u54C1\uFF1A',
        bra: 'Itens de n\xedvel <span class="colorfreelance">Aut\xf4nomo</span> desencaixotados:',
        fre: 'Objets de grade <span class="colorfreelance">Freelance</span> d\xe9ball\xe9s:',
        cze: '<span class="colorfreelance">Freelance</span> p\u0159edm\u011Bt\u016F z\xedsk\xe1no:',
        hun: '<span class="colorfreelance">Szabad\xfasz\xf3</span> t\xe1rgyak kibontva:',
        rom: '<span class="colorfreelance">Independent</span> obiecte deschise:',
        swe: '<span class="colorfreelance">Frilans</span> f\xf6rem\xe5l \xf6ppnade:',
        fil: '<span class="colorfreelance">Freelance</span> aytem nabukas:'
    },
    94: {
        eng: '<span class="colormercenary">Mercenary</span> items unboxed:',
        rus: '<span class="colormercenary">\u041D\u0430\u0435\u043C\u043D\u0438\u043A\u0430</span> \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u043E\u0442\u043A\u0440\u044B\u0442\u043E:',
        pol: 'Zdobyte przedmioty st. <span class="colormercenary">Najemnik</span>:',
        sch: '\u5DF2\u5F00\u51FA<span class="colormercenary">\u96C7\u4F63\u7EA7</span>\u7269\u54C1\uFF1A',
        bra: 'Itens de n\xedvel <span class="colormercenary">Mercen\xe1rio</span> desencaixotados:',
        fre: 'Objets de grade <span class="colormercenary">Mercenaire</span> d\xe9ball\xe9s:',
        cze: '<span class="colorfreelance">Mercenary</span> p\u0159edm\u011Bt\u016F z\xedsk\xe1no:',
        hun: '<span class="colormercenary">Zsoldos</span> t\xe1rgyak kibontva:',
        rom: '<span class="colormercenary">Mercenar</span> obiecte deschise:',
        swe: '<span class="colormercenary">Legosoldat</span> f\xf6rem\xe5l \xf6ppnade:',
        fil: '<span class="colormercenary">Mersenary</span> aytem nabukas:'
    },
    95: {
        eng: '<span class="colorcommando">Commando</span> items unboxed:',
        rus: '<span class="colorcommando">\u0411\u043E\u0439\u0446\u0430</span> \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u043E\u0442\u043A\u0440\u044B\u0442\u043E:',
        pol: 'Zdobyte przedmioty st. <span class="colorcommando">Komandos</span>:',
        sch: '\u5DF2\u5F00\u51FA<span class="colorcommando">\u7279\u79CD\u7EA7</span>\u7269\u54C1\uFF1A',
        bra: 'Itens de n\xedvel <span class="colorcommando">Comando</span> desencaixotados:',
        fre: 'Objets de grade <span class="colorcommando">Commando</span> d\xe9ball\xe9s:',
        cze: '<span class="colorcommando">Commando</span> p\u0159edm\u011Bt\u016F z\xedsk\xe1no:',
        hun: '<span class="colorcommando">Kommand\xf3s</span> t\xe1rgyak kibontva:',
        rom: '<span class="colorcommando">Comando</span> obiecte deschise:',
        swe: '<span class="colorcommando">Kommando</span> f\xf6rem\xe5l \xf6ppnade:',
        fil: '<span class="colorcommando">Kommando</span> aytem nabukas:'
    },
    96: {
        eng: '<span class="colorassassin">Assassin</span> items unboxed:',
        rus: '<span class="colorassassin">\u0423\u0431\u0438\u0439\u0446\u044B</span> \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u043E\u0442\u043A\u0440\u044B\u0442\u043E:',
        pol: 'Zdobyte przedmioty st. <span class="colorassassin">Asasyn</span>:',
        sch: '\u5DF2\u5F00\u51FA<span class="colorassassin">\u523A\u6740\u7EA7</span>\u7269\u54C1\uFF1A',
        bra: 'Itens de n\xedvel <span class="colorassassin">Assassino</span> desencaixotados:',
        fre: 'Objets de grade <span class="colorassassin">Assassin</span> d\xe9ball\xe9s:',
        cze: '<span class="colorassassin">Assassin</span> p\u0159edm\u011Bt\u016F z\xedsk\xe1no:',
        hun: '<span class="colorassassin">Orgyilkos</span> t\xe1rgyak kibontva:',
        rom: '<span class="colorassassin">Asasin</span> obiecte deschide:',
        swe: '<span class="colorassassin">L\xf6nnm\xf6rdar</span> f\xf6rem\xe5l \xf6ppnade:',
        fil: '<span class="colorassassin">Assassino</span> aytem nabukas:'
    },
    97: {
        eng: '<span class="colorelite">Elite</span> items unboxed:',
        rus: '<span class="colorelite">\u042D\u043B\u0438\u0442\u043D\u043E\u0433\u043E \u0431\u043E\u0439\u0446\u0430</span> \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u043E\u0442\u043A\u0440\u044B\u0442\u043E:',
        pol: 'Zdobyte przedmioty st. <span class="colorelite">Elita</span>:',
        sch: '\u5DF2\u5F00\u51FA<span class="colorelite">\u7CBE\u82F1\u7EA7</span>\u7269\u54C1\uFF1A',
        bra: 'Itens de n\xedvel <span class="colorelite">Elite</span> desencaixotados:',
        fre: 'Objets de grade <span class="colorelite">\xc9lite</span> d\xe9ball\xe9s:',
        cze: '<span class="colorelite">Elite</span> p\u0159edm\u011Bt\u016F z\xedsk\xe1no:',
        hun: '<span class="colorelite">Elit</span> t\xe1rgyak kibontva:',
        rom: '<span class="colorelite>Elit\u0103</span> obiecte deschise:',
        swe: '<span class="colorelite">Elit</span> f\xf6rem\xe5l \xf6ppnade:',
        fil: '<span class="colorelite">Elito</span> aytem nabukas:'
    },
    98: {
        eng: "Items with wear unboxed:",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u043E \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u0441 \u0432\u0435\u0449\u0430\u043C\u0438:",
        pol: "Zdobyte przedmioty z stopniem jako\u015Bci:",
        sch: "\u5DF2\u5F00\u51FA\u78E8\u635F\u7269\u54C1\uFF1A",
        bra: "Itens com desgaste desencaixotados:",
        fre: "Apparence ext\xe9rieur des objets d\xe9ball\xe9s:",
        cze: "P\u0159edm\u011Bt\u016F se skinem z\xedsk\xe1no:",
        hun: "Viseletekkel rendelkez\u0151 t\xe1rgyak kibontva:",
        rom: "Obiecte folosite deschise:",
        swe: "F\xf6rem\xe5l med slitage \xf6ppnade:",
        fil: "Aytem kasamang grado nabukas:"
    },
    99: {
        eng: "Factory New items unboxed:",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u043E \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u041F\u0440\u044F\u043C\u043E \u0441 \u0437\u0430\u0432\u043E\u0434\u0430:",
        pol: "Zdobyte fabrycznie nowe przedmioty:",
        sch: "\u5DF2\u5F00\u51FA\u5D2D\u65B0\u51FA\u5382\u7269\u54C1\uFF1A",
        bra: "Itens Novos de F\xe1brica desencaixotados:",
        fre: "Objets d'ext\xe9rieur Neuve d\xe9ball\xe9s:",
        cze: "Zbrusu nov\xfdch p\u0159edm\u011Bt\u016F z\xedsk\xe1no:",
        hun: "Gy\xe1ri \xfaj t\xe1rgyak kibontva:",
        rom: "Obiecte noi din fabrica deschise:",
        swe: "Fabriksnya f\xf6rem\xe5l \xf6ppnade:"
    },
    100: {
        eng: "Minimal Wear items unboxed:",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u043E \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u041D\u0435\u043C\u043D\u043E\u0433\u043E \u043F\u043E\u043D\u043E\u0448\u0435\u043D\u043D\u043E\u0435:",
        pol: "Zdobyte lekko u\u017Cywane przedmioty:",
        sch: "\u5DF2\u5F00\u51FA\u7565\u6709\u78E8\u635F\u7269\u54C1\uFF1A",
        bra: "Itens Pouco Usados desencaixotados:",
        fre: "Objets d'ext\xe9rieur Peu Us\xe9e d\xe9ball\xe9s",
        cze: "Lehce opot\u0159eben\xfdch p\u0159edm\u011Bt\u016F z\xedsk\xe1no:",
        hun: "Kev\xe9ss\xe9 haszn\xe1lt t\xe1rgyak kibontva:",
        rom: "Obiecte cu uzura minima deschise:",
        swe: "Minimalt slitage f\xf6rem\xe5l \xf6ppnade:"
    },
    101: {
        eng: "Field-Tested items unboxed:",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u043E \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u041F\u043E\u0441\u043B\u0435 \u043F\u043E\u043B\u0435\u0432\u044B\u0445 \u0438\u0441\u043F\u044B\u0442\u0430\u043D\u0438\u0439:",
        pol: "Zdobyte przetestowane w boju przedmioty:",
        sch: "\u5DF2\u5F00\u51FA\u4E45\u7ECF\u6C99\u573A\u7269\u54C1\uFF1A",
        bra: "Itens Testados em Campo desencaixotados:",
        fre: "Objets d'ext\xe9rieur Test\xe9e sur le Terrain d\xe9ball\xe9s:",
        cze: "Opot\u0159eben\xfdch p\u0159edm\u011Bt\u016F z\xedsk\xe1no:",
        hun: "Harct\xe9ren tesztelt t\xe1rgyak kibontva:",
        rom: "Obiecte testate pe teren deschise:",
        swe: "F\xe4lt-testade f\xf6rem\xe5l \xf6ppnade:"
    },
    102: {
        eng: "Well-Worn items unboxed:",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u043E \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u041F\u043E\u043D\u043E\u0448\u0435\u043D\u043D\u043E\u0435:",
        pol: "Zdobyte przedmioty z \u015Bladami u\u017Cywania:",
        sch: "\u5DF2\u5F00\u51FA\u7834\u635F\u4E0D\u582A\u7269\u54C1\uFF1A",
        bra: "Itens Bem Desgastados desencaixotados:",
        fre: "Objets d'ext\xe9rieur Us\xe9e d\xe9ball\xe9s:",
        cze: "Siln\u011B opot\u0159eben\xfdch p\u0159edm\u011B\u016F z\xedsk\xe1no:",
        hun: "Viseltes t\xe1rgyak kibontva:",
        rom: "Obiecte bine folosite deschise:",
        swe: "V\xe4l slitna f\xf6rem\xe5l \xf6ppnade:"
    },
    103: {
        eng: "Battle Scarred items unboxed:",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u043E \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u0417\u0430\u043A\u0430\u043B\u0451\u043D\u043D\u043E\u0435 \u0432 \u0431\u043E\u044F\u0445:",
        pol: "Zdobyte zaprawione w walkach przedmioty:",
        sch: "\u5DF2\u5F00\u51FA\u6218\u75D5\u7D2F\u7D2F\u7269\u54C1\uFF1A",
        bra: "Itens Veteranas de Guerra desencaixotados:",
        fre: "Objets d'ext\xe9rieurs Marqu\xe9e par les Combats d\xe9ball\xe9s:",
        cze: "P\u0159edm\u011Bt\u016F poni\u010Den\xfdch bojem z\xedsk\xe1no:",
        hun: "H\xe1bor\xfa t\xe9p\xe1zta t\xe1rgyak kibontva:",
        rom: "Obiecte zgariate in lupta deschise:",
        swe: "Kamp-\xe4rrade f\xf6rem\xe5l \xf6ppnade:"
    },
    104: {
        eng: "General",
        rus: "\u041E\u0431\u0449\u0435\u0435",
        pol: "Og\xf3lne",
        sch: "\u5E38\u89C4",
        bra: "Geral",
        fre: "G\xe9n\xe9ral",
        cze: "P\u0159ehled",
        hun: "\xc1ltal\xe1nos",
        rom: "General",
        swe: "Allm\xe4n",
        fil: "Pangkalahatan"
    },
    105: {
        eng: "Quality",
        rus: "\u041A\u0430\u0447\u0435\u0441\u0442\u0432\u043E",
        pol: "Jako\u015B\u0107",
        sch: "\u54C1\u8D28",
        bra: "Qualidade",
        fre: "Qualit\xe9",
        cze: "Kvalita",
        hun: "Min\u0151s\xe9g",
        rom: "Calitate",
        swe: "Kvalitet",
        fil: "Kalidad"
    },
    106: {
        eng: "Grades",
        rus: "\u041A\u043B\u0430\u0441\u0441\u044B",
        pol: "Stopnie",
        sch: "\u7B49\u7EA7",
        bra: "N\xedveis",
        fre: "Grades",
        cze: "T\u0159\xeddy",
        hun: "Fokozatok",
        rom: "Graduri",
        swe: "Betyg",
        fil: "Mga grado"
    },
    107: {
        eng: "Wears",
        rus: "\u0418\u0437\u043D\u043E\u0441",
        pol: "Stopnie zu\u017Cycia",
        sch: "\u78E8\u635F",
        bra: "Desgastes",
        fre: "Ext\xe9rieur",
        cze: "Skiny",
        hun: "K\xfcls\u0151",
        rom: "Folosire",
        swe: "Slitage"
    },
    108: {
        eng: "Average unboxes per Unusual:",
        rus: "\u0421\u0440\u0435\u0434\u043D\u0435\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u0439 \u043D\u0430 \u043E\u0434\u0438\u043D \u043F\u0440\u0435\u0434\u043C\u0435\u0442 \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430:",
        pol: "\u015Arednia ilo\u015B\u0107 otwar\u0107 na Nietypowy Okaz:",
        sch: "\u83B7\u5F97\u7A00\u6709\u5E73\u5747\u5F00\u7BB1\u6570\uFF1A",
        bra: "M\xe9dia de desencaixotamento por item Incomum:",
        fre: "D\xe9ballage moyen par Inhabituel:",
        cze: "Pr\u016Fm\u011Br po\u010Dtu otev\u0159en\xed za Unusual p\u0159edm\u011Bt:",
        hun: "\xc1tlag kibont\xe1sok sz\xe1ma k\xe9t Rendk\xedv\xfcli k\xf6z\xf6tt:",
        rom: "Deschidere in medie per obiecte Neobisnuite:",
        swe: "Genomsnittliga \xf6ppningar per Ovanligt f\xf6rem\xe5l:",
        fil: "Karaniwang buksan sa bawat na Unusual:"
    },
    109: {
        eng: '<span class="colorstrange">Strange</span> <span class="colorhaunted">Haunted</span> items unboxed:',
        rus: '<span class="colorstrange">\u0421\u0442\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430</span> & <span class="colorhaunted">\u041F\u0440\u0438\u0437\u0440\u0430\u0447\u043D\u043E\u0433\u043E \u0432\u0438\u0434\u0430</span> \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432 \u043E\u0442\u043A\u0440\u044B\u0442\u043E:',
        pol: 'Zdobyte <span class="colorstrange">Kuriozalne</span> <span class="colorhaunted">Nawiedzone</span> przedmioty:',
        sch: '\u5DF2\u5F00\u51FA<span class="colorstrange">\u5947\u5F02</span><span class="colorhaunted">\u95F9\u9B3C</span>\u7269\u54C1\uFF1A',
        bra: 'Itens <span class="colorstrange">Estranhos</span> <span class="colorhaunted">Assombrados</span> desencaixotados:',
        fre: 'Objets de qualit\xe9 <span class="colorstrange">\xc9trange</span> <span class="colorhaunted">Hant\xe9e</span> d\xe9ball\xe9s:',
        cze: '<span class="colorstrange">Strange</span> <span class="colorhaunted">Haunted</span> p\u0159edm\u011Bt\u016F z\xedsk\xe1no:',
        hun: '<span class="colorstrange">Fura</span> <span class="colorhaunted">K\xeds\xe9rtetj\xe1rta</span> t\xe1rgyak kibontva:',
        rom: '<span class="colorstrange">Straniu</span> <span class="colorhaunted">Bantuit</span> obiecte deschise:',
        swe: '<span class="colorstrange">Avvikande</span> <span class="colorhaunted">Hems\xf6kt</span> f\xf6rem\xe5l \xf6ppnade:',
        fil: '<span class="colorstrange">Strange</span> <span class="colorhaunted">Haunted</span> aytem nabukas:'
    },
    110: {
        eng: "Average price of an Unusual:",
        rus: "\u0421\u0440\u0435\u0434\u043D\u044F\u044F \u0446\u0435\u043D\u0430 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u0430 \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430:",
        pol: "\u015Arednia warto\u015B\u0107 Nietypowego Okazu:",
        sch: "\u83B7\u5F97\u7A00\u6709\u5E73\u5747\u82B1\u8D39\uFF1A",
        bra: "Pre\xe7o m\xe9dio de um item Incomum",
        fre: "Prix moyen d'un Inhabituel:",
        cze: "Pr\u016Fm\u011Brn\xe1 cena Unusual p\u0159edm\u011Btu:",
        hun: "Rendk\xedv\xfcliek \xe1tlagos \xe9rt\xe9ke:",
        rom: "Pret in medie al unui obiect Neobisnuit:",
        swe: "Genomsnittspris f\xf6r ett Ovanligt f\xf6rem\xe5l:",
        fil: "Karaniwang presyo ng Unusual:"
    },
    111: {
        eng: "Luck",
        rus: "\u0423\u0434\u0430\u0447\u0430",
        pol: "Szcz\u0119\u015Bcie",
        sch: "\u5E78\u8FD0",
        bra: "Sorte",
        fre: "Chance",
        cze: "\u0160t\u011Bst\xed",
        hun: "Szerencse",
        rom: "Noroc",
        swe: "Tur",
        fil: "Swerte"
    },
    112: {
        eng: "When it comes to Unusuals, you've been:",
        rus: "\u041A\u043E\u0433\u0434\u0430 \u0434\u0435\u043B\u043E \u0434\u043E\u0445\u043E\u0434\u0438\u0442 \u0434\u043E \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430, \u0432\u044B \u0431\u044B\u043B\u0438:",
        pol: "Je\u015Bli chodzi o Nietypowe Okazy, to mia\u0142e\u015B:",
        sch: "\u5BF9\u4E8E\u7A00\u6709\u7269\u54C1\u6765\u8BF4\uFF0C\u60A8\uFF1A",
        bra: "Quando chega \xe0 itens Incomuns, voc\xea esteve:",
        fre: "Quant aux Inhabituels, vous avez \xe9t\xe9:",
        cze: "Ohledn\u011B Unusual p\u0159edm\u011Bt\u016F jsi m\u011Bl:",
        hun: "Rendk\xedv\xfcliket tekintve te:",
        rom: "Cand vine vorba de obiecte Neobisnuite, tu ai fost:",
        swe: "N\xe4r det kommer till Ovanliga f\xf6rem\xe5l har du haft:",
        fil: "Pagdating sa Unusuals, ikaw ay naging:"
    },
    113: {
        eng: "When it comes to Stranges, you've been:",
        rus: "\u041A\u043E\u0433\u0434\u0430 \u0434\u0435\u043B\u043E \u0434\u043E\u0445\u043E\u0434\u0438\u0442 \u0434\u043E \u0421\u0442\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430, \u0432\u044B \u0431\u044B\u043B\u0438:",
        pol: "Je\u015Bli chodzi o przedmioty Kuriozalne, to mia\u0142e\u015B:",
        sch: "\u5BF9\u4E8E\u5947\u5F02\u7269\u54C1\u6765\u8BF4\uFF0C\u60A8\uFF1A",
        bra: "Quando chega \xe0 itens Estranhos, voc\xea esteve:",
        fre: "Quant aux \xc9tranges, vous avez \xe9t\xe9:",
        cze: "Ohledn\u011B Strange p\u0159edm\u011Bt\u016F jsi m\u011Bl:",
        hun: "Fur\xe1kat tekintve te:",
        rom: "Cand vine vorba de obiecte Stranii, tu ai fost:",
        swe: "N\xe4r det kommer till Avvikande f\xf6rem\xe5l har du haft:",
        fil: "Pagdating sa Stranges, ikaw ay naging:"
    },
    114: {
        eng: "Lucky",
        rus: "\u0423\u0434\u0430\u0447\u043B\u0438\u0432\u044B",
        pol: "Szcz\u0119\u015Bcie",
        sch: "\u624B\u6C14\u4E0D\u9519",
        bra: "Sortudo",
        fre: "Chanceux",
        cze: "\u0160t\u011Bst\xed",
        hun: "Szerencs\xe9s vagy",
        rom: "Norocos",
        swe: "Tur",
        fil: "Mapalad"
    },
    115: {
        eng: "Unlucky",
        rus: "\u041D\u0435\u0443\u0434\u0430\u0447\u043B\u0438\u0432\u044B",
        pol: "Pech",
        sch: "\u8FD0\u6C14\u8F83\u5DEE",
        bra: "Azarado",
        fre: "Malchanceux",
        cze: "Sm\u016Flu",
        hun: "Balszerencs\xe9s vagy",
        rom: "Ghinionist",
        swe: "Otur",
        fil: "Malas"
    },
    116: {
        eng: "Neither lucky nor unlucky",
        rus: "\u041D\u0438 \u0443\u0434\u0430\u0447\u043B\u0438\u0432\u044B, \u043D\u0438 \u043D\u0435\u0443\u0434\u0430\u0447\u043B\u0438\u0432\u044B",
        pol: "Ani szcz\u0119\u015Bcie, ani pech",
        sch: "\u666E\u666E\u901A\u901A",
        bra: "Nem sortudo, nem azarado",
        fre: "Ni chanceux, ni malchanceux",
        cze: "Ani \u0161t\u011Bst\xed, ani sm\u016Flu",
        hun: "Se nem szerencs\xe9s se nem balszerencs\xe9s",
        rom: "Nici norocos, nici ghinionist",
        swe: "Varken tur eller otur",
        fil: "Hindi swerte o malas"
    },
    117: {
        eng: "Not enough data to calculate luck.<br>Come back later once you unbox more crates/cases.",
        rus: "\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u043B\u044F \u0440\u0430\u0441\u0447\u0451\u0442\u0430 \u0443\u0434\u0430\u0447\u0438.<br>\u0412\u0435\u0440\u043D\u0438\u0442\u0435\u0441\u044C \u043F\u043E\u0437\u0436\u0435, \u043A\u043E\u0433\u0434\u0430 \u043E\u0442\u043A\u0440\u043E\u0435\u0442\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 \u044F\u0449\u0438\u043A\u043E\u0432/\u043A\u0435\u0439\u0441\u043E\u0432.",
        pol: "Za ma\u0142o danych do obliczenia szcz\u0119\u015Bcia.<br>Wr\xf3\u0107 p\xf3\u017Aniej jak otworzysz wi\u0119cej skrzynek.",
        sch: "\u6682\u65E0\u8DB3\u591F\u6570\u636E\u6765\u8BA1\u7B97\u5E78\u8FD0\u3002<br>\u5F00\u542F\u66F4\u591A\u7BB1\u5B50\u540E\u518D\u6765\u67E5\u770B\u3002",
        bra: "N\xe3o temos muita data para calcular a sua sorte.<br>Volte quando voc\xea tiver aberto mais caixas.",
        fre: "Pas assez de donn\xe9es pour calculer la chance.<br>Revenez lorsque vous aurez d\xe9ball\xe9 plus de caisses.",
        cze: "Nedostatek dat pro v\xfdpo\u010Det \u0161t\u011Bst\xed.<br>Stav se pozd\u011Bji jakmile otev\u0159e\u0161 v\xedc krabic/beden.",
        hun: "Nincs el\xe9g adat a szerencse kisz\xe1m\xedt\xe1s\xe1hoz.<br>Gyere vissza k\xe9s\u0151bb, amikor m\xe1r t\xf6bb l\xe1d\xe1t/t\xe1sk\xe1t nyitott\xe1l ki.",
        rom: "Nu exista destula data pentru calcularea norocului.<br>Intoarce-te cand ai deschis mai multe cutii.",
        swe: "Det finns inte tillr\xe4ckligt med data f\xf6r att ber\xe4kna tur.<br>Kom tillbaka senare n\xe4r du har \xf6ppnat fler l\xe5dor.",
        fil: "Hindi sapat ang data para ikalkulahin ang swerte.<br>Bumalik ka mamaya kapag nakabukas ka pa ng mga kahon/kaso."
    },
    118: {
        eng: "Out of #TOTALUNBOXES# unboxes that could have an Unusual,<br>you unboxed #UNUSUALSUNBOXED#, ",
        rus: "\u0418\u0437 #TOTALUNBOXES# \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u0439, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0433\u043B\u0438 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u044B\u0439 \u043F\u0440\u0435\u0434\u043C\u0435\u0442,<br>\u0432\u044B \u043E\u0442\u043A\u0440\u044B\u043B\u0438 #UNUSUALSUNBOXED#, ",
        pol: "Z #TOTALUNBOXES# otwar\u0107 kt\xf3re mog\u0142y by\u0107 Nietypowym Okazem,<br>zdoby\u0142e\u015B #UNUSUALSUNBOXED#, ",
        sch: "\u5728 #TOTALUNBOXES# \u4E2A\u6709\u673A\u4F1A\u5F00\u51FA\u7A00\u6709\u7269\u54C1\u7684\u7BB1\u5B50\u4E2D\uFF0C<br>\u60A8\u5F00\u51FA\u4E86 #UNUSUALSUNBOXED# \u4E2A\u7A00\u6709\u7269\u54C1,",
        bra: "De #TOTALUNBOXES# de caixas que voc\xea abriu que poderiam ter um item Incomum,<br>voc\xea abriu #UNUSUALSUNBOXED#, ",
        fre: "Sur les #TOTALUNBOXES# caisses qui auraient pu \xeatre Inhabituelles,<br>vous avez d\xe9ball\xe9 #UNUSUALSUNBOXED#, ",
        cze: "Z celkov\xfdch #TOTALUNBOXES# otev\u0159en\xed, co mohly b\xfdt Unusual kvality,<br>jsi otev\u0159el #UNUSUALSUNBOXED#, ",
        hun: "A #TOTALUNBOXES# kibont\xe1sb\xf3l ami lehetett Rendk\xedv\xfcli,<br> kinyitott\xe1l #UNUSUALSUNBOXED#-t, ",
        rom: "Din atatea #TOTALUNBOXES# deschideri care au fi putut fi un obiect Neobisnuit,<br>tu ai deschis #UNUSUALSUNBOXED#, ",
        swe: "Ut av #TOTALUNBOXES# l\xe5dor som kunde ha ett Ovanlig f\xf6rem\xe5l,<br>fick du #UNUSUALSUNBOXED# stycken, ",
        fil: "Mula sa #TOTALUNBOXES# nabukas na maaring magkaroon ng Unusual,<br>nabukas mo #UNUSUALSUNBOXED#, "
    },
    119: {
        eng: "which is #DIFF# more than we predicted (#PREDICTION#).",
        rus: "\u0447\u0442\u043E \u043D\u0430 #DIFF# \u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u043C\u044B \u043F\u0440\u0435\u0434\u0441\u043A\u0430\u0437\u044B\u0432\u0430\u043B\u0438 (#PREDICTION#).",
        pol: "czyli #DIFF# wi\u0119cej ni\u017C si\u0119 spodziewali\u015Bmy (#PREDICTION#).",
        sch: "\u6BD4\u6211\u4EEC\u9884\u6D4B\u7684\uFF08#PREDICTION#\uFF09\u8981\u591A #DIFF# \u4E2A\u3002",
        bra: "que \xe9 #DIFF# mais do que a nossa predi\xe7\xe3o (#PREDICTION#).",
        fre: "ce qui est #DIFF# plus que nous avons pr\xe9dit (#PREDICTION#).",
        cze: "co\u017E je o #DIFF# v\xedc, ne\u017E jsme p\u0159edpokl\xe1dali (#PREDICTION#).",
        hun: "ami #DIFF#-al/el t\xf6bb, mint amennyire sz\xe1m\xedtani lehetett (#PREDICTION#).",
        rom: "ceea ce este #DIFF# mai mult decat am prezis (#PREDICTION#).",
        swe: "vilket \xe4r #DIFF# mer \xe4n vi f\xf6rutsp\xe5dde (#PREDICTION#).",
        fil: "ay #DIFF# masmari na sa predikto namin (#PREDICTION#)."
    },
    120: {
        eng: "which is #DIFF# less than we predicted (#PREDICTION#).",
        rus: "\u0447\u0442\u043E \u043D\u0430 #DIFF# \u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u043C\u044B \u043F\u0440\u0435\u0434\u0441\u043A\u0430\u0437\u044B\u0432\u0430\u043B\u0438 (#PREDICTION#).",
        pol: "czyli #DIFF# mniej ni\u017C si\u0119 spodziewali\u015Bmy (#PREDICTION#).",
        sch: "\u6BD4\u6211\u4EEC\u9884\u6D4B\u7684\uFF08#PREDICTION#\uFF09\u8981\u5C11 #DIFF# \u4E2A\u3002",
        bra: "que \xe9 #DIFF# menos do que a nossa predi\xe7\xe3o (#PREDICTION#).",
        fre: "ce qui est #DIFF# moins que nous avons pr\xe9dit (#PREDICTION#).",
        cze: "co\u017E je o #DIFF# m\xe9n\u011B, ne\u017E jsme p\u0159edpokl\xe1dali (#PREDICTION#).",
        hun: "ami #DIFF#-al/el kevesebb, mint amennyire sz\xe1m\xedtani lehetett (#PREDICTION#).",
        rom: "ceea ce este #DIFF# mai putin decat am prezis (#PREDICTION#).",
        swe: "vilket \xe4r #DIFF# mindre \xe4n vi f\xf6rutsp\xe5dde (#PREDICTION#).",
        fil: "ay #DIFF# masmababa sa predikto namin (#PREDICTION#)."
    },
    121: {
        eng: "same amount as our prediction.",
        rus: "\u0441\u0442\u043E\u043B\u044C\u043A\u043E \u0436\u0435, \u0441\u043A\u043E\u043B\u044C\u043A\u043E \u043C\u044B \u043F\u0440\u0435\u0434\u0441\u043A\u0430\u0437\u044B\u0432\u0430\u043B\u0438.",
        pol: "zgodnie z przewidywaniami.",
        sch: "\u7B26\u5408\u6211\u4EEC\u9884\u6D4B\u7684\u6570\u91CF\u3002",
        bra: "mesmo valor que a nossa predi\xe7\xe3o.",
        fre: "le m\xeame montant que nous avons pr\xe9dit.",
        cze: "stejn\xe1 hodnota jako na\u0161e predikce.",
        hun: "pontosan annyi, amennyire sz\xe1m\xedtani lehetett.",
        rom: "ceea ce este aceeasi suma pe care am prezis-o.",
        swe: "samma som vi f\xf6rutsp\xe5dde.",
        fil: "kaparehong halaga sa predikto namin."
    },
    122: {
        eng: "Out of #TOTALUNBOXES# unboxes that could have a Strange item,<br>you unboxed #STRANGESUNBOXED#, ",
        rus: "\u0418\u0437 #TOTALUNBOXES# \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u0439, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0433\u043B\u0438 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C Strange \u043F\u0440\u0435\u0434\u043C\u0435\u0442,<br>\u0432\u044B \u043E\u0442\u043A\u0440\u044B\u043B\u0438 #STRANGESUNBOXED#, ",
        pol: "Z #TOTALUNBOXES# otwar\u0107 kt\xf3re mog\u0142y by\u0107 przedmiotem Kuriozalnym,<br>zdoby\u0142e\u015B #STRANGESUNBOXED#, ",
        sch: "\u5728 #TOTALUNBOXES# \u4E2A\u6709\u673A\u4F1A\u5F00\u51FA\u5947\u5F02\u7269\u54C1\u7684\u7BB1\u5B50\u4E2D\uFF0C<br>\u60A8\u5F00\u51FA\u4E86 #STRANGESUNBOXED# \u4E2A\u5947\u5F02\u7269\u54C1\uFF0C",
        bra: "De #TOTALUNBOXES# de caixas que voc\xea abriu que poderiam ter um item Estranho,<br>voc\xea abriu #STRANGESUNBOXED#, ",
        fre: "Sur les #TOTALUNBOXES# caisses qui auraient pu \xeatre \xc9tranges,<br>vous avez d\xe9ball\xe9 #STRANGESUNBOXED#,",
        cze: "Z celkov\xfdch #TOTALUNBOXES# otev\u0159en\xed, co mohly b\xfdt Strange kvality,<br>jsi otev\u0159el #STRANGESUNBOXED#, ",
        hun: "A #TOTALUNBOXES# kibont\xe1sb\xf3l ami lehetett Fura t\xe1rgy,<br> kinyitott\xe1l #STRANGESUNBOXED#-t, ",
        rom: "Din atatea #TOTALUNBOXES# deschideri care au fi putut fi un obiect Straniu,<br>tu ai deschis #STRANGESUNBOXED#, ",
        swe: "Ut av #TOTALUNBOXES# l\xe5dor som kunde ha ett Ovanlig f\xf6rem\xe5l,<br>fick du #STRANGESUNBOXED# stycken, ",
        fil: "Mula sa #TOTALUNBOXES# nabukas na maaring merong Strange aytem,<br>and nabukas mo #STRANGESUNBOXED#, "
    },
    123: {
        eng: "Cancel",
        rus: "\u041E\u0442\u043C\u0435\u043D\u0430",
        pol: "Anuluj",
        sch: "\u53D6\u6D88",
        bra: "Cancelar",
        fre: "Annuler",
        cze: "Zru\u0161it",
        hun: "M\xe9gse",
        rom: "Anulare",
        swe: "Avbryt",
        fil: "Ikansel"
    },
    124: {
        eng: "This may take a few seconds.<br>Please be patient.",
        rus: "\u042D\u0442\u043E \u043C\u043E\u0436\u0435\u0442 \u0437\u0430\u043D\u044F\u0442\u044C \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0441\u0435\u043A\u0443\u043D\u0434.<br>\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0434\u043E\u0436\u0434\u0438\u0442\u0435.",
        pol: "To mo\u017Ce potrwa\u0107 chwil\u0119.<br>Prosz\u0119 o cierpliwo\u015B\u0107.",
        sch: "\u8FD9\u53EF\u80FD\u8981\u82B1\u51E0\u79D2\u6765\u5B8C\u6210\u3002<br>\u8BF7\u7A0D\u5019\u3002",
        bra: "Isso pode demorar alguns segundos.<br>Por favor tenha paci\xeancia.",
        fre: "Ceci pourrait prendre quelques secondes.<br>Veuillez patienter.",
        cze: "Tohle chvilku potrv\xe1.<br>Pros\xedm, po\u010Dkej.",
        hun: "Ez eltarthat p\xe1r m\xe1sodpercig.<br>K\xe9rlek l\xe9gy t\xfcrelmes.",
        rom: "Asta va dura cateva secunda.<br>Va rugam sa aveti rabdare.",
        swe: "Det kan ta n\xe5gra sekunder.<br>Ha t\xe5lamod.",
        fil: "Ito ay maaring tumagal ng kakaunting sigundo.<br>Please humintay ka."
    },
    125: {
        eng: "This will take a minute or two to process.<br>Please be patient.",
        rus: "\u042D\u0442\u043E \u0437\u0430\u0439\u043C\u0451\u0442 \u043C\u0438\u043D\u0443\u0442\u0443 \u0438\u043B\u0438 \u0434\u0432\u0435.<br>\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0434\u043E\u0436\u0434\u0438\u0442\u0435.",
        pol: "To mo\u017Ce potrwa\u0107 minut\u0119 lub dwie.<br>Prosz\u0119 o cierpliwo\u015B\u0107.",
        sch: "\u8FD9\u5C06\u9700\u8981\u51E0\u5206\u949F\u6765\u5B8C\u6210\u3002<br>\u8BF7\u7A0D\u5019\u3002",
        bra: "Isso pode demorar um minuto ou dois para processar.<br>Por favor tenha paci\xeancia.",
        fre: "Ceci prendra une minute ou deux \xe0 proc\xe9der.<br>Veuillez patienter.",
        cze: "Tohle zabere chvilku na zpracov\xe1n\xed.<br>Pros\xedm, bu\u010F trp\u011Bliv\xfd.",
        hun: "Ez eltarthat p\xe1r percig.<br>K\xe9rlek l\xe9gy t\xfcrelmes.",
        rom: "Asta va dura un minut sau doua pentru a se procesa.<br>Va rugam sa aveti rabdare.",
        swe: "Det tar en minut eller tv\xe5 att bearbeta.<br>Ha t\xe5lamod.",
        fil: "Ito ay tatagal ng isa o dalawang minuto para i-proses.<br>Please humintay ka."
    },
    126: {
        eng: "Sheen:",
        rus: "\u0411\u043B\u0435\u0441\u043A:",
        pol: "Po\u0142ysk",
        sch: "\u6B66\u5668\u5149\u6CFD\u7279\u6548\uFF1A",
        bra: "Brilho:",
        fre: "\xc9clat:",
        cze: "Lesk:",
        hun: "Ragyog\xe1s:",
        rom: "Luciu:",
        swe: "Glans:"
    },
    127: {
        eng: "Killstreaker:",
        rus: "\u042D\u0444\u0444\u0435\u043A\u0442 \u0443\u0431\u0438\u0439\u0441\u0442\u0432:",
        pol: "Seryjny Zab\xf3jca:",
        sch: "\u8FDE\u6740\u8005\u7279\u6548\uFF1A",
        bra: "Efeito de combo:",
        fre: "Killstreak:",
        cze: "Efekt p\u0159i s\xe9rii zabit\xed:",
        hun: "\xc1mokfut\xf3:",
        rom: "Omor Consecutiv:",
        swe: "Killstreaker:"
    },
    128: {
        eng: "Team Shine",
        rus: "\u041A\u043E\u043C\u0430\u043D\u0434\u043D\u044B\u0439 \u0431\u043B\u0435\u0441\u043A",
        pol: "blask dru\u017Cyny",
        sch: "\u56E2\u961F\u4E4B\u5149",
        bra: "Brilho da equipe",
        fre: "\xc9clat d'\xe9quipe",
        cze: "Team Shine",
        hun: "Csapat-ragyog\xe1s",
        rom: "Luciu de Echipa",
        swe: "Lag Glans"
    },
    129: {
        eng: "Hot Rod",
        rus: "\u0425\u043E\u0442-\u0440\u043E\u0434",
        pol: "hot rod",
        sch: "\u8D64\u7EA2\u65B0\u661F",
        bra: "Rajada de roxo",
        fre: "\xc9clat de chaleur",
        cze: "Hot Rod",
        hun: "\xcdvad\xf3",
        rom: "Tija Fierbinte",
        swe: "Hot Rod"
    },
    130: {
        eng: "Manndarin",
        rus: "\u041C\u0430\u043D\u0434\u0430\u0440\u0438\u043D\u043A\u0430",
        pol: "manndarynka",
        sch: "\u4F17\u5FD7\u6210\u6A59",
        bra: "Manndarin",
        fre: "Manndarine",
        cze: "Manndarin",
        hun: "Manndarin",
        rom: "Mandarina",
        swe: "Manndarin"
    },
    131: {
        eng: "Deadly Daffodil",
        rus: "\u0421\u043C\u0435\u0440\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043D\u0430\u0440\u0446\u0438\u0441\u0441",
        pol: "nieludzki narcyz",
        sch: "\u81F4\u547D\u6C34\u4ED9",
        bra: "Narciso nefasto",
        fre: "Jonquille mortelle",
        cze: "Deadly Daffodil",
        hun: "Hal\xe1los N\xe1rcisz",
        rom: "Narcisa Mortala",
        swe: "D\xf6dliga P\xe5sklilja"
    },
    132: {
        eng: "Agonizing Emerald",
        rus: "\u041C\u0443\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0438\u0437\u0443\u043C\u0440\u0443\u0434",
        pol: "bolesny szmaragd",
        sch: "\u82E6\u96BE\u7FE1\u7FE0",
        bra: "Esmeralda agonizante",
        fre: "\xc9meraude agonisant",
        cze: "Agonizing Emerald",
        hun: "Gy\xf6trelmes Smaragd",
        rom: "Emerald Agonizant",
        swe: "Pl\xe5gsamma Smaragd"
    },
    133: {
        eng: "Mean Green",
        rus: "\u0417\u043B\u043E\u0431\u043D\u043E-\u0437\u0435\u043B\u0451\u043D\u044B\u0439",
        pol: "z\u0142o\u015Bliwa ziele\u0144",
        sch: "\u7EFF\u884C\u7EFF\u7D20",
        bra: "Lima maligna",
        fre: "M\xe9chamment vert",
        cze: "Mean Green",
        hun: "Durva Z\xf6ld",
        rom: "Verde Rautacios",
        swe: "Sn\xe5la Gr\xf6n"
    },
    134: {
        eng: "Villainous Violet",
        rus: "\u0417\u043B\u043E\u0434\u0435\u0439\u0441\u043A\u0438\u0439 \u0444\u0438\u043E\u043B\u0435\u0442\u043E\u0432\u044B\u0439",
        pol: "perfidna purpura",
        sch: "\u7F6A\u6076\u7D2B\u7F57\u5170",
        bra: "Violeta vil",
        fre: "Vil violet",
        cze: "Villainous Violet",
        hun: "Aljas Lila",
        rom: "Violet Raufacator",
        swe: "Skurklig Violett"
    },
    135: {
        eng: "Cerebral Discharge",
        rus: "\u0426\u0435\u0440\u0435\u0431\u0440\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0430\u0437\u0440\u044F\u0434",
        pol: "m\xf3zgowe wy\u0142adowanie",
        sch: "\u5927\u8111\u653E\u7535",
        bra: "Descarga cerebral",
        fre: "D\xe9charge c\xe9r\xe9brale",
        cze: "Cerebral Discharge",
        hun: "Agyi Kis\xfcl\xe9s",
        rom: "Descarcare Cerebrala",
        swe: "Cerebral Urladdning"
    },
    136: {
        eng: "Fire Horns",
        rus: "\u041E\u0433\u043D\u0435\u043D\u043D\u044B\u0435 \u0440\u043E\u0433\u0430",
        pol: "ogniste rogi",
        sch: "\u706B\u7130\u53F7\u89D2",
        bra: "Chifres ardentes",
        fre: "Cornes de feu",
        cze: "Fire Horns",
        hun: "T\xfczes Szarvak",
        rom: "Coarne de Foc",
        swe: "Eld Horn"
    },
    137: {
        eng: "Flames",
        rus: "\u041F\u043B\u0430\u043C\u044F",
        pol: "p\u0142omienie",
        sch: "\u706B\u7130",
        bra: "Chamas",
        fre: "Flammes",
        cze: "Flames",
        hun: "L\xe1ngok",
        rom: "Flacari",
        swe: "Flammor"
    },
    138: {
        eng: "Hypno-Beam",
        rus: "\u0413\u0438\u043F\u043D\u043E\u043B\u0443\u0447",
        pol: "hipno-promie\u0144",
        sch: "\u50AC\u7720\u5149\u675F",
        bra: "Raio hipnotizante",
        fre: "Rayon hypnotique",
        cze: "Hypno-Beam",
        hun: "Hipno-nyal\xe1b",
        rom: "Raza-Hipnotica",
        swe: "Hypno-Str\xe5le"
    },
    139: {
        eng: "Incinerator",
        rus: "\u0418\u0441\u043F\u0435\u043F\u0435\u043B\u0438\u0442\u0435\u043B\u044C",
        pol: "spopielacz",
        sch: "\u711A\u5316\u7089",
        bra: "Incinerador",
        fre: "Incin\xe9rateur",
        cze: "Incinerator",
        hun: "Kremat\xf3rium",
        rom: "Incinerator",
        swe: "F\xf6rbr\xe4nning"
    },
    140: {
        eng: "Singularity",
        rus: "\u0421\u0438\u043D\u0433\u0443\u043B\u044F\u0440\u043D\u043E\u0441\u0442\u044C",
        pol: "osobliwo\u015B\u0107",
        sch: "\u5947\u70B9",
        bra: "Singularidade",
        fre: "Singularit\xe9",
        cze: "Singularity",
        hun: "Szingularit\xe1s",
        rom: "Singularitate",
        swe: "S\xe4regenhet"
    },
    141: {
        eng: "Tornado",
        rus: "\u0422\u043E\u0440\u043D\u0430\u0434\u043E",
        pol: "tornado",
        sch: "\u98D3\u98CE",
        bra: "Tornado",
        fre: "Tornade",
        cze: "Tornado",
        hun: "Torn\xe1d\xf3",
        rom: "Tornada",
        swe: "Tornado"
    },
    142: {
        eng: "Killstreak Kits obtained from this crate may be unboxed as Specialized or Professional Killstreak Kits instead.",
        rus: "\u041D\u0430\u0431\u043E\u0440\u044B \u0443\u0431\u0438\u0439\u0441\u0442\u0432, \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u044B\u0435 \u0438\u0437 \u044D\u0442\u043E\u0433\u043E \u044F\u0449\u0438\u043A\u0430, \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u043A\u0440\u044B\u0442\u044B \u043A\u0430\u043A \u0421\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0438\u043B\u0438 \u041F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u043D\u0430\u0431\u043E\u0440\u044B \u0443\u0431\u0438\u0439\u0441\u0442\u0432.",
        pol: "Zestawy z seri\u0105 zab\xf3jstw z tej skrzynki mog\u0105 zosta\u0107 zast\u0105pione zestawami z wyspecjalizowan\u0105 lub profesionaln\u0105 seri\u0105 zab\xf3jstw.",
        sch: "\u4ECE\u8FD9\u4E2A\u7BB1\u5B50\u4E2D\u83B7\u5F97\u7684\u8FDE\u6740\u8BB0\u5F55\u5DE5\u5177\u5305\u53EF\u80FD\u4E3A\u9AD8\u7EA7\u6216\u804C\u4E1A\u54C1\u8D28\u3002",
        bra: "Kits de Combo obtidos por essa caixa podem ser desencaixotados como Kits de Combo Especializados ou Kits de Combo Profissionais.",
        fre: "Les kits Killstreak obtenus de cette caisse peuvent \xeatre Sp\xe9cialis\xe9s ou Professionels plut\xf4t qu'Unique.",
        cze: "Kity z t\xe9to krabice mohou b\xfdt verze Specialized nebo Professional.",
        hun: "Az \xc1mokfut\xe1s k\xe9szletek ebb\u0151l a l\xe1d\xe1b\xf3l lehetnek Specializ\xe1lt vagy Hivat\xe1sos \xc1mokfut\xe1s K\xe9szleteket.",
        rom: "Trusele de Omoruri Consecutive obtinute din aceasta cutie pot fi deschise ca de Specialitate sau Truse Profesionale de Omor Consecutiv.",
        swe: "Killstreak-kit som \xf6ppnas fr\xe5n denna l\xe5dan kan i st\xe4llet vara \xf6ppnade som specialiserade eller professionella Killstreak-kit.",
        fil: "Killstreak Kits na makukuha sa kahon nito ay mabubuksan na Specialized o Professional Killstreak Kits sa halip."
    },
    143: {
        eng: "Bonus items unboxed:",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u043E \u0431\u043E\u043D\u0443\u0441\u043D\u044B\u0445 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432:",
        pol: "Otrzymane przedmioty dodatkowe:",
        sch: "\u5DF2\u5F00\u51FA\u5956\u52B1\u7269\u54C1\uFF1A",
        bra: "Itens de b\xf4nus desencaixotados:",
        fre: "Objets bonus d\xe9ball\xe9s:",
        cze: "Z\xedsk\xe1no bonusov\xfdch p\u0159edm\u011Bt\u016F:",
        hun: "B\xf3nuszt\xe1rgyak kibontva:",
        rom: "Obiecte bonus deschise:",
        swe: "Bonus f\xf6rem\xe5l \xf6ppnade:",
        fil: "Bonus aytem nabukas:"
    },
    144: {
        eng: "Bonus items",
        rus: "\u0411\u043E\u043D\u0443\u0441\u043D\u044B\u0435 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u044B",
        pol: "Dodatkowe przedmioty",
        sch: "\u5956\u52B1\u7269\u54C1",
        bra: "Itens de b\xf4nus",
        fre: "Objets bonus",
        cze: "Bonusov\xe9 p\u0159edm\u011Bty",
        hun: "B\xf3nuszt\xe1rgy",
        rom: "Obiecte bonus deschise",
        swe: "Bonusf\xf6rem\xe5l",
        fil: "Bonus aytem"
    },
    145: {
        eng: "None",
        rus: "\u041D\u0435\u0442",
        pol: "Brak",
        sch: "\u65E0",
        bra: "Nenhum",
        fre: "Rien",
        cze: "\u017D\xe1dn\xe9",
        hun: "Semmi",
        rom: "Niciunul",
        swe: "Inga",
        fil: "Wala"
    },
    146: {
        eng: "Unique",
        rus: "\u0423\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439",
        pol: "Unikalny",
        sch: "\u72EC\u7279",
        bra: "\xdanico",
        fre: "Unique",
        cze: "Unique",
        hun: "Egyedi",
        rom: "Unic",
        swe: "Unik"
    },
    147: {
        eng: "This case may contain bonus items.",
        rus: "\u042D\u0442\u043E\u0442 \u043A\u0435\u0439\u0441 \u043C\u043E\u0436\u0435\u0442 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u0431\u043E\u043D\u0443\u0441\u043D\u044B\u0435 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u044B.",
        pol: "Ta skrzynka mo\u017Ce zawiera\u0107 dodatkowe przedmioty.",
        sch: "\u8FD9\u4E2A\u7BB1\u5B50\u53EF\u80FD\u5305\u542B\u5956\u52B1\u7269\u54C1\u3002",
        bra: "Essa caixa pode conter itens de b\xf4nus.",
        fre: "Cette caisse peut contenir des objets bonus.",
        cze: "Tato bedna m\u016F\u017Ee obsahovat bonusov\xe9 p\u0159edm\u011Bty.",
        hun: "Ebben a t\xe1sk\xe1ban b\xf3nuszt\xe1rgyak lehetnek.",
        rom: "Aceasta cutie poate contine obiecte bonus.",
        swe: "Detta l\xe5da kan inneh\xe5lla bonusf\xf6rem\xe5l.",
        fil: "Itong kaso ay maaring merong bonus aytem."
    },
    148: {
        eng: "Crate/case-exclusive bonus items:",
        rus: "\u042D\u043A\u0441\u043A\u043B\u044E\u0437\u0438\u0432\u043D\u044B\u0435 \u0431\u043E\u043D\u0443\u0441\u043D\u044B\u0435 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u044B \u0438\u0437 \u044F\u0449\u0438\u043A\u0430/\u043A\u0435\u0439\u0441\u0430:",
        pol: "Dodatkowe przedmioty ekskluzywne dla tej skrzynki:",
        sch: "\u7BB1\u5B50\u7279\u6709\u5956\u52B1\u7269\u54C1\uFF1A",
        bra: "Itens exclusivos para essa caixa:",
        fre: "Objets exclusifs de cette caisse:",
        cze: "Bonusov\xe9 p\u0159edm\u011Bty exkluzivn\u011B dle krabice/bedny",
        hun: "L\xe1da/t\xe1ska-exkluz\xedv b\xf3nuszt\xe1rgyak:",
        rom: "Obiect bonus exclusiv cutiei:",
        swe: "Bonusf\xf6rem\xe5l exclusivt f\xf6r l\xe5dan:",
        fil: "Kahon/kaso-ekslusibong bonus aytem:"
    },
    149: {
        eng: "Stop unboxing at certain items:",
        rus: "\u041E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u0435 \u043F\u0440\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0451\u043D\u043D\u044B\u0445 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u0430\u0445:",
        pol: "Przerwij otwieranie po otrzymaniu specyficznych przedmiot\xf3w:",
        sch: "\u5F00\u51FA\u7279\u5B9A\u7269\u54C1\u65F6\u505C\u6B62\u5F00\u7BB1\uFF1A",
        bra: "Pare de desencaixotar em certos itens:",
        fre: "Arr\xeater de d\xe9baller \xe0 certains objets:",
        cze: "Pozastavit rozbalov\xe1n\xed na ur\u010Dit\xfdch p\u0159edm\u011Btech:",
        hun: "Kibont\xe1s meg\xe1ll\xedt\xe1sa bizonyos t\xe1rgyakn\xe1l:",
        rom: "Nu mai deschide la anumite obiecte:",
        swe: "Sluta \xf6ppna vid vissa objekt:",
        fil: "Tumigil bumukas sa tiyak na aytem:"
    },
    150: {
        eng: "This will prevent you from accidentally unboxing another crate/case after getting certain items.",
        rus: "\u042D\u0442\u043E \u043F\u0440\u0435\u0434\u043E\u0442\u0432\u0440\u0430\u0442\u0438\u0442 \u0441\u043B\u0443\u0447\u0430\u0439\u043D\u043E\u0435 \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u0435 \u0434\u0440\u0443\u0433\u043E\u0433\u043E \u044F\u0449\u0438\u043A\u0430/\u043A\u0435\u0439\u0441\u0430 \u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0451\u043D\u043D\u044B\u0445 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u0432.",
        pol: "Ta opcja tymczasowo przerwie otwieranie po otrzymaniu wybranych przedmiot\xf3w.",
        sch: "\u6B64\u9009\u9879\u9632\u6B62\u60A8\u5728\u5F00\u51FA\u7279\u5B9A\u7269\u54C1\u540E\u610F\u5916\u5F00\u542F\u53E6\u4E00\u4E2A\u7BB1\u5B50\u3002",
        bra: "Isso vai prevenir voc\xea de acidentalmente desencaixotar outra caixa depois de obter certos itens.",
        fre: "Ceci vous emp\xeache d'accidentellement d\xe9baller une autre caisse apr\xe8s l'obtention de certains objets.",
        cze: "Tato mo\u017Enost na moment pozastav\xed otev\xedr\xe1n\xed beden po obdr\u017Een\xed ur\u010Dit\xfdch p\u0159edm\u011Bt\u016F.",
        hun: "Ez megakad\xe1lyozza, hogy v\xe9letlen\xfcl kibonts egy \xfajabb l\xe1d\xe1t/t\xe1sk\xe1t egy bizonyos t\xe1rgy kibont\xe1sa ut\xe1n.",
        rom: "Aceasta te va opri din a deschide din greseala o cutie dupa ce ai primit anumite obiecte.",
        swe: "Detta kommer att f\xf6rhindra att du av misstag \xf6ppnar en till l\xe5da efter att ha f\xe5tt vissa f\xf6rem\xe5l.",
        fil: "Ito ay ipipigilan ka sa pagaksidenteng pagbukas ng isa pang kahon/kaso pagtapos makuha ng tiyak na aytem."
    },
    151: {
        eng: "Items",
        rus: "\u041F\u0440\u0435\u0434\u043C\u0435\u0442\u044B",
        pol: "Przedmioty",
        sch: "\u7269\u54C1",
        bra: "Itens",
        fre: "Objets",
        cze: "P\u0159edm\u011Bty",
        hun: "T\xe1rgyak",
        rom: "Obiecte",
        swe: "F\xf6rem\xe5l",
        fil: "Aytem"
    },
    152: {
        eng: "Page #PAGE# of #TOTAL#",
        rus: "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 #PAGE# \u0438\u0437 #TOTAL#",
        pol: "Strona #PAGE# z #TOTAL#",
        sch: "\u7B2C #PAGE# / #TOTAL# \u9875",
        bra: "P\xe1gina #PAGE# de #TOTAL#",
        fre: "Page #PAGE# de #TOTAL#",
        cze: "Strana #PAGE# z #TOTAL#",
        hun: "Oldal #PAGE# a #TOTAL#-b\xf3l/b\u0151l",
        rom: "Pagina #PAGE# din #TOTAL#",
        swe: "Sida #PAGE# av #TOTAL#",
        fil: "Pahina #PAGE ng #TOTAL#"
    },
    153: {
        eng: "Single bonus items unboxed:",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u043E \u044F\u0449\u0438\u043A\u043E\u0432 \u0441 \u043E\u0434\u0438\u043D\u043E\u0447\u043D\u044B\u043C\u0438 \u0431\u043E\u043D\u0443\u0441\u043D\u044B\u043C\u0438 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u0430\u043C\u0438:",
        pol: "Otrzymane pojedyncze przedmioty dodatkowe:",
        sch: "\u5F00\u51FA\u4E00\u4E2A\u5956\u52B1\u7269\u54C1\u7684\u6B21\u6570\uFF1A",
        bra: "Singelos itens de b\xf4nus desencaixotados:",
        fre: "Objets bonus singuliers d\xe9ball\xe9s:",
        cze: "Rozbaleno jednotliv\xfdch bonusov\xfdch p\u0159edm\u011Bt\u016F:",
        hun: "Szimpla b\xf3nuszt\xe1rgyak kibontva:",
        rom: "Singurele obiecte bonus deschise:",
        swe: "Enstaka bonusf\xf6rem\xe5l \xf6ppnade:",
        fil: "Isang bonus na aytem nabukas:"
    },
    154: {
        eng: "Double bonus items unboxed:",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u043E \u044F\u0449\u0438\u043A\u043E\u0432 \u0441 \u0434\u0432\u043E\u0439\u043D\u044B\u043C\u0438 \u0431\u043E\u043D\u0443\u0441\u043D\u044B\u043C\u0438 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u0430\u043C\u0438:",
        pol: "Otrzymane podw\xf3jne przedmioty dodatkowe:",
        sch: "\u5F00\u51FA\u4E24\u4E2A\u5956\u52B1\u7269\u54C1\u7684\u6B21\u6570\uFF1A",
        bra: "Duplos itens de b\xf4nus desencaixotados:",
        fre: "Objets bonus doubles d\xe9ball\xe9s:",
        cze: "Rozbaleno dvojn\xe1sobn\xfdch bonusov\xfdch p\u0159edm\u011Bt\u016F:",
        hun: "Dupla b\xf3nuszt\xe1rgyak kibontva:",
        rom: "Obiecte bonus duble deschise:",
        swe: "Dubbel-bonusf\xf6rem\xe5l \xf6ppnade:",
        fil: "Dalawang bonus na aytem nabukas:"
    },
    155: {
        eng: "Triple bonus items unboxed:",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u043E \u044F\u0449\u0438\u043A\u043E\u0432 \u0441 \u0442\u0440\u043E\u0439\u043D\u044B\u043C\u0438 \u0431\u043E\u043D\u0443\u0441\u043D\u044B\u043C\u0438 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u0430\u043C\u0438:",
        pol: "Otrzymane potr\xf3jne przedmioty dodatkowe:",
        sch: "\u5F00\u51FA\u4E09\u4E2A\u5956\u52B1\u7269\u54C1\u7684\u6B21\u6570\uFF1A",
        bra: "Triplos itens de b\xf4nus desencaixotados:",
        fre: "Objets bonus triples d\xe9ball\xe9s:",
        cze: "Rozbaleno trojn\xe1sobn\xfdch bonusov\xfdch p\u0159edm\u011Bt\u016F:",
        hun: "Tripla b\xf3nuszt\xe1rgyak kibontva:",
        rom: "Obiecte bonus triple deschise:",
        swe: "Trippel-bonusf\xf6rem\xe5l \xf6ppnade:",
        fil: "Tatlong bonus na aytem nabukas:"
    },
    156: {
        eng: "Unusualifiers unboxed:",
        rus: "\u041E\u0442\u043A\u0440\u044B\u0442\u043E \u043D\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0442\u0438\u0437\u0430\u0442\u043E\u0440\u043E\u0432:",
        pol: "Otrzymane uniezwyklacze:",
        sch: "\u5F00\u51FA\u7A00\u6709\u8F6C\u5316\u9B54\u6CD5\uFF1A",
        bra: "Incomunizadores desencaixotados:",
        fre: "Inhabituellisateurs d\xe9ball\xe9s:",
        cze: "Rozbaleno Unusualifier\u016F:",
        hun: "Rendk\xedv\xfclies\xedt\u0151k kibontva:",
        rom: "Neobisnuitoare deschise:",
        swe: "Ovanlighetsg\xf6rare \xf6ppnade:",
        fil: "Unusualifiers nabukas:"
    },
    157: {
        eng: "Strange Stat Clock Attached",
        rus: "\u041F\u0440\u0438\u043A\u0440\u0435\u043F\u043B\u0451\u043D \u043A \u0421\u0442\u0440\u0430\u043D\u043D\u043E\u043C\u0443 \u0441\u0447\u0451\u0442\u0447\u0438\u043A\u0443",
        pol: "Do\u0142\u0105czony licznik zab\xf3jstw",
        sch: "\u5DF2\u9644\u4E0A\u7EDF\u8BA1\u8BB0\u5F55\u8868",
        bra: "Contador Estranho de estat\xedsticas anexado",
        fre: "Compeur de statistiques \xc9trange attach\xe9",
        cze: "M\xe1 p\u0159id\u011Blan\xfd modul pro z\xe1znam (Strange)",
        hun: "Fura statisztikasz\xe1ml\xe1l\xf3 csatlakoztatva",
        rom: "Ceas Straniu de Statistici atasat",
        swe: "Avvikande Statsklocka Bifogad"
    },
    158: {
        eng: "Unusualifiers",
        rus: "\u041D\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0442\u0438\u0437\u0430\u0442\u043E\u0440",
        pol: "Uniezwyklacze",
        sch: "\u7A00\u6709\u8F6C\u5316\u9B54\u6CD5",
        bra: "Incomunizadores",
        fre: "Inhabituellisateurs",
        cze: "Unusualifiery",
        hun: "Rendk\xedv\xfclies\xedt\u0151k",
        rom: "Neobisnuitoare",
        swe: "Ovanlighetsg\xf6rare"
    },
    159: {
        eng: "Stranges",
        rus: "\u0421\u0442\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430",
        pol: "Przedmioty kuriozalne",
        sch: "\u5947\u5F02",
        bra: "Estranhos",
        fre: "\xc9tranges",
        cze: "Strange p\u0159edm\u011Bty",
        hun: "Fur\xe1k",
        rom: "Obiecte stranii",
        swe: "Avvikande"
    },
    160: {
        eng: "Grade",
        rus: "\u041A\u043B\u0430\u0441\u0441",
        pol: "Stopie\u0144",
        sch: "\u7B49\u7EA7",
        bra: "N\xedvel",
        fre: "Grade",
        cze: "T\u0159\xedda",
        hun: "Fokozat",
        rom: "Grad",
        swe: "Grad",
        fil: "Grado"
    },
    161: {
        eng: "Prof. killstreak kits",
        rus: "\u041F\u0440\u043E\u0444. \u043D\u0430\u0431\u043E\u0440\u044B \u0443\u0431\u0438\u0439\u0441\u0442\u0432",
        pol: "Zestawy z prof. seri\u0105 zab\xf3jstw",
        sch: "\u804C\u4E1A\u8FDE\u6740\u8BB0\u5F55\u5DE5\u5177\u5305",
        bra: "Kits de Combo Profissionais",
        fre: "Kits killstreak pro.",
        cze: "Prof. killstreak kity",
        hun: "Hiv. \xe1mokfut\xe1s k\xe9szlet",
        rom: "Truse Profesionale de Omoruri Consecutive",
        swe: "Prof. killstreak-kit"
    },
    162: {
        eng: "Triple bonus items",
        rus: "\u0422\u0440\u043E\u0439\u043D\u044B\u0435 \u0431\u043E\u043D\u0443\u0441\u043D\u044B\u0435 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u044B",
        pol: "Potr\xf3jne przedmioty dodatkowe",
        sch: "\u4E09\u4E2A\u5956\u52B1\u7269\u54C1",
        bra: "Triplos itens de b\xf4nus",
        fre: "Objets bonus triples",
        cze: "Trojn\xe1sobn\xfd bonusov\xfd p\u0159edm\u011Bt",
        hun: "Tripla b\xf3nuszt\xe1rgyak",
        rom: "Obiecte bonus triple",
        swe: "Trippel-bonusf\xf6rem\xe5l",
        fil: "Tripleng bonus aytem"
    },
    163: {
        eng: "Grade Mercenary",
        rus: "\u041A\u043B\u0430\u0441\u0441 \u041D\u0430\u0451\u043C\u043D\u0438\u043A\u0430",
        pol: "Stopie\u0144 Najemnik",
        sch: "\u96C7\u4F63\u7EA7",
        bra: "N\xedvel Mercen\xe1rio",
        fre: "Grade Mercenaire",
        cze: "T\u0159\xedda Mercenary",
        hun: "Zsoldos Fokozat",
        rom: "Grad de Mercenar",
        swe: "Legosoldats Grad",
        fil: "Gradong Mercenary"
    },
    164: {
        eng: "Grade Commando",
        rus: "\u041A\u043B\u0430\u0441\u0441 \u0411\u043E\u0439\u0446\u0430",
        pol: "Stopie\u0144 Komandos",
        sch: "\u7279\u79CD\u7EA7",
        bra: "N\xedvel Comando",
        fre: "Grade Commando",
        cze: "T\u0159\xedda Commando",
        hun: "Kommand\xf3s Fokozat",
        rom: "Grad de Comando",
        swe: "Kommando Grad",
        fil: "Gradong Commando"
    },
    165: {
        eng: "Grade Assassin",
        rus: "\u041A\u043B\u0430\u0441\u0441 \u0423\u0431\u0438\u0439\u0446\u044B",
        pol: "Stopie\u0144 Asasyn",
        sch: "\u523A\u6740\u7EA7",
        bra: "N\xedvel Assassino",
        fre: "Grade Assassin",
        cze: "T\u0159\xedda Assassin",
        hun: "Orgyilkos Fokozat",
        rom: "Grad de Asasain",
        swe: "L\xf6nnm\xf6rdar Grad",
        fil: "Gradong Assassin"
    },
    166: {
        eng: "Grade Elite",
        rus: "\u041A\u043B\u0430\u0441\u0441 \u042D\u043B\u0438\u0442\u043D\u043E\u0433\u043E \u0431\u043E\u0439\u0446\u0430",
        pol: "Stopie\u0144 Elita",
        sch: "\u7CBE\u82F1\u7EA7",
        bra: "N\xedvel Elite",
        fre: "Grade \xc9lite",
        cze: "T\u0159\xedda Elite",
        hun: "Elit Fokozat",
        rom: "Grad de Elit\u0103",
        swe: "Elit Grad",
        fil: "Gradong Elite"
    },
    167: {
        eng: "Mercenary",
        rus: "\u041D\u0430\u0451\u043C\u043D\u0438\u043A\u0430",
        pol: "Najemnik",
        sch: "\u96C7\u4F63",
        bra: "Mercen\xe1rio",
        fre: "Mercenaire",
        cze: "Mercenary",
        hun: "Zsoldos",
        rom: "Mercenar",
        swe: "Legosoldat"
    },
    168: {
        eng: "Commando",
        rus: "\u0411\u043E\u0439\u0446\u0430",
        pol: "Komandos",
        sch: "\u7279\u79CD",
        bra: "Comando",
        fre: "Commando",
        cze: "Commando",
        hun: "Kommand\xf3s",
        rom: "Comando",
        swe: "Kommando"
    },
    169: {
        eng: "Assassin",
        rus: "\u0423\u0431\u0438\u0439\u0446\u044B",
        pol: "Asasyn",
        sch: "\u523A\u6740",
        bra: "Assassino",
        fre: "Assassin",
        cze: "Assassin",
        hun: "Orgyilkos",
        rom: "Asasin",
        swe: "L\xf6nnm\xf6rdar"
    },
    170: {
        eng: "Elite",
        rus: "\u042D\u043B\u0438\u0442\u043D\u043E\u0433\u043E \u0431\u043E\u0439\u0446\u0430",
        pol: "Elita",
        sch: "\u7CBE\u82F1",
        bra: "Elite",
        fre: "\xc9lite",
        cze: "Elite",
        hun: "Elit",
        rom: "Elit\u0103",
        swe: "Elit"
    },
    171: {
        eng: "Bulk unboxing in progress...",
        rus: "\u041C\u0430\u0441\u0441\u043E\u0432\u043E\u0435 \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u0435 \u0432 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0435...",
        pol: "Trwa otwieranie wielu skrzynek...",
        sch: "\u6B63\u5728\u6279\u91CF\u5F00\u7BB1...",
        bra: "Desencaixotamento em massa em andamento...",
        fre: "D\xe9ballage de masse en cours...",
        cze: "Rozbalov\xe1n\xed hromadn\xe9ho obsahu...",
        hun: "Nagyt\xe9tel\u0171 kibont\xe1s folyamatban...",
        rom: "Deschidere in masa in progres...",
        swe: "Mass\xf6ppning p\xe5g\xe5r ...",
        fil: "Maramihang pagbukas na sa progreso..."
    },
    172: {
        eng: "Bulk unboxing results",
        rus: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u043C\u0430\u0441\u0441\u043E\u0432\u043E\u0433\u043E \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F",
        pol: "Wyniki zbiorczego otwierania",
        sch: "\u6279\u91CF\u5F00\u7BB1\u7ED3\u679C",
        bra: "Resultados de desencaixotamento em massa",
        fre: "R\xe9sultats du d\xe9ballage de masse",
        cze: "V\xfdsledky hromadn\xe9ho rozbalov\xe1n\xed",
        hun: "Nagyt\xe9tel\u0171 kibont\xe1s eredm\xe9nyei",
        rom: "Deschidere in masa rezultate",
        swe: "Mass\xf6ppning resultat",
        fil: "Resulto ng maramihang pagbukas "
    },
    173: {
        eng: "Enable EOTL glitched Unusuals:",
        rus: "\u0412\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0431\u0430\u0433 \u0441 \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u044B\u043C\u0438 EOTL:",
        pol: "W\u0142\u0105cz zglitchowane Nietypowe Okazy EOTL:",
        sch: "\u542F\u7528 EOTL \u5F02\u5E38\u7A00\u6709\u7269\u54C1\uFF1A",
        bra: "Ativar itens Incomuns falhados do EOTL:",
        fre: "Activer les Inhabituels bugg\xe9s EOTL:",
        cze: "Povoluje EOTL glitchnut\xe9 Unusual p\u0159edm\u011Bty:",
        hun: "V\xe9g\xe1llom\xe1s Friss\xedt\xe9s hib\xe1s Rendk\xedv\xfcliek enged\xe9lyez\xe9se:",
        rom: "Porneste EOTL obiecte Neobisnuite buguite",
        swe: "Aktivera EOTL glitchade Ovanliga f\xf6rem\xe5l:",
        fil: "Ibukas ang EOTL glitched Unusuals:"
    },
    174: {
        eng: 'Allows the Hunter Heavy, Coldfront Curbstompers and Sleeveless in Siberia to be unboxed in Unusual quality from the End of the Line Community Crate.',
        rus: "\u041F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u043E\u0442\u043A\u0440\u044B\u0442\u044C Hunter Heavy, Coldfront Curbstompers \u0438 Sleeveless in Siberia \u0432 \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u043C \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u0438\u0437 Community Crate End of the Line.",
        pol: 'Pozwala na otrzymanie "\u0141owcy grubego zwierza", "Zimowych zgniataczy" i "Syberyjskiego bezr\u0119kawnika" jako Nietypowych Okaz\xf3w z skrzynki aktualizacji spo\u0142eczno\u015Bci \u201EKoniec trasy\u201D.',
        sch: "\u5141\u8BB8\u5728 End of the Line \u793E\u533A\u8865\u7ED9\u7BB1\u4E2D\u5F00\u51FA\u7A00\u6709\u54C1\u8D28\u7684\u201C\u673A\u67AA\u730E\u624B\u201D\u3001\u201C\u51B7\u950B\u8DF5\u8E0F\u8005\u201D\u548C\u201C\u897F\u4F2F\u5229\u4E9A\u65E0\u8896\u8863\u201D\u3002",
        bra: 'Permite que os cosm\xe9ticos "Ca\xe7ador Camuflado", "Frente Quente" e "Jaqueta de Geada" sejam desencaixotados em qualidade Incomum por a caixa do End of the Line.',
        fre: "Autoriser le Heavy Chasseur, les Mange-trottoir de Coldfront ainsi que le D\xe9bardeur Sib\xe9rien \xe0 \xeatre d\xe9ball\xe9 en qualit\xe9 Inhabituelles de la caisse End of the Line.",
        cze: "Umo\u017E\u0148uje p\u0159edm\u011Bty the Hunter Heavy, Coldfront Curbstompers a Sleeveless in Siberia rozbalit v Unusual kvalit\u011B z krabice z aktualizace End of the Line.",
        hun: "Enged\xe9lyezi a Neh\xe9z Vad\xe1szt, Hidegfront-harcost \xe9s a Szib\xe9riai Ujjatlant kibontani Rendk\xedv\xfcli fokozatban a V\xe9g\xe1llom\xe1s K\xf6z\xf6ss\xe9gi L\xe1d\xe1b\xf3l.",
        rom: 'Permite pe vantatorul Heavy, Coldfront Curbstompers si Fara Maneci in Siberia sa fie deschis in calitate Neobisnuita din cutia de comunitate Sfarsitul Liniei.',
        swe: "Till\xe5ter att J\xe4gar Heavy, Kallfrpnt Trottoarstampare och \xc4rml\xf6s i Sibirien f\xe5r \xf6ppnas i Ovanlig kvalitet fr\xe5n End of the Line Samh\xe4llsl\xe5da.",
        fil: 'Pinapayagan ang Hunter Heavy,Coldfront Curbstompers at Sleeveless sa Siberia para mabukas sa Unusual na kalidad sa End of the Line Community kahon.'
    },
    175: {
        eng: "Event mode:",
        rus: "\u0420\u0435\u0436\u0438\u043C \u0441\u043E\u0431\u044B\u0442\u0438\u044F:",
        pol: "Tryb wydarzenia:",
        sch: "\u6D3B\u52A8\u6A21\u5F0F\uFF1A",
        bra: "Modo de Evento:",
        fre: "Mode \xe9v\xe9nement:",
        cze: "Re\u017Eim ud\xe1lost\xed:",
        hun: "Esem\xe9ny m\xf3d:",
        rom: "Mod de Eveniment:",
        swe: "Eventl\xe4ge:"
    },
    176: {
        eng: "This option replaces Unusual effects in certain crates/cases with effects from the selected event.<br>Events from 2011 to 2016 affect only crates and cases released before the event.<br>Events from 2017 onwards affect only cases released before the event.",
        rus: "\u042D\u0442\u0430 \u043E\u043F\u0446\u0438\u044F \u0437\u0430\u043C\u0435\u043D\u044F\u0435\u0442 \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u044B\u0435 \u044D\u0444\u0444\u0435\u043A\u0442\u044B \u0432 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0451\u043D\u043D\u044B\u0445 \u044F\u0449\u0438\u043A\u0430\u0445/\u043A\u0435\u0439\u0441\u0430\u0445 \u043D\u0430 \u044D\u0444\u0444\u0435\u043A\u0442\u044B \u0438\u0437 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0441\u043E\u0431\u044B\u0442\u0438\u044F.<br>\u0421\u043E\u0431\u044B\u0442\u0438\u044F \u0441 2011 \u043F\u043E 2016 \u0433\u043E\u0434 \u0432\u043B\u0438\u044F\u044E\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u043D\u0430 \u044F\u0449\u0438\u043A\u0438 \u0438 \u043A\u0435\u0439\u0441\u044B, \u0432\u044B\u043F\u0443\u0449\u0435\u043D\u043D\u044B\u0435 \u0434\u043E \u0441\u043E\u0431\u044B\u0442\u0438\u044F.<br>\u0421\u043E\u0431\u044B\u0442\u0438\u044F \u0441 2017 \u0433\u043E\u0434\u0430 \u0432\u043B\u0438\u044F\u044E\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u043D\u0430 \u043A\u0435\u0439\u0441\u044B, \u0432\u044B\u043F\u0443\u0449\u0435\u043D\u043D\u044B\u0435 \u0434\u043E \u0441\u043E\u0431\u044B\u0442\u0438\u044F.",
        pol: "Ta opcja zmienia efekty Nietypowych Okaz\xf3w w niekt\xf3rych skrzynkach na efekty z wybranego wydarzenia.<br>Wydarzenia z 2011 do 2016 roku obejmuj\u0105 tylko skrzynki wydane przed wydarzeniem.<br>Wydarzenia z 2017 i nast\u0119pnych lat obejmuj\u0105 tylko skrzynki wydane przed wydarzeniem i po aktualizacji Si\u0142a charakteru.",
        sch: "\u6B64\u9009\u9879\u5C06\u7279\u5B9A\u7BB1\u5B50\u7684\u7A00\u6709\u6548\u679C\u66FF\u6362\u4E3A\u6307\u5B9A\u6D3B\u52A8\u7684\u6548\u679C\u3002<br>2011 \u81F3 2016 \u5E74\u7684\u6D3B\u52A8\u53EA\u4F1A\u5F71\u54CD\u6D3B\u52A8\u4E4B\u524D\u53D1\u5E03\u7684\u7BB1\u5B50\u3002<br>2017 \u5E74\u8D77\u7684\u6D3B\u52A8\u53EA\u4F1A\u5F71\u54CD\u6D3B\u52A8\u4E4B\u524D\u4E0E\u67AA\u9B42\u66F4\u65B0\u4E4B\u540E\u53D1\u5E03\u7684\u7BB1\u5B50\u3002",
        bra: "Essa op\xe7\xe3o substitui efeitos Incomuns em certas caixas com efeitos do evento selecionado.<br>Eventos de 2011 para 2016 s\xf3 afetam caixas lan\xe7adas antes do evento.<br>Eventos de 2017 e avante s\xf3 afetam as caixas lan\xe7adas antes do evento e as caixas lan\xe7adas depois da atualiza\xe7\xe3o Arsenal Art\xedstico.",
        fre: "Cette option remplace les effets Inhabituels pour certaines caisses selon l'\xe9v\xe9nement choisi.<br>Les \xc9v\xe9nements de 2011 jusqu'\xe0 2016 n'affectent que les caisses sorties avant l'update Gun Mettle. Les \xc9v\xe9nements \xe0 partir de 2017 n'affectent que les caisses sorties avant l'\xe9v\xe9nement and celles sorties depuis l'update Gun Mettle.",
        cze: "Toto nastaven\xed v\xe1m umo\u017E\u0148uje nahradit Unusual efekty u n\u011Bkter\xfdch beden z vybran\xfdch ud\xe1lost\xed.<br>Ud\xe1losti z roku 2011-2016 maj\xed vliv pouze na bedny vydan\xe9 p\u0159ed aktualizac\xed Gun Mettle.<br>Ud\xe1losti od roku 2017 ovliv\u0148uj\xed pouze krabice a bedny vydan\xe9 p\u0159ed ud\xe1lost\xed a ty, kter\xe9 byly vyd\xe1ny z aktualizace Gun Mettle.",
        hun: "Ez az opci\xf3 kiv\xe1ltja a Rendk\xedv\xfcli effekteket bizonyos l\xe1d\xe1kba/t\xe1sk\xe1kban a kiv\xe1lasztott esem\xe9nyr\u0151l.<br>A 2011 \xe9s 2016 k\xf6z\xf6tti esem\xe9nyek csak az azt megel\u0151z\u0151 \xe9vekben megjelent l\xe1d\xe1kat \xe9s t\xe1sk\xe1kat befoly\xe1solja.<br>A 2017 \xe9s ut\xe1ni esem\xe9nyek csak az adott esem\xe9nyt megel\u0151z\u0151 t\xe1sk\xe1kat befoly\xe1solja.",
        rom: "Aceasta optiune inlocuieste efectele neobisnuite in anumite cutii cu efecte din evenimentul selectat.<br>Evenimentele din 2011 pana in 2016 afecteaza doar cutiile lansate inainte de eveniment.<br>Evenimente din 2017 in sus afecteaza doar cutiile lansate dupa eveniment.",
        swe: "Detta alternativ ers\xe4tter Ovanliga effekter i vissa l\xe5dor/fodral med effekter fr\xe5n det valda eventet.<br>Eventer fr\xe5n 2011 till 2016 p\xe5verkar endast l\xe5dor som sl\xe4ppts f\xf6re eventet.<br>Events fr\xe5n och med 2017 p\xe5verkar endast fodral som sl\xe4ppts f\xf6re eventet och efter Gun Mettle-uppdateringen.",
        fil: "Itong opsyon ay ipapalit Unusual epekto  sa tiyak na mga kahon/kaso at kasamang epekto sa napiling event.<br>Events galing sa 2011 hanggang 2016 ay nakakaapekto lang ang mga kahon at kaso na nilabas bago ang event.<br>Mga events mula 2017 pasulong ay nakakaapekto lang kaso nilabas bago ang event."
    },
    177: {
        eng: "Disabled",
        rus: "\u041E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
        pol: "Wy\u0142\u0105czone",
        sch: "\u7981\u7528",
        bra: "Desativado",
        fre: "D\xe9sactiv\xe9",
        cze: "Vypnuto",
        hun: "Kikapcsolva",
        rom: "Dezactivat",
        swe: "Inaktiverad",
        fil: "Nakapatay"
    },
    178: {
        eng: "Very Scary Halloween Special (2011)",
        rus: "\u041E\u0447\u0435\u043D\u044C \u0441\u0442\u0440\u0430\u0448\u043D\u044B\u0439 \u0425\u044D\u043B\u043B\u043E\u0443\u0438\u043D\u0441\u043A\u0438\u0439 \u0441\u043F\u0435\u0446\u0432\u044B\u043F\u0443\u0441\u043A (2011)",
        pol: "Bardzo Straszne Halloween (2011)",
        sch: "\u975E\u5E38\u6050\u6016\u7684\u4E07\u5723\u8282\u7279\u7EA6\uFF082011\uFF09",
        bra: "Especial Bem Assustador de Dia das Bruxas (2011)",
        fre: "Sp\xe9cial Very Scary Halloween (2011)",
        hun: "Nagyon Ijeszt\u0151 Halloween K\xfcl\xf6nkiad\xe1s (2011)",
        rom: "Special de Infricosatorul Halloween (2011)",
        swe: "Mycket L\xe4skig Halloween Special (2011)"
    },
    179: {
        eng: "Spectral Halloween Special (2012)",
        rus: "\u041E\u0447\u0435\u043D\u044C \u0441\u0442\u0440\u0430\u0448\u043D\u044B\u0439 \u0425\u044D\u043B\u043B\u043E\u0443\u0438\u043D\u0441\u043A\u0438\u0439 \u0441\u043F\u0435\u0446\u0432\u044B\u043F\u0443\u0441\u043A (2012)",
        pol: "Spektralne Halloween (2012)",
        sch: "\u5E7D\u7075\u4E07\u5723\u8282\u7279\u7EA6\uFF082012\uFF09",
        bra: "Especial Espectral de Dia das Bruxas (2012)",
        fre: "Sp\xe9cial Halloween Spectral (2012)",
        hun: "K\xeds\xe9rteties Halloween K\xfcl\xf6nkiad\xe1s (2012)",
        rom: "Special de Halloween Fantomatic (2012)",
        swe: "Spektral Halloween Special (2012)"
    },
    180: {
        eng: "Scream Fortress V (2013)",
        rus: "\u0412\u0438\u0438\u0438\u0437\u0433 \u0424\u043E\u0440\u0442\u0440\u0435\u0441\u0441 V (2013)",
        sch: "\u5C16\u53EB\u8981\u585E V\uFF082013\uFF09",
        rom: "Fortareata Urlatoarea V (2013)",
        swe: "Skrik Fortress V (2013)"
    },
    181: {
        eng: "Scream Fortress VI (2014)",
        rus: "\u0412\u0438\u0438\u0438\u0437\u0433 \u0424\u043E\u0440\u0442\u0440\u0435\u0441\u0441 VI (2014)",
        sch: "\u5C16\u53EB\u8981\u585E VI\uFF082014\uFF09",
        rom: "Fortareata Urlatoare VI (2014)",
        swe: "Skrik Fortress VI (2014)"
    },
    182: {
        eng: "Scream Fortress VIII (2016)",
        rus: "\u0412\u0438\u0438\u0438\u0437\u0433 \u0424\u043E\u0440\u0442\u0440\u0435\u0441\u0441 VIII (2016)",
        sch: "\u5C16\u53EB\u8981\u585E VIII\uFF082016\uFF09",
        rom: "Fortareata Urlatoare VIII (2016)",
        swe: "Skrik Fortress VIII (2016)"
    },
    183: {
        eng: "Scream Fortress IX (2017)",
        rus: "\u0412\u0438\u0438\u0438\u0437\u0433 \u0424\u043E\u0440\u0442\u0440\u0435\u0441\u0441 IX (2017)",
        sch: "\u5C16\u53EB\u8981\u585E IX\uFF082017\uFF09",
        rom: "Fortareata Urlatoare IX (2017)",
        swe: "Skrik Fortress IX (2017)"
    },
    184: {
        eng: "Scream Fortress X (2018)",
        rus: "\u0412\u0438\u0438\u0438\u0437\u0433 \u0424\u043E\u0440\u0442\u0440\u0435\u0441\u0441 X (2018)",
        sch: "\u5C16\u53EB\u8981\u585E X\uFF082018\uFF09",
        rom: "Fortareata Urlatoare X (2018)",
        swe: "Skrik Fortress X (2018)"
    },
    185: {
        eng: "Scream Fortress XI (2019)",
        rus: "\u0412\u0438\u0438\u0438\u0437\u0433 \u0424\u043E\u0440\u0442\u0440\u0435\u0441\u0441 XI (2019)",
        sch: "\u5C16\u53EB\u8981\u585E XI\uFF082019\uFF09",
        rom: "Fortareata Urlatoare XI (2019)",
        swe: "Skrik Fortress XI (2019)"
    },
    186: {
        eng: "Scream Fortress XII (2020)",
        rus: "\u0412\u0438\u0438\u0438\u0437\u0433 \u0424\u043E\u0440\u0442\u0440\u0435\u0441\u0441 XII (2020)",
        sch: "\u5C16\u53EB\u8981\u585E XII\uFF082020\uFF09",
        rom: "Fortareata Urlatoare XII (2020)",
        swe: "Skrik Fortress XII (2020)"
    },
    187: {
        eng: "Support Unboxer.tf by donating",
        rus: "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0442\u0435 Unboxer.tf \u043F\u043E\u0436\u0435\u0440\u0442\u0432\u043E\u0432\u0430\u043D\u0438\u0435\u043C",
        pol: "Wspom\xf3\u017C Unboxer.tf, przekazuj\u0105c darowizn\u0119",
        sch: "\u6350\u8D60\u4EE5\u652F\u6301 Unboxer.tf",
        bra: "Apoie Unboxer.tf doando",
        fre: "Supportez Unboxer.tf en faisant un don",
        cze: "Podpo\u0159 Unboxer.tf p\u0159\xedsp\u011Bvkem",
        hun: "T\xe1mogasd az Unboxer.tf oldalt adom\xe1nyokkal",
        rom: "Sustine Unboxer.tf prin a dona",
        swe: "St\xf6d Unboxer.tf genom att donera",
        fil: "I-support Unboxer.tf sa pamimigitan ng donating"
    },
    188: {
        eng: "Unboxer.tf was made almost entirely by a single person in his spare time. If you like the website, please consider donating.<br>For your convenience, I do not and never will run any ads on this site.<br>Even a small donation will encourage me to continue working on Unboxer.tf. Thank you!",
        rus: "Unboxer.tf \u0431\u044B\u043B \u0441\u043E\u0437\u0434\u0430\u043D \u043F\u0440\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u043E\u0434\u043D\u0438\u043C \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u043E\u043C \u0432 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F. \u0415\u0441\u043B\u0438 \u0432\u0430\u043C \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u0441\u0430\u0439\u0442, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0438\u0442\u0435 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u043F\u043E\u0436\u0435\u0440\u0442\u0432\u043E\u0432\u0430\u043D\u0438\u044F.<br>\u0414\u043B\u044F \u0432\u0430\u0448\u0435\u0433\u043E \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430, \u044F \u043D\u0435 \u0440\u0430\u0437\u043C\u0435\u0449\u0430\u044E \u0438 \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0431\u0443\u0434\u0443 \u0440\u0430\u0437\u043C\u0435\u0449\u0430\u0442\u044C \u0440\u0435\u043A\u043B\u0430\u043C\u0443 \u043D\u0430 \u044D\u0442\u043E\u043C \u0441\u0430\u0439\u0442\u0435.<br>\u0414\u0430\u0436\u0435 \u043D\u0435\u0431\u043E\u043B\u044C\u0448\u043E\u0435 \u043F\u043E\u0436\u0435\u0440\u0442\u0432\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u043E\u0449\u0440\u0438\u0442 \u043C\u0435\u043D\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0430\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u043D\u0430\u0434 Unboxer.tf. \u0421\u043F\u0430\u0441\u0438\u0431\u043E!",
        pol: "Unboxer.tf zosta\u0142o stworzone prawie ca\u0142kowicie przez jedn\u0105 osob\u0119 w jego wolnym czasie. Je\u015Bli spodoba\u0142a ci si\u0119 ta strona, prosz\u0119 o przekazanie darowizny.<br>Dla Twojej wygody, nie ma i nie b\u0119dzie \u017Cadnych reklam na stronie.<br>Nawet ma\u0142a darowizna zmotywuje mnie do dalszej pracy nad Unboxer.tf. Dzi\u0119kuj\u0119!",
        sch: "Unboxer.tf \u4EC5\u7531\u4E00\u540D\u5F00\u53D1\u8005\u5728\u7A7A\u95F2\u65F6\u95F4\u5F00\u53D1\u800C\u6210\u3002\u5982\u679C\u60A8\u559C\u6B22\u6B64\u7F51\u7AD9\uFF0C\u8BF7\u8003\u8651\u6350\u8D60\u3002<br>\u5373\u4F7F\u662F\u4E00\u70B9\u70B9\u8D60\u4E88\u4E5F\u4F1A\u9F13\u52B1\u6211\u7EE7\u7EED\u5F00\u53D1 Unboxer.tf\u3002\u8C22\u8C22\uFF01",
        bra: "Unboxer.tf foi feito quase inteiramente por uma s\xf3 pessoa em seu tempo livre. Se voc\xea gostou do website, por favor considere doar.<br>At\xe9 uma doa\xe7\xe3o pequena me incentiva a continuar trabalhando no Unboxer.tf. Obrigado!",
        fre: "Unboxer.tf n'a \xe9t\xe9 fabriqu\xe9 que par une seule personne dans ses temps libre. Si vous aimez ce site, veuillez consid\xe9rer un don.<br>M\xeame les petit montants m'encouragent \xe0 continuer de travailler sur Unboxer.tf. Merci!",
        cze: "Unboxer.tf byl skoro cel\xfd vytvo\u0159en pouze jedn\xedm \u010Dlov\u011Bkem b\u011Bhem jeho voln\xe9ho \u010Dasu. Pokud se v\xe1m str\xe1nka l\xedb\xed, zva\u017Ete p\u0159\xedpadn\xfd p\u0159\xedsp\u011Bv\u011Bk.<br>I mal\xfd dar m\u011B povzbud\xed k dal\u0161\xed pr\xe1ci na Unboxer.tf. D\u011Bkuji!",
        hun: "Az Unboxer.tf-et teljes eg\xe9sz\xe9ben egy ember k\xe9sz\xedtette a szabadidej\xe9ben. Ha tetszik az oldal, k\xe9rlek fontold meg, hogy adom\xe1nyozz.<br>Minden kicsi adom\xe1ny is \xf6szt\xf6n\xf6z arra, hogy tov\xe1bbra is dolgozzak az Unboxer.tf-en. K\xf6sz\xf6n\xf6m!",
        rom: "Unboxer.tf a fost facut aproape complet de o singura persoana in propriul timp liber. Daca iti place acest site, te rog sa consideri a dona.<br>Chiar si cea mai mica donatie ma va incuraja sa continui a munci pe Unboxer.tf. Multumesc!",
        swe: "Unboxer.tf gjordes n\xe4stan helt av en enda person p\xe5 sin fritid. Om du gillar webbplatsen, kan du sn\xe4lla \xf6verv\xe4ga att donera.<br>\xc4ven en liten donation kommer att uppmuntra mig att forts\xe4tta arbeta p\xe5 Unboxer.tf. Tack!",
        fil: "Unboxer.tf ay halos gawa ng isang tao sa bakanteng oras niya. Ipag nagugustuhan mo ang website nito, please isaalang-alang magdonate.<br>Kahit isang maliit na donasyon ay hihimukin ako para magpatuloy nagtratrabaho sa Unboxer.tf. Maraming Salamat!"
    },
    189: {
        eng: "If you choose to donate, your name, Steam profile link and donation amount will appear in the list of donators.<br><b>In your donation message, please include that the donation is for unboxer.tf, as well as your name and Steam profile link.</b><br> You can choose to stay anonymous. Item donations will be displayed as their value in USD.",
        rus: "\u0415\u0441\u043B\u0438 \u0432\u044B \u0440\u0435\u0448\u0438\u0442\u0435 \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u043F\u043E\u0436\u0435\u0440\u0442\u0432\u043E\u0432\u0430\u043D\u0438\u0435, \u0432\u0430\u0448\u0435 \u0438\u043C\u044F, \u0441\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u043F\u0440\u043E\u0444\u0438\u043B\u044C Steam \u0438 \u0441\u0443\u043C\u043C\u0430 \u043F\u043E\u0436\u0435\u0440\u0442\u0432\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u044F\u0432\u044F\u0442\u0441\u044F \u0432 \u0441\u043F\u0438\u0441\u043A\u0435 \u0436\u0435\u0440\u0442\u0432\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439.<br><b>\u0412 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0438 \u043A \u043F\u043E\u0436\u0435\u0440\u0442\u0432\u043E\u0432\u0430\u043D\u0438\u044E, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0443\u043A\u0430\u0436\u0438\u0442\u0435, \u0447\u0442\u043E \u043F\u043E\u0436\u0435\u0440\u0442\u0432\u043E\u0432\u0430\u043D\u0438\u0435 \u0434\u043B\u044F unboxer.tf, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0432\u0430\u0448\u0435 \u0438\u043C\u044F \u0438 \u0441\u0441\u044B\u043B\u043A\u0443 \u043D\u0430 \u043F\u0440\u043E\u0444\u0438\u043B\u044C Steam.</b><br>\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043E\u0441\u0442\u0430\u0442\u044C\u0441\u044F \u0430\u043D\u043E\u043D\u0438\u043C\u043D\u044B\u043C. \u041F\u043E\u0436\u0435\u0440\u0442\u0432\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u0430\u043C\u0438 \u0431\u0443\u0434\u0443\u0442 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C\u0441\u044F \u043A\u0430\u043A \u0438\u0445 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0432 USD.",
        pol: "Je\u015Bli przeka\u017Cesz darowizn\u0119, tw\xf3j nick, link do profilu Steam i kwota darowizny zostan\u0105 dodane do listy darczy\u0144c\xf3w.<br><b>W wiadomo\u015Bci do\u0142\u0105czonej do darowizny, prosz\u0119 napisa\u0107 \u017Ce darowizna jest dla unboxer.tf oraz wpisz sw\xf3j nick i link do profilu Steam.</b><br> Mo\u017Cesz tak\u017Ce pozosta\u0107 anonimowym. Darowizny w postaci przedmiot\xf3w b\u0119d\u0105 pokazane jako ich warto\u015B\u0107 w USD.",
        sch: "\u5982\u679C\u60A8\u9009\u62E9\u6350\u8D60\uFF0C\u60A8\u7684\u540D\u5B57\u3001Steam \u4E2A\u4EBA\u8D44\u6599\u94FE\u63A5\u4E0E\u6350\u8D60\u91D1\u989D\u4F1A\u51FA\u73B0\u5728\u6350\u8D60\u5217\u8868\u4E2D\u3002<br>\u8BF7\u5728\u60A8\u7684\u6350\u8D60\u9644\u8A00\u4E2D\u8BF4\u660E\u6B64\u6B3E\u9879\u662F\u6350\u8D60\u7ED9 Unboxer.tf \u7684\uFF0C\u5E76\u9644\u4E0A\u60A8\u7684\u540D\u5B57\u4E0E Steam \u4E2A\u4EBA\u8D44\u6599\u94FE\u63A5\u3002\u60A8\u4E5F\u53EF\u4EE5\u9009\u62E9\u4FDD\u6301\u533F\u540D\u3002\u7269\u54C1\u6350\u8D60\u4F1A\u663E\u793A\u4E3A\u7269\u54C1\u7684\u7F8E\u5143\u4EF7\u683C\u3002",
        bra: "Se voc\xea escolher doar, o seu nome, link do perfil na Steam e o valor da sua doa\xe7\xe3o v\xe3o aparecer na lista de doadores. <br><b>Na sua mensagem de doa\xe7\xe3o, por favor inclua que a doa\xe7\xe3o \xe9 para unboxer.tf, tamb\xe9m inclua o seu nome e link de perfil na Steam.</b><br>Voc\xea pode escolher para ficar an\xf4nimo. Doa\xe7\xf5es de itens v\xe3o ser exibidas em seu pre\xe7o em d\xf3lares americanos.",
        fre: "Si vous choisissez de faire un don, votre nom, profil Steam et le montant apparaitront dans la liste des donneurs.<br><b>Dans le message de votre don, S'il-vous-pla\xeet inclure que le don est pour unboxer.tf, ainsi qu'inclure votre lien de profil Steam.</b><br>Vous pouvez choisir de rester anonyme. Les dons en items seront affich\xe9s selon leur valeur en USD.",
        cze: "Pokud se rozhodnete p\u0159isp\u011Bt, va\u0161e jm\xe9no, odkaz na Steam profil a v\xfd\u0161e p\u0159\xedp\u011Bvku budou zobrazeny v seznamu p\u0159isp\u011Bvatel\u016F.<br><b>Ve zpr\xe1v\u011B p\u0159\xedsp\u011Bvku pros\xedm uv\u011B\u010Fte, \u017Ee p\u0159\xedsp\u011Bvek je pro unboxer.tf, spole\u010Dn\u011B s t\xedm uve\u010Ft\u011B va\u0161e Steam jm\xe9no a odkaz na Steam profil.</b><br> M\u016F\u017Eete se rozhodnout z\u016Fstat anonymn\xed. P\u0159edm\u011Btn\xe9 p\u0159\xedsp\u011Bvky budou zobrazeny spolu s jejich hodnotou v USD.",
        hun: "Ha \xfagy d\xf6ntesz adom\xe1nyozol, akkor a neved, Steam profilod linkje \xe9s az adom\xe1ny mennyis\xe9ge l\xe1that\xf3v\xe1 v\xe1lik az adom\xe1nyoz\xf3k list\xe1j\xe1n.<br><b>K\xe9rlek az adom\xe1nyod mell\xe9 \xfczenetben t\xfcntesd fel, hogy az adom\xe1nyt az Unboxer.tf-nek sz\xe1nod, a nevedet \xe9s a Steam profilod linkj\xe9t.</b><br>Ha \xfagy d\xf6ntesz, maradhatsz anonim is. A t\xe1rgyi adom\xe1nyok USD-ben fognak megjelenni az \xe9rt\xe9k\xfck alapj\xe1n.",
        rom: "Daca alegi sa donezi, numele tau, Link-ul de la contul tau de Steam si suma donatiei va aparea pe lista donatorilor.<br><b>In mesajul donatiei tale, te rog sa incluzi ca donatia este pentru unboxer.tf, deasemenea si numele tau si linkul de la profilul de Steam.</b><br> Poti sa alegi sa ramai necunoscut. Donatiile de obiecte vor avea valoarea aratata in USD.",
        swe: "Om du v\xe4ljer att donera kommer ditt namn, Steam-profill\xe4nk och donationsbelopp att visas i donatorlistan.<br><b>I ditt donationsmeddelande, ange att donationen \xe4r f\xf6r unboxer.tf, liksom din namn och Steam-profill\xe4nk.</b><br>Du kan v\xe4lja att vara anonym. Varudonationer visas som deras v\xe4rde i USD.",
        fil: "Ipag napili mong magdonate, ang name mo, Steam profile link at halaga ng donasyon ay lilitaw sa listahan ng mga donators.<br><b>Sa iyong donasyon mensahe, please ilagay ang donasyon ay para kay unboxer.tf, at ang iyong name at Steam profile link.</b><br> maari kang pumili na maging anonymous. Aytem donasyon ay ipapakita na halaga nila sa USD."
    },
    190: {
        eng: "Donator List",
        rus: "\u0421\u043F\u0438\u0441\u043E\u043A \u0436\u0435\u0440\u0442\u0432\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439",
        pol: "Lista darczy\u0144c\xf3w",
        sch: "\u6350\u8D60\u5217\u8868",
        bra: "Lista de doadores",
        fre: "Liste des donneurs",
        cze: "Seznam p\u0159isp\u011Bvatel\u016F",
        hun: "Adom\xe1nyoz\xf3k list\xe1ja",
        rom: "Lista donatorilor",
        swe: "Donations Lista",
        fil: "Listahan ng mga Donator"
    },
    191: {
        eng: "",
        rus: ""
    },
    192: {
        eng: 'You can donate with <a href="https://paypal.me/kubikill" target="_blank" rel="noopener">PayPal</a> or <a href="https://steamcommunity.com/tradeoffer/new/?partner=98915182&token=YEmUtMbo" target="_blank" rel="noopener">TF2/Steam items</a>.<br>Brave Browser users can donate using BAT from within the browser.',
        rus: '\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u043F\u043E\u0436\u0435\u0440\u0442\u0432\u043E\u0432\u0430\u043D\u0438\u0435 \u0447\u0435\u0440\u0435\u0437 <a href="https://paypal.me/kubikill" target="_blank" rel="noopener">PayPal</a> \u0438\u043B\u0438 <a href="https://steamcommunity.com/tradeoffer/new/?partner=98915182&token=YEmUtMbo" target="_blank" rel="noopener">\u043F\u0440\u0435\u0434\u043C\u0435\u0442\u0430\u043C\u0438 TF2/Steam</a>.<br>\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430 Brave \u043C\u043E\u0433\u0443\u0442 \u0436\u0435\u0440\u0442\u0432\u043E\u0432\u0430\u0442\u044C BAT \u043F\u0440\u044F\u043C\u043E \u0438\u0437 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430.',
        pol: 'Mo\u017Cesz przekaza\u0107 darowizn\u0119 przez <a href="https://paypal.me/kubikill" target="_blank" rel="noopener">PayPal</a> lub <a href="https://steamcommunity.com/tradeoffer/new/?partner=98915182&token=YEmUtMbo" target="_blank" rel="noopener">przedmioty TF2/Steam</a>.<br>U\u017Cytkownicy przegl\u0105darki Brave Browser mog\u0105 przekaza\u0107 darowizn\u0119 w BAT z poziomu przegl\u0105darki.',
        sch: '\u60A8\u53EF\u4EE5\u901A\u8FC7 <a href="https://paypal.me/kubikill" target="_blank" rel="noopener">PayPal</a> \u6350\u8D60\u73B0\u91D1\u6216\u5411\u6211\u53D1\u9001 <a href="https://steamcommunity.com/tradeoffer/new/?partner=98915182&token=YEmUtMbo" target="_blank" rel="noopener">TF2/Steam \u7269\u54C1</a>\u3002<br>Brave \u6D4F\u89C8\u5668\u7684\u7528\u6237\u8FD8\u53EF\u4EE5\u6350\u8D60\u6D4F\u89C8\u5668\u5185\u7684 BAT \u4EE3\u5E01\u3002',
        bra: 'Voc\xea pode doar com <a href="https://paypal.me/kubikill" target="_blank" rel="noopener">PayPal</a> ou <a href="https://steamcommunity.com/tradeoffer/new/?partner=98915182&token=YEmUtMbo" target="_blank" rel="noopener">itens da Steam/TF2</a>.<br>Usu\xe1rios de Brave Browser podem doar usando BAT pelo navegador deles.',
        fre: 'Vous pouvez faire un don via <a href="https://paypal.me/kubikill">PayPal</a> ou avec des <a href="https://steamcommunity.com/tradeoffer/new/?partner=98915182&token=YEmUtMbo">TF2/objets Steam</a>.<br>Brave Browser les usagers peuvent donner en utilisant BAT dans leur fureteur',
        cze: 'M\u016F\u017Eete p\u0159isp\u011Bt skrze <a href="https://paypal.me/kubikill" target="_blank" rel="noopener">PayPal</a> nebo <a href="https://steamcommunity.com/tradeoffer/new/?partner=98915182&token=YEmUtMbo" target="_blank" rel="noopener">TF2/Steam p\u0159edm\u011Bty</a>.<br>Odv\xe1\u017En\xed u\u017Eivatel\xe9 prohl\xed\u017Ee\u010De mohou darovat pomoc\xed BAT p\u0159\xedmo z prohl\xed\u017Ee\u010De.',
        hun: 'Adom\xe1nyozni tudsz itt: <a href="https://paypal.me/kubikill" target="_blank" rel="noopener">PayPal</a> vagy itt: <a href="https://steamcommunity.com/tradeoffer/new/?partner=98915182&token=YEmUtMbo" target="_blank" rel="noopener">TF2/Steam items</a>.<br>Brave Browser felhaszn\xe1l\xf3k tudnak adom\xe1nyozni BAT felhaszn\xe1l\xe1s\xe1val a b\xf6ng\xe9sz\u0151n bel\xfcl.',
        rom: 'Poti dona cu <a href="https://paypal.me/kubikill" target="_blank" rel="noopener">PayPal</a> ori <a href="https://steamcommunity.com/tradeoffer/new/?partner=98915182&token=YEmUtMbo" target="_blank" rel="noopener">TF2/Steam items</a>.<br>Utilizatorii extensiei Brave Browser pot dona utilizand BAT din browser.',
        swe: 'Du kan donera med <a href="https://paypal.me/kubikill" target="_blank" rel="noopener">PayPal</a> eller <a href="https://steamcommunity.com/tradeoffer/new/?partner=98915182&token=YEmUtMbo" target="_blank" rel="noopener">TF2/Steam f\xf6rem\xe5l</a>.<br>Brave Browser-anv\xe4ndare kan donera med BAT fr\xe5n webbl\xe4saren.',
        fil: 'Kaya mong magdonate gamit <a href="https://paypal.me/kubikill" target="_blank" rel="noopener">PayPal</a> o <a href="https://steamcommunity.com/tradeoffer/new/?partner=98915182&token=YEmUtMbo" target="_blank" rel="noopener">TF2/Steam items</a>.<br>Brave Browser users ay maaring magdonate gamit BAT sa loob ng browser.'
    },
    193: {
        eng: 'French',
        rus: "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0438\u0439",
        pol: 'Francuski',
        sch: "\u6CD5\u8BED",
        bra: "Franc\xeas",
        fre: "Fran\xe7ais",
        cze: "Francouz\u0161tina",
        hun: 'Francia',
        rom: 'Franceza',
        swe: 'Franska',
        fil: 'Pranses'
    },
    194: {
        eng: 'Spanish',
        rus: "\u0418\u0441\u043F\u0430\u043D\u0441\u043A\u0438\u0439",
        pol: "Hiszpa\u0144ski",
        sch: "\u897F\u73ED\u7259\u8BED",
        bra: 'Espanhol',
        cze: "\u0160pan\u011Bl\u0161tina",
        hun: 'Spanyol',
        rom: 'Spaniola',
        swe: 'Spanska',
        fil: 'Espanyol'
    },
    195: {
        eng: 'German',
        rus: "\u041D\u0435\u043C\u0435\u0446\u043A\u0438\u0439",
        pol: 'Niemiecki',
        sch: "\u5FB7\u8BED",
        bra: "Alem\xe3o",
        cze: "N\u011Bm\u010Dina",
        hun: "N\xe9met",
        rom: 'Germana',
        swe: 'Tyska',
        fil: 'Aleman'
    },
    196: {
        eng: 'Brazilian Portuguese',
        rus: "\u0411\u0440\u0430\u0437\u0438\u043B\u044C\u0441\u043A\u0438\u0439 \u043F\u043E\u0440\u0442\u0443\u0433\u0430\u043B\u044C\u0441\u043A\u0438\u0439",
        pol: 'Brazylijski portugalski',
        sch: "\u5DF4\u897F\u8461\u8404\u7259\u8BED",
        bra: "Portugu\xeas do Brasil",
        fre: "Portugais br\xe9silien",
        cze: "Brazilsk\xe1 portugal\u0161tina",
        hun: "Brazil portug\xe1l",
        rom: 'Portugheza Braziliana',
        swe: "Brasiliansk Portugisiska",
        fil: 'Brazilian Portuges'
    },
    197: {
        eng: "View on Steam Market",
        rus: "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043D\u0430 \u0422\u043E\u0440\u0433\u043E\u0432\u043E\u0439 \u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0435 Steam",
        pol: "Wy\u015Bwietl na Rynku Steam",
        sch: "\u5728 Steam \u793E\u533A\u5E02\u573A\u67E5\u770B",
        bra: "Ver na Steam Market",
        fre: "Voir sur le march\xe9 Steam",
        cze: "V\xedce na Steam marketu",
        hun: "Megn\xe9z\xe9s a Steam Piacon",
        rom: "Vezi pe Steam Market",
        swe: "Se p\xe5 Steam Market",
        fil: "Itingnan sa Steam Market"
    },
    198: {
        eng: "View on Backpack.tf",
        rus: "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043D\u0430 Backpack.tf",
        pol: "Wy\u015Bwietl na Backpack.tf",
        sch: "\u5728 Backpack.tf \u67E5\u770B",
        bra: "Ver em Backpack.tf",
        fre: "Voir sur Backpack.tf",
        cze: "V\xedce na Backpack.tf",
        hun: "Megn\xe9z\xe9s Backpack.tf-en",
        rom: "Vezi pe Backpack.tf",
        swe: "Se p\xe5 Backpack.tf",
        fil: "Itingnan sa Backpack.tf"
    },
    199: {
        eng: "View on Marketplace.tf",
        rus: "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043D\u0430 Marketplace.tf",
        pol: "Wy\u015Bwietl na Marketplace.tf",
        sch: "\u5728 Marketplace.tf \u67E5\u770B",
        bra: "Ver em Marketplace.tf",
        fre: "Voir sur Marketplace.tf",
        cze: "V\xedce na Marketplace.tf",
        hun: "Megn\xe9z\xe9s Marketplace.tf-en",
        rom: "Vezi pe Marketplace.tf",
        swe: "Se p\xe5 Marketplace.tf",
        fil: "Itingna sa Marketplace.tf"
    },
    200: {
        eng: "Enable Unusual Sniper vs. Spy update hats:",
        rus: "\u0412\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u044B\u0435 \u0448\u043B\u044F\u043F\u044B \u0438\u0437 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u0421\u043D\u0430\u0439\u043F\u0435\u0440 \u043F\u0440\u043E\u0442\u0438\u0432 \u0428\u043F\u0438\u043E\u043D\u0430:",
        pol: "W\u0142\u0105cz Nietypowe Okazy z aktualizacji Snajper kontra Szpieg:",
        bra: "Ativar efeitos incomuns em chap\xe9us da atualiza\xe7\xe3o Sniper vs. Spy:",
        sch: "\u542F\u7528\u201C\u72D9\u51FB\u624B vs. \u95F4\u8C0D\u201D\u66F4\u65B0\u7684\u7A00\u6709\u5E3D\u5B50",
        fre: "Activer les Inhabituels de l'update Sniper vs. Spy:",
        cze: "Povoluje Unusual p\u0159edm\u011Bty ze Sniper vs. Spy updatu:",
        hun: "Mesterl\xf6v\xe9sz kontra K\xe9m Friss\xedt\xe9s sapk\xe1k enged\xe9lyez\xe9se:",
        rom: "Porneste Sniper Neobisnuit vs. Spy palarie de actualizare:",
        swe: "Aktivera Ovanliga hattar f\xf6r Sniper vs. Spy-uppdateringen:",
        fil: "Ibukas Unusual Sniper vs. Spy update hats:"
    },
    201: {
        eng: "Allows the hats added in the Sniper vs. Spy update to be unboxed as Unusuals from crates added before the TF2 January 25th 2013 update (crates #1 - #55).",
        rus: "\u041F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u0448\u043B\u044F\u043F\u0430\u043C, \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u043C \u0432 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0438 \u0421\u043D\u0430\u0439\u043F\u0435\u0440 \u043F\u0440\u043E\u0442\u0438\u0432 \u0428\u043F\u0438\u043E\u043D\u0430, \u0432\u044B\u043F\u0430\u0434\u0430\u0442\u044C \u043A\u0430\u043A \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u044B\u0435 \u0438\u0437 \u044F\u0449\u0438\u043A\u043E\u0432, \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0445 \u0434\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F TF2 25 \u044F\u043D\u0432\u0430\u0440\u044F 2013 \u0433\u043E\u0434\u0430 (\u044F\u0449\u0438\u043A\u0438 #1 - #55).",
        pol: "Ta opcja pozwala na otrzymanie czapek z aktualizacji Snajper kontra Szpieg w jako\u015Bci Nietypowy Okaz z skrzynek dodanych przed aktualizacj\u0105 TF2 z 25 stycznia 2013 (skrzynki #1 - #55).",
        bra: "Isso permite que os chap\xe9us adicionados na atualiza\xe7\xe3o do Sniper vs. Spy possam ser desencaixotados em qualidade Incomum por caixas adicionadas antes da atualiza\xe7\xe3o de TF2 em 25 de Janeiro de 2013 (caixas #1 - #55).",
        sch: "\u6B64\u9009\u9879\u5141\u8BB8\u4ECE 2013 \u5E74 1 \u6708 25 \u65E5 TF2 \u66F4\u65B0\u4E4B\u524D\u7684\u7BB1\u5B50\uFF08\u7F16\u53F7\u4E3A #1-#55\uFF09\u4E2D\u5F00\u51FA\u7A00\u6709\u54C1\u8D28\u7684\u3001\u5728\u201C\u72D9\u51FB\u624B vs. \u95F4\u8C0D\u201D\u66F4\u65B0\u4E2D\u6DFB\u52A0\u7684\u5E3D\u5B50\u3002",
        fre: "Cette option permet aux chapeaux ajout\xe9s avec l'update Sniper vs. Spy d'\xeatre d\xe9ball\xe9 en qualit\xe9 Inhabituelle dans les caisses ajout\xe9e avant l'update TF2 du 25 Janvier 2013 (caisses #1 \xe0 #55).",
        cze: "Umo\u017E\u0148uje rozbalen\xed klobouk\u016F p\u0159idan\xfdch ve Sniper vs. Spy updatu Unusual kvality z krabic p\u0159idan\xfdch p\u0159ed aktualizac\xed 25. ledna 2013 (krabice #1 - #55)",
        hun: "Enged\xe9lyezi, hogy a Mesterl\xf6v\xe9sz kontra K\xe9m Friss\xedt\xe9s sor\xe1n hozz\xe1adott sapk\xe1kat Rendk\xedv\xfcli min\u0151s\xe9gbe kibonthasd olyan l\xe1d\xe1kb\xf3l, amik a 2013. janu\xe1r 25.-i friss\xedt\xe9s el\u0151tt lettek hozz\xe1adva (#1-#55-\xf6s sz\xe9ri\xe1k)",
        rom: "Permite ca palariile sa fie adaugate in actualizarea Sniper vs Spy pentru a fi deschise ca obiecte Neobisnuite din cutii adaugate inainte de actualizarea TF2 25 Ianuarie 2013 (Cutiile #1 - #55).",
        swe: "Till\xe5ter att hattarna som l\xe4ggs till i Sniper vs. Spy-uppdateringen att \xf6ppnas som Ovanliga fr\xe5n l\xe5dor som lagts till f\xf6re TF2-uppdateringen den 25 januari 2013 (l\xe5dor #1 - #55).",
        fil: "Ipayagan ang hats na idinagdad sa Sniper vs. Spy update na mabukas na Unusual sa mga kahon idinagdad bago ang TF2 Enero 25th 2013 update (kahon #1 - #55)."
    },
    202: {
        eng: "Smissmas 2020",
        rus: "\u0421\u043C\u0438\u0441\u0441\u043C\u0430\u0441 2020",
        pol: "\u015Ani\u0119ta 2020",
        sch: "\u5723\u8BDE\u8282 2020",
        bra: "Natal de 2020",
        cze: "V\xe1noce 2020",
        hun: "Gal\xe1csony 2020",
        rom: "Craciun 2020",
        swe: "Smissmas 2020"
    },
    203: {
        eng: "Smissmas 2019",
        rus: "\u0421\u043C\u0438\u0441\u0441\u043C\u0430\u0441 2019",
        pol: "\u015Ani\u0119ta 2019",
        sch: "\u5723\u8BDE\u8282 2019",
        bra: "Natal de 2019",
        cze: "V\xe1noce 2019",
        hun: "Gal\xe1csony 2019",
        rom: "Craciun 2019",
        swe: "Smissmas 2019"
    },
    204: {
        eng: "Search",
        rus: "\u041F\u043E\u0438\u0441\u043A",
        pol: "Szukaj",
        cze: "Vyhled\xe1v\xe1n\xed",
        hun: "Keres\xe9s",
        rom: "Cauta",
        swe: "S\xf6k",
        fil: "I-search"
    },
    205: {
        eng: "Type to search",
        rus: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u043B\u044F \u043F\u043E\u0438\u0441\u043A\u0430",
        pol: "Pisz, aby wyszuka\u0107",
        cze: "Pi\u0161 pro vyhled\xe1v\xe1n\xed",
        hun: "Kezdj el g\xe9pelni a keres\xe9shez",
        rom: "Scrie ca sa cauti",
        swe: "Skriv f\xf6r att s\xf6ka",
        fil: "I-type para i-search"
    },
    206: {
        eng: 'Czech',
        rus: "\u0427\u0435\u0448\u0441\u043A\u0438\u0439",
        pol: 'Czeski',
        cze: "\u010Ce\u0161tina",
        hun: 'Cseh',
        rom: 'Ceha',
        swe: 'Tjeckiska'
    },
    207: {
        eng: 'Hungarian',
        rus: "\u0412\u0435\u043D\u0433\u0435\u0440\u0441\u043A\u0438\u0439",
        pol: "W\u0119gierski",
        hun: 'Magyar',
        rom: 'Maghiara',
        swe: 'Ungerska',
        fil: 'Hanggaryan'
    },
    208: {
        eng: 'Romanian',
        rus: "\u0420\u0443\u043C\u044B\u043D\u0441\u043A\u0438\u0439",
        pol: "Rumu\u0144ski",
        rom: 'Romana',
        swe: "Rum\xe4nska",
        fil: 'Rumano'
    },
    209: {
        eng: "Swedish",
        rus: "\u0428\u0432\u0435\u0434\u0441\u043A\u0438\u0439",
        pol: "Szwecki",
        swe: "Svenska",
        fil: "Suweko"
    },
    210: {
        eng: "Filipino",
        rus: "\u0424\u0438\u043B\u0438\u043F\u043F\u0438\u043D\u0441\u043A\u0438\u0439",
        pol: "Filipi\u0144ski"
    },
    211: {
        eng: "Scream Fortress XIII (2021)",
        rus: "\u0412\u0438\u0438\u0438\u0437\u0433 \u0424\u043E\u0440\u0442\u0440\u0435\u0441\u0441 XIII (2021)",
        sch: "\u5C16\u53EB\u8981\u585E XIII\uFF082021\uFF09",
        rom: "Fortareata Urlatoare XIII (2021)",
        swe: "Skrik Fortress XIII (2021)"
    },
    212: {
        eng: "Smissmas 2021",
        rus: "\u0421\u043C\u0438\u0441\u0441\u043C\u0430\u0441 2021",
        pol: "\u015Ani\u0119ta 2021",
        sch: "\u5723\u8BDE\u8282 2021",
        bra: "Natal de 2021",
        cze: "V\xe1noce 2021",
        hun: "Gal\xe1csony 2021",
        rom: "Craciun 2021",
        swe: "Smissmas 2021"
    },
    213: {
        eng: "Scream Fortress XIV (2022)",
        rus: "\u0412\u0438\u0438\u0438\u0437\u0433 \u0424\u043E\u0440\u0442\u0440\u0435\u0441\u0441 XIV (2022)",
        sch: "\u5C16\u53EB\u8981\u585E XIV\uFF082022\uFF09",
        rom: "Fortareata Urlatoare XIV (2022)",
        swe: "Skrik Fortress XIV (2022)"
    },
    214: {
        eng: "Smissmas 2022",
        rus: "\u0421\u043C\u0438\u0441\u0441\u043C\u0430\u0441 2022",
        pol: "\u015Ani\u0119ta 2022",
        sch: "\u5723\u8BDE\u8282 2022",
        bra: "Natal de 2022",
        cze: "V\xe1noce 2022",
        hun: "Gal\xe1csony 2022",
        rom: "Craciun 2022",
        swe: "Smissmas 2022"
    },
    215: {
        eng: "Summer 2023",
        rus: "\u041B\u0435\u0442\u043E 2023",
        pol: "Lato 2023"
    },
    216: {
        eng: "Scream Fortress XV (2023)",
        rus: "\u0412\u0438\u0438\u0438\u0437\u0433 \u0424\u043E\u0440\u0442\u0440\u0435\u0441\u0441 XV (2023)",
        sch: "\u5C16\u53EB\u8981\u585E XV\uFF082023\uFF09",
        rom: "Fortareata Urlatoare XV (2023)",
        swe: "Skrik Fortress XV (2023)"
    },
    217: {
        eng: "Smissmas 2023",
        rus: "\u0421\u043C\u0438\u0441\u0441\u043C\u0430\u0441 2023",
        pol: "\u015Ani\u0119ta 2023",
        sch: "\u5723\u8BDE\u8282 2023",
        bra: "Natal de 2023",
        cze: "V\xe1noce 2023",
        hun: "Gal\xe1csony 2023",
        rom: "Craciun 2023",
        swe: "Smissmas 2023"
    },
    218: {
        eng: "Enable unusual miscs:",
        rus: "\u0412\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043D\u0435\u043E\u0431\u044B\u0447\u043D\u044B\u0435 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u044B:",
        pol: "W\u0142\u0105cz Nietypowe Okazy na przedmiotach dodatkowych:"
    },
    219: {
        eng: "Allows some miscs to be unboxed as Unusuals from crates added before the TF2 July 7th 2016 update (crates #1 - #102)",
        rus: "\u041F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u044B\u043C \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u0430\u043C \u0432\u044B\u043F\u0430\u0434\u0430\u0442\u044C \u043A\u0430\u043A \u041D\u0435\u043E\u0431\u044B\u0447\u043D\u044B\u0435 \u0438\u0437 \u044F\u0449\u0438\u043A\u043E\u0432, \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0445 \u0434\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F TF2 7 \u0438\u044E\u043B\u044F 2016 \u0433\u043E\u0434\u0430 (\u044F\u0449\u0438\u043A\u0438 #1 - #102)",
        pol: "Ta opcja pozwala na otrzymanie tzw. przedmiot\xf3w dodatkowych (ang. miscs) w jako\u015Bci Nietypowy Okaz z skrzynek dodanych przed aktualizacj\u0105 TF2 z 7 lutego 2016 (skrzynki #1 - #102)."
    },
    220: {
        eng: "Summer 2024",
        rus: "\u041B\u0435\u0442\u043E 2024",
        pol: "Lato 2024"
    },
    221: {
        eng: "Scream Fortress XVI (2024)",
        rus: "\u0412\u0438\u0438\u0438\u0437\u0433 \u0424\u043E\u0440\u0442\u0440\u0435\u0441\u0441 XVI (2024)",
        sch: "\u5C16\u53EB\u8981\u585E XVI\uFF082024\uFF09",
        rom: "Fortareata Urlatoare XVI (2024)",
        swe: "Skrik Fortress XVI (2024)"
    },
    222: {
        eng: "Smissmas 2024",
        rus: "\u0421\u043C\u0438\u0441\u0441\u043C\u0430\u0441 2024",
        pol: "\u015Ani\u0119ta 2024",
        sch: "\u5723\u8BDE\u8282 2024",
        bra: "Natal de 2024",
        cze: "V\xe1noce 2024",
        hun: "Gal\xe1csony 2024",
        rom: "Craciun 2024",
        swe: "Smissmas 2024"
    },
    223: {
        eng: "Summer 2025",
        rus: "\u041B\u0435\u0442\u043E 2025",
        pol: "Lato 2025"
    },
    224: {
        eng: 'Russian',
        rus: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
        pol: "Rosyjski",
        hun: "Orosz",
        rom: "Rus\u0103",
        swe: "Ryska",
        fil: "Ruso"
    },
    225: {
        eng: "Scream Fortress XVII (2025)",
        rus: "\u0412\u0438\u0438\u0438\u0437\u0433 \u0424\u043E\u0440\u0442\u0440\u0435\u0441\u0441 XVII (2025)",
        sch: "\u5C16\u53EB\u8981\u585E XVII\uFF082025\uFF09",
        rom: "Fortareata Urlatoare XVII (2025)",
        swe: "Skrik Fortress XVII (2025)"
    },
    226: {
        eng: "Smissmas 2025",
        rus: "\u0421\u043C\u0438\u0441\u0441\u043C\u0430\u0441 2025",
        pol: "\u015Ani\u0119ta 2025",
        sch: "\u5723\u8BDE\u8282 2025",
        bra: "Natal de 2025",
        cze: "V\xe1noce 2025",
        hun: "Gal\xe1csony 2025",
        rom: "Craciun 2025",
        swe: "Smissmas 2025"
    },
    227: {
        eng: "View on Crate.tf",
        rus: "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043D\u0430 Crate.tf",
        pol: "Wy\u015Bwietl na Crate.tf",
        sch: "\u5728 Crate.tf \u67E5\u770B",
        bra: "Ver em Crate.tf",
        fre: "Voir sur Crate.tf",
        cze: "V\xedce na Crate.tf",
        hun: "Megn\xe9z\xe9s Crate.tf-en",
        rom: "Vezi pe Crate.tf",
        swe: "Se p\xe5 Crate.tf",
        fil: "Itingna sa Crate.tf"
    },
    228: {
        eng: "Summer 2026",
        rus: "\u041B\u0435\u0442\u043E 2026",
        pol: "Lato 2026"
    },
    229: {
        eng: "Scream Fortress XVIII (2026)",
        rus: "\u0412\u0438\u0438\u0438\u0437\u0433 \u0424\u043E\u0440\u0442\u0440\u0435\u0441\u0441 XVIII (2026)",
        sch: "\u5C16\u53EB\u8981\u585E XVIII\uFF082026\uFF09",
        rom: "Fortareata Urlatoare XVIII (2026)",
        swe: "Skrik Fortress XVIII (2026)"
    }
};


// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.5
const $c15f83c001069282$export$df1e024253068afa = function() {
    const f = String.fromCharCode;
    const keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    const keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
    const baseReverseDic = {};
    function getBaseValue(alphabet, character) {
        if (!baseReverseDic[alphabet]) {
            baseReverseDic[alphabet] = {};
            for(let i = 0; i < alphabet.length; i++)baseReverseDic[alphabet][alphabet.charAt(i)] = i;
        }
        return baseReverseDic[alphabet][character];
    }
    const LZString2 = {
        compressToBase64: function(input) {
            if (input == null) return "";
            const res = LZString2._compress(input, 6, function(a) {
                return keyStrBase64.charAt(a);
            });
            switch(res.length % 4){
                default:
                case 0:
                    return res;
                case 1:
                    return res + "===";
                case 2:
                    return res + "==";
                case 3:
                    return res + "=";
            }
        },
        decompressFromBase64: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            return LZString2._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrBase64, input.charAt(index));
            });
        },
        compressToUTF16: function(input) {
            if (input == null) return "";
            return LZString2._compress(input, 15, function(a) {
                return f(a + 32);
            }) + " ";
        },
        decompressFromUTF16: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString2._decompress(compressed.length, 16384, function(index) {
                return compressed.charCodeAt(index) - 32;
            });
        },
        //compress into uint8array (UCS-2 big endian format)
        compressToUint8Array: function(uncompressed) {
            const compressed = LZString2.compress(uncompressed);
            const buf = new Uint8Array(compressed.length * 2);
            for(let i = 0, TotalLen = compressed.length; i < TotalLen; i++){
                const current_value = compressed.charCodeAt(i);
                buf[i * 2] = current_value >>> 8;
                buf[i * 2 + 1] = current_value % 256;
            }
            return buf;
        },
        //decompress from uint8array (UCS-2 big endian format)
        decompressFromUint8Array: function(compressed) {
            if (compressed === null || compressed === void 0) return LZString2.decompress(compressed);
            else {
                const buf = new Array(compressed.length / 2);
                for(let i = 0, TotalLen = buf.length; i < TotalLen; i++)buf[i] = compressed[i * 2] * 256 + compressed[i * 2 + 1];
                const result = [];
                buf.forEach(function(c) {
                    result.push(f(c));
                });
                return LZString2.decompress(result.join(""));
            }
        },
        //compress into a string that is already URI encoded
        compressToEncodedURIComponent: function(input) {
            if (input == null) return "";
            return LZString2._compress(input, 6, function(a) {
                return keyStrUriSafe.charAt(a);
            });
        },
        //decompress from an output of compressToEncodedURIComponent
        decompressFromEncodedURIComponent: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            input = input.replace(/ /g, "+");
            return LZString2._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrUriSafe, input.charAt(index));
            });
        },
        compress: function(uncompressed) {
            return LZString2._compress(uncompressed, 16, function(a) {
                return f(a);
            });
        },
        _compress: function(uncompressed, bitsPerChar, getCharFromInt) {
            if (uncompressed == null) return "";
            let i;
            let value;
            const context_dictionary = {};
            const context_dictionaryToCreate = {};
            let context_c = "";
            let context_wc = "";
            let context_w = "";
            let context_enlargeIn = 2;
            let context_dictSize = 3;
            let context_numBits = 2;
            const context_data = [];
            let context_data_val = 0;
            let context_data_position = 0;
            let ii;
            for(ii = 0; ii < uncompressed.length; ii += 1){
                context_c = uncompressed.charAt(ii);
                if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
                    context_dictionary[context_c] = context_dictSize++;
                    context_dictionaryToCreate[context_c] = true;
                }
                context_wc = context_w + context_c;
                if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) context_w = context_wc;
                else {
                    if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                        if (context_w.charCodeAt(0) < 256) {
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 8; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        } else {
                            value = 1;
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1 | value;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = 0;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 16; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        }
                        context_enlargeIn--;
                        if (context_enlargeIn == 0) {
                            context_enlargeIn = Math.pow(2, context_numBits);
                            context_numBits++;
                        }
                        delete context_dictionaryToCreate[context_w];
                    } else {
                        value = context_dictionary[context_w];
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    context_dictionary[context_wc] = context_dictSize++;
                    context_w = String(context_c);
                }
            }
            if (context_w !== "") {
                if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                    if (context_w.charCodeAt(0) < 256) {
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 8; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    } else {
                        value = 1;
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = 0;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 16; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    delete context_dictionaryToCreate[context_w];
                } else {
                    value = context_dictionary[context_w];
                    for(i = 0; i < context_numBits; i++){
                        context_data_val = context_data_val << 1 | value & 1;
                        if (context_data_position == bitsPerChar - 1) {
                            context_data_position = 0;
                            context_data.push(getCharFromInt(context_data_val));
                            context_data_val = 0;
                        } else context_data_position++;
                        value = value >> 1;
                    }
                }
                context_enlargeIn--;
                if (context_enlargeIn == 0) {
                    context_enlargeIn = Math.pow(2, context_numBits);
                    context_numBits++;
                }
            }
            value = 2;
            for(i = 0; i < context_numBits; i++){
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                } else context_data_position++;
                value = value >> 1;
            }
            while(true){
                context_data_val = context_data_val << 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data.push(getCharFromInt(context_data_val));
                    break;
                } else context_data_position++;
            }
            return context_data.join("");
        },
        decompress: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString2._decompress(compressed.length, 32768, function(index) {
                return compressed.charCodeAt(index);
            });
        },
        _decompress: function(length, resetValue, getNextValue) {
            const dictionary = [];
            let enlargeIn = 4;
            let dictSize = 4;
            let numBits = 3;
            let entry = "";
            const result = [];
            let i;
            let w;
            let bits;
            let resb;
            let maxpower;
            let power;
            let c;
            const data = {
                val: getNextValue(0),
                position: resetValue,
                index: 1
            };
            for(i = 0; i < 3; i += 1)dictionary[i] = String(i);
            bits = 0;
            maxpower = Math.pow(2, 2);
            power = 1;
            while(power != maxpower){
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                    data.position = resetValue;
                    data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
            }
            switch(bits){
                case 0:
                    bits = 0;
                    maxpower = Math.pow(2, 8);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 1:
                    bits = 0;
                    maxpower = Math.pow(2, 16);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 2:
                    return "";
            }
            dictionary[3] = String(c);
            w = String(c);
            result.push(String(c));
            while(true){
                if (data.index > length) return "";
                bits = 0;
                maxpower = Math.pow(2, numBits);
                power = 1;
                while(power != maxpower){
                    resb = data.val & data.position;
                    data.position >>= 1;
                    if (data.position == 0) {
                        data.position = resetValue;
                        data.val = getNextValue(data.index++);
                    }
                    bits |= (resb > 0 ? 1 : 0) * power;
                    power <<= 1;
                }
                switch(c = bits){
                    case 0:
                        bits = 0;
                        maxpower = Math.pow(2, 8);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 1:
                        bits = 0;
                        maxpower = Math.pow(2, 16);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 2:
                        return result.join("");
                }
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
                if (dictionary[c]) entry = String(dictionary[c]);
                else {
                    if (c === dictSize) entry = w + w.charAt(0);
                    else return null;
                }
                result.push(entry);
                dictionary[dictSize++] = w + entry.charAt(0);
                enlargeIn--;
                w = entry;
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
            }
        }
    };
    return LZString2;
}();


"use strict";
// Function for reporting errors to analytics
let $e7012959a8ce1722$var$errorTimeout = false;
// Compressed function for deep merging objects. a - target object, b - source object
const $e7012959a8ce1722$var$mergeDeep = (a, b)=>{
    for (const c of Object.keys(b))b[c] instanceof Object && c in a && Object.assign(b[c], $e7012959a8ce1722$var$mergeDeep(a[c], b[c]));
    return Object.assign(a || {}, b), a;
};
// Generate random 5-letter string
const $e7012959a8ce1722$var$randomStringPool = "abcdefghijklmnopqrstuwxyz1234567890";
function $e7012959a8ce1722$var$generateRandomString() {
    let string = "";
    for(let i = 0; i < 5; i++)string += $e7012959a8ce1722$var$randomStringPool[Math.floor(Math.random() * $e7012959a8ce1722$var$randomStringPool.length)];
    return string;
}
// Detect WebP support
let $e7012959a8ce1722$var$imageSupport = ".webp";
let $e7012959a8ce1722$var$webpTest = new Image();
$e7012959a8ce1722$var$webpTest.onload = function() {
    if ($e7012959a8ce1722$var$webpTest.height != 2) {
        $e7012959a8ce1722$var$imageSupport = ".png";
        console.log("WebP is unsupported - failed image height check");
    }
};
$e7012959a8ce1722$var$webpTest.onerror = function() {
    $e7012959a8ce1722$var$imageSupport = ".png";
    $e7012959a8ce1722$var$DOM.main.img.src = "./images/crate/" + $e7012959a8ce1722$var$getImg("crate", $e7012959a8ce1722$var$currentCrateObj.id);
    console.log("WebP is unsupported - failed to load image");
};
$e7012959a8ce1722$var$webpTest.src = 'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
// DOM elements
HTMLDocument.prototype.eId = document.getElementById; // Use document.eID() as a shorthand for document.eId()
const $e7012959a8ce1722$var$DOM = {
    main: {
        container: document.eId("crateselectscreen"),
        optionsBtn: document.eId("optionsbtn"),
        statsBtn: document.eId("statsbtn"),
        gridViewBtn: document.eId("gridviewbtn"),
        exitGridViewBtn: document.eId("exitgridviewbtn"),
        unboxBtn: document.eId("unboxbtn"),
        bulkUnboxBtn: document.eId("bulkunboxbtn"),
        randomCrateBtn: document.eId("randomcratebtn"),
        muteSoundBtn: document.eId("soundbtn"),
        infoBtn: document.eId("infobtn"),
        previousCrateBtn: document.eId("previouscratebtn"),
        nextCrateBtn: document.eId("nextcratebtn"),
        crateName: document.eId("cratename"),
        crateInfoContainer: document.eId("crateinfo"),
        series: document.eId("crateseries"),
        imgContainer: document.eId("crateimagediv"),
        img: document.eId("crateimage"),
        detailsContainer: document.eId("cratedetails"),
        lootContainer: document.eId("cratelootdiv"),
        lootTitle: document.eId("crateloottitle"),
        lootList: document.eId("cratelootlist"),
        lootNote: document.eId("cratenote"),
        lootBonus: document.eId("cratelootbonus"),
        effectsContainer: document.eId("crateeffectsdiv"),
        effectsTitle: document.eId("crateeffectstitle"),
        effectsList: document.eId("crateeffectslist"),
        crateGrid: document.eId("crategrid"),
        crateGridSearch: document.eId("crategridsearchinput"),
        crateGridSearchBtn: document.eId("searchbtn"),
        crateGridSearchDiv: document.eId("crategridsearch"),
        crateWindow: document.eId("cratewindow"),
        crateSteamMarketBtn: document.eId("cratesteammarketbtn"),
        crateBptfBtn: document.eId("cratebptfbtn"),
        crateCratetfBtn: document.eId("cratecratetfbtn")
    },
    bulkSelect: {
        screen: document.eId("bulkunboxselect"),
        container: document.eId("bulkunboxcontainer"),
        num: document.eId("bulkselectnum"),
        unboxBtn: document.eId("bulkunboxselectbtn"),
        cancelBtn: document.eId("bulkunboxselectcancelbtn"),
        warning: document.eId("bulkwarning"),
        warningHuge: document.eId("bulkwarninghuge")
    },
    bulkProgress: {
        container: document.eId("bulkunboxprogress"),
        progress: document.eId("bulkunboxprogressbar"),
        progressDone: document.eId("bulkunboxprogressdone"),
        progressTotal: document.eId("bulkunboxprogresstotal"),
        progressPercent: document.eId("bulkunboxprogresspercent")
    },
    bulkResults: {
        container: document.eId("bulkunboxresults"),
        title: document.eId("bulkresultstitle"),
        prev: document.eId("bulkresultsprev"),
        next: document.eId("bulkresultsnext"),
        tabName: document.eId("bulkresultstabname"),
        stats: document.eId("bulkresultsstats"),
        return: document.eId("bulkresultsreturnbtn"),
        unusuals: document.eId("bulkresultsunusuals"),
        unusualsContent: document.eId("bulkresultsunusualscontent"),
        unusualsPageDiv: document.eId("bulkunusualspage"),
        unusualsPrev: document.eId("bulkunusualsprev"),
        unusualsNext: document.eId("bulkunusualsnext"),
        items: {
            container: document.eId("bulkresultsitems"),
            content: document.eId("bulkresultsitems")
        },
        bonusItems: {
            container: document.eId("bulkresultsbonusitems"),
            content: document.eId("bulkresultsbonusitems")
        }
    },
    options: {
        container: document.eId("optionsscreen"),
        returnBtn: document.eId("optionsreturnbtn"),
        debugSettings: document.eId("debugsettings"),
        resetBtn: document.eId("resetbtn"),
        langDropdown: document.eId("langdropdown")
    },
    stats: {
        container: document.eId("statsscreen"),
        returnBtn: document.eId("statsreturnbtn"),
        statistics: {
            container: document.eId("statscontainerinner"),
            prev: document.eId("statsgeneralprev"),
            tab: document.eId("statsgeneraltab"),
            next: document.eId("statsgeneralnext"),
            luck: {
                container: document.eId("statsluckcontainer"),
                notEnough: document.eId("statslucknotenough"),
                unusual: document.eId("unusualluck"),
                unusualDesc: document.eId("unusualluckdesc"),
                strange: document.eId("strangeluck"),
                strangeDesc: document.eId("strangeluckdesc")
            }
        },
        unusuals: {
            container: document.eId("statsunusuals"),
            content: document.eId("statsunusualscontent"),
            pageDiv: document.eId("statsunusualspage"),
            prev: document.eId("statsunusualsprev"),
            next: document.eId("statsunusualsnext")
        },
        crates: {
            container: document.eId("statscrates"),
            details: {
                container: document.eId("statscratesdetails"),
                returnBtn: document.eId("returnstatsdetailsbtn"),
                content: document.eId("statscratesdetailscontent"),
                image: document.eId("cratedetailsimage"),
                title: document.eId("cratedetailstitle"),
                crateStats: document.eId("cratedetailsstats")
            }
        }
    },
    about: {
        container: document.eId("aboutscreen"),
        creditsTitle: document.eId("creditstitle")
    },
    unboxing: {
        container: document.eId("countdownscreen"),
        countdown: document.eId("uncratingcountdown"),
        dots: document.eId("uncratinganim")
    },
    results: {
        container: document.eId("resultscreen"),
        returnBtn: document.eId("returnbtn"),
        unboxBtn: document.eId("unboxagainbtn"),
        lootName: document.eId("lootname"),
        lootChance: document.eId("lootunboxpercent"),
        lootImg: document.eId("lootimg"),
        effectImg: document.eId("effectimg"),
        effectField: document.eId("effectfield"),
        effectName: document.eId("effectname"),
        kitImg: document.eId("kitimg"),
        kitField: document.eId("kitfield"),
        statsContainer: document.eId("lootstatscontainer"),
        statTimesUnboxedDiv: document.eId("loottimesunboxeddiv"),
        statTimesUnboxed: document.eId("loottimesunboxed"),
        statUnusualsUnboxedDiv: document.eId("lootunusualsunboxeddiv"),
        statUnusualsUnboxed: document.eId("lootunusualsunboxed"),
        statSinceLastUnusual: document.eId("lootsincelastunu"),
        bonusContainer: document.eId("lootbonusitems"),
        bonusItemContainer: document.eId("lootbonusitemcontainer"),
        steamMarketBtn: document.eId("lootsteammarketbtn"),
        bptfBtn: document.eId("lootbptfbtn"),
        mptfBtn: document.eId("lootmptfbtn")
    }
};
// Misc variables
let $e7012959a8ce1722$var$currentCrate = (0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f).length - 1];
let $e7012959a8ce1722$var$currentCrateObj = (0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]];
let $e7012959a8ce1722$var$canUnbox = true;
let $e7012959a8ce1722$var$inDetailsMode = true;
let $e7012959a8ce1722$var$addToInventorySaveTimeout = null;
let $e7012959a8ce1722$var$addToUnusualsSaveTimeout = null;
let $e7012959a8ce1722$var$addToStatsSaveTimeout = null;
const $e7012959a8ce1722$var$emptyImage = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
const $e7012959a8ce1722$var$wearTable = [
    "",
    "FN",
    "MW",
    "FT",
    "WW",
    "BS"
];
const $e7012959a8ce1722$var$wearTableNames = [
    "",
    80,
    81,
    82,
    83,
    84
];
const $e7012959a8ce1722$var$gradeTable = [
    "",
    "colorcivilian",
    "colorfreelance",
    "colormercenary",
    "colorcommando",
    "colorassassin",
    "colorelite"
];
const $e7012959a8ce1722$var$sheenTable = [
    "",
    128,
    129,
    130,
    131,
    132,
    133,
    134
];
const $e7012959a8ce1722$var$killstreakerTable = [
    "",
    135,
    136,
    137,
    138,
    139,
    140,
    141
];
// Save object
let $e7012959a8ce1722$var$save = {
    stats: {
        "crates-opened": 0,
        "keys-money": 0.00,
        "unboxes-since-last-unusual": 0,
        "min-unusual-drought": "N/A",
        "max-unusual-drought": 0,
        "unusual-avg": "N/A",
        "unusual-avg-array": [],
        "unusual-avgprice": "N/A",
        "unusual-avgprice-array": [],
        "bonus-unboxed": 0,
        "unusualifiers-unboxed": 0,
        "single-bonus-unboxed": 0,
        "double-bonus-unboxed": 0,
        "triple-bonus-unboxed": 0,
        "unique-unboxed": 0,
        "strange-unboxed": 0,
        "random-strange-unboxed": 0,
        "haunted-unboxed": 0,
        "strangehaunted-unboxed": 0,
        "decorated-unboxed": 0,
        "unusual-unboxed": 0,
        "strangeunusual-unboxed": 0,
        "grade-unboxed": 0,
        "civilian-unboxed": 0,
        "freelance-unboxed": 0,
        "mercenary-unboxed": 0,
        "commando-unboxed": 0,
        "assassin-unboxed": 0,
        "elite-unboxed": 0,
        "factorynew-unboxed": 0,
        "minimalwear-unboxed": 0,
        "fieldtested-unboxed": 0,
        "wellworn-unboxed": 0,
        "battlescarred-unboxed": 0,
        "unusual-chances": 0,
        "strange-chances": 0
    },
    crates: {},
    crateStats: {},
    bonusItems: [],
    unusuals: [],
    options: {
        language: "eng",
        fastUnbox: false,
        forceUnusual: false,
        forceUnusualifier: false,
        forceStrange: false,
        forceGrade: false,
        forceGradeNum: 3,
        forceProKit: false,
        forceBonusItem: false,
        amoledTheme: false,
        stopAtItem: [
            "unusual",
            "tauntunusualifier",
            "bonusitem",
            "gradeelite"
        ],
        halloweenMode: "none",
        eotlGlitch: false,
        sniperVsSpyUnusuals: false,
        miscUnusuals: false,
        muteSound: false
    }
};
// Populate save.crates and save.crateStats
for(let crate1 in 0, $923c9e0e4e96ee85$export$afbe48a4a4275937){
    $e7012959a8ce1722$var$save.crates[crate1] = [];
    for (let item of (0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[crate1].loot){
        $e7012959a8ce1722$var$save.crates[crate1].push({});
        switch(item.quality){
            case 4:
            case 8:
            case 9:
            case 10:
                $e7012959a8ce1722$var$save.crates[crate1][$e7012959a8ce1722$var$save.crates[crate1].length - 1].n = 0;
                $e7012959a8ce1722$var$save.crates[crate1][$e7012959a8ce1722$var$save.crates[crate1].length - 1].q = 0;
                break;
            case 5:
                for(let i = 1; i < $e7012959a8ce1722$var$wearTable.length; i++)$e7012959a8ce1722$var$save.crates[crate1][$e7012959a8ce1722$var$save.crates[crate1].length - 1][$e7012959a8ce1722$var$wearTable[i]] = 0;
                break;
            case 6:
                for(let i = 1; i < $e7012959a8ce1722$var$wearTable.length; i++){
                    $e7012959a8ce1722$var$save.crates[crate1][$e7012959a8ce1722$var$save.crates[crate1].length - 1][$e7012959a8ce1722$var$wearTable[i]] = 0;
                    $e7012959a8ce1722$var$save.crates[crate1][$e7012959a8ce1722$var$save.crates[crate1].length - 1][`${$e7012959a8ce1722$var$wearTable[i]}q`] = 0;
                }
                break;
            case 11:
                $e7012959a8ce1722$var$save.crates[crate1][$e7012959a8ce1722$var$save.crates[crate1].length - 1].n = 0;
                $e7012959a8ce1722$var$save.crates[crate1][$e7012959a8ce1722$var$save.crates[crate1].length - 1].s = [];
                $e7012959a8ce1722$var$save.crates[crate1][$e7012959a8ce1722$var$save.crates[crate1].length - 1].p = [];
                break;
            default:
                $e7012959a8ce1722$var$save.crates[crate1][$e7012959a8ce1722$var$save.crates[crate1].length - 1].n = 0;
        }
    }
    for(let bonusItem in (0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[crate1].exclusiveBonus.loot)$e7012959a8ce1722$var$save.crates[crate1].push({
        n: 0
    });
    if ((0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[crate1].creepyBonus) for (let bonusItem of (0, $923c9e0e4e96ee85$export$dd394babd3967010)){
        $e7012959a8ce1722$var$save.crates[crate1].push({
            n: 0
        });
        if (bonusItem.quality == 11) {
            $e7012959a8ce1722$var$save.crates[crate1][$e7012959a8ce1722$var$save.crates[crate1].length - 1].s = [];
            $e7012959a8ce1722$var$save.crates[crate1][$e7012959a8ce1722$var$save.crates[crate1].length - 1].p = [];
        }
    }
    $e7012959a8ce1722$var$save.crateStats[crate1] = {
        n: 0
    };
    if ((0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[crate1].unusual) $e7012959a8ce1722$var$save.crateStats[crate1].u = 0;
    if ((0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[crate1].bonus || (0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[crate1].exclusiveBonus || (0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[crate1].creepyBonus) $e7012959a8ce1722$var$save.crateStats[crate1].b = 0;
}
const $e7012959a8ce1722$var$defaultSave = JSON.parse(JSON.stringify($e7012959a8ce1722$var$save));
/* ITEM SAVE SYSTEM

n - Stores the amount of the item.
    For items that can have a Strange or Strange Haunted variant, this will store the amount of non-Strange items.
    For killstreak kits, this will store the amount of normal killstreak kits.
q - For items that can have a Strange or Strange Haunted variant, this will store the amount of Strange items.
FN/MW/FT/WW/BS - Stores the amount of the item with specific wear
    For items that can have a Strange variant, this will store the amount of non-Strange items.
FNq/MWq/FTq/WWq/BSq - Same as above, but for items that can have a Strange variant, this will store the amount of non-Strange items.
s - For killstreak kits, this will store specialized killstreak kits.
p - For killstreak kits, this will store professional killstreak kits.
*/ // Options code
document.querySelectorAll("[data-option]").forEach((el)=>{
    if (el.classList.contains("checkbox")) el.addEventListener("click", ()=>{
        $e7012959a8ce1722$var$sound.play("btn");
        el.classList.toggle("checked");
        if (el.classList.contains("checked")) $e7012959a8ce1722$var$save.options[el.dataset.option] = true;
        else $e7012959a8ce1722$var$save.options[el.dataset.option] = false;
        localStorage.setItem("unboxertf-options", JSON.stringify($e7012959a8ce1722$var$save.options));
    });
    else if (el.tagName == "SELECT") el.addEventListener("input", ()=>{
        $e7012959a8ce1722$var$sound.play("btn");
        if (!isNaN(parseInt(el.value))) $e7012959a8ce1722$var$save.options[el.dataset.option] = parseInt(el.value);
        else $e7012959a8ce1722$var$save.options[el.dataset.option] = el.value;
        $e7012959a8ce1722$var$triggerOption(el.dataset.option);
        localStorage.setItem("unboxertf-options", JSON.stringify($e7012959a8ce1722$var$save.options));
    });
    else el.addEventListener("click", ()=>{
        el.parentNode.querySelector(".active").classList.remove("active");
        el.classList.add("active");
        if (el.dataset.optionvalue === 'true') $e7012959a8ce1722$var$save.options[el.dataset.option] = true;
        else if (el.dataset.optionvalue === 'false') $e7012959a8ce1722$var$save.options[el.dataset.option] = false;
        else $e7012959a8ce1722$var$save.options[el.dataset.option] = el.dataset.optionvalue;
        $e7012959a8ce1722$var$triggerOption(el.dataset.option);
        localStorage.setItem("unboxertf-options", JSON.stringify($e7012959a8ce1722$var$save.options));
    });
});
document.querySelectorAll("[data-optionarray]").forEach((el)=>{
    el.querySelectorAll("[data-optionvalue]").forEach((val)=>{
        val.addEventListener("click", ()=>{
            $e7012959a8ce1722$var$sound.play("btn");
            if (val.classList.contains("checked")) {
                val.classList.remove("checked");
                $e7012959a8ce1722$var$save.options[el.dataset.optionarray] = $e7012959a8ce1722$var$save.options[el.dataset.optionarray].filter((item)=>item !== val.dataset.optionvalue);
            } else {
                val.classList.add("checked");
                $e7012959a8ce1722$var$save.options[el.dataset.optionarray].push(val.dataset.optionvalue);
            }
            localStorage.setItem("unboxertf-options", JSON.stringify($e7012959a8ce1722$var$save.options));
        });
    });
});
function $e7012959a8ce1722$var$triggerOption(option, load) {
    if (load) {
        let optionEl = document.querySelector(`[data-option="${option}"], [data-optionarray="${option}"]`);
        if ($e7012959a8ce1722$var$save.options[option] === true || $e7012959a8ce1722$var$save.options[option] === false) {
            if (optionEl != null && optionEl.classList.contains("checkbox")) {
                if ($e7012959a8ce1722$var$save.options[option]) optionEl.classList.add("checked");
                else optionEl.classList.remove("checked");
            } else if (option === "muteSound") {
                if ($e7012959a8ce1722$var$save.options.muteSound) $e7012959a8ce1722$var$DOM.main.muteSoundBtn.innerHTML = '<i class="icon-mute"></i>';
            } else {
                document.querySelector(`[data-option="${option}"].active`).classList.remove("active");
                document.querySelector(`[data-option="${option}"][data-optionvalue="${$e7012959a8ce1722$var$save.options[option]}"]`).classList.add("active");
            }
        } else if (optionEl != null && optionEl.tagName === "SELECT") optionEl.value = $e7012959a8ce1722$var$save.options[option];
        else if (optionEl.dataset.optionarray) optionEl.querySelectorAll("[data-optionvalue]").forEach((el)=>{
            if ($e7012959a8ce1722$var$save.options[optionEl.dataset.optionarray].includes(el.dataset.optionvalue)) el.classList.add("checked");
            else el.classList.remove("checked");
        });
    }
    switch(option){
        case "amoledTheme":
            if ($e7012959a8ce1722$var$save.options.amoledTheme) document.body.classList.add("amoledtheme");
            else document.body.classList.remove("amoledtheme");
            break;
        case "language":
            if (load && $e7012959a8ce1722$var$save.options.language != "eng" || !load) $e7012959a8ce1722$var$changeLanguage($e7012959a8ce1722$var$save.options.language);
            break;
        case "halloweenMode":
            $e7012959a8ce1722$var$generateEffectList();
            break;
    }
}
// Update stats function
function $e7012959a8ce1722$var$updateStats() {
    document.querySelectorAll("[data-stat]").forEach((el)=>{
        el.innerHTML = $e7012959a8ce1722$var$save.stats[el.dataset.stat];
    });
    document.querySelectorAll('[data-stat="keys-money"], [data-stat="unusual-avgprice"]').forEach((el)=>{
        el.innerHTML = "$" + el.innerHTML;
    });
    // Luck
    if ($e7012959a8ce1722$var$save.stats["unusual-chances"] >= 100 && $e7012959a8ce1722$var$save.stats["strange-chances"] >= 10) {
        // Unusual luck
        let unusualPrediction = Math.floor($e7012959a8ce1722$var$save.stats["unusual-chances"] / 150);
        let msg = $e7012959a8ce1722$var$getString("ui", 118);
        msg = msg.replace("#TOTALUNBOXES#", $e7012959a8ce1722$var$save.stats["unusual-chances"]);
        msg = msg.replace("#UNUSUALSUNBOXED#", $e7012959a8ce1722$var$save.stats["unusual-unboxed"]);
        $e7012959a8ce1722$var$DOM.stats.statistics.luck.unusual.removeAttribute("class");
        if (unusualPrediction < $e7012959a8ce1722$var$save.stats["unusual-unboxed"]) {
            // Lucky
            $e7012959a8ce1722$var$DOM.stats.statistics.luck.unusual.classList.add("lucky");
            $e7012959a8ce1722$var$DOM.stats.statistics.luck.unusual.innerHTML = $e7012959a8ce1722$var$getString("ui", 114);
            msg += $e7012959a8ce1722$var$getString("ui", 119);
            msg = msg.replace("#DIFF#", $e7012959a8ce1722$var$save.stats["unusual-unboxed"] - unusualPrediction);
        } else if (unusualPrediction > $e7012959a8ce1722$var$save.stats["unusual-unboxed"]) {
            // Unlucky
            $e7012959a8ce1722$var$DOM.stats.statistics.luck.unusual.classList.add("unlucky");
            $e7012959a8ce1722$var$DOM.stats.statistics.luck.unusual.innerHTML = $e7012959a8ce1722$var$getString("ui", 115);
            msg += $e7012959a8ce1722$var$getString("ui", 120);
            msg = msg.replace("#DIFF#", unusualPrediction - $e7012959a8ce1722$var$save.stats["unusual-unboxed"]);
        } else {
            // Neither lucky nor unlucky
            $e7012959a8ce1722$var$DOM.stats.statistics.luck.unusual.classList.add("neither");
            msg += $e7012959a8ce1722$var$getString("ui", 121);
            $e7012959a8ce1722$var$DOM.stats.statistics.luck.unusual.innerHTML = $e7012959a8ce1722$var$getString("ui", 116);
        }
        msg = msg.replace("#PREDICTION#", unusualPrediction);
        $e7012959a8ce1722$var$DOM.stats.statistics.luck.unusualDesc.innerHTML = msg;
        // Strange luck
        let strangePrediction = Math.floor($e7012959a8ce1722$var$save.stats["strange-chances"] / 10);
        msg = $e7012959a8ce1722$var$getString("ui", 122);
        msg = msg.replace("#TOTALUNBOXES#", $e7012959a8ce1722$var$save.stats["strange-chances"]);
        msg = msg.replace("#STRANGESUNBOXED#", $e7012959a8ce1722$var$save.stats["random-strange-unboxed"]);
        $e7012959a8ce1722$var$DOM.stats.statistics.luck.strange.removeAttribute("class");
        if (strangePrediction < $e7012959a8ce1722$var$save.stats["random-strange-unboxed"]) {
            // Lucky
            $e7012959a8ce1722$var$DOM.stats.statistics.luck.strange.classList.add("lucky");
            $e7012959a8ce1722$var$DOM.stats.statistics.luck.strange.innerHTML = $e7012959a8ce1722$var$getString("ui", 114);
            msg += $e7012959a8ce1722$var$getString("ui", 119);
            msg = msg.replace("#DIFF#", $e7012959a8ce1722$var$save.stats["random-strange-unboxed"] - strangePrediction);
        } else if (strangePrediction > $e7012959a8ce1722$var$save.stats["random-strange-unboxed"]) {
            // Unlucky
            $e7012959a8ce1722$var$DOM.stats.statistics.luck.strange.classList.add("unlucky");
            $e7012959a8ce1722$var$DOM.stats.statistics.luck.strange.innerHTML = $e7012959a8ce1722$var$getString("ui", 115);
            msg += $e7012959a8ce1722$var$getString("ui", 120);
            msg = msg.replace("#DIFF#", strangePrediction - $e7012959a8ce1722$var$save.stats["random-strange-unboxed"]);
        } else {
            // Neither lucky nor unlucky
            $e7012959a8ce1722$var$DOM.stats.statistics.luck.unusual.classList.add("neither");
            msg += $e7012959a8ce1722$var$getString("ui", 121);
            $e7012959a8ce1722$var$DOM.stats.statistics.luck.strange.innerHTML = $e7012959a8ce1722$var$getString("ui", 116);
        }
        msg = msg.replace("#PREDICTION#", strangePrediction);
        $e7012959a8ce1722$var$DOM.stats.statistics.luck.strangeDesc.innerHTML = msg;
        $e7012959a8ce1722$var$DOM.stats.statistics.luck.notEnough.style.display = "none";
        $e7012959a8ce1722$var$DOM.stats.statistics.luck.container.style.display = "flex";
    } else {
        // Not enough data to show luck
        $e7012959a8ce1722$var$DOM.stats.statistics.luck.container.style.display = "none";
        $e7012959a8ce1722$var$DOM.stats.statistics.luck.notEnough.style.display = "flex";
    }
}
// Populate unusual section in stats
let $e7012959a8ce1722$var$unusualsGenerated = false;
function $e7012959a8ce1722$var$generateUnusualStats() {
    $e7012959a8ce1722$var$unusualsGenerated = true;
    $e7012959a8ce1722$var$DOM.stats.unusuals.content.innerHTML = "";
    if ($e7012959a8ce1722$var$save.unusuals.length > 0) {
        $e7012959a8ce1722$var$DOM.stats.unusuals.pageDiv.dataset.unusualpage = "1";
        $e7012959a8ce1722$var$DOM.stats.unusuals.pageDiv.dataset.unusualmaxpage = Math.ceil($e7012959a8ce1722$var$save.unusuals.length / 200);
        $e7012959a8ce1722$var$unusualPage({
            el: $e7012959a8ce1722$var$DOM.stats.unusuals.pageDiv
        });
    } else $e7012959a8ce1722$var$DOM.stats.unusuals.content.innerHTML = `<p id="nounusuals" data-string="50">${$e7012959a8ce1722$var$getString("ui", 50)}</p>`;
}
function $e7012959a8ce1722$var$updateUnusualStats(array, upd) {
    /*  array[0] - item ID
        array[1] - effect ID (or taunt ID if item is an unusualifier)
        array[2] - item quality
        array[3] - item wear
    */ let tempHtml = "";
    let itemName = $e7012959a8ce1722$var$getString("item", array[0]);
    let qualityName = $e7012959a8ce1722$var$getString("ui", 73);
    if ($e7012959a8ce1722$var$strangeStringPosition === "right") qualityName = `(${qualityName})`;
    let skinFolder = "";
    if (array[3] != 0) {
        skinFolder = `skins/${$e7012959a8ce1722$var$wearTable[array[3]]}`;
        itemName += ` (${$e7012959a8ce1722$var$getString("ui", $e7012959a8ce1722$var$wearTableNames[array[3]])})`;
    }
    let img1, img2;
    let effectText = "";
    if (array[2] === 1 && array[3] === 0) {
        let temp = `<span class="colorstrange">${$e7012959a8ce1722$var$getString("ui", 71)}</span>`;
        if ($e7012959a8ce1722$var$strangeStringPosition === "right") temp = temp.replace('">', '">(').replace('</span>', ')</span>');
        qualityName = `${temp} ${qualityName}`;
    }
    if (array[0] === 770) {
        itemName = $e7012959a8ce1722$var$getString("item", 770).replace("#ITEM#", $e7012959a8ce1722$var$getString("item", array[1])).replace('The ', '');
        img1 = `<img src="./images/item/${$e7012959a8ce1722$var$getImg("item", 770)}" alt="" loading="lazy">`;
        img2 = `<img class="unusualifierimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", array[1])}" alt="" loading="lazy">`;
    } else {
        if ($e7012959a8ce1722$var$strangeStringPosition === "left") itemName = `${qualityName} ${itemName}`;
        else itemName = `${itemName} ${qualityName}`;
        let statClockText = "";
        if (array[2] === 1 && array[3] != 0) statClockText = `<span class="colorstrange statclock">${$e7012959a8ce1722$var$getString("ui", 157)}</span><br>`;
        effectText = `<p class="statsunusualseffect">${statClockText}${$e7012959a8ce1722$var$getString("ui", 79)} ${$e7012959a8ce1722$var$getString("effect", array[1])}</p>`;
        img1 = `<img class="effectimg" src="./images/effect/${$e7012959a8ce1722$var$getImg("effect", array[1])}" alt="" loading="lazy">`;
        img2 = `<img src="./images/item/${skinFolder}${$e7012959a8ce1722$var$getImg("item", array[0])}" alt="" loading="lazy">`;
    }
    let urlOptions = {
        item: array[0],
        wear: array[3]
    };
    if (array[0] === 770) urlOptions.kitItem = array[1];
    else urlOptions.effect = array[1];
    if (array[2] === 1) urlOptions.quality = "strangeunusual";
    else urlOptions.quality = "unusual";
    let steamMarketUrl = $e7012959a8ce1722$var$generateSteamMarketUrl(urlOptions);
    let backpackUrl = $e7012959a8ce1722$var$generateBackpackTfUrl(urlOptions);
    let marketplaceUrl = $e7012959a8ce1722$var$generateMarketplaceTfUrl(urlOptions);
    tempHtml += `<div>
    ${img1}
    ${img2}
    <p class="statsunuusalsname">${itemName}</p>
    <div class="statsunusualsbottom">
    ${effectText}
    <div class="statsunusualsmarketbtns">
    <a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 197)}" data-tooltipstring="197" target="_blank" rel="noopener" href="${steamMarketUrl}"><i class="icon-steam"></i></a><a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 198)}" data-tooltipstring="198" target="_blank" rel="noopener" href="${backpackUrl}"><i class="icon-backpacktf"></i></a><a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 199)}" data-tooltipstring="199" target="_blank" rel="noopener" href="${marketplaceUrl}"><i class="icon-marketplacetf"></i></a>
    </div>
    </div>
    </div>`;
    if (upd) {
        let noUnusualsMsg = $e7012959a8ce1722$var$DOM.stats.unusuals.content.querySelector("#nounusuals");
        if (noUnusualsMsg) noUnusualsMsg.remove();
        $e7012959a8ce1722$var$DOM.stats.unusuals.content.innerHTML += tempHtml;
    } else return tempHtml;
}
let $e7012959a8ce1722$var$crateStatsGenerated = false;
// Populate list of crates in inventory
function $e7012959a8ce1722$var$generateCrateStats() {
    if ($e7012959a8ce1722$var$crateStatsGenerated) return 0;
    $e7012959a8ce1722$var$crateStatsGenerated = true;
    $e7012959a8ce1722$var$DOM.stats.crates.container.innerHTML = "";
    let tempHtml = "";
    tempHtml += `<div data-cratestats="bonus">
    <img src="./images/item/${$e7012959a8ce1722$var$getImg("item", 24)}" alt="" loading="lazy">
    <p class="statscratesname">${$e7012959a8ce1722$var$getString("ui", 144)}</p>
    </div>`;
    for (let crateNum of (0, $923c9e0e4e96ee85$export$43b46fa232650b2f)){
        let crate1 = (0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[crateNum];
        tempHtml += `<div data-cratestats="${crateNum}">
    <img src="./images/crate/${$e7012959a8ce1722$var$getImg("crate", crate1.id)}" alt="" loading="lazy">
    <p class="statscratesname">${$e7012959a8ce1722$var$getString("crate", crate1.id)}</p>
    <p class="statscratesseries">${$e7012959a8ce1722$var$getSeries(crate1.series)}</p>
    </div>`;
    }
    $e7012959a8ce1722$var$DOM.stats.crates.container.innerHTML = tempHtml;
    document.querySelectorAll("[data-cratestats]").forEach((el)=>{
        el.addEventListener("pointerdown", ()=>{
            $e7012959a8ce1722$var$sound.play("btn");
        });
        el.addEventListener("click", (evt)=>{
            $e7012959a8ce1722$var$sound.play("btnRelease");
            $e7012959a8ce1722$var$DOM.stats.container.style.display = "none";
            $e7012959a8ce1722$var$DOM.stats.crates.details.container.classList.add("visible");
            $e7012959a8ce1722$var$generateCrateDetails(el.dataset.cratestats);
        });
    });
}
// Crate inventory
let $e7012959a8ce1722$var$showAllItems = false; // Debug variable - if set to true, will show items that were never unboxed as well
function $e7012959a8ce1722$var$generateCrateDetails(crate1, el, saveObj, bonus) {
    let gridWidth = 0;
    let gridClass = "col0";
    let gridArray = [
        "col0",
        "col1",
        "col2",
        "col3"
    ];
    let htmlEl = $e7012959a8ce1722$var$DOM.stats.crates.details;
    if (el != undefined) htmlEl = el;
    let saveObject = $e7012959a8ce1722$var$save;
    if (saveObj != undefined) saveObject = saveObj;
    htmlEl.content.innerHTML = "";
    function setGridWidth(width) {
        if (width > gridWidth) {
            gridWidth = width;
            gridClass = gridArray[width];
        }
    }
    let tempHTML = "";
    if (crate1 === "bonus" || bonus === true) {
        if (el === undefined) {
            htmlEl.image.src = `./images/item/${$e7012959a8ce1722$var$getImg("item", 24)}`;
            htmlEl.title.innerHTML = `<p>${$e7012959a8ce1722$var$getString("ui", 144)}</p>`;
            htmlEl.crateStats.innerHTML = `<p>${$e7012959a8ce1722$var$getString("ui", 143)} ${saveObject.stats["bonus-unboxed"]}</p>`;
        }
        for (let item of saveObject.bonusItems){
            let urlOptions = {
                item: item.i,
                quality: "unique",
                wear: 0
            };
            let steamMarketUrl = $e7012959a8ce1722$var$generateSteamMarketUrl(urlOptions);
            let backpackUrl = $e7012959a8ce1722$var$generateBackpackTfUrl(urlOptions);
            let marketplaceUrl = $e7012959a8ce1722$var$generateMarketplaceTfUrl(urlOptions);
            tempHTML += `<div class="bordercolor colorunique">
                    <p class="cratedetailsitemname">${$e7012959a8ce1722$var$getString("item", item.i)}</p>
                    <img class="cratedetailsitemimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", item.i)}" loading="lazy">
                    <div class="cratedetailsitembottom">
                    <p class="cratedetailsitemunboxed">${$e7012959a8ce1722$var$getString("ui", 53)} ${item.n} ${$e7012959a8ce1722$var$getString("ui", 54)}</p>
                    <div class="cratedetailsitemmarketbtns">
                    <a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 197)}" data-tooltipstring="197" target="_blank" rel="noopener" href="${steamMarketUrl}"><i class="icon-steam"></i></a><a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 198)}" data-tooltipstring="198" target="_blank" rel="noopener" href="${backpackUrl}"><i class="icon-backpacktf"></i></a><a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 199)}" data-tooltipstring="199" target="_blank" rel="noopener" href="${marketplaceUrl}"><i class="icon-marketplacetf"></i></a>
                    </div>
                    </div>
                    </div>`;
        }
    } else {
        let urlOptions;
        let steamMarketUrl;
        let backpackUrl;
        let marketplaceUrl;
        for (let [index, item] of (0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[crate1].loot.entries())switch(item.quality){
            case 1:
            case 2:
            case 3:
            case 7:
            case 12:
                if (saveObject.crates[crate1][index].n === 0 && !$e7012959a8ce1722$var$showAllItems) continue;
                let itemImg, kitImg, itemName;
                itemImg = kitImg = itemName = "";
                if (item.quality === 12) {
                    itemImg = `<img class="cratedetailsitemimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", 452)}" loading="lazy">`;
                    kitImg = `<img class="cratedetailskitimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", item.id)}" loading="lazy">`;
                    itemName = $e7012959a8ce1722$var$getString("item", 452).replace("#ITEM#", $e7012959a8ce1722$var$getString("item", item.id)).replace('The ', '');
                } else {
                    itemImg = `<img class="cratedetailsitemimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", item.id)}" loading="lazy">`;
                    itemName = $e7012959a8ce1722$var$getString("item", item.id);
                }
                let borderColor = "bordercolor ";
                switch(item.quality){
                    case 2:
                        borderColor += "colorstrange";
                        break;
                    case 3:
                        borderColor = "colorhaunted";
                        break;
                    default:
                        borderColor = "colorunique";
                }
                urlOptions = {
                    item: item.id,
                    wear: 0
                };
                switch(item.quality){
                    case 1:
                    case 7:
                        urlOptions.quality = "unique";
                        break;
                    case 2:
                        urlOptions.quality = "strange";
                        break;
                    case 3:
                        urlOptions.quality = "haunted";
                        break;
                    case 12:
                        urlOptions.quality = "strangifier";
                        break;
                }
                if (urlOptions.quality != "unique" || (0, $923c9e0e4e96ee85$export$10dc550ff6f20217).includes(item.id) || (0, $923c9e0e4e96ee85$export$823717ebc7f69446).includes(item.id) || (0, $923c9e0e4e96ee85$export$d74038d209dbd599).includes(item.id) || (0, $923c9e0e4e96ee85$export$5a1370e0815c8951).includes(item.id)) steamMarketUrl = `<a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 197)}" data-tooltipstring="197" target="_blank" rel="noopener" href="${$e7012959a8ce1722$var$generateSteamMarketUrl(urlOptions)}"><i class="icon-steam"></i></a>`;
                else steamMarketUrl = `<a class="btn btndisabled"><i class="icon-steam"></i></a>`;
                backpackUrl = $e7012959a8ce1722$var$generateBackpackTfUrl(urlOptions);
                marketplaceUrl = $e7012959a8ce1722$var$generateMarketplaceTfUrl(urlOptions);
                tempHTML += `<div class="${borderColor}">
                    <p class="cratedetailsitemname">${itemName}</p>
                    ${itemImg}${kitImg}
                    <div class="cratedetailsitembottom">
                    <p class="cratedetailsitemunboxed">${$e7012959a8ce1722$var$getString("ui", 53)} ${saveObject.crates[crate1][index].n} ${$e7012959a8ce1722$var$getString("ui", 54)}</p>
                    <div class="cratedetailsitemmarketbtns">
                    ${steamMarketUrl}<a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 198)}" data-tooltipstring="198" target="_blank" rel="noopener" href="${backpackUrl}"><i class="icon-backpacktf"></i></a><a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 199)}" data-tooltipstring="199" target="_blank" rel="noopener" href="${marketplaceUrl}"><i class="icon-marketplacetf"></i></a>
                    </div>
                    </div>
                    </div>`;
                break;
            case 4:
            case 8:
            case 9:
            case 10:
                if (saveObject.crates[crate1][index].n === 0 && saveObject.crates[crate1][index].q === 0 && !$e7012959a8ce1722$var$showAllItems) continue;
                setGridWidth(2);
                let qualityString, gradeClass;
                if (item.quality == 8) qualityString = `<p class="colorstrange">${$e7012959a8ce1722$var$getString("ui", 71)} <span class="colorhaunted">${$e7012959a8ce1722$var$getString("ui", 72)}:</span></p>`;
                else qualityString = `<p class="colorstrange">${$e7012959a8ce1722$var$getString("ui", 71)}:</p>`;
                if (item.grade != 0) gradeClass = ` class="bordercolor ${$e7012959a8ce1722$var$gradeTable[item.grade]}"`;
                else gradeClass = "";
                urlOptions = {
                    item: item.id,
                    quality: "unique",
                    wear: 0
                };
                if (item.grade != 0 || (0, $923c9e0e4e96ee85$export$5a1370e0815c8951).includes(item.id)) steamMarketUrl = `<a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 197)}" data-tooltipstring="197" target="_blank" rel="noopener" href="${$e7012959a8ce1722$var$generateSteamMarketUrl(urlOptions)}"><i class="icon-steam"></i></a>`;
                else steamMarketUrl = `<a class="btn btndisabled"><i class="icon-steam"></i></a>`;
                backpackUrl = $e7012959a8ce1722$var$generateBackpackTfUrl(urlOptions);
                marketplaceUrl = $e7012959a8ce1722$var$generateMarketplaceTfUrl(urlOptions);
                tempHTML += `<div${gradeClass}>
                    <p class="cratedetailsitemname">${$e7012959a8ce1722$var$getString("item", item.id)}</p>
                    <div>
                    <img class="cratedetailsitemimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", item.id)}" loading="lazy">
                        <div class="cratedetailsqualitylist">
                            <p class="colorunique">${$e7012959a8ce1722$var$getString("ui", 146)}:</p>
                            <p>${saveObject.crates[crate1][index].n}</p>
                            ${qualityString}
                            <p>${saveObject.crates[crate1][index].q}</p>
                        </div>
                    </div>
                    <div class="cratedetailsitembottom">
                    <p class="cratedetailsitemunboxed">${$e7012959a8ce1722$var$getString("ui", 53)} ${saveObject.crates[crate1][index].n + saveObject.crates[crate1][index].q} ${$e7012959a8ce1722$var$getString("ui", 54)}</p>
                    <div class="cratedetailsitemmarketbtns">
                    ${steamMarketUrl}<a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 198)}" data-tooltipstring="198" target="_blank" rel="noopener" href="${backpackUrl}"><i class="icon-backpacktf"></i></a><a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 199)}" data-tooltipstring="199" target="_blank" rel="noopener" href="${marketplaceUrl}"><i class="icon-marketplacetf"></i></a>
                    </div>
                    </div>
                    </div>`;
                break;
            case 5:
            case 6:
                let noItems = true;
                for(let variant in saveObject.crates[crate1][index])if (saveObject.crates[crate1][index][variant] != 0 || $e7012959a8ce1722$var$showAllItems) {
                    noItems = false;
                    break;
                }
                if (noItems) continue;
                setGridWidth(3);
                let gradeClass2;
                if (item.grade != 0) gradeClass2 = ` class="bordercolor ${$e7012959a8ce1722$var$gradeTable[item.grade]}"`;
                else gradeClass2 = "";
                let strangeList = "";
                let saveItem = saveObject.crates[crate1][index];
                let itemTotal = saveItem.FN + saveItem.MW + saveItem.FT + saveItem.WW + saveItem.BS;
                if (item.quality === 6) {
                    strangeList = `<div class="cratedetailsqualitylist">
                        <p class="colorstrange" data-quality="FN">${$e7012959a8ce1722$var$getString("ui", 80)}:</p>
                        <p>${saveObject.crates[crate1][index].FNq}</p>
                        <p class="colorstrange" data-quality="MW">${$e7012959a8ce1722$var$getString("ui", 81)}:</p>
                        <p>${saveObject.crates[crate1][index].MWq}</p>
                        <p class="colorstrange" data-quality="FT">${$e7012959a8ce1722$var$getString("ui", 82)}:</p>
                        <p>${saveObject.crates[crate1][index].FTq}</p>
                        <p class="colorstrange" data-quality="WW">${$e7012959a8ce1722$var$getString("ui", 83)}:</p>
                        <p>${saveObject.crates[crate1][index].WWq}</p>
                        <p class="colorstrange" data-quality="BS">${$e7012959a8ce1722$var$getString("ui", 84)}:</p>
                        <p>${saveObject.crates[crate1][index].BSq}</p>
                        </div>`;
                    itemTotal += saveItem.FNq + saveItem.MWq + saveItem.FTq + saveItem.WWq + saveItem.BSq;
                }
                tempHTML += `<div${gradeClass2}>
                    <p class="cratedetailsitemname">${$e7012959a8ce1722$var$getString("item", item.id)}</p>
                    <div>
                    <img class="cratedetailsitemimg" src="./images/item/skins/BS${$e7012959a8ce1722$var$getImg("item", item.id)}" loading="lazy">
                        <div class="cratedetailsqualitylist">
                            <p class="colorunique" data-quality="FN">${$e7012959a8ce1722$var$getString("ui", 80)}:</p>
                            <p>${saveObject.crates[crate1][index].FN}</p>
                            <p class="colorunique" data-quality="MW">${$e7012959a8ce1722$var$getString("ui", 81)}:</p>
                            <p>${saveObject.crates[crate1][index].MW}</p>
                            <p class="colorunique" data-quality="FT">${$e7012959a8ce1722$var$getString("ui", 82)}:</p>
                            <p>${saveObject.crates[crate1][index].FT}</p>
                            <p class="colorunique" data-quality="WW">${$e7012959a8ce1722$var$getString("ui", 83)}:</p>
                            <p>${saveObject.crates[crate1][index].WW}</p>
                            <p class="colorunique" data-quality="BS">${$e7012959a8ce1722$var$getString("ui", 84)}:</p>
                            <p>${saveObject.crates[crate1][index].BS}</p>
                        </div>
                        ${strangeList}
                    </div>
                    <p class="cratedetailsitemunboxed cratedetailsitemnomarket">${$e7012959a8ce1722$var$getString("ui", 53)} ${itemTotal} ${$e7012959a8ce1722$var$getString("ui", 54)}</p>
                    </div>`;
                break;
            case 11:
                if (saveObject.crates[crate1][index].n === 0 && saveObject.crates[crate1][index].s.length === 0 && saveObject.crates[crate1][index].p.length === 0 && !$e7012959a8ce1722$var$showAllItems) continue;
                setGridWidth(1);
                if (saveObject.crates[crate1][index].n != 0) {
                    let itemName = $e7012959a8ce1722$var$getString("item", 764).replace("#ITEM#", $e7012959a8ce1722$var$getString("item", item.id)).replace('The ', '');
                    urlOptions = {
                        item: item.id,
                        quality: "unique",
                        wear: 0,
                        kit: 1
                    };
                    steamMarketUrl = `<a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 197)}" data-tooltipstring="197" target="_blank" rel="noopener" href="${$e7012959a8ce1722$var$generateSteamMarketUrl(urlOptions)}"><i class="icon-steam"></i></a>`;
                    backpackUrl = $e7012959a8ce1722$var$generateBackpackTfUrl(urlOptions);
                    marketplaceUrl = $e7012959a8ce1722$var$generateMarketplaceTfUrl(urlOptions);
                    tempHTML += `<div class="bordercolor colorunique">
                    <p class="cratedetailsitemname">${itemName}</p>
                    <img class="cratedetailsitemimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", 764)}" loading="lazy">
                    <img class="cratedetailskitimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", item.id)}" loading="lazy">
                    <div class="cratedetailsitembottom">
                    <p class="cratedetailsitemunboxed">${$e7012959a8ce1722$var$getString("ui", 53)} ${saveObject.crates[crate1][index].n} ${$e7012959a8ce1722$var$getString("ui", 54)}</p>
                    <div class="cratedetailsitemmarketbtns">
                    ${steamMarketUrl}<a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 198)}" data-tooltipstring="198" target="_blank" rel="noopener" href="${backpackUrl}"><i class="icon-backpacktf"></i></a><a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 199)}" data-tooltipstring="199" target="_blank" rel="noopener" href="${marketplaceUrl}"><i class="icon-marketplacetf"></i></a>
                    </div>
                    </div>
                    </div>`;
                }
                for (let specKit of saveObject.crates[crate1][index].s){
                    urlOptions = {
                        item: item.id,
                        quality: "unique",
                        wear: 0,
                        kit: 2
                    };
                    steamMarketUrl = `<a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 197)}" data-tooltipstring="197" target="_blank" rel="noopener" href="${$e7012959a8ce1722$var$generateSteamMarketUrl(urlOptions)}"><i class="icon-steam"></i></a>`;
                    backpackUrl = $e7012959a8ce1722$var$generateBackpackTfUrl(urlOptions);
                    marketplaceUrl = $e7012959a8ce1722$var$generateMarketplaceTfUrl(urlOptions);
                    let itemName = $e7012959a8ce1722$var$getString("item", 765).replace("#ITEM#", $e7012959a8ce1722$var$getString("item", item.id)).replace('The ', '');
                    tempHTML += `<div class="bordercolor colorunique">
                    <p class="cratedetailsitemname">${itemName}<br>
                    <span class="cratedetailskillstreak">${$e7012959a8ce1722$var$getString("ui", 126)} ${$e7012959a8ce1722$var$getString("ui", $e7012959a8ce1722$var$sheenTable[specKit.s])}</span></p>
                    <img class="cratedetailsitemimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", 765)}" loading="lazy">
                    <img class="cratedetailskitimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", item.id)}" loading="lazy">
                    <div class="cratedetailsitembottom">
                    <p class="cratedetailsitemunboxed">${$e7012959a8ce1722$var$getString("ui", 53)} ${specKit.n} ${$e7012959a8ce1722$var$getString("ui", 54)}</p>
                    <div class="cratedetailsitemmarketbtns">
                    ${steamMarketUrl}<a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 198)}" data-tooltipstring="198" target="_blank" rel="noopener" href="${backpackUrl}"><i class="icon-backpacktf"></i></a><a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 199)}" data-tooltipstring="199" target="_blank" rel="noopener" href="${marketplaceUrl}"><i class="icon-marketplacetf"></i></a>
                    </div>
                    </div>
                    </div>`;
                }
                for (let proKit of saveObject.crates[crate1][index].p){
                    urlOptions = {
                        item: item.id,
                        quality: "unique",
                        wear: 0,
                        kit: 3
                    };
                    steamMarketUrl = `<a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 197)}" data-tooltipstring="197" target="_blank" rel="noopener" href="${$e7012959a8ce1722$var$generateSteamMarketUrl(urlOptions)}"><i class="icon-steam"></i></a>`;
                    backpackUrl = $e7012959a8ce1722$var$generateBackpackTfUrl(urlOptions);
                    marketplaceUrl = $e7012959a8ce1722$var$generateMarketplaceTfUrl(urlOptions);
                    let itemName = $e7012959a8ce1722$var$getString("item", 766).replace("#ITEM#", $e7012959a8ce1722$var$getString("item", item.id)).replace('The ', '');
                    tempHTML += `<div class="bordercolor colorunique">
                    <p class="cratedetailsitemname">${itemName}<br>
                    <span class="cratedetailskillstreak">${$e7012959a8ce1722$var$getString("ui", 126)} ${$e7012959a8ce1722$var$getString("ui", $e7012959a8ce1722$var$sheenTable[proKit.s])}<br>
                    ${$e7012959a8ce1722$var$getString("ui", 127)} ${$e7012959a8ce1722$var$getString("ui", $e7012959a8ce1722$var$killstreakerTable[proKit.k])}</span></p>
                    <img class="cratedetailsitemimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", 766)}" loading="lazy">
                    <img class="cratedetailskitimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", item.id)}" loading="lazy">
                    <div class="cratedetailsitembottom">
                    <p class="cratedetailsitemunboxed">${$e7012959a8ce1722$var$getString("ui", 53)} ${proKit.n} ${$e7012959a8ce1722$var$getString("ui", 54)}</p>
                    <div class="cratedetailsitemmarketbtns">
                    ${steamMarketUrl}<a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 198)}" data-tooltipstring="198" target="_blank" rel="noopener" href="${backpackUrl}"><i class="icon-backpacktf"></i></a><a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 199)}" data-tooltipstring="199" target="_blank" rel="noopener" href="${marketplaceUrl}"><i class="icon-marketplacetf"></i></a>
                    </div>
                    </div>
                    </div>`;
                }
                break;
        }
        if ((0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[crate1].exclusiveBonus) for (let [index, item] of (0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[crate1].exclusiveBonus.loot.entries()){
            let bonusItemIndex = (0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[crate1].loot.length + index;
            if (saveObject.crates[crate1][bonusItemIndex].n === 0 && !$e7012959a8ce1722$var$showAllItems) continue;
            urlOptions = {
                item: item,
                quality: "unique",
                wear: 0
            };
            steamMarketUrl = `<a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 197)}" data-tooltipstring="197" target="_blank" rel="noopener" href="${$e7012959a8ce1722$var$generateSteamMarketUrl(urlOptions)}"><i class="icon-steam"></i></a>`;
            backpackUrl = $e7012959a8ce1722$var$generateBackpackTfUrl(urlOptions);
            marketplaceUrl = $e7012959a8ce1722$var$generateMarketplaceTfUrl(urlOptions);
            tempHTML += `<div class="bordercolor colorunique">
                <p class="cratedetailsitemname">${$e7012959a8ce1722$var$getString("item", item)}</p>
                <img class="cratedetailsitemimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", item)}" loading="lazy">
                <div class="cratedetailsitembottom">
                <p class="cratedetailsitemunboxed">${$e7012959a8ce1722$var$getString("ui", 53)} ${saveObject.crates[crate1][bonusItemIndex].n} ${$e7012959a8ce1722$var$getString("ui", 54)}</p>
                <div class="cratedetailsitemmarketbtns">
                    ${steamMarketUrl}<a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 198)}" data-tooltipstring="198" target="_blank" rel="noopener" href="${backpackUrl}"><i class="icon-backpacktf"></i></a><a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 199)}" data-tooltipstring="199" target="_blank" rel="noopener" href="${marketplaceUrl}"><i class="icon-marketplacetf"></i></a>
                    </div>
                    </div>
                </div>`;
        }
        if ((0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[crate1].creepyBonus) for (let [index, item] of (0, $923c9e0e4e96ee85$export$dd394babd3967010).entries()){
            let bonusItemIndex = (0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[crate1].loot.length + index;
            if (item.quality == 11) {
                if (saveObject.crates[crate1][bonusItemIndex].n === 0 && saveObject.crates[crate1][bonusItemIndex].s.length === 0 && saveObject.crates[crate1][bonusItemIndex].p.length === 0 && !$e7012959a8ce1722$var$showAllItems) continue;
                setGridWidth(1);
                if (saveObject.crates[crate1][bonusItemIndex].n != 0) {
                    urlOptions = {
                        item: item.id,
                        quality: "unique",
                        wear: 0,
                        kit: 1
                    };
                    steamMarketUrl = `<a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 197)}" data-tooltipstring="197" target="_blank" rel="noopener" href="${$e7012959a8ce1722$var$generateSteamMarketUrl(urlOptions)}"><i class="icon-steam"></i></a>`;
                    backpackUrl = $e7012959a8ce1722$var$generateBackpackTfUrl(urlOptions);
                    marketplaceUrl = $e7012959a8ce1722$var$generateMarketplaceTfUrl(urlOptions);
                    let itemName = $e7012959a8ce1722$var$getString("item", 764).replace("#ITEM#", $e7012959a8ce1722$var$getString("item", item.id)).replace('The ', '');
                    tempHTML += `<div class="bordercolor colorunique">
                    <p class="cratedetailsitemname">${itemName}</p>
                    <img class="cratedetailsitemimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", 764)}" loading="lazy">
                    <img class="cratedetailskitimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", item.id)}" loading="lazy">
                    <div class="cratedetailsitembottom">
                    <p class="cratedetailsitemunboxed">${$e7012959a8ce1722$var$getString("ui", 53)} ${saveObject.crates[crate1][bonusItemIndex].n} ${$e7012959a8ce1722$var$getString("ui", 54)}</p>
                    <div class="cratedetailsitemmarketbtns">
                    ${steamMarketUrl}<a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 198)}" data-tooltipstring="198" target="_blank" rel="noopener" href="${backpackUrl}"><i class="icon-backpacktf"></i></a><a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 199)}" data-tooltipstring="199" target="_blank" rel="noopener" href="${marketplaceUrl}"><i class="icon-marketplacetf"></i></a>
                    </div>
                    </div>
                    </div>`;
                }
                for (let specKit of saveObject.crates[crate1][bonusItemIndex].s){
                    urlOptions = {
                        item: item.id,
                        quality: "unique",
                        wear: 0,
                        kit: 2
                    };
                    steamMarketUrl = `<a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 197)}" data-tooltipstring="197" target="_blank" rel="noopener" href="${$e7012959a8ce1722$var$generateSteamMarketUrl(urlOptions)}"><i class="icon-steam"></i></a>`;
                    backpackUrl = $e7012959a8ce1722$var$generateBackpackTfUrl(urlOptions);
                    marketplaceUrl = $e7012959a8ce1722$var$generateMarketplaceTfUrl(urlOptions);
                    let itemName = $e7012959a8ce1722$var$getString("item", 765).replace("#ITEM#", $e7012959a8ce1722$var$getString("item", item.id)).replace('The ', '');
                    tempHTML += `<div class="bordercolor colorunique">
                    <p class="cratedetailsitemname">${itemName}<br>
                    <span class="cratedetailskillstreak">${$e7012959a8ce1722$var$getString("ui", 126)} ${$e7012959a8ce1722$var$getString("ui", $e7012959a8ce1722$var$sheenTable[specKit.s])}</span></p>
                    <img class="cratedetailsitemimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", 765)}" loading="lazy">
                    <img class="cratedetailskitimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", item.id)}" loading="lazy">
                    <div class="cratedetailsitembottom">
                    <p class="cratedetailsitemunboxed">${$e7012959a8ce1722$var$getString("ui", 53)} ${specKit.n} ${$e7012959a8ce1722$var$getString("ui", 54)}</p>
                    <div class="cratedetailsitemmarketbtns">
                    ${steamMarketUrl}<a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 198)}" data-tooltipstring="198" target="_blank" rel="noopener" href="${backpackUrl}"><i class="icon-backpacktf"></i></a><a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 199)}" data-tooltipstring="199" target="_blank" rel="noopener" href="${marketplaceUrl}"><i class="icon-marketplacetf"></i></a>
                    </div>
                    </div>
                    </div>`;
                }
                for (let proKit of saveObject.crates[crate1][bonusItemIndex].p){
                    urlOptions = {
                        item: item.id,
                        quality: "unique",
                        wear: 0,
                        kit: 3
                    };
                    steamMarketUrl = `<a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 197)}" data-tooltipstring="197" target="_blank" rel="noopener" href="${$e7012959a8ce1722$var$generateSteamMarketUrl(urlOptions)}"><i class="icon-steam"></i></a>`;
                    backpackUrl = $e7012959a8ce1722$var$generateBackpackTfUrl(urlOptions);
                    marketplaceUrl = $e7012959a8ce1722$var$generateMarketplaceTfUrl(urlOptions);
                    let itemName = $e7012959a8ce1722$var$getString("item", 766).replace("#ITEM#", $e7012959a8ce1722$var$getString("item", item.id)).replace('The ', '');
                    tempHTML += `<div class="bordercolor colorunique">
                    <p class="cratedetailsitemname">${itemName}<br>
                    <span class="cratedetailskillstreak">${$e7012959a8ce1722$var$getString("ui", 126)} ${$e7012959a8ce1722$var$getString("ui", $e7012959a8ce1722$var$sheenTable[proKit.s])}<br>
                    ${$e7012959a8ce1722$var$getString("ui", 127)} ${$e7012959a8ce1722$var$getString("ui", $e7012959a8ce1722$var$killstreakerTable[proKit.k])}</span></p>
                    <img class="cratedetailsitemimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", 766)}" loading="lazy">
                    <img class="cratedetailskitimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", item.id)}" loading="lazy">
                    <div class="cratedetailsitembottom">
                    <p class="cratedetailsitemunboxed">${$e7012959a8ce1722$var$getString("ui", 53)} ${proKit.n} ${$e7012959a8ce1722$var$getString("ui", 54)}</p>
                    <div class="cratedetailsitemmarketbtns">
                    ${steamMarketUrl}<a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 198)}" data-tooltipstring="198" target="_blank" rel="noopener" href="${backpackUrl}"><i class="icon-backpacktf"></i></a><a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 199)}" data-tooltipstring="199" target="_blank" rel="noopener" href="${marketplaceUrl}"><i class="icon-marketplacetf"></i></a>
                    </div>
                    </div>
                    </div>`;
                }
            } else {
                if (saveObject.crates[crate1][bonusItemIndex].n === 0 && !$e7012959a8ce1722$var$showAllItems) continue;
                urlOptions = {
                    item: item.id,
                    quality: "strangifier",
                    wear: 0
                };
                steamMarketUrl = `<a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 197)}" data-tooltipstring="197" target="_blank" rel="noopener" href="${$e7012959a8ce1722$var$generateSteamMarketUrl(urlOptions)}"><i class="icon-steam"></i></a>`;
                backpackUrl = $e7012959a8ce1722$var$generateBackpackTfUrl(urlOptions);
                marketplaceUrl = $e7012959a8ce1722$var$generateMarketplaceTfUrl(urlOptions);
                let itemImg = `<img class="cratedetailsitemimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", 452)}" loading="lazy">`;
                let kitImg = `<img class="cratedetailskitimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", item.id)}" loading="lazy">`;
                let itemName = $e7012959a8ce1722$var$getString("item", 452).replace("#ITEM#", $e7012959a8ce1722$var$getString("item", item.id)).replace('The ', '');
                tempHTML += `<div class="bordercolor colorunique">
                    <p class="cratedetailsitemname">${itemName}</p>
                    ${itemImg}${kitImg}
                    <div class="cratedetailsitembottom">
                    <p class="cratedetailsitemunboxed">${$e7012959a8ce1722$var$getString("ui", 53)} ${saveObject.crates[crate1][bonusItemIndex].n} ${$e7012959a8ce1722$var$getString("ui", 54)}</p>
                    <div class="cratedetailsitemmarketbtns">
                    ${steamMarketUrl}<a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 198)}" data-tooltipstring="198" target="_blank" rel="noopener" href="${backpackUrl}"><i class="icon-backpacktf"></i></a><a class="btn tooltiptop" data-tooltip="${$e7012959a8ce1722$var$getString("ui", 199)}" data-tooltipstring="199" target="_blank" rel="noopener" href="${marketplaceUrl}"><i class="icon-marketplacetf"></i></a>
                    </div>
                    </div>
                    </div>`;
            }
        }
        if (el === undefined) {
            htmlEl.image.src = `./images/crate/${$e7012959a8ce1722$var$getImg("crate", (0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[crate1].id)}`;
            htmlEl.title.innerHTML = `<p>${$e7012959a8ce1722$var$getString("crate", (0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[crate1].id)}</p>
        <p>${$e7012959a8ce1722$var$getSeries((0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[crate1].series)}</p>`;
            let stats = `<p>${$e7012959a8ce1722$var$getString("ui", 53)} ${saveObject.crateStats[crate1].n} ${$e7012959a8ce1722$var$getString("ui", 54)}</p>`;
            if (saveObject.crateStats[crate1].u != undefined) stats += `<p>${$e7012959a8ce1722$var$getString("ui", 40)} ${saveObject.crateStats[crate1].u}</p>`;
            if (saveObject.crateStats[crate1].b != undefined) stats += `<p>${$e7012959a8ce1722$var$getString("ui", 143)} ${saveObject.crateStats[crate1].b}</p>`;
            htmlEl.crateStats.innerHTML = stats;
        }
    }
    htmlEl.content.removeAttribute("class");
    htmlEl.content.classList.add(gridClass);
    htmlEl.content.innerHTML = tempHTML;
    htmlEl.content.querySelectorAll("[data-quality]").forEach((item)=>{
        const itemImage = item.parentElement.parentElement.querySelector(".cratedetailsitemimg");
        const originalSrc = itemImage.src;
        item.addEventListener("pointerenter", function() {
            itemImage.src = `./images/item/skins/${item.dataset.quality}${originalSrc.substring(originalSrc.lastIndexOf("/BS") + 3)}`;
        });
    });
}
// Keyboard events
document.addEventListener('keydown', function(event) {
    if ($e7012959a8ce1722$var$DOM.main.crateWindow.classList.contains("showsearch") && event.code == 'Enter') $e7012959a8ce1722$var$selectFirstCrateFromSearch();
    else if (event.code == 'Enter' || event.code == 'Space') {
        if (!$e7012959a8ce1722$var$unboxStop && $e7012959a8ce1722$var$canUnbox && $e7012959a8ce1722$var$inDetailsMode) {
            $e7012959a8ce1722$var$sound.play("btn");
            $e7012959a8ce1722$var$exitGridView();
            $e7012959a8ce1722$var$beginUnbox();
        }
        return 0;
    } else if (event.code == "ArrowLeft" || event.code == "KeyA") {
        if (!$e7012959a8ce1722$var$unboxStop && $e7012959a8ce1722$var$canUnbox && $e7012959a8ce1722$var$inDetailsMode) {
            $e7012959a8ce1722$var$sound.play("btn");
            $e7012959a8ce1722$var$jumpToCrate("previous");
        }
    } else if (event.code == "ArrowRight" || event.code == "KeyD") {
        if (!$e7012959a8ce1722$var$unboxStop && $e7012959a8ce1722$var$canUnbox && $e7012959a8ce1722$var$inDetailsMode) {
            $e7012959a8ce1722$var$sound.play("btn");
            $e7012959a8ce1722$var$jumpToCrate("next");
        }
    }
});
// Languages
let $e7012959a8ce1722$var$language = "eng";
const $e7012959a8ce1722$var$dataObj = {
    "item": (0, $393df7a6c81f1387$export$b808efe4d9fd6ed7),
    "crate": (0, $171d92d71d8943db$export$6483fd36607ee9f2),
    "effect": (0, $c53c4707280d53b6$export$f0ce432f9ace41f0),
    "ui": (0, $d1e5a223d1ff5d82$export$a665a64cc334a157)
};
function $e7012959a8ce1722$var$getString(type, id) {
    if ($e7012959a8ce1722$var$dataObj[type][id][$e7012959a8ce1722$var$language] == undefined) {
        if ($e7012959a8ce1722$var$dataObj[type][id].eng != undefined) return $e7012959a8ce1722$var$dataObj[type][id].eng;
        else return "Invalid name! Please report this";
    } else return $e7012959a8ce1722$var$dataObj[type][id][$e7012959a8ce1722$var$language];
}
function $e7012959a8ce1722$var$getEngString(type, id) {
    return $e7012959a8ce1722$var$dataObj[type][id].eng;
}
function $e7012959a8ce1722$var$getImg(type, id) {
    return $e7012959a8ce1722$var$dataObj[type][id].img + $e7012959a8ce1722$var$imageSupport;
}
function $e7012959a8ce1722$var$getSchema(type, id) {
    return $e7012959a8ce1722$var$dataObj[type][id].schema;
}
function $e7012959a8ce1722$var$getSchema2(type, id) {
    if ($e7012959a8ce1722$var$dataObj[type][id].schema2 != undefined) return $e7012959a8ce1722$var$dataObj[type][id].schema2;
    else return false;
}
function $e7012959a8ce1722$var$getCrateSchema(id) {
    return (0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[id].schema;
}
let $e7012959a8ce1722$var$strangeStringPosition = "left"; // Whether the "Strange" string in item names should appear before or after the item name
function $e7012959a8ce1722$var$changeLanguage(lang) {
    $e7012959a8ce1722$var$language = lang;
    localStorage.setItem("unboxertf-languagechanged", "true");
    $e7012959a8ce1722$var$unusualsGenerated = false;
    document.querySelectorAll("[data-string]").forEach((item)=>{
        item.innerHTML = $e7012959a8ce1722$var$getString("ui", item.dataset.string);
    });
    document.querySelectorAll("[data-tooltipstring]").forEach((item)=>{
        item.dataset.tooltip = $e7012959a8ce1722$var$getString("ui", item.dataset.tooltipstring);
    });
    document.querySelectorAll("[data-placeholderstring]").forEach((item)=>{
        item.placeholder = $e7012959a8ce1722$var$getString("ui", item.dataset.placeholderstring);
    });
    $e7012959a8ce1722$var$DOM.stats.statistics.tab.innerHTML = $e7012959a8ce1722$var$getString("ui", $e7012959a8ce1722$var$DOM.stats.statistics.container.querySelector(".statvisible").dataset.statstring);
    switch(lang){
        case "pol":
            $e7012959a8ce1722$var$strangeStringPosition = "right";
            break;
        default:
            $e7012959a8ce1722$var$strangeStringPosition = "left";
    }
    switch(lang){
        case "eng":
            document.documentElement.lang = "en";
            break;
        case "pol":
            document.documentElement.lang = "pl";
            break;
        case "fre":
            document.documentElement.lang = "fr";
            break;
        case "sch":
            document.documentElement.lang = "zh-Hans";
            break;
        case "bra":
            document.documentElement.lang = "pt-BR";
            break;
        case "cze":
            document.documentElement.lang = "cs";
            break;
        case "hun":
            document.documentElement.lang = "hu";
            break;
        case "rom":
            document.documentElement.lang = "ro";
            break;
        case "swe":
            document.documentElement.lang = "sv";
            break;
        case "fil":
            document.documentElement.lang = "fil";
            break;
    }
    $e7012959a8ce1722$var$jumpToCrate($e7012959a8ce1722$var$currentCrate);
    if ($e7012959a8ce1722$var$DOM.main.crateGrid.innerHTML != "") $e7012959a8ce1722$var$generateGrid();
    if ($e7012959a8ce1722$var$crateStatsGenerated) {
        $e7012959a8ce1722$var$crateStatsGenerated = false;
        $e7012959a8ce1722$var$generateCrateStats();
    }
}
// Crate series
function $e7012959a8ce1722$var$getSeries(id) {
    if (id == 0) return $e7012959a8ce1722$var$getString("ui", 76);
    else return $e7012959a8ce1722$var$getString("ui", 75).replace("(NUM)", id);
}
var $3ad72e936daea491$exports = {};
$3ad72e936daea491$exports = $parcel$resolve("3CDMC");


var $a4b3385cba6c2077$exports = {};
$a4b3385cba6c2077$exports = $parcel$resolve("lU8aV");


var $f7dfe3ecbf222e28$exports = {};
$f7dfe3ecbf222e28$exports = $parcel$resolve("r7kyJ");


var $1ce86aed1c81d9c0$exports = {};
$1ce86aed1c81d9c0$exports = $parcel$resolve("8AMeq");


var $76f933a0894edc41$exports = {};
$76f933a0894edc41$exports = $parcel$resolve("5Ad3H");


var $a1fe591f444cde69$exports = {};
$a1fe591f444cde69$exports = $parcel$resolve("dNH0R");


var $8b198ff90fb2dd61$exports = {};
$8b198ff90fb2dd61$exports = $parcel$resolve("02eJc");


// Sound
const $e7012959a8ce1722$var$sound = {
    btn: new Audio(new URL($3ad72e936daea491$exports)),
    btnRelease: new Audio(new URL($a4b3385cba6c2077$exports)),
    crateOpen: new Audio(new URL($f7dfe3ecbf222e28$exports)),
    winterCrateOpen: new Audio(new URL($1ce86aed1c81d9c0$exports)),
    roboCrateOpen: new Audio(new URL($76f933a0894edc41$exports)),
    unboxed: new Audio(new URL($a1fe591f444cde69$exports)),
    unusualUnboxed: new Audio(new URL($8b198ff90fb2dd61$exports)),
    play: (id)=>{
        if ($e7012959a8ce1722$var$save.options.muteSound) return;
        if ($e7012959a8ce1722$var$sound[id].paused) $e7012959a8ce1722$var$sound[id].play();
        else $e7012959a8ce1722$var$sound[id].currentTime = 0;
    }
};
$e7012959a8ce1722$var$DOM.main.muteSoundBtn.addEventListener("click", ()=>{
    if (!$e7012959a8ce1722$var$save.options.muteSound) {
        $e7012959a8ce1722$var$save.options.muteSound = true;
        $e7012959a8ce1722$var$DOM.main.muteSoundBtn.innerHTML = '<i class="icon-mute"></i>';
        localStorage.setItem("unboxertf-options", JSON.stringify($e7012959a8ce1722$var$save.options));
    } else {
        $e7012959a8ce1722$var$save.options.muteSound = false;
        $e7012959a8ce1722$var$DOM.main.muteSoundBtn.innerHTML = '<i class="icon-speaker"></i>';
        localStorage.setItem("unboxertf-options", JSON.stringify($e7012959a8ce1722$var$save.options));
        $e7012959a8ce1722$var$sound.play("btnRelease");
    }
});
for (let el of document.getElementsByClassName("btn")){
    el.addEventListener("pointerdown", ()=>{
        if (!el.classList.contains("btndisabled")) $e7012959a8ce1722$var$sound.play("btn");
    });
    el.addEventListener("click", ()=>{
        if (!el.classList.contains("btndisabled")) $e7012959a8ce1722$var$sound.play("btnRelease");
    });
}
// Previous/next crate buttons
function $e7012959a8ce1722$var$jumpToCrate(param, firstLoad = false) {
    switch(param){
        case "next":
            if ($e7012959a8ce1722$var$currentCrate == (0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f).length - 1]) $e7012959a8ce1722$var$currentCrate = 0;
            else $e7012959a8ce1722$var$currentCrate += 1;
            break;
        case "previous":
            if ($e7012959a8ce1722$var$currentCrate == 0) $e7012959a8ce1722$var$currentCrate = (0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f).length - 1];
            else $e7012959a8ce1722$var$currentCrate -= 1;
            break;
        case "random":
            $e7012959a8ce1722$var$currentCrate = Math.floor(Math.random() * ((0, $923c9e0e4e96ee85$export$43b46fa232650b2f).length - 1)) + 1;
            break;
        default:
            $e7012959a8ce1722$var$currentCrate = param;
            break;
    }
    $e7012959a8ce1722$var$currentCrateObj = (0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]];
    if (!firstLoad) {
        let urlOptions = {
            crate: $e7012959a8ce1722$var$currentCrateObj.id,
            unboxerCrate: (0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate],
            series: $e7012959a8ce1722$var$currentCrateObj.series,
            quality: "unique",
            wear: 0
        };
        if (urlOptions.crate == 57 || // Winter 2016 case
        urlOptions.crate >= 34 && urlOptions.crate <= 42 || // Unlocked Creepy Crates
        urlOptions.crate >= 72 && urlOptions.crate <= 81 // Unlocked Cosmetic Crates
        ) urlOptions.uncraftable = true;
        $e7012959a8ce1722$var$DOM.main.crateName.innerHTML = $e7012959a8ce1722$var$getString("crate", $e7012959a8ce1722$var$currentCrateObj.id);
        $e7012959a8ce1722$var$DOM.main.series.innerHTML = $e7012959a8ce1722$var$getSeries($e7012959a8ce1722$var$currentCrateObj.series);
        $e7012959a8ce1722$var$DOM.main.img.src = "./images/crate/" + $e7012959a8ce1722$var$getImg("crate", $e7012959a8ce1722$var$currentCrateObj.id);
        $e7012959a8ce1722$var$DOM.main.lootList.innerHTML = "";
        $e7012959a8ce1722$var$DOM.main.effectsList.innerHTML = "";
        $e7012959a8ce1722$var$DOM.main.crateSteamMarketBtn.href = $e7012959a8ce1722$var$generateSteamMarketUrl(urlOptions);
        $e7012959a8ce1722$var$DOM.main.crateBptfBtn.href = $e7012959a8ce1722$var$generateBackpackTfUrl(urlOptions);
        if ($e7012959a8ce1722$var$availableOnCrateTf(urlOptions)) {
            $e7012959a8ce1722$var$DOM.main.crateCratetfBtn.href = $e7012959a8ce1722$var$generateCrateTfUrl(urlOptions);
            $e7012959a8ce1722$var$DOM.main.crateCratetfBtn.classList.remove("btndisabled");
        } else {
            $e7012959a8ce1722$var$DOM.main.crateCratetfBtn.removeAttribute("href");
            $e7012959a8ce1722$var$DOM.main.crateCratetfBtn.classList.add("btndisabled");
        }
        $e7012959a8ce1722$var$generateLootList();
        $e7012959a8ce1722$var$generateEffectList();
    }
}
$e7012959a8ce1722$var$DOM.main.nextCrateBtn.addEventListener("click", ()=>{
    $e7012959a8ce1722$var$jumpToCrate("next");
});
$e7012959a8ce1722$var$DOM.main.previousCrateBtn.addEventListener("click", ()=>{
    $e7012959a8ce1722$var$jumpToCrate("previous");
});
// Generate loot list
function $e7012959a8ce1722$var$generateLootList() {
    let html = [];
    for (let item of $e7012959a8ce1722$var$currentCrateObj.loot){
        let itemClass = "";
        let itemName = "";
        switch(item.quality){
            case 11:
                itemName = $e7012959a8ce1722$var$getString("item", 764).replace("#ITEM#", $e7012959a8ce1722$var$getString("item", item.id));
                itemName = itemName.replace('The ', '');
                break;
            case 12:
                itemName = $e7012959a8ce1722$var$getString("item", 452).replace("#ITEM#", $e7012959a8ce1722$var$getString("item", item.id));
                itemName = itemName.replace('The ', '');
                break;
            default:
                itemName = $e7012959a8ce1722$var$getString("item", item.id);
        }
        if ($e7012959a8ce1722$var$gradeTable[item.grade] != 0) itemClass = ` class="${$e7012959a8ce1722$var$gradeTable[item.grade]}"`;
        html.push(`<li${itemClass}>${itemName}</li>`);
    }
    if ($e7012959a8ce1722$var$currentCrateObj.unusual === 1) html.push(`<li class="unusualloot">${$e7012959a8ce1722$var$getString("ui", 74)}</li>`);
    $e7012959a8ce1722$var$DOM.main.lootList.innerHTML = html.join('');
    let bonusHTML = [];
    if ($e7012959a8ce1722$var$currentCrateObj.bonus) bonusHTML.push(`<p>${$e7012959a8ce1722$var$getString("ui", 147)}</p>`);
    if ($e7012959a8ce1722$var$currentCrateObj.exclusiveBonus) {
        bonusHTML.push(`<p>${$e7012959a8ce1722$var$getString("ui", 148)}</p><ul>`);
        for (let bonusItem of $e7012959a8ce1722$var$currentCrateObj.exclusiveBonus.loot)bonusHTML.push(`<li>${$e7012959a8ce1722$var$getString("item", bonusItem)}</li>`);
        bonusHTML.push("</ul>");
    }
    if ($e7012959a8ce1722$var$currentCrateObj.creepyBonus) {
        bonusHTML.push(`<p>${$e7012959a8ce1722$var$getString("ui", 148)}</p><ul>`);
        for (let bonusItem of (0, $923c9e0e4e96ee85$export$dd394babd3967010))if (bonusItem.quality == 12) bonusHTML.push(`<li>${$e7012959a8ce1722$var$getString("item", 452).replace("#ITEM#", $e7012959a8ce1722$var$getString("item", bonusItem.id)).replace('The ', '')}</li>`);
        else bonusHTML.push(`<li>${$e7012959a8ce1722$var$getString("item", 764).replace("#ITEM#", $e7012959a8ce1722$var$getString("item", bonusItem.id)).replace('The ', '')}</li>`);
        bonusHTML.push("</ul>");
    }
    $e7012959a8ce1722$var$DOM.main.lootBonus.innerHTML = bonusHTML.join('');
    if ($e7012959a8ce1722$var$currentCrateObj.note > 0) $e7012959a8ce1722$var$DOM.main.lootNote.innerHTML = $e7012959a8ce1722$var$getString("ui", $e7012959a8ce1722$var$currentCrateObj.note);
    else $e7012959a8ce1722$var$DOM.main.lootNote.innerHTML = "";
}
// Generate effect list
function $e7012959a8ce1722$var$generateEffectList() {
    let html = [];
    let effectsArray;
    if (![
        "none",
        null,
        undefined
    ].includes($e7012959a8ce1722$var$save.options.halloweenMode) && (0, $923c9e0e4e96ee85$export$ba9ca3d1b9c67713)[$e7012959a8ce1722$var$save.options.halloweenMode].includes($e7012959a8ce1722$var$currentCrate)) switch($e7012959a8ce1722$var$save.options.halloweenMode){
        case "hw11":
            effectsArray = (0, $923c9e0e4e96ee85$export$fcfd2f8245a0c72b);
            break;
        case "hw12":
            effectsArray = (0, $923c9e0e4e96ee85$export$efdb3cea0ec18a0e);
            break;
        case "hw13":
            effectsArray = (0, $923c9e0e4e96ee85$export$daa7f6f4c59cb124);
            break;
        case "hw14":
            effectsArray = (0, $923c9e0e4e96ee85$export$7ed6475de6021fb1);
            break;
        case "hw16":
            effectsArray = (0, $923c9e0e4e96ee85$export$a1fdcf29c390e2ff);
            break;
        case "hw17":
            effectsArray = (0, $923c9e0e4e96ee85$export$479ea04ee3735415);
            break;
        case "hw18":
            effectsArray = (0, $923c9e0e4e96ee85$export$d7cc75ae001f49bb);
            break;
        case "hw19":
            effectsArray = (0, $923c9e0e4e96ee85$export$87cb2b63d48546e5);
            break;
        case "hw20":
            effectsArray = (0, $923c9e0e4e96ee85$export$dbe6de95c084ac0b);
            break;
        case "hw21":
            effectsArray = (0, $923c9e0e4e96ee85$export$38414dd56dd1142f);
            break;
        case "hw22":
            effectsArray = (0, $923c9e0e4e96ee85$export$4af39f2718c7dd8c);
            break;
        case "hw23":
            effectsArray = (0, $923c9e0e4e96ee85$export$6341f1ffae36f6e1);
            break;
        case "hw24":
            effectsArray = (0, $923c9e0e4e96ee85$export$67f97e3ea05d86cd);
            break;
        case "hw25":
            effectsArray = (0, $923c9e0e4e96ee85$export$bf8344a3e5db3ea9);
            break;
        case "hw26":
            effectsArray = (0, $923c9e0e4e96ee85$export$531bb3e137492ac6);
            break;
        case "xmas19":
            effectsArray = (0, $923c9e0e4e96ee85$export$c317c9865986caea);
            break;
        case "xmas20":
            effectsArray = (0, $923c9e0e4e96ee85$export$678a0e6ea5e17d);
            break;
        case "xmas21":
            effectsArray = (0, $923c9e0e4e96ee85$export$a5ca802835f1e521);
            break;
        case "xmas22":
            effectsArray = (0, $923c9e0e4e96ee85$export$5d2fb103389bf3ce);
            break;
        case "xmas23":
            effectsArray = (0, $923c9e0e4e96ee85$export$8f8d26fc356f0f89);
            break;
        case "xmas24":
            effectsArray = (0, $923c9e0e4e96ee85$export$488be7bbcbddddcb);
            break;
        case "xmas25":
            effectsArray = (0, $923c9e0e4e96ee85$export$fee703f8270b19bf);
            break;
        case "summer23":
            effectsArray = (0, $923c9e0e4e96ee85$export$77cd6f67ebed231f);
            break;
        case "summer24":
            effectsArray = (0, $923c9e0e4e96ee85$export$6418d71abfdb50e1);
            break;
        case "summer25":
            effectsArray = (0, $923c9e0e4e96ee85$export$78afa2b74c302149);
            break;
        case "summer26":
            effectsArray = (0, $923c9e0e4e96ee85$export$5fd569f55a6c2fd0);
            break;
    }
    else effectsArray = $e7012959a8ce1722$var$currentCrateObj.effects;
    for(let i = 0; i < effectsArray.length; i++)html.push(`<li>${$e7012959a8ce1722$var$getString("effect", effectsArray[i])}</li>`);
    $e7012959a8ce1722$var$DOM.main.effectsList.innerHTML = html.join('');
    if (effectsArray.length > 0) $e7012959a8ce1722$var$DOM.main.effectsTitle.innerHTML = $e7012959a8ce1722$var$getString("ui", 31);
    else $e7012959a8ce1722$var$DOM.main.effectsTitle.innerHTML = $e7012959a8ce1722$var$getString("ui", 32);
}
function $e7012959a8ce1722$var$crateHasUnusual(crate1) {
    if (crate1.loot[crate1.loot.length - 1].id == 0) return true;
    else return false;
}
function $e7012959a8ce1722$var$crateHasRandomStranges(crate1) {
    let result = false;
    for (let item of crate1.loot)if ([
        4,
        6,
        8,
        9,
        10
    ].includes(item.quality)) {
        result = true;
        break;
    }
    return result;
}
/* Generate Steam Market / backpack.tf / marketplace.tf URLs for items
Parameters:

item - item id
effect - unusual effect
quality - item quality
wear - item wear
kit - killstreak kit level
kitItem - item for strangifier/killstreak kit/unusualifier
*/ function $e7012959a8ce1722$var$generateSteamMarketUrl(arg) {
    if (arg.quality == undefined) arg.quality = "";
    let steamUrlItemName = '';
    if (arg.crate) steamUrlItemName = `${$e7012959a8ce1722$var$getEngString("crate", arg.crate)}`;
    else steamUrlItemName = `${$e7012959a8ce1722$var$getEngString("item", arg.item).replace("| ", "")}`;
    if (arg.kit) {
        switch(arg.kit){
            case 1:
                steamUrlItemName = $e7012959a8ce1722$var$getEngString("item", 764).replace("#ITEM#", $e7012959a8ce1722$var$getEngString("item", arg.item));
                break;
            case 2:
                steamUrlItemName = $e7012959a8ce1722$var$getEngString("item", 765).replace("#ITEM#", $e7012959a8ce1722$var$getEngString("item", arg.item));
                break;
            case 3:
                steamUrlItemName = $e7012959a8ce1722$var$getEngString("item", 766).replace("#ITEM#", $e7012959a8ce1722$var$getEngString("item", arg.item));
                break;
        }
        steamUrlItemName = steamUrlItemName.replace('The ', '');
    } else if (arg.quality == "strangifier") {
        steamUrlItemName = $e7012959a8ce1722$var$getEngString("item", 452).replace("#ITEM#", $e7012959a8ce1722$var$getEngString("item", arg.item));
        steamUrlItemName = steamUrlItemName.replace('The ', '');
    } else if (arg.item == 770) {
        steamUrlItemName = steamUrlItemName.replace("#ITEM#", $e7012959a8ce1722$var$getEngString("item", arg.kitItem));
        steamUrlItemName = steamUrlItemName.replace('The ', '');
    }
    if (arg.quality.includes("unusual")) {
        steamUrlItemName = "Unusual " + steamUrlItemName;
        steamUrlItemName = steamUrlItemName.replace('The ', '');
    }
    if (arg.quality.includes("haunted")) {
        steamUrlItemName = "Haunted " + steamUrlItemName;
        steamUrlItemName = steamUrlItemName.replace('The ', '');
    }
    if (arg.quality.includes("strange")) {
        steamUrlItemName = "Strange " + steamUrlItemName;
        steamUrlItemName = steamUrlItemName.replace('The ', '');
    }
    if (arg.wear && arg.wear != 0) steamUrlItemName += ` (${$e7012959a8ce1722$var$getEngString("ui", $e7012959a8ce1722$var$wearTableNames[arg.wear])})`;
    return encodeURI(`https://steamcommunity.com/market/listings/440/${steamUrlItemName}`);
}
function $e7012959a8ce1722$var$generateBackpackTfUrl(arg) {
    let bpItemName = '';
    if (arg.crate) bpItemName = `${$e7012959a8ce1722$var$getEngString("crate", arg.crate)}`;
    else bpItemName = `${$e7012959a8ce1722$var$getEngString("item", arg.item).replace("| ", "")}`;
    if (arg.item == 770) bpItemName = bpItemName.replace("#ITEM# ", "");
    else if (arg.wear && arg.wear != 0) bpItemName += ` (${$e7012959a8ce1722$var$getEngString("ui", $e7012959a8ce1722$var$wearTableNames[arg.wear])})`;
    else if (arg.quality == "strangifier") bpItemName = $e7012959a8ce1722$var$getEngString("item", 452).replace("#ITEM# ", "");
    else if (arg.kit) switch(arg.kit){
        case 1:
            bpItemName = $e7012959a8ce1722$var$getEngString("item", 764).replace("#ITEM# ", "");
            break;
        case 2:
            bpItemName = $e7012959a8ce1722$var$getEngString("item", 765).replace("#ITEM# ", "");
            break;
        case 3:
            bpItemName = $e7012959a8ce1722$var$getEngString("item", 766).replace("#ITEM# ", "");
            break;
    }
    if (!arg.crate) bpItemName = bpItemName.replace("War Paint", "| War Paint");
    let bpQuality = "";
    switch(arg.quality){
        case "unusual":
        case "unusualunique":
            bpQuality = "Unusual";
            break;
        case "strangeunusual":
        case "unusualstrange":
            bpQuality = "Strange Unusual";
            break;
        case "strange":
            bpQuality = "Strange";
            break;
        case "haunted":
            bpQuality = "Haunted";
            break;
        case "strangehaunted":
            bpQuality = "Strange Haunted";
            break;
        case "unique":
        case "strangifier":
            if (arg.wear != 0) bpQuality = "Decorated Weapon";
            else bpQuality = "Unique";
            break;
        default:
            if (arg.wear != 0) bpQuality = "Decorated Weapon";
            else console.warn(`Unknown Bptf quality: ${arg.quality}`);
    }
    let bpCraftable = "Craftable";
    if (arg.uncraftable || arg.item == 770 || arg.kit) bpCraftable = "Non-Craftable";
    let bpEffect;
    if (arg.item == 770) bpEffect = $e7012959a8ce1722$var$getSchema("item", arg.kitItem);
    else if (arg.quality.includes("unusual")) bpEffect = $e7012959a8ce1722$var$getSchema("effect", arg.effect);
    else if (arg.quality == "strangifier") bpEffect = $e7012959a8ce1722$var$getSchema("item", arg.item);
    else bpEffect = "";
    let bpKit;
    if (arg.kit) bpKit = `${arg.kit}-${$e7012959a8ce1722$var$getSchema("item", arg.item)}`;
    else bpKit = "";
    let bpUrl = `${bpQuality}/${bpItemName}/Tradable/${bpCraftable}/${bpEffect}${bpKit}`;
    return encodeURI(`https://backpack.tf/stats/${bpUrl}`);
}
// schema1 / quality / effect / uncraftable / kitlevel / kititem / wear / schema2
function $e7012959a8ce1722$var$generateSKU(arg, delimiter = ";") {
    let itemId;
    if (arg.quality == "strangifier") {
        itemId = $e7012959a8ce1722$var$getSchema2("item", arg.item);
        if (itemId === false) itemId = $e7012959a8ce1722$var$getSchema("item", 452);
    } else if (arg.kit) switch(arg.kit){
        case 1:
            itemId = $e7012959a8ce1722$var$getSchema("item", 764);
            break;
        case 2:
            itemId = $e7012959a8ce1722$var$getSchema("item", 765);
            break;
        case 3:
            itemId = $e7012959a8ce1722$var$getSchema("item", 766);
            break;
    }
    else if (arg.unboxerCrate !== null && arg.unboxerCrate !== undefined) itemId = $e7012959a8ce1722$var$getCrateSchema(arg.unboxerCrate);
    else itemId = $e7012959a8ce1722$var$getSchema("item", arg.item);
    let quality;
    switch(arg.quality){
        case "unusual":
        case "strangeunusual":
        case "unusualstrange":
        case "unusualunique":
            quality = 5;
            break;
        case "unique":
        case "strangifier":
            quality = 6;
            break;
        case "strange":
            quality = 11;
            break;
        case "haunted":
        case "strangehaunted":
            quality = 13;
            break;
        default:
            if (arg.wear && arg.wear != 0) quality = 15;
            else console.warn("Unknown SKU quality: " + arg.quality);
    }
    let effect = "";
    if (arg.effect != undefined) effect = `u${$e7012959a8ce1722$var$getSchema("effect", arg.effect)}${delimiter}`;
    let wear = "";
    if (arg.wear && arg.wear != 0) wear = `w${arg.wear}${delimiter}`;
    let extraQuality = "";
    if ([
        5,
        13,
        15
    ].includes(quality) && arg.quality.includes("strange")) extraQuality = `strange${delimiter}`;
    let craftable = "";
    if (arg.uncraftable || arg.kit || arg.item == 770) craftable = `uncraftable${delimiter}`;
    let kitLevel = "";
    switch(arg.kit){
        case 1:
        case 2:
        case 3:
            kitLevel = `kt-${arg.kit}${delimiter}`;
            break;
    }
    let kitItem = "";
    if (arg.kit || arg.quality == "strangifier") kitItem = `td-${$e7012959a8ce1722$var$getSchema("item", arg.item)};`;
    else if (arg.kitItem) kitItem = `td-${$e7012959a8ce1722$var$getSchema("item", arg.kitItem)};`;
    let wpId = "";
    if (arg.wear && arg.wear != 0) {
        wpId = $e7012959a8ce1722$var$getSchema2("item", arg.item);
        if (wpId === false) wpId = `pk${$e7012959a8ce1722$var$getSchema("item", arg.item).toString().slice(-3)}`;
        else wpId = `pk${wpId}`;
    }
    let series = "";
    if (arg.series) series = `c${arg.series}${delimiter}`;
    let sku = `${itemId}${delimiter}${quality}${delimiter}${effect}${craftable}${wear}${wpId}${extraQuality}${kitLevel}${kitItem}${series}`;
    if (sku[sku.length - 1] == delimiter) sku = sku.slice(0, -1);
    return sku;
}
function $e7012959a8ce1722$var$generateMarketplaceTfUrl(arg) {
    return encodeURI(`https://marketplace.tf/items/tf2/${$e7012959a8ce1722$var$generateSKU(arg)}`);
}
function $e7012959a8ce1722$var$generateCrateTfUrl(arg) {
    return encodeURI(`https://crate.tf/item/${$e7012959a8ce1722$var$generateSKU(arg, '-')}?r=unboxer&utm_source=unboxer.tf`);
}
function $e7012959a8ce1722$var$availableOnCrateTf(arg) {
    if (arg.crate >= 34 && arg.crate <= 42 || // Unlocked Creepy Crates
    arg.crate >= 72 && arg.crate <= 80 || // Unlocked Cosmetic Crates (except Multiclass)
    arg.crate === 63 || // Decorated War Hero War Paint case
    arg.crate === 64 || // Contract Campaigner War Paint case
    arg.crate === 32 // Bread Box
    ) return false;
    return true;
}
// Unboxing code
function $e7012959a8ce1722$var$unbox() {
    let randomNumber, unusualRandomNumber, itemId, itemWear, itemEffect, itemKillstreak, bonusDrops, cratePos;
    let itemQuality = [];
    const crate1 = $e7012959a8ce1722$var$currentCrateObj;
    randomNumber = Math.floor(Math.random() * 10000 + 1); // Between 1 and 10000
    unusualRandomNumber = Math.floor(Math.random() * 150 + 1) // Between 1 and 150
    ;
    let tempNumber = 0;
    // Select item from crate
    let crateItem;
    if (crate1.unusual && (unusualRandomNumber === 1 || $e7012959a8ce1722$var$save.options.forceUnusual)) {
        // Item is a random unusual. Pick a random unusual, then assign Unusual (and Strange if applicable) qualities
        let unusualArray = [];
        switch(crate1.unusual){
            case 1:
                unusualArray = (0, $923c9e0e4e96ee85$export$43cbf05ac7bc87ec).slice();
                if ($e7012959a8ce1722$var$currentCrate === 96 && $e7012959a8ce1722$var$save.options.eotlGlitch) unusualArray = unusualArray.concat((0, $923c9e0e4e96ee85$export$97338bf46fad8d5d));
                if ($e7012959a8ce1722$var$currentCrateObj.series >= 1 && $e7012959a8ce1722$var$currentCrateObj.series <= 55 && $e7012959a8ce1722$var$save.options.sniperVsSpyUnusuals) unusualArray = unusualArray.concat((0, $923c9e0e4e96ee85$export$828ca659e1638c64));
                if ($e7012959a8ce1722$var$currentCrateObj.series >= 1 && $e7012959a8ce1722$var$currentCrateObj.series <= 102 && $e7012959a8ce1722$var$save.options.miscUnusuals) unusualArray = unusualArray.concat((0, $923c9e0e4e96ee85$export$40df5ace82dd8ebd));
                if ($e7012959a8ce1722$var$currentCrateObj.series === 89) unusualArray = unusualArray.concat((0, $923c9e0e4e96ee85$export$c19bf1bf46c6afa8));
                else if ($e7012959a8ce1722$var$currentCrateObj.series === 86) unusualArray = unusualArray.concat((0, $923c9e0e4e96ee85$export$e281edce0be87230));
                itemId = unusualArray[Math.floor(Math.random() * unusualArray.length)];
                if ((0, $923c9e0e4e96ee85$export$c19bf1bf46c6afa8).includes(itemId)) {
                    let qualityRandomNumber = Math.floor(Math.random() * 10 + 1); // Between 1 and 10
                    if (qualityRandomNumber == 10 || $e7012959a8ce1722$var$save.options.forceStrange) itemQuality.push("strange");
                }
                crateItem = {
                    id: itemId,
                    quality: null
                };
                break;
            case 2:
                let gradeRandom;
                if ($e7012959a8ce1722$var$save.options.forceGrade) gradeRandom = $e7012959a8ce1722$var$save.options.forceGradeNum;
                else {
                    gradeRandom = Math.floor(Math.random() * 1000 + 1); // Between 1 and 1000
                    if (gradeRandom <= 8) gradeRandom = 6;
                    else if (gradeRandom <= 40) gradeRandom = 5;
                    else if (gradeRandom <= 200) gradeRandom = 4;
                    else gradeRandom = 3;
                }
                while(unusualArray.length === 0){
                    unusualArray = crate1.loot.filter((item)=>{
                        return [
                            6,
                            7,
                            9,
                            10
                        ].includes(item.quality) && item.grade == gradeRandom;
                    });
                    if ($e7012959a8ce1722$var$save.options.miscUnusuals && $e7012959a8ce1722$var$currentCrate === 105 && gradeRandom === 4) unusualArray.push(crate1.loot[5]) // Captain Space Mann
                    ;
                    if (gradeRandom <= 2) throw new Error;
                    gradeRandom--;
                }
                crateItem = unusualArray[Math.floor(Math.random() * unusualArray.length)];
                itemId = crateItem.id;
                break;
            case 3:
                unusualArray = crate1.loot.filter((item)=>{
                    return [
                        6,
                        7,
                        9,
                        10
                    ].includes(item.quality);
                });
                crateItem = unusualArray[Math.floor(Math.random() * unusualArray.length)];
                itemId = crateItem.id;
                break;
        }
        itemQuality.push("unusual");
    } else // Unbox something else
    switch(crate1.autoChance){
        case 1:
            let gradeRandom;
            if ($e7012959a8ce1722$var$save.options.forceGrade) gradeRandom = $e7012959a8ce1722$var$save.options.forceGradeNum;
            else {
                gradeRandom = Math.floor(Math.random() * 1000 + 1); // Between 1 and 1000
                if (gradeRandom <= 8) gradeRandom = 6;
                else if (gradeRandom <= 40) gradeRandom = 5;
                else if (gradeRandom <= 200) gradeRandom = 4;
                else gradeRandom = 3;
                if (crate1.loot[0].grade === 1) gradeRandom -= 2;
            }
            let itemPool = [];
            while(itemPool.length === 0){
                itemPool = crate1.loot.filter((item)=>{
                    return item.grade == gradeRandom;
                });
                if (gradeRandom <= 0) throw new Error;
                gradeRandom--;
            }
            let randomItemNumber = Math.floor(Math.random() * itemPool.length); // Between 0 and itemPool.length - 1
            crateItem = itemPool[randomItemNumber];
            cratePos = crate1.loot.findIndex((it)=>{
                return it.id == crateItem.id;
            });
            break;
        case 2:
            let randomItemNumber2 = Math.floor(Math.random() * crate1.loot.length); // Between 0 and crate.loot.length - 1
            crateItem = crate1.loot[randomItemNumber2];
            cratePos = randomItemNumber2;
            break;
        default:
            randomNumber = Math.floor(Math.random() * 9900 + 1);
            for(const item in crate1.loot)if (randomNumber > tempNumber && randomNumber <= tempNumber + crate1.loot[item].chance) {
                crateItem = crate1.loot[item]; // Create a copy of the item we unboxed. Otherwise, we may end up modifying the item in the crate
                cratePos = item;
                break;
            } else tempNumber += crate1.loot[item].chance;
    }
    itemId = crateItem.id;
    // Handle random unusual items and item qualities
    let generateWear = false;
    if (crateItem.quality != null) {
        // Item is not a random unusual. Assign quality
        let qualityRandomNumber;
        switch(crateItem.quality){
            case 0:
                itemQuality.push("unusual");
                break;
            case 1:
            case 7:
                itemQuality.push("unique");
                break;
            case 2:
                itemQuality.push("strange");
                break;
            case 3:
                itemQuality.push("haunted");
                break;
            case 4:
            case 9:
            case 10:
                qualityRandomNumber = Math.floor(Math.random() * 10 + 1); // Between 1 and 10
                if (qualityRandomNumber == 10 || $e7012959a8ce1722$var$save.options.forceStrange) itemQuality.push("strange");
                else itemQuality.push("unique");
                break;
            case 5:
                generateWear = true;
                break;
            case 6:
                generateWear = true;
                qualityRandomNumber = Math.floor(Math.random() * 10 + 1); // Between 1 and 10
                if (qualityRandomNumber == 10 || $e7012959a8ce1722$var$save.options.forceStrange) itemQuality.push("strange");
                break;
            case 8:
                qualityRandomNumber = Math.floor(Math.random() * 10 + 1); // Between 1 and 10
                if (qualityRandomNumber == 10 || $e7012959a8ce1722$var$save.options.forceStrange) itemQuality.push("strange", "haunted");
                else itemQuality.push("unique");
                break;
            case 11:
                itemQuality.push("unique");
                itemKillstreak = {
                    sheen: null,
                    killstreaker: null
                };
                qualityRandomNumber = Math.floor(Math.random() * 100 + 1);
                if (qualityRandomNumber > 65 || $e7012959a8ce1722$var$save.options.forceProKit) // Pick sheen
                itemKillstreak.sheen = Math.floor(Math.random() * ($e7012959a8ce1722$var$sheenTable.length - 1) + 1);
                if (qualityRandomNumber > 90 || $e7012959a8ce1722$var$save.options.forceProKit) // Pick killstreaker
                itemKillstreak.killstreaker = Math.floor(Math.random() * ($e7012959a8ce1722$var$killstreakerTable.length - 1) + 1);
                break;
            case 12:
                itemQuality.push("strangifier");
                break;
        }
    }
    if (itemQuality.length === 1) itemQuality = itemQuality[0];
    else itemQuality = itemQuality.join("");
    // Wear
    itemWear = 0;
    if (generateWear) {
        let randomWear = Math.floor(Math.random() * 10 + 1);
        switch(randomWear){
            case 1:
                itemWear = 1;
                break;
            case 2:
            case 3:
                itemWear = 2;
                break;
            case 4:
            case 5:
            case 6:
            case 7:
                itemWear = 3;
                break;
            case 8:
            case 9:
                itemWear = 4;
                break;
            case 10:
                itemWear = 5;
                break;
        }
    }
    // Unusual effect
    itemEffect = 0;
    if (itemQuality.includes("unusual")) {
        let effectsArray;
        if (![
            "none",
            null,
            undefined
        ].includes($e7012959a8ce1722$var$save.options.halloweenMode) && (0, $923c9e0e4e96ee85$export$ba9ca3d1b9c67713)[$e7012959a8ce1722$var$save.options.halloweenMode].includes($e7012959a8ce1722$var$currentCrate)) switch($e7012959a8ce1722$var$save.options.halloweenMode){
            case "hw11":
                effectsArray = (0, $923c9e0e4e96ee85$export$fcfd2f8245a0c72b);
                break;
            case "hw12":
                effectsArray = (0, $923c9e0e4e96ee85$export$efdb3cea0ec18a0e);
                break;
            case "hw13":
                effectsArray = (0, $923c9e0e4e96ee85$export$daa7f6f4c59cb124);
                break;
            case "hw14":
                effectsArray = (0, $923c9e0e4e96ee85$export$7ed6475de6021fb1);
                break;
            case "hw16":
                effectsArray = (0, $923c9e0e4e96ee85$export$a1fdcf29c390e2ff);
                break;
            case "hw17":
                effectsArray = (0, $923c9e0e4e96ee85$export$479ea04ee3735415);
                break;
            case "hw18":
                effectsArray = (0, $923c9e0e4e96ee85$export$d7cc75ae001f49bb);
                break;
            case "hw19":
                effectsArray = (0, $923c9e0e4e96ee85$export$87cb2b63d48546e5);
                break;
            case "hw20":
                effectsArray = (0, $923c9e0e4e96ee85$export$dbe6de95c084ac0b);
                break;
            case "hw21":
                effectsArray = (0, $923c9e0e4e96ee85$export$38414dd56dd1142f);
                break;
            case "hw22":
                effectsArray = (0, $923c9e0e4e96ee85$export$4af39f2718c7dd8c);
                break;
            case "hw23":
                effectsArray = (0, $923c9e0e4e96ee85$export$6341f1ffae36f6e1);
                break;
            case "hw24":
                effectsArray = (0, $923c9e0e4e96ee85$export$67f97e3ea05d86cd);
                break;
            case "hw25":
                effectsArray = (0, $923c9e0e4e96ee85$export$bf8344a3e5db3ea9);
                break;
            case "hw26":
                effectsArray = (0, $923c9e0e4e96ee85$export$531bb3e137492ac6);
                break;
            case "xmas19":
                effectsArray = (0, $923c9e0e4e96ee85$export$c317c9865986caea);
                break;
            case "xmas20":
                effectsArray = (0, $923c9e0e4e96ee85$export$678a0e6ea5e17d);
                break;
            case "xmas21":
                effectsArray = (0, $923c9e0e4e96ee85$export$a5ca802835f1e521);
                break;
            case "xmas22":
                effectsArray = (0, $923c9e0e4e96ee85$export$5d2fb103389bf3ce);
                break;
            case "xmas23":
                effectsArray = (0, $923c9e0e4e96ee85$export$8f8d26fc356f0f89);
                break;
            case "xmas24":
                effectsArray = (0, $923c9e0e4e96ee85$export$488be7bbcbddddcb);
                break;
            case "xmas25":
                effectsArray = (0, $923c9e0e4e96ee85$export$fee703f8270b19bf);
                break;
            case "summer23":
                effectsArray = (0, $923c9e0e4e96ee85$export$77cd6f67ebed231f);
                break;
            case "summer24":
                effectsArray = (0, $923c9e0e4e96ee85$export$6418d71abfdb50e1);
                break;
            case "summer25":
                effectsArray = (0, $923c9e0e4e96ee85$export$78afa2b74c302149);
                break;
            case "summer26":
                effectsArray = (0, $923c9e0e4e96ee85$export$5fd569f55a6c2fd0);
                break;
        }
        else {
            effectsArray = crate1.effects;
            // If unboxing an Unusual robohat from the Robo Community Crate, add 1st, 2nd and 3rd gen effects to effect pool
            if ($e7012959a8ce1722$var$currentCrateObj.series === 58) {
                for (let item of $e7012959a8ce1722$var$currentCrateObj.loot)if (itemId === item.id) effectsArray = effectsArray.concat((0, $923c9e0e4e96ee85$export$d4f00319c000ebd9));
            }
        }
        itemEffect = effectsArray[Math.floor(Math.random() * effectsArray.length)];
    }
    // Bonus drops
    bonusDrops = [];
    if (crate1.bonus) {
        let bonusNum = 0;
        if ($e7012959a8ce1722$var$save.options.forceBonusItem) bonusNum = 3;
        else {
            bonusNum = 0;
            let bonusChance = Math.floor(Math.random() * 5 + 1); // Between 1 and 5
            if (bonusChance <= 2 || $e7012959a8ce1722$var$save.options.forceBonusItem) {
                bonusNum++;
                bonusChance = Math.floor(Math.random() * 5 + 1) // Between 1 and 5
                ;
                if (bonusChance == 1) {
                    bonusNum++;
                    bonusChance = Math.floor(Math.random() * 25 + 1) // Between 1 and 25
                    ;
                    if (bonusChance == 1) bonusNum++;
                }
            }
        }
        let oneExclusiveBonusUnboxed = false;
        for(; bonusNum > 0; bonusNum--){
            let unusualifierChance = Math.floor(Math.random() * 1000 + 1) // Between 1 and 1000
            ;
            if (unusualifierChance <= 10 || $e7012959a8ce1722$var$save.options.forceUnusualifier) {
                // Unbox unusualifier
                let randomTaunt = Math.floor(Math.random() * (0, $923c9e0e4e96ee85$export$46565d5461ea95ac).length);
                bonusDrops.push({
                    id: 770,
                    taunt: (0, $923c9e0e4e96ee85$export$46565d5461ea95ac)[randomTaunt]
                });
            } else {
                let unboxExclusive = false;
                if (crate1.exclusiveBonus && !oneExclusiveBonusUnboxed) {
                    let exclusiveBonusChance = Math.floor(Math.random() * 10000 + 1) // Between 1 and 10000
                    ;
                    if (exclusiveBonusChance <= crate1.exclusiveBonus.chance) {
                        unboxExclusive = true;
                        if (crate1.oneExclusiveBonus) oneExclusiveBonusUnboxed = true;
                    }
                }
                if (unboxExclusive) {
                    // Case exclusive bonus drop
                    let randomBonus = Math.floor(Math.random() * crate1.exclusiveBonus.loot.length);
                    bonusDrops.push({
                        id: crate1.exclusiveBonus.loot[randomBonus]
                    });
                } else {
                    // Global bonus drop
                    let randomBonus = Math.floor(Math.random() * (0, $923c9e0e4e96ee85$export$10dc550ff6f20217).length);
                    switch((0, $923c9e0e4e96ee85$export$10dc550ff6f20217)[randomBonus]){
                        case "paint":
                            bonusDrops.push({
                                id: (0, $923c9e0e4e96ee85$export$823717ebc7f69446)[Math.floor(Math.random() * (0, $923c9e0e4e96ee85$export$823717ebc7f69446).length)]
                            });
                            break;
                        case "strangepart":
                            bonusDrops.push({
                                id: (0, $923c9e0e4e96ee85$export$d74038d209dbd599)[Math.floor(Math.random() * (0, $923c9e0e4e96ee85$export$d74038d209dbd599).length)]
                            });
                            break;
                        default:
                            bonusDrops.push({
                                id: (0, $923c9e0e4e96ee85$export$10dc550ff6f20217)[randomBonus]
                            });
                            break;
                    }
                }
            }
        }
    } else if (crate1.exclusiveBonus) {
        let exclusiveBonusChance = Math.floor(Math.random() * 10000 + 1) // Between 1 and 10000
        ;
        if (exclusiveBonusChance <= crate1.exclusiveBonus.chance || $e7012959a8ce1722$var$save.options.forceBonusItem) {
            let randomBonus = Math.floor(Math.random() * crate1.exclusiveBonus.loot.length);
            bonusDrops.push({
                id: crate1.exclusiveBonus.loot[randomBonus]
            });
        }
    }
    if (crate1.creepyBonus) {
        let bonusChance = Math.floor(Math.random() * 50 + 1) // Between 1 and 50
        ;
        if (bonusChance === 1 || $e7012959a8ce1722$var$save.options.forceBonusItem) {
            let randomBonus = Math.floor(Math.random() * (0, $923c9e0e4e96ee85$export$dd394babd3967010).length);
            let itemKillstreak;
            if ((0, $923c9e0e4e96ee85$export$dd394babd3967010)[randomBonus].quality === 11) {
                itemKillstreak = {
                    sheen: null,
                    killstreaker: null
                };
                let randomKillstreak = Math.floor(Math.random() * 100 + 1);
                if (randomKillstreak > 65 || $e7012959a8ce1722$var$save.options.forceProKit) // Pick sheen
                itemKillstreak.sheen = Math.floor(Math.random() * ($e7012959a8ce1722$var$sheenTable.length - 1) + 1);
                if (randomKillstreak > 90 || $e7012959a8ce1722$var$save.options.forceProKit) // Pick killstreaker
                itemKillstreak.killstreaker = Math.floor(Math.random() * ($e7012959a8ce1722$var$killstreakerTable.length - 1) + 1);
            }
            bonusDrops.push({
                id: (0, $923c9e0e4e96ee85$export$dd394babd3967010)[randomBonus].id,
                quality: (0, $923c9e0e4e96ee85$export$dd394babd3967010)[randomBonus].quality,
                killstreak: itemKillstreak
            });
        }
    }
    // Return item
    return {
        id: itemId,
        cratePos: cratePos,
        name: $e7012959a8ce1722$var$getString("item", itemId),
        quality: itemQuality,
        wear: itemWear,
        grade: crateItem.grade,
        effect: itemEffect,
        killstreak: itemKillstreak,
        bonus: bonusDrops
    };
}
let $e7012959a8ce1722$var$unboxStop = false;
let $e7012959a8ce1722$var$pause = false;
function $e7012959a8ce1722$var$beginUnbox() {
    if ($e7012959a8ce1722$var$unboxStop) return 0;
    let unboxResult = $e7012959a8ce1722$var$unbox();
    if (unboxResult === undefined) return 0; // Stop function here
    let soundToPlay = "unboxed";
    // Pause unboxing at certain items
    function pauseUnboxing() {
        $e7012959a8ce1722$var$pause = $e7012959a8ce1722$var$unboxStop = true;
        $e7012959a8ce1722$var$DOM.results.returnBtn.classList.add("btndisabled");
        $e7012959a8ce1722$var$DOM.results.unboxBtn.classList.add("btndisabled");
        setTimeout(()=>{
            $e7012959a8ce1722$var$DOM.results.returnBtn.classList.remove("btndisabled");
            $e7012959a8ce1722$var$DOM.results.unboxBtn.classList.remove("btndisabled");
            $e7012959a8ce1722$var$unboxStop = false;
        }, 3000);
    }
    $e7012959a8ce1722$var$pause = false;
    for (let check of $e7012959a8ce1722$var$save.options.stopAtItem){
        switch(check){
            case "unusual":
                if (unboxResult.quality.includes("unusual")) pauseUnboxing();
                break;
            case "tauntunusualifier":
                for (let bonusItem of unboxResult.bonus)if (bonusItem.id === 770) {
                    pauseUnboxing();
                    break;
                }
                break;
            case "strange":
                if (unboxResult.quality.includes("strange")) pauseUnboxing();
                break;
            case "prokit":
                if (unboxResult.killstreak && unboxResult.killstreak.killstreaker != null) pauseUnboxing();
                break;
            case "bonusitem":
                if (unboxResult.bonus.length === 3) pauseUnboxing();
                break;
            case "grademercenary":
                if (unboxResult.grade === 3) pauseUnboxing();
                break;
            case "gradecommando":
                if (unboxResult.grade === 4) pauseUnboxing();
                break;
            case "gradeassassin":
                if (unboxResult.grade === 5) pauseUnboxing();
                break;
            case "gradeelite":
                if (unboxResult.grade === 6) pauseUnboxing();
                break;
        }
        if ($e7012959a8ce1722$var$pause) break;
    }
    if (unboxResult.quality.includes("unusual")) soundToPlay = "unusualUnboxed";
    else {
        for (let bonusItem of unboxResult.bonus)if (bonusItem.id === 770) {
            soundToPlay = "unusualUnboxed";
            break;
        }
    }
    if ($e7012959a8ce1722$var$save.options.fastUnbox) {
        // If fast unboxing is on, just show the result screen instantly
        showResults();
        $e7012959a8ce1722$var$DOM.main.container.style.display = "none";
        $e7012959a8ce1722$var$DOM.results.container.style.display = "block";
        $e7012959a8ce1722$var$sound.play(soundToPlay);
    } else {
        // Otherwise, play crate sound, display unbox animation, and when it's finished, show result screen
        $e7012959a8ce1722$var$canUnbox = false;
        switch((0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]){
            case 57:
                $e7012959a8ce1722$var$sound.play("roboCrateOpen");
                break;
            case 114:
            case 122:
            case 127:
            case 140:
            case 145:
            case 150:
            case 154:
            case 158:
                $e7012959a8ce1722$var$sound.play("winterCrateOpen");
                break;
            default:
                $e7012959a8ce1722$var$sound.play("crateOpen");
        }
        $e7012959a8ce1722$var$DOM.unboxing.container.style.display = "block";
        // Dot animation
        let dotAnimPos = 2;
        $e7012959a8ce1722$var$DOM.unboxing.dots.innerHTML = ".";
        let dotAnimation = setInterval(function() {
            switch(dotAnimPos){
                case 0:
                    $e7012959a8ce1722$var$DOM.unboxing.dots.innerHTML = "&nbsp;";
                    dotAnimPos += 1;
                    break;
                case 1:
                    $e7012959a8ce1722$var$DOM.unboxing.dots.innerHTML = ".";
                    dotAnimPos += 1;
                    break;
                case 2:
                    $e7012959a8ce1722$var$DOM.unboxing.dots.innerHTML = "..";
                    dotAnimPos += 1;
                    break;
                case 3:
                    $e7012959a8ce1722$var$DOM.unboxing.dots.innerHTML = "...";
                    dotAnimPos = 0;
                    break;
            }
        }, 500);
        // Countdown
        let secondsUntilUnbox = 5;
        $e7012959a8ce1722$var$DOM.unboxing.countdown.innerHTML = secondsUntilUnbox;
        let uncratingCountdown = setInterval(function() {
            secondsUntilUnbox -= 1;
            $e7012959a8ce1722$var$DOM.unboxing.countdown.innerHTML = secondsUntilUnbox;
            if (secondsUntilUnbox == 0) {
                showResults();
                $e7012959a8ce1722$var$DOM.main.container.style.display = "none";
                $e7012959a8ce1722$var$DOM.unboxing.container.style.display = "none";
                $e7012959a8ce1722$var$DOM.results.container.style.display = "block";
                clearInterval(dotAnimation);
                clearInterval(uncratingCountdown);
                $e7012959a8ce1722$var$canUnbox = true;
                $e7012959a8ce1722$var$sound.play(soundToPlay);
            }
        }, 1000);
    }
    function showResults() {
        $e7012959a8ce1722$var$DOM.results.lootName.removeAttribute("class");
        $e7012959a8ce1722$var$DOM.results.effectImg.src = $e7012959a8ce1722$var$emptyImage;
        $e7012959a8ce1722$var$DOM.results.kitField.innerHTML = "";
        let completeLootName = unboxResult.name;
        if (unboxResult.wear) {
            completeLootName += ` (${$e7012959a8ce1722$var$getString("ui", $e7012959a8ce1722$var$wearTableNames[unboxResult.wear])})`;
            $e7012959a8ce1722$var$DOM.results.lootImg.src = `./images/item/skins/${$e7012959a8ce1722$var$wearTable[unboxResult.wear]}${$e7012959a8ce1722$var$getImg("item", unboxResult.id)}`;
            $e7012959a8ce1722$var$DOM.results.kitImg.src = $e7012959a8ce1722$var$emptyImage;
        } else if (unboxResult.killstreak) {
            if (unboxResult.killstreak.killstreaker) {
                completeLootName = $e7012959a8ce1722$var$getString("item", 766).replace("#ITEM#", completeLootName);
                $e7012959a8ce1722$var$DOM.results.lootImg.src = `./images/item/${$e7012959a8ce1722$var$getImg("item", 766)}`;
                $e7012959a8ce1722$var$DOM.results.kitField.innerHTML = `${$e7012959a8ce1722$var$getString("ui", 127)} ${$e7012959a8ce1722$var$getString("ui", $e7012959a8ce1722$var$killstreakerTable[unboxResult.killstreak.killstreaker])}
      <br>${$e7012959a8ce1722$var$getString("ui", 126)} ${$e7012959a8ce1722$var$getString("ui", $e7012959a8ce1722$var$sheenTable[unboxResult.killstreak.sheen])}`;
            } else if (unboxResult.killstreak.sheen) {
                completeLootName = $e7012959a8ce1722$var$getString("item", 765).replace("#ITEM#", completeLootName);
                $e7012959a8ce1722$var$DOM.results.lootImg.src = `./images/item/${$e7012959a8ce1722$var$getImg("item", 765)}`;
                $e7012959a8ce1722$var$DOM.results.kitField.innerHTML = `${$e7012959a8ce1722$var$getString("ui", 126)} ${$e7012959a8ce1722$var$getString("ui", $e7012959a8ce1722$var$sheenTable[unboxResult.killstreak.sheen])}`;
            } else {
                completeLootName = $e7012959a8ce1722$var$getString("item", 764).replace("#ITEM#", completeLootName);
                $e7012959a8ce1722$var$DOM.results.lootImg.src = `./images/item/${$e7012959a8ce1722$var$getImg("item", 764)}`;
            }
            completeLootName = completeLootName.replace('The ', '');
            $e7012959a8ce1722$var$DOM.results.kitImg.src = `./images/item/${$e7012959a8ce1722$var$getImg("item", unboxResult.id)}`;
        } else if (unboxResult.quality == "strangifier") {
            completeLootName = $e7012959a8ce1722$var$getString("item", 452).replace("#ITEM#", completeLootName);
            completeLootName = completeLootName.replace('The ', '');
            $e7012959a8ce1722$var$DOM.results.lootImg.src = `./images/item/${$e7012959a8ce1722$var$getImg("item", 452)}`;
            $e7012959a8ce1722$var$DOM.results.kitImg.src = `./images/item/${$e7012959a8ce1722$var$getImg("item", unboxResult.id)}`;
        } else {
            $e7012959a8ce1722$var$DOM.results.lootImg.src = `./images/item/${$e7012959a8ce1722$var$getImg("item", unboxResult.id)}`;
            $e7012959a8ce1722$var$DOM.results.kitImg.src = $e7012959a8ce1722$var$emptyImage;
        }
        if (unboxResult.effect) {
            $e7012959a8ce1722$var$DOM.results.effectImg.src = `./images/effect/${$e7012959a8ce1722$var$getImg("effect", unboxResult.effect)}`;
            $e7012959a8ce1722$var$DOM.results.effectField.style.display = "block";
            $e7012959a8ce1722$var$DOM.results.effectName.innerHTML = $e7012959a8ce1722$var$getString("effect", unboxResult.effect);
        } else $e7012959a8ce1722$var$DOM.results.effectField.style.display = "none";
        let tempQualityName = [];
        if (unboxResult.grade) {
            // Item has grade
            $e7012959a8ce1722$var$DOM.results.lootName.classList.add($e7012959a8ce1722$var$gradeTable[unboxResult.grade]);
            if (unboxResult.quality.includes("strange")) {
                if (unboxResult.wear) $e7012959a8ce1722$var$DOM.results.kitField.innerHTML = `<span class="colorstrange">${$e7012959a8ce1722$var$getString("ui", 157)}</span>`;
                else tempQualityName.push(`<span class="colorstrange">(${$e7012959a8ce1722$var$getString("ui", 71)})</span>`);
            }
            if (unboxResult.quality.includes("unusual")) tempQualityName.push(`<span class="colorunusual">(${$e7012959a8ce1722$var$getString("ui", 73)})</span>`);
        } else // Item has no grade
        if (unboxResult.quality.includes("unusual")) {
            // Item is unusual
            $e7012959a8ce1722$var$DOM.results.lootName.classList.add("colorunusual");
            completeLootName = completeLootName.replace('The ', '');
            if (unboxResult.quality.includes("strange")) tempQualityName.push(`<span class="colorstrange">(${$e7012959a8ce1722$var$getString("ui", 71)})</span>`);
            tempQualityName.push(`(${$e7012959a8ce1722$var$getString("ui", 73)})`);
        } else {
            // Item is not unusual
            if (unboxResult.quality.includes("haunted")) {
                $e7012959a8ce1722$var$DOM.results.lootName.classList.add("colorhaunted");
                completeLootName = completeLootName.replace('The ', '');
                if (unboxResult.quality.includes("strange")) tempQualityName.push(`(${$e7012959a8ce1722$var$getString("ui", 71)})`);
                tempQualityName.push(`(${$e7012959a8ce1722$var$getString("ui", 72)})`);
            } else if (unboxResult.quality.includes("strange")) {
                $e7012959a8ce1722$var$DOM.results.lootName.classList.add("colorstrange");
                completeLootName = completeLootName.replace('The ', '');
                tempQualityName.push(`(${$e7012959a8ce1722$var$getString("ui", 71)})`);
            } else // Item is not unusual or strange. So it must be unique
            $e7012959a8ce1722$var$DOM.results.lootName.classList.add("colorunique");
        }
        if ($e7012959a8ce1722$var$strangeStringPosition === "left") {
            for(let quality in tempQualityName)if (typeof tempQualityName[quality] === 'string' || tempQualityName[quality] instanceof String) tempQualityName[quality] = tempQualityName[quality].replace("(", "").replace(")", "");
            $e7012959a8ce1722$var$DOM.results.lootName.innerHTML = `${tempQualityName.join(" ")} ${completeLootName}`;
        } else $e7012959a8ce1722$var$DOM.results.lootName.innerHTML = `${completeLootName} ${tempQualityName.join(" ")}`;
        // Show bonus items
        $e7012959a8ce1722$var$DOM.results.bonusItemContainer.removeAttribute("class");
        if ($e7012959a8ce1722$var$currentCrateObj.bonus || $e7012959a8ce1722$var$currentCrateObj.creepyBonus || $e7012959a8ce1722$var$currentCrateObj.exclusiveBonus) {
            $e7012959a8ce1722$var$DOM.results.bonusContainer.style.display = "block";
            if (unboxResult.bonus.length > 0) {
                let bonusHTML = "";
                for (let bonusItem of unboxResult.bonus){
                    if (bonusItem.taunt != undefined) bonusHTML += `<div class="unusual"><img src="./images/item/${$e7012959a8ce1722$var$getImg("item", bonusItem.id)}">
                    <img class="unusualifierimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", bonusItem.taunt)}">
                <div class="bonustooltip colorunusual">${$e7012959a8ce1722$var$getString("item", bonusItem.id).replace("#ITEM#", $e7012959a8ce1722$var$getString("item", bonusItem.taunt))}</div>
                </div>`;
                    else if (bonusItem.killstreak != undefined) {
                        let killstreakImg;
                        let itemName;
                        if (bonusItem.killstreak.killstreaker != undefined) {
                            killstreakImg = $e7012959a8ce1722$var$getImg("item", 766);
                            itemName = $e7012959a8ce1722$var$getString("item", 766);
                        } else if (bonusItem.killstreak.sheen != undefined) {
                            killstreakImg = $e7012959a8ce1722$var$getImg("item", 765);
                            itemName = $e7012959a8ce1722$var$getString("item", 765);
                        } else {
                            killstreakImg = $e7012959a8ce1722$var$getImg("item", 764);
                            itemName = $e7012959a8ce1722$var$getString("item", 764);
                        }
                        itemName = itemName.replace("#ITEM#", $e7012959a8ce1722$var$getString("item", bonusItem.id)).replace('The ', '');
                        bonusHTML += `<div><img src="./images/item/${killstreakImg}">
                    <img class="kitimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", bonusItem.id)}">
                <div class="bonustooltip">${itemName}</div>
                </div>`;
                    } else if (bonusItem.quality === 12) bonusHTML += `<div><img src="./images/item/${$e7012959a8ce1722$var$getImg("item", 452)}">
                    <img class="kitimg" src="./images/item/${$e7012959a8ce1722$var$getImg("item", bonusItem.id)}">
                <div class="bonustooltip">${$e7012959a8ce1722$var$getString("item", 452).replace("#ITEM#", $e7012959a8ce1722$var$getString("item", bonusItem.id)).replace('The ', '')}</div>
                </div>`;
                    else bonusHTML += `<div><img src="./images/item/${$e7012959a8ce1722$var$getImg("item", bonusItem.id)}">
                <div class="bonustooltip">${$e7012959a8ce1722$var$getString("item", bonusItem.id)}</div>
                </div>`;
                }
                $e7012959a8ce1722$var$DOM.results.bonusItemContainer.classList.add(`i${unboxResult.bonus.length}`);
                $e7012959a8ce1722$var$DOM.results.bonusItemContainer.innerHTML = bonusHTML;
                document.querySelectorAll(".bonustooltip").forEach((el)=>{
                    [
                        "pointerover",
                        "click"
                    ].forEach((evt)=>{
                        el.parentNode.addEventListener(evt, ()=>{
                            let tooltipPos = el.getBoundingClientRect();
                            if (tooltipPos.x < 0 || tooltipPos.x + el.clientWidth > window.innerWidth) el.style.whiteSpace = "initial";
                            else {
                                el.style.whiteSpace = "nowrap";
                                tooltipPos = el.getBoundingClientRect();
                                if (tooltipPos.x < 0 || tooltipPos.x + el.clientWidth > window.innerWidth) el.style.whiteSpace = "initial";
                            }
                        });
                    });
                });
            } else $e7012959a8ce1722$var$DOM.results.bonusItemContainer.innerHTML = `<span id="lootbonusnone">${$e7012959a8ce1722$var$getString("ui", 145)}</span>`;
        } else $e7012959a8ce1722$var$DOM.results.bonusContainer.style.display = "none";
        // Update market links
        let urlOptions = {
            item: unboxResult.id,
            quality: unboxResult.quality,
            wear: unboxResult.wear
        };
        if (unboxResult.quality.includes("unusual")) urlOptions.effect = unboxResult.effect;
        if (unboxResult.killstreak) {
            if (unboxResult.killstreak.killstreaker) urlOptions.kit = 3;
            else if (unboxResult.killstreak.sheen) urlOptions.kit = 2;
            else urlOptions.kit = 1;
        }
        if ([
            764,
            765,
            766,
            452
        ].includes(unboxResult.id)) urlOptions.kitItem = unboxResult.effect;
        if (unboxResult.quality != "unique" || unboxResult.grade != 0 || unboxResult.killstreak != null || (0, $923c9e0e4e96ee85$export$10dc550ff6f20217).includes(unboxResult.id) || (0, $923c9e0e4e96ee85$export$823717ebc7f69446).includes(unboxResult.id) || (0, $923c9e0e4e96ee85$export$d74038d209dbd599).includes(unboxResult.id) || (0, $923c9e0e4e96ee85$export$5a1370e0815c8951).includes(unboxResult.id)) {
            $e7012959a8ce1722$var$DOM.results.steamMarketBtn.href = $e7012959a8ce1722$var$generateSteamMarketUrl(urlOptions);
            $e7012959a8ce1722$var$DOM.results.steamMarketBtn.classList.remove("btndisabled");
        } else {
            $e7012959a8ce1722$var$DOM.results.steamMarketBtn.removeAttribute("href");
            $e7012959a8ce1722$var$DOM.results.steamMarketBtn.classList.add("btndisabled");
        }
        $e7012959a8ce1722$var$DOM.results.bptfBtn.href = $e7012959a8ce1722$var$generateBackpackTfUrl(urlOptions);
        $e7012959a8ce1722$var$DOM.results.mptfBtn.href = $e7012959a8ce1722$var$generateMarketplaceTfUrl(urlOptions);
        if ($e7012959a8ce1722$var$save.options.forceUnusual || $e7012959a8ce1722$var$save.options.forceUnusualifier || $e7012959a8ce1722$var$save.options.forceStrange || $e7012959a8ce1722$var$save.options.forceGrade || $e7012959a8ce1722$var$save.options.forceProKit || $e7012959a8ce1722$var$save.options.forceBonusItem) $e7012959a8ce1722$var$DOM.results.statsContainer.style.display = "none";
        else {
            $e7012959a8ce1722$var$DOM.results.statsContainer.style.display = "flex";
            // Add items to save
            let itemNum = $e7012959a8ce1722$var$addToInventory(unboxResult, $e7012959a8ce1722$var$save, true);
            if ([
                "unusual",
                "unusualunique",
                "strangeunusual",
                "unusualstrange"
            ].includes(unboxResult.quality)) {
                $e7012959a8ce1722$var$DOM.results.statSinceLastUnusual.innerHTML = $e7012959a8ce1722$var$save.stats["unboxes-since-last-unusual"] + 1;
                $e7012959a8ce1722$var$addToUnusuals(unboxResult, $e7012959a8ce1722$var$save, true);
                $e7012959a8ce1722$var$addToStats(unboxResult, $e7012959a8ce1722$var$save, true);
                $e7012959a8ce1722$var$DOM.results.statTimesUnboxedDiv.style.display = "none";
                $e7012959a8ce1722$var$DOM.results.statUnusualsUnboxed.innerHTML = $e7012959a8ce1722$var$save.stats["unusual-unboxed"];
                $e7012959a8ce1722$var$DOM.results.statUnusualsUnboxedDiv.style.display = "block";
            } else {
                $e7012959a8ce1722$var$addToUnusuals(unboxResult, $e7012959a8ce1722$var$save, true);
                $e7012959a8ce1722$var$addToStats(unboxResult, $e7012959a8ce1722$var$save, true);
                if ($e7012959a8ce1722$var$currentCrateObj.unusual) $e7012959a8ce1722$var$DOM.results.statSinceLastUnusual.innerHTML = $e7012959a8ce1722$var$save.stats["unboxes-since-last-unusual"];
                $e7012959a8ce1722$var$DOM.results.statTimesUnboxed.innerHTML = itemNum;
                $e7012959a8ce1722$var$DOM.results.statTimesUnboxedDiv.style.display = "block";
                $e7012959a8ce1722$var$DOM.results.statUnusualsUnboxedDiv.style.display = "none";
            }
        }
    }
}
function $e7012959a8ce1722$var$addToInventory(unboxResult, saveObj, saveToStorage) {
    let itemNum;
    if (unboxResult.cratePos != null) switch($e7012959a8ce1722$var$currentCrateObj.loot[unboxResult.cratePos].quality){
        case 4:
        case 8:
        case 9:
        case 10:
            if ([
                "strange",
                "strangehaunted"
            ].includes(unboxResult.quality)) itemNum = saveObj.crates[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]][unboxResult.cratePos].q += 1;
            else itemNum = saveObj.crates[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]][unboxResult.cratePos].n += 1;
            break;
        case 5:
            itemNum = saveObj.crates[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]][unboxResult.cratePos][$e7012959a8ce1722$var$wearTable[unboxResult.wear]] += 1;
            break;
        case 6:
            if (unboxResult.quality === "strange") itemNum = saveObj.crates[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]][unboxResult.cratePos][`${$e7012959a8ce1722$var$wearTable[unboxResult.wear]}q`] += 1;
            else itemNum = saveObj.crates[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]][unboxResult.cratePos][$e7012959a8ce1722$var$wearTable[unboxResult.wear]] += 1;
            break;
        case 11:
            let found = false;
            if (unboxResult.killstreak.killstreaker) {
                for (let item of saveObj.crates[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]][unboxResult.cratePos].p)if (item.s === unboxResult.killstreak.sheen && item.p === unboxResult.killstreak.killstreaker) {
                    itemNum = item.n += 1;
                    found = true;
                    break;
                }
                if (!found) {
                    itemNum = 1;
                    saveObj.crates[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]][unboxResult.cratePos].p.push({
                        n: 1,
                        s: unboxResult.killstreak.sheen,
                        k: unboxResult.killstreak.killstreaker
                    });
                }
            } else if (unboxResult.killstreak.sheen) {
                for (let item of saveObj.crates[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]][unboxResult.cratePos].s)if (item.s === unboxResult.killstreak.sheen) {
                    itemNum = item.n += 1;
                    found = true;
                    break;
                }
                if (!found) {
                    itemNum = 1;
                    saveObj.crates[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]][unboxResult.cratePos].s.push({
                        n: 1,
                        s: unboxResult.killstreak.sheen
                    });
                }
            } else itemNum = saveObj.crates[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]][unboxResult.cratePos].n += 1;
            break;
        default:
            itemNum = saveObj.crates[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]][unboxResult.cratePos].n += 1;
    }
    for (let bonusItem of unboxResult.bonus){
        if ($e7012959a8ce1722$var$currentCrateObj.exclusiveBonus.loot != undefined && $e7012959a8ce1722$var$currentCrateObj.exclusiveBonus.loot.includes(bonusItem.id)) saveObj.crates[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]][$e7012959a8ce1722$var$currentCrateObj.loot.length + $e7012959a8ce1722$var$currentCrateObj.exclusiveBonus.loot.findIndex((arrayItem)=>{
            return arrayItem === bonusItem.id;
        })].n++;
        else if ($e7012959a8ce1722$var$currentCrateObj.creepyBonus) {
            let bonusItemPos = (0, $923c9e0e4e96ee85$export$dd394babd3967010).findIndex((arrayItem)=>{
                return arrayItem.id === bonusItem.id && arrayItem.quality === bonusItem.quality;
            });
            if (bonusItem.quality == 12 || bonusItem.killstreak != null && bonusItem.killstreak.sheen === null) saveObj.crates[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]][$e7012959a8ce1722$var$currentCrateObj.loot.length + bonusItemPos].n++;
            else if (bonusItem.killstreak.killstreaker === null) {
                let found = false;
                for (let item of saveObj.crates[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]][$e7012959a8ce1722$var$currentCrateObj.loot.length + bonusItemPos].s)if (item.s === bonusItem.killstreak.sheen) {
                    item.n += 1;
                    found = true;
                    break;
                }
                if (!found) saveObj.crates[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]][$e7012959a8ce1722$var$currentCrateObj.loot.length + bonusItemPos].s.push({
                    n: 1,
                    s: bonusItem.killstreak.sheen
                });
            } else {
                let found = false;
                for (let item of saveObj.crates[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]][$e7012959a8ce1722$var$currentCrateObj.loot.length + bonusItemPos].p)if (item.s === bonusItem.killstreak.sheen && item.p === bonusItem.killstreak.killstreaker) {
                    item.n += 1;
                    found = true;
                    break;
                }
                if (!found) saveObj.crates[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]][$e7012959a8ce1722$var$currentCrateObj.loot.length + bonusItemPos].p.push({
                    n: 1,
                    s: bonusItem.killstreak.sheen,
                    k: bonusItem.killstreak.killstreaker
                });
            }
        } else if (bonusItem.id != 770) {
            let found = false;
            for (let saveItem of saveObj.bonusItems)if (saveItem.i === bonusItem.id) {
                saveItem.n++;
                found = true;
                break;
            }
            if (!found) saveObj.bonusItems.push({
                i: bonusItem.id,
                n: 1
            });
        }
    }
    if (saveToStorage) {
        clearTimeout($e7012959a8ce1722$var$addToInventorySaveTimeout);
        $e7012959a8ce1722$var$addToInventorySaveTimeout = setTimeout(()=>{
            localStorage.setItem("unboxertf-crates", (0, $c15f83c001069282$export$df1e024253068afa).compressToUTF16(JSON.stringify($e7012959a8ce1722$var$save.crates)));
            localStorage.setItem("unboxertf-bonusitems", (0, $c15f83c001069282$export$df1e024253068afa).compressToUTF16(JSON.stringify($e7012959a8ce1722$var$save.bonusItems)));
            localStorage.setItem("unboxertf-save-format", 'lzstring');
        }, 2000);
    }
    return itemNum;
}
function $e7012959a8ce1722$var$addToUnusuals(unboxResult, saveObj, saveToStorage) {
    if (unboxResult.quality.includes("unusual")) {
        if ([
            "strange",
            "strangeunusual",
            "unusualstrange"
        ].includes(unboxResult.quality)) saveObj.unusuals.push([
            unboxResult.id,
            unboxResult.effect,
            1,
            unboxResult.wear
        ]);
        else saveObj.unusuals.push([
            unboxResult.id,
            unboxResult.effect,
            0,
            unboxResult.wear
        ]);
        if (saveToStorage) $e7012959a8ce1722$var$updateUnusualStats($e7012959a8ce1722$var$save.unusuals[$e7012959a8ce1722$var$save.unusuals.length - 1], true);
    }
    for (let bonusItem of unboxResult.bonus)if (bonusItem.id === 770) {
        saveObj.unusuals.push([
            bonusItem.id,
            bonusItem.taunt,
            0,
            0
        ]);
        if (saveToStorage) $e7012959a8ce1722$var$updateUnusualStats($e7012959a8ce1722$var$save.unusuals[$e7012959a8ce1722$var$save.unusuals.length - 1], true);
    }
    if (saveToStorage) {
        clearTimeout($e7012959a8ce1722$var$addToUnusualsSaveTimeout);
        $e7012959a8ce1722$var$addToUnusualsSaveTimeout = setTimeout(()=>{
            localStorage.setItem("unboxertf-unusuals", (0, $c15f83c001069282$export$df1e024253068afa).compressToUTF16(JSON.stringify($e7012959a8ce1722$var$save.unusuals)));
            localStorage.setItem("unboxertf-save-format", 'lzstring');
        }, 2000);
    }
}
function $e7012959a8ce1722$var$addToStats(unboxResult, saveObj, saveToStorage) {
    // Update stats
    saveObj.stats["crates-opened"] += 1;
    saveObj.stats["keys-money"] = (parseFloat(saveObj.stats["keys-money"]) + 2.49).toFixed(2);
    switch(unboxResult.quality){
        case "unique":
            saveObj.stats["unique-unboxed"] += 1;
            break;
        case "strange":
            saveObj.stats["strange-unboxed"] += 1;
            break;
        case "haunted":
            saveObj.stats["haunted-unboxed"] += 1;
            break;
        case "unusual":
        case "unusualunique":
            saveObj.stats["unusual-unboxed"] += 1;
            break;
        case "strangehaunted":
            saveObj.stats["strange-unboxed"] += 1;
            saveObj.stats["haunted-unboxed"] += 1;
            saveObj.stats["strangehaunted-unboxed"] += 1;
            break;
        case "strangeunusual":
        case "unusualstrange":
            saveObj.stats["strange-unboxed"] += 1;
            saveObj.stats["unusual-unboxed"] += 1;
            saveObj.stats["strangeunusual-unboxed"] += 1;
            break;
    }
    if (unboxResult.wear) saveObj.stats["decorated-unboxed"] += 1;
    if (unboxResult.grade) saveObj.stats["grade-unboxed"] += 1;
    switch(unboxResult.grade){
        case 1:
            saveObj.stats["civilian-unboxed"] += 1;
            break;
        case 2:
            saveObj.stats["freelance-unboxed"] += 1;
            break;
        case 3:
            saveObj.stats["mercenary-unboxed"] += 1;
            break;
        case 4:
            saveObj.stats["commando-unboxed"] += 1;
            break;
        case 5:
            saveObj.stats["assassin-unboxed"] += 1;
            break;
        case 6:
            saveObj.stats["elite-unboxed"] += 1;
            break;
    }
    switch(unboxResult.wear){
        case 1:
            saveObj.stats["factorynew-unboxed"] += 1;
            break;
        case 2:
            saveObj.stats["minimalwear-unboxed"] += 1;
            break;
        case 3:
            saveObj.stats["fieldtested-unboxed"] += 1;
            break;
        case 4:
            saveObj.stats["wellworn-unboxed"] += 1;
            break;
        case 5:
            saveObj.stats["battlescarred-unboxed"] += 1;
            break;
    }
    if ([
        "unusual",
        "unusualunique",
        "strangeunusual",
        "unusualstrange"
    ].includes(unboxResult.quality)) {
        if (saveObj.stats["unboxes-since-last-unusual"] < saveObj.stats["min-unusual-drought"] || saveObj.stats["min-unusual-drought"] === "N/A") saveObj.stats["min-unusual-drought"] = saveObj.stats["unboxes-since-last-unusual"];
        saveObj.crateStats[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]].u++;
        saveObj.stats["unusual-avg-array"].push(saveObj.stats["unboxes-since-last-unusual"]);
        let avg = 0;
        for (let num of saveObj.stats["unusual-avg-array"])avg += parseInt(num);
        saveObj.stats["unusual-avg"] = Math.round(avg / saveObj.stats["unusual-avg-array"].length);
        saveObj.stats["unusual-avgprice-array"].push((saveObj.stats["unboxes-since-last-unusual"] * 2.49).toFixed(2));
        avg = 0;
        for (let num of saveObj.stats["unusual-avgprice-array"])avg += parseFloat(num);
        saveObj.stats["unusual-avgprice"] = (avg / saveObj.stats["unusual-avg-array"].length).toFixed(2);
        saveObj.stats["unboxes-since-last-unusual"] = 0;
    } else if ($e7012959a8ce1722$var$currentCrateObj.unusual) {
        saveObj.stats["unboxes-since-last-unusual"] += 1;
        if (saveObj.stats["unboxes-since-last-unusual"] > saveObj.stats["max-unusual-drought"]) saveObj.stats["max-unusual-drought"] = saveObj.stats["unboxes-since-last-unusual"];
    }
    saveObj.stats["bonus-unboxed"] += unboxResult.bonus.length;
    if ($e7012959a8ce1722$var$currentCrateObj.unusual) saveObj.stats["unusual-chances"] += 1;
    if ($e7012959a8ce1722$var$crateHasRandomStranges($e7012959a8ce1722$var$currentCrateObj)) {
        saveObj.stats["strange-chances"] += 1;
        if (unboxResult.quality.includes("strange")) saveObj.stats["random-strange-unboxed"] += 1;
    }
    saveObj.crateStats[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]].n++;
    if (unboxResult.bonus.length > 0) {
        saveObj.crateStats[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]].b += unboxResult.bonus.length;
        switch(unboxResult.bonus.length){
            case 1:
                saveObj.stats["single-bonus-unboxed"]++;
                break;
            case 2:
                saveObj.stats["double-bonus-unboxed"]++;
                break;
            case 3:
                saveObj.stats["triple-bonus-unboxed"]++;
                break;
        }
    }
    for (let bonusItem of unboxResult.bonus)if (bonusItem.id === 770) {
        saveObj.crateStats[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate]].u++;
        saveObj.stats["unusualifiers-unboxed"]++;
    }
    if (saveToStorage) {
        clearTimeout($e7012959a8ce1722$var$addToStatsSaveTimeout);
        $e7012959a8ce1722$var$addToStatsSaveTimeout = setTimeout(()=>{
            localStorage.setItem("unboxertf-cratestats", (0, $c15f83c001069282$export$df1e024253068afa).compressToUTF16(JSON.stringify($e7012959a8ce1722$var$save.crateStats)));
            localStorage.setItem("unboxertf-stats", (0, $c15f83c001069282$export$df1e024253068afa).compressToUTF16(JSON.stringify($e7012959a8ce1722$var$save.stats)));
            localStorage.setItem("unboxertf-save-format", 'lzstring');
        }, 2000);
    }
}
// Generate grid
let $e7012959a8ce1722$var$gridDivs = null;
let $e7012959a8ce1722$var$gridNames = [];
function $e7012959a8ce1722$var$generateGrid() {
    $e7012959a8ce1722$var$DOM.main.crateGrid.innerHTML = "";
    let html = [];
    for(let i = 0; i < (0, $923c9e0e4e96ee85$export$43b46fa232650b2f).length; i++)html.push(`<div cratenum="${i}" series="${(0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[i]].series}">
    <img class="statscratesimg" src="./images/crate/${$e7012959a8ce1722$var$getImg("crate", (0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[i]].id)}" alt="" loading="lazy">
    <p class="statscratesname">${$e7012959a8ce1722$var$getString("crate", (0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[i]].id)}</p>
    <p class="statscratesseries">${$e7012959a8ce1722$var$getSeries((0, $923c9e0e4e96ee85$export$afbe48a4a4275937)[(0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[i]].series)}</p>
    </div>`);
    $e7012959a8ce1722$var$DOM.main.crateGrid.innerHTML = html.join('');
    $e7012959a8ce1722$var$gridDivs = $e7012959a8ce1722$var$DOM.main.crateGrid.querySelectorAll("div");
    $e7012959a8ce1722$var$gridNames = [];
    for(let i = 0; i < $e7012959a8ce1722$var$gridDivs.length; i++){
        $e7012959a8ce1722$var$gridDivs[i].addEventListener("pointerdown", function() {
            $e7012959a8ce1722$var$sound.play("btn");
        });
        $e7012959a8ce1722$var$gridDivs[i].addEventListener("click", function() {
            $e7012959a8ce1722$var$sound.play("btnRelease");
            $e7012959a8ce1722$var$jumpToCrate(parseInt(this.getAttribute("cratenum")));
            $e7012959a8ce1722$var$exitGridView();
        });
        $e7012959a8ce1722$var$gridNames.push(`${$e7012959a8ce1722$var$gridDivs[i].querySelector(".statscratesname").textContent} ${$e7012959a8ce1722$var$gridDivs[i].querySelector(".statscratesseries").textContent}`.toLowerCase());
    }
}
function $e7012959a8ce1722$var$exitGridView() {
    $e7012959a8ce1722$var$DOM.main.crateGrid.style.display = "none";
    $e7012959a8ce1722$var$DOM.main.crateInfoContainer.style.display = "block";
    $e7012959a8ce1722$var$DOM.main.gridViewBtn.style.display = "flex";
    $e7012959a8ce1722$var$DOM.main.exitGridViewBtn.style.display = "none";
    $e7012959a8ce1722$var$DOM.main.crateGridSearchBtn.style.display = "none";
    $e7012959a8ce1722$var$DOM.main.crateWindow.classList.remove("gridactive");
    $e7012959a8ce1722$var$DOM.main.crateWindow.classList.remove("showsearch");
    $e7012959a8ce1722$var$DOM.main.crateGridSearch.value = "";
    $e7012959a8ce1722$var$inDetailsMode = true;
    $e7012959a8ce1722$var$searchGrid("");
}
function $e7012959a8ce1722$var$searchGrid(input) {
    if ($e7012959a8ce1722$var$gridDivs === null) return 0;
    let searchName = input.toLowerCase();
    if (searchName.length > 0) {
        for(let i = 0; i < $e7012959a8ce1722$var$gridDivs.length; i++)if ($e7012959a8ce1722$var$gridNames[i].includes(searchName)) $e7012959a8ce1722$var$gridDivs[i].style.display = "block";
        else $e7012959a8ce1722$var$gridDivs[i].style.display = "none";
    } else for (let crate1 of $e7012959a8ce1722$var$gridDivs)crate1.style.display = "block";
}
function $e7012959a8ce1722$var$selectFirstCrateFromSearch() {
    for (let crate1 of $e7012959a8ce1722$var$gridDivs)if (crate1.style.display == "block") {
        $e7012959a8ce1722$var$sound.play("btn");
        $e7012959a8ce1722$var$jumpToCrate(parseInt(crate1.getAttribute("cratenum")));
        $e7012959a8ce1722$var$exitGridView();
        return;
    }
}
// Main screen bindings
$e7012959a8ce1722$var$DOM.main.gridViewBtn.addEventListener("click", ()=>{
    $e7012959a8ce1722$var$DOM.main.crateGrid.style.display = "grid";
    $e7012959a8ce1722$var$DOM.main.crateInfoContainer.style.display = "none";
    $e7012959a8ce1722$var$DOM.main.gridViewBtn.style.display = "none";
    $e7012959a8ce1722$var$DOM.main.exitGridViewBtn.style.display = "flex";
    $e7012959a8ce1722$var$DOM.main.crateGridSearchBtn.style.display = "flex";
    $e7012959a8ce1722$var$DOM.main.crateWindow.classList.add("gridactive");
    $e7012959a8ce1722$var$inDetailsMode = false;
    if ($e7012959a8ce1722$var$DOM.main.crateGrid.innerHTML == "") $e7012959a8ce1722$var$generateGrid();
});
$e7012959a8ce1722$var$DOM.main.exitGridViewBtn.addEventListener("click", $e7012959a8ce1722$var$exitGridView);
$e7012959a8ce1722$var$DOM.main.randomCrateBtn.addEventListener("click", ()=>{
    $e7012959a8ce1722$var$jumpToCrate("random");
    $e7012959a8ce1722$var$exitGridView();
});
$e7012959a8ce1722$var$DOM.main.crateGridSearchBtn.addEventListener("click", ()=>{
    $e7012959a8ce1722$var$DOM.main.crateWindow.classList.toggle("showsearch");
    if ($e7012959a8ce1722$var$DOM.main.crateWindow.classList.contains("showsearch")) $e7012959a8ce1722$var$DOM.main.crateGridSearch.focus();
    else {
        $e7012959a8ce1722$var$DOM.main.crateGridSearch.value = "";
        $e7012959a8ce1722$var$searchGrid("");
    }
});
$e7012959a8ce1722$var$DOM.main.unboxBtn.addEventListener("click", ()=>{
    $e7012959a8ce1722$var$exitGridView();
    $e7012959a8ce1722$var$beginUnbox();
});
$e7012959a8ce1722$var$DOM.main.bulkUnboxBtn.addEventListener("click", ()=>{
    $e7012959a8ce1722$var$DOM.bulkSelect.screen.style.display = "flex";
    $e7012959a8ce1722$var$canUnbox = false;
});
document.querySelector('[data-screen="#statsscreen"]').addEventListener("click", ()=>{
    $e7012959a8ce1722$var$updateStats();
    $e7012959a8ce1722$var$generateCrateStats();
    if (!$e7012959a8ce1722$var$unusualsGenerated) $e7012959a8ce1722$var$generateUnusualStats();
});
$e7012959a8ce1722$var$DOM.main.crateInfoContainer.addEventListener("swiped-left", ()=>{
    $e7012959a8ce1722$var$jumpToCrate("previous");
});
$e7012959a8ce1722$var$DOM.main.crateInfoContainer.addEventListener("swiped-right", ()=>{
    $e7012959a8ce1722$var$jumpToCrate("next");
});
$e7012959a8ce1722$var$DOM.main.crateGridSearch.addEventListener("input", ()=>{
    $e7012959a8ce1722$var$searchGrid($e7012959a8ce1722$var$DOM.main.crateGridSearch.value);
});
// Options screen bindings
document.querySelectorAll(".tabreturnbtn").forEach((button)=>{
    button.addEventListener("click", ()=>{
        $e7012959a8ce1722$var$DOM.main.container.style.display = "block";
        $e7012959a8ce1722$var$canUnbox = true;
        button.closest("main").style.display = "none";
    });
});
document.querySelectorAll("[data-screen]").forEach((button)=>{
    button.addEventListener("click", ()=>{
        $e7012959a8ce1722$var$canUnbox = false;
        document.querySelector(button.dataset.screen).style.display = "block";
        button.closest("main").style.display = "none";
    });
});
document.querySelectorAll("[data-tab]").forEach((button)=>{
    button.addEventListener("click", ()=>{
        button.parentNode.querySelector("[data-tab].active").classList.remove("active");
        button.classList.add("active");
        button.closest("main").querySelector("div.visible").classList.remove("visible");
        document.querySelector(button.dataset.tab).classList.add("visible");
    });
});
let $e7012959a8ce1722$var$resetting = 0;
$e7012959a8ce1722$var$DOM.options.resetBtn.addEventListener("click", ()=>{
    if ($e7012959a8ce1722$var$resetting === 0) {
        $e7012959a8ce1722$var$resetting = 1;
        $e7012959a8ce1722$var$DOM.options.resetBtn.innerHTML = $e7012959a8ce1722$var$getString("ui", 78);
        setTimeout(()=>{
            if ($e7012959a8ce1722$var$resetting === 1) {
                $e7012959a8ce1722$var$resetting = 0;
                $e7012959a8ce1722$var$DOM.options.resetBtn.innerHTML = $e7012959a8ce1722$var$getString("ui", 29);
            }
        }, 4000);
    } else if ($e7012959a8ce1722$var$resetting === 1) {
        $e7012959a8ce1722$var$resetting = 2;
        $e7012959a8ce1722$var$DOM.options.resetBtn.innerHTML = $e7012959a8ce1722$var$getString("ui", 77);
        $e7012959a8ce1722$var$save = JSON.parse(JSON.stringify($e7012959a8ce1722$var$defaultSave));
        localStorage.removeItem("unboxertf-stats");
        localStorage.removeItem("unboxertf-unusuals");
        localStorage.removeItem("unboxertf-bonusitems");
        localStorage.removeItem("unboxertf-crates");
        localStorage.removeItem("unboxertf-cratestats");
        $e7012959a8ce1722$var$DOM.stats.unusuals.content.innerHTML = "";
        $e7012959a8ce1722$var$unusualsGenerated = false;
        let tempOptionsSave = localStorage.getItem("unboxertf-options");
        if (tempOptionsSave != null) $e7012959a8ce1722$var$save.options = JSON.parse(tempOptionsSave);
        setTimeout(()=>{
            $e7012959a8ce1722$var$resetting = 0;
            $e7012959a8ce1722$var$DOM.options.resetBtn.innerHTML = $e7012959a8ce1722$var$getString("ui", 29);
        }, 4000);
    }
});
// Statistics screen bindings
let $e7012959a8ce1722$var$lastTabNum = $e7012959a8ce1722$var$DOM.stats.statistics.container.querySelectorAll("[data-statstring]").length - 1;
$e7012959a8ce1722$var$DOM.stats.statistics.container.querySelectorAll("[data-statstring]").forEach((tab, index)=>{
    tab.dataset.num = index;
});
$e7012959a8ce1722$var$DOM.stats.statistics.prev.addEventListener("click", ()=>{
    let currentTab = $e7012959a8ce1722$var$DOM.stats.statistics.container.querySelector(".statvisible");
    currentTab.classList.remove("statvisible");
    let newTab;
    if (currentTab.dataset.num == "0") newTab = $e7012959a8ce1722$var$DOM.stats.statistics.container.querySelector(`[data-num="${$e7012959a8ce1722$var$lastTabNum}"]`);
    else newTab = $e7012959a8ce1722$var$DOM.stats.statistics.container.querySelector(`[data-num="${parseInt(currentTab.dataset.num) - 1}"]`);
    newTab.classList.add("statvisible");
    $e7012959a8ce1722$var$DOM.stats.statistics.tab.innerHTML = $e7012959a8ce1722$var$getString("ui", newTab.dataset.statstring);
});
$e7012959a8ce1722$var$DOM.stats.statistics.next.addEventListener("click", ()=>{
    let currentTab = $e7012959a8ce1722$var$DOM.stats.statistics.container.querySelector(".statvisible");
    currentTab.classList.remove("statvisible");
    let newTab;
    if (currentTab.dataset.num == $e7012959a8ce1722$var$lastTabNum) newTab = $e7012959a8ce1722$var$DOM.stats.statistics.container.querySelector("[data-num='0']");
    else newTab = $e7012959a8ce1722$var$DOM.stats.statistics.container.querySelector(`[data-num="${parseInt(currentTab.dataset.num) + 1}"]`);
    newTab.classList.add("statvisible");
    $e7012959a8ce1722$var$DOM.stats.statistics.tab.innerHTML = $e7012959a8ce1722$var$getString("ui", newTab.dataset.statstring);
});
$e7012959a8ce1722$var$DOM.stats.crates.details.returnBtn.addEventListener("click", ()=>{
    $e7012959a8ce1722$var$DOM.stats.container.style.display = "block";
    $e7012959a8ce1722$var$DOM.stats.crates.details.container.classList.remove("visible");
});
$e7012959a8ce1722$var$DOM.stats.unusuals.prev.addEventListener("click", ()=>{
    $e7012959a8ce1722$var$unusualPage({
        el: $e7012959a8ce1722$var$DOM.stats.unusuals.pageDiv,
        page: "prev"
    });
});
$e7012959a8ce1722$var$DOM.stats.unusuals.next.addEventListener("click", ()=>{
    $e7012959a8ce1722$var$unusualPage({
        el: $e7012959a8ce1722$var$DOM.stats.unusuals.pageDiv,
        page: "next"
    });
});
// Results screen bindings
$e7012959a8ce1722$var$DOM.results.returnBtn.addEventListener("click", ()=>{
    if (!$e7012959a8ce1722$var$DOM.results.returnBtn.classList.contains("btndisabled")) {
        $e7012959a8ce1722$var$DOM.main.container.style.display = "block";
        $e7012959a8ce1722$var$DOM.results.container.style.display = "none";
    }
});
$e7012959a8ce1722$var$DOM.results.unboxBtn.addEventListener("click", ()=>{
    $e7012959a8ce1722$var$exitGridView();
    $e7012959a8ce1722$var$beginUnbox();
});
let $e7012959a8ce1722$var$holdUnbox;
$e7012959a8ce1722$var$DOM.results.unboxBtn.addEventListener("pointerdown", ()=>{
    clearInterval($e7012959a8ce1722$var$holdUnbox);
    clearTimeout($e7012959a8ce1722$var$holdUnbox);
    if ($e7012959a8ce1722$var$save.options.fastUnbox) $e7012959a8ce1722$var$holdUnbox = setTimeout(()=>{
        $e7012959a8ce1722$var$holdUnbox = setInterval($e7012959a8ce1722$var$beginUnbox, 50);
    }, 1000);
});
$e7012959a8ce1722$var$DOM.results.unboxBtn.addEventListener("pointerup", ()=>{
    clearInterval($e7012959a8ce1722$var$holdUnbox);
    clearTimeout($e7012959a8ce1722$var$holdUnbox);
});
$e7012959a8ce1722$var$DOM.results.unboxBtn.addEventListener("pointerleave", ()=>{
    clearInterval($e7012959a8ce1722$var$holdUnbox);
    clearTimeout($e7012959a8ce1722$var$holdUnbox);
});
// Bulk select bindings
$e7012959a8ce1722$var$DOM.bulkSelect.num.addEventListener("input", ()=>{
    let crateNum = parseInt($e7012959a8ce1722$var$DOM.bulkSelect.num.value);
    if ([
        0,
        NaN
    ].includes(crateNum)) $e7012959a8ce1722$var$DOM.bulkSelect.unboxBtn.classList.add("btndisabled");
    else $e7012959a8ce1722$var$DOM.bulkSelect.unboxBtn.classList.remove("btndisabled");
    if (!$e7012959a8ce1722$var$bulkUnlimited && crateNum > 1000000) $e7012959a8ce1722$var$DOM.bulkSelect.num.value = 1000000;
    if (crateNum >= 500000) {
        $e7012959a8ce1722$var$DOM.bulkSelect.warning.style.display = "none";
        $e7012959a8ce1722$var$DOM.bulkSelect.warningHuge.style.display = "block";
    } else if (crateNum >= 50000) {
        $e7012959a8ce1722$var$DOM.bulkSelect.warning.style.display = "block";
        $e7012959a8ce1722$var$DOM.bulkSelect.warningHuge.style.display = "none";
    } else {
        $e7012959a8ce1722$var$DOM.bulkSelect.warning.style.display = "none";
        $e7012959a8ce1722$var$DOM.bulkSelect.warningHuge.style.display = "none";
    }
});
$e7012959a8ce1722$var$DOM.bulkSelect.cancelBtn.addEventListener("click", ()=>{
    $e7012959a8ce1722$var$DOM.bulkSelect.screen.style.display = "none";
    $e7012959a8ce1722$var$canUnbox = true;
});
$e7012959a8ce1722$var$DOM.bulkSelect.unboxBtn.addEventListener("click", ()=>{
    if (!$e7012959a8ce1722$var$DOM.bulkSelect.unboxBtn.classList.contains("btndisabled")) $e7012959a8ce1722$var$startBulkUnbox(parseInt($e7012959a8ce1722$var$DOM.bulkSelect.num.value));
});
// Bulk results bindings
let $e7012959a8ce1722$var$lastBulkNum = $e7012959a8ce1722$var$DOM.bulkResults.container.querySelectorAll("[data-statstring]").length - 1;
$e7012959a8ce1722$var$DOM.bulkResults.container.querySelectorAll("[data-statstring]").forEach((tab, index)=>{
    tab.dataset.num = index;
});
$e7012959a8ce1722$var$DOM.bulkResults.prev.addEventListener("click", ()=>{
    let currentTab = $e7012959a8ce1722$var$DOM.bulkResults.container.querySelector(".bulkvisible");
    currentTab.classList.remove("bulkvisible");
    let newTab;
    if (currentTab.dataset.num == "0") newTab = $e7012959a8ce1722$var$DOM.bulkResults.container.querySelector(`[data-num="${$e7012959a8ce1722$var$lastBulkNum}"]`);
    else newTab = $e7012959a8ce1722$var$DOM.bulkResults.container.querySelector(`[data-num="${parseInt(currentTab.dataset.num) - 1}"]`);
    newTab.classList.add("bulkvisible");
    $e7012959a8ce1722$var$DOM.bulkResults.tabName.innerHTML = $e7012959a8ce1722$var$getString("ui", newTab.dataset.statstring);
});
$e7012959a8ce1722$var$DOM.bulkResults.next.addEventListener("click", ()=>{
    let currentTab = $e7012959a8ce1722$var$DOM.bulkResults.container.querySelector(".bulkvisible");
    currentTab.classList.remove("bulkvisible");
    let newTab;
    if (currentTab.dataset.num == $e7012959a8ce1722$var$lastBulkNum) newTab = $e7012959a8ce1722$var$DOM.bulkResults.container.querySelector("[data-num='0']");
    else newTab = $e7012959a8ce1722$var$DOM.bulkResults.container.querySelector(`[data-num="${parseInt(currentTab.dataset.num) + 1}"]`);
    newTab.classList.add("bulkvisible");
    $e7012959a8ce1722$var$DOM.bulkResults.tabName.innerHTML = $e7012959a8ce1722$var$getString("ui", newTab.dataset.statstring);
});
$e7012959a8ce1722$var$DOM.bulkResults.return.addEventListener("click", ()=>{
    $e7012959a8ce1722$var$DOM.main.container.style.display = "block";
    $e7012959a8ce1722$var$DOM.bulkResults.container.style.display = "none";
    $e7012959a8ce1722$var$canUnbox = true;
});
$e7012959a8ce1722$var$DOM.bulkResults.unusualsPrev.addEventListener("click", ()=>{
    $e7012959a8ce1722$var$unusualPage({
        saveObj: $e7012959a8ce1722$var$bulkSave,
        el: $e7012959a8ce1722$var$DOM.bulkResults.unusualsPageDiv,
        page: "prev"
    });
});
$e7012959a8ce1722$var$DOM.bulkResults.unusualsNext.addEventListener("click", ()=>{
    $e7012959a8ce1722$var$unusualPage({
        saveObj: $e7012959a8ce1722$var$bulkSave,
        el: $e7012959a8ce1722$var$DOM.bulkResults.unusualsPageDiv,
        page: "next"
    });
});
// Load saves
let $e7012959a8ce1722$var$newSaveFormat = localStorage.getItem("unboxertf-save-format");
let $e7012959a8ce1722$var$tempStatSave = localStorage.getItem("unboxertf-stats");
if ($e7012959a8ce1722$var$tempStatSave != null) {
    if ($e7012959a8ce1722$var$newSaveFormat === 'lzstring') $e7012959a8ce1722$var$tempStatSave = (0, $c15f83c001069282$export$df1e024253068afa).decompressFromUTF16($e7012959a8ce1722$var$tempStatSave);
    Object.assign($e7012959a8ce1722$var$save.stats, JSON.parse($e7012959a8ce1722$var$tempStatSave));
}
let $e7012959a8ce1722$var$tempUnusualSave = localStorage.getItem("unboxertf-unusuals");
let $e7012959a8ce1722$var$newUnusualFormat = localStorage.getItem("unboxertf-unusuals-save-format");
if ($e7012959a8ce1722$var$tempUnusualSave != null) {
    if ($e7012959a8ce1722$var$newSaveFormat === 'lzstring' || $e7012959a8ce1722$var$newUnusualFormat === 'lzstring') $e7012959a8ce1722$var$tempUnusualSave = (0, $c15f83c001069282$export$df1e024253068afa).decompressFromUTF16($e7012959a8ce1722$var$tempUnusualSave);
    $e7012959a8ce1722$var$save.unusuals = JSON.parse($e7012959a8ce1722$var$tempUnusualSave);
}
let $e7012959a8ce1722$var$tempBonusItemSave = localStorage.getItem("unboxertf-bonusitems");
if ($e7012959a8ce1722$var$tempBonusItemSave != null) {
    if ($e7012959a8ce1722$var$newSaveFormat === 'lzstring') $e7012959a8ce1722$var$tempBonusItemSave = (0, $c15f83c001069282$export$df1e024253068afa).decompressFromUTF16($e7012959a8ce1722$var$tempBonusItemSave);
    $e7012959a8ce1722$var$save.bonusItems = JSON.parse($e7012959a8ce1722$var$tempBonusItemSave);
}
let $e7012959a8ce1722$var$tempCrateSave = localStorage.getItem("unboxertf-crates");
if ($e7012959a8ce1722$var$tempCrateSave != null) {
    if ($e7012959a8ce1722$var$newSaveFormat === 'lzstring') $e7012959a8ce1722$var$tempCrateSave = (0, $c15f83c001069282$export$df1e024253068afa).decompressFromUTF16($e7012959a8ce1722$var$tempCrateSave);
    $e7012959a8ce1722$var$mergeDeep($e7012959a8ce1722$var$save.crates, JSON.parse($e7012959a8ce1722$var$tempCrateSave));
}
let $e7012959a8ce1722$var$tempCrateStatsSave = localStorage.getItem("unboxertf-cratestats");
if ($e7012959a8ce1722$var$tempCrateStatsSave != null) {
    if ($e7012959a8ce1722$var$newSaveFormat === 'lzstring') $e7012959a8ce1722$var$tempCrateStatsSave = (0, $c15f83c001069282$export$df1e024253068afa).decompressFromUTF16($e7012959a8ce1722$var$tempCrateStatsSave);
    $e7012959a8ce1722$var$mergeDeep($e7012959a8ce1722$var$save.crateStats, JSON.parse($e7012959a8ce1722$var$tempCrateStatsSave));
}
let $e7012959a8ce1722$var$tempOptionsSave = localStorage.getItem("unboxertf-options");
if ($e7012959a8ce1722$var$tempOptionsSave != null) {
    Object.assign($e7012959a8ce1722$var$save.options, JSON.parse($e7012959a8ce1722$var$tempOptionsSave));
    for(let key in $e7012959a8ce1722$var$save.options)$e7012959a8ce1722$var$triggerOption(key, true);
}
function $e7012959a8ce1722$var$unusualPage(arg) {
    let saveObject = $e7012959a8ce1722$var$save;
    let el = arg.el;
    if (arg.saveObj != undefined) saveObject = arg.saveObj;
    if (arg.page === "prev") {
        if (el.dataset.unusualpage == "1") el.dataset.unusualpage = el.dataset.unusualmaxpage;
        else el.dataset.unusualpage = parseInt(el.dataset.unusualpage) - 1;
    } else if (arg.page === "next") {
        if (el.dataset.unusualpage == el.dataset.unusualmaxpage) el.dataset.unusualpage = "1";
        else el.dataset.unusualpage = parseInt(el.dataset.unusualpage) + 1;
    }
    let pageString = $e7012959a8ce1722$var$getString("ui", 152).replace("#PAGE#", el.dataset.unusualpage).replace("#TOTAL#", el.dataset.unusualmaxpage);
    el.querySelector("[data-unusualpagecount]").innerHTML = pageString;
    let startArray = 200 * (parseInt(el.dataset.unusualpage) - 1);
    let endArray = 200 * parseInt(el.dataset.unusualpage);
    let tempHtml = "";
    for (let unusual of saveObject.unusuals.slice(startArray, endArray))tempHtml += $e7012959a8ce1722$var$updateUnusualStats(unusual);
    el.parentNode.querySelector("[data-unusualcontent]").innerHTML = tempHtml;
}
var $1e073185ec2250b4$exports = {};
var $167cfaacd4ac4da3$exports = {};
"use strict";
$167cfaacd4ac4da3$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $1e073185ec2250b4$var$url = new URL($parcel$resolve("atjRc"));
$1e073185ec2250b4$exports = $167cfaacd4ac4da3$exports($1e073185ec2250b4$var$url.toString(), $1e073185ec2250b4$var$url.origin, true);


// Bulk unboxing code
let $e7012959a8ce1722$var$bulkWorker = new Worker($1e073185ec2250b4$exports);
let $e7012959a8ce1722$var$bulkSave;
$e7012959a8ce1722$var$bulkWorker.onmessage = function(e) {
    if (e.data.item) {
        if (!$e7012959a8ce1722$var$save.options.forceUnusual && !$e7012959a8ce1722$var$save.options.forceUnusualifier && !$e7012959a8ce1722$var$save.options.forceStrange && !$e7012959a8ce1722$var$save.options.forceGrade && !$e7012959a8ce1722$var$save.options.forceProKit && !$e7012959a8ce1722$var$save.options.forceBonusItem) {
            $e7012959a8ce1722$var$addToInventory(e.data.item, $e7012959a8ce1722$var$save);
            $e7012959a8ce1722$var$addToUnusuals(e.data.item, $e7012959a8ce1722$var$save);
            $e7012959a8ce1722$var$addToStats(e.data.item, $e7012959a8ce1722$var$save);
        }
    } else if (e.data.progress) {
        $e7012959a8ce1722$var$DOM.bulkProgress.progressDone.innerHTML = $e7012959a8ce1722$var$DOM.bulkProgress.progress.value = e.data.progress;
        $e7012959a8ce1722$var$DOM.bulkProgress.progressPercent.innerHTML = `${Math.round(e.data.progress / $e7012959a8ce1722$var$DOM.bulkProgress.progress.max * 100)}%`;
    } else if (e.data.complete) {
        $e7012959a8ce1722$var$bulkSave = JSON.parse(e.data.bulkSave);
        localStorage.setItem("unboxertf-crates", (0, $c15f83c001069282$export$df1e024253068afa).compressToUTF16(JSON.stringify($e7012959a8ce1722$var$save.crates)));
        localStorage.setItem("unboxertf-bonusitems", (0, $c15f83c001069282$export$df1e024253068afa).compressToUTF16(JSON.stringify($e7012959a8ce1722$var$save.bonusItems)));
        localStorage.setItem("unboxertf-cratestats", (0, $c15f83c001069282$export$df1e024253068afa).compressToUTF16(JSON.stringify($e7012959a8ce1722$var$save.crateStats)));
        localStorage.setItem("unboxertf-stats", (0, $c15f83c001069282$export$df1e024253068afa).compressToUTF16(JSON.stringify($e7012959a8ce1722$var$save.stats)));
        localStorage.setItem("unboxertf-unusuals", (0, $c15f83c001069282$export$df1e024253068afa).compressToUTF16(JSON.stringify($e7012959a8ce1722$var$save.unusuals)));
        localStorage.setItem("unboxertf-save-format", 'lzstring');
        // Display results
        $e7012959a8ce1722$var$DOM.bulkResults.title.innerHTML = `${$e7012959a8ce1722$var$getString("crate", $e7012959a8ce1722$var$currentCrateObj.id)}<br>${$e7012959a8ce1722$var$getSeries($e7012959a8ce1722$var$currentCrateObj.series)}`;
        document.querySelectorAll("[data-bulkstat]").forEach((el)=>{
            el.innerHTML = $e7012959a8ce1722$var$bulkSave.stats[el.dataset.bulkstat];
        });
        document.querySelectorAll('[data-bulkstat="keys-money"], [data-bulkstat="unusual-avgprice"]').forEach((el)=>{
            el.innerHTML = "$" + el.innerHTML;
        });
        $e7012959a8ce1722$var$DOM.bulkResults.unusualsPageDiv.dataset.unusualpage = "1";
        $e7012959a8ce1722$var$DOM.bulkResults.unusualsPageDiv.dataset.unusualmaxpage = Math.ceil($e7012959a8ce1722$var$bulkSave.unusuals.length / 200);
        $e7012959a8ce1722$var$unusualPage({
            saveObj: $e7012959a8ce1722$var$bulkSave,
            el: $e7012959a8ce1722$var$DOM.bulkResults.unusualsPageDiv
        });
        $e7012959a8ce1722$var$generateCrateDetails((0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate], $e7012959a8ce1722$var$DOM.bulkResults.items, $e7012959a8ce1722$var$bulkSave);
        $e7012959a8ce1722$var$generateCrateDetails((0, $923c9e0e4e96ee85$export$43b46fa232650b2f)[$e7012959a8ce1722$var$currentCrate], $e7012959a8ce1722$var$DOM.bulkResults.bonusItems, $e7012959a8ce1722$var$bulkSave, true);
        $e7012959a8ce1722$var$generateUnusualStats();
        $e7012959a8ce1722$var$DOM.main.container.style.display = "none";
        $e7012959a8ce1722$var$DOM.bulkSelect.screen.style.display = "none";
        $e7012959a8ce1722$var$DOM.bulkSelect.container.style.display = "flex";
        $e7012959a8ce1722$var$DOM.bulkProgress.container.style.display = "none";
        if ($e7012959a8ce1722$var$DOM.bulkResults.container.querySelector(".bulkvisible")) $e7012959a8ce1722$var$DOM.bulkResults.container.querySelector(".bulkvisible").classList.remove("bulkvisible");
        $e7012959a8ce1722$var$DOM.bulkResults.tabName.innerHTML = $e7012959a8ce1722$var$getString("ui", $e7012959a8ce1722$var$DOM.bulkResults.stats.dataset.statstring);
        $e7012959a8ce1722$var$DOM.bulkResults.stats.classList.add("bulkvisible");
        $e7012959a8ce1722$var$DOM.bulkResults.container.style.display = "block";
    } else if (e.data.error) throw new Error(e.data.error);
};
function $e7012959a8ce1722$var$startBulkUnbox(num) {
    $e7012959a8ce1722$var$bulkSave = JSON.parse(JSON.stringify($e7012959a8ce1722$var$defaultSave));
    let cheatsEnabled = false;
    if ($e7012959a8ce1722$var$save.options.forceUnusual || $e7012959a8ce1722$var$save.options.forceUnusualifier || $e7012959a8ce1722$var$save.options.forceStrange || $e7012959a8ce1722$var$save.options.forceGrade || $e7012959a8ce1722$var$save.options.forceProKit || $e7012959a8ce1722$var$save.options.forceBonusItem) cheatsEnabled = true;
    $e7012959a8ce1722$var$DOM.bulkSelect.container.style.display = "none";
    $e7012959a8ce1722$var$DOM.bulkProgress.progress.value = "0";
    $e7012959a8ce1722$var$DOM.bulkProgress.progressTotal.innerHTML = $e7012959a8ce1722$var$DOM.bulkProgress.progress.max = num;
    $e7012959a8ce1722$var$DOM.bulkProgress.progressDone.innerHTML = "0";
    $e7012959a8ce1722$var$DOM.bulkProgress.container.style.display = "flex";
    $e7012959a8ce1722$var$bulkWorker.postMessage({
        bulkSave: $e7012959a8ce1722$var$bulkSave,
        options: JSON.stringify($e7012959a8ce1722$var$save.options),
        crate: $e7012959a8ce1722$var$currentCrate,
        crateNum: num,
        cheats: cheatsEnabled
    });
}
// Disable bulk limit if site URL has a ?bulkunlimited parameter
const $e7012959a8ce1722$var$urlParams = new URLSearchParams(window.location.search);
let $e7012959a8ce1722$var$bulkUnlimited = false;
if ($e7012959a8ce1722$var$urlParams.has('bulkunlimited')) $e7012959a8ce1722$var$bulkUnlimited = true;
// Debug function: Unbox each crate 50 times. THIS IS SLOW! Enable fast unboxing and disable the pause unboxing option before using, or this will not work.
function $e7012959a8ce1722$var$testUnbox() {
    try {
        for(let crate1 in 0, $923c9e0e4e96ee85$export$afbe48a4a4275937){
            console.log(`Testing crate ${crate1}`);
            $e7012959a8ce1722$var$jumpToCrate(crate1);
            let counter = 0;
            while(counter <= 49){
                $e7012959a8ce1722$var$beginUnbox();
                counter++;
            }
        }
    } catch  {
        throw new Error(`Error at crate ${crate}`);
    }
}
// On load, disable loading screen
if (localStorage.getItem("unboxertf-languagechanged") == undefined) langLoop: for(let i = 0; i < navigator.languages.length; i++){
    switch(navigator.languages[i].slice(0, 2)){
        case "en":
            break langLoop;
        case "pl":
            $e7012959a8ce1722$var$changeLanguage("pol");
            $e7012959a8ce1722$var$save.options.language = "pol";
            $e7012959a8ce1722$var$DOM.options.langDropdown.value = "pol";
            localStorage.setItem("unboxertf-options", JSON.stringify($e7012959a8ce1722$var$save.options));
            break langLoop;
        case "fr":
            $e7012959a8ce1722$var$changeLanguage("fre");
            $e7012959a8ce1722$var$save.options.language = "fre";
            $e7012959a8ce1722$var$DOM.options.langDropdown.value = "fre";
            localStorage.setItem("unboxertf-options", JSON.stringify($e7012959a8ce1722$var$save.options));
            break langLoop;
        case "zh":
            $e7012959a8ce1722$var$changeLanguage("sch");
            $e7012959a8ce1722$var$save.options.language = "sch";
            $e7012959a8ce1722$var$DOM.options.langDropdown.value = "sch";
            localStorage.setItem("unboxertf-options", JSON.stringify($e7012959a8ce1722$var$save.options));
            break langLoop;
        case "cs":
            $e7012959a8ce1722$var$changeLanguage("cze");
            $e7012959a8ce1722$var$save.options.language = "cze";
            $e7012959a8ce1722$var$DOM.options.langDropdown.value = "cze";
            localStorage.setItem("unboxertf-options", JSON.stringify($e7012959a8ce1722$var$save.options));
            break langLoop;
        case "hu":
            $e7012959a8ce1722$var$changeLanguage("hun");
            $e7012959a8ce1722$var$save.options.language = "hun";
            $e7012959a8ce1722$var$DOM.options.langDropdown.value = "hun";
            localStorage.setItem("unboxertf-options", JSON.stringify($e7012959a8ce1722$var$save.options));
            break langLoop;
        case "ro":
            $e7012959a8ce1722$var$changeLanguage("rom");
            $e7012959a8ce1722$var$save.options.language = "rom";
            $e7012959a8ce1722$var$DOM.options.langDropdown.value = "rom";
            localStorage.setItem("unboxertf-options", JSON.stringify($e7012959a8ce1722$var$save.options));
            break langLoop;
        case "sv":
            $e7012959a8ce1722$var$changeLanguage("swe");
            $e7012959a8ce1722$var$save.options.language = "swe";
            $e7012959a8ce1722$var$DOM.options.langDropdown.value = "swe";
            localStorage.setItem("unboxertf-options", JSON.stringify($e7012959a8ce1722$var$save.options));
            break langLoop;
    }
    switch(navigator.languages[i]){
        case "fil":
            $e7012959a8ce1722$var$changeLanguage("fil");
            $e7012959a8ce1722$var$save.options.language = "fil";
            $e7012959a8ce1722$var$DOM.options.langDropdown.value = "fil";
            localStorage.setItem("unboxertf-options", JSON.stringify($e7012959a8ce1722$var$save.options));
            break langLoop;
        case "pt-BR":
            $e7012959a8ce1722$var$changeLanguage("bra");
            $e7012959a8ce1722$var$save.options.language = "bra";
            $e7012959a8ce1722$var$DOM.options.langDropdown.value = "bra";
            localStorage.setItem("unboxertf-options", JSON.stringify($e7012959a8ce1722$var$save.options));
            break langLoop;
    }
}
$e7012959a8ce1722$var$DOM.main.container.classList.remove("loading");
document.querySelector("#loadingscreen").classList.add("loaded");


//# sourceMappingURL=repo.ed8018cc.js.map
